/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://storage.googleapis.com/cdn.indigofair.com/web/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(280);
	module.exports = __webpack_require__(305);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(39);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(456)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(578)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(459)();
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Utils = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Utils = __webpack_require__(42);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	var _ajax = __webpack_require__(282);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _cache2 = __webpack_require__(283);
	
	var _cache3 = _interopRequireDefault(_cache2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function event(path) {
	  return _ajax2.default.post('/api/event', { path: path });
	}
	
	function error(message) {
	  return _ajax2.default.post('/api/error', { message: message });
	}
	
	function getBrands(query, activeOnly) {
	  var url = '/api/brand/search';
	  var parameters = [];
	  if (typeof query === 'string' && query.length > 0) {
	    parameters.push('query=' + query);
	  }
	
	  if (activeOnly !== undefined) {
	    parameters.push('active_only=' + (activeOnly ? 'true' : 'false'));
	  }
	
	  if (parameters.length > 0) {
	    url += '?' + parameters.join('&');
	  }
	
	  return _ajax2.default.get(url);
	}
	
	function getBrand(brandToken, cached) {
	  if (cached && _cache2._cache.brands[brandToken]) {
	    return Promise.resolve(_cache2._cache.brands[brandToken]);
	  }
	
	  var returnValue = _ajax2.default.get('/api/brand/' + brandToken);
	
	  returnValue.then(function (brand) {
	    _cache3.default.setBrands([brand]);
	  });
	
	  return returnValue;
	}
	
	function getClosestBrandRetailer(brandToken) {
	  return _ajax2.default.get('/api/retailer/closest-brand-retailer/' + brandToken);
	}
	
	function getAccountStatus(retailerToken) {
	  return _ajax2.default.get('/api/retailer/' + retailerToken + '/account-status');
	}
	
	function getPendingPaymentsStatus(retailerToken) {
	  return _ajax2.default.get('/api/retailer/' + retailerToken + '/pending-payment');
	}
	
	function getOutstandingIncomingPayments(retailerToken) {
	  return _ajax2.default.get('/api/payment/outstanding-incoming/' + retailerToken);
	}
	
	function saveBrand(brand) {
	  var returnValue = _ajax2.default.post('/api/brand', brand);
	
	  returnValue.then(function (brand) {
	    _cache3.default.setBrands([brand]);
	  });
	
	  return returnValue;
	}
	
	function getBrandProducts(brandToken) {
	  return _ajax2.default.get('/api/brand/' + brandToken + '/products');
	}
	
	function brandLead(payload) {
	  return _ajax2.default.post('/api/brand/lead', payload);
	}
	
	/* --- Emails --- */
	
	function searchEmails(request) {
	  if (!request) request = {};
	  return _ajax2.default.post('/api/email/search', request);
	}
	
	function sendEmail(token) {
	  return _ajax2.default.post('/api/email/send/' + token);
	}
	
	/* --- Recommendation Emails --- */
	
	function getPendingRecommendationEmails(request) {
	  if (!request) {
	    request = { template: "RECOMMENDATIONS" };
	  }
	  return _ajax2.default.post('/api/email-recommendations/pending', request);
	}
	
	function updatePendingRecommendationEmails(emails) {
	  return _ajax2.default.post('/api/email-recommendations/update-pending', emails);
	}
	
	/* --- Categories --- */
	
	function getCategories(cached) {
	
	  function format(categories) {
	    return categories.reduce(function (mapping, category) {
	      mapping[category.name] = (category.sub_categories || []).map(function (subcategory) {
	        return subcategory.name;
	      });
	
	      return mapping;
	    }, {});
	  }
	
	  if (cached && _cache3.default.getCategories() !== null) {
	    return Promise.resolve(_cache3.default.getCategories());
	  }
	
	  return _ajax2.default.get('/api/category/new').then(function (response) {
	    var categoryMapping = format(response);
	    _cache3.default.setCategories(categoryMapping);
	    return Promise.resolve(categoryMapping);
	  });
	}
	
	/* --- Retailer --- */
	
	function getRetailer(retailerToken, cached) {
	  // TODO: Throw Exception if no retailerToken is given
	  cached = cached || false;
	  if (cached && _cache2._cache.retailer && _cache2._cache.retailer.token === retailerToken) {
	    return Promise.resolve(_cache2._cache.retailer);
	  }
	
	  var getPromise = _ajax2.default.get('/api/retailer/' + retailerToken);
	
	  getPromise.then(function (retailer) {
	    _cache3.default.setRetailer(retailer);
	    return retailer;
	  }, function (errorData) {
	    _cache3.default.setRetailer(null);
	    return errorData;
	  });
	
	  return getPromise;
	}
	
	function getRetailers(query, activeOnly) {
	  var url = '/api/retailer/search';
	  var parameters = [];
	  if (typeof query === 'string' && query.length > 0) {
	    parameters.push('query=' + query);
	  }
	
	  if (activeOnly !== undefined) {
	    parameters.push('active_only=' + (activeOnly ? 'true' : 'false'));
	  }
	
	  if (parameters.length > 0) {
	    url += '?' + parameters.join('&');
	  }
	
	  return _ajax2.default.get(url);
	}
	
	function createRetailer(retailer) {
	  var postPromise = _ajax2.default.post('/api/retailer', retailer);
	  postPromise.then(function (createdRetailer) {
	    _cache3.default.setRetailer(createdRetailer);
	    return createdRetailer;
	  }, function (errorData) {
	    _cache3.default.setRetailer(null);
	    return errorData;
	  });
	
	  return postPromise;
	}
	
	function refreshCurrentRecommendations() {
	  var recommendations = _cache3.default.getRecommendations();
	  if (recommendations && recommendations.url) {
	    var _ret = function () {
	      var url = recommendations.url;
	      var promise = _ajax2.default.get(recommendations.url);
	      promise.then(function (response) {
	        _cache3.default.setRecommendations(url, response);
	        _cache3.default.setProducts(response.products);
	        _cache3.default.setBrands(response.brands);
	      });
	      return {
	        v: promise
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  } else {
	    return Promise.resolve(recommendations);
	  }
	}
	
	function retailerAddRecommendation(retailerToken, productToken) {
	  return retailerAddRecommendations(retailerToken, [productToken]);
	}
	
	function retailerAddRecommendations(retailerToken, productTokens) {
	  var url = '/api/retailer/' + retailerToken + '/add-recommendations';
	  var data = [];
	  productTokens.forEach(function (token) {
	    data.push({ "token": token });
	  });
	
	  return _ajax2.default.post(url, data);
	}
	
	function retailerRemoveRecommendation(retailerToken, productToken) {
	  return retailerRemoveRecommendations(retailerToken, [productToken]);
	}
	
	function retailerRemoveRecommendations(retailerToken, productTokens) {
	  var url = '/api/retailer/' + retailerToken + '/remove-recommendations';
	  var data = [];
	  productTokens.forEach(function (token) {
	    data.push({ "token": token });
	  });
	
	  return _ajax2.default.post(url, data);
	}
	
	function retailerAddCollectionRecommendation(retailerToken, collectionToken) {
	  return retailerAddCollectionRecommendations(retailerToken, [collectionToken]);
	}
	
	function retailerAddCollectionRecommendations(retailerToken, collectionTokens) {
	  var url = '/api/retailer/' + retailerToken + '/add-collection-recommendations';
	  var data = collectionTokens.map(function (token) {
	    return { "token": token };
	  });
	
	  return _ajax2.default.post(url, data);
	}
	
	function retailerRemoveCollectionRecommendation(retailerToken, collectionToken) {
	  return retailerRemoveCollectionRecommendations(retailerToken, [collectionToken]);
	}
	
	function retailerRemoveCollectionRecommendations(retailerToken, collectionTokens) {
	  var url = '/api/retailer/' + retailerToken + '/remove-collection-recommendations';
	  var data = collectionTokens.map(function (token) {
	    return { "token": token };
	  });
	
	  return _ajax2.default.post(url, data);
	}
	
	function retailerClearRecommendations(retailerToken) {
	  return _ajax2.default.post('/api/retailer/' + retailerToken + '/clear-recommendations');
	}
	
	function retailerAddFromRetailer(retailerToken, fromToken) {
	  return _ajax2.default.post('/api/retailer/' + retailerToken + '/add-recommendations/' + fromToken);
	}
	
	function retailerLead(retailer, payload) {
	  return _ajax2.default.post('/api/retailer/' + retailer + '/lead', payload);
	}
	
	/* --- Product --- */
	
	function getProduct(productToken, cached) {
	  // TODO: Throw Exception if no id is given
	
	  if (cached && _cache2._cache.products[productToken]) {
	    var product = _cache2._cache.products[productToken];
	    var payload = {
	      products: _defineProperty({}, productToken, product),
	      brands: _defineProperty({}, product.brand_token, _cache2._cache.brands[product.brand_token])
	    };
	
	    return Promise.resolve(payload);
	  }
	
	  var returnValue = _ajax2.default.get('/api/product/' + productToken);
	  returnValue.then(function (response) {
	    _cache3.default.setProducts(response.products);
	    _cache3.default.setBrands(response.brands);
	  });
	
	  return returnValue;
	}
	
	/**
	 * Retrieves a given product from cache, if exists or fetch from the API if needed.
	 */
	function getProductCache(productToken) {
	  return getProduct(productToken, true);
	}
	
	function saveProduct(product) {
	  var returnPromise = _ajax2.default.post('/api/product', product);
	
	  returnPromise.then(function (response) {
	    _cache3.default.setProducts(response.products);
	  });
	
	  return returnPromise;
	}
	
	function getProducts(query, activeOnly, retailerToken) {
	  var url = '/api/product/search';
	  var parameters = [];
	  if (typeof query === 'string' && query.length > 0) {
	    parameters.push('query=' + query);
	  }
	
	  if (activeOnly !== undefined) {
	    parameters.push('active_only=' + (activeOnly ? 'true' : 'false'));
	  }
	
	  if (retailerToken !== undefined) {
	    parameters.push('retailer_token=' + retailerToken);
	  }
	
	  if (parameters.length > 0) {
	    url += '?' + parameters.join('&');
	  }
	
	  return _ajax2.default.get(url).then(function (recommendations) {
	    _cache3.default.setProductSearchRecommendations(recommendations);
	    return recommendations;
	  });
	}
	
	function saveProductOption(productToken, data) {
	  var promise = _ajax2.default.post('/api/product/' + productToken + '/option', data);
	
	  promise.then(function () {
	    // Remove product from cache
	    _cache3.default.removeProduct(productToken);
	    // Re-retrieve product
	    return getProduct(productToken);
	  });
	
	  return promise;
	}
	
	function deleteProductOption(productToken, optionToken) {
	  var promise = _ajax2.default.delete('/api/product/' + productToken + '/option/' + optionToken);
	
	  promise.then(function () {
	    // Remove product from cache
	    _cache3.default.removeProduct(productToken);
	    // Re-retrieve product
	    return getProduct(productToken);
	  });
	
	  return promise;
	}
	
	function createProductBrowseNewPayload(category, subcategory, filter) {
	  var categories = [subcategory ? subcategory : category];
	  var payload = {
	    categories: categories
	  };
	
	  if (filter) {
	    payload[filter.value] = true;
	  }
	
	  return payload;
	}
	
	function productBrowseNew(payload) {
	  // generate cacheKey
	  var values = Object.keys(payload).filter(function (key) {
	    return payload[key] === true;
	  }).sort();
	  var cacheKey = (payload.categories || []).join(':');
	  if (values.length > 0) cacheKey += '+' + values.join(':');
	  if (payload.query) cacheKey += '+query:' + payload.query;
	
	  var currentData = _cache3.default.getCategoryData(cacheKey);
	
	  if (!payload.pagination_token && currentData) {
	    return Promise.resolve(currentData);
	  }
	
	  var appendResultsToRecommendations = function appendResultsToRecommendations(newData) {
	    if (!currentData) return newData;
	
	    var returnValue = _Utils2.default.clone(currentData, true);
	    returnValue.display_order = returnValue.display_order.concat(newData.display_order);
	    returnValue.products = Object.assign(returnValue.products, newData.products);
	    returnValue.brands = Object.assign(returnValue.brands || {}, newData.brands || {});
	    returnValue.collections = Object.assign(returnValue.collections || {}, newData.collections || {});
	
	    if (newData.next_request) {
	      returnValue.next_request = newData.next_request;
	    } else {
	      delete returnValue.next_request;
	    }
	
	    return returnValue;
	  };
	
	  return _ajax2.default.post('/api/product/search-new', payload).then(function (response) {
	    var newContent = appendResultsToRecommendations(response);
	    newContent.cacheKey = cacheKey;
	    _cache3.default.setCategoryData(cacheKey, newContent);
	    return newContent;
	  });
	}
	
	function activateProducts(tokens) {
	  return _ajax2.default.post('/api/product/activate', tokens);
	}
	
	function deactivateProducts(tokens) {
	  return _ajax2.default.post('/api/product/deactivate', tokens);
	}
	
	/**
	 * This gets the value from the local cache only.
	 */
	function getProductOption(productToken, optionToken) {
	  return new Promise(function (accept, reject) {
	    getProductCache(productToken).then(function () {
	      // cache is populated by getProduct / getProductCache
	      var i = void 0,
	          product = _cache2._cache.products[productToken];
	
	      for (i = 0; i < product.options.length; i++) {
	        if (product.options[i].token === optionToken) {
	          accept(product.options[i]);
	          return;
	        }
	      }
	
	      reject('Invalid option token for the given product.');
	    }, reject);
	  });
	}
	
	/* --- Cart --- */
	
	function getCart(cached) {
	  if (cached && _cache2._cache.cart) {
	    return Promise.resolve(_cache2._cache.cart);
	  }
	
	  var returnValue = _ajax2.default.get('/api/cart');
	  returnValue.then(function (response) {
	    _cache3.default.setCart(response);
	  });
	
	  return returnValue;
	}
	
	// TODO: eventually remove this.
	function getCartCache() {
	  return getCart(true);
	}
	
	function addToCart(data) {
	  return _ajax2.default.post('/api/cart/add-items', data).then(function (response) {
	    _cache3.default.setLastAddedProductToken(data[0].product_token);
	    _cache3.default.setCart(response);
	    return response;
	  });
	}
	
	function removeFromCart(itemToken) {
	  var itemList = itemToken;
	  if (!Array.isArray(itemList)) itemList = [itemList];
	  var returnValue = _ajax2.default.post('/api/cart/remove-items', itemList);
	  returnValue.then(function (response) {
	    _cache3.default.setCart(response);
	  });
	
	  return returnValue;
	}
	
	function submitOrder(addressToken, instrumentToken, promoCode) {
	  var payload = {};
	  if (addressToken) payload.address_token = addressToken;
	  if (instrumentToken) payload.instrument_token = instrumentToken;
	  if (promoCode) payload.promo_codes = [promoCode];
	  return _ajax2.default.post('/api/order', payload);
	}
	
	function register(data, requestUpdates) {
	  var url = '/api/user';
	
	  var parameters = [];
	  if (requestUpdates !== undefined) {
	    parameters.push('request-updates=' + (requestUpdates ? 'true' : 'false'));
	  }
	  if (parameters.length > 0) {
	    url += '?' + parameters.join('&');
	  }
	
	  return _ajax2.default.post(url, data);
	}
	
	/* --- User --- */
	function userLogin(alias, code) {
	  var data = {};
	  if (alias.indexOf('@') >= 0) {
	    data.email_address = alias;
	  } else {
	    data.phone_number = alias;
	  }
	
	  if (code) data.code = code;
	
	  var postPromise = _ajax2.default.post('/api/user/login', data);
	
	  if (code) {
	    postPromise.then(function (user) {
	      _cache3.default.setUser(user);
	      return user;
	    });
	  }
	  return postPromise;
	}
	
	function userLogout() {
	  return _ajax2.default.post('/api/user/logout').then(function (response) {
	    _cache3.default.setUser(null);
	    return response;
	  });
	}
	
	function createUser(data) {
	  var promise = _ajax2.default.post('/api/user', data);
	
	  promise.then(function (createdUser) {
	    _cache3.default.setUser(createdUser);
	    return createdUser;
	  });
	
	  return promise;
	}
	
	function impersonateUserByToken(userToken) {
	  var promise = _ajax2.default.post('/api/user/impersonate?token=' + userToken);
	
	  promise.then(function (impersonatedUser) {
	    _cache3.default.setUser(impersonatedUser);
	    return impersonatedUser;
	  });
	
	  return promise;
	}
	
	function importBrand(brandUrl, brandName) {
	  return _ajax2.default.post('/api/import/brand?url=' + brandUrl + '&name=' + brandName);
	}
	
	function backfill(name, dryRun, minId, maxId, windowSize) {
	  var data = { name: name, dry_run: dryRun, min_id: minId, max_id: maxId, window_size: windowSize };
	  return _ajax2.default.post('/api/backfill/start', data);
	}
	
	function getBackfillers() {
	  return _ajax2.default.get('/api/backfill');
	}
	
	function unimpersonateUser() {
	  var promise = _ajax2.default.post('/api/user/unimpersonate');
	
	  promise.then(function (adminUser) {
	    _cache3.default.setUser(adminUser);
	    return adminUser;
	  });
	
	  return promise;
	}
	
	function getLastSelectedRetailer() {
	  var lastSelectedRetailerToken = _cache3.default.getLastSelectedRetailerToken();
	  if (lastSelectedRetailerToken) return Promise.resolve(lastSelectedRetailerToken);
	
	  var promise = _ajax2.default.get('/api/user/last-selected-retailer');
	
	  promise.then(function (lastSelectedRetailerToken) {
	    _cache3.default.setLastSelectedRetailerToken(lastSelectedRetailerToken);
	    return lastSelectedRetailerToken;
	  });
	
	  return promise;
	}
	
	function resetLastSelectedRetailer() {
	  // Reset the cache right away. No need to wait for the network!
	  _cache3.default.setLastSelectedRetailerToken(null);
	
	  return _ajax2.default.post('/api/user/reset-last-selected-retailer');
	}
	
	function getUser(cached) {
	  if (getUser.promise) return getUser.promise;
	
	  cached = cached || false;
	
	  if (cached && _cache2._cache.user !== null) {
	    return Promise.resolve(_cache2._cache.user);
	  }
	
	  getUser.promise = _ajax2.default.get('/api/user').then(function (response) {
	    _cache3.default.setUser(response);
	    getUser.promise = null;
	    return response;
	  });
	
	  return getUser.promise;
	}
	
	function saveUserAddress(address) {
	  var returnValue = _ajax2.default.post('/api/user/addresses', address);
	
	  returnValue.then(function (response) {
	    var user = _Utils2.default.clone(_cache2._cache.user);
	    user.addresses = response;
	    _cache3.default.setUser(user);
	  });
	
	  return returnValue;
	}
	
	/* --- Instrument --- */
	
	function plaidTokenViaStripe(data) {
	  return _ajax2.default.post('/api/instrument/plaid-token-via-stripe', data);
	}
	
	function stripeLinkCard(data) {
	  return _ajax2.default.post('/api/instrument/stripe-link-card', data);
	}
	
	function setDefaultInstrument(instrumentToken) {
	  return _ajax2.default.post('/api/instrument/set-default', { token: instrumentToken });
	}
	
	function removeInstrument(instrumentToken) {
	  return _ajax2.default.post('/api/instrument/unlink', { token: instrumentToken });
	}
	
	/* --- Payment --- */
	
	function chargeRetailer(request) {
	  return _ajax2.default.post('/api/payment/add-retailer-payment', request);
	}
	
	/* --- Orders --- */
	
	function getOrder(orderToken) {
	  return _ajax2.default.get('/api/order/' + orderToken);
	}
	
	var getOrdersPromise = null;
	function getOrders(cached) {
	  if (getOrdersPromise) return getOrdersPromise;
	
	  if (cached && _cache3.default.getOrderList() !== null) {
	    return Promise.resolve(_cache3.default.getOrderList());
	  }
	
	  getOrdersPromise = _ajax2.default.get('/api/order');
	
	  getOrdersPromise.then(function (orders) {
	    getOrdersPromise = null;
	    _cache3.default.setOrderList(orders);
	    return orders;
	  }, function (error) {
	    getOrdersPromise = null;
	    return error;
	  });
	
	  return getOrdersPromise;
	}
	
	function cancelOrder(orderToken) {
	  return _ajax2.default.post('/api/order/' + orderToken + '/cancel');
	}
	
	function updateOrderItem(orderToken, orderItem) {
	  return _ajax2.default.post('/api/order/' + orderToken + '/item', orderItem);
	}
	
	function cancelOrderItems(orderToken, orderItemTokens) {
	  return _ajax2.default.post('/api/order/' + orderToken + '/cancel-items', orderItemTokens);
	}
	
	function removeOrderItems(orderToken, orderItemTokens) {
	  return _ajax2.default.post('/api/order/' + orderToken + '/remove-items', orderItemTokens);
	}
	
	function updateBrandOrder(orderToken, brandOrder) {
	  return _ajax2.default.post('/api/order/' + orderToken + '/brand-order', brandOrder);
	}
	
	function createShipment(orderToken, orderItemTokens) {
	  var data = {
	    order_token: orderToken,
	    order_item_tokens: orderItemTokens
	  };
	
	  return _ajax2.default.post('/api/order/' + orderToken + '/shipment', data);
	}
	
	function updateShipment(payload) {
	  return _ajax2.default.post('/api/order/' + payload.order_token + '/shipment', payload);
	}
	
	function removeShipment(orderToken, shipmentToken) {
	  return _ajax2.default.post('/api/order/' + orderToken + '/remove-shipment/' + shipmentToken);
	}
	
	/* --- Product Collections --- */
	
	function getProductCollection(collectionToken) {
	  return _ajax2.default.get('/api/product-collection/' + collectionToken);
	}
	
	var getProductCollectionsPromise = null;
	function getProductCollections(cached) {
	  if (cached && _cache3.default.getProductCollections() !== null) {
	    return Promise.resolve(_cache3.default.getProductCollections());
	  }
	
	  if (getProductCollectionsPromise) return getProductCollectionsPromise;
	
	  getProductCollectionsPromise = _ajax2.default.get('/api/product-collection');
	  getProductCollectionsPromise.then(function (response) {
	    getProductCollectionsPromise = null;
	    _cache3.default.setProductCollections(response);
	    return response;
	  });
	
	  return getProductCollectionsPromise;
	}
	
	function createOrUpdateProductCollection(payload) {
	  return _ajax2.default.post('/api/product-collection', payload);
	}
	
	/* Admin helpers */
	
	function retailerFromLead(leadLine) {
	  return _ajax2.default.post('/api/retailer/retailer-from-lead', { lead_csv: leadLine });
	}
	
	/* --- Listeners --- */
	
	/**
	 * Sets the state for the given key when the eventType associated cached value changes.
	 * This will also trigger the function `set{stateKey}Value` if it exists within the component object.
	 * @param component -- object: the component for this to work on. usually the `this` value.
	 * @param stateKey -- string: the state key value.
	 * @param eventType -- enum string: from the cache types.
	 */
	function startListen(component, stateKey, eventType) {
	  var eventKeyFunction = '__x_' + _cache3.default.eventTypes[eventType];
	  if (component[eventKeyFunction]) {
	    console.error("statListen() -- trying to register same event type twice.");
	    return;
	  }
	
	  component[eventKeyFunction] = function () {
	    var payload = {};
	    var setValueFunctionName = 'set' + stateKey + 'Value';
	
	    payload[stateKey] = _cache3.default.getForEventType(eventType);
	    component.setState(payload);
	
	    if (component[setValueFunctionName] && typeof component[setValueFunctionName] === 'function') {
	      component[setValueFunctionName](payload[stateKey]);
	    }
	  };
	
	  component[eventKeyFunction]();
	
	  _cache3.default.addChangeListener(component[eventKeyFunction], eventType);
	}
	
	function stopListen(component, eventType) {
	  var eventKeyFunction = '__x_' + _cache3.default.eventTypes[eventType];
	  _cache3.default.removeChangeListener(component[eventKeyFunction], eventType);
	
	  component[eventKeyFunction] = null;
	}
	
	function userStartListen(component, stateKey) {
	  startListen(component, stateKey, _cache3.default.eventTypes.USER_CHANGED);
	}
	
	function userStopListen(component) {
	  stopListen(component, _cache3.default.eventTypes.USER_CHANGED);
	}
	
	function orderListStartListen(component, stateKey) {
	  startListen(component, stateKey, _cache3.default.eventTypes.ORDER_LIST_CHANGED);
	}
	
	function orderListStopListen(component, stateKey) {
	  stopListen(component, stateKey, _cache3.default.eventTypes.ORDER_LIST_CHANGED);
	}
	
	function internalRecommendations() {
	  return _ajax2.default.get('/api/internal/recommendations/');
	}
	
	function validatePromoCodes(promoCodes) {
	  var data = {
	    'promo_codes': promoCodes
	  };
	  return _ajax2.default.post('/api/cart/validate-promo-codes', data);
	}
	
	exports.default = {
	  Utils: _Utils2.default,
	  cache: _cache3.default,
	  event: event,
	  error: error,
	
	  getCategories: getCategories,
	
	  /* Brand */
	  getBrands: getBrands,
	  getBrand: getBrand,
	  saveBrand: saveBrand,
	  getBrandProducts: getBrandProducts,
	  brandLead: brandLead,
	
	  /* Emails */
	  searchEmails: searchEmails,
	  sendEmail: sendEmail,
	
	  /* Recommendation Emails */
	  getPendingRecommendationEmails: getPendingRecommendationEmails,
	  updatePendingRecommendationEmails: updatePendingRecommendationEmails,
	
	  /* Retailer */
	  getRetailer: getRetailer,
	  getRetailers: getRetailers,
	  createRetailer: createRetailer,
	  refreshCurrentRecommendations: refreshCurrentRecommendations,
	  retailerAddRecommendation: retailerAddRecommendation,
	  retailerAddRecommendations: retailerAddRecommendations,
	  retailerRemoveRecommendation: retailerRemoveRecommendation,
	  retailerRemoveRecommendations: retailerRemoveRecommendations,
	  retailerAddCollectionRecommendation: retailerAddCollectionRecommendation,
	  retailerAddCollectionRecommendations: retailerAddCollectionRecommendations,
	  retailerRemoveCollectionRecommendation: retailerRemoveCollectionRecommendation,
	  retailerRemoveCollectionRecommendations: retailerRemoveCollectionRecommendations,
	  retailerAddFromRetailer: retailerAddFromRetailer,
	  retailerClearRecommendations: retailerClearRecommendations,
	  retailerLead: retailerLead,
	  getClosestBrandRetailer: getClosestBrandRetailer,
	  getAccountStatus: getAccountStatus,
	  getPendingPaymentsStatus: getPendingPaymentsStatus,
	
	  /* Product */
	  getProduct: getProduct,
	  getProductCache: getProductCache,
	  getProductOption: getProductOption,
	  deleteProductOption: deleteProductOption,
	  saveProduct: saveProduct,
	  getProducts: getProducts,
	  saveProductOption: saveProductOption,
	  createProductBrowseNewPayload: createProductBrowseNewPayload,
	  productBrowseNew: productBrowseNew,
	  activateProducts: activateProducts,
	  deactivateProducts: deactivateProducts,
	
	  /* Product Collections */
	  getProductCollection: getProductCollection,
	  getProductCollections: getProductCollections,
	  createOrUpdateProductCollection: createOrUpdateProductCollection,
	
	  /* Cart */
	  getCart: getCart,
	  getCartCache: getCartCache,
	  addToCart: addToCart,
	  removeFromCart: removeFromCart,
	  submitOrder: submitOrder,
	  register: register,
	
	  /* User */
	  userLogin: userLogin,
	  userLogout: userLogout,
	  getUser: getUser,
	  createUser: createUser,
	  saveUserAddress: saveUserAddress,
	  impersonateUserByToken: impersonateUserByToken,
	  importBrand: importBrand,
	  unimpersonateUser: unimpersonateUser,
	  getLastSelectedRetailer: getLastSelectedRetailer,
	  resetLastSelectedRetailer: resetLastSelectedRetailer,
	
	  /* Instrument */
	  plaidTokenViaStripe: plaidTokenViaStripe,
	  stripeLinkCard: stripeLinkCard,
	  setDefaultInstrument: setDefaultInstrument,
	  removeInstrument: removeInstrument,
	
	  /* Payment */
	  chargeRetailer: chargeRetailer,
	  getOutstandingIncomingPayments: getOutstandingIncomingPayments,
	
	  /* Orders */
	  getOrder: getOrder,
	  getOrders: getOrders,
	  cancelOrder: cancelOrder,
	  updateOrderItem: updateOrderItem,
	  cancelOrderItems: cancelOrderItems,
	  removeOrderItems: removeOrderItems,
	  updateBrandOrder: updateBrandOrder,
	  createShipment: createShipment,
	  updateShipment: updateShipment,
	  removeShipment: removeShipment,
	
	  /* Promo Codes */
	  validatePromoCodes: validatePromoCodes,
	
	  /* Listener helpers */
	  startListen: startListen,
	  stopListen: stopListen,
	  userStartListen: userStartListen,
	  userStopListen: userStopListen,
	  orderListStartListen: orderListStartListen,
	  orderListStopListen: orderListStopListen,
	
	  /* More stuff */
	  retailerFromLead: retailerFromLead,
	  internalRecommendations: internalRecommendations,
	  backfill: backfill,
	  getBackfillers: getBackfillers
	};
	exports.Utils = _Utils2.default;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonDropdown = exports.Button = undefined;
	
	var _button = __webpack_require__(101);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _dropdown = __webpack_require__(287);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _button2.default;
	exports.Button = _button2.default;
	exports.ButtonDropdown = _dropdown2.default;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _screenReaderStyles = __webpack_require__(527);
	
	var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A React component for the font-awesome icon library.
	 *
	 *
	 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
	 * @param {Boolean} [border=false] Whether or not to show a border radius
	 * @param {String} [className] An extra set of CSS classes to add to the component
	 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
	 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
	 * @param {String} [flip=false] Flip the icon's orientation.
	 * @param {Boolean} [inverse=false]Inverse the icon's color
	 * @param {String} name Name of the icon to use
	 * @param {Boolean} [pulse=false] Rotate icon with 8 steps (rather than smoothly)
	 * @param {Number} [rotate] The degress to rotate the icon by
	 * @param {String} [size] The icon scaling size
	 * @param {Boolean} [spin=false] Spin the icon
	 * @param {String} [stack] Stack an icon on top of another
	 * @param {String} [tag=span] The HTML tag to use as a string (eg 'i' or 'em')
	 * @module FontAwesome
	 * @type {ReactClass}
	 */
	exports.default = _react2.default.createClass({
	
	  displayName: 'FontAwesome',
	
	  propTypes: {
	    ariaLabel: _react2.default.PropTypes.string,
	    border: _react2.default.PropTypes.bool,
	    className: _react2.default.PropTypes.string,
	    cssModule: _react2.default.PropTypes.object,
	    fixedWidth: _react2.default.PropTypes.bool,
	    flip: _react2.default.PropTypes.oneOf(['horizontal', 'vertical']),
	    inverse: _react2.default.PropTypes.bool,
	    name: _react2.default.PropTypes.string.isRequired,
	    pulse: _react2.default.PropTypes.bool,
	    rotate: _react2.default.PropTypes.oneOf([90, 180, 270]),
	    size: _react2.default.PropTypes.oneOf(['lg', '2x', '3x', '4x', '5x']),
	    spin: _react2.default.PropTypes.bool,
	    stack: _react2.default.PropTypes.oneOf(['1x', '2x']),
	    tag: _react2.default.PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var border = _props.border;
	    var cssModule = _props.cssModule;
	    var className = _props.className;
	    var fixedWidth = _props.fixedWidth;
	    var flip = _props.flip;
	    var inverse = _props.inverse;
	    var name = _props.name;
	    var pulse = _props.pulse;
	    var rotate = _props.rotate;
	    var size = _props.size;
	    var spin = _props.spin;
	    var stack = _props.stack;
	    var _props$tag = _props.tag;
	    var tag = _props$tag === undefined ? 'span' : _props$tag;
	    var ariaLabel = _props.ariaLabel;
	
	    var props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);
	
	    var classNames = [];
	
	    if (cssModule) {
	      classNames.push(cssModule['fa']);
	      classNames.push(cssModule['fa-' + name]);
	      size && classNames.push(cssModule['fa-' + size]);
	      spin && classNames.push(cssModule['fa-spin']);
	      pulse && classNames.push(cssModule['fa-pulse']);
	      border && classNames.push(cssModule['fa-border']);
	      fixedWidth && classNames.push(cssModule['fa-fw']);
	      inverse && classNames.push(cssModule['fa-inverse']);
	      flip && classNames.push(cssModule['fa-flip-' + flip]);
	      rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
	      stack && classNames.push(cssModule['fa-stack-' + stack]);
	    } else {
	      classNames.push('fa');
	      classNames.push('fa-' + name);
	      size && classNames.push('fa-' + size);
	      spin && classNames.push('fa-spin');
	      pulse && classNames.push('fa-pulse');
	      border && classNames.push('fa-border');
	      fixedWidth && classNames.push('fa-fw');
	      inverse && classNames.push('fa-inverse');
	      flip && classNames.push('fa-flip-' + flip);
	      rotate && classNames.push('fa-rotate-' + rotate);
	      stack && classNames.push('fa-stack-' + stack);
	    }
	
	    // Add any custom class names at the end.
	    className && classNames.push(className);
	    return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(26);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(96);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(38);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(536);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(263);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(530);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(549);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(531);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(532);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(264);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(534);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(529);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(533);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(535);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(548);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(62);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(537);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(546);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(269);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(539);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(540);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(544);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(266);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var DOMProperty = __webpack_require__(36);
	var ReactDOMComponentFlags = __webpack_require__(246);
	
	var invariant = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(577);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spinner = __webpack_require__(444);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	__webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Processing = function (_React$Component) {
	  _inherits(Processing, _React$Component);
	
	  function Processing() {
	    _classCallCheck(this, Processing);
	
	    return _possibleConstructorReturn(this, (Processing.__proto__ || Object.getPrototypeOf(Processing)).apply(this, arguments));
	  }
	
	  _createClass(Processing, [{
	    key: 'render',
	    value: function render() {
	      var message = this.props.message && this.props.message.length > 0 ? _react2.default.createElement(
	        'h1',
	        { className: 'processing-message' },
	        this.props.message
	      ) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'processing-component' },
	        _react2.default.createElement(
	          'div',
	          { className: 'processing-spinner' },
	          _react2.default.createElement('img', { src: _spinner2.default, role: 'presentation' })
	        ),
	        message
	      );
	    }
	  }]);
	
	  return Processing;
	}(_react2.default.Component);
	
	Processing.propTypes = {
	  message: _propTypes2.default.string
	};
	Processing.defaultProps = {
	  message: ''
	};
	exports.default = Processing;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminTitle = function (_Component) {
	  _inherits(AdminTitle, _Component);
	
	  function AdminTitle() {
	    _classCallCheck(this, AdminTitle);
	
	    return _possibleConstructorReturn(this, (AdminTitle.__proto__ || Object.getPrototypeOf(AdminTitle)).apply(this, arguments));
	  }
	
	  _createClass(AdminTitle, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-title' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'admin-title-text' },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'nav',
	          { className: 'admin-title-nav' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return AdminTitle;
	}(_react.Component);
	
	exports.default = AdminTitle;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8),
	    _assign = __webpack_require__(11);
	
	var CallbackQueue = __webpack_require__(244);
	var PooledClass = __webpack_require__(30);
	var ReactFeatureFlags = __webpack_require__(249);
	var ReactReconciler = __webpack_require__(37);
	var Transaction = __webpack_require__(59);
	
	var invariant = __webpack_require__(5);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(476);


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(30);
	
	var emptyFunction = __webpack_require__(16);
	var warning = __webpack_require__(7);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 25 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/react-select
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactInputAutosize = __webpack_require__(528);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsDefaultArrowRenderer = __webpack_require__(555);
	
	var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);
	
	var _utilsDefaultFilterOptions = __webpack_require__(270);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(271);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var _utilsDefaultClearRenderer = __webpack_require__(556);
	
	var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);
	
	var _Async = __webpack_require__(550);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(551);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(552);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Option = __webpack_require__(553);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(554);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function stringifyValue(value) {
		var valueType = typeof value;
		if (valueType === 'string') {
			return value;
		} else if (valueType === 'object') {
			return JSON.stringify(value);
		} else if (valueType === 'number' || valueType === 'boolean') {
			return String(value);
		} else {
			return '';
		}
	}
	
	var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
	var instanceId = 1;
	
	var Select = _react2['default'].createClass({
	
		displayName: 'Select',
	
		propTypes: {
			addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
			'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
			'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
			arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
			autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
			autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
			autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
			backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
			className: _react2['default'].PropTypes.string, // className for the outer element
			clearAllText: stringOrNode, // title for the "clear" control when multi: true
			clearRenderer: _react2['default'].PropTypes.func, // create clearable x element
			clearValueText: stringOrNode, // title for the "clear" control
			clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
			deleteRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
			disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
			escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
			filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
			filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
			inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
			inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
			instanceId: _react2['default'].PropTypes.string, // set the components instanceId
			isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
			joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
			labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
			matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
			menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
			menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
			menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
			menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
			multi: _react2['default'].PropTypes.bool, // multi-value input
			name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
			noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
			onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
			onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
			onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
			onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
			onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
			onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
			onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
			onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
			onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
			openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
			openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
			optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
			optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
			optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
			options: _react2['default'].PropTypes.array, // array of options
			pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
			placeholder: stringOrNode, // field placeholder, displayed when there's no value
			required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
			resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
			scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
			searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
			simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
			style: _react2['default'].PropTypes.object, // optional style to apply to the control
			tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
			tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
			value: _react2['default'].PropTypes.any, // initial field value
			valueComponent: _react2['default'].PropTypes.func, // value component to render
			valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
			wrapperStyle: _react2['default'].PropTypes.object },
	
		// optional style to apply to the component wrapper
		statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },
	
		getDefaultProps: function getDefaultProps() {
			return {
				addLabelText: 'Add "{label}"?',
				arrowRenderer: _utilsDefaultArrowRenderer2['default'],
				autosize: true,
				backspaceRemoves: true,
				backspaceToRemoveMessage: 'Press backspace to remove {label}',
				clearable: true,
				clearAllText: 'Clear all',
				clearRenderer: _utilsDefaultClearRenderer2['default'],
				clearValueText: 'Clear value',
				deleteRemoves: true,
				delimiter: ',',
				disabled: false,
				escapeClearsValue: true,
				filterOptions: _utilsDefaultFilterOptions2['default'],
				ignoreAccents: true,
				ignoreCase: true,
				inputProps: {},
				isLoading: false,
				joinValues: false,
				labelKey: 'label',
				matchPos: 'any',
				matchProp: 'any',
				menuBuffer: 0,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				multi: false,
				noResultsText: 'No results found',
				onBlurResetsInput: true,
				onCloseResetsInput: true,
				openAfterFocus: false,
				optionComponent: _Option2['default'],
				pageSize: 5,
				placeholder: 'Select...',
				required: false,
				scrollMenuIntoView: true,
				searchable: true,
				simpleValue: false,
				tabSelectsValue: true,
				valueComponent: _Value2['default'],
				valueKey: 'value'
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
		},
	
		componentWillMount: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);
	
			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		},
	
		componentDidMount: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);
	
			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			}
		},
	
		componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		},
	
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
				var menuNode = _reactDom2['default'].findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}
	
			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
				var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		},
	
		componentWillUnmount: function componentWillUnmount() {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		},
	
		toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		},
	
		handleTouchOutside: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		},
	
		focus: function focus() {
			if (!this.input) return;
			this.input.focus();
	
			if (this.props.openAfterFocus) {
				this.setState({
					isOpen: true
				});
			}
		},
	
		blurInput: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.handleMouseDown(event);
		},
	
		handleTouchEndClearValue: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Clear the value
			this.clearValue(event);
		},
	
		handleMouseDown: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
	
			if (event.target.tagName === 'INPUT') {
				return;
			}
	
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
	
			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}
	
			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();
	
				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}
	
				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';
	
				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = true;
				this.focus();
			}
		},
	
		handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		},
	
		handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
	
			this._openAfterFocus = true;
			this.focus();
		},
	
		closeMenu: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: ''
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.state.inputValue
				});
			}
			this.hasScrolledToOption = false;
		},
	
		handleInputFocus: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		},
	
		handleInputBlur: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}
	
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = '';
			}
			this.setState(onBlurredState);
		},
	
		handleInputChange: function handleInputChange(event) {
			var newInputValue = event.target.value;
	
			if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
				var nextState = this.props.onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && typeof nextState !== 'object') {
					newInputValue = '' + nextState;
				}
			}
	
			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		},
	
		handleKeyDown: function handleKeyDown(event) {
			if (this.props.disabled) return;
	
			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}
	
			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				case 46:
					// backspace
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				default:
					return;
			}
			event.preventDefault();
		},
	
		handleValueClick: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		},
	
		handleMenuScroll: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;
	
			if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
				this.props.onMenuScrollToBottom();
			}
		},
	
		handleRequired: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		},
	
		getOptionLabel: function getOptionLabel(op) {
			return op[this.props.labelKey];
		},
	
		/**
	  * Turns a value into an array from the given options
	  * @param	{String|Number|Array}	value		- the value of the select input
	  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	  * @returns	{Array}	the value of the select represented in an array
	  */
		getValueArray: function getValueArray(value, nextProps) {
			var _this = this;
	
			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = typeof nextProps === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		},
	
		/**
	  * Retrieve a value from the given options and valueKey
	  * @param	{String|Number|Array}	value	- the selected value(s)
	  * @param	{Object}		props	- the Select component's props (or nextProps)
	  */
		expandValue: function expandValue(value, props) {
			var valueType = typeof value;
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options;
			var valueKey = props.valueKey;
	
			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		},
	
		setValue: function setValue(value) {
			var _this2 = this;
	
			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (!this.props.onChange) return;
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			this.props.onChange(value);
		},
	
		selectValue: function selectValue(value) {
			var _this3 = this;
	
			//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
			this.hasScrolledToOption = false;
			if (this.props.multi) {
				this.setState({
					inputValue: '',
					focusedIndex: null
				}, function () {
					_this3.addValue(value);
				});
			} else {
				this.setState({
					isOpen: false,
					inputValue: '',
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		},
	
		addValue: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		},
	
		popValue: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(valueArray.slice(0, valueArray.length - 1));
		},
	
		removeValue: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		},
	
		clearValue: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: ''
			}, this.focus);
		},
	
		getResetValue: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		},
	
		focusOption: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		},
	
		focusNextOption: function focusNextOption() {
			this.focusAdjacentOption('next');
		},
	
		focusPreviousOption: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		},
	
		focusPageUpOption: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		},
	
		focusPageDownOption: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		},
	
		focusStartOption: function focusStartOption() {
			this.focusAdjacentOption('start');
		},
	
		focusEndOption: function focusEndOption() {
			this.focusAdjacentOption('end');
		},
	
		focusAdjacentOption: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}
	
			if (focusedIndex === -1) {
				focusedIndex = 0;
			}
	
			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		},
	
		getFocusedOption: function getFocusedOption() {
			return this._focusedOption;
		},
	
		getInputValue: function getInputValue() {
			return this.state.inputValue;
		},
	
		selectFocusedOption: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		},
	
		renderLoading: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2['default'].createElement('span', { className: 'Select-loading' })
			);
		},
	
		renderValue: function renderValue(valueArray, isOpen) {
			var _this4 = this;
	
			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2['default'].createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2['default'].createElement(
						ValueComponent,
						{
							id: _this4._instancePrefix + '-value-' + i,
							instancePrefix: _this4._instancePrefix,
							disabled: _this4.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this4.props.valueKey],
							onClick: onClick,
							onRemove: _this4.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2['default'].createElement(
							'span',
							{ className: 'Select-aria-only' },
							' '
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		},
	
		renderInput: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this5 = this;
	
			var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
			var isOpen = !!this.state.isOpen;
	
			var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
			// TODO: Check how this project includes Object.assign()
			var inputProps = _extends({}, this.props.inputProps, {
				role: 'combobox',
				'aria-expanded': '' + isOpen,
				'aria-owns': ariaOwns,
				'aria-haspopup': '' + isOpen,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-label': this.props['aria-label'],
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this5.input = _ref;
				},
				required: this.state.required,
				value: this.state.inputValue
			});
	
			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}
	
			if (this.props.disabled || !this.props.searchable) {
				var _props$inputProps = this.props.inputProps;
				var inputClassName = _props$inputProps.inputClassName;
	
				var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
				return _react2['default'].createElement('div', _extends({}, divProps, {
					role: 'combobox',
					'aria-expanded': isOpen,
					'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function (ref) {
						return _this5.input = ref;
					},
					'aria-readonly': '' + !!this.props.disabled,
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}
	
			if (this.props.autosize) {
				return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
			}
			return _react2['default'].createElement(
				'div',
				{ className: className },
				_react2['default'].createElement('input', inputProps)
			);
		},
	
		renderClear: function renderClear() {
			if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			var clear = this.props.clearRenderer();
	
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				clear
			);
		},
	
		renderArrow: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
			return _react2['default'].createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		},
	
		filterOptions: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];
	
				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		},
	
		onOptionRef: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		},
	
		renderMenu: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2['default'].createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		},
	
		renderHiddenField: function renderHiddenField(valueArray) {
			var _this6 = this;
	
			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this6.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2['default'].createElement('input', {
					type: 'hidden',
					ref: function (ref) {
						return _this6.value = ref;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2['default'].createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this6.props.name,
					value: stringifyValue(item[_this6.props.valueKey]),
					disabled: _this6.props.disabled });
			});
		},
	
		getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;
	
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = options.indexOf(focusedOption);
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}
	
			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		},
	
		renderOuter: function renderOuter(options, valueArray, focusedOption) {
			var _this7 = this;
	
			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menuContainer = ref;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this7.menu = ref;
						}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		},
	
		render: function render() {
			var _this8 = this;
	
			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2['default'])('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});
	
			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2['default'].createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}
	
			return _react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.wrapper = ref;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this8.control = ref;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2['default'].createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	
	});
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children && this.props.children.length > 0 ? _react2.default.createElement(
	        'div',
	        { className: 'block right' },
	        this.props.children
	      ) : null;
	
	      return _react2.default.createElement(
	        'footer',
	        { className: 'main-footer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'block' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Help'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:contact@indigofair.com' },
	                'Contact'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/tos' },
	                'Terms of Service'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/privacy' },
	                'Privacy Policy'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'block' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Company'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/team' },
	                'Team'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/about' },
	                'About'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:careers@indigofair.com' },
	                'Careers'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'block' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Connect'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://medium.com/@max_150/betting-big-on-local-retail-1aa9706c4e04#', target: '_blank' },
	                'Blog'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.facebook.com/IndigoFairInc/', target: '_blank' },
	                'Facebook'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://twitter.com/indigofair', target: '_blank' },
	                'Twitter'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.instagram.com/indigo.fair/', target: '_blank' },
	                'Instagram'
	              )
	            )
	          )
	        ),
	        children
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 30 */
[581, 8],
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _closeButton = __webpack_require__(125);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	__webpack_require__(374);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LightBox = function (_React$Component) {
	  _inherits(LightBox, _React$Component);
	
	  function LightBox() {
	    _classCallCheck(this, LightBox);
	
	    var _this = _possibleConstructorReturn(this, (LightBox.__proto__ || Object.getPrototypeOf(LightBox)).call(this));
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(LightBox, [{
	    key: 'onClose',
	    value: function onClose(event) {
	      if (this.props.onClose) {
	        this.props.onClose(event);
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      if (event.target.id === 'light-box') {
	        this.onClose(event);
	      } else if (this.props.onClick) {
	        this.props.onClick(event);
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      if (!event.defaultPrevented && event.key === 'Escape') {
	        this.onClose(event);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.addEventListener("keydown", this.onKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.onKeyDown);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classNames = ['light-box-component'];
	      var closeButton = void 0;
	
	      if (this.props.className) classNames.push(this.props.className);
	
	      if (this.props.onClose) {
	        closeButton = _react2.default.createElement(
	          'div',
	          { className: 'light-box-close-button', onClick: this.onClose },
	          _react2.default.createElement('img', { src: _closeButton2.default, role: 'presentation' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'light-box', className: classNames.join(' '), onClick: this.onClick },
	        _react2.default.createElement(
	          'div',
	          { id: 'light-box-contents', className: 'light-box-contents' },
	          closeButton,
	          _react2.default.createElement(
	            'div',
	            { className: 'light-box-inner' },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return LightBox;
	}(_react2.default.Component);
	
	LightBox.propTypes = {
	  onClose: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};
	exports.default = LightBox;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 34 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(80);
	var setInnerHTML = __webpack_require__(61);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(88);
	var setTextContent = __webpack_require__(261);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var invariant = __webpack_require__(5);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(499);
	var ReactInstrumentation = __webpack_require__(18);
	
	var warning = __webpack_require__(7);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactChildren = __webpack_require__(565);
	var ReactComponent = __webpack_require__(98);
	var ReactPureComponent = __webpack_require__(570);
	var ReactClass = __webpack_require__(566);
	var ReactDOMFactories = __webpack_require__(567);
	var ReactElement = __webpack_require__(40);
	var ReactPropTypes = __webpack_require__(568);
	var ReactVersion = __webpack_require__(571);
	
	var onlyChild = __webpack_require__(572);
	var warning = __webpack_require__(7);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(25);
	
	var warning = __webpack_require__(7);
	var canDefineProperty = __webpack_require__(278);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(276);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 41 */
8,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _clone = __webpack_require__(284);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var animate = function animate(elem, style, unit, from, to, time, prop) {
	  if (!elem) return;
	  var start = new Date().getTime();
	  var timer = setInterval(function () {
	    var step = Math.min(1, (new Date().getTime() - start) / time);
	    if (prop) {
	      elem[style] = from + step * (to - from) + unit;
	    } else {
	      elem.style[style] = from + step * (to - from) + unit;
	    }
	
	    if (step === 1) clearInterval(timer);
	  }, 16);
	  elem.style[style] = from + unit;
	};
	
	var csrf_token = null;
	
	/** Sets the CSRF token to be sent on ajax calls.
	 * Pass the parameter `null` or an empty string to stop sending the header.
	 */
	var setCSRF = function setCSRF(token) {
	  csrf_token = token;
	};
	
	/**
	 * Returns a object with the values of the form elements passed on the `keys` parameter,
	 * using their "ref" names.
	 * `keys` should be either
	 * - An Array containing the wanted ref names or
	 * - An Object where the keys are the wanted ref names
	 */
	function getFormValues(component, keys) {
	  var data = {};
	
	  var extractValue = function extractValue(key, resultKey) {
	    var obj = component.refs[key];
	    if (obj) {
	      if (obj.type === 'checkbox') {
	        data[resultKey] = obj.checked;
	      } else if (obj.value) {
	        data[resultKey] = obj.value.trim();
	      }
	    } else {
	      data[resultKey] = null;
	    }
	  };
	
	  if (Array.isArray(keys)) {
	    keys.forEach(function (key) {
	      extractValue(key, key);
	    });
	  } else if ((typeof keys === 'undefined' ? 'undefined' : _typeof(keys)) === 'object') {
	    var myKeys = Object.keys(keys);
	    myKeys.forEach(function (key) {
	      extractValue(key, keys[key]);
	    });
	  }
	  return data;
	}
	
	/**
	 * This function returns all the form refs in the `keys` parameter as an array.
	 * for the bahaviour of the `keys` parameter, refer to the function `getFormValues()` definition.
	 * if `filterNull` is true, all null values are filtered out.
	 * filterNull defaults to false.
	 */
	function getFormValuesArray(component, keys, filterNull) {
	  var data = getFormValues(component, keys);
	  var ret = [];
	
	  if (filterNull === undefined) filterNull = false;
	
	  Object.keys(data).forEach(function (key) {
	    ret.push(data[key]);
	  });
	
	  if (filterNull) {
	    ret = ret.filter(function (value) {
	      return !!value;
	    });
	  }
	
	  return ret;
	}
	
	function millisToYMD(millis) {
	  if (!millis) return '';
	
	  var date = new Date(millis);
	  var day = date.getDate();
	  var month = date.getMonth() + 1;
	  var year = date.getFullYear();
	  return '' + year + '-' + (month <= 9 ? '0' + month : month) + '-' + (day <= 9 ? '0' + day : day);
	}
	
	function millisToTimeOfDay(millis) {
	  if (!millis) return '';
	
	  var date = new Date(millis);
	  var hour = date.getHours();
	  var minute = date.getMinutes();
	  return '' + (hour <= 9 ? '0' + hour : hour) + ':' + (minute <= 9 ? '0' + minute : minute);
	}
	
	function millisToDateAndTime(millis) {
	  if (!millis) return '';
	
	  return millisToYMD(millis) + ' ' + millisToTimeOfDay(millis);
	}
	
	function getTimezoneCode() {
	  var date = new Date();
	  return date.toLocaleString('en', { timeZoneName: 'short' }).split(' ').pop();
	}
	
	function formatCents(cents, dropEmptyCents, dropComma) {
	  if (cents === null || cents === undefined) return null;
	
	  var returnValue = (cents / 100).toLocaleString('en-US', {
	    minimumFractionDigits: 2,
	    maximumFractionDigits: 2
	  });
	
	  if (dropEmptyCents) returnValue = returnValue.replace('.00', '');
	  if (dropComma) returnValue = returnValue.replace(/,/g, '');
	
	  return returnValue;
	}
	
	var MILLIS_PER_DAY = 1000 * 60 * 60 * 24;
	
	/** Returns the always positive total number of days in between the given dates ignoring time and time zones. */
	function dateDiffInDays(date1, date2) {
	  // Discard the time and time-zone information.
	  var utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
	  var utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
	
	  return Math.abs(Math.floor((utc2 - utc1) / MILLIS_PER_DAY));
	}
	
	function camelize(str) {
	  return str.toLowerCase().replace(/_/g, ' ').replace(/(?:[A-Z]|\b\w)/g, function (letter) {
	    return letter.toUpperCase();
	  });
	}
	
	exports.default = {
	  setCSRF: setCSRF,
	  clone: _clone2.default,
	  millisToYMD: millisToYMD,
	  millisToTimeOfDay: millisToTimeOfDay,
	  millisToDateAndTime: millisToDateAndTime,
	  getTimezoneCode: getTimezoneCode,
	
	  scrollTo: function scrollTo(anchor) {
	    var target = document.getElementById(anchor);
	    // TODO: Check if target exists
	    animate(document.body, 'scrollTop', '', window.pageYOffset, target.offsetTop, 200, true);
	  },
	  titleCase: function titleCase(str) {
	    return (str || '').replace(/[_-]/g, ' ').replace(/\w\S*/g, function (txt) {
	      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	    });
	  },
	  bindThis: function bindThis(self, methods) {
	    if (!Array.isArray(methods)) throw new Error('Invalid methods');
	
	    methods.forEach(function (method) {
	      try {
	        self[method] = self[method].bind(self);
	      } catch (e) {
	        console.error('error binding method: ' + method);
	        console.error(e);
	      }
	    });
	  },
	  ajax: function ajax(params) {
	    // TODO: Maybe use fetch() when available?
	    var request = new XMLHttpRequest();
	
	    var url = params.url;
	
	    request.open(params.type, url, true);
	    request.withCredentials = true;
	    request.setRequestHeader('Content-Type', 'application/json');
	    if (csrf_token !== null && csrf_token.length > 0) {
	      request.setRequestHeader('X-Csrf-Token', csrf_token);
	    }
	
	    request.onreadystatechange = function () {
	      if (this.readyState === this.HEADERS_RECEIVED) {
	        // Update CSRF value
	        var new_csrf = this.getResponseHeader('X-Csrf-Token');
	        if (new_csrf !== null) {
	          setCSRF(new_csrf);
	        }
	      }
	
	      if (this.readyState !== 4) return;
	
	      var responseData = null;
	
	      if (this.status !== 204) {
	        try {
	          responseData = JSON.parse(this.responseText);
	        } catch (e) {
	          // Some endpoints do return simple strings.
	          responseData = this.responseText;
	        }
	      }
	
	      if ((this.status === 200 || this.status === 204 || this.status === 304) && params.success) {
	        params.success(responseData);
	      } else if (params.error) {
	        params.error(responseData, params.url, this.status);
	      }
	    };
	    request.send(params.data ? JSON.stringify(params.data) : true);
	  },
	
	
	  getFormValues: getFormValues,
	  getFormValuesArray: getFormValuesArray,
	  formatCents: formatCents,
	  dateDiffInDays: dateDiffInDays,
	  camelize: camelize,
	
	  dollarToCents: function dollarToCents(dollars) {
	    if (dollars === null || dollars === undefined) return null;
	
	    var dollarString = dollars + '00';
	    var dotPosition = dollarString.indexOf('.');
	    var truncatedDollar = dotPosition >= 0 ? dollarString.substr(0, dotPosition + 3) : dollarString;
	    return parseInt(truncatedDollar.replace('.', ''), 10);
	  }
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputField = function (_React$Component) {
	  _inherits(InputField, _React$Component);
	
	  function InputField(props) {
	    _classCallCheck(this, InputField);
	
	    var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.state = {
	      name: props.name
	    };
	    return _this;
	  }
	
	  _createClass(InputField, [{
	    key: 'validate',
	    value: function validate(input) {
	      var isValid = true;
	      if (this.props.required) {
	        isValid = isValid && input.length > 0;
	      } else if (input.length === 0) {
	        return true;
	      }
	
	      if (this.props.validator) {
	        isValid = isValid && this.props.validator(input);
	      }
	
	      return isValid;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var target = event.target;
	      var name = target.name;
	      var isCheckBox = target.type === 'checkbox';
	      var value = isCheckBox ? target.checked : target.value;
	
	      var isValid = false;
	      if (isCheckBox) {
	        isValid = true;
	      } else {
	        isValid = this.validate(value);
	      }
	
	      this.props.onInput && this.props.onInput(name, value, !isValid); // eslint-disable-line no-unused-expressions
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Don't add `onInput`, `error`, `defautValue` as property
	      /* eslint-disable no-unused-vars */
	      var _props = this.props,
	          validator = _props.validator,
	          onInput = _props.onInput,
	          className = _props.className,
	          defaultValue = _props.defaultValue,
	          rest = _objectWithoutProperties(_props, ['validator', 'onInput', 'className', 'defaultValue']);
	      /* eslint-enable no-unused-vars */
	
	      var inputView = void 0;
	      if (this.props.type === 'textarea') {
	        inputView = _react2.default.createElement('textarea', _extends({ onChange: this.onChange,
	          className: className
	        }, rest));
	      } else {
	        inputView = _react2.default.createElement('input', _extends({ onChange: this.onChange,
	          className: className
	        }, rest));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'input-field' },
	        inputView
	      );
	    }
	  }]);
	
	  return InputField;
	}(_react2.default.Component);
	
	InputField.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  errorClass: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onInput: _propTypes2.default.func,
	  validator: _propTypes2.default.func
	};
	exports.default = InputField;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JUST_FOR_YOU_CATEGORY = exports.SHOP_ALL_CATEGORY = exports.CATEGORY_FILTERS_VALUE_TO_NAME = exports.CATEGORY_FILTERS = exports.COUNTRIES = exports.ISO_TO_COUNTRY_NAME = exports.CAN_PROVINCES = exports.USA_STATES = exports.STATE_PROVINCE_SHORTHAND_TO_NAME = exports.CANADA_ISO = exports.US_ISO = undefined;
	
	var _madeInUsa = __webpack_require__(427);
	
	var _madeInUsa2 = _interopRequireDefault(_madeInUsa);
	
	var _ecofriendly = __webpack_require__(425);
	
	var _ecofriendly2 = _interopRequireDefault(_ecofriendly);
	
	var _handmade = __webpack_require__(426);
	
	var _handmade2 = _interopRequireDefault(_handmade);
	
	var _socialGood = __webpack_require__(428);
	
	var _socialGood2 = _interopRequireDefault(_socialGood);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var US_ISO = exports.US_ISO = 'USA';
	var CANADA_ISO = exports.CANADA_ISO = 'CAN';
	
	var STATE_PROVINCE_SHORTHAND_TO_NAME = exports.STATE_PROVINCE_SHORTHAND_TO_NAME = {
	  'AL': 'Alabama',
	  'AK': 'Alaska',
	  'AZ': 'Arizona',
	  'AR': 'Arkansas',
	  'CA': 'California',
	  'CO': 'Colorado',
	  'CT': 'Connecticut',
	  'DE': 'Delaware',
	  'DC': 'District of Columbia',
	  'FL': 'Florida',
	  'GA': 'Georgia',
	  'HI': 'Hawaii',
	  'ID': 'Idaho',
	  'IL': 'Illinois',
	  'IN': 'Indiana',
	  'IA': 'Iowa',
	  'KS': 'Kansas',
	  'KY': 'Kentucky',
	  'LA': 'Louisiana',
	  'ME': 'Maine',
	  'MD': 'Maryland',
	  'MA': 'Massachusetts',
	  'MI': 'Michigan',
	  'MN': 'Minnesota',
	  'MS': 'Mississippi',
	  'MO': 'Missouri',
	  'MT': 'Montana',
	  'NE': 'Nebraska',
	  'NV': 'Nevada',
	  'NH': 'New Hampshire',
	  'NJ': 'New Jersey',
	  'NM': 'New Mexico',
	  'NY': 'New York',
	  'NC': 'North Carolina',
	  'ND': 'North Dakota',
	  'OH': 'Ohio',
	  'OK': 'Oklahoma',
	  'OR': 'Oregon',
	  'PA': 'Pennsylvania',
	  'PR': 'Puerto Rico',
	  'RI': 'Rhode Island',
	  'SC': 'South Carolina',
	  'SD': 'South Dakota',
	  'TN': 'Tennessee',
	  'TX': 'Texas',
	  'UT': 'Utah',
	  'VT': 'Vermont',
	  'VA': 'Virginia',
	  'WA': 'Washington',
	  'WV': 'West Virginia',
	  'WI': 'Wisconsin',
	  'WY': 'Wyoming',
	  'AB': 'Alberta',
	  'BC': 'British Columbia',
	  'MB': 'Manitoba',
	  'NB': 'New Brunswick',
	  'NL': 'Newfoundland',
	  'NS': 'Nova Scotia',
	  'NT': 'Northwest Territories',
	  'NU': 'Nunavut',
	  'ON': 'Ontario',
	  'PE': 'Prince Edward Island',
	  'QC': 'Quebec',
	  'SK': 'Saskatchewan',
	  'YT': 'Yukon'
	};
	
	var USA_STATES = exports.USA_STATES = [{ value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' }, { value: 'AZ', label: 'Arizona' }, { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' }, { value: 'CO', label: 'Colorado' }, { value: 'CT', label: 'Connecticut' }, { value: 'DE', label: 'Delaware' }, { value: 'DC', label: 'District of Columbia' }, { value: 'FL', label: 'Florida' }, { value: 'GA', label: 'Georgia' }, { value: 'HI', label: 'Hawaii' }, { value: 'ID', label: 'Idaho' }, { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' }, { value: 'IA', label: 'Iowa' }, { value: 'KS', label: 'Kansas' }, { value: 'KY', label: 'Kentucky' }, { value: 'LA', label: 'Louisiana' }, { value: 'ME', label: 'Maine' }, { value: 'MD', label: 'Maryland' }, { value: 'MA', label: 'Massachusetts' }, { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' }, { value: 'MS', label: 'Mississippi' }, { value: 'MO', label: 'Missouri' }, { value: 'MT', label: 'Montana' }, { value: 'NE', label: 'Nebraska' }, { value: 'NV', label: 'Nevada' }, { value: 'NH', label: 'New Hampshire' }, { value: 'NJ', label: 'New Jersey' }, { value: 'NM', label: 'New Mexico' }, { value: 'NY', label: 'New York' }, { value: 'NC', label: 'North Carolina' }, { value: 'ND', label: 'North Dakota' }, { value: 'OH', label: 'Ohio' }, { value: 'OK', label: 'Oklahoma' }, { value: 'OR', label: 'Oregon' }, { value: 'PA', label: 'Pennsylvania' }, { value: 'PR', label: 'Puerto Rico' }, { value: 'RI', label: 'Rhode Island' }, { value: 'SC', label: 'South Carolina' }, { value: 'SD', label: 'South Dakota' }, { value: 'TN', label: 'Tennessee' }, { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' }, { value: 'VT', label: 'Vermont' }, { value: 'VA', label: 'Virginia' }, { value: 'WA', label: 'Washington' }, { value: 'WV', label: 'West Virginia' }, { value: 'WI', label: 'Wisconsin' }, { value: 'WY', label: 'Wyoming' }];
	
	var CAN_PROVINCES = exports.CAN_PROVINCES = [{ value: 'AB', label: 'Alberta' }, { value: 'BC', label: 'British Columbia' }, { value: 'MB', label: 'Manitoba' }, { value: 'NB', label: 'New Brunswick' }, { value: 'NL', label: 'Newfoundland' }, { value: 'NS', label: 'Nova Scotia' }, { value: 'NT', label: 'Northwest Territories' }, { value: 'NU', label: 'Nunavut' }, { value: 'ON', label: 'Ontario' }, { value: 'PE', label: 'Prince Edward Island' }, { value: 'QC', label: 'Quebec' }, { value: 'SK', label: 'Saskatchewan' }, { value: 'YT', label: 'Yukon' }];
	
	var ISO_TO_COUNTRY_NAME = exports.ISO_TO_COUNTRY_NAME = {
	  "AFG": "Afghanistan",
	  "ALB": "Albania",
	  "DZA": "Algeria",
	  "ASM": "American Samoa",
	  "AND": "Andorra",
	  "AGO": "Angola",
	  "AIA": "Anguilla",
	  "ATA": "Antarctica",
	  "ATG": "Antigua and Barbuda",
	  "ARG": "Argentina",
	  "ARM": "Armenia",
	  "ABW": "Aruba",
	  "AUS": "Australia",
	  "AUT": "Austria",
	  "AZE": "Azerbaijan",
	  "BHS": "Bahamas",
	  "BHR": "Bahrain",
	  "BGD": "Bangladesh",
	  "BRB": "Barbados",
	  "BLR": "Belarus",
	  "BEL": "Belgium",
	  "BLZ": "Belize",
	  "BEN": "Benin",
	  "BMU": "Bermuda",
	  "BTN": "Bhutan",
	  "BOL": "Bolivia",
	  "BIH": "Bosnia and Herzegovina",
	  "BWA": "Botswana",
	  "BVT": "Bouvet Island",
	  "BRA": "Brazil",
	  "VGB": "British Virgin Islands",
	  "IOT": "British Indian Ocean Territory",
	  "BRN": "Brunei Darussalam",
	  "BGR": "Bulgaria",
	  "BFA": "Burkina Faso",
	  "BDI": "Burundi",
	  "KHM": "Cambodia",
	  "CMR": "Cameroon",
	  "CAN": "Canada",
	  "CPV": "Cape Verde",
	  "CYM": "Cayman Islands",
	  "CAF": "Central African Republic",
	  "TCD": "Chad",
	  "CHL": "Chile",
	  "CHN": "China",
	  "HKG": "Hong Kong, SAR China",
	  "MAC": "Macao, SAR China",
	  "CXR": "Christmas Island",
	  "CCK": "Cocos (Keeling) Islands",
	  "COL": "Colombia",
	  "COM": "Comoros",
	  "COG": "Congo (Brazzaville)",
	  "COD": "Congo, (Kinshasa)",
	  "COK": "Cook Islands",
	  "CRI": "Costa Rica",
	  "CIV": "Côte d’Ivoire",
	  "HRV": "Croatia",
	  "CUB": "Cuba",
	  "CYP": "Cyprus",
	  "CZE": "Czech Republic",
	  "DNK": "Denmark",
	  "DJI": "Djibouti",
	  "DMA": "Dominica",
	  "DOM": "Dominican Republic",
	  "ECU": "Ecuador",
	  "EGY": "Egypt",
	  "SLV": "El Salvador",
	  "GNQ": "Equatorial Guinea",
	  "ERI": "Eritrea",
	  "EST": "Estonia",
	  "ETH": "Ethiopia",
	  "FLK": "Falkland Islands (Malvinas)",
	  "FRO": "Faroe Islands",
	  "FJI": "Fiji",
	  "FIN": "Finland",
	  "FRA": "France",
	  "GUF": "French Guiana",
	  "PYF": "French Polynesia",
	  "ATF": "French Southern Territories",
	  "GAB": "Gabon",
	  "GMB": "Gambia",
	  "GEO": "Georgia",
	  "DEU": "Germany",
	  "GHA": "Ghana",
	  "GIB": "Gibraltar",
	  "GRC": "Greece",
	  "GRL": "Greenland",
	  "GRD": "Grenada",
	  "GLP": "Guadeloupe",
	  "GUM": "Guam",
	  "GTM": "Guatemala",
	  "GGY": "Guernsey",
	  "GIN": "Guinea",
	  "GNB": "Guinea-Bissau",
	  "GUY": "Guyana",
	  "HTI": "Haiti",
	  "HMD": "Heard and Mcdonald Islands",
	  "VAT": "Holy See (Vatican City State)",
	  "HND": "Honduras",
	  "HUN": "Hungary",
	  "ISL": "Iceland",
	  "IND": "India",
	  "IDN": "Indonesia",
	  "IRN": "Iran, Islamic Republic of",
	  "IRQ": "Iraq",
	  "IRL": "Ireland",
	  "IMN": "Isle of Man",
	  "ISR": "Israel",
	  "ITA": "Italy",
	  "JAM": "Jamaica",
	  "JPN": "Japan",
	  "JEY": "Jersey",
	  "JOR": "Jordan",
	  "KAZ": "Kazakhstan",
	  "KEN": "Kenya",
	  "KIR": "Kiribati",
	  "PRK": "Korea (North)",
	  "KOR": "Korea (South)",
	  "KWT": "Kuwait",
	  "KGZ": "Kyrgyzstan",
	  "LAO": "Lao PDR",
	  "LVA": "Latvia",
	  "LBN": "Lebanon",
	  "LSO": "Lesotho",
	  "LBR": "Liberia",
	  "LBY": "Libya",
	  "LIE": "Liechtenstein",
	  "LTU": "Lithuania",
	  "LUX": "Luxembourg",
	  "MKD": "Macedonia, Republic",
	  "MDG": "Madagascar",
	  "MWI": "Malawi",
	  "MYS": "Malaysia",
	  "MDV": "Maldives",
	  "MLI": "Mali",
	  "MLT": "Malta",
	  "MHL": "Marshall Islands",
	  "MTQ": "Martinique",
	  "MRT": "Mauritania",
	  "MUS": "Mauritius",
	  "MYT": "Mayotte",
	  "MEX": "Mexico",
	  "FSM": "Micronesia, Federated States",
	  "MDA": "Moldova",
	  "MCO": "Monaco",
	  "MNG": "Mongolia",
	  "MNE": "Montenegro",
	  "MSR": "Montserrat",
	  "MAR": "Morocco",
	  "MOZ": "Mozambique",
	  "MMR": "Myanmar",
	  "NAM": "Namibia",
	  "NRU": "Nauru",
	  "NPL": "Nepal",
	  "NLD": "Netherlands",
	  "ANT": "Netherlands Antilles",
	  "NCL": "New Caledonia",
	  "NZL": "New Zealand",
	  "NIC": "Nicaragua",
	  "NER": "Niger",
	  "NGA": "Nigeria",
	  "NIU": "Niue",
	  "NFK": "Norfolk Island",
	  "MNP": "Northern Mariana Islands",
	  "NOR": "Norway",
	  "OMN": "Oman",
	  "PAK": "Pakistan",
	  "PLW": "Palau",
	  "PSE": "Palestinian Territory",
	  "PAN": "Panama",
	  "PNG": "Papua New Guinea",
	  "PRY": "Paraguay",
	  "PER": "Peru",
	  "PHL": "Philippines",
	  "PCN": "Pitcairn",
	  "POL": "Poland",
	  "PRT": "Portugal",
	  "PRI": "Puerto Rico",
	  "QAT": "Qatar",
	  "REU": "Réunion",
	  "ROU": "Romania",
	  "RUS": "Russian Federation",
	  "RWA": "Rwanda",
	  "BLM": "Saint-Barthélemy",
	  "SHN": "Saint Helena",
	  "KNA": "Saint Kitts and Nevis",
	  "LCA": "Saint Lucia",
	  "MAF": "Saint-Martin (French part)",
	  "SPM": "Saint Pierre and Miquelon",
	  "VCT": "Saint Vincent and Grenadines",
	  "WSM": "Samoa",
	  "SMR": "San Marino",
	  "STP": "Sao Tome and Principe",
	  "SAU": "Saudi Arabia",
	  "SEN": "Senegal",
	  "SRB": "Serbia",
	  "SYC": "Seychelles",
	  "SLE": "Sierra Leone",
	  "SGP": "Singapore",
	  "SVK": "Slovakia",
	  "SVN": "Slovenia",
	  "SLB": "Solomon Islands",
	  "SOM": "Somalia",
	  "ZAF": "South Africa",
	  "SGS": "South Georgia and the South Sandwich Islands",
	  "SSD": "South Sudan",
	  "ESP": "Spain",
	  "LKA": "Sri Lanka",
	  "SDN": "Sudan",
	  "SUR": "Suriname",
	  "SJM": "Svalbard and Jan Mayen Islands",
	  "SWZ": "Swaziland",
	  "SWE": "Sweden",
	  "CHE": "Switzerland",
	  "SYR": "Syrian Arab Republic (Syria)",
	  "TWN": "Taiwan, Republic of China",
	  "TJK": "Tajikistan",
	  "TZA": "Tanzania, United Republic of",
	  "THA": "Thailand",
	  "TLS": "Timor-Leste",
	  "TGO": "Togo",
	  "TKL": "Tokelau",
	  "TON": "Tonga",
	  "TTO": "Trinidad and Tobago",
	  "TUN": "Tunisia",
	  "TUR": "Turkey",
	  "TKM": "Turkmenistan",
	  "TCA": "Turks and Caicos Islands",
	  "TUV": "Tuvalu",
	  "UGA": "Uganda",
	  "UKR": "Ukraine",
	  "ARE": "United Arab Emirates",
	  "GBR": "United Kingdom",
	  "USA": "United States of America",
	  "UMI": "US Minor Outlying Islands",
	  "URY": "Uruguay",
	  "UZB": "Uzbekistan",
	  "VUT": "Vanuatu",
	  "VEN": "Venezuela (Bolivarian Republic)",
	  "VNM": "Viet Nam",
	  "VIR": "Virgin Islands",
	  "WLF": "Wallis and Futuna Islands",
	  "ESH": "Western Sahara",
	  "YEM": "Yemen",
	  "ZMB": "Zambia",
	  "ZWE": "Zimbabe"
	};
	
	var COUNTRIES = exports.COUNTRIES = [{ value: "USA", label: "United States of America" }, { value: "CAN", label: "Canada" }, { value: "AFG", label: "Afghanistan" }, { value: "ALB", label: "Albania" }, { value: "DZA", label: "Algeria" }, { value: "ASM", label: "American Samoa" }, { value: "AND", label: "Andorra" }, { value: "AGO", label: "Angola" }, { value: "AIA", label: "Anguilla" }, { value: "ATA", label: "Antarctica" }, { value: "ATG", label: "Antigua and Barbuda" }, { value: "ARG", label: "Argentina" }, { value: "ARM", label: "Armenia" }, { value: "ABW", label: "Aruba" }, { value: "AUS", label: "Australia" }, { value: "AUT", label: "Austria" }, { value: "AZE", label: "Azerbaijan" }, { value: "BHS", label: "Bahamas" }, { value: "BHR", label: "Bahrain" }, { value: "BGD", label: "Bangladesh" }, { value: "BRB", label: "Barbados" }, { value: "BLR", label: "Belarus" }, { value: "BEL", label: "Belgium" }, { value: "BLZ", label: "Belize" }, { value: "BEN", label: "Benin" }, { value: "BMU", label: "Bermuda" }, { value: "BTN", label: "Bhutan" }, { value: "BOL", label: "Bolivia" }, { value: "BIH", label: "Bosnia and Herzegovina" }, { value: "BWA", label: "Botswana" }, { value: "BVT", label: "Bouvet Island" }, { value: "BRA", label: "Brazil" }, { value: "VGB", label: "British Virgin Islands" }, { value: "IOT", label: "British Indian Ocean Territory" }, { value: "BRN", label: "Brunei Darussalam" }, { value: "BGR", label: "Bulgaria" }, { value: "BFA", label: "Burkina Faso" }, { value: "BDI", label: "Burundi" }, { value: "KHM", label: "Cambodia" }, { value: "CMR", label: "Cameroon" }, { value: "CPV", label: "Cape Verde" }, { value: "CYM", label: "Cayman Islands" }, { value: "CAF", label: "Central African Republic" }, { value: "TCD", label: "Chad" }, { value: "CHL", label: "Chile" }, { value: "CHN", label: "China" }, { value: "HKG", label: "Hong Kong, SAR China" }, { value: "MAC", label: "Macao, SAR China" }, { value: "CXR", label: "Christmas Island" }, { value: "CCK", label: "Cocos (Keeling) Islands" }, { value: "COL", label: "Colombia" }, { value: "COM", label: "Comoros" }, { value: "COG", label: "Congo (Brazzaville)" }, { value: "COD", label: "Congo, (Kinshasa)" }, { value: "COK", label: "Cook Islands" }, { value: "CRI", label: "Costa Rica" }, { value: "CIV", label: "Côte d’Ivoire" }, { value: "HRV", label: "Croatia" }, { value: "CUB", label: "Cuba" }, { value: "CYP", label: "Cyprus" }, { value: "CZE", label: "Czech Republic" }, { value: "DNK", label: "Denmark" }, { value: "DJI", label: "Djibouti" }, { value: "DMA", label: "Dominica" }, { value: "DOM", label: "Dominican Republic" }, { value: "ECU", label: "Ecuador" }, { value: "EGY", label: "Egypt" }, { value: "SLV", label: "El Salvador" }, { value: "GNQ", label: "Equatorial Guinea" }, { value: "ERI", label: "Eritrea" }, { value: "EST", label: "Estonia" }, { value: "ETH", label: "Ethiopia" }, { value: "FLK", label: "Falkland Islands (Malvinas)" }, { value: "FRO", label: "Faroe Islands" }, { value: "FJI", label: "Fiji" }, { value: "FIN", label: "Finland" }, { value: "FRA", label: "France" }, { value: "GUF", label: "French Guiana" }, { value: "PYF", label: "French Polynesia" }, { value: "ATF", label: "French Southern Territories" }, { value: "GAB", label: "Gabon" }, { value: "GMB", label: "Gambia" }, { value: "GEO", label: "Georgia" }, { value: "DEU", label: "Germany" }, { value: "GHA", label: "Ghana" }, { value: "GIB", label: "Gibraltar" }, { value: "GRC", label: "Greece" }, { value: "GRL", label: "Greenland" }, { value: "GRD", label: "Grenada" }, { value: "GLP", label: "Guadeloupe" }, { value: "GUM", label: "Guam" }, { value: "GTM", label: "Guatemala" }, { value: "GGY", label: "Guernsey" }, { value: "GIN", label: "Guinea" }, { value: "GNB", label: "Guinea-Bissau" }, { value: "GUY", label: "Guyana" }, { value: "HTI", label: "Haiti" }, { value: "HMD", label: "Heard and Mcdonald Islands" }, { value: "VAT", label: "Holy See (Vatican City State)" }, { value: "HND", label: "Honduras" }, { value: "HUN", label: "Hungary" }, { value: "ISL", label: "Iceland" }, { value: "IND", label: "India" }, { value: "IDN", label: "Indonesia" }, { value: "IRN", label: "Iran, Islamic Republic of" }, { value: "IRQ", label: "Iraq" }, { value: "IRL", label: "Ireland" }, { value: "IMN", label: "Isle of Man" }, { value: "ISR", label: "Israel" }, { value: "ITA", label: "Italy" }, { value: "JAM", label: "Jamaica" }, { value: "JPN", label: "Japan" }, { value: "JEY", label: "Jersey" }, { value: "JOR", label: "Jordan" }, { value: "KAZ", label: "Kazakhstan" }, { value: "KEN", label: "Kenya" }, { value: "KIR", label: "Kiribati" }, { value: "PRK", label: "Korea (North)" }, { value: "KOR", label: "Korea (South)" }, { value: "KWT", label: "Kuwait" }, { value: "KGZ", label: "Kyrgyzstan" }, { value: "LAO", label: "Lao PDR" }, { value: "LVA", label: "Latvia" }, { value: "LBN", label: "Lebanon" }, { value: "LSO", label: "Lesotho" }, { value: "LBR", label: "Liberia" }, { value: "LBY", label: "Libya" }, { value: "LIE", label: "Liechtenstein" }, { value: "LTU", label: "Lithuania" }, { value: "LUX", label: "Luxembourg" }, { value: "MKD", label: "Macedonia, Republic" }, { value: "MDG", label: "Madagascar" }, { value: "MWI", label: "Malawi" }, { value: "MYS", label: "Malaysia" }, { value: "MDV", label: "Maldives" }, { value: "MLI", label: "Mali" }, { value: "MLT", label: "Malta" }, { value: "MHL", label: "Marshall Islands" }, { value: "MTQ", label: "Martinique" }, { value: "MRT", label: "Mauritania" }, { value: "MUS", label: "Mauritius" }, { value: "MYT", label: "Mayotte" }, { value: "MEX", label: "Mexico" }, { value: "FSM", label: "Micronesia, Federated States" }, { value: "MDA", label: "Moldova" }, { value: "MCO", label: "Monaco" }, { value: "MNG", label: "Mongolia" }, { value: "MNE", label: "Montenegro" }, { value: "MSR", label: "Montserrat" }, { value: "MAR", label: "Morocco" }, { value: "MOZ", label: "Mozambique" }, { value: "MMR", label: "Myanmar" }, { value: "NAM", label: "Namibia" }, { value: "NRU", label: "Nauru" }, { value: "NPL", label: "Nepal" }, { value: "NLD", label: "Netherlands" }, { value: "ANT", label: "Netherlands Antilles" }, { value: "NCL", label: "New Caledonia" }, { value: "NZL", label: "New Zealand" }, { value: "NIC", label: "Nicaragua" }, { value: "NER", label: "Niger" }, { value: "NGA", label: "Nigeria" }, { value: "NIU", label: "Niue" }, { value: "NFK", label: "Norfolk Island" }, { value: "MNP", label: "Northern Mariana Islands" }, { value: "NOR", label: "Norway" }, { value: "OMN", label: "Oman" }, { value: "PAK", label: "Pakistan" }, { value: "PLW", label: "Palau" }, { value: "PSE", label: "Palestinian Territory" }, { value: "PAN", label: "Panama" }, { value: "PNG", label: "Papua New Guinea" }, { value: "PRY", label: "Paraguay" }, { value: "PER", label: "Peru" }, { value: "PHL", label: "Philippines" }, { value: "PCN", label: "Pitcairn" }, { value: "POL", label: "Poland" }, { value: "PRT", label: "Portugal" }, { value: "PRI", label: "Puerto Rico" }, { value: "QAT", label: "Qatar" }, { value: "REU", label: "Réunion" }, { value: "ROU", label: "Romania" }, { value: "RUS", label: "Russian Federation" }, { value: "RWA", label: "Rwanda" }, { value: "BLM", label: "Saint-Barthélemy" }, { value: "SHN", label: "Saint Helena" }, { value: "KNA", label: "Saint Kitts and Nevis" }, { value: "LCA", label: "Saint Lucia" }, { value: "MAF", label: "Saint-Martin (French part)" }, { value: "SPM", label: "Saint Pierre and Miquelon" }, { value: "VCT", label: "Saint Vincent and Grenadines" }, { value: "WSM", label: "Samoa" }, { value: "SMR", label: "San Marino" }, { value: "STP", label: "Sao Tome and Principe" }, { value: "SAU", label: "Saudi Arabia" }, { value: "SEN", label: "Senegal" }, { value: "SRB", label: "Serbia" }, { value: "SYC", label: "Seychelles" }, { value: "SLE", label: "Sierra Leone" }, { value: "SGP", label: "Singapore" }, { value: "SVK", label: "Slovakia" }, { value: "SVN", label: "Slovenia" }, { value: "SLB", label: "Solomon Islands" }, { value: "SOM", label: "Somalia" }, { value: "ZAF", label: "South Africa" }, { value: "SGS", label: "South Georgia and the South Sandwich Islands" }, { value: "SSD", label: "South Sudan" }, { value: "ESP", label: "Spain" }, { value: "LKA", label: "Sri Lanka" }, { value: "SDN", label: "Sudan" }, { value: "SUR", label: "Suriname" }, { value: "SJM", label: "Svalbard and Jan Mayen Islands" }, { value: "SWZ", label: "Swaziland" }, { value: "SWE", label: "Sweden" }, { value: "CHE", label: "Switzerland" }, { value: "SYR", label: "Syrian Arab Republic (Syria)" }, { value: "TWN", label: "Taiwan, Republic of China" }, { value: "TJK", label: "Tajikistan" }, { value: "TZA", label: "Tanzania, United Republic of" }, { value: "THA", label: "Thailand" }, { value: "TLS", label: "Timor-Leste" }, { value: "TGO", label: "Togo" }, { value: "TKL", label: "Tokelau" }, { value: "TON", label: "Tonga" }, { value: "TTO", label: "Trinidad and Tobago" }, { value: "TUN", label: "Tunisia" }, { value: "TUR", label: "Turkey" }, { value: "TKM", label: "Turkmenistan" }, { value: "TCA", label: "Turks and Caicos Islands" }, { value: "TUV", label: "Tuvalu" }, { value: "UGA", label: "Uganda" }, { value: "UKR", label: "Ukraine" }, { value: "ARE", label: "United Arab Emirates" }, { value: "GBR", label: "United Kingdom" }, { value: "UMI", label: "US Minor Outlying Islands" }, { value: "URY", label: "Uruguay" }, { value: "UZB", label: "Uzbekistan" }, { value: "VUT", label: "Vanuatu" }, { value: "VEN", label: "Venezuela (Bolivarian Republic)" }, { value: "VNM", label: "Viet Nam" }, { value: "VIR", label: "Virgin Islands" }, { value: "WLF", label: "Wallis and Futuna Islands" }, { value: "ESH", label: "Western Sahara" }, { value: "YEM", label: "Yemen" }, { value: "ZMB", label: "Zambia" }, { value: "ZWE", label: "Zimbabe" }];
	
	var CATEGORY_FILTERS = exports.CATEGORY_FILTERS = [{ name: "made in USA", icon: _madeInUsa2.default, value: "made_in_usa", height: 14 }, { name: "ecofriendly", icon: _ecofriendly2.default, value: "eco_friendly", height: 14 }, { name: "handmade", icon: _handmade2.default, value: "hand_made", height: 13 }, { name: "social good", icon: _socialGood2.default, value: "charitable", height: 11 }];
	
	var CATEGORY_FILTERS_VALUE_TO_NAME = exports.CATEGORY_FILTERS_VALUE_TO_NAME = {
	  "made_in_usa": "made in USA",
	  "eco_friendly": "ecofriendly",
	  "hand_made": "handmade",
	  "charitable": "social good"
	};
	
	var SHOP_ALL_CATEGORY = exports.SHOP_ALL_CATEGORY = 'All Products';
	var JUST_FOR_YOU_CATEGORY = exports.JUST_FOR_YOU_CATEGORY = 'Just For You';

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var EventPluginRegistry = __webpack_require__(81);
	var EventPluginUtils = __webpack_require__(82);
	var ReactErrorUtils = __webpack_require__(86);
	
	var accumulateInto = __webpack_require__(255);
	var forEachAccumulated = __webpack_require__(256);
	var invariant = __webpack_require__(5);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(45);
	var EventPluginUtils = __webpack_require__(82);
	
	var accumulateInto = __webpack_require__(255);
	var forEachAccumulated = __webpack_require__(256);
	var warning = __webpack_require__(7);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(24);
	
	var getEventTarget = __webpack_require__(91);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_OPTION_NAME = undefined;
	exports.optionTree = optionTree;
	exports.getTopLevelOptions = getTopLevelOptions;
	exports.getErrorKey = getErrorKey;
	exports.createAlertMessage = createAlertMessage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_OPTION_NAME = exports.DEFAULT_OPTION_NAME = 'default';
	
	function optionTree(brandToken, product, parentToken) {
	  if (!product || !product.options || product.options === 0) return null;
	
	  parentToken = parentToken || '';
	
	  var ret = product.options.filter(function (productOption) {
	    var myParent = productOption.parent_token || '';
	    return myParent === parentToken;
	  }).map(function (productOption) {
	    var children = optionTree(brandToken, product, productOption.token);
	
	    var color = void 0;
	    if (productOption.color && productOption.color.rgb && productOption.color.rgb !== '') {
	      var rgbColor = productOption.color.rgb;
	      if (rgbColor.length > 0 && rgbColor[0] !== '#') rgbColor = '#' + rgbColor;
	      color = _react2.default.createElement('span', { className: 'oval', style: { backgroundColor: rgbColor } });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { key: productOption.token, className: 'product-option-block' },
	      _react2.default.createElement(
	        'div',
	        { className: 'product-option' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          productOption.group_name,
	          ': ',
	          productOption.name
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'description' },
	          color,
	          ' (',
	          productOption.description,
	          ')'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'brand-code' },
	          productOption.brand_code
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            null,
	            'Remove'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              to: '/admin/brand/' + brandToken + '/product/' + product.token + '/option/' + productOption.token + '/edit' },
	            'Edit'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'product-option-children' },
	        children
	      )
	    );
	  });
	
	  return ret;
	}
	
	function getTopLevelOptions(options) {
	  var defaultOptionValues = [{ key: 'optionValues-0', value: { name: DEFAULT_OPTION_NAME } }];
	  if (!options) {
	    return { optionName: DEFAULT_OPTION_NAME, optionValues: defaultOptionValues };
	  }
	
	  var optionValues = options.filter(function (o) {
	    return !o.parent_token;
	  }).map(function (o) {
	    return { key: o.token, value: o };
	  });
	
	  // Invalid options, must be level of no parent_token set; return default case
	  if (!optionValues || optionValues.length === 0) {
	    return { optionName: DEFAULT_OPTION_NAME, optionValues: defaultOptionValues };
	  }
	
	  var optionName = optionValues.reduce(function (acc, optionValue) {
	    return optionValue.value.group_name || acc;
	  }, DEFAULT_OPTION_NAME);
	
	  return {
	    optionName: optionName,
	    optionValues: optionValues
	  };
	}
	
	var ErrorPrefix = 'ErrorPrefix';
	function getErrorKey(fieldName) {
	  return ErrorPrefix + '_' + fieldName;
	}
	
	function createAlertMessage(error) {
	  var messages = [];
	  messages.push('Status: ' + error.httpStatusCode);
	  messages.push('Message: ' + JSON.stringify(error.message || error.response && error.response.message));
	  return messages.join('\n');
	}

/***/ },
/* 50 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.capitalizeEveryWord = capitalizeEveryWord;
	function capitalizeEveryWord(string) {
	  if (!string) {
	    return string;
	  }
	
	  return string.toLowerCase().replace(/(?:[A-Z]|\b\w)/g, function (letter) {
	    return letter.toUpperCase();
	  });
	}

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _logo = __webpack_require__(53);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StaticHeader = function (_React$Component) {
	  _inherits(StaticHeader, _React$Component);
	
	  function StaticHeader() {
	    _classCallCheck(this, StaticHeader);
	
	    return _possibleConstructorReturn(this, (StaticHeader.__proto__ || Object.getPrototypeOf(StaticHeader)).apply(this, arguments));
	  }
	
	  _createClass(StaticHeader, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'header-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'logo-wrapper' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/' },
	              _react2.default.createElement('img', { src: _logo2.default, role: 'presentation' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StaticHeader;
	}(_react2.default.Component);
	
	exports.default = StaticHeader;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(362);
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.59f3a2eb.png";

/***/ },
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(460);
	
	var _runTransitionHook = __webpack_require__(77);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(29);
	
	var _deprecate = __webpack_require__(76);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(462);

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var EventPluginRegistry = __webpack_require__(81);
	var ReactEventEmitterMixin = __webpack_require__(491);
	var ViewportMetrics = __webpack_require__(254);
	
	var getVendorPrefixedEventName = __webpack_require__(524);
	var isEventSupported = __webpack_require__(92);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(48);
	var ViewportMetrics = __webpack_require__(254);
	
	var getEventModifierState = __webpack_require__(90);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var invariant = __webpack_require__(5);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 60 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	var DOMNamespaces = __webpack_require__(80);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(88);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(63);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(543);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(26);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(52);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(23);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'Tab',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    focus: _propTypes2.default.bool,
	    selected: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    activeTabClassName: _propTypes2.default.string,
	    disabledTabClassName: _propTypes2.default.string,
	    panelId: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      focus: false,
	      selected: false,
	      id: null,
	      panelId: null,
	      activeTabClassName: 'ReactTabs__Tab--selected',
	      disabledTabClassName: 'ReactTabs__Tab--disabled'
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.checkFocus();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.checkFocus();
	  },
	  checkFocus: function checkFocus() {
	    if (this.props.selected && this.props.focus) {
	      (0, _reactDom.findDOMNode)(this).focus();
	    }
	  },
	  render: function render() {
	    var _cx;
	
	    var _props = this.props,
	        selected = _props.selected,
	        disabled = _props.disabled,
	        panelId = _props.panelId,
	        activeTabClassName = _props.activeTabClassName,
	        disabledTabClassName = _props.disabledTabClassName,
	        className = _props.className,
	        children = _props.children,
	        id = _props.id,
	        attributes = _objectWithoutProperties(_props, ['selected', 'disabled', 'panelId', 'activeTabClassName', 'disabledTabClassName', 'className', 'children', 'id']);
	
	    delete attributes.focus;
	
	    return _react2.default.createElement(
	      'li',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__Tab', className, (_cx = {}, _defineProperty(_cx, activeTabClassName, selected), _defineProperty(_cx, disabledTabClassName, disabled), _cx)),
	        role: 'tab',
	        id: id,
	        'aria-selected': selected ? 'true' : 'false',
	        'aria-disabled': disabled ? 'true' : 'false',
	        'aria-controls': panelId,
	        tabIndex: selected ? '0' : null
	      }),
	      children
	    );
	  }
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StringUtils = __webpack_require__(50);
	
	__webpack_require__(368);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HOME = 'home';
	
	var BreadCrumb = function (_Component) {
	  _inherits(BreadCrumb, _Component);
	
	  function BreadCrumb() {
	    _classCallCheck(this, BreadCrumb);
	
	    return _possibleConstructorReturn(this, (BreadCrumb.__proto__ || Object.getPrototypeOf(BreadCrumb)).apply(this, arguments));
	  }
	
	  _createClass(BreadCrumb, [{
	    key: 'render',
	    value: function render() {
	      var path = [{ name: HOME, onClick: this.props.onSelect.bind(this, null, 0) }];
	      if (this.props.primary) {
	        path.push({
	          name: this.props.primary,
	          onClick: this.props.onSelect.bind(this, this.props.primary, 1)
	        });
	        if (this.props.secondary) {
	          path.push({
	            name: this.props.secondary,
	            onClick: this.props.onSelect.bind(this, this.props.secondary, 2)
	          });
	        }
	      }
	
	      var breadcrumb = path.map(function (pathObj, index) {
	        var key = pathObj.name + index;
	        return _react2.default.createElement(
	          'li',
	          { onClick: pathObj.onClick, key: key },
	          _react2.default.createElement(
	            'span',
	            null,
	            pathObj.name
	          )
	        );
	      });
	
	      var filtersLink = null;
	      if (this.props.onShopFilters && this.props.onClearFilters && this.props.filter) {
	        var filterNameString = (0, _StringUtils.capitalizeEveryWord)(this.props.filter.name);
	        filtersLink = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { className: 'text', onClick: this.props.onShopFilters.bind(this, this.props.filter) },
	            'Shop All ',
	            filterNameString,
	            ' Products'
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'link', onClick: this.props.onClearFilters },
	            'Clear Filters'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'breadcrumb-component ' + this.props.className },
	        _react2.default.createElement(
	          'div',
	          { className: 'breadcrumb' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            breadcrumb
	          )
	        ),
	        this.props.children,
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-actions' },
	          filtersLink
	        )
	      );
	    }
	  }]);
	
	  return BreadCrumb;
	}(_react.Component);
	
	BreadCrumb.propTypes = {
	  onShopFilters: _propTypes2.default.func,
	  onClearFilters: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func.isRequired,
	  primary: _propTypes2.default.string,
	  secondary: _propTypes2.default.string,
	  filter: _propTypes2.default.object
	};
	exports.default = BreadCrumb;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Hardcoded things for now
	var SIDE_MARGINS = 300;
	var WIDTH_PER_CATEGORY = 108;
	
	function normalizeToClassName(name) {
	  return name.toLowerCase().replace(/[^a-z0-9]/g, '-');
	}
	
	function splitList(list, count) {
	  if (!list || list.length === 0) {
	    return { visible: null, hidden: null };
	  }
	
	  if (list.length > count) {
	    count -= 1;
	  }
	
	  var visible = list.slice(0, count);
	  var hidden = list.slice(count);
	  return { visible: visible, hidden: hidden };
	}
	
	var CategoryBarDropdown = function (_React$Component) {
	  _inherits(CategoryBarDropdown, _React$Component);
	
	  function CategoryBarDropdown(props) {
	    _classCallCheck(this, CategoryBarDropdown);
	
	    var _this = _possibleConstructorReturn(this, (CategoryBarDropdown.__proto__ || Object.getPrototypeOf(CategoryBarDropdown)).call(this, props));
	
	    _this.onPlaceholderMouseOver = _this.onPlaceholderMouseOver.bind(_this);
	    return _this;
	  }
	
	  _createClass(CategoryBarDropdown, [{
	    key: 'onPlaceholderMouseOver',
	    value: function onPlaceholderMouseOver() {
	      if (this.props.onPlaceholderMouseOver) {
	        this.props.onPlaceholderMouseOver();
	      }
	      this.props.onExpand(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var hasActive = false;
	      var optionItems = this.props.options.map(function (option) {
	        var active = option === _this2.props.value;
	        hasActive = hasActive || active;
	        var className = 'option ' + (active ? _this2.props.activeClass : '');
	        return _react2.default.createElement(
	          'div',
	          { key: option,
	            className: className,
	            onClick: _this2.props.onClick.bind(_this2, option, false) },
	          option
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'category-bar-dropdown-component ' + this.props.className + ' ' + (this.props.expand ? 'expand' : '') + ' ' + (hasActive ? this.props.activeClass : ''),
	          onMouseLeave: this.props.onExpand.bind(this, false) },
	        _react2.default.createElement(
	          'div',
	          { className: 'placeholder',
	            onMouseOver: this.onPlaceholderMouseOver },
	          this.props.placeholder + (this.props.value ? ' / ' + this.props.value : '')
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "dropdown" },
	          optionItems
	        )
	      );
	    }
	  }]);
	
	  return CategoryBarDropdown;
	}(_react2.default.Component);
	
	CategoryBarDropdown.propTypes = {
	  options: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  value: _propTypes2.default.string,
	  expand: _propTypes2.default.bool.isRequired,
	  activeClass: _propTypes2.default.string.isRequired,
	  placeholder: _propTypes2.default.string,
	  onClick: _propTypes2.default.func.isRequired,
	  onPlaceholderMouseOver: _propTypes2.default.func,
	  onExpand: _propTypes2.default.func.isRequired
	};
	
	var CategoryBar = function (_React$Component2) {
	  _inherits(CategoryBar, _React$Component2);
	
	  function CategoryBar(props) {
	    _classCallCheck(this, CategoryBar);
	
	    var _this3 = _possibleConstructorReturn(this, (CategoryBar.__proto__ || Object.getPrototypeOf(CategoryBar)).call(this, props));
	
	    _this3.onScroll = _this3.onScroll.bind(_this3);
	    _this3.onCategory = _this3.onCategory.bind(_this3);
	    _this3.onSubcategory = _this3.onSubcategory.bind(_this3);
	    _this3.onFilter = _this3.onFilter.bind(_this3);
	    _this3.onResize = _this3.onResize.bind(_this3);
	    _this3.onSubcategoryDropdown = _this3.onSubcategoryDropdown.bind(_this3);
	    _this3.onCategoryDropdown = _this3.onCategoryDropdown.bind(_this3);
	    _this3.onMouseLeave = _this3.onMouseLeave.bind(_this3);
	    _this3.onMouseOver = _this3.onMouseOver.bind(_this3);
	    _this3.width = window.innerWidth;
	    _this3.categories = {};
	    _this3.collapsed = false;
	    _this3.$categoryBar = null;
	
	    _this3.state = _this3.createState(props);
	    return _this3;
	  }
	
	  _createClass(CategoryBar, [{
	    key: 'createState',
	    value: function createState(props) {
	      this.categories = props.categories;
	      var categoryNames = Object.keys(this.categories);
	      var activeCategory = null;
	      var activeSubcategories = null;
	      var activeSubcategory = null;
	
	      // Only set active category/subcategory if defined in `this.categories`
	      if (props.activeCategory) {
	        var subcategories = this.categories[props.activeCategory];
	        if (subcategories) {
	          activeCategory = props.activeCategory;
	          activeSubcategories = subcategories;
	        }
	
	        if (props.activeSubcategory) {
	          if (subcategories) {
	            var isValidSubcategory = subcategories.findIndex(function (subcategory) {
	              return subcategory === props.activeSubcategory;
	            }) >= 0;
	            if (isValidSubcategory) {
	              activeSubcategory = props.activeSubcategory;
	            }
	          }
	        }
	      }
	
	      var threshold = this.width - SIDE_MARGINS;
	      var count = this.updateVisibleCount(threshold, categoryNames);
	
	      var _splitList = splitList(categoryNames, count),
	          visibleCategories = _splitList.visible,
	          hiddenCategories = _splitList.hidden;
	
	      var _splitList2 = splitList(activeSubcategories, count),
	          visibleSubcategories = _splitList2.visible,
	          hiddenSubcategories = _splitList2.hidden;
	
	      var activeFilter = props.activeFilter || null;
	
	      return {
	        activeCategory: activeCategory,
	        activeSubcategory: activeSubcategory,
	        activeFilter: activeFilter,
	        visibleCategories: visibleCategories,
	        hiddenCategories: hiddenCategories,
	        visibleSubcategories: visibleSubcategories,
	        hiddenSubcategories: hiddenSubcategories,
	        categoryDropdownExpand: false,
	        subcategoryDropdownExpand: false,
	        tmpCategory: null,
	        tmpVisibleSubcategories: null,
	        tmpHiddenSubcategories: null
	      };
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth(item) {
	      return this.clientWidths[item];
	    }
	  }, {
	    key: 'updateVisibleCount',
	    value: function updateVisibleCount(threshold, items) {
	      this.visibleCount = Math.min(Math.floor(threshold / WIDTH_PER_CATEGORY, items.length));
	      return this.visibleCount;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.categories !== this.props.categories) {
	        this.setState(this.createState(newProps));
	      }
	
	      if (newProps.activeCategory !== this.props.activeCategory || newProps.activeFilter !== this.props.activeFilter || newProps.activeSubcategory !== this.props.activeSubcategory) {
	        // naive approach, assume category is valid
	        this.setState({
	          activeCategory: newProps.activeCategory,
	          activeSubcategory: newProps.activeSubcategory,
	          activeFilter: newProps.activeFilter
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize); // re-render visible
	      window.addEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.onScroll);
	      window.removeEventListener('resize', this.onResize);
	    }
	  }, {
	    key: 'onCategoryDropdown',
	    value: function onCategoryDropdown(visible) {
	      var subcategoryDropdownExpand = this.state.subcategoryDropdownExpand;
	      if (visible && subcategoryDropdownExpand) {
	        subcategoryDropdownExpand = false;
	      }
	      this.setState({
	        categoryDropdownExpand: visible,
	        subcategoryDropdownExpand: subcategoryDropdownExpand
	      });
	    }
	  }, {
	    key: 'onSubcategoryDropdown',
	    value: function onSubcategoryDropdown(visible) {
	      var categoryDropdownExpand = this.state.categoryDropdownExpand;
	      if (visible && categoryDropdownExpand) {
	        categoryDropdownExpand = false;
	      }
	      this.setState({
	        subcategoryDropdownExpand: visible,
	        categoryDropdownExpand: categoryDropdownExpand
	      });
	    }
	  }, {
	    key: 'onCategory',
	    value: function onCategory(category, clear) {
	      var activeCategory = category;
	      var activeSubcategory = null;
	      var activeFilter = null;
	      var categoryDropdownExpand = false;
	      var subcategoryDropdownExpand = false;
	      var visibleSubcategories = null;
	      var hiddenSubcategories = null;
	
	      if (clear || category !== this.state.activeCategory) {
	        var subcategories = this.categories[activeCategory];
	
	        var _splitList3 = splitList(subcategories, this.visibleCount),
	            visible = _splitList3.visible,
	            hidden = _splitList3.hidden;
	
	        visibleSubcategories = visible;
	        hiddenSubcategories = hidden;
	      }
	
	      this.setState({
	        activeCategory: activeCategory,
	        activeSubcategory: activeSubcategory,
	        activeFilter: activeFilter,
	        visibleSubcategories: visibleSubcategories,
	        hiddenSubcategories: hiddenSubcategories,
	        categoryDropdownExpand: categoryDropdownExpand,
	        subcategoryDropdownExpand: subcategoryDropdownExpand
	      });
	
	      this.props.onSelect(activeCategory, activeSubcategory, activeFilter);
	    }
	  }, {
	    key: 'onSubcategory',
	    value: function onSubcategory(subcategory, clear) {
	      var activeSubcategory = subcategory;
	      if (!clear && subcategory === this.state.activeSubcategory && this.state.tmpCategory === this.state.activeCategory) {
	        // no-op
	        return;
	      }
	
	      var activeCategory = this.state.activeCategory;
	      var visibleSubcategories = this.state.visibleSubcategories;
	      var hiddenSubcategories = this.state.hiddenSubcategories;
	
	      if (this.state.tmpCategory) {
	        activeCategory = this.state.tmpCategory;
	        visibleSubcategories = this.state.tmpVisibleSubcategories;
	        hiddenSubcategories = this.state.tmpHiddenSubcategories;
	      }
	
	      this.setState({
	        activeCategory: activeCategory,
	        activeSubcategory: activeSubcategory,
	        visibleSubcategories: visibleSubcategories,
	        hiddenSubcategories: hiddenSubcategories,
	        categoryDropdownExpand: false,
	        subcategoryDropdownExpand: false,
	        tmpCategory: null,
	        tmpVisibleSubcategories: null,
	        tmpHiddenSubcategories: null
	      });
	
	      this.props.onSelect(activeCategory, activeSubcategory, this.state.activeFilter);
	    }
	  }, {
	    key: 'onFilter',
	    value: function onFilter(filter) {
	      if (this.state.activeFilter && this.state.activeFilter.value === filter.value) {
	        filter = null;
	      }
	
	      this.setState({
	        activeFilter: filter,
	        categoryDropdownExpand: false,
	        subcategoryDropdownExpand: false
	      });
	
	      this.props.onSelect(this.state.activeCategory, this.state.activeSubcategory, filter);
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      this.width = window.innerWidth;
	      var threshold = this.width - SIDE_MARGINS;
	      var categoryNames = Object.keys(this.categories);
	      var subcategories = this.state.activeCategory ? this.categories[this.state.activeCategory] : null;
	
	      var count = this.updateVisibleCount(threshold, categoryNames);
	
	      var _splitList4 = splitList(categoryNames, count),
	          visibleCategories = _splitList4.visible,
	          hiddenCategories = _splitList4.hidden;
	
	      var _splitList5 = splitList(subcategories, count),
	          visibleSubcategories = _splitList5.visible,
	          hiddenSubcategories = _splitList5.hidden;
	
	      this.setState({
	        visibleCategories: visibleCategories,
	        hiddenCategories: hiddenCategories,
	        visibleSubcategories: visibleSubcategories,
	        hiddenSubcategories: hiddenSubcategories
	      });
	    }
	  }, {
	    key: 'onScroll',
	    value: function onScroll() {
	      var distance = window.pageYOffset || window.document.documentElement.scrollTop;
	      var minimizeThreshold = this.$categoryBar.clientHeight;
	
	      if (distance < minimizeThreshold) {
	        this.$categoryBar.classList.remove('collapse');
	        this.collapsed = false;
	      } else {
	        if (!this.$categoryBar.classList.contains('collapse')) {
	          this.$categoryBar.classList.add('collapse');
	          this.collapsed = true;
	
	          // only hide dropdowns if scolling causes collapse
	          if (this.state.categoryDropdownExpand || this.state.subcategoryDropdownExpand) {
	            this.setState({
	              categoryDropdownExpand: false,
	              subcategoryDropdownExpand: false
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'onMouseOver',
	    value: function onMouseOver(tmpCategory) {
	      if (this.collapsed) {
	        return;
	      }
	
	      if (tmpCategory === this.state.activeCategory) {
	        this.setState({
	          tmpCategory: null,
	          tmpVisibleSubcategories: null,
	          tmpHiddenSubcategories: null
	        });
	        return;
	      }
	
	      var subcategories = this.categories[tmpCategory];
	
	      var _splitList6 = splitList(subcategories, this.visibleCount),
	          tmpVisibleSubcategories = _splitList6.visible,
	          tmpHiddenSubcategories = _splitList6.hidden;
	
	      this.setState({
	        tmpCategory: tmpCategory,
	        tmpVisibleSubcategories: tmpVisibleSubcategories,
	        tmpHiddenSubcategories: tmpHiddenSubcategories
	      });
	    }
	  }, {
	    key: 'onMouseLeave',
	    value: function onMouseLeave() {
	      if (this.state.tmpCategory) {
	        this.setState({
	          tmpCategory: null,
	          tmpVisibleSubcategories: null,
	          tmpHiddenSubcategories: null
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var visibleCategoryItems = this.state.visibleCategories.map(function (c, index) {
	        var normalized = normalizeToClassName(c);
	        var className = 'category ' + (c === _this4.state.activeCategory ? 'active' : '');
	        return _react2.default.createElement(
	          'div',
	          { key: normalized + '-' + index,
	            className: className,
	            onMouseOver: _this4.onMouseOver.bind(_this4, c),
	            onClick: _this4.onCategory.bind(_this4, c, false) },
	          _react2.default.createElement(
	            'div',
	            null,
	            c
	          )
	        );
	      });
	
	      var hiddenCategoryView = null;
	      if (this.state.hiddenCategories.length > 0) {
	        var activeCategoryIsHidden = this.state.activeCategory && this.state.hiddenCategories.findIndex(function (h) {
	          return h === _this4.state.activeCategory;
	        }) >= 0;
	
	        var selectedValue = activeCategoryIsHidden ? this.state.activeCategory : null;
	        hiddenCategoryView = _react2.default.createElement(CategoryBarDropdown, { value: selectedValue,
	          placeholder: '...MORE',
	          className: 'category',
	          activeClass: 'active',
	          expand: this.state.categoryDropdownExpand,
	          onPlaceholderMouseOver: this.onMouseLeave,
	          onExpand: this.onCategoryDropdown,
	          onClick: this.onCategory,
	          options: this.state.hiddenCategories });
	      }
	
	      var showSubcategoryBar = this.state.activeCategory !== null && this.state.visibleSubcategories !== null && this.state.hiddenSubcategories !== null;
	
	      if (this.state.tmpCategory) {
	        showSubcategoryBar = this.state.tmpVisibleSubcategories !== null;
	      }
	
	      var hideSubcategoryClassName = showSubcategoryBar ? '' : 'no-subcategories';
	
	      var visibleSubcategories = this.state.tmpVisibleSubcategories ? this.state.tmpVisibleSubcategories : this.state.visibleSubcategories;
	      var hiddenSubcategories = this.state.tmpHiddenSubcategories ? this.state.tmpHiddenSubcategories : this.state.hiddenSubcategories;
	
	      var visibleSubcategoryItems = visibleSubcategories ? visibleSubcategories.map(function (sub) {
	        var className = 'subcategory ' + (sub === _this4.state.activeSubcategory && !_this4.state.tmpCategory ? 'active' : '');
	        return _react2.default.createElement(
	          'div',
	          { className: className, key: sub,
	            onClick: _this4.onSubcategory.bind(_this4, sub, false, !!_this4.state.tmpCategory) },
	          _react2.default.createElement(
	            'div',
	            null,
	            sub
	          )
	        );
	      }) : null;
	
	      var hiddenSubcategoryView = null;
	      if (hiddenSubcategories && hiddenSubcategories.length > 0) {
	        var activeSubcategoryIsHidden = !this.state.tmpCategory && this.state.activeSubcategory && this.state.hiddenSubcategories.findIndex(function (h) {
	          return h === _this4.state.activeSubcategory;
	        }) >= 0;
	
	        var _selectedValue = activeSubcategoryIsHidden ? this.state.activeSubcategory : null;
	        hiddenSubcategoryView = _react2.default.createElement(CategoryBarDropdown, { value: _selectedValue,
	          placeholder: '...More',
	          activeClass: 'active',
	          className: 'subcategory',
	          expand: this.state.subcategoryDropdownExpand,
	          onExpand: this.onSubcategoryDropdown,
	          onClick: this.onSubcategory,
	          options: hiddenSubcategories });
	      }
	
	      var path = [{ name: 'Home', onClick: this.onCategory.bind(this, this.state.activeCategory, false) }];
	      if (this.state.activeCategory) {
	        path.push({
	          name: this.state.activeCategory,
	          onClick: this.onCategory.bind(this, this.state.activeCategory, true)
	        });
	      }
	      if (this.state.activeSubcategory) {
	        path.push({
	          name: this.state.activeSubcategory,
	          onClick: this.onSubcategory.bind(this, this.state.activeSubcategory, true)
	        });
	      }
	
	      var filterItems = this.props.filters ? this.props.filters.map(function (filter) {
	        var active = _this4.state.activeFilter && _this4.state.activeFilter.value === filter.value;
	        var className = 'filter ' + (active ? 'active' : '');
	        return _react2.default.createElement(
	          'div',
	          { className: className, key: filter.name,
	            onClick: _this4.onFilter.bind(_this4, filter) },
	          _react2.default.createElement('img', { role: 'presentation', className: 'icon', style: { height: filter.height + 'px' }, src: filter.icon }),
	          _react2.default.createElement(
	            'span',
	            null,
	            filter.name
	          )
	        );
	      }) : null;
	
	      return _react2.default.createElement(
	        'nav',
	        { role: 'navigation',
	          className: 'category-bar-component ' + hideSubcategoryClassName,
	          ref: function ref(div) {
	            _this4.$categoryBar = div;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'category-bar',
	            onScroll: this.onScroll },
	          _react2.default.createElement(
	            'div',
	            { onMouseLeave: this.onMouseLeave },
	            _react2.default.createElement(
	              'div',
	              { className: 'categories' },
	              visibleCategoryItems,
	              hiddenCategoryView
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'subcategories' },
	              visibleSubcategoryItems,
	              hiddenSubcategoryView
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'filters' },
	            filterItems
	          )
	        )
	      );
	    }
	  }]);
	
	  return CategoryBar;
	}(_react2.default.Component);
	
	CategoryBar.propTypes = {
	  onCategory: _propTypes2.default.func,
	  categories: _propTypes2.default.object.isRequired,
	  filters: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  activeCategory: _propTypes2.default.string,
	  activeSubcategory: _propTypes2.default.string,
	  activeFilter: _propTypes2.default.object
	};
	CategoryBar.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = CategoryBar;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImageField = exports.MultipleField = exports.EmailField = exports.InputField = undefined;
	
	var _InputField = __webpack_require__(43);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _EmailField = __webpack_require__(290);
	
	var _EmailField2 = _interopRequireDefault(_EmailField);
	
	var _MultipleField = __webpack_require__(292);
	
	var _MultipleField2 = _interopRequireDefault(_MultipleField);
	
	var _ImageField = __webpack_require__(291);
	
	var _ImageField2 = _interopRequireDefault(_ImageField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InputField2.default;
	exports.InputField = _InputField2.default;
	exports.EmailField = _EmailField2.default;
	exports.MultipleField = _MultipleField2.default;
	exports.ImageField = _ImageField2.default;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Props:
	 * waitingSearch: boolean value that specifies if we should display a spinning icon or not.
	 * onChange: function to be called when the search terms change.
	 * placeholder: input placeholder
	 */
	var LiveSearch = function (_React$Component) {
	  _inherits(LiveSearch, _React$Component);
	
	  function LiveSearch() {
	    _classCallCheck(this, LiveSearch);
	
	    var _this = _possibleConstructorReturn(this, (LiveSearch.__proto__ || Object.getPrototypeOf(LiveSearch)).call(this));
	
	    _this.onSearchChange = _this.onSearchChange.bind(_this);
	    _this.fireSearchChange = _this.fireSearchChange.bind(_this);
	    _this.clearSearch = _this.clearSearch.bind(_this);
	
	    _this.state = {
	      search: '',
	      timer: null,
	      lastFiredSearch: ''
	    };
	    return _this;
	  }
	
	  _createClass(LiveSearch, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.value !== this.props.value && newProps.value !== this.state.search) {
	        this.fireSearchChange(newProps.value);
	      }
	    }
	  }, {
	    key: 'fireSearchChange',
	    value: function fireSearchChange(searchValue) {
	      if (searchValue === undefined) searchValue = this.state.search;
	
	      if (searchValue.trim() !== this.state.lastFiredSearch) {
	        if (this.props.onChange) {
	          this.props.onChange(searchValue);
	        }
	        this.setState({
	          search: searchValue,
	          lastFiredSearch: searchValue,
	          timer: null
	        });
	      } else if (searchValue !== this.state.search) {
	        this.setState({
	          search: searchValue
	        });
	      }
	    }
	  }, {
	    key: 'onSearchChange',
	    value: function onSearchChange(event) {
	      // TODO: make this 500 a prop.
	      if (this.state.timer) clearTimeout(this.state.timer);
	
	      var searchValue = event.target.value;
	      var timer = setTimeout(this.fireSearchChange, 500);
	
	      this.setState({
	        search: searchValue,
	        timer: timer
	      });
	
	      if (!timer) this.fireSearchChange(searchValue);
	    }
	  }, {
	    key: 'clearSearch',
	    value: function clearSearch() {
	      if (this.state.timer) clearTimeout(this.state.timer);
	
	      this.fireSearchChange('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var statusIcon = void 0;
	      if (this.props.waitingSearch) {
	        statusIcon = _react2.default.createElement('i', { className: 'fa fa-refresh', 'aria-hidden': 'true' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'live-search' },
	        _react2.default.createElement(
	          'span',
	          { className: 'input-box' },
	          _react2.default.createElement(
	            'span',
	            { className: 'input-element' },
	            _react2.default.createElement('input', { type: 'text', id: this.props.id || 'live-search', onChange: this.onSearchChange, value: this.state.search, placeholder: this.props.placeholder })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'status-icon' },
	            statusIcon
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.children
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'actions' },
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.clearSearch },
	            'Clear'
	          )
	        )
	      );
	    }
	  }]);
	
	  return LiveSearch;
	}(_react2.default.Component);
	
	LiveSearch.propTypes = {
	  onChange: _propTypes2.default.func,
	  waitingSearch: _propTypes2.default.bool,
	  placeholder: _propTypes2.default.string
	};
	exports.default = LiveSearch;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addBankAccount(user) {
	  if (!user) {
	    return Promise.reject('Invalid user');
	  }
	
	  var payload = _Api2.default.Utils.clone(window.plaidPayload);
	
	  var returnValue = new Promise(function (accept, reject) {
	    var isSuccess = false;
	    payload.onSuccess = function (public_token, metadata) {
	      var data = {
	        public_token: public_token,
	        account_id: metadata.account_id
	      };
	
	      isSuccess = true;
	      _Api2.default.plaidTokenViaStripe(data).then(accept, reject);
	    };
	
	    payload.onExit = function (err, metadata) {
	      if (!isSuccess) reject(metadata);
	    };
	
	    var linkHandler = window.Plaid.create(payload);
	    linkHandler.open();
	  });
	
	  returnValue.then(function (response) {
	    _Api2.default.cache.setSelectedInstrument(response.token);
	    return _Api2.default.getUser();
	  });
	
	  return returnValue;
	}
	
	function addCreditCard(user) {
	  if (!user) {
	    return Promise.reject('Invalid user');
	  }
	
	  var returnValue = new Promise(function (accept, reject) {
	    var isTokenReceived = false;
	
	    var stripeHandler = window.StripeCheckout.configure({
	      key: window.stripePublicKey,
	      image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
	      locale: 'English',
	      token: function token(_token) {
	        isTokenReceived = true;
	        _Api2.default.stripeLinkCard(_token).then(accept, reject);
	      },
	      closed: function closed() {
	        if (!isTokenReceived) reject();
	      }
	    });
	
	    stripeHandler.open({
	      name: 'Indigo Fair Inc.',
	      description: '',
	      panelLabel: 'Link Card',
	      allowRememberMe: false,
	      zipCode: false,
	      billingAddress: false,
	      email: user.email_address
	    });
	
	    window.addEventListener('popstate', function () {
	      stripeHandler.close();
	      reject();
	    }, {
	      once: true
	    });
	  });
	
	  returnValue.then(function (response) {
	    _Api2.default.cache.setSelectedInstrument(response.token);
	    return _Api2.default.getUser();
	  });
	
	  return returnValue;
	}
	
	exports.default = { addBankAccount: addBankAccount, addCreditCard: addCreditCard };

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _image_collection = __webpack_require__(321);
	
	var _image_collection2 = _interopRequireDefault(_image_collection);
	
	var _selection_button = __webpack_require__(324);
	
	var _selection_button2 = _interopRequireDefault(_selection_button);
	
	var _StringUtils = __webpack_require__(50);
	
	__webpack_require__(384);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReatailerProduct = function (_React$Component) {
	  _inherits(ReatailerProduct, _React$Component);
	
	  function ReatailerProduct(props) {
	    _classCallCheck(this, ReatailerProduct);
	
	    var _this = _possibleConstructorReturn(this, (ReatailerProduct.__proto__ || Object.getPrototypeOf(ReatailerProduct)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['newSelection', 'removeSelection', 'changeSelection', 'changeOption', 'selections', 'changeQuantity', 'goBack', 'colorOptionRender', 'loadProduct', 'onSave', 'getButtonText']);
	
	    var productToken = null;
	    if (props.productToken) {
	      productToken = props.productToken;
	    } else if (props.params) {
	      productToken = props.params.productId;
	    }
	
	    var brandToken = null;
	    if (props.brandToken) {
	      brandToken = props.brandToken;
	    } else if (props.params) {
	      brandToken = props.params.brandId;
	    }
	
	    var retailerToken = null;
	    if (props.retailerToken) {
	      retailerToken = props.retailerToken;
	    } else if (props.params) {
	      retailerToken = props.retailerId;
	    }
	
	    _this.state = {
	      productToken: productToken,
	      brandToken: brandToken,
	      retailerToken: retailerToken,
	      product: null,
	      brand: null,
	      selections: _this.props.defaultSelection || [],
	      selectableImages: [],
	      options_info: null,
	      errorMessage: null,
	      shake: false
	    };
	    return _this;
	  }
	
	  _createClass(ReatailerProduct, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var payload = {};
	
	      var productToken = null;
	      if (nextProps.productToken) {
	        productToken = nextProps.productToken;
	      } else if (nextProps.params) {
	        productToken = nextProps.params.productId;
	      }
	
	      if (this.state.productToken !== productToken) {
	        payload.selections = nextProps.defaultSelection || [];
	      }
	
	      var brandToken = null;
	      if (nextProps.brandToken) {
	        brandToken = nextProps.brandToken;
	      } else if (nextProps.params) {
	        brandToken = nextProps.params.brandId;
	      }
	
	      var retailerToken = null;
	      if (nextProps.retailerToken) {
	        retailerToken = nextProps.retailerToken;
	      } else if (nextProps.params) {
	        retailerToken = nextProps.params.retailerId;
	      }
	
	      payload.productToken = productToken;
	      payload.brandToken = brandToken;
	      payload.retailerToken = retailerToken;
	
	      this.setState(payload);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.productToken !== this.state.productToken) {
	        this.loadProduct();
	      }
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(event) {
	      var _this2 = this;
	
	      event.preventDefault();
	      if (this.state.selections.length === 0) {
	        this.setState({ shake: true }, function () {
	          setTimeout(function () {
	            _this2.setState({ shake: false });
	          }, 825);
	        });
	        return false;
	      }
	      return this.props.onSave(this.state.productToken, this.state.selections);
	    }
	  }, {
	    key: 'buildImageList',
	    value: function buildImageList(product) {
	      var images = [];
	      if (product.images && product.images.length > 0) {
	        product.images.forEach(function (image) {
	          return images.push(image);
	        });
	      }
	
	      product.options.forEach(function (productOption) {
	        (productOption.images || []).forEach(function (image) {
	          images.push(image);
	        });
	      });
	
	      return images.slice(0, 4);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadProduct();
	    }
	  }, {
	    key: 'loadProduct',
	    value: function loadProduct() {
	      var _this3 = this;
	
	      if (!this.state.productToken) {
	        this.setState({
	          product: null,
	          brand: null,
	          options_info: null,
	          selectableImages: null,
	          selections: []
	        });
	        return;
	      }
	
	      _Api2.default.getProduct(this.state.productToken, true).then(function (result) {
	        var product = null;
	        if (result.products) {
	          if (Array.isArray(result.products)) {
	            product = result.products[0];
	          } else {
	            product = result.products[_this3.state.productToken];
	          }
	        }
	
	        if (!product) {
	          console.error('I cannot seem to have found the product I was looking for: %s.', _this3.state.productToken);
	          console.error(result);
	          _this3.setState({
	            error: 'Error loading product information.'
	          });
	          return;
	        }
	        var options_info = _this3.buildOptionsObject(product);
	        var selectableImages = _this3.buildImageList(product);
	
	        try {
	          var selections = _this3.state.selections;
	
	          if (!selections || selections.length <= 0) {
	            if (options_info.options.length === 1) {
	              selections = [{
	                option: options_info.options[0]._option.token,
	                batches: 1
	              }];
	            } else {
	              selections = [];
	            }
	          }
	
	          _this3.setState({
	            product: product,
	            brand: result.brands[product.brand_token],
	            options_info: options_info,
	            selectableImages: selectableImages,
	            selections: selections
	          });
	        } catch (error) {
	          var errorMessage = {
	            message: 'Invalid product on marketplace',
	            error: error,
	            product: product,
	            options_info: options_info,
	            user: _Api2.default.cache.getUser()
	          };
	          _Api2.default.error(JSON.stringify(errorMessage));
	
	          console.error(error);
	          console.log(product);
	          console.log(options_info);
	          _this3.setState({
	            errorMessage: 'this product has an error.'
	          });
	        }
	      });
	    }
	  }, {
	    key: 'newSelection',
	    value: function newSelection() {
	      var _this4 = this;
	
	      var nextSelection = this.state.options_info.options.find(function (option) {
	        var i = void 0;
	        for (i = 0; i < _this4.state.selections.length; i++) {
	          if (option._option.token === _this4.state.selections[i].option) return false;
	        }
	
	        return true;
	      });
	
	      if (!nextSelection) {
	        console.error("No more remaining selections!");
	        return;
	      }
	
	      var selections = _Api.Utils.clone(this.state.selections);
	      selections.push({
	        option: nextSelection._option.token,
	        batches: 1
	      });
	
	      this.setState({ selections: selections });
	    }
	  }, {
	    key: 'changeSelection',
	    value: function changeSelection(token, newToken) {
	      var selections = _Api.Utils.clone(this.state.selections);
	      selections.forEach(function (selection) {
	        if (selection.option === token) {
	          selection.option = newToken;
	        }
	      });
	
	      this.setState({ selections: selections });
	    }
	
	    /* 
	     * Changes the option on the given index.
	     * We need to know what kind the user has actually changed to stop lookin on that index.
	     * We also retrieve the list of availableOptions (unused options) to not select the same option twice.
	     * OptionValue is expected as an object containing at least the following keys:
	     * * name
	     * * kind
	     * * option
	     */
	
	  }, {
	    key: 'changeOption',
	    value: function changeOption(selectionIdx, optionValue, availableOptions) {
	      var kinds = this.state.options_info.kinds;
	      var kindLimit = optionValue.kind;
	
	      // Get the token of our index
	      var selectedPropToken = this.state.selections[selectionIdx].option;
	      // Using the token, let's get the option with the actual dictionary value 
	      var selectedProps = availableOptions.find(function (option) {
	        return option._option.token === selectedPropToken;
	      });
	      selectedProps = _Api.Utils.clone(selectedProps); // No need to go deep here
	      selectedProps[optionValue.kind] = optionValue;
	      var selections = _Api.Utils.clone(this.state.selections, true);
	
	      var newOption = availableOptions.find(function (option) {
	        var i = void 0;
	        for (i = 0; i < kinds.length; i++) {
	          if (selectedProps[kinds[i]].name !== option[kinds[i]].name) return false;
	          if (kinds[i] === kindLimit) break;
	        }
	
	        return true;
	      });
	
	      selections[selectionIdx].option = newOption._option.token;
	      this.setState({ selections: selections });
	    }
	
	    /*
	     * Quantity is number of batches / packs / cases
	     */
	
	  }, {
	    key: 'changeQuantity',
	    value: function changeQuantity(token, quantity) {
	      var selections = _Api.Utils.clone(this.state.selections);
	      var currentSelection = selections.find(function (selection) {
	        return selection.option === token;
	      });
	      if (!currentSelection) {
	        currentSelection = {
	          option: token
	        };
	        selections.push(currentSelection);
	      }
	      currentSelection.batches = parseInt(quantity, 10);
	
	      selections = selections.filter(function (selection) {
	        return selection.batches > 0;
	      });
	
	      this.setState({ selections: selections });
	    }
	  }, {
	    key: 'removeSelection',
	    value: function removeSelection(token) {
	      if (this.state.selections.length <= 1) return;
	
	      var selections = _Api.Utils.clone(this.state.selections).filter(function (selection) {
	        return selection.option !== token;
	      });
	
	      this.setState({ selections: selections });
	    }
	  }, {
	    key: 'colorOptionRender',
	    value: function colorOptionRender(option, kind, selected) {
	      if (option.kind && option.kind.toLowerCase() === 'color') {
	        var colorName = '';
	        var colorValue = '';
	        if (option.option.color) {
	          colorName = option.option.color.name;
	          if (option.option.color && option.option.color.rgb) {
	            colorValue = option.option.color.rgb;
	          }
	
	          if (colorValue.length > 0 && colorValue[0] !== '#') {
	            colorValue = '#' + colorValue;
	          }
	        } else {
	          colorName = option.name;
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { className: 'content color-option' + (colorValue === '' ? ' no-color' : '') },
	          _react2.default.createElement('span', { className: 'oval', style: { backgroundColor: colorValue } }),
	          _react2.default.createElement(
	            'span',
	            { className: 'description' },
	            colorName
	          )
	        );
	      }
	
	      return option.name;
	    }
	  }, {
	    key: 'selections',
	    value: function selections() {
	      var _this5 = this;
	
	      var product = this.state.product;
	
	      if (!product) return null;
	
	      var ret = [];
	      var allOptions = this.state.options_info.options;
	
	      // Fix names
	      allOptions.forEach(function (option) {
	        var optionArray = [];
	        Object.keys(option).forEach(function (k) {
	          if (k[0] === '_') return;
	          optionArray.push((0, _StringUtils.capitalizeEveryWord)(option[k].name));
	        });
	        option._text = optionArray.join(', ');
	      });
	
	      var hideColor = false;
	      allOptions.forEach(function (option) {
	        var color = option.Color || option.color || option.Colors || option.colors || null;
	        if (!color) {
	          hideColor = true;
	          return;
	        }
	        if (!color.option || !color.option.color || !color.option.color.rgb) {
	          hideColor = true;
	        }
	      });
	
	      var selectionList = allOptions.map(function (option) {
	        return _react2.default.createElement(_selection_button2.default, {
	          key: 'selection-item-' + option._option.token,
	          unitMultiplier: product.unit_multiplier,
	          selectionList: _this5.state.selections,
	          option: option,
	          hideColor: hideColor,
	          isOnlyOption: allOptions.length === 1,
	          onChange: function onChange(value) {
	            return _this5.changeQuantity(option._option.token, value / product.unit_multiplier);
	          }
	        });
	      });
	
	      ret.push(_react2.default.createElement(
	        'div',
	        { className: 'selection-list', key: 'selection-list' },
	        selectionList
	      ));
	
	      return ret;
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      var address = '/retailer/' + this.state.retailerToken;
	      if (this.state.brandToken) {
	        address += '/brand/' + this.state.brandToken;
	      }
	      this.context.router.push(address);
	    }
	
	    /**
	     * Builds an object based on the product options with the following structure:
	     * {
	     *   kinds: [],
	     *   options: [
	     *     {
	     *       kindName1: ...,
	     *       kindName2: ...,
	     *       ...,
	     *       _option: { optionObject }
	     *     },
	     *     ...
	     *   ]
	     * }
	     * This object will help us properly populate the user interface
	     */
	
	  }, {
	    key: 'buildOptionsObject',
	    value: function buildOptionsObject(product) {
	      var ret = {};
	      ret.kinds = [];
	      if (!product) {
	        console.error('no product to build options for!');
	        console.error(this);
	        return ret;
	      }
	
	      if (!product.options) {
	        console.error('product has no options');
	        console.error(product);
	        return ret;
	      }
	      product.options.forEach(function (option) {
	        if (ret.kinds.indexOf(option.group_name) >= 0) return;
	        ret.kinds.push(option.group_name);
	      });
	
	      // Finds all options and suboptions with the same parent.
	      // If there are no children with that parent, the `prev` object is returned as-is.
	      // If there are any children (even if just 1), the return object is an array where every element is a copy
	      // of `prev`, along with the new `group_name` key and its value for each child.
	      function findWithParent(parent, prev) {
	        var productChildren = product.options.filter(function (option) {
	          return (option.parent_token || '') === parent;
	        });
	
	        if (productChildren.length === 0) return prev;
	
	        var ret = [];
	
	        // Populate the return array
	        productChildren.forEach(function (option) {
	          // We need a working object. If no previous one is supplied, we create an empty one.
	          var optionObject = prev ? _Api.Utils.clone(prev) : {};
	          optionObject[option.group_name] = {
	            name: option.name,
	            option: option
	          };
	          optionObject._option = option;
	
	          // Update our color, if we have one.
	          if (option.color && option.color.rgb !== '') {
	            optionObject._color = option.color;
	          }
	
	          // Check if we are parent of anyone.
	          var childOptions = findWithParent(option.token, optionObject);
	
	          // Populate the return array properly
	          if (Array.isArray(childOptions)) {
	            childOptions.forEach(function (element) {
	              ret.push(element);
	            });
	          } else {
	            ret.push(childOptions);
	          }
	        });
	
	        return ret;
	      }
	
	      // Start with all the product options that have no parents (root options)
	      ret.options = findWithParent('');
	
	      return ret;
	    }
	  }, {
	    key: 'getSelectionValue',
	    value: function getSelectionValue() {
	      var _this6 = this;
	
	      var totalValue = 0;
	
	      this.state.selections.forEach(function (selection) {
	        totalValue += selection.batches * _this6.state.product.unit_multiplier * _this6.state.product.wholesale_price_cents;
	      });
	
	      return '$' + (_Api.Utils.formatCents(totalValue) || 0);
	    }
	  }, {
	    key: 'getButtonText',
	    value: function getButtonText() {
	      if (typeof this.props.buttonText === 'string') return this.props.buttonText;
	
	      return this.props.buttonText(this.state.selections);
	    }
	  }, {
	    key: 'getProductControls',
	    value: function getProductControls() {
	      var product = this.state.product;
	      var productSelectionClasses = 'product-selection selected-options-' + this.state.selections.length;
	
	      var styleNames = [].concat(_toConsumableArray(this.state.options_info.kinds));
	
	      var stylesDiv = null;
	      styleNames = styleNames.filter(function (name) {
	        return !!name;
	      });
	      if (this.state.options_info.options.length > 1) {
	        stylesDiv = _react2.default.createElement(
	          'div',
	          { className: 'styles' },
	          styleNames.length ? styleNames.join(', ') : 'Style'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-controls' },
	        _react2.default.createElement(
	          'div',
	          { className: 'product-controls-inner-wrapper' },
	          _react2.default.createElement(BrandModalHeader, { brand: this.state.brand, retailerToken: this.state.retailerToken }),
	          _react2.default.createElement(
	            'div',
	            { className: 'product-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'name' },
	              product.name,
	              ' \u2014 $',
	              _Api.Utils.formatCents(product.wholesale_price_cents, true)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'details' },
	              _react2.default.createElement(
	                'span',
	                { className: 'case-size' },
	                'Case Size ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'value' },
	                  product.unit_multiplier
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'retail-price' },
	                'Suggested Retail Price: ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'value' },
	                  '$',
	                  _Api.Utils.formatCents(product.retail_price_cents, true)
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: productSelectionClasses },
	            _react2.default.createElement(
	              'div',
	              { className: 'header' },
	              stylesDiv,
	              _react2.default.createElement(
	                'div',
	                { className: 'item-quantity' },
	                'Item Quantity'
	              )
	            ),
	            this.selections()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'add-to-cart' },
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.onSave, waitingState: _react2.default.createElement(_Processing2.default, null), className: 'full-width' + (this.state.shake ? ' shake' : '') },
	              this.getButtonText(),
	              _react2.default.createElement(
	                'span',
	                { className: 'button-subtotal' },
	                this.getSelectionValue()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            ProductDescription,
	            null,
	            product.description
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.productToken) {
	        return _react2.default.createElement('div', { className: 'retailer-product' });
	      }
	
	      if (this.state.errorMessage) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.state.errorMessage
	        );
	      }
	      if (this.state.product === null || this.state.brand === null) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'retailer-product' },
	          _react2.default.createElement(_Processing2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'retailer-product' },
	        _react2.default.createElement(_image_collection2.default, { images: this.state.selectableImages }),
	        this.getProductControls()
	      );
	    }
	  }]);
	
	  return ReatailerProduct;
	}(_react2.default.Component);
	
	ReatailerProduct.propTypes = {
	  buttonText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  onSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func,
	  defaultSelection: _propTypes2.default.array,
	  productToken: _propTypes2.default.string
	};
	ReatailerProduct.defaultProps = {
	  buttonText: 'Add to My Bag'
	};
	ReatailerProduct.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = ReatailerProduct;
	
	
	var BrandModalHeader = function BrandModalHeader(_ref) {
	  var brand = _ref.brand,
	      retailerToken = _ref.retailerToken;
	
	  if (!brand) return _react2.default.createElement('div', { className: 'brand-info' });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'brand-info' },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { className: 'name', to: '/retailer/' + retailerToken + '/brand/' + brand.token },
	      brand.name
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'minimum' },
	      brand.minimum_order_amount_cents ? 'Maker Minimum $' + _Api.Utils.formatCents(brand.minimum_order_amount_cents, true) : 'No Minimum'
	    )
	  );
	};
	
	var ProductDescription = function ProductDescription(_ref2) {
	  var children = _ref2.children;
	
	  if (!children) return null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'description' },
	    _react2.default.createElement(
	      'div',
	      { className: 'header' },
	      'Description'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      children
	    )
	  );
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetNinetyPayment = exports.CreditCardPayment = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Steps = __webpack_require__(72);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _payments = __webpack_require__(69);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	var _net = __webpack_require__(435);
	
	var _net2 = _interopRequireDefault(_net);
	
	var _creditcards = __webpack_require__(434);
	
	var _creditcards2 = _interopRequireDefault(_creditcards);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentInformation = function (_React$Component) {
	  _inherits(PaymentInformation, _React$Component);
	
	  function PaymentInformation() {
	    _classCallCheck(this, PaymentInformation);
	
	    var _this = _possibleConstructorReturn(this, (PaymentInformation.__proto__ || Object.getPrototypeOf(PaymentInformation)).call(this));
	
	    _Api.Utils.bindThis(_this, ['stopListeners', 'navigate', 'actionLinkBankAccount', 'actionLinkCreditCard', 'nextStep']);
	
	    _this.state = {
	      user: _Api2.default.cache.getUser(),
	      retailer: _Api2.default.cache.getRetailer(),
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(PaymentInformation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.userStartListen(this, 'user');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopListeners();
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(to) {
	      this.stopListeners();
	      this.context.router.push(to);
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep() {
	      if (!this.state.user.addresses || this.state.user.addresses.length <= 0) {
	        this.navigate('/checkout/address');
	      } else {
	        this.navigate('/checkout/delivery');
	      }
	    }
	  }, {
	    key: 'stopListeners',
	    value: function stopListeners() {
	      _Api2.default.userStopListen(this);
	    }
	  }, {
	    key: 'actionLinkBankAccount',
	    value: function actionLinkBankAccount(event) {
	      event.preventDefault();
	      var paymentPromise = _payments2.default.addBankAccount(this.state.user);
	      paymentPromise.then(this.nextStep);
	
	      return paymentPromise;
	    }
	  }, {
	    key: 'actionLinkCreditCard',
	    value: function actionLinkCreditCard(event) {
	      event.preventDefault();
	      var paymentPromise = _payments2.default.addCreditCard(this.state.user);
	      paymentPromise.then(this.nextStep);
	
	      return paymentPromise;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var error = this.state.error ? _react2.default.createElement(
	        'div',
	        { className: 'error' },
	        this.state.error
	      ) : null;
	      // Not checking for 'is_employee' on purpose on the next line.
	      var isAdmin = this.state.user && (this.state.user.type === 'ADMIN' || this.state.user.impersonating);
	      var retailerCanSkip = this.state.retailer && this.state.retailer.can_skip_payment;
	      var skipButton = null;
	      if (isAdmin || retailerCanSkip) {
	        skipButton = _react2.default.createElement(
	          _Button2.default,
	          { onClick: this.nextStep },
	          'Skip'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Steps2.default, { current: '2' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'page-flyout checkout checkout-payment' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'flyout-header' },
	            'Select a Payment Method'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'payment-options' },
	              _react2.default.createElement(CreditCardPayment, { onClick: this.actionLinkCreditCard }),
	              _react2.default.createElement(NetNinetyPayment, { onClick: this.actionLinkBankAccount })
	            ),
	            skipButton,
	            error,
	            _react2.default.createElement(
	              'p',
	              { className: 'note' },
	              'By linking a payment instrument, you authorize Indigo Fair. I authorize to electronically debit your account and, if necessary, electronically credit account to correct erroneous debits.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentInformation;
	}(_react2.default.Component);
	
	PaymentInformation.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = PaymentInformation;
	
	var CreditCardPayment = function (_React$Component2) {
	  _inherits(CreditCardPayment, _React$Component2);
	
	  function CreditCardPayment() {
	    _classCallCheck(this, CreditCardPayment);
	
	    return _possibleConstructorReturn(this, (CreditCardPayment.__proto__ || Object.getPrototypeOf(CreditCardPayment)).apply(this, arguments));
	  }
	
	  _createClass(CreditCardPayment, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'payment-option creditcard' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement('img', { src: _creditcards2.default, role: 'presentation' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your credit card will be charged \u2028for items and freight costs at the \u2028time of shipment. You will receive a \u2028full refund for all items you return.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'round', onClick: this.props.onClick, waitingState: _react2.default.createElement(_Processing2.default, null) },
	            this.props.buttonText
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreditCardPayment;
	}(_react2.default.Component);
	
	CreditCardPayment.propTypes = {
	  onClick: _propTypes2.default.func.isRequired,
	  buttonText: _propTypes2.default.string,
	  title: _propTypes2.default.string
	};
	CreditCardPayment.defaultProps = {
	  title: 'Pay With Credit Card',
	  buttonText: 'LINK CARD'
	};
	
	var NetNinetyPayment = function (_React$Component3) {
	  _inherits(NetNinetyPayment, _React$Component3);
	
	  function NetNinetyPayment() {
	    _classCallCheck(this, NetNinetyPayment);
	
	    return _possibleConstructorReturn(this, (NetNinetyPayment.__proto__ || Object.getPrototypeOf(NetNinetyPayment)).apply(this, arguments));
	  }
	
	  _createClass(NetNinetyPayment, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'payment-option net90' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement('img', { src: _net2.default, role: 'presentation' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your bank account will be charged 90 days after items ship. Freight costs will be charged upon shipment. You will never be charged for returned items. \u2028'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'round', onClick: this.props.onClick, color: 'white', waitingState: _react2.default.createElement(_Processing2.default, null) },
	            this.props.buttonText
	          )
	        )
	      );
	    }
	  }]);
	
	  return NetNinetyPayment;
	}(_react2.default.Component);
	
	NetNinetyPayment.propTypes = {
	  onClick: _propTypes2.default.func.isRequired,
	  buttonText: _propTypes2.default.string,
	  title: _propTypes2.default.string
	};
	NetNinetyPayment.defaultProps = {
	  title: 'PAY USING NET 90',
	  buttonText: 'LINK BANK'
	};
	exports.CreditCardPayment = CreditCardPayment;
	exports.NetNinetyPayment = NetNinetyPayment;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkmark = __webpack_require__(432);
	
	var _checkmark2 = _interopRequireDefault(_checkmark);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStepList = ['Create Account', 'Select Payment Method', 'Add an Address'];
	
	var Steps = function Steps(_ref) {
	  var stepList = _ref.stepList,
	      current = _ref.current;
	
	  stepList = stepList || defaultStepList;
	  var stepCount = stepList.length;
	  var steps = [],
	      i = void 0;
	  current = current ? parseInt(current, 10) : 1;
	
	  for (i = 0; i < stepCount; i++) {
	    var className = 'step step-' + (i + 1);
	    if (i + 1 === current) {
	      className += ' current';
	    } else if (i + 1 < current) {
	      className += ' done';
	    } else {
	      className += ' future';
	    }
	
	    if (i > 0) {
	      steps.push(_react2.default.createElement(
	        'span',
	        { key: 'steps-separator-' + i, className: 'separator' },
	        _react2.default.createElement('hr', null)
	      ));
	    }
	
	    steps.push(_react2.default.createElement(
	      'span',
	      { key: 'steps-item-' + i, className: className },
	      _react2.default.createElement(
	        'span',
	        { className: 'step-number' },
	        i + 1
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'step-done' },
	        _react2.default.createElement('img', { role: 'presentation', src: _checkmark2.default })
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        stepList[i]
	      )
	    ));
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'checkout-steps' },
	    steps
	  );
	};
	
	exports.default = Steps;

/***/ },
/* 73 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 75 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(461);

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(35);
	var Danger = __webpack_require__(468);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactInstrumentation = __webpack_require__(18);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(88);
	var setInnerHTML = __webpack_require__(61);
	var setTextContent = __webpack_require__(261);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var ReactErrorUtils = __webpack_require__(86);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var React = __webpack_require__(39);
	var ReactPropTypesSecret = __webpack_require__(497);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var invariant = __webpack_require__(5);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(21);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 88 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 90 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 93 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var emptyFunction = __webpack_require__(16);
	var warning = __webpack_require__(7);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(63);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(31);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(541);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(538);
	
	var _isActive2 = __webpack_require__(545);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(542);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(547);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(41);
	
	var ReactNoopUpdateQueue = __webpack_require__(99);
	
	var canDefineProperty = __webpack_require__(278);
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(7);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _AdminFunctions = __webpack_require__(49);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FieldComponents = __webpack_require__(67);
	
	var _UrlValidator = __webpack_require__(107);
	
	var _UrlValidator2 = _interopRequireDefault(_UrlValidator);
	
	__webpack_require__(367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SocialMediaTags = [{ icon: 'facebook-square', key: 'facebook_handle' }, { icon: 'twitter-square', key: 'twitter_handle' }, { icon: 'instagram', key: 'instagram_handle' }, { icon: 'pinterest-square', key: 'pinterest_handle' }, { icon: 'youtube-square', key: 'youtube_handle' }];
	
	var ErrorClass = 'error';
	
	var BrandEditor = function (_Component) {
	  _inherits(BrandEditor, _Component);
	
	  function BrandEditor(props) {
	    _classCallCheck(this, BrandEditor);
	
	    var _this = _possibleConstructorReturn(this, (BrandEditor.__proto__ || Object.getPrototypeOf(BrandEditor)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.onInput = _this.onInput.bind(_this);
	    _this.clearSavedView = _this.clearSavedView.bind(_this);
	
	    _this.state = _this.createState(props.brand);
	    return _this;
	  }
	
	  _createClass(BrandEditor, [{
	    key: 'onInput',
	    value: function onInput(name, input, error) {
	      var _setState;
	
	      var errorState = this.state.error;
	      errorState[name] = !!error;
	      this.setState((_setState = {}, _defineProperty(_setState, name, input), _defineProperty(_setState, 'error', errorState), _setState));
	    }
	  }, {
	    key: 'createState',
	    value: function createState(brand) {
	      brand = brand || {};
	      // Set initial error values for required fields
	      var error = {
	        name: !brand.name,
	        url: !brand.url
	      };
	
	      return {
	        error: error,
	        errorView: null,
	        description: brand.description || '',
	        name: brand.name || '',
	        facebook_handle: brand.facebook_handle,
	        twitter_handle: brand.twitter_handle,
	        instagram_handle: brand.instagram_handle,
	        pinterest_handle: brand.pinterest_handle,
	        youtube_handle: brand.youtube_handle,
	        url: brand.url || ''
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState(this.createState(props.brand));
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      var data = {
	        description: this.state.description,
	        name: this.state.name,
	        url: this.state.url
	      };
	
	      var routeToEdit = false;
	      if (this.state.token) {
	        data.token = this.state.token;
	      } else {
	        // default to active brand
	        routeToEdit = true;
	        data.active = true;
	      }
	
	      return _Api2.default.saveBrand(data).then(function (response) {
	        var state = _this2.createState(response);
	        state.savedView = _this2.createSavedView();
	        state.savedViewCount = (_this2.state.savedViewCount || 0) + 1;
	        _this2.setState(state);
	        if (routeToEdit) {
	          _this2.context.router.push('/admin/brand/' + response.token + '/edit');
	        }
	      }, function (error) {
	        alert((0, _AdminFunctions.createAlertMessage)(error));
	        _this2.setState({
	          savedView: null,
	          savedViewCount: 0,
	          errorView: _this2.createErrorView(error)
	        });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      if (this.handleError()) {
	        return;
	      }
	      return this.submit();
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      var errorValues = Object.values(this.state.error) || [];
	      var error = errorValues.some(function (value) {
	        return !!value;
	      });
	      if (error) {
	        this.setState({
	          savedView: null,
	          savedViewCount: 0,
	          errorView: this.createErrorView()
	        });
	      }
	
	      return error;
	    }
	  }, {
	    key: 'createSavedView',
	    value: function createSavedView() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'saved-box' },
	        'Saved!'
	      );
	    }
	  }, {
	    key: 'createErrorView',
	    value: function createErrorView(serverError) {
	      var view = void 0;
	      if (serverError) {
	        view = serverError && serverError.message || 'There was an error saving the content';
	      } else {
	        var messages = Object.entries(this.state.error).filter(function (entry) {
	          return !!entry[1];
	        }).map(function (entry) {
	          return 'Invalid ' + entry[0].replace('_', ' ') + ' field';
	        });
	        var listItems = messages.map(function (m, index) {
	          var key = 'error-message-' + index;
	          return _react2.default.createElement(
	            'li',
	            { key: key },
	            m
	          );
	        });
	        view = _react2.default.createElement(
	          'ul',
	          null,
	          listItems
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-error-message' },
	        view
	      );
	    }
	  }, {
	    key: 'clearSavedView',
	    value: function clearSavedView() {
	      var savedViewCount = Math.max(this.state.savedViewCount - 1, 0);
	      var savedView = savedViewCount === 0 ? null : this.state.savedView;
	      this.setState({
	        savedViewCount: savedViewCount,
	        savedView: savedView
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var socialMedia = SocialMediaTags.map(function (socialMedium) {
	        var key = socialMedium.key;
	        var icon = socialMedium.icon;
	        var value = _this3.state[key];
	
	        if (value) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'social-media-line', key: key },
	            _react2.default.createElement(_reactFontawesome2.default, { className: 'social-media-icon', name: icon }),
	            _react2.default.createElement(
	              'span',
	              null,
	              value
	            )
	          );
	        } else {
	          return null;
	        }
	      });
	
	      if (this.state.savedView) {
	        setTimeout(this.clearSavedView, 3000);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'brand-editor' },
	        _react2.default.createElement(
	          'form',
	          { className: 'admin-editor', onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'name', className: 'label required' },
	                'Name'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                required: true,
	                className: this.state.error && this.state.error.name ? ErrorClass : '',
	                name: 'name',
	                type: 'text',
	                value: this.state.name,
	                placeholder: 'Name' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line line-block' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'description', className: 'label' },
	                'Description'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'description',
	                type: 'textarea',
	                value: this.state.description,
	                placeholder: 'Description' })
	            )
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'url', className: 'label required' },
	                _react2.default.createElement(_reactFontawesome2.default, { name: 'link' }),
	                ' URL'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { required: true,
	                className: this.state.error && this.state.error.url ? ErrorClass : '',
	                disabled: this.props.brand && this.props.brand.url,
	                name: 'url',
	                type: 'text',
	                onInput: this.onInput,
	                value: this.state.url,
	                validator: _UrlValidator2.default,
	                placeholder: 'Website' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'social-media-data' },
	              socialMedia
	            )
	          ),
	          this.state.errorView,
	          this.state.savedView,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.handleSubmit },
	              'Save'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BrandEditor;
	}(_react.Component);
	
	exports.default = BrandEditor;
	
	
	BrandEditor.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	__webpack_require__(401);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button(props) {
	    _classCallCheck(this, Button);
	
	    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.noMoreWaiting = _this.noMoreWaiting.bind(_this);
	    _this.waitingState = _this.waitingState.bind(_this);
	    _this.getClasses = _this.getClasses.bind(_this);
	    _this.waitForAction = _this.waitForAction.bind(_this);
	
	    _this.state = {
	      waiting: false
	    };
	
	    _this.mounted = false;
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'waitForAction',
	    value: function waitForAction(promise) {
	      if (this.state.waiting) return;
	
	      if (!(promise instanceof Promise)) return;
	
	      this.setState({ waiting: true });
	      promise.then(this.noMoreWaiting, this.noMoreWaiting);
	
	      return promise;
	    }
	  }, {
	    key: 'noMoreWaiting',
	    value: function noMoreWaiting() {
	      if (!this.mounted) return;
	
	      this.setState({ waiting: false });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      if (this.props.disabled === true) return;
	      if (this.props.onClick && !this.state.waiting) {
	        this.waitForAction(this.props.onClick(event));
	      }
	    }
	
	    // For firing clicks within javascript
	
	  }, {
	    key: 'click',
	    value: function click(event) {
	      this.onClick(event);
	    }
	  }, {
	    key: 'waitingState',
	    value: function waitingState() {
	      if (!this.state.waiting) return null;
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'button-status' },
	        _react2.default.createElement(_reactFontawesome2.default, { name: 'refresh', spin: true })
	      );
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      var btnClass = ['button', 'button--small'];
	
	      if (this.props.color) btnClass.push(this.props.color);
	      if (this.props.disabled === true) btnClass.push('disabled');
	      if (this.props.className && this.props.className.length > 0) btnClass.push(this.props.className);
	
	      return btnClass.join(' ');
	    }
	  }, {
	    key: 'getExtras',
	    value: function getExtras() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.waiting && this.props.waitingState) return this.props.waitingState;
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: this.props.to,
	          onClick: this.onClick,
	          className: this.getClasses()
	        },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.children,
	          this.waitingState()
	        ),
	        this.getExtras()
	      );
	    }
	  }]);
	
	  return Button;
	}(_react2.default.Component);
	
	Button.propTypes = {
	  waitingState: _propTypes2.default.object,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  color: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	exports.default = Button;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _tools = __webpack_require__(103);
	
	var _BagItem = __webpack_require__(288);
	
	var _BagItem2 = _interopRequireDefault(_BagItem);
	
	var _purse = __webpack_require__(126);
	
	var _purse2 = _interopRequireDefault(_purse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Flyout = function (_React$Component) {
	  _inherits(Flyout, _React$Component);
	
	  function Flyout(props) {
	    _classCallCheck(this, Flyout);
	
	    var _this = _possibleConstructorReturn(this, (Flyout.__proto__ || Object.getPrototypeOf(Flyout)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['updateCart', 'emptyCart', 'changeQuantity', 'checkout', 'onKeyDown', 'belowMinimum', 'checkoutComputedButtonText']);
	
	    _this.state = {
	      cart: null,
	      parsed_items: null,
	      products: null,
	      shake: false,
	      editingDisabled: props.disableEditing === true,
	      brandOrder: []
	    };
	
	    _this.shakeTimer = null;
	    return _this;
	  }
	
	  _createClass(Flyout, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.addEventListener("keydown", this.onKeyDown);
	      this.updateCart(this.props.cart);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // Props received. Update state.
	
	      this.updateCart(newProps.cart);
	
	      var editingDisabled = newProps.disableEditing === true;
	      if (editingDisabled !== this.state.editingDisabled) {
	        this.setState({ editingDisabled: editingDisabled });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.onKeyDown);
	      if (this.shakeTimer) clearTimeout(this.shakeTimer);
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      if (event.key === 'Escape' && _Api2.default.cache.getCartVisible()) {
	        _Api2.default.cache.setCartVisible(false);
	        event.preventDefault();
	      }
	    }
	
	    /* If we don't have anything on the cart, just display an empty cart. */
	
	  }, {
	    key: 'emptyCart',
	    value: function emptyCart() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'cart-contents empty-cart' },
	        _react2.default.createElement('span', { className: 'clickcatcher', onClick: this.props.closeCart }),
	        _react2.default.createElement(
	          'span',
	          { className: 'outer-wrapper' },
	          _react2.default.createElement(
	            'span',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'span',
	              { className: 'header-wrapper' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Your Bag'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'cart-products-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'shopping-cart-icon' },
	                _react2.default.createElement('img', { role: 'presentation', src: _purse2.default })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                'You have no items in your bag'
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'updateCart',
	    value: function updateCart(cartData) {
	      if (!cartData) {
	        this.setState({ cart: null });
	        return;
	      }
	
	      var cart = _Api.Utils.clone(cartData);
	
	      cart.brandOrder = cart.parsed_items.map(function (brand) {
	        return brand.token;
	      }).sort(function (aToken, bToken) {
	        var brandA = (0, _tools.findWithToken)(cart.parsed_items, aToken);
	        var brandB = (0, _tools.findWithToken)(cart.parsed_items, bToken);
	        return brandA.name.localeCompare(brandB.name);
	      });
	
	      cart.checkoutText = this.checkoutComputedButtonText();
	      this.setState(cart);
	    }
	
	    // Sets the quantity of a specific cart item
	
	  }, {
	    key: 'changeQuantity',
	    value: function changeQuantity(token, quantity) {
	      var parsed_items = _Api.Utils.clone(this.state.parsed_items, true);
	
	      // find cart item
	      var chosenItem = null;
	      parsed_items.forEach(function (brand) {
	        brand.products.forEach(function (cart_product) {
	          if (cart_product.token === token) chosenItem = cart_product;
	        });
	      });
	
	      if (!chosenItem) {
	        console.error('error: cannot find product with token %s on cart.', token);
	        return;
	      }
	      chosenItem.loading = true;
	      chosenItem.quantity = quantity;
	
	      this.setState({ parsed_items: parsed_items });
	
	      _Api2.default.addToCart([chosenItem]);
	    }
	  }, {
	    key: 'checkout',
	    value: function checkout(event) {
	      var _this2 = this;
	
	      var belowMinimum = this.state.parsed_items.filter(function (brand) {
	        return brand.total_cents < brand.minimum_order_amount_cents;
	      });
	
	      if (belowMinimum.length <= 0 || this.props.isAdminImpersonating) {
	        this.props.checkout();
	        return;
	      }
	
	      this.setState({
	        shake: true
	      });
	
	      if (!this.shakeTimer) {
	        this.shakeTimer = setTimeout(function () {
	          _this2.setState({ shake: false });
	          _this2.shakeTimer = null;
	        }, 3000);
	      }
	    }
	  }, {
	    key: 'belowMinimum',
	    value: function belowMinimum() {
	      if (!this.state.parsed_items) return [];
	
	      return this.state.parsed_items.filter(function (brand) {
	        return brand.total_cents < brand.minimum_order_amount_cents;
	      });
	    }
	  }, {
	    key: 'checkoutComputedButtonText',
	    value: function checkoutComputedButtonText() {
	      if (this.shakeTimer) {
	        return 'Some Orders Below minimum';
	      }
	
	      if (this.belowMinimum().length > 0) {
	        return 'Some Orders Below minimum';
	      }
	
	      return 'Proceed to Checkout';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var cart = this.state.cart;
	
	      if (!cart || cart.items.length === 0 || !this.state.parsed_items || this.state.parsed_items.length === 0) {
	        return this.emptyCart();
	      }
	
	      // Creates one block for each brand...
	      var itemsDisplay = this.state.brandOrder.map(function (brandToken) {
	        return (0, _tools.findWithToken)(_this3.state.parsed_items, brandToken);
	      }).map(function (brand) {
	        return _react2.default.createElement(BrandSection, {
	          retailerToken: _this3.props.retailerToken,
	          key: "cart-" + brand.token,
	          brand: brand,
	          products: _this3.state.products,
	          changeQuantity: _this3.changeQuantity,
	          disableEditing: _this3.state.editingDisabled
	        });
	      });
	
	      var belowMinimum = this.belowMinimum();
	
	      // If we have a checkout prop, we display the button action bar. If not, do not.
	      var buttonActionBar = null;
	      if (this.props.checkout && typeof this.props.checkout === 'function') {
	        var classNames = [];
	        if (this.state.shake) classNames.push('shake');
	        if (belowMinimum.length > 0) classNames.push('disabled');
	
	        buttonActionBar = _react2.default.createElement(
	          'div',
	          { className: 'actions' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: classNames.join(' '), onClick: this.checkout },
	            this.checkoutComputedButtonText(),
	            _react2.default.createElement(
	              'span',
	              { className: 'button-subtotal' },
	              '$',
	              _Api.Utils.formatCents(this.state.cart.total_value_cents)
	            )
	          )
	        );
	      }
	
	      var discount = this.state.cart.discount;
	
	      var subtotal = null;
	      if (this.props.subtotal) {
	        var discountView = null;
	        if (discount && discount.code && discount.total_discount_amount_cents) {
	          discountView = _react2.default.createElement(
	            'div',
	            { className: 'promo-code-discount' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Promo Code: ' + discount.code
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'amount' },
	              '$',
	              _Api.Utils.formatCents(discount.total_discount_amount_cents)
	            )
	          );
	        }
	
	        var shipping = discount && discount.free_shipping ? "FREE" : "TBD*";
	
	        subtotal = _react2.default.createElement(
	          'div',
	          { className: 'cart-summary' },
	          _react2.default.createElement(
	            'div',
	            { className: 'subtotal' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Subtotal'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'amount' },
	              '$',
	              _Api.Utils.formatCents(this.state.cart.total_value_cents)
	            )
	          ),
	          discountView,
	          _react2.default.createElement(
	            'div',
	            { className: 'shipping-cost' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Shipping'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'amount' },
	              shipping
	            )
	          )
	        );
	      }
	
	      var textTotal = null;
	      if (this.props.textTotal) {
	        var totalCents = discount && discount.total_amount_cents ? discount.total_amount_cents : this.state.cart.total_value_cents;
	        textTotal = _react2.default.createElement(
	          'div',
	          { className: 'text-total' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Total'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'amount' },
	            '$',
	            _Api.Utils.formatCents(totalCents)
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cart-contents' + (belowMinimum.length === 0 ? '' : ' below-minimum') },
	        _react2.default.createElement(
	          'span',
	          { className: 'clickcatcher', onClick: this.props.closeCart },
	          _react2.default.createElement('div', { className: 'background' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'outer-wrapper' },
	          _react2.default.createElement(
	            'span',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'header-wrapper' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Your Bag'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'cart-products-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'cart-products' },
	                itemsDisplay
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'fix-bottom' },
	              subtotal,
	              buttonActionBar,
	              textTotal
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Flyout;
	}(_react2.default.Component);
	
	Flyout.propTypes = {
	  isAdminImpersonating: _propTypes2.default.bool, /* if true, ignore brand minimums */
	  closeCart: _propTypes2.default.func,
	  checkout: _propTypes2.default.func,
	  disableEditing: _propTypes2.default.bool
	};
	exports.default = Flyout;
	
	var BrandSection = function (_React$Component2) {
	  _inherits(BrandSection, _React$Component2);
	
	  function BrandSection(props) {
	    _classCallCheck(this, BrandSection);
	
	    var _this4 = _possibleConstructorReturn(this, (BrandSection.__proto__ || Object.getPrototypeOf(BrandSection)).call(this, props));
	
	    _Api.Utils.bindThis(_this4, ['brandNameClick']);
	
	    _this4.state = {
	      collapsed: false
	    };
	    return _this4;
	  }
	
	  _createClass(BrandSection, [{
	    key: 'brandNameClick',
	    value: function brandNameClick(event) {
	      event.preventDefault();
	
	      if (!this.props.retailerToken) return;
	
	      var url = '/retailer/' + this.props.retailerToken + '/brand/' + this.props.brand.token;
	      _Api2.default.cache.setCartVisible(false);
	      this.context.router.push(url);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var brand = this.props.brand;
	      var belowMinimumAlert = null;
	      var brandQuantity = 0;
	      var brandCents = 0;
	
	      var productBlocks = [];
	      brand.products.forEach(function (item) {
	        var productBlock = productBlocks.find(function (block) {
	          return item.product_token === block.product_token;
	        });
	        if (!productBlock) {
	          productBlock = {
	            product_token: item.product_token,
	            product: _this5.props.products[item.product_token],
	            quantity: 0,
	            price_cents: 0,
	            item_list: []
	          };
	          productBlocks.push(productBlock);
	        }
	        productBlock.quantity += item.quantity;
	        productBlock.price_cents += item.quantity * item.price_cents;
	        productBlock.item_list.push(item);
	      });
	
	      productBlocks = productBlocks.sort(function (blockA, blockB) {
	        return blockA.product.name.localeCompare(blockB.product.name);
	      });
	
	      // one block for each item.
	      var products = productBlocks.map(function (block) {
	        brandQuantity += block.quantity;
	        brandCents += block.price_cents;
	        return _react2.default.createElement(_BagItem2.default, { disableEditing: _this5.props.disableEditing, key: block.product.token, itemList: block.item_list,
	          product: block.product, retailerToken: _this5.props.retailerToken });
	      });
	
	      if (brand.below_minimum) {
	        belowMinimumAlert = _react2.default.createElement(
	          'div',
	          { className: 'below-minimum-alert link', onClick: this.brandNameClick },
	          'Add ',
	          (0, _tools.formatPrice)(brand.minimum_order_amount_cents - brand.total_cents),
	          ' to reach ',
	          brand.name,
	          ' ',
	          'Minimum >'
	        );
	      }
	
	      var brandTitle = _react2.default.createElement(
	        'h2',
	        { onClick: this.brandNameClick, className: !!this.props.retailerToken ? 'link' : '' },
	        _react2.default.createElement(
	          'span',
	          { className: 'quantity' },
	          brandQuantity
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'brand-name' },
	          brand.name
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'value' },
	          '$',
	          _Api.Utils.formatCents(brandCents)
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: "brand-section" + (belowMinimumAlert !== null ? ' below-minimum' : ''),
	          key: "cart-" + brand.token },
	        brandTitle,
	        belowMinimumAlert,
	        _react2.default.createElement(
	          'div',
	          { className: 'products' },
	          products
	        )
	      );
	    }
	  }]);
	
	  return BrandSection;
	}(_react2.default.Component);
	
	BrandSection.propTypes = {
	  brand: _propTypes2.default.object.isRequired,
	  products: _propTypes2.default.object.isRequired,
	  changeQuantity: _propTypes2.default.func.isRequired,
	  disableEditing: _propTypes2.default.bool
	};
	BrandSection.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findWithToken = exports.formatPrice = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Utils = __webpack_require__(42);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatPrice(price_cents) {
	  var price_dollars = _Utils2.default.formatCents(price_cents);
	
	  var cents = price_dollars.substr(-2);
	  var whole = price_dollars.substr(0, price_dollars.length - 3);
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'price' },
	    _react2.default.createElement(
	      'span',
	      { className: 'sign' },
	      '$'
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'dollars' },
	      whole
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'dot' },
	      '.'
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'cents' },
	      cents
	    )
	  );
	}
	
	function findWithToken(arr, token) {
	  return arr.find(function (item) {
	    return item && item.token === token;
	  });
	}
	
	exports.formatPrice = formatPrice;
	exports.findWithToken = findWithToken;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _fieldKit = __webpack_require__(120);
	
	var _fieldKit2 = _interopRequireDefault(_fieldKit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextField = function (_React$Component) {
	  _inherits(TextField, _React$Component);
	
	  function TextField(props) {
	    _classCallCheck(this, TextField);
	
	    var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));
	
	    _this.buildFieldKitField = _this.buildFieldKitField.bind(_this);
	    _this.setUpPlaceholders = _this.setUpPlaceholders.bind(_this);
	    _this.setupEvents = _this.setupEvents.bind(_this);
	    _this.getField = _this.getField.bind(_this);
	    _this.getFormatter = _this.getFormatter.bind(_this);
	    _this.getElement = _this.getElement.bind(_this);
	    _this.getValue = _this.getValue.bind(_this);
	    _this.onTextDidChange = _this.onTextDidChange.bind(_this);
	
	    _this.state = {
	      value: props.value,
	      formattedValue: ''
	    };
	
	    _this.name = props.name;
	    return _this;
	  }
	
	  _createClass(TextField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.buildFieldKitField();
	      this.field.setValue(this.props.value);
	      this.value = this.props.value;
	
	      this.setUpPlaceholders();
	
	      this.setupEvents();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && this.state.value !== nextProps.value) {
	        this.field.setValue(nextProps.value);
	      }
	    }
	  }, {
	    key: 'buildFieldKitField',
	    value: function buildFieldKitField() {
	      var field = this.getField();
	
	      if (field) {
	        this.field = field;
	      } else {
	        var formatter = this.getFormatter();
	        if (formatter) {
	          this.field = new _fieldKit2.default.TextField(this.getElement(), formatter);
	        } else {
	          this.field = new _fieldKit2.default.TextField(this.getElement());
	        }
	      }
	
	      return this.field;
	    }
	  }, {
	    key: 'setUpPlaceholders',
	    value: function setUpPlaceholders() {
	      if (this.props.placeholder || this.props.unfocusedPlaceholder) {
	        this.field.setUnfocusedPlaceholder(this.props.placeholder || this.props.unfocusedPlaceholder);
	      }
	
	      if (this.props.focusedPlaceholder) {
	        this.field.setFocusedPlaceholder(this.props.focusedPlaceholder);
	      }
	    }
	  }, {
	    key: 'setupEvents',
	    value: function setupEvents() {
	      this.field.setDelegate({
	        textFieldDidBeginEditing: this.props.didBeginEditing,
	        textFieldDidEndEditing: this.props.didEndEditing,
	        textDidChange: this.onTextDidChange
	      });
	    }
	  }, {
	    key: 'getField',
	    value: function getField() {
	      // Allows subclasses to override
	      return null;
	    }
	  }, {
	    key: 'getFormatter',
	    value: function getFormatter() {
	      // Allows subclasses to override
	      return null;
	    }
	  }, {
	    key: 'getElement',
	    value: function getElement() {
	      return _reactDom2.default.findDOMNode(this);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: 'onTextDidChange',
	    value: function onTextDidChange(field) {
	      // Update component value
	      //this.props.rawValue = field.value();
	
	      this.setState({
	        value: field.value(),
	        formattedValue: field.text()
	      });
	
	      // For accessing with ref
	      this.value = field.value();
	
	      if (this.props.onChange) {
	        var event = {};
	        event.target = {
	          name: this.props.name,
	          value: this.value
	        };
	        this.props.onChange(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('input', {
	        type: 'text',
	        name: this.props.name,
	        className: this.props.className,
	        onBlur: this.props.onBlur.bind(this),
	        onKeyDown: this.props.onKeyDown
	      });
	    }
	
	    // Helper method for subclasses
	
	  }], [{
	    key: 'getBasePropTypes',
	    value: function getBasePropTypes() {
	      return {
	        rawValue: _propTypes2.default.string,
	        value: _propTypes2.default.string,
	        placeholder: _propTypes2.default.string,
	        focusedPlaceholder: _propTypes2.default.string,
	        unfocusedPlaceholder: _propTypes2.default.string,
	        onChange: _propTypes2.default.func,
	        didBeginEditing: _propTypes2.default.func,
	        didEndEditing: _propTypes2.default.func,
	        onBlur: _propTypes2.default.func,
	        onKeyDown: _propTypes2.default.func
	      };
	    }
	
	    // Helper method for subclasses
	
	  }, {
	    key: 'getBaseDefaultProps',
	    value: function getBaseDefaultProps() {
	      return {
	        onBlur: function onBlur() {},
	        didBeginEditing: function didBeginEditing() {},
	        didEndEditing: function didEndEditing() {}
	      };
	    }
	  }]);
	
	  return TextField;
	}(_react2.default.Component);
	
	exports.default = TextField;
	
	
	TextField.propTypes = TextField.getBasePropTypes();
	
	TextField.defaultProps = TextField.getBaseDefaultProps();

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhoneField = exports.TextField = undefined;
	
	var _TextField = __webpack_require__(104);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _PhoneField = __webpack_require__(293);
	
	var _PhoneField2 = _interopRequireDefault(_PhoneField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;
	exports.TextField = _TextField2.default;
	exports.PhoneField = _PhoneField2.default;

/***/ },
/* 106 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateUUID = generateUUID;
	// source: http://stackoverflow.com/a/8809472
	// source: http://stackoverflow.com/a/2117523
	function generateUUID() {
	  // Public Domain/MIT
	  var d = Date.now();
	  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
	    d += performance.now(); //use high-precision timer if available
	  }
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = (d + Math.random() * 16) % 16 | 0;
	    d = Math.floor(d / 16);
	    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16); // eslint-disable-line  no-mixed-operators
	  });
	}

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = validate;
	// Regular Expression for URL validation
	//
	// Author: Diego Perini
	// Updated: 2010/12/05
	// License: MIT
	//
	// Copyright (c) 2010-2013 Diego Perini (http://www.iport.it)
	//
	// Permission is hereby granted, free of charge, to any person
	// obtaining a copy of this software and associated documentation
	// files (the "Software"), to deal in the Software without
	// restriction, including without limitation the rights to use,
	// copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the
	// Software is furnished to do so, subject to the following
	// conditions:
	//
	// The above copyright notice and this permission notice shall be
	// included in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	// OTHER DEALINGS IN THE SOFTWARE.
	//
	// the regular expression composed & commented
	// could be easily tweaked for RFC compliance,
	// it was expressly modified to fit & satisfy
	// these test for an URL shortener:
	//
	//   http://mathiasbynens.be/demo/url-regex
	//
	
	/* eslint-disable no-useless-escape */
	var regexStr = "^" +
	// protocol identifier (optional) + //
	"(?:(?:https?:)?//)?" +
	// user:pass authentication (optional)
	"(?:\\S+(?::\\S*)?@)?" +
	// host (optional) + domain + tld
	"(?:(?!-)[-a-z0-9\\u00a1-\\uffff]*[a-z0-9\\u00a1-\\uffff]+(?!./|\\.$)\\.?){2,}" +
	// server port number (optional)
	"(?::\\d{2,5})?" +
	// resource path (optional)
	"(?:/\\S*)?" + "$";
	
	/* eslint-enable no-useless-escape */
	var WebUrlRegex = new RegExp(regexStr);
	
	function validate(url) {
	    return WebUrlRegex.test(url);
	}

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Values = function (_React$Component) {
	  _inherits(Values, _React$Component);
	
	  function Values() {
	    _classCallCheck(this, Values);
	
	    return _possibleConstructorReturn(this, (Values.__proto__ || Object.getPrototypeOf(Values)).apply(this, arguments));
	  }
	
	  _createClass(Values, [{
	    key: 'render',
	    value: function render() {
	      var values = this.props.values;
	      var headline = this.props.headline;
	
	      var items = values.map(function (valueEntry, idx) {
	        return _react2.default.createElement(
	          'div',
	          { key: 'value-entry-item-' + idx, className: 'value-entry' + (valueEntry.className ? ' ' + valueEntry.className : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'value-logo' },
	            _react2.default.createElement('img', { role: 'presentation', src: valueEntry.imageUrl })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              valueEntry.header
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              valueEntry.description
	            )
	          )
	        );
	      });
	
	      var headlineContent = null;
	      if (headline) headlineContent = _react2.default.createElement(
	        'h2',
	        null,
	        headline
	      );
	
	      var className = 'values home-section' + (this.props.className ? ' ' + this.props.className : '');
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { className: 'values-inner-wrapper' },
	          headlineContent,
	          items
	        )
	      );
	    }
	  }]);
	
	  return Values;
	}(_react2.default.Component);
	
	exports.default = Values;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var marketplaceImageWidth = 236;
	var marketplaceImageHeight = 260;
	var marketplaceImageAspectRatio = marketplaceImageWidth / marketplaceImageHeight;
	
	var MarketplaceProduct = function (_React$Component) {
	  _inherits(MarketplaceProduct, _React$Component);
	
	  function MarketplaceProduct(props) {
	    _classCallCheck(this, MarketplaceProduct);
	
	    var _this = _possibleConstructorReturn(this, (MarketplaceProduct.__proto__ || Object.getPrototypeOf(MarketplaceProduct)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['adminPanel', 'onImageLoad', 'imageList', 'heartsPanel', 'wholesaleInfo', 'extraContent', 'onProductClick', 'onBrandClick', 'onAdminClick', 'onActiveClick', 'onManualRecommendationClick']);
	
	    _this.state = {
	      product: props.product,
	      brand: props.brand
	    };
	    return _this;
	  }
	
	  _createClass(MarketplaceProduct, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        product: nextProps.product
	      });
	    }
	  }, {
	    key: 'displayBrandBlock',
	    value: function displayBrandBlock() {
	      return true;
	    }
	  }, {
	    key: 'onImageLoad',
	    value: function onImageLoad() {
	      var _this2 = this;
	
	      if (this.props.onImageLoad) {
	        var delay = this.props.imageLoadDelay || 0;
	        setTimeout(function () {
	          _this2.props.onImageLoad(_this2);
	        }, delay);
	      }
	    }
	  }, {
	    key: 'imageList',
	    value: function imageList(product) {
	      var imageList = [];
	      if (product.images) {
	        product.images.forEach(function (image) {
	          imageList.push(image);
	        });
	      }
	
	      if (product.options) {
	        product.options.forEach(function (productOption) {
	          if (!productOption.images) return;
	
	          productOption.images.forEach(function (image) {
	            imageList.push(image);
	          });
	        });
	      }
	
	      return imageList;
	    }
	  }, {
	    key: 'onProductClick',
	    value: function onProductClick(event) {
	      if (!this.props.onClick || event.defaultPrevented) return;
	
	      event.preventDefault();
	      this.props.onClick(this.state.product);
	    }
	  }, {
	    key: 'onBrandClick',
	    value: function onBrandClick(event) {
	      if (!this.props.onBrandClick || event.defaultPrevented) return;
	
	      event.preventDefault();
	      this.props.onBrandClick(this.props.brand);
	    }
	  }, {
	    key: 'onAdminClick',
	    value: function onAdminClick(event) {
	      event.preventDefault();
	    }
	  }, {
	    key: 'onActiveClick',
	    value: function onActiveClick(event) {
	      var _this3 = this;
	
	      event.preventDefault();
	
	      var product = this.state.product;
	      product.active = !product.active;
	      return _Api2.default.saveProduct(product).then(function () {
	        _this3.setState({ product: product });
	      }, function (error) {
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'onManualRecommendationClick',
	    value: function onManualRecommendationClick(event) {
	      var _this4 = this;
	
	      event.preventDefault();
	
	      var retailerToken = this.props.retailerToken;
	      if (!retailerToken) return;
	
	      var product = this.state.product;
	      var manualRecommendation = product.manual_recommendation;
	      var promise = null;
	      if (manualRecommendation) {
	        promise = _Api2.default.retailerRemoveRecommendation(retailerToken, product.token);
	      } else {
	        promise = _Api2.default.retailerAddRecommendation(retailerToken, product.token);
	      }
	
	      return promise.then(function () {
	        product.manual_recommendation = !manualRecommendation;
	        _this4.setState({ product: product });
	      }, function (error) {
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'heartsPanel',
	    value: function heartsPanel() {
	      var hearts = null;
	      var totalLikes = this.state.product.likes || this.props.brand.likes;
	      if (totalLikes) {
	        if (totalLikes > 1000000) {
	          totalLikes = parseFloat(totalLikes / 1000000).toFixed(0) + 'M';
	        } else if (totalLikes > 1000) {
	          totalLikes = parseFloat(totalLikes / 1000).toFixed(0) + 'k';
	        }
	
	        hearts = _react2.default.createElement(
	          'div',
	          { className: 'hearts' },
	          totalLikes,
	          ' ',
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'heart' })
	        );
	      }
	
	      return hearts;
	    }
	  }, {
	    key: 'adminPanel',
	    value: function adminPanel() {
	      var admin = null;
	      if (this.props.isEmployee) {
	        var isActive = !!this.state.product.active;
	
	        var isManualRecommendation = !!this.state.product.manual_recommendation;
	        var manualRecommendation = _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { onClick: this.onManualRecommendationClick },
	            'Manual recommendation'
	          ),
	          _react2.default.createElement('input', { className: 'checkbox inline',
	            type: 'checkbox',
	            style: { cursor: 'pointer' },
	            onChange: this.onManualRecommendationClick,
	            checked: isManualRecommendation })
	        );
	
	        var recommenderNames = null;
	        if (this.state.product.recommenders) {
	          // Make sure the elements are unique and remove manual as it's displayed separately above.
	          var recommendationSet = new Set(this.state.product.recommenders);
	          recommendationSet.delete('MANUAL');
	          recommenderNames = _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              Array.from(recommendationSet).join(', ')
	            )
	          );
	        }
	
	        var likesAndCreationYear = null;
	        if (this.state.brand) {
	          var totalLikes = this.state.brand.likes || '-';
	          if (totalLikes >= 1000000) {
	            totalLikes = parseFloat(totalLikes / 1000000).toFixed(0) + 'M';
	          } else if (totalLikes >= 1000) {
	            totalLikes = parseFloat(totalLikes / 1000).toFixed(0) + 'K';
	          }
	          var established = this.state.brand.creation_year || '-';
	          likesAndCreationYear = _react2.default.createElement(
	            'div',
	            null,
	            totalLikes,
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'heart' }),
	            ' Established: ',
	            established
	          );
	        }
	
	        admin = _react2.default.createElement(
	          'div',
	          { className: 'admin', onClick: this.onAdminClick },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { onClick: this.onActiveClick },
	              'Active'
	            ),
	            _react2.default.createElement('input', { className: 'checkbox inline',
	              type: 'checkbox',
	              style: { cursor: 'pointer' },
	              onChange: this.onActiveClick,
	              checked: isActive })
	          ),
	          manualRecommendation,
	          recommenderNames,
	          likesAndCreationYear
	        );
	      }
	
	      return admin;
	    }
	  }, {
	    key: 'wholesaleInfo',
	    value: function wholesaleInfo() {
	      var product = this.state.product;
	      var productOption = product.options && product.options.length > 0 ? product.options[0] : {
	        unit_multiplier: 1,
	        wholesale_price_cents: null
	      };
	
	      var unitMultiplier = productOption.unit_multiplier;
	      var retailPrice = productOption.retail_price_cents ? '$' + _Api.Utils.formatCents(productOption.retail_price_cents, true) : null;
	      var wholesalePrice = productOption.wholesale_price_cents ? '$' + _Api.Utils.formatCents(productOption.wholesale_price_cents, true) : null;
	
	      return {
	        wholesale_price: wholesalePrice,
	        retail_price: retailPrice,
	        unit_multiplier: unitMultiplier,
	        collection_size: null
	      };
	    }
	  }, {
	    key: 'extraContent',
	    value: function extraContent() {
	      if (this.props.cartEntry) {
	        var quantity = 0;
	        this.props.cartEntry.forEach(function (entry) {
	          quantity += entry.quantity;
	        });
	        return _react2.default.createElement(
	          'div',
	          { className: 'cart-contents' },
	          _react2.default.createElement(
	            'div',
	            { className: 'edit-icon' },
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'pencil' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            'Added to Bag'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'quantity' },
	            'Qty: ',
	            quantity,
	            ' items'
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.product) return null;
	
	      if (!this.props.brand) {
	        console.error("Where's my brand?");
	        console.error(this.state.product);
	
	        return null;
	      }
	
	      var product = this.state.product;
	
	      var minimumOrder = this.props.brand.minimum_order_amount_cents;
	      if (minimumOrder) {
	        minimumOrder = 'Minimum $' + parseFloat(minimumOrder / 100).toFixed(0);
	      }
	
	      if (!minimumOrder) {
	        minimumOrder = 'No minimum';
	      }
	
	      var wholesaleData = this.wholesaleInfo();
	      var retailContents = _react2.default.createElement(
	        'div',
	        { className: 'outer-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'retail-price' },
	            wholesaleData.retail_price && "Retail Price " + wholesaleData.retail_price
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'case-size' },
	            wholesaleData.collection_size && wholesaleData.collection_size + ' Items',
	            wholesaleData.unit_multiplier && 'Case Size ' + wholesaleData.unit_multiplier
	          )
	        )
	      );
	
	      var brandBlock = null;
	      if (this.displayBrandBlock()) {
	        brandBlock = _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'brand-block', to: this.props.brandUrl },
	          _react2.default.createElement(
	            'div',
	            { className: 'maker' },
	            'Maker'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'brand-info-contents' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'name' },
	              this.props.brand.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'minimum' },
	              minimumOrder
	            )
	          )
	        );
	      } else {
	        brandBlock = _react2.default.createElement(_reactRouter.Link, { className: 'brand-block blank' });
	      }
	
	      var productError = false;
	      if (!this.state.product.items) {
	        productError = !this.state.product || !this.state.product.options || this.state.product.options.length <= 0;
	      }
	
	      var classNames = ['marketplace-product'];
	      if (productError) {
	        classNames.push('product-error');
	      }
	
	      if (productError && !this.props.isEmployee) {
	        return null;
	      }
	
	      if (this.props.className) classNames.push(this.props.className);
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '), onClick: this.onProductClick },
	        _react2.default.createElement(
	          'div',
	          { className: 'product-block' },
	          _react2.default.createElement(MarketplaceImage, { imageList: this.imageList(product) }),
	          this.extraContent(),
	          _react2.default.createElement(
	            'div',
	            { className: 'retail-overlay' },
	            retailContents
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'product-line line flex' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'product-name inline' },
	              product.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wholesale-price' },
	              wholesaleData.wholesale_price
	            )
	          )
	        ),
	        brandBlock,
	        this.adminPanel()
	      );
	    }
	  }]);
	
	  return MarketplaceProduct;
	}(_react2.default.Component);
	
	MarketplaceProduct.propTypes = {
	  className: _propTypes2.default.string,
	  product: _propTypes2.default.object.isRequired,
	  brand: _propTypes2.default.object.isRequired,
	  retailerToken: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onBrandClick: _propTypes2.default.func,
	  brandUrl: _propTypes2.default.string,
	  onImageLoad: _propTypes2.default.func,
	  imageLoadDelay: _propTypes2.default.number,
	  isEmployee: _propTypes2.default.bool,
	  cartEntry: _propTypes2.default.array
	};
	exports.default = MarketplaceProduct;
	
	
	var MarketplaceImage = function MarketplaceImage(_ref) {
	  var imageList = _ref.imageList;
	
	  if (!Array.isArray(imageList) || imageList.length === 0) return _react2.default.createElement('div', { className: 'image no-image' });
	  var image = imageList[0];
	
	  var classNames = ['image'];
	  if (image.width && image.height) {
	    var aspectRatio = image.width / image.height;
	
	    if (aspectRatio > marketplaceImageAspectRatio) {
	      classNames.push('landscape');
	    } else if (aspectRatio < marketplaceImageAspectRatio) {
	      classNames.push('portrait');
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: classNames.join(' ') },
	    _react2.default.createElement('img', {
	      role: 'presentation',
	      src: image.url
	    })
	  );
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MarketplaceProduct = __webpack_require__(109);
	
	var _MarketplaceProduct2 = _interopRequireDefault(_MarketplaceProduct);
	
	var _MarketplaceCollection = __webpack_require__(319);
	
	var _MarketplaceCollection2 = _interopRequireDefault(_MarketplaceCollection);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var refName = 'recommendation-grid';
	
	var RecommendationGrid = function (_React$Component) {
	  _inherits(RecommendationGrid, _React$Component);
	
	  function RecommendationGrid(props) {
	    _classCallCheck(this, RecommendationGrid);
	
	    var _this = _possibleConstructorReturn(this, (RecommendationGrid.__proto__ || Object.getPrototypeOf(RecommendationGrid)).call(this, props));
	
	    _this.cartUpdated = _this.cartUpdated.bind(_this);
	    _this.brandUrl = _this.brandUrl.bind(_this);
	
	    _this.state = {
	      user: null,
	      cart: _Api2.default.cache.getCart()
	    };
	    return _this;
	  }
	
	  _createClass(RecommendationGrid, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _Api2.default.getUser(true).then(function (user) {
	        _this2.setState({ user: user });
	      });
	
	      _Api2.default.cache.addChangeListener(this.cartUpdated, _Api2.default.cache.eventTypes.CART_CHANGED);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.cartUpdated, _Api2.default.cache.eventTypes.CART_CHANGED);
	    }
	  }, {
	    key: 'cartUpdated',
	    value: function cartUpdated() {
	      this.setState({ cart: _Api2.default.cache.getCart() });
	    }
	  }, {
	    key: 'brandUrl',
	    value: function brandUrl(brand) {
	      return '/retailer/' + this.props.retailerToken + '/brand/' + brand.token;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var recommendations = null;
	      var gridCount = 0;
	      var isEmployee = this.state.user && this.state.user.is_employee;
	
	      var display_order = this.props.display_order;
	      if (!display_order) return null;
	
	      if (display_order && display_order.length > 0) {
	        gridCount = display_order.length;
	        recommendations = display_order.map(function (marketplaceObject) {
	          var object = _this3.props.products[marketplaceObject] || _this3.props.collections[marketplaceObject];
	          if (!object) {
	            console.error('invalid display object: %s', marketplaceObject);
	            return null;
	          }
	          if (object.items && object.items.length <= 0) {
	            console.error('product collection has no items: %s', marketplaceObject);
	            return null;
	          }
	          var brandToken = object.items ? object.items[0].brand_token : object.brand_token;
	          var brand = _this3.props.brands[brandToken];
	          if (!brand) {
	            console.error('cannot find brand: "%s"', brandToken);
	            console.error(marketplaceObject);
	            console.error(object);
	            return null;
	          }
	          if (object.items) {
	            return _react2.default.createElement(_MarketplaceCollection2.default, {
	              key: object.token,
	              retailerToken: _this3.props.retailerToken,
	              isEmployee: isEmployee,
	              onImageLoad: _this3.fixLayout,
	              product: object,
	              brand: brand,
	              productList: _this3.props.products,
	              onClick: _this3.props.selectCollection,
	              onBrandClick: _this3.props.selectBrand
	            });
	          }
	
	          var cartEntry = null;
	          if (_this3.state.cart && _this3.state.cart.cart && _this3.state.cart.cart.items && _this3.state.cart.cart.items.length > 0) {
	            cartEntry = _this3.state.cart.cart.items.filter(function (cartItem) {
	              return cartItem.product_token === object.token;
	            });
	
	            if (cartEntry.length === 0) cartEntry = null;
	          }
	
	          return _react2.default.createElement(_MarketplaceProduct2.default, {
	            key: object.token,
	            retailerToken: _this3.props.retailerToken,
	            isEmployee: isEmployee,
	            onImageLoad: _this3.fixLayout,
	            product: object,
	            brand: brand,
	            onClick: _this3.props.selectProduct,
	            onBrandClick: _this3.props.selectBrand,
	            brandUrl: _this3.brandUrl(brand),
	            cartEntry: cartEntry
	          });
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'recommendation-grid-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'recommendation-grid grid-count-' + gridCount,
	            ref: refName },
	          recommendations
	        )
	      );
	    }
	  }]);
	
	  return RecommendationGrid;
	}(_react2.default.Component);
	
	RecommendationGrid.propTypes = {
	  products: _propTypes2.default.object.isRequired,
	  collections: _propTypes2.default.object.isRequired,
	  brands: _propTypes2.default.object.isRequired,
	  display_order: _propTypes2.default.array.isRequired,
	  retailerToken: _propTypes2.default.string,
	  selectProduct: _propTypes2.default.func,
	  selectBrand: _propTypes2.default.func,
	  brandUrl: _propTypes2.default.func,
	  selectCollection: _propTypes2.default.func
	};
	exports.default = RecommendationGrid;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ronReactAutocomplete = __webpack_require__(574);
	
	var _ronReactAutocomplete2 = _interopRequireDefault(_ronReactAutocomplete);
	
	var _reactDataGrid = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoCompleteEditor = function (_React$Component) {
	  _inherits(AutoCompleteEditor, _React$Component);
	
	  function AutoCompleteEditor(props) {
	    _classCallCheck(this, AutoCompleteEditor);
	
	    var _this = _possibleConstructorReturn(this, (AutoCompleteEditor.__proto__ || Object.getPrototypeOf(AutoCompleteEditor)).call(this, props));
	
	    _this.search = _this.search.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutoCompleteEditor, [{
	    key: "getValue",
	    value: function getValue() {
	      var updated = {};
	      if (this.autoComplete.state.focusedValue && this.autoComplete.state.focusedValue.value) {
	        updated[this.props.column.key] = this.autoComplete.state.focusedValue.value;
	      }
	      return updated;
	    }
	  }, {
	    key: "getEditorDisplayValue",
	    value: function getEditorDisplayValue() {
	      var displayValue = { title: '' };
	      var _props = this.props,
	          column = _props.column,
	          value = _props.value,
	          editorDisplayValue = _props.editorDisplayValue;
	
	      if (editorDisplayValue && typeof editorDisplayValue === 'function') {
	        displayValue.title = editorDisplayValue(column, value);
	      } else {
	        displayValue.title = value;
	      }
	      return displayValue;
	    }
	  }, {
	    key: "getInputNode",
	    value: function getInputNode() {
	      return _reactDom2.default.findDOMNode(this).getElementsByTagName('input')[0];
	    }
	  }, {
	    key: "getLabel",
	    value: function getLabel(item) {
	      var label = this.props.label !== null ? this.props.label : 'title';
	      if (typeof label === 'function') {
	        return label(item);
	      } else if (typeof label === 'string') {
	        return item[label];
	      }
	    }
	  }, {
	    key: "hasResults",
	    value: function hasResults() {
	      return this.autoComplete.state.results.length > 0;
	    }
	  }, {
	    key: "isFocusedOnSuggestion",
	    value: function isFocusedOnSuggestion() {
	      var autoComplete = this.autoComplete;
	      return autoComplete.state.focusedValue !== null;
	    }
	  }, {
	    key: "constructValueFromParams",
	    value: function constructValueFromParams(obj, props) {
	      debugger;
	      if (!props) {
	        return '';
	      }
	
	      var ret = [];
	      for (var i = 0, ii = props.length; i < ii; i++) {
	        ret.push(obj[props[i]]);
	      }
	      return ret.join('|');
	    }
	  }, {
	    key: "search",
	    value: function search(options, searchTerm, callback) {
	      if (this.props.search) {
	        this.props.search(this.props.rowData, options, searchTerm, callback);
	      } else {
	        callback(null, []);
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(event) {
	      if (this.props.onCommit) this.props.onCommit(event);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var label = this.props.label !== null ? this.props.label : 'title';
	      return _react2.default.createElement(
	        "div",
	        { height: this.props.height, onKeyDown: this.props.onKeyDown },
	        _react2.default.createElement(_ronReactAutocomplete2.default, {
	          ref: function ref(node) {
	            return _this2.autoComplete = node;
	          },
	          label: label,
	          search: this.search,
	          onChange: this.onChange,
	          onFocus: this.props.onFocus,
	          resultIdentifier: this.props.resultIdentifier,
	          options: this.props.options,
	          value: this.getEditorDisplayValue() })
	      );
	    }
	  }]);
	
	  return AutoCompleteEditor;
	}(_react2.default.Component);
	
	exports.default = AutoCompleteEditor;
	
	
	AutoCompleteEditor.propTypes = {
	  onCommit: _propTypes2.default.func,
	  getOptions: _propTypes2.default.func,
	  rowData: _propTypes2.default.any,
	  label: _propTypes2.default.any,
	  value: _propTypes2.default.any,
	  height: _propTypes2.default.number,
	  valueParams: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  column: _propTypes2.default.shape(_reactDataGrid.ExcelColumn),
	  resultIdentifier: _propTypes2.default.string,
	  search: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  editorDisplayValue: _propTypes2.default.func
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactRouter = __webpack_require__(10);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(391);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function findWithToken(token, list) {
	  return list.find(function (item) {
	    return item.token === token;
	  });
	}
	
	var Orders = function (_React$Component) {
	  _inherits(Orders, _React$Component);
	
	  function Orders(props) {
	    _classCallCheck(this, Orders);
	
	    var _this = _possibleConstructorReturn(this, (Orders.__proto__ || Object.getPrototypeOf(Orders)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = Object.assign({
	      orders: null,
	      error: null,
	      retailerFilter: null,
	      brandFilter: null
	    }, _Api2.default.cache.getOrderList() || {});
	    return _this;
	  }
	
	  _createClass(Orders, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.state.orders) {
	        this.loadOrders();
	      }
	    }
	  }, {
	    key: 'loadOrders',
	    value: function loadOrders() {
	      var _this2 = this;
	
	      _Api2.default.getOrders().then(function (orders) {
	        _this2.setState(orders);
	      }).catch(function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var payload = {};
	      payload[event.target.name] = event.target.value;
	      this.setState(payload);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.state.error) {
	        console.error(this.state.error);
	        return _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          'Error: ',
	          this.state.error.message
	        );
	      }
	
	      var orders = void 0;
	      if (!this.state.orders) {
	        orders = _react2.default.createElement(_reactFontawesome2.default, { name: 'refresh', spin: true });
	      } else {
	        var orderList = this.state.orders;
	
	        // Filter retailer
	        if (this.state.retailerFilter) {
	          orderList = orderList.filter(function (order) {
	            return order.retailer_token === _this3.state.retailerFilter;
	          });
	        }
	
	        // Filter brand
	        if (this.state.brandFilter) {
	          orderList = orderList.filter(function (order) {
	            var i = void 0;
	            for (i = 0; i < order.items.length; i++) {
	              if (order.items[i].brand_token === _this3.state.brandFilter) return true;
	            }
	
	            return false;
	          });
	        }
	
	        orders = orderList.map(function (order) {
	          return _react2.default.createElement(OrderItem, { key: order.token, order: order, retailers: _this3.state.retailers, users: _this3.state.users, loadOrders: _this3.loadOrders });
	        });
	      }
	
	      var retailerFilter = null;
	      if (this.state.retailers) {
	        (function () {
	          var retailerOptions = [_react2.default.createElement(
	            'option',
	            { key: 'retailerfilter-option-none', value: '' },
	            '-'
	          )];
	
	          _this3.state.retailers.sort(function (a, b) {
	            return a.name.localeCompare(b.name);
	          }).forEach(function (retailer) {
	            retailerOptions.push(_react2.default.createElement(
	              'option',
	              { key: 'retailerfilter-option-' + retailer.token, value: retailer.token },
	              retailer.name
	            ));
	          });
	          retailerFilter = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Retailer'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'select',
	              { name: 'retailerFilter', onChange: _this3.onChange },
	              retailerOptions
	            )
	          );
	        })();
	      }
	
	      var brandFilter = null;
	      if (this.state.brands) {
	        (function () {
	          var brandOptions = [_react2.default.createElement(
	            'option',
	            { key: 'brandfilter-option-none', value: '' },
	            '-'
	          )];
	
	          var brandList = Object.keys(_this3.state.brands).map(function (brand_key) {
	            return _this3.state.brands[brand_key];
	          });
	
	          brandList.sort(function (a, b) {
	            return a.name.localeCompare(b.name);
	          }).forEach(function (brand) {
	            brandOptions.push(_react2.default.createElement(
	              'option',
	              { key: 'brandFilter-option-' + brand.token, value: brand.token },
	              brand.name
	            ));
	          });
	          brandFilter = _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Brand'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'select',
	              { name: 'brandFilter', onChange: _this3.onChange },
	              brandOptions
	            )
	          );
	        })();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'order-list' },
	        _react2.default.createElement(_AdminTitle2.default, { title: 'Placed Orders' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'order-filter' },
	          retailerFilter,
	          brandFilter
	        ),
	        orders
	      );
	    }
	  }]);
	
	  return Orders;
	}(_react2.default.Component);
	
	exports.default = Orders;
	
	var OrderItem = exports.OrderItem = function (_React$Component2) {
	  _inherits(OrderItem, _React$Component2);
	
	  function OrderItem(props) {
	    _classCallCheck(this, OrderItem);
	
	    var _this4 = _possibleConstructorReturn(this, (OrderItem.__proto__ || Object.getPrototypeOf(OrderItem)).call(this, props));
	
	    _this4.onCancelOrder = _this4.onCancelOrder.bind(_this4);
	    _this4.getCancelOrderSpan = _this4.getCancelOrderSpan.bind(_this4);
	    return _this4;
	  }
	
	  _createClass(OrderItem, [{
	    key: 'onCancelOrder',
	    value: function onCancelOrder() {
	      var _this5 = this;
	
	      var orderAmount = parseFloat(this.props.order.total_amount_cents / 100);
	      var retailer = findWithToken(this.props.order.retailer_token, this.props.retailers) || {};
	
	      var choice = confirm("Are you sure you want to CANCEL the $" + orderAmount + " order for " + retailer.name + "?");
	      if (choice === true) {
	        _Api2.default.cancelOrder(this.props.order.token).then(function () {
	          return _this5.props.loadOrders();
	        }, function (error) {
	          alert('Error canceling order: ' + error.message);
	        });
	      }
	    }
	  }, {
	    key: 'getCancelOrderSpan',
	    value: function getCancelOrderSpan() {
	      if (this.props.order.state === 'CANCELED' || this.props.order.state === 'FAILED') return _react2.default.createElement('span', { className: 'cancel' });
	
	      for (var i = 0; i < this.props.order.items.length; i++) {
	        var item = this.props.order.items[i];
	        if (item.state !== 'WAITING_ON_ORDER' && item.state !== 'CANCELED') return _react2.default.createElement('span', { className: 'cancel' });
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'cancel', onClick: this.onCancelOrder },
	        _react2.default.createElement(_reactFontawesome2.default, { name: 'remove' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var order = this.props.order;
	      if (!order) return null;
	
	      var retailer = findWithToken(order.retailer_token, this.props.retailers) || {};
	      var user = findWithToken(order.user_token, this.props.users) || {};
	      var cancelOrder = this.getCancelOrderSpan();
	      var orderTotalCents = order.items_amount_cents;
	      if (order.shipping_amount_cents) orderTotalCents += order.shipping_amount_cents;
	      if (order.total_amount_cents) orderTotalCents += order.total_amount_cents;
	
	      var orderDate = (0, _moment2.default)(order.created_at);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'order-list-entry' },
	        _react2.default.createElement(
	          'span',
	          { className: 'retailer' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/admin/orders/' + order.token },
	            retailer.name
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'user' },
	          user.name
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'itemcount' },
	          order.items.length,
	          ' items'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'orderdate' },
	          orderDate.format('MMM Do YY')
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'state' },
	          order.state
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'price' },
	          '$',
	          parseFloat(orderTotalCents / 100).toFixed(2)
	        ),
	        cancelOrder
	      );
	    }
	  }]);
	
	  return OrderItem;
	}(_react2.default.Component);

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddressDisplay = function AddressDisplay(_ref) {
	  var address = _ref.address;
	  return _react2.default.createElement(
	    "div",
	    { className: "address-display" },
	    _react2.default.createElement(
	      "div",
	      null,
	      address.name
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      address.address1
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      address.city,
	      ", ",
	      address.state,
	      " ",
	      address.postal_code
	    )
	  );
	};
	
	exports.default = AddressDisplay;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditAddressForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditAddress = function (_React$Component) {
	  _inherits(EditAddress, _React$Component);
	
	  function EditAddress(props) {
	    _classCallCheck(this, EditAddress);
	
	    var _this = _possibleConstructorReturn(this, (EditAddress.__proto__ || Object.getPrototypeOf(EditAddress)).call(this, props));
	
	    _this.save = _this.save.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	
	    var address = props.address || {};
	
	    _this.state = {
	      'name': address.name || '',
	      'address1': address.address1 || '',
	      'address2': address.address2 || '',
	      'city': address.city || '',
	      'state': address.state || '',
	      'postal_code': address.postal_code || '',
	      'instructions': address.instructions || ''
	    };
	    return _this;
	  }
	
	  _createClass(EditAddress, [{
	    key: 'save',
	    value: function save() {
	      return this.props.save(this.state);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancelDiv = this.props.cancel ? _react2.default.createElement(
	        'div',
	        { className: 'col-50' },
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'white', onClick: this.props.cancel },
	          'Cancel'
	        )
	      ) : null;
	
	      var errorMessage = null;
	      if (this.props.errorMessage) {
	        errorMessage = _react2.default.createElement(
	          'div',
	          { className: 'error-message' },
	          this.props.errorMessage
	        );
	      }
	
	      var buttonRow = null;
	      var saveButton = _react2.default.createElement(
	        _Button2.default,
	        { className: 'full-width', onClick: this.save },
	        this.props.buttonText || 'Save'
	      );
	      if (cancelDiv) {
	        buttonRow = _react2.default.createElement(
	          'div',
	          { className: 'row button-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-50' },
	            saveButton
	          ),
	          cancelDiv
	        );
	      } else {
	        buttonRow = _react2.default.createElement(
	          'div',
	          { className: 'row button-row' },
	          saveButton
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'edit-address' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Where should we send it?'
	        ),
	        _react2.default.createElement(EditAddressForm, { address: this.state, onChange: this.onChange }),
	        errorMessage,
	        buttonRow
	      );
	    }
	  }]);
	
	  return EditAddress;
	}(_react2.default.Component);
	
	EditAddress.propTypes = {
	  save: _propTypes2.default.func.isRequired,
	  cancel: _propTypes2.default.func,
	  address: _propTypes2.default.object,
	  errorMessage: _propTypes2.default.string,
	  buttonText: _propTypes2.default.string
	};
	exports.default = EditAddress;
	
	
	var EditAddressForm = function EditAddressForm(_ref) {
	  var address = _ref.address,
	      onChange = _ref.onChange;
	  return _react2.default.createElement(
	    'div',
	    { className: 'edit-address-form' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'input input-recipient' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'name' },
	          'Recipient'
	        ),
	        _react2.default.createElement('input', { className: 'input', type: 'text', name: 'name', onChange: onChange, value: address.name })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'input input-address1' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Address Line 1'
	        ),
	        _react2.default.createElement('input', { className: 'input', type: 'text', name: 'address1', onChange: onChange, value: address.address1 })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'input' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Address Line 2'
	        ),
	        _react2.default.createElement('input', { className: 'input', type: 'text', name: 'address2', onChange: onChange, value: address.address2 })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'input col-33 input-city' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'City'
	        ),
	        _react2.default.createElement('input', { className: 'input', type: 'text', name: 'city', onChange: onChange, value: address.city })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'input col-33 input-state' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'State'
	        ),
	        _react2.default.createElement('input', { className: 'input', type: 'text', name: 'state', onChange: onChange, value: address.state })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'input col-33 input-zip' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'POSTAL CODE'
	        ),
	        _react2.default.createElement('input', { className: 'input', type: 'text', name: 'postal_code', onChange: onChange, value: address.postal_code })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'input' },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Instructions'
	        ),
	        _react2.default.createElement('input', { className: 'input', type: 'text', name: 'instructions', onChange: onChange, value: address.instructions })
	      )
	    )
	  );
	};
	
	exports.EditAddressForm = EditAddressForm;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StringUtils = __webpack_require__(50);
	
	var _creditCard = __webpack_require__(433);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _bank = __webpack_require__(431);
	
	var _bank2 = _interopRequireDefault(_bank);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentDisplay = function PaymentDisplay(_ref) {
	  var payment = _ref.payment;
	
	  if (!payment) return _react2.default.createElement(
	    'div',
	    { className: 'payment-display' },
	    'No payment information'
	  );
	  if (payment.card) {
	    var type = payment.card.type;
	    var typeIcon = null;
	    switch (type) {
	      case 'CREDIT_CARD':
	      case 'PREPAID_CARD':
	      case 'DEBIT_CARD':
	        typeIcon = _react2.default.createElement('img', { src: _creditCard2.default, role: 'presentation' });
	        type = 'Credit Card';
	        break;
	      default:
	        break;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'payment-display' },
	      _react2.default.createElement(
	        'div',
	        { className: 'type-line' },
	        typeIcon,
	        _react2.default.createElement(
	          'span',
	          null,
	          type
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        (0, _StringUtils.capitalizeEveryWord)(payment.card.brand.replace(/_/g, '')),
	        ' **** **** **** ',
	        payment.card.last_four
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'Exp: ',
	        payment.card.expiration.month,
	        '/',
	        payment.card.expiration.year
	      )
	    );
	  }
	
	  if (payment.bank_account) {
	    var _typeIcon = _react2.default.createElement('img', { src: _bank2.default, role: 'presentation' });
	    return _react2.default.createElement(
	      'div',
	      { className: 'payment-display' },
	      _react2.default.createElement(
	        'div',
	        { className: 'type-line' },
	        _typeIcon,
	        _react2.default.createElement(
	          'span',
	          null,
	          payment.bank_account.name
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement('div', null);
	};
	
	exports.default = PaymentDisplay;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountMenu = function (_React$Component) {
	  _inherits(AccountMenu, _React$Component);
	
	  function AccountMenu() {
	    _classCallCheck(this, AccountMenu);
	
	    return _possibleConstructorReturn(this, (AccountMenu.__proto__ || Object.getPrototypeOf(AccountMenu)).apply(this, arguments));
	  }
	
	  _createClass(AccountMenu, [{
	    key: 'render',
	    value: function render() {
	      var classNameArray = ['account-menu'];
	      if (this.props.className) classNameArray.push(this.props.className);
	
	      return _react2.default.createElement(
	        'ul',
	        { className: classNameArray.join(' ') },
	        this.props.children
	      );
	    }
	  }]);
	
	  return AccountMenu;
	}(_react2.default.Component);
	
	AccountMenu.propTypes = {
	  className: _propTypes2.default.string
	};
	exports.default = AccountMenu;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.FieldKit = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	},{}],2:[function(_dereq_,module,exports){
	(function (process){
	(function (global, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define('InputSim', ['exports'], factory);
	  } else if (typeof exports !== 'undefined') {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.InputSim = mod.exports;
	  }
	})(this, function (exports) {
	  /*! jshint esnext:true, undef:true, unused:true */
	
	  /** @private */
	  'use strict';
	
	  Object.defineProperty(exports, '__esModule', {
	    value: true
	  });
	
	  var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	  var A = 65;
	  /** @private */
	  var Y = 89;
	  /** @private */
	  var Z = 90;
	  /** @private */
	  var ZERO = 48;
	  /** @private */
	  var NINE = 57;
	  /** @private */
	  var LEFT = 37;
	  /** @private */
	  var RIGHT = 39;
	  /** @private */
	  var UP = 38;
	  /** @private */
	  var DOWN = 40;
	  /** @private */
	  var BACKSPACE = 8;
	  /** @private */
	  var DELETE = 46;
	  /** @private */
	  var TAB = 9;
	  /** @private */
	  var ENTER = 13;
	
	  /**
	   * @namespace KEYS
	   */
	  var KEYS = {
	    A: A,
	    Y: Y,
	    Z: Z,
	    ZERO: ZERO,
	    NINE: NINE,
	    LEFT: LEFT,
	    RIGHT: RIGHT,
	    UP: UP,
	    DOWN: DOWN,
	    BACKSPACE: BACKSPACE,
	    DELETE: DELETE,
	    TAB: TAB,
	    ENTER: ENTER,
	
	    /**
	     * @param {number} keyCode
	     * @returns {boolean}
	     */
	    isDigit: function isDigit(keyCode) {
	      return ZERO <= keyCode && keyCode <= NINE;
	    },
	
	    /**
	     * Is an arrow keyCode.
	     *
	     * @param {number} keyCode
	     * @returns {boolean}
	     */
	    isDirectional: function isDirectional(keyCode) {
	      return keyCode === LEFT || keyCode === RIGHT || keyCode === UP || keyCode === DOWN;
	    }
	  };
	
	  var CTRL = 1 << 0;
	  var META = 1 << 1;
	  var ALT = 1 << 2;
	  var SHIFT = 1 << 3;
	
	  var cache = {};
	
	  /**
	   * Builds a BindingSet based on the current platform.
	   *
	   * @param {string} platform A string name of a platform (e.g. "OSX").
	   * @returns {BindingSet} keybindings appropriate for the given platform.
	   */
	  function keyBindingsForPlatform(platform) {
	    var osx = platform === 'OSX';
	    var ctrl = osx ? META : CTRL;
	
	    if (!cache[platform]) {
	      cache[platform] = build(function (bind) {
	        bind(A, ctrl, 'selectAll');
	        bind(LEFT, null, 'moveLeft');
	        bind(LEFT, ALT, 'moveWordLeft');
	        bind(LEFT, SHIFT, 'moveLeftAndModifySelection');
	        bind(LEFT, ALT | SHIFT, 'moveWordLeftAndModifySelection');
	        bind(RIGHT, null, 'moveRight');
	        bind(RIGHT, ALT, 'moveWordRight');
	        bind(RIGHT, SHIFT, 'moveRightAndModifySelection');
	        bind(RIGHT, ALT | SHIFT, 'moveWordRightAndModifySelection');
	        bind(UP, null, 'moveUp');
	        bind(UP, ALT, 'moveToBeginningOfParagraph');
	        bind(UP, SHIFT, 'moveUpAndModifySelection');
	        bind(UP, ALT | SHIFT, 'moveParagraphBackwardAndModifySelection');
	        bind(DOWN, null, 'moveDown');
	        bind(DOWN, ALT, 'moveToEndOfParagraph');
	        bind(DOWN, SHIFT, 'moveDownAndModifySelection');
	        bind(DOWN, ALT | SHIFT, 'moveParagraphForwardAndModifySelection');
	        bind(BACKSPACE, null, 'deleteBackward');
	        bind(BACKSPACE, SHIFT, 'deleteBackward');
	        bind(BACKSPACE, ALT, 'deleteWordBackward');
	        bind(BACKSPACE, ALT | SHIFT, 'deleteWordBackward');
	        bind(BACKSPACE, ctrl, 'deleteBackwardToBeginningOfLine');
	        bind(BACKSPACE, ctrl | SHIFT, 'deleteBackwardToBeginningOfLine');
	        bind(DELETE, null, 'deleteForward');
	        bind(DELETE, ALT, 'deleteWordForward');
	        bind(TAB, null, 'insertTab');
	        bind(TAB, SHIFT, 'insertBackTab');
	        bind(ENTER, null, 'insertNewline');
	        bind(Z, ctrl, 'undo');
	
	        if (osx) {
	          bind(LEFT, META, 'moveToBeginningOfLine');
	          bind(LEFT, META | SHIFT, 'moveToBeginningOfLineAndModifySelection');
	          bind(RIGHT, META, 'moveToEndOfLine');
	          bind(RIGHT, META | SHIFT, 'moveToEndOfLineAndModifySelection');
	          bind(UP, META, 'moveToBeginningOfDocument');
	          bind(UP, META | SHIFT, 'moveToBeginningOfDocumentAndModifySelection');
	          bind(DOWN, META, 'moveToEndOfDocument');
	          bind(DOWN, META | SHIFT, 'moveToEndOfDocumentAndModifySelection');
	          bind(BACKSPACE, CTRL, 'deleteBackwardByDecomposingPreviousCharacter');
	          bind(BACKSPACE, CTRL | SHIFT, 'deleteBackwardByDecomposingPreviousCharacter');
	          bind(Z, META | SHIFT, 'redo');
	        } else {
	          bind(Y, CTRL, 'redo');
	        }
	      });
	    }
	
	    return cache[platform];
	  }
	
	  function build(callback) {
	    var result = new BindingSet();
	    callback(function () {
	      return result.bind.apply(result, arguments);
	    });
	    return result;
	  }
	
	  /**
	   * @private
	   */
	
	  var BindingSet = (function () {
	    function BindingSet() {
	      _classCallCheck(this, BindingSet);
	
	      this.bindings = {};
	    }
	
	    /**
	     * Enum for text direction affinity.
	     *
	     * @const
	     * @enum {number}
	     * @private
	     */
	
	    /**
	     * @param {number} keyCode
	     * @param {number} modifiers
	     * @param {string} action
	     */
	
	    _createClass(BindingSet, [{
	      key: 'bind',
	      value: function bind(keyCode, modifiers, action) {
	        if (!this.bindings[keyCode]) {
	          this.bindings[keyCode] = {};
	        }
	        this.bindings[keyCode][modifiers || 0] = action;
	      }
	
	      /**
	       * @param {Event} event
	       * @returns {?string}
	       */
	    }, {
	      key: 'actionForEvent',
	      value: function actionForEvent(event) {
	        var bindingsForKeyCode = this.bindings[event.keyCode];
	        if (bindingsForKeyCode) {
	          var modifiers = 0;
	          if (event.altKey) {
	            modifiers |= ALT;
	          }
	          if (event.ctrlKey) {
	            modifiers |= CTRL;
	          }
	          if (event.metaKey) {
	            modifiers |= META;
	          }
	          if (event.shiftKey) {
	            modifiers |= SHIFT;
	          }
	          return bindingsForKeyCode[modifiers];
	        }
	      }
	    }]);
	
	    return BindingSet;
	  })();
	
	  var Affinity = {
	    UPSTREAM: 0,
	    DOWNSTREAM: 1,
	    NONE: null
	  };
	
	  /**
	   * Tests is string passed in is a single word.
	   *
	   * @param {string} chr
	   * @returns {boolean}
	   * @private
	   */
	  function isWordChar(chr) {
	    return chr && /^\w$/.test(chr);
	  }
	
	  /**
	   * Checks if char to the left of {index} in {string}
	   * is a break (non-char).
	   *
	   * @param {string} text
	   * @param {number} index
	   * @returns {boolean}
	   * @private
	   */
	  function hasLeftWordBreakAtIndex(text, index) {
	    if (index === 0) {
	      return true;
	    } else {
	      return !isWordChar(text[index - 1]) && isWordChar(text[index]);
	    }
	  }
	
	  /**
	   * Checks if char to the right of {index} in {string}
	   * is a break (non-char).
	   *
	   * @param {string} text
	   * @param {number} index
	   * @returns {boolean}
	   * @private
	   */
	  function hasRightWordBreakAtIndex(text, index) {
	    if (index === text.length - 1) {
	      return true;
	    } else {
	      return isWordChar(text[index]) && !isWordChar(text[index + 1]);
	    }
	  }
	
	  var Input = (function () {
	    /**
	      * Sets up the initial properties of the TextField and
	      * sets  up the event listeners
	      *
	      * @param {string} value
	      * @param {Object} range ({start: 0, length: 0})
	      */
	
	    function Input(value, range) {
	      _classCallCheck(this, Input);
	
	      this._value = '';
	      this._selectedRange = {
	        start: 0,
	        length: 0
	      };
	      this.shouldCancelEvents = true;
	      this.selectionAffinity = Affinity.NONE;
	
	      if (value) {
	        this.setText(value);
	      }
	      if (range) {
	        this.setSelectedRange(range);
	      }
	      this._buildKeybindings();
	    }
	
	    /**
	     * Clears all characters in the existing selection.
	     *
	     * @example
	     *     // 12|34567|8
	     *     clearSelection();
	     *     // 12|8
	     *
	     */
	
	    _createClass(Input, [{
	      key: 'clearSelection',
	      value: function clearSelection() {
	        this.replaceSelection('');
	      }
	
	      /**
	       * Deletes backward one character or clears a non-empty selection.
	       *
	       * @example
	       *
	       *     // |What's up, doc?
	       *     deleteBackward(event);
	       *     // |What's up, doc?
	       *
	       *     // What'|s up, doc?
	       *     deleteBackward(event);
	       *     // What|s up, doc?
	       *
	       *     // |What's| up, doc?
	       *     deleteBackward(event);
	       *     // | up, doc?
	       */
	    }, {
	      key: 'deleteBackward',
	      value: function deleteBackward(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        if (range.length === 0) {
	          range.start--;
	          range.length++;
	          this.setSelectedRange(range);
	        }
	        this.clearSelection();
	      }
	
	      /**
	       * Deletes backward one word or clears a non-empty selection.
	       *
	       * @example
	       *     // |What's up, doc?
	       *     deleteWordBackward(event);
	       *     // |What's up, doc?
	       *
	       *     // What'|s up, doc?
	       *     deleteWordBackward(event);
	       *     // |s up, doc?
	       *
	       *     // |What's| up, doc?
	       *     deleteWordBackward(event);
	       *     // | up, doc?
	       */
	    }, {
	      key: 'deleteWordBackward',
	      value: function deleteWordBackward(event) {
	        if (this.hasSelection()) {
	          this.deleteBackward(event);
	        } else {
	          this._handleEvent(event);
	          var range = this.selectedRange();
	          var start = this._lastWordBreakBeforeIndex(range.start);
	          range.length += range.start - start;
	          range.start = start;
	          this.setSelectedRange(range);
	          this.clearSelection();
	        }
	      }
	
	      /**
	       * Deletes backward one character, clears a non-empty selection, or decomposes
	       * an accented character to its simple form.
	       *
	       * @TODO Make this work as described.
	       *
	       * @example
	       *     // |fiancée
	       *     deleteBackwardByDecomposingPreviousCharacter(event);
	       *     // |What's up, doc?
	       *
	       *     // fianc|é|e
	       *     deleteBackwardByDecomposingPreviousCharacter(event);
	       *     // fianc|e
	       *
	       *     // fiancé|e
	       *     deleteBackwardByDecomposingPreviousCharacter(event);
	       *     // fiance|e
	       *
	       */
	    }, {
	      key: 'deleteBackwardByDecomposingPreviousCharacter',
	      value: function deleteBackwardByDecomposingPreviousCharacter(event) {
	        this.deleteBackward(event);
	      }
	
	      /**
	       * Deletes all characters before the cursor or clears a non-empty selection.
	       *
	       * @example
	       *     // The quick |brown fox.
	       *     deleteBackwardToBeginningOfLine(event);
	       *     // |brown fox.
	       *
	       *     // The |quick |brown fox.
	       *     deleteBackwardToBeginningOfLine(event);
	       *     // The brown fox.
	       *
	       */
	    }, {
	      key: 'deleteBackwardToBeginningOfLine',
	      value: function deleteBackwardToBeginningOfLine(event) {
	        if (this.hasSelection()) {
	          this.deleteBackward(event);
	        } else {
	          this._handleEvent(event);
	          var range = this.selectedRange();
	          range.length = range.start;
	          range.start = 0;
	          this.setSelectedRange(range);
	          this.clearSelection();
	        }
	      }
	
	      /**
	       * Deletes forward one character or clears a non-empty selection.
	       *
	       * @example
	       *     // What's up, doc?|
	       *     deleteForward(event);
	       *     // What's up, doc?|
	       *
	       *     // What'|s up, doc?
	       *     deleteForward(event);
	       *     // What'| up, doc?
	       *
	       *     // |What's| up, doc?
	       *     deleteForward(event);
	       *     // | up, doc?
	       *
	       */
	    }, {
	      key: 'deleteForward',
	      value: function deleteForward(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        if (range.length === 0) {
	          range.length++;
	          this.setSelectedRange(range);
	        }
	        this.clearSelection();
	      }
	
	      /**
	       * Deletes forward one word or clears a non-empty selection.
	       *
	       * @example
	       *     // What's up, doc?|
	       *     deleteWordForward(event);
	       *     // What's up, doc?|
	       *
	       *     // What's |up, doc?
	       *     deleteWordForward(event);
	       *     // What's |, doc?
	       *
	       *     // |What's| up, doc?
	       *     deleteWordForward(event);
	       *     // | up, doc?
	       */
	    }, {
	      key: 'deleteWordForward',
	      value: function deleteWordForward(event) {
	        if (this.hasSelection()) {
	          return this.deleteForward(event);
	        } else {
	          this._handleEvent(event);
	          var range = this.selectedRange();
	          var end = this._nextWordBreakAfterIndex(range.start + range.length);
	          this.setSelectedRange({
	            start: range.start,
	            length: end - range.start
	          });
	          this.clearSelection();
	        }
	      }
	    }, {
	      key: 'handleEvent',
	      value: function handleEvent(event) {
	        if (typeof event === 'undefined') {
	          throw new Error('cannot handle and event that isn\'t passed');
	        }
	        var action = this._bindings.actionForEvent(event);
	        if (action) this[action](event);
	        return action;
	      }
	
	      /**
	       * Determines whether this field has any selection.
	       *
	       * @returns {boolean} true if there is at least one character selected
	       */
	    }, {
	      key: 'hasSelection',
	      value: function hasSelection() {
	        return this.selectedRange().length !== 0;
	      }
	
	      /**
	       * Handles the back tab key.
	       *
	       */
	    }, {
	      key: 'insertBackTab',
	      value: function insertBackTab() {}
	
	      /**
	       * Handles a key event could be trying to end editing.
	       *
	       */
	    }, {
	      key: 'insertNewline',
	      value: function insertNewline() {}
	
	      /**
	       * Handles the tab key.
	       *
	       */
	    }, {
	      key: 'insertTab',
	      value: function insertTab() {}
	
	      /**
	       * Handles a event that is trying to insert a character.
	       *
	       * @param {string} text
	       */
	    }, {
	      key: 'insertText',
	      value: function insertText(text) {
	        var range;
	        if (this.hasSelection()) {
	          this.clearSelection();
	        }
	
	        this.replaceSelection(text);
	        range = this.selectedRange();
	        range.start += range.length;
	        range.length = 0;
	        this.setSelectedRange(range);
	      }
	
	      /**
	       * Moves the cursor up, which because this is a single-line text field, means
	       * moving to the beginning of the value.
	       *
	       * @example
	       *     // Hey guys|
	       *     moveUp(event);
	       *     // |Hey guys
	       *
	       *     // Hey |guys|
	       *     moveUp(event);
	       *     // |Hey guys
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveUp',
	      value: function moveUp(event) {
	        this._handleEvent(event);
	        this.setSelectedRange({
	          start: 0,
	          length: 0
	        });
	      }
	
	      /**
	       * Moves the cursor up to the beginning of the current paragraph, which because
	       * this is a single-line text field, means moving to the beginning of the
	       * value.
	       *
	       * @example
	       *     // Hey guys|
	       *     moveToBeginningOfParagraph(event)
	       *     // |Hey guys
	       *
	       *     // Hey |guys|
	       *     moveToBeginningOfParagraph(event)
	       *     // |Hey guys
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToBeginningOfParagraph',
	      value: function moveToBeginningOfParagraph(event) {
	        this.moveUp(event);
	      }
	
	      /**
	       * Moves the cursor up, keeping the current anchor point and extending the
	       * selection to the beginning as moveUp would.
	       *
	       * @example
	       *     // rightward selections are shrunk
	       *     // Hey guys, |where> are you?
	       *     moveUpAndModifySelection(event);
	       *     // <Hey guys, |where are you?
	       *
	       *     // leftward selections are extended
	       *     // Hey guys, <where| are you?
	       *     moveUpAndModifySelection(event);
	       *     // <Hey guys, where| are you?
	       *
	       *     // neutral selections are extended
	       *     // Hey guys, |where| are you?
	       *     moveUpAndModifySelection(event);
	       *     // <Hey guys, where| are you?
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveUpAndModifySelection',
	      value: function moveUpAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        switch (this.selectionAffinity) {
	          case Affinity.UPSTREAM:
	          case Affinity.NONE:
	            // 12<34 56|78  =>  <1234 56|78
	            range.length += range.start;
	            range.start = 0;
	            break;
	          case Affinity.DOWNSTREAM:
	            // 12|34 56>78   =>   <12|34 5678
	            range.length = range.start;
	            range.start = 0;
	            break;
	        }
	        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
	      }
	
	      /**
	       * Moves the free end of the selection to the beginning of the paragraph, or
	       * since this is a single-line text field to the beginning of the line.
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveParagraphBackwardAndModifySelection',
	      value: function moveParagraphBackwardAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        switch (this.selectionAffinity) {
	          case Affinity.UPSTREAM:
	          case Affinity.NONE:
	            // 12<34 56|78  =>  <1234 56|78
	            range.length += range.start;
	            range.start = 0;
	            break;
	          case Affinity.DOWNSTREAM:
	            // 12|34 56>78  =>  12|34 5678
	            range.length = 0;
	            break;
	        }
	        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
	      }
	
	      /**
	       * Moves the cursor to the beginning of the document.
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToBeginningOfDocument',
	      value: function moveToBeginningOfDocument(event) {
	        // Since we only support a single line this is just an alias.
	        this.moveToBeginningOfLine(event);
	      }
	
	      /**
	       * Moves the selection start to the beginning of the document.
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToBeginningOfDocumentAndModifySelection',
	      value: function moveToBeginningOfDocumentAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        range.length += range.start;
	        range.start = 0;
	        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
	      }
	
	      /**
	       * Moves the cursor down, which because this is a single-line text field, means
	       * moving to the end of the value.
	       *
	       * @example
	       *     // Hey |guys
	       *     moveDown(event)
	       *     // Hey guys|
	       *
	       *     // |Hey| guys
	       *     moveDown(event)
	       *     // Hey guys|
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveDown',
	      value: function moveDown(event) {
	        this._handleEvent(event);
	        // 12|34 56|78  =>  1234 5678|
	        var range = {
	          start: this.text().length,
	          length: 0
	        };
	        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
	      }
	
	      /**
	       * Moves the cursor up to the end of the current paragraph, which because this
	       * is a single-line text field, means moving to the end of the value.
	       *
	       * @example
	       *     // |Hey guys
	       *     moveToEndOfParagraph(event)
	       *     // Hey guys|
	       *
	       *     // Hey |guys|
	       *     moveToEndOfParagraph(event)
	       *     // Hey guys|
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToEndOfParagraph',
	      value: function moveToEndOfParagraph(event) {
	        this.moveDown(event);
	      }
	
	      /**
	       * Moves the cursor down, keeping the current anchor point and extending the
	       * selection to the end as moveDown would.
	       *
	       * @example
	       *     // leftward selections are shrunk
	       *     // Hey guys, <where| are you?
	       *     moveDownAndModifySelection(event)
	       *     // Hey guys, where| are you?>
	       *
	       *     // rightward selections are extended
	       *     // Hey guys, |where> are you?
	       *     moveDownAndModifySelection(event)
	       *     // Hey guys, |where are you?>
	       *
	       *     // neutral selections are extended
	       *     // Hey guys, |where| are you?
	       *     moveDownAndModifySelection(event)
	       *     // Hey guys, |where are you?>
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveDownAndModifySelection',
	      value: function moveDownAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        var end = this.text().length;
	        if (this.selectionAffinity === Affinity.UPSTREAM) {
	          range.start += range.length;
	        }
	        range.length = end - range.start;
	        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
	      }
	
	      /**
	       * Moves the free end of the selection to the end of the paragraph, or since
	       * this is a single-line text field to the end of the line.
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveParagraphForwardAndModifySelection',
	      value: function moveParagraphForwardAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        switch (this.selectionAffinity) {
	          case Affinity.DOWNSTREAM:
	          case Affinity.NONE:
	            // 12|34 56>78  =>  12|34 5678>
	            range.length = this.text().length - range.start;
	            break;
	          case Affinity.UPSTREAM:
	            // 12<34 56|78  =>  12|34 5678
	            range.start += range.length;
	            range.length = 0;
	            break;
	        }
	        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
	      }
	
	      /**
	       * Moves the cursor to the end of the document.
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToEndOfDocument',
	      value: function moveToEndOfDocument(event) {
	        // Since we only support a single line this is just an alias.
	        this.moveToEndOfLine(event);
	      }
	
	      /**
	       * Moves the selection end to the end of the document.
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToEndOfDocumentAndModifySelection',
	      value: function moveToEndOfDocumentAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        range.length = this.text().length - range.start;
	        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
	      }
	
	      /**
	       * Moves the cursor to the left, counting selections as a thing to move past.
	       *
	       * @example
	       *     // no selection just moves the cursor left
	       *     // Hey guys|
	       *     moveLeft(event)
	       *     // Hey guy|s
	       *
	       *     // selections are removed
	       *     // Hey |guys|
	       *     moveLeft(event)
	       *     // Hey |guys
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveLeft',
	      value: function moveLeft(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        if (range.length !== 0) {
	          range.length = 0;
	        } else {
	          range.start--;
	        }
	        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
	      }
	
	      /**
	       * Moves the free end of the selection one to the left.
	       *
	       * @example
	       *     // no selection just selects to the left
	       *     // Hey guys|
	       *     moveLeftAndModifySelection(event)
	       *     // Hey guy<s|
	       *
	       *     // left selections are extended
	       *     // Hey <guys|
	       *     moveLeftAndModifySelection(event)
	       *     // Hey< guys|
	       *
	       *     // right selections are shrunk
	       *     // Hey |guys>
	       *     moveLeftAndModifySelection(event)
	       *     // Hey |guy>s
	       *
	       *     // neutral selections are extended
	       *     // Hey |guys|
	       *     moveLeftAndModifySelection(event)
	       *     //Hey< guys|
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveLeftAndModifySelection',
	      value: function moveLeftAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        switch (this.selectionAffinity) {
	          case Affinity.UPSTREAM:
	          case Affinity.NONE:
	            this.selectionAffinity = Affinity.UPSTREAM;
	            range.start--;
	            range.length++;
	            break;
	          case Affinity.DOWNSTREAM:
	            range.length--;
	            break;
	        }
	        this.setSelectedRange(range);
	      }
	
	      /**
	       * Moves the cursor left until the start of a word is found.
	       *
	       * @example
	       *     // no selection just moves the cursor left
	       *     // Hey guys|
	       *     moveWordLeft(event)
	       *     // Hey |guys
	       *
	       *     // selections are removed
	       *     // Hey |guys|
	       *     moveWordLeft(event)
	       *     // |Hey guys
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveWordLeft',
	      value: function moveWordLeft(event) {
	        this._handleEvent(event);
	        var index = this._lastWordBreakBeforeIndex(this.selectedRange().start - 1);
	        this.setSelectedRange({ start: index, length: 0 });
	      }
	
	      /**
	       * Moves the free end of the current selection to the beginning of the previous
	       * word.
	       *
	       * @example
	       *     // no selection just selects to the left
	       *     // Hey guys|
	       *     moveWordLeftAndModifySelection(event)
	       *     // Hey <guys|
	       *
	       *     // left selections are extended
	       *     // Hey <guys|
	       *     moveWordLeftAndModifySelection(event)
	       *     // <Hey guys|
	       *
	       *     // right selections are shrunk
	       *     // |Hey guys>
	       *     moveWordLeftAndModifySelection(event)
	       *     // |Hey >guys
	       *
	       *     // neutral selections are extended
	       *     // Hey |guys|
	       *     moveWordLeftAndModifySelection(event)
	       *     // <Hey guys|
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveWordLeftAndModifySelection',
	      value: function moveWordLeftAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        switch (this.selectionAffinity) {
	          case Affinity.UPSTREAM:
	          case Affinity.NONE:
	            this.selectionAffinity = Affinity.UPSTREAM;
	            var start = this._lastWordBreakBeforeIndex(range.start - 1);
	            range.length += range.start - start;
	            range.start = start;
	            break;
	          case Affinity.DOWNSTREAM:
	            var end = this._lastWordBreakBeforeIndex(range.start + range.length);
	            if (end < range.start) {
	              end = range.start;
	            }
	            range.length -= range.start + range.length - end;
	            break;
	        }
	        this.setSelectedRange(range);
	      }
	
	      /**
	       * Moves the cursor to the beginning of the current line.
	       *
	       * @example
	       *     // Hey guys, where| are ya?
	       *     moveToBeginningOfLine(event)
	       *     // |Hey guys, where are ya?
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToBeginningOfLine',
	      value: function moveToBeginningOfLine(event) {
	        this._handleEvent(event);
	        this.setSelectedRange({ start: 0, length: 0 });
	      }
	
	      /**
	       * Select from the free end of the selection to the beginning of line.
	       *
	       * @example
	       *     // Hey guys, where| are ya?
	       *     moveToBeginningOfLineAndModifySelection(event)
	       *     // <Hey guys, where| are ya?
	       *
	       *     // Hey guys, where| are> ya?
	       *     moveToBeginningOfLineAndModifySelection(event)
	       *     // <Hey guys, where are| ya?
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToBeginningOfLineAndModifySelection',
	      value: function moveToBeginningOfLineAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        range.length += range.start;
	        range.start = 0;
	        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
	      }
	
	      /**
	       * Moves the cursor to the right, counting selections as a thing to move past.
	       *
	       * @example
	       *     // no selection just moves the cursor right
	       *     // Hey guy|s
	       *     moveRight(event)
	       *     // Hey guys|
	       *
	       *     // selections are removed
	       *     // Hey |guys|
	       *     moveRight(event)
	       *     // Hey guys|
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveRight',
	      value: function moveRight(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        if (range.length !== 0) {
	          range.start += range.length;
	          range.length = 0;
	        } else {
	          range.start++;
	        }
	        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
	      }
	
	      /**
	       * Moves the free end of the selection one to the right.
	       *
	       * @example
	       *     // no selection just selects to the right
	       *     // Hey |guys
	       *     moveRightAndModifySelection(event)
	       *     // Hey |g>uys
	       *
	       *     // right selections are extended
	       *     // Hey |gu>ys
	       *     moveRightAndModifySelection(event)
	       *     // Hey |guy>s
	       *
	       *     // left selections are shrunk
	       *     // <Hey |guys
	       *     moveRightAndModifySelection(event)
	       *     // H<ey |guys
	       *
	       *     // neutral selections are extended
	       *     // |Hey| guys
	       *     moveRightAndModifySelection(event)
	       *     // |Hey >guys
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveRightAndModifySelection',
	      value: function moveRightAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        switch (this.selectionAffinity) {
	          case Affinity.UPSTREAM:
	            range.start++;
	            range.length--;
	            break;
	          case Affinity.DOWNSTREAM:
	          case Affinity.NONE:
	            this.selectionAffinity = Affinity.DOWNSTREAM;
	            range.length++;
	            break;
	        }
	        this.setSelectedRange(range);
	      }
	
	      /**
	       * Moves the cursor right until the end of a word is found.
	       *
	       * @example
	       *     // no selection just moves the cursor right
	       *     // Hey| guys
	       *     moveWordRight(event)
	       *     // Hey guys|
	       *
	       *     // selections are removed
	       *     // |Hey| guys
	       *     moveWordRight(event)
	       *     // Hey guys|
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveWordRight',
	      value: function moveWordRight(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        var index = this._nextWordBreakAfterIndex(range.start + range.length);
	        this.setSelectedRange({ start: index, length: 0 });
	      }
	
	      /**
	       * Moves the free end of the current selection to the next end of word.
	       *
	       * @example
	       *     // no selection just selects to the right
	       *     // Hey |guys
	       *     moveWordRightAndModifySelection(event)
	       *     // Hey |guys|
	       *
	       *     // right selections are extended
	       *     // Hey |g>uys
	       *     moveWordRightAndModifySelection(event)
	       *     // Hey |guys>
	       *
	       *     // left selections are shrunk
	       *     // He<y |guys
	       *     moveWordRightAndModifySelection(event)
	       *     // Hey< |guys
	       *
	       *     // neutral selections are extended
	       *     // He|y |guys
	       *     moveWordRightAndModifySelection(event)
	       *     // He|y guys>
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveWordRightAndModifySelection',
	      value: function moveWordRightAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        var start = range.start;
	        var end = range.start + range.length;
	        switch (this.selectionAffinity) {
	          case Affinity.UPSTREAM:
	            start = Math.min(this._nextWordBreakAfterIndex(start), end);
	            break;
	          case Affinity.DOWNSTREAM:
	          case Affinity.NONE:
	            this.selectionAffinity = Affinity.DOWNSTREAM;
	            end = this._nextWordBreakAfterIndex(range.start + range.length);
	            break;
	        }
	        this.setSelectedRange({ start: start, length: end - start });
	      }
	
	      /**
	       * Moves the cursor to the end of the current line.
	       *
	       * @example
	       *     // Hey guys, where| are ya?
	       *     moveToEndOfLine(event)
	       *     // |Hey guys, where are ya?
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToEndOfLine',
	      value: function moveToEndOfLine(event) {
	        this._handleEvent(event);
	        this.setSelectedRange({ start: this.text().length, length: 0 });
	      }
	
	      /**
	       * Moves the free end of the selection to the end of the current line.
	       *
	       * @example
	       *     // Hey guys, where| are ya?
	       *     moveToEndOfLineAndModifySelection(event)
	       *     // Hey guys, where| are ya?>
	       *
	       *     // Hey guys, <where| are ya?
	       *     moveToEndOfLineAndModifySelection(event)
	       *     // Hey guys, |where are ya?>
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'moveToEndOfLineAndModifySelection',
	      value: function moveToEndOfLineAndModifySelection(event) {
	        this._handleEvent(event);
	        var range = this.selectedRange();
	        range.length = this.text().length - range.start;
	        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
	      }
	
	      /**
	       * Replaces the characters within the selection with given text.
	       *
	       * @example
	       *     // 12|34567|8
	       *     replaceSelection('00')
	       *     // 12|00|8
	       *
	       * @param {string} replacement
	       */
	    }, {
	      key: 'replaceSelection',
	      value: function replaceSelection(replacement) {
	        var range = this.selectedRange();
	        var end = range.start + range.length;
	        var text = this.text();
	        text = text.substring(0, range.start) + replacement + text.substring(end);
	        range.length = replacement.length;
	        this.setText(text);
	        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
	      }
	
	      /**
	       * Find ends of 'words' for navigational purposes.
	       *
	       * @example
	       *     // given value of '123456789' and text of '123-45-6789'
	       *     rightWordBreakIndexes()
	       *     //=> [3, 5, 9]
	       *
	       * @returns {number[]}
	       */
	    }, {
	      key: 'rightWordBreakIndexes',
	      value: function rightWordBreakIndexes() {
	        var result = [];
	        var text = this.text();
	        for (var i = 0, l = text.length; i < l; i++) {
	          if (hasRightWordBreakAtIndex(text, i)) {
	            result.push(i + 1);
	          }
	        }
	        return result;
	      }
	
	      /**
	       * Expands the selection to contain all the characters in the content.
	       *
	       * @example
	       *     // 123|45678
	       *     selectAll(event)
	       *     // |12345678|
	       *
	       * @param {Event} event
	       */
	    }, {
	      key: 'selectAll',
	      value: function selectAll(event) {
	        this._handleEvent(event);
	        this.setSelectedRangeWithAffinity({
	          start: 0,
	          length: this.text().length
	        }, Affinity.NONE);
	      }
	
	      /**
	       * Gets the object value. This is the value that should be considered the
	       * 'real' value of the field.
	       *
	       * @returns {String}
	       */
	    }, {
	      key: 'text',
	      value: function text() {
	        return this._value;
	      }
	
	      /**
	       * Sets the object value of the field.
	       *
	       * @param {string} value
	       */
	    }, {
	      key: 'setText',
	      value: function setText(value) {
	        this._value = '' + value;
	        this.setSelectedRange({
	          start: this._value.length,
	          length: 0
	        });
	      }
	
	      /**
	       * Gets the range of the current selection.
	       *
	       * @returns {Object} {start: number, length: number}
	       */
	    }, {
	      key: 'selectedRange',
	      value: function selectedRange() {
	        return this._selectedRange;
	      }
	
	      /**
	       * Sets the range of the current selection without changing the affinity.
	       * @param {Object} range ({start: 0, length: 0})
	       */
	    }, {
	      key: 'setSelectedRange',
	      value: function setSelectedRange(range) {
	        this.setSelectedRangeWithAffinity(range, this.selectionAffinity);
	      }
	
	      /**
	       * Sets the range of the current selection and the selection affinity.
	       *
	       * @param {Object} range {start: number, length: number}
	       * @param {Affinity} affinity
	       * @returns {Object} {start: 0, length: 0}
	       */
	    }, {
	      key: 'setSelectedRangeWithAffinity',
	      value: function setSelectedRangeWithAffinity(range, affinity) {
	        var min = 0;
	        var max = this.text().length;
	        var caret = {
	          start: Math.max(min, Math.min(max, range.start)),
	          end: Math.max(min, Math.min(max, range.start + range.length))
	        };
	        this._selectedRange = {
	          start: caret.start,
	          length: caret.end - caret.start
	        };
	        this.selectionAffinity = range.length === 0 ? Affinity.NONE : affinity;
	        return this._selectedRange;
	      }
	
	      /**
	       * Gets the position of the current selection's anchor point, i.e. the point
	       * that the selection extends from, if any.
	       *
	       * @returns {number}
	       */
	    }, {
	      key: 'selectionAnchor',
	      value: function selectionAnchor() {
	        var range = this.selectedRange();
	        switch (this.selectionAffinity) {
	          case Affinity.UPSTREAM:
	            return range.start + range.length;
	          case Affinity.DOWNSTREAM:
	            return range.start;
	          default:
	            return Affinity.NONE;
	        }
	      }
	
	      /**
	       * Builds the key bindings for platform
	       *
	       * @TODO: Make this better
	       * @private
	       */
	    }, {
	      key: '_buildKeybindings',
	      value: function _buildKeybindings() {
	        var osx;
	
	        if (typeof navigator !== 'undefined') {
	          osx = /^Mozilla\/[\d\.]+ \(Macintosh/.test(navigator.userAgent);
	        } else if (typeof process !== 'undefined') {
	          osx = /darwin/.test(process.platform);
	        }
	        this._bindings = keyBindingsForPlatform(osx ? 'OSX' : 'Default');
	      }
	
	      /**
	       * Handles the event based on the `shouldCancelEvents` prop.
	       *
	       * @param {Event} event
	       * @private
	       */
	    }, {
	      key: '_handleEvent',
	      value: function _handleEvent(event) {
	        if (event && this.shouldCancelEvents) {
	          event.preventDefault();
	        }
	      }
	
	      /**
	       * Finds the start of the 'word' before index.
	       *
	       * @param {number} index position at which to start looking
	       * @returns {number} index in value less than or equal to the given index
	       * @private
	       */
	    }, {
	      key: '_lastWordBreakBeforeIndex',
	      value: function _lastWordBreakBeforeIndex(index) {
	        var indexes = this._leftWordBreakIndexes();
	        var result = indexes[0];
	        for (var i = 0, l = indexes.length; i < l; i++) {
	          var wordBreakIndex = indexes[i];
	          if (index > wordBreakIndex) {
	            result = wordBreakIndex;
	          } else {
	            break;
	          }
	        }
	        return result;
	      }
	
	      /**
	       * Find starts of 'words' for navigational purposes.
	       *
	       * @example
	       *     // given value of '123456789' and text of '123-45-6789'
	       *     leftWordBreakIndexes()
	       *     // => [0, 3, 5]
	       *
	       * @returns {number[]} indexes in value of word starts.
	       * @private
	       */
	    }, {
	      key: '_leftWordBreakIndexes',
	      value: function _leftWordBreakIndexes() {
	        var result = [];
	        var text = this.text();
	        for (var i = 0, l = text.length; i < l; i++) {
	          if (hasLeftWordBreakAtIndex(text, i)) {
	            result.push(i);
	          }
	        }
	        return result;
	      }
	
	      /**
	       * Finds the end of the 'word' after index.
	       *
	       * @param {number} index position in value at which to start looking.
	       * @returns {number}
	       * @private
	       */
	    }, {
	      key: '_nextWordBreakAfterIndex',
	      value: function _nextWordBreakAfterIndex(index) {
	        var indexes = this.rightWordBreakIndexes().reverse();
	        var result = indexes[0];
	        for (var i = 0, l = indexes.length; i < l; i++) {
	          var wordBreakIndex = indexes[i];
	          if (index < wordBreakIndex) {
	            result = wordBreakIndex;
	          } else {
	            break;
	          }
	        }
	        return result;
	      }
	    }]);
	
	    return Input;
	  })();
	
	  exports.Input = Input;
	  exports.KEYS = KEYS;
	  exports.keyBindingsForPlatform = keyBindingsForPlatform;
	});
	
	
	}).call(this,_dereq_('_process'))
	},{"_process":1}],3:[function(_dereq_,module,exports){
	(function (global, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define('stround', ['exports'], factory);
	  } else if (typeof exports !== 'undefined') {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.stround = mod.exports;
	  }
	})(this, function (exports) {
	  /* jshint sub:true, esnext:true, undef:true, unused:true */
	
	  /**
	   * Enum for the available rounding modes.
	   *
	   * @enum {number}
	   */
	  'use strict';
	
	  Object.defineProperty(exports, '__esModule', {
	    value: true
	  });
	
	  var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	  exports.parse = parse;
	  exports.format = format;
	  exports.shiftParts = shiftParts;
	  exports.shift = shift;
	  exports.round = round;
	  var modes = {
	    CEILING: 0,
	    FLOOR: 1,
	    DOWN: 2,
	    UP: 3,
	    HALF_EVEN: 4,
	    HALF_DOWN: 5,
	    HALF_UP: 6
	  };
	
	  exports.modes = modes;
	  /**
	   * @const
	   * @private
	   */
	  var NEG = '-';
	
	  /**
	   * @const
	   * @private
	   */
	  var SEP = '.';
	
	  /**
	   * @const
	   * @private
	   */
	  var NEG_PATTERN = '-';
	
	  /**
	   * @const
	   * @private
	   */
	  var SEP_PATTERN = '\\.';
	
	  /**
	   * @const
	   * @private
	   */
	  var NUMBER_PATTERN = new RegExp('^(' + NEG_PATTERN + ')?(\\d*)(?:' + SEP_PATTERN + '(\\d*))?$');
	
	  /**
	   * Increments the given integer represented by a string by one.
	   *
	   * @example
	   *
	   *   increment('1');  // '2'
	   *   increment('99'); // '100'
	   *   increment('');   // '1'
	   *
	   * @param {string} strint
	   * @return {string}
	   * @private
	   */
	  function increment(strint) {
	    var length = strint.length;
	
	    if (length === 0) {
	      return '1';
	    }
	
	    var last = parseInt(strint[length - 1], 10);
	
	    if (last === 9) {
	      return increment(strint.slice(0, length - 1)) + '0';
	    } else {
	      return strint.slice(0, length - 1) + (last + 1);
	    }
	  }
	
	  /**
	   * Parses the given decimal string into its component parts.
	   *
	   * @example
	   *
	   *   stround.parse('3.14');  // [false, '3', '14']
	   *   stround.parse('-3.45'); // [true, '3', '45']
	   *
	   * @param {string} strnum
	   * @return {?Array}
	   */
	
	  function parse(strnum) {
	    switch (strnum) {
	      case 'NaN':case 'Infinity':case '-Infinity':
	        return null;
	    }
	
	    var match = strnum.match(NUMBER_PATTERN);
	
	    if (!match) {
	      throw new Error('cannot round malformed number: ' + strnum);
	    }
	
	    return [match[1] !== undefined, match[2], match[3] || ''];
	  }
	
	  /**
	   * Format the given number configuration as a number string.
	   *
	   * @example
	   *
	   *   stround.format([false, '12', '34']); // '12.34'
	   *   stround.format([true, '8', '']);     // '-8'
	   *   stround.format([true, '', '7']);     // '-0.7'
	   *
	   * @param {Array} parts
	   * @return {string}
	   */
	
	  function format(_ref) {
	    var _ref2 = _slicedToArray(_ref, 3);
	
	    var negative = _ref2[0];
	    var intPart = _ref2[1];
	    var fracPart = _ref2[2];
	
	    if (intPart.length === 0) {
	      intPart = '0';
	    } else {
	      var firstNonZeroIndex = undefined;
	      for (firstNonZeroIndex = 0; firstNonZeroIndex < intPart.length; firstNonZeroIndex++) {
	        if (intPart[firstNonZeroIndex] !== '0') {
	          break;
	        }
	      }
	
	      if (firstNonZeroIndex !== intPart.length) {
	        intPart = intPart.slice(firstNonZeroIndex);
	      }
	    }
	
	    return (negative ? NEG + intPart : intPart) + (fracPart.length ? SEP + fracPart : '');
	  }
	
	  /**
	   * Shift the exponent of the given number (in parts) by the given amount.
	   *
	   * @example
	   *
	   *   stround.shiftParts([false, '12', ''], 2);  // [false, '1200', '']
	   *   stround.shiftParts([false, '12', ''], -2); // [false, '', '12']
	   *
	   * @param {Array} parts
	   * @param {number} exponent
	   * @return {Array}
	   */
	
	  function shiftParts(_ref3, exponent) {
	    var _ref32 = _slicedToArray(_ref3, 3);
	
	    var negative = _ref32[0];
	    var intPart = _ref32[1];
	    var fracPart = _ref32[2];
	
	    var partToMove = undefined;
	
	    if (exponent > 0) {
	      partToMove = fracPart.slice(0, exponent);
	      while (partToMove.length < exponent) {
	        partToMove += '0';
	      }
	      intPart += partToMove;
	      fracPart = fracPart.slice(exponent);
	    } else if (exponent < 0) {
	      while (intPart.length < -exponent) {
	        intPart = '0' + intPart;
	      }
	      partToMove = intPart.slice(intPart.length + exponent);
	      fracPart = partToMove + fracPart;
	      intPart = intPart.slice(0, intPart.length - partToMove.length);
	    }
	
	    return [negative, intPart, fracPart];
	  }
	
	  /**
	   * Shift the exponent of the given number (as a string) by the given amount.
	   *
	   *   shift('12', 2);  // '1200'
	   *   shift('12', -2); // '0.12'
	   *
	   * @param {string|number} strnum
	   * @param {number} exponent
	   * @return {string}
	   */
	
	  function shift(strnum, exponent) {
	    if (typeof strnum === 'number') {
	      strnum = '' + strnum;
	    }
	
	    var parsed = parse(strnum);
	    if (parsed === null) {
	      return strnum;
	    } else {
	      return format(shiftParts(parsed, exponent));
	    }
	  }
	
	  /**
	   * Round the given number represented by a string according to the given
	   * precision and mode.
	   *
	   * @param {string|number} strnum
	   * @param {number|null|undefined=} precision
	   * @param {modes=} mode
	   * @return {string}
	   */
	
	  function round(strnum, precision, mode) {
	    if (typeof strnum === 'number') {
	      strnum = '' + strnum;
	    }
	
	    if (typeof strnum !== 'string') {
	      throw new Error('expected a string or number, got: ' + strnum);
	    }
	
	    if (strnum.length === 0) {
	      return strnum;
	    }
	
	    if (precision === null || precision === undefined) {
	      precision = 0;
	    }
	
	    if (mode === undefined) {
	      mode = modes.HALF_EVEN;
	    }
	
	    var parsed = parse(strnum);
	
	    if (parsed === null) {
	      return strnum;
	    }
	
	    if (precision > 0) {
	      parsed = shiftParts(parsed, precision);
	    }
	
	    var _parsed = parsed;
	
	    var _parsed2 = _slicedToArray(_parsed, 3);
	
	    var negative = _parsed2[0];
	    var intPart = _parsed2[1];
	    var fracPart = _parsed2[2];
	
	    switch (mode) {
	      case modes.CEILING:case modes.FLOOR:case modes.UP:
	        var foundNonZeroDigit = false;
	        for (var i = 0, _length = fracPart.length; i < _length; i++) {
	          if (fracPart[i] !== '0') {
	            foundNonZeroDigit = true;
	            break;
	          }
	        }
	        if (foundNonZeroDigit) {
	          if (mode === modes.UP || negative !== (mode === modes.CEILING)) {
	            intPart = increment(intPart);
	          }
	        }
	        break;
	
	      case modes.HALF_EVEN:case modes.HALF_DOWN:case modes.HALF_UP:
	        var shouldRoundUp = false;
	        var firstFracPartDigit = parseInt(fracPart[0], 10);
	
	        if (firstFracPartDigit > 5) {
	          shouldRoundUp = true;
	        } else if (firstFracPartDigit === 5) {
	          if (mode === modes.HALF_UP) {
	            shouldRoundUp = true;
	          }
	
	          if (!shouldRoundUp) {
	            for (var i = 1, _length2 = fracPart.length; i < _length2; i++) {
	              if (fracPart[i] !== '0') {
	                shouldRoundUp = true;
	                break;
	              }
	            }
	          }
	
	          if (!shouldRoundUp && mode === modes.HALF_EVEN) {
	            var lastIntPartDigit = parseInt(intPart[intPart.length - 1], 10);
	            shouldRoundUp = lastIntPartDigit % 2 !== 0;
	          }
	        }
	
	        if (shouldRoundUp) {
	          intPart = increment(intPart);
	        }
	        break;
	    }
	
	    return format(shiftParts([negative, intPart, ''], -precision));
	  }
	});
	
	},{}],4:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _amex_card_formatter = _dereq_('./amex_card_formatter');
	
	var _amex_card_formatter2 = _interopRequireDefault(_amex_card_formatter);
	
	var _default_card_formatter = _dereq_('./default_card_formatter');
	
	var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
	
	var _card_utils = _dereq_('./card_utils');
	
	/**
	 * AdaptiveCardFormatter will decide if it needs to use
	 * {@link AmexCardFormatter} or {@link DefaultCardFormatter}.
	 */
	
	var AdaptiveCardFormatter = (function () {
	  function AdaptiveCardFormatter() {
	    _classCallCheck(this, AdaptiveCardFormatter);
	
	    /** @private */
	    this.amexCardFormatter = new _amex_card_formatter2['default']();
	    /** @private */
	    this.defaultCardFormatter = new _default_card_formatter2['default']();
	    /** @private */
	    this.formatter = this.defaultCardFormatter;
	  }
	
	  /**
	   * Will pick the right formatter based on the `pan` and will return the
	   * formatted string.
	   *
	   * @param {string} pan
	   * @returns {string} formatted string
	   */
	
	  _createClass(AdaptiveCardFormatter, [{
	    key: 'format',
	    value: function format(pan) {
	      return this._formatterForPan(pan).format(pan);
	    }
	
	    /**
	     * Will call parse on the formatter.
	     *
	     * @param {string} text
	     * @param {function(string)} error
	     * @returns {string} returns value with delimiters removed
	     */
	  }, {
	    key: 'parse',
	    value: function parse(text, error) {
	      return this.formatter.parse(text, error);
	    }
	
	    /**
	     * Determines whether the given change should be allowed and, if so, whether
	     * it should be altered.
	     *
	     * @param {TextFieldStateChange} change
	     * @param {function(!string)} error
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isChangeValid',
	    value: function isChangeValid(change, error) {
	      this.formatter = this._formatterForPan(change.proposed.text);
	      return this.formatter.isChangeValid(change, error);
	    }
	
	    /**
	     * Decides which formatter to use.
	     *
	     * @param {string} pan
	     * @returns {Formatter}
	     * @private
	     */
	  }, {
	    key: '_formatterForPan',
	    value: function _formatterForPan(pan) {
	      if ((0, _card_utils.determineCardType)(pan.replace(/[^\d]+/g, '')) === _card_utils.AMEX) {
	        return this.amexCardFormatter;
	      } else {
	        return this.defaultCardFormatter;
	      }
	    }
	  }]);
	
	  return AdaptiveCardFormatter;
	})();
	
	exports['default'] = AdaptiveCardFormatter;
	module.exports = exports['default'];
	
	},{"./amex_card_formatter":5,"./card_utils":7,"./default_card_formatter":9}],5:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _default_card_formatter = _dereq_('./default_card_formatter');
	
	var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
	
	/**
	 * Amex credit card formatter.
	 *
	 * @extends DefaultCardFormatter
	 */
	
	var AmexCardFormatter = (function (_DefaultCardFormatter) {
	  _inherits(AmexCardFormatter, _DefaultCardFormatter);
	
	  function AmexCardFormatter() {
	    _classCallCheck(this, AmexCardFormatter);
	
	    _get(Object.getPrototypeOf(AmexCardFormatter.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(AmexCardFormatter, [{
	    key: 'hasDelimiterAtIndex',
	
	    /**
	     * @override
	     */
	    value: function hasDelimiterAtIndex(index) {
	      return index === 4 || index === 11;
	    }
	
	    /**
	     * @override
	     */
	  }, {
	    key: 'maximumLength',
	    get: function get() {
	      return 15 + 2;
	    }
	  }]);
	
	  return AmexCardFormatter;
	})(_default_card_formatter2['default']);
	
	exports['default'] = AmexCardFormatter;
	module.exports = exports['default'];
	
	},{"./default_card_formatter":9}],6:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _text_field = _dereq_('./text_field');
	
	var _text_field2 = _interopRequireDefault(_text_field);
	
	var _adaptive_card_formatter = _dereq_('./adaptive_card_formatter');
	
	var _adaptive_card_formatter2 = _interopRequireDefault(_adaptive_card_formatter);
	
	var _card_utils = _dereq_('./card_utils');
	
	/**
	 * Enum for card mask strategies.
	 *
	 * @readonly
	 * @enum {number}
	 * @private
	 */
	var CardMaskStrategy = {
	  None: 'None',
	  DoneEditing: 'DoneEditing'
	};
	
	/**
	 * CardTextField add some functionality for credit card inputs
	 *
	 * @extends TextField
	 */
	
	var CardTextField = (function (_TextField) {
	  _inherits(CardTextField, _TextField);
	
	  /**
	   * @param {HTMLElement} element
	   */
	
	  function CardTextField(element) {
	    _classCallCheck(this, CardTextField);
	
	    _get(Object.getPrototypeOf(CardTextField.prototype), 'constructor', this).call(this, element, new _adaptive_card_formatter2['default']());
	    this.setCardMaskStrategy(CardMaskStrategy.None);
	
	    /**
	     * Whether we are currently masking the displayed text.
	     *
	     * @private
	     */
	    this._masked = false;
	
	    /**
	     * Whether we are currently editing.
	     *
	     * @private
	     */
	    this._editing = false;
	  }
	
	  /**
	   * Gets the card type for the current value.
	   *
	   * @returns {string} Returns one of 'visa', 'mastercard', 'amex' and 'discover'.
	   */
	
	  _createClass(CardTextField, [{
	    key: 'cardType',
	    value: function cardType() {
	      return (0, _card_utils.determineCardType)(this.value());
	    }
	
	    /**
	     * Gets the type of masking this field uses.
	     *
	     * @returns {CardMaskStrategy}
	     */
	  }, {
	    key: 'cardMaskStrategy',
	    value: function cardMaskStrategy() {
	      return this._cardMaskStrategy;
	    }
	
	    /**
	     * Sets the type of masking this field uses.
	     *
	     * @param {CardMaskStrategy} cardMaskStrategy One of CardMaskStrategy.
	     */
	  }, {
	    key: 'setCardMaskStrategy',
	    value: function setCardMaskStrategy(cardMaskStrategy) {
	      if (cardMaskStrategy !== this._cardMaskStrategy) {
	        this._cardMaskStrategy = cardMaskStrategy;
	        this._syncMask();
	      }
	    }
	
	    /**
	     * Returns a masked version of the current formatted PAN. Example:
	     *
	     * @example
	     *     field.setText('4111 1111 1111 1111');
	     *     field.cardMask(); // "•••• •••• •••• 1111"
	     *
	     * @returns {string} Returns a masked card string.
	     */
	  }, {
	    key: 'cardMask',
	    value: function cardMask() {
	      var text = this.text();
	      var last4 = text.slice(-4);
	      var toMask = text.slice(0, -4);
	
	      return toMask.replace(/\d/g, '•') + last4;
	    }
	
	    /**
	     * Gets the formatted PAN for this field.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'text',
	    value: function text() {
	      if (this._masked) {
	        return this._unmaskedText;
	      } else {
	        return _get(Object.getPrototypeOf(CardTextField.prototype), 'text', this).call(this);
	      }
	    }
	
	    /**
	     * Sets the formatted PAN for this field.
	     *
	     * @param {string} text A formatted PAN.
	     */
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      if (this._masked) {
	        this._unmaskedText = text;
	        text = this.cardMask();
	      }
	      _get(Object.getPrototypeOf(CardTextField.prototype), 'setText', this).call(this, text);
	    }
	
	    /**
	     * Called by our superclass, used to implement card masking.
	     *
	     * @private
	     */
	  }, {
	    key: 'textFieldDidEndEditing',
	    value: function textFieldDidEndEditing() {
	      this._editing = false;
	      this._syncMask();
	    }
	
	    /**
	     * Called by our superclass, used to implement card masking.
	     *
	     * @private
	     */
	  }, {
	    key: 'textFieldDidBeginEditing',
	    value: function textFieldDidBeginEditing() {
	      this._editing = true;
	      this._syncMask();
	    }
	
	    /**
	     * Enables masking if it is not already enabled.
	     *
	     * @private
	     */
	  }, {
	    key: '_enableMasking',
	    value: function _enableMasking() {
	      if (!this._masked) {
	        this._unmaskedText = this.text();
	        this._masked = true;
	        this.setText(this._unmaskedText);
	      }
	    }
	
	    /**
	     * Disables masking if it is currently enabled.
	     *
	     * @private
	     */
	  }, {
	    key: '_disableMasking',
	    value: function _disableMasking() {
	      if (this._masked) {
	        this._masked = false;
	        this.setText(this._unmaskedText);
	        this._unmaskedText = null;
	      }
	    }
	
	    /**
	     * Enables or disables masking based on the mask settings.
	     *
	     * @private
	     */
	  }, {
	    key: '_syncMask',
	    value: function _syncMask() {
	      if (this.cardMaskStrategy() === CardMaskStrategy.DoneEditing) {
	        if (this._editing) {
	          this._disableMasking();
	        } else {
	          this._enableMasking();
	        }
	      }
	    }
	
	    /**
	     * Enum for card mask strategies.
	     *
	     * @readonly
	     * @enum {number}
	     */
	  }], [{
	    key: 'CardMaskStrategy',
	    get: function get() {
	      return CardMaskStrategy;
	    }
	  }]);
	
	  return CardTextField;
	})(_text_field2['default']);
	
	exports['default'] = CardTextField;
	module.exports = exports['default'];
	
	},{"./adaptive_card_formatter":4,"./card_utils":7,"./text_field":20}],7:[function(_dereq_,module,exports){
	/**
	 * @TODO Make this an enum
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.determineCardType = determineCardType;
	exports.luhnCheck = luhnCheck;
	exports.validCardLength = validCardLength;
	var AMEX = 'amex';
	exports.AMEX = AMEX;
	var DISCOVER = 'discover';
	exports.DISCOVER = DISCOVER;
	var JCB = 'jcb';
	exports.JCB = JCB;
	var MASTERCARD = 'mastercard';
	exports.MASTERCARD = MASTERCARD;
	var VISA = 'visa';
	
	exports.VISA = VISA;
	/**
	 * Pass in a credit card number and it'll return the
	 * type of card it is.
	 *
	 * @param {string} pan
	 * @returns {?string} returns the type of card based in the digits
	 */
	
	function determineCardType(pan) {
	  if (pan === null || pan === undefined) {
	    return null;
	  }
	
	  pan = pan.toString();
	  var firsttwo = parseInt(pan.slice(0, 2), 10);
	  var iin = parseInt(pan.slice(0, 6), 10);
	  var halfiin = parseInt(pan.slice(0, 3), 10);
	
	  if (pan[0] === '4') {
	    return VISA;
	  } else if (pan.slice(0, 4) === '6011' || firsttwo === 65 || halfiin >= 664 && halfiin <= 649 || iin >= 622126 && iin <= 622925) {
	    return DISCOVER;
	  } else if (pan.slice(0, 4) === '2131' || pan.slice(0, 4) === '1800' || firsttwo === 35) {
	    return JCB;
	  } else if (firsttwo >= 51 && firsttwo <= 55) {
	    return MASTERCARD;
	  } else if (firsttwo === 34 || firsttwo === 37) {
	    return AMEX;
	  }
	}
	
	/**
	 * Pass in a credit card number and it'll return if it
	 * passes the [luhn algorithm](http://en.wikipedia.org/wiki/Luhn_algorithm)
	 *
	 * @param {string} pan
	 * @returns {boolean}
	 */
	
	function luhnCheck(pan) {
	  var sum = 0;
	  var flip = true;
	  for (var i = pan.length - 1; i >= 0; i--) {
	    var digit = parseInt(pan.charAt(i), 10);
	    sum += (flip = !flip) ? Math.floor(digit * 2 / 10) + Math.floor(digit * 2 % 10) : digit;
	  }
	
	  return sum % 10 === 0;
	}
	
	/**
	 * Pass in a credit card number and it'll return if it
	 * is a valid length for that type. If it doesn't know the
	 * type it'll return false
	 *
	 * @param {string} pan
	 * @returns {boolean}
	 */
	
	function validCardLength(pan) {
	  switch (determineCardType(pan)) {
	    case VISA:
	      return pan.length === 13 || pan.length === 16;
	    case DISCOVER:case MASTERCARD:
	      return pan.length === 16;
	    case JCB:
	      return pan.length === 15 || pan.length === 16;
	    case AMEX:
	      return pan.length === 15;
	    default:
	      return false;
	  }
	}
	
	},{}],8:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = installCaret;
	
	function installCaret() {
	  var _document = arguments.length <= 0 || arguments[0] === undefined ? document : arguments[0];
	
	  var getCaret = undefined;
	  var setCaret = undefined;
	
	  if (!_document) {
	    throw new Error('Caret does not have access to document');
	  } else if ('selectionStart' in _document.createElement('input')) {
	    getCaret = function (element) {
	      return {
	        start: element.selectionStart,
	        end: element.selectionEnd
	      };
	    };
	    setCaret = function (element, start, end) {
	      element.selectionStart = start;
	      element.selectionEnd = end;
	    };
	  } else if (_document.selection) {
	    getCaret = function (element) {
	      var selection = _document.selection;
	      var value = element.value;
	      var range = selection.createRange().duplicate();
	
	      range.moveEnd('character', value.length);
	
	      var start = range.text === '' ? value.length : value.lastIndexOf(range.text);
	      range = selection.createRange().duplicate();
	
	      range.moveStart('character', -value.length);
	
	      var end = range.text.length;
	      return { start: start, end: end };
	    };
	    setCaret = function (element, start, end) {
	      var range = element.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    };
	  } else {
	    throw new Error('Caret unknown input selection capabilities');
	  }
	
	  return { getCaret: getCaret, setCaret: setCaret };
	}
	
	;
	module.exports = exports['default'];
	
	},{}],9:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
	
	var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
	
	var _card_utils = _dereq_('./card_utils');
	
	/**
	 * A generic credit card formatter.
	 *
	 * @extends DelimitedTextFormatter
	 */
	
	var DefaultCardFormatter = (function (_DelimitedTextFormatter) {
	  _inherits(DefaultCardFormatter, _DelimitedTextFormatter);
	
	  function DefaultCardFormatter() {
	    _classCallCheck(this, DefaultCardFormatter);
	
	    _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), 'constructor', this).call(this, ' ');
	  }
	
	  /**
	   * @param {number} index
	   * @returns {boolean}
	   */
	
	  _createClass(DefaultCardFormatter, [{
	    key: 'hasDelimiterAtIndex',
	    value: function hasDelimiterAtIndex(index) {
	      return index === 4 || index === 9 || index === 14;
	    }
	
	    /**
	     * Will call parse on the formatter.
	     *
	     * @param {string} text
	     * @param {function(string)} error
	     * @returns {string} returns value with delimiters removed
	     */
	  }, {
	    key: 'parse',
	    value: function parse(text, error) {
	      var value = this._valueFromText(text);
	      if (typeof error === 'function') {
	        if (!(0, _card_utils.validCardLength)(value)) {
	          error('card-formatter.number-too-short');
	        }
	        if (!(0, _card_utils.luhnCheck)(value)) {
	          error('card-formatter.invalid-number');
	        }
	      }
	      return _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), 'parse', this).call(this, text, error);
	    }
	
	    /**
	     * Parses the given text by removing delimiters.
	     *
	     * @param {?string} text
	     * @returns {string}
	     * @private
	     */
	  }, {
	    key: '_valueFromText',
	    value: function _valueFromText(text) {
	      return _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), '_valueFromText', this).call(this, (text || '').replace(/[^\d]/g, ''));
	    }
	
	    /**
	     * Gets the maximum length of a formatted default card number.
	     *
	     * @returns {number}
	     */
	  }, {
	    key: 'maximumLength',
	    get: function get() {
	      return 16 + 3;
	    }
	  }]);
	
	  return DefaultCardFormatter;
	})(_delimited_text_formatter2['default']);
	
	exports['default'] = DefaultCardFormatter;
	module.exports = exports['default'];
	
	},{"./card_utils":7,"./delimited_text_formatter":10}],10:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _formatter = _dereq_('./formatter');
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	/**
	 * A generic delimited formatter.
	 *
	 * @extends Formatter
	 */
	
	var DelimitedTextFormatter = (function (_Formatter) {
	  _inherits(DelimitedTextFormatter, _Formatter);
	
	  /**
	   * @param {string=} delimiter
	   * @param {boolean=} isLazy
	   * @throws {Error} delimiter must have just one character
	   */
	
	  function DelimitedTextFormatter(delimiter) {
	    var isLazy = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    _classCallCheck(this, DelimitedTextFormatter);
	
	    _get(Object.getPrototypeOf(DelimitedTextFormatter.prototype), 'constructor', this).call(this);
	
	    if (arguments.length === 0) {
	      return;
	    }
	
	    if (delimiter === null || delimiter === undefined || delimiter.length !== 1) {
	      throw new Error('delimiter must have just one character');
	    }
	    this.delimiter = delimiter;
	
	    // If the formatter is lazy, delimiter will not be added until input has gone
	    // past the delimiter index. Useful for 'optional' extension, like zip codes.
	    // 94103  ->  type '1'  ->  94103-1
	    this.isLazy = isLazy;
	  }
	
	  /**
	   * Determines the delimiter character at the given index.
	   *
	   * @param {number} index
	   * @returns {?string}
	   */
	
	  _createClass(DelimitedTextFormatter, [{
	    key: 'delimiterAt',
	    value: function delimiterAt(index) {
	      if (!this.hasDelimiterAtIndex(index)) {
	        return null;
	      }
	      return this.delimiter;
	    }
	
	    /**
	     * Determines whether the given character is a delimiter.
	     *
	     * @param {string} chr
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isDelimiter',
	    value: function isDelimiter(chr) {
	      return chr === this.delimiter;
	    }
	
	    /**
	     * Formats the given value by adding delimiters where needed.
	     *
	     * @param {?string} value
	     * @returns {string}
	     */
	  }, {
	    key: 'format',
	    value: function format(value) {
	      return this._textFromValue(value);
	    }
	
	    /**
	     * Formats the given value by adding delimiters where needed.
	     *
	     * @param {?string} value
	     * @returns {string}
	     * @private
	     */
	  }, {
	    key: '_textFromValue',
	    value: function _textFromValue(value) {
	      if (!value) {
	        return '';
	      }
	
	      var result = '';
	      var delimiter = undefined;
	      var maximumLength = this.maximumLength;
	
	      for (var i = 0, l = value.length; i < l; i++) {
	        while (delimiter = this.delimiterAt(result.length)) {
	          result += delimiter;
	        }
	        result += value[i];
	        if (!this.isLazy) {
	          while (delimiter = this.delimiterAt(result.length)) {
	            result += delimiter;
	          }
	        }
	      }
	
	      if (maximumLength !== undefined && maximumLength !== null) {
	        return result.slice(0, maximumLength);
	      } else {
	        return result;
	      }
	    }
	
	    /**
	     * Parses the given text by removing delimiters.
	     *
	     * @param {?string} text
	     * @returns {string}
	     */
	  }, {
	    key: 'parse',
	    value: function parse(text) {
	      return this._valueFromText(text);
	    }
	
	    /**
	     * Parses the given text by removing delimiters.
	     *
	     * @param {?string} text
	     * @returns {string}
	     * @private
	     */
	  }, {
	    key: '_valueFromText',
	    value: function _valueFromText(text) {
	      if (!text) {
	        return '';
	      }
	      var result = '';
	      for (var i = 0, l = text.length; i < l; i++) {
	        if (!this.isDelimiter(text[i])) {
	          result += text[i];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Determines whether the given change should be allowed and, if so, whether
	     * it should be altered.
	     *
	     * @param {TextFieldStateChange} change
	     * @param {function(string)} error
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isChangeValid',
	    value: function isChangeValid(change, error) {
	      if (!_get(Object.getPrototypeOf(DelimitedTextFormatter.prototype), 'isChangeValid', this).call(this, change, error)) {
	        return false;
	      }
	
	      var newText = change.proposed.text;
	      var range = change.proposed.selectedRange;
	      var hasSelection = range.length !== 0;
	
	      var startMovedLeft = range.start < change.current.selectedRange.start;
	      var startMovedRight = range.start > change.current.selectedRange.start;
	      var endMovedLeft = range.start + range.length < change.current.selectedRange.start + change.current.selectedRange.length;
	      var endMovedRight = range.start + range.length > change.current.selectedRange.start + change.current.selectedRange.length;
	
	      var startMovedOverADelimiter = startMovedLeft && this.hasDelimiterAtIndex(range.start) || startMovedRight && this.hasDelimiterAtIndex(range.start - 1);
	      var endMovedOverADelimiter = endMovedLeft && this.hasDelimiterAtIndex(range.start + range.length) || endMovedRight && this.hasDelimiterAtIndex(range.start + range.length - 1);
	
	      if (this.isDelimiter(change.deleted.text)) {
	        var newCursorPosition = change.deleted.start - 1;
	        // delete any immediately preceding delimiters
	        while (this.isDelimiter(newText.charAt(newCursorPosition))) {
	          newText = newText.substring(0, newCursorPosition) + newText.substring(newCursorPosition + 1);
	          newCursorPosition--;
	        }
	        // finally delete the real character that was intended
	        newText = newText.substring(0, newCursorPosition) + newText.substring(newCursorPosition + 1);
	      }
	
	      // adjust the cursor / selection
	      if (startMovedLeft && startMovedOverADelimiter) {
	        // move left over any immediately preceding delimiters
	        while (this.delimiterAt(range.start - 1)) {
	          range.start--;
	          range.length++;
	        }
	        // finally move left over the real intended character
	        range.start--;
	        range.length++;
	      }
	
	      if (startMovedRight) {
	        // move right over any delimiters found on the way, including any leading delimiters
	        for (var i = change.current.selectedRange.start; i < range.start + range.length; i++) {
	          if (this.delimiterAt(i)) {
	            range.start++;
	            if (range.length > 0) {
	              range.length--;
	            }
	          }
	        }
	
	        while (this.delimiterAt(range.start)) {
	          range.start++;
	          range.length--;
	        }
	      }
	
	      if (hasSelection) {
	        // Otherwise, the logic for the range start takes care of everything.
	        if (endMovedOverADelimiter) {
	          if (endMovedLeft) {
	            // move left over any immediately preceding delimiters
	            while (this.delimiterAt(range.start + range.length - 1)) {
	              range.length--;
	            }
	            // finally move left over the real intended character
	            range.length--;
	          }
	
	          if (endMovedRight) {
	            // move right over any immediately following delimiters
	            while (this.delimiterAt(range.start + range.length)) {
	              range.length++;
	            }
	            // finally move right over the real intended character
	            range.length++;
	          }
	        }
	
	        // trailing delimiters in the selection
	        while (this.hasDelimiterAtIndex(range.start + range.length - 1)) {
	          if (startMovedLeft || endMovedLeft) {
	            range.length--;
	          } else {
	            range.length++;
	          }
	        }
	
	        while (this.hasDelimiterAtIndex(range.start)) {
	          if (startMovedRight || endMovedRight) {
	            range.start++;
	            range.length--;
	          } else {
	            range.start--;
	            range.length++;
	          }
	        }
	      } else {
	        range.length = 0;
	      }
	
	      var result = true;
	
	      var value = this._valueFromText(newText, function () {
	        result = false;
	        error.apply(undefined, arguments);
	      });
	
	      if (result) {
	        change.proposed.text = this._textFromValue(value);
	      }
	
	      return result;
	    }
	  }]);
	
	  return DelimitedTextFormatter;
	})(_formatter2['default']);
	
	exports['default'] = DelimitedTextFormatter;
	module.exports = exports['default'];
	
	},{"./formatter":14}],11:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
	
	var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
	
	/**
	 * @const
	 * @private
	 */
	var DIGITS_PATTERN = /^\d*$/;
	
	/**
	 * @extends DelimitedTextFormatter
	 */
	
	var EmployerIdentificationNumberFormatter = (function (_DelimitedTextFormatter) {
	  _inherits(EmployerIdentificationNumberFormatter, _DelimitedTextFormatter);
	
	  function EmployerIdentificationNumberFormatter() {
	    _classCallCheck(this, EmployerIdentificationNumberFormatter);
	
	    _get(Object.getPrototypeOf(EmployerIdentificationNumberFormatter.prototype), 'constructor', this).call(this, '-');
	    this.maximumLength = 9 + 1;
	  }
	
	  /**
	   * @param {number} index
	   * @returns {boolean}
	   */
	
	  _createClass(EmployerIdentificationNumberFormatter, [{
	    key: 'hasDelimiterAtIndex',
	    value: function hasDelimiterAtIndex(index) {
	      return index === 2;
	    }
	
	    /**
	     * Determines whether the given change should be allowed and, if so, whether
	     * it should be altered.
	     *
	     * @param {TextFieldStateChange} change
	     * @param {function(string)} error
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isChangeValid',
	    value: function isChangeValid(change, error) {
	      if (DIGITS_PATTERN.test(change.inserted.text)) {
	        return _get(Object.getPrototypeOf(EmployerIdentificationNumberFormatter.prototype), 'isChangeValid', this).call(this, change, error);
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return EmployerIdentificationNumberFormatter;
	})(_delimited_text_formatter2['default']);
	
	exports['default'] = EmployerIdentificationNumberFormatter;
	module.exports = exports['default'];
	
	},{"./delimited_text_formatter":10}],12:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _text_field = _dereq_('./text_field');
	
	var _text_field2 = _interopRequireDefault(_text_field);
	
	var _expiry_date_formatter = _dereq_('./expiry_date_formatter');
	
	var _expiry_date_formatter2 = _interopRequireDefault(_expiry_date_formatter);
	
	/**
	 * Adds a default formatter for expiration dates.
	 *
	 * @extends TextField
	 */
	
	var ExpiryDateField = (function (_TextField) {
	  _inherits(ExpiryDateField, _TextField);
	
	  /**
	   * @param {HTMLElement} element
	   */
	
	  function ExpiryDateField(element) {
	    _classCallCheck(this, ExpiryDateField);
	
	    _get(Object.getPrototypeOf(ExpiryDateField.prototype), 'constructor', this).call(this, element, new _expiry_date_formatter2['default']());
	  }
	
	  /**
	   * Called by our superclass, used to post-process the text.
	   *
	   * @private
	   */
	
	  _createClass(ExpiryDateField, [{
	    key: 'textFieldDidEndEditing',
	    value: function textFieldDidEndEditing() {
	      var value = this.value();
	      if (value) {
	        this.setText(this.formatter().format(value));
	      }
	    }
	  }]);
	
	  return ExpiryDateField;
	})(_text_field2['default']);
	
	exports['default'] = ExpiryDateField;
	module.exports = exports['default'];
	
	},{"./expiry_date_formatter":13,"./text_field":20}],13:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
	
	var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
	
	var _utils = _dereq_('./utils');
	
	/**
	 * Give this function a 2 digit year it'll return with 4.
	 *
	 * @example
	 *     interpretTwoDigitYear(15);
	 *     // => 2015
	 *     interpretTwoDigitYear(97);
	 *     // => 1997
	 * @param {number} year
	 * @returns {number}
	 * @private
	 */
	function interpretTwoDigitYear(year) {
	  var thisYear = new Date().getFullYear();
	  var thisCentury = thisYear - thisYear % 100;
	  var centuries = [thisCentury, thisCentury - 100, thisCentury + 100].sort(function (a, b) {
	    return Math.abs(thisYear - (year + a)) - Math.abs(thisYear - (year + b));
	  });
	  return year + centuries[0];
	}
	
	/**
	 * @extends DelimitedTextFormatter
	 */
	
	var ExpiryDateFormatter = (function (_DelimitedTextFormatter) {
	  _inherits(ExpiryDateFormatter, _DelimitedTextFormatter);
	
	  function ExpiryDateFormatter() {
	    _classCallCheck(this, ExpiryDateFormatter);
	
	    _get(Object.getPrototypeOf(ExpiryDateFormatter.prototype), 'constructor', this).call(this, '/');
	    this.maximumLength = 5;
	  }
	
	  /**
	   * @param {number} index
	   * @returns {boolean}
	   */
	
	  _createClass(ExpiryDateFormatter, [{
	    key: 'hasDelimiterAtIndex',
	    value: function hasDelimiterAtIndex(index) {
	      return index === 2;
	    }
	
	    /**
	     * Formats the given value by adding delimiters where needed.
	     *
	     * @param {?string} value
	     * @returns {string}
	     */
	  }, {
	    key: 'format',
	    value: function format(value) {
	      if (!value) {
	        return '';
	      }
	
	      var month = value.month;
	      var year = value.year;
	
	      year = year % 100;
	
	      return _get(Object.getPrototypeOf(ExpiryDateFormatter.prototype), 'format', this).call(this, (0, _utils.zpad2)(month) + (0, _utils.zpad2)(year));
	    }
	
	    /**
	     * Parses the given text
	     *
	     * @param {string} text
	     * @param {Function(string)} error
	     * @returns {?Object} { month: month, year: year }
	     */
	  }, {
	    key: 'parse',
	    value: function parse(text, error) {
	      var monthAndYear = text.split(this.delimiter);
	      var month = monthAndYear[0];
	      var year = monthAndYear[1];
	      if (month && month.match(/^(0?[1-9]|1\d)$/) && year && year.match(/^\d\d?$/)) {
	        month = Number(month);
	        year = interpretTwoDigitYear(Number(year));
	        return { month: month, year: year };
	      } else {
	        if (typeof error === 'function') {
	          error('expiry-date-formatter.invalid-date');
	        }
	        return null;
	      }
	    }
	
	    /**
	     * Determines whether the given change should be allowed and, if so, whether
	     * it should be altered.
	     *
	     * @param {TextFieldStateChange} change
	     * @param {function(string)} error
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isChangeValid',
	    value: function isChangeValid(change, error) {
	      if (!error) {
	        error = function () {};
	      }
	
	      var isBackspace = change.proposed.text.length < change.current.text.length;
	      var newText = change.proposed.text;
	
	      if (change.inserted.text === this.delimiter && change.current.text === '1') {
	        newText = '01' + this.delimiter;
	      } else if (change.inserted.text.length > 0 && !/^\d$/.test(change.inserted.text)) {
	        error('expiry-date-formatter.only-digits-allowed');
	        return false;
	      } else {
	        if (isBackspace) {
	          if (change.deleted.text === this.delimiter) {
	            newText = newText[0];
	          }
	          if (newText === '0') {
	            newText = '';
	          }
	          if (change.inserted.text.length > 0 && !/^\d$/.test(change.inserted.text)) {
	            error('expiry-date-formatter.only-digits-allowed');
	            return false;
	          }
	        }
	
	        // 4| -> 04|
	        if (/^[2-9]$/.test(newText)) {
	          newText = '0' + newText;
	        }
	
	        // 1|1|/5 -> 11|/5
	        if (/^1[3-9].+$/.test(newText)) {
	          error('expiry-date-formatter.invalid-month');
	          return false;
	        }
	
	        // 15| -> 01/5|
	        if (/^1[3-9]$/.test(newText)) {
	          newText = '01' + this.delimiter + newText.slice(-1);
	        }
	
	        // Don't allow 00
	        if (newText === '00') {
	          error('expiry-date-formatter.invalid-month');
	          return false;
	        }
	
	        // 11| -> 11/
	        if (/^(0[1-9]|1[0-2])$/.test(newText)) {
	          newText += this.delimiter;
	        }
	
	        var match = newText.match(/^(\d\d)(.)(\d\d?).*$/);
	        if (match && match[2] === this.delimiter) {
	          newText = match[1] + this.delimiter + match[3];
	        }
	      }
	
	      change.proposed.text = newText;
	      change.proposed.selectedRange = { start: newText.length, length: 0 };
	
	      return true;
	    }
	  }]);
	
	  return ExpiryDateFormatter;
	})(_delimited_text_formatter2['default']);
	
	exports['default'] = ExpiryDateFormatter;
	module.exports = exports['default'];
	
	},{"./delimited_text_formatter":10,"./utils":22}],14:[function(_dereq_,module,exports){
	/**
	 * Base class providing basic formatting, parsing, and change validation to be
	 * customized in subclasses.
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var Formatter = (function () {
	  function Formatter() {
	    _classCallCheck(this, Formatter);
	  }
	
	  _createClass(Formatter, [{
	    key: 'format',
	
	    /**
	     * @param {string} text
	     * @returns {string}
	     */
	    value: function format(text) {
	      if (text === undefined || text === null) {
	        text = '';
	      }
	      if (this.maximumLength !== undefined && this.maximumLength !== null) {
	        text = text.substring(0, this.maximumLength);
	      }
	      return text;
	    }
	
	    /**
	     * @param {string} text
	     * @returns {string}
	     */
	  }, {
	    key: 'parse',
	    value: function parse(text) {
	      if (text === undefined || text === null) {
	        text = '';
	      }
	      if (this.maximumLength !== undefined && this.maximumLength !== null) {
	        text = text.substring(0, this.maximumLength);
	      }
	      return text;
	    }
	
	    /**
	     * Determines whether the given change should be allowed and, if so, whether
	     * it should be altered.
	     *
	     * @param {TextFieldStateChange} change
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isChangeValid',
	    value: function isChangeValid(change) {
	      var selectedRange = change.proposed.selectedRange;
	      var text = change.proposed.text;
	      if (this.maximumLength !== undefined && this.maximumLength !== null && text.length > this.maximumLength) {
	        var available = this.maximumLength - (text.length - change.inserted.text.length);
	        var newText = change.current.text.substring(0, change.current.selectedRange.start);
	        if (available > 0) {
	          newText += change.inserted.text.substring(0, available);
	        }
	        newText += change.current.text.substring(change.current.selectedRange.start + change.current.selectedRange.length);
	        var truncatedLength = text.length - newText.length;
	        change.proposed.text = newText;
	        selectedRange.start -= truncatedLength;
	      }
	      return true;
	    }
	  }]);
	
	  return Formatter;
	})();
	
	exports['default'] = Formatter;
	module.exports = exports['default'];
	
	},{}],15:[function(_dereq_,module,exports){
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _adaptive_card_formatter = _dereq_('./adaptive_card_formatter');
	
	var _adaptive_card_formatter2 = _interopRequireDefault(_adaptive_card_formatter);
	
	var _amex_card_formatter = _dereq_('./amex_card_formatter');
	
	var _amex_card_formatter2 = _interopRequireDefault(_amex_card_formatter);
	
	var _card_text_field = _dereq_('./card_text_field');
	
	var _card_text_field2 = _interopRequireDefault(_card_text_field);
	
	var _card_utils = _dereq_('./card_utils');
	
	var _default_card_formatter = _dereq_('./default_card_formatter');
	
	var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
	
	var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
	
	var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
	
	var _employer_identification_number_formatter = _dereq_('./employer_identification_number_formatter');
	
	var _employer_identification_number_formatter2 = _interopRequireDefault(_employer_identification_number_formatter);
	
	var _expiry_date_field = _dereq_('./expiry_date_field');
	
	var _expiry_date_field2 = _interopRequireDefault(_expiry_date_field);
	
	var _expiry_date_formatter = _dereq_('./expiry_date_formatter');
	
	var _expiry_date_formatter2 = _interopRequireDefault(_expiry_date_formatter);
	
	var _formatter = _dereq_('./formatter');
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var _number_formatter = _dereq_('./number_formatter');
	
	var _number_formatter2 = _interopRequireDefault(_number_formatter);
	
	var _number_formatter_settings_formatter = _dereq_('./number_formatter_settings_formatter');
	
	var _number_formatter_settings_formatter2 = _interopRequireDefault(_number_formatter_settings_formatter);
	
	var _phone_formatter = _dereq_('./phone_formatter');
	
	var _phone_formatter2 = _interopRequireDefault(_phone_formatter);
	
	var _social_security_number_formatter = _dereq_('./social_security_number_formatter');
	
	var _social_security_number_formatter2 = _interopRequireDefault(_social_security_number_formatter);
	
	var _text_field = _dereq_('./text_field');
	
	var _text_field2 = _interopRequireDefault(_text_field);
	
	var _undo_manager = _dereq_('./undo_manager');
	
	var _undo_manager2 = _interopRequireDefault(_undo_manager);
	
	/**
	 * @namespace FieldKit
	 * @readonly
	 */
	module.exports = {
	  AdaptiveCardFormatter: _adaptive_card_formatter2['default'],
	  AmexCardFormatter: _amex_card_formatter2['default'],
	  CardTextField: _card_text_field2['default'],
	  CardUtils: {
	    AMEX: _card_utils.AMEX,
	    DISCOVER: _card_utils.DISCOVER,
	    VISA: _card_utils.VISA,
	    MASTERCARD: _card_utils.MASTERCARD,
	    determineCardType: _card_utils.determineCardType,
	    luhnCheck: _card_utils.luhnCheck,
	    validCardLength: _card_utils.validCardLength
	  },
	  DefaultCardFormatter: _default_card_formatter2['default'],
	  DelimitedTextFormatter: _delimited_text_formatter2['default'],
	  EmployerIdentificationNumberFormatter: _employer_identification_number_formatter2['default'],
	  ExpiryDateField: _expiry_date_field2['default'],
	  ExpiryDateFormatter: _expiry_date_formatter2['default'],
	  Formatter: _formatter2['default'],
	  NumberFormatter: _number_formatter2['default'],
	  NumberFormatterSettingsFormatter: _number_formatter_settings_formatter2['default'],
	  PhoneFormatter: _phone_formatter2['default'],
	  SocialSecurityNumberFormatter: _social_security_number_formatter2['default'],
	  TextField: _text_field2['default'],
	  UndoManager: _undo_manager2['default']
	};
	
	},{"./adaptive_card_formatter":4,"./amex_card_formatter":5,"./card_text_field":6,"./card_utils":7,"./default_card_formatter":9,"./delimited_text_formatter":10,"./employer_identification_number_formatter":11,"./expiry_date_field":12,"./expiry_date_formatter":13,"./formatter":14,"./number_formatter":16,"./number_formatter_settings_formatter":17,"./phone_formatter":18,"./social_security_number_formatter":19,"./text_field":20,"./undo_manager":21}],16:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _formatter = _dereq_('./formatter');
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var _number_formatter_settings_formatter = _dereq_('./number_formatter_settings_formatter');
	
	var _number_formatter_settings_formatter2 = _interopRequireDefault(_number_formatter_settings_formatter);
	
	var _utils = _dereq_('./utils');
	
	var _stround = _dereq_('stround');
	
	// Style
	var NONE = 0;
	var CURRENCY = 1;
	var PERCENT = 2;
	
	var DEFAULT_LOCALE = 'en-US';
	var DEFAULT_COUNTRY = 'US';
	
	/**
	 * @param {string} locale
	 * @returns {Object} {lang: lang, country: country}
	 * @private
	 */
	function splitLocaleComponents(locale) {
	  var match = locale.match(/^([a-z][a-z])(?:[-_]([a-z][a-z]))?$/i);
	  if (match) {
	    var lang = match[1] && match[1].toLowerCase();
	    var country = match[2] && match[2].toLowerCase();
	    return { lang: lang, country: country };
	  }
	}
	
	/**
	 * This simple property getter assumes that properties will never be functions
	 * and so attempts to run those functions using the given args.
	 *
	 * @private
	 */
	function get(object, key) {
	  if (object) {
	    var value = object[key];
	    if (typeof value === 'function') {
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      return value.apply(undefined, args);
	    } else {
	      return value;
	    }
	  }
	}
	
	/**
	 * @param {string} string
	 * @param {string} currencySymbol
	 * @return {string}
	 * @private
	 */
	function replaceCurrencySymbol(string, currencySymbol) {
	  return string.replace(/¤/g, currencySymbol);
	}
	
	/**
	 * @param {string} string
	 * @param {string} plusSign
	 * @returns {string}
	 * @private
	 */
	function replacePlusSign(string, plusSign) {
	  return string.replace(/\+/g, plusSign);
	}
	/**
	 * @param {string} string
	 * @param {string} minusSign
	 * @returns {string}
	 * @private
	 */
	function replaceMinusSign(string, minusSign) {
	  return string.replace(/-/g, minusSign);
	}
	
	/**
	 * Formats and parses numbers. There are many configuration options for how to
	 * format numbers as strings, but for many users simply adjusting the
	 * {@link NumberFormatter#numberStyle}, {@link NumberFormatter#locale},
	 * {@link NumberFormatter#currencyCode}, and {@link NumberFormatter#countryCode}
	 * values will be sufficient. NumberFormatter natively understands how to
	 * format numbers, currencies, and percentages for a variety of locales.
	 *
	 * @example
	 *
	 *   // Configure a NumberFormatter to display currencies.
	 *   var f = new FieldKit.NumberFormatter();
	 *   f.setNumberStyle(FieldKit.NumberFormatter.Style.CURRENCY);
	 *
	 *   // Configure the current locale info.
	 *   f.setLocale('en-US');
	 *   f.setCountryCode('US');
	 *   f.setCurrencyCode('USD');
	 *
	 *   // Showing USD in US uses abbreviated currency.
	 *   f.format(6.17);  // '$6.17'
	 *
	 *   // Showing CAD in US uses fully-qualified currency.
	 *   f.setCurrencyCode('CAD');
	 *   f.format(6.17);  // 'CA$6.17'
	 *
	 *   // Showing CAD in CA again uses abbreviated currency.
	 *   f.setLocale('en-CA');
	 *   f.setCountryCode('CA');
	 *   f.format(6.17);  // '$6.17'
	 *
	 *   // Showing CAD in CA to a French speaker uses correct formatting.
	 *   f.setLocale('fr-CA');
	 *   f.format(6.17);  // '6,17 $'
	 *
	 *   // You may customize the behavior of NumberFormatter to achieve whatever
	 *   // number formatting you need using the setter methods for the various
	 *   // settings, or you can use the {@link NumberFormatter#positiveFormat} and
	 *   // {@link NumberFormatter#negativeFormat} shorthand templates.
	 *
	 *   var f = new FieldKit.NumberFormatter();
	 *
	 *   // Using this template string…
	 *   f.setPositiveFormat('¤#0.00');
	 *
	 *   // …is equivalent to this:
	 *   f.setPositivePrefix('¤');
	 *   f.setPositiveSuffix('');
	 *   f.setMinimumIntegerDigits(1);
	 *   f.setMinimumFractionDigits(2);
	 *   f.setMaximumFractionDigits(2);
	 *
	 *   // And you can determine what the template string is for however you've
	 *   // configured the NumberFormatter:
	 *   f.setUsesGroupingSeparator(true);
	 *   f.setGroupingSize(2);
	 *   f.positiveFormat(); // '¤#,#0.00'
	 *
	 * @extends Formatter
	 */
	
	var NumberFormatter = (function (_Formatter) {
	  _inherits(NumberFormatter, _Formatter);
	
	  function NumberFormatter() {
	    _classCallCheck(this, NumberFormatter);
	
	    _get(Object.getPrototypeOf(NumberFormatter.prototype), 'constructor', this).call(this);
	    this.setNumberStyle(NONE);
	  }
	
	  /**
	   * Defaults
	   */
	
	  /** @private */
	
	  /**
	   * Gets whether this formatter will parse float number values. This value does
	   * not apply to formatting. To prevent formatting floats, set
	   * maximumFractionDigits to 0.
	   *
	   * @returns {boolean}
	   */
	
	  _createClass(NumberFormatter, [{
	    key: 'allowsFloats',
	    value: function allowsFloats() {
	      return this._get('allowsFloats');
	    }
	
	    /**
	     * Sets whether this formatter will parse float number values.
	     *
	     * @param {boolean} allowsFloats
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setAllowsFloats',
	    value: function setAllowsFloats(allowsFloats) {
	      this._allowsFloats = allowsFloats;
	      return this;
	    }
	
	    /**
	     * Gets whether this formatter should show the decimal separator.
	     *
	     * @returns {boolean}
	     */
	  }, {
	    key: 'alwaysShowsDecimalSeparator',
	    value: function alwaysShowsDecimalSeparator() {
	      return this._get('alwaysShowsDecimalSeparator');
	    }
	
	    /**
	     * Sets whether this formatter will show the decimal separator.
	     *
	     * @param {boolean} alwaysShowsDecimalSeparator
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setAlwaysShowsDecimalSeparator',
	    value: function setAlwaysShowsDecimalSeparator(alwaysShowsDecimalSeparator) {
	      this._alwaysShowsDecimalSeparator = alwaysShowsDecimalSeparator;
	      return this;
	    }
	
	    /**
	     * Gets the country code for formatter.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'countryCode',
	    value: function countryCode() {
	      return this._countryCode || DEFAULT_COUNTRY;
	    }
	
	    /**
	     * Sets the country code for formatter.
	     *
	     * @param {string} countryCode
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setCountryCode',
	    value: function setCountryCode(countryCode) {
	      this._countryCode = countryCode;
	      return this;
	    }
	
	    /**
	     * Gets the currency code for formatter.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'currencyCode',
	    value: function currencyCode() {
	      return this._get('currencyCode');
	    }
	
	    /**
	     * Sets the currency code for formatter.
	     *
	     * @param {string} currencyCode
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setCurrencyCode',
	    value: function setCurrencyCode(currencyCode) {
	      this._currencyCode = currencyCode;
	      return this;
	    }
	
	    /**
	     * Gets the currency symbol for formatter.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'currencySymbol',
	    value: function currencySymbol() {
	      if (this._shouldShowNativeCurrencySymbol()) {
	        return this._get('currencySymbol');
	      } else {
	        return this._get('internationalCurrencySymbol');
	      }
	    }
	
	    /**
	     * Sets the currency symbol for formatter.
	     *
	     * @param {string} currencySymbol
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setCurrencySymbol',
	    value: function setCurrencySymbol(currencySymbol) {
	      this._currencySymbol = currencySymbol;
	      return this;
	    }
	
	    /**
	     * @returns {boolean}
	     * @private
	     */
	  }, {
	    key: '_shouldShowNativeCurrencySymbol',
	    value: function _shouldShowNativeCurrencySymbol() {
	      var regionDefaultCurrencyCode = this._regionDefaults().currencyCode;
	      if (typeof regionDefaultCurrencyCode === 'function') {
	        regionDefaultCurrencyCode = regionDefaultCurrencyCode();
	      }
	      return this.currencyCode() === regionDefaultCurrencyCode;
	    }
	
	    /**
	     * Gets the decimal separator for formatter.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'decimalSeparator',
	    value: function decimalSeparator() {
	      return this._get('decimalSeparator');
	    }
	
	    /**
	     * Sets the decimal separator for formatter.
	     *
	     * @param {string} decimalSeparator
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setDecimalSeparator',
	    value: function setDecimalSeparator(decimalSeparator) {
	      this._decimalSeparator = decimalSeparator;
	      return this;
	    }
	
	    /**
	     * Gets the number of decimal places to shift numbers before formatting.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'exponent',
	    value: function exponent() {
	      return this._get('exponent');
	    }
	
	    /**
	     * Sets the number of decimal places to shift numbers before formatting.
	     *
	     * @param exponent
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setExponent',
	    value: function setExponent(exponent) {
	      this._exponent = exponent;
	      return this;
	    }
	  }, {
	    key: 'groupingSeparator',
	    value: function groupingSeparator() {
	      return this._get('groupingSeparator');
	    }
	
	    /**
	     * @param {string} groupingSeparator
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setGroupingSeparator',
	    value: function setGroupingSeparator(groupingSeparator) {
	      this._groupingSeparator = groupingSeparator;
	      return this;
	    }
	
	    /**
	     * Gets the grouping size for formatter.
	     *
	     * @returns {number}
	     */
	  }, {
	    key: 'groupingSize',
	    value: function groupingSize() {
	      return this._get('groupingSize');
	    }
	
	    /**
	     * @param {number} groupingSize
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setGroupingSize',
	    value: function setGroupingSize(groupingSize) {
	      this._groupingSize = groupingSize;
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'internationalCurrencySymbol',
	    value: function internationalCurrencySymbol() {
	      return this._get('internationalCurrencySymbol');
	    }
	
	    /**
	     * @param {string} internationalCurrencySymbol
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setInternationalCurrencySymbol',
	    value: function setInternationalCurrencySymbol(internationalCurrencySymbol) {
	      this._internationalCurrencySymbol = internationalCurrencySymbol;
	      return this;
	    }
	
	    /**
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isLenient',
	    value: function isLenient() {
	      return this._lenient;
	    }
	
	    /**
	     * @param {boolean} lenient
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setLenient',
	    value: function setLenient(lenient) {
	      this._lenient = lenient;
	      return this;
	    }
	
	    /**
	     * Gets the locale identifier for which this formatter is currently
	     * configured to format strings. This setting controls default settings such
	     * as the grouping separator character, decimal separator character, placement
	     * of currency and percent symbols, etc.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'locale',
	    value: function locale() {
	      return this._locale || DEFAULT_LOCALE;
	    }
	
	    /**
	     * Sets the locale identifier used for default settings values.
	     *
	     * @see {@link NumberFormatter#locale}
	     * @param {string} locale
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setLocale',
	    value: function setLocale(locale) {
	      this._locale = locale;
	      return this;
	    }
	
	    /**
	     * @returns {number}
	     */
	  }, {
	    key: 'maximum',
	    value: function maximum() {
	      return this._maximum;
	    }
	
	    /**
	     * @param {number} max
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setMaximum',
	    value: function setMaximum(max) {
	      this._maximum = max;
	      return this;
	    }
	
	    /**
	     * @returns {number}
	     */
	  }, {
	    key: 'minimum',
	    value: function minimum() {
	      return this._minimum;
	    }
	
	    /**
	     * @param {number} min
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setMinimum',
	    value: function setMinimum(min) {
	      this._minimum = min;
	      return this;
	    }
	
	    /**
	     * @returns {number}
	     */
	  }, {
	    key: 'maximumFractionDigits',
	    value: function maximumFractionDigits() {
	      var result = this._get('maximumFractionDigits');
	      var minimumFractionDigits = this._minimumFractionDigits;
	      if (result !== null && result !== undefined && minimumFractionDigits !== null && minimumFractionDigits !== undefined && minimumFractionDigits > result) {
	        result = minimumFractionDigits;
	      }
	      return result;
	    }
	
	    /**
	     * @param {number} maximumFractionDigits
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setMaximumFractionDigits',
	    value: function setMaximumFractionDigits(maximumFractionDigits) {
	      this._maximumFractionDigits = maximumFractionDigits;
	      return this;
	    }
	
	    /**
	     * @returns {number}
	     */
	  }, {
	    key: 'minimumFractionDigits',
	    value: function minimumFractionDigits() {
	      var result = this._get('minimumFractionDigits');
	      var maximumFractionDigits = this._maximumFractionDigits;
	      if (result !== null && result !== undefined && maximumFractionDigits !== null && maximumFractionDigits !== undefined && maximumFractionDigits < result) {
	        result = maximumFractionDigits;
	      }
	      return result;
	    }
	
	    /**
	     * @param {number} minimumFractionDigits
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setMinimumFractionDigits',
	    value: function setMinimumFractionDigits(minimumFractionDigits) {
	      this._minimumFractionDigits = minimumFractionDigits;
	      return this;
	    }
	
	    /**
	     * @returns {number}
	     */
	  }, {
	    key: 'maximumIntegerDigits',
	    value: function maximumIntegerDigits() {
	      var result = this._get('maximumIntegerDigits');
	      var minimumIntegerDigits = this._minimumIntegerDigits;
	      if (result !== null && result !== undefined && minimumIntegerDigits !== null && minimumIntegerDigits !== undefined && minimumIntegerDigits > result) {
	        result = minimumIntegerDigits;
	      }
	      return result;
	    }
	
	    /**
	     * @param {number} maximumIntegerDigits
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setMaximumIntegerDigits',
	    value: function setMaximumIntegerDigits(maximumIntegerDigits) {
	      this._maximumIntegerDigits = maximumIntegerDigits;
	      return this;
	    }
	
	    /**
	     * @returns {number}
	     */
	  }, {
	    key: 'minimumIntegerDigits',
	    value: function minimumIntegerDigits() {
	      var result = this._get('minimumIntegerDigits');
	      var maximumIntegerDigits = this._maximumIntegerDigits;
	      if (result !== null && result !== undefined && maximumIntegerDigits !== null && maximumIntegerDigits !== undefined && maximumIntegerDigits < result) {
	        result = maximumIntegerDigits;
	      }
	      return result;
	    }
	
	    /**
	     * @param {number} minimumIntegerDigits
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setMinimumIntegerDigits',
	    value: function setMinimumIntegerDigits(minimumIntegerDigits) {
	      this._minimumIntegerDigits = minimumIntegerDigits;
	      return this;
	    }
	
	    /**
	     * Gets the minus sign used for negative numbers in some locales.
	     *
	     * @returns {?string}
	     */
	  }, {
	    key: 'minusSign',
	    value: function minusSign() {
	      return this._get('minusSign');
	    }
	
	    /**
	     * Sets the minus sign used for negative numbers in some locales.
	     *
	     * @param {?string} minusSign
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setMinusSign',
	    value: function setMinusSign(minusSign) {
	      this._minusSign = minusSign;
	      return this;
	    }
	
	    /**
	     * Gets the negative number format string for the current settings. For
	     * example, changing `minimumFractionDigits` from 0 to 3 would change this
	     * value from "-#" to "-#.000".
	     *
	     * @return {string}
	     */
	  }, {
	    key: 'negativeFormat',
	    value: function negativeFormat() {
	      return this.numberFormatFormatter().format({
	        alwaysShowsDecimalSeparator: this.alwaysShowsDecimalSeparator(),
	        groupingSize: this.groupingSize(),
	        maximumFractionDigits: this.maximumFractionDigits(),
	        minimumFractionDigits: this.minimumFractionDigits(),
	        minimumIntegerDigits: this.minimumIntegerDigits(),
	        prefix: this._get('negativePrefix'),
	        suffix: this._get('negativeSuffix'),
	        usesGroupingSeparator: this.usesGroupingSeparator()
	      });
	    }
	
	    /**
	     * Configures this number formatter according to the given format string.
	     * For most usages you should simply use
	     * {@link NumberFormatter#setPositiveFormat} and configure the negative
	     * prefix and suffix separately.
	     *
	     * @param negativeFormat
	     */
	  }, {
	    key: 'setNegativeFormat',
	    value: function setNegativeFormat(negativeFormat) {
	      var settings = this.numberFormatFormatter().parse(negativeFormat);
	      this.setNegativePrefix(settings.prefix);
	      this.setNegativeSuffix(settings.suffix);
	      this.setGroupingSize(settings.groupingSize);
	      this.setMaximumFractionDigits(settings.maximumFractionDigits);
	      this.setMinimumFractionDigits(settings.minimumFractionDigits);
	      this.setMinimumIntegerDigits(settings.minimumIntegerDigits);
	      this.setUsesGroupingSeparator(settings.usesGroupingSeparator);
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'negativeInfinitySymbol',
	    value: function negativeInfinitySymbol() {
	      return this._get('negativeInfinitySymbol');
	    }
	
	    /**
	     * @param {string} negativeInfinitySymbol
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setNegativeInfinitySymbol',
	    value: function setNegativeInfinitySymbol(negativeInfinitySymbol) {
	      this._negativeInfinitySymbol = negativeInfinitySymbol;
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'negativePrefix',
	    value: function negativePrefix() {
	      return replaceCurrencySymbol(replaceMinusSign(this._get('negativePrefix'), this._get('minusSign')), this.currencySymbol());
	    }
	
	    /**
	     * @param {string} prefix
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setNegativePrefix',
	    value: function setNegativePrefix(prefix) {
	      this._negativePrefix = prefix;
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'negativeSuffix',
	    value: function negativeSuffix() {
	      return replaceCurrencySymbol(replaceMinusSign(this._get('negativeSuffix'), this._get('minusSign')), this.currencySymbol());
	    }
	
	    /**
	     * @param {string} prefix
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setNegativeSuffix',
	    value: function setNegativeSuffix(prefix) {
	      this._negativeSuffix = prefix;
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'notANumberSymbol',
	    value: function notANumberSymbol() {
	      return this._get('notANumberSymbol');
	    }
	
	    /**
	     * @param {string} notANumberSymbol
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setNotANumberSymbol',
	    value: function setNotANumberSymbol(notANumberSymbol) {
	      this._notANumberSymbol = notANumberSymbol;
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'nullSymbol',
	    value: function nullSymbol() {
	      return this._get('nullSymbol');
	    }
	
	    /**
	     * @param {string} nullSymbol
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setNullSymbol',
	    value: function setNullSymbol(nullSymbol) {
	      this._nullSymbol = nullSymbol;
	      return this;
	    }
	
	    /**
	     * @return {NumberFormatterSettingsFormatter}
	     * @private
	     */
	  }, {
	    key: 'numberFormatFormatter',
	    value: function numberFormatFormatter() {
	      if (!this._numberFormatFormatter) {
	        this._numberFormatFormatter = new _number_formatter_settings_formatter2['default']();
	      }
	      return this._numberFormatFormatter;
	    }
	
	    /**
	     * Gets the number style used to configure various default setting values.
	     *
	     * @returns {NumberFormatter.Style}
	     */
	  }, {
	    key: 'numberStyle',
	    value: function numberStyle() {
	      return this._numberStyle;
	    }
	
	    /**
	     * Sets the number style used to configure various default setting values.
	     *
	     * @param {string} numberStyle
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setNumberStyle',
	    value: function setNumberStyle(numberStyle) {
	      this._numberStyle = numberStyle;
	      switch (this._numberStyle) {
	        case NONE:
	          this._styleDefaults = StyleDefaults.NONE;
	          break;
	        case PERCENT:
	          this._styleDefaults = StyleDefaults.PERCENT;
	          break;
	        case CURRENCY:
	          this._styleDefaults = StyleDefaults.CURRENCY;
	          break;
	        default:
	          this._styleDefaults = null;
	      }
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'percentSymbol',
	    value: function percentSymbol() {
	      return this._get('percentSymbol');
	    }
	
	    /**
	     * @param {string} percentSymbol
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setPercentSymbol',
	    value: function setPercentSymbol(percentSymbol) {
	      this._percentSymbol = percentSymbol;
	      return this;
	    }
	
	    /**
	     * Gets the plus sign used in positive numbers in some locales.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'plusSign',
	    value: function plusSign() {
	      return this._get('plusSign');
	    }
	
	    /**
	     * Sets the plus sign used in positive numbers in some locales.
	     *
	     * @param {?string} plusSign
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setPlusSign',
	    value: function setPlusSign(plusSign) {
	      this._plusSign = plusSign;
	      return this;
	    }
	
	    /**
	     * Gets the positive number format string for the current settings. For
	     * example, changing `minimumFractionDigits` from 0 to 3 would change this
	     * value from "#" to "#.000".
	     *
	     * @return {string}
	     */
	  }, {
	    key: 'positiveFormat',
	    value: function positiveFormat() {
	      return this.numberFormatFormatter().format({
	        alwaysShowsDecimalSeparator: this.alwaysShowsDecimalSeparator(),
	        groupingSize: this.groupingSize(),
	        maximumFractionDigits: this.maximumFractionDigits(),
	        minimumFractionDigits: this.minimumFractionDigits(),
	        minimumIntegerDigits: this.minimumIntegerDigits(),
	        prefix: this._get('positivePrefix'),
	        suffix: this._get('positiveSuffix'),
	        usesGroupingSeparator: this.usesGroupingSeparator()
	      });
	    }
	
	    /**
	     * Configures this number formatter according to the given format string.
	     *
	     * @example
	     *
	     *   // Use '0' for padding, '.' for decimal separator.
	     *   formatter.setPositiveFormat('00.000');
	     *   formatter.format(2);     // '02.000'
	     *   formatter.format(-5.03); // '-05.030'
	     *   formatter.setLocale('fr-FR');
	     *   formatter.format(2);     // '02,000'
	     *
	     *   // Use '#' for maximum fraction digits.
	     *   formatter.setPositiveFormat('#.##');
	     *   formatter.format(3.456); // '3.46'
	     *
	     *   // Use '¤' as the currency placeholder.
	     *   formatter.setPositiveFormat('¤#0.00');
	     *   formatter.format(1.23); // '$1.23'
	     *   formatter.setCurrencyCode('JPY');
	     *   formatter.format(81);   // 'JP¥81.00'
	     *   formatter.setLocale('jp-JP');
	     *   formatter.format(7);   // '¥7.00'
	     *
	     *   // Use ',' for grouping separator placement.
	     *   formatter.setPositiveFormat('#,##');
	     *   formatter.format(123); // '1,23'
	     *
	     * @param positiveFormat
	     */
	  }, {
	    key: 'setPositiveFormat',
	    value: function setPositiveFormat(positiveFormat) {
	      var settings = this.numberFormatFormatter().parse(positiveFormat);
	      this.setPositivePrefix(settings.prefix);
	      this.setPositiveSuffix(settings.suffix);
	      this.setGroupingSize(settings.groupingSize);
	      this.setMaximumFractionDigits(settings.maximumFractionDigits);
	      this.setMinimumFractionDigits(settings.minimumFractionDigits);
	      this.setMinimumIntegerDigits(settings.minimumIntegerDigits);
	      this.setUsesGroupingSeparator(settings.usesGroupingSeparator);
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'positiveInfinitySymbol',
	    value: function positiveInfinitySymbol() {
	      return this._get('positiveInfinitySymbol');
	    }
	
	    /**
	     * @param {string} positiveInfinitySymbol
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setPositiveInfinitySymbol',
	    value: function setPositiveInfinitySymbol(positiveInfinitySymbol) {
	      this._positiveInfinitySymbol = positiveInfinitySymbol;
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'positivePrefix',
	    value: function positivePrefix() {
	      return replaceCurrencySymbol(replacePlusSign(this._get('positivePrefix'), this._get('plusSign')), this.currencySymbol());
	    }
	
	    /**
	     * @param {string} prefix
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setPositivePrefix',
	    value: function setPositivePrefix(prefix) {
	      this._positivePrefix = prefix;
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'positiveSuffix',
	    value: function positiveSuffix() {
	      return replaceCurrencySymbol(replacePlusSign(this._get('positiveSuffix'), this._get('plusSign')), this.currencySymbol());
	    }
	
	    /**
	     * @param {string} prefix
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setPositiveSuffix',
	    value: function setPositiveSuffix(prefix) {
	      this._positiveSuffix = prefix;
	      return this;
	    }
	
	    /**
	     * @returns {Function}
	     */
	  }, {
	    key: 'roundingMode',
	    value: function roundingMode() {
	      return this._get('roundingMode');
	    }
	
	    /**
	     * @param {Function} roundingMode
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setRoundingMode',
	    value: function setRoundingMode(roundingMode) {
	      this._roundingMode = roundingMode;
	      return this;
	    }
	
	    /**
	     * @returns {boolean}
	     */
	  }, {
	    key: 'usesGroupingSeparator',
	    value: function usesGroupingSeparator() {
	      return this._get('usesGroupingSeparator');
	    }
	
	    /**
	     * @param {boolean} usesGroupingSeparator
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setUsesGroupingSeparator',
	    value: function setUsesGroupingSeparator(usesGroupingSeparator) {
	      this._usesGroupingSeparator = usesGroupingSeparator;
	      return this;
	    }
	
	    /**
	     * @returns {string}
	     */
	  }, {
	    key: 'zeroSymbol',
	    value: function zeroSymbol() {
	      return this._get('zeroSymbol');
	    }
	
	    /**
	     * @param {string} zeroSymbol
	     * @returns {NumberFormatter}
	     */
	  }, {
	    key: 'setZeroSymbol',
	    value: function setZeroSymbol(zeroSymbol) {
	      this._zeroSymbol = zeroSymbol;
	      return this;
	    }
	
	    /**
	     * @param {string} attr
	     * @returns {*}
	     * @private
	     */
	  }, {
	    key: '_get',
	    value: function _get(attr) {
	      var value = this['_' + attr];
	      if (value !== null && value !== undefined) {
	        return value;
	      }
	      var styleDefaults = this._styleDefaults;
	      var localeDefaults = this._localeDefaults();
	      var regionDefaults = this._regionDefaults();
	      value = get(styleDefaults, attr, this, localeDefaults);
	      if (value !== null && value !== undefined) {
	        return value;
	      }
	      value = get(localeDefaults, attr, this, styleDefaults);
	      if (value !== null && value !== undefined) {
	        return value;
	      }
	      value = get(regionDefaults, attr, this, styleDefaults);
	      if (value !== null && value !== undefined) {
	        return value;
	      }
	      value = get(this._currencyDefaults(), attr, this, localeDefaults);
	      if (value !== null && value !== undefined) {
	        return value;
	      }
	      return null;
	    }
	
	    /**
	     * Formats the given number as a string according to the settings applied to
	     * this formatter. This may cause the number to be truncated, rounded, or
	     * otherwise differ from what you might expect.
	     *
	     * @example
	     *
	     *   // By default no fraction digits are shown.
	     *   var f = new FieldKit.NumberFormatter();
	     *   f.format(Math.PI);  // '3'
	     *
	     *   // Let's format as a currency.
	     *   f.setNumberStyle(FieldKit.NumberFormatter.Style.CURRENCY);
	     *   f.format(Math.PI);  // '$3.14'
	     *
	     *   // Or as a percentage, which illustrates usage of {@link NumberFormatter#exponent}.
	     *   f.setNumberStyle(FieldKit.NumberFormatter.Style.PERCENT);
	     *   f.format(Math.PI);  // '314%'
	     *
	     *   // For the rest of the examples we'll go back to normal.
	     *   f.setNumberStyle(FieldKit.NumberFormatter.Style.NONE);
	     *
	     *   // The default rounding mode is {@link NumberFormatter.Rounding.HALF_EVEN}.
	     *   f.setMaximumFractionDigits(4);
	     *   f.format(Math.PI);  // '3.1416'
	     *
	     *   // And we can change the rounding mode if we like.
	     *   f.setRoundingMode(FieldKit.NumberFormatter.Rounding.FLOOR);
	     *   f.format(Math.PI);  // '3.1415'
	     *
	     * @param {number} number
	     * @returns {string}
	     */
	  }, {
	    key: 'format',
	    value: function format(number) {
	      if (number === '') {
	        return '';
	      }
	
	      var zeroSymbol = this.zeroSymbol();
	      if (zeroSymbol !== undefined && zeroSymbol !== null && number === 0) {
	        return zeroSymbol;
	      }
	
	      var nullSymbol = this.nullSymbol();
	      if (nullSymbol !== undefined && nullSymbol !== null && number === null) {
	        return nullSymbol;
	      }
	
	      var notANumberSymbol = this.notANumberSymbol();
	      if (notANumberSymbol !== undefined && notANumberSymbol !== null && isNaN(number)) {
	        return notANumberSymbol;
	      }
	
	      var positiveInfinitySymbol = this.positiveInfinitySymbol();
	      if (positiveInfinitySymbol !== undefined && positiveInfinitySymbol !== null && number === Infinity) {
	        return positiveInfinitySymbol;
	      }
	
	      var negativeInfinitySymbol = this.negativeInfinitySymbol();
	      if (negativeInfinitySymbol !== undefined && negativeInfinitySymbol !== null && number === -Infinity) {
	        return negativeInfinitySymbol;
	      }
	
	      var negative = number < 0;
	
	      var parts = ('' + Math.abs(number)).split('.');
	      var integerPart = parts[0];
	      var fractionPart = parts[1] || '';
	
	      var exponent = this.exponent();
	      if (exponent !== undefined && exponent !== null) {
	        var shifted = (0, _stround.shiftParts)([negative, integerPart, fractionPart], exponent);
	        negative = shifted[0];
	        integerPart = shifted[1];
	        fractionPart = shifted[2];
	        while (integerPart[0] === '0') {
	          integerPart = integerPart.slice(1);
	        }
	      }
	
	      // round fraction part to the maximum length
	      var maximumFractionDigits = this.maximumFractionDigits();
	      if (fractionPart.length > maximumFractionDigits) {
	        var unrounded = integerPart + '.' + fractionPart;
	        var rounded = this._round(negative ? '-' + unrounded : unrounded);
	        if (rounded[0] === '-') {
	          rounded = rounded.slice(1);
	        }
	        parts = rounded.split('.');
	        integerPart = parts[0];
	        fractionPart = parts[1] || '';
	      }
	
	      // right-pad fraction zeros up to the minimum length
	      var minimumFractionDigits = this.minimumFractionDigits();
	      while (fractionPart.length < minimumFractionDigits) {
	        fractionPart += '0';
	      }
	
	      // left-pad integer zeros up to the minimum length
	      var minimumIntegerDigits = this.minimumIntegerDigits();
	      while (integerPart.length < minimumIntegerDigits) {
	        integerPart = '0' + integerPart;
	      }
	
	      // eat any unneeded trailing zeros
	      while (fractionPart.length > minimumFractionDigits && fractionPart.slice(-1) === '0') {
	        fractionPart = fractionPart.slice(0, -1);
	      }
	
	      // left-truncate any integer digits over the maximum length
	      var maximumIntegerDigits = this.maximumIntegerDigits();
	      if (maximumIntegerDigits !== undefined && maximumIntegerDigits !== null && integerPart.length > maximumIntegerDigits) {
	        integerPart = integerPart.slice(-maximumIntegerDigits);
	      }
	
	      // add the decimal separator
	      if (fractionPart.length > 0 || this.alwaysShowsDecimalSeparator()) {
	        fractionPart = this.decimalSeparator() + fractionPart;
	      }
	
	      if (this.usesGroupingSeparator()) {
	        var integerPartWithGroupingSeparators = '';
	        var copiedCharacterCount = 0;
	
	        for (var i = integerPart.length - 1; i >= 0; i--) {
	          if (copiedCharacterCount > 0 && copiedCharacterCount % this.groupingSize() === 0) {
	            integerPartWithGroupingSeparators = this.groupingSeparator() + integerPartWithGroupingSeparators;
	          }
	          integerPartWithGroupingSeparators = integerPart[i] + integerPartWithGroupingSeparators;
	          copiedCharacterCount++;
	        }
	        integerPart = integerPartWithGroupingSeparators;
	      }
	
	      var result = integerPart + fractionPart;
	
	      // surround with the appropriate prefix and suffix
	      if (negative) {
	        result = this.negativePrefix() + result + this.negativeSuffix();
	      } else {
	        result = this.positivePrefix() + result + this.positiveSuffix();
	      }
	      return result;
	    }
	
	    /**
	     * @param {number} number
	     * @returns {number}
	     * @private
	     */
	  }, {
	    key: '_round',
	    value: function _round(number) {
	      return (0, _stround.round)(number, this.maximumFractionDigits(), this.roundingMode());
	    }
	
	    /**
	     * Parses the given string according to the current formatting settings.
	     * When parsing values with a guaranteed regular format you can simply
	     * configure the formatter correctly and call this method. However, when
	     * dealing with human input it is often useful to configure
	     * {@link NumberFormatter#isLenient} to be true, allowing more leeway in what
	     * may be parsed as a valid number.
	     *
	     * @example
	     *
	     *   var f = new FieldKit.NumberFormatter();
	     *   f.parse('89'); // 89
	     *
	     * @param {string} string
	     * @param {function(string)} error
	     * @returns {?number}
	     */
	  }, {
	    key: 'parse',
	    value: function parse(string, error) {
	      var result = undefined;
	      var positivePrefix = this.positivePrefix();
	      var negativePrefix = this.negativePrefix();
	      var positiveSuffix = this.positiveSuffix();
	      var negativeSuffix = this.negativeSuffix();
	
	      if (this.isLenient()) {
	        string = string.replace(/\s/g, '');
	        positivePrefix = (0, _utils.trim)(positivePrefix);
	        negativePrefix = (0, _utils.trim)(negativePrefix);
	        positiveSuffix = (0, _utils.trim)(positiveSuffix);
	        negativeSuffix = (0, _utils.trim)(negativeSuffix);
	      }
	
	      var zeroSymbol = undefined;
	      var nullSymbol = undefined;
	      var notANumberSymbol = undefined;
	      var positiveInfinitySymbol = undefined;
	      var negativeInfinitySymbol = undefined;
	      var innerString = undefined;
	
	      if ((zeroSymbol = this.zeroSymbol()) !== undefined && zeroSymbol !== null && string === zeroSymbol) {
	        result = 0;
	      } else if ((nullSymbol = this.nullSymbol()) !== undefined && nullSymbol !== null && string === nullSymbol) {
	        result = null;
	      } else if ((notANumberSymbol = this.notANumberSymbol()) !== undefined && notANumberSymbol !== null && string === notANumberSymbol) {
	        result = NaN;
	      } else if ((positiveInfinitySymbol = this.positiveInfinitySymbol()) !== undefined && positiveInfinitySymbol !== null && string === positiveInfinitySymbol) {
	        result = Infinity;
	      } else if ((negativeInfinitySymbol = this.negativeInfinitySymbol()) !== undefined && negativeInfinitySymbol !== null && string === negativeInfinitySymbol) {
	        result = -Infinity;
	      } else {
	        var hasNegativePrefix = (0, _utils.startsWith)(negativePrefix, string);
	        var hasNegativeSuffix = (0, _utils.endsWith)(negativeSuffix, string);
	        if (hasNegativePrefix && (this.isLenient() || hasNegativeSuffix)) {
	          innerString = string.slice(negativePrefix.length);
	          if (hasNegativeSuffix) {
	            innerString = innerString.slice(0, innerString.length - negativeSuffix.length);
	          }
	          result = this._parseAbsoluteValue(innerString, error);
	          if (result !== undefined && result !== null) {
	            result *= -1;
	          }
	        } else {
	          var hasPositivePrefix = (0, _utils.startsWith)(positivePrefix, string);
	          var hasPositiveSuffix = (0, _utils.endsWith)(positiveSuffix, string);
	          if (this.isLenient() || hasPositivePrefix && hasPositiveSuffix) {
	            innerString = string;
	            if (hasPositivePrefix) {
	              innerString = innerString.slice(positivePrefix.length);
	            }
	            if (hasPositiveSuffix) {
	              innerString = innerString.slice(0, innerString.length - positiveSuffix.length);
	            }
	            result = this._parseAbsoluteValue(innerString, error);
	          } else {
	            if (typeof error === 'function') {
	              error('number-formatter.invalid-format');
	            }
	            return null;
	          }
	        }
	      }
	
	      if (result !== undefined && result !== null) {
	        var minimum = this.minimum();
	        if (minimum !== undefined && minimum !== null && result < minimum) {
	          if (typeof error === 'function') {
	            error('number-formatter.out-of-bounds.below-minimum');
	          }
	          return null;
	        }
	
	        var maximum = this.maximum();
	        if (maximum !== undefined && maximum !== null && result > maximum) {
	          if (typeof error === 'function') {
	            error('number-formatter.out-of-bounds.above-maximum');
	          }
	          return null;
	        }
	      }
	
	      return result;
	    }
	
	    /**
	     * @param {string} string
	     * @param {function(string)} error
	     * @returns {?number} returns value with delimiters removed
	     * @private
	     */
	  }, {
	    key: '_parseAbsoluteValue',
	    value: function _parseAbsoluteValue(string, error) {
	      var number = undefined;
	      if (string.length === 0) {
	        if (typeof error === 'function') {
	          error('number-formatter.invalid-format');
	        }
	        return null;
	      }
	
	      var parts = string.split(this.decimalSeparator());
	      if (parts.length > 2) {
	        if (typeof error === 'function') {
	          error('number-formatter.invalid-format');
	        }
	        return null;
	      }
	
	      var integerPart = parts[0];
	      var fractionPart = parts[1] || '';
	
	      if (this.usesGroupingSeparator()) {
	        var groupingSize = this.groupingSize();
	        var groupParts = integerPart.split(this.groupingSeparator());
	
	        if (!this.isLenient()) {
	          if (groupParts.length > 1) {
	            // disallow 1000,000
	            if (groupParts[0].length > groupingSize) {
	              if (typeof error === 'function') {
	                error('number-formatter.invalid-format.grouping-size');
	              }
	              return null;
	            }
	
	            // disallow 1,00
	            var groupPartsTail = groupParts.slice(1);
	            for (var i = 0, l = groupPartsTail.length; i < l; i++) {
	              if (groupPartsTail[i].length !== groupingSize) {
	                if (typeof error === 'function') {
	                  error('number-formatter.invalid-format.grouping-size');
	                }
	                return null;
	              }
	            }
	          }
	        }
	
	        // remove grouping separators
	        integerPart = groupParts.join('');
	      }
	
	      if (!(0, _utils.isDigits)(integerPart) || !(0, _utils.isDigits)(fractionPart)) {
	        if (typeof error === 'function') {
	          error('number-formatter.invalid-format');
	        }
	        return null;
	      }
	
	      var exponent = this.exponent();
	      if (exponent !== undefined && exponent !== null) {
	        var shifted = (0, _stround.shiftParts)([false, integerPart, fractionPart], -exponent);
	        integerPart = shifted[1];
	        fractionPart = shifted[2];
	      }
	
	      number = Number(integerPart) + Number('.' + (fractionPart || '0'));
	
	      if (!this.allowsFloats() && number !== ~ ~number) {
	        if (typeof error === 'function') {
	          error('number-formatter.floats-not-allowed');
	        }
	        return null;
	      }
	
	      return number;
	    }
	
	    /**
	     * Gets defaults.
	     *
	     * @returns {Array}
	     * @private
	     */
	  }, {
	    key: '_currencyDefaults',
	    value: function _currencyDefaults() {
	      var result = {};
	
	      (0, _utils.forEach)(CurrencyDefaults['default'], function (value, key) {
	        result[key] = value;
	      });
	
	      (0, _utils.forEach)(CurrencyDefaults[this.currencyCode()], function (value, key) {
	        result[key] = value;
	      });
	
	      return result;
	    }
	
	    /**
	     * Gets defaults.
	     *
	     * @returns {Array}
	     * @private
	     */
	  }, {
	    key: '_regionDefaults',
	    value: function _regionDefaults() {
	      var result = {};
	
	      (0, _utils.forEach)(RegionDefaults['default'], function (value, key) {
	        result[key] = value;
	      });
	
	      (0, _utils.forEach)(RegionDefaults[this.countryCode()], function (value, key) {
	        result[key] = value;
	      });
	
	      return result;
	    }
	
	    /**
	     * Gets defaults.
	     *
	     * @returns {Array}
	     * @private
	     */
	  }, {
	    key: '_localeDefaults',
	    value: function _localeDefaults() {
	      var locale = this.locale();
	      var countryCode = this.countryCode();
	      var lang = splitLocaleComponents(locale).lang;
	      var result = {};
	
	      var defaultFallbacks = [RegionDefaults['default'], LocaleDefaults['default'], RegionDefaults[countryCode], // CA
	      LocaleDefaults[lang], // fr
	      LocaleDefaults[locale] // fr-CA
	      ];
	
	      (0, _utils.forEach)(defaultFallbacks, function (defaults) {
	        (0, _utils.forEach)(defaults, function (value, key) {
	          result[key] = value;
	        });
	      });
	
	      return result;
	    }
	  }]);
	
	  return NumberFormatter;
	})(_formatter2['default']);
	
	NumberFormatter.prototype._allowsFloats = null;
	/** @private */
	NumberFormatter.prototype._alwaysShowsDecimalSeparator = null;
	/** @private */
	NumberFormatter.prototype._countryCode = null;
	/** @private */
	NumberFormatter.prototype._currencyCode = null;
	/** @private */
	NumberFormatter.prototype._exponent = null;
	/** @private */
	NumberFormatter.prototype._groupingSeparator = null;
	/** @private */
	NumberFormatter.prototype._groupingSize = null;
	/** @private */
	NumberFormatter.prototype._lenient = false;
	/** @private */
	NumberFormatter.prototype._locale = null;
	/** @private */
	NumberFormatter.prototype._internationalCurrencySymbol = null;
	/** @private */
	NumberFormatter.prototype._maximumFractionDigits = null;
	/** @private */
	NumberFormatter.prototype._minimumFractionDigits = null;
	/** @private */
	NumberFormatter.prototype._maximumIntegerDigits = null;
	/** @private */
	NumberFormatter.prototype._minimumIntegerDigits = null;
	/** @private */
	NumberFormatter.prototype._maximum = null;
	/** @private */
	NumberFormatter.prototype._minimum = null;
	/** @private */
	NumberFormatter.prototype._notANumberSymbol = null;
	/** @private */
	NumberFormatter.prototype._nullSymbol = null;
	/** @private */
	NumberFormatter.prototype._numberStyle = null;
	/** @private */
	NumberFormatter.prototype._roundingMode = null;
	/** @private */
	NumberFormatter.prototype._usesGroupingSeparator = null;
	/** @private */
	NumberFormatter.prototype._zeroSymbol = null;
	
	/**
	 * Aliases
	 */
	
	NumberFormatter.prototype.stringFromNumber = NumberFormatter.prototype.format;
	NumberFormatter.prototype.numberFromString = NumberFormatter.prototype.parse;
	
	NumberFormatter.Rounding = _stround.modes;
	
	/**
	 * @enum {number}
	 * @readonly
	 */
	NumberFormatter.Style = {
	  NONE: NONE,
	  CURRENCY: CURRENCY,
	  PERCENT: PERCENT
	};
	
	/**
	 * @namespace StyleDefaults
	 */
	var StyleDefaults = {
	  NONE: {
	    usesGroupingSeparator: false,
	    minimumFractionDigits: 0,
	    maximumFractionDigits: 0,
	    minimumIntegerDigits: 0
	  },
	  PERCENT: {
	    usesGroupingSeparator: false,
	    exponent: 2,
	    minimumFractionDigits: 0,
	    maximumFractionDigits: 0,
	    minimumIntegerDigits: 1,
	    positiveSuffix: function positiveSuffix(formatter) {
	      return formatter.percentSymbol();
	    },
	    negativeSuffix: function negativeSuffix(formatter) {
	      return formatter.percentSymbol();
	    }
	  },
	  CURRENCY: {
	    positivePrefix: function positivePrefix(formatter, locale) {
	      return get(locale, 'positiveCurrencyPrefix', formatter, this);
	    },
	    positiveSuffix: function positiveSuffix(formatter, locale) {
	      return get(locale, 'positiveCurrencySuffix', formatter, this);
	    },
	    negativePrefix: function negativePrefix(formatter, locale) {
	      return get(locale, 'negativeCurrencyPrefix', formatter, this);
	    },
	    negativeSuffix: function negativeSuffix(formatter, locale) {
	      return get(locale, 'negativeCurrencySuffix', formatter, this);
	    }
	  }
	};
	
	/**
	 * Contains the default values for various number formatter settings, including
	 * per-locale overrides. Some of these characters will not be used as-is and
	 * instead serve as placeholders:
	 *
	 *   "¤"  placeholder for `currencySymbol()`.
	 *   "-"  placeholder for `minusSign()`.
	 *   "+"  placeholder for `plusSign()`.
	 *
	 * @namespace LocaleDefaults
	 */
	var LocaleDefaults = {
	  'default': {
	    allowsFloats: true,
	    alwaysShowsDecimalSeparator: false,
	    decimalSeparator: '.',
	    groupingSeparator: ',',
	    groupingSize: 3,
	    minusSign: '-',
	    negativeInfinitySymbol: '-∞',
	    negativePrefix: '-',
	    negativeSuffix: '',
	    notANumberSymbol: 'NaN',
	    nullSymbol: '',
	    percentSymbol: '%',
	    positiveInfinitySymbol: '+∞',
	    positivePrefix: '',
	    positiveSuffix: '',
	    plusSign: '+',
	    roundingMode: NumberFormatter.Rounding.HALF_EVEN,
	    positiveCurrencyPrefix: '¤',
	    positiveCurrencySuffix: '',
	    negativeCurrencyPrefix: '(¤',
	    negativeCurrencySuffix: ')'
	  },
	  fr: {
	    decimalSeparator: ',',
	    groupingSeparator: ' ',
	    percentSymbol: ' %',
	    positiveCurrencyPrefix: '',
	    positiveCurrencySuffix: ' ¤',
	    negativeCurrencyPrefix: '(',
	    negativeCurrencySuffix: ' ¤)'
	  },
	  ja: {
	    negativeCurrencyPrefix: '-¤',
	    negativeCurrencySuffix: ''
	  },
	  'en-GB': {
	    negativeCurrencyPrefix: '-¤',
	    negativeCurrencySuffix: ''
	  }
	};
	
	/**
	 * @namespace RegionDefaults
	 */
	var RegionDefaults = {
	  AE: {
	    currencyCode: 'AED'
	  },
	  AG: {
	    currencyCode: 'XCD'
	  },
	  AI: {
	    currencyCode: 'XCD'
	  },
	  AL: {
	    currencyCode: 'ALL'
	  },
	  AM: {
	    currencyCode: 'AMD'
	  },
	  AO: {
	    currencyCode: 'AOA'
	  },
	  AR: {
	    currencyCode: 'ARS'
	  },
	  AT: {
	    currencyCode: 'EUR'
	  },
	  AU: {
	    currencyCode: 'AUD'
	  },
	  AW: {
	    currencyCode: 'AWG'
	  },
	  AZ: {
	    currencyCode: 'AZN'
	  },
	  BA: {
	    currencyCode: 'BAM'
	  },
	  BB: {
	    currencyCode: 'BBD'
	  },
	  BD: {
	    currencyCode: 'BDT'
	  },
	  BE: {
	    currencyCode: 'EUR'
	  },
	  BF: {
	    currencyCode: 'XOF'
	  },
	  BG: {
	    currencyCode: 'BGN'
	  },
	  BH: {
	    currencyCode: 'BHD'
	  },
	  BJ: {
	    currencyCode: 'XOF'
	  },
	  BM: {
	    currencyCode: 'BMD'
	  },
	  BN: {
	    currencyCode: 'BND'
	  },
	  BO: {
	    currencyCode: 'BOB'
	  },
	  BR: {
	    currencyCode: 'BRL'
	  },
	  BS: {
	    currencyCode: 'BSD'
	  },
	  BT: {
	    currencyCode: 'BTN'
	  },
	  BW: {
	    currencyCode: 'BWP'
	  },
	  BY: {
	    currencyCode: 'BYR'
	  },
	  BZ: {
	    currencyCode: 'BZD'
	  },
	  CA: {
	    currencyCode: 'CAD'
	  },
	  CG: {
	    currencyCode: 'CDF'
	  },
	  CH: {
	    currencyCode: 'CHF'
	  },
	  CI: {
	    currencyCode: 'XOF'
	  },
	  CL: {
	    currencyCode: 'CLP'
	  },
	  CM: {
	    currencyCode: 'XAF'
	  },
	  CN: {
	    currencyCode: 'CNY'
	  },
	  CO: {
	    currencyCode: 'COP'
	  },
	  CR: {
	    currencyCode: 'CRC'
	  },
	  CV: {
	    currencyCode: 'CVE'
	  },
	  CY: {
	    currencyCode: 'EUR'
	  },
	  CZ: {
	    currencyCode: 'CZK'
	  },
	  DE: {
	    currencyCode: 'EUR'
	  },
	  DK: {
	    currencyCode: 'DKK'
	  },
	  DM: {
	    currencyCode: 'XCD'
	  },
	  DO: {
	    currencyCode: 'DOP'
	  },
	  DZ: {
	    currencyCode: 'DZD'
	  },
	  EC: {
	    currencyCode: 'USD'
	  },
	  EE: {
	    currencyCode: 'EUR'
	  },
	  EG: {
	    currencyCode: 'EGP'
	  },
	  ES: {
	    currencyCode: 'EUR'
	  },
	  ET: {
	    currencyCode: 'ETB'
	  },
	  FI: {
	    currencyCode: 'EUR'
	  },
	  FJ: {
	    currencyCode: 'FJD'
	  },
	  FM: {
	    currencyCode: 'USD'
	  },
	  FR: {
	    currencyCode: 'EUR'
	  },
	  GA: {
	    currencyCode: 'XAF'
	  },
	  GB: {
	    currencyCode: 'GBP'
	  },
	  GD: {
	    currencyCode: 'XCD'
	  },
	  GE: {
	    currencyCode: 'GEL'
	  },
	  GH: {
	    currencyCode: 'GHS'
	  },
	  GI: {
	    currencyCode: 'GIP'
	  },
	  GM: {
	    currencyCode: 'GMD'
	  },
	  GR: {
	    currencyCode: 'EUR'
	  },
	  GT: {
	    currencyCode: 'GTQ'
	  },
	  GU: {
	    currencyCode: 'USD'
	  },
	  GW: {
	    currencyCode: 'XOF'
	  },
	  GY: {
	    currencyCode: 'GYD'
	  },
	  HK: {
	    currencyCode: 'HKD'
	  },
	  HN: {
	    currencyCode: 'HNL'
	  },
	  HR: {
	    currencyCode: 'HRK'
	  },
	  HT: {
	    currencyCode: 'HTG'
	  },
	  HU: {
	    currencyCode: 'HUF'
	  },
	  ID: {
	    currencyCode: 'IDR'
	  },
	  IE: {
	    currencyCode: 'EUR'
	  },
	  IL: {
	    currencyCode: 'ILS'
	  },
	  IN: {
	    currencyCode: 'INR'
	  },
	  IS: {
	    currencyCode: 'ISK'
	  },
	  IT: {
	    currencyCode: 'EUR'
	  },
	  JM: {
	    currencyCode: 'JMD'
	  },
	  JO: {
	    currencyCode: 'JOD'
	  },
	  JP: {
	    currencyCode: 'JPY'
	  },
	  KE: {
	    currencyCode: 'KES'
	  },
	  KG: {
	    currencyCode: 'KGS'
	  },
	  KH: {
	    currencyCode: 'KHR'
	  },
	  KN: {
	    currencyCode: 'XCD'
	  },
	  KR: {
	    currencyCode: 'KRW'
	  },
	  KW: {
	    currencyCode: 'KWD'
	  },
	  KY: {
	    currencyCode: 'KYD'
	  },
	  KZ: {
	    currencyCode: 'KZT'
	  },
	  LA: {
	    currencyCode: 'LAK'
	  },
	  LB: {
	    currencyCode: 'LBP'
	  },
	  LC: {
	    currencyCode: 'XCD'
	  },
	  LI: {
	    currencyCode: 'CHF'
	  },
	  LK: {
	    currencyCode: 'LKR'
	  },
	  LR: {
	    currencyCode: 'LRD'
	  },
	  LT: {
	    currencyCode: 'LTL'
	  },
	  LU: {
	    currencyCode: 'EUR'
	  },
	  LV: {
	    currencyCode: 'EUR'
	  },
	  MA: {
	    currencyCode: 'MAD'
	  },
	  MD: {
	    currencyCode: 'MDL'
	  },
	  MG: {
	    currencyCode: 'MGA'
	  },
	  MK: {
	    currencyCode: 'MKD'
	  },
	  ML: {
	    currencyCode: 'XOF'
	  },
	  MM: {
	    currencyCode: 'MMK'
	  },
	  MN: {
	    currencyCode: 'MNT'
	  },
	  MO: {
	    currencyCode: 'MOP'
	  },
	  MP: {
	    currencyCode: 'USD'
	  },
	  MR: {
	    currencyCode: 'MRO'
	  },
	  MS: {
	    currencyCode: 'XCD'
	  },
	  MT: {
	    currencyCode: 'EUR'
	  },
	  MU: {
	    currencyCode: 'MUR'
	  },
	  MW: {
	    currencyCode: 'MWK'
	  },
	  MX: {
	    currencyCode: 'MXN'
	  },
	  MY: {
	    currencyCode: 'MYR'
	  },
	  MZ: {
	    currencyCode: 'MZN'
	  },
	  NA: {
	    currencyCode: 'NAD'
	  },
	  NE: {
	    currencyCode: 'XOF'
	  },
	  NG: {
	    currencyCode: 'NGN'
	  },
	  NI: {
	    currencyCode: 'NIO'
	  },
	  NL: {
	    currencyCode: 'EUR'
	  },
	  NO: {
	    currencyCode: 'NOK'
	  },
	  NP: {
	    currencyCode: 'NPR'
	  },
	  NZ: {
	    currencyCode: 'NZD'
	  },
	  OM: {
	    currencyCode: 'OMR'
	  },
	  PA: {
	    currencyCode: 'PAB'
	  },
	  PE: {
	    currencyCode: 'PEN'
	  },
	  PG: {
	    currencyCode: 'PGK'
	  },
	  PH: {
	    currencyCode: 'PHP'
	  },
	  PK: {
	    currencyCode: 'PKR'
	  },
	  PL: {
	    currencyCode: 'PLN'
	  },
	  PR: {
	    currencyCode: 'USD'
	  },
	  PT: {
	    currencyCode: 'EUR'
	  },
	  PW: {
	    currencyCode: 'USD'
	  },
	  PY: {
	    currencyCode: 'PYG'
	  },
	  QA: {
	    currencyCode: 'QAR'
	  },
	  RO: {
	    currencyCode: 'RON'
	  },
	  RS: {
	    currencyCode: 'RSD'
	  },
	  RU: {
	    currencyCode: 'RUB'
	  },
	  RW: {
	    currencyCode: 'RWF'
	  },
	  SA: {
	    currencyCode: 'SAR'
	  },
	  SB: {
	    currencyCode: 'SBD'
	  },
	  SC: {
	    currencyCode: 'SCR'
	  },
	  SE: {
	    currencyCode: 'SEK'
	  },
	  SG: {
	    currencyCode: 'SGD'
	  },
	  SI: {
	    currencyCode: 'EUR'
	  },
	  SK: {
	    currencyCode: 'EUR'
	  },
	  SL: {
	    currencyCode: 'SLL'
	  },
	  SN: {
	    currencyCode: 'XOF'
	  },
	  SR: {
	    currencyCode: 'SRD'
	  },
	  ST: {
	    currencyCode: 'STD'
	  },
	  SV: {
	    currencyCode: 'SVC'
	  },
	  SZ: {
	    currencyCode: 'SZL'
	  },
	  TC: {
	    currencyCode: 'USD'
	  },
	  TD: {
	    currencyCode: 'XAF'
	  },
	  TG: {
	    currencyCode: 'XOF'
	  },
	  TH: {
	    currencyCode: 'THB'
	  },
	  TJ: {
	    currencyCode: 'TJS'
	  },
	  TM: {
	    currencyCode: 'TMT'
	  },
	  TN: {
	    currencyCode: 'TND'
	  },
	  TR: {
	    currencyCode: 'TRY'
	  },
	  TT: {
	    currencyCode: 'TTD'
	  },
	  TW: {
	    currencyCode: 'TWD'
	  },
	  TZ: {
	    currencyCode: 'TZS'
	  },
	  UA: {
	    currencyCode: 'UAH'
	  },
	  UG: {
	    currencyCode: 'UGX'
	  },
	  US: {
	    currencyCode: 'USD'
	  },
	  UY: {
	    currencyCode: 'UYU'
	  },
	  UZ: {
	    currencyCode: 'UZS'
	  },
	  VC: {
	    currencyCode: 'XCD'
	  },
	  VE: {
	    currencyCode: 'VEF'
	  },
	  VG: {
	    currencyCode: 'USD'
	  },
	  VI: {
	    currencyCode: 'USD'
	  },
	  VN: {
	    currencyCode: 'VND'
	  },
	  YE: {
	    currencyCode: 'YER'
	  },
	  ZA: {
	    currencyCode: 'ZAR'
	  },
	  ZM: {
	    currencyCode: 'ZMW'
	  },
	  ZW: {
	    currencyCode: 'USD'
	  }
	};
	
	/**
	 * @namespace CurrencyDefaults
	 */
	var CurrencyDefaults = {
	  'default': {
	    currencySymbol: function currencySymbol(formatter) {
	      return formatter.currencyCode();
	    },
	    internationalCurrencySymbol: function internationalCurrencySymbol(formatter) {
	      return formatter.currencyCode();
	    },
	    minimumFractionDigits: 2,
	    maximumFractionDigits: 2,
	    minimumIntegerDigits: 1,
	    usesGroupingSeparator: true
	  },
	  AED: {
	    currencySymbol: 'د.إ',
	    internationalCurrencySymbol: 'د.إ'
	  },
	  ALL: {
	    currencySymbol: 'L',
	    internationalCurrencySymbol: 'L'
	  },
	  AMD: {
	    currencySymbol: 'դր.',
	    internationalCurrencySymbol: 'դր.'
	  },
	  AOA: {
	    currencySymbol: 'Kz',
	    internationalCurrencySymbol: 'Kz'
	  },
	  ARS: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  AUD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  AWG: {
	    currencySymbol: 'ƒ',
	    internationalCurrencySymbol: 'ƒ'
	  },
	  AZN: {
	    currencySymbol: '₼',
	    internationalCurrencySymbol: '₼'
	  },
	  BAM: {
	    currencySymbol: 'КМ',
	    internationalCurrencySymbol: 'КМ'
	  },
	  BBD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  BDT: {
	    currencySymbol: '৳',
	    internationalCurrencySymbol: '৳'
	  },
	  BGN: {
	    currencySymbol: 'лв',
	    internationalCurrencySymbol: 'лв'
	  },
	  BHD: {
	    currencySymbol: 'ب.د',
	    internationalCurrencySymbol: 'ب.د',
	    minimumFractionDigits: 3,
	    maximumFractionDigits: 3
	  },
	  BMD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  BND: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  BOB: {
	    currencySymbol: 'Bs.',
	    internationalCurrencySymbol: 'Bs.'
	  },
	  BRL: {
	    currencySymbol: 'R$',
	    internationalCurrencySymbol: 'R$'
	  },
	  BSD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  BTN: {
	    currencySymbol: 'Nu.',
	    internationalCurrencySymbol: 'Nu.'
	  },
	  BWP: {
	    currencySymbol: 'P',
	    internationalCurrencySymbol: 'P'
	  },
	  BYR: {
	    currencySymbol: 'Br',
	    internationalCurrencySymbol: 'Br'
	  },
	  BZD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  CAD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  CDF: {
	    currencySymbol: 'Fr',
	    internationalCurrencySymbol: 'Fr'
	  },
	  CHF: {
	    currencySymbol: 'Fr',
	    internationalCurrencySymbol: 'Fr'
	  },
	  CLP: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$',
	    minimumFractionDigits: 0,
	    maximumFractionDigits: 0
	  },
	  CNY: {
	    currencySymbol: '¥',
	    internationalCurrencySymbol: '¥'
	  },
	  COP: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  CRC: {
	    currencySymbol: '₡',
	    internationalCurrencySymbol: '₡'
	  },
	  CVE: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  CZK: {
	    currencySymbol: 'Kč',
	    internationalCurrencySymbol: 'Kč'
	  },
	  DKK: {
	    currencySymbol: 'kr',
	    internationalCurrencySymbol: 'kr'
	  },
	  DOP: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  DZD: {
	    currencySymbol: 'د.ج',
	    internationalCurrencySymbol: 'د.ج'
	  },
	  EGP: {
	    currencySymbol: 'E£',
	    internationalCurrencySymbol: 'E£'
	  },
	  ETB: {
	    currencySymbol: 'ብር',
	    internationalCurrencySymbol: 'ብር'
	  },
	  EUR: {
	    currencySymbol: '€',
	    internationalCurrencySymbol: '€'
	  },
	  FJD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  GBP: {
	    currencySymbol: '£',
	    internationalCurrencySymbol: '£'
	  },
	  GEL: {
	    currencySymbol: 'ლ,',
	    internationalCurrencySymbol: 'ლ,'
	  },
	  GHS: {
	    currencySymbol: '₵',
	    internationalCurrencySymbol: '₵'
	  },
	  GIP: {
	    currencySymbol: '£',
	    internationalCurrencySymbol: '£'
	  },
	  GMD: {
	    currencySymbol: 'D',
	    internationalCurrencySymbol: 'D'
	  },
	  GTQ: {
	    currencySymbol: 'Q',
	    internationalCurrencySymbol: 'Q'
	  },
	  GYD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  HKD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  HNL: {
	    currencySymbol: 'L',
	    internationalCurrencySymbol: 'L'
	  },
	  HRK: {
	    currencySymbol: 'kn',
	    internationalCurrencySymbol: 'kn'
	  },
	  HTG: {
	    currencySymbol: 'G',
	    internationalCurrencySymbol: 'G'
	  },
	  HUF: {
	    currencySymbol: 'Ft',
	    internationalCurrencySymbol: 'Ft'
	  },
	  IDR: {
	    currencySymbol: 'Rp',
	    internationalCurrencySymbol: 'Rp'
	  },
	  ILS: {
	    currencySymbol: '₪',
	    internationalCurrencySymbol: '₪'
	  },
	  INR: {
	    currencySymbol: '₹',
	    internationalCurrencySymbol: '₹'
	  },
	  ISK: {
	    currencySymbol: 'kr',
	    internationalCurrencySymbol: 'kr'
	  },
	  JMD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  JOD: {
	    currencySymbol: 'د.ا',
	    internationalCurrencySymbol: 'د.ا',
	    minimumFractionDigits: 3,
	    maximumFractionDigits: 3
	  },
	  JPY: {
	    currencySymbol: '¥',
	    internationalCurrencySymbol: '¥',
	    minimumFractionDigits: 0,
	    maximumFractionDigits: 0
	  },
	  KES: {
	    currencySymbol: 'KSh',
	    internationalCurrencySymbol: 'KSh'
	  },
	  KGS: {
	    currencySymbol: 'som',
	    internationalCurrencySymbol: 'som'
	  },
	  KHR: {
	    currencySymbol: '៛',
	    internationalCurrencySymbol: '៛'
	  },
	  KRW: {
	    currencySymbol: '₩',
	    internationalCurrencySymbol: '₩',
	    minimumFractionDigits: 0,
	    maximumFractionDigits: 0
	  },
	  KWD: {
	    currencySymbol: 'د.ك',
	    internationalCurrencySymbol: 'د.ك',
	    minimumFractionDigits: 3,
	    maximumFractionDigits: 3
	  },
	  KYD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  KZT: {
	    currencySymbol: '〒',
	    internationalCurrencySymbol: '〒'
	  },
	  LAK: {
	    currencySymbol: '₭',
	    internationalCurrencySymbol: '₭'
	  },
	  LBP: {
	    currencySymbol: 'ل.ل',
	    internationalCurrencySymbol: 'ل.ل'
	  },
	  LKR: {
	    currencySymbol: '₨',
	    internationalCurrencySymbol: '₨'
	  },
	  LRD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  LTL: {
	    currencySymbol: 'Lt',
	    internationalCurrencySymbol: 'Lt'
	  },
	  MAD: {
	    currencySymbol: 'د.م.',
	    internationalCurrencySymbol: 'د.م.'
	  },
	  MDL: {
	    currencySymbol: 'L',
	    internationalCurrencySymbol: 'L'
	  },
	  MGA: {
	    currencySymbol: 'Ar',
	    internationalCurrencySymbol: 'Ar',
	    minimumFractionDigits: 0,
	    maximumFractionDigits: 0
	  },
	  MKD: {
	    currencySymbol: 'ден',
	    internationalCurrencySymbol: 'ден'
	  },
	  MMK: {
	    currencySymbol: 'K',
	    internationalCurrencySymbol: 'K'
	  },
	  MNT: {
	    currencySymbol: '₮',
	    internationalCurrencySymbol: '₮'
	  },
	  MOP: {
	    currencySymbol: 'P',
	    internationalCurrencySymbol: 'P'
	  },
	  MRO: {
	    currencySymbol: 'UM',
	    internationalCurrencySymbol: 'UM',
	    minimumFractionDigits: 0,
	    maximumFractionDigits: 0
	  },
	  MUR: {
	    currencySymbol: '₨',
	    internationalCurrencySymbol: '₨'
	  },
	  MWK: {
	    currencySymbol: 'MK',
	    internationalCurrencySymbol: 'MK'
	  },
	  MXN: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  MYR: {
	    currencySymbol: 'RM',
	    internationalCurrencySymbol: 'RM'
	  },
	  MZN: {
	    currencySymbol: 'MTn',
	    internationalCurrencySymbol: 'MTn'
	  },
	  NAD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  NGN: {
	    currencySymbol: '₦',
	    internationalCurrencySymbol: '₦'
	  },
	  NIO: {
	    currencySymbol: 'C$',
	    internationalCurrencySymbol: 'C$'
	  },
	  NOK: {
	    currencySymbol: 'kr',
	    internationalCurrencySymbol: 'kr'
	  },
	  NPR: {
	    currencySymbol: '₨',
	    internationalCurrencySymbol: '₨'
	  },
	  NZD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  OMR: {
	    currencySymbol: 'ر.ع.',
	    internationalCurrencySymbol: 'ر.ع.',
	    minimumFractionDigits: 3,
	    maximumFractionDigits: 3
	  },
	  PAB: {
	    currencySymbol: 'B/.',
	    internationalCurrencySymbol: 'B/.'
	  },
	  PEN: {
	    currencySymbol: 'S/.',
	    internationalCurrencySymbol: 'S/.'
	  },
	  PGK: {
	    currencySymbol: 'K',
	    internationalCurrencySymbol: 'K'
	  },
	  PHP: {
	    currencySymbol: '₱',
	    internationalCurrencySymbol: '₱'
	  },
	  PKR: {
	    currencySymbol: '₨',
	    internationalCurrencySymbol: '₨'
	  },
	  PLN: {
	    currencySymbol: 'zł',
	    internationalCurrencySymbol: 'zł'
	  },
	  PYG: {
	    currencySymbol: '₲',
	    internationalCurrencySymbol: '₲'
	  },
	  QAR: {
	    currencySymbol: 'ر.ق',
	    internationalCurrencySymbol: 'ر.ق'
	  },
	  RON: {
	    currencySymbol: 'Lei',
	    internationalCurrencySymbol: 'Lei'
	  },
	  RSD: {
	    currencySymbol: 'РСД',
	    internationalCurrencySymbol: 'РСД'
	  },
	  RUB: {
	    currencySymbol: '₽',
	    internationalCurrencySymbol: '₽'
	  },
	  RWF: {
	    currencySymbol: 'FRw',
	    internationalCurrencySymbol: 'FRw'
	  },
	  SAR: {
	    currencySymbol: 'ر.س',
	    internationalCurrencySymbol: 'ر.س'
	  },
	  SBD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  SCR: {
	    currencySymbol: '₨',
	    internationalCurrencySymbol: '₨'
	  },
	  SEK: {
	    currencySymbol: 'kr',
	    internationalCurrencySymbol: 'kr'
	  },
	  SGD: {
	    currencySymbol: 'S$',
	    internationalCurrencySymbol: 'S$'
	  },
	  SLL: {
	    currencySymbol: 'Le',
	    internationalCurrencySymbol: 'Le'
	  },
	  SRD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  STD: {
	    currencySymbol: 'Db',
	    internationalCurrencySymbol: 'Db'
	  },
	  SVC: {
	    currencySymbol: '₡',
	    internationalCurrencySymbol: '₡'
	  },
	  SZL: {
	    currencySymbol: 'E',
	    internationalCurrencySymbol: 'E'
	  },
	  THB: {
	    currencySymbol: '฿',
	    internationalCurrencySymbol: '฿'
	  },
	  TJS: {
	    currencySymbol: 'ЅМ',
	    internationalCurrencySymbol: 'ЅМ'
	  },
	  TMT: {
	    currencySymbol: 'm',
	    internationalCurrencySymbol: 'm'
	  },
	  TND: {
	    currencySymbol: 'د.ت',
	    internationalCurrencySymbol: 'د.ت',
	    minimumFractionDigits: 3,
	    maximumFractionDigits: 3
	  },
	  TRY: {
	    currencySymbol: '₺',
	    internationalCurrencySymbol: '₺'
	  },
	  TTD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  TWD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  TZS: {
	    currencySymbol: 'Sh',
	    internationalCurrencySymbol: 'Sh'
	  },
	  UAH: {
	    currencySymbol: '₴',
	    internationalCurrencySymbol: '₴'
	  },
	  UGX: {
	    currencySymbol: 'USh',
	    internationalCurrencySymbol: 'USh'
	  },
	  USD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: 'US$'
	  },
	  UYU: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  UZS: {
	    currencySymbol: 'лв',
	    internationalCurrencySymbol: 'лв'
	  },
	  VEF: {
	    currencySymbol: 'Bs F',
	    internationalCurrencySymbol: 'Bs F'
	  },
	  VND: {
	    currencySymbol: '₫',
	    internationalCurrencySymbol: '₫',
	    minimumFractionDigits: 0,
	    maximumFractionDigits: 0
	  },
	  XAF: {
	    currencySymbol: 'Fr',
	    internationalCurrencySymbol: 'Fr'
	  },
	  XCD: {
	    currencySymbol: '$',
	    internationalCurrencySymbol: '$'
	  },
	  XOF: {
	    currencySymbol: 'Fr',
	    internationalCurrencySymbol: 'Fr'
	  },
	  YER: {
	    currencySymbol: '﷼',
	    internationalCurrencySymbol: '﷼'
	  },
	  ZAR: {
	    currencySymbol: 'R',
	    internationalCurrencySymbol: 'R'
	  },
	  ZMW: {
	    currencySymbol: 'ZMK',
	    internationalCurrencySymbol: 'ZMK'
	  }
	};
	
	exports['default'] = NumberFormatter;
	module.exports = exports['default'];
	
	},{"./formatter":14,"./number_formatter_settings_formatter":17,"./utils":22,"stround":3}],17:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _formatter = _dereq_('./formatter');
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var NumberFormatterSettings = function NumberFormatterSettings() {
	  _classCallCheck(this, NumberFormatterSettings);
	
	  /** @type boolean */
	  this.alwaysShowsDecimalSeparator = false;
	
	  /** @type number */
	  this.groupingSize = 0;
	
	  /** @type number */
	  this.maximumFractionDigits = 0;
	
	  /** @type number */
	  this.minimumFractionDigits = 0;
	
	  /** @type number */
	  this.minimumIntegerDigits = 0;
	
	  /** @type string */
	  this.prefix = '';
	
	  /** @type string */
	  this.suffix = '';
	
	  /** @type boolean */
	  this.usesGroupingSeparator = false;
	}
	
	/**
	 * Returns a string composed of the given character repeated `length` times.
	 *
	 * @param {string} character
	 * @param {number} length
	 * @returns {string}
	 * @private
	 */
	;
	
	function chars(character, length) {
	  return new Array(length + 1).join(character);
	}
	
	/**
	 * @const
	 * @private
	 */
	var DIGIT = '#';
	
	/**
	 * @const
	 * @private
	 */
	var PADDING = '0';
	
	/**
	 * @const
	 * @private
	 */
	var DECIMAL_SEPARATOR = '.';
	
	/**
	 * @const
	 * @private
	 */
	var GROUPING_SEPARATOR = ',';
	
	var NumberFormatterSettingsFormatter = (function (_Formatter) {
	  _inherits(NumberFormatterSettingsFormatter, _Formatter);
	
	  function NumberFormatterSettingsFormatter() {
	    _classCallCheck(this, NumberFormatterSettingsFormatter);
	
	    _get(Object.getPrototypeOf(NumberFormatterSettingsFormatter.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NumberFormatterSettingsFormatter, [{
	    key: 'format',
	
	    /**
	     * @param {NumberFormatterSettings} settings
	     * @returns {string}
	     */
	    value: function format(settings) {
	      var result = '';
	
	      var minimumIntegerDigits = settings.minimumIntegerDigits;
	      if (minimumIntegerDigits !== 0) {
	        result += chars(PADDING, minimumIntegerDigits);
	      }
	
	      result = DIGIT + result;
	
	      if (settings.usesGroupingSeparator) {
	        while (result.length <= settings.groupingSize) {
	          result = DIGIT + result;
	        }
	
	        result = result.slice(0, -settings.groupingSize) + GROUPING_SEPARATOR + result.slice(-settings.groupingSize);
	      }
	
	      var minimumFractionDigits = settings.minimumFractionDigits;
	      var maximumFractionDigits = settings.maximumFractionDigits;
	      var hasFractionalPart = settings.alwaysShowsDecimalSeparator || minimumFractionDigits > 0 || maximumFractionDigits > 0;
	
	      if (hasFractionalPart) {
	        result += DECIMAL_SEPARATOR;
	        for (var i = 0, _length = maximumFractionDigits; i < _length; i++) {
	          result += i < minimumFractionDigits ? PADDING : DIGIT;
	        }
	      }
	
	      return settings.prefix + result + settings.suffix;
	    }
	
	    /**
	     * @param {string} string
	     * @returns {?NumberFormatterSettings}
	     */
	  }, {
	    key: 'parse',
	    value: function parse(string) {
	      var result = new NumberFormatterSettings();
	
	      var hasPassedPrefix = false;
	      var hasStartedSuffix = false;
	      var decimalSeparatorIndex = null;
	      var groupingSeparatorIndex = null;
	      var lastIntegerDigitIndex = null;
	
	      for (var i = 0, length = string.length; i < length; i++) {
	        var c = string[i];
	
	        switch (c) {
	          case DIGIT:
	            if (hasStartedSuffix) {
	              return null;
	            }
	            hasPassedPrefix = true;
	            if (decimalSeparatorIndex !== null) {
	              result.maximumFractionDigits++;
	            }
	            break;
	
	          case PADDING:
	            if (hasStartedSuffix) {
	              return null;
	            }
	            hasPassedPrefix = true;
	            if (decimalSeparatorIndex === null) {
	              result.minimumIntegerDigits++;
	            } else {
	              result.minimumFractionDigits++;
	              result.maximumFractionDigits++;
	            }
	            break;
	
	          case DECIMAL_SEPARATOR:
	            if (hasStartedSuffix) {
	              return null;
	            }
	            hasPassedPrefix = true;
	            decimalSeparatorIndex = i;
	            lastIntegerDigitIndex = i - 1;
	            break;
	
	          case GROUPING_SEPARATOR:
	            if (hasStartedSuffix) {
	              return null;
	            }
	            hasPassedPrefix = true;
	            groupingSeparatorIndex = i;
	            break;
	
	          default:
	            if (hasPassedPrefix) {
	              hasStartedSuffix = true;
	              result.suffix += c;
	            } else {
	              result.prefix += c;
	            }
	        }
	      }
	
	      if (decimalSeparatorIndex === null) {
	        lastIntegerDigitIndex = length - 1;
	      }
	
	      if (decimalSeparatorIndex === length - 1) {
	        result.alwaysShowsDecimalSeparator = true;
	      }
	
	      if (groupingSeparatorIndex !== null) {
	        result.groupingSize = lastIntegerDigitIndex - groupingSeparatorIndex;
	        result.usesGroupingSeparator = true;
	      }
	
	      return result;
	    }
	  }]);
	
	  return NumberFormatterSettingsFormatter;
	})(_formatter2['default']);
	
	exports['default'] = NumberFormatterSettingsFormatter;
	module.exports = exports['default'];
	
	},{"./formatter":14}],18:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
	
	var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
	
	/**
	 * @const
	 * @private
	 */
	var NANPPhoneDelimiters = {
	  name: 'NANPPhoneDelimiters',
	  0: '(',
	  4: ')',
	  5: ' ',
	  9: '-'
	};
	
	/**
	 * @const
	 * @private
	 */
	var NANPPhoneDelimitersWithOne = {
	  name: 'NANPPhoneDelimitersWithOne',
	  1: ' ',
	  2: '(',
	  6: ')',
	  7: ' ',
	  11: '-'
	};
	
	/**
	 * @const
	 * @private
	 */
	var E164PhoneDelimitersWithOneDigit = {
	  name: 'E164PhoneDelimitersWithOneDigit',
	  2: ' ',
	  3: '(',
	  7: ')',
	  8: ' ',
	  12: '-'
	};
	
	/**
	 * @const
	 * @private
	 */
	var E164PhoneDelimitersWithTwoDigit = {
	  name: 'E164PhoneDelimitersWithTwoDigit',
	  3: ' ',
	  4: '(',
	  8: ')',
	  9: ' ',
	  13: '-'
	};
	
	/**
	 * @const
	 * @private
	 */
	var E164PhoneDelimitersWithThreeDigit = {
	  name: 'E164PhoneDelimitersWithThreeDigit',
	  4: ' ',
	  5: '(',
	  9: ')',
	  10: ' ',
	  14: '-'
	};
	
	/**
	 * This should match any characters in the maps above.
	 *
	 * @const
	 * @private
	 */
	var DELIMITER_PATTERN = /[-\(\) ]/g;
	
	/**
	 * @const
	 * @private
	 */
	var DEFAULT_COUNTRY_CODE = {
	  "E164": "1",
	  "country": ["American Samoa", "Anguilla", "Antigua and Barbuda", "Bahamas", "Barbados", "Bermuda", "British Virgin Islands", "Canada", "Cayman Islands", "Dominica", "Dominican Republic", "Grenada", "Guam", "Jamaica", "Montserrat", "Northern Mariana Islands", "Puerto Rico", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Vincent and the Grenadines", "Sint Maarten", "Trinidad and Tobago", "Turks and Caicos Islands", "U.S. Virgin Islands", "United States"]
	};
	
	/**
	 * This is an internal store for the current country
	 *
	 * @private
	 */
	var currentCountryCode = DEFAULT_COUNTRY_CODE;
	
	/**
	 * @extends DelimitedTextFormatter
	 */
	
	var PhoneFormatter = (function (_DelimitedTextFormatter) {
	  _inherits(PhoneFormatter, _DelimitedTextFormatter);
	
	  /**
	   * @throws {Error} if anything is passed in
	   * @param {Array} args
	   */
	
	  function PhoneFormatter() {
	    _classCallCheck(this, PhoneFormatter);
	
	    _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'constructor', this).call(this);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (args.length !== 0) {
	      throw new Error('were you trying to set a delimiter (' + args[0] + ')?');
	    }
	  }
	
	  /**
	   * @param {string} chr
	   * @returns {boolean}
	   */
	
	  _createClass(PhoneFormatter, [{
	    key: 'isDelimiter',
	    value: function isDelimiter(chr) {
	      var map = this.delimiterMap;
	      for (var index in map) {
	        if (map.hasOwnProperty(index)) {
	          if (map[index] === chr) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * @param {number} index
	     * @returns {?string}
	     */
	  }, {
	    key: 'delimiterAt',
	    value: function delimiterAt(index) {
	      return this.delimiterMap[index];
	    }
	
	    /**
	     * @param {number} index
	     * @returns {boolean}
	     */
	  }, {
	    key: 'hasDelimiterAtIndex',
	    value: function hasDelimiterAtIndex(index) {
	      var delimiter = this.delimiterAt(index);
	      return delimiter !== undefined && delimiter !== null;
	    }
	
	    /**
	     * Will call parse on the formatter.
	     *
	     * @param {string} text
	     * @param {function(string)} error
	     * @returns {string} returns value with delimiters removed
	     */
	  }, {
	    key: 'parse',
	    value: function parse(text, error) {
	      if (!error) {
	        error = function () {};
	      }
	      var digits = this.digitsWithoutCountryCode(text);
	      // Source: http://en.wikipedia.org/wiki/North_American_Numbering_Plan
	      //
	      // Area Code
	      if (text.length < 10) {
	        error('phone-formatter.number-too-short');
	      }
	      if (digits[0] === '0') {
	        error('phone-formatter.area-code-zero');
	      }
	      if (digits[0] === '1') {
	        error('phone-formatter.area-code-one');
	      }
	      if (digits[1] === '9') {
	        error('phone-formatter.area-code-n9n');
	      }
	      // Central Office Code
	      if (digits[3] === '1') {
	        error('phone-formatter.central-office-one');
	      }
	      if (digits.slice(4, 6) === '11') {
	        error('phone-formatter.central-office-n11');
	      }
	      return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'parse', this).call(this, text, error);
	    }
	
	    /**
	     * @param {string} value
	     * @returns {string}
	     */
	  }, {
	    key: 'format',
	    value: function format(value) {
	      this.guessFormatFromText(value);
	      return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'format', this).call(this, this.removeDelimiterMapChars(value));
	    }
	
	    /**
	     * Determines whether the given change should be allowed and, if so, whether
	     * it should be altered.
	     *
	     * @param {TextFieldStateChange} change
	     * @param {function(string)} error
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isChangeValid',
	    value: function isChangeValid(change, error) {
	      this.guessFormatFromText(change.proposed.text);
	
	      if (change.inserted.text.length > 1) {
	        // handle pastes
	        var text = change.current.text;
	        var selectedRange = change.current.selectedRange;
	        var toInsert = change.inserted.text;
	
	        // Replace the selection with the new text, remove non-digits, then format.
	        var formatted = this.format((text.slice(0, selectedRange.start) + toInsert + text.slice(selectedRange.start + selectedRange.length)).replace(/[^\d]/g, ''));
	
	        change.proposed = {
	          text: formatted,
	          selectedRange: {
	            start: formatted.length - (text.length - (selectedRange.start + selectedRange.length)),
	            length: 0
	          }
	        };
	
	        return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, change, error);
	      }
	
	      if (/^\d*$/.test(change.inserted.text) || change.proposed.text.indexOf('+') === 0) {
	        var formatName = this.delimiterMap.name;
	
	        // First guess at the localized format
	        if (currentCountryCode.localizedFormat) {
	          this.delimiterMap = currentCountryCode.localizedFormat;
	          this.maximumLength = currentCountryCode.localizedFormat.maximumLength;
	          formatName = 'localized-' + currentCountryCode.E164;
	        }
	
	        // We need to store the change and current format guess so that if the isChangeValid
	        // call to super changes the proposed text such that the format we thought is no longer
	        // valid. If that does happen we actually just rerun it through with the correct format
	        var originalProposed = change.proposed.text;
	        var _isChangeValid = _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, change, error);
	
	        this.guessFormatFromText(change.proposed.text);
	
	        // Make sure if the localizedFormat changed, respect that
	        if (currentCountryCode.localizedFormat) {
	          this.delimiterMap = currentCountryCode.localizedFormat;
	          this.maximumLength = currentCountryCode.localizedFormat.maximumLength;
	          this.delimiterMap.name = 'localized-' + currentCountryCode.E164;
	        }
	
	        if (formatName === this.delimiterMap.name) {
	          return _isChangeValid;
	        } else {
	          var originalChange = change;
	          originalChange.proposed.text = originalProposed;
	          return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, originalChange, error);
	        }
	      } else {
	        return false;
	      }
	    }
	
	    /**
	     * Re-configures this formatter to use the delimiters appropriate
	     * for the given text.
	     *
	     * @param {string} text A potentially formatted string containing a phone number.
	     * @private
	     */
	  }, {
	    key: 'guessFormatFromText',
	    value: function guessFormatFromText(text) {
	      currentCountryCode = DEFAULT_COUNTRY_CODE;
	      if (text && text[0] === '+') {
	        if (text.length > 1) {
	          var isValidCountryCode = function isValidCountryCode(countryCode) {
	            var matchingCodes = COUNTRY_CODES.filter(function (country) {
	              return country.E164 === countryCode;
	            });
	
	            return matchingCodes.length > 0;
	          };
	
	          var rawText = this.removeDelimiterMapChars(text);
	          if (currentCountryCode = isValidCountryCode(rawText[1])) {
	            this.delimiterMap = E164PhoneDelimitersWithOneDigit;
	            this.maximumLength = 1 + 1 + 10 + 5;
	          } else if (text.length > 2 && (currentCountryCode = isValidCountryCode(rawText.slice(1, 3)))) {
	            this.delimiterMap = E164PhoneDelimitersWithTwoDigit;
	            this.maximumLength = 1 + 2 + 10 + 5;
	          } else {
	            currentCountryCode = isValidCountryCode(rawText.slice(1, 4)) || DEFAULT_COUNTRY_CODE;
	            this.delimiterMap = E164PhoneDelimitersWithThreeDigit;
	            this.maximumLength = 1 + 3 + 10 + 5;
	          }
	        } else {
	
	          this.delimiterMap = E164PhoneDelimitersWithThreeDigit;
	          this.maximumLength = 1 + 3 + 10 + 5;
	        }
	      } else if (text && text[0] === '1') {
	        this.delimiterMap = NANPPhoneDelimitersWithOne;
	        this.maximumLength = 1 + 10 + 5;
	      } else if (text && text[0] === ' ') {
	        this.delimiterMap = NANPPhoneDelimiters;
	        this.maximumLength = 10 + 5;
	      } else {
	        this.delimiterMap = NANPPhoneDelimiters;
	        this.maximumLength = 10 + 4;
	      }
	    }
	
	    /**
	     * Gives back just the phone number digits as a string without the
	     * country code. Future-proofing internationalization where the country code
	     * isn't just +1.
	     *
	     * @param {string} text
	     * @private
	     */
	  }, {
	    key: 'digitsWithoutCountryCode',
	    value: function digitsWithoutCountryCode(text) {
	      var digits = (text || '').replace(/[^\d]/g, '');
	      var extraDigits = digits.length - 10;
	      if (extraDigits > 0) {
	        digits = digits.substr(extraDigits);
	      }
	      return digits;
	    }
	
	    /**
	     * Removes characters from the phone number that will be added
	     * by the formatter.
	     *
	     * @param {string} text
	     * @private
	     */
	  }, {
	    key: 'removeDelimiterMapChars',
	    value: function removeDelimiterMapChars(text) {
	      return (text || '').replace(DELIMITER_PATTERN, '');
	    }
	  }]);
	
	  return PhoneFormatter;
	})(_delimited_text_formatter2['default']);
	
	var COUNTRY_CODES = [{
	  "E164": "93",
	  "country": "Afghanistan"
	}, {
	  "E164": "355",
	  "country": "Albania"
	}, {
	  "E164": "213",
	  "country": "Algeria"
	}, {
	  "E164": "1",
	  "country": ["American Samoa", "Anguilla", "Antigua and Barbuda", "Bahamas", "Barbados", "Bermuda", "British Virgin Islands", "Canada", "Cayman Islands", "Dominica", "Dominican Republic", "Grenada", "Guam", "Jamaica", "Montserrat", "Northern Mariana Islands", "Puerto Rico", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Vincent and the Grenadines", "Sint Maarten", "Trinidad and Tobago", "Turks and Caicos Islands", "U.S. Virgin Islands", "United States"]
	}, {
	  "E164": "376",
	  "country": "Andorra"
	}, {
	  "E164": "244",
	  "country": "Angola"
	}, {
	  "E164": "672",
	  "country": "Antarctica"
	}, {
	  "E164": "54",
	  "country": "Argentina"
	}, {
	  "E164": "374",
	  "country": "Armenia"
	}, {
	  "E164": "297",
	  "country": "Aruba"
	}, {
	  "E164": "43",
	  "country": "Austria"
	}, {
	  "E164": "994",
	  "country": "Azerbaijan"
	}, {
	  "E164": "973",
	  "country": "Bahrain"
	}, {
	  "E164": "880",
	  "country": "Bangladesh"
	}, {
	  "E164": "375",
	  "country": "Belarus"
	}, {
	  "E164": "32",
	  "country": "Belgium"
	}, {
	  "E164": "501",
	  "country": "Belize"
	}, {
	  "E164": "229",
	  "country": "Benin"
	}, {
	  "E164": "975",
	  "country": "Bhutan"
	}, {
	  "E164": "591",
	  "country": "Bolivia"
	}, {
	  "E164": "387",
	  "country": "Bosnia and Herzegovina"
	}, {
	  "E164": "267",
	  "country": "Botswana"
	}, {
	  "E164": "55",
	  "country": "Brazil"
	}, {
	  "E164": "246",
	  "country": "British Indian Ocean Territory"
	}, {
	  "E164": "673",
	  "country": "Brunei"
	}, {
	  "E164": "359",
	  "country": "Bulgaria"
	}, {
	  "E164": "226",
	  "country": "Burkina Faso"
	}, {
	  "E164": "257",
	  "country": "Burundi"
	}, {
	  "E164": "855",
	  "country": "Cambodia"
	}, {
	  "E164": "237",
	  "country": "Cameroon"
	}, {
	  "E164": "238",
	  "country": "Cape Verde"
	}, {
	  "E164": "236",
	  "country": "Central African Republic"
	}, {
	  "E164": "235",
	  "country": "Chad"
	}, {
	  "E164": "56",
	  "country": "Chile"
	}, {
	  "E164": "86",
	  "country": "China"
	}, {
	  "E164": "61",
	  "country": ["Australia", "Christmas Island", "Cocos Islands"]
	}, {
	  "E164": "57",
	  "country": "Colombia"
	}, {
	  "E164": "269",
	  "country": "Comoros"
	}, {
	  "E164": "682",
	  "country": "Cook Islands"
	}, {
	  "E164": "506",
	  "country": "Costa Rica"
	}, {
	  "E164": "385",
	  "country": "Croatia"
	}, {
	  "E164": "53",
	  "country": "Cuba"
	}, {
	  "E164": "599",
	  "country": ["Curacao", "Netherlands Antilles"]
	}, {
	  "E164": "357",
	  "country": "Cyprus"
	}, {
	  "E164": "420",
	  "country": "Czech Republic"
	}, {
	  "E164": "243",
	  "country": "Democratic Republic of the Congo"
	}, {
	  "E164": "45",
	  "country": "Denmark"
	}, {
	  "E164": "253",
	  "country": "Djibouti"
	}, {
	  "E164": "670",
	  "country": "East Timor"
	}, {
	  "E164": "593",
	  "country": "Ecuador"
	}, {
	  "E164": "20",
	  "country": "Egypt"
	}, {
	  "E164": "503",
	  "country": "El Salvador"
	}, {
	  "E164": "240",
	  "country": "Equatorial Guinea"
	}, {
	  "E164": "291",
	  "country": "Eritrea"
	}, {
	  "E164": "372",
	  "country": "Estonia"
	}, {
	  "E164": "251",
	  "country": "Ethiopia"
	}, {
	  "E164": "500",
	  "country": "Falkland Islands"
	}, {
	  "E164": "298",
	  "country": "Faroe Islands"
	}, {
	  "E164": "679",
	  "country": "Fiji"
	}, {
	  "E164": "358",
	  "country": "Finland"
	}, {
	  "E164": "33",
	  "country": "France"
	}, {
	  "E164": "689",
	  "country": "French Polynesia"
	}, {
	  "E164": "241",
	  "country": "Gabon"
	}, {
	  "E164": "220",
	  "country": "Gambia"
	}, {
	  "E164": "995",
	  "country": "Georgia"
	}, {
	  "E164": "49",
	  "country": "Germany"
	}, {
	  "E164": "233",
	  "country": "Ghana"
	}, {
	  "E164": "350",
	  "country": "Gibraltar"
	}, {
	  "E164": "30",
	  "country": "Greece"
	}, {
	  "E164": "299",
	  "country": "Greenland"
	}, {
	  "E164": "502",
	  "country": "Guatemala"
	}, {
	  "E164": "44",
	  "country": ["Guernsey", "Isle of Man", "Jersey", "United Kingdom"]
	}, {
	  "E164": "224",
	  "country": "Guinea"
	}, {
	  "E164": "245",
	  "country": "Guinea-Bissau"
	}, {
	  "E164": "592",
	  "country": "Guyana"
	}, {
	  "E164": "509",
	  "country": "Haiti"
	}, {
	  "E164": "504",
	  "country": "Honduras"
	}, {
	  "E164": "852",
	  "country": "Hong Kong"
	}, {
	  "E164": "36",
	  "country": "Hungary"
	}, {
	  "E164": "354",
	  "country": "Iceland"
	}, {
	  "E164": "91",
	  "country": "India"
	}, {
	  "E164": "62",
	  "country": "Indonesia"
	}, {
	  "E164": "98",
	  "country": "Iran"
	}, {
	  "E164": "964",
	  "country": "Iraq"
	}, {
	  "E164": "353",
	  "country": "Ireland"
	}, {
	  "E164": "972",
	  "country": "Israel"
	}, {
	  "E164": "39",
	  "country": ["Italy", "Vatican"]
	}, {
	  "E164": "225",
	  "country": "Ivory Coast"
	}, {
	  "E164": "81",
	  "country": "Japan"
	}, {
	  "E164": "962",
	  "country": "Jordan"
	}, {
	  "E164": "7",
	  "country": ["Kazakhstan", "Russia"],
	  "localizedFormat": {
	    "maximumLength": 1 + 1 + 10 + 6,
	    2: ' ',
	    3: '(',
	    7: ')',
	    8: ' ',
	    12: '-',
	    15: '-'
	  }
	}, {
	  "E164": "254",
	  "country": "Kenya"
	}, {
	  "E164": "686",
	  "country": "Kiribati"
	}, {
	  "E164": "383",
	  "country": "Kosovo"
	}, {
	  "E164": "965",
	  "country": "Kuwait"
	}, {
	  "E164": "996",
	  "country": "Kyrgyzstan"
	}, {
	  "E164": "856",
	  "country": "Laos"
	}, {
	  "E164": "371",
	  "country": "Latvia"
	}, {
	  "E164": "961",
	  "country": "Lebanon"
	}, {
	  "E164": "266",
	  "country": "Lesotho"
	}, {
	  "E164": "231",
	  "country": "Liberia"
	}, {
	  "E164": "218",
	  "country": "Libya"
	}, {
	  "E164": "423",
	  "country": "Liechtenstein"
	}, {
	  "E164": "370",
	  "country": "Lithuania"
	}, {
	  "E164": "352",
	  "country": "Luxembourg"
	}, {
	  "E164": "853",
	  "country": "Macao"
	}, {
	  "E164": "389",
	  "country": "Macedonia"
	}, {
	  "E164": "261",
	  "country": "Madagascar"
	}, {
	  "E164": "265",
	  "country": "Malawi"
	}, {
	  "E164": "60",
	  "country": "Malaysia"
	}, {
	  "E164": "960",
	  "country": "Maldives"
	}, {
	  "E164": "223",
	  "country": "Mali"
	}, {
	  "E164": "356",
	  "country": "Malta"
	}, {
	  "E164": "692",
	  "country": "Marshall Islands"
	}, {
	  "E164": "222",
	  "country": "Mauritania"
	}, {
	  "E164": "230",
	  "country": "Mauritius"
	}, {
	  "E164": "262",
	  "country": ["Mayotte", "Reunion"]
	}, {
	  "E164": "52",
	  "country": "Mexico"
	}, {
	  "E164": "691",
	  "country": "Micronesia"
	}, {
	  "E164": "373",
	  "country": "Moldova"
	}, {
	  "E164": "377",
	  "country": "Monaco"
	}, {
	  "E164": "976",
	  "country": "Mongolia"
	}, {
	  "E164": "382",
	  "country": "Montenegro"
	}, {
	  "E164": "212",
	  "country": ["Morocco", "Western Sahara"]
	}, {
	  "E164": "258",
	  "country": "Mozambique"
	}, {
	  "E164": "95",
	  "country": "Myanmar"
	}, {
	  "E164": "264",
	  "country": "Namibia"
	}, {
	  "E164": "674",
	  "country": "Nauru"
	}, {
	  "E164": "977",
	  "country": "Nepal"
	}, {
	  "E164": "31",
	  "country": "Netherlands"
	}, {
	  "E164": "687",
	  "country": "New Caledonia"
	}, {
	  "E164": "64",
	  "country": "New Zealand"
	}, {
	  "E164": "64",
	  "country": "Pitcairn"
	}, {
	  "E164": "505",
	  "country": "Nicaragua"
	}, {
	  "E164": "227",
	  "country": "Niger"
	}, {
	  "E164": "234",
	  "country": "Nigeria"
	}, {
	  "E164": "683",
	  "country": "Niue"
	}, {
	  "E164": "850",
	  "country": "North Korea"
	}, {
	  "E164": "47",
	  "country": ["Norway", "Svalbard and Jan Mayen"]
	}, {
	  "E164": "968",
	  "country": "Oman"
	}, {
	  "E164": "92",
	  "country": "Pakistan"
	}, {
	  "E164": "680",
	  "country": "Palau"
	}, {
	  "E164": "970",
	  "country": "Palestine"
	}, {
	  "E164": "507",
	  "country": "Panama"
	}, {
	  "E164": "675",
	  "country": "Papua New Guinea"
	}, {
	  "E164": "595",
	  "country": "Paraguay"
	}, {
	  "E164": "51",
	  "country": "Peru"
	}, {
	  "E164": "63",
	  "country": "Philippines"
	}, {
	  "E164": "48",
	  "country": "Poland"
	}, {
	  "E164": "351",
	  "country": "Portugal"
	}, {
	  "E164": "974",
	  "country": "Qatar"
	}, {
	  "E164": "242",
	  "country": "Republic of the Congo"
	}, {
	  "E164": "40",
	  "country": "Romania"
	}, {
	  "E164": "250",
	  "country": "Rwanda"
	}, {
	  "E164": "590",
	  "country": "Saint Barthelemy"
	}, {
	  "E164": "290",
	  "country": "Saint Helena"
	}, {
	  "E164": "508",
	  "country": "Saint Pierre and Miquelon"
	}, {
	  "E164": "685",
	  "country": "Samoa"
	}, {
	  "E164": "378",
	  "country": "San Marino"
	}, {
	  "E164": "239",
	  "country": "Sao Tome and Principe"
	}, {
	  "E164": "966",
	  "country": "Saudi Arabia"
	}, {
	  "E164": "221",
	  "country": "Senegal"
	}, {
	  "E164": "381",
	  "country": "Serbia"
	}, {
	  "E164": "248",
	  "country": "Seychelles"
	}, {
	  "E164": "232",
	  "country": "Sierra Leone"
	}, {
	  "E164": "65",
	  "country": "Singapore"
	}, {
	  "E164": "421",
	  "country": "Slovakia"
	}, {
	  "E164": "386",
	  "country": "Slovenia"
	}, {
	  "E164": "677",
	  "country": "Solomon Islands"
	}, {
	  "E164": "252",
	  "country": "Somalia"
	}, {
	  "E164": "27",
	  "country": "South Africa"
	}, {
	  "E164": "82",
	  "country": "South Korea"
	}, {
	  "E164": "211",
	  "country": "South Sudan"
	}, {
	  "E164": "34",
	  "country": "Spain"
	}, {
	  "E164": "94",
	  "country": "Sri Lanka"
	}, {
	  "E164": "249",
	  "country": "Sudan"
	}, {
	  "E164": "597",
	  "country": "Suriname"
	}, {
	  "E164": "268",
	  "country": "Swaziland"
	}, {
	  "E164": "46",
	  "country": "Sweden"
	}, {
	  "E164": "41",
	  "country": "Switzerland"
	}, {
	  "E164": "963",
	  "country": "Syria"
	}, {
	  "E164": "886",
	  "country": "Taiwan"
	}, {
	  "E164": "992",
	  "country": "Tajikistan"
	}, {
	  "E164": "255",
	  "country": "Tanzania"
	}, {
	  "E164": "66",
	  "country": "Thailand"
	}, {
	  "E164": "228",
	  "country": "Togo"
	}, {
	  "E164": "690",
	  "country": "Tokelau"
	}, {
	  "E164": "676",
	  "country": "Tonga"
	}, {
	  "E164": "216",
	  "country": "Tunisia"
	}, {
	  "E164": "90",
	  "country": "Turkey"
	}, {
	  "E164": "993",
	  "country": "Turkmenistan"
	}, {
	  "E164": "688",
	  "country": "Tuvalu"
	}, {
	  "E164": "256",
	  "country": "Uganda"
	}, {
	  "E164": "380",
	  "country": "Ukraine"
	}, {
	  "E164": "971",
	  "country": "United Arab Emirates"
	}, {
	  "E164": "598",
	  "country": "Uruguay"
	}, {
	  "E164": "998",
	  "country": "Uzbekistan"
	}, {
	  "E164": "678",
	  "country": "Vanuatu"
	}, {
	  "E164": "58",
	  "country": "Venezuela"
	}, {
	  "E164": "84",
	  "country": "Vietnam"
	}, {
	  "E164": "681",
	  "country": "Wallis and Futuna"
	}, {
	  "E164": "967",
	  "country": "Yemen"
	}, {
	  "E164": "260",
	  "country": "Zambia"
	}, {
	  "E164": "263",
	  "country": "Zimbabwe"
	}];
	exports['default'] = PhoneFormatter;
	module.exports = exports['default'];
	
	},{"./delimited_text_formatter":10}],19:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
	
	var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
	
	/**
	 * @const
	 * @private
	 */
	var DIGITS_PATTERN = /^\d*$/;
	
	/**
	 * @extends DelimitedTextFormatter
	 */
	
	var SocialSecurityNumberFormatter = (function (_DelimitedTextFormatter) {
	  _inherits(SocialSecurityNumberFormatter, _DelimitedTextFormatter);
	
	  function SocialSecurityNumberFormatter() {
	    _classCallCheck(this, SocialSecurityNumberFormatter);
	
	    _get(Object.getPrototypeOf(SocialSecurityNumberFormatter.prototype), 'constructor', this).call(this, '-');
	    this.maximumLength = 9 + 2;
	  }
	
	  /**
	   * @param {number} index
	   * @returns {boolean}
	   */
	
	  _createClass(SocialSecurityNumberFormatter, [{
	    key: 'hasDelimiterAtIndex',
	    value: function hasDelimiterAtIndex(index) {
	      return index === 3 || index === 6;
	    }
	
	    /**
	     * Determines whether the given change should be allowed and, if so, whether
	     * it should be altered.
	     *
	     * @param {TextFieldStateChange} change
	     * @param {function(string)} error
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isChangeValid',
	    value: function isChangeValid(change, error) {
	      if (DIGITS_PATTERN.test(change.inserted.text)) {
	        return _get(Object.getPrototypeOf(SocialSecurityNumberFormatter.prototype), 'isChangeValid', this).call(this, change, error);
	      } else {
	        return false;
	      }
	    }
	  }]);
	
	  return SocialSecurityNumberFormatter;
	})(_delimited_text_formatter2['default']);
	
	exports['default'] = SocialSecurityNumberFormatter;
	module.exports = exports['default'];
	
	},{"./delimited_text_formatter":10}],20:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _formatter = _dereq_('./formatter');
	
	var _formatter2 = _interopRequireDefault(_formatter);
	
	var _undo_manager = _dereq_('./undo_manager');
	
	var _undo_manager2 = _interopRequireDefault(_undo_manager);
	
	var _utils = _dereq_('./utils');
	
	var _caret = _dereq_('./caret');
	
	var _caret2 = _interopRequireDefault(_caret);
	
	/**
	 * Simulates input behavior.
	 *
	 * @external InputSim
	 * @see https://github.com/iamJoeTaylor/input-sim
	 */
	
	var _inputSim = _dereq_('input-sim');
	
	/**
	 * TextField is the simplest input and the base for more complex
	 * types to inherit.
	 *
	 * @extends external:InputSim.Input
	 */
	
	var _installCaret = (0, _caret2['default'])();
	
	var getCaret = _installCaret.getCaret;
	var setCaret = _installCaret.setCaret;
	
	var TextField = (function (_Input) {
	  _inherits(TextField, _Input);
	
	  /**
	   * Sets up the initial properties of the TextField and
	   * sets  up the event listeners
	   *
	   * @param {HTMLElement} element
	   * @param {Formatter} formatter
	   */
	
	  function TextField(element, formatter) {
	    _classCallCheck(this, TextField);
	
	    _get(Object.getPrototypeOf(TextField.prototype), 'constructor', this).call(this);
	
	    var caret = getCaret(element);
	    if (typeof element.get === 'function') {
	      console.warn('DEPRECATION: FieldKit.TextField instances should no longer be ' + 'created with a jQuery-wrapped element.');
	      element = element.get(0);
	    }
	    this.element = element;
	    this._formatter = formatter;
	    this._enabled = true;
	    this._manualCaret = { start: 0, end: 0 };
	    this._placeholder = null;
	    this._disabledPlaceholder = null;
	    this._focusedPlaceholder = null;
	    this._unfocusedPlaceholder = null;
	    this._isDirty = false;
	    this._valueOnFocus = '';
	    this._currentValue = '';
	    // Make sure textDidChange fires while the value is correct
	    this._needsKeyUpTextDidChangeTrigger = false;
	    this._blur = (0, _utils.bind)(this._blur, this);
	    this._focus = (0, _utils.bind)(this._focus, this);
	    this._click = (0, _utils.bind)(this._click, this);
	    this._paste = (0, _utils.bind)(this._paste, this);
	    this._keyUp = (0, _utils.bind)(this._keyUp, this);
	    this._keyPress = (0, _utils.bind)(this._keyPress, this);
	    this._keyDown = (0, _utils.bind)(this._keyDown, this);
	    if (element['field-kit-text-field']) {
	      throw new Error('already attached a TextField to this element');
	    } else {
	      element['field-kit-text-field'] = this;
	    }
	    element.addEventListener('keydown', this._keyDown);
	    element.addEventListener('keypress', this._keyPress);
	    element.addEventListener('keyup', this._keyUp);
	    element.addEventListener('click', this._click);
	    element.addEventListener('paste', this._paste);
	    element.addEventListener('focus', this._focus);
	    element.addEventListener('blur', this._blur);
	
	    if (!element.getAttribute('autocapitalize')) {
	      element.setAttribute('autocapitalize', 'off');
	    }
	
	    var window = element.ownerDocument.defaultView;
	
	    /**
	     * Fixes caret bug (Android) that caused the input
	     * to place inserted characters in the wrong place
	     * Expected: 1234 5678|  =>  1234 5678 9|
	     * Bug: 1234 5678|  =>  1234 5679| 8
	     *
	     * @private
	     */
	    this._needsManualCaret = window.navigator.userAgent.toLowerCase().indexOf('android') > -1;
	
	    this.setText(element.value);
	
	    this.setSelectedRange({
	      start: caret.start,
	      length: caret.end - caret.start
	    });
	  }
	
	  /**
	   * Helps calculate the changes after an event on a FieldKit.TextField.
	   *
	   * @private
	   */
	
	  /**
	   * **** Public Events ****
	   */
	
	  /**
	   * Called when the user has changed the text of the field. Can be used in
	   * subclasses to perform actions suitable for this event.
	   *
	   * @private
	   */
	
	  _createClass(TextField, [{
	    key: 'textDidChange',
	    value: function textDidChange() {}
	
	    /**
	     * Called when the user has in some way declared that they are done editing,
	     * such as leaving the field or perhaps pressing enter. Can be used in
	     * subclasses to perform actions suitable for this event.
	     *
	     * @private
	     */
	  }, {
	    key: 'textFieldDidEndEditing',
	    value: function textFieldDidEndEditing() {}
	
	    /**
	     * Performs actions necessary for beginning editing.
	     *
	     * @private
	     */
	  }, {
	    key: 'textFieldDidBeginEditing',
	    value: function textFieldDidBeginEditing() {}
	
	    /**
	     * **** Private Events ****
	     */
	
	    /**
	     * Performs actions necessary for text change.
	     *
	     * @private
	     */
	  }, {
	    key: '_textDidChange',
	    value: function _textDidChange() {
	      var delegate = this._delegate;
	      this.textDidChange();
	      if (delegate && typeof delegate.textDidChange === 'function') {
	        delegate.textDidChange(this);
	      }
	
	      // manually fire the HTML5 input event
	      this._fireEvent('input');
	    }
	
	    /**
	     * Performs actions necessary for ending editing.
	     *
	     * @private
	     */
	  }, {
	    key: '_textFieldDidEndEditing',
	    value: function _textFieldDidEndEditing() {
	      var delegate = this._delegate;
	      this.textFieldDidEndEditing();
	      if (delegate && typeof delegate.textFieldDidEndEditing === 'function') {
	        delegate.textFieldDidEndEditing(this);
	      }
	
	      // manually fire the HTML5 change event, only when a change has been made since focus
	      if (this._isDirty && this._valueOnFocus !== this.element.value) {
	        this._fireEvent('change');
	      }
	
	      // reset the dirty property
	      this._isDirty = false;
	      this._valueOnFocus = '';
	    }
	
	    /**
	     * Performs actions necessary for beginning editing.
	     *
	     * @private
	     */
	  }, {
	    key: '_textFieldDidBeginEditing',
	    value: function _textFieldDidBeginEditing() {
	      var delegate = this._delegate;
	      this.textFieldDidBeginEditing();
	      if (delegate && typeof delegate.textFieldDidBeginEditing === 'function') {
	        delegate.textFieldDidBeginEditing(this);
	      }
	    }
	
	    /**
	     * **** Public Methods ****
	     */
	
	    /**
	     * Gets the current delegate for this text field.
	     *
	     * @returns {TextFieldDelegate}
	     */
	  }, {
	    key: 'delegate',
	    value: function delegate() {
	      return this._delegate;
	    }
	
	    /**
	     * Sets the current delegate for this text field.
	     *
	     * @param {TextFieldDelegate} delegate
	     */
	  }, {
	    key: 'setDelegate',
	    value: function setDelegate(delegate) {
	      this._delegate = delegate;
	    }
	
	    /**
	     * Tears down FieldKit
	     */
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var element = this.element;
	      element.removeEventListener('keydown', this._keyDown);
	      element.removeEventListener('keypress', this._keyPress);
	      element.removeEventListener('keyup', this._keyUp);
	      element.removeEventListener('click', this._click);
	      element.removeEventListener('paste', this._paste);
	      element.removeEventListener('focus', this._focus);
	      element.removeEventListener('blur', this._blur);
	      delete element['field-kit-text-field'];
	    }
	
	    /**
	     * Gets the current formatter. Formatters are used to translate between text
	     * and value properties of the field.
	     *
	     * @returns {Formatter}
	     */
	  }, {
	    key: 'formatter',
	    value: function formatter() {
	      if (!this._formatter) {
	        this._formatter = new _formatter2['default']();
	        var maximumLengthString = this.element.getAttribute('maxlength');
	        if (maximumLengthString !== undefined && maximumLengthString !== null) {
	          this._formatter.maximumLength = parseInt(maximumLengthString, 10);
	        }
	      }
	
	      return this._formatter;
	    }
	
	    /**
	     * Sets the current formatter.
	     *
	     * @param {Formatter} formatter
	     */
	  }, {
	    key: 'setFormatter',
	    value: function setFormatter(formatter) {
	      var value = this.value();
	      this._formatter = formatter;
	      this.setValue(value);
	    }
	
	    /**
	     * Builds a change instance and formats the change to see if it's valid
	     *
	     * @param   {object} current
	     * @param   {object} proposed
	     * @returns {?object} false if change doesn't have changes or change isn't valid. Change object if it is.
	     */
	  }, {
	    key: 'hasChangesAndIsValid',
	    value: function hasChangesAndIsValid(current, proposed) {
	      var _this = this;
	
	      var change = new TextFieldStateChange(this);
	      var error = function error(errorType) {
	        var delegate = _this.delegate();
	        if (delegate) {
	          if (typeof delegate.textFieldDidFailToValidateChange === 'function') {
	            delegate.textFieldDidFailToValidateChange(_this, change, errorType);
	          }
	        }
	      };
	      change.current = { text: current.text, selectedRange: current.selectedRange };
	      change.proposed = { text: proposed.text, selectedRange: proposed.selectedRange };
	      if (change.hasChanges() && this.formatter().isChangeValid(change, error)) {
	        return change;
	      }
	      return null;
	    }
	
	    /**
	     * Handles a key event could be trying to end editing.
	     *
	     */
	  }, {
	    key: 'insertNewline',
	    value: function insertNewline() {
	      this._textFieldDidEndEditing();
	      this._didEndEditingButKeptFocus = true;
	    }
	
	    /**
	     * Debug support
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'inspect',
	    value: function inspect() {
	      return '#<TextField text="' + this.text() + '">';
	    }
	
	    /**
	     * Replaces the current selection with text from the given pasteboard.
	     *
	     * @param {DataTransfer} pasteboard
	     */
	  }, {
	    key: 'readSelectionFromPasteboard',
	    value: function readSelectionFromPasteboard(pasteboard) {
	      var range = undefined,
	          text = undefined;
	      text = pasteboard.getData('Text');
	      this.replaceSelection(text);
	      range = this.selectedRange();
	      range.start += range.length;
	      range.length = 0;
	      this.setSelectedRange(range);
	    }
	
	    /**
	     * Checks changes after invoking the passed function for validity and rolls
	     * them back if the changes turned out to be invalid.
	     *
	     * @returns {Object} whatever object `callback` returns
	     */
	  }, {
	    key: 'rollbackInvalidChanges',
	    value: function rollbackInvalidChanges(callback) {
	      var result = null;
	      var errorType = null;
	      var change = TextFieldStateChange.build(this, function () {
	        return result = callback();
	      });
	      var error = function error(type) {
	        errorType = type;
	      };
	      if (change.hasChanges()) {
	        var formatter = this.formatter();
	        if (formatter && typeof formatter.isChangeValid === 'function') {
	          if (!this._isDirty) {
	            this._valueOnFocus = change.current.text || '';
	            this._isDirty = true;
	          }
	          if (formatter.isChangeValid(change, error)) {
	            change.recomputeDiff();
	            this.setText(change.proposed.text);
	            this.setSelectedRange(change.proposed.selectedRange);
	          } else {
	            var delegate = this.delegate();
	            if (delegate) {
	              if (typeof delegate.textFieldDidFailToValidateChange === 'function') {
	                delegate.textFieldDidFailToValidateChange(this, change, errorType);
	              }
	            }
	            this.setText(change.current.text);
	            this.setSelectedRange(change.current.selectedRange);
	            return result;
	          }
	        }
	        if (change.inserted.text.length || change.deleted.text.length) {
	          this.undoManager().proxyFor(this)._applyChangeFromUndoManager(change);
	          this._textDidChange();
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the object value. This is the value that should be considered the
	     * 'real' value of the field.
	     *
	     * @returns {Object}
	     */
	  }, {
	    key: 'value',
	    value: function value() {
	      var _this2 = this;
	
	      var text = this.text();
	      var delegate = this.delegate();
	      var formatter = this.formatter();
	      if (!formatter) {
	        return text;
	      }
	
	      return formatter.parse(text, function (errorType) {
	        if (delegate) {
	          if (typeof delegate.textFieldDidFailToParseString === 'function') {
	            delegate.textFieldDidFailToParseString(_this2, text, errorType);
	          }
	        }
	      });
	    }
	
	    /**
	     * Sets the object value of the field.
	     *
	     * @param {string} value
	     */
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      if (this._formatter) {
	        value = this._formatter.format(value);
	      }
	      this.setText('' + value);
	    }
	
	    /**
	     * **** InputSim Overrides ****
	     */
	
	    /**
	     * Gets the formatted text value. This is the same as the value of the
	     * underlying input element.
	     *
	     * @augments external:InputSim.Input#text
	     * @returns {string}
	     */
	  }, {
	    key: 'text',
	    value: function text() {
	      return this.element.value;
	    }
	
	    /**
	     * Sets the formatted text value. This generally should not be used. Instead,
	     * use the value setter.
	     *
	     * @augments external:InputSim.Input#setText
	     * @param {string} text
	     */
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      this.element.value = text;
	      this._currentValue = text;
	    }
	
	    /**
	     * Gets the range of the current selection.
	     *
	     * @augments external:InputSim.Input#selectedRange
	     * @returns {Object} {start: number, length: number}
	     */
	  }, {
	    key: 'selectedRange',
	    value: function selectedRange() {
	      var caret = this._needsManualCaret ? this._manualCaret : getCaret(this.element);
	
	      return {
	        start: caret.start,
	        length: caret.end - caret.start
	      };
	    }
	
	    /**
	     * Sets the range of the current selection and the selection affinity.
	     *
	     * @augments external:InputSim.Input#setSelectedRangeWithAffinity
	     * @param {{start: number, length: number}} range
	     * @param {Affinity} affinity
	     */
	  }, {
	    key: 'setSelectedRangeWithAffinity',
	    value: function setSelectedRangeWithAffinity(range, affinity) {
	      var newRange = _get(Object.getPrototypeOf(TextField.prototype), 'setSelectedRangeWithAffinity', this).call(this, range, affinity);
	      var caret = {
	        start: newRange.start,
	        end: newRange.start + newRange.length
	      };
	      this._manualCaret = caret;
	      setCaret(this.element, caret.start, caret.end);
	      this.selectionAffinity = range.length === 0 ? null : affinity;
	    }
	
	    /**
	     * **** Undo Support ****
	     */
	
	    /**
	     * Gets whether this text field records undo actions with its undo manager.
	     *
	     * @returns {boolean}
	     */
	  }, {
	    key: 'allowsUndo',
	    value: function allowsUndo() {
	      return this._allowsUndo;
	    }
	
	    /**
	     * Sets whether this text field records undo actions with its undo manager.
	     *
	     * @param {boolean} allowsUndo
	     */
	  }, {
	    key: 'setAllowsUndo',
	    value: function setAllowsUndo(allowsUndo) {
	      this._allowsUndo = allowsUndo;
	    }
	
	    /**
	     * Triggers a redo in the underlying UndoManager, if applicable.
	     *
	     * @param {Event} event
	     */
	  }, {
	    key: 'redo',
	    value: function redo(event) {
	      if (this.undoManager().canRedo()) {
	        this.undoManager().redo();
	      }
	      event.preventDefault();
	    }
	
	    /**
	     * Triggers an undo in the underlying UndoManager, if applicable.
	     *
	     * @param {Event} event
	     */
	  }, {
	    key: 'undo',
	    value: function undo(event) {
	      if (this.undoManager().canUndo()) {
	        this.undoManager().undo();
	      }
	      event.preventDefault();
	    }
	
	    /**
	     * Gets the UndoManager for this text field.
	     *
	     * @returns {UndoManager}
	     */
	  }, {
	    key: 'undoManager',
	    value: function undoManager() {
	      return this._undoManager || (this._undoManager = new _undo_manager2['default']());
	    }
	
	    /**
	     * **** Enabled/disabled support *****
	     */
	
	    /**
	     * Removes focus from this field if it has focus.
	     */
	  }, {
	    key: 'becomeFirstResponder',
	    value: function becomeFirstResponder() {
	      var _this3 = this;
	
	      this.element.focus();
	      this.rollbackInvalidChanges(function () {
	        _this3.element.select();
	        _this3._syncPlaceholder();
	      });
	    }
	
	    /**
	     * Determines whether this field has focus.
	     *
	     * @returns {boolean} true if this field has focus
	     */
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.element.ownerDocument.activeElement === this.element;
	    }
	
	    /**
	     * Determines whether this field is enabled or disabled.
	     *
	     * @returns {boolean} true if this field is enabled
	     */
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return this._enabled;
	    }
	
	    /**
	     * Sets whether this text field is enabled
	     * and syncs the placeholder to match
	     *
	     * @param {boolean} enabled
	     */
	  }, {
	    key: 'setEnabled',
	    value: function setEnabled(enabled) {
	      this._enabled = enabled;
	      this._syncPlaceholder();
	    }
	
	    /**
	     * Removes focus from this field if it has focus.
	     *
	     * @param {Event} event
	     */
	  }, {
	    key: 'resignFirstResponder',
	    value: function resignFirstResponder(event) {
	      if (event !== undefined && event !== null) {
	        event.preventDefault();
	      }
	      this.element.blur();
	      this._syncPlaceholder();
	    }
	
	    /*
	     * **** Placeholder support ****
	     */
	
	    /**
	     * Gets the disabled placeholder if one
	     * has been set.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'disabledPlaceholder',
	    value: function disabledPlaceholder() {
	      return this._disabledPlaceholder;
	    }
	
	    /**
	     * Sets the disabled placeholder.
	     *
	     * @param {string} disabledPlaceholder
	     */
	  }, {
	    key: 'setDisabledPlaceholder',
	    value: function setDisabledPlaceholder(disabledPlaceholder) {
	      this._disabledPlaceholder = disabledPlaceholder;
	      this._syncPlaceholder();
	    }
	
	    /**
	     * Gets the focused placeholder if one
	     * has been set.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'focusedPlaceholder',
	    value: function focusedPlaceholder() {
	      return this._focusedPlaceholder;
	    }
	
	    /**
	     * Sets the focused placeholder.
	     *
	     * @param {string} focusedPlaceholder
	     */
	  }, {
	    key: 'setFocusedPlaceholder',
	    value: function setFocusedPlaceholder(focusedPlaceholder) {
	      this._focusedPlaceholder = focusedPlaceholder;
	      this._syncPlaceholder();
	    }
	
	    /**
	     * Gets the placeholder if one has
	     * been set.
	     *
	     * @TODO Does this do anything?
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'placeholder',
	    value: function placeholder() {
	      return this._placeholder;
	    }
	
	    /**
	     * Sets the placeholder.
	     *
	     * @param {string} placeholder
	     */
	  }, {
	    key: 'setPlaceholder',
	    value: function setPlaceholder(placeholder) {
	      this._placeholder = placeholder;
	      this.element.setAttribute('placeholder', this._placeholder);
	    }
	
	    /**
	     * Gets the unfocused placeholder if one
	     * has been set.
	     *
	     * @returns {string}
	     */
	  }, {
	    key: 'unfocusedPlaceholder',
	    value: function unfocusedPlaceholder() {
	      return this._unfocusedPlaceholder;
	    }
	
	    /**
	     * Sets the unfocused placeholder.
	     *
	     * @param {string} unfocusedPlaceholder
	     */
	  }, {
	    key: 'setUnfocusedPlaceholder',
	    value: function setUnfocusedPlaceholder(unfocusedPlaceholder) {
	      this._unfocusedPlaceholder = unfocusedPlaceholder;
	      this._syncPlaceholder();
	    }
	
	    /**
	     * **** Private Methods ****
	     */
	
	    /**
	     * Applies the given change as an undo/redo.
	     *
	     * @param {Object} change object with current and proposed properties
	     * @private
	     */
	  }, {
	    key: '_applyChangeFromUndoManager',
	    value: function _applyChangeFromUndoManager(change) {
	      this.undoManager().proxyFor(this)._applyChangeFromUndoManager(change);
	
	      if (this.undoManager().isUndoing()) {
	        this.setText(change.current.text);
	        this.setSelectedRange(change.current.selectedRange);
	      } else {
	        this.setText(change.proposed.text);
	        this.setSelectedRange(change.proposed.selectedRange);
	      }
	
	      this._textDidChange();
	    }
	
	    /**
	     * Handles clicks by resetting the selection affinity.
	     *
	     * @private
	     */
	  }, {
	    key: '_click',
	    value: function _click() {
	      this._manualCaret = getCaret(this.element);
	      this._selectedRange = {
	        start: this._manualCaret.start,
	        length: this._manualCaret.end - this._manualCaret.start
	      };
	      this.selectionAffinity = null;
	    }
	
	    /**
	     * Fires event on the element
	     *
	     * @param {string} eventType
	     * @private
	     */
	  }, {
	    key: '_fireEvent',
	    value: function _fireEvent(eventType) {
	      var document = this.element.ownerDocument;
	      var window = document.defaultView;
	      if (typeof window.CustomEvent === 'function') {
	        this.element.dispatchEvent(new window.CustomEvent(eventType, {}));
	      } else {
	        var _event = document.createEvent('Event');
	        _event.initEvent(eventType, false, false);
	        this.element.dispatchEvent(_event);
	      }
	    }
	
	    /**
	     * Handles gaining focus. This method delegates to other methods, and syncs
	     * the placeholder appropriately.
	     *
	     * @private
	     */
	  }, {
	    key: '_focus',
	    value: function _focus() {
	      this._textFieldDidBeginEditing();
	      this._syncPlaceholder();
	    }
	
	    /**
	     * Handles losing focus. This method delegates to other methods, and syncs the
	     * placeholder appropriately.
	     *
	     * @private
	     */
	  }, {
	    key: '_blur',
	    value: function _blur() {
	      this._textFieldDidEndEditing();
	      this._syncPlaceholder();
	    }
	
	    /**
	     * Handles keyDown events. This method essentially just delegates to other,
	     * more semantic, methods based on the modifier keys and the pressed key of the
	     * event.
	     *
	     * @param {Event} event
	     * @private
	     */
	  }, {
	    key: '_keyDown',
	    value: function _keyDown(event) {
	      var _this4 = this;
	
	      if (this._didEndEditingButKeptFocus) {
	        this._textFieldDidBeginEditing();
	        this._didEndEditingButKeptFocus = false;
	      }
	
	      var action = this._bindings.actionForEvent(event);
	      if (action) {
	        switch (action) {
	          case 'undo':
	          case 'redo':
	            this[action](event);
	            break;
	
	          default:
	            this.rollbackInvalidChanges(function () {
	              return _this4[action](event);
	            });
	            break;
	        }
	      }
	    }
	
	    /**
	     * Handles inserting characters based on the typed key for normal keyboards.
	     *
	     * NOTE: Does not fire on some versions of Android, in which case we handle
	     * changes in _keyUp instead.
	     *
	     * @param {Event} event
	     * @private
	     */
	  }, {
	    key: '_keyPress',
	    value: function _keyPress(event) {
	      var _this5 = this;
	
	      var keyCode = event.keyCode;
	      if (!event.metaKey && !event.ctrlKey && keyCode !== _inputSim.KEYS.ENTER && keyCode !== _inputSim.KEYS.TAB && keyCode !== _inputSim.KEYS.BACKSPACE) {
	        if (event.charCode !== 0) {
	          (function () {
	            var newText = String.fromCharCode(event.charCode || event.keyCode);
	
	            _this5._processChange({
	              currentText: _this5.text(),
	              proposedText: (0, _utils.replaceStringSelection)(newText, _this5.text(), _this5.selectedRange()),
	              onSuccess: function onSuccess(change, changeTriggeredFormatting) {
	                if (!changeTriggeredFormatting && event instanceof KeyboardEvent) {
	                  // HACK(JoeTaylor) Use Browser's native input when using the formatter
	                  // would not make a difference https://code.google.com/p/chromium/issues/detail?id=32865
	                  if (!_this5._isDirty) {
	                    _this5._valueOnFocus = change.current.text || '';
	                    _this5._isDirty = true;
	                  }
	                  _this5.undoManager().proxyFor(_this5)._applyChangeFromUndoManager(change);
	                  _this5._manualCaret = {
	                    start: change.proposed.selectedRange.start,
	                    end: change.proposed.selectedRange.start + change.proposed.selectedRange.length
	                  };
	                  _this5._needsKeyUpTextDidChangeTrigger = true;
	                } else {
	                  event.preventDefault();
	                  _this5.rollbackInvalidChanges(function () {
	                    return _this5.insertText(newText);
	                  });
	                }
	                _this5._currentValue = change.proposed.text;
	              },
	              onFail: function onFail() {
	                event.preventDefault();
	                _this5.rollbackInvalidChanges(function () {
	                  return _this5.insertText(newText);
	                });
	              }
	            });
	          })();
	        } else {
	          event.preventDefault();
	        }
	      }
	    }
	
	    /**
	     * Handles keyup events. On Some Android we need to do all input processing
	     * here because no other information comes in.
	     *
	     * @param {Event} event
	     * @private
	     */
	  }, {
	    key: '_keyUp',
	    value: function _keyUp(event) {
	      var _this6 = this;
	
	      if (this._needsKeyUpTextDidChangeTrigger) {
	        this._textDidChange();
	        this._needsKeyUpTextDidChangeTrigger = false;
	      }
	      var keyCode = event.keyCode;
	      // NOTE: Certain Androids on Chrome always return 229
	      // https://code.google.com/p/chromium/issues/detail?id=118639
	      if (keyCode === 229) {
	        (function () {
	          // Text has already been changed at this point, so we check the previous text
	          // to determine whether we need to undo the change.
	          var previousText = _this6._currentValue || '';
	          _this6._processChange({
	            currentText: previousText,
	            proposedText: _this6.text(),
	            onSuccess: function onSuccess(change, changeTriggeredFormatting) {
	              if (changeTriggeredFormatting) {
	                var newText = change.proposed.text;
	                _this6.setSelectedRange(change.proposed.selectedRange);
	                _this6.setText(newText);
	              }
	              if (!_this6._isDirty) {
	                _this6._valueOnFocus = change.current.text || '';
	                _this6._isDirty = true;
	              }
	              _this6.undoManager().proxyFor(_this6)._applyChangeFromUndoManager(change);
	              _this6._textDidChange();
	              _this6._currentValue = change.proposed.text;
	            },
	            onFail: function onFail() {
	              // Need to rollback the letter input in the Keyup event because it is not valid,
	              // so we set text to the previous state (as collected from the UndoManager).
	              _this6.setText(previousText);
	            }
	          });
	        })();
	      } else {
	        this.rollbackInvalidChanges(function () {
	          if (event.keyCode === _inputSim.KEYS.TAB) {
	            _this6.selectAll(event);
	          }
	        });
	      }
	    }
	
	    /**
	     * Checks if a change is valid and calls `onSuccess` if so,
	     * and `onFail` if not.
	     *
	     * @param {object} options
	     * @param {string} options.currentText
	     * @param {string} options.proposedText
	     * @param {function} options.onSuccess
	     * @param {function=} options.onFail
	     * @private
	     */
	  }, {
	    key: '_processChange',
	    value: function _processChange(_ref) {
	      var currentText = _ref.currentText;
	      var proposedText = _ref.proposedText;
	      var onSuccess = _ref.onSuccess;
	      var _ref$onFail = _ref.onFail;
	      var onFail = _ref$onFail === undefined ? function () {} : _ref$onFail;
	
	      var current = {
	        text: currentText,
	        selectedRange: this.selectedRange()
	      };
	      var proposed = {
	        text: proposedText,
	        selectedRange: { start: current.selectedRange.start + 1, length: 0 }
	      };
	      var change = this.hasChangesAndIsValid(current, proposed);
	      var changeTriggeredFormatting = change && (change.proposed.text !== proposed.text || change.proposed.selectedRange.start !== proposed.selectedRange.start || change.proposed.selectedRange.length !== proposed.selectedRange.length);
	
	      if (change) {
	        onSuccess(change, changeTriggeredFormatting);
	      } else {
	        onFail();
	      }
	    }
	
	    /**
	     * Handles paste events.
	     *
	     * @param {Event} event
	     * @private
	     */
	  }, {
	    key: '_paste',
	    value: function _paste(event) {
	      var _this7 = this;
	
	      event.preventDefault();
	      this.rollbackInvalidChanges(function () {
	        _this7.readSelectionFromPasteboard(event.clipboardData);
	      });
	    }
	
	    /**
	     * @private
	     */
	  }, {
	    key: '_syncPlaceholder',
	    value: function _syncPlaceholder() {
	      if (!this._enabled) {
	        var disabledPlaceholder = this._disabledPlaceholder;
	        if (disabledPlaceholder !== undefined && disabledPlaceholder !== null) {
	          this.setPlaceholder(disabledPlaceholder);
	        }
	      } else if (this.hasFocus()) {
	        var focusedPlaceholder = this._focusedPlaceholder;
	        if (focusedPlaceholder !== undefined && focusedPlaceholder !== null) {
	          this.setPlaceholder(focusedPlaceholder);
	        }
	      } else {
	        var unfocusedPlaceholder = this._unfocusedPlaceholder;
	        if (unfocusedPlaceholder !== undefined && unfocusedPlaceholder !== null) {
	          this.setPlaceholder(unfocusedPlaceholder);
	        }
	      }
	    }
	  }]);
	
	  return TextField;
	})(_inputSim.Input);
	
	var TextFieldStateChange = (function () {
	  /**
	   * @param {TextField} field
	   */
	
	  function TextFieldStateChange(field) {
	    _classCallCheck(this, TextFieldStateChange);
	
	    this.field = field;
	  }
	
	  /**
	   * Builds a new {TextFieldStateChange} that will allow you to
	   * compute differences, and see the current vs proposed changes.
	   *
	   * @param {TextField} field
	   * @param {Function} callback called when you want changes to the field
	   *    take place. Current will be calculated before this callback.
	   *    Proposed will be calculated after this callback.
	   *
	   * @returns {Object} change object with current and proposed properties
	   */
	
	  /**
	   * Determines whether this field has changes.
	   *
	   * @returns {boolean} true if either the current text doesn't match the proposed text
	   *    or the current selection range doesn't match the proposed selection range
	   */
	
	  _createClass(TextFieldStateChange, [{
	    key: 'hasChanges',
	    value: function hasChanges() {
	      this.recomputeDiff();
	      return this.current.text !== this.proposed.text || this.current.selectedRange.start !== this.proposed.selectedRange.start || this.current.selectedRange.length !== this.proposed.selectedRange.length;
	    }
	
	    /**
	     * Updates {TextFieldStateChange} inserted and {TextFieldStateChange} deleted
	     * based on proposed and current
	     */
	  }, {
	    key: 'recomputeDiff',
	    value: function recomputeDiff() {
	      if (this.proposed.text !== this.current.text) {
	        var ctext = this.current.text;
	        var ptext = this.proposed.text;
	        var sharedPrefixLength = 0;
	        var sharedSuffixLength = 0;
	        var minTextLength = Math.min(ctext.length, ptext.length);
	        var i = undefined;
	
	        for (i = 0; i < minTextLength; i++) {
	          if (ptext[i] === ctext[i]) {
	            sharedPrefixLength = i + 1;
	          } else {
	            break;
	          }
	        }
	
	        for (i = 0; i < minTextLength - sharedPrefixLength; i++) {
	          if (ptext[ptext.length - 1 - i] === ctext[ctext.length - 1 - i]) {
	            sharedSuffixLength = i + 1;
	          } else {
	            break;
	          }
	        }
	
	        var inserted = {
	          start: sharedPrefixLength,
	          end: ptext.length - sharedSuffixLength
	        };
	        var deleted = {
	          start: sharedPrefixLength,
	          end: ctext.length - sharedSuffixLength
	        };
	        inserted.text = ptext.substring(inserted.start, inserted.end);
	        deleted.text = ctext.substring(deleted.start, deleted.end);
	        this.inserted = inserted;
	        this.deleted = deleted;
	      } else {
	        this.inserted = {
	          start: this.proposed.selectedRange.start,
	          end: this.proposed.selectedRange.start + this.proposed.selectedRange.length,
	          text: ''
	        };
	        this.deleted = {
	          start: this.current.selectedRange.start,
	          end: this.current.selectedRange.start + this.current.selectedRange.length,
	          text: ''
	        };
	      }
	    }
	  }]);
	
	  return TextFieldStateChange;
	})();
	
	TextFieldStateChange.build = function (field, callback) {
	  var change = new this(field);
	  change.current = {
	    text: field.text(),
	    selectedRange: field.selectedRange()
	  };
	  callback();
	  change.proposed = {
	    text: field.text(),
	    selectedRange: field.selectedRange()
	  };
	  change.recomputeDiff();
	  return change;
	};
	
	exports['default'] = TextField;
	module.exports = exports['default'];
	
	},{"./caret":8,"./formatter":14,"./undo_manager":21,"./utils":22,"input-sim":2}],21:[function(_dereq_,module,exports){
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utils = _dereq_('./utils');
	
	/**
	 * UndoManager is a general-purpose recorder of operations for undo and redo.
	 *
	 * Registering an undo action is done by specifying the changed object, along
	 * with a method to invoke to revert its state and the arguments for that
	 * method. When performing undo an UndoManager saves the operations reverted so
	 * that you can redo the undos.
	 */
	
	var UndoManager = (function () {
	  function UndoManager() {
	    _classCallCheck(this, UndoManager);
	
	    /** @private */
	    this._undos = [];
	    /** @private */
	    this._redos = [];
	    /** @private */
	    this._isUndoing = false;
	    /** @private */
	    this._isRedoing = false;
	  }
	
	  /**
	   * Determines whether there are any undo actions on the stack.
	   *
	   * @returns {boolean}
	   */
	
	  _createClass(UndoManager, [{
	    key: 'canUndo',
	    value: function canUndo() {
	      return this._undos.length !== 0;
	    }
	
	    /**
	     * Determines whether there are any redo actions on the stack.
	     *
	     * @returns {boolean}
	     */
	  }, {
	    key: 'canRedo',
	    value: function canRedo() {
	      return this._redos.length !== 0;
	    }
	
	    /**
	     * Indicates whether or not this manager is currently processing an undo.
	     *
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isUndoing',
	    value: function isUndoing() {
	      return this._isUndoing;
	    }
	
	    /**
	     * Indicates whether or not this manager is currently processing a redo.
	     *
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isRedoing',
	    value: function isRedoing() {
	      return this._isRedoing;
	    }
	
	    /**
	     * Manually registers an simple undo action with the given args.
	     *
	     * If this undo manager is currently undoing then this will register a redo
	     * action instead. If this undo manager is neither undoing or redoing then the
	     * redo stack will be cleared.
	     *
	     * @param {Object} target call `selector` on this object
	     * @param {string} selector the method name to call on `target`
	     * @param {...Object} args arguments to pass when calling `selector` on `target`
	     */
	  }, {
	    key: 'registerUndo',
	    value: function registerUndo(target, selector) {
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      if (this._isUndoing) {
	        this._appendRedo.apply(this, [target, selector].concat(args));
	      } else {
	        if (!this._isRedoing) {
	          this._redos.length = 0;
	        }
	        this._appendUndo.apply(this, [target, selector].concat(args));
	      }
	    }
	
	    /**
	     * Appends an undo action to the internal stack.
	     *
	     * @param {Object} target call `selector` on this object
	     * @param {string} selector the method name to call on `target`
	     * @param {...Object} args arguments to pass when calling `selector` on `target`
	     * @private
	     */
	  }, {
	    key: '_appendUndo',
	    value: function _appendUndo(target, selector) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      this._undos.push({
	        target: target,
	        selector: selector,
	        args: args
	      });
	    }
	
	    /**
	     * Appends a redo action to the internal stack.
	     *
	     * @param {Object} target call `selector` on this object
	     * @param {string} selector the method name to call on `target`
	     * @param {...Object} args arguments to pass when calling `selector` on `target`
	     * @private
	     */
	  }, {
	    key: '_appendRedo',
	    value: function _appendRedo(target, selector) {
	      for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	        args[_key3 - 2] = arguments[_key3];
	      }
	
	      this._redos.push({
	        target: target,
	        selector: selector,
	        args: args
	      });
	    }
	
	    /**
	     * Performs the top-most undo action on the stack.
	     *
	     * @throws {Error} Raises an error if there are no available undo actions.
	     */
	  }, {
	    key: 'undo',
	    value: function undo() {
	      if (!this.canUndo()) {
	        throw new Error('there are no registered undos');
	      }
	      var data = this._undos.pop();
	      var target = data.target;
	      var selector = data.selector;
	      var args = data.args;
	      this._isUndoing = true;
	      target[selector].apply(target, args);
	      this._isUndoing = false;
	    }
	
	    /**
	     * Performs the top-most redo action on the stack.
	     *
	     * @throws {Error} Raises an error if there are no available redo actions.
	     */
	  }, {
	    key: 'redo',
	    value: function redo() {
	      if (!this.canRedo()) {
	        throw new Error('there are no registered redos');
	      }
	      var data = this._redos.pop();
	      var target = data.target;
	      var selector = data.selector;
	      var args = data.args;
	      this._isRedoing = true;
	      target[selector].apply(target, args);
	      this._isRedoing = false;
	    }
	
	    /**
	     * Returns a proxy object based on target that will register undo/redo actions
	     * by calling methods on the proxy.
	     *
	     * @example
	     *     setSize(size) {
	     *       this.undoManager.proxyFor(this).setSize(this._size);
	     *       this._size = size;
	     *     }
	     *
	     * @param {Object} target call `selector` on this object
	     * @returns {Object}
	     */
	  }, {
	    key: 'proxyFor',
	    value: function proxyFor(target) {
	      var proxy = {};
	      var self = this;
	
	      function proxyMethod(selector) {
	        return function () {
	          for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	            args[_key4] = arguments[_key4];
	          }
	
	          self.registerUndo.apply(self, [target, selector].concat(args));
	        };
	      }
	
	      (0, _utils.getAllPropertyNames)(target).forEach(function (selector) {
	        // don't trigger anything that has a getter
	        if ((0, _utils.hasGetter)(target, selector)) {
	          return;
	        }
	
	        // don't try to proxy properties that aren't functions
	        if (typeof target[selector] !== 'function') {
	          return;
	        }
	
	        // set up a proxy function to register an undo
	        proxy[selector] = proxyMethod(selector);
	      });
	
	      return proxy;
	    }
	  }]);
	
	  return UndoManager;
	})();
	
	exports['default'] = UndoManager;
	module.exports = exports['default'];
	
	},{"./utils":22}],22:[function(_dereq_,module,exports){
	/**
	 * @const
	 * @private
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.isDigits = isDigits;
	exports.startsWith = startsWith;
	exports.endsWith = endsWith;
	exports.zpad = zpad;
	exports.zpad2 = zpad2;
	exports.bind = bind;
	exports.replaceStringSelection = replaceStringSelection;
	exports.forEach = forEach;
	exports.hasGetter = hasGetter;
	exports.getAllPropertyNames = getAllPropertyNames;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var DIGITS_PATTERN = /^\d*$/;
	
	/**
	 * @const
	 * @private
	 */
	var SURROUNDING_SPACE_PATTERN = /(^\s+|\s+$)/;
	
	/**
	 * @param {string} string
	 * @returns {boolean}
	 */
	
	function isDigits(string) {
	  return DIGITS_PATTERN.test(string);
	}
	
	/**
	 * @param {string} prefix
	 * @param {string} string
	 * @returns {boolean}
	 */
	
	function startsWith(prefix, string) {
	  return string.slice(0, prefix.length) === prefix;
	}
	
	/**
	 * @param {string} suffix
	 * @param {string} string
	 * @returns {boolean}
	 */
	
	function endsWith(suffix, string) {
	  return string.slice(string.length - suffix.length) === suffix;
	}
	
	/**
	 * @param {string} string
	 * @returns {string}
	 */
	var trim = typeof ''.trim === 'function' ? function (string) {
	  return string.trim();
	} : function (string) {
	  return string.replace(SURROUNDING_SPACE_PATTERN, '');
	};
	
	exports.trim = trim;
	/**
	 * Will pad n with `0` up until length.
	 *
	 * @example
	 *     zpad(16, '1234');
	 *     // => 0000000000001234
	 *
	 * @param {number} length
	 * @param {(string|number)} n
	 * @returns {string}
	 */
	
	function zpad(length, n) {
	  var result = '' + n;
	  while (result.length < length) {
	    result = '0' + result;
	  }
	  return result;
	}
	
	/**
	 * Will pad n with `0` up until length is 2.
	 *
	 * @example
	 *     zpad2('2');
	 *     // => 02
	 *
	 * @param {(string|number)} n
	 * @returns {string}
	 */
	
	function zpad2(n) {
	  return zpad(2, n);
	}
	
	/**
	 * PhantomJS 1.9 does not have Function.bind.
	 *
	 * @param {Function} fn
	 * @param {*} context
	 * @returns {*}
	 */
	
	function bind(fn, context) {
	  return fn.bind(context);
	}
	
	if (!Function.prototype.bind) {
	  Function.prototype.bind = function (context) {
	    for (var _len = arguments.length, prependedArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      prependedArgs[_key - 1] = arguments[_key];
	    }
	
	    var self = this;
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return self.apply(context, prependedArgs.concat(args));
	    };
	  };
	}
	
	/**
	 * Replaces the characters within the selection with given text.
	 *
	 * @example
	 *     // 12|34567|8
	 *     replaceStringSelection('12345678', '00', { start: 2, length: 5 });
	 *     // 12|00|8
	 *
	 * @param   {string} replacement
	 * @param   {string} text
	 * @param   {object} {start: number, length: number}
	 * @returns {string}
	 */
	
	function replaceStringSelection(replacement, text, range) {
	  var end = range.start + range.length;
	  return text.substring(0, range.start) + replacement + text.substring(end);
	}
	
	var hasOwnProp = Object.prototype.hasOwnProperty;
	/**
	 * @param {*} iterable
	 * @param {Function} iterator
	 */
	
	function forEach(iterable, iterator) {
	  if (iterable && typeof iterable.forEach === 'function') {
	    iterable.forEach(iterator);
	  } else if (({}).toString.call(iterable) === '[object Array]') {
	    for (var i = 0, l = iterable.length; i < l; i++) {
	      iterator.call(null, iterable[i], i, iterable);
	    }
	  } else {
	    for (var key in iterable) {
	      if (hasOwnProp.call(iterable, key)) {
	        iterator.call(null, iterable[key], key, iterable);
	      }
	    }
	  }
	}
	
	var getOwnPropertyNames = (function () {
	  var getOwnPropertyNames = Object.getOwnPropertyNames;
	
	  try {
	    Object.getOwnPropertyNames({}, 'sq');
	  } catch (e) {
	    // IE 8
	    getOwnPropertyNames = function (object) {
	      var result = [];
	      for (var key in object) {
	        if (hasOwnProp.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    };
	  }
	
	  return getOwnPropertyNames;
	})();
	
	var getPrototypeOf = Object.getPrototypeOf || function (object) {
	  return object.__proto__;
	};
	/**
	 * @param {Object} object
	 * @param {string} property
	 * @returns {boolean}
	 */
	
	function hasGetter(object, property) {
	  // Skip if getOwnPropertyDescriptor throws (IE8)
	  try {
	    Object.getOwnPropertyDescriptor({}, 'sq');
	  } catch (e) {
	    return false;
	  }
	
	  var descriptor = undefined;
	
	  if (object && object.constructor && object.constructor.prototype) {
	    descriptor = Object.getOwnPropertyDescriptor(object.constructor.prototype, property);
	  }
	
	  if (!descriptor) {
	    descriptor = Object.getOwnPropertyDescriptor(object, property);
	  }
	
	  if (descriptor && descriptor.get) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	/**
	 * @param {Object} object
	 * @returns {?string[]}
	 */
	
	function getAllPropertyNames(object) {
	  if (object === null || object === undefined) {
	    return [];
	  }
	
	  var result = getOwnPropertyNames(object);
	
	  var prototype = object.constructor && object.constructor.prototype;
	  while (prototype) {
	    result.push.apply(result, _toConsumableArray(getOwnPropertyNames(prototype)));
	    prototype = getPrototypeOf(prototype);
	  }
	
	  return result;
	}
	
	},{}]},{},[15])(15)
	});
	//# sourceMappingURL=field-kit.js.map


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bag.c4a99837.svg";

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/computer.13e55497.svg";

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/creditcard.5710702b.svg";

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/back-button.3d837ff0.svg";

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/close-button.10d85fda.svg";

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/purse.d5a6c167.svg";

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/success.e271083c.svg";

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(54);
	
	var _DOMUtils = __webpack_require__(75);
	
	var _createHistory = __webpack_require__(131);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(34);
	
	var _PathUtils = __webpack_require__(29);
	
	var _ExecutionEnvironment = __webpack_require__(54);
	
	var _DOMUtils = __webpack_require__(75);
	
	var _DOMStateStorage = __webpack_require__(128);
	
	var _createDOMHistory = __webpack_require__(129);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(364);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(29);
	
	var _AsyncUtils = __webpack_require__(450);
	
	var _Actions = __webpack_require__(34);
	
	var _createLocation2 = __webpack_require__(452);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(77);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(76);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(54);
	
	var _PathUtils = __webpack_require__(29);
	
	var _runTransitionHook = __webpack_require__(77);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(76);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    ordinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    ordinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    ordinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[I dag kl.] LT',
	        nextDay : '[I morgen kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[I går kl.] LT',
	        lastWeek : '[sidste] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    ordinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	    weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-an de] MMMM, YYYY',
	        LLL : 'D[-an de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'je %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    ordinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چندین ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    ordinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : '');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    ordinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'Ah時m分',
	        LTS : 'Ah時m分s秒',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah時m分',
	        LLLL : 'YYYY年M月D日Ah時m分 dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    ordinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h시 m분',
	        LTS : 'A h시 m분 s초',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h시 m분',
	        LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '일분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    ordinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    ordinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    ordinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    ordinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    ordinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    },
	    nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    ordinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah点mm分',
	        LTS : 'Ah点m分s秒',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah点mm分',
	        llll : 'YYYY年MMMD日ddddAh点mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : function () {
	            return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	        },
	        nextDay : function () {
	            return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	        },
	        lastDay : function () {
	            return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	        },
	        nextWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        lastWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        sameElse : 'LL'
	    },
	    ordinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 241 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(281);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 243 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(30);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(36);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactInstrumentation = __webpack_require__(18);
	
	var quoteAttributeValueForBrowser = __webpack_require__(525);
	var warning = __webpack_require__(7);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 246 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var LinkedValueUtils = __webpack_require__(84);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactUpdates = __webpack_require__(21);
	
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 248 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 249 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var invariant = __webpack_require__(5);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(484);
	
	var containsNode = __webpack_require__(412);
	var focusNode = __webpack_require__(118);
	var getActiveElement = __webpack_require__(119);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var DOMLazyTree = __webpack_require__(35);
	var DOMProperty = __webpack_require__(36);
	var React = __webpack_require__(39);
	var ReactBrowserEventEmitter = __webpack_require__(57);
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactDOMContainerInfo = __webpack_require__(478);
	var ReactDOMFeatureFlags = __webpack_require__(480);
	var ReactFeatureFlags = __webpack_require__(249);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactMarkupChecksum = __webpack_require__(494);
	var ReactReconciler = __webpack_require__(37);
	var ReactUpdateQueue = __webpack_require__(87);
	var ReactUpdates = __webpack_require__(21);
	
	var emptyObject = __webpack_require__(33);
	var instantiateReactComponent = __webpack_require__(259);
	var invariant = __webpack_require__(5);
	var setInnerHTML = __webpack_require__(61);
	var shouldUpdateReactComponent = __webpack_require__(93);
	var warning = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var React = __webpack_require__(39);
	
	var invariant = __webpack_require__(5);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 254 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 256 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(253);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8),
	    _assign = __webpack_require__(11);
	
	var ReactCompositeComponent = __webpack_require__(475);
	var ReactEmptyComponent = __webpack_require__(248);
	var ReactHostComponent = __webpack_require__(250);
	
	var getNextDebugID = __webpack_require__(522);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	var escapeTextContentForBrowser = __webpack_require__(60);
	var setInnerHTML = __webpack_require__(61);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var REACT_ELEMENT_TYPE = __webpack_require__(490);
	
	var getIteratorFn = __webpack_require__(521);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(83);
	var warning = __webpack_require__(7);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(26);
	
	var _PatternUtils = __webpack_require__(38);
	
	var _InternalPropTypes = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(63);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(55);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(132);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(453);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(269);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(63);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(55);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(132);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stripDiacritics = __webpack_require__(272);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function filterOptions(options, filterValue, excludeOptions, props) {
		var _this = this;
	
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2['default'])(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
			if (!filterValue) return true;
			var valueTest = String(option[props.valueKey]);
			var labelTest = String(option[props.labelKey]);
			if (props.ignoreAccents) {
				if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
				if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
			}
			if (props.ignoreCase) {
				if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
			return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	}
	
	module.exports = filterOptions;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption;
		var instancePrefix = _ref.instancePrefix;
		var labelKey = _ref.labelKey;
		var onFocus = _ref.onFocus;
		var onSelect = _ref.onSelect;
		var optionClassName = _ref.optionClassName;
		var optionComponent = _ref.optionComponent;
		var optionRenderer = _ref.optionRenderer;
		var options = _ref.options;
		var valueArray = _ref.valueArray;
		var valueKey = _ref.valueKey;
		var onOptionRef = _ref.onOptionRef;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.indexOf(option) > -1;
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2['default'])(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2['default'].createElement(
				Option,
				{
					className: optionClass,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function (ref) {
						onOptionRef(ref, isFocused);
					}
				},
				optionRenderer(option, i)
			);
		});
	}
	
	module.exports = menuRenderer;

/***/ },
/* 272 */
/***/ function(module, exports) {

	'use strict';
	
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	module.exports = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(52);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tab = __webpack_require__(64);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function renderChildren(props) {
	  return _react2.default.Children.map(props.children, function (child) {
	    // if child is not a tab we don't need to clone it
	    // since we don't need to add custom props
	
	    if (child.type !== _Tab2.default) {
	      return child;
	    }
	
	    var clonedProps = {
	      activeTabClassName: props.activeTabClassName,
	      disabledTabClassName: props.disabledTabClassName
	    };
	
	    return _react2.default.cloneElement(child, clonedProps);
	  });
	}
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'TabList',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    activeTabClassName: _propTypes2.default.string,
	    disabledTabClassName: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
	  },
	
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        activeTabClassName = _props.activeTabClassName,
	        disabledTabClassName = _props.disabledTabClassName,
	        children = _props.children,
	        attributes = _objectWithoutProperties(_props, ['className', 'activeTabClassName', 'disabledTabClassName', 'children']);
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__TabList', className),
	        role: 'tablist'
	      }),
	      renderChildren({ activeTabClassName: activeTabClassName, disabledTabClassName: disabledTabClassName, children: children })
	    );
	  }
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabPanel = exports.Tab = exports.TabList = exports.Tabs = undefined;
	
	var _Tabs = __webpack_require__(558);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabList = __webpack_require__(273);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _Tab = __webpack_require__(64);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabPanel = __webpack_require__(557);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tabs = _Tabs2.default;
	exports.TabList = _TabList2.default;
	exports.Tab = _Tab2.default;
	exports.TabPanel = _TabPanel2.default;
	
	// For bc we also export a default object, remove in 1.0
	
	exports.default = {
	  Tabs: _Tabs2.default,
	  TabList: _TabList2.default,
	  Tab: _Tab2.default,
	  TabPanel: _TabPanel2.default
	};

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(41);
	
	var ReactCurrentOwner = __webpack_require__(25);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 276 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 279 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(458).enable();
	  window.Promise = __webpack_require__(457);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(579);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(11);


/***/ },
/* 281 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Utils = __webpack_require__(42);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** This generates a basic error response when receiving and ajax error and rejecting a promise. */
	function generateRejectResponse(reject) {
	  return function (data, url, httpStatusCode) {
	    var errorData = { message: "Ajax Error: " + httpStatusCode };
	    errorData.response = data;
	    errorData.url = url;
	    errorData.httpStatusCode = httpStatusCode;
	    if (data.message) errorData.message = data.message;
	
	    reject(errorData);
	  };
	}
	
	function post(url, data) {
	  return new Promise(function (accept, reject) {
	    var payload = {
	      url: url,
	      type: 'POST',
	      success: accept,
	      error: generateRejectResponse(reject)
	    };
	
	    if (data) payload.data = data;
	    _Utils2.default.ajax(payload);
	  });
	}
	
	function get(url) {
	  return new Promise(function (accept, reject) {
	    var payload = {
	      url: url,
	      type: 'GET',
	      success: accept,
	      error: generateRejectResponse(reject)
	    };
	    _Utils2.default.ajax(payload);
	  });
	}
	
	function del(url) {
	  return new Promise(function (accept, reject) {
	    var payload = {
	      url: url,
	      type: 'DELETE',
	      success: accept,
	      error: generateRejectResponse(reject)
	    };
	    _Utils2.default.ajax(payload);
	  });
	}
	
	exports.default = {
	  post: post,
	  get: get,
	  delete: del
	};

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._cache = undefined;
	
	var _wolfy87Eventemitter = __webpack_require__(580);
	
	var _wolfy87Eventemitter2 = _interopRequireDefault(_wolfy87Eventemitter);
	
	var _Utils = __webpack_require__(42);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _cache = {
	  products: {},
	  brands: {},
	  cart: null,
	  cartVisible: false,
	  user: null,
	  orderList: null,
	  retailer: null,
	  lastSelectedRetailerToken: null,
	  recommendations: {
	    url: null,
	    response: null
	  },
	  categoryTypes: null,
	  categories: {},
	  productCollections: null,
	
	  productSearchActive: false,
	  productSearchTerm: '',
	  productSearchRecommendations: null,
	
	  selectedInstrument: '',
	  lastAddedProductToken: null,
	  adminBarVisible: true,
	  campaignRetailerToken: null,
	
	  currentRecommendationSet: null,
	  currentRecommendationFilter: []
	};
	
	var cache = {
	  emitter: new _wolfy87Eventemitter2.default(),
	  eventTypes: {
	    CATEGORIES_CHANGED: 'CATEGORIES_CHANGED',
	    CATEGORY_DATA_CHANGED: 'CATEGORY_DATA_CHANGED',
	    PRODUCTS_CHANGED: 'PRODUCTS_CHANGED',
	    BRANDS_CHANGED: 'BRANDS_CHANGED',
	    RECOMMENDATIONS_CHANGED: 'RECOMMENDATIONS_CHANGED',
	    CART_CHANGED: 'CART_CHANGED',
	    CART_VISIBLE_CHANGED: 'CART_VISIBLE_CHANGED',
	    USER_CHANGED: 'USER_CHANGED',
	    RETAILER_CHANGED: 'RETAILER_CHANGED',
	    ORDER_LIST_CHANGED: 'ORDER_LIST_CHANGED',
	    PRODUCT_COLLECTIONS_CHANGED: 'PRODUCT_COLLECTIONS_CHANGED',
	    PRODUCT_SEARCH_TERM_CHANGED: 'PRODUCT_SEARCH_TERM_CHANGED',
	    PRODUCT_SEARCH_ACTIVE_CHANGED: 'PRODUCT_SEARCH_ACTIVE_CHANGED',
	    PRODUCT_SEARCH_RECOMMENDATIONS_CHANGED: 'PRODUCT_SEARCH_RECOMMENDATIONS_CHANGED',
	    SELECTED_INSTRUMENT_CHANGED: 'SELECTED_INSTRUMENT_CHANGED',
	    LAST_ADDED_PRODUCT_TOKEN_CHANGED: 'LAST_ADDED_PRODUCT_TOKEN_CHANGED',
	    ADMIN_BAR_VISIBILITY_CHANGED: 'ADMIN_BAR_VISIBILITY_CHANGED',
	    CURRENT_RECOMMENDATION_SET_CHANGED: 'CURRENT_RECOMMENDATION_SET_CHANGED',
	    CURRENT_RECOMMENDATION_FILTER_CHANGED: 'CURRENT_RECOMMENDATION_FILTER_CHANGED'
	  },
	
	  addChangeListener: function addChangeListener(callback, eventType) {
	    this.emitter.on(eventType, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback, eventType) {
	    this.emitter.removeListener(eventType, callback);
	  },
	
	
	  // Get the cached value based on the eventType
	  getForEventType: function getForEventType(eventType) {
	    switch (eventType) {
	      case this.eventTypes.USER_CHANGED:
	        return this.getUser();
	      case this.eventTypes.RETAILER_CHANGED:
	        return this.getRetailer();
	      case this.eventTypes.CART_CHANGED:
	        return this.getCart();
	      case this.eventTypes.CART_VISIBLE_CHANGED:
	        return this.getCartVisible();
	      case this.eventTypes.ORDER_LIST_CHANGED:
	        return this.getOrderList();
	      case this.eventTypes.PRODUCT_SEARCH_TERM_CHANGED:
	        return this.getProductSearchTerm();
	      case this.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED:
	        return this.getProductSearchActive();
	      case this.eventTypes.PRODUCT_SEARCH_RECOMMENDATIONS_CHANGED:
	        return this.getProductSearchRecommendations();
	      case this.eventTypes.RECOMMENDATIONS_CHANGED:
	        return this.getRecommendations().response;
	      case this.eventTypes.PRODUCT_COLLECTIONS_CHANGED:
	        return this.getProductCollections();
	      case this.eventTypes.LAST_ADDED_PRODUCT_TOKEN_CHANGED:
	        return this.getLastAddedProductToken();
	      case this.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED:
	        return this.getAdminBarVisible();
	      case this.eventTypes.CATEGORIES_CHANGED:
	        return this.getCategories();
	      case this.eventTypes.CATEGORY_DATA_CHANGED:
	        return this.getCategoryData();
	      case this.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED:
	        return this.getCurrentRecommendationSet();
	      case this.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED:
	        return this.getCurrentRecommendationFilter();
	      default:
	        console.error('getEventForType() does not have a value for the type "%s"', eventType);
	    }
	
	    return null;
	  },
	
	
	  /* --- Recommendations --- */
	
	  setRecommendations: function setRecommendations(url, response) {
	    _cache.recommendations.url = url;
	    _cache.recommendations.response = response;
	    this.emitter.emitEvent(this.eventTypes.RECOMMENDATIONS_CHANGED);
	  },
	  getRecommendations: function getRecommendations() {
	    return _cache.recommendations;
	  },
	  hasProductRecommendations: function hasProductRecommendations() {
	    if (!_cache.recommendations.response || !_cache.recommendations.response.products) return false;
	    if (Array.isArray(_cache.recommendations.response.products) && _cache.recommendations.response.products.length > 0) return true;
	    if (_cache.recommendations.response.display_order && _cache.recommendations.response.display_order.length > 0) return true;
	
	    return false;
	  },
	
	
	  /* --- Products --- */
	
	  setProducts: function setProducts(products) {
	    if (Array.isArray(products)) {
	      products.forEach(function (product) {
	        _cache.products[product.token] = product;
	      });
	    } else {
	      Object.keys(products).forEach(function (token) {
	        _cache.products[token] = products[token];
	      });
	    }
	
	    this.emitter.emitEvent(this.eventTypes.PRODUCTS_CHANGED);
	  },
	  removeProduct: function removeProduct(productToken) {
	    delete _cache.products[productToken];
	    this.emitter.emitEvent(this.eventTypes.PRODUCTS_CHANGED);
	  },
	
	
	  /* --- Brand --- */
	
	  setBrands: function setBrands(brands) {
	    if (Array.isArray(brands)) {
	      brands.forEach(function (brand) {
	        _cache.brands[brand.token] = brand;
	      });
	    } else {
	      Object.keys(brands).forEach(function (brandToken) {
	        _cache.brands[brandToken] = brands[brandToken];
	      });
	    }
	    this.emitter.emitEvent(this.eventTypes.BRANDS_CHANGED);
	  },
	  getBrand: function getBrand(brandToken) {
	    return _cache.brands[brandToken];
	  },
	  removeBrand: function removeBrand(brandToken) {
	    delete _cache.brands[brandToken];
	    this.emitter.emitEvent(this.eventTypes.BRANDS_CHANGED);
	  },
	
	
	  /* --- Categories --- */
	  setCategories: function setCategories(data) {
	    if (_cache.categoryTypes === data) return;
	
	    _cache.categoryTypes = data;
	    this.emitter.emitEvent(this.eventTypes.CATEGORIES_CHANGED);
	  },
	  getCategories: function getCategories() {
	    return _cache.categoryTypes;
	  },
	  clearCategoryData: function clearCategoryData() {
	    _cache.categories = {};
	  },
	  setCategoryData: function setCategoryData(query, data) {
	    _cache.categories[query] = data;
	    this.emitter.emitEvent(this.eventTypes.CATEGORY_DATA_CHANGED);
	  },
	  getCategoryData: function getCategoryData(query) {
	    return _cache.categories[query];
	  },
	
	
	  /* --- Cart --- */
	  setCart: function setCart(data) {
	    // Only change the data if the data is different
	    if (_cache.cart === data) return;
	
	    data = data || {};
	
	    var i = void 0,
	        j = void 0;
	
	    var parsed_items = [];
	    var cart_value_cents = 0;
	    var below_minimum = [];
	
	    // Find all items with the given brand_token.
	    function itemsForBrand(items, brand_token) {
	      return items.filter(function (item) {
	        return item.brand_token === brand_token;
	      });
	    }
	
	    var brandKeys = data.brands ? Object.keys(data.brands) : [];
	    for (i = 0; i < brandKeys.length; i++) {
	      var brand = _Utils2.default.clone(data.brands[brandKeys[i]]);
	
	      // Put all items from our brand in our new object
	      brand.products = itemsForBrand(data.cart.items, brand.token);
	
	      // Calculate the total order value for the brand
	      brand.total_cents = 0;
	      for (j = 0; j < brand.products.length; j++) {
	        var currentItem = brand.products[j];
	        try {
	          brand.total_cents += currentItem.price_cents * currentItem.quantity;
	        } catch (e) {
	          console.error(e);
	          console.error("Error adding total cents.");
	          console.error(currentItem);
	          console.error("brand");
	          console.error(brand);
	        }
	      }
	      brand.below_minimum = brand.total_cents < brand.minimum_order_amount_cents;
	      if (brand.below_minimum) {
	        below_minimum.push(brand.token);
	      }
	      cart_value_cents += brand.total_cents;
	
	      parsed_items.push(brand);
	    }
	
	    data.cart = data.cart || { items: [] };
	    data.parsed_items = parsed_items;
	    data.cart.total_value_cents = cart_value_cents;
	    data.below_minimum = below_minimum;
	
	    _cache.cart = data;
	    this.emitter.emitEvent(this.eventTypes.CART_CHANGED);
	  },
	  getCart: function getCart() {
	    return _cache.cart;
	  },
	  setCartVisible: function setCartVisible(visible) {
	    if (visible === _cache.cartVisible) return;
	    _cache.cartVisible = visible;
	    this.emitter.emitEvent(this.eventTypes.CART_VISIBLE_CHANGED);
	  },
	  getCartVisible: function getCartVisible() {
	    return _cache.cartVisible;
	  },
	
	
	  /* --- Last Added Product --- */
	  getLastAddedProductToken: function getLastAddedProductToken() {
	    return _cache.lastAddedProductToken;
	  },
	  setLastAddedProductToken: function setLastAddedProductToken(productToken) {
	    if (_cache.lastAddedProductToken === productToken) return;
	
	    _cache.lastAddedProductToken = productToken;
	    this.emitter.emitEvent(this.eventTypes.LAST_ADDED_PRODUCT_TOKEN_CHANGED);
	  },
	
	
	  /* --- User --- */
	  setUser: function setUser(user) {
	    if (_cache.user === user) return;
	
	    // Clear category cache whenever user changes.
	    if (!_cache.user || !user) this.clearCategoryData();
	    if (_cache.user && user && _cache.user.token !== user.token) this.clearCategoryData();
	
	    _cache.user = user;
	    this.emitter.emitEvent(this.eventTypes.USER_CHANGED);
	  },
	  getUser: function getUser() {
	    return _cache.user;
	  },
	
	
	  /* --- Retailer --- */
	  setRetailer: function setRetailer(retailer) {
	    if (_cache.retailer === retailer) return;
	
	    _cache.retailer = retailer;
	    if (retailer && retailer.token && retailer.token !== _cache.lastSelectedRetailerToken) {
	      _cache.lastSelectedRetailerToken = retailer.token;
	      this.clearCategoryData();
	    }
	    if (!retailer) {
	      this.clearCategoryData();
	    }
	
	    this.emitter.emitEvent(this.eventTypes.RETAILER_CHANGED);
	  },
	  getRetailer: function getRetailer() {
	    return _cache.retailer;
	  },
	  setLastSelectedRetailerToken: function setLastSelectedRetailerToken(token) {
	    _cache.lastSelectedRetailerToken = token;
	  },
	  getLastSelectedRetailerToken: function getLastSelectedRetailerToken() {
	    return _cache.lastSelectedRetailerToken;
	  },
	
	
	  /* --- Order List --- */
	  setOrderList: function setOrderList(list) {
	    _cache.orderList = list;
	    this.emitter.emitEvent(this.eventTypes.ORDER_LIST_CHANGED);
	  },
	  getOrderList: function getOrderList() {
	    return _cache.orderList;
	  },
	
	
	  /* --- Product Collections --- */
	  setProductCollections: function setProductCollections(productCollections) {
	    _cache.productCollections = productCollections;
	    this.emitter.emitEvent(this.eventTypes.PRODUCT_COLLECTIONS_CHANGED);
	  },
	  getProductCollections: function getProductCollections() {
	    return _cache.productCollections;
	  },
	
	
	  /* --- Search --- */
	  setProductSearchTerm: function setProductSearchTerm(productSearchTerm) {
	    if (_cache.productSearchTerm === productSearchTerm) return;
	
	    _cache.productSearchTerm = productSearchTerm;
	    this.emitter.emitEvent(this.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
	  },
	  getProductSearchTerm: function getProductSearchTerm() {
	    return _cache.productSearchTerm;
	  },
	  setProductSearchActive: function setProductSearchActive(productSearchActive) {
	    if (_cache.productSearchActive === productSearchActive) return;
	
	    _cache.productSearchActive = productSearchActive;
	    this.emitter.emitEvent(this.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
	  },
	  getProductSearchActive: function getProductSearchActive() {
	    return _cache.productSearchActive;
	  },
	  setProductSearchRecommendations: function setProductSearchRecommendations(recommendations) {
	    if (_cache.productSearchRecommendations === recommendations) return;
	
	    _cache.productSearchRecommendations = recommendations;
	    this.emitter.emitEvent(this.eventTypes.PRODUCT_SEARCH_RECOMMENDATIONS_CHANGED);
	  },
	  getProductSearchRecommendations: function getProductSearchRecommendations() {
	    return _cache.productSearchRecommendations;
	  },
	
	
	  /* --- Selected Instrument --- */
	  setSelectedInstrument: function setSelectedInstrument(selectedInstrument) {
	    if (_cache.selectedInstrument === selectedInstrument) return;
	
	    _cache.selectedInstrument = selectedInstrument;
	    this.emitter.emitEvent(this.eventTypes.SELECTED_INSTRUMENT_CHANGED);
	  },
	  getSelectedInstrument: function getSelectedInstrument() {
	    return _cache.selectedInstrument;
	  },
	
	
	  /* --- Admin Bar --- */
	  getAdminBarVisible: function getAdminBarVisible() {
	    return _cache.adminBarVisible;
	  },
	  setAdminBarVisible: function setAdminBarVisible(visibility) {
	    if (_cache.adminBarVisible === visibility) return;
	
	    _cache.adminBarVisible = visibility;
	    this.emitter.emitEvent(this.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
	  },
	
	
	  /* --- Campaign Retailer Token --- */
	  getCampaignRetailerToken: function getCampaignRetailerToken() {
	    return _cache.campaignRetailerToken;
	  },
	  setCampaignRetailerToken: function setCampaignRetailerToken(retailerToken) {
	    _cache.campaignRetailerToken = retailerToken;
	  },
	
	
	  /* --- Recommendation and Recommendation Filter --- */
	  getCurrentRecommendationSet: function getCurrentRecommendationSet() {
	    return _cache.currentRecommendationSet;
	  },
	  setCurrentRecommendationSet: function setCurrentRecommendationSet(recommendations) {
	    if (_cache.currentRecommendationSet === recommendations) return;
	
	    _cache.currentRecommendationSet = recommendations;
	    this.emitter.emitEvent(this.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
	  },
	  getCurrentRecommendationFilter: function getCurrentRecommendationFilter() {
	    return _cache.currentRecommendationFilter;
	  },
	  setCurrentRecommendationFilter: function setCurrentRecommendationFilter(filter) {
	    filter = filter || [];
	    if (_cache.currentRecommendationFilter === filter) return;
	
	    _cache.currentRecommendationFilter = filter;
	    this.emitter.emitEvent(this.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
	  }
	};
	
	exports.default = cache;
	exports._cache = _cache;

/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var clone;
	
	var cloneObject = function cloneObject(obj, deep) {
	  var ret = {};
	  var keys = Object.keys(obj);
	  var i;
	  for (i = 0; i < keys.length; i++) {
	    ret[keys[i]] = deep ? clone(obj[keys[i]], deep) : obj[keys[i]];
	  }
	
	  return ret;
	};
	
	var cloneArray = function cloneArray(arr, deep) {
	  var ret = [];
	  var i;
	  for (i = 0; i < arr.length; i++) {
	    ret.push(deep ? clone(arr[i], deep) : arr[i]);
	  }
	
	  return ret;
	};
	
	clone = function clone(obj, deep) {
	  if (!obj) return obj;
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') return obj;
	  if (Array.isArray(obj)) {
	    return cloneArray(obj, deep);
	  } else {
	    return cloneObject(obj, deep);
	  }
	};
	
	module.exports = clone;
	module.exports.array = cloneArray;
	module.exports.object = cloneObject;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(27);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FieldComponents = __webpack_require__(67);
	
	var _AdminFunctions = __webpack_require__(49);
	
	var _consts = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorClass = 'error';
	
	var BrandLogisticsEditor = function (_Component) {
	  _inherits(BrandLogisticsEditor, _Component);
	
	  function BrandLogisticsEditor(props) {
	    _classCallCheck(this, BrandLogisticsEditor);
	
	    var _this = _possibleConstructorReturn(this, (BrandLogisticsEditor.__proto__ || Object.getPrototypeOf(BrandLogisticsEditor)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.onInput = _this.onInput.bind(_this);
	    _this.onAddressStateChange = _this.onAddressStateChange.bind(_this);
	    _this.onCountryOriginChange = _this.onCountryOriginChange.bind(_this);
	    _this.onSecondaryOriginChange = _this.onSecondaryOriginChange.bind(_this);
	    _this.onImagesChange = _this.onImagesChange.bind(_this);
	    _this.onImagesClear = _this.onImagesClear.bind(_this);
	    _this.onImagesNew = _this.onImagesNew.bind(_this);
	    _this.onBrandChanged = _this.onBrandChanged.bind(_this);
	
	    _this.state = _this.createState(props.logistics);
	    return _this;
	  }
	
	  _createClass(BrandLogisticsEditor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.cache.addChangeListener(this.onBrandChanged, _Api2.default.cache.eventTypes.BRANDS_CHANGED);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.onBrandChanged, _Api2.default.cache.eventTypes.BRANDS_CHANGED);
	    }
	  }, {
	    key: 'createState',
	    value: function createState(logistics) {
	      logistics = logistics || {};
	
	      var _logistics = logistics,
	          token = _logistics.token,
	          email_address = _logistics.email_address,
	          phone_number = _logistics.phone_number,
	          active = _logistics.active,
	          address = _logistics.address,
	          commission_bps = _logistics.commission_bps,
	          minimum_order_amount_cents = _logistics.minimum_order_amount_cents,
	          images = _logistics.images,
	          email_hero_image = _logistics.email_hero_image,
	          email_description = _logistics.email_description,
	          made_in = _logistics.made_in,
	          made_in_state = _logistics.made_in_state,
	          made_in_city = _logistics.made_in_city,
	          hand_made = _logistics.hand_made,
	          charitable = _logistics.charitable,
	          eco_friendly = _logistics.eco_friendly;
	
	
	      images = (images || []).map(function (image) {
	        return { key: image.token, value: image };
	      });
	
	      email_hero_image = email_hero_image || { url: '' };
	
	      var minimum_order_amount_dollars = _Api2.default.Utils.formatCents(minimum_order_amount_cents, false, true) || '';
	
	      var secondaryOriginEnabled = logistics.made_in === _consts.CANADA_ISO || logistics.made_in === _consts.US_ISO;
	      var secondaryOptions = [];
	      if (secondaryOriginEnabled) {
	        secondaryOptions = logistics.made_in === _consts.US_ISO ? _consts.USA_STATES : _consts.CAN_PROVINCES;
	      }
	
	      if (made_in) {
	        var label = _consts.ISO_TO_COUNTRY_NAME[made_in] || made_in;
	        made_in = { label: label, value: made_in };
	      }
	
	      if (made_in_state) {
	        var _label = _consts.STATE_PROVINCE_SHORTHAND_TO_NAME[made_in_state] || made_in_state;
	        made_in_state = { label: _label, value: made_in_state };
	      }
	
	      address = address || {};
	      commission_bps = _Api2.default.Utils.formatCents(commission_bps) || '';
	
	      var address_state = null;
	      if (address.state) {
	        var _label2 = _consts.STATE_PROVINCE_SHORTHAND_TO_NAME[address.state];
	        if (_label2) {
	          address_state = { label: _label2, value: address.state };
	        } else {
	          address_state = { label: address_state, value: address_state };
	        }
	      }
	
	      var error = this.state && this.state.error || false;
	
	      return {
	        token: token,
	        error: error,
	        active: active,
	        email_address: email_address || '',
	        phone_number: phone_number || '',
	        commission_bps: commission_bps,
	        images: images,
	        made_in: made_in,
	        made_in_state: made_in_state,
	        made_in_city: made_in_city,
	        email_hero_image: email_hero_image,
	        email_description: email_description || '',
	        minimum_order_amount_dollars: minimum_order_amount_dollars,
	        secondaryOriginEnabled: secondaryOriginEnabled,
	        secondaryOptions: secondaryOptions,
	        hand_made: hand_made,
	        charitable: charitable,
	        eco_friendly: eco_friendly,
	
	        // Flatten address properties
	        address_name: address.name || '',
	        address_address1: address.address1 || '',
	        address_address2: address.address2 || '',
	        address_postal_code: address.postal_code || '',
	        address_city: address.city || '',
	        address_state: address_state,
	        address_instructions: address.instructions || ''
	      };
	    }
	  }, {
	    key: 'onBrandChanged',
	    value: function onBrandChanged() {
	      var _this2 = this;
	
	      if (!this.state.token) return;
	      _Api2.default.getBrand(this.state.token, true).then(function (brand) {
	        _this2.setState(_this2.createState(brand));
	      });
	    }
	  }, {
	    key: 'onInput',
	    value: function onInput(name, input, error) {
	      var _setState;
	
	      var errorKey = (0, _AdminFunctions.getErrorKey)(name);
	      this.setState((_setState = {}, _defineProperty(_setState, name, input), _defineProperty(_setState, errorKey, error), _setState));
	    }
	  }, {
	    key: 'onCountryOriginChange',
	    value: function onCountryOriginChange(selectedCountry) {
	      var original = this.state.made_in && this.state.made_in.value || null;
	      var updated = selectedCountry && selectedCountry.value || null;
	
	      if (original === updated) return;
	
	      var secondaryOriginEnabled = updated === _consts.US_ISO || updated === _consts.CANADA_ISO;
	      var secondaryOptions = [];
	      if (secondaryOriginEnabled) {
	        secondaryOptions = updated === _consts.US_ISO ? _consts.USA_STATES : _consts.CAN_PROVINCES;
	      }
	
	      this.setState({
	        made_in: selectedCountry,
	        from: null,
	        secondaryOriginEnabled: secondaryOriginEnabled,
	        secondaryOptions: secondaryOptions
	      });
	    }
	  }, {
	    key: 'onSecondaryOriginChange',
	    value: function onSecondaryOriginChange(selectedStateProv) {
	      if (!this.state.made_in || this.state.made_in.value !== _consts.CANADA_ISO && this.state.made_in.value !== _consts.US_ISO) return;
	
	      this.setState({
	        made_in_state: selectedStateProv
	      });
	    }
	  }, {
	    key: 'onImagesChange',
	    value: function onImagesChange(index, key, value) {
	      var images = this.state.images;
	      if (index > images.length) {
	        images.push({ key: key, value: value });
	      } else {
	        images[index] = { key: key, value: value };
	      }
	      this.setState({
	        images: images
	      });
	    }
	  }, {
	    key: 'onImagesNew',
	    value: function onImagesNew() {
	      return { key: 'image-' + this.state.images.length + '-' + Date.now(), value: { url: '' } };
	    }
	  }, {
	    key: 'onImagesClear',
	    value: function onImagesClear(index) {
	      var images = this.state.images;
	      if (index >= images.length) return;
	      images.splice(index, 1);
	      this.setState({
	        images: images
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this3 = this;
	
	      var data = {
	        token: this.state.token,
	        active: this.state.active,
	        commission_bps: _Api2.default.Utils.dollarToCents(this.state.commission_bps),
	        email_address: this.state.email_address,
	        phone_number: this.state.phone_number,
	        email_description: this.state.email_description,
	        charitable: !!this.state.charitable,
	        hand_made: !!this.state.hand_made,
	        eco_friendly: !!this.state.eco_friendly,
	        made_in_city: this.state.made_in_city
	      };
	
	      data.address = {
	        name: this.state.address_name,
	        address1: this.state.address_address1,
	        address2: this.state.address_address2,
	        postal_code: this.state.address_postal_code,
	        city: this.state.address_city,
	        state: this.state.address_state && this.state.address_state.value || null,
	        instructions: this.state.address_instructions
	      };
	
	      if (this.state.email_hero_image) {
	        data.email_hero_image = this.state.email_hero_image;
	      }
	
	      if (this.state.minimum_order_amount_dollars) {
	        data.minimum_order_amount_cents = _Api2.default.Utils.dollarToCents(this.state.minimum_order_amount_dollars);
	      }
	
	      data.images = this.state.images.filter(function (image) {
	        return !!(image && image.value && image.value.url);
	      }).map(function (image) {
	        return image.value;
	      });
	
	      if (this.state.made_in) {
	        data.made_in = this.state.made_in.value;
	      }
	
	      if (this.state.made_in_state) {
	        data.made_in_state = this.state.made_in_state.value;
	      }
	
	      return _Api2.default.saveBrand(data).catch(function (error) {
	        alert((0, _AdminFunctions.createAlertMessage)(error));
	        _this3.setState({
	          errorView: _this3.createErrorView(null, null, error)
	        });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      var errorView = this.createErrorView();
	
	      if (errorView) {
	        this.setState({
	          errorView: errorView
	        });
	      } else {
	        return this.submit();
	      }
	    }
	  }, {
	    key: 'onAddressStateChange',
	    value: function onAddressStateChange(selectedState) {
	      this.setState({
	        address_state: selectedState
	      });
	    }
	  }, {
	    key: 'createErrorView',
	    value: function createErrorView(error) {
	      var emailErrorKey = (0, _AdminFunctions.getErrorKey)('email_address');
	      var messages = [];
	      if (this.state[emailErrorKey]) {
	        messages.push('Invalid email field');
	      }
	
	      if (messages.length === 0 && !error) {
	        return null;
	      }
	
	      var view = void 0;
	      if (messages.length !== 0) {
	        var listItems = messages.map(function (m, index) {
	          var key = 'error-message-' + index;
	          return _react2.default.createElement(
	            'li',
	            { key: key },
	            m
	          );
	        });
	        view = _react2.default.createElement(
	          'ul',
	          null,
	          listItems
	        );
	      } else {
	        view = error && error.message && error.message.message || 'There was an error saving the content';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-error-message' },
	        view
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var emailErrorKey = (0, _AdminFunctions.getErrorKey)('email_address');
	      var emailErrorClass = this.state[emailErrorKey] ? ErrorClass : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'brand-logistics-editor' },
	        _react2.default.createElement(
	          'form',
	          { className: 'admin-editor', onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Brand Logistic Info'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'active', className: 'label' },
	                'Active'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                type: 'checkbox',
	                name: 'active',
	                defaultChecked: this.state.active })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'email_address', className: 'label' },
	                'E-Mail'
	              ),
	              _react2.default.createElement(_FieldComponents.EmailField, { placeholder: 'Email Address',
	                className: emailErrorClass,
	                name: 'email_address',
	                onInput: this.onInput,
	                value: this.state.email_address,
	                required: false })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'phone_number', className: 'label' },
	                'Phone Number'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { name: 'phone_number',
	                placeholder: 'Phone Number',
	                onInput: this.onInput,
	                value: this.state.phone_number })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'commission_bps', className: 'label' },
	                'Commission %'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'commission_bps',
	                type: 'tel',
	                value: this.state.commission_bps,
	                placeholder: 'Commission %' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'minimum_order_amount_dollars', className: 'label' },
	                'Min. Order $'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'minimum_order_amount_dollars',
	                type: 'number',
	                value: this.state.minimum_order_amount_dollars,
	                placeholder: 'Minimum Order $' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'made_in', className: 'label' },
	                'Made In Country'
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                name: 'made_in',
	                clearable: true,
	                value: this.state.made_in,
	                options: _consts.COUNTRIES,
	                onChange: this.onCountryOriginChange
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'from', className: 'label' },
	                'Made In State'
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                name: 'from',
	                clearable: true,
	                disabled: !this.state.secondaryOriginEnabled,
	                value: this.state.made_in_state,
	                options: this.state.secondaryOptions,
	                onChange: this.onSecondaryOriginChange
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'minimum_order_amount_dollars', className: 'label' },
	                'Made in City'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                disabled: !this.state.made_in_state,
	                name: 'made_in_city',
	                type: 'text',
	                value: this.state.made_in_city,
	                placeholder: 'Made in City' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line checkboxes' },
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                type: 'checkbox',
	                name: 'hand_made',
	                defaultChecked: this.state.hand_made }),
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'Handmade'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                type: 'checkbox',
	                name: 'eco_friendly',
	                defaultChecked: this.state.eco_friendly }),
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'Eco-Friendly'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                type: 'checkbox',
	                name: 'charitable',
	                defaultChecked: this.state.charitable }),
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'Charitable'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line line-block' },
	              _react2.default.createElement(
	                'label',
	                { className: 'label', htmlFor: 'images' },
	                'Images'
	              ),
	              _react2.default.createElement(_FieldComponents.MultipleField, { name: 'images',
	                component: _FieldComponents.ImageField,
	                inputs: this.state.images,
	                onNew: this.onImagesNew,
	                onClear: this.onImagesClear,
	                onChange: this.onImagesChange })
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Email Campaign Details'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { className: 'label', htmlFor: 'email_hero_image' },
	                'Email Hero Image'
	              ),
	              _react2.default.createElement(_FieldComponents.ImageField, { onInput: this.onInput,
	                type: 'text',
	                name: 'email_hero_image',
	                value: this.state.email_hero_image,
	                placeholder: 'Email hero image' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line line-block' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'email_description', className: 'label' },
	                'Email Description'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'email_description',
	                type: 'textarea',
	                value: this.state.email_description,
	                placeholder: 'Email Description' })
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Address'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'address_name', className: 'label' },
	                'Name'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'address_name',
	                type: 'text',
	                value: this.state.address_name,
	                placeholder: 'Name' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'address_line1', className: 'label' },
	                'Address Line 1'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'address_address1',
	                type: 'text',
	                value: this.state.address_address1,
	                placeholder: 'Address Line 1' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'Address line 2'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'address_address2',
	                type: 'text',
	                value: this.state.address_address2,
	                placeholder: 'Address Line 2' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'address_postalcode', className: 'label' },
	                'Postal Code'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'address_postal_code',
	                type: 'text',
	                value: this.state.address_postal_code,
	                placeholder: 'Postal Code' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'address_city', className: 'label' },
	                'City'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'address_city',
	                type: 'text',
	                value: this.state.address_city,
	                placeholder: 'City' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'address_state', className: 'label' },
	                'State'
	              ),
	              _react2.default.createElement(_reactSelect2.default, {
	                name: 'address_state',
	                clearable: true,
	                value: this.state.address_state,
	                options: _consts.USA_STATES,
	                onChange: this.onAddressStateChange
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'line line-block' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'address_instructions', className: 'label' },
	                'Instructions'
	              ),
	              _react2.default.createElement(_FieldComponents.InputField, { onInput: this.onInput,
	                name: 'address_instructions',
	                type: 'textarea',
	                value: this.state.address_instructions,
	                placeholder: 'Instructions' })
	            )
	          ),
	          this.state.errorView,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.handleSubmit },
	              'Save'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BrandLogisticsEditor;
	}(_react.Component);
	
	exports.default = BrandLogisticsEditor;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GoogleMapsComponent2 = __webpack_require__(295);
	
	var _GoogleMapsComponent3 = _interopRequireDefault(_GoogleMapsComponent2);
	
	var _SelectBusinessOption = __webpack_require__(303);
	
	var _SelectBusinessOption2 = _interopRequireDefault(_SelectBusinessOption);
	
	var _reactTimerMixin = __webpack_require__(562);
	
	var _reactTimerMixin2 = _interopRequireDefault(_reactTimerMixin);
	
	var _reactSelect = __webpack_require__(27);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BusinessSearchComponent = function (_GoogleMapsComponent) {
	  _inherits(BusinessSearchComponent, _GoogleMapsComponent);
	
	  function BusinessSearchComponent(props) {
	    _classCallCheck(this, BusinessSearchComponent);
	
	    var _this = _possibleConstructorReturn(this, (BusinessSearchComponent.__proto__ || Object.getPrototypeOf(BusinessSearchComponent)).call(this, props));
	
	    _this.state = {
	      autoCompleteService: null,
	      placesService: null,
	      googleMaps: null,
	      latestQueryString: null,
	      searchResults: {},
	      placeholderText: 'Enter your store name to view products'
	    };
	
	
	    _this.handleGetOptions = _this.handleGetOptions.bind(_this);
	    _this.handleOnFocus = _this.handleOnFocus.bind(_this);
	    _this.handleOnOptionsOpen = _this.handleOnOptionsOpen.bind(_this);
	    _this.handleOnOptionsClose = _this.handleOnOptionsClose.bind(_this);
	    _this.handleOnBlur = _this.handleOnBlur.bind(_this);
	    _this.handleSearchChange = _this.handleSearchChange.bind(_this);
	    _this.renderOption = _this.renderOption.bind(_this);
	    _this.filterOption = _this.filterOption.bind(_this);
	    _this.focus = _this.focus.bind(_this);
	
	    _this.onResults = _this.onResults.bind(_this);
	    _this.onPredictionsResults = _this.onPredictionsResults.bind(_this);
	    _this.onTextSearchResults = _this.onTextSearchResults.bind(_this);
	    return _this;
	  }
	
	  _createClass(BusinessSearchComponent, [{
	    key: 'focus',
	    value: function focus() {
	      // TODO: Re-implement or fix Select.Async component to fix all comments on this function.
	
	      // Ugly hack. This needs to go.
	      //document.getElementsByTagName('input')[0].focus();
	
	      // This should work, once the Select.Async class is recreated.
	      //this.refs.businessSearchInput.focus();
	    }
	  }, {
	    key: 'handleOnFocus',
	    value: function handleOnFocus() {
	      if (this.props.onFocus) {
	        this.props.onFocus();
	      }
	    }
	  }, {
	    key: 'handleOnOptionsOpen',
	    value: function handleOnOptionsOpen() {
	      this.setState({ placeholderText: '' });
	    }
	  }, {
	    key: 'handleOnOptionsClose',
	    value: function handleOnOptionsClose() {
	      this.setState({ placeholderText: 'Enter your store name to view products' });
	    }
	  }, {
	    key: 'handleOnBlur',
	    value: function handleOnBlur() {
	      if (this.props.onBlur) {
	        this.props.onBlur();
	      }
	    }
	
	    // Google Maps has loaded and we can initialize our input
	
	  }, {
	    key: 'handleApiLoaded',
	    value: function handleApiLoaded(googleMaps) {
	      var resultDiv = document.createElement('result-div');
	      var placesService = new googleMaps.places.PlacesService(resultDiv);
	      var autoCompleteService = new googleMaps.places.AutocompleteService();
	
	      this.setState({
	        autoCompleteService: autoCompleteService,
	        placesService: placesService,
	        googleMaps: googleMaps
	      });
	    }
	  }, {
	    key: 'handleGetOptions',
	    value: function handleGetOptions(input, placesCallback) {
	      var _this2 = this;
	
	      if (input.length < 4) {
	        // We don't search with less than 4 letters
	        placesCallback(input, { options: [], complete: false });
	        return;
	      }
	
	      // Save the current query string. Once the function executes, if the query is still the same
	      // then we fire a Google Places query.
	      var searchResults = this.state.searchResults;
	      searchResults[input] = { total: 0, places: {} };
	      this.setState({ latestQueryString: input });
	
	      // Search with autoComplete APIs.
	      setTimeout(function () {
	        _this2.autoCompleteSearch(input, placesCallback);
	      }, 250);
	
	      // Search with text search APIs.
	      setTimeout(function () {
	        _this2.textSearch(input, placesCallback);
	      }, 250);
	    }
	  }, {
	    key: 'autoCompleteSearch',
	    value: function autoCompleteSearch(input, placesCallback) {
	      var _this3 = this;
	
	      if (this.state.latestQueryString !== input) {
	        // User has changed the search query, no need to search on Google Places yet.
	        this.onResults(placesCallback, input, {});
	        return;
	      }
	
	      var service = this.state.autoCompleteService;
	
	      var autocompletePlacesRequest = {
	        input: input,
	        componentRestrictions: { country: 'US' },
	        types: ['establishment']
	      };
	      service.getPlacePredictions(autocompletePlacesRequest, function (predictions, status) {
	        _this3.onPredictionsResults(placesCallback, input, predictions, status);
	      });
	
	      var autocompleteQueryRequest = {
	        input: input,
	        componentRestrictions: { country: 'US|CA' }
	      };
	      service.getQueryPredictions(autocompleteQueryRequest, function (predictions, status) {
	        _this3.onPredictionsResults(placesCallback, input, predictions, status);
	      });
	    }
	  }, {
	    key: 'textSearch',
	    value: function textSearch(input, placesCallback) {
	      var _this4 = this;
	
	      if (this.state.latestQueryString !== input) {
	        // User has changed the search query, no need to search on Google Places yet.
	        this.onResults(placesCallback, input, {});
	        return;
	      }
	
	      var service = this.state.placesService;
	      var textSearchRequest = {
	        query: input,
	        type: 'store' // We only want to find stores!
	      };
	
	      service.textSearch(textSearchRequest, function (places, status, pagination) {
	        _this4.onTextSearchResults(placesCallback, input, places, status, pagination);
	      });
	    }
	  }, {
	    key: 'onPredictionsResults',
	    value: function onPredictionsResults(placesCallback, input, predictions, status) {
	      if (status !== "OK") {
	        this.onResults(placesCallback, input, {});
	        return;
	      }
	
	      var options = {};
	      predictions.forEach(function (prediction) {
	        if (!prediction.place_id || !prediction.structured_formatting.secondary_text) {
	          return;
	        }
	
	        var name = prediction.structured_formatting.main_text;
	        var address = prediction.structured_formatting.secondary_text;
	        var lastComma = address.lastIndexOf(',');
	        var country = address.substring(lastComma + 2, address.length);
	        address = address.substring(0, lastComma);
	        var newPlace = {
	          placeId: prediction.place_id,
	          name: name,
	          types: [],
	          address: address,
	          country: country
	        };
	        options[newPlace.placeId] = newPlace;
	      });
	
	      this.onResults(placesCallback, input, options);
	    }
	  }, {
	    key: 'onTextSearchResults',
	    value: function onTextSearchResults(placesCallback, input, places, status, pagination) {
	      if (status !== "OK") {
	        this.onResults(placesCallback, input, {});
	        return;
	      }
	
	      var options = {};
	      places.forEach(function (place) {
	        var address = place.formatted_address;
	        var lastComma = address.lastIndexOf(',');
	        var country = address.substring(lastComma + 2, address.length);
	        address = address.substring(0, lastComma);
	        var newPlace = {
	          placeId: place.place_id,
	          name: place.name,
	          types: place.types,
	          address: address,
	          country: country
	        };
	        options[newPlace.placeId] = newPlace;
	      });
	
	      this.onResults(placesCallback, input, options);
	    }
	  }, {
	    key: 'onResults',
	    value: function onResults(placesCallback, input, options) {
	      var onQueryChanged = this.props.onQueryChanged;
	      var searchResults = this.state.searchResults[input] || { total: 0, places: {} };
	
	      searchResults.total++;
	
	      var placeIds = Object.keys(options);
	      placeIds.forEach(function (placeId) {
	        searchResults.places[placeId] = options[placeId];
	      });
	
	      if (searchResults.total === 3) {
	        (function () {
	          if (onQueryChanged !== null) onQueryChanged(input);
	
	          var allFoundStores = [];
	          var allPlaceIds = Object.keys(searchResults.places);
	          allPlaceIds.forEach(function (placeId) {
	            allFoundStores.push(searchResults.places[placeId]);
	          });
	          // Add the hint item.
	          allFoundStores.push({ hintItem: true, disabled: true });
	          placesCallback(input, { options: allFoundStores, complete: false });
	        })();
	      }
	    }
	
	    /** The user has selected a business. */
	
	  }, {
	    key: 'handleSearchChange',
	    value: function handleSearchChange(place) {
	      if (place == null) return;
	      var onBusinessSelected = this.props.onBusinessSelected;
	
	      var placesService = this.state.placesService;
	      var googleMaps = this.state.googleMaps;
	      placesService.getDetails({ placeId: place.placeId }, function (placeDetails, status) {
	        if (status === googleMaps.places.PlacesServiceStatus.OK) {
	          if (onBusinessSelected !== null) {
	            onBusinessSelected(placeDetails);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'filterOption',
	    value: function filterOption(place) {
	      if (place.hintItem) return true;
	
	      if (place.country.toLowerCase() !== 'united states' && place.country.toLowerCase() !== 'canada') {
	        return false;
	      }
	
	      var excluded = false;
	      var totalTypes = place.types.length;
	      var excludedTypes = [];
	      for (var i = 0; i < totalTypes; i++) {
	        var placeType = place.types[i];
	        if (placeType in window.includedBusinessTypes) {
	          return true;
	        }
	        if (placeType in window.excludedBusinessTypes) {
	          excludedTypes.push(placeType);
	          excluded = true;
	        }
	      }
	
	      if (excluded) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'renderOption',
	    value: function renderOption(place) {
	      return _react2.default.createElement(_SelectBusinessOption2.default, {
	        googlePlaceSearchItem: place
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var placesService = this.state.placesService;
	      if (placesService == null) return null;
	
	      return _react2.default.createElement(_reactSelect2.default.Async, {
	        loadOptions: this.handleGetOptions,
	        ref: this.props.id,
	        id: this.props.id,
	        onFocus: this.handleOnFocus,
	        onOpen: this.handleOnOptionsOpen,
	        onClose: this.handleOnOptionsClose,
	        onBlur: this.handleOnBlur,
	        onChange: this.handleSearchChange,
	        optionRenderer: this.renderOption,
	        filterOption: this.filterOption,
	        clearable: true,
	        autoBlur: true,
	        autofocus: this.props.autofocus || false,
	        autoload: false,
	        autosize: true,
	        multi: false,
	        cache: false,
	        tabSelectsValue: false,
	        placeholder: this.state.placeholderText,
	        searchPromptText: 'Start typing the name of your store',
	        noResultsText: 'Store not found. Try typing your store name and the city'
	      });
	    }
	  }]);
	
	  return BusinessSearchComponent;
	}(_GoogleMapsComponent3.default);
	
	BusinessSearchComponent.propTypes = {
	  onBusinessSelected: _propTypes2.default.func,
	  onQueryChanged: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onOptionsOpen: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  placeholder: _propTypes2.default.string
	};
	exports.default = BusinessSearchComponent;
	
	
	BusinessSearchComponent.mixins = [_reactTimerMixin2.default];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(101);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: Update when props update
	var ButtonDropdown = function (_Button) {
	  _inherits(ButtonDropdown, _Button);
	
	  function ButtonDropdown(props) {
	    _classCallCheck(this, ButtonDropdown);
	
	    var _this = _possibleConstructorReturn(this, (ButtonDropdown.__proto__ || Object.getPrototypeOf(ButtonDropdown)).call(this, props));
	
	    _this.show = _this.show.bind(_this);
	    _this.hide = _this.hide.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.onItemSelected = _this.onItemSelected.bind(_this);
	
	    _this.state = _this.state || {};
	
	    _this.state.dropdownOpen = false;
	    return _this;
	  }
	
	  _createClass(ButtonDropdown, [{
	    key: 'onClick',
	    value: function onClick(event) {
	      if (this.props.disabled === true) return;
	      this.toggle();
	      event.preventDefault();
	    }
	  }, {
	    key: 'onItemSelected',
	    value: function onItemSelected(item) {
	      if (this.props.disabled === true) return;
	      if (this.props.onClick && !this.state.waiting) {
	        this.waitForAction(this.props.onClick(item));
	      }
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      if (this.state.dropdownOpen) return;
	      document.addEventListener("click", this.hide);
	      this.setState({ dropdownOpen: true });
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (!this.state.dropdownOpen) return;
	      document.removeEventListener("click", this.hide);
	      this.setState({ dropdownOpen: false });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      if (this.state.dropdownOpen) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    }
	  }, {
	    key: 'getClasses',
	    value: function getClasses() {
	      var classesList = _get(ButtonDropdown.prototype.__proto__ || Object.getPrototypeOf(ButtonDropdown.prototype), 'getClasses', this).call(this);
	
	      if (this.state.dropdownOpen) {
	        classesList += ' open';
	      }
	
	      classesList += ' buttondropdown';
	
	      return classesList;
	    }
	  }, {
	    key: 'getExtras',
	    value: function getExtras() {
	      var _this2 = this;
	
	      var options = (this.props.options || []).map(function (option, idx) {
	        return _react2.default.createElement(DropdownItem, { onClick: _this2.onItemSelected, key: 'button-dropdown-' + idx, option: option });
	      });
	      return _react2.default.createElement(
	        'ul',
	        { className: 'dropdown' },
	        options
	      );
	    }
	  }]);
	
	  return ButtonDropdown;
	}(_button2.default);
	
	exports.default = ButtonDropdown;
	
	var DropdownItem = function (_React$Component) {
	  _inherits(DropdownItem, _React$Component);
	
	  function DropdownItem(props) {
	    _classCallCheck(this, DropdownItem);
	
	    var _this3 = _possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));
	
	    _this3.onClick = _this3.onClick.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(DropdownItem, [{
	    key: 'onClick',
	    value: function onClick(event) {
	      if (this.props.onClick) {
	        this.props.onClick(this.props.option);
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var option = null;
	
	      if (typeof this.props.option === 'string') {
	        option = this.props.option;
	      } else if (_typeof(this.props.option) === 'object') {
	        option = this.props.option.content;
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { onClick: this.onClick, className: 'link' },
	        option
	      );
	    }
	  }]);
	
	  return DropdownItem;
	}(_react2.default.Component);

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _tools = __webpack_require__(103);
	
	var _pencil = __webpack_require__(437);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _pencilHover = __webpack_require__(436);
	
	var _pencilHover2 = _interopRequireDefault(_pencilHover);
	
	var _closeButton = __webpack_require__(125);
	
	var _closeButton2 = _interopRequireDefault(_closeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BagItem = function (_React$Component) {
	  _inherits(BagItem, _React$Component);
	
	  function BagItem(props) {
	    _classCallCheck(this, BagItem);
	
	    var _this = _possibleConstructorReturn(this, (BagItem.__proto__ || Object.getPrototypeOf(BagItem)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['editProductClick', 'removeFromCart', 'productImages']);
	    return _this;
	  }
	
	  _createClass(BagItem, [{
	    key: 'productImages',
	    value: function productImages() {
	      var imageList = [];
	      this.props.product.images.forEach(function (image) {
	        imageList.push(image);
	      });
	
	      this.props.product.options.forEach(function (productOption) {
	        productOption.images.forEach(function (image) {
	          imageList.push(image);
	        });
	      });
	
	      return imageList;
	    }
	  }, {
	    key: 'editProductClick',
	    value: function editProductClick(event) {
	      if (event.defaultPrevented) return;
	      if (this.props.disableEditing) return;
	      event.preventDefault();
	
	      var url = '/retailer/' + this.props.retailerToken + '/product/' + this.props.product.token;
	      this.context.router.push(url);
	    }
	  }, {
	    key: 'removeFromCart',
	    value: function removeFromCart(event) {
	      event.preventDefault();
	
	      var items = this.props.itemList.map(function (item) {
	        return item.product_option_token;
	      });
	
	      return _Api2.default.removeFromCart(items);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var itemList = this.props.itemList;
	      var product = this.props.product;
	      var productOptions = [];
	      product.options.forEach(function (option) {
	        var currentItem = itemList.find(function (item) {
	          return option.token === item.product_option_token;
	        });
	        if (!currentItem) return;
	
	        productOptions.push({
	          item: currentItem,
	          option: option
	        });
	      });
	      var productOptionsDisplay = productOptions.map(function (productOption) {
	        if (productOption.option.name.toLowerCase() === 'default') return null;
	        var optionName = productOption.option.name;
	        if (!optionName && productOption.option.group_name.toLowerCase() === 'color') {
	          optionName = productOption.option.color.name;
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { key: productOption.option.token, className: 'cart-option-entry' },
	          productOption.item.quantity,
	          ' ',
	          optionName
	        );
	      });
	
	      var quantity = 0;
	      var price = 0;
	      itemList.forEach(function (item) {
	        quantity += item.quantity;
	        price += item.quantity * item.price_cents;
	      });
	
	      var imageUrl = void 0;
	      var imageList = this.productImages();
	      if (imageList.length > 0) {
	        imageUrl = imageList[0].url;
	      }
	
	      var classNames = ['product-row'];
	      if (!this.props.disableEditing) {
	        classNames.push('link');
	      } else {
	        classNames.push('no-edit');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '), onClick: this.editProductClick },
	        _react2.default.createElement(
	          'div',
	          { className: 'quantity' },
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            quantity
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'edit-icon' },
	          _react2.default.createElement(
	            'span',
	            { className: 'inactive' },
	            _react2.default.createElement('img', { src: _pencil2.default, role: 'presentation' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'active' },
	            _react2.default.createElement('img', { src: _pencilHover2.default, role: 'presentation' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'product-preview' },
	          _react2.default.createElement('img', { src: imageUrl, role: 'presentation' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'product-info-block' },
	          _react2.default.createElement(
	            'span',
	            { className: 'product-name' },
	            product.name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'product-options' },
	            productOptionsDisplay
	          )
	        ),
	        (0, _tools.formatPrice)(price),
	        _react2.default.createElement(
	          'span',
	          { className: 'close-action', onClick: this.removeFromCart },
	          _react2.default.createElement('img', { src: _closeButton2.default, role: 'presentation' })
	        )
	      );
	    }
	  }]);
	
	  return BagItem;
	}(_react2.default.Component);
	
	BagItem.propTypes = {
	  itemList: _propTypes2.default.array.isRequired,
	  product: _propTypes2.default.object.isRequired,
	  disableEditing: _propTypes2.default.bool
	};
	BagItem.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = BagItem;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _flyout = __webpack_require__(102);
	
	var _flyout2 = _interopRequireDefault(_flyout);
	
	var _purse = __webpack_require__(126);
	
	var _purse2 = _interopRequireDefault(_purse);
	
	__webpack_require__(369);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cart = function (_React$Component) {
	  _inherits(Cart, _React$Component);
	
	  function Cart() {
	    _classCallCheck(this, Cart);
	
	    var _this = _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).call(this));
	
	    _Api.Utils.bindThis(_this, ['cartUpdated', 'cartToggle', 'submitOrder', 'cartFlyout']);
	    _this.cartUpdated = _this.cartUpdated.bind(_this);
	
	    _this.state = {
	      cart: null,
	      visible: false,
	      user: _Api2.default.cache.getUser(),
	      currentRetailer: null
	    };
	    return _this;
	  }
	
	  _createClass(Cart, [{
	    key: 'cartUpdated',
	    value: function cartUpdated() {
	      var _this2 = this;
	
	      _Api2.default.getCart(true).then(function (response) {
	        _this2.setState({ cart: response });
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.cache.addChangeListener(this.cartUpdated, _Api2.default.cache.eventTypes.CART_CHANGED);
	      _Api2.default.startListen(this, 'currentRetailer', _Api2.default.cache.eventTypes.RETAILER_CHANGED);
	      _Api2.default.startListen(this, 'visible', _Api2.default.cache.eventTypes.CART_VISIBLE_CHANGED);
	      _Api2.default.userStartListen(this, 'user');
	      _Api2.default.getCart();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.cartUpdated, _Api2.default.cache.eventTypes.CART_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.RETAILER_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.CART_VISIBLE_CHANGED);
	      _Api2.default.userStopListen(this);
	    }
	  }, {
	    key: 'cartToggle',
	    value: function cartToggle() {
	      _Api2.default.cache.setCartVisible(!this.state.visible);
	    }
	  }, {
	    key: 'submitOrder',
	    value: function submitOrder() {
	      var user = this.state.user;
	
	      _Api2.default.cache.setCartVisible(false);
	
	      if (!user) {
	        // No user: Goes to checkout.
	        this.context.router.push('/checkout');
	      } else if (window.linkInstruments) {
	        // We need to link instruments.
	        if (user.instruments.length > 0) {
	          // We already have instruments!
	          this.context.router.push('/checkout/delivery');
	        } else {
	          this.context.router.push('/checkout/payment');
	        }
	      } else {
	        // We do not need to link instruments. Go to delivery.
	        this.context.router.push('/checkout/delivery');
	      }
	    }
	  }, {
	    key: 'cartFlyout',
	    value: function cartFlyout() {
	      if (!this.state.visible) return null;
	
	      return _react2.default.createElement(_flyout2.default, {
	        subtotal: true,
	        cart: this.state.cart,
	        enableCheckout: this.state.user && this.state.user.impersonating,
	        retailerToken: this.state.currentRetailer ? this.state.currentRetailer.token : null,
	        checkout: this.submitOrder,
	        closeCart: this.cartToggle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cartText = null;
	      if (this.state.cart && this.state.cart.cart.items.length > 0) {
	        cartText = _react2.default.createElement(
	          'span',
	          { className: 'amount' },
	          this.state.cart.cart.items.length > 9 ? '+' : this.state.cart.cart.items.length
	        );
	      }
	
	      var cartComponentClass = 'cart-component' + (this.state.visible ? ' opened' : '');
	
	      return _react2.default.createElement(
	        'div',
	        { className: cartComponentClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'cart-label', onClick: this.cartToggle },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { role: 'presentation', src: _purse2.default })
	          ),
	          cartText
	        ),
	        _react2.default.createElement('div', { className: 'cart-fullscreen', onClick: this.cartToggle }),
	        this.cartFlyout()
	      );
	    }
	  }]);
	
	  return Cart;
	}(_react2.default.Component);
	
	exports.default = Cart;
	
	
	Cart.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _InputField2 = __webpack_require__(43);
	
	var _InputField3 = _interopRequireDefault(_InputField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO move this into lib folder and get rid of component
	function validateEmail(email, isRequired) {
	  if (!isRequired && email.length === 0) {
	    return true;
	  }
	
	  var regex = new RegExp('[A-Z0-9._%\'=+][A-Z0-9._%\'=+-]*@([A-Z0-9]([A-Z0-9-]*[A-Z0-9])?\\.)+[A-Z]{2,}', 'iugy');
	  return !!regex.exec(email);
	}
	
	var EmailField = function (_InputField) {
	  _inherits(EmailField, _InputField);
	
	  function EmailField() {
	    _classCallCheck(this, EmailField);
	
	    return _possibleConstructorReturn(this, (EmailField.__proto__ || Object.getPrototypeOf(EmailField)).apply(this, arguments));
	  }
	
	  _createClass(EmailField, [{
	    key: 'validate',
	    value: function validate(input) {
	      var validated = _get(EmailField.prototype.__proto__ || Object.getPrototypeOf(EmailField.prototype), 'validate', this).call(this, input);
	      return validated && validateEmail(input, this.props.required);
	    }
	  }]);
	
	  return EmailField;
	}(_InputField3.default);
	
	exports.default = EmailField;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InputField = __webpack_require__(43);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _UrlValidator = __webpack_require__(107);
	
	var _UrlValidator2 = _interopRequireDefault(_UrlValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageField = function (_React$Component) {
	  _inherits(ImageField, _React$Component);
	
	  function ImageField(props) {
	    _classCallCheck(this, ImageField);
	
	    var _this = _possibleConstructorReturn(this, (ImageField.__proto__ || Object.getPrototypeOf(ImageField)).call(this, props));
	
	    _this.onInput = _this.onInput.bind(_this);
	    return _this;
	  }
	
	  _createClass(ImageField, [{
	    key: 'onInput',
	    value: function onInput(name, value, error) {
	      var image = this.props.value;
	      image.url = value;
	
	      this.props.onInput && this.props.onInput(name, image, error); // eslint-disable-line no-unused-expressions
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var imageUrl = this.props.value.url;
	      var imageView = imageUrl ? _react2.default.createElement('img', { src: imageUrl, role: 'presentation' }) : null;
	
	      var _props = this.props,
	          onInput = _props.onInput,
	          value = _props.value,
	          rest = _objectWithoutProperties(_props, ['onInput', 'value']); // eslint-disable-line no-unused-vars
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'controlled-image-field image-field' },
	        _react2.default.createElement(_InputField2.default, _extends({ validator: _UrlValidator2.default
	        }, rest, {
	          onInput: this.onInput,
	          required: this.props.required,
	          value: imageUrl
	        })),
	        imageView
	      );
	    }
	  }]);
	
	  return ImageField;
	}(_react2.default.Component);
	
	ImageField.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  required: _propTypes2.default.bool,
	  onInput: _propTypes2.default.func,
	  value: function value(props, propName, componentName) {
	    var property = props[propName];
	    if ((typeof property === 'undefined' ? 'undefined' : _typeof(property)) !== 'object' || !property.hasOwnProperty('url')) {
	      return new Error('Invalid prop ' + propName + ' supplied to ' + componentName + '. Validation failed.');
	    }
	  }
	};
	ImageField.defaultProps = {
	  required: false
	};
	exports.default = ImageField;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InputField = __webpack_require__(43);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	__webpack_require__(371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultipleField = function (_React$Component) {
	  _inherits(MultipleField, _React$Component);
	
	  function MultipleField() {
	    _classCallCheck(this, MultipleField);
	
	    return _possibleConstructorReturn(this, (MultipleField.__proto__ || Object.getPrototypeOf(MultipleField)).apply(this, arguments));
	  }
	
	  _createClass(MultipleField, [{
	    key: 'onChange',
	    value: function onChange(index) {
	      var _props;
	
	      for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        rest[_key - 1] = arguments[_key];
	      }
	
	      (_props = this.props).onChange.apply(_props, [index].concat(rest));
	    }
	  }, {
	    key: 'onClear',
	    value: function onClear(index, key, value) {
	      if (this.props.clearable && this.props.onClear) {
	        this.props.onClear(index, key, value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var newInput = this.props.onNew();
	      var inputs = this.props.inputs || [];
	      inputs = inputs.concat(newInput);
	
	      var inputViews = inputs.map(function (input, index) {
	        var component = _this2.props.component || _InputField2.default;
	        var customComponent = _react2.default.createElement(component, {
	          'name': input.key,
	          'className': _this2.props.className,
	          'value': input.value,
	          'onInput': _this2.onChange.bind(_this2, index)
	        });
	
	        var clearableView = null;
	        if (_this2.props.clearable) {
	          clearableView = _react2.default.createElement(
	            'div',
	            { className: 'close-icon',
	              onClick: _this2.onClear.bind(_this2, index, input.key, input.value) },
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'close' })
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { key: input.key, className: 'multiple-input-field' },
	          customComponent,
	          clearableView
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'multiple-input-field-group' },
	        inputViews
	      );
	    }
	  }]);
	
	  return MultipleField;
	}(_react2.default.Component);
	
	MultipleField.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  onNew: _propTypes2.default.func.isRequired,
	  onClear: _propTypes2.default.func,
	  onChange: _propTypes2.default.func, // callback for entire component change
	  component: _propTypes2.default.func.isRequired,
	  clearable: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  inputs: _propTypes2.default.arrayOf(_propTypes2.default.object)
	};
	MultipleField.defaultProps = {
	  clearable: true
	};
	exports.default = MultipleField;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fieldKit = __webpack_require__(120);
	
	var _fieldKit2 = _interopRequireDefault(_fieldKit);
	
	var _TextField2 = __webpack_require__(104);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhoneField = function (_TextField) {
	  _inherits(PhoneField, _TextField);
	
	  function PhoneField() {
	    _classCallCheck(this, PhoneField);
	
	    return _possibleConstructorReturn(this, (PhoneField.__proto__ || Object.getPrototypeOf(PhoneField)).apply(this, arguments));
	  }
	
	  _createClass(PhoneField, [{
	    key: 'getFormatter',
	    value: function getFormatter() {
	      return new _fieldKit2.default.PhoneFormatter();
	    }
	  }]);
	
	  return PhoneField;
	}(_TextField3.default);
	
	exports.default = PhoneField;
	
	
	PhoneField.propTypes = _TextField3.default.getBasePropTypes();
	
	PhoneField.defaultProps = _TextField3.default.getBaseDefaultProps();

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Flyout = function (_React$Component) {
	  _inherits(Flyout, _React$Component);
	
	  function Flyout(props) {
	    _classCallCheck(this, Flyout);
	
	    var _this = _possibleConstructorReturn(this, (Flyout.__proto__ || Object.getPrototypeOf(Flyout)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Flyout, [{
	    key: 'onClick',
	    value: function onClick(event) {
	      if (event.defaultPrevented) return;
	
	      if (this.props.onClose) {
	        this.props.onClose(event);
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var flyoutClass = 'flyout-contents';
	      if (this.props.className) {
	        flyoutClass += ' ' + this.props.className;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'flyout-component' },
	        _react2.default.createElement('div', { className: 'flyout-mask', onClick: this.onClick }),
	        _react2.default.createElement(
	          'div',
	          { className: flyoutClass },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Flyout;
	}(_react2.default.Component);
	
	exports.default = Flyout;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _scriptjs = __webpack_require__(575);
	
	var _scriptjs2 = _interopRequireDefault(_scriptjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoogleMapsComponent = function (_Component) {
	  _inherits(GoogleMapsComponent, _Component);
	
	  function GoogleMapsComponent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GoogleMapsComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GoogleMapsComponent.__proto__ || Object.getPrototypeOf(GoogleMapsComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      googleMaps: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GoogleMapsComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (typeof window.google === 'undefined') {
	        window.gMapsLoaded = function () {
	          _scriptjs2.default.done('google-maps-places');
	        };
	
	        var apiKey = window.googlePlacesApiKey;
	        (0, _scriptjs2.default)('https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places&callback=gMapsLoaded');
	        _scriptjs2.default.ready('google-maps-places', function () {
	          _this2.handleLoaded(window.google.maps);
	        });
	      } else {
	        this.handleLoaded(window.google.maps);
	      }
	    }
	  }, {
	    key: 'handleLoaded',
	    value: function handleLoaded(googleMaps) {
	      this.setState({ googleMaps: googleMaps });
	      if (this.handleApiLoaded) {
	        this.handleApiLoaded(googleMaps);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return GoogleMapsComponent;
	}(_react.Component);
	
	exports.default = GoogleMapsComponent;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Cart = __webpack_require__(289);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _TopSearch = __webpack_require__(304);
	
	var _TopSearch2 = _interopRequireDefault(_TopSearch);
	
	var _user = __webpack_require__(297);
	
	var _user2 = _interopRequireDefault(_user);
	
	__webpack_require__(372);
	
	var _logo = __webpack_require__(442);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var availableRoutes = ['/admin', '/retailer', '/checkout', '/user', '/login', '/logout', '/apply'];
	
	function hasLocationChanged(oldLocation, newLocation) {
	  return oldLocation && !newLocation || !oldLocation && newLocation || oldLocation && newLocation && oldLocation.pathname !== newLocation.pathname;
	}
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.floatingHeader = _this.floatingHeader.bind(_this);
	    _this.logoLink = _this.logoLink.bind(_this);
	
	    _this.state = {
	      user: props.user,
	      toastProductToken: null,
	      inMarketplace: _this.inMarketplace(props.location)
	    };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (hasLocationChanged(nextProps.location, this.props.location)) {
	        this.setState({
	          inMarketplace: this.inMarketplace(nextProps.location)
	        });
	      }
	
	      if (nextProps.user !== this.state.user) {
	        this.setState({
	          user: nextProps.user
	        });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.startListen(this, 'recommendations', _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
	      _Api2.default.startListen(this, 'toastProductToken', _Api2.default.cache.eventTypes.LAST_ADDED_PRODUCT_TOKEN_CHANGED);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.LAST_ADDED_PRODUCT_TOKEN_CHANGED);
	    }
	  }, {
	    key: 'floatingHeader',
	    value: function floatingHeader() {
	      if (!this.props.location) return false;
	
	      var pathName = this.props.location.pathname;
	      return pathName === '/' || pathName === '/about' || pathName === '/login';
	    }
	  }, {
	    key: 'inMarketplace',
	    value: function inMarketplace(currentLocation) {
	      if (currentLocation === undefined) {
	        currentLocation = this.props.location;
	      }
	
	      if (!currentLocation) return false;
	
	      return !!currentLocation.pathname.match('^/retailer/[^/]*(/(product|collection)/[^/]*)?$');
	    }
	  }, {
	    key: 'logoLink',
	    value: function logoLink() {
	      var url = null;
	
	      if (this.props.location) {
	        var pathName = this.props.location.pathname;
	        var matches = pathName.match(/.*retailer\/([^/]*)/);
	        if (matches && matches.length >= 2) {
	          url = '/retailer/' + matches[1];
	        }
	      }
	
	      if (!url && this.props.retailer) {
	        url = '/retailer/' + this.props.retailer.token;
	      }
	
	      if (!url && this.props.lastSelectedRetailerToken) {
	        url = '/retailer/' + this.props.lastSelectedRetailerToken;
	      }
	
	      return url || '/';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pathName = this.props.location.pathname;
	
	      if (Header.showInRoute(pathName) === false) return null;
	
	      var classes = (0, _classnames2.default)({
	        'header': true,
	        'floating': !this.floatingHeader()
	      });
	
	      var logoLink = this.logoLink();
	
	      var searchProducts = null;
	      var cart = null;
	
	      var isInvited = this.props.retailer && this.props.retailer.invited;
	      var isEmployee = this.state.user && this.state.user.is_employee;
	      var marketplaceAvailable = isInvited || isEmployee;
	      var showSearchOnThisPage = pathName.indexOf('/retailer') >= 0 || pathName.indexOf('/brand') > 0 || pathName.indexOf('/category') > 0;
	
	      if (marketplaceAvailable) {
	        if (showSearchOnThisPage) {
	          searchProducts = _react2.default.createElement(_TopSearch2.default, { className: 'responsive-desktop ib' });
	        }
	        if (pathName.indexOf('/retailer') === 0 || pathName.indexOf('/collection/') > 0 || pathName.indexOf('/user') === 0 || pathName.indexOf('/checkout') === 0) {
	          cart = _react2.default.createElement(_Cart2.default, { location: this.props.location });
	        }
	      }
	
	      return _react2.default.createElement(
	        'header',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'nav',
	              { className: 'retailer-nav' },
	              _react2.default.createElement(_user2.default, { key: 'header-user-component', user: this.state.user,
	                retailer: this.props.retailer, location: this.props.location })
	            ),
	            _react2.default.createElement(
	              'nav',
	              { className: 'cart-nav' },
	              searchProducts,
	              cart
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'header-logo logo', to: logoLink },
	              _react2.default.createElement('img', { src: _logo2.default, role: 'presentation' })
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'showInRoute',
	    value: function showInRoute(pathName) {
	      var i = void 0;
	      for (i = 0; i < availableRoutes.length; i++) {
	        if (pathName.indexOf(availableRoutes[i]) >= 0) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Flyout = __webpack_require__(294);
	
	var _Flyout2 = _interopRequireDefault(_Flyout);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var User = function (_React$Component) {
	  _inherits(User, _React$Component);
	
	  function User(props) {
	    _classCallCheck(this, User);
	
	    var _this = _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).call(this, props));
	
	    _Api2.default.Utils.bindThis(_this, ['onRetailerNameClick', 'onPopupMenuClose', 'updateOrderList', 'onNotYouClicked', 'onImpersonate', 'onUnimpersonate', 'onRecommendAllProducts', 'onRemoveAllManualRecommendations', 'onKeyDown']);
	
	    _this.state = {
	      opened: false,
	      user: props.user,
	      userOrders: null,
	      adminBarVisible: _Api2.default.cache.getAdminBarVisible()
	    };
	    return _this;
	  }
	
	  _createClass(User, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.addEventListener("keydown", this.onKeyDown);
	      this.updateOrderList();
	
	      _Api2.default.startListen(this, 'adminBarVisible', _Api2.default.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
	      _Api2.default.startListen(this, 'userOrders', _Api2.default.cache.eventTypes.ORDER_LIST_CHANGED);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.location && this.props.location && this.props.location.pathname !== newProps.location.pathname) {
	        this.onPopupMenuClose();
	      }
	
	      if (newProps.user !== this.state.user) {
	        this.setState({
	          user: newProps.user
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!this.props.user || !prevProps.user || prevProps.user.token !== this.props.user.token) {
	        this.updateOrderList();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.onKeyDown);
	
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.ORDER_LIST_CHANGED);
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      if (event.key === 'Escape' && this.state.opened) {
	        this.setState({ opened: false });
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: 'updateOrderList',
	    value: function updateOrderList() {
	      var _this2 = this;
	
	      if (!this.state.user) {
	        if (this.state.userOrders) {
	          this.setState({ userOrders: null });
	        }
	        return;
	      }
	
	      _Api2.default.getOrders().then(function (orderList) {
	        _this2.setState({ userOrders: orderList });
	      });
	    }
	  }, {
	    key: 'onRetailerNameClick',
	    value: function onRetailerNameClick(event) {
	      if (event) event.preventDefault();
	      this.setState({
	        opened: !this.state.opened
	      });
	    }
	  }, {
	    key: 'onPopupMenuClose',
	    value: function onPopupMenuClose(event) {
	      if (event) event.preventDefault();
	      this.setState({
	        opened: false
	      });
	    }
	  }, {
	    key: 'onNotYouClicked',
	    value: function onNotYouClicked() {
	      var _this3 = this;
	
	      return _Api2.default.resetLastSelectedRetailer().then(function () {
	        _this3.context.router.push('/');
	      });
	    }
	  }, {
	    key: 'onImpersonate',
	    value: function onImpersonate() {
	      var _this4 = this;
	
	      return _Api2.default.impersonateUserByToken(this.props.retailer.owner_user_token).then(function () {
	        _this4.context.router.push('/');
	      });
	    }
	  }, {
	    key: 'onUnimpersonate',
	    value: function onUnimpersonate() {
	      var _this5 = this;
	
	      return _Api2.default.unimpersonateUser().then(function () {
	        _this5.context.router.push('/');
	      });
	    }
	  }, {
	    key: 'onRecommendAllProducts',
	    value: function onRecommendAllProducts() {
	      this.setState({
	        opened: false
	      });
	
	      var tokensToRecommend = [];
	      var recommendations = _Api2.default.cache.getRecommendations();
	      if (recommendations.response.products) {
	        Object.keys(recommendations.response.products).forEach(function (token) {
	          var product = recommendations.response.products[token];
	          if (product.auto_recommendation && !product.manual_recommendation) {
	            tokensToRecommend.push(product.token);
	          }
	        });
	      }
	
	      if (tokensToRecommend.length > 0) {
	        _Api2.default.retailerAddRecommendations(this.props.retailer.token, tokensToRecommend).then(function () {
	          return _Api2.default.refreshCurrentRecommendations();
	        }).catch(function (error) {
	          alert("Error adding manual recommendations: " + error.response.message);
	        });
	      }
	    }
	  }, {
	    key: 'onRemoveAllManualRecommendations',
	    value: function onRemoveAllManualRecommendations() {
	      this.setState({
	        opened: false
	      });
	
	      _Api2.default.retailerClearRecommendations(this.props.retailer.token).then(function () {
	        return _Api2.default.refreshCurrentRecommendations();
	      }).catch(function (error) {
	        alert("Error removing manual recommendations: " + error.response.message);
	      });
	    }
	  }, {
	    key: 'toggleAdminBar',
	    value: function toggleAdminBar() {
	      _Api2.default.cache.setAdminBarVisible(!_Api2.default.cache.getAdminBarVisible());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      if (!this.props.retailer) return null;
	
	      var state = this.state;
	      var isEmployee = state.user && state.user.is_employee;
	      var hasOrders = state.userOrders && state.userOrders.orders && state.userOrders.orders.length > 0;
	
	      var orderHistory = null;
	      var paymentOptions = null;
	      if (isEmployee || hasOrders) {
	        orderHistory = _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/user/account' },
	            'Order History'
	          )
	        );
	      }
	
	      if (state.user) {
	        paymentOptions = _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/user/account/payments' },
	            'Payment Options'
	          )
	        );
	      }
	
	      var goToAdmin = null;
	      var forgetRetailer = null;
	      var carriedBrands = null;
	      var retailerWebsite = null;
	      var impersonate = null;
	      var recommendAllProducts = null;
	      var removeAllManualRecommendations = null;
	      var recommendationsInfo = null;
	      var adminBarToggle = null;
	      if (isEmployee) {
	        goToAdmin = _react2.default.createElement(
	          'li',
	          { className: 'admin' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/admin' },
	            'Go To Admin'
	          )
	        );
	        retailerWebsite = this.props.retailer.url !== null ? _react2.default.createElement(
	          'li',
	          { className: 'admin' },
	          _react2.default.createElement(
	            'a',
	            { href: this.props.retailer.url, target: '_blank' },
	            'Retailer Website'
	          )
	        ) : null;
	        carriedBrands = _react2.default.createElement(
	          'li',
	          { className: 'admin' },
	          _react2.default.createElement(
	            'a',
	            { href: '/api/leads/carried-brands', target: '_blank' },
	            'Carried Brands'
	          )
	        );
	        forgetRetailer = _react2.default.createElement(
	          'li',
	          { className: 'admin', style: { cursor: 'pointer' }, onClick: this.onNotYouClicked },
	          'Forget ',
	          this.props.retailer.name
	        );
	
	        if (this.props.retailer.owner_user_token) {
	          impersonate = _react2.default.createElement(
	            'li',
	            { className: 'admin', style: { cursor: 'pointer' }, onClick: this.onImpersonate },
	            'Impersonate ',
	            this.props.retailer.name,
	            ' (',
	            this.props.retailer.owner_user_token,
	            ')'
	          );
	        }
	
	        adminBarToggle = _react2.default.createElement(
	          'li',
	          { className: 'admin link', onClick: this.toggleAdminBar },
	          this.state.adminBarVisible ? 'Hide' : 'Show',
	          ' admin bar'
	        );
	        removeAllManualRecommendations = _react2.default.createElement(
	          'li',
	          { className: 'admin', style: { cursor: 'pointer' },
	            onClick: this.onRemoveAllManualRecommendations },
	          'Remove all manual recommendations'
	        );
	        if (_Api2.default.cache.hasProductRecommendations()) {
	          (function () {
	            var active = 0;
	            var inactive = 0;
	            var auto = 0;
	            var manual = 0;
	            var recent = 0;
	            var autoNotManual = 0;
	            var recommendations = _Api2.default.cache.getRecommendations();
	            if (recommendations && recommendations.response) {
	              recommendations = recommendations.response;
	
	              if (recommendations.display_order) {
	                recommendations.display_order.forEach(function (displayToken) {
	                  var displayObject = recommendations.products[displayToken];
	                  if (!displayObject) {
	                    if (!recommendations.collections[displayToken]) {
	                      console.error("cannot find product or collection with token %s", displayToken);
	                    }
	                    return;
	                  }
	
	                  if (displayObject.active) {
	                    active++;
	                  } else {
	                    inactive++;
	                  }
	                  if (displayObject.auto_recommendation) auto++;
	                  if (displayObject.manual_recommendation) manual++;
	                  if (displayObject.recently_ordered) recent++;
	                  if (displayObject.auto_recommendation && !displayObject.manual_recommendation) autoNotManual++;
	                });
	              }
	
	              recommendationsInfo = _react2.default.createElement(
	                'li',
	                { className: 'admin' },
	                'Active: ',
	                active,
	                ', Inactive: ',
	                inactive,
	                ', Auto: ',
	                auto,
	                ', Manual: ',
	                manual,
	                ', Recent: ',
	                recent
	              );
	
	              if (autoNotManual > 0) {
	                recommendAllProducts = _react2.default.createElement(
	                  'li',
	                  { className: 'admin', style: { cursor: 'pointer' },
	                    onClick: _this6.onRecommendAllProducts },
	                  'Recommend ',
	                  autoNotManual,
	                  ' products'
	                );
	              }
	              removeAllManualRecommendations = _react2.default.createElement(
	                'li',
	                { className: 'admin', style: { cursor: 'pointer' },
	                  onClick: _this6.onRemoveAllManualRecommendations },
	                'Remove ',
	                manual,
	                ' manual recommendations'
	              );
	            }
	          })();
	        }
	      }
	
	      var impersonating = state.user && state.user.impersonating === true;
	      var paymentStatus = null;
	      var unimpersonate = null;
	      if (impersonating) {
	        unimpersonate = _react2.default.createElement(
	          'li',
	          { className: 'admin', style: { cursor: 'pointer' }, onClick: this.onUnimpersonate },
	          'Unimpersonate ',
	          state.user.name
	        );
	        if (this.state.user.retailer_token) {
	          paymentStatus = _react2.default.createElement(
	            'li',
	            { className: 'admin', style: { cursor: 'pointer' } },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/user/account/status' },
	              'Payment Status'
	            )
	          );
	        }
	      }
	
	      var popupMenu = null;
	      if (state.opened && state.user) {
	        popupMenu = _react2.default.createElement(
	          _Flyout2.default,
	          { className: 'user-flyout', onClose: this.onPopupMenuClose },
	          _react2.default.createElement(
	            'ul',
	            null,
	            orderHistory,
	            paymentOptions,
	            _react2.default.createElement(
	              'li',
	              { onClick: this.onNotYouClicked, className: 'responsive-mobile link' },
	              'Not You?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/user/logout' },
	                'Log out'
	              )
	            ),
	            goToAdmin,
	            carriedBrands,
	            retailerWebsite,
	            forgetRetailer,
	            paymentStatus,
	            impersonate,
	            unimpersonate,
	            recommendationsInfo,
	            recommendAllProducts,
	            removeAllManualRecommendations,
	            adminBarToggle
	          )
	        );
	      }
	
	      var notYou = null;
	      if (!state.user) {
	        notYou = _react2.default.createElement(
	          'span',
	          { className: 'not-you link responsive-desktop', onClick: this.onNotYouClicked },
	          'Not You?'
	        );
	      }
	
	      var displayName = impersonating ? this.props.retailer.name + " - IMPERSONATING: " + state.user.name : this.props.retailer.name + (isEmployee ? " - AS ADMIN" : "");
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'userheader-component' },
	        _react2.default.createElement('span', { className: 'link header-bars responsive-mobile', onClick: this.onRetailerNameClick }),
	        _react2.default.createElement(
	          'span',
	          { className: 'link responsive-desktop', onClick: this.onRetailerNameClick },
	          displayName
	        ),
	        popupMenu,
	        notYou
	      );
	    }
	  }]);
	
	  return User;
	}(_react2.default.Component);
	
	User.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = User;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Image = function (_React$Component) {
	  _inherits(Image, _React$Component);
	
	  function Image(props) {
	    _classCallCheck(this, Image);
	
	    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));
	
	    if (!props.src && !props.image) {
	      console.error('Error: invalid image props passed to the Image component');
	    }
	    if (props.src && props.image) {
	      console.error('Error: Image component has too much information!');
	    }
	    return _this;
	  }
	
	  _createClass(Image, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.src && !this.props.image) {
	        return null;
	      }
	
	      var role = this.props.role;
	      if (!role && !this.props.alt) role = "presentation";
	
	      var classNames = ['image-component'];
	      if (this.props.className) classNames.push(this.props.className);
	      if (this.props.stretchAndCrop) classNames.push('stretch-and-crop');
	
	      var src = this.props.src;
	
	      var style = {};
	
	      if (this.props.image) {
	        src = this.props.image.url;
	
	        if (this.props.width && this.props.height) {
	          var boundingAspectRatio = this.props.width / this.props.height;
	          style.width = this.props.width;
	          style.height = this.props.height;
	
	          if (this.props.image.width && this.props.image.height) {
	            var aspectRatio = this.props.image.width / this.props.image.height;
	
	            if (aspectRatio > boundingAspectRatio) {
	              classNames.push('landscape');
	            } else if (aspectRatio < boundingAspectRatio) {
	              classNames.push('portrait');
	            }
	          }
	        }
	      }
	
	      var params = {
	        src: src,
	        alt: this.props.alt,
	        role: role
	      };
	
	      var divParams = {
	        style: style,
	        onClick: this.props.onClick
	      };
	
	      /* eslint-disable jsx-a11y/img-has-alt */
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: classNames.join(' ') }, divParams),
	        _react2.default.createElement('img', params)
	      );
	      /* eslint-enable jsx-a11y/img-has-alt */
	    }
	  }]);
	
	  return Image;
	}(_react2.default.Component);
	
	Image.propTypes = {
	  src: _propTypes2.default.string,
	  image: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  role: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  alt: _propTypes2.default.string,
	  stretchAndCrop: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	};
	exports.default = Image;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FieldKit = __webpack_require__(105);
	
	__webpack_require__(375);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoProducts = function (_React$Component) {
	  _inherits(NoProducts, _React$Component);
	
	  function NoProducts(props) {
	    _classCallCheck(this, NoProducts);
	
	    var _this = _possibleConstructorReturn(this, (NoProducts.__proto__ || Object.getPrototypeOf(NoProducts)).call(this, props));
	
	    _this.state = {
	      registered: false,
	      firstNameError: false,
	      lastNameError: false,
	      emailError: false,
	      error: false
	    };
	
	
	    _Api.Utils.bindThis(_this, ['registerRequestUpdates', 'onKeyDown']);
	    return _this;
	  }
	
	  _createClass(NoProducts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refs.first_name.focus();
	    }
	  }, {
	    key: 'registerRequestUpdates',
	    value: function registerRequestUpdates() {
	      var _this2 = this;
	
	      var payload = _Api.Utils.getFormValues(this, ['first_name', 'last_name', 'email_address', 'phone_number', 'note']);
	      var error = false;
	      var statePayload = {
	        firstNameError: false,
	        lastNameError: false,
	        emailError: false
	      };
	      var emailRegex = new RegExp('[A-Z0-9._%\'=+][A-Z0-9._%\'=+-]*@([A-Z0-9]([A-Z0-9-]*[A-Z0-9])?\\.)+[A-Z]{2,}', 'iugy');
	
	      if (!payload.first_name || !payload.first_name.length) {
	        statePayload.firstNameError = true;
	        error = true;
	      }
	      if (!payload.last_name || !payload.last_name.length) {
	        statePayload.lastNameError = true;
	        error = true;
	      }
	      if (!payload.email_address || !payload.email_address.length || !emailRegex.exec(payload.email_address)) {
	        statePayload.emailError = true;
	        error = true;
	      }
	      this.setState(statePayload);
	
	      if (error) return;
	
	      return _Api2.default.retailerLead(this.props.retailer.token, payload).then(function (response) {
	        if (response === true) {
	          _this2.setState({ registered: true });
	        } else {
	          _this2.setState({
	            error: true,
	            email: ''
	          });
	        }
	      }, function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      if (event.key === 'Enter') {
	        this.refs.submitButton.click(event);
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.registered) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'no-products' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Thank you!'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We will be in touch within 48 hours.'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'no-products' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Welcome ',
	          this.props.retailer.name,
	          '!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Thank you for your interest in Indigo Fair. We are currently available to retailers by invitation only. Enter your information to request access to products.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'first_name', placeholder: 'First Name', onKeyDown: this.onKeyDown }),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.firstNameError ? '' : 'hidden' },
	            'This field is required'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'last_name', placeholder: 'Last Name', onKeyDown: this.onKeyDown }),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.lastNameError ? '' : 'hidden' },
	            'This field is required'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'email', ref: 'email_address', placeholder: 'Email Address', onKeyDown: this.onKeyDown }),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.emailError ? '' : 'hidden' },
	            'This field is required'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement(_FieldKit.PhoneField, { ref: 'phone_number', placeholder: 'Phone Number', onKeyDown: this.onKeyDown })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input note-input' },
	          _react2.default.createElement('textarea', { name: 'note', placeholder: 'Note', ref: 'note' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.error ? '' : 'hidden' },
	          'Invalid field values'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper' },
	          _react2.default.createElement(
	            _Button2.default,
	            { ref: 'submitButton', onClick: this.registerRequestUpdates },
	            'Submit'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NoProducts;
	}(_react2.default.Component);
	
	exports.default = NoProducts;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(27);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FieldComponents = __webpack_require__(67);
	
	var _AdminFunctions = __webpack_require__(49);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(376);
	
	var _index = __webpack_require__(17);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OPTION_GROUP_NAMES = [{ label: 'default', value: 'default' }, { label: 'Color', value: 'Color' }, { label: 'Scent', value: 'Scent' }, { label: 'Size', value: 'Size' }, { label: 'Material', value: 'Material' }];
	
	var OptionField = function (_Component) {
	  _inherits(OptionField, _Component);
	
	  function OptionField(props) {
	    _classCallCheck(this, OptionField);
	
	    var _this = _possibleConstructorReturn(this, (OptionField.__proto__ || Object.getPrototypeOf(OptionField)).call(this, props));
	
	    _this.onInput = _this.onInput.bind(_this);
	    _this.onImage = _this.onImage.bind(_this);
	    return _this;
	  }
	
	  _createClass(OptionField, [{
	    key: 'onInput',
	    value: function onInput(name, value) {
	      var option = _Api2.default.Utils.clone(this.props.value);
	      option[name] = value;
	      this.props.onInput(this.props.name, option);
	    }
	  }, {
	    key: 'onImage',
	    value: function onImage(_, image) {
	      var _props$value = this.props.value,
	          name = _props$value.name,
	          images = _props$value.images,
	          brand_code = _props$value.brand_code,
	          rest = _objectWithoutProperties(_props$value, ['name', 'images', 'brand_code']);
	      // Update to just one image
	
	
	      images = [image];
	
	      var option = _extends({
	        name: name || '',
	        brand_code: brand_code || '',
	        images: images
	      }, rest);
	      this.props.onInput(this.props.name, option);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$value2 = this.props.value,
	          name = _props$value2.name,
	          images = _props$value2.images,
	          brand_code = _props$value2.brand_code;
	
	      var firstImage = images && images[0] || { url: '' };
	      return _react2.default.createElement(
	        'div',
	        { className: 'option-field' },
	        _react2.default.createElement(_FieldComponents.InputField, { name: 'name',
	          required: true,
	          onInput: this.onInput,
	          placeholder: 'Option Name',
	          value: name || '' }),
	        _react2.default.createElement(_FieldComponents.InputField, { name: 'brand_code',
	          placeholder: 'Option SKU',
	          onInput: this.onInput,
	          value: brand_code || '' }),
	        _react2.default.createElement(_FieldComponents.ImageField, { name: 'image',
	          placeholder: 'Option Image',
	          onInput: this.onImage,
	          value: firstImage || '' })
	      );
	    }
	  }]);
	
	  return OptionField;
	}(_react.Component);
	
	OptionField.propTypes = {
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  onInput: _propTypes2.default.func.isRequired
	};
	
	
	var ErrorClass = "error";
	
	function mapFlatCategoriesToOptions(categoryTree, flatCategories) {
	  var categoryNames = Object.keys(categoryTree);
	  var categories = flatCategories.filter(function (category) {
	    return categoryNames.indexOf(category) >= 0;
	  });
	  var subcategories = flatCategories.filter(function (category) {
	    return categoryNames.indexOf(category) === -1;
	  });
	
	  return subcategories.map(function (subcategory) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var category = _step.value;
	
	        var potentialSubcategories = categoryTree[category];
	        if (potentialSubcategories.indexOf(subcategory) >= 0) {
	          var option = category + ': ' + subcategory;
	          return { label: option, value: option };
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return { label: subcategory, value: subcategory };
	  });
	}
	
	var ProductEditor = function (_Component2) {
	  _inherits(ProductEditor, _Component2);
	
	  function ProductEditor(props, context) {
	    _classCallCheck(this, ProductEditor);
	
	    var _this2 = _possibleConstructorReturn(this, (ProductEditor.__proto__ || Object.getPrototypeOf(ProductEditor)).call(this, props, context));
	
	    _this2.onImagesChange = _this2.onImagesChange.bind(_this2);
	    _this2.onImagesClear = _this2.onImagesClear.bind(_this2);
	    _this2.onImagesNew = _this2.onImagesNew.bind(_this2);
	    _this2.onInput = _this2.onInput.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.onOptionChange = _this2.onOptionChange.bind(_this2);
	    _this2.onOptionName = _this2.onOptionName.bind(_this2);
	    _this2.onOptionClear = _this2.onOptionClear.bind(_this2);
	    _this2.onNewOption = _this2.onNewOption.bind(_this2);
	    _this2.onShowAdvanced = _this2.onShowAdvanced.bind(_this2);
	    _this2.clearSavedView = _this2.clearSavedView.bind(_this2);
	    _this2.onProductChanged = _this2.onProductChanged.bind(_this2);
	    _this2.onCategoriesChange = _this2.onCategoriesChange.bind(_this2);
	    _this2.onCategoryOptionsChanged = _this2.onCategoryOptionsChanged.bind(_this2);
	    _this2.state = _this2.createState(_this2.props.product);
	    return _this2;
	  }
	
	  _createClass(ProductEditor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.cache.addChangeListener(this.onProductChanged, _Api2.default.cache.eventTypes.PRODUCTS_CHANGED);
	      _Api2.default.cache.addChangeListener(this.onCategoryOptionsChanged, _Api2.default.cache.eventTypes.CATEGORIES_CHANGED);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      _Api2.default.getCategories(true).then(function (categories) {
	        return _this3.setState({ categoryTree: categories });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.onProductChanged, _Api2.default.cache.eventTypes.PRODUCTS_CHANGED);
	      _Api2.default.cache.removeChangeListener(this.onCategoryOptionsChanged, _Api2.default.cache.eventTypes.CATEGORIES_CHANGED);
	    }
	  }, {
	    key: 'onProductChanged',
	    value: function onProductChanged() {
	      var _this4 = this;
	
	      if (!this.props.product || !this.props.product.token) return;
	
	      _Api2.default.getProductCache(this.props.product.token).then(function (result) {
	        _this4.setState(_this4.createState(result.products[_this4.props.product.token], _this4.state.showAdvanced, _this4.saved));
	      }).catch(function (error) {
	        console.error('error', error);
	      });
	    }
	  }, {
	    key: 'onCategoryOptionsChanged',
	    value: function onCategoryOptionsChanged() {
	      var categoryTree = _Api2.default.cache.getCategories();
	      var flatCategories = this.state.product.categories;
	      var categories = mapFlatCategoriesToOptions(categoryTree, flatCategories);
	      this.setState({
	        categoryTree: categoryTree,
	        categories: categories
	      });
	    }
	  }, {
	    key: 'createState',
	    value: function createState(product) {
	      var showAdvanced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var saved = arguments[2];
	
	      var _getTopLevelOptions = (0, _AdminFunctions.getTopLevelOptions)(product.options),
	          optionName = _getTopLevelOptions.optionName,
	          optionValues = _getTopLevelOptions.optionValues;
	
	      optionName = { label: optionName, value: optionName };
	
	      var savedViewCount = saved ? (this.state && this.state.savedViewCount || 0) + 1 : 0;
	      this.saved = false;
	
	      var categoryTree = _Api2.default.cache.getCategories();
	      var selectedCategories = [];
	      if (categoryTree && product.categories) {
	        selectedCategories = mapFlatCategoriesToOptions(categoryTree, product.categories);
	      }
	
	      var images = (product.images || []).map(function (image) {
	        return { key: image.token, value: image };
	      });
	
	      return {
	        product: product,
	        categoryTree: categoryTree,
	        categories: selectedCategories,
	        error: {
	          name: !product.name,
	          wholesale_price_cents: !product.wholesale_price_cents,
	          retail_price_cents: !product.retail_price_cents,
	          unit_multiplier: !product.unit_multiplier
	        },
	        errorView: null,
	        images: images,
	        showAdvanced: showAdvanced,
	        optionName: optionName,
	        optionValues: optionValues,
	        savedView: saved ? this.createSavedView() : null,
	        savedViewCount: savedViewCount
	      };
	    }
	  }, {
	    key: 'onImagesChange',
	    value: function onImagesChange(index, key, value) {
	      var images = this.state.images;
	      if (index > images.length) {
	        images.push({ key: key, value: value });
	      } else {
	        images[index] = { key: key, value: value };
	      }
	      this.setState({
	        images: images
	      });
	    }
	  }, {
	    key: 'onImagesNew',
	    value: function onImagesNew() {
	      return { key: 'image-' + this.state.images.length + '-' + Date.now(), value: { url: '' } };
	    }
	  }, {
	    key: 'onImagesClear',
	    value: function onImagesClear(index) {
	      var images = this.state.images;
	      images.splice(index, 1);
	      this.setState({
	        images: images
	      });
	    }
	  }, {
	    key: 'onShowAdvanced',
	    value: function onShowAdvanced() {
	      this.setState({
	        showAdvanced: true
	      });
	    }
	  }, {
	    key: 'onInput',
	    value: function onInput(name, input, error) {
	      if (name === 'wholesale_price_dollars' || name === 'retail_price_dollars') {
	        name = name.replace('dollars', 'cents');
	        input = _Api2.default.Utils.dollarToCents(input);
	      }
	
	      var product = this.state.product;
	      product[name] = input;
	
	      var errorState = this.state.error || {};
	      errorState[name] = !!error;
	
	      this.setState({
	        product: product,
	        error: errorState
	      });
	
	      if (this.props.onUpdated) {
	        this.props.onUpdated(product);
	      }
	    }
	  }, {
	    key: 'onCategoriesChange',
	    value: function onCategoriesChange(selectedCategoryOptions) {
	      this.setState({
	        categories: selectedCategoryOptions
	      });
	    }
	  }, {
	    key: 'onOptionChange',
	    value: function onOptionChange(index, optionKey, option) {
	      var optionValues = this.state.optionValues;
	      optionValues[index] = { key: optionKey, value: option };
	      this.setState({
	        optionValues: optionValues
	      });
	    }
	  }, {
	    key: 'onOptionClear',
	    value: function onOptionClear(index, name, value) {
	      var _this5 = this;
	
	      if (this.state.optionValues.length === 1) {
	        alert('Must have one option');
	        return;
	      }
	
	      if (window.confirm('Do you want to delete this option ' + name + ': ' + value.name)) {
	        var optionValues = this.state.optionValues;
	
	        if (value.token) {
	          this.setState({
	            deletingOption: true
	          });
	          _Api2.default.deleteProductOption(this.props.product.token, value.token).then(function () {
	            _this5.setState({
	              deletingOption: false
	            }, function () {
	              alert('Option deleted');
	            });
	          }).catch(function (error) {
	            alert('Failed to delete option');
	            console.error('error deleting option', error);
	            _this5.setState({
	              deletingOption: false
	            });
	          });
	        } else {
	          optionValues.splice(index, 1);
	          this.setState({
	            optionValues: optionValues
	          });
	        }
	      }
	    }
	  }, {
	    key: 'onNewOption',
	    value: function onNewOption() {
	      var key = 'option-' + this.state.optionValues.length + '-' + Date.now();
	      return { key: key, value: { name: '', brand_code: '', images: [] } };
	    }
	  }, {
	    key: 'onOptionName',
	    value: function onOptionName(selected) {
	      this.setState({
	        optionName: selected
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this6 = this;
	
	      var product = this.state.product;
	      var data = {
	        brand_token: this.props.brandToken,
	        active: product.active,
	        name: product.name.trim(),
	        wholesale_price_cents: product.wholesale_price_cents,
	        retail_price_cents: product.retail_price_cents,
	        unit_multiplier: product.unit_multiplier,
	        description: product.description,
	        amazon_url: product.amazon_url
	      };
	
	      if (product && product.token) {
	        data.token = product.token;
	      }
	
	      if (this.state.categories && this.state.categories.length > 0) {
	        data.categories = this.state.categories.reduce(function (flatCategories, categoryGroup) {
	          return flatCategories.concat(categoryGroup.value.split(':').map(function (str) {
	            return str.trim();
	          }));
	        }, []);
	      }
	
	      if (this.state.images.length) {
	        data.images = this.state.images.map(function (imageInput) {
	          return imageInput.value;
	        }).filter(function (image) {
	          return !!image.url;
	        });
	      }
	
	      var nestedOptions = (product.options || []).filter(function (o) {
	        return !!o.parent_token;
	      });
	      var modifiedOptions = this.state.optionValues.map(function (o) {
	        return o.value;
	      }).filter(function (o) {
	        return o && o.name;
	      }).map(function (o) {
	        o.group_name = _this6.state.optionName.value;
	        o.unit_multiplier = o.unit_multiplier || product.unit_multiplier;
	        o.wholesale_price_cents = o.wholesale_price_cents || product.wholesale_price_cents;
	        o.retail_price_cents = o.retail_price_cents || product.retail_price_cents;
	        return o;
	      });
	
	      data.options = nestedOptions.concat(modifiedOptions);
	
	      return _Api2.default.saveProduct(data).then(function (response) {
	        var products = response.products;
	        var productKey = Object.keys(products)[0];
	        var product = products[productKey];
	        _this6.props.onUpdated && _this6.props.onUpdated(product); // eslint-disable-line no-unused-expressions
	        _this6.saved = true;
	      }).catch(function (error) {
	        alert((0, _AdminFunctions.createAlertMessage)(error));
	        _this6.setState({
	          savedView: null,
	          savedViewCount: 0,
	          errorView: _this6.createErrorView(error)
	        });
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      if (this.handleError()) {
	        return;
	      }
	      return this.submit();
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      var errorValues = Object.values(this.state.error) || [];
	      var error = errorValues.some(function (value) {
	        return !!value;
	      });
	      if (error) {
	        this.setState({
	          savedView: null,
	          savedViewCount: 0,
	          errorView: this.createErrorView()
	        });
	      }
	
	      return error;
	    }
	  }, {
	    key: 'createErrorView',
	    value: function createErrorView(serverError) {
	      var view = void 0;
	      if (serverError) {
	        view = serverError && serverError.message || 'There was an error saving the content';
	      } else {
	        var messages = Object.entries(this.state.error).filter(function (entry) {
	          return !!entry[1];
	        }).map(function (entry) {
	          var name = entry[0];
	          if (name === 'wholesale_price_cents' || name === 'retail_price_cents') {
	            name = name.replace('_cents', '');
	          }
	          return 'Invalid ' + name.replace('_', ' ') + ' field';
	        });
	        var listItems = messages.map(function (m, index) {
	          var key = 'error-message-' + index;
	          return _react2.default.createElement(
	            'li',
	            { key: key },
	            m
	          );
	        });
	        view = _react2.default.createElement(
	          'ul',
	          null,
	          listItems
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-error-message' },
	        view
	      );
	    }
	  }, {
	    key: 'createSavedView',
	    value: function createSavedView() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'saved-box' },
	        'Saved!'
	      );
	    }
	  }, {
	    key: 'clearSavedView',
	    value: function clearSavedView() {
	      var savedViewCount = Math.max(this.state.savedViewCount - 1, 0);
	      var savedView = savedViewCount === 0 ? null : this.state.savedView;
	      if (!savedView) {
	        this.saved = false;
	      }
	      this.setState({
	        savedViewCount: savedViewCount,
	        savedView: savedView
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      if (!this.state.categoryTree) {
	        return _react2.default.createElement(_index2.default, null);
	      }
	      var product = this.state.product;
	
	      var googleImageLink = 'https://www.google.com/search?tbm=isch&q=' + (product.name || '') + ' ' + (this.props.brandName || '');
	      var wholesale_price_dollars = _Api2.default.Utils.formatCents(product.wholesale_price_cents, false, true) || '';
	      var retail_price_dollars = _Api2.default.Utils.formatCents(product.retail_price_cents, false, true) || '';
	
	      var firstProductImageUrl = null;
	      var imageUrls = this.state.images.filter(function (image) {
	        return !!image.value.url;
	      }).map(function (image) {
	        return image.value.url;
	      });
	      if (imageUrls && imageUrls.length > 0) {
	        firstProductImageUrl = imageUrls[0];
	      }
	
	      var productImageView = firstProductImageUrl ? _react2.default.createElement('img', { role: 'presentation', src: firstProductImageUrl }) : null;
	
	      if (this.state.savedView) {
	        setTimeout(this.clearSavedView, 2000);
	      }
	
	      // assumes every category (non-retailer specific) has subcategories
	      var categoryNames = Object.keys(this.state.categoryTree);
	      var categoryOptions = [];
	      categoryNames.forEach(function (category) {
	        var subcategories = _this7.state.categoryTree[category];
	        subcategories.forEach(function (subcategory) {
	          var option = category + ': ' + subcategory;
	          categoryOptions.push({ label: option, value: option });
	        });
	      });
	
	      var showAdvanced = this.state.showAdvanced;
	      var advancedView = void 0;
	      if (!showAdvanced && product.token) {
	        advancedView = _react2.default.createElement(
	          _Button2.default,
	          { onClick: this.onShowAdvanced },
	          'Show Advanced...'
	        );
	      } else if (showAdvanced) {
	        var options = (0, _AdminFunctions.optionTree)(this.props.brandToken, product);
	        advancedView = _react2.default.createElement(
	          'div',
	          { className: 'options' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Options'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            options
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { to: '/admin/brand/' + this.props.brandToken + '/product/' + product.token + '/option/new' },
	              'Add Option'
	            )
	          )
	        );
	      } else {
	        advancedView = null;
	      }
	
	      var deletingOptionView = this.state.deletingOption ? _react2.default.createElement(
	        'div',
	        null,
	        'Deleting option...',
	        _react2.default.createElement(_index2.default, null)
	      ) : null;
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-editor' },
	        _react2.default.createElement(
	          'form',
	          { className: 'admin-editor', onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            'h4',
	            null,
	            this.state.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'product-editor-image' },
	            productImageView
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label required' },
	              'Name'
	            ),
	            _react2.default.createElement(_FieldComponents.InputField, { name: 'name',
	              onInput: this.onInput,
	              required: true,
	              type: 'text',
	              className: this.state.error && this.state.error.name ? ErrorClass : '',
	              value: product.name || '',
	              placeholder: 'Name' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label' },
	              'Active'
	            ),
	            _react2.default.createElement(_FieldComponents.InputField, { type: 'checkbox',
	              onInput: this.onInput,
	              name: 'active',
	              defaultChecked: product.active })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line line-block' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label' },
	              'Description'
	            ),
	            _react2.default.createElement(_FieldComponents.InputField, { type: 'textarea',
	              name: 'description',
	              onInput: this.onInput,
	              value: product.description || '',
	              placeholder: 'Description' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label required' },
	              'Wholesale Price $'
	            ),
	            _react2.default.createElement(_FieldComponents.InputField, { name: 'wholesale_price_dollars',
	              onInput: this.onInput,
	              className: this.state.error && this.state.error.wholesale_price_cents ? ErrorClass : '',
	              required: true,
	              type: 'number',
	              value: wholesale_price_dollars,
	              placeholder: 'Wholesale Price' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label required' },
	              'Retail Price $'
	            ),
	            _react2.default.createElement(_FieldComponents.InputField, { name: 'retail_price_dollars',
	              onInput: this.onInput,
	              required: true,
	              className: this.state.error && this.state.error.retail_price_cents ? ErrorClass : '',
	              type: 'number',
	              value: retail_price_dollars,
	              placeholder: 'Retail Price' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label required' },
	              'Case Quantity'
	            ),
	            _react2.default.createElement(_FieldComponents.InputField, { name: 'unit_multiplier',
	              onInput: this.onInput,
	              required: true,
	              className: this.state.error && this.state.error.unit_multiplier ? ErrorClass : '',
	              type: 'number',
	              value: product.unit_multiplier || '',
	              placeholder: 'Case Quantity' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line line-block' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'categories', className: 'label' },
	              'Categories'
	            ),
	            _react2.default.createElement(_reactSelect2.default, {
	              name: 'categories',
	              clearable: true,
	              value: this.state.categories,
	              multi: true,
	              options: categoryOptions,
	              placeholder: 'Product Categories',
	              onChange: this.onCategoriesChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line' },
	            _react2.default.createElement(
	              'a',
	              { href: googleImageLink, target: '_blank' },
	              'Search on Google for Product Images'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line line-block' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label required' },
	              'Product Images'
	            ),
	            _react2.default.createElement(_FieldComponents.MultipleField, { name: 'images',
	              onClear: this.onImagesClear,
	              onNew: this.onImagesNew,
	              component: _FieldComponents.ImageField,
	              inputs: this.state.images,
	              onChange: this.onImagesChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label' },
	              'Amazon Url'
	            ),
	            _react2.default.createElement(_FieldComponents.InputField, { name: 'amazon_url',
	              onInput: this.onInput,
	              type: 'text',
	              value: product.amazon_url || '',
	              placeholder: 'Amazon URL' })
	          ),
	          _react2.default.createElement('hr', null),
	          deletingOptionView,
	          _react2.default.createElement(
	            'div',
	            { className: 'line' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label' },
	              'Option Group Name'
	            ),
	            _react2.default.createElement(_reactSelect.Creatable, { name: 'option_name',
	              options: OPTION_GROUP_NAMES,
	              clearable: false,
	              onChange: this.onOptionName,
	              type: 'text',
	              value: this.state.optionName })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'line line-block' },
	            _react2.default.createElement(
	              'label',
	              { className: 'label' },
	              'Option Values'
	            ),
	            _react2.default.createElement(_FieldComponents.MultipleField, { name: 'optionValues',
	              onClear: this.onOptionClear,
	              disabled: this.state.deletingOption,
	              component: OptionField,
	              inputs: this.state.optionValues,
	              onNew: this.onNewOption,
	              onChange: this.onOptionChange })
	          ),
	          this.state.errorView,
	          this.state.savedView,
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.handleSubmit },
	            'Save'
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        advancedView
	      );
	    }
	  }]);
	
	  return ProductEditor;
	}(_react.Component);
	
	ProductEditor.PropTypes = {
	  brandToken: _propTypes2.default.string.isRequired,
	  brandName: _propTypes2.default.string,
	  product: _propTypes2.default.object.isRequired,
	  onUpdated: _propTypes2.default.func
	};
	exports.default = ProductEditor;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductList = function (_Component) {
	  _inherits(ProductList, _Component);
	
	  function ProductList(props, context) {
	    _classCallCheck(this, ProductList);
	
	    var _this = _possibleConstructorReturn(this, (ProductList.__proto__ || Object.getPrototypeOf(ProductList)).call(this, props, context));
	
	    _this.onSelect = _this.onSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProductList, [{
	    key: 'onSelect',
	    value: function onSelect(event) {
	      var index = parseInt(event && event.target && event.target.dataset && event.target.dataset.index, 10);
	      if (typeof index !== 'number' || isNaN(index)) {
	        return;
	      }
	
	      this.props.onSelect(index);
	      this.setState({
	        selectedIndex: index
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var listItems = this.props.products.map(function (product, index) {
	        var key = product.token || index;
	        var className = index === _this2.props.selectedIndex ? 'selected' : '';
	        var value = product[_this2.props.keyName] || 'Missing Product Name';
	        // Show an active icon. The icon is not clickable though.
	        var active = _react2.default.createElement(_reactFontawesome2.default, { name: product.active ? "toggle-on" : "toggle-off" });
	        return _react2.default.createElement(
	          'li',
	          { key: key,
	            className: className,
	            'data-index': index,
	            onClick: _this2.onSelect },
	          active,
	          ' ',
	          value
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-list-component' },
	        _react2.default.createElement(
	          'div',
	          { className: 'product-list-component-title' },
	          'Products'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { onClick: this.onSelect },
	          listItems
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { onClick: this.props.onNew },
	          'New Product'
	        )
	      );
	    }
	  }]);
	
	  return ProductList;
	}(_react.Component);
	
	ProductList.propTypes = {
	  onNew: _propTypes2.default.func.isRequired,
	  onSelect: _propTypes2.default.func.isRequired,
	  products: _propTypes2.default.array.isRequired,
	  keyName: _propTypes2.default.string.isRequired,
	  selectedIndex: _propTypes2.default.number
	};
	exports.default = ProductList;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _InputField = __webpack_require__(43);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	__webpack_require__(377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO generic message?
	var PROMO_CODE_GENERIC_FAILURE_MESSAGE = 'Something went wrong applying this code. Try again in a bit';
	
	var PromoCode = function (_React$Component) {
	  _inherits(PromoCode, _React$Component);
	
	  function PromoCode(props) {
	    _classCallCheck(this, PromoCode);
	
	    var _this = _possibleConstructorReturn(this, (PromoCode.__proto__ || Object.getPrototypeOf(PromoCode)).call(this, props));
	
	    _this.onApply = _this.onApply.bind(_this);
	    _this.onShow = _this.onShow.bind(_this);
	    _this.onInput = _this.onInput.bind(_this);
	
	    _this.state = {
	      show: false,
	      applied: false,
	      disabled: true,
	      error: false,
	      input: ''
	    };
	    return _this;
	  }
	
	  _createClass(PromoCode, [{
	    key: 'onApply',
	    value: function onApply() {
	      var _this2 = this;
	
	      if (this.state.disabled || !this.state.input || this.state.input.trim().length === 0) return;
	
	      var promoCode = this.state.input.trim().toUpperCase();
	      _Api2.default.validatePromoCodes([promoCode]).then(function (response) {
	        var discount = response.discounts && response.discounts[promoCode] ? response.discounts[promoCode] : null;
	
	        if (discount) {
	          discount.code = promoCode;
	          discount.total_amount_cents = response.total_amount_cents;
	          _this2.setState({
	            applied: discount
	          });
	
	          _this2.props.onDiscount(discount);
	        } else {
	          var error = response.errors[promoCode];
	          if (!error) {
	            error = PROMO_CODE_GENERIC_FAILURE_MESSAGE;
	          }
	
	          _this2.setState({
	            error: error
	          });
	        }
	      }).catch(function (error) {
	        error = error.message || JSON.stringify(error);
	        _this2.setState({
	          error: error
	        });
	      });
	    }
	  }, {
	    key: 'onShow',
	    value: function onShow() {
	      var show = !this.state.show;
	      var input = show ? '' : this.state.input;
	      this.setState({
	        show: show,
	        error: false,
	        input: input
	      });
	    }
	  }, {
	    key: 'onInput',
	    value: function onInput(_, value) {
	      this.setState({
	        input: value,
	        error: false,
	        disabled: value.trim().length === 0
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var componentClassNames = ['promo-code-component'];
	      if (this.state.show) componentClassNames.push('show');
	      var applyOrInvalidView = null;
	
	      if (this.state.error) {
	        componentClassNames.push('invalid');
	        applyOrInvalidView = _react2.default.createElement(
	          'div',
	          { className: 'invalid-message' },
	          this.state.error
	        );
	      } else {
	        applyOrInvalidView = _react2.default.createElement(
	          'div',
	          { onClick: this.onApply,
	            className: 'apply-button ' + (this.state.disabled ? 'disabled' : '') },
	          'Apply'
	        );
	      }
	
	      var view = null;
	      if (this.state.applied) {
	        var discountMessage = this.state.applied.message ? _react2.default.createElement(
	          'div',
	          null,
	          this.state.applied.message
	        ) : null;
	        view = _react2.default.createElement(
	          'div',
	          { className: 'applied' },
	          _react2.default.createElement('div', { className: 'icon' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'messages' },
	            _react2.default.createElement(
	              'div',
	              null,
	              this.state.applied.code + ' was successfully applied to your cart!'
	            ),
	            discountMessage
	          )
	        );
	      } else {
	        view = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'label',
	              onClick: this.onShow },
	            _react2.default.createElement(
	              'div',
	              { className: 'switch' },
	              _react2.default.createElement(_reactFontawesome2.default, { name: 'close' })
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'ADD A PROMO CODE'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'promo-code-input' },
	            _react2.default.createElement(_InputField2.default, { name: 'promoCodeInput',
	              value: this.state.input,
	              onInput: this.onInput,
	              className: this.props.className }),
	            applyOrInvalidView
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: componentClassNames.join(' ') },
	        view
	      );
	    }
	  }]);
	
	  return PromoCode;
	}(_react2.default.Component);
	
	PromoCode.propTypes = {
	  className: _propTypes2.default.string,
	  onDiscount: _propTypes2.default.func.isRequired
	};
	exports.default = PromoCode;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectBusinessOption = function (_Component) {
	  _inherits(SelectBusinessOption, _Component);
	
	  function SelectBusinessOption() {
	    _classCallCheck(this, SelectBusinessOption);
	
	    return _possibleConstructorReturn(this, (SelectBusinessOption.__proto__ || Object.getPrototypeOf(SelectBusinessOption)).apply(this, arguments));
	  }
	
	  _createClass(SelectBusinessOption, [{
	    key: 'render',
	    value: function render() {
	      var place = this.props.googlePlaceSearchItem;
	
	      if (place.hintItem) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'select-business-place-hint' },
	            'Can\'t find your store? Try adding your city'
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'select-business-place-option-name' },
	            place.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-business-place-option-address' },
	            place.address
	          )
	        );
	      }
	    }
	  }]);
	
	  return SelectBusinessOption;
	}(_react.Component);
	
	SelectBusinessOption.propTypes = {
	  googlePlaceSearchItem: _propTypes2.default.object
	};
	exports.default = SelectBusinessOption;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LiveSearch = __webpack_require__(68);
	
	var _LiveSearch2 = _interopRequireDefault(_LiveSearch);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _search = __webpack_require__(438);
	
	var _search2 = _interopRequireDefault(_search);
	
	__webpack_require__(378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopSearch = function (_React$Component) {
	  _inherits(TopSearch, _React$Component);
	
	  function TopSearch(props) {
	    _classCallCheck(this, TopSearch);
	
	    var _this = _possibleConstructorReturn(this, (TopSearch.__proto__ || Object.getPrototypeOf(TopSearch)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this.focus = _this.focus.bind(_this);
	
	    _this.state = {
	      visible: false,
	      searchTerm: ''
	    };
	    return _this;
	  }
	
	  _createClass(TopSearch, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.startListen(this, 'visible', _Api2.default.cache.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
	      _Api2.default.startListen(this, 'searchTerm', _Api2.default.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(oldProps, oldState) {
	      if (this.state.visible && !oldState.visible) {
	        this.focus();
	      }
	
	      if (!this.state.visible && oldState.visible) {
	        // Once the search is hidden, clear the search value.
	        _Api2.default.cache.setProductSearchTerm('');
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      setTimeout(function () {
	        document.getElementById('top-search').focus();
	      }, 50);
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      _Api2.default.cache.setProductSearchActive(!this.state.visible);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(value) {
	      _Api2.default.cache.setProductSearchTerm(value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classNames = ['topsearch-component'];
	      if (this.props.className) {
	        classNames.push(this.props.className);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' ') },
	        _react2.default.createElement(
	          'div',
	          { className: 'search-icon', onClick: this.toggle },
	          _react2.default.createElement('img', { role: 'presentation', src: _search2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'search-input' + (this.state.visible ? '' : ' hidden') },
	          _react2.default.createElement(_LiveSearch2.default, { id: 'top-search', onChange: this.onChange, value: this.state.searchTerm })
	        )
	      );
	    }
	  }]);
	
	  return TopSearch;
	}(_react2.default.Component);
	
	TopSearch.propTypes = {
	  className: _propTypes2.default.string
	};
	exports.default = TopSearch;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(10);
	
	var _App = __webpack_require__(306);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(318);
	
	var _Retailer = __webpack_require__(325);
	
	var _Retailer2 = _interopRequireDefault(_Retailer);
	
	var _Brand = __webpack_require__(310);
	
	var _Brand2 = _interopRequireDefault(_Brand);
	
	var _collection = __webpack_require__(352);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _Apply = __webpack_require__(307);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _NotFound = __webpack_require__(320);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _user = __webpack_require__(358);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _checkout = __webpack_require__(349);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	var _Admin = __webpack_require__(326);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(407);
	
	__webpack_require__(406);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global csrfToken */
	_Api.Utils.setCSRF(csrfToken);
	
	function errorCallback(msg, url, lineNo, columnNo, error) {
	  if (!error) return;
	
	  var user = _Api2.default.cache.getUser() || {};
	  var retailer = _Api2.default.cache.getRetailer() || {};
	
	  var errorObject = {
	    pathname: window.location.pathname,
	    userToken: user.token,
	    retailerToken: retailer.token,
	    msg: msg,
	    url: url,
	    lineNo: lineNo,
	    columnNo: columnNo,
	    message: error.message,
	    stack: error.stack,
	    user: user,
	    retailer: retailer
	  };
	
	  _Api2.default.error(JSON.stringify(errorObject));
	}
	
	window.onerror = errorCallback;
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRouter.Router,
	  { history: _reactRouter.browserHistory },
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: '/', component: _App2.default },
	    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home.Home }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'about', component: _Home.About }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'team', component: _Home.Team }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _user.UserSignin }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'logout', component: _user.UserSignout }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'retailer/:retailerToken', component: _Retailer2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'retailer/:retailerToken/product/:productId', component: _Retailer2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'retailer/:retailerToken/category/:categoryName', component: _Retailer2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'retailer/:retailerId/brand/:brandToken', component: _Brand2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'retailer/:retailerId/brand/:brandToken/product/:productId', component: _Brand2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'retailer/:retailerToken/collection/:collectionToken', component: _collection2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'apply', component: _Apply2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'tos', component: _Home.TermsOfUse }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'purchaseterms', component: _Home.PurchaseTerms }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'copyright', component: _Home.Copyright }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'privacy', component: _Home.PrivacyPolicy }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'user', component: _user2.default },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _user.UserSignin }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'code/:email', component: _user.UserCode }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'logout', component: _user.UserSignout }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: 'account', component: _user.UserAccount },
	        _react2.default.createElement(_reactRouter.IndexRoute, { component: _user.UserAccountOrderStatus }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'orders', component: _user.UserAccountOrderStatus }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'payments', component: _user.UserPayments }),
	        _react2.default.createElement(_reactRouter.Route, { path: 'status', component: _user.UserAccountStatus })
	      )
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'checkout', component: _checkout2.default },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _checkout.CheckoutCreateAccount }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'payment', component: _checkout.CheckoutPaymentInformation }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'address', component: _checkout.CheckoutAddAddress }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'delivery', component: _checkout.CheckoutDeliveryDetails }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'success', component: _checkout.CheckoutSuccess })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'admin', component: _Admin2.default },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Admin.AdminBrand }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'create', component: _Admin.AdminBrandCreate }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'brand/:brandToken/edit', component: _Admin.AdminBrandEdit }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'brand/:brandId/product/:productId', component: _Admin.AdminProduct }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'brand/:brandId/product/:productId/option/new',
	        component: _Admin.AdminProductOptionEdit }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'brand/:brandId/product/:productId/option/:optionId/edit',
	        component: _Admin.AdminProductOptionEdit }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'retailers', component: _Admin.AdminRetailer }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'retailers/:retailerToken', component: _Admin.AdminRetailerView }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'queue', component: _Admin.AdminQueue }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'orders', component: _Admin.AdminOrders }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'orders/:orderToken', component: _Admin.AdminSingleOrder }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'emails', component: _Admin.AdminEmails }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'recommendations', component: _Admin.AdminRecommendations }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'collections', component: _Admin.AdminCollections }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'collections/:collectionToken', component: _Admin.AdminCollectionEdit }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'tools', component: _Admin.AdminTools })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFound2.default })
	  )
	), document.getElementById('root'));

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(296);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _LightBox = __webpack_require__(32);
	
	var _LightBox2 = _interopRequireDefault(_LightBox);
	
	var _AdminBar = __webpack_require__(327);
	
	var _AdminBar2 = _interopRequireDefault(_AdminBar);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(379);
	
	__webpack_require__(408);
	
	__webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['isModalView', 'doCloseModal', 'willCloseModal']);
	
	    if (_this.props.location && _this.props.location.query && _this.props.location.query.campaign === "1") {
	      _Api2.default.cache.setCampaignRetailerToken(_this.props.location.query['retailer_token']);
	    }
	
	    // True if we're in the list of modal views
	    _this.isModal = false;
	
	    // Children from the last view before we became modal, null if none.
	    _this.backgroundChildren = null;
	
	    // Array with the list of routes that are to be handled as modal
	    _this.modalViews = ['/admin/brand/[^/]*/product/[^/]*/option/.*', '/admin/amazon/[^/]+'];
	
	    _this.state = {
	      user: _Api2.default.cache.getUser(),
	      retailer: _Api2.default.cache.getRetailer(),
	      adminBarVisible: _Api2.default.cache.getAdminBarVisible()
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.userStartListen(this, 'user');
	      _Api2.default.startListen(this, 'retailer', _Api2.default.cache.eventTypes.RETAILER_CHANGED);
	      _Api2.default.startListen(this, 'adminBarVisible', _Api2.default.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
	
	      _Api2.default.getUser(true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.userStopListen(this);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.RETAILER_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.location && this.props.location.query && Object.keys(this.props.location.query).length > 0) {
	        setTimeout(function () {
	          _this2.context.router.replace(_this2.props.location.pathname);
	        }, 200);
	      }
	    }
	  }, {
	    key: 'isModalView',
	    value: function isModalView(path) {
	      var i = void 0;
	      for (i = 0; i < this.modalViews.length; i++) {
	        var normalPath = '^' + this.modalViews[i] + '$';
	
	        if (path.match(normalPath)) return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.location.key !== nextProps.location.key) {
	        var isModal = this.isModalView(nextProps.location.pathname);
	
	        if (isModal && !this.isModal) {
	          this.backgroundChildren = this.props.children;
	        } else if (!isModal) {
	          this.backgroundChildren = null;
	        }
	
	        this.isModal = isModal;
	        nextProps.location.isModal = this.isModal;
	
	        // onLocationChange
	        var callback = window.onLocationChange;
	        if (callback && typeof callback === 'function') {
	          callback(nextProps.location);
	        }
	
	        // Event
	        _Api2.default.event(nextProps.location.pathname);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(oldProps, oldState) {
	      if (this.state.user && !this.state.retailer) {
	        if (this.state.user.retailer_token) {
	          _Api2.default.getRetailer(this.state.user.retailer_token, true);
	        }
	      }
	    }
	
	    /**
	     * Closes the modal. No questions asked.
	     */
	
	  }, {
	    key: 'doCloseModal',
	    value: function doCloseModal() {
	      if (!this.isModal) return;
	
	      this.props.location.willCloseModal = null;
	      this.context.router.goBack();
	    }
	
	    /**
	     * This function is called when the user tries to close a modal.
	     *
	     * To change the way that the user may or may not close the modal, the value of `this.props.location.willCloseModal`
	     * should be a function that will be called in this moment.
	     * * Should the function return `false`, the modal will not close.
	     * * Should the function return `true`, the modal will close.
	     * * Should the function return an instance of the `Promise` object, the modal will close once the promise is
	     * resolved. If rejected, no action will be taken.
	     * * Any other return values are rejected and the modal will not be closed.
	     */
	
	  }, {
	    key: 'willCloseModal',
	    value: function willCloseModal() {
	      if (this.props.location.willCloseModal && typeof this.props.location.willCloseModal === 'function') {
	        var ret = this.props.location.willCloseModal();
	
	        if (ret === false) return;
	        if (ret === true) {
	          this.doCloseModal();
	        }
	
	        if (ret instanceof Promise) {
	          ret.then(this.doCloseModal);
	        }
	      } else {
	        this.doCloseModal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pageContents = this.isModal ? this.backgroundChildren : this.props.children;
	      var modalContents = this.isModal ? _react2.default.createElement(
	        _LightBox2.default,
	        { onClose: this.willCloseModal },
	        this.props.children
	      ) : null;
	
	      if (this.isModal) {
	        document.body.classList.add('noscroll');
	      } else {
	        document.body.classList.remove('noscroll');
	      }
	
	      var className = 'app';
	      var environment = window.envName[0] === '{' ? 'development' : window.envName;
	      if (window.envName !== 'production') {
	        className += ' env-' + environment;
	      }
	
	      var adminBar = null;
	      if (this.state.user && this.state.user.is_employee) {
	        adminBar = _react2.default.createElement(_AdminBar2.default, null);
	      }
	
	      if (adminBar && this.state.adminBarVisible && this.props.location.pathname.indexOf('/retailer/') === 0) {
	        document.body.classList.add('admin-bar-visible');
	      } else {
	        document.body.classList.remove('admin-bar-visible');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(_Header2.default, { location: this.props.location,
	          user: this.state.user,
	          retailer: this.state.retailer,
	          lastRetailerToken: _Api2.default.cache.getLastSelectedRetailerToken() }),
	        adminBar,
	        _react2.default.createElement(
	          'div',
	          { className: 'app-middle' },
	          pageContents
	        ),
	        modalContents
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;
	
	
	App.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _success = __webpack_require__(127);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(380);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Apply = function (_React$Component) {
	  _inherits(Apply, _React$Component);
	
	  function Apply(props) {
	    _classCallCheck(this, Apply);
	
	    var _this = _possibleConstructorReturn(this, (Apply.__proto__ || Object.getPrototypeOf(Apply)).call(this, props));
	
	    _this.success = _this.success.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	
	    _this.state = {
	      success: false,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(Apply, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'success',
	    value: function success() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'apply-component page-flyout success' },
	        _react2.default.createElement(
	          'div',
	          { className: 'image-wrapper' },
	          _react2.default.createElement('img', { role: 'presentation', src: _success2.default })
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Application Submitted!'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'note' },
	          'Thank you for your application.',
	          _react2.default.createElement('br', null),
	          'We will get back to you within 48 hours.'
	        )
	      );
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      var payload = _Api2.default.Utils.getFormValues(this, ['company_name', 'url', 'name', 'email_address', 'phone_number', 'note']);
	
	      return _Api2.default.brandLead(payload).then(function () {
	        _this2.setState({ success: true });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.success) {
	        return this.success();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'apply-component page-flyout' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Apply to Sell'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'note' },
	          'Apply to sell on Indigo Fair to get access to thousands of local retailers.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'company_name', placeholder: 'Company Name' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'url', placeholder: 'Website' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'name', placeholder: 'Your Name' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'email_address', placeholder: 'Email Address' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'phone_number', placeholder: 'Phone Number' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input note-input' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'note' },
	            'Note'
	          ),
	          _react2.default.createElement('textarea', { name: 'note', ref: 'note' })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.submit },
	            'Submit'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Apply;
	}(_react2.default.Component);
	
	exports.default = Apply;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectionStrip = function (_React$Component) {
	  _inherits(CollectionStrip, _React$Component);
	
	  function CollectionStrip(props) {
	    _classCallCheck(this, CollectionStrip);
	
	    var _this = _possibleConstructorReturn(this, (CollectionStrip.__proto__ || Object.getPrototypeOf(CollectionStrip)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.findCollection = _this.findCollection.bind(_this);
	
	    var collectionList = _Api2.default.cache.getProductCollections();
	
	    _this.state = {
	      brandToken: props.brandToken,
	      collectionList: collectionList,
	      collection: null
	    };
	    return _this;
	  }
	
	  _createClass(CollectionStrip, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.startListen(this, 'collectionList', _Api2.default.cache.eventTypes.PRODUCT_COLLECTIONS_CHANGED);
	      this.findCollection();
	      _Api2.default.getProductCollections(true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.PRODUCT_COLLECTIONS_CHANGED);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.brandToken !== this.state.brandToken) {
	        this.setState({
	          brandToken: nextProps.brandToken,
	          collection: null
	        });
	        this.findCollection();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.collectionList !== this.state.collectionList) {
	        this.findCollection();
	      }
	    }
	  }, {
	    key: 'findCollection',
	    value: function findCollection() {
	      var _this2 = this;
	
	      if (!this.state.collectionList || !this.state.collectionList.product_collections || this.state.collectionList.product_collections.length <= 0) {
	        this.setState({
	          collection: null
	        });
	        return;
	      }
	
	      var collectionDisplay = null;
	
	      this.state.collectionList.product_collections.forEach(function (collection) {
	        var validCollection = collection.items && collection.items.length > 0;
	        collection.items.forEach(function (collectionItem) {
	          if (collectionItem.brand_token !== _this2.props.brandToken) validCollection = false;
	        });
	
	        if (validCollection) collectionDisplay = collection;
	      });
	
	      this.setState({ collection: collectionDisplay });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      var url = '/retailer/' + this.props.retailerToken + '/collection/' + this.state.collection.token;
	
	      this.context.router.push(url);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.collection) return null;
	
	      var currentBrand = this.state.collectionList.brands[this.props.brandToken];
	      var classNames = ['collection-strip-component'];
	      if (this.props.className) classNames.push(this.props.className);
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' ') },
	        _react2.default.createElement(_reactFontawesome2.default, { name: 'heart' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'shop' },
	            'Shop the ',
	            this.state.collection.name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'dash' },
	            '-'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'featuring' },
	            'Featuring the ',
	            this.state.collection.items.length,
	            ' ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Most Popular'
	            ),
	            ' Items from ',
	            currentBrand.name
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { onClick: this.onClick },
	          'View Collection'
	        )
	      );
	    }
	  }]);
	
	  return CollectionStrip;
	}(_react2.default.Component);
	
	CollectionStrip.propTypes = {
	  brandToken: _propTypes2.default.string.isRequired,
	  retailerToken: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string
	};
	CollectionStrip.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = CollectionStrip;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var socialMap = {
	  'facebook': {
	    'field': 'facebook_handle',
	    'prefix': 'http://facebook.com/'
	  },
	  'twitter': {
	    'field': 'twitter_handle',
	    'prefix': 'http://twitter.com/'
	  },
	  'instagram': {
	    'field': 'instagram_handle',
	    'prefix': 'http://instagram.com/'
	  },
	  'youtube': {
	    'field': 'youtube_handle',
	    'prefix': 'http://youtube.com/'
	  },
	  'pinterest': {
	    'field': 'pinterest_handle',
	    'prefix': 'http://pinterest.com/'
	  }
	};
	
	var BrandHeader = function (_React$Component) {
	  _inherits(BrandHeader, _React$Component);
	
	  function BrandHeader(props) {
	    _classCallCheck(this, BrandHeader);
	
	    var _this = _possibleConstructorReturn(this, (BrandHeader.__proto__ || Object.getPrototypeOf(BrandHeader)).call(this, props));
	
	    _Api2.default.Utils.bindThis(_this, ['brandImageUrl', 'brandImage', 'logoGrid', 'socialIcons', 'brandAbout']);
	    return _this;
	  }
	
	  _createClass(BrandHeader, [{
	    key: 'brandImageUrl',
	    value: function brandImageUrl() {
	      var brandInfo = this.props.brand;
	
	      if (!brandInfo) return null;
	      if (brandInfo.images.length <= 0) return null;
	
	      return brandInfo.images[0].url;
	    }
	  }, {
	    key: 'brandImage',
	    value: function brandImage() {
	      var url = this.brandImageUrl();
	      if (!url) return null;
	
	      return _react2.default.createElement('img', { role: 'presentation', src: url });
	    }
	  }, {
	    key: 'logoGrid',
	    value: function logoGrid() {
	      if (!this.props.recommendations || this.props.recommendations.length <= 0) return;
	      if (!this.props.brandInfo) return;
	
	      var urls = [];
	
	      // Brand Image
	      if (this.props.brandInfo.images.length > 0) urls.push(this.props.brandInfo.images[0].url);
	
	      this.props.recommendations.forEach(function (product) {
	        var url = null;
	        if (product.images.length > 0) {
	          url = product.images[0].url;
	        } else if (product.options.length > 0 && product.options[0].images.length > 0) {
	          url = product.options[0].images[0].url;
	        }
	
	        if (url) urls.push(url);
	      });
	
	      if (urls.length <= 0) return null;
	
	      var idx = 0;
	      while (urls.length < 4) {
	        urls.push(urls[idx++]);
	      }
	
	      var contents = urls.map(function (url, idx) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'logo-image-block', key: 'brand-header-logo-image-block-' + idx },
	          _react2.default.createElement('img', { role: 'presentation', src: url })
	        );
	      });
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'logo-image-mosaic' },
	        contents
	      );
	    }
	  }, {
	    key: 'socialIcons',
	    value: function socialIcons() {
	      var _this2 = this;
	
	      if (!this.props.brand) return null;
	
	      var socialIcons = Object.keys(socialMap).map(function (socialKey) {
	        var socialFields = socialMap[socialKey];
	        if (!_this2.props.brand[socialFields.field]) return null;
	        return _react2.default.createElement(
	          'a',
	          {
	            className: 'social-link',
	            key: _this2.props.brand.token + '-social-' + socialKey,
	            href: socialFields.prefix + _this2.props.brand[socialFields.field],
	            target: '_new' },
	          _react2.default.createElement(_reactFontawesome2.default, { name: socialKey })
	        );
	      });
	
	      if (socialIcons.length === 0) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'social-icons' },
	        socialIcons
	      );
	    }
	  }, {
	    key: 'brandAbout',
	    value: function brandAbout() {
	      if (!this.props.brand || !this.props.brand.description) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'brand-about' },
	        _react2.default.createElement(
	          'p',
	          null,
	          this.props.brand.description
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var brandInfo = this.props.brand;
	      if (!brandInfo) return null;
	
	      var closestBrandRetailer = null;
	      if (this.props.closestBrandRetailer) {
	        var distance = null;
	        if (this.props.closestBrandRetailer < 1) {
	          distance = 'less than a mile away';
	        } else if (this.props.closestBrandRetailer > 5) {
	          distance = 'more than 5 miles away';
	        } else {
	          distance = Math.ceil(this.props.closestBrandRetailer) + ' miles away';
	        }
	        closestBrandRetailer = _react2.default.createElement(
	          'span',
	          { className: 'distance' },
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'map-marker' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Nearest known store carrying ',
	            brandInfo.name,
	            ' ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              distance
	            ),
	            '.'
	          )
	        );
	      }
	
	      var brandUrl = brandInfo.url;
	      if (brandUrl) {
	        brandUrl = brandUrl.replace(/^https?:\/\/([^/]*)\/?/, '$1');
	      }
	
	      var brandStyle = {};
	      var brandImageUrl = this.brandImageUrl();
	      var classNames = ['brand-header'];
	
	      if (brandImageUrl) {
	        brandStyle.backgroundImage = 'url(' + brandImageUrl + ')';
	      } else {
	        classNames.push('no-image');
	      }
	
	      var brandMinimum = null;
	      if (brandInfo.minimum_order_amount_cents) {
	        var minimumText = _Api2.default.Utils.formatCents(brandInfo.minimum_order_amount_cents);
	        if (minimumText.indexOf('.') > 0) {
	          minimumText = minimumText.substr(0, minimumText.indexOf('.'));
	        }
	        brandMinimum = _react2.default.createElement(
	          'span',
	          { className: 'brand-minimum' },
	          'Minimum $',
	          minimumText
	        );
	      } else {
	        brandMinimum = _react2.default.createElement(
	          'span',
	          { className: 'brand-minimum' },
	          'No Minimum'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '), id: 'brand-header-' + brandInfo.token, style: brandStyle },
	        this.socialIcons(),
	        _react2.default.createElement(
	          'div',
	          { className: 'inner-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'left-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'brand-name' },
	              brandInfo.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'brand-info-line' },
	              _react2.default.createElement(
	                'span',
	                { className: 'brand-from' },
	                brandInfo.from
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'brand-url' },
	                brandUrl
	              ),
	              brandMinimum
	            ),
	            this.brandAbout(),
	            closestBrandRetailer
	          )
	        )
	      );
	    }
	  }]);
	
	  return BrandHeader;
	}(_react2.default.Component);
	
	BrandHeader.propTypes = {
	  brand: _propTypes2.default.object,
	  recommendations: _propTypes2.default.array
	};
	exports.default = BrandHeader;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProductModal = __webpack_require__(70);
	
	var _ProductModal2 = _interopRequireDefault(_ProductModal);
	
	var _RecommendationGrid = __webpack_require__(110);
	
	var _RecommendationGrid2 = _interopRequireDefault(_RecommendationGrid);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _LightBox = __webpack_require__(32);
	
	var _LightBox2 = _interopRequireDefault(_LightBox);
	
	var _CategoryBar = __webpack_require__(66);
	
	var _CategoryBar2 = _interopRequireDefault(_CategoryBar);
	
	var _header = __webpack_require__(309);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _collection_strip = __webpack_require__(308);
	
	var _collection_strip2 = _interopRequireDefault(_collection_strip);
	
	var _consts = __webpack_require__(44);
	
	__webpack_require__(381);
	
	var _index = __webpack_require__(65);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var calculateButtonText = function calculateButtonText(selections) {
	  var totalCases = 0;
	  selections.forEach(function (selection) {
	    totalCases += selection.batches;
	  });
	
	  if (totalCases >= 2) return 'Add Cases to Bag';
	
	  return 'Add Case to Bag';
	};
	
	var Brand = function (_React$Component) {
	  _inherits(Brand, _React$Component);
	
	  function Brand(props) {
	    _classCallCheck(this, Brand);
	
	    var _this = _possibleConstructorReturn(this, (Brand.__proto__ || Object.getPrototypeOf(Brand)).call(this, props));
	
	    _this.searchChanged = _this.searchChanged.bind(_this);
	
	    _Api2.default.Utils.bindThis(_this, ['refresh', 'selectProduct', 'productModal', 'closeProductModal', 'redirectToBrandPage', 'addToCart', 'getCartSelection', 'getRecommendedProduct', 'categoriesUpdated', 'onBreadCrumb', 'onCategory']);
	
	    _this.state = {
	      categories: null,
	      recommendations: null,
	      filteredRecommendations: null,
	      brandInfo: null,
	      closestBrandRetailer: null,
	      productToken: props.params.productId
	    };
	    return _this;
	  }
	
	  _createClass(Brand, [{
	    key: 'categoriesUpdated',
	    value: function categoriesUpdated() {
	      this.setState({
	        categories: _Api2.default.cache.getCategories()
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.refresh();
	
	      _Api2.default.getRetailer(this.props.params.retailerId, true);
	      _Api2.default.cache.addChangeListener(this.categoriesUpdated, _Api2.default.cache.eventTypes.CATEGORIES_CHANGED);
	
	      _Api2.default.cache.setProductSearchActive(false);
	      _Api2.default.cache.setProductSearchTerm('');
	      _Api2.default.cache.addChangeListener(this.searchChanged, _Api2.default.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.searchChanged, _Api2.default.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
	      _Api2.default.cache.removeChangeListener(this.categoriesUpdated, _Api2.default.cache.eventTypes.CATEGORIES_CHANGED);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.params.brandToken !== nextProps.params.brandToken) {
	        this.setState({ recommendations: null });
	        _Api2.default.getBrand(nextProps.params.brandToken, true).then(function (brandInfo) {
	          _this2.setState({ brandInfo: brandInfo });
	        }).then(this.refresh);
	      }
	
	      if (this.state.productToken !== nextProps.params.productId) {
	        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	
	        this.setState({
	          productToken: nextProps.params.productId
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.scrollTop) {
	        document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop;
	      }
	    }
	  }, {
	    key: 'selectProduct',
	    value: function selectProduct(product) {
	      var url = '/retailer/' + this.props.params.retailerId + '/brand/' + this.props.params.brandToken + '/product/' + product.token;
	      this.context.router.push(url);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var _this3 = this;
	
	      _Api2.default.getBrand(this.props.params.brandToken, true).then(function (brandInfo) {
	        _this3.setState({ brandInfo: brandInfo });
	      });
	
	      _Api2.default.getClosestBrandRetailer(this.props.params.brandToken).then(function (closestBrandRetailer) {
	        _this3.setState({ closestBrandRetailer: closestBrandRetailer });
	      });
	
	      _Api2.default.getProductCollections(true).then(function () {
	        return _Api2.default.getBrandProducts(_this3.props.params.brandToken);
	      }).then(function (recommendations) {
	        _this3.setState({ recommendations: recommendations });
	      });
	
	      _Api2.default.getRetailer(this.props.params.retailerId, true).then(function (retailer) {
	        _this3.setState({ retailer: retailer });
	      }, function (error) {
	        if (error.httpStatusCode === 401) {
	          var user = _Api2.default.cache.getUser();
	          if (user && user.retailer_token && user.retailer_token !== _this3.props.params.retailerId) {
	            // Send the user to the Retailer they actually own.
	            _this3.context.router.push('/retailer/' + user.retailer_token);
	          } else {
	            _this3.context.router.push('/');
	          }
	        } else {
	          console.log(error);
	        }
	      });
	      _Api2.default.getCategories(true).then(function (categories) {
	        _this3.setState({ categories: categories });
	      }, function (error) {
	        console.log(error);
	      });
	    }
	  }, {
	    key: 'closeProductModal',
	    value: function closeProductModal() {
	      this.redirectToBrandPage();
	    }
	  }, {
	    key: 'getRecommendedProduct',
	    value: function getRecommendedProduct(productToken) {
	      var recommendedProduct = null;
	
	      if (this.state.recommendations && this.state.recommendations.products) {
	        recommendedProduct = this.state.recommendations.products[productToken];
	      }
	
	      if (recommendedProduct) {
	        return Promise.resolve(recommendedProduct);
	      }
	
	      return _Api2.default.getProduct(productToken, true).then(function (productResponse) {
	        return productResponse.products[productToken];
	      });
	    }
	  }, {
	    key: 'productModal',
	    value: function productModal() {
	      if (this.state.productToken) {
	        document.body.classList.add('noscroll');
	      } else {
	        document.body.classList.remove('noscroll');
	      }
	
	      if (!this.state.productToken) return;
	
	      var cartSelection = this.getCartSelection();
	
	      return _react2.default.createElement(
	        _LightBox2.default,
	        { onClose: this.closeProductModal },
	        _react2.default.createElement(_ProductModal2.default, {
	          productToken: this.state.productToken,
	          retailerToken: this.props.params.retailerId,
	          onSave: this.addToCart,
	          defaultSelection: cartSelection,
	          buttonText: !cartSelection ? calculateButtonText : 'Save'
	        })
	      );
	    }
	  }, {
	    key: 'redirectToBrandPage',
	    value: function redirectToBrandPage() {
	      this.context.router.push('/retailer/' + this.props.params.retailerId + '/brand/' + this.props.params.brandToken);
	    }
	  }, {
	    key: 'getCartSelection',
	    value: function getCartSelection() {
	      var _this4 = this;
	
	      var cartSelection = null;
	      var cart = _Api2.default.cache.getCart();
	      if (cart && cart.cart && cart.cart.items && cart.cart.items.length > 0) {
	        var productOptionsInCart = cart.cart.items.filter(function (cartItem) {
	          return cartItem.product_token === _this4.state.productToken;
	        });
	
	        if (productOptionsInCart.length > 0) {
	          (function () {
	            var product = cart.products[productOptionsInCart[0].product_token];
	            var batchCount = product.options[0].unit_multiplier;
	            cartSelection = productOptionsInCart.map(function (cartItem) {
	              return {
	                option: cartItem.product_option_token,
	                batches: cartItem.quantity / batchCount
	              };
	            });
	          })();
	        }
	      }
	
	      return cartSelection;
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(productToken, productOptions) {
	      var _this5 = this;
	
	      var cartItems = null;
	
	      return this.getRecommendedProduct(productToken).then(function (product) {
	        if (!product) {
	          console.error('Cannot find product with token %s', productToken);
	          console.error(_this5.state.recommendations);
	        }
	
	        cartItems = productOptions.map(function (selection) {
	          var selectedOption = product.options.find(function (option) {
	            return selection.option === option.token;
	          });
	          var bagEntry = {};
	          bagEntry.brand_token = product.brand_token;
	          bagEntry.product_token = product.token;
	          bagEntry.product_option_token = selectedOption.token;
	          bagEntry.quantity = selection.batches * selectedOption.unit_multiplier;
	          bagEntry.price_cents = selectedOption.wholesale_price_cents;
	
	          return bagEntry;
	        });
	      }).then(function () {
	        var oldSelection = _this5.getCartSelection();
	
	        if (oldSelection && oldSelection.length > 0) {
	          return _Api2.default.removeFromCart(oldSelection.map(function (selection) {
	            return selection.option;
	          }));
	        }
	      }).then(function () {
	        return _Api2.default.addToCart(cartItems);
	      }).then(function (result) {
	        _this5.redirectToBrandPage();
	        return result;
	      });
	    }
	  }, {
	    key: 'searchChanged',
	    value: function searchChanged() {
	      var searchTerm = _Api2.default.cache.getProductSearchTerm();
	      if (searchTerm !== '') {
	        this.context.router.push('/retailer/' + this.props.params.retailerId);
	      }
	    }
	  }, {
	    key: 'onCategory',
	    value: function onCategory(category, subcategory, filter) {
	      var params = {
	        category: category,
	        subcategory: subcategory,
	        filter: filter && filter.value || null
	      };
	
	      var queryString = Object.keys(params).filter(function (key) {
	        return params[key];
	      }).map(function (key) {
	        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
	      }).join('&');
	
	      this.context.router.push('/retailer/' + this.props.params.retailerId + '?' + queryString);
	    }
	  }, {
	    key: 'onBreadCrumb',
	    value: function onBreadCrumb(_, position) {
	      // only care about home
	      if (position !== 0) {
	        return;
	      }
	
	      this.context.router.push('/retailer/' + this.props.params.retailerId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.recommendations || !this.state.categories) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'retailer-loading-wrapper' },
	          _react2.default.createElement(_Processing2.default, null)
	        );
	      }
	
	      var brands = {};
	      if (this.state.brandInfo) brands[this.state.brandInfo.token] = this.state.brandInfo;
	
	      var productDict = {};
	      var displayOrder = [];
	      this.state.recommendations.forEach(function (product) {
	        displayOrder.push(product.token);
	        productDict[product.token] = product;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'brand-component' },
	        _react2.default.createElement(_CategoryBar2.default, { categories: this.state.categories,
	          filters: _consts.CATEGORY_FILTERS,
	          onSelect: this.onCategory }),
	        _react2.default.createElement(_header2.default, { brand: this.state.brandInfo,
	          closestBrandRetailer: this.state.closestBrandRetailer,
	          recommendations: this.state.recommendations }),
	        _react2.default.createElement(_collection_strip2.default, { brandToken: this.state.brandInfo.token, retailerToken: this.props.params.retailerId }),
	        _react2.default.createElement(_index2.default, { onSelect: this.onBreadCrumb, primary: this.state.brandInfo.name }),
	        _react2.default.createElement(_RecommendationGrid2.default, {
	          retailerToken: this.props.params.retailerId,
	          products: productDict,
	          collections: {},
	          display_order: displayOrder,
	          brands: brands,
	          selectProduct: this.selectProduct }),
	        this.productModal()
	      );
	    }
	  }]);
	
	  return Brand;
	}(_react2.default.Component);
	
	exports.default = Brand;
	
	
	Brand.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bag = __webpack_require__(121);
	
	var _bag2 = _interopRequireDefault(_bag);
	
	var _computer = __webpack_require__(122);
	
	var _computer2 = _interopRequireDefault(_computer);
	
	var _creditcard = __webpack_require__(123);
	
	var _creditcard2 = _interopRequireDefault(_creditcard);
	
	var _logo = __webpack_require__(53);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Values = __webpack_require__(108);
	
	var _Values2 = _interopRequireDefault(_Values);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = [{
	  className: '',
	  header: 'Passionate about Product',
	  imageUrl: _bag2.default,
	  description: 'Lorem ipsum dolor sit amet, conse ctetur adipiscing elit.'
	}, {
	  className: '',
	  header: 'Believe in the Little Guys',
	  imageUrl: _computer2.default,
	  description: 'Lorem ipsum dolor sit amet, conse ctetur adipiscing elit.'
	}, {
	  className: '',
	  header: 'Love what We Do',
	  imageUrl: _creditcard2.default,
	  description: 'Lorem ipsum dolor sit amet, conse ctetur adipiscing elit.'
	}];
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
	  }
	
	  _createClass(About, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'onApplyClick',
	    value: function onApplyClick() {
	      window.location.assign('mailto:careers@indigofair.com');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var onApplyClick = this.onApplyClick.bind(this);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'about', id: 'about' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-wrapper' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/' },
	                _react2.default.createElement('img', { src: _logo2.default, role: 'presentation' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'preamble' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Empowering Local Retailers'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'about-preamble' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Indigo Fair is on a mission to revolutionize the way retailers shop for their stores. We take all the pain out of buying for store owners. Retailers can come to Indigo Fair to find unique and exciting products from hundreds of makers all in one place. We have also created the first wholesale marketplace to offer free returns. Our goal is to make every item in your store a bestseller.'
	          ),
	          _react2.default.createElement(
	            'blockquote',
	            { className: 'hidden' },
	            '\u201CAt vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentim voluptatum deleniti  corrupti quos dolores et quas molestias. Lorem ipsum spiritus.\u201D'
	          )
	        ),
	        _react2.default.createElement(_Values2.default, { values: values, className: 'hidden' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'full-block' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'We\u2019re here to help you discover the perfect products for your store.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'jobs' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Interested in joining the team?'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: onApplyClick },
	            'Apply'
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return About;
	}(_react.Component);
	
	exports.default = About;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _StaticHeader = __webpack_require__(51);
	
	var _StaticHeader2 = _interopRequireDefault(_StaticHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Copyright = function (_React$Component) {
	  _inherits(Copyright, _React$Component);
	
	  function Copyright() {
	    _classCallCheck(this, Copyright);
	
	    return _possibleConstructorReturn(this, (Copyright.__proto__ || Object.getPrototypeOf(Copyright)).apply(this, arguments));
	  }
	
	  _createClass(Copyright, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'copyright', id: 'copyright' },
	        _react2.default.createElement(_StaticHeader2.default, null),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Copyright Dispute Policy'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contents' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'In accordance with the DMCA, we\u2019ve adopted the policy below toward copyright infringement.  We reserve the right to (1) block access to or remove material that we believe in good faith to be copyrighted material that has been illegally copied and distributed by any of our advertisers, affiliates, content providers, members or users and (2) remove and discontinue service to repeat offenders.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Remember that your use of Indigo Fair\u2019s Services is at all times subject to the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/tos' },
	              'Terms of Use'
	            ),
	            ', which incorporates this Copyright Dispute Policy.  Any terms we use in this Policy without defining them have the definitions given to them in the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/tos' },
	              'Terms of Use'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Procedure for Reporting Copyright Infringements.  If you believe that material or content residing on or accessible through the Services infringes your copyright (or the copyright of someone whom you are authorized to act on behalf of), please send a notice of copyright infringement containing the following information to the Indigo Fair\u2019s Designated Agent to Receive Notification of Claimed Infringement (our \u201CDesignated Agent,\u201D whose contact details are listed below):',
	              _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'A physical or electronic signature of a person authorized to act on behalf of the owner of the copyright that has been allegedly infringed;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Identification of works or materials being infringed;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Identification of the material that is claimed to be infringing including information regarding the location of the infringing materials that the copyright owner seeks to have removed, with sufficient detail so that Indigo Fair is capable of finding and verifying its existence;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Contact information about the notifier including address, telephone number and, if available, email address;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'A statement that the notifier has a good faith belief that the material identified in (1)(c) is not authorized by the copyright owner, its agent, or the law; and'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'A statement made under penalty of perjury that the information provided is accurate and the notifying party is authorized to make the complaint on behalf of the copyright owner.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Once Proper Bona Fide Infringement Notification Is Received by the Designated Agent.  Upon receipt of a proper notice of copyright infringement, we reserve the right to:',
	              _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'remove or disable access to the infringing material;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'notify the content provider who is accused of infringement that we have removed or disabled access to the applicable material; and'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'terminate such content provider\'s access to the Services if he or she is a repeat offender.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Procedure to Supply a Counter-Notice to the Designated Agent.  If the content provider believes that the material that was removed (or to which access was disabled) is not infringing, or the content provider believes that it has the right to post and use such material from the copyright owner, the copyright owner\'s agent, or, pursuant to the law, the content provider may send us a counter-notice containing the following information to the Designated Agent:',
	              _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'A physical or electronic signature of the content provider;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Identification of the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or disabled;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'A statement that the content provider has a good faith belief that the material was removed or disabled as a result of mistake or misidentification of the material; and'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Content provider\'s name, address, telephone number, and, if available, email address, and a statement that such person or entity consents to the jurisdiction of the Federal Court for the judicial district in which the content provider\u2019s address is located, or, if the content provider\'s address is located outside the United States, for any judicial district in which Indigo Fair is located, and that such person or entity will accept service of process from the person who provided notification of the alleged infringement.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If a counter-notice is received by the Designated Agent, Indigo Fair may, in its discretion, send a copy of the counter-notice to the original complaining party informing that person that Indigo Fair may replace the removed material or cease disabling it in 10 business days. Unless the copyright owner files an action seeking a court order against the content provider accused of committing infringement, the removed material may be replaced or access to it restored in 10 to 14 business days or more after receipt of the counter-notice, at Indigo Fair\u2019s discretion.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Please contact Indigo Fair\u2019s Designated Agent at the following address:'
	            ),
	            _react2.default.createElement(
	              'blockquote',
	              null,
	              'Matthew Rhodes',
	              _react2.default.createElement('br', null),
	              '3424a 19th Street',
	              _react2.default.createElement('br', null),
	              'San Francisco, Ca 94110'
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Copyright;
	}(_react2.default.Component);
	
	exports.default = Copyright;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(10);
	
	var _frontImage = __webpack_require__(430);
	
	var _frontImage2 = _interopRequireDefault(_frontImage);
	
	var _spinner = __webpack_require__(443);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _chevronDown = __webpack_require__(429);
	
	var _chevronDown2 = _interopRequireDefault(_chevronDown);
	
	var _bag = __webpack_require__(121);
	
	var _bag2 = _interopRequireDefault(_bag);
	
	var _computer = __webpack_require__(122);
	
	var _computer2 = _interopRequireDefault(_computer);
	
	var _creditcard = __webpack_require__(123);
	
	var _creditcard2 = _interopRequireDefault(_creditcard);
	
	var _package = __webpack_require__(422);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _percentage = __webpack_require__(423);
	
	var _percentage2 = _interopRequireDefault(_percentage);
	
	var _tag = __webpack_require__(424);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _Cactus_IndigoFair = __webpack_require__(439);
	
	var _Cactus_IndigoFair2 = _interopRequireDefault(_Cactus_IndigoFair);
	
	var _Cactus_IndigoFair3 = __webpack_require__(440);
	
	var _Cactus_IndigoFair4 = _interopRequireDefault(_Cactus_IndigoFair3);
	
	var _Cactus_IndigoFair5 = __webpack_require__(441);
	
	var _Cactus_IndigoFair6 = _interopRequireDefault(_Cactus_IndigoFair5);
	
	var _WinkSF = __webpack_require__(446);
	
	var _WinkSF2 = _interopRequireDefault(_WinkSF);
	
	var _OfficeHours = __webpack_require__(445);
	
	var _OfficeHours2 = _interopRequireDefault(_OfficeHours);
	
	var _logo = __webpack_require__(53);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Values = __webpack_require__(108);
	
	var _Values2 = _interopRequireDefault(_Values);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _BusinessSearchComponent = __webpack_require__(286);
	
	var _BusinessSearchComponent2 = _interopRequireDefault(_BusinessSearchComponent);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _consts = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = [{
	  className: '',
	  header: 'Unique Products',
	  imageUrl: _bag2.default,
	  description: 'Browse exciting products from hundreds of makers, all in one place.'
	}, {
	  className: '',
	  header: 'Easy Ordering',
	  imageUrl: _computer2.default,
	  description: 'Place wholesale orders with just a few clicks. Track shipments online.'
	}, {
	  className: '',
	  header: 'Low Minimums',
	  imageUrl: _creditcard2.default,
	  description: 'Opening order minimums are $150 or lower for most makers.'
	}, {
	  className: '',
	  header: 'Flexible Terms',
	  imageUrl: _percentage2.default,
	  description: 'Pay with a credit card or take Net 90 payment terms, however you like to pay.'
	}, {
	  className: '',
	  header: 'Free for Retailers',
	  imageUrl: _tag2.default,
	  description: 'Indigo Fair is completely free for retailers. No markups or fees.'
	}, {
	  className: '',
	  header: 'Guaranteed Sales',
	  imageUrl: _package2.default,
	  description: 'Send back any products that don’t sell within 90 days with free return shipping.'
	}];
	
	var testimonials = [{
	  className: '',
	  imageUrl: _WinkSF2.default,
	  message: 'We love working with Indigo Fair! Indigo Fair gives us the opportunity to experience new merchandise in our store and see if it is a good match for our customers. We are able to try new merchandise we might not have purchased. For example, PyroPet Candles have been one of our bestsellers and we would not have ordered them without the option to return them.',
	  who: 'Marcy Isreal',
	  where: 'WINK SF, San Francisco, CA'
	}, {
	  className: '',
	  imageUrl: _OfficeHours2.default,
	  message: 'Finding new and great products is part of the fun of owning a small store. It is also my most time-consuming activity. Indigo Fair does the leg work and researches the products to show me things I will like. Best of all, I only pay for what I sell, which allows me to carry new merchandise in the store without any risk.',
	  who: 'Patricia Rudd',
	  where: 'Office Hours, Mill Valley, CA'
	}];
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home(props) {
	    _classCallCheck(this, Home);
	
	    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['handleBusinessSelected', 'businessSelected', 'handleAddressFocus', 'handleSearchChange', 'handleQueryChanged', 'handleRawRetailer', 'getSearchComponent', 'shakeIt', 'onScroll', 'loadInitialProducts']);
	
	    _this.state = {
	      hasSearchTerm: false,
	      businessData: null,
	      loading: false,
	      queryString: '',
	      shake: false,
	      retailer: null,
	      scrollTop: 0
	    };
	    return _this;
	  }
	
	  _createClass(Home, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var retailerToken = this.props.location.query.retailer_token;
	      if (retailerToken) {
	        this.onSelectedRetailerToken(retailerToken);
	        return;
	      }
	
	      _Api2.default.getLastSelectedRetailer().then(function (retailerToken) {
	        if (retailerToken) {
	          _this2.context.router.push("/retailer/" + retailerToken);
	        }
	      });
	
	      document.addEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      document.removeEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: "onScroll",
	    value: function onScroll() {
	      this.setState({
	        scrollTop: document.documentElement.scrollTop || document.body.scrollTop
	      });
	    }
	  }, {
	    key: "onSelectedRetailerToken",
	    value: function onSelectedRetailerToken(retailerToken) {
	      var _this3 = this;
	
	      _Api2.default.getRetailer(retailerToken, true).then(function (retailer) {
	        _this3.setState({ retailer: retailer });
	      }).catch(function (error) {
	        if (error.httpStatusCode === 401) {
	          var user = _Api2.default.cache.getUser();
	          if (user && user.retailer_token && user.retailer_token !== retailerToken) {
	            // Send the user to the Retailer they actually own.
	            _this3.context.router.push("/retailer/" + user.retailer_token);
	            _this3.loadRetailer(user.retailer_token);
	          } else {
	            _this3.context.router.push('/');
	          }
	        } else {
	          // TODO(sergio): We need to handle this case and display some error.
	          console.log(error);
	          _this3.setState({ error: error });
	        }
	      });
	    }
	  }, {
	    key: "loadInitialProducts",
	    value: function loadInitialProducts() {
	      var request = _Api2.default.createProductBrowseNewPayload(_consts.JUST_FOR_YOU_CATEGORY, null, null);
	
	      return _Api2.default.productBrowseNew(request, true);
	    }
	  }, {
	    key: "handleBusinessSelected",
	    value: function handleBusinessSelected(businessData) {
	      this.setState({ businessData: businessData });
	      this.businessSelected(businessData);
	    }
	  }, {
	    key: "handleQueryChanged",
	    value: function handleQueryChanged(query) {
	      this.setState({ queryString: query });
	    }
	  }, {
	    key: "shakeIt",
	    value: function shakeIt(idx) {
	      var _this4 = this;
	
	      var elementList = document.getElementsByTagName('input');
	      if (!elementList) return;
	      var element = elementList[idx || 0];
	      if (!element) return;
	
	      element.focus();
	      this.setState({ shake: true });
	
	      setTimeout(function () {
	        if (_this4.state.shake) _this4.setState({ shake: false });
	      }, 1000);
	    }
	  }, {
	    key: "createRetailer",
	    value: function createRetailer(payload, welcomeBack) {
	      var _this5 = this;
	
	      var retailerData = null;
	      var isEmployee = _Api2.default.cache.getUser() && _Api2.default.cache.getUser().is_employee;
	
	      return _Api2.default.createRetailer(payload).then(function (retailer) {
	        retailerData = retailer;
	
	        if (retailer.invited || isEmployee) return _this5.loadInitialProducts();
	        return retailer;
	      }).then(function () {
	        _this5.context.router.push("/retailer/" + retailerData.token);
	      }).catch(function (errorData) {
	        if (errorData.httpStatusCode === 401) {
	          var retailerToken = errorData.response && errorData.response.entity_token ? errorData.response.entity_token : null;
	          var url = "/user";
	          if (retailerToken) {
	            url += "?redirect=/retailer/" + retailerToken;
	          }
	          if (welcomeBack) {
	            url += '&welcomeback=1';
	          }
	          _this5.context.router.push(url);
	        } else {
	          _this5.setState({ error: errorData });
	        }
	      });
	    }
	  }, {
	    key: "handleRawRetailer",
	    value: function handleRawRetailer(inputIdx) {
	      var _this6 = this;
	
	      var retailerToken = _Api2.default.cache.getCampaignRetailerToken();
	      if (retailerToken) {
	        var _ret = function () {
	          // Display loading icon
	          _this6.setState({
	            loading: true
	          });
	
	          var url = "/retailer/" + retailerToken + "?campaign=1";
	          var isEmployee = _Api2.default.cache.getUser() && _Api2.default.cache.getUser().is_employee;
	
	          return {
	            v: _Api2.default.getRetailer(retailerToken, true).then(function (retailer) {
	              if (retailer.invited || isEmployee) return _this6.loadInitialProducts();
	              return retailer;
	            }).then(function () {
	              _this6.context.router.push(url);
	            })
	          };
	        }();
	
	        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
	      }
	
	      var businessName = this.state.queryString;
	      if (businessName.length <= 5) {
	        this.shakeIt(inputIdx);
	        return;
	      }
	
	      this.setState({
	        loading: true
	      });
	
	      return this.createRetailer({ name: businessName });
	    }
	  }, {
	    key: "businessSelected",
	    value: function businessSelected(businessData) {
	      var business = businessData;
	      if (!business) return;
	
	      var images = business.photos && business.photos.map(function (photoObj) {
	        return { url: photoObj.getUrl({ 'maxWidth': 1600, 'maxHeight': 1600 }) };
	      });
	
	      // Combine Vicinity and First Category into friendly sentence
	      // Try to remove street number from vicinity.
	      var description = _Api.Utils.titleCase(business.types[0]) + ' in the ' + (business.vicinity || '').split(' ').splice(1).join(' ') + ' area.';
	
	      var data = {
	        name: business.name,
	        description: description,
	        url: business.website,
	        display_phone_number: business.formatted_phone_number,
	        display_address: business.formatted_address,
	        images: images || [],
	        categories: business.types,
	        google_places_json: JSON.stringify(businessData)
	      };
	
	      this.setState({
	        loading: true
	      });
	
	      return this.createRetailer(data, true);
	    }
	  }, {
	    key: "handleAddressFocus",
	    value: function handleAddressFocus() {
	      //Utils.scrollTo('get-started');
	    }
	  }, {
	    key: "handleSearchChange",
	    value: function handleSearchChange(searchTerm) {
	      this.setState({ hasSearchTerm: !!searchTerm });
	      if (!searchTerm) {
	        this.setState({ businessData: null });
	      }
	    }
	  }, {
	    key: "getTestimonials",
	    value: function getTestimonials() {
	      var items = testimonials.map(function (testimonial, idx) {
	        return _react2.default.createElement(
	          "div",
	          { key: "testimonial-entry-item-" + idx,
	            className: 'entry' + (testimonial.className ? ' ' + testimonial.className : '') },
	          _react2.default.createElement(
	            "div",
	            { className: "image-wrapper" },
	            _react2.default.createElement("img", { src: testimonial.imageUrl, role: "presentation" })
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "\u201C",
	            testimonial.message,
	            "\u201D"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "author" },
	            "- ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              testimonial.who
	            ),
	            ", ",
	            testimonial.where
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            null,
	            "View Store"
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "testimonials home-section" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Testimonials"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "wrapper" },
	          items
	        )
	      );
	    }
	  }, {
	    key: "getSearchComponent",
	    value: function getSearchComponent(refName, autofocus) {
	      return _react2.default.createElement(_BusinessSearchComponent2.default, {
	        type: "text",
	        autofocus: !!autofocus,
	        ref: refName,
	        id: refName,
	        onFocus: this.handleAddressFocus,
	        onSearchChange: this.handleSearchChange,
	        onBusinessSelected: this.handleBusinessSelected,
	        onQueryChanged: this.handleQueryChanged
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      var buttonClasses = [];
	      buttonClasses.push('view-products');
	      if (this.state.shake) buttonClasses.push('shake');
	
	      var buttonText = 'View Products';
	      var retailerToken = _Api2.default.cache.getCampaignRetailerToken();
	
	      if (retailerToken) {
	        buttonText = 'Request Access';
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "landing", id: "landing" },
	        _react2.default.createElement(
	          "div",
	          { className: 'more-below' + (this.state.scrollTop > 50 ? ' hidden' : '') },
	          _react2.default.createElement(
	            "div",
	            { className: "updown" },
	            _react2.default.createElement("img", { src: _chevronDown2.default, role: "presentation" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "header-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "h2",
	              { className: "logo" },
	              _react2.default.createElement("img", { src: _logo2.default, role: "presentation" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "headline" },
	              _react2.default.createElement(
	                "span",
	                { className: "unique-finds" },
	                "Unique Finds."
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "guaranteed-sales" },
	                "Guaranteed Sales."
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "businesssearch-wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: 'input-wrapper' + (this.state.loading ? ' hidden' : '') },
	                !retailerToken ? this.getSearchComponent('businessSearchInput', true) : null,
	                _react2.default.createElement(
	                  _Button2.default,
	                  { className: buttonClasses.join(' '), onClick: function onClick() {
	                      _this7.handleRawRetailer(0);
	                    } },
	                  buttonText
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: 'spin' + (this.state.loading ? '' : ' hidden') },
	                _react2.default.createElement("img", { role: "presentation", src: _spinner2.default })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "front-image" },
	          _react2.default.createElement("img", { src: _frontImage2.default, role: "presentation" })
	        ),
	        _react2.default.createElement(_Values2.default, { headline: "Buying for Your Store Just Became a Lot More Fun", values: values }),
	        this.getTestimonials(),
	        _react2.default.createElement(
	          "div",
	          { className: "how-it-works home-section" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "How It Works"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "section-header" },
	            "Make every item in your store a bestseller"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "entry entry-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "image-wrapper" },
	              _react2.default.createElement("img", { src: _Cactus_IndigoFair4.default, role: "presentation" })
	            ),
	            _react2.default.createElement(
	              "h4",
	              null,
	              "Order products for your store."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Find items you like, add them to your bag, create an account and check out."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "entry entry-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "image-wrapper" },
	              _react2.default.createElement("img", { src: _Cactus_IndigoFair6.default, role: "presentation" })
	            ),
	            _react2.default.createElement(
	              "h4",
	              null,
	              "See which items sell best."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Items typically ship to your store from vendors within 48 hours of your order."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "entry entry-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "image-wrapper" },
	              _react2.default.createElement("img", { src: _Cactus_IndigoFair2.default, role: "presentation" })
	            ),
	            _react2.default.createElement(
	              "h4",
	              null,
	              "Return whatever doesn\u2019t sell."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Get a free return shipping label to send back items that didn\u2019t sell after 90 days."
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "make-something home-section" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Ready to try out Indigo Fair?"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "businesssearch-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: 'input-wrapper' + (this.state.loading ? ' hidden' : '') },
	              !retailerToken ? this.getSearchComponent('businessSearchInput2') : null,
	              _react2.default.createElement(
	                _Button2.default,
	                { className: buttonClasses.join(' '), onClick: function onClick() {
	                    _this7.handleRawRetailer(1);
	                  } },
	                buttonText
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: 'spin' + (this.state.loading ? '' : ' hidden') },
	              _react2.default.createElement("img", { role: "presentation", src: _spinner2.default })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Footer2.default,
	          null,
	          "Make something amazing? ",
	          _react2.default.createElement(
	            "em",
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: "/apply" },
	              "Apply to sell it on Indigo Fair."
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Home;
	}(_react.Component);
	
	Home.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = Home;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _StaticHeader = __webpack_require__(51);
	
	var _StaticHeader2 = _interopRequireDefault(_StaticHeader);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyPolicy = function (_React$Component) {
	  _inherits(PrivacyPolicy, _React$Component);
	
	  function PrivacyPolicy() {
	    _classCallCheck(this, PrivacyPolicy);
	
	    return _possibleConstructorReturn(this, (PrivacyPolicy.__proto__ || Object.getPrototypeOf(PrivacyPolicy)).apply(this, arguments));
	  }
	
	  _createClass(PrivacyPolicy, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'privacy-policy', id: 'privacy-policy' },
	        _react2.default.createElement(_StaticHeader2.default, null),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Privacy Policy'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contents' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'We at Indigo Fair know you care about how your personal information is used and shared, and we take your privacy seriously. Please read the following to learn more about our Privacy Policy. By using or accessing the Services in any manner, you acknowledge that you accept the practices and policies outlined in this Privacy Policy, and you hereby consent that we will collect, use, and share your information in the following ways.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Remember that your use of Indigo Fair\u2019s Services is at all times subject to the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/tos' },
	              'Terms of Use'
	            ),
	            ', which incorporates this Privacy Policy. Any terms we use in this Policy without defining them have the definitions given to them in the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/tos' },
	              'Terms of Use'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What does this Privacy Policy cover?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This Privacy Policy covers our treatment of personally identifiable information ("Personal Information") that we gather when you are accessing or using our Services, but not to the practices of companies we don\u2019t own or control, or people that we don\u2019t manage. We gather various types of Personal Information from our users, as explained in more detail below, and we use this Personal Information internally in connection with our Services, including to personalize, provide, and improve our services, to allow you to set up a user account and profile, to contact you and allow other users to contact you, to fulfill your requests for certain products and services, and to analyze how you use the Services. In certain cases, we may also share some Personal Information with third parties, but only as described below.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'As noted in the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/tos' },
	              'Terms of Use'
	            ),
	            ', we do not knowingly collect or solicit personal information from anyone under the age of 13. If you are under 13, please do not attempt to register for the Services or send any personal information about yourself to us. If we learn that we have collected personal information from a child under age 13, we will delete that information as quickly as possible. If you believe that a child under 13 may have provided us personal information, please contact us at privacy@indigofair.com.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Will Indigo Fair ever change this Privacy Policy?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We\u2019re constantly trying to improve our Services, so we may need to change this Privacy Policy from time to time as well, but we will alert you to changes by placing a notice on the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/' },
	              'www.indigofair.com'
	            ),
	            ' website, by sending you an email, and/or by some other means. Please note that if you\u2019ve opted not to receive legal notice emails from us (or you haven\u2019t provided us with your email address), those legal notices will still govern your use of the Services, and you are still responsible for reading and understanding them. If you use the Services after any changes to the Privacy Policy have been posted, that means you agree to all of the changes.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What Information does Indigo Fair Collect?'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Information You Provide to Us:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We receive and store any information you knowingly provide to us. For example, through the registration process and/or through your account settings, we may collect Personal Information such as your physical address, name, company affiliation, email address, and phone number. Certain information may be required to register with us or to take advantage of some of our features.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We may communicate with you if you\u2019ve provided us the means to do so. For example, if you\u2019ve given us your email address, we may send you promotional email offers on behalf of other businesses, or email you about your use of the Services. Also, we may receive a confirmation when you open an email from us. This confirmation helps us make our communications with you more interesting and improve our services. If you do not want to receive communications from us, please indicate your preference by emailing privacy@indigofair.com.'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Information Collected Automatically'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Whenever you interact with our Services, we automatically receive and record information on our server logs from your browser or device, which may include your IP address, geolocation data, device identification, \u201Ccookie\u201D information, the type of browser and/or device you\u2019re using to access our Services, and the page or feature you requested. \u201CCookies\u201D are identifiers we transfer to your browser or device that allow us to recognize your browser or device and tell us how and when pages and features in our Services are visited and by how many people. You may be able to change the preferences on your browser or device to prevent or limit your device\u2019s acceptance of cookies, but this may prevent you from taking advantage of some of our features.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you click on a link to a third party website or service, a third party may also transmit cookies to you. Again, this Privacy Policy does not cover the use of cookies by any third parties, and we aren\u2019t responsible for their privacy policies and practices. Please be aware that cookies placed by third parties may continue to track your activities online even after you have left our Services, and those third parties may not honor \u201CDo Not Track\u201D requests you have set using your browser or device.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We may use this data to customize content for you that we think you might like, based on your usage patterns. We may also use it to improve the Services \u2013 for example, this data can tell us how often users use a particular feature of the Services, and we can use that knowledge to make the Services interesting to as many users as possible.'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Information Collected From Other Websites and Do Not Track Policy'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Through cookies we place on your browser or device, we may collect information about your online activity after you leave our Services. Just like any other usage information we collect, this information allows us to improve the Services and customize your online experience, and otherwise as described in this Privacy Policy. Your browser may offer you a \u201CDo Not Track\u201D option, which allows you to signal to operators of websites and web applications and services (including behavioral advertising services) that you do not wish such operators to track certain of your online activities over time and across different websites.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Will Indigo Fair Share Any of the Personal Information it Receives?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We do not rent or sell your Personal Information in personally identifiable form to anyone, except as expressly provided below. We may share your Personal Information with third parties as described in this section:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Information that\u2019s been de-identified.'
	            ),
	            ' We may de-identify your Personal Information so that you are not identified as an individual, and provide that information to our partners. We may also provide aggregate usage information to our partners (or allow partners to collect that information from you), who may use such information to understand how often and in what ways people use our Services, so that they, too, can provide you with an optimal online experience. However, we never disclose aggregate usage or de-identified information to a partner (or allow a partner to collect such information) in a manner that would identify you as an individual person.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Advertisers:'
	            ),
	            ' We allow advertisers and/or merchant partners (\u201CAdvertisers\u201D) to choose the demographic information of users who will see their advertisements and/or promotional offers and you agree that we may provide any of the information we have collected from you in non-personally identifiable form to an Advertiser, in order for that Advertiser to select the appropriate audience for those advertisements and/or offers. For example, we might use the fact you are located in San Francisco to show you ads or offers for San Francisco businesses, but we will not tell such businesses who you are.  Or, we might allow Advertisers to display their ads to users with similar usage patterns to yours, but we will not disclose usage information to Advertisers except in aggregate form, and not in a manner that would identify you personally.  Note that if an advertiser asks us to show an ad to a certain audience or audience segment and you respond to that ad, the advertiser may conclude that you fit the description of the audience they were trying to reach.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We may deliver a file to you through the Services (known as a \u201Cweb beacon\u201D) from an ad network.  Web beacons allow ad networks to provide anonymized, aggregated auditing, research and reporting for us and for advertisers.  Web beacons also enable ad networks to serve targeted advertisements to you when you visit other websites.  Because your web browser must request these advertisements and web beacons from the ad network\u2019s servers, these companies can view, edit, or set their own cookies, just as if you had requested a web page from their site.  You may be able to opt-out of web beacon tracking conducted by third parties through our Services by adjusting the Do Not Track settings on your browser; please note that we don\u2019t control whether or how these third parties comply with Do Not Track requests.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Affiliated Businesses:'
	            ),
	            ' In certain situations, businesses or third party websites we\u2019re affiliated with may sell or provide products or services to you through or in connection with the Services (either alone or jointly with us). You can recognize when an affiliated business is associated with such a transaction or service, and we will share your Personal Information with that affiliated business only to the extent that it is related to such transaction or service. We have no control over the policies and practices of third party websites or businesses as to privacy or anything else, so if you choose to take part in any transaction or service relating to an affiliated website or business, please review all such business\u2019 or websites\u2019 policies.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Agents:'
	            ),
	            ' We employ other companies and people to perform tasks on our behalf and need to share your information with them to provide products or services to you; for example, we may use a payment processing company to receive and process any credit card transactions for us. Unless we tell you differently (or unless stated otherwise in a third party privacy policy referred to below), our agents do not have any right to use the Personal Information we share with them beyond what is necessary to assist us.  We currently use the following third party services, and by using our Services, you agree to be bound by the applicable privacy policies for such third party services:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Plaid Technologies, Inc. (\u201CPlaid\u201D); you acknowledge and agree that information you provide for processing by Plaid will be treated in accordance with Plaid\u2019s privacy policy https://plaid.com/legal/#privacy-policy. You are hereby put on notice of, and agree to, such privacy policy. You expressly grant Plaid the right, power and authority to (acting on behalf of you) access and transmit the End User Data as reasonably necessary for Plaid to provide the Service to you (for purposes of this sentence only, capitalized terms have the meaning given them in Plaid\u2019s Terms of Use https://plaid.com/legal/#terms-of-use).'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Stripe, Inc.; https://stripe.com/us/privacy'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'User Profiles and Submissions:'
	            ),
	            ' Certain user profile information, including your name, location, and any video or image content that such user has uploaded to the Services, may be displayed to other users to facilitate user interaction within the Services or address your request for our services. Your account privacy settings may allow you to limit the other users who can see the Personal Information in your user profile and/or what information in your user profile is visible to others. Please remember that any content you upload to your public user profile, along with any Personal Information or content that you voluntarily disclose online in a manner other users can view (on discussion boards, in messages and chat areas, etc.) becomes publicly available, and can be collected and used by anyone. Your user name may also be displayed to other users if and when you send messages or comments or upload images or videos through the Services and other users can contact you through messages and comments.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Business Transfers:'
	            ),
	            ' We may choose to buy or sell assets, and may share and/or transfer customer information in connection with the evaluation of and entry into such transactions. Also, if we (or our assets) are acquired, or if we go out of business, enter bankruptcy, or go through some other change of control, Personal Information could be one of the assets transferred to or acquired by a third party.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Protection of Company and Others:'
	            ),
	            ' We reserve the right to access, read, preserve, and disclose any information that we reasonably believe is necessary to comply with law or court order; enforce or apply our ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/tos' },
	              'Terms of Use'
	            ),
	            ' and other agreements; or protect the rights, property, or safety of Company, our employees, our users, or others.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Is Personal Information about me secure?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You must prevent unauthorized access to your account and Personal Information by selecting and protecting your password appropriately and limiting access to your computer or device and browser by signing off after you have finished accessing your account.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We endeavor to protect the privacy of your account and other Personal Information we hold in our records, but unfortunately, we cannot guarantee complete security. Unauthorized entry or use, hardware or software failure, and other factors, may compromise the security of user information at any time.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What Personal Information can I access?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Through your account settings, you may access, and, in some cases, edit or delete the following information you\u2019ve provided to us:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'name'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'email address'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'location'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'payment information'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The information you can view, update, and delete may change as the Services change. If you have any questions about viewing or updating information we have on file about you, please contact us at privacy@indigofair.com.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Under California Civil Code Sections 1798.83-1798.84, California residents are entitled to contact us to prevent disclosure of Personal Information to third parties for such third parties\u2019 direct marketing purposes; in order to submit such a request, please contact us at privacy@indigofair.com.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What choices do I have?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You can always opt not to disclose information to us, but keep in mind some information may be needed to register with us or to take advantage of some of our features.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You may be able to add, update, or delete information as explained above. When you update information, however, we may maintain a copy of the unrevised information in our records. Some information may remain in our records after your deletion of such information from your account. We may use any aggregated data derived from or incorporating your Personal Information after you update or delete it, but not in a manner that would identify you personally.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What if I have questions about this policy?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you have any questions or concerns regarding our privacy policies, please send us a detailed message to privacy@indigofair.com, and we will try to resolve your concerns.'
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return PrivacyPolicy;
	}(_react2.default.Component);
	
	exports.default = PrivacyPolicy;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _StaticHeader = __webpack_require__(51);
	
	var _StaticHeader2 = _interopRequireDefault(_StaticHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PurchaseTerms = function (_React$Component) {
	  _inherits(PurchaseTerms, _React$Component);
	
	  function PurchaseTerms() {
	    _classCallCheck(this, PurchaseTerms);
	
	    return _possibleConstructorReturn(this, (PurchaseTerms.__proto__ || Object.getPrototypeOf(PurchaseTerms)).apply(this, arguments));
	  }
	
	  _createClass(PurchaseTerms, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'purchase-terms', id: 'purchase-terms' },
	        _react2.default.createElement(_StaticHeader2.default, null),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'PURCHASE ORDER TERMS AND CONDITIONS'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contents' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Your use of Indigo Fair\u2019s Services is at all times subject to the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/tos' },
	              'Terms of Use'
	            ),
	            ', which incorporates these Purchase Order Terms and Conditions. Any terms we use in these Purchase Order Terms and Conditions without defining them have the definitions given to them in the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/tos' },
	              'Terms of Use'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Sale and Purchase.'
	              ),
	              ' All products purchased hereunder (\u201CProducts\u201D) from Indigo Fair Inc. (\u201CSupplier\u201D) are sold at the relevant prices specified on the Indigo Fair Services (\u201CPrices\u201D), and are subject to the unqualified acceptance of these terms and conditions by buyer (\u201CBuyer\u201D).  There shall be no force or effect to any different or additional terms of any purchase order, confirmation or similar form even if signed by the parties after the date hereof.  Provision of any Product to or on behalf of Buyer is conditioned on, and Buyer\u2019s order or taking delivery of or otherwise accepting, using, or distributing any Product shall constitute, Buyer\u2019s assent to these PO Terms and Conditions (\u201CPO Terms\u201D) to the exclusion of all other terms.  If these PO Terms are considered an offer, acceptance is expressly limited to such PO Terms. Prices contained in a quotation shall be valid for thirty (30) days following the date of the quotation.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Price, Payment and Delivery Terms.'
	              ),
	              ' All payments due hereunder to Supplier shall be paid to Supplier in US dollars not later than thirty\xA0(30) days following the date of the applicable invoice. Late payments shall bear interest at the rate of one and one-half percent (1.5%) per month or, if lower, the maximum rate allowed by law. All Products are delivered F.O.B. Supplier\u2019s plant or other place of shipment. Supplier will use reasonable commercial efforts to ship Products on the agreed-upon ship dates, consistent with its then-applicable lead time requirements. In addition to the price, Buyer will pay all charges, including without limitation transportation charges, insurance premiums, and shall be responsible for all taxes (except Supplier\u2019s U.S. income taxes), duties, costs of compliance with export and import controls and regulations, and other governmental assessments.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Warranties.'
	              ),
	              ' Supplier warrants only to Buyer that the Products, when shipped to Buyer by Supplier, will conform in all material respects to the applicable specifications sheets shipped with the Products. Such warranty does not apply to units that have been damaged, mishandled, mistreated;  used or maintained or stored other than in conformity with such specifications and Supplier\'s instructions; or modified, altered or repaired in any manner by any party other than Supplier. EXCEPT FOR BODILY INJURY, BUYER\'S SOLE AND EXCLUSIVE REMEDY FOR ANY BREACH OF THE FOREGOING WARRANTY SHALL BE THE REPLACEMENT OF OR (AT SUPPLIER\'S OPTION OR IF REPLACEMENT IS IMPRACTICAL) REFUND FOR RETURNED NON-CONFORMING UNITS OF PRODUCT FOR WHICH FULL DOCUMENTATION AND PROOF OF NON-CONFORMITY IS PROVIDED TO SUPPLIER WITHIN NINETY DAYS AFTER THE ORIGINAL NON-CONFORMING UNITS ARE SHIPPED BY SUPPLIER. EXCEPT FOR THE FOREGOING WARRANTIES, SUPPLIER DOES NOT MAKE (AND HAS NOT AUTHORIZED ANYONE TO MAKE) ANY EXPRESS OR IMPLIED WARRANTY, INCLUDING, WITHOUT LIMITATION, ANY WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OR NONINFRINGEMENT.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Shipping Discrepancies.'
	              ),
	              ' Any shipment discrepancy must be reported to Supplier within thirty (30) days of receipt of the Product(s).'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Software.'
	              ),
	              ' Any software incorporated into or provided for use in or with a Product (whether initially, as part of maintenance or support or otherwise) is not sold, but rather is licensed solely for Buyer\u2019s internal use in or with that Product strictly in accordance with the documentation and any other use restrictions applicable for that Product. Such license is non-exclusive, non-sublicensable and does not include the right to (and Buyer will not) modify, reverse engineer (except to the extent applicable law prohibits reverse engineering restrictions), incorporate or use in any other works, create derivatives of, or copy any portion of such software, or to use the software or Product for the benefit of any third party.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Limited Liability.'
	              ),
	              ' EXCEPT FOR BODILY INJURY, SUPPLIER WILL NOT BE LIABLE WITH RESPECT TO ANY SUBJECT MATTER OF THIS AGREEMENT UNDER ANY CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHER LEGAL OR EQUITABLE THEORY FOR (I)\xA0ANY AMOUNTS IN EXCESS IN THE AGGREGATE OF THE AMOUNTS PAID TO SUPPLIER HEREUNDER DURING THE TWELVE MONTH PERIOD PRIOR TO THE DATE THE CAUSE OF ACTION AROSE OR (II)\xA0ANY INCIDENTAL OR CONSEQUENTIAL DAMAGES, OR (III)\xA0COST OF PROCUREMENT OF SUBSTITUTE GOODS, TECHNOLOGY OR SERVICES. SUPPLIER SHALL HAVE NO LIABILITY FOR ANY FAILURE OR DELAY DUE TO MATTERS BEYOND ITS REASONABLE CONTROL OR FOR ANY ALLOCATION OF PRODUCTS BETWEEN ITS CUSTOMERS IN THE EVENT OF A SHORTAGE.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'FCPA and Export Control.'
	              ),
	              ' Buyer shall comply with the U.S. Foreign Corrupt Practices Act and all export laws and restrictions and regulations of the Department of Commerce, the United States Department of Treasury Office of Foreign Assets Control (\u201COFAC\u201D), or other United States or foreign agency or authority, and not export, or allow the export or re-export of any Product in violation of any such restrictions, laws or regulations. Buyer shall obtain and bear all expenses relating to any necessary licenses and/or exemptions with respect to the export from the U.S. of all Products to any location and shall demonstrate to Supplier compliance with all applicable laws and regulations prior to delivery thereof by Supplier.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'General.'
	              ),
	              ' Supplier may assign this Agreement in whole or in part. The failure of either party to enforce its rights under this Agreement at any time for any period shall not be construed as a waiver of such rights. This Agreement supersedes all proposals, oral or written, all negotiations, conversations, or discussions between or among parties relating to the subject matter of this Agreement and all past dealing or industry custom. No changes or modifications or waivers are to be made to this Agreement unless evidenced in a writing (other than a purchase order confirmation or similar form) that is conspicuously identified and labeled as an amendment and that is signed for and on behalf of both parties. In the event that any provision of this Agreement shall be determined to be illegal or unenforceable, that provision will be limited or eliminated to the minimum extent necessary so that this Agreement shall otherwise remain in full force and effect and enforceable. This Agreement shall be governed by and construed in accordance with the laws of the State of California (without regard to the conflicts of laws provisions thereof or the UN Convention on the International Sale of Goods). In any action or proceeding to enforce rights under this Agreement, the prevailing party will be entitled to recover costs and attorneys\u2019 fees.'
	            )
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return PurchaseTerms;
	}(_react2.default.Component);
	
	exports.default = PurchaseTerms;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _logo = __webpack_require__(53);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _teamMax = __webpack_require__(449);
	
	var _teamMax2 = _interopRequireDefault(_teamMax);
	
	var _teamDaniele = __webpack_require__(447);
	
	var _teamDaniele2 = _interopRequireDefault(_teamDaniele);
	
	var _teamMarcelo = __webpack_require__(448);
	
	var _teamMarcelo2 = _interopRequireDefault(_teamMarcelo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var profiles = [{
	  name: 'Max Rhodes',
	  title: 'Chief Executive Officer & Founder',
	  description: "Prior to starting Indigo Fair, Max was the first product manager for " + "several key initiatives at Square, including Square Capital ($1Bn+ deployed) and Square " + "Cash (Square's only Top 50-ranked app in the iOS App Store). " + "He first came up with the idea for Indigo Fair while introducing the Blunt Umbrella to " + "the United States, helping to place Blunt into over 100 local retailers.",
	  photo: _teamMax2.default,
	  layout: 'photo-right'
	}, {
	  name: 'Daniele Perito',
	  title: 'Chief Information Officer & Founder',
	  description: "Prior to starting Indigo Fair, he led Risk and Security for Square Cash, " + "where he designed and implemented the anti-abuse and anti-fraud systems that have made " + "Cash possible. He holds his PhD in Computer Science with a focus on security and machine learning.",
	  photo: _teamDaniele2.default,
	  layout: 'photo-left'
	}, {
	  name: 'Marcelo Cortes',
	  title: 'Chief Technology Officer & Founder',
	  description: "He has over 18 years of software engineering experience. Prior to starting Indigo " + "Fair, Marcelo was an engineering lead for Square Cash since the product started early in 2013. " + "Before that, he was an engineering lead on Google+ for Android and launched the first mobile " + "version of Google Hangouts.",
	  photo: _teamMarcelo2.default,
	  layout: 'photo-right'
	}];
	
	var Team = function (_React$Component) {
	  _inherits(Team, _React$Component);
	
	  function Team() {
	    _classCallCheck(this, Team);
	
	    return _possibleConstructorReturn(this, (Team.__proto__ || Object.getPrototypeOf(Team)).apply(this, arguments));
	  }
	
	  _createClass(Team, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var profileContents = profiles.map(function (profile, idx) {
	        var key = 'profile-' + idx;
	        var imageWrapper = _react2.default.createElement(
	          'div',
	          { className: 'image-wrapper' },
	          _react2.default.createElement('img', { role: 'presentation',
	            src: profile.photo })
	        );
	        return _react2.default.createElement(
	          'div',
	          { key: key, className: 'entry' },
	          profile.layout === 'photo-left' ? imageWrapper : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'profile-contents' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              profile.name
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              profile.title
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              profile.description
	            )
	          ),
	          profile.layout === 'photo-right' ? imageWrapper : null
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'team' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'logo-wrapper' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/' },
	                _react2.default.createElement('img', { src: _logo2.default, role: 'presentation' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'preamble' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Our team combines over 15 years of experience building software products for small business customers.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'profiles' },
	          profileContents
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Team;
	}(_react2.default.Component);
	
	exports.default = Team;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _StaticHeader = __webpack_require__(51);
	
	var _StaticHeader2 = _interopRequireDefault(_StaticHeader);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TermsOfUse = function (_React$Component) {
	  _inherits(TermsOfUse, _React$Component);
	
	  function TermsOfUse() {
	    _classCallCheck(this, TermsOfUse);
	
	    return _possibleConstructorReturn(this, (TermsOfUse.__proto__ || Object.getPrototypeOf(TermsOfUse)).apply(this, arguments));
	  }
	
	  _createClass(TermsOfUse, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'terms-of-use', id: 'terms-of-use' },
	        _react2.default.createElement(_StaticHeader2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'preamble' },
	          'PLEASE NOTE THAT YOUR USE OF AND ACCESS TO OUR SERVICES (DEFINED BELOW) ARE SUBJECT TO THE FOLLOWING TERMS; IF YOU DO NOT AGREE TO ALL OF THE FOLLOWING, YOU MAY NOT USE OR ACCESS THE SERVICES IN ANY MANNER.'
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Terms of Use'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contents' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Welcome to Indigo Fair. Please read on to learn the rules and restrictions that govern your use of our website(s), products, services and applications (the \u201CServices\u201D). If you have any questions, comments, or concerns regarding these terms or the Services, please contact us at terms@indigofair.com.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'These Terms of Use (the \u201CTerms\u201D) are a binding contract between you and Indigo Fair Inc. (\u201CIndigo Fair\u201D, \u201Cwe\u201D and \u201Cus\u201D). You must agree to and accept all of the Terms, or you don\u2019t have the right to use the Services. Your using the Services in any way means that you agree to all of these Terms, and these Terms will remain in effect while you use the Services. These Terms include the provisions in this document, as well as those in the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/privacy' },
	              'Privacy Policy'
	            ),
	            ', ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/copyright' },
	              'Copyright Dispute Policy'
	            ),
	            ', and, with respect to any purchase you make using the Services, the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/purchaseterms' },
	              'Purchase Order Terms and Conditions'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Will these Terms ever change?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We are constantly trying to improve our Services, so these Terms may need to change along with the Services. We reserve the right to change the Terms at any time, but if we do, we will bring it to your attention by placing a notice on the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/' },
	              'www.indigofair.com'
	            ),
	            ' website, by sending you an email, and/or by some other means.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you don\u2019t agree with the new Terms, you are free to reject them; unfortunately, that means you will no longer be able to use the Services. If you use the Services in any way after a change to the Terms is effective, that means you agree to all of the changes.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Except for changes by us as described here, no other amendment or modification of these Terms will be effective unless in writing and signed by both you and us.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What about my privacy?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Indigo Fair takes the privacy of its users very seriously. Please review Indigo Fair\u2019s current ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/privacy' },
	              'Privacy Policy'
	            ),
	            ' to learn more.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The Children\u2019s Online Privacy Protection Act (\u201CCOPPA\u201D) requires that online service providers obtain parental consent before they knowingly collect personally identifiable information online from children who are under 13. We do not knowingly collect or solicit personally identifiable information from children under 13; if you are a child under 13, please do not attempt to register for the Services or send any personal information about yourself to us. If we learn we have collected personal information from a child under 13, we will delete that information as quickly as possible. If you believe that a child under 13 may have provided us personal information, please contact us at privacy@indigofair.com.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What are the basics of using Indigo Fair\u2019s Services?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You may be required to sign up for an account, and select a password and user name (\u201CIndigo Fair User ID\u201D). You promise to provide us with accurate, complete, and updated registration information about yourself. You may not select as your Indigo Fair User ID a name that you don\u2019t have the right to use, or another person\u2019s name with the intent to impersonate that person. You may not transfer your account to anyone else without our prior written permission.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You represent and warrant that you are of legal age to form a binding contract (or if not, you\u2019ve received your parent\u2019s or guardian\u2019s permission to use the Services and gotten your parent or guardian to agree to these Terms on your behalf). If you\u2019re agreeing to these Terms on behalf of an organization or entity, you represent and warrant that you are authorized to agree to these Terms on that organization or entity\u2019s behalf and bind them to these Terms (in which case, the references to \u201Cyou\u201D and \u201Cyour\u201D in these Terms, except for in this sentence, refer to that organization or entity).'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You will only use the Services for your own internal, personal use, and not on behalf of or for the benefit of any third party, and only in a manner that complies with all laws that apply to you. If your use of the Services is prohibited by applicable laws, then you aren\u2019t authorized to use the Services. We can\u2019t and won\u2019t be responsible for your using the Services in a way that breaks the law.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You will not share your account or password with anyone, and you must protect the security of your account and your password. You\u2019re responsible for any activity associated with your account.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Your use of the Services is subject to the following additional restrictions:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You represent, warrant, and agree that you will not contribute any Content or User Submission (each of those terms is defined below) or otherwise use the Services or interact with the Services in a manner that:'
	          ),
	          _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Infringes or violates the intellectual property rights or any other rights of anyone else (including Indigo Fair);'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Violates any law or regulation, including any applicable export control laws;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Is harmful, fraudulent, deceptive, threatening, harassing, defamatory, obscene, or otherwise objectionable;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Jeopardizes the security of your Indigo Fair account or anyone else\u2019s (such as allowing someone else to log in to the Services as you);'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Attempts, in any manner, to obtain the password, account, or other security information from any other user;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Violates the security of any computer network, or cracks any passwords or security encryption codes;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Runs Maillist, Listserv, any form of auto-responder or \u201Cspam\u201D on the Services, or any processes that run or are activated while you are not logged into the Services, or that otherwise interfere with the proper working of the Services (including by placing an unreasonable load on the Services\u2019 infrastructure);'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              '\u201CCrawls,\u201D \u201Cscrapes,\u201D or \u201Cspiders\u201D any page, data, or portion of or relating to the Services or Content (through use of manual or automated means);'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Copies or stores any significant portion of the Content;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Decompiles, reverse engineers, or otherwise attempts to obtain the source code or underlying ideas or information of or relating to the Services.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Confidentiality:'
	            ),
	            ' In addition, you understand that Indigo Fair has disclosed or may disclose information relating to Indigo Fair\u2019s technology or business (including pricing accessible only to authorized users) (hereinafter referred to as \u201CProprietary Information\u201D). You agree: (i) not to divulge to any third person any such Proprietary Information, (i) to give access to such Proprietary information solely to those employees with a need to have access thereto for purposes of these Terms, and (iii) to take the same security precautions to protect against disclosure or unauthorized use of such Proprietary Information that you take with your own proprietary information, but in no event less than reasonable precautions to protect such Proprietary Information. The foregoing will not apply with respect to any information that you can document (a) is or becomes generally available to the public other than through your own wrongful act, or (b) was in your possession or known by you prior to receipt from us, or (c) was rightfully disclosed to you without restriction by a third party, or (d) was independently developed without use of any Proprietary Information. Nothing in this Agreement will prevent you from disclosing the Proprietary Information pursuant to any judicial or governmental order, provided that you give us reasonable prior notice of such disclosure to contest such order.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A violation of any of the foregoing is grounds for termination of your right to use or access the Services.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What are my rights in Indigo Fair\u2019s Services?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The materials displayed or performed or available on or through the Services, including, but not limited to, text, graphics, data, articles, photos, images, illustrations, User Submissions, and so forth (all of the foregoing, the \u201CContent\u201D) are protected by copyright and/or other intellectual property laws. You promise to abide by all copyright notices, trademark rules, information, and restrictions contained in any Content you access through the Services, and you won\u2019t use, copy, reproduce, modify, translate, publish, broadcast, transmit, distribute, perform, upload, display, license, sell or otherwise exploit for any purpose any Content not owned by you, (i) without the prior consent of the owner of that Content or (ii) in a way that violates someone else\u2019s (including Indigo Fair\u2019s) rights.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You understand that Indigo Fair owns the Services. You won\u2019t modify, publish, transmit, participate in the transfer or sale of, reproduce (except as expressly provided in this Section), create derivative works based on, or otherwise exploit any of the Services.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The Services may allow you to copy or download certain Content; please remember that just because this functionality exists, doesn\u2019t mean that all the restrictions above don\u2019t apply \u2013 they do!'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Do I have to grant any licenses to Indigo Fair or to other users?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Anything you post, upload, share, store, or otherwise provide through the Services is your \u201CUser Submission.\u201D Some User Submissions may be viewable by other users. In order to display your User Submissions on the Services, and to allow other users to enjoy them (where applicable), you grant us certain rights in those User Submissions. Please note that all of the following licenses are subject to our ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/privacy' },
	              'Privacy Policy'
	            ),
	            ' to the extent they relate to User Submissions that are also your personally-identifiable information.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'For all User Submissions, you hereby grant Indigo Fair a license to translate, modify (for technical purposes, for example making sure your content is viewable on an iPhone as well as a computer) and reproduce and otherwise act with respect to such User Submissions, in each case to enable us to operate the Services, as described in more detail below. This is a license only \u2013 your ownership in User Submissions is not affected.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you store a User Submission in your own personal Indigo Fair account or input a temporary User Submission, in each case in a manner that is not viewable by any other user except you (a \u201CPersonal User Submission\u201D), you grant Indigo Fair the license above, as well as a license to display, perform, and distribute your Personal User Submission for the sole purpose of making that Personal User Submission accessible to you and providing the Services necessary to do so.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you share a User Submission only in a manner that only certain specified users can view (for example, a private message to one or more other users) (a \u201CLimited Audience User Submission\u201D), then you grant Indigo Fair the licenses above, as well as a license to display, perform, and distribute your Limited Audience User Submission for the sole purpose of making that Limited Audience User Submission accessible to such other specified users, and providing the Services necessary to do so. Also, you grant such other specified users a license to access that Limited Audience User Submission, and to use and exercise all rights in it, as permitted by the functionality of the Services.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you share a User Submission publicly on the Services and/or in a manner that more than just you or certain specified users can view, or if you provide us (in a direct email or otherwise) with any feedback, suggestions, improvements, enhancements, and/or feature requests relating to the Services (each of the foregoing, a \u201CPublic User Submission\u201D), then you grant Indigo Fair the licenses above, as well as a license to display, perform, and distribute your Public User Submission for the purpose of making that Public User Submission accessible to all Indigo Fair users and providing the Services necessary to do so, as well as all other rights necessary to use and exercise all rights in that Public User Submission in connection with the Services and/or otherwise in connection with Indigo Fair\u2019s business for any purpose. Also, you grant all other users of the Services a license to access that Public User Submission, and to use and exercise all rights in it, as permitted by the functionality of the Services.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You agree that the licenses you grant are royalty-free, perpetual, sublicensable, irrevocable, and worldwide, provided that when you delete your Indigo Fair account, we will stop displaying your User Submissions (other than Public User Submissions, which may remain fully available) to other users (if applicable), but you understand and agree that it may not be possible to completely delete that content from Indigo Fair\u2019s records, and that your User Submissions may remain viewable elsewhere to the extent that they were copied or stored by other users.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Finally, you understand and agree that Indigo Fair, in performing the required technical steps to provide the Services to our users (including you), may need to make changes to your User Submissions to conform and adapt those User Submissions to the technical requirements of connection networks, devices, services, or media, and the foregoing licenses include the rights to do so.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What if I see something on the Services that infringes my copyright?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You may have heard of the Digital Millennium Copyright Act (the \u201CDMCA\u201D), as it relates to online service providers, like Indigo Fair, being asked to remove material that allegedly violates someone\u2019s copyright.  We respect others\u2019 intellectual property rights, and we reserve the right to delete or disable Content alleged to be infringing, and to terminate the accounts of repeat alleged infringers; to review our complete Copyright Dispute Policy and learn how to report potentially infringing content, ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/copyright' },
	              'click here'
	            ),
	            '. To learn more about the DMCA, click here.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Who is responsible for what I see and do on the Services?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Any information or content publicly posted or privately transmitted through the Services is the sole responsibility of the person from whom such content originated, and you access all such information and content at your own risk, and we aren\u2019t liable for any errors or omissions in that information or content or for any damages or loss you might suffer in connection with it. We cannot control and have no duty to take any action regarding how you may interpret and use the Content or what actions you may take as a result of having been exposed to the Content, and you hereby release us from all liability for you having acquired or not acquired Content through the Services. We can\u2019t guarantee the identity of any users with whom you interact in using the Services and are not responsible for which users gain access to the Services.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You are responsible for all Content you contribute, in any manner, to the Services, and you represent and warrant you have all rights necessary to do so, in the manner in which you contribute it. You will keep all your registration information accurate and current. You are responsible for all your activity in connection with the Services.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The Services may contain links or connections to third party websites or services that are not owned or controlled by Indigo Fair. When you access third party websites or use third party services, you accept that there are risks in doing so, and that Indigo Fair is not responsible for such risks. We encourage you to be aware when you leave the Services and to read the terms and conditions and privacy policy of each third party website or service that you visit or utilize. We currently use the following third party services, and by using our Services, you agree to be bound by the applicable terms for such third party services:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Plaid Technologies, Inc. (\u201CPlaid\u201D); you expressly grant Plaid the right, power and authority to (acting on behalf of you) access and transmit the End User Data as reasonably necessary for Plaid to provide the Service to you (for purposes of this sentence only, capitalized terms have the meaning given them in Plaid\u2019s Terms of Use https://plaid.com/legal/#terms-of-use).'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Stripe, Inc.; https://stripe.com/us/legal'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Indigo Fair has no control over, and assumes no responsibility for, the content, accuracy, privacy policies, or practices of or opinions expressed in any third party websites or by any third party that you interact with through the Services. In addition, Indigo Fair will not and cannot monitor, verify, censor or edit the content of any third party site or service. By using the Services, you release and hold us harmless from any and all liability arising from your use of any third party website or service.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Your interactions with organizations and/or individuals found on or through the Services, including payment and delivery of goods or services, and any other terms, conditions, warranties or representations associated with such dealings, are solely between you and such organizations and/or individuals. You should make whatever investigation you feel necessary or appropriate before proceeding with any online or offline transaction with any of these third parties. You agree that Indigo Fair shall not be responsible or liable for any loss or damage of any sort incurred as the result of any such dealings.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If there is a dispute between participants on this site, or between users and any third party, you agree that Indigo Fair is under no obligation to become involved. In the event that you have a dispute with one or more other users, you release Indigo Fair, its officers, employees, agents, and successors from claims, demands, and damages of every kind or nature, known or unknown, suspected or unsuspected, disclosed or undisclosed, arising out of or in any way related to such disputes and/or our Services. If you are a California resident, you shall and hereby do waive California Civil Code Section 1542, which says: "A general release does not extend to claims which the creditor does not know or suspect to exist in his or her favor at the time of executing the release, which, if known by him or her must have materially affected his or her settlement with the debtor."'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Will Indigo Fair ever change the Services?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We\u2019re always trying to improve the Services, so they may change over time. We may suspend or discontinue any part of the Services, or we may introduce new features or impose limits on certain features or restrict access to parts or all of the Services. We\u2019ll try to give you notice when we make a material change to the Services that would adversely affect you, but this isn\u2019t always practical. Similarly, we reserve the right to remove any Content from the Services at any time, for any reason (including, but not limited to, if someone alleges you contributed that Content in violation of these Terms), in our sole discretion, and without notice.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Do Indigo Fair\u2019s Services cost anything, and what terms apply to purchases?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We reserve the right to charge for certain or all Services. We will notify you before any Services you are using begin carrying a fee, and if you wish to continue using such Services, you must pay all applicable fees for such Services.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'With respect to any purchase you make using the Services, the ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/purchaseterms' },
	              'Purchase Order Terms and Conditions'
	            ),
	            ' apply.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Where applicable, you shall pay all fees described by the Services in connection with such for-fee products/services purchased by you in the manner specified on or selected through the Services (or as otherwise agreed upon in writing by you and us). Unless otherwise specified, the following terms apply to all purchases.'
	          ),
	          _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'We may use a third-party payment processor (the \u201CPayment Processor\u201D) to bill you through a payment account, such as your bank account or debit or credit card, linked to your account on the Services (your \u201CBilling Account\u201D). The processing of payments will be subject to the terms, conditions and privacy policies of the Payment Processor in addition to these Terms. We are not responsible for error by the Payment Processor. By choosing to use for-fee Services or purchase products, you agree to pay us, through the Payment Processor, all charges at the prices then in effect for any use of such Services or purchase of such products in accordance with the applicable payment terms and you authorize us, through the Payment Processor, to charge your chosen payment provider (your \u201CPayment Method\u201D). You agree to make payment using that selected Payment Method. We reserve the right to correct any errors or mistakes that it makes even if it has already requested or received payment.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Payment Method.'
	              ),
	              ' The terms of your payment will be based on your Payment Method and may be determined by agreements between you and the financial institution, credit card issuer or other provider of your chosen Payment Method. If we, through the Payment Processor, do not receive payment from you, you agree to pay all amounts due upon demand.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Recurring Billing.'
	              ),
	              ' Some of the for-fee Services and product purchases may consist of an initial period, for which there is a one-time charge, followed by recurring period charges as agreed to by you. By choosing a recurring payment plan, you acknowledge that such Services have an initial and recurring payment feature and you accept responsibility for all recurring charges prior to cancellation. WE MAY SUBMIT PERIODIC CHARGES (E.G., MONTHLY) WITHOUT FURTHER AUTHORIZATION FROM YOU, UNTIL YOU PROVIDE PRIOR NOTICE (RECEIPT OF WHICH IS CONFIRMED BY US) THAT YOU HAVE TERMINATED THIS AUTHORIZATION OR WISH TO CHANGE YOUR PAYMENT METHOD. SUCH NOTICE WILL NOT AFFECT CHARGES SUBMITTED BEFORE WE REASONABLY COULD ACT. TO TERMINATE YOUR AUTHORIZATION OR CHANGE YOUR PAYMENT METHOD, GO TO ',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/account' },
	                'ACCOUNT PAGE'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Current Information Required.'
	              ),
	              ' YOU MUST PROVIDE CURRENT, COMPLETE AND ACCURATE INFORMATION FOR YOUR BILLING ACCOUNT. YOU MUST PROMPTLY UPDATE ALL INFORMATION TO KEEP YOUR BILLING ACCOUNT CURRENT, COMPLETE AND ACCURATE (SUCH AS A CHANGE IN BILLING ADDRESS, CREDIT CARD NUMBER, OR CREDIT CARD EXPIRATION DATE), AND YOU MUST PROMPTLY NOTIFY US OR OUR PAYMENT PROCESSOR IF YOUR PAYMENT METHOD IS CANCELED (E.G., FOR LOSS OR THEFT) OR IF YOU BECOME AWARE OF A POTENTIAL BREACH OF SECURITY, SUCH AS THE UNAUTHORIZED DISCLOSURE OR USE OF YOUR USER NAME OR PASSWORD. CHANGES TO SUCH INFORMATION CAN BE MADE AT ',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/account' },
	                'ACCOUNT PAGE'
	              ),
	              '. IF YOU FAIL TO PROVIDE ANY OF THE FOREGOING INFORMATION, YOU AGREE THAT WE MAY CONTINUE CHARGING YOU FOR ANY USE OF FOR-FEE SERVICES OR PURCHASES OF PRODUCTS UNDER YOUR ACCOUNT.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Change in Amount Authorized.'
	              ),
	              ' If the amount to be charged to your Billing Account varies from the amount you preauthorized (other than due to the imposition or change in the amount of state sales taxes), you have the right to receive, and we shall provide, notice of the amount to be charged and the date of the charge before the scheduled date of the transaction. Any agreement you have with your payment provider will govern your use of your Payment Method. You agree that we may accumulate charges incurred and submit them as one or more aggregate charges during or at the end of each billing cycle.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Auto-Renewal for Subscription Services.'
	              ),
	              ' Unless you opt out of auto-renewal, which can be done through your ',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/account' },
	                'account settings'
	              ),
	              ', any subscription services or purchases you have signed up for will be automatically extended for successive renewal periods of the same duration as the subscription term originally selected, at the then-current non-promotional rate. To change or resign your subscription services at any time, go to ',
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/account' },
	                'account settings'
	              ),
	              '.  If you terminate a subscription service, you may use your subscription until the end of your then-current term; your subscription will not be renewed after your then-current term expires. However, you won\u2019t be eligible for a prorated refund of any portion of the subscription fee paid for the then-current subscription period.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Reaffirmation of Authorization.'
	              ),
	              ' Your non-termination or continued use of a for-fee service reaffirms that we are authorized to charge your Payment Method for that service. We may submit those charges for payment and you will be responsible for such charges. This does not waive our right to seek payment directly from you. Your charges may be payable in advance, in arrears, per usage, or as otherwise described when you initially selected to use the for-fee service.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Free Trials and Other Promotions.'
	              ),
	              ' Any free trial or other promotion that provides access to a for-fee service must be used within the specified time of the trial. You must stop using a for-fee service before the end of the trial period in order to avoid being charged for that service. If you cancel prior to the end of the trial period and are inadvertently charged for a for-fee service, please contact us at [support@indigofair.com].'
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What if I want to stop using Indigo Fair\u2019s Services?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You\u2019re free to do that at any time, by contacting us at [support@indigofair.com]; please refer to our ',
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/privacy' },
	              'Privacy Policy'
	            ),
	            ', as well as the licenses above, to understand how we treat information you provide to us after you have stopped using our Services.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Indigo Fair is also free to terminate (or suspend access to) your use of the Services or your account, for any reason in our discretion, including your breach of these Terms. Indigo Fair has the sole right to decide whether you are in violation of any of the restrictions set forth in these Terms.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Account termination may result in destruction of any Content associated with your account, so keep that in mind before you decide to terminate your account.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Provisions that, by their nature, should survive termination of these Terms shall survive termination. By way of example, all of the following will survive termination: any obligation you have to pay us or indemnify us, any limitations on our liability, any terms regarding ownership or intellectual property rights, and terms regarding disputes between us.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'I use the Indigo Fair App available via the Apple App Store \u2013 should I know anything about that?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'These Terms apply to your use of all the Services, including the iOS applications available via the Apple, Inc. (\u201CApple\u201D) App Store (the \u201CApplication\u201D), but the following additional terms also apply to the Application:'
	          ),
	          _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Both you and Indigo Fair acknowledge that the Terms are concluded between you and Indigo Fair only, and not with Apple, and that Apple is not responsible for the Application or the Content;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'The Application is licensed to you on a limited, non-exclusive, non-transferrable, non-sublicensable basis, solely to be used in connection with the Services for your private, personal, non-commercial use, subject to all the terms and conditions of these Terms as they are applicable to the Services;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'You will only use the Application in connection with an Apple device that you own or control;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'You acknowledge and agree that Apple has no obligation whatsoever to furnish any maintenance and support services with respect to the Application;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'In the event of any failure of the Application to conform to any applicable warranty, including those implied by law, you may notify Apple of such failure; upon notification, Apple\u2019s sole warranty obligation to you will be to refund to you the purchase price, if any, of the Application;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'You acknowledge and agree that Indigo Fair, and not Apple, is responsible for addressing any claims you or any third party may have in relation to the Application;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'You acknowledge and agree that, in the event of any third party claim that the Application or your possession and use of the Application infringes that third party\u2019s intellectual property rights, Indigo Fair, and not Apple, will be responsible for the investigation, defense, settlement and discharge of any such infringement claim;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'You represent and warrant that you are not located in a country subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a \u201Cterrorist supporting\u201D country, and that you are not listed on any U.S. Government list of prohibited or restricted parties;'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Both you and Indigo Fair acknowledge and agree that, in your use of the Application, you will comply with any applicable third party terms of agreement which may affect or be affected by such use; and'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Both you and Indigo Fair acknowledge and agree that Apple and Apple\u2019s subsidiaries are third party beneficiaries of these Terms, and that upon your acceptance of these Terms, Apple will have the right (and will be deemed to have accepted the right) to enforce these Terms against you as the third party beneficiary hereof.'
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What else do I need to know?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Warranty Disclaimer.'
	            ),
	            ' Neither Indigo Fair nor its licensors or suppliers makes any representations or warranties concerning any content contained in or accessed through the Services, and we will not be responsible or liable for the accuracy, copyright compliance, legality, or decency of material contained in or accessed through the Services. We (and our licensors and suppliers) make no representations or warranties regarding suggestions or recommendations of services or products offered or purchased through the Services. Products and services purchased or offered (whether or not following such recommendations and suggestions) through the Services are provided \u201CAS IS\u201D and without any warranty of any kind from Indigo Fair or others (unless provided expressly and unambiguously in writing for a specific product). THE SERVICES AND CONTENT ARE PROVIDED BY INDIGO FAIR (AND ITS LICENSORS AND SUPPLIERS) ON AN \u201CAS-IS\u201D BASIS, WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR THAT USE OF THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE. SOME STATES DO NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, SO THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Limitation of Liability.'
	            ),
	            ' TO THE FULLEST EXTENT ALLOWED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY (INCLUDING, WITHOUT LIMITATION, TORT, CONTRACT, STRICT LIABILITY, OR OTHERWISE) SHALL INDIGO FAIR (OR ITS LICENSORS OR SUPPLIERS) BE LIABLE TO YOU OR TO ANY OTHER PERSON FOR (A) ANY INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING DAMAGES FOR LOST PROFITS, LOSS OF GOODWILL, WORK STOPPAGE, ACCURACY OF RESULTS, OR COMPUTER FAILURE OR MALFUNCTION, OR (B) ANY AMOUNT, IN THE AGGREGATE, IN EXCESS OF THE GREATER OF (I) $100 OR (II) THE AMOUNTS PAID BY YOU TO INDIGO FAIR IN CONNECTION WITH THE SERVICES IN THE TWELVE (12) MONTH PERIOD PRECEDING THIS APPLICABLE CLAIM, OR (III) ANY MATTER BEYOND OUR REASONABLE CONTROL. SOME STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES, SO THE ABOVE LIMITATION AND EXCLUSIONS MAY NOT APPLY TO YOU.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Indemnity.'
	            ),
	            ' To the fullest extent allowed by applicable law, you agree to indemnify and hold Indigo Fair, its affiliates, officers, agents, employees, and partners harmless from and against any and all claims, liabilities, damages (actual and consequential), losses and expenses (including attorneys\u2019 fees) arising from or in any way related to any third party claims relating to (a) your use of the Services (including any actions taken by a third party using your account), and (b) your violation of these Terms. In the event of such a claim, suit, or action (\u201CClaim\u201D), we will attempt to provide notice of the Claim to the contact information we have for your account (provided that failure to deliver such notice shall not eliminate or reduce your indemnification obligations hereunder).'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Assignment.'
	            ),
	            ' You may not assign, delegate or transfer these Terms or your rights or obligations hereunder, or your Services account, in any way (by operation of law or otherwise) without Indigo Fair\u2019s prior written consent. We may transfer, assign, or delegate these Terms and our rights and obligations without consent.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Choice of Law; Arbitration.'
	            ),
	            ' These Terms are governed by and will be construed under the laws of the State of California, without regard to the conflicts of laws provisions thereof. Any dispute arising from or relating to the subject matter of these Terms shall be finally settled in San Francisco County, California, in English, in accordance with the Streamlined Arbitration Rules and Procedures of Judicial Arbitration and Mediation Services, Inc. (\u201CJAMS\u201D) then in effect, by one commercial arbitrator with substantial experience in resolving intellectual property and commercial contract disputes, who shall be selected from the appropriate list of JAMS arbitrators in accordance with such Rules. Judgment upon the award rendered by such arbitrator may be entered in any court of competent jurisdiction. Notwithstanding the foregoing obligation to arbitrate disputes, each party shall have the right to pursue injunctive or other equitable relief at any time, from any court of competent jurisdiction. For all purposes of these Terms, the parties consent to exclusive jurisdiction and venue in the state or federal courts located in, respectively, San Francisco County, California, or the Northern District of California.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Miscellaneous.'
	            ),
	            ' You will be responsible for paying, withholding, filing, and reporting all taxes, duties, and other governmental assessments associated with your activity in connection with the Services, provided that Indigo Fair may, in its sole discretion, do any of the foregoing on your behalf or for itself as it sees fit. The failure of either you or us to exercise, in any way, any right herein shall not be deemed a waiver of any further rights hereunder. If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated, to the minimum extent necessary, so that these Terms shall otherwise remain in full force and effect and enforceable. You and Indigo Fair agree that these Terms are the complete and exclusive statement of the mutual understanding between you and Indigo Fair, and that it supersedes and cancels all previous written and oral agreements, communications and other understandings relating to the subject matter of these Terms. You hereby acknowledge and agree that you are not an employee, agent, partner, or joint venture of Indigo Fair, and you do not have any authority of any kind to bind Indigo Fair in any respect whatsoever. Except as expressly set forth in the section above regarding the Apple Application, you and Indigo Fair agree there are no third party beneficiaries intended under these Terms.'
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return TermsOfUse;
	}(_react2.default.Component);
	
	exports.default = TermsOfUse;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.About = exports.PurchaseTerms = exports.Copyright = exports.PrivacyPolicy = exports.TermsOfUse = exports.Team = exports.Home = undefined;
	
	var _Home = __webpack_require__(313);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _About = __webpack_require__(311);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Team = __webpack_require__(316);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _TermsOfUse = __webpack_require__(317);
	
	var _TermsOfUse2 = _interopRequireDefault(_TermsOfUse);
	
	var _PrivacyPolicy = __webpack_require__(314);
	
	var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);
	
	var _Copyright = __webpack_require__(312);
	
	var _Copyright2 = _interopRequireDefault(_Copyright);
	
	var _PurchaseTerms = __webpack_require__(315);
	
	var _PurchaseTerms2 = _interopRequireDefault(_PurchaseTerms);
	
	__webpack_require__(383);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Home = _Home2.default;
	exports.Team = _Team2.default;
	exports.TermsOfUse = _TermsOfUse2.default;
	exports.PrivacyPolicy = _PrivacyPolicy2.default;
	exports.Copyright = _Copyright2.default;
	exports.PurchaseTerms = _PurchaseTerms2.default;
	exports.About = _About2.default;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _MarketplaceProduct2 = __webpack_require__(109);
	
	var _MarketplaceProduct3 = _interopRequireDefault(_MarketplaceProduct2);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketplaceCollection = function (_MarketplaceProduct) {
	  _inherits(MarketplaceCollection, _MarketplaceProduct);
	
	  function MarketplaceCollection(props) {
	    _classCallCheck(this, MarketplaceCollection);
	
	    var _this = _possibleConstructorReturn(this, (MarketplaceCollection.__proto__ || Object.getPrototypeOf(MarketplaceCollection)).call(this, props));
	
	    _this.imageList = _this.imageList.bind(_this);
	    _this.wholesaleInfo = _this.wholesaleInfo.bind(_this);
	    _this.extraContent = _this.extraContent.bind(_this);
	    _this.displayBrandBlock = _this.displayBrandBlock.bind(_this);
	    return _this;
	  }
	
	  _createClass(MarketplaceCollection, [{
	    key: 'displayBrandBlock',
	    value: function displayBrandBlock() {
	      var brandList = [];
	      var collection = this.state.product;
	
	      collection.items.forEach(function (collectionItem) {
	        if (brandList.indexOf(collectionItem.brand_token) < 0) brandList.push(collectionItem.brand_token);
	      });
	
	      return brandList.length === 1;
	    }
	  }, {
	    key: 'imageList',
	    value: function imageList(product) {
	      if (product.image) return [product.image];
	
	      return _get(MarketplaceCollection.prototype.__proto__ || Object.getPrototypeOf(MarketplaceCollection.prototype), 'imageList', this).call(this, product);
	    }
	  }, {
	    key: 'wholesaleInfo',
	    value: function wholesaleInfo() {
	      var _this2 = this;
	
	      var collection = this.state.product;
	
	      var wholesalePriceCents = 0;
	      var collectionItemCount = 0;
	      collection.items.forEach(function (collectionItem) {
	        var product = _this2.props.productList[collectionItem.product_token];
	        var productOption = product.options.find(function (productOption) {
	          return productOption.token === collectionItem.product_option_token;
	        });
	        if (!productOption) {
	          console.error('Invalid product option: %s', collectionItem.product_option_token);
	          return;
	        }
	
	        collectionItemCount += collectionItem.quantity;
	        wholesalePriceCents += productOption.wholesale_price_cents * collectionItem.quantity;
	      });
	      var wholesalePrice = '$' + _Api.Utils.formatCents(wholesalePriceCents);
	
	      return {
	        wholesale_price: wholesalePrice,
	        retail_price: null,
	        unit_multiplier: null,
	        collection_size: collectionItemCount
	      };
	    }
	  }, {
	    key: 'onActiveClick',
	    value: function onActiveClick(event) {
	      var _this3 = this;
	
	      event.preventDefault();
	
	      var collection = this.state.product;
	      collection.active = !collection.active;
	      return _Api2.default.createOrUpdateProductCollection(collection).then(function () {
	        _this3.setState({ product: collection });
	      }, function (error) {
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'onManualRecommendationClick',
	    value: function onManualRecommendationClick(event) {
	      var _this4 = this;
	
	      event.preventDefault();
	
	      var retailerToken = this.props.retailerToken;
	      if (!retailerToken) return;
	
	      var collection = this.state.product;
	      var manualRecommendation = collection.manual_recommendation;
	      var promise = null;
	      if (manualRecommendation) {
	        promise = _Api2.default.retailerRemoveCollectionRecommendation(retailerToken, collection.token);
	      } else {
	        promise = _Api2.default.retailerAddCollectionRecommendation(retailerToken, collection.token);
	      }
	
	      return promise.then(function () {
	        collection.manual_recommendation = !manualRecommendation;
	        _this4.setState({ product: collection });
	      }, function (error) {
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'extraContent',
	    value: function extraContent() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'collection-star' },
	        'Starter Collection ',
	        _react2.default.createElement(_reactFontawesome2.default, { name: 'star' })
	      );
	    }
	  }]);
	
	  return MarketplaceCollection;
	}(_MarketplaceProduct3.default);
	
	exports.default = MarketplaceCollection;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	__webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFound = function (_Component) {
	  _inherits(NotFound, _Component);
	
	  function NotFound() {
	    _classCallCheck(this, NotFound);
	
	    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	  }
	
	  _createClass(NotFound, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'error-page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column body-content' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Not Found'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This page was not found.'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/' },
	            'Back to home'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotFound;
	}(_react.Component);
	
	exports.default = NotFound;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Image = __webpack_require__(298);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var displayImageWidth = 493;
	var displayImageHeight = 420;
	var imageButtonWidth = 108;
	var imageButtonHeight = 124;
	
	var ImageCollection = function (_React$Component) {
	  _inherits(ImageCollection, _React$Component);
	
	  function ImageCollection(props) {
	    _classCallCheck(this, ImageCollection);
	
	    var _this = _possibleConstructorReturn(this, (ImageCollection.__proto__ || Object.getPrototypeOf(ImageCollection)).call(this, props));
	
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	
	    _this.state = {
	      selectedImageIndex: 0
	    };
	    return _this;
	  }
	
	  _createClass(ImageCollection, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      document.addEventListener("keydown", this.onKeyDown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("keydown", this.onKeyDown);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.images !== nextProps.images) {
	        this.setState({
	          selectedImageIndex: 0
	        });
	      }
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      var selectedImageIndex = this.state.selectedImageIndex;
	      if (event.key === "ArrowRight") {
	        selectedImageIndex++;
	      }
	      if (event.key === "ArrowLeft") {
	        selectedImageIndex--;
	      }
	
	      if (selectedImageIndex >= this.props.images.length) selectedImageIndex = this.props.images.length - 1;
	      if (selectedImageIndex < 0) selectedImageIndex = 0;
	
	      this.setState({ selectedImageIndex: selectedImageIndex });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.images) return null;
	      // Creates an array with all the image URLs for this product
	      var imageArray = this.props.images.map(function (image, index) {
	        return _react2.default.createElement(_Image2.default, {
	          key: 'product-image-' + index,
	          className: 'img' + (index === _this2.state.selectedImageIndex ? ' active' : ''),
	          stretchAndCrop: true,
	          width: displayImageWidth,
	          height: displayImageHeight,
	          image: image
	        });
	      });
	
	      var imageButtons = this.props.images.map(function (image, index) {
	        return _react2.default.createElement(_Image2.default, {
	          key: 'product-image-button-' + index,
	          className: 'img img-button link' + (index === _this2.state.selectedImageIndex ? ' selected' : ''),
	          stretchAndCrop: true,
	          image: image,
	          width: imageButtonWidth,
	          height: imageButtonHeight,
	          onClick: function onClick() {
	            return _this2.setState({ selectedImageIndex: index });
	          }
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-images' },
	        _react2.default.createElement(
	          'div',
	          { className: 'image-display' },
	          imageArray
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'image-listing' },
	          imageButtons
	        )
	      );
	    }
	  }]);
	
	  return ImageCollection;
	}(_react2.default.Component);
	
	ImageCollection.propTypes = {
	  images: _propTypes2.default.array.isRequired
	};
	exports.default = ImageCollection;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ItemColor = function ItemColor(_ref) {
	  var color = _ref.color,
	      className = _ref.className;
	
	  var colorObject = color && color.option && color.option.color;
	  if (!colorObject) return _react2.default.createElement('div', null);
	
	  var classNames = ['color'];
	  if (colorObject.name) {
	    classNames.push('color-' + colorObject.name.toLowerCase());
	  }
	
	  if (className) classNames.push(className);
	
	  return _react2.default.createElement(
	    'div',
	    { className: classNames.join(' ') },
	    _react2.default.createElement('span', { style: { backgroundColor: '#' + colorObject.rgb } })
	  );
	};
	
	exports.default = ItemColor;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UUID = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalDropdown = function (_React$Component) {
	  _inherits(ModalDropdown, _React$Component);
	
	  function ModalDropdown(props) {
	    _classCallCheck(this, ModalDropdown);
	
	    var _this = _possibleConstructorReturn(this, (ModalDropdown.__proto__ || Object.getPrototypeOf(ModalDropdown)).call(this, props));
	
	    _this.buildOptionList = _this.buildOptionList.bind(_this);
	
	    _this.uniqueId = (0, _UUID.generateUUID)();
	
	    _this.state = {
	      dimensions: props.parentDimensions
	    };
	    return _this;
	  }
	
	  _createClass(ModalDropdown, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ dimensions: nextProps.parentDimensions });
	    }
	  }, {
	    key: 'buildOptionList',
	    value: function buildOptionList() {
	      var _this2 = this;
	
	      var listItemGenerator = function listItemGenerator(key, value) {
	        return _react2.default.createElement(
	          'li',
	          {
	            key: 'modal-dropdown-item-' + _this2.uniqueId + '-' + key,
	            onClick: function onClick() {
	              return _this2.props.onChange(key);
	            },
	            className: '' + key === '' + _this2.props.value ? 'active' : ''
	          },
	          value
	        );
	      };
	
	      if (Array.isArray(this.props.options)) {
	        return this.props.options.map(function (value) {
	          return listItemGenerator(value, value);
	        });
	      } else if (_typeof(this.props.options) === 'object') {
	        return Object.keys(this.props.options).map(function (keyValue) {
	          return listItemGenerator(keyValue, _this2.props.options[keyValue]);
	        });
	      } else {
	        console.error('invalid options passed to ModalDropdown component');
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classNames = ['modal'];
	      if (this.props.className) classNames.push(this.props.className);
	      classNames.push('modal-dropdown');
	      classNames.push('modal-' + this.uniqueId);
	
	      var style = {};
	      if (this.state.dimensions) {
	        style = {
	          top: this.state.dimensions.top,
	          left: this.state.dimensions.left,
	          right: this.state.dimensions.right,
	          width: this.state.dimensions.width
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: this.uniqueId, className: classNames.join(' ') },
	        _react2.default.createElement('div', { className: 'modal--backdrop', onClick: this.props.onCancel }),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal--container', style: style },
	          _react2.default.createElement(
	            'ul',
	            null,
	            this.buildOptionList()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalDropdown;
	}(_react2.default.Component);
	
	ModalDropdown.propTypes = {
	  className: _propTypes2.default.string,
	  value: _propTypes2.default.number,
	  options: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]).isRequired,
	  onCancel: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  parentDimensions: _propTypes2.default.object
	};
	exports.default = ModalDropdown;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _item_color = __webpack_require__(322);
	
	var _item_color2 = _interopRequireDefault(_item_color);
	
	var _modal_dropdown = __webpack_require__(323);
	
	var _modal_dropdown2 = _interopRequireDefault(_modal_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectionButton = function (_React$Component) {
	  _inherits(SelectionButton, _React$Component);
	
	  function SelectionButton(props) {
	    _classCallCheck(this, SelectionButton);
	
	    var _this = _possibleConstructorReturn(this, (SelectionButton.__proto__ || Object.getPrototypeOf(SelectionButton)).call(this, props));
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onCancel = _this.onCancel.bind(_this);
	    _this.getComponentDimensions = _this.getComponentDimensions.bind(_this);
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
	    _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
	    _this.onWindowResize = _this.onWindowResize.bind(_this);
	
	    _this.manualTextInput = null;
	
	    var currentSelection = _this.props.selectionList.find(function (selection) {
	      return _this.props.option._option.token === selection.option;
	    });
	    var value = currentSelection ? currentSelection.batches * _this.props.unitMultiplier : 0;
	
	    _this.state = {
	      opened: false,
	      manualInput: false,
	      manualInputValue: 0,
	      dimensions: null,
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(SelectionButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        dimensions: this.getComponentDimensions()
	      });
	
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && nextProps.value !== this.state.value) {
	        this.setState({ value: nextProps.value });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.manualTextInput) this.manualTextInput.focus();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.onWindowResize, false);
	    }
	  }, {
	    key: 'onWindowResize',
	    value: function onWindowResize() {
	      this.setState({
	        dimensions: this.getComponentDimensions()
	      });
	    }
	  }, {
	    key: 'getComponentDimensions',
	    value: function getComponentDimensions() {
	      var dom = (0, _reactDom.findDOMNode)(this);
	      var box = dom.getBoundingClientRect();
	      var dimensions = {};
	      ['top', 'right', 'bottom', 'left', 'width', 'height'].forEach(function (key) {
	        dimensions[key] = box[key];
	      });
	
	      return dimensions;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      if (this.state.manualInput) return;
	      this.setState({
	        opened: !this.state.opened,
	        dimensions: this.getComponentDimensions()
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(value) {
	      var payload = {
	        opened: false
	      };
	      if (value === '+') {
	        payload.manualInput = true;
	        var actualValue = this.props.unitMultiplier * 10;
	        if (this.state.value > actualValue) actualValue = this.state.value;
	        payload.manualInputValue = actualValue;
	      }
	      this.setState(payload);
	
	      if (value !== '+') {
	        this.props.onChange(value);
	      }
	    }
	  }, {
	    key: 'onCancel',
	    value: function onCancel() {
	      this.setState({ opened: false });
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(event) {
	      var value = event.target.value;
	      var fixedValue = '';
	
	      var i = void 0;
	      for (i = 0; i < value.length; i++) {
	        if (value[i] >= '0' && value[i] <= '9') {
	          fixedValue += value[i];
	        }
	      }
	      this.setState({
	        manualInputValue: fixedValue
	      });
	    }
	  }, {
	    key: 'handleInputBlur',
	    value: function handleInputBlur(event) {
	      event.preventDefault();
	
	      var actualValue = 0;
	      var currentValue = this.props.unitMultiplier;
	      while (this.state.manualInputValue >= currentValue) {
	        actualValue = currentValue;
	        currentValue += this.props.unitMultiplier;
	      }
	
	      if (actualValue === 0 && this.props.isOnlyOption) actualValue = this.props.unitMultiplier;
	
	      this.setState({
	        manualInput: false,
	        value: actualValue
	      });
	
	      this.props.onChange(actualValue);
	    }
	  }, {
	    key: 'handleInputKeyDown',
	    value: function handleInputKeyDown(event) {
	      var key = event.keyCode || event.charCode || 0;
	
	      // Escape key
	      if (key === 27) {
	        event.preventDefault();
	        this.setState({
	          manualInput: false,
	          manualInputValue: this.state.value
	        });
	        return;
	      }
	
	      // Return key
	      if (key === 13) {
	        this.handleInputBlur(event);
	        return;
	      }
	    }
	  }, {
	    key: 'generateOptionList',
	    value: function generateOptionList() {
	      var optionList = {};
	      var iStart = 0;
	      if (this.props.isOnlyOption) iStart = 1;
	      for (var i = iStart; i < 10; i++) {
	        optionList[i * this.props.unitMultiplier] = i * this.props.unitMultiplier;
	      }
	
	      var maxValue = 10 * this.props.unitMultiplier;
	      if (this.state.value > maxValue) maxValue = this.state.value;
	
	      optionList['+'] = maxValue + '+';
	
	      return optionList;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var currentSelection = this.props.selectionList.find(function (selection) {
	        return _this2.props.option._option.token === selection.option;
	      });
	      var actualQuantity = currentSelection ? currentSelection.batches * this.props.unitMultiplier : 0;
	      var color = null;
	
	      if (!this.props.hideColor) {
	        color = this.props.option.Color || this.props.option.color || this.props.option.Colors || this.props.option.colors || null;
	      }
	
	      var dropDown = null;
	      var classNames = ['selection-item'];
	
	      if (this.state.opened) {
	        dropDown = _react2.default.createElement(_modal_dropdown2.default, {
	          value: actualQuantity,
	          options: this.generateOptionList(),
	          onChange: this.onChange,
	          onCancel: this.onCancel
	        });
	      }
	
	      if (this.state.manualInput) {
	        actualQuantity = _react2.default.createElement('input', {
	          value: this.state.manualInputValue,
	          ref: function ref(input) {
	            return _this2.manualTextInput = input;
	          },
	          onChange: this.handleInputChange,
	          onBlur: this.handleInputBlur,
	          onKeyDown: this.handleInputKeyDown
	        });
	        classNames.push('manual-input');
	      }
	
	      if (this.props.className) classNames.push(this.props.className);
	      if (!color) classNames.push('no-color');
	
	      if (this.props.option._text.toLowerCase() === 'default') {
	        classNames.push('default-value');
	        return _react2.default.createElement(
	          'div',
	          { className: classNames.join(' '), onClick: this.toggle },
	          _react2.default.createElement(
	            'span',
	            { className: 'quantity full-width' },
	            actualQuantity
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'quantity-chevron' },
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'angle-down' })
	          ),
	          dropDown
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '), onClick: this.toggle },
	        _react2.default.createElement(_item_color2.default, { color: color }),
	        _react2.default.createElement(
	          'span',
	          { className: 'name' },
	          this.props.option._text
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'quantity' },
	          actualQuantity
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'quantity-chevron' },
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'angle-down' })
	        ),
	        dropDown
	      );
	    }
	  }]);
	
	  return SelectionButton;
	}(_react2.default.Component);
	
	SelectionButton.propTypes = {
	  selectionList: _propTypes2.default.array.isRequired,
	  option: _propTypes2.default.object.isRequired,
	  onChange: _propTypes2.default.func,
	  unitMultiplier: _propTypes2.default.number,
	  isOnlyOption: _propTypes2.default.bool,
	  hideColor: _propTypes2.default.bool
	};
	exports.default = SelectionButton;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _NoProducts = __webpack_require__(299);
	
	var _NoProducts2 = _interopRequireDefault(_NoProducts);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _LightBox = __webpack_require__(32);
	
	var _LightBox2 = _interopRequireDefault(_LightBox);
	
	var _CategoryBar = __webpack_require__(66);
	
	var _CategoryBar2 = _interopRequireDefault(_CategoryBar);
	
	var _BreadCrumb = __webpack_require__(65);
	
	var _BreadCrumb2 = _interopRequireDefault(_BreadCrumb);
	
	var _ProductModal = __webpack_require__(70);
	
	var _ProductModal2 = _interopRequireDefault(_ProductModal);
	
	var _RecommendationGrid = __webpack_require__(110);
	
	var _RecommendationGrid2 = _interopRequireDefault(_RecommendationGrid);
	
	var _consts = __webpack_require__(44);
	
	var _StringUtils = __webpack_require__(50);
	
	var _UUID = __webpack_require__(106);
	
	__webpack_require__(386);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RECOMMENDATION_TYPES = {
	  SEARCH: 'search',
	  CATEGORY: 'category'
	};
	var OFFSET_TO_LOAD = 300;
	
	var calculateButtonText = function calculateButtonText(selections) {
	  var totalCases = 0;
	  selections.forEach(function (selection) {
	    totalCases += selection.batches;
	  });
	
	  if (totalCases >= 2) return 'Add Cases to Bag';
	
	  return 'Add Case to Bag';
	};
	
	var Retailer = function (_Component) {
	  _inherits(Retailer, _Component);
	
	  function Retailer(props) {
	    _classCallCheck(this, Retailer);
	
	    var _this = _possibleConstructorReturn(this, (Retailer.__proto__ || Object.getPrototypeOf(Retailer)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['selectProduct', 'selectCollection', 'getMargin', 'setCategory', 'categoryBar', 'closeProductModal', 'productModal', 'redirectToRetailerPage', 'addToCart', 'getRecommendedProduct', 'getCartSelection', 'onScroll', 'onUserChanged']);
	
	    var productToken = props.params.productId ? props.params.productId : null;
	
	    var activeCategory = _consts.JUST_FOR_YOU_CATEGORY;
	    var categorySearching = false;
	    if (props.params.categoryName) {
	      activeCategory = props.params.categoryName.replace(/\+/g, ' ');
	      categorySearching = true;
	    } else if (props.location.query.category) {
	      activeCategory = props.location.query.category;
	    }
	
	    var activeSubcategory = null;
	    if (activeCategory && props.location.query.subcategory) {
	      activeSubcategory = props.location.query.subcategory;
	    }
	
	    var activeFilter = null;
	    var filterValue = props.location.query.filter;
	    if (filterValue) {
	      var filterName = _consts.CATEGORY_FILTERS_VALUE_TO_NAME[filterValue];
	      activeFilter = { name: filterName, value: filterValue };
	    }
	
	    _this.categoryRequestLock = null;
	    _this.state = {
	      error: null,
	      retailer: null,
	      user: _Api2.default.cache.getUser(),
	      category: activeCategory,
	      subcategory: activeSubcategory,
	      filter: activeFilter,
	      activeRecommendationType: RECOMMENDATION_TYPES.CATEGORY,
	      categorySearching: categorySearching,
	      categories: _Api2.default.cache.getCategories(),
	      categoryRecommendations: null,
	      margins: {},
	      isSearching: !!_Api2.default.cache.getProductSearchTerm(),
	      productToken: productToken,
	      searchVisible: _Api2.default.cache.getProductSearchActive(),
	      searchTerm: _Api2.default.cache.getProductSearchTerm(),
	      searchRecommendations: null,
	      cartVisible: _Api2.default.cache.getCartVisible(),
	      currentFilter: _Api2.default.cache.getCurrentRecommendationFilter(),
	      recommendations: _Api2.default.cache.getCurrentRecommendationSet()
	    };
	    return _this;
	  }
	
	  _createClass(Retailer, [{
	    key: 'selectProduct',
	    value: function selectProduct(product) {
	      var url = '/retailer/' + this.props.params.retailerToken + '/product/' + product.token;
	      this.context.router.push(url);
	    }
	  }, {
	    key: 'selectCollection',
	    value: function selectCollection(collection) {
	      var url = '/retailer/' + this.props.params.retailerToken + '/collection/' + collection.token;
	      this.context.router.push(url);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.startListen(this, 'categories', _Api2.default.cache.eventTypes.CATEGORIES_CHANGED);
	      _Api2.default.startListen(this, 'searchVisible', _Api2.default.cache.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
	      _Api2.default.startListen(this, 'searchTerm', _Api2.default.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
	      _Api2.default.startListen(this, 'cartVisible', _Api2.default.cache.eventTypes.CART_VISIBLE_CHANGED);
	      _Api2.default.startListen(this, 'currentFilter', _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
	      _Api2.default.startListen(this, 'recommendations', _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
	      _Api2.default.cache.addChangeListener(this.onUserChanged, _Api2.default.cache.eventTypes.USER_CHANGED);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var loaded = this.loadRetailer(this.props.params.retailerToken);
	      if (loaded) {
	        loaded.then(function () {
	          if (_this2.state.category || _this2.state.filter || _this2.state.searchTerm) {
	            _this2.updateRecommendations();
	          }
	        });
	      }
	      window.scrollTo(0, 0);
	      window.addEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.CATEGORIES_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.PRODUCT_SEARCH_ACTIVE_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.PRODUCT_SEARCH_TERM_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.RECOMMENDATIONS_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.CART_VISIBLE_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
	      _Api2.default.cache.removeChangeListener(this.onUserChanged, _Api2.default.cache.eventTypes.USER_CHANGED);
	      window.removeEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.productToken !== nextProps.params.productId) {
	        this.setState({
	          productToken: nextProps.params.productId
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(oldProps, oldState) {
	      var _this3 = this;
	
	      if (this.props.params.retailerToken !== oldProps.params.retailerToken) {
	        // If our retailer ever changes, load the new one.
	        var loaded = this.loadRetailer(this.props.params.retailerToken);
	        if (loaded) {
	          loaded.then(function () {
	            if (_this3.state.category || _this3.state.filter || _this3.state.searchTerm) {
	              _this3.updateRecommendations();
	            }
	          });
	          return;
	        }
	      }
	
	      var shouldUpdate = false;
	      // Simple search term changed. Search bar is visible
	      shouldUpdate = shouldUpdate || oldState.searchTerm !== this.state.searchTerm && this.state.searchVisible;
	
	      // Search bar is no longer visible
	      shouldUpdate = shouldUpdate || !this.state.searchVisible && oldState.searchVisible;
	
	      // Search bar is now visible and it already has a searchTerm
	      shouldUpdate = shouldUpdate || this.state.searchVisible && !oldState.searchVisible && this.state.searchTerm.trim().length > 0;
	
	      // Category/Subcategory/Filter is changed
	      shouldUpdate = shouldUpdate || oldState.category !== this.state.category || oldState.subcategory !== this.state.subcategory || (oldState.filter && oldState.filter.value) !== (this.state.filter && this.state.filter.value);
	
	      if (shouldUpdate) this.updateRecommendations();
	
	      if (this.state.productToken) {
	        document.body.classList.add('noscroll');
	      } else {
	        document.body.classList.remove('noscroll');
	      }
	    }
	  }, {
	    key: 'onScroll',
	    value: function onScroll() {
	      // Only check to load more if category recommendations is active
	      // and there is more to load
	      if (this.state.activeRecommendationType !== RECOMMENDATION_TYPES.CATEGORY || !this.state.categoryRecommendations || !this.state.categoryRecommendations.loadMore) {
	        return;
	      }
	
	      var document = window.document;
	      var documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
	
	      var windowPos = window.pageYOffset || document.documentElement.scrollTop;
	      if (windowPos + window.innerHeight > documentHeight - OFFSET_TO_LOAD) {
	        this.state.categoryRecommendations.loadMore();
	      }
	    }
	  }, {
	    key: 'onUserChanged',
	    value: function onUserChanged() {
	      var newUser = _Api2.default.cache.getUser();
	      if (newUser.token !== (this.state.user && this.state.user.token)) {
	        _Api2.default.cache.setProductSearchRecommendations(null);
	        _Api2.default.cache.setCategories(null);
	        this.setState({
	          user: newUser
	        });
	      }
	    }
	  }, {
	    key: 'getRecommendedProduct',
	    value: function getRecommendedProduct(productToken) {
	      var recommendedProduct = null;
	
	      if (this.state.recommendations && this.state.recommendations.products) {
	        recommendedProduct = this.state.recommendations.products[productToken];
	      }
	
	      if (recommendedProduct) {
	        return Promise.resolve(recommendedProduct);
	      }
	
	      return _Api2.default.getProduct(productToken, true).then(function (productResponse) {
	        return productResponse.products[productToken];
	      });
	    }
	  }, {
	    key: 'loadRetailer',
	    value: function loadRetailer(retailerToken) {
	      var _this4 = this;
	
	      return _Api2.default.getRetailer(retailerToken, true).then(function (retailer) {
	        return new Promise(function (accept, reject) {
	          _this4.setState({ retailer: retailer }, accept);
	        });
	      }).then(function () {
	        return _Api2.default.getUser();
	      }).then(function (user) {
	        var isEmployee = user && user.is_employee;
	        var isInvited = _this4.state.retailer && _this4.state.retailer.invited;
	
	        if (isInvited || isEmployee) return _Api2.default.getCategories();
	      }).catch(function (error) {
	        if (error.httpStatusCode === 401) {
	          var user = _Api2.default.cache.getUser();
	          if (user && user.retailer_token && user.retailer_token !== retailerToken) {
	            // Send the user to the Retailer they actually own.
	            _this4.context.router.push('/retailer/' + user.retailer_token);
	          } else if (!user) {
	            // Handle user not loaded
	            return _Api2.default.getUser().then(function (user) {
	              if (!user) {
	                _this4.context.router.push('/user');
	                return;
	              }
	
	              if (!user.retailer_token) {
	                _this4.context.router.push('/');
	                return;
	              }
	
	              _this4.context.router.push('/retailer/' + user.retailer_token);
	            }, function () {
	              _this4.context.router.push('/user');
	            });
	          } else {
	            // Should never happen
	            _this4.context.router.push('/');
	          }
	        } else {
	          console.error(error);
	          _this4.setState({ error: error });
	        }
	      });
	    }
	  }, {
	    key: 'updateRecommendations',
	    value: function updateRecommendations() {
	      if (this.state.searchVisible && this.state.searchTerm && this.state.searchTerm.trim().length > 0) {
	        this.loadSearchProducts();
	      } else {
	        this.loadCategoryProducts();
	      }
	    }
	  }, {
	    key: 'loadSearchProducts',
	    value: function loadSearchProducts() {
	      var _this5 = this;
	
	      _Api2.default.cache.setCurrentRecommendationSet(null);
	      this.setState({
	        activeRecommendationType: RECOMMENDATION_TYPES.SEARCH,
	        isSearching: true,
	        categorySearching: false,
	        searchRecommendations: null
	      }, function () {
	        _Api2.default.productBrowseNew({ query: _this5.state.searchTerm }).then(function (recommendations) {
	          _Api2.default.cache.setCurrentRecommendationSet(recommendations);
	          _this5.setState({
	            isSearching: false,
	            searchRecommendations: recommendations
	          });
	        });
	      });
	    }
	  }, {
	    key: 'loadCategoryProducts',
	    value: function loadCategoryProducts() {
	      var _this6 = this;
	
	      _Api2.default.cache.setCurrentRecommendationSet(null);
	      this.setState({
	        activeRecommendationType: RECOMMENDATION_TYPES.CATEGORY,
	        isSearching: false,
	        categorySearching: true,
	        categoryRecommendations: null
	      }, function () {
	        var request = _Api2.default.createProductBrowseNewPayload(_this6.state.category, _this6.state.subcategory, _this6.state.filter);
	
	        var requestUUID = (0, _UUID.generateUUID)();
	        var promise = _this6.loadContinuous(request, requestUUID);
	        if (promise) {
	          promise.then(function () {
	            _this6.setState({
	              categorySearching: false,
	              isSearching: false
	            });
	          });
	        }
	      });
	    }
	  }, {
	    key: 'loadContinuous',
	    value: function loadContinuous(request, requestId) {
	      var _this7 = this;
	
	      if (this.categoryRequestLock === requestId) return null;
	
	      this.categoryRequestLock = requestId;
	
	      var isEmployee = this.state.user && this.state.user.is_employee;
	      var isInvited = this.state.retailer && this.state.retailer.invited;
	
	      if (!isEmployee && !isInvited) return null;
	
	      return _Api2.default.productBrowseNew(request).then(function (response) {
	        if (_this7.categoryRequestLock !== requestId) return;
	
	        var recommendations = response;
	
	        if (response.next_request) {
	          var nextRequestId = response.next_request.pagination_token;
	          recommendations.loadMore = _this7.loadContinuous.bind(_this7, response.next_request, nextRequestId);
	        } else {
	          _this7.categoryRequestLock = null;
	          recommendations.loadMore = null;
	        }
	
	        _Api2.default.cache.setCurrentRecommendationSet(recommendations);
	        _this7.setState({
	          categoryRecommendations: recommendations
	        });
	      });
	    }
	  }, {
	    key: 'getMargin',
	    value: function getMargin(token) {
	      var margins = this.state.margins;
	      if (Object.keys(margins).indexOf(token) < 0) return 0;
	      return margins[token];
	    }
	  }, {
	    key: 'setCategory',
	    value: function setCategory(category, subcategory, filter) {
	      if (this.props.location.pathname.indexOf('category') > 0) {
	        this.context.router.push('/retailer/' + this.props.params.retailerToken);
	      }
	
	      _Api2.default.cache.setProductSearchActive(false);
	      this.setState({
	        category: category || _consts.JUST_FOR_YOU_CATEGORY,
	        subcategory: subcategory,
	        filter: filter
	      });
	    }
	  }, {
	    key: 'categoryBar',
	    value: function categoryBar() {
	      return _react2.default.createElement(_CategoryBar2.default, { categories: this.state.categories,
	        filters: _consts.CATEGORY_FILTERS,
	        activeCategory: this.state.category,
	        activeSubcategory: this.state.subcategory,
	        activeFilter: this.state.filter,
	        onSelect: this.setCategory });
	    }
	  }, {
	    key: 'closeProductModal',
	    value: function closeProductModal() {
	      this.redirectToRetailerPage();
	    }
	  }, {
	    key: 'getCartSelection',
	    value: function getCartSelection() {
	      var _this8 = this;
	
	      var cartSelection = null;
	      var cart = _Api2.default.cache.getCart();
	      if (cart && cart.cart && cart.cart.items && cart.cart.items.length > 0) {
	        var productOptionsInCart = cart.cart.items.filter(function (cartItem) {
	          return cartItem.product_token === _this8.state.productToken;
	        });
	
	        if (productOptionsInCart.length > 0) {
	          (function () {
	            var product = cart.products[productOptionsInCart[0].product_token];
	            var batchCount = product.options[0].unit_multiplier;
	            cartSelection = productOptionsInCart.map(function (cartItem) {
	              return {
	                option: cartItem.product_option_token,
	                batches: cartItem.quantity / batchCount
	              };
	            });
	          })();
	        }
	      }
	
	      return cartSelection;
	    }
	  }, {
	    key: 'productModal',
	    value: function productModal() {
	      if (this.state.productToken) {
	        document.body.classList.add('noscroll');
	      } else {
	        document.body.classList.remove('noscroll');
	      }
	
	      var cartSelection = this.getCartSelection();
	
	      return _react2.default.createElement(
	        _LightBox2.default,
	        { onClose: this.closeProductModal, className: this.state.productToken ? '' : 'hidden' },
	        _react2.default.createElement(_ProductModal2.default, {
	          productToken: this.state.productToken,
	          retailerToken: this.props.params.retailerToken,
	          onSave: this.addToCart,
	          defaultSelection: cartSelection,
	          buttonText: !cartSelection ? calculateButtonText : 'Save'
	        })
	      );
	    }
	  }, {
	    key: 'redirectToRetailerPage',
	    value: function redirectToRetailerPage() {
	      this.context.router.push('/retailer/' + this.props.params.retailerToken);
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(productToken, productOptions) {
	      var _this9 = this;
	
	      var cartItems = null;
	
	      return this.getRecommendedProduct(productToken).then(function (product) {
	        if (!product) {
	          console.error('Cannot find product with token %s', productToken);
	          return null;
	        }
	
	        cartItems = productOptions.map(function (selection) {
	          var selectedOption = product.options.find(function (option) {
	            return selection.option === option.token;
	          });
	          var bagEntry = {};
	          bagEntry.brand_token = product.brand_token;
	          bagEntry.product_token = product.token;
	          bagEntry.product_option_token = selectedOption.token;
	          bagEntry.quantity = selection.batches * selectedOption.unit_multiplier;
	          bagEntry.price_cents = selectedOption.wholesale_price_cents;
	
	          return bagEntry;
	        });
	      }).then(function () {
	        var oldSelection = _this9.getCartSelection();
	        // Delete existing items from cart before continuing
	        if (oldSelection && oldSelection.length > 0) {
	          return _Api2.default.removeFromCart(oldSelection.map(function (selection) {
	            return selection.option;
	          }));
	        }
	      }).then(function () {
	        return _Api2.default.addToCart(cartItems);
	      }).then(function (result) {
	        _this9.redirectToRetailerPage();
	        return result;
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      var retailerInvited = this.state.retailer && this.state.retailer.invited;
	      var isEmployee = this.state.user && this.state.user.is_employee;
	      var forceLead = this.props.location && this.props.location.query && this.props.location.query.lead === "1";
	
	      if (!this.state.retailer) return null;
	
	      if (forceLead || !retailerInvited && !isEmployee) {
	        return _react2.default.createElement(_NoProducts2.default, { retailer: this.state.retailer });
	      }
	
	      if (this.state.error) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          this.state.error.message
	        );
	      }
	
	      var activeRecommendations = this.state.recommendations;
	      if (this.state.isSearching || this.state.categorySearching || !this.state.categories || !activeRecommendations || !this.state.retailer) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.state.categories ? this.categoryBar() : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'retailer-loading-wrapper' },
	            _react2.default.createElement(_Processing2.default, null)
	          )
	        );
	      }
	
	      var recommendations = null;
	      if (activeRecommendations) {
	        var _ret2 = function () {
	          var displayOrder = activeRecommendations.display_order;
	          var productMap = activeRecommendations.products;
	
	          var isEmployee = _this10.state.user && _this10.state.user.is_employee;
	
	          if (isEmployee && _this10.state.currentFilter.length > 0) {
	            displayOrder = displayOrder.filter(function (productToken) {
	              var product = productMap[productToken];
	              var enabled = false;
	
	              if (product) {
	                if (_this10.state.currentFilter.length === 1 && _this10.state.currentFilter[0] === '+ACTIVE') {
	                  enabled = product.active;
	                } else {
	                  _this10.state.currentFilter.forEach(function (filterValue) {
	                    if (product.recommenders && product.recommenders.indexOf(filterValue) >= 0) enabled = true;
	                  });
	                  if (enabled && _this10.state.currentFilter.indexOf('+ACTIVE') >= 0 && !product.active) enabled = false;
	                }
	              }
	
	              return enabled;
	            });
	          }
	
	          if (displayOrder.length === 0) {
	            if (_this10.props.location.query.campaign === "1") return {
	                v: _react2.default.createElement(LeadSubmittedMessage, { retailer: _this10.state.retailer })
	              };
	            var clearFilters = _this10.state.filter ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Clear filters above to view all results.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'clear-filters',
	                  onClick: function onClick() {
	                    _this10.setCategory(_this10.state.category, _this10.state.subcategory, null);
	                  } },
	                'Clear Filters'
	              )
	            ) : null;
	            recommendations = _react2.default.createElement(
	              'div',
	              { className: 'no-results' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'No Items Found'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Try widening your search to see what\u2019s available. '
	              ),
	              clearFilters
	            );
	          } else {
	            var loading = activeRecommendations.loadMore ? _react2.default.createElement(_Processing2.default, null) : null;
	            recommendations = _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_RecommendationGrid2.default, {
	                products: productMap,
	                brands: activeRecommendations.brands,
	                collections: activeRecommendations.collections || {},
	                display_order: displayOrder,
	                retailerToken: _this10.props.params.retailerToken,
	                selectProduct: _this10.selectProduct,
	                selectCollection: _this10.selectCollection
	              }),
	              loading
	            );
	          }
	        }();
	
	        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	      }
	
	      var classNames = ['retailer'];
	
	      var headerTitle = _consts.JUST_FOR_YOU_CATEGORY;
	      if (this.state.searchTerm) {
	        headerTitle = 'Search: ' + this.state.searchTerm;
	      } else if (this.state.subcategory) {
	        headerTitle = (0, _StringUtils.capitalizeEveryWord)(this.state.subcategory);
	      } else if (this.state.category) {
	        headerTitle = (0, _StringUtils.capitalizeEveryWord)(this.state.category);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' ') },
	        this.categoryBar(),
	        _react2.default.createElement(
	          'div',
	          { className: 'recommendation-wrapper' },
	          _react2.default.createElement(
	            _BreadCrumb2.default,
	            { primary: this.state.category,
	              secondary: this.state.subcategory,
	              className: this.state.activeRecommendationType === RECOMMENDATION_TYPES.SEARCH ? "hide" : "",
	              filter: this.state.category === _consts.SHOP_ALL_CATEGORY ? null : this.state.filter,
	              onSelect: function onSelect(selection) {
	                if (!selection) {
	                  _this10.setCategory(null, null, _this10.state.filter);
	                } else if (selection === _this10.state.category) {
	                  _this10.setCategory(_this10.state.category, null, _this10.state.filter);
	                }
	              },
	              onClearFilters: function onClearFilters() {
	                _this10.setCategory(_this10.state.category, _this10.state.subcategory, null);
	              },
	              onShopFilters: function onShopFilters(filter) {
	                _this10.setCategory(_consts.SHOP_ALL_CATEGORY, null, filter);
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'recommendations-title' },
	              headerTitle
	            )
	          ),
	          recommendations
	        ),
	        this.productModal()
	      );
	    }
	  }]);
	
	  return Retailer;
	}(_react.Component);
	
	Retailer.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = Retailer;
	
	var LeadSubmittedMessage = function (_React$Component) {
	  _inherits(LeadSubmittedMessage, _React$Component);
	
	  function LeadSubmittedMessage(props) {
	    _classCallCheck(this, LeadSubmittedMessage);
	
	    var _this11 = _possibleConstructorReturn(this, (LeadSubmittedMessage.__proto__ || Object.getPrototypeOf(LeadSubmittedMessage)).call(this, props));
	
	    _this11.sendLead = _this11.sendLead.bind(_this11);
	    return _this11;
	  }
	
	  _createClass(LeadSubmittedMessage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.sendLead();
	    }
	  }, {
	    key: 'sendLead',
	    value: function sendLead() {
	      var payload = {
	        first_name: '',
	        last_name: '',
	        email_address: 'campaign@indigofair.com',
	        phone_number: '',
	        note: 'Campaign lead for \'' + this.props.retailer.name + '\' (' + this.props.retailer.token + ')'
	      };
	
	      _Api2.default.retailerLead(this.props.retailer.token, payload);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'no-products' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Thank you!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your request has been received. We will email you a link to view the Indigo Fair product catalogue within 24 hours'
	        )
	      );
	    }
	  }]);
	
	  return LeadSubmittedMessage;
	}(_react2.default.Component);
	
	LeadSubmittedMessage.propTypes = {
	  retailer: _propTypes2.default.object.isRequired
	};

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminTools = exports.AdminSingleOrder = exports.AdminQueue = exports.AdminOrders = exports.AdminRetailerView = exports.AdminRetailer = exports.AdminRecommendations = exports.AdminProductOptionEdit = exports.AdminProduct = exports.AdminEmails = exports.AdminCollectionEdit = exports.AdminCollections = exports.AdminBrandCreate = exports.AdminBrandEdit = exports.AdminBrand = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Brand = __webpack_require__(338);
	
	var _Brand2 = _interopRequireDefault(_Brand);
	
	var _AdminBrandEdit = __webpack_require__(329);
	
	var _AdminBrandEdit2 = _interopRequireDefault(_AdminBrandEdit);
	
	var _AdminBrandCreate = __webpack_require__(328);
	
	var _AdminBrandCreate2 = _interopRequireDefault(_AdminBrandCreate);
	
	var _AdminCollections = __webpack_require__(331);
	
	var _AdminCollections2 = _interopRequireDefault(_AdminCollections);
	
	var _AdminCollectionEdit = __webpack_require__(330);
	
	var _AdminCollectionEdit2 = _interopRequireDefault(_AdminCollectionEdit);
	
	var _AdminEmails = __webpack_require__(332);
	
	var _AdminEmails2 = _interopRequireDefault(_AdminEmails);
	
	var _AdminProduct = __webpack_require__(333);
	
	var _AdminProduct2 = _interopRequireDefault(_AdminProduct);
	
	var _AdminProductOptionEdit = __webpack_require__(334);
	
	var _AdminProductOptionEdit2 = _interopRequireDefault(_AdminProductOptionEdit);
	
	var _AdminRecommendations = __webpack_require__(336);
	
	var _AdminRecommendations2 = _interopRequireDefault(_AdminRecommendations);
	
	var _Retailer = __webpack_require__(340);
	
	var _Retailer2 = _interopRequireDefault(_Retailer);
	
	var _RetailerView = __webpack_require__(341);
	
	var _RetailerView2 = _interopRequireDefault(_RetailerView);
	
	var _Orders = __webpack_require__(112);
	
	var _Orders2 = _interopRequireDefault(_Orders);
	
	var _AdminQueue = __webpack_require__(335);
	
	var _AdminQueue2 = _interopRequireDefault(_AdminQueue);
	
	var _SingleOrder = __webpack_require__(342);
	
	var _SingleOrder2 = _interopRequireDefault(_SingleOrder);
	
	var _AdminTools = __webpack_require__(337);
	
	var _AdminTools2 = _interopRequireDefault(_AdminTools);
	
	__webpack_require__(387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Admin = function (_React$Component) {
	  _inherits(Admin, _React$Component);
	
	  function Admin(props) {
	    _classCallCheck(this, Admin);
	
	    var _this = _possibleConstructorReturn(this, (Admin.__proto__ || Object.getPrototypeOf(Admin)).call(this, props));
	
	    _this.userChanged = _this.userChanged.bind(_this);
	    _this.state = { user: null };
	    return _this;
	  }
	
	  _createClass(Admin, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _Api2.default.cache.addChangeListener(this.userChanged, _Api2.default.cache.eventTypes.USER_CHANGED);
	      _Api2.default.getUser(true).then(function () {
	        _this2.userChanged();
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.userChanged, _Api2.default.cache.eventTypes.USER_CHANGED);
	    }
	  }, {
	    key: "userChanged",
	    value: function userChanged() {
	      var user = _Api2.default.cache.getUser();
	
	      if (!user) {
	        this.context.router.push('/user?redirect=/admin');
	      } else if (!user.is_employee) {
	        this.context.router.push('/');
	      } else {
	        this.setState({ user: user });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!this.state.user) return null;
	      if (this.props.location && this.props.location.isModal) return this.props.children;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "admin" },
	        _react2.default.createElement(
	          "div",
	          { className: "admin-inner-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "column body-content" },
	            _react2.default.createElement(
	              "div",
	              { className: "admin-banner" },
	              _react2.default.createElement(
	                _Button2.default,
	                { color: "dark", to: "/admin" },
	                "Brands"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                { color: "dark", to: "/admin/retailers" },
	                "Retailers"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                { color: "dark", to: "/admin/collections" },
	                "Collections"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                { color: "dark", to: "/admin/orders" },
	                "Orders"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "admin-banner" },
	              _react2.default.createElement(
	                _Button2.default,
	                { color: "dark", to: "/admin/emails" },
	                "Emails"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                { color: "dark", to: "/admin/recommendations" },
	                "Email Recommendations"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                { color: "dark", to: "/admin/tools" },
	                "Tools"
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                { color: "dark", to: "/admin/queue" },
	                "Queue"
	              )
	            ),
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return Admin;
	}(_react2.default.Component);
	
	exports.default = Admin;
	
	
	Admin.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.AdminBrand = _Brand2.default;
	exports.AdminBrandEdit = _AdminBrandEdit2.default;
	exports.AdminBrandCreate = _AdminBrandCreate2.default;
	exports.AdminCollections = _AdminCollections2.default;
	exports.AdminCollectionEdit = _AdminCollectionEdit2.default;
	exports.AdminEmails = _AdminEmails2.default;
	exports.AdminProduct = _AdminProduct2.default;
	exports.AdminProductOptionEdit = _AdminProductOptionEdit2.default;
	exports.AdminRecommendations = _AdminRecommendations2.default;
	exports.AdminRetailer = _Retailer2.default;
	exports.AdminRetailerView = _RetailerView2.default;
	exports.AdminOrders = _Orders2.default;
	exports.AdminQueue = _AdminQueue2.default;
	exports.AdminSingleOrder = _SingleOrder2.default;
	exports.AdminTools = _AdminTools2.default;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminBar = function (_React$Component) {
	  _inherits(AdminBar, _React$Component);
	
	  function AdminBar(props) {
	    _classCallCheck(this, AdminBar);
	
	    var _this = _possibleConstructorReturn(this, (AdminBar.__proto__ || Object.getPrototypeOf(AdminBar)).call(this, props));
	
	    _this.refreshData = _this.refreshData.bind(_this);
	
	    _this.state = {
	      retailer: _Api2.default.cache.getRetailer(),
	      isVisible: _Api2.default.cache.getAdminBarVisible(),
	      data: null
	    };
	    return _this;
	  }
	
	  _createClass(AdminBar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.startListen(this, 'isVisible', _Api2.default.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
	      _Api2.default.cache.addChangeListener(this.refreshData, _Api2.default.cache.eventTypes.RETAILER_CHANGED);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
	      _Api2.default.cache.removeChangeListener(this.refreshData, _Api2.default.cache.eventTypes.RETAILER_CHANGED);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refreshData();
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      var _this2 = this;
	
	      _Api2.default.internalRecommendations().then(function (response) {
	        _this2.setState({
	          data: response
	        });
	      }, function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var classNames = ['admin-bar'];
	      if (this.props.className && this.props.className !== '') classNames.push(classNames);
	
	      var carriedCategories = void 0;
	      var crawledImages = void 0;
	
	      if (this.state.data) {
	        carriedCategories = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Known Carried Categories'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            this.state.data.carried_categories.join(', ')
	          )
	        );
	
	        if (this.state.data.crawled_images && this.state.data.crawled_images.length > 0) {
	          (function () {
	            var style = {
	              width: "auto",
	              height: "100px"
	            };
	            var images = _this3.state.data.crawled_images.map(function (image, index) {
	              return _react2.default.createElement('img', { key: 'admin-bar-image-' + image.url + '-' + index,
	                src: image.url, style: style,
	                role: 'presentation' });
	            });
	            crawledImages = _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Crawled Images'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                images
	              )
	            );
	          })();
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' ') },
	        carriedCategories,
	        _react2.default.createElement(AdminBarFilter, null),
	        crawledImages
	      );
	    }
	  }]);
	
	  return AdminBar;
	}(_react2.default.Component);
	
	AdminBar.propTypes = {
	  className: _propTypes2.default.string
	};
	exports.default = AdminBar;
	
	var AdminBarFilter = function (_React$Component2) {
	  _inherits(AdminBarFilter, _React$Component2);
	
	  function AdminBarFilter(props) {
	    _classCallCheck(this, AdminBarFilter);
	
	    var _this4 = _possibleConstructorReturn(this, (AdminBarFilter.__proto__ || Object.getPrototypeOf(AdminBarFilter)).call(this, props));
	
	    _this4.updateRecommendationList = _this4.updateRecommendationList.bind(_this4);
	    _this4.onChange = _this4.onChange.bind(_this4);
	    _this4.selectAll = _this4.selectAll.bind(_this4);
	    _this4.selectNone = _this4.selectNone.bind(_this4);
	
	    _this4.state = {
	      displayedResults: null,
	      availableFilters: [],
	      currentFilter: _Api2.default.cache.getCurrentRecommendationFilter()
	    };
	    return _this4;
	  }
	
	  _createClass(AdminBarFilter, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.cache.addChangeListener(this.updateRecommendationList, _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
	      _Api2.default.startListen(this, 'currentFilter', _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
	      this.updateRecommendationList();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.updateRecommendationList, _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
	      _Api2.default.stopListen(this, _Api2.default.cache.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
	    }
	  }, {
	    key: 'updateRecommendationList',
	    value: function updateRecommendationList() {
	      var payload = {
	        displayedResults: _Api2.default.cache.getCurrentRecommendationSet(),
	        availableFilters: []
	      };
	
	      if (payload.displayedResults) {
	        Object.keys(payload.displayedResults.products).forEach(function (productToken) {
	          var product = payload.displayedResults.products[productToken];
	
	          if (product.recommenders) {
	            product.recommenders.forEach(function (recommender) {
	              if (payload.availableFilters.indexOf(recommender) < 0) payload.availableFilters.push(recommender);
	            });
	          }
	        });
	      }
	
	      this.setState(payload);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var itemIndex = this.state.currentFilter.indexOf(event.target.value);
	      var newFilter = [];
	      if (itemIndex < 0) {
	        newFilter = [event.target.value].concat(_toConsumableArray(this.state.currentFilter));
	      } else {
	        newFilter = [].concat(_toConsumableArray(this.state.currentFilter.slice(0, itemIndex)), _toConsumableArray(this.state.currentFilter.slice(itemIndex + 1)));
	      }
	
	      _Api2.default.cache.setCurrentRecommendationFilter(newFilter);
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll(event) {
	      event.preventDefault();
	      _Api2.default.cache.setCurrentRecommendationFilter([].concat(_toConsumableArray(this.state.availableFilters)));
	    }
	  }, {
	    key: 'selectNone',
	    value: function selectNone(event) {
	      event.preventDefault();
	      _Api2.default.cache.setCurrentRecommendationFilter([]);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var options = null;
	
	      if (!this.state.availableFilters || this.state.availableFilters.length <= 0) {
	        options = _react2.default.createElement(
	          'span',
	          null,
	          'No Recommenders'
	        );
	      } else {
	        options = this.state.availableFilters.map(function (filterName) {
	          return _react2.default.createElement(
	            'li',
	            { key: 'admin-filter-' + filterName },
	            _react2.default.createElement('input', { type: 'checkbox', checked: _this5.state.currentFilter.indexOf(filterName) >= 0, value: filterName,
	              onChange: _this5.onChange }),
	            filterName
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'adminbar-filter-component' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Available recommenders'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          options,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('input', { type: 'checkbox', checked: this.state.currentFilter.indexOf('+ACTIVE') >= 0, value: '+ACTIVE', onChange: this.onChange }),
	            '+ACTIVE'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.selectAll },
	            'All'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.selectNone },
	            'None'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminBarFilter;
	}(_react2.default.Component);

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _BrandEditor = __webpack_require__(100);
	
	var _BrandEditor2 = _interopRequireDefault(_BrandEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminBrandCreate = function (_Component) {
	  _inherits(AdminBrandCreate, _Component);
	
	  function AdminBrandCreate() {
	    _classCallCheck(this, AdminBrandCreate);
	
	    return _possibleConstructorReturn(this, (AdminBrandCreate.__proto__ || Object.getPrototypeOf(AdminBrandCreate)).apply(this, arguments));
	  }
	
	  _createClass(AdminBrandCreate, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_AdminTitle2.default, { title: 'Create Brand' }),
	        _react2.default.createElement(_BrandEditor2.default, null)
	      );
	    }
	  }]);
	
	  return AdminBrandCreate;
	}(_react.Component);
	
	exports.default = AdminBrandCreate;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _BrandEditor = __webpack_require__(100);
	
	var _BrandEditor2 = _interopRequireDefault(_BrandEditor);
	
	var _BrandLogisticsEditor = __webpack_require__(285);
	
	var _BrandLogisticsEditor2 = _interopRequireDefault(_BrandLogisticsEditor);
	
	var _ProductEditor = __webpack_require__(300);
	
	var _ProductEditor2 = _interopRequireDefault(_ProductEditor);
	
	var _ProductList = __webpack_require__(301);
	
	var _ProductList2 = _interopRequireDefault(_ProductList);
	
	var _reactTabs = __webpack_require__(274);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(388);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminBrandEdit = function (_Component) {
	  _inherits(AdminBrandEdit, _Component);
	
	  function AdminBrandEdit(props) {
	    _classCallCheck(this, AdminBrandEdit);
	
	    var _this = _possibleConstructorReturn(this, (AdminBrandEdit.__proto__ || Object.getPrototypeOf(AdminBrandEdit)).call(this, props));
	
	    _this.brandUpdated = _this.brandUpdated.bind(_this);
	    _this.onNewProduct = _this.onNewProduct.bind(_this);
	    _this.onSelectIndex = _this.onSelectIndex.bind(_this);
	    _this.onProductUpdated = _this.onProductUpdated.bind(_this);
	
	    _this.state = {
	      brand: _Api2.default.cache.getBrand(props.params.brandToken),
	      products: []
	    };
	    return _this;
	  }
	
	  _createClass(AdminBrandEdit, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.cache.addChangeListener(this.brandUpdated, _Api2.default.cache.eventTypes.BRANDS_CHANGED);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _Api2.default.getBrand(this.props.params.brandToken, true);
	
	      _Api2.default.getBrandProducts(this.props.params.brandToken).then(function (response) {
	        var products = response;
	        if (!products || products.length === 0) {
	          _this2.onNewProduct();
	        } else {
	          _this2.setState({
	            products: products,
	            selectedIndex: 0
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.brandUpdated, _Api2.default.cache.eventTypes.BRANDS_CHANGED);
	    }
	  }, {
	    key: 'brandUpdated',
	    value: function brandUpdated() {
	      this.setState({
	        brand: _Api2.default.cache.getBrand(this.props.params.brandToken)
	      });
	    }
	  }, {
	    key: 'onNewProduct',
	    value: function onNewProduct() {
	      var products = this.state.products || [];
	      products.push({
	        name: 'Product ' + products.length,
	        active: true,
	        short_description: null,
	        description: null,
	        wholesale_price_cents: null,
	        retail_price_cents: null,
	        unit_multiplier: null,
	        categories: [],
	        images: []
	      });
	
	      var selectedIndex = products.length - 1;
	
	      this.setState({
	        products: products,
	        selectedIndex: selectedIndex
	      });
	    }
	  }, {
	    key: 'onSelectIndex',
	    value: function onSelectIndex(index) {
	      this.setState({
	        selectedIndex: index
	      });
	    }
	  }, {
	    key: 'onProductUpdated',
	    value: function onProductUpdated(product) {
	      var products = this.state.products;
	      products[this.state.selectedIndex] = product;
	      this.setState({
	        products: products
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.brand) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'circle-o-notch', spin: true })
	        );
	      }
	
	      var productView = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactFontawesome2.default, { name: 'circle-o-notch', spin: true })
	      );
	      if (this.state.products) {
	        var products = this.state.products;
	        var selectedProduct = products[this.state.selectedIndex];
	        var selectedKey = selectedProduct && selectedProduct.token || 'new-product-key-' + this.state.selectedIndex;
	        productView = _react2.default.createElement(
	          'div',
	          { className: 'admin-brand-edit-products-container' },
	          _react2.default.createElement(_ProductList2.default, { onNew: this.onNewProduct,
	            onSelect: this.onSelectIndex,
	            selectedIndex: this.state.selectedIndex,
	            products: products,
	            keyName: 'name' }),
	          _react2.default.createElement(_ProductEditor2.default, { product: selectedProduct,
	            brandToken: this.props.params.brandToken,
	            brandName: this.state.brand && this.state.brand.name || null,
	            onUpdated: this.onProductUpdated,
	            updateOnKey: 'name',
	            key: selectedKey })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-brand-edit-component' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          this.state.brand.name
	        ),
	        _react2.default.createElement(
	          _reactTabs.Tabs,
	          null,
	          _react2.default.createElement(
	            _reactTabs.TabList,
	            null,
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              'Edit Brand'
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              'Edit Products'
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              'Edit Advanced'
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(_BrandEditor2.default, { brand: this.state.brand })
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            productView
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(_BrandLogisticsEditor2.default, { logistics: this.state.brand })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminBrandEdit;
	}(_react.Component);
	
	exports.default = AdminBrandEdit;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(73);
	
	var _AutoCompleteEditor = __webpack_require__(111);
	
	var _AutoCompleteEditor2 = _interopRequireDefault(_AutoCompleteEditor);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactDataGrid = __webpack_require__(56);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(78);
	
	var _DeleteRowContextMenu = __webpack_require__(339);
	
	var _DeleteRowContextMenu2 = _interopRequireDefault(_DeleteRowContextMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageFormatter = _reactDataGridAddons.Formatters.ImageFormatter;
	
	var AdminCollectionEdit = function (_React$Component) {
	  _inherits(AdminCollectionEdit, _React$Component);
	
	  function AdminCollectionEdit(props) {
	    _classCallCheck(this, AdminCollectionEdit);
	
	    var _this = _possibleConstructorReturn(this, (AdminCollectionEdit.__proto__ || Object.getPrototypeOf(AdminCollectionEdit)).call(this, props));
	
	    _this.onCollectionActiveChange = _this.onCollectionActiveChange.bind(_this);
	    _this.onCollectionNameChange = _this.onCollectionNameChange.bind(_this);
	    _this.onCollectionDescriptionChange = _this.onCollectionDescriptionChange.bind(_this);
	    _this.onCollectionImageUrlChange = _this.onCollectionImageUrlChange.bind(_this);
	
	    _this.state = {
	      brands: null,
	      products: null,
	      collection: null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(AdminCollectionEdit, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.loadCollection();
	    }
	  }, {
	    key: "loadCollection",
	    value: function loadCollection() {
	      var _this2 = this;
	
	      _Api2.default.getProductCollection(this.props.params.collectionToken).then(function (collectionsResponse) {
	        var collections = collectionsResponse.product_collections;
	        _this2.setState({
	          collection: collections && collections.length > 0 ? collections[0] : null,
	          brands: collectionsResponse.brands,
	          products: collectionsResponse.products
	        });
	      }, function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.context.router.push('/admin/collections');
	    }
	  }, {
	    key: "save",
	    value: function save() {
	      var _this3 = this;
	
	      _Api2.default.createOrUpdateProductCollection(this.state.collection).then(function () {
	        _this3.context.router.push('/admin/collections');
	      }, function (error) {
	        alert('Error saving collection: ' + error.message);
	      });
	    }
	  }, {
	    key: "onCollectionActiveChange",
	    value: function onCollectionActiveChange() {
	      var collection = this.state.collection;
	      collection.active = !collection.active;
	      this.setState({ collection: collection });
	    }
	  }, {
	    key: "onCollectionNameChange",
	    value: function onCollectionNameChange(event) {
	      var collection = this.state.collection;
	      collection.name = event.target.value;
	      this.setState({ collection: collection });
	    }
	  }, {
	    key: "onCollectionDescriptionChange",
	    value: function onCollectionDescriptionChange(event) {
	      var collection = this.state.collection;
	      collection.description = event.target.value;
	      this.setState({ collection: collection });
	    }
	  }, {
	    key: "onCollectionImageUrlChange",
	    value: function onCollectionImageUrlChange(event) {
	      var collection = this.state.collection;
	      collection.image = { url: event.target.value };
	      this.setState({ collection: collection });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.error) {
	        console.error(this.state.error);
	        return _react2.default.createElement(
	          "div",
	          { className: "error" },
	          "Error: ",
	          this.state.error.message
	        );
	      }
	
	      if (!this.state.collection) return _react2.default.createElement(_reactFontawesome2.default, { name: "refresh", spin: true });
	
	      var collection = this.state.collection;
	      var imageUrl = collection.image ? collection.image.url : null;
	      return _react2.default.createElement(
	        "div",
	        { className: "collection-editor" },
	        _react2.default.createElement(
	          "div",
	          null,
	          "Product Collection Editor"
	        ),
	        _react2.default.createElement(
	          "form",
	          { className: "collection-editor-form" },
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement(
	              "label",
	              null,
	              "Active: "
	            ),
	            _react2.default.createElement("input", { ref: "active", name: "active", type: "checkbox", checked: collection.active,
	              onChange: this.onCollectionActiveChange })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement(
	              "label",
	              null,
	              "Name: "
	            ),
	            _react2.default.createElement("input", { className: "input", ref: "name", defaultValue: collection.name, placeholder: "Name",
	              onChange: this.onCollectionNameChange })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement(
	              "label",
	              null,
	              "Description: "
	            ),
	            _react2.default.createElement("input", { className: "input", ref: "description", defaultValue: collection.description,
	              placeholder: "Description", onChange: this.onCollectionDescriptionChange })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group" },
	            _react2.default.createElement(
	              "label",
	              null,
	              "Image URL: "
	            ),
	            _react2.default.createElement("input", { className: "input", ref: "image", defaultValue: imageUrl, placeholder: "Image URL",
	              onChange: this.onCollectionImageUrlChange })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.save.bind(this) },
	              "Save"
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.cancel.bind(this) },
	              "Cancel / Go back"
	            )
	          )
	        ),
	        _react2.default.createElement(CollectionItemsGrid, {
	          collection: collection,
	          brands: this.state.brands,
	          products: this.state.products
	        })
	      );
	    }
	  }]);
	
	  return AdminCollectionEdit;
	}(_react2.default.Component);
	
	exports.default = AdminCollectionEdit;
	
	var CheckmarkFormatter = function (_React$Component2) {
	  _inherits(CheckmarkFormatter, _React$Component2);
	
	  function CheckmarkFormatter() {
	    _classCallCheck(this, CheckmarkFormatter);
	
	    return _possibleConstructorReturn(this, (CheckmarkFormatter.__proto__ || Object.getPrototypeOf(CheckmarkFormatter)).apply(this, arguments));
	  }
	
	  _createClass(CheckmarkFormatter, [{
	    key: "render",
	    value: function render() {
	      var className = this.props.value ? 'fa fa-check' : 'fa fa-close';
	      return _react2.default.createElement(
	        "div",
	        null,
	        " ",
	        _react2.default.createElement("span", { className: className }),
	        " "
	      );
	    }
	  }]);
	
	  return CheckmarkFormatter;
	}(_react2.default.Component);
	
	CheckmarkFormatter.propTypes = {
	  value: _propTypes2.default.any
	};
	
	var CollectionItemsGrid = function (_React$Component3) {
	  _inherits(CollectionItemsGrid, _React$Component3);
	
	  function CollectionItemsGrid(props) {
	    _classCallCheck(this, CollectionItemsGrid);
	
	    var _this5 = _possibleConstructorReturn(this, (CollectionItemsGrid.__proto__ || Object.getPrototypeOf(CollectionItemsGrid)).call(this, props));
	
	    _this5.state = {
	      collection: props.collection,
	      products: props.products,
	      brands: props.brands,
	      selectedIndexes: []
	    };
	
	    _this5.getColumns = _this5.getColumns.bind(_this5);
	    _this5.getAutoCompleteProducts = _this5.getAutoCompleteProducts.bind(_this5);
	    _this5.searchProducts = _this5.searchProducts.bind(_this5);
	    _this5.searchProductOptions = _this5.searchProductOptions.bind(_this5);
	    _this5.getRow = _this5.getRow.bind(_this5);
	    _this5.getRowCount = _this5.getRowCount.bind(_this5);
	    _this5.onGridRowUpdated = _this5.onGridRowUpdated.bind(_this5);
	    _this5.addRow = _this5.addRow.bind(_this5);
	    _this5.deleteRow = _this5.deleteRow.bind(_this5);
	
	    _this5.takenProductOptionTokens = {};
	    props.collection.items.forEach(function (item) {
	      _this5.takenProductOptionTokens[item.product_option_token] = true;
	    });
	
	    _this5.columns = [{
	      key: 'product_name',
	      name: 'Product Name',
	      width: 300,
	      resizable: true,
	      editor: _react2.default.createElement(_AutoCompleteEditor2.default, { options: _this5.getAutoCompleteProducts(),
	        search: _this5.searchProducts
	      })
	    }, {
	      key: 'product_option',
	      name: 'Product Option Name',
	      width: 270,
	      resizable: true,
	      editor: _react2.default.createElement(_AutoCompleteEditor2.default, { options: [], search: _this5.searchProductOptions })
	    }, {
	      key: 'quantity',
	      name: 'Quantity',
	      width: 90,
	      resizable: true,
	      editable: true
	    }, {
	      key: 'active',
	      name: 'Active?',
	      width: 75,
	      resizable: true,
	      formatter: CheckmarkFormatter
	    }, {
	      key: 'image_url',
	      name: 'Image',
	      width: 65,
	      resizable: false,
	      formatter: ImageFormatter
	    }, {
	      key: 'case_size',
	      name: 'Case',
	      width: 70,
	      resizable: true
	    }, {
	      key: 'wholesale_price',
	      name: 'Wholesale',
	      width: 90,
	      resizable: true
	    }, {
	      key: 'retail_price',
	      name: 'Retail',
	      width: 90,
	      resizable: true
	    }];
	    return _this5;
	  }
	
	  _createClass(CollectionItemsGrid, [{
	    key: "getAutoCompleteProducts",
	    value: function getAutoCompleteProducts() {
	      var _this6 = this;
	
	      var tokens = Object.keys(this.state.products);
	      var products = [];
	      tokens.forEach(function (token) {
	        var product = _this6.state.products[token];
	        products.push({
	          id: product.token,
	          value: product,
	          text: product.name,
	          title: product.name
	        });
	      });
	      return products;
	    }
	  }, {
	    key: "searchProducts",
	    value: function searchProducts(rowData, currentOptions, searchTerm, callback) {
	      var _this7 = this;
	
	      if (searchTerm.length < 2) {
	        callback(null, this.getAutoCompleteProducts());
	        return;
	      }
	
	      _Api2.default.getProducts(searchTerm, false).then(function (productsResponse) {
	        var products = [];
	        productsResponse.display_order.forEach(function (productToken) {
	          var product = productsResponse.products[productToken];
	          products.push({
	            id: productToken,
	            value: product,
	            text: product.name,
	            title: product.name
	          });
	        });
	        callback(null, products);
	      }, function (error) {
	        alert('Error finding products: ' + error.message);
	        callback(null, _this7.getAutoCompleteProducts());
	      });
	    }
	  }, {
	    key: "searchProductOptions",
	    value: function searchProductOptions(rowData, currentOptions, searchTerm, callback) {
	      var _this8 = this;
	
	      var options = [];
	      rowData.product.options.forEach(function (option) {
	        if (!_this8.takenProductOptionTokens[option.token]) {
	          options.push({
	            id: option.token,
	            value: option,
	            text: option.name,
	            title: option.name
	          });
	        }
	      });
	      callback(null, options);
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      return this.columns;
	    }
	  }, {
	    key: "getRow",
	    value: function getRow(index) {
	      var item = this.state.collection.items[index];
	      if (!item.product_token) {
	        // Empty new row!
	        return {
	          product: null,
	          product_name: 'Select product',
	          product_option: null,
	          active: false,
	          image_url: '',
	          case_size: null,
	          wholesale_price: null,
	          retail_price: null,
	          quantity: null
	        };
	      }
	
	      var product = this.state.products[item.product_token];
	      var productOption = null;
	      for (var i = 0; i < product.options.length; i++) {
	        if (product.options[i].token === item.product_option_token) {
	          productOption = product.options[i];
	          break;
	        }
	      }
	
	      var imageUrl = null;
	      if (productOption && productOption.images && productOption.images.length > 0) {
	        imageUrl = productOption.images[0].url;
	      }
	      if (imageUrl === null && product.images && product.images.length > 0) {
	        imageUrl = product.images[0].url;
	      }
	      if (imageUrl === null) {
	        for (var _i = 0; _i < product.options.length; _i++) {
	          var option = product.options[_i];
	          if (option.images && option.images.length > 0) {
	            imageUrl = option.images[0].url;
	            break;
	          }
	        }
	      }
	
	      var caseSize = null;
	      var wholesalePrice = null;
	      var retailPrice = null;
	      if (productOption) {
	        caseSize = productOption.unit_multiplier;
	        wholesalePrice = '$' + parseFloat(productOption.wholesale_price_cents / 100).toFixed(2);
	        retailPrice = '$' + parseFloat(productOption.retail_price_cents / 100).toFixed(2);
	      }
	
	      var brand = this.state.brands[item.brand_token];
	      var active = product && product.active && brand && brand.active;
	      return {
	        product: product,
	        product_name: product.name || '',
	        product_option: productOption ? productOption.name : '',
	        active: active,
	        image_url: imageUrl || '',
	        case_size: caseSize,
	        wholesale_price: wholesalePrice,
	        retail_price: retailPrice,
	        quantity: item.quantity || product.unit_multiplier
	      };
	    }
	  }, {
	    key: "getRowCount",
	    value: function getRowCount() {
	      return this.state.collection.items.length;
	    }
	  }, {
	    key: "onGridRowUpdated",
	    value: function onGridRowUpdated(_ref) {
	      var fromRow = _ref.fromRow,
	          toRow = _ref.toRow,
	          updated = _ref.updated;
	
	      var collection = this.state.collection;
	      var items = collection.items;
	      var products = this.state.products;
	
	      var changed = false;
	      for (var i = fromRow; i <= toRow; i++) {
	        if (updated.quantity) {
	          var newQuantity = parseInt(updated.quantity, 10);
	          if (items[i].quantity !== newQuantity) {
	            items[i].quantity = newQuantity;
	            changed = true;
	          }
	        }
	
	        if (updated.product_name) {
	          var product = updated.product_name;
	          if (items[i].product_token !== product.token) {
	
	            // Let's see if there are options available for the newly selected product!
	            var productOptionToken = null;
	            var unitMultiplier = 1;
	            for (var _i2 = 0; _i2 < product.options.length; _i2++) {
	              if (!this.takenProductOptionTokens[product.options[_i2].token]) {
	                productOptionToken = product.options[_i2].token;
	                unitMultiplier = product.options[_i2].unit_multiplier;
	                break;
	              }
	            }
	
	            if (productOptionToken) {
	              // Update available product option tokens.
	              this.takenProductOptionTokens[items[i].product_option_token] = false;
	              this.takenProductOptionTokens[productOptionToken] = true;
	
	              // Update the collection item
	              items[i] = {
	                token: null,
	                product: product,
	                product_token: product.token,
	                product_option_token: productOptionToken,
	                brand_token: product.brand_token,
	                quantity: unitMultiplier
	              };
	
	              products[product.token] = product;
	
	              changed = true;
	            } else {
	              alert('All product options for the selected product are already in the collection');
	            }
	          }
	        }
	
	        if (updated.product_option) {
	          if (items[i].product_option_token !== updated.product_option.token) {
	            // Update available product option tokens.
	            this.takenProductOptionTokens[items[i].product_option_token] = false;
	            this.takenProductOptionTokens[updated.product_option.token] = true;
	
	            // Update the collection item
	            items[i].product_option_token = updated.product_option.token;
	            items[i].token = null;
	
	            changed = true;
	          }
	        }
	      }
	
	      if (!changed) return;
	
	      collection.items = items;
	      this.setState({
	        collection: collection,
	        products: products
	      });
	
	      _Api2.default.createOrUpdateProductCollection(collection).then(function () {}, function (error) {
	        alert('Error saving collection: ' + error.message);
	      });
	    }
	  }, {
	    key: "addRow",
	    value: function addRow() {
	      var items = this.state.collection.items;
	      items.push({
	        product: null,
	        product_token: null,
	        product_option_token: null,
	        brand_token: null,
	        quantity: 1
	      });
	      this.setState({ items: items });
	    }
	  }, {
	    key: "deleteRow",
	    value: function deleteRow(e, _ref2) {
	      var rowIdx = _ref2.rowIdx;
	
	      var collection = this.state.collection;
	
	      // Mark the product option as available
	      var productOptionToken = collection.items[rowIdx].product_option_token;
	      this.takenProductOptionTokens[productOptionToken] = false;
	
	      // Remove the item from the current items.
	      collection.items.splice(rowIdx, 1);
	      this.setState({ collection: collection });
	
	      _Api2.default.createOrUpdateProductCollection(collection).then(function () {}, function (error) {
	        alert('Error saving collection: ' + error.message);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactDataGrid2.default, {
	        contextMenu: _react2.default.createElement(_DeleteRowContextMenu2.default, { onRowDelete: this.deleteRow }),
	        columns: this.getColumns(),
	        rowGetter: this.getRow,
	        rowsCount: this.getRowCount(),
	        onGridRowsUpdated: this.onGridRowUpdated,
	        toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { onAddRow: this.addRow }),
	        enableCellSelect: true,
	        enableRowSelect: false,
	        rowHeight: 50,
	        minHeight: 600,
	        rowScrollTimeout: 200
	      });
	    }
	  }]);
	
	  return CollectionItemsGrid;
	}(_react2.default.Component);
	
	CollectionItemsGrid.propTypes = {
	  collection: _propTypes2.default.object.isRequired,
	  brands: _propTypes2.default.object.isRequired,
	  products: _propTypes2.default.object.isRequired
	};
	
	
	AdminCollectionEdit.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(73);
	
	var _reactRouter = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminCollections = function (_React$Component) {
	  _inherits(AdminCollections, _React$Component);
	
	  function AdminCollections(props) {
	    _classCallCheck(this, AdminCollections);
	
	    var _this = _possibleConstructorReturn(this, (AdminCollections.__proto__ || Object.getPrototypeOf(AdminCollections)).call(this, props));
	
	    _this.state = {
	      collectionsResponse: null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(AdminCollections, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.refreshCollections();
	    }
	  }, {
	    key: "createCollection",
	    value: function createCollection() {
	      var _this2 = this;
	
	      var newCollection = { name: 'New product collection' };
	      _Api2.default.createOrUpdateProductCollection(newCollection).then(function (createdProductCollection) {
	        _this2.context.router.push("/admin/collections/" + createdProductCollection.token);
	      }, function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: "refreshCollections",
	    value: function refreshCollections() {
	      var _this3 = this;
	
	      _Api2.default.getProductCollections().then(function (collectionsResponse) {
	        _this3.setState({
	          collectionsResponse: collectionsResponse
	        });
	      }, function (error) {
	        _this3.setState({ error: error });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.error) {
	        console.error(this.state.error);
	        return _react2.default.createElement(
	          "div",
	          { className: "error" },
	          "Error: ",
	          this.state.error.message
	        );
	      }
	
	      var collectionsList = void 0;
	      var header = void 0;
	      if (!this.state.collectionsResponse) {
	        collectionsList = _react2.default.createElement(_reactFontawesome2.default, { name: "refresh", spin: true });
	      } else {
	        header = _react2.default.createElement(
	          "div",
	          { key: "header", className: "collection-list-entry" },
	          _react2.default.createElement(
	            "span",
	            { className: "active" },
	            "Active?"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "items" },
	            "Items"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "name" },
	            "Name"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "description" },
	            "Description"
	          )
	        );
	
	        collectionsList = this.state.collectionsResponse.product_collections.map(function (collection) {
	          var token = collection.token;
	          var activeClass = "active " + (collection.active ? "fa fa-check" : "");
	          var items = collection.items ? collection.items.length : 0;
	          var name = collection.name || '';
	          var description = collection.description || '';
	
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { key: "edit-" + token, to: "/admin/collections/" + token },
	            _react2.default.createElement(
	              "div",
	              { key: token, className: "collection-list-entry" },
	              _react2.default.createElement("span", { className: activeClass }),
	              _react2.default.createElement(
	                "span",
	                { className: "items" },
	                items
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "name" },
	                name
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "description" },
	                description
	              )
	            )
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "collection-list" },
	        _react2.default.createElement(
	          _AdminTitle2.default,
	          { title: "Product Collections" },
	          _react2.default.createElement("input", { type: "button", className: "button button--small",
	            onClick: this.createCollection.bind(this), value: "Create Collection" })
	        ),
	        header,
	        collectionsList
	      );
	    }
	  }]);
	
	  return AdminCollections;
	}(_react2.default.Component);
	
	exports.default = AdminCollections;
	
	
	AdminCollections.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(389);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminEmails = function (_React$Component) {
	  _inherits(AdminEmails, _React$Component);
	
	  function AdminEmails(props) {
	    _classCallCheck(this, AdminEmails);
	
	    var _this = _possibleConstructorReturn(this, (AdminEmails.__proto__ || Object.getPrototypeOf(AdminEmails)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onEmailClick = _this.onEmailClick.bind(_this);
	
	    _this.state = {
	      emails: null,
	      nextRequest: null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(AdminEmails, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.searchEmails(false);
	    }
	  }, {
	    key: "searchEmails",
	    value: function searchEmails(more) {
	      var _this2 = this;
	
	      var request = {};
	      var loadingMore = false;
	      if (more && this.state.nextRequest) {
	        request = this.state.nextRequest;
	        loadingMore = true;
	      }
	
	      _Api2.default.searchEmails(request).then(function (response) {
	        var emails = _this2.state.emails ? _this2.state.emails : [];
	        emails = loadingMore ? emails.concat(response.emails) : response.emails;
	
	        _this2.setState({
	          emails: emails,
	          nextRequest: response.next
	        });
	      }, function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(event) {
	      var payload = {};
	      payload[event.target.name] = event.target.value;
	      this.setState(payload);
	    }
	  }, {
	    key: "onEmailClick",
	    value: function onEmailClick(token) {
	      window.open("/api/email/view/" + token + "/html", '_blank').focus();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      if (this.state.error) {
	        console.error(this.state.error.message);
	        return _react2.default.createElement(
	          "div",
	          { className: "error" },
	          "Error: ",
	          this.state.error.message
	        );
	      }
	
	      var emailList = void 0;
	      var header = void 0;
	      if (!this.state.emails) {
	        emailList = _react2.default.createElement(_reactFontawesome2.default, { name: "refresh", spin: true });
	      } else {
	        header = _react2.default.createElement(
	          "div",
	          { key: "header", className: "email-list-entry" },
	          _react2.default.createElement(
	            "span",
	            { className: "to" },
	            "To"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "template" },
	            "Template"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "send-at" },
	            "Send At"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "sent-at" },
	            "Sent At"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "bounced-at" },
	            "Bounced At"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "delivered-at" },
	            "Delivered At"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "first-opened-at" },
	            "First Opened At"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "last-opened-at" },
	            "Last Opened At"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "open-count" },
	            "Open Count"
	          )
	        );
	        emailList = this.state.emails.map(function (email) {
	          var token = email.token;
	          var name = email.to_name || '';
	          var emailAddress = email.to_email_address || '';
	          var template = email.template;
	          var sendAt = email.send_at ? (0, _moment2.default)(email.send_at).format('MM/DD') : '-';
	          var sentAt = email.sent_at ? (0, _moment2.default)(email.sent_at).format('MM/DD') : '-';
	          var bouncedAt = email.bounced_at ? (0, _moment2.default)(email.bounced_at).format('MM/DD') : '-';
	          var deliveredAt = email.delivered_at ? (0, _moment2.default)(email.delivered_at).format('MM/DD') : '-';
	          var firstOpenedAt = email.first_opened_at ? (0, _moment2.default)(email.first_opened_at).format('MM/DD') : '-';
	          var lastOpenedAt = email.last_opened_at ? (0, _moment2.default)(email.last_opened_at).format('MM/DD') : '-';
	          var openCount = email.open_count;
	
	          return _react2.default.createElement(
	            "div",
	            { key: token, onClick: _this3.onEmailClick.bind(_this3, token), className: "email-list-entry link" },
	            _react2.default.createElement(
	              "span",
	              { className: "to" },
	              name,
	              " - ",
	              emailAddress
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "template" },
	              template
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "send-at" },
	              sendAt
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "sent-at" },
	              sentAt
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "bounced-at" },
	              bouncedAt
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "delivered-at" },
	              deliveredAt
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "first-opened-at" },
	              firstOpenedAt
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "last-opened-at" },
	              lastOpenedAt
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "open-count" },
	              openCount
	            )
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "email-list" },
	        _react2.default.createElement(_AdminTitle2.default, { title: "Outgoing Emails" }),
	        header,
	        emailList,
	        _react2.default.createElement(
	          _Button2.default,
	          { key: 'load-more-button', onClick: this.searchEmails.bind(this, true) },
	          "Load More"
	        )
	      );
	    }
	  }]);
	
	  return AdminEmails;
	}(_react2.default.Component);
	
	exports.default = AdminEmails;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _AdminFunctions = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminProduct = function (_Component) {
	  _inherits(AdminProduct, _Component);
	
	  function AdminProduct() {
	    _classCallCheck(this, AdminProduct);
	
	    var _this = _possibleConstructorReturn(this, (AdminProduct.__proto__ || Object.getPrototypeOf(AdminProduct)).call(this));
	
	    _this.refreshProduct = _this.refreshProduct.bind(_this);
	
	    _this.state = {
	      brand: null,
	      product: null
	    };
	    return _this;
	  }
	
	  _createClass(AdminProduct, [{
	    key: 'refreshProduct',
	    value: function refreshProduct() {
	      var _this2 = this;
	
	      _Api2.default.getProductCache(this.props.params.productId).then(function (response) {
	        var product = response.products[_this2.props.params.productId];
	        var brand = response.brands[product.brand_token];
	
	        _this2.setState({ product: product, brand: brand });
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.refreshProduct();
	      _Api2.default.cache.addChangeListener(this.refreshProduct, _Api2.default.cache.eventTypes.PRODUCTS_CHANGED);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.refreshProduct, _Api2.default.cache.eventTypes.PRODUCTS_CHANGED);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.brand || !this.state.product) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'page-loading' },
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'circle-o-notch', spin: true })
	        );
	      }
	      var brand = this.state.brand;
	      var product = this.state.product;
	
	      var categories = (product.categories || []).join(', ');
	
	      var images = (product.images || []).map(function (image) {
	        var imageUrl = image.url.indexOf('http') === 0 ? image.url : 'http://' + image.url;
	        var imageKey = image !== null ? image.token : null;
	        return _react2.default.createElement('img', { className: 'admin-product-thumbnail', key: imageKey, src: imageUrl, alt: product.name });
	      });
	
	      var options = (0, _AdminFunctions.optionTree)(this.state.brand.token, this.state.product);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _AdminTitle2.default,
	          { title: brand.name + ' / ' + product.name },
	          _react2.default.createElement(
	            _Button2.default,
	            { to: '/admin/brand/' + brand.token },
	            'Back to brand'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { to: '/admin/brand/' + brand.token + '/product/' + product.token + '/edit' },
	            'Edit Product'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'admin-product' },
	          _react2.default.createElement(
	            'div',
	            { className: 'admin-product-section' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              product.name
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'short-description' },
	              product.short_description
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'description' },
	              product.description
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'categories' },
	              categories
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'admin-product-thumbnails admin-product-section' },
	            images
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'options' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Options'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              options
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _Button2.default,
	                { to: '/admin/brand/' + brand.token + '/product/' + product.token + '/option/new' },
	                'Add Option'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminProduct;
	}(_react.Component);
	
	exports.default = AdminProduct;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminProductOptionEdit = function (_React$Component) {
	  _inherits(AdminProductOptionEdit, _React$Component);
	
	  function AdminProductOptionEdit() {
	    _classCallCheck(this, AdminProductOptionEdit);
	
	    return _possibleConstructorReturn(this, (AdminProductOptionEdit.__proto__ || Object.getPrototypeOf(AdminProductOptionEdit)).apply(this, arguments));
	  }
	
	  _createClass(AdminProductOptionEdit, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var productToken = this.props.params.productId;
	      var optionToken = this.props.params.optionId;
	
	      _Api.Utils.bindThis(this, ['goBack', 'cancelButton', 'saveButton']);
	
	      var defaultOption = null;
	
	      if (!optionToken) {
	        defaultOption = {
	          name: '',
	          brand_code: '',
	          description: '',
	          group_name: '',
	          parent_token: '',
	          images: []
	        };
	      }
	
	      var self = this;
	
	      _Api2.default.getProductCache(productToken).then(function (response) {
	        var product = response.products[productToken];
	        self.setState({ product: product });
	      }, function (error) {
	        console.error(error);
	      });
	
	      _Api2.default.getProductOption(productToken, optionToken).then(function (option) {
	        self.setState({
	          loading: false,
	          option: option
	        });
	      }, function (err) {
	        self.setState({
	          loading: false
	        });
	      });
	
	      this.state = {
	        loading: defaultOption == null,
	        product: null,
	        option: defaultOption
	      };
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.context.router.goBack();
	    }
	  }, {
	    key: 'cancelButton',
	    value: function cancelButton() {
	      // TODO: ask if we're sure to cancel if there are any changes.
	      this.goBack();
	    }
	  }, {
	    key: 'saveButton',
	    value: function saveButton() {
	      var payload = _Api.Utils.getFormValues(this, ['name', 'brand_code', 'description', 'group_name', 'parent_token']);
	
	      if (this.props.params.optionId) {
	        payload.token = this.props.params.optionId;
	      }
	
	      payload.group_name = payload.group_name ? payload.group_name : '';
	
	      // Images
	      var imageValues = this.refs.urls.value;
	      if (imageValues && imageValues.length > 0) {
	        payload.images = imageValues.split('\n').map(function (url) {
	          return { url: url };
	        });
	      }
	
	      var ret = _Api2.default.saveProductOption(this.state.product.token, payload);
	      ret.then(this.goBack);
	
	      return ret;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.state.loading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'loading...'
	        );
	      }
	
	      if (this.state.option === null) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'invalid option!'
	        );
	      }
	
	      var option = this.state.option;
	
	      var selectOptions = [];
	      selectOptions.push(_react2.default.createElement(
	        'option',
	        { key: 'empty-parent-token', value: '' },
	        '-'
	      ));
	      if (this.state.product) {
	        (this.state.product.options || []).filter(function (option) {
	          return option.token !== _this2.props.params.optionId;
	        }).forEach(function (option) {
	          selectOptions.push(_react2.default.createElement(
	            'option',
	            { key: option.token,
	              value: option.token },
	            option.group_name,
	            ': ',
	            option.name
	          ));
	        });
	      }
	
	      var imageUrls = [];
	      if (option.images && option.images.length > 0) {
	        option.images.forEach(function (image) {
	          imageUrls.push(image.url);
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'options-editor' },
	        _react2.default.createElement(
	          'div',
	          null,
	          'Options Editor'
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'admin-form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Group name (Optional)'
	            ),
	            _react2.default.createElement('input', { className: 'input', ref: 'group_name', defaultValue: option.group_name,
	              placeholder: 'Optional Group Name (e.g., Color)' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Option name (Optional)'
	            ),
	            _react2.default.createElement('input', { className: 'input', ref: 'name', defaultValue: option.name || 'default',
	              placeholder: 'Optional Name (e.g., Blue)' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'SKU # (Optional)'
	            ),
	            _react2.default.createElement('input', { className: 'input', ref: 'brand_code', defaultValue: option.brand_code, placeholder: 'SKU#' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Parent Option (Optional)'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-combobox' },
	              _react2.default.createElement(
	                'select',
	                { ref: 'parent_token', defaultValue: option.parent_token || '' },
	                selectOptions
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form-textarea' },
	            _react2.default.createElement('textarea', { ref: 'urls', placeholder: 'image urls', defaultValue: imageUrls.join('\n') })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.cancelButton },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.saveButton },
	              'Save'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminProductOptionEdit;
	}(_react2.default.Component);
	
	exports.default = AdminProductOptionEdit;
	
	
	AdminProductOptionEdit.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactTabs = __webpack_require__(274);
	
	var _Orders = __webpack_require__(112);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminQueue = function (_React$Component) {
	  _inherits(AdminQueue, _React$Component);
	
	  function AdminQueue(props) {
	    _classCallCheck(this, AdminQueue);
	
	    var _this = _possibleConstructorReturn(this, (AdminQueue.__proto__ || Object.getPrototypeOf(AdminQueue)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {
	      orders: null
	    };
	    return _this;
	  }
	
	  _createClass(AdminQueue, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var orders = _Api2.default.cache.getOrderList();
	      if (orders) {
	        this.setState(orders);
	      } else {
	        this.loadOrders();
	      }
	    }
	  }, {
	    key: 'loadOrders',
	    value: function loadOrders() {
	      var _this2 = this;
	
	      _Api2.default.getOrders().then(function (orders) {
	        _this2.setState(orders);
	      }, function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var payload = {};
	      payload[event.target.name] = event.target.value;
	      this.setState(payload);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'order-list' },
	        _react2.default.createElement(_AdminTitle2.default, { title: 'Queue' }),
	        _react2.default.createElement(
	          _reactTabs.Tabs,
	          null,
	          _react2.default.createElement(
	            _reactTabs.TabList,
	            null,
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              'New Orders'
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              'Waiting On Shipping'
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              'Shipped'
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              'Requested Returns'
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            this.filterOrders('WAITING_ON_ORDER')
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            this.filterOrders('WAITING_ON_SHIPPING')
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            this.filterOrders('SHIPPED')
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            this.filterOrders('RETURN_REQUESTED')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'filterOrders',
	    value: function filterOrders(orderItemState) {
	      var _this3 = this;
	
	      var orders = void 0;
	      if (!this.state.orders) {
	        orders = _react2.default.createElement(_reactFontawesome2.default, { name: 'refresh', spin: true });
	      } else {
	        var orderList = this.state.orders;
	        orders = orderList.filter(function (order) {
	          return order.items.filter(function (item) {
	            return item.state === orderItemState;
	          }).length > 0 && order.state !== 'FAILED' && order.state !== 'CANCELED';
	        }).map(function (order) {
	          return _react2.default.createElement(_Orders.OrderItem, { key: order.token, order: order, retailers: _this3.state.retailers, users: _this3.state.users,
	            loadOrders: _this3.loadOrders });
	        });
	      }
	      return orders;
	    }
	  }]);
	
	  return AdminQueue;
	}(_react2.default.Component);
	
	exports.default = AdminQueue;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(73);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _AutoCompleteEditor = __webpack_require__(111);
	
	var _AutoCompleteEditor2 = _interopRequireDefault(_AutoCompleteEditor);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGrid = __webpack_require__(56);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _reactDataGridAddons = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckboxEditor = _reactDataGridAddons.Editors.CheckboxEditor;
	var ImageFormatter = _reactDataGridAddons.Formatters.ImageFormatter;
	
	var Selectors = _reactDataGridAddons.Data.Selectors;
	var ContextMenu = _reactDataGridAddons.Menu.ContextMenu;
	var MenuItem = _reactDataGridAddons.Menu.MenuItem;
	
	var AdminCollectionEdit = function (_React$Component) {
	  _inherits(AdminCollectionEdit, _React$Component);
	
	  function AdminCollectionEdit(props) {
	    _classCallCheck(this, AdminCollectionEdit);
	
	    var _this = _possibleConstructorReturn(this, (AdminCollectionEdit.__proto__ || Object.getPrototypeOf(AdminCollectionEdit)).call(this, props));
	
	    _this.onGridSort = _this.onGridSort.bind(_this);
	    _this.onAddFilter = _this.onAddFilter.bind(_this);
	    _this.onClearFilters = _this.onClearFilters.bind(_this);
	    _this.searchBrands = _this.searchBrands.bind(_this);
	    _this.getColumns = _this.getColumns.bind(_this);
	    _this.getRowCount = _this.getRowCount.bind(_this);
	    _this.getRows = _this.getRows.bind(_this);
	    _this.getRow = _this.getRow.bind(_this);
	    _this.onGridRowUpdated = _this.onGridRowUpdated.bind(_this);
	    _this.onCellChange = _this.onCellChange.bind(_this);
	    _this.getBrandData = _this.getBrandData.bind(_this);
	    _this.updateEmails = _this.updateEmails.bind(_this);
	    _this.emailToRow = _this.emailToRow.bind(_this);
	
	    _this.state = {
	      rows: [],
	      filters: {},
	      sortColumn: null,
	      sortDirection: null,
	      loading: true
	    };
	
	    _this.columns = [{
	      key: 'send',
	      name: 'Send?',
	      width: 80,
	      formatter: _react2.default.createElement(CheckboxEditor, { onCellChange: _this.onCellChange }),
	      onCellChange: _this.onCellChange,
	      sortable: true
	    }, {
	      key: 'user_name',
	      name: 'Customer',
	      width: 150,
	      resizable: true,
	      filterable: true,
	      sortable: true
	    }, {
	      key: 'retailer_name',
	      name: 'Retailer',
	      width: 150,
	      resizable: true,
	      filterable: true,
	      sortable: true
	    }, {
	      key: 'subject',
	      name: 'Subject',
	      width: 90,
	      resizable: true,
	      editable: true,
	      filterable: true,
	      sortable: true
	    }, {
	      key: 'last_sent_at',
	      name: 'Last sent at',
	      width: 110,
	      resizable: true,
	      sortable: true
	    }, {
	      key: 'send_at',
	      name: 'Send at (' + _Api.Utils.getTimezoneCode() + ')',
	      width: 160,
	      resizable: true,
	      editable: true,
	      filterable: true,
	      sortable: true
	    }, {
	      key: 'brand1',
	      name: 'Brand 1',
	      width: 100,
	      resizable: true,
	      editor: _react2.default.createElement(_AutoCompleteEditor2.default, { options: [], search: _this.searchBrands }),
	      filterable: true,
	      sortable: true
	    }, {
	      key: 'brand1_image_url',
	      name: 'Img1',
	      width: 55,
	      resizable: false,
	      formatter: ImageFormatter
	    }, {
	      key: 'brand1_description',
	      name: 'Description 1',
	      width: 100,
	      resizable: true
	    }, {
	      key: 'brand2',
	      name: 'Brand 2',
	      width: 100,
	      resizable: true,
	      editor: _react2.default.createElement(_AutoCompleteEditor2.default, { options: [], search: _this.searchBrands }),
	      filterable: true,
	      sortable: true
	    }, {
	      key: 'brand2_image_url',
	      name: 'Img2',
	      width: 55,
	      resizable: false,
	      formatter: ImageFormatter
	    }, {
	      key: 'brand2_description',
	      name: 'Description 2',
	      width: 100,
	      resizable: true
	    }, {
	      key: 'brand3',
	      name: 'Brand 3',
	      width: 100,
	      resizable: true,
	      editor: _react2.default.createElement(_AutoCompleteEditor2.default, { options: [], search: _this.searchBrands }),
	      filterable: true,
	      sortable: true
	    }, {
	      key: 'brand3_image_url',
	      name: 'Img3',
	      width: 55,
	      resizable: false,
	      formatter: ImageFormatter
	    }, {
	      key: 'brand3_description',
	      name: 'Description 3',
	      width: 100,
	      resizable: true
	    }, {
	      key: 'brand4',
	      name: 'Brand 4',
	      width: 100,
	      resizable: true,
	      editor: _react2.default.createElement(_AutoCompleteEditor2.default, { options: [], search: _this.searchBrands }),
	      filterable: true,
	      sortable: true
	    }, {
	      key: 'brand4_image_url',
	      name: 'Img4',
	      width: 55,
	      resizable: false,
	      formatter: ImageFormatter
	    }, {
	      key: 'brand4_description',
	      name: 'Description 4',
	      width: 100,
	      resizable: true
	    }];
	    return _this;
	  }
	
	  _createClass(AdminCollectionEdit, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.loadPendingEmails(null);
	    }
	  }, {
	    key: "loadPendingEmails",
	    value: function loadPendingEmails(request) {
	      var _this2 = this;
	
	      this.setState({ loading: true });
	
	      if (!request) {
	        // Reset all current rows.
	        this.setState({ rows: [] });
	      }
	
	      _Api2.default.getPendingRecommendationEmails(request).then(function (response) {
	        var newRows = [];
	        var index = _this2.state.rows.length;
	        response.pending_emails.forEach(function (email) {
	          newRows.push(_this2.emailToRow(email, index));
	          index++;
	        });
	
	        var rows = _this2.state.rows.concat(newRows);
	        _this2.setState({ rows: rows });
	        if (response.next_request) {
	          // Keep loading!
	          _this2.loadPendingEmails(response.next_request);
	        } else {
	          _this2.setState({ loading: false });
	        }
	      }, function (error) {
	        alert(error.message);
	      });
	    }
	  }, {
	    key: "onGridSort",
	    value: function onGridSort(sortColumn, sortDirection) {
	      this.setState({ sortColumn: sortColumn, sortDirection: sortDirection });
	    }
	  }, {
	    key: "onAddFilter",
	    value: function onAddFilter(filter) {
	      var newFilters = Object.assign({}, this.state.filters);
	      if (filter.filterTerm) {
	        newFilters[filter.column.key] = filter;
	      } else {
	        delete newFilters[filter.column.key];
	      }
	
	      this.setState({ filters: newFilters });
	    }
	  }, {
	    key: "onClearFilters",
	    value: function onClearFilters() {
	      this.setState({ filters: {} });
	    }
	  }, {
	    key: "searchBrands",
	    value: function searchBrands(rowData, currentOptions, searchTerm, callback) {
	      if (searchTerm.length < 2) {
	        callback(null, []);
	        return;
	      }
	
	      _Api2.default.getBrands(searchTerm, true).then(function (brands) {
	        var results = [];
	        brands.forEach(function (brand) {
	          results.push({
	            id: brand.token,
	            value: brand,
	            text: brand.name,
	            title: brand.name
	          });
	        });
	        callback(null, results);
	      }, function (error) {
	        alert('Error finding brands: ' + error.message);
	        callback(null, []);
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      return this.columns;
	    }
	  }, {
	    key: "getRowCount",
	    value: function getRowCount() {
	      return this.getRows().length;
	    }
	  }, {
	    key: "getRows",
	    value: function getRows() {
	      return Selectors.getRows(this.state);
	    }
	  }, {
	    key: "getRow",
	    value: function getRow(index) {
	      var rows = this.getRows();
	      return rows[index];
	    }
	  }, {
	    key: "emailToRow",
	    value: function emailToRow(email, index) {
	      var brand1 = void 0;
	      var brand1ImageUrl = '';
	      var description1 = '';
	      if (email.selected_brands.length > 0) {
	        var brand = email.selected_brands[0];
	        brand1 = brand.name;
	        brand1ImageUrl = brand.email_hero_image_url || '';
	        description1 = brand.email_description;
	      }
	
	      var brand2 = void 0;
	      var brand2ImageUrl = '';
	      var description2 = '';
	      if (email.selected_brands.length > 1) {
	        var _brand = email.selected_brands[1];
	        brand2 = _brand.name;
	        brand2ImageUrl = _brand.email_hero_image_url || '';
	        description2 = _brand.email_description;
	      }
	
	      var brand3 = void 0;
	      var brand3ImageUrl = '';
	      var description3 = '';
	      if (email.selected_brands.length > 2) {
	        var _brand2 = email.selected_brands[2];
	        brand3 = _brand2.name;
	        brand3ImageUrl = _brand2.email_hero_image_url || '';
	        description3 = _brand2.email_description;
	      }
	
	      var brand4 = void 0;
	      var brand4ImageUrl = '';
	      var description4 = '';
	      if (email.selected_brands.length > 3) {
	        var _brand3 = email.selected_brands[3];
	        brand4 = _brand3.name;
	        brand4ImageUrl = _brand3.email_hero_image_url || '';
	        description4 = _brand3.email_description;
	      }
	
	      return {
	        index: index,
	        email: email,
	        token: email.token,
	        send: email.send,
	        user_name: email.user_name,
	        retailer_token: email.retailer_token,
	        retailer_name: email.retailer_name,
	        retailer_url: email.retailer_url,
	        subject: email.subject,
	        last_sent_at: email.last_sent_at ? _Api.Utils.millisToYMD(email.last_sent_at) : 'Never',
	        send_at: _Api.Utils.millisToDateAndTime(email.send_at),
	        brand1: brand1,
	        brand1_image_url: brand1ImageUrl,
	        brand1_description: description1,
	        brand2: brand2,
	        brand2_image_url: brand2ImageUrl,
	        brand2_description: description2,
	        brand3: brand3,
	        brand3_image_url: brand3ImageUrl,
	        brand3_description: description3,
	        brand4: brand4,
	        brand4_image_url: brand4ImageUrl,
	        brand4_description: description4
	      };
	    }
	  }, {
	    key: "onGridRowUpdated",
	    value: function onGridRowUpdated(_ref) {
	      var fromRow = _ref.fromRow,
	          toRow = _ref.toRow,
	          updated = _ref.updated;
	
	      if (this.state.loading) {
	        alert('Please waiting until we are done loading all emails before making changes');
	        return;
	      }
	
	      var allRows = this.state.rows;
	      var displayedRows = this.getRows();
	      var updatedEmails = [];
	
	      for (var rowIndex = fromRow; rowIndex <= toRow; rowIndex++) {
	        var email = displayedRows[rowIndex].email;
	
	        if (updated.subject) {
	          email.subject = updated.subject;
	        }
	        if (updated.send_at) {
	          var sendAt = new Date(updated.send_at);
	          email.send_at = sendAt.getTime();
	        }
	        if (updated.brand1) {
	          email.selected_brands[0] = this.getBrandData(updated.brand1);
	        }
	        if (updated.brand2) {
	          email.selected_brands[1] = this.getBrandData(updated.brand2);
	        }
	        if (updated.brand3) {
	          email.selected_brands[2] = this.getBrandData(updated.brand3);
	        }
	        if (updated.brand4) {
	          email.selected_brands[3] = this.getBrandData(updated.brand4);
	        }
	        var globalIndex = displayedRows[rowIndex].index;
	        var updatedRow = this.emailToRow(email, globalIndex);
	        displayedRows[rowIndex] = updatedRow;
	        allRows[globalIndex] = updatedRow;
	        updatedEmails.push(email);
	      }
	
	      this.setState({ rows: allRows });
	
	      this.updateEmails(updatedEmails);
	    }
	  }, {
	    key: "onCellChange",
	    value: function onCellChange(rowIndex, key) {
	      if (key === 'send') {
	        if (this.state.loading) {
	          alert('Please waiting until we are done loading all emails before making changes');
	          return;
	        }
	        var displayedRows = this.getRows();
	        var email = displayedRows[rowIndex].email;
	        email.send = !email.send;
	
	        var allRows = this.state.rows;
	        var globalIndex = displayedRows[rowIndex].index;
	        var updatedRow = this.emailToRow(email, globalIndex);
	        displayedRows[rowIndex] = updatedRow;
	        allRows[globalIndex] = updatedRow;
	
	        this.setState({ rows: allRows });
	
	        this.updateEmails([email]);
	      }
	    }
	  }, {
	    key: "getBrandData",
	    value: function getBrandData(brand) {
	      return {
	        token: brand.token,
	        name: brand.name,
	        url: brand.url,
	        email_hero_image_url: brand.email_hero_image ? brand.email_hero_image.url : null,
	        email_description: brand.email_description
	      };
	    }
	  }, {
	    key: "updateEmails",
	    value: function updateEmails(emails) {
	      _Api2.default.updatePendingRecommendationEmails(emails).then(function () {}, function (error) {
	        alert(error.message);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var loadingSpinner = this.state.loading ? _react2.default.createElement(_reactFontawesome2.default, { name: "refresh", spin: true }) : null;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "recommendation-emails-list" },
	        loadingSpinner,
	        _react2.default.createElement(_reactDataGrid2.default, {
	          contextMenu: _react2.default.createElement(EmailContextMenu, { getRow: this.getRow }),
	          toolbar: _react2.default.createElement(_reactDataGridAddons.Toolbar, { enableFilter: true }),
	          onGridSort: this.onGridSort,
	          onAddFilter: this.onAddFilter,
	          onClearFilters: this.onClearFilters,
	          columns: this.getColumns(),
	          rowGetter: this.getRow,
	          rowsCount: this.getRowCount(),
	          onGridRowsUpdated: this.onGridRowUpdated,
	          enableRowSelect: false,
	          enableCellSelect: true,
	          rowHeight: 55,
	          minHeight: 1000,
	          rowScrollTimeout: 200
	        })
	      );
	    }
	  }]);
	
	  return AdminCollectionEdit;
	}(_react2.default.Component);
	
	exports.default = AdminCollectionEdit;
	
	var EmailContextMenu = function (_React$Component2) {
	  _inherits(EmailContextMenu, _React$Component2);
	
	  function EmailContextMenu(props) {
	    _classCallCheck(this, EmailContextMenu);
	
	    var _this3 = _possibleConstructorReturn(this, (EmailContextMenu.__proto__ || Object.getPrototypeOf(EmailContextMenu)).call(this, props));
	
	    _this3.onSendEmail = _this3.onSendEmail.bind(_this3);
	    _this3.onViewEmail = _this3.onViewEmail.bind(_this3);
	    _this3.onViewRetailerMarketplace = _this3.onViewRetailerMarketplace.bind(_this3);
	    _this3.onViewRetailerWebsite = _this3.onViewRetailerWebsite.bind(_this3);
	    return _this3;
	  }
	
	  _createClass(EmailContextMenu, [{
	    key: "onSendEmail",
	    value: function onSendEmail(e, data) {
	      var email = this.props.getRow(data.rowIdx);
	      _Api2.default.sendEmail(email.token);
	    }
	  }, {
	    key: "onViewEmail",
	    value: function onViewEmail(e, data) {
	      var email = this.props.getRow(data.rowIdx);
	      window.open("/api/email/view/" + email.token + "/html", '_blank').focus();
	    }
	  }, {
	    key: "onViewRetailerMarketplace",
	    value: function onViewRetailerMarketplace(e, data) {
	      var email = this.props.getRow(data.rowIdx);
	      window.open("/retailer/" + email.retailer_token, '_blank').focus();
	    }
	  }, {
	    key: "onViewRetailerWebsite",
	    value: function onViewRetailerWebsite(e, data) {
	      var email = this.props.getRow(data.rowIdx);
	      if (email.retailer_url) {
	        window.open(email.retailer_url, '_blank').focus();
	      } else {
	        alert('We do not have a URL for the selected retailer');
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        ContextMenu,
	        { identifier: "context=menu" },
	        _react2.default.createElement(
	          MenuItem,
	          { data: { rowIdx: this.props.rowIdx, idx: this.props.idx },
	            onClick: this.onSendEmail },
	          "Send Email to myself!"
	        ),
	        _react2.default.createElement(
	          MenuItem,
	          { data: { rowIdx: this.props.rowIdx, idx: this.props.idx },
	            onClick: this.onViewEmail },
	          "View Email on the web"
	        ),
	        _react2.default.createElement(
	          MenuItem,
	          { data: { rowIdx: this.props.rowIdx, idx: this.props.idx },
	            onClick: this.onViewRetailerMarketplace },
	          "View Retailer recommendations"
	        ),
	        _react2.default.createElement(
	          MenuItem,
	          { data: { rowIdx: this.props.rowIdx, idx: this.props.idx },
	            onClick: this.onViewRetailerWebsite },
	          "View Retailer website"
	        )
	      );
	    }
	  }]);
	
	  return EmailContextMenu;
	}(_react2.default.Component);
	
	EmailContextMenu.propTypes = {
	  getRow: _propTypes2.default.func.isRequired,
	  rowIdx: _propTypes2.default.any,
	  idx: _propTypes2.default.any
	};

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactSelect = __webpack_require__(27);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminTools = function (_Component) {
	  _inherits(AdminTools, _Component);
	
	  function AdminTools(props) {
	    _classCallCheck(this, AdminTools);
	
	    var _this = _possibleConstructorReturn(this, (AdminTools.__proto__ || Object.getPrototypeOf(AdminTools)).call(this, props));
	
	    _this.impersonateUser = _this.impersonateUser.bind(_this);
	    _this.importBrand = _this.importBrand.bind(_this);
	    _this.backfill = _this.backfill.bind(_this);
	    _this.onBackfillerChange = _this.onBackfillerChange.bind(_this);
	
	    _this.state = {
	      backfillers: [],
	      selectedBackfillerName: null
	    };
	    return _this;
	  }
	
	  _createClass(AdminTools, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _Api2.default.getBackfillers().then(function (backfillerNames) {
	        var backfillers = [];
	        backfillerNames.forEach(function (backfillerName) {
	          backfillers.push({ label: backfillerName, value: backfillerName });
	        });
	        _this2.setState({ backfillers: backfillers });
	      }, function (error) {
	        if (error.httpStatusCode >= 500) {
	          _this2.setState({ error: 'Server error processing request' });
	        } else {
	          _this2.setState({ error: 'Error: ' + error.message });
	        }
	      });
	    }
	  }, {
	    key: "impersonateUser",
	    value: function impersonateUser() {
	      var _this3 = this;
	
	      var userToken = this.refs["impersonate_user_token"].value.trim();
	      if (!userToken || !userToken.startsWith("u_")) {
	        console.log("Invalid user token: " + userToken);
	        return;
	      }
	
	      console.log("Impersonating user token: " + userToken);
	
	      return _Api2.default.impersonateUserByToken(userToken).then(function () {
	        _this3.context.router.push('/');
	      }, function (error) {
	        console.log("Error impersonating user: " + error.response.message);
	      });
	    }
	  }, {
	    key: "importBrand",
	    value: function importBrand() {
	      var _this4 = this;
	
	      var brandUrl = this.refs["brand_url"].value.trim();
	      var brandName = this.refs["brand_name"].value;
	
	      return _Api2.default.importBrand(brandUrl, brandName).then(function (brand) {
	        if (brand && brand.token) {
	          alert("Already imported " + JSON.stringify(brand, null, 2));
	        } else {
	          alert("Brand importing in progress");
	        }
	      }, function (error) {
	        if (error.httpStatusCode >= 500) {
	          _this4.setState({ error: 'Server error processing request' });
	        } else {
	          _this4.setState({ error: 'Error: ' + error.message });
	        }
	      });
	    }
	  }, {
	    key: "onBackfillerChange",
	    value: function onBackfillerChange(selectedBackfiller) {
	      this.setState({ selectedBackfillerName: selectedBackfiller.value });
	    }
	  }, {
	    key: "backfill",
	    value: function backfill() {
	      var _this5 = this;
	
	      if (!this.state.selectedBackfillerName) {
	        alert('No backfiller selected!');
	        return;
	      }
	
	      var name = this.state.selectedBackfillerName;
	      var dryRun = this.refs["dry_run"].value === 'true';
	      var minId = Number(this.refs["min_id"].value) || null;
	      var maxId = Number(this.refs["max_id"].value) || null;
	      var windowSize = Number(this.refs["window_size"].value) || null;
	
	      return _Api2.default.backfill(name, dryRun, minId, maxId, windowSize).then(function (message) {
	        alert(message);
	      }, function (error) {
	        if (error.httpStatusCode >= 500) {
	          _this5.setState({ error: 'Server error processing request' });
	        } else {
	          _this5.setState({ error: 'Error: ' + error.message });
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "tools" },
	        _react2.default.createElement(
	          "div",
	          { className: "tool-section" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Impersonate User"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              "User token: ",
	              _react2.default.createElement("input", { className: "input", ref: "impersonate_user_token", placeholder: "u_a0b1c2d3" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _Button2.default,
	                { onClick: this.impersonateUser },
	                "Impersonate"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "tool-section" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Import Brand"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              "Brand URL: ",
	              _react2.default.createElement("input", { className: "input", ref: "brand_url", placeholder: "http://example.com" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Brand Name: ",
	              _react2.default.createElement("input", { className: "input", ref: "brand_name", placeholder: "Example" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _Button2.default,
	                { onClick: this.importBrand },
	                "Import"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(CsvLeads, null),
	        _react2.default.createElement(
	          "div",
	          { className: "tool-section" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Backfill"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              null,
	              "Backfiller: ",
	              _react2.default.createElement(_reactSelect2.default, { name: "backfiller-name",
	                options: this.state.backfillers,
	                onChange: this.onBackfillerChange,
	                clearable: false,
	                searchable: true,
	                value: this.state.selectedBackfillerName })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Dry Run: ",
	              _react2.default.createElement(
	                "select",
	                { ref: "dry_run" },
	                _react2.default.createElement(
	                  "option",
	                  { value: "true" },
	                  "True"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "false" },
	                  "False"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Min ID: ",
	              _react2.default.createElement("input", { className: "input", ref: "min_id", placeholder: "(Optional) Min ID" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Max ID: ",
	              _react2.default.createElement("input", { className: "input", ref: "max_id", placeholder: "(Optional) Max ID" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Window Size: ",
	              _react2.default.createElement("input", { className: "input", ref: "window_size", placeholder: "(Optional) Window Size" })
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _Button2.default,
	                { onClick: this.backfill },
	                "Backfill"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminTools;
	}(_react.Component);
	
	exports.default = AdminTools;
	
	
	AdminTools.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	var CsvLeads = function (_React$Component) {
	  _inherits(CsvLeads, _React$Component);
	
	  function CsvLeads(props) {
	    _classCallCheck(this, CsvLeads);
	
	    var _this6 = _possibleConstructorReturn(this, (CsvLeads.__proto__ || Object.getPrototypeOf(CsvLeads)).call(this, props));
	
	    _this6.state = {
	      working: false,
	      output: ''
	    };
	
	    _this6.work = _this6.work.bind(_this6);
	    return _this6;
	  }
	
	  _createClass(CsvLeads, [{
	    key: "work",
	    value: function work() {
	      var _this7 = this;
	
	      this.setState({
	        working: true,
	        output: ''
	      });
	
	      var self = this;
	      var lines = this.refs.csvleads.value.split('\n');
	
	      var returnPromise = new Promise(function (accept, reject) {
	        var curIdx = 0;
	
	        function next() {
	          if (curIdx >= lines.length) {
	            accept();
	            return;
	          }
	
	          var currentLine = lines[curIdx++];
	          var ret = null;
	          if (currentLine === '') {
	            ret = Promise.resolve(null);
	          } else {
	            ret = _Api2.default.retailerFromLead(currentLine);
	            ret.then(function (retailer) {
	              var newOutput = self.state.output;
	              if (newOutput.length > 0) newOutput += '\n';
	
	              var leadUrl = document.location.origin + "?retailer_token=" + retailer.token + "&campaign=1";
	              newOutput += currentLine + ',' + retailer.token + ',' + leadUrl;
	              self.setState({ output: newOutput });
	            }, function (error) {
	              var newOutput = self.state.output;
	              if (newOutput.length > 0) newOutput += '\n';
	
	              var errorMessage = 'ERROR';
	              if (typeof error.message === 'string') {
	                errorMessage = error.message;
	              } else if (_typeof(error.message === 'object')) {
	                errorMessage = error.message._key;
	              }
	
	              newOutput += currentLine + ',' + errorMessage;
	              self.setState({ output: newOutput });
	            });
	          }
	
	          ret.then(next, next);
	
	          return ret;
	        }
	
	        next();
	      });
	
	      returnPromise.then(function () {
	        _this7.setState({ working: false });
	        alert('CSV processing done.');
	      });
	
	      return returnPromise;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "tool-section" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "CSV Leads"
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("textarea", { ref: "csvleads", cols: "80", rows: "10", readOnly: this.state.working })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("textarea", { ref: "csvleads_output", cols: "80", rows: "10", value: this.state.output, readOnly: true })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.work },
	            "Start"
	          )
	        )
	      );
	    }
	  }]);
	
	  return CsvLeads;
	}(_react2.default.Component);

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _LiveSearch = __webpack_require__(68);
	
	var _LiveSearch2 = _interopRequireDefault(_LiveSearch);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminHome = function (_Component) {
	  _inherits(AdminHome, _Component);
	
	  function AdminHome() {
	    _classCallCheck(this, AdminHome);
	
	    var _this = _possibleConstructorReturn(this, (AdminHome.__proto__ || Object.getPrototypeOf(AdminHome)).call(this));
	
	    _Api.Utils.bindThis(_this, ['executeSearch', 'onActiveOnlyChange', 'onSearchChange', 'refresh']);
	
	    _this.state = {
	      brands: [],
	      search: '',
	      waitingSearch: false,
	      activeOnly: false,
	      searchResults: []
	    };
	    return _this;
	  }
	
	  _createClass(AdminHome, [{
	    key: 'refresh',
	    value: function refresh() {
	      var _this2 = this;
	
	      _Api2.default.getBrands().then(function (response) {
	        _this2.setState({
	          brands: response
	        });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refresh();
	    }
	  }, {
	    key: 'onActiveOnlyChange',
	    value: function onActiveOnlyChange() {
	      this.setState({ activeOnly: this.refs['active_only'].checked });
	    }
	  }, {
	    key: 'onSearchChange',
	    value: function onSearchChange(value) {
	      var payload = { search: value };
	      if (value === '') payload.searchResults = [];
	      this.setState(payload);
	    }
	  }, {
	    key: 'executeSearch',
	    value: function executeSearch() {
	      var _this3 = this;
	
	      if (this.state.search.length === 0) return;
	
	      _Api2.default.getBrands(this.state.search, this.state.activeOnly).then(function (response) {
	        _this3.setState({
	          waitingSearch: false,
	          searchResults: response
	        });
	      });
	
	      this.setState({ waitingSearch: true });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.search.trim() !== prevState.search.trim() || this.state.activeOnly !== prevState.activeOnly) {
	        if (this.state.search.trim().length > 0) this.executeSearch();
	      }
	
	      if (this.state.activeOnly !== prevState.activeOnly) {
	        this.refresh();
	      }
	    }
	  }, {
	    key: 'contents',
	    value: function contents() {
	      var brands = [];
	
	      if (this.state.search.length === 0) {
	        brands = this.state.brands;
	      } else {
	        brands = this.state.searchResults;
	      }
	
	      return brands.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      }).map(function (brand) {
	        var inactiveStatus = null;
	        var link = '/admin/brand/' + brand.token + '/edit';
	
	        var imageUrl = void 0;
	        if (brand.images && brand.images.length > 0) {
	          imageUrl = brand.images[0].url;
	        }
	
	        var brandImage = null;
	        if (brand.images && brand.images.length > 0) {
	          brandImage = _react2.default.createElement('img', { role: 'presentation', src: brand.images[0].url });
	        }
	
	        if (brand.active === false) inactiveStatus = _react2.default.createElement(_reactFontawesome2.default, { name: 'exclamation-circle' });
	        return _react2.default.createElement(
	          'span',
	          { key: brand.token, className: 'brand-list-item brand-' + brand.token },
	          _react2.default.createElement(
	            'div',
	            { className: 'brand-image' + (!!brandImage ? '' : ' hidden') },
	            brandImage
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'brand-line-1' },
	            _react2.default.createElement(
	              'span',
	              { className: 'brand-status-icon' },
	              inactiveStatus
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'commission' },
	              brand.commission_bps ? parseFloat(brand.commission_bps / 100).toFixed(2) + '%' : ''
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: link, className: 'brand-name' },
	              brand.name
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'brand-image' + (!!imageUrl ? '' : ' hidden') },
	              _react2.default.createElement('img', { role: 'presentation',
	                src: imageUrl,
	                height: '15px' })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'brand-url' },
	              _react2.default.createElement(
	                'a',
	                { href: brand.url, target: '_blank' },
	                brand.url
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'brand-line-2' },
	            _react2.default.createElement(
	              'p',
	              null,
	              brand.description
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _AdminTitle2.default,
	          { title: 'Brand List' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/admin/create', className: 'button button--small' },
	            'New Brand'
	          )
	        ),
	        _react2.default.createElement(
	          _LiveSearch2.default,
	          { onChange: this.onSearchChange, waitingSearch: this.state.waitingSearch, placeholder: 'Search Brands' },
	          _react2.default.createElement(
	            'span',
	            { className: 'active-only-block' },
	            _react2.default.createElement('input', { type: 'checkbox', id: 'active_only', ref: 'active_only', onChange: this.onActiveOnlyChange }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'active_only' },
	              'Active Only'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'brand-list' },
	          this.contents()
	        )
	      );
	    }
	  }]);
	
	  return AdminHome;
	}(_react.Component);
	
	exports.default = AdminHome;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDataGridAddons = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContextMenu = _reactDataGridAddons.Menu.ContextMenu;
	var MenuItem = _reactDataGridAddons.Menu.MenuItem;
	
	var DeleteRowContextMenu = function (_React$Component) {
	  _inherits(DeleteRowContextMenu, _React$Component);
	
	  function DeleteRowContextMenu(props) {
	    _classCallCheck(this, DeleteRowContextMenu);
	
	    var _this = _possibleConstructorReturn(this, (DeleteRowContextMenu.__proto__ || Object.getPrototypeOf(DeleteRowContextMenu)).call(this, props));
	
	    _this.onRowDelete = _this.onRowDelete.bind(_this);
	    return _this;
	  }
	
	  _createClass(DeleteRowContextMenu, [{
	    key: "onRowDelete",
	    value: function onRowDelete(e, data) {
	      if (typeof this.props.onRowDelete === 'function') {
	        this.props.onRowDelete(e, data);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        ContextMenu,
	        { identifier: "context=menu" },
	        _react2.default.createElement(
	          MenuItem,
	          { data: { rowIdx: this.props.rowIdx, idx: this.props.idx },
	            onClick: this.onRowDelete },
	          "Delete Row"
	        )
	      );
	    }
	  }]);
	
	  return DeleteRowContextMenu;
	}(_react2.default.Component);
	
	DeleteRowContextMenu.propTypes = {
	  onRowDelete: _propTypes2.default.func.isRequired,
	  rowIdx: _propTypes2.default.any,
	  idx: _propTypes2.default.any
	};
	exports.default = DeleteRowContextMenu;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _LiveSearch = __webpack_require__(68);
	
	var _LiveSearch2 = _interopRequireDefault(_LiveSearch);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Retailer = function (_React$Component) {
	  _inherits(Retailer, _React$Component);
	
	  function Retailer() {
	    _classCallCheck(this, Retailer);
	
	    var _this = _possibleConstructorReturn(this, (Retailer.__proto__ || Object.getPrototypeOf(Retailer)).call(this));
	
	    _this.state = {
	      retailers: [],
	      search: '',
	      waitingSearch: false,
	      searchResults: []
	    };
	
	    _Api.Utils.bindThis(_this, ['onSearchChange', 'getRetailerLink', 'retailerList', 'executeSearch', 'impersonateRetailerOwner']);
	    return _this;
	  }
	
	  _createClass(Retailer, [{
	    key: 'executeSearch',
	    value: function executeSearch() {
	      var _this2 = this;
	
	      if (this.state.search.length === 0) return;
	
	      _Api2.default.getRetailers(this.state.search).then(function (response) {
	        _this2.setState({
	          waitingSearch: false,
	          searchResults: response
	        });
	      });
	
	      this.setState({ waitingSearch: true });
	    }
	  }, {
	    key: 'impersonateRetailerOwner',
	    value: function impersonateRetailerOwner(userToken) {
	      var _this3 = this;
	
	      console.log('Impersonating user token: ' + userToken);
	
	      return _Api2.default.impersonateUserByToken(userToken).then(function () {
	        _this3.context.router.push('/');
	      }, function (error) {
	        console.log("Error impersonating user: " + error.response.message);
	      });
	    }
	  }, {
	    key: 'onSearchChange',
	    value: function onSearchChange(value) {
	      var payload = {};
	      payload.search = value.trim();
	      if (payload.search.length === 0) payload.searchResults = [];
	
	      this.setState(payload);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      _Api2.default.getRetailers().then(function (response) {
	        _this4.setState({
	          retailers: response
	        });
	      });
	    }
	  }, {
	    key: 'getRetailerLink',
	    value: function getRetailerLink(retailer) {
	      var _this5 = this;
	
	      var link = '/admin/retailers/' + retailer.token;
	      var buttons = [];
	
	      buttons.push(_react2.default.createElement(
	        _Button2.default,
	        {
	          key: retailer.token + '-marketplace-button',
	          to: '/retailer/' + retailer.token },
	        'Marketplace'
	      ));
	
	      if (retailer.owner_user_token) {
	        buttons.push(_react2.default.createElement(
	          _Button2.default,
	          {
	            key: retailer.token + '-impersonate-button',
	            className: 'retailer-list-item-impersonate-button',
	            onClick: function onClick() {
	              return _this5.impersonateRetailerOwner(retailer.owner_user_token);
	            } },
	          'Impersonate'
	        ));
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { key: retailer.token },
	        _react2.default.createElement(
	          'div',
	          { className: 'retailer-list-item' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'retailer-list-item-description', key: retailer.token + '-description',
	              style: { cursor: 'pointer' }, to: link },
	            _react2.default.createElement(
	              'h4',
	              null,
	              retailer.name
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              retailer.description
	            )
	          ),
	          buttons
	        )
	      );
	    }
	  }, {
	    key: 'retailerList',
	    value: function retailerList() {
	      var _this6 = this;
	
	      var ret = [];
	
	      if (this.state.search.length > 0) {
	        if (this.state.searchResults.length === 0 && this.state.waitingSearch) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'page-loading' },
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'circle-o-notch', spin: true })
	          );
	        } else if (this.state.searchResults.length === 0) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            'I can\'t find anything.'
	          );
	        }
	
	        ret = this.state.searchResults.map(function (retailer) {
	          return _this6.getRetailerLink(retailer);
	        });
	      } else {
	        ret = this.state.retailers.map(function (retailer) {
	          return _this6.getRetailerLink(retailer);
	        });
	      }
	
	      if (ret.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'page-loading' },
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'circle-o-notch', spin: true })
	        );
	      }
	
	      return ret;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // Updates the product list and search results based on changes to the search and activeOnly states.
	      if (this.state.activeOnly !== prevState.activeOnly || this.state.search.trim() !== prevState.search.trim()) {
	        if (this.state.search.trim().length > 0) this.executeSearch();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _AdminTitle2.default,
	          { title: 'Retailer List' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/admin/retailer/create', className: 'button button--small' },
	            'New Retailer'
	          )
	        ),
	        _react2.default.createElement(_LiveSearch2.default, { onChange: this.onSearchChange, waitingSearch: this.state.waitingSearch,
	          placeholder: 'Search Retailers' }),
	        this.retailerList()
	      );
	    }
	  }]);
	
	  return Retailer;
	}(_react2.default.Component);
	
	exports.default = Retailer;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _Utils = __webpack_require__(42);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactSelect = __webpack_require__(27);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminRetailerView = function (_React$Component) {
	  _inherits(AdminRetailerView, _React$Component);
	
	  function AdminRetailerView(props) {
	    _classCallCheck(this, AdminRetailerView);
	
	    var _this = _possibleConstructorReturn(this, (AdminRetailerView.__proto__ || Object.getPrototypeOf(AdminRetailerView)).call(this, props));
	
	    _this.reloadOutstandingPayments = _this.reloadOutstandingPayments.bind(_this);
	    _this.getOrders = _this.getOrders.bind(_this);
	    _this.getDisplayOrder = _this.getDisplayOrder.bind(_this);
	    _this.getDisplayShipmentsFor = _this.getDisplayShipmentsFor.bind(_this);
	    _this.getDisplayShipment = _this.getDisplayShipment.bind(_this);
	    _this.getDisplayOrderItemsFor = _this.getDisplayOrderItemsFor.bind(_this);
	    _this.getDisplayOrderItem = _this.getDisplayOrderItem.bind(_this);
	    _this.onChargeClicked = _this.onChargeClicked.bind(_this);
	    _this.onSelectAllCredit = _this.onSelectAllCredit.bind(_this);
	    _this.onSelectAllNet90 = _this.onSelectAllNet90.bind(_this);
	    _this.onClearSelection = _this.onClearSelection.bind(_this);
	
	    _this.findProductOption = _this.findProductOption.bind(_this);
	
	    _this.state = {
	      response: null,
	      error: null,
	      selectedAmountCents: 0,
	      selectedOrderTokens: {},
	      selectedShipmentTokens: {},
	      selectedOrderItemTokens: {}
	    };
	
	    _this.orderItems = {};
	    return _this;
	  }
	
	  _createClass(AdminRetailerView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.reloadOutstandingPayments();
	    }
	  }, {
	    key: "reloadOutstandingPayments",
	    value: function reloadOutstandingPayments() {
	      var _this2 = this;
	
	      this.setState({
	        response: null,
	        error: null,
	        selectedAmountCents: 0,
	        selectedOrderTokens: {},
	        selectedShipmentTokens: {},
	        selectedOrderItemTokens: {}
	      });
	
	      _Api2.default.getOutstandingIncomingPayments(this.props.params.retailerToken).then(function (response) {
	        // Map received order items.
	        _this2.orderItems = {};
	        response.order_items.forEach(function (orderItem) {
	          _this2.orderItems[orderItem.token] = orderItem;
	        });
	
	        // Reset state.
	        _this2.setState({
	          response: response,
	          error: null,
	          selectedAmountCents: 0,
	          selectedOrderTokens: {},
	          selectedShipmentTokens: {},
	          selectedOrderItemTokens: {}
	        });
	      }, function (error) {
	        if (error.httpStatusCode >= 500) {
	          _this2.setState({ error: 'Server error processing request' });
	        } else {
	          _this2.setState({ error: 'Error: ' + error.message });
	        }
	      });
	    }
	  }, {
	    key: "getOrders",
	    value: function getOrders(user) {
	      var _this3 = this;
	
	      return Object.keys(this.state.response.orders).map(function (orderToken) {
	        return _this3.getDisplayOrder(user, _this3.state.response.orders[orderToken]);
	      });
	    }
	  }, {
	    key: "getDisplayOrder",
	    value: function getDisplayOrder(user, order) {
	      var shipments = this.getDisplayShipmentsFor(order);
	      var orderItems = this.getDisplayOrderItemsFor(order);
	
	      var selected = this.state.selectedOrderTokens[order.token] === true;
	      var orderLink = "/admin/orders/" + order.token;
	
	      return _react2.default.createElement(
	        "div",
	        { key: order.token },
	        _react2.default.createElement("hr", null),
	        _react2.default.createElement("input", {
	          type: "checkbox",
	          value: order.token,
	          checked: selected,
	          onChange: this.onOrderSelectedChanged.bind(this, order.token, !selected)
	        }),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: orderLink, target: "_blank" },
	          "Order ",
	          order.token
	        ),
	        " created at ",
	        _Utils2.default.millisToYMD(order.created_at),
	        shipments.displayShipments,
	        orderItems.displayOrderItems,
	        _react2.default.createElement(PaymentSelector, {
	          user: user,
	          orderToken: order.token,
	          shipmentTokens: shipments.shipmentTokens,
	          orderItemTokens: orderItems.orderItemTokens,
	          totalCents: shipments.totalCents + orderItems.totalCents,
	          onChargeClicked: this.onChargeClicked
	        })
	      );
	    }
	  }, {
	    key: "onOrderSelectedChanged",
	    value: function onOrderSelectedChanged(orderToken, selected) {
	      var selectedOrderTokens = this.state.selectedOrderTokens;
	      var selectedShipmentTokens = this.state.selectedShipmentTokens;
	      var selectedOrderItemTokens = this.state.selectedOrderItemTokens;
	      var selectedAmountCents = this.state.selectedAmountCents;
	
	      selectedOrderTokens[orderToken] = selected;
	
	      var shipments = this.state.response.shipments;
	      for (var i = 0; i < shipments.length; i++) {
	        var shipment = shipments[i];
	        if (selected && !this.canPayForShipment(shipment)) continue;
	        if (shipment.order_token === orderToken) {
	          var currentSelection = selectedShipmentTokens[shipment.token] === true;
	          if (currentSelection === selected) continue;
	
	          var shipmentCostCents = shipment.cost_cents || 0;
	          selectedAmountCents += selected ? shipmentCostCents : -shipmentCostCents;
	          if (selected) {
	            selectedShipmentTokens[shipment.token] = selected;
	          } else {
	            delete selectedShipmentTokens[shipment.token];
	          }
	        }
	      }
	
	      var orderItems = this.state.response.order_items;
	      for (var _i = 0; _i < orderItems.length; _i++) {
	        var orderItem = orderItems[_i];
	        if (orderItem.order_token === orderToken) {
	          var _currentSelection = selectedOrderItemTokens[orderItem.token] === true;
	          if (_currentSelection === selected) continue;
	
	          selectedAmountCents += selected ? orderItem.total_cents : -orderItem.total_cents;
	          if (selected) {
	            selectedOrderItemTokens[orderItem.token] = selected;
	          } else {
	            delete selectedOrderItemTokens[orderItem.token];
	          }
	        }
	      }
	
	      this.setState({
	        selectedOrderTokens: selectedOrderTokens,
	        selectedShipmentTokens: selectedShipmentTokens,
	        selectedOrderItemTokens: selectedOrderItemTokens,
	        selectedAmountCents: selectedAmountCents
	      });
	    }
	  }, {
	    key: "getDisplayShipmentsFor",
	    value: function getDisplayShipmentsFor(order) {
	      var shipments = this.state.response.shipments;
	      var shipmentTokens = [];
	      var totalCents = 0;
	
	      var displayShipments = [];
	      for (var i = 0; i < shipments.length; i++) {
	        var shipment = shipments[i];
	        if (shipment.order_token !== order.token) continue;
	        shipmentTokens.push(shipment.token);
	        if (!shipment.free) {
	          totalCents += shipment.cost_cents || 0;
	        }
	
	        displayShipments.push(this.getDisplayShipment(shipment));
	      }
	      return { displayShipments: displayShipments, shipmentTokens: shipmentTokens, totalCents: totalCents };
	    }
	  }, {
	    key: "getDisplayShipment",
	    value: function getDisplayShipment(shipment) {
	      var displayCost = void 0;
	      var costCents = 0;
	      var selected = this.state.selectedShipmentTokens[shipment.token] === true;
	      if (shipment.free) {
	        displayCost = "Free (PROMO CODE)";
	      } else {
	        displayCost = shipment.cost_cents === undefined ? "Missing!" : shipment.cost_cents === 0 ? "Free" : "$" + _Utils2.default.formatCents(shipment.cost_cents);
	        costCents = shipment.cost_cents || 0;
	      }
	
	      var brandName = '';
	      for (var i = 0; i < shipment.order_item_tokens.length; i++) {
	        var orderItemToken = shipment.order_item_tokens[i];
	        if (this.orderItems[orderItemToken]) {
	          var orderItem = this.orderItems[orderItemToken];
	          var product = this.state.response.products[orderItem.product_token];
	          brandName = this.state.response.brands[product.brand_token].name;
	          break;
	        }
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { key: shipment.token },
	        _react2.default.createElement("input", {
	          type: "checkbox",
	          value: shipment.token,
	          checked: selected,
	          onChange: this.onShipmentSelectedChanged.bind(this, shipment, costCents, !selected)
	        }),
	        "Shipment ",
	        shipment.token,
	        " - ",
	        brandName,
	        " - delivered at ",
	        shipment.delivered_at ? _Utils2.default.millisToYMD(shipment.delivered_at) : "N/A",
	        " for ",
	        displayCost
	      );
	    }
	  }, {
	    key: "canPayForShipment",
	    value: function canPayForShipment(shipment) {
	      // We can pay for shipments once they were shipped (have a shipping date) and either have cost or are free.
	      return shipment.shipped_at !== undefined && (shipment.free === true || shipment.cost_cents !== undefined);
	    }
	  }, {
	    key: "onShipmentSelectedChanged",
	    value: function onShipmentSelectedChanged(shipment, shipmentCostCents, selected) {
	      var selectedAmountCents = this.state.selectedAmountCents;
	      var selectedShipmentTokens = this.state.selectedShipmentTokens;
	
	      if (selected && !this.canPayForShipment(shipment)) {
	        alert('Cannot select shipment ' + shipment.token + ' missing cost or shipping date');
	        return;
	      }
	
	      if (selected) {
	        selectedShipmentTokens[shipment.token] = selected;
	      } else {
	        delete selectedShipmentTokens[shipment.token];
	      }
	
	      selectedAmountCents += selected ? shipmentCostCents : -shipmentCostCents;
	      this.setState({ selectedAmountCents: selectedAmountCents, selectedShipmentTokens: selectedShipmentTokens });
	    }
	  }, {
	    key: "getDisplayOrderItemsFor",
	    value: function getDisplayOrderItemsFor(order) {
	      var orderItems = this.state.response.order_items;
	      var orderItemTokens = [];
	      var totalCents = 0;
	
	      var displayOrderItems = [];
	      for (var i = 0; i < orderItems.length; i++) {
	        var orderItem = orderItems[i];
	        if (orderItem.order_token !== order.token) continue;
	
	        orderItemTokens.push(orderItem.token);
	        totalCents += orderItem.total_cents;
	
	        displayOrderItems.push(this.getDisplayOrderItem(orderItem));
	      }
	      return { displayOrderItems: displayOrderItems, orderItemTokens: orderItemTokens, totalCents: totalCents };
	    }
	  }, {
	    key: "getDisplayOrderItem",
	    value: function getDisplayOrderItem(orderItem) {
	      var selected = this.state.selectedOrderItemTokens[orderItem.token] === true;
	      var displayCost = _Utils2.default.formatCents(orderItem.total_cents);
	      var product = this.state.response.products[orderItem.product_token];
	      var brand = this.state.response.brands[product.brand_token];
	      var productOption = this.findProductOption(product, orderItem.product_option_token);
	
	      return _react2.default.createElement(
	        "div",
	        { key: orderItem.token },
	        _react2.default.createElement("input", {
	          type: "checkbox",
	          value: orderItem.token,
	          checked: selected,
	          onChange: this.onOrderItemSelectedChanged.bind(this, orderItem, !selected)
	        }),
	        brand.name,
	        " - ",
	        product.name,
	        " - ",
	        productOption.name,
	        " - ",
	        orderItem.state,
	        " - ",
	        orderItem.quantity,
	        " X $",
	        _Utils2.default.formatCents(orderItem.price_cents),
	        " = $",
	        displayCost
	      );
	    }
	  }, {
	    key: "onOrderItemSelectedChanged",
	    value: function onOrderItemSelectedChanged(orderItem, selected) {
	      var selectedAmountCents = this.state.selectedAmountCents;
	      var selectedOrderItemTokens = this.state.selectedOrderItemTokens;
	
	      if (selected) {
	        selectedOrderItemTokens[orderItem.token] = selected;
	      } else {
	        delete selectedOrderItemTokens[orderItem.token];
	      }
	      selectedAmountCents += selected ? orderItem.total_cents : -orderItem.total_cents;
	
	      this.setState({ selectedAmountCents: selectedAmountCents, selectedOrderItemTokens: selectedOrderItemTokens });
	    }
	  }, {
	    key: "findProductOption",
	    value: function findProductOption(product, optionToken) {
	      for (var i = 0; i < product.options.length; i++) {
	        var option = product.options[i];
	        if (option.token === optionToken) return option;
	      }
	      return null;
	    }
	  }, {
	    key: "onChargeClicked",
	    value: function onChargeClicked(orderToken, instrumentToken) {
	      var _this4 = this;
	
	      var selectedShipmentTokens = [];
	      var selectedOrderItemTokens = [];
	      var totalCost = 0;
	
	      this.state.response.shipments.forEach(function (shipment) {
	        if (!orderToken || shipment.order_token === orderToken) {
	          if (_this4.state.selectedShipmentTokens[shipment.token] === true) {
	            selectedShipmentTokens.push(shipment.token);
	            if (!shipment.free) {
	              totalCost += shipment.cost_cents || 0;
	            }
	          }
	        }
	      });
	
	      this.state.response.order_items.forEach(function (orderItem) {
	        if (!orderToken || orderItem.order_token === orderToken) {
	          if (_this4.state.selectedOrderItemTokens[orderItem.token] === true) {
	            selectedOrderItemTokens.push(orderItem.token);
	            totalCost += orderItem.total_cents;
	          }
	        }
	      });
	
	      if (selectedShipmentTokens.length === 0 && selectedOrderItemTokens.length === 0) {
	        return; // nothing to do!
	      }
	
	      if (confirm("The customer will be charged $" + _Utils2.default.formatCents(totalCost) + "! Continue?") !== true) {
	        return;
	      }
	
	      var request = {
	        retailer_token: this.props.params.retailerToken,
	        instrument_token: instrumentToken,
	        shipment_tokens: selectedShipmentTokens,
	        order_item_tokens: selectedOrderItemTokens,
	        total_amount_cents: totalCost
	      };
	
	      return _Api2.default.chargeRetailer(request).then(function (payment) {
	        var failureReason = payment.failure_reason;
	        alert('Payment submitted. State = ' + payment.state + (failureReason ? '. Reason: ' + failureReason : ''));
	        if (payment.state !== 'FAILED') _this4.reloadOutstandingPayments();
	      }, function (error) {
	        if (error.httpStatusCode >= 500) {
	          alert('Server error processing request: ' + error.message);
	        } else {
	          alert('Error: ' + error.message);
	        }
	      });
	    }
	  }, {
	    key: "onSelectAllCredit",
	    value: function onSelectAllCredit() {
	      var _this5 = this;
	
	      var selectedOrderTokens = {};
	      var selectedShipmentTokens = {};
	      var selectedOrderItemTokens = {};
	      var selectedAmountCents = 0;
	
	      this.state.response.shipments.forEach(function (shipment) {
	        if (_this5.canPayForShipment(shipment)) {
	          selectedShipmentTokens[shipment.token] = true;
	          if (!shipment.free) {
	            selectedAmountCents += shipment.cost_cents || 0;
	          }
	        }
	      });
	
	      this.state.response.order_items.forEach(function (orderItem) {
	        if (orderItem.state === 'SHIPPED' || orderItem.state === 'DELIVERED') {
	          selectedOrderItemTokens[orderItem.token] = true;
	          selectedAmountCents += orderItem.total_cents;
	        }
	      });
	
	      this.setState({ selectedAmountCents: selectedAmountCents, selectedOrderTokens: selectedOrderTokens, selectedShipmentTokens: selectedShipmentTokens, selectedOrderItemTokens: selectedOrderItemTokens });
	    }
	  }, {
	    key: "onSelectAllNet90",
	    value: function onSelectAllNet90() {
	      var _this6 = this;
	
	      var selectedOrderTokens = {};
	      var selectedShipmentTokens = {};
	      var selectedOrderItemTokens = {};
	      var selectedAmountCents = 0;
	
	      this.state.response.shipments.forEach(function (shipment) {
	        if (_this6.canPayForShipment(shipment)) {
	          selectedShipmentTokens[shipment.token] = true;
	          if (!shipment.free) {
	            selectedAmountCents += shipment.cost_cents || 0;
	          }
	        }
	      });
	
	      var now = new Date();
	
	      this.state.response.order_items.forEach(function (orderItem) {
	        if (orderItem.state === 'SHIPPED' || orderItem.state === 'DELIVERED') {
	          var itemShippedAt = new Date(orderItem.shipped_at);
	
	          var daysSinceShipped = _Utils2.default.dateDiffInDays(now, itemShippedAt);
	          if (daysSinceShipped >= 90) {
	            selectedOrderItemTokens[orderItem.token] = true;
	            selectedAmountCents += orderItem.total_cents;
	          }
	        }
	      });
	
	      this.setState({ selectedAmountCents: selectedAmountCents, selectedOrderTokens: selectedOrderTokens, selectedShipmentTokens: selectedShipmentTokens, selectedOrderItemTokens: selectedOrderItemTokens });
	    }
	  }, {
	    key: "onClearSelection",
	    value: function onClearSelection() {
	      this.setState({
	        selectedAmountCents: 0,
	        selectedOrderTokens: {},
	        selectedShipmentTokens: {},
	        selectedOrderItemTokens: {}
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.error) return _react2.default.createElement(
	        "div",
	        null,
	        this.state.error
	      );
	
	      if (!this.state.response) return _react2.default.createElement(_reactFontawesome2.default, { name: "refresh", spin: true });
	
	      var retailer = this.state.response.retailer;
	      var shipmentCount = Object.keys(this.state.selectedShipmentTokens).length;
	      var totalShipmentCount = this.state.response.shipments.length;
	      var selectedShipments = "Shipments: " + shipmentCount + "/" + totalShipmentCount;
	
	      var totalOrderItemCount = this.state.response.order_items.length;
	      var orderItemCount = Object.keys(this.state.selectedOrderItemTokens).length;
	      var selectedOrderItems = "Order Items: " + orderItemCount + "/" + totalOrderItemCount;
	
	      var selectedTotal = "Total: $" + _Utils2.default.formatCents(this.state.selectedAmountCents);
	
	      var paymentDiv = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(PaymentSelector, {
	          user: this.state.response.user,
	          orderToken: null,
	          shipmentTokens: Object.keys(this.state.selectedShipmentTokens),
	          orderItemTokens: Object.keys(this.state.selectedOrderItemTokens),
	          totalCents: this.state.selectedAmountCents,
	          onChargeClicked: this.onChargeClicked
	        })
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_index2.default, { title: retailer.name + ' / Outstanding payments' }),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("br", null),
	          selectedShipments,
	          " ",
	          selectedOrderItems,
	          " ",
	          selectedTotal,
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.onClearSelection },
	            "Clear"
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.onSelectAllCredit },
	            "All Credit"
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.onSelectAllNet90 },
	            "All Net 90"
	          )
	        ),
	        paymentDiv,
	        this.getOrders(this.state.response.user)
	      );
	    }
	  }]);
	
	  return AdminRetailerView;
	}(_react2.default.Component);
	
	exports.default = AdminRetailerView;
	
	var PaymentSelector = function (_React$Component2) {
	  _inherits(PaymentSelector, _React$Component2);
	
	  function PaymentSelector(props) {
	    _classCallCheck(this, PaymentSelector);
	
	    var _this7 = _possibleConstructorReturn(this, (PaymentSelector.__proto__ || Object.getPrototypeOf(PaymentSelector)).call(this, props));
	
	    _this7.onInstrumentChange = _this7.onInstrumentChange.bind(_this7);
	    _this7.onChargeInstrument = _this7.onChargeInstrument.bind(_this7);
	
	    _this7.state = { selectedInstrumentToken: null };
	
	    var user = props.user;
	
	    _this7.instruments = user.instruments.map(function (instrument) {
	      var card = instrument.card;
	      var bankAccount = instrument.bank_account;
	
	      if (instrument.card) {
	        var brand = 'Card';
	        switch (card.brand) {
	          case 'VISA':
	            brand = 'Visa';
	            break;
	          case 'AMERICAN_EXPRESS':
	            brand = 'Amex';
	            break;
	          case 'MASTERCARD':
	            brand = 'Mastercard';
	            break;
	          case 'DISCOVER':
	            brand = 'Discover';
	            break;
	          case 'JCB':
	            brand = 'Jbc';
	            break;
	          case 'DINERS_CLUB':
	            brand = 'Diners';
	            break;
	          default:
	            brand = card.brand;
	            break;
	        }
	        return { label: brand + " " + card.last_four, value: instrument.token };
	      } else {
	        return { label: "Bank account " + bankAccount.account_number, value: instrument.token };
	      }
	    });
	
	    var selectedInstrumentToken = null;
	    if (_this7.instruments.length > 0) {
	      selectedInstrumentToken = user.instruments[0].token;
	    }
	    _this7.state = { selectedInstrumentToken: selectedInstrumentToken };
	    return _this7;
	  }
	
	  _createClass(PaymentSelector, [{
	    key: "onInstrumentChange",
	    value: function onInstrumentChange(selected) {
	      this.setState({ selectedInstrumentToken: selected.value });
	    }
	  }, {
	    key: "onChargeInstrument",
	    value: function onChargeInstrument() {
	      this.props.onChargeClicked(this.props.orderToken, this.state.selectedInstrumentToken);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.instruments.length === 0) return _react2.default.createElement(
	        "span",
	        null,
	        "No instrument linked!"
	      );
	
	      var selectedInstrumentToken = this.state.selectedInstrumentToken;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactSelect2.default, { name: "instrument",
	          options: this.instruments,
	          onChange: this.onInstrumentChange,
	          clearable: false,
	          searchable: false,
	          value: selectedInstrumentToken }),
	        _react2.default.createElement(
	          _Button2.default,
	          { onClick: this.onChargeInstrument },
	          "Charge instrument"
	        )
	      );
	    }
	  }]);
	
	  return PaymentSelector;
	}(_react2.default.Component);

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _AdminTitle = __webpack_require__(19);
	
	var _AdminTitle2 = _interopRequireDefault(_AdminTitle);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	__webpack_require__(392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var orderItemStates = ['WAITING_ON_ORDER', 'CANCELED', 'WAITING_ON_SHIPPING', 'SHIPPED', 'DELIVERED', 'RETURN_REQUESTED', 'RETURNED', 'BACKORDERED'];
	
	var shippingProviders = {
	  'default': 'None',
	  'canada_post': 'Canada Post',
	  'dhl_ecommerce': 'DHL eCommerce',
	  'dhl_express': 'DHL Express',
	  'fedex': 'FedEx',
	  'purolator': 'Purolator',
	  'ups': 'UPS',
	  'usps': 'USPS'
	};
	
	function findByToken(token, list) {
	  return list.find(function (item) {
	    return item.token === token;
	  });
	}
	
	var SingleOrder = function (_React$Component) {
	  _inherits(SingleOrder, _React$Component);
	
	  function SingleOrder(props) {
	    _classCallCheck(this, SingleOrder);
	
	    var _this = _possibleConstructorReturn(this, (SingleOrder.__proto__ || Object.getPrototypeOf(SingleOrder)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['checkItem', 'clearChecked', 'onOrderItemChanged', 'onOrderItemUpdate', 'onOrderItemCancelEditing', 'updateOrderItem', 'cancelItems', 'removeItems', 'newShipment', 'updateBrandOrder', 'createOrUpdateShipment', 'removeShipment', 'getProducts', 'getBrandOrders', 'getShipments', 'getPayments']);
	
	    _this.state = {
	      editingItem: null,
	      order: null,
	      orders: null,
	      checkedItems: []
	    };
	    return _this;
	  }
	
	  _createClass(SingleOrder, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.reloadOrder();
	    }
	  }, {
	    key: 'reloadOrder',
	    value: function reloadOrder() {
	      var _this2 = this;
	
	      return _Api2.default.getOrder(this.props.params.orderToken).then(function (ordersResponse) {
	        _this2.setState({
	          order: ordersResponse.orders[0],
	          orders: ordersResponse,
	          checkedItems: []
	        });
	      });
	    }
	  }, {
	    key: 'clearChecked',
	    value: function clearChecked() {
	      this.setState({ checkedItems: [] });
	    }
	  }, {
	    key: 'checkItem',
	    value: function checkItem(event) {
	      var items = _Api.Utils.clone(this.state.checkedItems);
	      if (event.target.checked) {
	        items.push(event.target.value);
	      } else {
	        items = items.filter(function (item) {
	          return item !== event.target.value;
	        });
	      }
	
	      this.setState({ checkedItems: items });
	    }
	  }, {
	    key: 'cancelItems',
	    value: function cancelItems() {
	      var _this3 = this;
	
	      return _Api2.default.cancelOrderItems(this.state.order.token, this.state.checkedItems).then(function () {
	        return _this3.reloadOrder();
	      }, function (error) {
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'removeItems',
	    value: function removeItems() {
	      var _this4 = this;
	
	      return _Api2.default.removeOrderItems(this.state.order.token, this.state.checkedItems).then(function () {
	        return _this4.reloadOrder();
	      }, function (error) {
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'onEditOrderItemClick',
	    value: function onEditOrderItemClick(item) {
	      var editingItem = {
	        'token': item.token,
	        'brand_token': item.brand_token,
	        'name': item.name,
	        'state': item.state,
	        'expected_ship_date': item.expected_ship_date,
	        'price_cents': item.price_cents,
	        'quantity': item.quantity
	      };
	
	      this.setState({
	        editingItem: editingItem
	      });
	    }
	  }, {
	    key: 'onOrderItemChanged',
	    value: function onOrderItemChanged(event) {
	      var editingItem = _Api.Utils.clone(this.state.editingItem);
	
	      var fieldName = event.target.name;
	      if (fieldName === 'expected_ship_date') {
	        editingItem['shipDate'] = event.target.value;
	      } else {
	        editingItem[fieldName] = event.target.value;
	      }
	
	      this.setState({ editingItem: editingItem });
	    }
	  }, {
	    key: 'onOrderItemUpdate',
	    value: function onOrderItemUpdate() {
	      var _this5 = this;
	
	      var editingItem = this.state.editingItem;
	      if (editingItem.shipDate && editingItem.shipDate !== '') {
	        editingItem.expected_ship_date = new Date(editingItem.shipDate).getTime();
	      }
	      editingItem.shipDate = null;
	      return _Api2.default.updateOrderItem(this.state.order.token, editingItem).then(function () {
	        _this5.onOrderItemCancelEditing();
	        return _this5.reloadOrder();
	      }, function (error) {
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'updateOrderItem',
	    value: function updateOrderItem(orderItem) {
	      var _this6 = this;
	
	      var payload = orderItem;
	      if (orderItem.shipDate && orderItem.shipDate !== '') {
	        payload.expected_ship_date = new Date(orderItem.shipDate).getTime();
	      }
	
	      delete payload.shipDate;
	
	      return _Api2.default.updateOrderItem(this.state.order.token, payload).then(function () {
	        return _this6.reloadOrder();
	      }, function (error) {
	        console.error(error);
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'onOrderItemCancelEditing',
	    value: function onOrderItemCancelEditing() {
	      this.setState({
	        editingItem: null
	      });
	    }
	  }, {
	    key: 'updateBrandOrder',
	    value: function updateBrandOrder(brandOrder) {
	      var _this7 = this;
	
	      var returnValue = _Api2.default.updateBrandOrder(this.state.order.token, brandOrder);
	      returnValue.then(function () {
	        return _this7.reloadOrder();
	      });
	
	      return returnValue;
	    }
	  }, {
	    key: 'newShipment',
	    value: function newShipment() {
	      var order = this.state.order;
	      var newShipment = {
	        order_token: order.token,
	        order_item_tokens: this.state.checkedItems
	      };
	      if (order.shipments) {
	        order.shipments.push(newShipment);
	      } else {
	        order.shipments = [newShipment];
	      }
	      this.setState({ order: order });
	    }
	  }, {
	    key: 'createOrUpdateShipment',
	    value: function createOrUpdateShipment(data) {
	      var _this8 = this;
	
	      var payload = _Api.Utils.clone(data);
	      payload.order_token = this.state.order.token;
	      var returnValue = _Api2.default.updateShipment(payload);
	
	      returnValue.then(function () {
	        return _this8.reloadOrder();
	      });
	
	      return returnValue;
	    }
	  }, {
	    key: 'removeShipment',
	    value: function removeShipment(shipmentToken) {
	      var _this9 = this;
	
	      var orderToken = this.state.order.token;
	      _Api2.default.removeShipment(orderToken, shipmentToken).then(function () {
	        return _this9.reloadOrder();
	      }, function (error) {
	        alert(error.response.message);
	      });
	    }
	  }, {
	    key: 'getProducts',
	    value: function getProducts() {
	      var _this10 = this;
	
	      var previousBrand = null;
	
	      return this.state.order.items.map(function (orderItem) {
	        // This is needed by the BrandOrder class
	        orderItem.product = _this10.state.orders.products[orderItem.product_token];
	        var brand = _this10.state.orders.brands[orderItem.brand_token];
	        var showBrandName = orderItem.brand_token !== previousBrand;
	        previousBrand = orderItem.brand_token;
	
	        return _react2.default.createElement(OrderItemLine, {
	          checked: _this10.state.checkedItems.indexOf(orderItem.token) >= 0,
	          onCheck: _this10.checkItem,
	          key: orderItem.token,
	          orderItem: orderItem,
	          brand: brand,
	          showBrandName: showBrandName,
	          updateOrderItem: _this10.updateOrderItem
	        });
	      });
	    }
	  }, {
	    key: 'getBrandOrders',
	    value: function getBrandOrders() {
	      var _this11 = this;
	
	      if (!this.state.order.brand_orders || this.state.order.brand_orders.length <= 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'no brand orders'
	        );
	      }
	
	      return this.state.order.brand_orders.map(function (brandOrder) {
	        return _react2.default.createElement(BrandOrder, {
	          key: brandOrder.token,
	          brandOrder: brandOrder,
	          items: _this11.state.order.items,
	          updateBrandOrder: _this11.updateBrandOrder
	        });
	      });
	    }
	  }, {
	    key: 'getShipments',
	    value: function getShipments() {
	      var _this12 = this;
	
	      if (!this.state.order.shipments || this.state.order.shipments.length <= 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'no shipments'
	        );
	      }
	
	      return this.state.order.shipments.map(function (shipment, index) {
	        return _react2.default.createElement(Shipment, {
	          key: shipment.token || 'new-shipment-' + index,
	          shipment: shipment,
	          createOrUpdateShipment: _this12.createOrUpdateShipment,
	          removeShipment: _this12.removeShipment,
	          items: _this12.state.order.items
	        });
	      });
	    }
	  }, {
	    key: 'getPayments',
	    value: function getPayments() {
	      if (!this.state.order.payments || this.state.order.payments.length <= 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'no payments'
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this13 = this;
	
	      if (this.state.order === null) {
	        return _react2.default.createElement(_reactFontawesome2.default, { name: 'refresh', spin: true });
	      } else if (this.state.order === null) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Invalid order'
	        );
	      }
	
	      var retailer = findByToken(this.state.order.retailer_token, this.state.orders.retailers) || {};
	      var user = findByToken(this.state.order.user_token, this.state.orders.users) || {};
	
	      // Cancel or Remove items button check
	      var cancelOrRemoveItemsEnabled = this.state.checkedItems.length > 0;
	      this.state.checkedItems.forEach(function (itemToken) {
	        var orderItem = findByToken(itemToken, _this13.state.order.items);
	        if (!orderItem) {
	          console.error('Cannot find item %s in order.', itemToken);
	          return;
	        }
	
	        if (orderItem.state !== 'WAITING_ON_SHIPPING' && orderItem.state !== 'WAITING_ON_ORDER' && orderItem.state !== 'SHIPPED' // We allow cancelling if not yet shipped!
	        && orderItem.state !== 'CANCELED') {
	          cancelOrRemoveItemsEnabled = false;
	        }
	      });
	
	      // Shipment button check
	      var createShipmentEnabled = this.state.checkedItems.length > 0;
	      this.state.checkedItems.forEach(function (itemToken) {
	        var orderItem = findByToken(itemToken, _this13.state.order.items);
	        if (!orderItem) {
	          console.error('Cannot find item %s in order.', itemToken);
	          return;
	        }
	
	        if (orderItem.state !== 'WAITING_ON_SHIPPING') createShipmentEnabled = false;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'single-order-component' },
	        _react2.default.createElement(_AdminTitle2.default, { title: retailer.name + ' (' + this.state.order.token + ')' }),
	        _react2.default.createElement(
	          'dl',
	          null,
	          _react2.default.createElement(
	            'dt',
	            null,
	            'Order Status'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            this.state.order.state
	          ),
	          _react2.default.createElement(
	            'dt',
	            null,
	            'User'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            user.name
	          ),
	          _react2.default.createElement(
	            'dt',
	            null,
	            'Retailer'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            retailer.name
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'products-list' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Products'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.getProducts()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-group' },
	            _react2.default.createElement(
	              _Button2.default,
	              { disabled: !cancelOrRemoveItemsEnabled, onClick: this.cancelItems },
	              'Cancel Items'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { disabled: !cancelOrRemoveItemsEnabled, onClick: this.removeItems },
	              'Remove Items'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { disabled: !createShipmentEnabled, onClick: this.newShipment },
	              'Create Shipment'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { disabled: this.state.checkedItems.length === 0, onClick: this.clearChecked },
	              'Uncheck Everything'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'brand-orders' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Brand Orders'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.getBrandOrders()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'shipment-list' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Shipments'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.getShipments()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'payment-list' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Payments'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.getPayments()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-group' },
	            _react2.default.createElement(
	              _Button2.default,
	              null,
	              'Add Payment'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'dl',
	          null,
	          _react2.default.createElement(
	            'dt',
	            null,
	            'Order total'
	          ),
	          _react2.default.createElement(
	            'dd',
	            null,
	            '$',
	            _Api.Utils.formatCents(this.state.order.total_amount_cents)
	          )
	        )
	      );
	    }
	  }]);
	
	  return SingleOrder;
	}(_react2.default.Component);
	
	/* Dedicated class for Brand Orders. They need functions from the SingleOrder class. */
	
	
	exports.default = SingleOrder;
	
	var BrandOrder = function (_React$Component2) {
	  _inherits(BrandOrder, _React$Component2);
	
	  function BrandOrder(props) {
	    _classCallCheck(this, BrandOrder);
	
	    var _this14 = _possibleConstructorReturn(this, (BrandOrder.__proto__ || Object.getPrototypeOf(BrandOrder)).call(this, props));
	
	    _Api.Utils.bindThis(_this14, ['onCommissionChange', 'onExternalTokenChange', 'onNotesChange', 'onUpdate', 'startEditing', 'cancelEditing']);
	
	    _this14.state = {
	      editing: false,
	      commission: props.brandOrder.commission_bps ? props.brandOrder.commission_bps / 100 + '' : '',
	      externalToken: props.brandOrder.external_token || '',
	      notes: props.brandOrder.notes || ''
	    };
	    return _this14;
	  }
	
	  _createClass(BrandOrder, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        commission: nextProps.brandOrder.commission_bps ? nextProps.brandOrder.commission_bps / 100 + '' : '',
	        externalToken: nextProps.brandOrder.external_token || '',
	        notes: nextProps.brandOrder.notes || ''
	      });
	    }
	  }, {
	    key: 'startEditing',
	    value: function startEditing() {
	      this.setState({
	        editing: true
	      });
	    }
	  }, {
	    key: 'cancelEditing',
	    value: function cancelEditing() {
	      this.setState({
	        editing: false,
	        commission: this.props.brandOrder.commission_bps ? this.props.brandOrder.commission_bps / 100 + '' : '',
	        externalToken: this.props.brandOrder.external_token || '',
	        notes: this.props.brandOrder.notes || ''
	      });
	    }
	  }, {
	    key: 'onCommissionChange',
	    value: function onCommissionChange(event) {
	      this.setState({
	        commission: event.target.value
	      });
	    }
	  }, {
	    key: 'onExternalTokenChange',
	    value: function onExternalTokenChange(event) {
	      this.setState({
	        externalToken: event.target.value
	      });
	    }
	  }, {
	    key: 'onNotesChange',
	    value: function onNotesChange(event) {
	      this.setState({
	        notes: event.target.value
	      });
	    }
	  }, {
	    key: 'onUpdate',
	    value: function onUpdate() {
	      var _this15 = this;
	
	      var brandOrder = this.props.brandOrder;
	      brandOrder.commission_bps = parseInt(parseFloat(this.state.commission) * 100, 10);
	      brandOrder.external_token = this.state.externalToken;
	      brandOrder.notes = this.state.notes;
	
	      return this.props.updateBrandOrder(brandOrder).then(function () {
	        _this15.setState({
	          editing: false
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var brandOrder = this.props.brandOrder;
	      var items = this.props.items;
	
	      var products = brandOrder.order_item_tokens.map(function (orderItemToken) {
	        var productOption = findByToken(orderItemToken, items);
	
	        if (!productOption) {
	          console.error('No product option for token %s', orderItemToken);
	          console.error(brandOrder);
	          return orderItemToken;
	        }
	
	        return productOption.product.name;
	      }).join(', ');
	
	      var brandOrderDetails = void 0;
	      if (this.state.editing === true) {
	        brandOrderDetails = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('input', {
	            placeholder: 'Commission %',
	            className: 'input',
	            type: 'text',
	            value: this.state.commission,
	            onChange: this.onCommissionChange
	          }),
	          _react2.default.createElement('input', {
	            placeholder: 'external token',
	            className: 'input',
	            type: 'text',
	            value: this.state.externalToken,
	            onChange: this.onExternalTokenChange
	          }),
	          _react2.default.createElement('input', {
	            placeholder: 'notes',
	            className: 'input',
	            type: 'text',
	            value: this.state.notes,
	            onChange: this.onNotesChange
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'button-group' },
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.onUpdate },
	              'Update'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.cancelEditing },
	              'Cancel'
	            )
	          )
	        );
	      } else {
	        brandOrderDetails = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Commission %'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.commission ? this.state.commission : '<empty>'
	          ),
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'External Token'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.externalToken ? this.state.externalToken : '<empty>'
	          ),
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Notes'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.notes ? this.state.notes : '<empty>'
	          ),
	          _react2.default.createElement(_reactFontawesome2.default, { className: 'icon-button', onClick: this.startEditing, name: 'pencil' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'brand-order-item' },
	        _react2.default.createElement(
	          'span',
	          { className: 'product-names' },
	          products
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'form brand-order' },
	          brandOrderDetails
	        )
	      );
	    }
	  }]);
	
	  return BrandOrder;
	}(_react2.default.Component);
	
	var Shipment = function (_React$Component3) {
	  _inherits(Shipment, _React$Component3);
	
	  function Shipment(props) {
	    _classCallCheck(this, Shipment);
	
	    var _this16 = _possibleConstructorReturn(this, (Shipment.__proto__ || Object.getPrototypeOf(Shipment)).call(this, props));
	
	    _Api.Utils.bindThis(_this16, ['onChange', 'onUpdate', 'onRemove', 'startEditing', 'cancelEditing', 'getContents']);
	
	    _this16.state = {
	      editing: !props.shipment.token, // If we don't have a token, we are creating this shipment. Start on edit mode.
	      trackingCode: props.shipment.tracking_code || '',
	      costDollars: _Api.Utils.formatCents(props.shipment.cost_cents) || '',
	      provider: props.shipment.provider || 'default'
	    };
	    return _this16;
	  }
	
	  _createClass(Shipment, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        trackingCode: nextProps.shipment.tracking_code || '',
	        costDollars: _Api.Utils.formatCents(nextProps.shipment.cost_cents) || '',
	        provider: nextProps.shipment.provider || 'default'
	      });
	    }
	  }, {
	    key: 'onRemove',
	    value: function onRemove() {
	      this.props.removeShipment(this.props.shipment.token);
	    }
	  }, {
	    key: 'startEditing',
	    value: function startEditing() {
	      this.setState({
	        editing: true
	      });
	    }
	  }, {
	    key: 'cancelEditing',
	    value: function cancelEditing() {
	      this.setState({
	        editing: false,
	        trackingCode: this.props.shipment.tracking_code || '',
	        costDollars: _Api.Utils.formatCents(this.props.shipment.cost_cents) || '',
	        provider: this.props.shipment.provider || 'default'
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      var payload = {};
	      payload[event.target.name] = event.target.value;
	
	      this.setState(payload);
	    }
	  }, {
	    key: 'onUpdate',
	    value: function onUpdate() {
	      var _this17 = this;
	
	      var trackingCode = this.state.trackingCode.trim();
	
	      if (trackingCode.length > 0 && trackingCode.length < 5) {
	        alert('Tracking costs must have at least 5 characters');
	        return;
	      }
	
	      if (trackingCode.length > 4 && this.state.provider === 'default') {
	        // Note that we allow picking a provider without setting a tracking code.
	        alert('You must selected a valid provider when entering a tracking code');
	        return;
	      }
	
	      var validTracking = trackingCode.length > 0 && this.state.provider !== 'default';
	
	      var shipment = this.props.shipment;
	      shipment.tracking_code = validTracking ? trackingCode : null;
	      shipment.cost_cents = this.state.costDollars.length > 0 ? _Api.Utils.dollarToCents(this.state.costDollars) : null;
	      shipment.provider = this.state.provider === 'default' ? null : this.state.provider;
	
	      if (!shipment.cost_cents) {
	        alert('Shipment must have cost. Set it to ZERO to if you wish to make it free!');
	        return;
	      }
	
	      this.setState({ error: null });
	
	      return this.props.createOrUpdateShipment(shipment).then(function () {
	        _this17.setState({
	          editing: false
	        });
	      }).catch(function (error) {
	        alert('Error: ' + error);
	      });
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(editing, canRemove) {
	      var _this18 = this;
	
	      var contents = null;
	      if (editing) {
	        contents = [_react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-external-token', className: 'external-token' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Tracking Code'
	          ),
	          _react2.default.createElement('input', {
	            placeholder: 'tracking code',
	            className: 'input',
	            type: 'text',
	            name: 'trackingCode',
	            value: this.state.trackingCode,
	            onChange: this.onChange
	          })
	        ), _react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-shipping-cost', className: 'shipping-cost' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Shipping Cost'
	          ),
	          _react2.default.createElement('input', {
	            type: 'text',
	            className: 'input',
	            placeholder: 'shipping cost',
	            name: 'costDollars',
	            value: this.state.costDollars,
	            onChange: this.onChange
	          })
	        ), _react2.default.createElement(
	          'span',
	          { key: this.props.shipment.provider + '-order-admin-shipping-provider', className: 'shipping-provider' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Shipping Provider'
	          ),
	          _react2.default.createElement(
	            'select',
	            {
	              value: this.state.provider,
	              onChange: this.onChange,
	              className: 'input',
	              name: 'provider' },
	            Object.keys(shippingProviders).map(function (provider) {
	              return _react2.default.createElement(
	                'option',
	                { key: _this18.props.shipment.token + '-provider-' + provider,
	                  value: provider },
	                shippingProviders[provider]
	              );
	            })
	          )
	        ), _react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-shipping-button-group', className: 'button-group' },
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.onUpdate },
	            this.props.shipment.token ? 'Update' : 'Create'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.cancelEditing },
	            'Cancel'
	          )
	        ), _react2.default.createElement(
	          'div',
	          { key: this.props.shipment.token + '-order-admin-shipping-error', className: 'error' },
	          this.state.error ? 'something went wrong. check console.' : null
	        )];
	      } else {
	        contents = [_react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-shipped-at', className: 'shipped-at' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Shipped at'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.shipment.shipped_at ? _Api.Utils.millisToYMD(this.props.shipment.shipped_at) : 'N/A'
	          )
	        ), _react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-delivered-at', className: 'delivered-at' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Delivered at'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.shipment.delivered_at ? _Api.Utils.millisToYMD(this.props.shipment.delivered_at) : 'N/A'
	          )
	        ), _react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-external-token', className: 'external-token' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Tracking Code'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.trackingCode ? this.state.trackingCode : 'N/A'
	          )
	        ), _react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-shipping-cost', className: 'shipping-cost' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Shipping Cost'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.costDollars ? '$' + this.state.costDollars : 'N/A'
	          )
	        ), _react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-shipping-provider', className: 'shipping-provider' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'inline' },
	            'Shipping Provider'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            this.state.provider ? shippingProviders[this.state.provider] : 'N/A'
	          )
	        ), _react2.default.createElement(
	          'span',
	          { key: this.props.shipment.token + '-order-admin-shipping-button-group' },
	          _react2.default.createElement(_reactFontawesome2.default, { className: 'icon-button', onClick: this.startEditing, name: 'pencil' })
	        )];
	
	        if (canRemove) {
	          contents.push(_react2.default.createElement(
	            'span',
	            { key: this.props.shipment.token + '-order-admin-shipping-remove-button-group' },
	            _react2.default.createElement(_reactFontawesome2.default, { className: 'icon-button', onClick: this.onRemove, name: 'remove' })
	          ));
	        }
	      }
	      return _react2.default.createElement(
	        'span',
	        { className: 'form' },
	        contents
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var shipment = this.props.shipment;
	      var items = this.props.items;
	      var canRemove = !shipment.shipped_at;
	
	      var products = shipment.order_item_tokens.map(function (orderItemToken) {
	        var productOption = findByToken(orderItemToken, items);
	
	        if (!productOption) {
	          console.error('No product option for token %s', orderItemToken);
	          console.error(shipment);
	          return orderItemToken;
	        }
	
	        return productOption.product.name;
	      }).join(', ');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'shipment-item' },
	        _react2.default.createElement(
	          'span',
	          { className: 'product-names' },
	          products
	        ),
	        this.getContents(this.state.editing, canRemove)
	      );
	    }
	  }]);
	
	  return Shipment;
	}(_react2.default.Component);
	
	var OrderItemLine = function (_React$Component4) {
	  _inherits(OrderItemLine, _React$Component4);
	
	  function OrderItemLine(props) {
	    _classCallCheck(this, OrderItemLine);
	
	    var _this19 = _possibleConstructorReturn(this, (OrderItemLine.__proto__ || Object.getPrototypeOf(OrderItemLine)).call(this, props));
	
	    _this19.startEditing = _this19.startEditing.bind(_this19);
	    _this19.finishEditing = _this19.finishEditing.bind(_this19);
	    _this19.saveItem = _this19.saveItem.bind(_this19);
	
	    _this19.state = {
	      editing: false
	    };
	    return _this19;
	  }
	
	  _createClass(OrderItemLine, [{
	    key: 'startEditing',
	    value: function startEditing() {
	      this.setState({
	        editing: true
	      });
	    }
	  }, {
	    key: 'finishEditing',
	    value: function finishEditing() {
	      this.setState({
	        editing: false
	      });
	    }
	  }, {
	    key: 'saveItem',
	    value: function saveItem() {
	      var payload = _Api.Utils.getFormValues(this, ["state", "expected_ship_date", "quantity", "price_cents"]);
	
	      payload.token = this.props.orderItem.token;
	      payload.expected_ship_date = new Date(payload.expected_ship_date).getTime();
	
	      var returnValue = this.props.updateOrderItem(payload);
	      returnValue.then(this.finishEditing);
	      return returnValue;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var orderItem = this.props.orderItem;
	      var product = orderItem.product;
	      var brand = this.props.brand;
	      var brandLine = void 0;
	
	      if (this.props.showBrandName) {
	        brandLine = _react2.default.createElement(
	          'div',
	          { className: 'brand-name' },
	          brand ? brand.name : orderItem.brand_token
	        );
	      }
	
	      if (this.state.editing) {
	        if (!orderItem.shipDate) {
	          if (orderItem.expected_ship_date) {
	            orderItem.shipDate = _Api.Utils.millisToYMD(orderItem.expected_ship_date);
	          } else {
	            orderItem.shipDate = '';
	          }
	        }
	
	        var orderItemStatesOptions = orderItemStates.map(function (state) {
	          return _react2.default.createElement(
	            'option',
	            { key: orderItem.token + '-state-' + state, value: state },
	            state
	          );
	        });
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          brandLine,
	          _react2.default.createElement(
	            'div',
	            { className: 'product-line' },
	            _react2.default.createElement(
	              'span',
	              { className: 'product-name' },
	              product.name
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: orderItem.token + '-order-admin-order-item-state', className: 'order-item-state' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'inline' },
	                'State'
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  defaultValue: orderItem.state,
	                  className: 'input',
	                  ref: 'state',
	                  name: 'state' },
	                orderItemStatesOptions
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: orderItem.token + '-order-admin-order-expected-ship-date', className: 'order-item-expected-ship-date' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'inline' },
	                'Expected ship date'
	              ),
	              _react2.default.createElement('input', {
	                type: 'date',
	                className: 'input',
	                placeholder: 'Expected Shipping Date',
	                name: 'expected_ship_date',
	                ref: 'expected_ship_date',
	                defaultValue: orderItem.shipDate
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: orderItem.token + '-order-admin-order-item-quantity', className: 'order-item-quantity' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'inline' },
	                'Quantity'
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                className: 'input',
	                placeholder: 'quantity',
	                name: 'quantity',
	                ref: 'quantity',
	                defaultValue: orderItem.quantity
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: orderItem.token + '-order-admin-order-item-price', className: 'order-item-price' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'inline' },
	                'Price Cents'
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                className: 'input',
	                placeholder: 'price_cents',
	                name: 'price_cents',
	                ref: 'price_cents',
	                defaultValue: orderItem.price_cents
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: orderItem.token + '-order-admin-order-item-button-group', className: 'button-group' },
	              _react2.default.createElement(
	                _Button2.default,
	                { onClick: this.saveItem },
	                'Update'
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                { onClick: this.finishEditing },
	                'Cancel'
	              )
	            )
	          )
	        );
	      } else {
	        var expectedShipDateSpan = null;
	        if ((orderItem.state === 'WAITING_ON_SHIPPING' || orderItem.state === 'BACKORDERED') && orderItem.expected_ship_date) {
	          var shipDate = _Api.Utils.millisToYMD(orderItem.expected_ship_date);
	          expectedShipDateSpan = _react2.default.createElement(
	            'span',
	            { className: 'expected_ship-date' },
	            'Ships by ',
	            shipDate
	          );
	        }
	        return _react2.default.createElement(
	          'div',
	          null,
	          brandLine,
	          _react2.default.createElement(
	            'div',
	            { className: 'product-line' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                value: orderItem.token,
	                checked: this.props.checked,
	                onChange: this.props.onCheck
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'product-name' },
	              product.name
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'state' },
	              orderItem.state
	            ),
	            expectedShipDateSpan,
	            _react2.default.createElement(
	              'span',
	              { className: 'quantity' },
	              orderItem.quantity,
	              ' units'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'price' },
	              '$',
	              _Api.Utils.formatCents(orderItem.price_cents)
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'subtotal' },
	              'Total: $',
	              _Api.Utils.formatCents(orderItem.price_cents * orderItem.quantity)
	            ),
	            _react2.default.createElement(
	              'span',
	              { key: orderItem.token + '-edit-order-item' },
	              _react2.default.createElement(_reactFontawesome2.default, { className: 'icon-button', onClick: this.startEditing, name: 'pencil' })
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return OrderItemLine;
	}(_react2.default.Component);
	
	OrderItemLine.propTypes = {
	  orderItem: _propTypes2.default.object.isRequired,
	  brand: _propTypes2.default.object.isRequired,
	  showBrandName: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  onCheck: _propTypes2.default.func.isRequired,
	  updateOrderItem: _propTypes2.default.func.isRequired
	};

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Steps = __webpack_require__(72);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _EditAddress = __webpack_require__(114);
	
	var _EditAddress2 = _interopRequireDefault(_EditAddress);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddAddressStep = function (_React$Component) {
	  _inherits(AddAddressStep, _React$Component);
	
	  function AddAddressStep(props) {
	    _classCallCheck(this, AddAddressStep);
	
	    var _this = _possibleConstructorReturn(this, (AddAddressStep.__proto__ || Object.getPrototypeOf(AddAddressStep)).call(this, props));
	
	    _this.navigate = _this.navigate.bind(_this);
	    _this.nextStep = _this.nextStep.bind(_this);
	    _this.save = _this.save.bind(_this);
	
	    _this.state = {
	      user: _Api2.default.cache.getUser(),
	      retailer: _Api2.default.cache.getRetailer()
	    };
	    return _this;
	  }
	
	  _createClass(AddAddressStep, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _Api2.default.getUser(true).then(function (user) {
	        _this2.setState({ user: user });
	      });
	
	      _Api2.default.getLastSelectedRetailer().then(function (retailerToken) {
	        if (!retailerToken) return;
	
	        return _Api2.default.getRetailer(retailerToken, true);
	      }).then(function (retailer) {
	        _this2.setState({ retailer: retailer });
	      });
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(to) {
	      //this.stopListeners();
	      this.context.router.push(to);
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep() {
	      this.navigate('/checkout/delivery');
	    }
	  }, {
	    key: 'save',
	    value: function save(address) {
	      var _this3 = this;
	
	      var returnValue = _Api2.default.saveUserAddress(address);
	
	      returnValue.then(function (response) {
	        _this3.nextStep();
	        return response;
	      }, function (error) {
	        _this3.setState({
	          error: 'There was an error adding this address'
	        });
	
	        var errorPayload = {
	          message: 'User cannot add address',
	          address: address,
	          user: _this3.state.user,
	          retailer: _this3.state.retailer
	        };
	        _Api2.default.error(JSON.stringify(errorPayload));
	
	        console.error(error);
	
	        return error;
	      });
	
	      return returnValue;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.user) {
	        return null;
	      }
	
	      var address = {};
	      address.name = this.state.user.name;
	
	      if (this.state.retailer && this.state.retailer.address && this.state.user.addresses.length === 0) {
	        address.address1 = this.state.retailer.address.address1;
	        address.address2 = this.state.retailer.address.address2;
	        address.postal_code = this.state.retailer.address.postal_code;
	        address.city = this.state.retailer.address.city;
	        address.state = this.state.retailer.address.state;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Steps2.default, { current: '3' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'add-address page-flyout' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Add Address'
	          ),
	          _react2.default.createElement(_EditAddress2.default, { save: this.save, address: address, errorMessage: this.state.error, buttonText: 'Continue' })
	        )
	      );
	    }
	  }]);
	
	  return AddAddressStep;
	}(_react2.default.Component);
	
	AddAddressStep.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = AddAddressStep;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _AddressDisplay = __webpack_require__(113);
	
	var _AddressDisplay2 = _interopRequireDefault(_AddressDisplay);
	
	var _EditAddress = __webpack_require__(114);
	
	var _backButton = __webpack_require__(124);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddressEditingModal = function (_React$Component) {
	  _inherits(AddressEditingModal, _React$Component);
	
	  function AddressEditingModal(props) {
	    _classCallCheck(this, AddressEditingModal);
	
	    var _this = _possibleConstructorReturn(this, (AddressEditingModal.__proto__ || Object.getPrototypeOf(AddressEditingModal)).call(this, props));
	
	    _this.addressListing = _this.addressListing.bind(_this);
	    _this.addressAdd = _this.addressAdd.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    _this.saveAddress = _this.saveAddress.bind(_this);
	
	    _this.state = {
	      addAddress: false,
	      error: null,
	      name: '',
	      address1: '',
	      address2: '',
	      city: '',
	      state: '',
	      postal_code: '',
	      instructions: ''
	    };
	    return _this;
	  }
	
	  _createClass(AddressEditingModal, [{
	    key: 'addressListing',
	    value: function addressListing() {
	      var _this2 = this;
	
	      var addresses = this.props.addressList.map(function (address) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'address-display-entry', key: 'address-' + address.token },
	          _react2.default.createElement(_AddressDisplay2.default, { address: address }),
	          _react2.default.createElement(
	            'div',
	            { className: 'use-this-address link', onClick: function onClick() {
	                return _this2.props.setSelectedAddress(address.token);
	              } },
	            'Use This Address'
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'address-listing' },
	          addresses
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-box' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'full-width', onClick: function onClick() {
	                return _this2.setState({ addAddress: true });
	              } },
	            'Add New Address'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'addressAdd',
	    value: function addressAdd() {
	      var _this3 = this;
	
	      var error = null;
	      if (this.state.error) error = _react2.default.createElement(
	        'div',
	        { className: 'error-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          this.state.error.message
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'back-button link', onClick: function onClick() {
	              return _this3.setState({ addAddress: false });
	            } },
	          _react2.default.createElement('img', { role: 'presentation', src: _backButton2.default })
	        ),
	        error,
	        _react2.default.createElement(_EditAddress.EditAddressForm, { address: this.state, onChange: this.onChange }),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-box' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'full-width', onClick: this.saveAddress, waitingState: _react2.default.createElement(_Processing2.default, null) },
	            'Save'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'saveAddress',
	    value: function saveAddress() {
	      var _this4 = this;
	
	      var address = {
	        name: this.state.name,
	        address1: this.state.address1,
	        address2: this.state.address2,
	        city: this.state.city,
	        state: this.state.state,
	        postal_code: this.state.postal_code,
	        instructions: this.state.instructions
	      };
	
	      return this.props.save(address).catch(function (error) {
	        return _this4.setState({ error: error });
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'address-editing-component' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Edit Shipping Information'
	        ),
	        this.state.addAddress ? this.addressAdd() : this.addressListing()
	      );
	    }
	  }]);
	
	  return AddressEditingModal;
	}(_react2.default.Component);
	
	AddressEditingModal.propTypes = {
	  save: _propTypes2.default.func.isRequired,
	  addressList: _propTypes2.default.array.isRequired
	};
	exports.default = AddressEditingModal;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Steps = __webpack_require__(72);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FieldKit = __webpack_require__(105);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateAccount = function (_React$Component) {
	  _inherits(CreateAccount, _React$Component);
	
	  function CreateAccount(props) {
	    _classCallCheck(this, CreateAccount);
	
	    var _this = _possibleConstructorReturn(this, (CreateAccount.__proto__ || Object.getPrototypeOf(CreateAccount)).call(this, props));
	
	    _Api.Utils.bindThis(_this, ['btnContinue', 'nextStep', 'onChange']);
	
	    _this.state = {
	      validnames: true,
	      validphone: true,
	      validemail: true,
	      accountExists: false,
	      first_name: '',
	      last_name: '',
	      email_address: '',
	      phone_number: '',
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(CreateAccount, [{
	    key: 'btnContinue',
	    value: function btnContinue() {
	      var _this2 = this;
	
	      var data = {
	        first_name: (this.state.first_name || '').trim(),
	        last_name: (this.state.last_name || '').trim(),
	        email_address: (this.state.email_address || '').trim(),
	        phone_number: this.state.phone_number
	      };
	
	      var stateChange = {
	        validnames: true,
	        validphone: true,
	        validemail: true,
	        accountExists: false
	      };
	
	      // Validate the data
	
	      if (!data.first_name || data.first_name.trim().length === 0 || !data.last_name || data.last_name.trim().length === 0) {
	        stateChange.validnames = false;
	      }
	
	      // E-Mail
	      if (!data.email_address || data.email_address.length < 5) {
	        stateChange.validemail = false;
	      } else {
	        var regex = new RegExp('[A-Z0-9._%\'=+][A-Z0-9._%\'=+-]*@([A-Z0-9]([A-Z0-9-]*[A-Z0-9])?\\.)+[A-Z]{2,}', 'iugy');
	        if (!regex.exec(data.email_address)) stateChange.validemail = false;
	      }
	
	      // Phone Number
	      if (!data.phone_number || data.phone_number.length < 9) {
	        stateChange.validphone = false;
	      } else {
	        // Strip the following characters from the number: +, -, SPACE, DOT, ( and ).
	        var actualPhoneNumber = data.phone_number.replace(/[ \-\(\)\.+]*/g, '');
	        if (actualPhoneNumber.match(/[^0-9]/)) {
	          // We can only have numbers left
	          stateChange.validphone = false;
	        } else if (actualPhoneNumber.length < 9 || actualPhoneNumber.length > 10) {
	          // Length should be between 9 and 10.
	          stateChange.validphone = false;
	        }
	      }
	
	      this.setState(stateChange);
	
	      if (!stateChange.validemail || !stateChange.validphone || !stateChange.validnames) return;
	
	      return _Api2.default.createUser(data).then(function (answer) {
	        if (!answer) {
	          _this2.setState({ accountExists: true });
	          return;
	        }
	
	        _this2.nextStep();
	        return answer;
	      }, function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep() {
	      if (window.linkInstruments) {
	        this.context.router.push('/checkout/payment');
	      } else {
	        this.context.router.push('/checkout/delivery');
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      this.setState(_defineProperty({}, event.target.name, event.target.value));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Steps2.default, { current: '1' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'create-account page-flyout' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'flyout-header extra-space' },
	            'Looks Like You\'re New!',
	            _react2.default.createElement('br', null),
	            'Let\'s Create An Account'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'create-account-form' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row2' + (this.state.validnames ? '' : ' error') },
	              _react2.default.createElement(
	                'div',
	                { className: 'input col-50' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'first_name' },
	                  'First Name ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'error-message' },
	                    'Invalid First Name'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', name: 'first_name', onChange: this.onChange, value: this.state.first_name })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input col-50' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'last_name' },
	                  'Last Name ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'error-message' },
	                    'Invalid Last Name'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', name: 'last_name', onChange: this.onChange, value: this.state.last_name })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row2' + (this.state.validemail ? '' : ' error') },
	              _react2.default.createElement(
	                'div',
	                { className: 'input' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'email_address' },
	                  'Email ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'error-message' },
	                    'Invalid Email'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', name: 'email_address', onChange: this.onChange, value: this.state.email_address })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row2' + (this.state.validphone ? '' : ' error') },
	              _react2.default.createElement(
	                'div',
	                { className: 'input' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'phone_number' },
	                  'Phone Number ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'error-message' },
	                    'Invalid Phone Number'
	                  )
	                ),
	                _react2.default.createElement(_FieldKit.PhoneField, { name: 'phone_number', onChange: this.onChange, value: this.state.phone_number })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'account-exists ' + (this.state.accountExists ? '' : 'hidden') },
	                'An account with this email address or phone number already exists. Do you want to ',
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/user' },
	                  'sign in'
	                ),
	                '?'
	              ),
	              _react2.default.createElement(
	                _Button2.default,
	                { className: 'full-width', onClick: this.btnContinue },
	                'Continue'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'toc' },
	                'By continuing, I agree to Indigo Fair\u2019s ',
	                _react2.default.createElement(
	                  'a',
	                  { href: '/tos', target: '_blank' },
	                  'Terms & Conditions'
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'already-have-account', to: '/user' },
	                'Already have an account? Sign In >'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateAccount;
	}(_react2.default.Component);
	
	exports.default = CreateAccount;
	
	
	CreateAccount.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _flyout = __webpack_require__(102);
	
	var _flyout2 = _interopRequireDefault(_flyout);
	
	var _PromoCode = __webpack_require__(302);
	
	var _PromoCode2 = _interopRequireDefault(_PromoCode);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _LightBox = __webpack_require__(32);
	
	var _LightBox2 = _interopRequireDefault(_LightBox);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _AddressDisplay = __webpack_require__(113);
	
	var _AddressDisplay2 = _interopRequireDefault(_AddressDisplay);
	
	var _PaymentDisplay = __webpack_require__(115);
	
	var _PaymentDisplay2 = _interopRequireDefault(_PaymentDisplay);
	
	var _AddressEditingModal = __webpack_require__(344);
	
	var _AddressEditingModal2 = _interopRequireDefault(_AddressEditingModal);
	
	var _PaymentEditingModal = __webpack_require__(347);
	
	var _PaymentEditingModal2 = _interopRequireDefault(_PaymentEditingModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliveryDetails = function (_React$Component) {
	  _inherits(DeliveryDetails, _React$Component);
	
	  function DeliveryDetails() {
	    _classCallCheck(this, DeliveryDetails);
	
	    var _this = _possibleConstructorReturn(this, (DeliveryDetails.__proto__ || Object.getPrototypeOf(DeliveryDetails)).call(this));
	
	    _Api.Utils.bindThis(_this, ['cartUpdated', 'userUpdated', 'instrumentUpdated', 'setSelectedAddress', 'setSelectedInstrument', 'placeOrderInterface', 'submitOrder', 'editSelectedAddress', 'cancel', 'saveAddress', 'onDiscount']);
	
	    _this.state = {
	      cart: _Api2.default.cache.getCart(),
	      user: null, // User will be read on componentWillMount().
	      selectedAddressToken: null,
	      selectedInstrument: _Api2.default.cache.getSelectedInstrument(),
	      changeAddress: false,
	      changePayment: false,
	      errorMessage: null
	    };
	    return _this;
	  }
	
	  _createClass(DeliveryDetails, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _Api2.default.cache.addChangeListener(this.cartUpdated, _Api2.default.cache.eventTypes.CART_CHANGED);
	      _Api2.default.cache.addChangeListener(this.userUpdated, _Api2.default.cache.eventTypes.USER_CHANGED);
	      _Api2.default.cache.addChangeListener(this.instrumentUpdated, _Api2.default.cache.eventTypes.SELECTED_INSTRUMENT_CHANGED);
	
	      if (!this.state.cart) _Api2.default.getCart(true).then(function () {
	        _this2.cartUpdated();
	      });_Api2.default.getUser(true).then(function () {
	        _this2.userUpdated();
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.cache.removeChangeListener(this.cartUpdated, _Api2.default.cache.eventTypes.CART_CHANGED);
	      _Api2.default.cache.removeChangeListener(this.userUpdated, _Api2.default.cache.eventTypes.USER_CHANGED);
	      _Api2.default.cache.removeChangeListener(this.instrumentUpdated, _Api2.default.cache.eventTypes.SELECTED_INSTRUMENT_CHANGED);
	    }
	  }, {
	    key: 'cartUpdated',
	    value: function cartUpdated() {
	      var cart = _Api2.default.cache.getCart();
	      this.setState({ cart: cart });
	    }
	  }, {
	    key: 'userUpdated',
	    value: function userUpdated() {
	      var user = _Api2.default.cache.getUser();
	      var selectedAddressToken = this.state.selectedAddressToken || user.last_shipping_address_token;
	
	      // If we have no addresses, none should be selected.
	      if (!user.addresses || user.addresses.length === 0) selectedAddressToken = null;
	
	      if (selectedAddressToken && !user.addresses.find(function (address) {
	        return address.token === selectedAddressToken;
	      })) selectedAddressToken = null;
	
	      // If we don't have an address selected, select the first.
	      if (user.addresses && user.addresses.length > 0 && !selectedAddressToken) selectedAddressToken = user.addresses[0].token;
	
	      var selectedInstrument = this.state.selectedInstrument;
	      if (!selectedInstrument && user.instruments.length > 0) {
	        selectedInstrument = user.instruments[0].token;
	      }
	
	      this.setState({
	        user: user,
	        selectedAddressToken: selectedAddressToken,
	        selectedInstrument: selectedInstrument
	      });
	    }
	  }, {
	    key: 'instrumentUpdated',
	    value: function instrumentUpdated() {
	      var selectedInstrument = _Api2.default.cache.getSelectedInstrument();
	      if (!selectedInstrument || selectedInstrument === this.state.selectedInstrument) return;
	      this.setState({
	        selectedInstrument: selectedInstrument
	      });
	    }
	  }, {
	    key: 'placeOrderInterface',
	    value: function placeOrderInterface() {
	      var _this3 = this;
	
	      // Place order button should be disabled if there is no cart, or the cart is empty, or there are any brands below minimum.
	      var buttonDisabled = false;
	      var placeOrderText = 'Place Order';
	
	      if (!this.state.user.impersonating) {
	        buttonDisabled = !this.state.cart || !this.state.cart.cart || this.state.cart.cart.items.length === 0 || this.state.cart.below_minimum.length > 0 || !this.state.user || !this.state.selectedAddressToken;
	      } else {
	        placeOrderText = 'Place Order (!)';
	      }
	
	      var selectedAddress = null;
	      if (this.state.selectedAddressToken && this.state.user && this.state.user.addresses) {
	        selectedAddress = this.state.user.addresses.find(function (address) {
	          return address.token === _this3.state.selectedAddressToken;
	        });
	      }
	      selectedAddress = selectedAddress || {};
	
	      var shippingAddressName = selectedAddress.name;
	      if (!shippingAddressName && this.state.user) {
	        shippingAddressName = this.state.user.name;
	      }
	
	      // Instrument
	      var instrumentInfo = null;
	      if (this.state.user) {
	        if (!this.state.selectedInstrument) {
	          instrumentInfo = "No payment method selected";
	        } else {
	          var selectedInstrument = this.state.user.instruments.find(function (instrument) {
	            return instrument.token === _this3.state.selectedInstrument;
	          });
	
	          if (!selectedInstrument) {
	            instrumentInfo = "Invalid payment information";
	          } else if (selectedInstrument.card) {
	            instrumentInfo = "Credit card ending in " + selectedInstrument.card.last_four;
	          } else {
	            instrumentInfo = selectedInstrument.token;
	          }
	        }
	      }
	
	      var addressInfo = "Please, add an address";
	      if (this.state.selectedAddressToken) {
	        addressInfo = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            shippingAddressName
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            selectedAddress.address1
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            selectedAddress.city,
	            ', ',
	            selectedAddress.state,
	            ' ',
	            selectedAddress.postal_code
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Shipping Address'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row shipping-address' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-80' },
	            addressInfo
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-20' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: function onClick(event) {
	                  event.preventDefault();
	                  if (_this3.state.user.addresses.length > 0) {
	                    _this3.setState({ changeAddress: true });
	                  } else {
	                    _this3.editSelectedAddress();
	                  }
	                } },
	              this.state.user.addresses.length === 0 ? 'Add Address' : 'Change'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: window.linkInstruments ? '' : 'hidden' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Payment Details'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row payment-details' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-80' },
	              instrumentInfo
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-20' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/checkout/payment' },
	                'Change'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-row center' },
	          _react2.default.createElement(
	            _Button2.default,
	            { disabled: buttonDisabled, onClick: this.submitOrder },
	            placeOrderText
	          )
	        )
	      );
	    }
	  }, {
	    key: 'setSelectedAddress',
	    value: function setSelectedAddress(addressToken) {
	      this.setState({
	        selectedAddressToken: addressToken,
	        changeAddress: false
	      });
	    }
	  }, {
	    key: 'setSelectedInstrument',
	    value: function setSelectedInstrument(paymentToken) {
	      this.setState({
	        selectedInstrument: paymentToken,
	        changePayment: false
	      });
	    }
	  }, {
	    key: 'editSelectedAddress',
	    value: function editSelectedAddress(addressToken) {
	      var selectedAddress = this.state.user.addresses.find(function (address) {
	        return address.token === addressToken;
	      });
	      if (!selectedAddress) {
	        selectedAddress = {};
	        selectedAddress.name = this.state.user.name;
	
	        var retailer = _Api2.default.cache.getRetailer();
	
	        if (retailer && retailer.address && this.state.user.addresses.length === 0) {
	          selectedAddress.address1 = retailer.address.address1;
	          selectedAddress.address2 = retailer.address.address2;
	          selectedAddress.postal_code = retailer.address.postal_code;
	          selectedAddress.city = retailer.address.city;
	          selectedAddress.state = retailer.address.state;
	        }
	      }
	      this.setState({
	        changeAddress: false,
	        editAddress: selectedAddress
	      });
	    }
	  }, {
	    key: 'translateMessage',
	    value: function translateMessage(failure_reason) {
	      // TODO: I don't like it here. There should be created a file/function to handle all message translations.
	      switch (failure_reason) {
	        case 'CART_IS_EMPTY':
	          return 'The cart is empty.';
	        case 'BELOW_MINIMUM_BRAND_AMOUNT':
	          return 'You have not reached the brand minimum for one or more items on your bag.';
	        case 'CLIENT_PRICE_MISMATCH':
	          return 'The price of one or more of the products included in the order has changed since the cart was initiated.';
	        case 'INVALID_ITEM_UNIT_MULTIPLIER':
	          return 'The quantity of one or more of the products included in the order is not a multiple of the item unit multiplier.';
	        default:
	          // TODO: Send event to server about a missing failure reason.
	          return 'Oops! Something went wrong. Please try again!';
	      }
	    }
	  }, {
	    key: 'onDiscount',
	    value: function onDiscount(discount) {
	      var cart = this.state.cart;
	      cart.cart.discount = discount;
	      this.setState({ cart: cart });
	    }
	  }, {
	    key: 'submitOrder',
	    value: function submitOrder() {
	      var _this4 = this;
	
	      var promoCode = this.state.cart.cart && this.state.cart.cart.discount && this.state.cart.cart.discount.code;
	      return _Api2.default.submitOrder(this.state.selectedAddressToken, this.state.selectedInstrument, promoCode).then(function (response) {
	        var order = response.orders[0];
	
	        if (order.state === 'FAILED') {
	          _this4.setState({
	            errorMessage: _this4.translateMessage(order.failure_reason)
	          });
	        } else {
	          _Api2.default.cache.setCart(null);
	          _this4.context.router.push('/checkout/success');
	          return _Api2.default.getOrders(false);
	        }
	
	        return response;
	      }).catch(function (error) {
	        var errorMessage = {
	          message: 'User could not send order',
	          error: error,
	          address_token: _this4.state.selectedAddressToken,
	          instrument_token: _this4.state.selectedInstrument,
	          user: _Api2.default.cache.getUser()
	        };
	        _Api2.default.error(JSON.stringify(errorMessage));
	
	        _this4.setState({
	          errorMessage: error.message || 'Something went wrong'
	        });
	      });
	    }
	
	    /* Cancels any other state */
	
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.setState({
	        changeAddress: false,
	        changePayment: false
	      });
	    }
	
	    /* Creates/Updates an address */
	
	  }, {
	    key: 'saveAddress',
	    value: function saveAddress(address) {
	      var _this5 = this;
	
	      var currentAddresses = this.state.user.addresses;
	      var currentAddressesTokens = currentAddresses.map(function (address) {
	        return address.token;
	      });
	      var returnValue = _Api2.default.saveUserAddress(address);
	
	      returnValue.then(function (response) {
	        var newAddress = _this5.state.selectedAddressToken;
	        response.forEach(function (responseAddress) {
	          if (currentAddressesTokens.indexOf(responseAddress.token) < 0) newAddress = responseAddress.token;
	        });
	        _this5.setState({
	          changeAddress: false,
	          selectedAddressToken: newAddress
	        });
	      });
	
	      return returnValue;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      if (!this.state.user) return null;
	
	      var errorMessage = null;
	      if (this.state.errorMessage) {
	        errorMessage = _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          this.state.errorMessage
	        );
	      }
	
	      var selectedAddress = this.state.user.addresses.find(function (address) {
	        return address.token === _this6.state.selectedAddressToken;
	      });
	      var selectedInstrument = this.state.user.instruments.find(function (instrument) {
	        return instrument.token === _this6.state.selectedInstrument;
	      });
	
	      var modalView = null;
	      if (this.state.changeAddress) {
	        document.body.classList.add('noscroll');
	
	        modalView = _react2.default.createElement(
	          _LightBox2.default,
	          { className: 'address-editing-modal', onClose: this.cancel },
	          _react2.default.createElement(_AddressEditingModal2.default, {
	            save: this.saveAddress,
	            cancel: this.cancel,
	            address: this.state.editAddress,
	            addressList: this.state.user.addresses,
	            setSelectedAddress: this.setSelectedAddress
	          })
	        );
	      } else if (this.state.changePayment) {
	        document.body.classList.add('noscroll');
	
	        modalView = _react2.default.createElement(
	          _LightBox2.default,
	          { className: 'payment-editing-modal', onClose: this.cancel },
	          _react2.default.createElement(_PaymentEditingModal2.default, {
	            save: this.savePayment,
	            cancel: this.cancel,
	            instrumentList: this.state.user.instruments,
	            setSelectedInstrument: this.setSelectedInstrument
	          })
	        );
	      } else {
	        document.body.classList.remove('noscroll');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-flyout checkout checkout-delivery' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'flyout-header' },
	          'Checkout'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'delivery-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'delivery-col' },
	            _react2.default.createElement(
	              'div',
	              { className: 'section-header' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Shipping Details'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'edit-link', onClick: function onClick() {
	                    return _this6.setState({ changeAddress: true });
	                  } },
	                'Edit'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'section-contents' },
	              _react2.default.createElement(_AddressDisplay2.default, { address: selectedAddress })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'section-header' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Payment Details'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'edit-link', onClick: function onClick() {
	                    return _this6.setState({ changePayment: true });
	                  } },
	                'Edit'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'section-contents' },
	              _react2.default.createElement(_PaymentDisplay2.default, { payment: selectedInstrument })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'promo-code-section' },
	              _react2.default.createElement(_PromoCode2.default, { onDiscount: this.onDiscount })
	            ),
	            errorMessage,
	            _react2.default.createElement(
	              'div',
	              { className: 'button-container' },
	              _react2.default.createElement(
	                _Button2.default,
	                { onClick: this.submitOrder, className: 'full-width', waitingState: _react2.default.createElement(_Processing2.default, null) },
	                'Place Order'
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'separator-col' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'cart-col' },
	            _react2.default.createElement(
	              'div',
	              { className: 'section-header' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Order Summary'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'edit-link', onClick: function onClick() {
	                    return _Api2.default.cache.setCartVisible(true);
	                  } },
	                'Edit'
	              )
	            ),
	            _react2.default.createElement(_flyout2.default, { disableEditing: true, className: 'cart-inline', cart: this.state.cart, dueToday: true,
	              subtotal: true, textTotal: true })
	          )
	        ),
	        modalView
	      );
	    }
	  }]);
	
	  return DeliveryDetails;
	}(_react2.default.Component);
	
	DeliveryDetails.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = DeliveryDetails;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PaymentInformation = __webpack_require__(71);
	
	var _PaymentDisplay = __webpack_require__(115);
	
	var _PaymentDisplay2 = _interopRequireDefault(_PaymentDisplay);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _payments = __webpack_require__(69);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _backButton = __webpack_require__(124);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentEditingModal = function (_React$Component) {
	  _inherits(PaymentEditingModal, _React$Component);
	
	  function PaymentEditingModal(props) {
	    _classCallCheck(this, PaymentEditingModal);
	
	    var _this = _possibleConstructorReturn(this, (PaymentEditingModal.__proto__ || Object.getPrototypeOf(PaymentEditingModal)).call(this, props));
	
	    _this.instrumentList = _this.instrumentList.bind(_this);
	    _this.addBilling = _this.addBilling.bind(_this);
	    _this.actionLinkBankAccount = _this.actionLinkBankAccount.bind(_this);
	    _this.actionLinkCreditCard = _this.actionLinkCreditCard.bind(_this);
	
	    _this.state = {
	      addingPayment: false
	    };
	    return _this;
	  }
	
	  _createClass(PaymentEditingModal, [{
	    key: 'addBilling',
	    value: function addBilling() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'back-button link', onClick: function onClick() {
	              return _this2.setState({ addingPayment: false });
	            } },
	          _react2.default.createElement('img', { role: 'presentation', src: _backButton2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row payment-options' },
	          _react2.default.createElement(_PaymentInformation.CreditCardPayment, { title: 'ADD CREDIT CARD', buttonText: 'LINK CARD', onClick: this.actionLinkCreditCard }),
	          _react2.default.createElement(_PaymentInformation.NetNinetyPayment, { title: 'ADD BANK ACCOUNT', buttonText: 'LINK ACCOUNT', onClick: this.actionLinkBankAccount })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-box' },
	          _react2.default.createElement(
	            'p',
	            { className: 'note' },
	            'By linking a payment instrument, you authorize Indigo Fair. I authorize to \u2028electronically debit your account and, if necessary, electronically credit account \u2028to correct erroneous debits.'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'instrumentList',
	    value: function instrumentList() {
	      var _this3 = this;
	
	      var instruments = this.props.instrumentList.map(function (instrument) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'instrument-display-entry', key: 'payment-' + instrument.token },
	          _react2.default.createElement(_PaymentDisplay2.default, { payment: instrument }),
	          _react2.default.createElement(
	            'div',
	            { className: 'use-this-instrument link', onClick: function onClick() {
	                return _this3.props.setSelectedInstrument(instrument.token);
	              } },
	            'Use This ',
	            instrument.card ? 'Credit Card' : 'Bank Account'
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'instrument-listing' },
	          instruments
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-box' },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'full-width', onClick: function onClick() {
	                return _this3.setState({ addingPayment: true });
	              } },
	            'Add New Payment'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'actionLinkBankAccount',
	    value: function actionLinkBankAccount(event) {
	      var _this4 = this;
	
	      event.preventDefault();
	      var user = _Api2.default.cache.getUser();
	      var returnValue = _payments2.default.addBankAccount(user);
	
	      returnValue.then(function (response) {
	        _this4.props.setSelectedInstrument(response.token);
	        return response;
	      });
	
	      return returnValue;
	    }
	  }, {
	    key: 'actionLinkCreditCard',
	    value: function actionLinkCreditCard(event) {
	      var _this5 = this;
	
	      event.preventDefault();
	      var user = _Api2.default.cache.getUser();
	      var returnValue = _payments2.default.addCreditCard(user);
	
	      returnValue.then(function (response) {
	        _this5.props.setSelectedInstrument(response.token);
	        return response;
	      });
	
	      return returnValue;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'payment-editing-component' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Edit Billing Information'
	        ),
	        this.state.addingPayment ? this.addBilling() : this.instrumentList()
	      );
	    }
	  }]);
	
	  return PaymentEditingModal;
	}(_react2.default.Component);
	
	PaymentEditingModal.propTypes = {
	  instrumentList: _propTypes2.default.array.isRequired,
	  setSelectedInstrument: _propTypes2.default.func.isRequired
	};
	exports.default = PaymentEditingModal;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _success = __webpack_require__(127);
	
	var _success2 = _interopRequireDefault(_success);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderSuccess = function (_React$Component) {
	  _inherits(OrderSuccess, _React$Component);
	
	  function OrderSuccess() {
	    _classCallCheck(this, OrderSuccess);
	
	    return _possibleConstructorReturn(this, (OrderSuccess.__proto__ || Object.getPrototypeOf(OrderSuccess)).apply(this, arguments));
	  }
	
	  _createClass(OrderSuccess, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'order-success page-flyout checkout' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Your Order was Submitted!'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'image-wrapper' },
	          _react2.default.createElement('img', { role: 'presentation', src: _success2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'note' },
	          'Thank you for your purchase! We have received your order and will send a confirmation email within 24 hours.'
	        )
	      );
	    }
	  }]);
	
	  return OrderSuccess;
	}(_react2.default.Component);
	
	exports.default = OrderSuccess;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckoutDeliveryDetails = exports.CheckoutAddAddress = exports.CheckoutPaymentInformation = exports.CheckoutSuccess = exports.CheckoutCreateAccount = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CreateAccount = __webpack_require__(345);
	
	var _CreateAccount2 = _interopRequireDefault(_CreateAccount);
	
	var _Success = __webpack_require__(348);
	
	var _Success2 = _interopRequireDefault(_Success);
	
	var _PaymentInformation = __webpack_require__(71);
	
	var _PaymentInformation2 = _interopRequireDefault(_PaymentInformation);
	
	var _AddAddressStep = __webpack_require__(343);
	
	var _AddAddressStep2 = _interopRequireDefault(_AddAddressStep);
	
	var _DeliveryDetails = __webpack_require__(346);
	
	var _DeliveryDetails2 = _interopRequireDefault(_DeliveryDetails);
	
	__webpack_require__(394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkout = function (_React$Component) {
	  _inherits(Checkout, _React$Component);
	
	  function Checkout() {
	    _classCallCheck(this, Checkout);
	
	    return _possibleConstructorReturn(this, (Checkout.__proto__ || Object.getPrototypeOf(Checkout)).apply(this, arguments));
	  }
	
	  _createClass(Checkout, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'checkout' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Checkout;
	}(_react2.default.Component);
	
	exports.default = Checkout;
	exports.CheckoutCreateAccount = _CreateAccount2.default;
	exports.CheckoutSuccess = _Success2.default;
	exports.CheckoutPaymentInformation = _PaymentInformation2.default;
	exports.CheckoutAddAddress = _AddAddressStep2.default;
	exports.CheckoutDeliveryDetails = _DeliveryDetails2.default;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _Api = __webpack_require__(4);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brand = function (_React$Component) {
	  _inherits(Brand, _React$Component);
	
	  function Brand(props) {
	    _classCallCheck(this, Brand);
	
	    var _this = _possibleConstructorReturn(this, (Brand.__proto__ || Object.getPrototypeOf(Brand)).call(this, props));
	
	    _this.onScroll = _this.onScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(Brand, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.onScroll);
	    }
	  }, {
	    key: 'onScroll',
	    value: function onScroll() {
	      var distance = window.pageYOffset || window.document.documentElement.scrollTop;
	      var minimizeThreshold = this.$component.clientHeight;
	
	      if (distance < minimizeThreshold) {
	        this.$component.classList.remove('collapse');
	      } else {
	        if (!this.$component.classList.contains('collapse')) {
	          this.$component.classList.add('collapse');
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var classNames = ['product-collection-brand-component'];
	      if (this.props.className) classNames.push(this.props.className);
	
	      var closestText = null;
	      if (this.props.closestBrandRetailer) {
	        closestText = _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'map-marker' }),
	          ' Nearest store carrying ',
	          this.props.brand.name,
	          _react2.default.createElement(
	            'strong',
	            null,
	            parseInt(this.props.closestBrandRetailer, 10),
	            ' miles away'
	          )
	        );
	      }
	
	      var fromText = null;
	      if (this.props.brand.from) fromText = _react2.default.createElement(
	        'div',
	        { className: 'from' },
	        this.props.brand.from
	      );
	
	      var minimumText = null;
	      if (this.props.brand.minimum_order_amount_cents) {
	        minimumText = _react2.default.createElement(
	          'div',
	          { className: 'brand-minimum' },
	          'Minimum $',
	          _Api.Utils.formatCents(this.props.brand.minimum_order_amount_cents, true)
	        );
	      }
	
	      var urlText = null;
	      if (this.props.url && this.props.url.length > 0) {
	        urlText = _react2.default.createElement(
	          'div',
	          { className: 'site' },
	          this.props.url
	        );
	      }
	
	      var button = null;
	      if (this.props.loading) {
	        button = _react2.default.createElement(_Processing2.default, null);
	      } else {
	        button = _react2.default.createElement(
	          _Button2.default,
	          { onClick: this.props.addToBag, disabled: !this.props.count },
	          'Add Collection to Bag'
	        );
	      }
	
	      var brandInfoHidden = !fromText && !urlText && !minimumText;
	      var brandInfo = null;
	      if (!brandInfoHidden) {
	        brandInfo = _react2.default.createElement(
	          'div',
	          { className: 'brand-info' },
	          fromText,
	          urlText,
	          minimumText
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '), ref: function ref(div) {
	            _this2.$component = div;
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'contents' },
	          _react2.default.createElement(
	            'div',
	            { className: 'topbar' },
	            _react2.default.createElement('div', { className: 'social' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'closest' },
	              closestText
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'name' },
	            this.props.title
	          ),
	          brandInfo,
	          _react2.default.createElement(
	            'div',
	            { className: 'description' },
	            this.props.description
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'collection-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'count' },
	              this.props.count || 0,
	              ' Items'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'cost' },
	              'Total Cost ',
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'value' },
	                '$',
	                _Api.Utils.formatCents(this.props.cost, true) || '0'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-wrapper' },
	            button
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'collection-contents-header' },
	            'Collection Contents'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Brand;
	}(_react2.default.Component);
	
	Brand.propTypes = {
	  brand: _propTypes2.default.object.isRequired,
	  count: _propTypes2.default.number,
	  cost: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  addToBag: _propTypes2.default.func,
	  title: _propTypes2.default.string.isRequired,
	  url: _propTypes2.default.string
	};
	exports.default = Brand;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	__webpack_require__(395);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckBox = function (_React$Component) {
	  _inherits(CheckBox, _React$Component);
	
	  function CheckBox(props) {
	    _classCallCheck(this, CheckBox);
	
	    var _this = _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	
	    if (_this.props.value !== undefined && _this.props.defaultValue !== undefined) {
	      console.error('[Checkbox] you cannot define both `value` and `defaultValue` props to the same component. `defaultValue` will be ignored.');
	    }
	
	    var checkedValue = false;
	    if (_this.props.defaultValue !== undefined) {
	      checkedValue = !!_this.props.defaultValue;
	    }
	
	    if (_this.props.value !== undefined) {
	      checkedValue = !!_this.props.value;
	    }
	
	    _this.state = {
	      checked: checkedValue
	    };
	
	    _this.value = checkedValue;
	    return _this;
	  }
	
	  _createClass(CheckBox, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && nextProps.value !== this.state.checked) {
	        this.value = nextProps.value;
	        this.setState({ checked: nextProps.value });
	      }
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      if (this.props.onClick) return this.props.onClick(event);
	      event.preventDefault();
	
	      if (this.props.value !== undefined) {
	        var checkedValue = !this.state.checked;
	        this.value = checkedValue;
	        this.setState({ value: checkedValue });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classNames = ['checkbox-component'];
	      if (this.props.className) classNames.push(this.props.className);
	      if (this.state.checked) classNames.push('checked');
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '), onClick: this.onClick },
	        _react2.default.createElement(
	          'div',
	          { className: 'box' },
	          _react2.default.createElement(
	            'span',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(_reactFontawesome2.default, { name: 'check' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'label' },
	          this.props.label
	        )
	      );
	    }
	  }]);
	
	  return CheckBox;
	}(_react2.default.Component);
	
	CheckBox.propTypes = {
	  onClick: _propTypes2.default.func,
	  value: _propTypes2.default.bool,
	  defaultValue: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  classNames: _propTypes2.default.string
	};
	exports.default = CheckBox;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _LightBox = __webpack_require__(32);
	
	var _LightBox2 = _interopRequireDefault(_LightBox);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _ProductModal = __webpack_require__(70);
	
	var _ProductModal2 = _interopRequireDefault(_ProductModal);
	
	var _CategoryBar = __webpack_require__(66);
	
	var _CategoryBar2 = _interopRequireDefault(_CategoryBar);
	
	var _brand = __webpack_require__(350);
	
	var _brand2 = _interopRequireDefault(_brand);
	
	var _product = __webpack_require__(353);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _consts = __webpack_require__(44);
	
	__webpack_require__(396);
	
	var _index = __webpack_require__(65);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var topTreshold = 20;
	
	var Collection = function (_React$Component) {
	  _inherits(Collection, _React$Component);
	
	  function Collection(props) {
	    _classCallCheck(this, Collection);
	
	    var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props));
	
	    _Api2.default.Utils.bindThis(_this, ['setcollectionsValue', 'productList', 'closeProductModal', 'productModal', 'openProductModal', 'save', 'setProductActive', 'addToBag', 'onCategory', 'onBreadCrumb']);
	
	    _this.state = {
	      collections: null,
	      activeCollection: null,
	      productGroups: null,
	      brand: null,
	      productToken: null,
	      closestBrandRetailer: null,
	      scrollTop: 0,
	      addingToBag: false
	    };
	    return _this;
	  }
	
	  _createClass(Collection, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _Api2.default.getProductCollections(true).then(function (collections) {
	        _this2.setcollectionsValue(collections);
	      }, function (error) {
	        console.error(error);
	      });
	
	      _Api2.default.getCategories(true).then(function (categories) {
	        _this2.setState({
	          categories: categories
	        });
	      }, function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'setcollectionsValue',
	    value: function setcollectionsValue(collections) {
	      var _this3 = this;
	
	      var activeCollection = collections.product_collections.find(function (collection) {
	        return collection.token === _this3.props.params.collectionToken;
	      });
	
	      // Setup brand and product groups for properly grouping product options
	      var brand = null;
	      var productGroups = null;
	      if (activeCollection) {
	        if (activeCollection.items && activeCollection.items.length > 0) {
	          brand = collections.brands[activeCollection.items[0].brand_token];
	        }
	
	        productGroups = {};
	        activeCollection.items.forEach(function (product) {
	          if (Object.keys(productGroups).indexOf(product.product_token) < 0) {
	            productGroups[product.product_token] = {
	              active: true,
	              product: collections.products[product.product_token],
	              products: []
	            };
	          }
	
	          productGroups[product.product_token].products.push(product);
	        });
	      }
	
	      this.setState({
	        activeCollection: activeCollection,
	        collections: collections,
	        brand: brand,
	        productGroups: productGroups,
	        closestBrandRetailer: null
	      });
	
	      if (brand && brand.token) {
	        _Api2.default.getClosestBrandRetailer(brand.token).then(function (closestBrandRetailer) {
	          _this3.setState({ closestBrandRetailer: closestBrandRetailer });
	        });
	      }
	    }
	  }, {
	    key: 'setProductActive',
	    value: function setProductActive(productToken, active) {
	      var productGroups = _Api2.default.Utils.clone(this.state.productGroups, true);
	      var currentGroup = productGroups[productToken];
	
	      if (!currentGroup) {
	        console.error("Cannot find group: " + productToken);
	        return;
	      }
	
	      if (currentGroup.active === active) return;
	
	      currentGroup.active = active;
	      this.setState({ productGroups: productGroups });
	    }
	  }, {
	    key: 'productList',
	    value: function productList() {
	      var _this4 = this;
	
	      if (!this.state.productGroups) return null;
	
	      var productKeys = Object.keys(this.state.productGroups);
	
	      var products = productKeys.map(function (productKey) {
	        return _this4.state.productGroups[productKey];
	      }).map(function (productGroup) {
	        var product = _this4.state.collections.products[productGroup.products[0].product_token];
	        return _react2.default.createElement(_product2.default, {
	          key: product.token,
	          product: product,
	          collectionOptions: productGroup.products,
	          onEdit: _this4.openProductModal,
	          setActive: _this4.setProductActive
	        });
	      });
	
	      return products;
	    }
	  }, {
	    key: 'closeProductModal',
	    value: function closeProductModal() {
	      this.setState({ productToken: null });
	    }
	  }, {
	    key: 'openProductModal',
	    value: function openProductModal(productToken) {
	      this.setState({ productToken: productToken });
	    }
	  }, {
	    key: 'productModal',
	    value: function productModal() {
	      if (!this.state.productToken) return null;
	
	      var productGroup = this.state.productGroups[this.state.productToken];
	      var product = this.state.collections.products[this.state.productToken];
	      var batchCount = product.options[0].unit_multiplier;
	
	      var defaultSelection = productGroup.products.map(function (group) {
	        var batches = group.quantity / batchCount;
	        if (!batches) batches = 1;
	
	        return {
	          option: group.product_option_token,
	          batches: batches
	        };
	      });
	
	      return _react2.default.createElement(
	        _LightBox2.default,
	        { onClose: this.closeProductModal },
	        _react2.default.createElement(_ProductModal2.default, {
	          productToken: this.state.productToken,
	          retailerToken: this.props.params.retailerToken,
	          buttonText: 'Save',
	          defaultSelection: defaultSelection,
	          onSave: this.save,
	          onCancel: this.closeProductModal
	        })
	      );
	    }
	  }, {
	    key: 'save',
	    value: function save(productToken, selection) {
	      var product = this.state.collections.products[productToken];
	      var batchCount = product.options[0].unit_multiplier;
	
	      var newSelection = selection.map(function (select) {
	        return {
	          brand_token: product.brand_token,
	          product_option_token: select.option,
	          product_token: product.token,
	          quantity: select.batches * batchCount
	        };
	      });
	
	      var newProductGroup = _Api2.default.Utils.clone(this.state.productGroups, true);
	      newProductGroup[this.state.productToken].products = newSelection;
	      this.setState({ productGroups: newProductGroup });
	
	      this.closeProductModal();
	    }
	  }, {
	    key: 'addToBag',
	    value: function addToBag() {
	      var _this5 = this;
	
	      var cartList = [];
	      Object.keys(this.state.productGroups).map(function (productToken) {
	        return _this5.state.productGroups[productToken];
	      }).forEach(function (productGroup) {
	        if (!productGroup.active) return;
	
	        productGroup.products.forEach(function (productGroupItem) {
	          var cartItem = {
	            brand_token: productGroupItem.brand_token,
	            product_token: productGroupItem.product_token,
	            product_option_token: productGroupItem.product_option_token,
	            price_cents: productGroup.product.options[0].wholesale_price_cents,
	            quantity: productGroupItem.quantity
	          };
	          cartList.push(cartItem);
	        });
	      });
	
	      this.setState({
	        addingToBag: true
	      });
	
	      return _Api2.default.addToCart(cartList).then(function (response) {
	        _this5.context.router.push('/retailer/' + _this5.props.params.retailerToken);
	        return response;
	      }, function (error) {
	        console.error("Cannot add collection to bag.");
	        console.error(error);
	        _this5.setState({
	          addingToBag: false
	        });
	        return error;
	      });
	    }
	  }, {
	    key: 'onBreadCrumb',
	    value: function onBreadCrumb(_, position) {
	      // only home is relevant
	      if (position !== 0) {
	        return;
	      }
	      this.context.router.push('/retailer/' + this.props.params.retailerToken);
	    }
	  }, {
	    key: 'onCategory',
	    value: function onCategory(category, subcategory, filter) {
	      var params = {
	        category: category,
	        subcategory: subcategory,
	        filter: filter && filter.value || null
	      };
	
	      var queryString = Object.keys(params).filter(function (key) {
	        return params[key];
	      }).map(function (key) {
	        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
	      }).join('&');
	      this.context.router.push('/retailer/' + this.props.params.retailerToken + '?' + queryString);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      if (!this.state.collections || !this.state.categories) return _react2.default.createElement(
	        'div',
	        { className: 'retailer-loading-wrapper' },
	        _react2.default.createElement(_Processing2.default, null)
	      );
	      if (!this.state.activeCollection) return _react2.default.createElement(
	        'div',
	        null,
	        'Invalid collection'
	      );
	
	      var numberOfItems = 0;
	      var valueOfItems = 0;
	      var brandList = [];
	
	      Object.keys(this.state.productGroups).map(function (productKey) {
	        return _this6.state.productGroups[productKey];
	      }).forEach(function (productGroup) {
	        var brandToken = productGroup.product.brand_token;
	        if (brandList.indexOf(brandToken) < 0) {
	          brandList.push(brandToken);
	        }
	
	        if (productGroup.active) {
	          productGroup.products.forEach(function (collectionProduct) {
	            numberOfItems += collectionProduct.quantity;
	            valueOfItems += productGroup.product.options[0].wholesale_price_cents * collectionProduct.quantity;
	          });
	        }
	      });
	
	      var url = '';
	      if (brandList.length === 1) {
	        url = this.state.brand.url.replace(/https?:\/\/([^\/]*)\/?/, '$1');
	      }
	
	      var classNames = ['collection-component'];
	      if (this.state.scrollTop > topTreshold) classNames.push('scrolled');
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' ') },
	        _react2.default.createElement(_CategoryBar2.default, { categories: this.state.categories,
	          onSelect: this.onCategory,
	          filters: _consts.CATEGORY_FILTERS }),
	        _react2.default.createElement(_brand2.default, {
	          title: this.state.activeCollection.name,
	          brand: this.state.brand,
	          url: url,
	          description: this.state.activeCollection.description,
	          closestBrandRetailer: this.state.closestBrandRetailer,
	          count: numberOfItems,
	          cost: valueOfItems,
	          loading: this.state.addingToBag,
	          addToBag: this.addToBag
	        }),
	        _react2.default.createElement(_index2.default, { primary: this.state.activeCollection.name, onSelect: this.onBreadCrumb }),
	        _react2.default.createElement(
	          'div',
	          { className: 'product-list' },
	          this.productList()
	        ),
	        this.productModal()
	      );
	    }
	  }]);
	
	  return Collection;
	}(_react2.default.Component);
	
	Collection.contextTypes = {
	  router: _propTypes2.default.object
	};
	exports.default = Collection;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _checkbox = __webpack_require__(351);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _Api = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var findProductOption = function findProductOption(product, productOptionToken) {
	  return product.options.find(function (productOption) {
	    return productOption.token === productOptionToken;
	  });
	};
	
	var Product = function (_React$Component) {
	  _inherits(Product, _React$Component);
	
	  function Product(props) {
	    _classCallCheck(this, Product);
	
	    var _this = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props));
	
	    _this.options = _this.options.bind(_this);
	    _this.images = _this.images.bind(_this);
	    _this.toggleSelected = _this.toggleSelected.bind(_this);
	    _this.toggleEditModal = _this.toggleEditModal.bind(_this);
	
	    _this.state = {
	      groupEnabled: true,
	      images: _this.images(props.product)
	    };
	    return _this;
	  }
	
	  _createClass(Product, [{
	    key: 'productOptionsHierarchy',
	    value: function productOptionsHierarchy(product, productOption) {
	      var productHierarchy = [productOption];
	
	      var lastProductOption = productOption;
	      while (lastProductOption && lastProductOption.parent_token) {
	        lastProductOption = findProductOption(product, lastProductOption.parent_token);
	        productHierarchy.push(lastProductOption);
	      }
	
	      return productHierarchy;
	    }
	  }, {
	    key: 'options',
	    value: function options() {
	      var _this2 = this;
	
	      var firstCollectionOption = this.props.collectionOptions[0];
	      var firstProductOption = this.props.product.options.find(function (option) {
	        return option.token === firstCollectionOption.product_option_token;
	      });
	      var firstProductOptionHierarchy = this.productOptionsHierarchy(this.props.product, firstProductOption);
	
	      var styleHeader = firstProductOptionHierarchy.map(function (option) {
	        return option.group_name;
	      }).join(',');
	
	      var returnValue = [];
	      returnValue.push(_react2.default.createElement(
	        'div',
	        { key: this.props.product.token + '-options-header', className: 'option-line-header' },
	        _react2.default.createElement(
	          'span',
	          null,
	          styleHeader
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Units'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Cost'
	        )
	      ));
	
	      this.props.collectionOptions.forEach(function (collectionOption) {
	        var productOption = _this2.props.product.options.find(function (option) {
	          return option.token === collectionOption.product_option_token;
	        });
	        var productCharacteristics = [];
	
	        if (_this2.props.product.options && _this2.props.product.options.length > 1) {
	          var productHierarchy = _this2.productOptionsHierarchy(_this2.props.product, productOption);
	          productCharacteristics = productHierarchy.map(function (option) {
	            return option.name;
	          });
	        }
	
	        returnValue.push(_react2.default.createElement(
	          'div',
	          { key: collectionOption.product_option_token, className: 'option-line' },
	          _react2.default.createElement(
	            'span',
	            null,
	            productCharacteristics.join(', ')
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            collectionOption.quantity
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            '$',
	            _Api.Utils.formatCents(productOption.wholesale_price_cents * collectionOption.quantity)
	          )
	        ));
	      });
	
	      return returnValue;
	    }
	  }, {
	    key: 'images',
	    value: function images(product) {
	      var images = [];
	
	      product = product || this.props.product;
	      if (!product) return images;
	
	      product.images.forEach(function (image) {
	        images.push(image);
	      });
	      product.options.forEach(function (product_option) {
	        product_option.images.forEach(function (image) {
	          images.push(image);
	        });
	      });
	
	      return images;
	    }
	  }, {
	    key: 'toggleSelected',
	    value: function toggleSelected(event) {
	      event.preventDefault();
	      if (this.props.setActive) this.props.setActive(this.props.product.token, !this.state.groupEnabled);
	      this.setState({ groupEnabled: !this.state.groupEnabled });
	    }
	  }, {
	    key: 'toggleEditModal',
	    value: function toggleEditModal(event) {
	      if (!event.defaultPrevented && this.state.groupEnabled) {
	        this.props.onEdit(this.props.product.token);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var classNames = ['collection-product-component'];
	
	      if (!this.props.product || !this.props.product.options || this.props.product.options.length <= 0) return _react2.default.createElement(
	        'div',
	        null,
	        'Invalid product'
	      );
	
	      if (!this.state.groupEnabled) classNames.push('disabled');
	      if (this.props.className) classNames.push(this.props.className);
	
	      var imageUrl = null;
	      if (this.state.images && this.state.images.length > 0) {
	        imageUrl = this.state.images[0].url;
	      }
	
	      var description = this.props.product.description || '';
	      if (description.indexOf('.') > 0) {
	        description = description.substr(0, description.indexOf('.') + 1);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' ') },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner-wrapper collection-product-component-inner-wrapper', onClick: this.toggleEditModal },
	          _react2.default.createElement('div', { className: 'disabled-mask' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'image' },
	            _react2.default.createElement('img', { role: 'presentation', src: imageUrl })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'name' },
	              this.props.product.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'description' },
	              description
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pricing' },
	              _react2.default.createElement(
	                'div',
	                { className: 'unitprice' },
	                'Unit Cost $',
	                _Api.Utils.formatCents(this.props.product.options[0].wholesale_price_cents)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'srp' },
	                'SRP $',
	                _Api.Utils.formatCents(this.props.product.options[0].retail_price_cents)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'case-size' },
	                'CASE SIZE ',
	                this.props.product.options[0].unit_multiplier
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'options' },
	            _react2.default.createElement(
	              'div',
	              { className: 'header' },
	              'INCLUDED ITEMS ',
	              _react2.default.createElement(
	                'span',
	                { className: 'edit' },
	                'Edit ',
	                _react2.default.createElement(_reactFontawesome2.default, { name: 'pencil' })
	              )
	            ),
	            this.options()
	          ),
	          _react2.default.createElement(_checkbox2.default, { onClick: this.toggleSelected, value: this.state.groupEnabled, label: 'Include' })
	        )
	      );
	    }
	  }]);
	
	  return Product;
	}(_react2.default.Component);
	
	Product.propTypes = {
	  product: _propTypes2.default.object.isRequired,
	  collectionOptions: _propTypes2.default.array.isRequired,
	  onEdit: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  setActive: _propTypes2.default.func
	};
	exports.default = Product;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountOrderStatus = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(10);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _account_order_status = __webpack_require__(355);
	
	var _account_order_status2 = _interopRequireDefault(_account_order_status);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sections = {
	  'Account': 'account',
	  'Saved Items': 'saved',
	  'Orders & Returns': 'orders',
	  'Payment information': 'payment',
	  'Shipping Information': 'shipping',
	  'Invite': 'invite',
	  'Log Out': 'logout'
	};
	
	var Account = function (_React$Component) {
	  _inherits(Account, _React$Component);
	
	  function Account(props) {
	    _classCallCheck(this, Account);
	
	    var _this = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, props));
	
	    _this.state = {
	      user: _Api2.default.cache.getUser()
	    };
	    return _this;
	  }
	
	  _createClass(Account, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.userStartListen(this, 'user');
	      _Api2.default.getUser();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.userStopListen(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.user) return null;
	      var currentSection = this.props.location.pathname.replace('/user/account', '').replace(/\//g, '') || 'orders';
	
	      var menu = Object.keys(sections).map(function (sectionName) {
	        var key = sections[sectionName];
	
	        return _react2.default.createElement(
	          'div',
	          { key: 'user-account-menuitem-' + key, className: 'menu-item' + (currentSection === key ? ' active' : '') },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/user/account/' + key },
	            sectionName
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'user-account' },
	        _react2.default.createElement(
	          'div',
	          { className: 'menu' },
	          menu
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contents' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Account;
	}(_react2.default.Component);
	
	exports.default = Account;
	exports.AccountOrderStatus = _account_order_status2.default;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderProduct = exports.OrderEntryHeader = exports.OrderEntry = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AccountMenu = __webpack_require__(116);
	
	var _AccountMenu2 = _interopRequireDefault(_AccountMenu);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dateFormat = 'MMM, Do YYYY';
	var TBD = 'TBD*';
	
	var OrderStatus = function (_React$Component) {
	  _inherits(OrderStatus, _React$Component);
	
	  function OrderStatus(props) {
	    _classCallCheck(this, OrderStatus);
	
	    var _this = _possibleConstructorReturn(this, (OrderStatus.__proto__ || Object.getPrototypeOf(OrderStatus)).call(this, props));
	
	    _this.state = {
	      orderListLoading: false,
	      orderList: [],
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(OrderStatus, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.setState({ orderListLoading: true });
	      _Api2.default.orderListStartListen(this, 'orderList');
	      _Api2.default.getOrders().then(function () {
	        _this2.setState({ orderListLoading: false });
	      }, function (error) {
	        _this2.setState({ error: error });
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.orderListStopListen(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var orders = (this.state.orderList ? this.state.orderList.orders : null) || [];
	
	      var orderEntryList = null;
	      if (this.state.error) {
	        orderEntryList = _react2.default.createElement(
	          'div',
	          null,
	          'Something went wrong: ',
	          _react2.default.createElement(
	            'em',
	            null,
	            this.state.error.message
	          )
	        );
	      } else if (this.state.orderListLoading) {
	        orderEntryList = _react2.default.createElement(
	          'div',
	          { className: 'fullscreen-component center-inside' },
	          _react2.default.createElement(_Processing2.default, null)
	        );
	      } else {
	        orderEntryList = orders.map(function (orderEntry) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'orderlist-container', key: 'order-' + orderEntry.token },
	            _react2.default.createElement(OrderEntry, {
	              order: orderEntry,
	              products: _this3.state.orderList.products,
	              brands: _this3.state.orderList.brands })
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'account-orders' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Your Orders'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'account-orders-preamble' },
	          _react2.default.createElement(
	            'p',
	            { className: 'note' },
	            'We accept orders within 90 days of purchase that have not sold. Please ensure that items are unused, unwashed, and undamaged.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row first-row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-50 align-top' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Online Orders'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'If for any reason you wish to return an item you can do so by clicking on the \u2018',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Create Return'
	                ),
	                '\u2019 link underneath the order below.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-50 align-top' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Return Address'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Mail back all returns to the address below for 100% money back return.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'address' },
	                'INDIGO FAIR',
	                _react2.default.createElement('br', null),
	                '1920 Pacific Ave',
	                _react2.default.createElement('br', null),
	                'San Francisco CA',
	                _react2.default.createElement('br', null),
	                '94109'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _AccountMenu2.default,
	          { className: this.state.orderListLoading ? 'hidden' : '' },
	          _react2.default.createElement(
	            'li',
	            { className: 'active' },
	            'Orders'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'hidden' },
	            'Open Orders'
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'hidden' },
	            'Cancelled Orders'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'order-count' + (orders.length <= 0 ? ' hidden' : '') },
	          orders.length,
	          ' Orders placed in the ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Past 6 months'
	          )
	        ),
	        orderEntryList
	      );
	    }
	  }]);
	
	  return OrderStatus;
	}(_react2.default.Component);
	
	var OrderEntry = function (_React$Component2) {
	  _inherits(OrderEntry, _React$Component2);
	
	  function OrderEntry(props) {
	    _classCallCheck(this, OrderEntry);
	
	    var _this4 = _possibleConstructorReturn(this, (OrderEntry.__proto__ || Object.getPrototypeOf(OrderEntry)).call(this, props));
	
	    _this4.state = {
	      collapsed: true
	    };
	
	
	    _this4.toggleCollapsed = _this4.toggleCollapsed.bind(_this4);
	    _this4.buildShipmentGroups = _this4.buildShipmentGroups.bind(_this4);
	    return _this4;
	  }
	
	  _createClass(OrderEntry, [{
	    key: 'toggleCollapsed',
	    value: function toggleCollapsed(event) {
	      if (event.defaultPrevented) return;
	      event.preventDefault();
	
	      this.setState({
	        collapsed: !this.state.collapsed
	      });
	    }
	  }, {
	    key: 'buildShipmentGroups',
	    value: function buildShipmentGroups() {
	      var _this5 = this;
	
	      var shipmentGroups = [];
	      var shippedGoods = [];
	
	      // Group products inside each shipment
	      this.props.order.shipments.forEach(function (shipment) {
	        // Adds every item token to the array of shipped goods. It's not a problem if there are duplicates.
	        shipment.order_item_tokens.forEach(function (order_item_token) {
	          shippedGoods.push(order_item_token);
	        });
	
	        // Create shipment group
	        var shipmentGroup = {};
	        shipmentGroup.shipment = shipment;
	        shipmentGroup.items = _this5.props.order.items.filter(function (order_item) {
	          return shipment.order_item_tokens.indexOf(order_item.token) >= 0;
	        });
	        shipmentGroup.products = {};
	        shipmentGroup.items.forEach(function (order_item) {
	          shipmentGroup.products[order_item.product_token] = _this5.props.products[order_item.product_token];
	        });
	        shipmentGroup.brand_token = shipmentGroup.items[0].brand_token;
	        shipmentGroup.brand = _this5.props.brands[shipmentGroup.brand_token];
	
	        shipmentGroups.push(shipmentGroup);
	      });
	
	      // Group the remaining products that don't have shipment status yet
	      Object.keys(this.props.brands).forEach(function (brand_token) {
	        var items = _this5.props.order.items.filter(function (order_item) {
	          return order_item.brand_token === brand_token;
	        }).filter(function (order_item) {
	          return shippedGoods.indexOf(order_item.token) < 0;
	        });
	        if (items.length <= 0) return;
	
	        var shipmentGroup = {};
	        shipmentGroup.shipment = null;
	        shipmentGroup.items = items;
	        shipmentGroup.products = {};
	        shipmentGroup.items.forEach(function (order_item) {
	          shipmentGroup.products[order_item.product_token] = _this5.props.products[order_item.product_token];
	        });
	        shipmentGroup.brand_token = brand_token;
	        shipmentGroup.brand = _this5.props.brands[shipmentGroup.brand_token];
	
	        shipmentGroups.push(shipmentGroup);
	      });
	
	      // We need this sorted by brand.
	      return shipmentGroups.sort(function (a, b) {
	        return a.brand_token.localeCompare(b.brand_token);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var shipments = this.buildShipmentGroups();
	      var shipmentList = shipments.map(function (shipment) {
	        return _react2.default.createElement(OrderShipmentGroup, {
	          className: _this6.state.collapsed ? 'hidden' : '',
	          key: 'order-shipment-group-' + shipment.brand_token + '-' + (shipment.shipment ? shipment.shipment.token : 'not-shipped'),
	          shipment: shipment
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'order-entry' },
	        _react2.default.createElement(OrderEntryHeader, {
	          onClick: this.toggleCollapsed,
	          order: this.props.order,
	          collapsed: this.state.collapsed
	        }),
	        shipmentList
	      );
	    }
	  }]);
	
	  return OrderEntry;
	}(_react2.default.Component);
	
	var OrderEntryHeader = function (_React$Component3) {
	  _inherits(OrderEntryHeader, _React$Component3);
	
	  function OrderEntryHeader() {
	    _classCallCheck(this, OrderEntryHeader);
	
	    return _possibleConstructorReturn(this, (OrderEntryHeader.__proto__ || Object.getPrototypeOf(OrderEntryHeader)).apply(this, arguments));
	  }
	
	  _createClass(OrderEntryHeader, [{
	    key: 'render',
	    value: function render() {
	      var order = this.props.order;
	      if (!order) return;
	
	      var orderCreation = (0, _moment2.default)(order.created_at);
	      var addressName = order.shipping_address ? order.shipping_address.name : null;
	
	      var freight = TBD;
	      if (order.shipping_amount_cents !== undefined && order.shipping_amount_cents !== null) {
	        if (order.shipping_amount_cents === 0) {
	          freight = 'Free';
	        } else {
	          freight = '$' + _Api2.default.Utils.formatCents(order.shipping_amount_cents);
	        }
	      }
	      var total = '$' + _Api2.default.Utils.formatCents(order.total_amount_cents);
	      if (freight === TBD) {
	        total += '*';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'order-header', id: 'order-header-' + order.token, onClick: this.props.onClick },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-block collapsed' },
	          this.props.collapsed ? '+' : '-'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header-block placed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            'Order Placed'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'value' },
	            orderCreation.format(dateFormat)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header-block subtotal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            'Subtotal'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'value' },
	            '$',
	            _Api2.default.Utils.formatCents(order.items_amount_cents)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header-block freight' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            'Freight'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'value' },
	            freight
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header-block total' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            'Total'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'value' },
	            total
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header-block shipto' + (addressName ? '' : ' empty') },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            'Ship to'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'value' },
	            addressName
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header-block ordernumber' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            'Order Number'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'value' },
	            order.token
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header-block actions hidden' },
	          _react2.default.createElement(
	            'div',
	            { className: 'action' },
	            'Order Details'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'action' },
	            'Invoice'
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderEntryHeader;
	}(_react2.default.Component);
	
	var OrderShipmentGroup = function (_React$Component4) {
	  _inherits(OrderShipmentGroup, _React$Component4);
	
	  function OrderShipmentGroup() {
	    _classCallCheck(this, OrderShipmentGroup);
	
	    return _possibleConstructorReturn(this, (OrderShipmentGroup.__proto__ || Object.getPrototypeOf(OrderShipmentGroup)).apply(this, arguments));
	  }
	
	  _createClass(OrderShipmentGroup, [{
	    key: 'render',
	    value: function render() {
	      var shipment = this.props.shipment;
	      var orderItems = this.props.shipment.items.map(function (order_item, index) {
	        return _react2.default.createElement(OrderProduct, {
	          key: 'order-' + shipment.token + '-product-' + order_item.token,
	          hideDeliveryStatus: index > 0,
	          orderItem: order_item,
	          product: shipment.products[order_item.product_token],
	          brand: shipment.brand,
	          shipment: shipment.shipment
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'order-shipment-group' + (this.props.className ? ' ' + this.props.className : '') },
	        orderItems
	      );
	    }
	  }]);
	
	  return OrderShipmentGroup;
	}(_react2.default.Component);
	
	var OrderProduct = function (_React$Component5) {
	  _inherits(OrderProduct, _React$Component5);
	
	  function OrderProduct(props) {
	    _classCallCheck(this, OrderProduct);
	
	    var _this9 = _possibleConstructorReturn(this, (OrderProduct.__proto__ || Object.getPrototypeOf(OrderProduct)).call(this, props));
	
	    _this9.buyItAgain = _this9.buyItAgain.bind(_this9);
	    return _this9;
	  }
	
	  _createClass(OrderProduct, [{
	    key: 'buyItAgain',
	    value: function buyItAgain() {
	      var payload = {};
	      payload.brand_token = this.props.orderItem.brand_token;
	      payload.product_token = this.props.orderItem.product_token;
	      payload.product_option_token = this.props.orderItem.product_option_token;
	      payload.quantity = this.props.orderItem.quantity;
	      payload.price_cents = this.props.orderItem.price_cents;
	
	      return _Api2.default.addToCart([payload]);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var product = this.props.product;
	      var orderItem = this.props.orderItem;
	
	      var productOption = product.options.find(function (productOption) {
	        return productOption.token === orderItem.product_option_token;
	      });
	
	      var productImage = null;
	      var productImageUrl = null;
	      if (productOption.images.length > 0) {
	        productImageUrl = productOption.images[0].url;
	      } else if (product.images.length > 0) {
	        productImageUrl = product.images[0].url;
	      }
	
	      if (productImageUrl) {
	        productImage = _react2.default.createElement('img', { src: productImageUrl, role: 'presentation' });
	      }
	
	      var deliveryStatusSection = null;
	      var buttons = null;
	      if (!this.props.hideDeliveryStatus) {
	        var deliveryStatusHeader = orderItem.state;
	        if (deliveryStatusHeader === 'WAITING_ON_SHIPPING') {
	          deliveryStatusHeader = 'Shipping Soon';
	        } else {
	          deliveryStatusHeader = deliveryStatusHeader.replace(/_/g, ' ');
	        }
	        var freightValue = null;
	        if (this.props.shipment && this.props.shipment.cost_cents !== null) {
	          if (this.props.shipment.cost_cents === 0) {
	            freightValue = _react2.default.createElement(
	              'span',
	              { className: 'price-info' },
	              'Free Freight'
	            );
	          } else {
	            freightValue = _react2.default.createElement(
	              'span',
	              { className: 'price-info' },
	              'Freight ',
	              _react2.default.createElement(
	                'span',
	                { className: 'price' },
	                '$',
	                _Api2.default.Utils.formatCents(this.props.shipment.cost_cents)
	              )
	            );
	          }
	        }
	        if (!freightValue && orderItem.expected_ship_date) {
	          freightValue = 'Expected to ship at ' + _Api.Utils.millisToYMD(orderItem.expected_ship_date);
	        }
	
	        deliveryStatusSection = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'header' },
	            deliveryStatusHeader
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'detail' },
	            freightValue
	          )
	        );
	
	        if (this.props.shipment && this.props.shipment.tracking_code) {
	          buttons = _react2.default.createElement(
	            'div',
	            { className: 'actions button-column' },
	            _react2.default.createElement(
	              _Button2.default,
	              { className: 'hidden default' },
	              'Track Package'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: 'hidden' },
	              'Download Invoice'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: 'hidden' },
	              'Cancel Item'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: 'hidden' },
	              'Return Item'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: 'hidden' },
	              'Archive Order'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: 'hidden' },
	              'Leave Feedback'
	            )
	          );
	        }
	      }
	
	      if (!buttons) buttons = _react2.default.createElement('div', { className: 'actions button-column' });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'product-entry', id: 'order-product-entry-' + this.props.orderItem.token },
	        _react2.default.createElement(
	          'div',
	          { className: 'delivery-status' },
	          deliveryStatusSection
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'product-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'product-data' },
	            _react2.default.createElement(
	              'div',
	              { className: 'image' },
	              productImage
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'details' },
	              _react2.default.createElement(
	                'div',
	                { className: 'brand-name' },
	                this.props.brand.name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'product' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'quantity' },
	                  this.props.orderItem.quantity,
	                  ' x'
	                ),
	                ' ',
	                this.props.product.name
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'individual-prices' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wholesale price-info' },
	                  'Wholesale Price ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'price' },
	                    '$',
	                    _Api2.default.Utils.formatCents(this.props.orderItem.price_cents)
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'retail price-info' },
	                  'Retail Price ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'price' },
	                    '$',
	                    _Api2.default.Utils.formatCents(productOption.retail_price_cents)
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'actions' },
	            _react2.default.createElement(
	              _Button2.default,
	              { onClick: this.buyItAgain },
	              'Buy it Again'
	            )
	          )
	        ),
	        buttons
	      );
	    }
	  }]);
	
	  return OrderProduct;
	}(_react2.default.Component);
	
	OrderProduct.propTypes = {
	  product: _propTypes2.default.object.isRequired,
	  orderItem: _propTypes2.default.object.isRequired,
	  shipment: _propTypes2.default.object,
	  hideDeliveryStatus: _propTypes2.default.bool
	};
	exports.default = OrderStatus;
	exports.OrderEntry = OrderEntry;
	exports.OrderEntryHeader = OrderEntryHeader;
	exports.OrderProduct = OrderProduct;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccountStatus = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataGrid = __webpack_require__(56);
	
	var _reactDataGrid2 = _interopRequireDefault(_reactDataGrid);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountStatus = function (_React$Component) {
	  _inherits(AccountStatus, _React$Component);
	
	  function AccountStatus(props) {
	    _classCallCheck(this, AccountStatus);
	
	    var _this = _possibleConstructorReturn(this, (AccountStatus.__proto__ || Object.getPrototypeOf(AccountStatus)).call(this, props));
	
	    _this.state = {
	      user: null,
	      rows: []
	    };
	
	    _this.getColumns = _this.getColumns.bind(_this);
	    _this.getRow = _this.getRow.bind(_this);
	    _this.getRowCount = _this.getRowCount.bind(_this);
	
	    _this.columns = [{
	      key: 'name',
	      name: 'Name',
	      width: 250,
	      resizable: true
	    }, {
	      key: 'items',
	      name: 'Order Items',
	      width: 150,
	      resizable: true
	    }, {
	      key: 'amount',
	      name: 'Total amount',
	      width: 150,
	      resizable: true
	    }];
	    return _this;
	  }
	
	  _createClass(AccountStatus, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var user = _Api2.default.cache.getUser(true);
	      if (user) {
	        this.onUserLoaded(user);
	        return;
	      }
	
	      _Api2.default.getUser().then(function (userResponse) {
	        user = userResponse;
	        _this2.onUserLoaded(user);
	      }, function (error) {
	        console.error('Error getting user: ' + error.message);
	      });
	    }
	  }, {
	    key: "onUserLoaded",
	    value: function onUserLoaded(user) {
	      var _this3 = this;
	
	      if (!user.retailer_token) return;
	
	      _Api2.default.getAccountStatus(user.retailer_token).then(function (accountStatus) {
	
	        var rows = [];
	        rows.push({
	          name: 'Outstanding order items',
	          items: accountStatus.outstanding_items,
	          amount: '$' + (_Api2.default.Utils.formatCents(accountStatus.outstanding_items_amount_cents) || '0')
	        });
	        rows.push({
	          name: 'Paid order items',
	          items: accountStatus.paid_items,
	          amount: '$' + (_Api2.default.Utils.formatCents(accountStatus.paid_items_amount_cents) || '0')
	        });
	        rows.push({
	          name: 'Cancelled order items',
	          items: accountStatus.canceled_items,
	          amount: '$' + (_Api2.default.Utils.formatCents(accountStatus.canceled_items_amount_cents) || '0')
	        });
	        rows.push({
	          name: 'Order items pending return',
	          items: accountStatus.return_pending_items,
	          amount: '$' + (_Api2.default.Utils.formatCents(accountStatus.return_pending_items_amount_cents) || '0')
	        });
	        rows.push({
	          name: 'Returned ordem items',
	          items: accountStatus.returned_items,
	          amount: '$' + (_Api2.default.Utils.formatCents(accountStatus.returned_items_amount_cents) || '0')
	        });
	        rows.push({
	          name: 'Outstanding Shipments',
	          items: accountStatus.outstanding_shipments,
	          amount: '$' + (_Api2.default.Utils.formatCents(accountStatus.outstanding_shipments_amount_cents) || '0')
	        });
	        rows.push({
	          name: 'Paid Shipments',
	          items: accountStatus.paid_shipments,
	          amount: '$' + (_Api2.default.Utils.formatCents(accountStatus.paid_shipments_amount_cents) || '0')
	        });
	        rows.push({
	          name: 'Untracked Shipments',
	          items: accountStatus.untracked_shipments,
	          amount: '$' + (_Api2.default.Utils.formatCents(accountStatus.untracked_shipments_amount_cents) || '0')
	        });
	
	        _this3.setState({ rows: rows });
	      }, function (error) {
	        console.error('Error getting account status: ' + error.message);
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      return this.columns;
	    }
	  }, {
	    key: "getRow",
	    value: function getRow(index) {
	      return this.state.rows[index];
	    }
	  }, {
	    key: "getRowCount",
	    value: function getRowCount() {
	      return this.state.rows.length;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactDataGrid2.default, {
	        enableCellSelect: false,
	        columns: this.getColumns(),
	        rowGetter: this.getRow,
	        rowsCount: this.getRowCount(),
	        enableRowSelect: false,
	        rowHeight: 35,
	        minHeight: 600,
	        rowScrollTimeout: 200
	      });
	    }
	  }]);
	
	  return AccountStatus;
	}(_react2.default.Component);
	
	exports.default = AccountStatus;
	exports.AccountStatus = AccountStatus;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Code = function (_React$Component) {
	  _inherits(Code, _React$Component);
	
	  function Code(props) {
	    _classCallCheck(this, Code);
	
	    var _this = _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).call(this, props));
	
	    _this.onSignIn = _this.onSignIn.bind(_this);
	    _this.onKeyPress = _this.onKeyPress.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	
	    _this.state = {
	      invalidCode: false,
	      code: ''
	    };
	    return _this;
	  }
	
	  _createClass(Code, [{
	    key: 'onKeyPress',
	    value: function onKeyPress(event) {
	      if (event.key === 'Enter') {
	        return this.refs.submit.click(event);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      if (event.defaultPrevented) return;
	
	      var initialValue = event.target.value || '';
	      var value = initialValue.replace(/\D/g, '');
	
	      this.setState({
	        code: value
	      });
	    }
	  }, {
	    key: 'onSignIn',
	    value: function onSignIn() {
	      var _this2 = this;
	
	      this.setState({ invalidCode: false });
	
	      return _Api2.default.userLogin(this.props.params.email, this.refs.credential.value).then(function (user) {
	        if (!user) {
	          _this2.setState({ invalidCode: true });
	        } else {
	          var defaultRedirect = user.retailer_token ? '/retailer/' + user.retailer_token : '/';
	          _this2.context.router.push(_this2.props.location.query.redirect || defaultRedirect);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-flyout signin' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Sign In'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'note' },
	          'Enter the access code we sent to ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            this.props.params.email
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'credential', placeholder: 'Confirmation Code', className: 'center', pattern: '\\d*', value: this.state.code, onChange: this.onChange, onKeyPress: this.onKeyPress })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.state.invalidCode ? '' : 'hidden' },
	          'Invalid code'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { ref: 'submit', onClick: this.onSignIn },
	            'Sign In'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Code;
	}(_react2.default.Component);
	
	exports.default = Code;
	
	
	Code.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserPayments = exports.UserAccountStatus = exports.UserAccountOrderStatus = exports.UserAccount = exports.UserCode = exports.UserSignout = exports.UserSignin = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _signin = __webpack_require__(360);
	
	var _signin2 = _interopRequireDefault(_signin);
	
	var _signout = __webpack_require__(361);
	
	var _signout2 = _interopRequireDefault(_signout);
	
	var _code = __webpack_require__(357);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _account = __webpack_require__(354);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _account_status = __webpack_require__(356);
	
	var _account_status2 = _interopRequireDefault(_account_status);
	
	var _payments = __webpack_require__(359);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	__webpack_require__(398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var User = function (_React$Component) {
	  _inherits(User, _React$Component);
	
	  function User() {
	    _classCallCheck(this, User);
	
	    return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
	  }
	
	  _createClass(User, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'user-component' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return User;
	}(_react2.default.Component);
	
	exports.default = User;
	
	
	var UserAccountOrderStatus = _account.AccountOrderStatus;
	
	exports.UserSignin = _signin2.default;
	exports.UserSignout = _signout2.default;
	exports.UserCode = _code2.default;
	exports.UserAccount = _account2.default;
	exports.UserAccountOrderStatus = UserAccountOrderStatus;
	exports.UserAccountStatus = _account_status2.default;
	exports.UserPayments = _payments2.default;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(9);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _AccountMenu = __webpack_require__(116);
	
	var _AccountMenu2 = _interopRequireDefault(_AccountMenu);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _payments = __webpack_require__(69);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	var _LightBox = __webpack_require__(32);
	
	var _LightBox2 = _interopRequireDefault(_LightBox);
	
	var _PaymentInformation = __webpack_require__(71);
	
	__webpack_require__(397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Payments = function (_React$Component) {
	  _inherits(Payments, _React$Component);
	
	  function Payments(props) {
	    _classCallCheck(this, Payments);
	
	    var _this = _possibleConstructorReturn(this, (Payments.__proto__ || Object.getPrototypeOf(Payments)).call(this, props));
	
	    _Api2.default.Utils.bindThis(_this, ['showModal', 'hideModal', 'actionLinkBankAccount', 'actionLinkCreditCard']);
	
	    _this.state = {
	      modalVisible: false,
	      user: _Api2.default.cache.getUser()
	    };
	    return _this;
	  }
	
	  _createClass(Payments, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _Api2.default.userStartListen(this, 'user');
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Api2.default.userStopListen(this);
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal() {
	      this.setState({ modalVisible: true });
	    }
	  }, {
	    key: 'hideModal',
	    value: function hideModal() {
	      this.setState({ modalVisible: false });
	    }
	  }, {
	    key: 'actionLinkBankAccount',
	    value: function actionLinkBankAccount(event) {
	      event.preventDefault();
	      var returnValue = _payments2.default.addBankAccount(this.state.user);
	
	      returnValue.then(this.hideModal);
	
	      return returnValue;
	    }
	  }, {
	    key: 'actionLinkCreditCard',
	    value: function actionLinkCreditCard(event) {
	      event.preventDefault();
	      var returnValue = _payments2.default.addCreditCard(this.state.user);
	
	      returnValue.then(this.hideModal);
	
	      return returnValue;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.user) return null;
	
	      var instruments = (this.state.user.instruments || []).map(function (instrument, idx) {
	        return _react2.default.createElement(PaymentEntry, { key: instrument.token, instrument: instrument, 'default': idx === 0 });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'payments-component' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.showModal, className: 'fixed-right' },
	            'Add Payment Method'
	          ),
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Manage Payment Methods'
	          )
	        ),
	        _react2.default.createElement(
	          _AccountMenu2.default,
	          { className: this.state.orderListLoading ? 'hidden' : '' },
	          _react2.default.createElement(
	            'li',
	            { className: 'active' },
	            'Payment Methods'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'payment-methods' },
	          instruments
	        ),
	        _react2.default.createElement(
	          _LightBox2.default,
	          { onClose: this.hideModal, className: 'payments-modal' + (this.state.modalVisible ? '' : ' hidden') },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Select a Payment Method'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_PaymentInformation.NetNinetyPayment, { title: 'ADD BANK ACCOUNT', buttonText: 'LINK ACCOUNT', onClick: this.actionLinkBankAccount }),
	            _react2.default.createElement(_PaymentInformation.CreditCardPayment, { title: 'ADD CREDIT CARD', buttonText: 'LINK CARD', onClick: this.actionLinkCreditCard })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Payments;
	}(_react2.default.Component);
	
	exports.default = Payments;
	
	var PaymentEntry = function (_React$Component2) {
	  _inherits(PaymentEntry, _React$Component2);
	
	  function PaymentEntry(props) {
	    _classCallCheck(this, PaymentEntry);
	
	    var _this2 = _possibleConstructorReturn(this, (PaymentEntry.__proto__ || Object.getPrototypeOf(PaymentEntry)).call(this, props));
	
	    _this2.flag = _this2.flag.bind(_this2);
	    _this2.cardInfo = _this2.cardInfo.bind(_this2);
	    _this2.expiration = _this2.expiration.bind(_this2);
	    _this2.setDefault = _this2.setDefault.bind(_this2);
	    _this2.removeInstrument = _this2.removeInstrument.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(PaymentEntry, [{
	    key: 'flag',
	    value: function flag() {
	      var flag = null;
	
	      if (this.props.instrument.card) {
	        flag = this.props.instrument.card.brand;
	      }
	      if (this.props.instrument.bank_account) {
	        flag = this.props.instrument.bank_account.institution;
	      }
	
	      switch (flag) {
	        case 'VISA':
	        case 'MASTERCARD':
	        case 'AMEX':
	        case 'PAYPAL':
	          return _react2.default.createElement(_reactFontawesome2.default, { name: 'cc-' + flag.toLowerCase() });
	        default:
	      }
	
	      return flag;
	    }
	  }, {
	    key: 'cardInfo',
	    value: function cardInfo() {
	      if (this.props.instrument.card) {
	        return '**** **** **** ' + this.props.instrument.card.last_four;
	      }
	      if (this.props.instrument.bank_account) {
	        return this.props.instrument.bank_account.account_number;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'expiration',
	    value: function expiration() {
	      if (!this.props.instrument.card || !this.props.instrument.card.expiration) return null;
	      return this.props.instrument.card.expiration.month + '/' + this.props.instrument.card.expiration.year;
	    }
	  }, {
	    key: 'setDefault',
	    value: function setDefault(event) {
	      event.preventDefault();
	      console.log('setDefault');
	      return _Api2.default.setDefaultInstrument(this.props.instrument.token);
	    }
	  }, {
	    key: 'removeInstrument',
	    value: function removeInstrument(event) {
	      event.preventDefault();
	
	      var alertText = 'Are you sure you want to remove payment ' + this.cardInfo();
	      if (!confirm(alertText)) return;
	
	      console.log('remove instrument');
	
	      return _Api2.default.removeInstrument(this.props.instrument.token).then(function () {
	        return _Api2.default.getUser();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var defaultOption = 'Default';
	      if (!this.props.default) {
	        defaultOption = _react2.default.createElement(
	          _Button2.default,
	          { onClick: this.setDefault },
	          'Set as Default'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'payment-entry' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flag' },
	          this.flag()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'number' },
	            this.cardInfo()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'expiration' },
	            this.expiration()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'default' },
	          defaultOption
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'delete' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'remove' + (this.props.default ? ' hidden' : ''), onClick: this.removeInstrument },
	            'Remove'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentEntry;
	}(_react2.default.Component);
	
	PaymentEntry.propTypes = {
	  instrument: _propTypes2.default.object.isRequired,
	  "default": _propTypes2.default.bool
	};

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(6);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignIn = function (_React$Component) {
	  _inherits(SignIn, _React$Component);
	
	  function SignIn(props) {
	    _classCallCheck(this, SignIn);
	
	    var _this = _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this, props));
	
	    _this.onSignIn = _this.onSignIn.bind(_this);
	    _this.onKeyPress = _this.onKeyPress.bind(_this);
	
	    _this.state = {
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(SignIn, [{
	    key: 'onSignIn',
	    value: function onSignIn() {
	      var _this2 = this;
	
	      var redirectQuery = this.props.location.query.redirect ? '?redirect=' + this.props.location.query.redirect : '';
	      return _Api2.default.userLogin(this.refs.credential.value).then(function () {
	        var route = '/user/code/' + _this2.refs.credential.value + redirectQuery;
	        _this2.context.router.push(route);
	      }, function (error) {
	        _this2.setState({ error: error });
	      });
	    }
	  }, {
	    key: 'onKeyPress',
	    value: function onKeyPress(event) {
	      if (event.key === 'Enter') {
	        this.setState({ error: null });
	        return this.refs.submit.click(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var welcomeback = null;
	      if (this.props.location.query.welcomeback) {
	        welcomeback = _react2.default.createElement(
	          'p',
	          { className: 'note' },
	          'Welcome back! Enter the email or phone number you provided when creating your account to receive your access code.'
	        );
	      }
	
	      var errorMessage = null;
	      if (this.state.error && this.state.error.message) {
	        errorMessage = _react2.default.createElement(
	          'div',
	          { className: 'error' },
	          this.state.error.message
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page-flyout signin' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Sign In'
	        ),
	        welcomeback,
	        _react2.default.createElement(
	          'div',
	          { className: 'input' },
	          _react2.default.createElement('input', { type: 'text', ref: 'credential', placeholder: 'Phone or Email', className: 'center', onKeyPress: this.onKeyPress })
	        ),
	        errorMessage,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { ref: 'submit', onClick: this.onSignIn },
	            'Request Sign In Code'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignIn;
	}(_react2.default.Component);
	
	exports.default = SignIn;
	
	
	SignIn.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Processing = __webpack_require__(17);
	
	var _Processing2 = _interopRequireDefault(_Processing);
	
	var _Api = __webpack_require__(4);
	
	var _Api2 = _interopRequireDefault(_Api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignOut = function (_React$Component) {
	  _inherits(SignOut, _React$Component);
	
	  function SignOut() {
	    _classCallCheck(this, SignOut);
	
	    return _possibleConstructorReturn(this, (SignOut.__proto__ || Object.getPrototypeOf(SignOut)).apply(this, arguments));
	  }
	
	  _createClass(SignOut, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var returnToRoot = function returnToRoot(response) {
	        this.context.router.push('/');
	        return response;
	      };
	      returnToRoot = returnToRoot.bind(this);
	
	      _Api2.default.userLogout().then(function () {
	        return _Api2.default.resetLastSelectedRetailer().then(returnToRoot, returnToRoot);
	      }, returnToRoot);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'signout-component fullscreen-component center-inside' },
	        _react2.default.createElement(_Processing2.default, null)
	      );
	    }
	  }]);
	
	  return SignOut;
	}(_react2.default.Component);
	
	exports.default = SignOut;
	
	
	SignOut.contextTypes = {
	  router: _propTypes2.default.object
	};

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(363);
	
	var emptyObject = __webpack_require__(33);
	var _invariant = __webpack_require__(5);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @nosideeffects
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function (Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function (Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function (Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	    },
	    contextTypes: function (Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function (Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function (Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function (Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function () {} };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	      }
	
	      return;
	    }
	
	    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	        } else if (!args.length) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedMixin = {
	    componentDidMount: function () {
	      this.__isMounted = true;
	    },
	    componentWillUnmount: function () {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function (newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function () {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function () {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedMixin);
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 363 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(366);
	var isArguments = __webpack_require__(365);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 365 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 366 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 367 */
73,
/* 368 */
73,
/* 369 */
73,
/* 370 */
73,
/* 371 */
73,
/* 372 */
73,
/* 373 */
73,
/* 374 */
73,
/* 375 */
73,
/* 376 */
73,
/* 377 */
73,
/* 378 */
73,
/* 379 */
73,
/* 380 */
73,
/* 381 */
73,
/* 382 */
73,
/* 383 */
73,
/* 384 */
73,
/* 385 */
73,
/* 386 */
73,
/* 387 */
73,
/* 388 */
73,
/* 389 */
73,
/* 390 */
73,
/* 391 */
73,
/* 392 */
73,
/* 393 */
73,
/* 394 */
73,
/* 395 */
73,
/* 396 */
73,
/* 397 */
73,
/* 398 */
73,
/* 399 */
73,
/* 400 */
73,
/* 401 */
73,
/* 402 */
73,
/* 403 */
73,
/* 404 */
73,
/* 405 */
73,
/* 406 */
73,
/* 407 */
73,
/* 408 */
73,
/* 409 */
73,
/* 410 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(410);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(420);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var createArrayFromMixed = __webpack_require__(413);
	var getMarkupWrap = __webpack_require__(415);
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 416 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 417 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(417);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(419);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 421 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/package.f5e3a599.svg";

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/percentage.45f1eff5.svg";

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tag.c779a655.svg";

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ecofriendly.6e6b000d.svg";

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/handmade.0ff7db88.svg";

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/made-in-usa.5cd00673.svg";

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/social-good.52865b8d.svg";

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/chevron-down.8da1ee2b.png";

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/front-image.1ac11fc2.png";

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bank.ce9fc21f.svg";

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/checkmark.0e43eef9.svg";

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/credit-card.06df8a1e.svg";

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/creditcards.a3d0250e.svg";

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/net90.fbbc7f64.svg";

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pencil-hover.bf9fdc7b.svg";

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pencil.6ec9e5a1.svg";

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/search.40c3b28a.svg";

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Cactus_IndigoFair-04.5113a817.png";

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Cactus_IndigoFair-05.d22c8229.png";

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Cactus_IndigoFair-06.e7f716e2.png";

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.5fdd8cc2.svg";

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/spinner.e8d35990.png";

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/spinner.c116c4fc.svg";

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/OfficeHours.b6d1e77e.jpg";

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/WinkSF.3fcd922c.jpg";

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/team-daniele.b976837c.jpg";

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/team-marcelo.ca6269a7.jpg";

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/team-max.3de8232f.jpg";

/***/ },
/* 450 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(34);
	
	var _PathUtils = __webpack_require__(29);
	
	var _ExecutionEnvironment = __webpack_require__(54);
	
	var _DOMUtils = __webpack_require__(75);
	
	var _DOMStateStorage = __webpack_require__(128);
	
	var _createDOMHistory = __webpack_require__(129);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(34);
	
	var _PathUtils = __webpack_require__(29);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(29);
	
	var _Actions = __webpack_require__(34);
	
	var _createHistory = __webpack_require__(131);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 454 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	!(function() {
	  function jss(blocks) {
	    var css = [];
	    for (var block in blocks)
	      css.push(createStyleBlock(block, blocks[block]));
	    injectCSS(css);
	  }
	
	  function createStyleBlock(selector, rules) {
	    return selector + ' {\n' + parseRules(rules) + '\n}';
	  }
	
	  function parseRules(rules) {
	    var css = [];
	    for (var rule in rules)
	      css.push('  '+rule+': '+rules[rule]+';');
	    return css.join('\n');
	  }
	
	  function injectCSS(css) {
	    var style = document.getElementById('jss-styles');
	    if (!style) {
	      style = document.createElement('style');
	      style.setAttribute('id', 'jss-styles');
	      var head = document.getElementsByTagName('head')[0];
	      head.insertBefore(style, head.firstChild);
	    }
	    var node = document.createTextNode(css.join('\n\n'));
	    style.appendChild(node);
	  }
	
	  if (true)
	    module.exports = jss;
	  else
	    window.jss = jss;
	
	})();
	


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 133,
		"./af.js": 133,
		"./ar": 139,
		"./ar-dz": 134,
		"./ar-dz.js": 134,
		"./ar-ly": 135,
		"./ar-ly.js": 135,
		"./ar-ma": 136,
		"./ar-ma.js": 136,
		"./ar-sa": 137,
		"./ar-sa.js": 137,
		"./ar-tn": 138,
		"./ar-tn.js": 138,
		"./ar.js": 139,
		"./az": 140,
		"./az.js": 140,
		"./be": 141,
		"./be.js": 141,
		"./bg": 142,
		"./bg.js": 142,
		"./bn": 143,
		"./bn.js": 143,
		"./bo": 144,
		"./bo.js": 144,
		"./br": 145,
		"./br.js": 145,
		"./bs": 146,
		"./bs.js": 146,
		"./ca": 147,
		"./ca.js": 147,
		"./cs": 148,
		"./cs.js": 148,
		"./cv": 149,
		"./cv.js": 149,
		"./cy": 150,
		"./cy.js": 150,
		"./da": 151,
		"./da.js": 151,
		"./de": 153,
		"./de-at": 152,
		"./de-at.js": 152,
		"./de.js": 153,
		"./dv": 154,
		"./dv.js": 154,
		"./el": 155,
		"./el.js": 155,
		"./en-au": 156,
		"./en-au.js": 156,
		"./en-ca": 157,
		"./en-ca.js": 157,
		"./en-gb": 158,
		"./en-gb.js": 158,
		"./en-ie": 159,
		"./en-ie.js": 159,
		"./en-nz": 160,
		"./en-nz.js": 160,
		"./eo": 161,
		"./eo.js": 161,
		"./es": 163,
		"./es-do": 162,
		"./es-do.js": 162,
		"./es.js": 163,
		"./et": 164,
		"./et.js": 164,
		"./eu": 165,
		"./eu.js": 165,
		"./fa": 166,
		"./fa.js": 166,
		"./fi": 167,
		"./fi.js": 167,
		"./fo": 168,
		"./fo.js": 168,
		"./fr": 171,
		"./fr-ca": 169,
		"./fr-ca.js": 169,
		"./fr-ch": 170,
		"./fr-ch.js": 170,
		"./fr.js": 171,
		"./fy": 172,
		"./fy.js": 172,
		"./gd": 173,
		"./gd.js": 173,
		"./gl": 174,
		"./gl.js": 174,
		"./he": 175,
		"./he.js": 175,
		"./hi": 176,
		"./hi.js": 176,
		"./hr": 177,
		"./hr.js": 177,
		"./hu": 178,
		"./hu.js": 178,
		"./hy-am": 179,
		"./hy-am.js": 179,
		"./id": 180,
		"./id.js": 180,
		"./is": 181,
		"./is.js": 181,
		"./it": 182,
		"./it.js": 182,
		"./ja": 183,
		"./ja.js": 183,
		"./jv": 184,
		"./jv.js": 184,
		"./ka": 185,
		"./ka.js": 185,
		"./kk": 186,
		"./kk.js": 186,
		"./km": 187,
		"./km.js": 187,
		"./ko": 188,
		"./ko.js": 188,
		"./ky": 189,
		"./ky.js": 189,
		"./lb": 190,
		"./lb.js": 190,
		"./lo": 191,
		"./lo.js": 191,
		"./lt": 192,
		"./lt.js": 192,
		"./lv": 193,
		"./lv.js": 193,
		"./me": 194,
		"./me.js": 194,
		"./mi": 195,
		"./mi.js": 195,
		"./mk": 196,
		"./mk.js": 196,
		"./ml": 197,
		"./ml.js": 197,
		"./mr": 198,
		"./mr.js": 198,
		"./ms": 200,
		"./ms-my": 199,
		"./ms-my.js": 199,
		"./ms.js": 200,
		"./my": 201,
		"./my.js": 201,
		"./nb": 202,
		"./nb.js": 202,
		"./ne": 203,
		"./ne.js": 203,
		"./nl": 205,
		"./nl-be": 204,
		"./nl-be.js": 204,
		"./nl.js": 205,
		"./nn": 206,
		"./nn.js": 206,
		"./pa-in": 207,
		"./pa-in.js": 207,
		"./pl": 208,
		"./pl.js": 208,
		"./pt": 210,
		"./pt-br": 209,
		"./pt-br.js": 209,
		"./pt.js": 210,
		"./ro": 211,
		"./ro.js": 211,
		"./ru": 212,
		"./ru.js": 212,
		"./se": 213,
		"./se.js": 213,
		"./si": 214,
		"./si.js": 214,
		"./sk": 215,
		"./sk.js": 215,
		"./sl": 216,
		"./sl.js": 216,
		"./sq": 217,
		"./sq.js": 217,
		"./sr": 219,
		"./sr-cyrl": 218,
		"./sr-cyrl.js": 218,
		"./sr.js": 219,
		"./ss": 220,
		"./ss.js": 220,
		"./sv": 221,
		"./sv.js": 221,
		"./sw": 222,
		"./sw.js": 222,
		"./ta": 223,
		"./ta.js": 223,
		"./te": 224,
		"./te.js": 224,
		"./tet": 225,
		"./tet.js": 225,
		"./th": 226,
		"./th.js": 226,
		"./tl-ph": 227,
		"./tl-ph.js": 227,
		"./tlh": 228,
		"./tlh.js": 228,
		"./tr": 229,
		"./tr.js": 229,
		"./tzl": 230,
		"./tzl.js": 230,
		"./tzm": 232,
		"./tzm-latn": 231,
		"./tzm-latn.js": 231,
		"./tzm.js": 232,
		"./uk": 233,
		"./uk.js": 233,
		"./uz": 234,
		"./uz.js": 234,
		"./vi": 235,
		"./vi.js": 235,
		"./x-pseudo": 236,
		"./x-pseudo.js": 236,
		"./yo": 237,
		"./yo.js": 237,
		"./zh-cn": 238,
		"./zh-cn.js": 238,
		"./zh-hk": 239,
		"./zh-hk.js": 239,
		"./zh-tw": 240,
		"./zh-tw.js": 240
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 456;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(242);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(242);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(16);
	var invariant = __webpack_require__(5);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(576);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(23));
		else if(typeof define === 'function' && define.amd)
			define(["react", "react-dom"], factory);
		else if(typeof exports === 'object')
			exports["ReactDataGrid"] = factory(require("react"), require("react-dom"));
		else
			root["ReactDataGrid"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ((function(modules) {
		// Check all modules for deduplicated modules
		for(var i in modules) {
			if(Object.prototype.hasOwnProperty.call(modules, i)) {
				switch(typeof modules[i]) {
				case "function": break;
				case "object":
					// Module can be created from a template
					modules[i] = (function(_m) {
						var args = _m.slice(1), fn = modules[_m[0]];
						return function (a,b,c) {
							fn.apply(this, [a,b,c].concat(args));
						};
					}(modules[i]));
					break;
				default:
					// Module is a copy of another module
					modules[i] = modules[modules[i]];
					break;
				}
			}
		}
		return modules;
	}([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(228);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = function(module) {
			if(!module.webpackPolyfill) {
				module.deprecate = function() {};
				module.paths = [];
				// module.parent = undefined by default
				module.children = [];
				module.webpackPolyfill = 1;
			}
			return module;
		}
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(186);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */,
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var invariant = function(condition, format, a, b, c, d, e, f) {
		  if (false) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  }
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error(
		        'Minified exception occurred; use the non-minified dev environment ' +
		        'for the full error message and additional helpful warnings.'
		      );
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(
		        format.replace(/%s/g, function() { return args[argIndex++]; })
		      );
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		};
	
		module.exports = invariant;
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		/*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
		// css base code, injected by the css-loader
		module.exports = function() {
			var list = [];
	
			// return the list of modules as css string
			list.toString = function toString() {
				var result = [];
				for(var i = 0; i < this.length; i++) {
					var item = this[i];
					if(item[2]) {
						result.push("@media " + item[2] + "{" + item[1] + "}");
					} else {
						result.push(item[1]);
					}
				}
				return result.join("");
			};
	
			// import a list of modules into the list
			list.i = function(modules, mediaQuery) {
				if(typeof modules === "string")
					modules = [[null, modules, ""]];
				var alreadyImportedModules = {};
				for(var i = 0; i < this.length; i++) {
					var id = this[i][0];
					if(typeof id === "number")
						alreadyImportedModules[id] = true;
				}
				for(i = 0; i < modules.length; i++) {
					var item = modules[i];
					// skip already imported module
					// this implementation is not 100% perfect for weird media query combinations
					//  when a module is imported multiple times with different media queries.
					//  I hope this will never occur (Hey this way we have smaller bundles)
					if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
						if(mediaQuery && !item[2]) {
							item[2] = mediaQuery;
						} else if(mediaQuery) {
							item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
						}
						list.push(item);
					}
				}
			};
			return list;
		};
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
		var stylesInDom = {},
			memoize = function(fn) {
				var memo;
				return function () {
					if (typeof memo === "undefined") memo = fn.apply(this, arguments);
					return memo;
				};
			},
			isOldIE = memoize(function() {
				return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
			}),
			getHeadElement = memoize(function () {
				return document.head || document.getElementsByTagName("head")[0];
			}),
			singletonElement = null,
			singletonCounter = 0,
			styleElementsInsertedAtTop = [];
	
		module.exports = function(list, options) {
			if(false) {
				if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
			}
	
			options = options || {};
			// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
			// tags it will allow on a page
			if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
			// By default, add <style> tags to the bottom of <head>.
			if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
			var styles = listToStyles(list);
			addStylesToDom(styles, options);
	
			return function update(newList) {
				var mayRemove = [];
				for(var i = 0; i < styles.length; i++) {
					var item = styles[i];
					var domStyle = stylesInDom[item.id];
					domStyle.refs--;
					mayRemove.push(domStyle);
				}
				if(newList) {
					var newStyles = listToStyles(newList);
					addStylesToDom(newStyles, options);
				}
				for(var i = 0; i < mayRemove.length; i++) {
					var domStyle = mayRemove[i];
					if(domStyle.refs === 0) {
						for(var j = 0; j < domStyle.parts.length; j++)
							domStyle.parts[j]();
						delete stylesInDom[domStyle.id];
					}
				}
			};
		}
	
		function addStylesToDom(styles, options) {
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				if(domStyle) {
					domStyle.refs++;
					for(var j = 0; j < domStyle.parts.length; j++) {
						domStyle.parts[j](item.parts[j]);
					}
					for(; j < item.parts.length; j++) {
						domStyle.parts.push(addStyle(item.parts[j], options));
					}
				} else {
					var parts = [];
					for(var j = 0; j < item.parts.length; j++) {
						parts.push(addStyle(item.parts[j], options));
					}
					stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
				}
			}
		}
	
		function listToStyles(list) {
			var styles = [];
			var newStyles = {};
			for(var i = 0; i < list.length; i++) {
				var item = list[i];
				var id = item[0];
				var css = item[1];
				var media = item[2];
				var sourceMap = item[3];
				var part = {css: css, media: media, sourceMap: sourceMap};
				if(!newStyles[id])
					styles.push(newStyles[id] = {id: id, parts: [part]});
				else
					newStyles[id].parts.push(part);
			}
			return styles;
		}
	
		function insertStyleElement(options, styleElement) {
			var head = getHeadElement();
			var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
			if (options.insertAt === "top") {
				if(!lastStyleElementInsertedAtTop) {
					head.insertBefore(styleElement, head.firstChild);
				} else if(lastStyleElementInsertedAtTop.nextSibling) {
					head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
				} else {
					head.appendChild(styleElement);
				}
				styleElementsInsertedAtTop.push(styleElement);
			} else if (options.insertAt === "bottom") {
				head.appendChild(styleElement);
			} else {
				throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
			}
		}
	
		function removeStyleElement(styleElement) {
			styleElement.parentNode.removeChild(styleElement);
			var idx = styleElementsInsertedAtTop.indexOf(styleElement);
			if(idx >= 0) {
				styleElementsInsertedAtTop.splice(idx, 1);
			}
		}
	
		function createStyleElement(options) {
			var styleElement = document.createElement("style");
			styleElement.type = "text/css";
			insertStyleElement(options, styleElement);
			return styleElement;
		}
	
		function createLinkElement(options) {
			var linkElement = document.createElement("link");
			linkElement.rel = "stylesheet";
			insertStyleElement(options, linkElement);
			return linkElement;
		}
	
		function addStyle(obj, options) {
			var styleElement, update, remove;
	
			if (options.singleton) {
				var styleIndex = singletonCounter++;
				styleElement = singletonElement || (singletonElement = createStyleElement(options));
				update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
				remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
			} else if(obj.sourceMap &&
				typeof URL === "function" &&
				typeof URL.createObjectURL === "function" &&
				typeof URL.revokeObjectURL === "function" &&
				typeof Blob === "function" &&
				typeof btoa === "function") {
				styleElement = createLinkElement(options);
				update = updateLink.bind(null, styleElement);
				remove = function() {
					removeStyleElement(styleElement);
					if(styleElement.href)
						URL.revokeObjectURL(styleElement.href);
				};
			} else {
				styleElement = createStyleElement(options);
				update = applyToTag.bind(null, styleElement);
				remove = function() {
					removeStyleElement(styleElement);
				};
			}
	
			update(obj);
	
			return function updateStyle(newObj) {
				if(newObj) {
					if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
						return;
					update(obj = newObj);
				} else {
					remove();
				}
			};
		}
	
		var replaceText = (function () {
			var textStore = [];
	
			return function (index, replacement) {
				textStore[index] = replacement;
				return textStore.filter(Boolean).join('\n');
			};
		})();
	
		function applyToSingletonTag(styleElement, index, remove, obj) {
			var css = remove ? "" : obj.css;
	
			if (styleElement.styleSheet) {
				styleElement.styleSheet.cssText = replaceText(index, css);
			} else {
				var cssNode = document.createTextNode(css);
				var childNodes = styleElement.childNodes;
				if (childNodes[index]) styleElement.removeChild(childNodes[index]);
				if (childNodes.length) {
					styleElement.insertBefore(cssNode, childNodes[index]);
				} else {
					styleElement.appendChild(cssNode);
				}
			}
		}
	
		function applyToTag(styleElement, obj) {
			var css = obj.css;
			var media = obj.media;
	
			if(media) {
				styleElement.setAttribute("media", media)
			}
	
			if(styleElement.styleSheet) {
				styleElement.styleSheet.cssText = css;
			} else {
				while(styleElement.firstChild) {
					styleElement.removeChild(styleElement.firstChild);
				}
				styleElement.appendChild(document.createTextNode(css));
			}
		}
	
		function updateLink(linkElement, obj) {
			var css = obj.css;
			var sourceMap = obj.sourceMap;
	
			if(sourceMap) {
				// http://stackoverflow.com/a/26603875
				css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
			}
	
			var blob = new Blob([css], { type: "text/css" });
	
			var oldSrc = linkElement.href;
	
			linkElement.href = URL.createObjectURL(blob);
	
			if(oldSrc)
				URL.revokeObjectURL(oldSrc);
		}
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2015 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	
		function classNames() {
			var classes = '';
			var arg;
	
			for (var i = 0; i < arguments.length; i++) {
				arg = arguments[i];
				if (!arg) {
					continue;
				}
	
				if ('string' === typeof arg || 'number' === typeof arg) {
					classes += ' ' + arg;
				} else if (Object.prototype.toString.call(arg) === '[object Array]') {
					classes += ' ' + classNames.apply(null, arg);
				} else if ('object' === typeof arg) {
					for (var key in arg) {
						if (!arg.hasOwnProperty(key) || !arg[key]) {
							continue;
						}
						classes += ' ' + key;
					}
				}
			}
			return classes.substr(1);
		}
	
		// safely export classNames for node / browserify
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		}
	
		// safely export classNames for RequireJS
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = {
		  getColumn: function getColumn(columns, idx) {
		    if (Array.isArray(columns)) {
		      return columns[idx];
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.get(idx);
		    }
		  },
		  spliceColumn: function spliceColumn(metrics, idx, column) {
		    if (Array.isArray(metrics.columns)) {
		      metrics.columns.splice(idx, 1, column);
		    } else if (typeof Immutable !== 'undefined') {
		      metrics.columns = metrics.columns.splice(idx, 1, column);
		    }
		    return metrics;
		  },
		  getSize: function getSize(columns) {
		    if (Array.isArray(columns)) {
		      return columns.length;
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.size;
		    }
		  },
	
	
		  // Logic extented to allow for functions to be passed down in column.editable
		  // this allows us to deicde whether we can be edting from a cell level
		  canEdit: function canEdit(col, rowData, enableCellSelect) {
		    if (col.editable != null && typeof col.editable === 'function') {
		      return enableCellSelect === true && col.editable(rowData);
		    }
		    return enableCellSelect === true && (!!col.editor || !!col.editable);
		  }
		};
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var ExcelColumnShape = {
		  name: React.PropTypes.node.isRequired,
		  key: React.PropTypes.string.isRequired,
		  width: React.PropTypes.number.isRequired,
		  filterable: React.PropTypes.bool
		};
	
		module.exports = ExcelColumnShape;
	
	/***/ },
	/* 12 */
	[1786, 149],
	/* 13 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;
	
		module.exports = isArray;
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var PropTypes = __webpack_require__(2).PropTypes;
	
		module.exports = {
		  selected: PropTypes.object.isRequired,
		  copied: PropTypes.object,
		  dragged: PropTypes.object,
		  onCellClick: PropTypes.func.isRequired,
		  onCellDoubleClick: PropTypes.func.isRequired,
		  onCommit: PropTypes.func.isRequired,
		  onCommitCancel: PropTypes.func.isRequired,
		  handleDragEnterRow: PropTypes.func.isRequired,
		  handleTerminateDrag: PropTypes.func.isRequired
		};
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGetTag = __webpack_require__(42),
		    getPrototype = __webpack_require__(304),
		    isObjectLike = __webpack_require__(30);
	
		/** `Object#toString` result references. */
		var objectTag = '[object Object]';
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype,
		    objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to infer the `Object` constructor. */
		var objectCtorString = funcToString.call(Object);
	
		/**
		 * Checks if `value` is a plain object, that is, an object created by the
		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.8.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * _.isPlainObject(new Foo);
		 * // => false
		 *
		 * _.isPlainObject([1, 2, 3]);
		 * // => false
		 *
		 * _.isPlainObject({ 'x': 0, 'y': 0 });
		 * // => true
		 *
		 * _.isPlainObject(Object.create(null));
		 * // => true
		 */
		function isPlainObject(value) {
		  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
		    return false;
		  }
		  var proto = getPrototype(value);
		  if (proto === null) {
		    return true;
		  }
		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
		  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
		    funcToString.call(Ctor) == objectCtorString;
		}
	
		module.exports = isPlainObject;
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _DragDropContext = __webpack_require__(128);
	
		Object.defineProperty(exports, 'DragDropContext', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragDropContext).default;
		  }
		});
	
		var _DragDropContextProvider = __webpack_require__(364);
	
		Object.defineProperty(exports, 'DragDropContextProvider', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragDropContextProvider).default;
		  }
		});
	
		var _DragLayer = __webpack_require__(365);
	
		Object.defineProperty(exports, 'DragLayer', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragLayer).default;
		  }
		});
	
		var _DragSource = __webpack_require__(366);
	
		Object.defineProperty(exports, 'DragSource', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragSource).default;
		  }
		});
	
		var _DropTarget = __webpack_require__(367);
	
		Object.defineProperty(exports, 'DropTarget', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DropTarget).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		"use strict";
	
		function createObjectWithProperties(originalObj, properties) {
		  var result = {};
		  for (var _iterator = properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var property = _ref;
	
		    if (originalObj[property]) {
		      result[property] = originalObj[property];
		    }
		  }
		  return result;
		}
	
		module.exports = createObjectWithProperties;
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(196);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-header.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-header.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 19 */
	13,
	/* 20 */
	[1697, 430, 454],
	/* 21 */,
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var shallowCloneObject = __webpack_require__(36);
	
		var contextTypes = {
		  metricsComputator: React.PropTypes.object
		};
	
		var MetricsComputatorMixin = {
	
		  childContextTypes: contextTypes,
	
		  getChildContext: function getChildContext() {
		    return { metricsComputator: this };
		  },
		  getMetricImpl: function getMetricImpl(name) {
		    return this._DOMMetrics.metrics[name].value;
		  },
		  registerMetricsImpl: function registerMetricsImpl(component, metrics) {
		    var getters = {};
		    var s = this._DOMMetrics;
	
		    for (var name in metrics) {
		      if (s.metrics[name] !== undefined) {
		        throw new Error('DOM metric ' + name + ' is already defined');
		      }
		      s.metrics[name] = { component: component, computator: metrics[name].bind(component) };
		      getters[name] = this.getMetricImpl.bind(null, name);
		    }
	
		    if (s.components.indexOf(component) === -1) {
		      s.components.push(component);
		    }
	
		    return getters;
		  },
		  unregisterMetricsFor: function unregisterMetricsFor(component) {
		    var s = this._DOMMetrics;
		    var idx = s.components.indexOf(component);
	
		    if (idx > -1) {
		      s.components.splice(idx, 1);
	
		      var name = void 0;
		      var metricsToDelete = {};
	
		      for (name in s.metrics) {
		        if (s.metrics[name].component === component) {
		          metricsToDelete[name] = true;
		        }
		      }
	
		      for (name in metricsToDelete) {
		        if (metricsToDelete.hasOwnProperty(name)) {
		          delete s.metrics[name];
		        }
		      }
		    }
		  },
		  updateMetrics: function updateMetrics() {
		    var s = this._DOMMetrics;
	
		    var needUpdate = false;
	
		    for (var name in s.metrics) {
		      if (!s.metrics.hasOwnProperty(name)) continue;
	
		      var newMetric = s.metrics[name].computator();
		      if (newMetric !== s.metrics[name].value) {
		        needUpdate = true;
		      }
		      s.metrics[name].value = newMetric;
		    }
	
		    if (needUpdate) {
		      for (var i = 0, len = s.components.length; i < len; i++) {
		        if (s.components[i].metricsUpdated) {
		          s.components[i].metricsUpdated();
		        }
		      }
		    }
		  },
		  componentWillMount: function componentWillMount() {
		    this._DOMMetrics = {
		      metrics: {},
		      components: []
		    };
		  },
		  componentDidMount: function componentDidMount() {
		    if (window.addEventListener) {
		      window.addEventListener('resize', this.updateMetrics);
		    } else {
		      window.attachEvent('resize', this.updateMetrics);
		    }
		    this.updateMetrics();
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    window.removeEventListener('resize', this.updateMetrics);
		  }
		};
	
		var MetricsMixin = {
	
		  contextTypes: contextTypes,
	
		  componentWillMount: function componentWillMount() {
		    if (this.DOMMetrics) {
		      this._DOMMetricsDefs = shallowCloneObject(this.DOMMetrics);
	
		      this.DOMMetrics = {};
		      for (var name in this._DOMMetricsDefs) {
		        if (!this._DOMMetricsDefs.hasOwnProperty(name)) continue;
	
		        this.DOMMetrics[name] = function () {};
		      }
		    }
		  },
		  componentDidMount: function componentDidMount() {
		    if (this.DOMMetrics) {
		      this.DOMMetrics = this.registerMetrics(this._DOMMetricsDefs);
		    }
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    if (!this.registerMetricsImpl) {
		      return this.context.metricsComputator.unregisterMetricsFor(this);
		    }
		    if (this.hasOwnProperty('DOMMetrics')) {
		      delete this.DOMMetrics;
		    }
		  },
		  registerMetrics: function registerMetrics(metrics) {
		    if (this.registerMetricsImpl) {
		      return this.registerMetricsImpl(this, metrics);
		    }
	
		    return this.context.metricsComputator.registerMetricsImpl(this, metrics);
		  },
		  getMetric: function getMetric(name) {
		    if (this.getMetricImpl) {
		      return this.getMetricImpl(name);
		    }
	
		    return this.context.metricsComputator.getMetricImpl(name);
		  }
		};
	
		module.exports = {
		  MetricsComputatorMixin: MetricsComputatorMixin,
		  MetricsMixin: MetricsMixin
		};
	
	/***/ },
	/* 23 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
		module.exports = exports['default'];
	
	/***/ },
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 *  Copyright (c) 2014-2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		(function (global, factory) {
		   true ? module.exports = factory() :
		  typeof define === 'function' && define.amd ? define(factory) :
		  (global.Immutable = factory());
		}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
		  function createClass(ctor, superClass) {
		    if (superClass) {
		      ctor.prototype = Object.create(superClass.prototype);
		    }
		    ctor.prototype.constructor = ctor;
		  }
	
		  function Iterable(value) {
		      return isIterable(value) ? value : Seq(value);
		    }
	
	
		  createClass(KeyedIterable, Iterable);
		    function KeyedIterable(value) {
		      return isKeyed(value) ? value : KeyedSeq(value);
		    }
	
	
		  createClass(IndexedIterable, Iterable);
		    function IndexedIterable(value) {
		      return isIndexed(value) ? value : IndexedSeq(value);
		    }
	
	
		  createClass(SetIterable, Iterable);
		    function SetIterable(value) {
		      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
		    }
	
	
	
		  function isIterable(maybeIterable) {
		    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
		  }
	
		  function isKeyed(maybeKeyed) {
		    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
		  }
	
		  function isIndexed(maybeIndexed) {
		    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
		  }
	
		  function isAssociative(maybeAssociative) {
		    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
		  }
	
		  function isOrdered(maybeOrdered) {
		    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
		  }
	
		  Iterable.isIterable = isIterable;
		  Iterable.isKeyed = isKeyed;
		  Iterable.isIndexed = isIndexed;
		  Iterable.isAssociative = isAssociative;
		  Iterable.isOrdered = isOrdered;
	
		  Iterable.Keyed = KeyedIterable;
		  Iterable.Indexed = IndexedIterable;
		  Iterable.Set = SetIterable;
	
	
		  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
		  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
		  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
		  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
		  // Used for setting prototype methods that IE8 chokes on.
		  var DELETE = 'delete';
	
		  // Constants describing the size of trie nodes.
		  var SHIFT = 5; // Resulted in best performance after ______?
		  var SIZE = 1 << SHIFT;
		  var MASK = SIZE - 1;
	
		  // A consistent shared value representing "not set" which equals nothing other
		  // than itself, and nothing that could be provided externally.
		  var NOT_SET = {};
	
		  // Boolean references, Rough equivalent of `bool &`.
		  var CHANGE_LENGTH = { value: false };
		  var DID_ALTER = { value: false };
	
		  function MakeRef(ref) {
		    ref.value = false;
		    return ref;
		  }
	
		  function SetRef(ref) {
		    ref && (ref.value = true);
		  }
	
		  // A function which returns a value representing an "owner" for transient writes
		  // to tries. The return value will only ever equal itself, and will not equal
		  // the return of any subsequent call of this function.
		  function OwnerID() {}
	
		  // http://jsperf.com/copy-array-inline
		  function arrCopy(arr, offset) {
		    offset = offset || 0;
		    var len = Math.max(0, arr.length - offset);
		    var newArr = new Array(len);
		    for (var ii = 0; ii < len; ii++) {
		      newArr[ii] = arr[ii + offset];
		    }
		    return newArr;
		  }
	
		  function ensureSize(iter) {
		    if (iter.size === undefined) {
		      iter.size = iter.__iterate(returnTrue);
		    }
		    return iter.size;
		  }
	
		  function wrapIndex(iter, index) {
		    // This implements "is array index" which the ECMAString spec defines as:
		    //
		    //     A String property name P is an array index if and only if
		    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
		    //     to 2^32−1.
		    //
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
		    if (typeof index !== 'number') {
		      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
		      if ('' + uint32Index !== index || uint32Index === 4294967295) {
		        return NaN;
		      }
		      index = uint32Index;
		    }
		    return index < 0 ? ensureSize(iter) + index : index;
		  }
	
		  function returnTrue() {
		    return true;
		  }
	
		  function wholeSlice(begin, end, size) {
		    return (begin === 0 || (size !== undefined && begin <= -size)) &&
		      (end === undefined || (size !== undefined && end >= size));
		  }
	
		  function resolveBegin(begin, size) {
		    return resolveIndex(begin, size, 0);
		  }
	
		  function resolveEnd(end, size) {
		    return resolveIndex(end, size, size);
		  }
	
		  function resolveIndex(index, size, defaultIndex) {
		    return index === undefined ?
		      defaultIndex :
		      index < 0 ?
		        Math.max(0, size + index) :
		        size === undefined ?
		          index :
		          Math.min(size, index);
		  }
	
		  /* global Symbol */
	
		  var ITERATE_KEYS = 0;
		  var ITERATE_VALUES = 1;
		  var ITERATE_ENTRIES = 2;
	
		  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
		  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
		  function Iterator(next) {
		      this.next = next;
		    }
	
		    Iterator.prototype.toString = function() {
		      return '[Iterator]';
		    };
	
	
		  Iterator.KEYS = ITERATE_KEYS;
		  Iterator.VALUES = ITERATE_VALUES;
		  Iterator.ENTRIES = ITERATE_ENTRIES;
	
		  Iterator.prototype.inspect =
		  Iterator.prototype.toSource = function () { return this.toString(); }
		  Iterator.prototype[ITERATOR_SYMBOL] = function () {
		    return this;
		  };
	
	
		  function iteratorValue(type, k, v, iteratorResult) {
		    var value = type === 0 ? k : type === 1 ? v : [k, v];
		    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
		      value: value, done: false
		    });
		    return iteratorResult;
		  }
	
		  function iteratorDone() {
		    return { value: undefined, done: true };
		  }
	
		  function hasIterator(maybeIterable) {
		    return !!getIteratorFn(maybeIterable);
		  }
	
		  function isIterator(maybeIterator) {
		    return maybeIterator && typeof maybeIterator.next === 'function';
		  }
	
		  function getIterator(iterable) {
		    var iteratorFn = getIteratorFn(iterable);
		    return iteratorFn && iteratorFn.call(iterable);
		  }
	
		  function getIteratorFn(iterable) {
		    var iteratorFn = iterable && (
		      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
		      iterable[FAUX_ITERATOR_SYMBOL]
		    );
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  function isArrayLike(value) {
		    return value && typeof value.length === 'number';
		  }
	
		  createClass(Seq, Iterable);
		    function Seq(value) {
		      return value === null || value === undefined ? emptySequence() :
		        isIterable(value) ? value.toSeq() : seqFromValue(value);
		    }
	
		    Seq.of = function(/*...values*/) {
		      return Seq(arguments);
		    };
	
		    Seq.prototype.toSeq = function() {
		      return this;
		    };
	
		    Seq.prototype.toString = function() {
		      return this.__toString('Seq {', '}');
		    };
	
		    Seq.prototype.cacheResult = function() {
		      if (!this._cache && this.__iterateUncached) {
		        this._cache = this.entrySeq().toArray();
		        this.size = this._cache.length;
		      }
		      return this;
		    };
	
		    // abstract __iterateUncached(fn, reverse)
	
		    Seq.prototype.__iterate = function(fn, reverse) {
		      return seqIterate(this, fn, reverse, true);
		    };
	
		    // abstract __iteratorUncached(type, reverse)
	
		    Seq.prototype.__iterator = function(type, reverse) {
		      return seqIterator(this, type, reverse, true);
		    };
	
	
	
		  createClass(KeyedSeq, Seq);
		    function KeyedSeq(value) {
		      return value === null || value === undefined ?
		        emptySequence().toKeyedSeq() :
		        isIterable(value) ?
		          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
		          keyedSeqFromValue(value);
		    }
	
		    KeyedSeq.prototype.toKeyedSeq = function() {
		      return this;
		    };
	
	
	
		  createClass(IndexedSeq, Seq);
		    function IndexedSeq(value) {
		      return value === null || value === undefined ? emptySequence() :
		        !isIterable(value) ? indexedSeqFromValue(value) :
		        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
		    }
	
		    IndexedSeq.of = function(/*...values*/) {
		      return IndexedSeq(arguments);
		    };
	
		    IndexedSeq.prototype.toIndexedSeq = function() {
		      return this;
		    };
	
		    IndexedSeq.prototype.toString = function() {
		      return this.__toString('Seq [', ']');
		    };
	
		    IndexedSeq.prototype.__iterate = function(fn, reverse) {
		      return seqIterate(this, fn, reverse, false);
		    };
	
		    IndexedSeq.prototype.__iterator = function(type, reverse) {
		      return seqIterator(this, type, reverse, false);
		    };
	
	
	
		  createClass(SetSeq, Seq);
		    function SetSeq(value) {
		      return (
		        value === null || value === undefined ? emptySequence() :
		        !isIterable(value) ? indexedSeqFromValue(value) :
		        isKeyed(value) ? value.entrySeq() : value
		      ).toSetSeq();
		    }
	
		    SetSeq.of = function(/*...values*/) {
		      return SetSeq(arguments);
		    };
	
		    SetSeq.prototype.toSetSeq = function() {
		      return this;
		    };
	
	
	
		  Seq.isSeq = isSeq;
		  Seq.Keyed = KeyedSeq;
		  Seq.Set = SetSeq;
		  Seq.Indexed = IndexedSeq;
	
		  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
		  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
		  createClass(ArraySeq, IndexedSeq);
		    function ArraySeq(array) {
		      this._array = array;
		      this.size = array.length;
		    }
	
		    ArraySeq.prototype.get = function(index, notSetValue) {
		      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
		    };
	
		    ArraySeq.prototype.__iterate = function(fn, reverse) {
		      var array = this._array;
		      var maxIndex = array.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    ArraySeq.prototype.__iterator = function(type, reverse) {
		      var array = this._array;
		      var maxIndex = array.length - 1;
		      var ii = 0;
		      return new Iterator(function() 
		        {return ii > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
		      );
		    };
	
	
	
		  createClass(ObjectSeq, KeyedSeq);
		    function ObjectSeq(object) {
		      var keys = Object.keys(object);
		      this._object = object;
		      this._keys = keys;
		      this.size = keys.length;
		    }
	
		    ObjectSeq.prototype.get = function(key, notSetValue) {
		      if (notSetValue !== undefined && !this.has(key)) {
		        return notSetValue;
		      }
		      return this._object[key];
		    };
	
		    ObjectSeq.prototype.has = function(key) {
		      return this._object.hasOwnProperty(key);
		    };
	
		    ObjectSeq.prototype.__iterate = function(fn, reverse) {
		      var object = this._object;
		      var keys = this._keys;
		      var maxIndex = keys.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        var key = keys[reverse ? maxIndex - ii : ii];
		        if (fn(object[key], key, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    ObjectSeq.prototype.__iterator = function(type, reverse) {
		      var object = this._object;
		      var keys = this._keys;
		      var maxIndex = keys.length - 1;
		      var ii = 0;
		      return new Iterator(function()  {
		        var key = keys[reverse ? maxIndex - ii : ii];
		        return ii++ > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, key, object[key]);
		      });
		    };
	
		  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
		  createClass(IterableSeq, IndexedSeq);
		    function IterableSeq(iterable) {
		      this._iterable = iterable;
		      this.size = iterable.length || iterable.size;
		    }
	
		    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterable = this._iterable;
		      var iterator = getIterator(iterable);
		      var iterations = 0;
		      if (isIterator(iterator)) {
		        var step;
		        while (!(step = iterator.next()).done) {
		          if (fn(step.value, iterations++, this) === false) {
		            break;
		          }
		        }
		      }
		      return iterations;
		    };
	
		    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterable = this._iterable;
		      var iterator = getIterator(iterable);
		      if (!isIterator(iterator)) {
		        return new Iterator(iteratorDone);
		      }
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step : iteratorValue(type, iterations++, step.value);
		      });
		    };
	
	
	
		  createClass(IteratorSeq, IndexedSeq);
		    function IteratorSeq(iterator) {
		      this._iterator = iterator;
		      this._iteratorCache = [];
		    }
	
		    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterator = this._iterator;
		      var cache = this._iteratorCache;
		      var iterations = 0;
		      while (iterations < cache.length) {
		        if (fn(cache[iterations], iterations++, this) === false) {
		          return iterations;
		        }
		      }
		      var step;
		      while (!(step = iterator.next()).done) {
		        var val = step.value;
		        cache[iterations] = val;
		        if (fn(val, iterations++, this) === false) {
		          break;
		        }
		      }
		      return iterations;
		    };
	
		    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = this._iterator;
		      var cache = this._iteratorCache;
		      var iterations = 0;
		      return new Iterator(function()  {
		        if (iterations >= cache.length) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          cache[iterations] = step.value;
		        }
		        return iteratorValue(type, iterations, cache[iterations++]);
		      });
		    };
	
	
	
	
		  // # pragma Helper functions
	
		  function isSeq(maybeSeq) {
		    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
		  }
	
		  var EMPTY_SEQ;
	
		  function emptySequence() {
		    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
		  }
	
		  function keyedSeqFromValue(value) {
		    var seq =
		      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
		      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
		      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
		      typeof value === 'object' ? new ObjectSeq(value) :
		      undefined;
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of [k, v] entries, '+
		        'or keyed object: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function indexedSeqFromValue(value) {
		    var seq = maybeIndexedSeqFromValue(value);
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of values: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function seqFromValue(value) {
		    var seq = maybeIndexedSeqFromValue(value) ||
		      (typeof value === 'object' && new ObjectSeq(value));
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of values, or keyed object: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function maybeIndexedSeqFromValue(value) {
		    return (
		      isArrayLike(value) ? new ArraySeq(value) :
		      isIterator(value) ? new IteratorSeq(value) :
		      hasIterator(value) ? new IterableSeq(value) :
		      undefined
		    );
		  }
	
		  function seqIterate(seq, fn, reverse, useKeys) {
		    var cache = seq._cache;
		    if (cache) {
		      var maxIndex = cache.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        var entry = cache[reverse ? maxIndex - ii : ii];
		        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    }
		    return seq.__iterateUncached(fn, reverse);
		  }
	
		  function seqIterator(seq, type, reverse, useKeys) {
		    var cache = seq._cache;
		    if (cache) {
		      var maxIndex = cache.length - 1;
		      var ii = 0;
		      return new Iterator(function()  {
		        var entry = cache[reverse ? maxIndex - ii : ii];
		        return ii++ > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
		      });
		    }
		    return seq.__iteratorUncached(type, reverse);
		  }
	
		  function fromJS(json, converter) {
		    return converter ?
		      fromJSWith(converter, json, '', {'': json}) :
		      fromJSDefault(json);
		  }
	
		  function fromJSWith(converter, json, key, parentJSON) {
		    if (Array.isArray(json)) {
		      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
		    }
		    if (isPlainObj(json)) {
		      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
		    }
		    return json;
		  }
	
		  function fromJSDefault(json) {
		    if (Array.isArray(json)) {
		      return IndexedSeq(json).map(fromJSDefault).toList();
		    }
		    if (isPlainObj(json)) {
		      return KeyedSeq(json).map(fromJSDefault).toMap();
		    }
		    return json;
		  }
	
		  function isPlainObj(value) {
		    return value && (value.constructor === Object || value.constructor === undefined);
		  }
	
		  /**
		   * An extension of the "same-value" algorithm as [described for use by ES6 Map
		   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
		   *
		   * NaN is considered the same as NaN, however -0 and 0 are considered the same
		   * value, which is different from the algorithm described by
		   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
		   *
		   * This is extended further to allow Objects to describe the values they
		   * represent, by way of `valueOf` or `equals` (and `hashCode`).
		   *
		   * Note: because of this extension, the key equality of Immutable.Map and the
		   * value equality of Immutable.Set will differ from ES6 Map and Set.
		   *
		   * ### Defining custom values
		   *
		   * The easiest way to describe the value an object represents is by implementing
		   * `valueOf`. For example, `Date` represents a value by returning a unix
		   * timestamp for `valueOf`:
		   *
		   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
		   *     var date2 = new Date(1234567890000);
		   *     date1.valueOf(); // 1234567890000
		   *     assert( date1 !== date2 );
		   *     assert( Immutable.is( date1, date2 ) );
		   *
		   * Note: overriding `valueOf` may have other implications if you use this object
		   * where JavaScript expects a primitive, such as implicit string coercion.
		   *
		   * For more complex types, especially collections, implementing `valueOf` may
		   * not be performant. An alternative is to implement `equals` and `hashCode`.
		   *
		   * `equals` takes another object, presumably of similar type, and returns true
		   * if the it is equal. Equality is symmetrical, so the same result should be
		   * returned if this and the argument are flipped.
		   *
		   *     assert( a.equals(b) === b.equals(a) );
		   *
		   * `hashCode` returns a 32bit integer number representing the object which will
		   * be used to determine how to store the value object in a Map or Set. You must
		   * provide both or neither methods, one must not exist without the other.
		   *
		   * Also, an important relationship between these methods must be upheld: if two
		   * values are equal, they *must* return the same hashCode. If the values are not
		   * equal, they might have the same hashCode; this is called a hash collision,
		   * and while undesirable for performance reasons, it is acceptable.
		   *
		   *     if (a.equals(b)) {
		   *       assert( a.hashCode() === b.hashCode() );
		   *     }
		   *
		   * All Immutable collections implement `equals` and `hashCode`.
		   *
		   */
		  function is(valueA, valueB) {
		    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
		      return true;
		    }
		    if (!valueA || !valueB) {
		      return false;
		    }
		    if (typeof valueA.valueOf === 'function' &&
		        typeof valueB.valueOf === 'function') {
		      valueA = valueA.valueOf();
		      valueB = valueB.valueOf();
		      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
		        return true;
		      }
		      if (!valueA || !valueB) {
		        return false;
		      }
		    }
		    if (typeof valueA.equals === 'function' &&
		        typeof valueB.equals === 'function' &&
		        valueA.equals(valueB)) {
		      return true;
		    }
		    return false;
		  }
	
		  function deepEqual(a, b) {
		    if (a === b) {
		      return true;
		    }
	
		    if (
		      !isIterable(b) ||
		      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
		      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
		      isKeyed(a) !== isKeyed(b) ||
		      isIndexed(a) !== isIndexed(b) ||
		      isOrdered(a) !== isOrdered(b)
		    ) {
		      return false;
		    }
	
		    if (a.size === 0 && b.size === 0) {
		      return true;
		    }
	
		    var notAssociative = !isAssociative(a);
	
		    if (isOrdered(a)) {
		      var entries = a.entries();
		      return b.every(function(v, k)  {
		        var entry = entries.next().value;
		        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
		      }) && entries.next().done;
		    }
	
		    var flipped = false;
	
		    if (a.size === undefined) {
		      if (b.size === undefined) {
		        if (typeof a.cacheResult === 'function') {
		          a.cacheResult();
		        }
		      } else {
		        flipped = true;
		        var _ = a;
		        a = b;
		        b = _;
		      }
		    }
	
		    var allEqual = true;
		    var bSize = b.__iterate(function(v, k)  {
		      if (notAssociative ? !a.has(v) :
		          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
		        allEqual = false;
		        return false;
		      }
		    });
	
		    return allEqual && a.size === bSize;
		  }
	
		  createClass(Repeat, IndexedSeq);
	
		    function Repeat(value, times) {
		      if (!(this instanceof Repeat)) {
		        return new Repeat(value, times);
		      }
		      this._value = value;
		      this.size = times === undefined ? Infinity : Math.max(0, times);
		      if (this.size === 0) {
		        if (EMPTY_REPEAT) {
		          return EMPTY_REPEAT;
		        }
		        EMPTY_REPEAT = this;
		      }
		    }
	
		    Repeat.prototype.toString = function() {
		      if (this.size === 0) {
		        return 'Repeat []';
		      }
		      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
		    };
	
		    Repeat.prototype.get = function(index, notSetValue) {
		      return this.has(index) ? this._value : notSetValue;
		    };
	
		    Repeat.prototype.includes = function(searchValue) {
		      return is(this._value, searchValue);
		    };
	
		    Repeat.prototype.slice = function(begin, end) {
		      var size = this.size;
		      return wholeSlice(begin, end, size) ? this :
		        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
		    };
	
		    Repeat.prototype.reverse = function() {
		      return this;
		    };
	
		    Repeat.prototype.indexOf = function(searchValue) {
		      if (is(this._value, searchValue)) {
		        return 0;
		      }
		      return -1;
		    };
	
		    Repeat.prototype.lastIndexOf = function(searchValue) {
		      if (is(this._value, searchValue)) {
		        return this.size;
		      }
		      return -1;
		    };
	
		    Repeat.prototype.__iterate = function(fn, reverse) {
		      for (var ii = 0; ii < this.size; ii++) {
		        if (fn(this._value, ii, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
		      var ii = 0;
		      return new Iterator(function() 
		        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
		      );
		    };
	
		    Repeat.prototype.equals = function(other) {
		      return other instanceof Repeat ?
		        is(this._value, other._value) :
		        deepEqual(other);
		    };
	
	
		  var EMPTY_REPEAT;
	
		  function invariant(condition, error) {
		    if (!condition) throw new Error(error);
		  }
	
		  createClass(Range, IndexedSeq);
	
		    function Range(start, end, step) {
		      if (!(this instanceof Range)) {
		        return new Range(start, end, step);
		      }
		      invariant(step !== 0, 'Cannot step a Range by 0');
		      start = start || 0;
		      if (end === undefined) {
		        end = Infinity;
		      }
		      step = step === undefined ? 1 : Math.abs(step);
		      if (end < start) {
		        step = -step;
		      }
		      this._start = start;
		      this._end = end;
		      this._step = step;
		      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
		      if (this.size === 0) {
		        if (EMPTY_RANGE) {
		          return EMPTY_RANGE;
		        }
		        EMPTY_RANGE = this;
		      }
		    }
	
		    Range.prototype.toString = function() {
		      if (this.size === 0) {
		        return 'Range []';
		      }
		      return 'Range [ ' +
		        this._start + '...' + this._end +
		        (this._step !== 1 ? ' by ' + this._step : '') +
		      ' ]';
		    };
	
		    Range.prototype.get = function(index, notSetValue) {
		      return this.has(index) ?
		        this._start + wrapIndex(this, index) * this._step :
		        notSetValue;
		    };
	
		    Range.prototype.includes = function(searchValue) {
		      var possibleIndex = (searchValue - this._start) / this._step;
		      return possibleIndex >= 0 &&
		        possibleIndex < this.size &&
		        possibleIndex === Math.floor(possibleIndex);
		    };
	
		    Range.prototype.slice = function(begin, end) {
		      if (wholeSlice(begin, end, this.size)) {
		        return this;
		      }
		      begin = resolveBegin(begin, this.size);
		      end = resolveEnd(end, this.size);
		      if (end <= begin) {
		        return new Range(0, 0);
		      }
		      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
		    };
	
		    Range.prototype.indexOf = function(searchValue) {
		      var offsetValue = searchValue - this._start;
		      if (offsetValue % this._step === 0) {
		        var index = offsetValue / this._step;
		        if (index >= 0 && index < this.size) {
		          return index
		        }
		      }
		      return -1;
		    };
	
		    Range.prototype.lastIndexOf = function(searchValue) {
		      return this.indexOf(searchValue);
		    };
	
		    Range.prototype.__iterate = function(fn, reverse) {
		      var maxIndex = this.size - 1;
		      var step = this._step;
		      var value = reverse ? this._start + maxIndex * step : this._start;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        if (fn(value, ii, this) === false) {
		          return ii + 1;
		        }
		        value += reverse ? -step : step;
		      }
		      return ii;
		    };
	
		    Range.prototype.__iterator = function(type, reverse) {
		      var maxIndex = this.size - 1;
		      var step = this._step;
		      var value = reverse ? this._start + maxIndex * step : this._start;
		      var ii = 0;
		      return new Iterator(function()  {
		        var v = value;
		        value += reverse ? -step : step;
		        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
		      });
		    };
	
		    Range.prototype.equals = function(other) {
		      return other instanceof Range ?
		        this._start === other._start &&
		        this._end === other._end &&
		        this._step === other._step :
		        deepEqual(this, other);
		    };
	
	
		  var EMPTY_RANGE;
	
		  createClass(Collection, Iterable);
		    function Collection() {
		      throw TypeError('Abstract');
		    }
	
	
		  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
		  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
		  createClass(SetCollection, Collection);function SetCollection() {}
	
	
		  Collection.Keyed = KeyedCollection;
		  Collection.Indexed = IndexedCollection;
		  Collection.Set = SetCollection;
	
		  var imul =
		    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
		    Math.imul :
		    function imul(a, b) {
		      a = a | 0; // int
		      b = b | 0; // int
		      var c = a & 0xffff;
		      var d = b & 0xffff;
		      // Shift by 0 fixes the sign on the high part.
		      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
		    };
	
		  // v8 has an optimization for storing 31-bit signed numbers.
		  // Values which have either 00 or 11 as the high order bits qualify.
		  // This function drops the highest order bit in a signed number, maintaining
		  // the sign bit.
		  function smi(i32) {
		    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
		  }
	
		  function hash(o) {
		    if (o === false || o === null || o === undefined) {
		      return 0;
		    }
		    if (typeof o.valueOf === 'function') {
		      o = o.valueOf();
		      if (o === false || o === null || o === undefined) {
		        return 0;
		      }
		    }
		    if (o === true) {
		      return 1;
		    }
		    var type = typeof o;
		    if (type === 'number') {
		      if (o !== o || o === Infinity) {
		        return 0;
		      }
		      var h = o | 0;
		      if (h !== o) {
		        h ^= o * 0xFFFFFFFF;
		      }
		      while (o > 0xFFFFFFFF) {
		        o /= 0xFFFFFFFF;
		        h ^= o;
		      }
		      return smi(h);
		    }
		    if (type === 'string') {
		      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
		    }
		    if (typeof o.hashCode === 'function') {
		      return o.hashCode();
		    }
		    if (type === 'object') {
		      return hashJSObj(o);
		    }
		    if (typeof o.toString === 'function') {
		      return hashString(o.toString());
		    }
		    throw new Error('Value type ' + type + ' cannot be hashed.');
		  }
	
		  function cachedHashString(string) {
		    var hash = stringHashCache[string];
		    if (hash === undefined) {
		      hash = hashString(string);
		      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
		        STRING_HASH_CACHE_SIZE = 0;
		        stringHashCache = {};
		      }
		      STRING_HASH_CACHE_SIZE++;
		      stringHashCache[string] = hash;
		    }
		    return hash;
		  }
	
		  // http://jsperf.com/hashing-strings
		  function hashString(string) {
		    // This is the hash from JVM
		    // The hash code for a string is computed as
		    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
		    // where s[i] is the ith character of the string and n is the length of
		    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
		    // (exclusive) by dropping high bits.
		    var hash = 0;
		    for (var ii = 0; ii < string.length; ii++) {
		      hash = 31 * hash + string.charCodeAt(ii) | 0;
		    }
		    return smi(hash);
		  }
	
		  function hashJSObj(obj) {
		    var hash;
		    if (usingWeakMap) {
		      hash = weakMap.get(obj);
		      if (hash !== undefined) {
		        return hash;
		      }
		    }
	
		    hash = obj[UID_HASH_KEY];
		    if (hash !== undefined) {
		      return hash;
		    }
	
		    if (!canDefineProperty) {
		      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
		      if (hash !== undefined) {
		        return hash;
		      }
	
		      hash = getIENodeHash(obj);
		      if (hash !== undefined) {
		        return hash;
		      }
		    }
	
		    hash = ++objHashUID;
		    if (objHashUID & 0x40000000) {
		      objHashUID = 0;
		    }
	
		    if (usingWeakMap) {
		      weakMap.set(obj, hash);
		    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
		      throw new Error('Non-extensible objects are not allowed as keys.');
		    } else if (canDefineProperty) {
		      Object.defineProperty(obj, UID_HASH_KEY, {
		        'enumerable': false,
		        'configurable': false,
		        'writable': false,
		        'value': hash
		      });
		    } else if (obj.propertyIsEnumerable !== undefined &&
		               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
		      // Since we can't define a non-enumerable property on the object
		      // we'll hijack one of the less-used non-enumerable properties to
		      // save our hash on it. Since this is a function it will not show up in
		      // `JSON.stringify` which is what we want.
		      obj.propertyIsEnumerable = function() {
		        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
		      };
		      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
		    } else if (obj.nodeType !== undefined) {
		      // At this point we couldn't get the IE `uniqueID` to use as a hash
		      // and we couldn't use a non-enumerable property to exploit the
		      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
		      // itself.
		      obj[UID_HASH_KEY] = hash;
		    } else {
		      throw new Error('Unable to set a non-enumerable property on object.');
		    }
	
		    return hash;
		  }
	
		  // Get references to ES5 object methods.
		  var isExtensible = Object.isExtensible;
	
		  // True if Object.defineProperty works as expected. IE8 fails this test.
		  var canDefineProperty = (function() {
		    try {
		      Object.defineProperty({}, '@', {});
		      return true;
		    } catch (e) {
		      return false;
		    }
		  }());
	
		  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
		  // and avoid memory leaks from the IE cloneNode bug.
		  function getIENodeHash(node) {
		    if (node && node.nodeType > 0) {
		      switch (node.nodeType) {
		        case 1: // Element
		          return node.uniqueID;
		        case 9: // Document
		          return node.documentElement && node.documentElement.uniqueID;
		      }
		    }
		  }
	
		  // If possible, use a WeakMap.
		  var usingWeakMap = typeof WeakMap === 'function';
		  var weakMap;
		  if (usingWeakMap) {
		    weakMap = new WeakMap();
		  }
	
		  var objHashUID = 0;
	
		  var UID_HASH_KEY = '__immutablehash__';
		  if (typeof Symbol === 'function') {
		    UID_HASH_KEY = Symbol(UID_HASH_KEY);
		  }
	
		  var STRING_HASH_CACHE_MIN_STRLEN = 16;
		  var STRING_HASH_CACHE_MAX_SIZE = 255;
		  var STRING_HASH_CACHE_SIZE = 0;
		  var stringHashCache = {};
	
		  function assertNotInfinite(size) {
		    invariant(
		      size !== Infinity,
		      'Cannot perform this action with an infinite size.'
		    );
		  }
	
		  createClass(Map, KeyedCollection);
	
		    // @pragma Construction
	
		    function Map(value) {
		      return value === null || value === undefined ? emptyMap() :
		        isMap(value) && !isOrdered(value) ? value :
		        emptyMap().withMutations(function(map ) {
		          var iter = KeyedIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v, k)  {return map.set(k, v)});
		        });
		    }
	
		    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
		      return emptyMap().withMutations(function(map ) {
		        for (var i = 0; i < keyValues.length; i += 2) {
		          if (i + 1 >= keyValues.length) {
		            throw new Error('Missing value for key: ' + keyValues[i]);
		          }
		          map.set(keyValues[i], keyValues[i + 1]);
		        }
		      });
		    };
	
		    Map.prototype.toString = function() {
		      return this.__toString('Map {', '}');
		    };
	
		    // @pragma Access
	
		    Map.prototype.get = function(k, notSetValue) {
		      return this._root ?
		        this._root.get(0, undefined, k, notSetValue) :
		        notSetValue;
		    };
	
		    // @pragma Modification
	
		    Map.prototype.set = function(k, v) {
		      return updateMap(this, k, v);
		    };
	
		    Map.prototype.setIn = function(keyPath, v) {
		      return this.updateIn(keyPath, NOT_SET, function()  {return v});
		    };
	
		    Map.prototype.remove = function(k) {
		      return updateMap(this, k, NOT_SET);
		    };
	
		    Map.prototype.deleteIn = function(keyPath) {
		      return this.updateIn(keyPath, function()  {return NOT_SET});
		    };
	
		    Map.prototype.update = function(k, notSetValue, updater) {
		      return arguments.length === 1 ?
		        k(this) :
		        this.updateIn([k], notSetValue, updater);
		    };
	
		    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
		      if (!updater) {
		        updater = notSetValue;
		        notSetValue = undefined;
		      }
		      var updatedValue = updateInDeepMap(
		        this,
		        forceIterator(keyPath),
		        notSetValue,
		        updater
		      );
		      return updatedValue === NOT_SET ? undefined : updatedValue;
		    };
	
		    Map.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._root = null;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyMap();
		    };
	
		    // @pragma Composition
	
		    Map.prototype.merge = function(/*...iters*/) {
		      return mergeIntoMapWith(this, undefined, arguments);
		    };
	
		    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoMapWith(this, merger, iters);
		    };
	
		    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
		      return this.updateIn(
		        keyPath,
		        emptyMap(),
		        function(m ) {return typeof m.merge === 'function' ?
		          m.merge.apply(m, iters) :
		          iters[iters.length - 1]}
		      );
		    };
	
		    Map.prototype.mergeDeep = function(/*...iters*/) {
		      return mergeIntoMapWith(this, deepMerger, arguments);
		    };
	
		    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
		    };
	
		    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
		      return this.updateIn(
		        keyPath,
		        emptyMap(),
		        function(m ) {return typeof m.mergeDeep === 'function' ?
		          m.mergeDeep.apply(m, iters) :
		          iters[iters.length - 1]}
		      );
		    };
	
		    Map.prototype.sort = function(comparator) {
		      // Late binding
		      return OrderedMap(sortFactory(this, comparator));
		    };
	
		    Map.prototype.sortBy = function(mapper, comparator) {
		      // Late binding
		      return OrderedMap(sortFactory(this, comparator, mapper));
		    };
	
		    // @pragma Mutability
	
		    Map.prototype.withMutations = function(fn) {
		      var mutable = this.asMutable();
		      fn(mutable);
		      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
		    };
	
		    Map.prototype.asMutable = function() {
		      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
		    };
	
		    Map.prototype.asImmutable = function() {
		      return this.__ensureOwner();
		    };
	
		    Map.prototype.wasAltered = function() {
		      return this.__altered;
		    };
	
		    Map.prototype.__iterator = function(type, reverse) {
		      return new MapIterator(this, type, reverse);
		    };
	
		    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      this._root && this._root.iterate(function(entry ) {
		        iterations++;
		        return fn(entry[1], entry[0], this$0);
		      }, reverse);
		      return iterations;
		    };
	
		    Map.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this.__altered = false;
		        return this;
		      }
		      return makeMap(this.size, this._root, ownerID, this.__hash);
		    };
	
	
		  function isMap(maybeMap) {
		    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
		  }
	
		  Map.isMap = isMap;
	
		  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
		  var MapPrototype = Map.prototype;
		  MapPrototype[IS_MAP_SENTINEL] = true;
		  MapPrototype[DELETE] = MapPrototype.remove;
		  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
		  // #pragma Trie Nodes
	
	
	
		    function ArrayMapNode(ownerID, entries) {
		      this.ownerID = ownerID;
		      this.entries = entries;
		    }
	
		    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      var entries = this.entries;
		      for (var ii = 0, len = entries.length; ii < len; ii++) {
		        if (is(key, entries[ii][0])) {
		          return entries[ii][1];
		        }
		      }
		      return notSetValue;
		    };
	
		    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      var removed = value === NOT_SET;
	
		      var entries = this.entries;
		      var idx = 0;
		      for (var len = entries.length; idx < len; idx++) {
		        if (is(key, entries[idx][0])) {
		          break;
		        }
		      }
		      var exists = idx < len;
	
		      if (exists ? entries[idx][1] === value : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
		      (removed || !exists) && SetRef(didChangeSize);
	
		      if (removed && entries.length === 1) {
		        return; // undefined
		      }
	
		      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
		        return createNodes(ownerID, entries, key, value);
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newEntries = isEditable ? entries : arrCopy(entries);
	
		      if (exists) {
		        if (removed) {
		          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
		        } else {
		          newEntries[idx] = [key, value];
		        }
		      } else {
		        newEntries.push([key, value]);
		      }
	
		      if (isEditable) {
		        this.entries = newEntries;
		        return this;
		      }
	
		      return new ArrayMapNode(ownerID, newEntries);
		    };
	
	
	
	
		    function BitmapIndexedNode(ownerID, bitmap, nodes) {
		      this.ownerID = ownerID;
		      this.bitmap = bitmap;
		      this.nodes = nodes;
		    }
	
		    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
		      var bitmap = this.bitmap;
		      return (bitmap & bit) === 0 ? notSetValue :
		        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
		    };
	
		    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var bit = 1 << keyHashFrag;
		      var bitmap = this.bitmap;
		      var exists = (bitmap & bit) !== 0;
	
		      if (!exists && value === NOT_SET) {
		        return this;
		      }
	
		      var idx = popCount(bitmap & (bit - 1));
		      var nodes = this.nodes;
		      var node = exists ? nodes[idx] : undefined;
		      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
		      if (newNode === node) {
		        return this;
		      }
	
		      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
		        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
		      }
	
		      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
		        return nodes[idx ^ 1];
		      }
	
		      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
		        return newNode;
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
		      var newNodes = exists ? newNode ?
		        setIn(nodes, idx, newNode, isEditable) :
		        spliceOut(nodes, idx, isEditable) :
		        spliceIn(nodes, idx, newNode, isEditable);
	
		      if (isEditable) {
		        this.bitmap = newBitmap;
		        this.nodes = newNodes;
		        return this;
		      }
	
		      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
		    };
	
	
	
	
		    function HashArrayMapNode(ownerID, count, nodes) {
		      this.ownerID = ownerID;
		      this.count = count;
		      this.nodes = nodes;
		    }
	
		    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var node = this.nodes[idx];
		      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
		    };
	
		    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var removed = value === NOT_SET;
		      var nodes = this.nodes;
		      var node = nodes[idx];
	
		      if (removed && !node) {
		        return this;
		      }
	
		      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
		      if (newNode === node) {
		        return this;
		      }
	
		      var newCount = this.count;
		      if (!node) {
		        newCount++;
		      } else if (!newNode) {
		        newCount--;
		        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
		          return packNodes(ownerID, nodes, newCount, idx);
		        }
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
		      if (isEditable) {
		        this.count = newCount;
		        this.nodes = newNodes;
		        return this;
		      }
	
		      return new HashArrayMapNode(ownerID, newCount, newNodes);
		    };
	
	
	
	
		    function HashCollisionNode(ownerID, keyHash, entries) {
		      this.ownerID = ownerID;
		      this.keyHash = keyHash;
		      this.entries = entries;
		    }
	
		    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      var entries = this.entries;
		      for (var ii = 0, len = entries.length; ii < len; ii++) {
		        if (is(key, entries[ii][0])) {
		          return entries[ii][1];
		        }
		      }
		      return notSetValue;
		    };
	
		    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
	
		      var removed = value === NOT_SET;
	
		      if (keyHash !== this.keyHash) {
		        if (removed) {
		          return this;
		        }
		        SetRef(didAlter);
		        SetRef(didChangeSize);
		        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
		      }
	
		      var entries = this.entries;
		      var idx = 0;
		      for (var len = entries.length; idx < len; idx++) {
		        if (is(key, entries[idx][0])) {
		          break;
		        }
		      }
		      var exists = idx < len;
	
		      if (exists ? entries[idx][1] === value : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
		      (removed || !exists) && SetRef(didChangeSize);
	
		      if (removed && len === 2) {
		        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newEntries = isEditable ? entries : arrCopy(entries);
	
		      if (exists) {
		        if (removed) {
		          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
		        } else {
		          newEntries[idx] = [key, value];
		        }
		      } else {
		        newEntries.push([key, value]);
		      }
	
		      if (isEditable) {
		        this.entries = newEntries;
		        return this;
		      }
	
		      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
		    };
	
	
	
	
		    function ValueNode(ownerID, keyHash, entry) {
		      this.ownerID = ownerID;
		      this.keyHash = keyHash;
		      this.entry = entry;
		    }
	
		    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
		    };
	
		    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      var removed = value === NOT_SET;
		      var keyMatch = is(key, this.entry[0]);
		      if (keyMatch ? value === this.entry[1] : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
	
		      if (removed) {
		        SetRef(didChangeSize);
		        return; // undefined
		      }
	
		      if (keyMatch) {
		        if (ownerID && ownerID === this.ownerID) {
		          this.entry[1] = value;
		          return this;
		        }
		        return new ValueNode(ownerID, this.keyHash, [key, value]);
		      }
	
		      SetRef(didChangeSize);
		      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
		    };
	
	
	
		  // #pragma Iterators
	
		  ArrayMapNode.prototype.iterate =
		  HashCollisionNode.prototype.iterate = function (fn, reverse) {
		    var entries = this.entries;
		    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
		      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
		        return false;
		      }
		    }
		  }
	
		  BitmapIndexedNode.prototype.iterate =
		  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
		    var nodes = this.nodes;
		    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
		      var node = nodes[reverse ? maxIndex - ii : ii];
		      if (node && node.iterate(fn, reverse) === false) {
		        return false;
		      }
		    }
		  }
	
		  ValueNode.prototype.iterate = function (fn, reverse) {
		    return fn(this.entry);
		  }
	
		  createClass(MapIterator, Iterator);
	
		    function MapIterator(map, type, reverse) {
		      this._type = type;
		      this._reverse = reverse;
		      this._stack = map._root && mapIteratorFrame(map._root);
		    }
	
		    MapIterator.prototype.next = function() {
		      var type = this._type;
		      var stack = this._stack;
		      while (stack) {
		        var node = stack.node;
		        var index = stack.index++;
		        var maxIndex;
		        if (node.entry) {
		          if (index === 0) {
		            return mapIteratorValue(type, node.entry);
		          }
		        } else if (node.entries) {
		          maxIndex = node.entries.length - 1;
		          if (index <= maxIndex) {
		            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
		          }
		        } else {
		          maxIndex = node.nodes.length - 1;
		          if (index <= maxIndex) {
		            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
		            if (subNode) {
		              if (subNode.entry) {
		                return mapIteratorValue(type, subNode.entry);
		              }
		              stack = this._stack = mapIteratorFrame(subNode, stack);
		            }
		            continue;
		          }
		        }
		        stack = this._stack = this._stack.__prev;
		      }
		      return iteratorDone();
		    };
	
	
		  function mapIteratorValue(type, entry) {
		    return iteratorValue(type, entry[0], entry[1]);
		  }
	
		  function mapIteratorFrame(node, prev) {
		    return {
		      node: node,
		      index: 0,
		      __prev: prev
		    };
		  }
	
		  function makeMap(size, root, ownerID, hash) {
		    var map = Object.create(MapPrototype);
		    map.size = size;
		    map._root = root;
		    map.__ownerID = ownerID;
		    map.__hash = hash;
		    map.__altered = false;
		    return map;
		  }
	
		  var EMPTY_MAP;
		  function emptyMap() {
		    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
		  }
	
		  function updateMap(map, k, v) {
		    var newRoot;
		    var newSize;
		    if (!map._root) {
		      if (v === NOT_SET) {
		        return map;
		      }
		      newSize = 1;
		      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
		    } else {
		      var didChangeSize = MakeRef(CHANGE_LENGTH);
		      var didAlter = MakeRef(DID_ALTER);
		      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
		      if (!didAlter.value) {
		        return map;
		      }
		      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
		    }
		    if (map.__ownerID) {
		      map.size = newSize;
		      map._root = newRoot;
		      map.__hash = undefined;
		      map.__altered = true;
		      return map;
		    }
		    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
		  }
	
		  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		    if (!node) {
		      if (value === NOT_SET) {
		        return node;
		      }
		      SetRef(didAlter);
		      SetRef(didChangeSize);
		      return new ValueNode(ownerID, keyHash, [key, value]);
		    }
		    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
		  }
	
		  function isLeafNode(node) {
		    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
		  }
	
		  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
		    if (node.keyHash === keyHash) {
		      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
		    }
	
		    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
		    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
		    var newNode;
		    var nodes = idx1 === idx2 ?
		      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
		      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
		    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
		  }
	
		  function createNodes(ownerID, entries, key, value) {
		    if (!ownerID) {
		      ownerID = new OwnerID();
		    }
		    var node = new ValueNode(ownerID, hash(key), [key, value]);
		    for (var ii = 0; ii < entries.length; ii++) {
		      var entry = entries[ii];
		      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
		    }
		    return node;
		  }
	
		  function packNodes(ownerID, nodes, count, excluding) {
		    var bitmap = 0;
		    var packedII = 0;
		    var packedNodes = new Array(count);
		    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
		      var node = nodes[ii];
		      if (node !== undefined && ii !== excluding) {
		        bitmap |= bit;
		        packedNodes[packedII++] = node;
		      }
		    }
		    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
		  }
	
		  function expandNodes(ownerID, nodes, bitmap, including, node) {
		    var count = 0;
		    var expandedNodes = new Array(SIZE);
		    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
		      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
		    }
		    expandedNodes[including] = node;
		    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
		  }
	
		  function mergeIntoMapWith(map, merger, iterables) {
		    var iters = [];
		    for (var ii = 0; ii < iterables.length; ii++) {
		      var value = iterables[ii];
		      var iter = KeyedIterable(value);
		      if (!isIterable(value)) {
		        iter = iter.map(function(v ) {return fromJS(v)});
		      }
		      iters.push(iter);
		    }
		    return mergeIntoCollectionWith(map, merger, iters);
		  }
	
		  function deepMerger(existing, value, key) {
		    return existing && existing.mergeDeep && isIterable(value) ?
		      existing.mergeDeep(value) :
		      is(existing, value) ? existing : value;
		  }
	
		  function deepMergerWith(merger) {
		    return function(existing, value, key)  {
		      if (existing && existing.mergeDeepWith && isIterable(value)) {
		        return existing.mergeDeepWith(merger, value);
		      }
		      var nextValue = merger(existing, value, key);
		      return is(existing, nextValue) ? existing : nextValue;
		    };
		  }
	
		  function mergeIntoCollectionWith(collection, merger, iters) {
		    iters = iters.filter(function(x ) {return x.size !== 0});
		    if (iters.length === 0) {
		      return collection;
		    }
		    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
		      return collection.constructor(iters[0]);
		    }
		    return collection.withMutations(function(collection ) {
		      var mergeIntoMap = merger ?
		        function(value, key)  {
		          collection.update(key, NOT_SET, function(existing )
		            {return existing === NOT_SET ? value : merger(existing, value, key)}
		          );
		        } :
		        function(value, key)  {
		          collection.set(key, value);
		        }
		      for (var ii = 0; ii < iters.length; ii++) {
		        iters[ii].forEach(mergeIntoMap);
		      }
		    });
		  }
	
		  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
		    var isNotSet = existing === NOT_SET;
		    var step = keyPathIter.next();
		    if (step.done) {
		      var existingValue = isNotSet ? notSetValue : existing;
		      var newValue = updater(existingValue);
		      return newValue === existingValue ? existing : newValue;
		    }
		    invariant(
		      isNotSet || (existing && existing.set),
		      'invalid keyPath'
		    );
		    var key = step.value;
		    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
		    var nextUpdated = updateInDeepMap(
		      nextExisting,
		      keyPathIter,
		      notSetValue,
		      updater
		    );
		    return nextUpdated === nextExisting ? existing :
		      nextUpdated === NOT_SET ? existing.remove(key) :
		      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
		  }
	
		  function popCount(x) {
		    x = x - ((x >> 1) & 0x55555555);
		    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
		    x = (x + (x >> 4)) & 0x0f0f0f0f;
		    x = x + (x >> 8);
		    x = x + (x >> 16);
		    return x & 0x7f;
		  }
	
		  function setIn(array, idx, val, canEdit) {
		    var newArray = canEdit ? array : arrCopy(array);
		    newArray[idx] = val;
		    return newArray;
		  }
	
		  function spliceIn(array, idx, val, canEdit) {
		    var newLen = array.length + 1;
		    if (canEdit && idx + 1 === newLen) {
		      array[idx] = val;
		      return array;
		    }
		    var newArray = new Array(newLen);
		    var after = 0;
		    for (var ii = 0; ii < newLen; ii++) {
		      if (ii === idx) {
		        newArray[ii] = val;
		        after = -1;
		      } else {
		        newArray[ii] = array[ii + after];
		      }
		    }
		    return newArray;
		  }
	
		  function spliceOut(array, idx, canEdit) {
		    var newLen = array.length - 1;
		    if (canEdit && idx === newLen) {
		      array.pop();
		      return array;
		    }
		    var newArray = new Array(newLen);
		    var after = 0;
		    for (var ii = 0; ii < newLen; ii++) {
		      if (ii === idx) {
		        after = 1;
		      }
		      newArray[ii] = array[ii + after];
		    }
		    return newArray;
		  }
	
		  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
		  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
		  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
		  createClass(List, IndexedCollection);
	
		    // @pragma Construction
	
		    function List(value) {
		      var empty = emptyList();
		      if (value === null || value === undefined) {
		        return empty;
		      }
		      if (isList(value)) {
		        return value;
		      }
		      var iter = IndexedIterable(value);
		      var size = iter.size;
		      if (size === 0) {
		        return empty;
		      }
		      assertNotInfinite(size);
		      if (size > 0 && size < SIZE) {
		        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
		      }
		      return empty.withMutations(function(list ) {
		        list.setSize(size);
		        iter.forEach(function(v, i)  {return list.set(i, v)});
		      });
		    }
	
		    List.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    List.prototype.toString = function() {
		      return this.__toString('List [', ']');
		    };
	
		    // @pragma Access
	
		    List.prototype.get = function(index, notSetValue) {
		      index = wrapIndex(this, index);
		      if (index >= 0 && index < this.size) {
		        index += this._origin;
		        var node = listNodeFor(this, index);
		        return node && node.array[index & MASK];
		      }
		      return notSetValue;
		    };
	
		    // @pragma Modification
	
		    List.prototype.set = function(index, value) {
		      return updateList(this, index, value);
		    };
	
		    List.prototype.remove = function(index) {
		      return !this.has(index) ? this :
		        index === 0 ? this.shift() :
		        index === this.size - 1 ? this.pop() :
		        this.splice(index, 1);
		    };
	
		    List.prototype.insert = function(index, value) {
		      return this.splice(index, 0, value);
		    };
	
		    List.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = this._origin = this._capacity = 0;
		        this._level = SHIFT;
		        this._root = this._tail = null;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyList();
		    };
	
		    List.prototype.push = function(/*...values*/) {
		      var values = arguments;
		      var oldSize = this.size;
		      return this.withMutations(function(list ) {
		        setListBounds(list, 0, oldSize + values.length);
		        for (var ii = 0; ii < values.length; ii++) {
		          list.set(oldSize + ii, values[ii]);
		        }
		      });
		    };
	
		    List.prototype.pop = function() {
		      return setListBounds(this, 0, -1);
		    };
	
		    List.prototype.unshift = function(/*...values*/) {
		      var values = arguments;
		      return this.withMutations(function(list ) {
		        setListBounds(list, -values.length);
		        for (var ii = 0; ii < values.length; ii++) {
		          list.set(ii, values[ii]);
		        }
		      });
		    };
	
		    List.prototype.shift = function() {
		      return setListBounds(this, 1);
		    };
	
		    // @pragma Composition
	
		    List.prototype.merge = function(/*...iters*/) {
		      return mergeIntoListWith(this, undefined, arguments);
		    };
	
		    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoListWith(this, merger, iters);
		    };
	
		    List.prototype.mergeDeep = function(/*...iters*/) {
		      return mergeIntoListWith(this, deepMerger, arguments);
		    };
	
		    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoListWith(this, deepMergerWith(merger), iters);
		    };
	
		    List.prototype.setSize = function(size) {
		      return setListBounds(this, 0, size);
		    };
	
		    // @pragma Iteration
	
		    List.prototype.slice = function(begin, end) {
		      var size = this.size;
		      if (wholeSlice(begin, end, size)) {
		        return this;
		      }
		      return setListBounds(
		        this,
		        resolveBegin(begin, size),
		        resolveEnd(end, size)
		      );
		    };
	
		    List.prototype.__iterator = function(type, reverse) {
		      var index = 0;
		      var values = iterateList(this, reverse);
		      return new Iterator(function()  {
		        var value = values();
		        return value === DONE ?
		          iteratorDone() :
		          iteratorValue(type, index++, value);
		      });
		    };
	
		    List.prototype.__iterate = function(fn, reverse) {
		      var index = 0;
		      var values = iterateList(this, reverse);
		      var value;
		      while ((value = values()) !== DONE) {
		        if (fn(value, index++, this) === false) {
		          break;
		        }
		      }
		      return index;
		    };
	
		    List.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        return this;
		      }
		      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
		    };
	
	
		  function isList(maybeList) {
		    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
		  }
	
		  List.isList = isList;
	
		  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
		  var ListPrototype = List.prototype;
		  ListPrototype[IS_LIST_SENTINEL] = true;
		  ListPrototype[DELETE] = ListPrototype.remove;
		  ListPrototype.setIn = MapPrototype.setIn;
		  ListPrototype.deleteIn =
		  ListPrototype.removeIn = MapPrototype.removeIn;
		  ListPrototype.update = MapPrototype.update;
		  ListPrototype.updateIn = MapPrototype.updateIn;
		  ListPrototype.mergeIn = MapPrototype.mergeIn;
		  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
		  ListPrototype.withMutations = MapPrototype.withMutations;
		  ListPrototype.asMutable = MapPrototype.asMutable;
		  ListPrototype.asImmutable = MapPrototype.asImmutable;
		  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
		    function VNode(array, ownerID) {
		      this.array = array;
		      this.ownerID = ownerID;
		    }
	
		    // TODO: seems like these methods are very similar
	
		    VNode.prototype.removeBefore = function(ownerID, level, index) {
		      if (index === level ? 1 << level : 0 || this.array.length === 0) {
		        return this;
		      }
		      var originIndex = (index >>> level) & MASK;
		      if (originIndex >= this.array.length) {
		        return new VNode([], ownerID);
		      }
		      var removingFirst = originIndex === 0;
		      var newChild;
		      if (level > 0) {
		        var oldChild = this.array[originIndex];
		        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
		        if (newChild === oldChild && removingFirst) {
		          return this;
		        }
		      }
		      if (removingFirst && !newChild) {
		        return this;
		      }
		      var editable = editableVNode(this, ownerID);
		      if (!removingFirst) {
		        for (var ii = 0; ii < originIndex; ii++) {
		          editable.array[ii] = undefined;
		        }
		      }
		      if (newChild) {
		        editable.array[originIndex] = newChild;
		      }
		      return editable;
		    };
	
		    VNode.prototype.removeAfter = function(ownerID, level, index) {
		      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
		        return this;
		      }
		      var sizeIndex = ((index - 1) >>> level) & MASK;
		      if (sizeIndex >= this.array.length) {
		        return this;
		      }
	
		      var newChild;
		      if (level > 0) {
		        var oldChild = this.array[sizeIndex];
		        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
		        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
		          return this;
		        }
		      }
	
		      var editable = editableVNode(this, ownerID);
		      editable.array.splice(sizeIndex + 1);
		      if (newChild) {
		        editable.array[sizeIndex] = newChild;
		      }
		      return editable;
		    };
	
	
	
		  var DONE = {};
	
		  function iterateList(list, reverse) {
		    var left = list._origin;
		    var right = list._capacity;
		    var tailPos = getTailOffset(right);
		    var tail = list._tail;
	
		    return iterateNodeOrLeaf(list._root, list._level, 0);
	
		    function iterateNodeOrLeaf(node, level, offset) {
		      return level === 0 ?
		        iterateLeaf(node, offset) :
		        iterateNode(node, level, offset);
		    }
	
		    function iterateLeaf(node, offset) {
		      var array = offset === tailPos ? tail && tail.array : node && node.array;
		      var from = offset > left ? 0 : left - offset;
		      var to = right - offset;
		      if (to > SIZE) {
		        to = SIZE;
		      }
		      return function()  {
		        if (from === to) {
		          return DONE;
		        }
		        var idx = reverse ? --to : from++;
		        return array && array[idx];
		      };
		    }
	
		    function iterateNode(node, level, offset) {
		      var values;
		      var array = node && node.array;
		      var from = offset > left ? 0 : (left - offset) >> level;
		      var to = ((right - offset) >> level) + 1;
		      if (to > SIZE) {
		        to = SIZE;
		      }
		      return function()  {
		        do {
		          if (values) {
		            var value = values();
		            if (value !== DONE) {
		              return value;
		            }
		            values = null;
		          }
		          if (from === to) {
		            return DONE;
		          }
		          var idx = reverse ? --to : from++;
		          values = iterateNodeOrLeaf(
		            array && array[idx], level - SHIFT, offset + (idx << level)
		          );
		        } while (true);
		      };
		    }
		  }
	
		  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
		    var list = Object.create(ListPrototype);
		    list.size = capacity - origin;
		    list._origin = origin;
		    list._capacity = capacity;
		    list._level = level;
		    list._root = root;
		    list._tail = tail;
		    list.__ownerID = ownerID;
		    list.__hash = hash;
		    list.__altered = false;
		    return list;
		  }
	
		  var EMPTY_LIST;
		  function emptyList() {
		    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
		  }
	
		  function updateList(list, index, value) {
		    index = wrapIndex(list, index);
	
		    if (index !== index) {
		      return list;
		    }
	
		    if (index >= list.size || index < 0) {
		      return list.withMutations(function(list ) {
		        index < 0 ?
		          setListBounds(list, index).set(0, value) :
		          setListBounds(list, 0, index + 1).set(index, value)
		      });
		    }
	
		    index += list._origin;
	
		    var newTail = list._tail;
		    var newRoot = list._root;
		    var didAlter = MakeRef(DID_ALTER);
		    if (index >= getTailOffset(list._capacity)) {
		      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
		    } else {
		      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
		    }
	
		    if (!didAlter.value) {
		      return list;
		    }
	
		    if (list.__ownerID) {
		      list._root = newRoot;
		      list._tail = newTail;
		      list.__hash = undefined;
		      list.__altered = true;
		      return list;
		    }
		    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
		  }
	
		  function updateVNode(node, ownerID, level, index, value, didAlter) {
		    var idx = (index >>> level) & MASK;
		    var nodeHas = node && idx < node.array.length;
		    if (!nodeHas && value === undefined) {
		      return node;
		    }
	
		    var newNode;
	
		    if (level > 0) {
		      var lowerNode = node && node.array[idx];
		      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
		      if (newLowerNode === lowerNode) {
		        return node;
		      }
		      newNode = editableVNode(node, ownerID);
		      newNode.array[idx] = newLowerNode;
		      return newNode;
		    }
	
		    if (nodeHas && node.array[idx] === value) {
		      return node;
		    }
	
		    SetRef(didAlter);
	
		    newNode = editableVNode(node, ownerID);
		    if (value === undefined && idx === newNode.array.length - 1) {
		      newNode.array.pop();
		    } else {
		      newNode.array[idx] = value;
		    }
		    return newNode;
		  }
	
		  function editableVNode(node, ownerID) {
		    if (ownerID && node && ownerID === node.ownerID) {
		      return node;
		    }
		    return new VNode(node ? node.array.slice() : [], ownerID);
		  }
	
		  function listNodeFor(list, rawIndex) {
		    if (rawIndex >= getTailOffset(list._capacity)) {
		      return list._tail;
		    }
		    if (rawIndex < 1 << (list._level + SHIFT)) {
		      var node = list._root;
		      var level = list._level;
		      while (node && level > 0) {
		        node = node.array[(rawIndex >>> level) & MASK];
		        level -= SHIFT;
		      }
		      return node;
		    }
		  }
	
		  function setListBounds(list, begin, end) {
		    // Sanitize begin & end using this shorthand for ToInt32(argument)
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
		    if (begin !== undefined) {
		      begin = begin | 0;
		    }
		    if (end !== undefined) {
		      end = end | 0;
		    }
		    var owner = list.__ownerID || new OwnerID();
		    var oldOrigin = list._origin;
		    var oldCapacity = list._capacity;
		    var newOrigin = oldOrigin + begin;
		    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
		    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
		      return list;
		    }
	
		    // If it's going to end after it starts, it's empty.
		    if (newOrigin >= newCapacity) {
		      return list.clear();
		    }
	
		    var newLevel = list._level;
		    var newRoot = list._root;
	
		    // New origin might need creating a higher root.
		    var offsetShift = 0;
		    while (newOrigin + offsetShift < 0) {
		      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
		      newLevel += SHIFT;
		      offsetShift += 1 << newLevel;
		    }
		    if (offsetShift) {
		      newOrigin += offsetShift;
		      oldOrigin += offsetShift;
		      newCapacity += offsetShift;
		      oldCapacity += offsetShift;
		    }
	
		    var oldTailOffset = getTailOffset(oldCapacity);
		    var newTailOffset = getTailOffset(newCapacity);
	
		    // New size might need creating a higher root.
		    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
		      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
		      newLevel += SHIFT;
		    }
	
		    // Locate or create the new tail.
		    var oldTail = list._tail;
		    var newTail = newTailOffset < oldTailOffset ?
		      listNodeFor(list, newCapacity - 1) :
		      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
		    // Merge Tail into tree.
		    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
		      newRoot = editableVNode(newRoot, owner);
		      var node = newRoot;
		      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
		        var idx = (oldTailOffset >>> level) & MASK;
		        node = node.array[idx] = editableVNode(node.array[idx], owner);
		      }
		      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
		    }
	
		    // If the size has been reduced, there's a chance the tail needs to be trimmed.
		    if (newCapacity < oldCapacity) {
		      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
		    }
	
		    // If the new origin is within the tail, then we do not need a root.
		    if (newOrigin >= newTailOffset) {
		      newOrigin -= newTailOffset;
		      newCapacity -= newTailOffset;
		      newLevel = SHIFT;
		      newRoot = null;
		      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
		    // Otherwise, if the root has been trimmed, garbage collect.
		    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
		      offsetShift = 0;
	
		      // Identify the new top root node of the subtree of the old root.
		      while (newRoot) {
		        var beginIndex = (newOrigin >>> newLevel) & MASK;
		        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
		          break;
		        }
		        if (beginIndex) {
		          offsetShift += (1 << newLevel) * beginIndex;
		        }
		        newLevel -= SHIFT;
		        newRoot = newRoot.array[beginIndex];
		      }
	
		      // Trim the new sides of the new root.
		      if (newRoot && newOrigin > oldOrigin) {
		        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
		      }
		      if (newRoot && newTailOffset < oldTailOffset) {
		        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
		      }
		      if (offsetShift) {
		        newOrigin -= offsetShift;
		        newCapacity -= offsetShift;
		      }
		    }
	
		    if (list.__ownerID) {
		      list.size = newCapacity - newOrigin;
		      list._origin = newOrigin;
		      list._capacity = newCapacity;
		      list._level = newLevel;
		      list._root = newRoot;
		      list._tail = newTail;
		      list.__hash = undefined;
		      list.__altered = true;
		      return list;
		    }
		    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
		  }
	
		  function mergeIntoListWith(list, merger, iterables) {
		    var iters = [];
		    var maxSize = 0;
		    for (var ii = 0; ii < iterables.length; ii++) {
		      var value = iterables[ii];
		      var iter = IndexedIterable(value);
		      if (iter.size > maxSize) {
		        maxSize = iter.size;
		      }
		      if (!isIterable(value)) {
		        iter = iter.map(function(v ) {return fromJS(v)});
		      }
		      iters.push(iter);
		    }
		    if (maxSize > list.size) {
		      list = list.setSize(maxSize);
		    }
		    return mergeIntoCollectionWith(list, merger, iters);
		  }
	
		  function getTailOffset(size) {
		    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
		  }
	
		  createClass(OrderedMap, Map);
	
		    // @pragma Construction
	
		    function OrderedMap(value) {
		      return value === null || value === undefined ? emptyOrderedMap() :
		        isOrderedMap(value) ? value :
		        emptyOrderedMap().withMutations(function(map ) {
		          var iter = KeyedIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v, k)  {return map.set(k, v)});
		        });
		    }
	
		    OrderedMap.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    OrderedMap.prototype.toString = function() {
		      return this.__toString('OrderedMap {', '}');
		    };
	
		    // @pragma Access
	
		    OrderedMap.prototype.get = function(k, notSetValue) {
		      var index = this._map.get(k);
		      return index !== undefined ? this._list.get(index)[1] : notSetValue;
		    };
	
		    // @pragma Modification
	
		    OrderedMap.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._map.clear();
		        this._list.clear();
		        return this;
		      }
		      return emptyOrderedMap();
		    };
	
		    OrderedMap.prototype.set = function(k, v) {
		      return updateOrderedMap(this, k, v);
		    };
	
		    OrderedMap.prototype.remove = function(k) {
		      return updateOrderedMap(this, k, NOT_SET);
		    };
	
		    OrderedMap.prototype.wasAltered = function() {
		      return this._map.wasAltered() || this._list.wasAltered();
		    };
	
		    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._list.__iterate(
		        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
		        reverse
		      );
		    };
	
		    OrderedMap.prototype.__iterator = function(type, reverse) {
		      return this._list.fromEntrySeq().__iterator(type, reverse);
		    };
	
		    OrderedMap.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map.__ensureOwner(ownerID);
		      var newList = this._list.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        this._list = newList;
		        return this;
		      }
		      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
		    };
	
	
		  function isOrderedMap(maybeOrderedMap) {
		    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
		  }
	
		  OrderedMap.isOrderedMap = isOrderedMap;
	
		  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
		  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
		  function makeOrderedMap(map, list, ownerID, hash) {
		    var omap = Object.create(OrderedMap.prototype);
		    omap.size = map ? map.size : 0;
		    omap._map = map;
		    omap._list = list;
		    omap.__ownerID = ownerID;
		    omap.__hash = hash;
		    return omap;
		  }
	
		  var EMPTY_ORDERED_MAP;
		  function emptyOrderedMap() {
		    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
		  }
	
		  function updateOrderedMap(omap, k, v) {
		    var map = omap._map;
		    var list = omap._list;
		    var i = map.get(k);
		    var has = i !== undefined;
		    var newMap;
		    var newList;
		    if (v === NOT_SET) { // removed
		      if (!has) {
		        return omap;
		      }
		      if (list.size >= SIZE && list.size >= map.size * 2) {
		        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
		        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
		        if (omap.__ownerID) {
		          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
		        }
		      } else {
		        newMap = map.remove(k);
		        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
		      }
		    } else {
		      if (has) {
		        if (v === list.get(i)[1]) {
		          return omap;
		        }
		        newMap = map;
		        newList = list.set(i, [k, v]);
		      } else {
		        newMap = map.set(k, list.size);
		        newList = list.set(list.size, [k, v]);
		      }
		    }
		    if (omap.__ownerID) {
		      omap.size = newMap.size;
		      omap._map = newMap;
		      omap._list = newList;
		      omap.__hash = undefined;
		      return omap;
		    }
		    return makeOrderedMap(newMap, newList);
		  }
	
		  createClass(ToKeyedSequence, KeyedSeq);
		    function ToKeyedSequence(indexed, useKeys) {
		      this._iter = indexed;
		      this._useKeys = useKeys;
		      this.size = indexed.size;
		    }
	
		    ToKeyedSequence.prototype.get = function(key, notSetValue) {
		      return this._iter.get(key, notSetValue);
		    };
	
		    ToKeyedSequence.prototype.has = function(key) {
		      return this._iter.has(key);
		    };
	
		    ToKeyedSequence.prototype.valueSeq = function() {
		      return this._iter.valueSeq();
		    };
	
		    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
		      var reversedSequence = reverseFactory(this, true);
		      if (!this._useKeys) {
		        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
		      }
		      return reversedSequence;
		    };
	
		    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
		      var mappedSequence = mapFactory(this, mapper, context);
		      if (!this._useKeys) {
		        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
		      }
		      return mappedSequence;
		    };
	
		    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var ii;
		      return this._iter.__iterate(
		        this._useKeys ?
		          function(v, k)  {return fn(v, k, this$0)} :
		          ((ii = reverse ? resolveSize(this) : 0),
		            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
		        reverse
		      );
		    };
	
		    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
		      if (this._useKeys) {
		        return this._iter.__iterator(type, reverse);
		      }
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      var ii = reverse ? resolveSize(this) : 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
		      });
		    };
	
		  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
		  createClass(ToIndexedSequence, IndexedSeq);
		    function ToIndexedSequence(iter) {
		      this._iter = iter;
		      this.size = iter.size;
		    }
	
		    ToIndexedSequence.prototype.includes = function(value) {
		      return this._iter.includes(value);
		    };
	
		    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
		    };
	
		    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, iterations++, step.value, step)
		      });
		    };
	
	
	
		  createClass(ToSetSequence, SetSeq);
		    function ToSetSequence(iter) {
		      this._iter = iter;
		      this.size = iter.size;
		    }
	
		    ToSetSequence.prototype.has = function(key) {
		      return this._iter.includes(key);
		    };
	
		    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
		    };
	
		    ToSetSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, step.value, step.value, step);
		      });
		    };
	
	
	
		  createClass(FromEntriesSequence, KeyedSeq);
		    function FromEntriesSequence(entries) {
		      this._iter = entries;
		      this.size = entries.size;
		    }
	
		    FromEntriesSequence.prototype.entrySeq = function() {
		      return this._iter.toSeq();
		    };
	
		    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._iter.__iterate(function(entry ) {
		        // Check if entry exists first so array access doesn't throw for holes
		        // in the parent iteration.
		        if (entry) {
		          validateEntry(entry);
		          var indexedIterable = isIterable(entry);
		          return fn(
		            indexedIterable ? entry.get(1) : entry[1],
		            indexedIterable ? entry.get(0) : entry[0],
		            this$0
		          );
		        }
		      }, reverse);
		    };
	
		    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      return new Iterator(function()  {
		        while (true) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          var entry = step.value;
		          // Check if entry exists first so array access doesn't throw for holes
		          // in the parent iteration.
		          if (entry) {
		            validateEntry(entry);
		            var indexedIterable = isIterable(entry);
		            return iteratorValue(
		              type,
		              indexedIterable ? entry.get(0) : entry[0],
		              indexedIterable ? entry.get(1) : entry[1],
		              step
		            );
		          }
		        }
		      });
		    };
	
	
		  ToIndexedSequence.prototype.cacheResult =
		  ToKeyedSequence.prototype.cacheResult =
		  ToSetSequence.prototype.cacheResult =
		  FromEntriesSequence.prototype.cacheResult =
		    cacheResultThrough;
	
	
		  function flipFactory(iterable) {
		    var flipSequence = makeSequence(iterable);
		    flipSequence._iter = iterable;
		    flipSequence.size = iterable.size;
		    flipSequence.flip = function()  {return iterable};
		    flipSequence.reverse = function () {
		      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
		      reversedSequence.flip = function()  {return iterable.reverse()};
		      return reversedSequence;
		    };
		    flipSequence.has = function(key ) {return iterable.includes(key)};
		    flipSequence.includes = function(key ) {return iterable.has(key)};
		    flipSequence.cacheResult = cacheResultThrough;
		    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
		    }
		    flipSequence.__iteratorUncached = function(type, reverse) {
		      if (type === ITERATE_ENTRIES) {
		        var iterator = iterable.__iterator(type, reverse);
		        return new Iterator(function()  {
		          var step = iterator.next();
		          if (!step.done) {
		            var k = step.value[0];
		            step.value[0] = step.value[1];
		            step.value[1] = k;
		          }
		          return step;
		        });
		      }
		      return iterable.__iterator(
		        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
		        reverse
		      );
		    }
		    return flipSequence;
		  }
	
	
		  function mapFactory(iterable, mapper, context) {
		    var mappedSequence = makeSequence(iterable);
		    mappedSequence.size = iterable.size;
		    mappedSequence.has = function(key ) {return iterable.has(key)};
		    mappedSequence.get = function(key, notSetValue)  {
		      var v = iterable.get(key, NOT_SET);
		      return v === NOT_SET ?
		        notSetValue :
		        mapper.call(context, v, key, iterable);
		    };
		    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(
		        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
		        reverse
		      );
		    }
		    mappedSequence.__iteratorUncached = function (type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      return new Iterator(function()  {
		        var step = iterator.next();
		        if (step.done) {
		          return step;
		        }
		        var entry = step.value;
		        var key = entry[0];
		        return iteratorValue(
		          type,
		          key,
		          mapper.call(context, entry[1], key, iterable),
		          step
		        );
		      });
		    }
		    return mappedSequence;
		  }
	
	
		  function reverseFactory(iterable, useKeys) {
		    var reversedSequence = makeSequence(iterable);
		    reversedSequence._iter = iterable;
		    reversedSequence.size = iterable.size;
		    reversedSequence.reverse = function()  {return iterable};
		    if (iterable.flip) {
		      reversedSequence.flip = function () {
		        var flipSequence = flipFactory(iterable);
		        flipSequence.reverse = function()  {return iterable.flip()};
		        return flipSequence;
		      };
		    }
		    reversedSequence.get = function(key, notSetValue) 
		      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
		    reversedSequence.has = function(key )
		      {return iterable.has(useKeys ? key : -1 - key)};
		    reversedSequence.includes = function(value ) {return iterable.includes(value)};
		    reversedSequence.cacheResult = cacheResultThrough;
		    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
		    };
		    reversedSequence.__iterator =
		      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
		    return reversedSequence;
		  }
	
	
		  function filterFactory(iterable, predicate, context, useKeys) {
		    var filterSequence = makeSequence(iterable);
		    if (useKeys) {
		      filterSequence.has = function(key ) {
		        var v = iterable.get(key, NOT_SET);
		        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
		      };
		      filterSequence.get = function(key, notSetValue)  {
		        var v = iterable.get(key, NOT_SET);
		        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
		          v : notSetValue;
		      };
		    }
		    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c)  {
		        if (predicate.call(context, v, k, c)) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0);
		        }
		      }, reverse);
		      return iterations;
		    };
		    filterSequence.__iteratorUncached = function (type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (true) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          var entry = step.value;
		          var key = entry[0];
		          var value = entry[1];
		          if (predicate.call(context, value, key, iterable)) {
		            return iteratorValue(type, useKeys ? key : iterations++, value, step);
		          }
		        }
		      });
		    }
		    return filterSequence;
		  }
	
	
		  function countByFactory(iterable, grouper, context) {
		    var groups = Map().asMutable();
		    iterable.__iterate(function(v, k)  {
		      groups.update(
		        grouper.call(context, v, k, iterable),
		        0,
		        function(a ) {return a + 1}
		      );
		    });
		    return groups.asImmutable();
		  }
	
	
		  function groupByFactory(iterable, grouper, context) {
		    var isKeyedIter = isKeyed(iterable);
		    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
		    iterable.__iterate(function(v, k)  {
		      groups.update(
		        grouper.call(context, v, k, iterable),
		        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
		      );
		    });
		    var coerce = iterableClass(iterable);
		    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
		  }
	
	
		  function sliceFactory(iterable, begin, end, useKeys) {
		    var originalSize = iterable.size;
	
		    // Sanitize begin & end using this shorthand for ToInt32(argument)
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
		    if (begin !== undefined) {
		      begin = begin | 0;
		    }
		    if (end !== undefined) {
		      if (end === Infinity) {
		        end = originalSize;
		      } else {
		        end = end | 0;
		      }
		    }
	
		    if (wholeSlice(begin, end, originalSize)) {
		      return iterable;
		    }
	
		    var resolvedBegin = resolveBegin(begin, originalSize);
		    var resolvedEnd = resolveEnd(end, originalSize);
	
		    // begin or end will be NaN if they were provided as negative numbers and
		    // this iterable's size is unknown. In that case, cache first so there is
		    // a known size and these do not resolve to NaN.
		    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
		      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
		    }
	
		    // Note: resolvedEnd is undefined when the original sequence's length is
		    // unknown and this slice did not supply an end and should contain all
		    // elements after resolvedBegin.
		    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
		    var resolvedSize = resolvedEnd - resolvedBegin;
		    var sliceSize;
		    if (resolvedSize === resolvedSize) {
		      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
		    }
	
		    var sliceSeq = makeSequence(iterable);
	
		    // If iterable.size is undefined, the size of the realized sliceSeq is
		    // unknown at this point unless the number of items to slice is 0
		    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
		    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
		      sliceSeq.get = function (index, notSetValue) {
		        index = wrapIndex(this, index);
		        return index >= 0 && index < sliceSize ?
		          iterable.get(index + resolvedBegin, notSetValue) :
		          notSetValue;
		      }
		    }
	
		    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      if (sliceSize === 0) {
		        return 0;
		      }
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var skipped = 0;
		      var isSkipping = true;
		      var iterations = 0;
		      iterable.__iterate(function(v, k)  {
		        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
		                 iterations !== sliceSize;
		        }
		      });
		      return iterations;
		    };
	
		    sliceSeq.__iteratorUncached = function(type, reverse) {
		      if (sliceSize !== 0 && reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      // Don't bother instantiating parent iterator if taking 0.
		      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
		      var skipped = 0;
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (skipped++ < resolvedBegin) {
		          iterator.next();
		        }
		        if (++iterations > sliceSize) {
		          return iteratorDone();
		        }
		        var step = iterator.next();
		        if (useKeys || type === ITERATE_VALUES) {
		          return step;
		        } else if (type === ITERATE_KEYS) {
		          return iteratorValue(type, iterations - 1, undefined, step);
		        } else {
		          return iteratorValue(type, iterations - 1, step.value[1], step);
		        }
		      });
		    }
	
		    return sliceSeq;
		  }
	
	
		  function takeWhileFactory(iterable, predicate, context) {
		    var takeSequence = makeSequence(iterable);
		    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c) 
		        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
		      );
		      return iterations;
		    };
		    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var iterating = true;
		      return new Iterator(function()  {
		        if (!iterating) {
		          return iteratorDone();
		        }
		        var step = iterator.next();
		        if (step.done) {
		          return step;
		        }
		        var entry = step.value;
		        var k = entry[0];
		        var v = entry[1];
		        if (!predicate.call(context, v, k, this$0)) {
		          iterating = false;
		          return iteratorDone();
		        }
		        return type === ITERATE_ENTRIES ? step :
		          iteratorValue(type, k, v, step);
		      });
		    };
		    return takeSequence;
		  }
	
	
		  function skipWhileFactory(iterable, predicate, context, useKeys) {
		    var skipSequence = makeSequence(iterable);
		    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var isSkipping = true;
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c)  {
		        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0);
		        }
		      });
		      return iterations;
		    };
		    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var skipping = true;
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step, k, v;
		        do {
		          step = iterator.next();
		          if (step.done) {
		            if (useKeys || type === ITERATE_VALUES) {
		              return step;
		            } else if (type === ITERATE_KEYS) {
		              return iteratorValue(type, iterations++, undefined, step);
		            } else {
		              return iteratorValue(type, iterations++, step.value[1], step);
		            }
		          }
		          var entry = step.value;
		          k = entry[0];
		          v = entry[1];
		          skipping && (skipping = predicate.call(context, v, k, this$0));
		        } while (skipping);
		        return type === ITERATE_ENTRIES ? step :
		          iteratorValue(type, k, v, step);
		      });
		    };
		    return skipSequence;
		  }
	
	
		  function concatFactory(iterable, values) {
		    var isKeyedIterable = isKeyed(iterable);
		    var iters = [iterable].concat(values).map(function(v ) {
		      if (!isIterable(v)) {
		        v = isKeyedIterable ?
		          keyedSeqFromValue(v) :
		          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
		      } else if (isKeyedIterable) {
		        v = KeyedIterable(v);
		      }
		      return v;
		    }).filter(function(v ) {return v.size !== 0});
	
		    if (iters.length === 0) {
		      return iterable;
		    }
	
		    if (iters.length === 1) {
		      var singleton = iters[0];
		      if (singleton === iterable ||
		          isKeyedIterable && isKeyed(singleton) ||
		          isIndexed(iterable) && isIndexed(singleton)) {
		        return singleton;
		      }
		    }
	
		    var concatSeq = new ArraySeq(iters);
		    if (isKeyedIterable) {
		      concatSeq = concatSeq.toKeyedSeq();
		    } else if (!isIndexed(iterable)) {
		      concatSeq = concatSeq.toSetSeq();
		    }
		    concatSeq = concatSeq.flatten(true);
		    concatSeq.size = iters.reduce(
		      function(sum, seq)  {
		        if (sum !== undefined) {
		          var size = seq.size;
		          if (size !== undefined) {
		            return sum + size;
		          }
		        }
		      },
		      0
		    );
		    return concatSeq;
		  }
	
	
		  function flattenFactory(iterable, depth, useKeys) {
		    var flatSequence = makeSequence(iterable);
		    flatSequence.__iterateUncached = function(fn, reverse) {
		      var iterations = 0;
		      var stopped = false;
		      function flatDeep(iter, currentDepth) {var this$0 = this;
		        iter.__iterate(function(v, k)  {
		          if ((!depth || currentDepth < depth) && isIterable(v)) {
		            flatDeep(v, currentDepth + 1);
		          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
		            stopped = true;
		          }
		          return !stopped;
		        }, reverse);
		      }
		      flatDeep(iterable, 0);
		      return iterations;
		    }
		    flatSequence.__iteratorUncached = function(type, reverse) {
		      var iterator = iterable.__iterator(type, reverse);
		      var stack = [];
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (iterator) {
		          var step = iterator.next();
		          if (step.done !== false) {
		            iterator = stack.pop();
		            continue;
		          }
		          var v = step.value;
		          if (type === ITERATE_ENTRIES) {
		            v = v[1];
		          }
		          if ((!depth || stack.length < depth) && isIterable(v)) {
		            stack.push(iterator);
		            iterator = v.__iterator(type, reverse);
		          } else {
		            return useKeys ? step : iteratorValue(type, iterations++, v, step);
		          }
		        }
		        return iteratorDone();
		      });
		    }
		    return flatSequence;
		  }
	
	
		  function flatMapFactory(iterable, mapper, context) {
		    var coerce = iterableClass(iterable);
		    return iterable.toSeq().map(
		      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
		    ).flatten(true);
		  }
	
	
		  function interposeFactory(iterable, separator) {
		    var interposedSequence = makeSequence(iterable);
		    interposedSequence.size = iterable.size && iterable.size * 2 -1;
		    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      iterable.__iterate(function(v, k) 
		        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
		        fn(v, iterations++, this$0) !== false},
		        reverse
		      );
		      return iterations;
		    };
		    interposedSequence.__iteratorUncached = function(type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
		      var iterations = 0;
		      var step;
		      return new Iterator(function()  {
		        if (!step || iterations % 2) {
		          step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		        }
		        return iterations % 2 ?
		          iteratorValue(type, iterations++, separator) :
		          iteratorValue(type, iterations++, step.value, step);
		      });
		    };
		    return interposedSequence;
		  }
	
	
		  function sortFactory(iterable, comparator, mapper) {
		    if (!comparator) {
		      comparator = defaultComparator;
		    }
		    var isKeyedIterable = isKeyed(iterable);
		    var index = 0;
		    var entries = iterable.toSeq().map(
		      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
		    ).toArray();
		    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
		      isKeyedIterable ?
		      function(v, i)  { entries[i].length = 2; } :
		      function(v, i)  { entries[i] = v[1]; }
		    );
		    return isKeyedIterable ? KeyedSeq(entries) :
		      isIndexed(iterable) ? IndexedSeq(entries) :
		      SetSeq(entries);
		  }
	
	
		  function maxFactory(iterable, comparator, mapper) {
		    if (!comparator) {
		      comparator = defaultComparator;
		    }
		    if (mapper) {
		      var entry = iterable.toSeq()
		        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
		        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
		      return entry && entry[0];
		    } else {
		      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
		    }
		  }
	
		  function maxCompare(comparator, a, b) {
		    var comp = comparator(b, a);
		    // b is considered the new max if the comparator declares them equal, but
		    // they are not equal and b is in fact a nullish value.
		    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
		  }
	
	
		  function zipWithFactory(keyIter, zipper, iters) {
		    var zipSequence = makeSequence(keyIter);
		    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
		    // Note: this a generic base implementation of __iterate in terms of
		    // __iterator which may be more generically useful in the future.
		    zipSequence.__iterate = function(fn, reverse) {
		      /* generic:
		      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
		      var step;
		      var iterations = 0;
		      while (!(step = iterator.next()).done) {
		        iterations++;
		        if (fn(step.value[1], step.value[0], this) === false) {
		          break;
		        }
		      }
		      return iterations;
		      */
		      // indexed:
		      var iterator = this.__iterator(ITERATE_VALUES, reverse);
		      var step;
		      var iterations = 0;
		      while (!(step = iterator.next()).done) {
		        if (fn(step.value, iterations++, this) === false) {
		          break;
		        }
		      }
		      return iterations;
		    };
		    zipSequence.__iteratorUncached = function(type, reverse) {
		      var iterators = iters.map(function(i )
		        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
		      );
		      var iterations = 0;
		      var isDone = false;
		      return new Iterator(function()  {
		        var steps;
		        if (!isDone) {
		          steps = iterators.map(function(i ) {return i.next()});
		          isDone = steps.some(function(s ) {return s.done});
		        }
		        if (isDone) {
		          return iteratorDone();
		        }
		        return iteratorValue(
		          type,
		          iterations++,
		          zipper.apply(null, steps.map(function(s ) {return s.value}))
		        );
		      });
		    };
		    return zipSequence
		  }
	
	
		  // #pragma Helper Functions
	
		  function reify(iter, seq) {
		    return isSeq(iter) ? seq : iter.constructor(seq);
		  }
	
		  function validateEntry(entry) {
		    if (entry !== Object(entry)) {
		      throw new TypeError('Expected [K, V] tuple: ' + entry);
		    }
		  }
	
		  function resolveSize(iter) {
		    assertNotInfinite(iter.size);
		    return ensureSize(iter);
		  }
	
		  function iterableClass(iterable) {
		    return isKeyed(iterable) ? KeyedIterable :
		      isIndexed(iterable) ? IndexedIterable :
		      SetIterable;
		  }
	
		  function makeSequence(iterable) {
		    return Object.create(
		      (
		        isKeyed(iterable) ? KeyedSeq :
		        isIndexed(iterable) ? IndexedSeq :
		        SetSeq
		      ).prototype
		    );
		  }
	
		  function cacheResultThrough() {
		    if (this._iter.cacheResult) {
		      this._iter.cacheResult();
		      this.size = this._iter.size;
		      return this;
		    } else {
		      return Seq.prototype.cacheResult.call(this);
		    }
		  }
	
		  function defaultComparator(a, b) {
		    return a > b ? 1 : a < b ? -1 : 0;
		  }
	
		  function forceIterator(keyPath) {
		    var iter = getIterator(keyPath);
		    if (!iter) {
		      // Array might not be iterable in this environment, so we need a fallback
		      // to our wrapped type.
		      if (!isArrayLike(keyPath)) {
		        throw new TypeError('Expected iterable or array-like: ' + keyPath);
		      }
		      iter = getIterator(Iterable(keyPath));
		    }
		    return iter;
		  }
	
		  createClass(Record, KeyedCollection);
	
		    function Record(defaultValues, name) {
		      var hasInitialized;
	
		      var RecordType = function Record(values) {
		        if (values instanceof RecordType) {
		          return values;
		        }
		        if (!(this instanceof RecordType)) {
		          return new RecordType(values);
		        }
		        if (!hasInitialized) {
		          hasInitialized = true;
		          var keys = Object.keys(defaultValues);
		          setProps(RecordTypePrototype, keys);
		          RecordTypePrototype.size = keys.length;
		          RecordTypePrototype._name = name;
		          RecordTypePrototype._keys = keys;
		          RecordTypePrototype._defaultValues = defaultValues;
		        }
		        this._map = Map(values);
		      };
	
		      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
		      RecordTypePrototype.constructor = RecordType;
	
		      return RecordType;
		    }
	
		    Record.prototype.toString = function() {
		      return this.__toString(recordName(this) + ' {', '}');
		    };
	
		    // @pragma Access
	
		    Record.prototype.has = function(k) {
		      return this._defaultValues.hasOwnProperty(k);
		    };
	
		    Record.prototype.get = function(k, notSetValue) {
		      if (!this.has(k)) {
		        return notSetValue;
		      }
		      var defaultVal = this._defaultValues[k];
		      return this._map ? this._map.get(k, defaultVal) : defaultVal;
		    };
	
		    // @pragma Modification
	
		    Record.prototype.clear = function() {
		      if (this.__ownerID) {
		        this._map && this._map.clear();
		        return this;
		      }
		      var RecordType = this.constructor;
		      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
		    };
	
		    Record.prototype.set = function(k, v) {
		      if (!this.has(k)) {
		        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
		      }
		      if (this._map && !this._map.has(k)) {
		        var defaultVal = this._defaultValues[k];
		        if (v === defaultVal) {
		          return this;
		        }
		      }
		      var newMap = this._map && this._map.set(k, v);
		      if (this.__ownerID || newMap === this._map) {
		        return this;
		      }
		      return makeRecord(this, newMap);
		    };
	
		    Record.prototype.remove = function(k) {
		      if (!this.has(k)) {
		        return this;
		      }
		      var newMap = this._map && this._map.remove(k);
		      if (this.__ownerID || newMap === this._map) {
		        return this;
		      }
		      return makeRecord(this, newMap);
		    };
	
		    Record.prototype.wasAltered = function() {
		      return this._map.wasAltered();
		    };
	
		    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
		      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
		    };
	
		    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
		    };
	
		    Record.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map && this._map.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        return this;
		      }
		      return makeRecord(this, newMap, ownerID);
		    };
	
	
		  var RecordPrototype = Record.prototype;
		  RecordPrototype[DELETE] = RecordPrototype.remove;
		  RecordPrototype.deleteIn =
		  RecordPrototype.removeIn = MapPrototype.removeIn;
		  RecordPrototype.merge = MapPrototype.merge;
		  RecordPrototype.mergeWith = MapPrototype.mergeWith;
		  RecordPrototype.mergeIn = MapPrototype.mergeIn;
		  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
		  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
		  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
		  RecordPrototype.setIn = MapPrototype.setIn;
		  RecordPrototype.update = MapPrototype.update;
		  RecordPrototype.updateIn = MapPrototype.updateIn;
		  RecordPrototype.withMutations = MapPrototype.withMutations;
		  RecordPrototype.asMutable = MapPrototype.asMutable;
		  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
		  function makeRecord(likeRecord, map, ownerID) {
		    var record = Object.create(Object.getPrototypeOf(likeRecord));
		    record._map = map;
		    record.__ownerID = ownerID;
		    return record;
		  }
	
		  function recordName(record) {
		    return record._name || record.constructor.name || 'Record';
		  }
	
		  function setProps(prototype, names) {
		    try {
		      names.forEach(setProp.bind(undefined, prototype));
		    } catch (error) {
		      // Object.defineProperty failed. Probably IE8.
		    }
		  }
	
		  function setProp(prototype, name) {
		    Object.defineProperty(prototype, name, {
		      get: function() {
		        return this.get(name);
		      },
		      set: function(value) {
		        invariant(this.__ownerID, 'Cannot set on an immutable record.');
		        this.set(name, value);
		      }
		    });
		  }
	
		  createClass(Set, SetCollection);
	
		    // @pragma Construction
	
		    function Set(value) {
		      return value === null || value === undefined ? emptySet() :
		        isSet(value) && !isOrdered(value) ? value :
		        emptySet().withMutations(function(set ) {
		          var iter = SetIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v ) {return set.add(v)});
		        });
		    }
	
		    Set.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    Set.fromKeys = function(value) {
		      return this(KeyedIterable(value).keySeq());
		    };
	
		    Set.prototype.toString = function() {
		      return this.__toString('Set {', '}');
		    };
	
		    // @pragma Access
	
		    Set.prototype.has = function(value) {
		      return this._map.has(value);
		    };
	
		    // @pragma Modification
	
		    Set.prototype.add = function(value) {
		      return updateSet(this, this._map.set(value, true));
		    };
	
		    Set.prototype.remove = function(value) {
		      return updateSet(this, this._map.remove(value));
		    };
	
		    Set.prototype.clear = function() {
		      return updateSet(this, this._map.clear());
		    };
	
		    // @pragma Composition
	
		    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
		      iters = iters.filter(function(x ) {return x.size !== 0});
		      if (iters.length === 0) {
		        return this;
		      }
		      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
		        return this.constructor(iters[0]);
		      }
		      return this.withMutations(function(set ) {
		        for (var ii = 0; ii < iters.length; ii++) {
		          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
		        }
		      });
		    };
	
		    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
		      if (iters.length === 0) {
		        return this;
		      }
		      iters = iters.map(function(iter ) {return SetIterable(iter)});
		      var originalSet = this;
		      return this.withMutations(function(set ) {
		        originalSet.forEach(function(value ) {
		          if (!iters.every(function(iter ) {return iter.includes(value)})) {
		            set.remove(value);
		          }
		        });
		      });
		    };
	
		    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
		      if (iters.length === 0) {
		        return this;
		      }
		      iters = iters.map(function(iter ) {return SetIterable(iter)});
		      var originalSet = this;
		      return this.withMutations(function(set ) {
		        originalSet.forEach(function(value ) {
		          if (iters.some(function(iter ) {return iter.includes(value)})) {
		            set.remove(value);
		          }
		        });
		      });
		    };
	
		    Set.prototype.merge = function() {
		      return this.union.apply(this, arguments);
		    };
	
		    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return this.union.apply(this, iters);
		    };
	
		    Set.prototype.sort = function(comparator) {
		      // Late binding
		      return OrderedSet(sortFactory(this, comparator));
		    };
	
		    Set.prototype.sortBy = function(mapper, comparator) {
		      // Late binding
		      return OrderedSet(sortFactory(this, comparator, mapper));
		    };
	
		    Set.prototype.wasAltered = function() {
		      return this._map.wasAltered();
		    };
	
		    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
		    };
	
		    Set.prototype.__iterator = function(type, reverse) {
		      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
		    };
	
		    Set.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        return this;
		      }
		      return this.__make(newMap, ownerID);
		    };
	
	
		  function isSet(maybeSet) {
		    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
		  }
	
		  Set.isSet = isSet;
	
		  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
		  var SetPrototype = Set.prototype;
		  SetPrototype[IS_SET_SENTINEL] = true;
		  SetPrototype[DELETE] = SetPrototype.remove;
		  SetPrototype.mergeDeep = SetPrototype.merge;
		  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
		  SetPrototype.withMutations = MapPrototype.withMutations;
		  SetPrototype.asMutable = MapPrototype.asMutable;
		  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
		  SetPrototype.__empty = emptySet;
		  SetPrototype.__make = makeSet;
	
		  function updateSet(set, newMap) {
		    if (set.__ownerID) {
		      set.size = newMap.size;
		      set._map = newMap;
		      return set;
		    }
		    return newMap === set._map ? set :
		      newMap.size === 0 ? set.__empty() :
		      set.__make(newMap);
		  }
	
		  function makeSet(map, ownerID) {
		    var set = Object.create(SetPrototype);
		    set.size = map ? map.size : 0;
		    set._map = map;
		    set.__ownerID = ownerID;
		    return set;
		  }
	
		  var EMPTY_SET;
		  function emptySet() {
		    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
		  }
	
		  createClass(OrderedSet, Set);
	
		    // @pragma Construction
	
		    function OrderedSet(value) {
		      return value === null || value === undefined ? emptyOrderedSet() :
		        isOrderedSet(value) ? value :
		        emptyOrderedSet().withMutations(function(set ) {
		          var iter = SetIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v ) {return set.add(v)});
		        });
		    }
	
		    OrderedSet.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    OrderedSet.fromKeys = function(value) {
		      return this(KeyedIterable(value).keySeq());
		    };
	
		    OrderedSet.prototype.toString = function() {
		      return this.__toString('OrderedSet {', '}');
		    };
	
	
		  function isOrderedSet(maybeOrderedSet) {
		    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
		  }
	
		  OrderedSet.isOrderedSet = isOrderedSet;
	
		  var OrderedSetPrototype = OrderedSet.prototype;
		  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
		  OrderedSetPrototype.__empty = emptyOrderedSet;
		  OrderedSetPrototype.__make = makeOrderedSet;
	
		  function makeOrderedSet(map, ownerID) {
		    var set = Object.create(OrderedSetPrototype);
		    set.size = map ? map.size : 0;
		    set._map = map;
		    set.__ownerID = ownerID;
		    return set;
		  }
	
		  var EMPTY_ORDERED_SET;
		  function emptyOrderedSet() {
		    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
		  }
	
		  createClass(Stack, IndexedCollection);
	
		    // @pragma Construction
	
		    function Stack(value) {
		      return value === null || value === undefined ? emptyStack() :
		        isStack(value) ? value :
		        emptyStack().unshiftAll(value);
		    }
	
		    Stack.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    Stack.prototype.toString = function() {
		      return this.__toString('Stack [', ']');
		    };
	
		    // @pragma Access
	
		    Stack.prototype.get = function(index, notSetValue) {
		      var head = this._head;
		      index = wrapIndex(this, index);
		      while (head && index--) {
		        head = head.next;
		      }
		      return head ? head.value : notSetValue;
		    };
	
		    Stack.prototype.peek = function() {
		      return this._head && this._head.value;
		    };
	
		    // @pragma Modification
	
		    Stack.prototype.push = function(/*...values*/) {
		      if (arguments.length === 0) {
		        return this;
		      }
		      var newSize = this.size + arguments.length;
		      var head = this._head;
		      for (var ii = arguments.length - 1; ii >= 0; ii--) {
		        head = {
		          value: arguments[ii],
		          next: head
		        };
		      }
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    Stack.prototype.pushAll = function(iter) {
		      iter = IndexedIterable(iter);
		      if (iter.size === 0) {
		        return this;
		      }
		      assertNotInfinite(iter.size);
		      var newSize = this.size;
		      var head = this._head;
		      iter.reverse().forEach(function(value ) {
		        newSize++;
		        head = {
		          value: value,
		          next: head
		        };
		      });
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    Stack.prototype.pop = function() {
		      return this.slice(1);
		    };
	
		    Stack.prototype.unshift = function(/*...values*/) {
		      return this.push.apply(this, arguments);
		    };
	
		    Stack.prototype.unshiftAll = function(iter) {
		      return this.pushAll(iter);
		    };
	
		    Stack.prototype.shift = function() {
		      return this.pop.apply(this, arguments);
		    };
	
		    Stack.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._head = undefined;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyStack();
		    };
	
		    Stack.prototype.slice = function(begin, end) {
		      if (wholeSlice(begin, end, this.size)) {
		        return this;
		      }
		      var resolvedBegin = resolveBegin(begin, this.size);
		      var resolvedEnd = resolveEnd(end, this.size);
		      if (resolvedEnd !== this.size) {
		        // super.slice(begin, end);
		        return IndexedCollection.prototype.slice.call(this, begin, end);
		      }
		      var newSize = this.size - resolvedBegin;
		      var head = this._head;
		      while (resolvedBegin--) {
		        head = head.next;
		      }
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    // @pragma Mutability
	
		    Stack.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this.__altered = false;
		        return this;
		      }
		      return makeStack(this.size, this._head, ownerID, this.__hash);
		    };
	
		    // @pragma Iteration
	
		    Stack.prototype.__iterate = function(fn, reverse) {
		      if (reverse) {
		        return this.reverse().__iterate(fn);
		      }
		      var iterations = 0;
		      var node = this._head;
		      while (node) {
		        if (fn(node.value, iterations++, this) === false) {
		          break;
		        }
		        node = node.next;
		      }
		      return iterations;
		    };
	
		    Stack.prototype.__iterator = function(type, reverse) {
		      if (reverse) {
		        return this.reverse().__iterator(type);
		      }
		      var iterations = 0;
		      var node = this._head;
		      return new Iterator(function()  {
		        if (node) {
		          var value = node.value;
		          node = node.next;
		          return iteratorValue(type, iterations++, value);
		        }
		        return iteratorDone();
		      });
		    };
	
	
		  function isStack(maybeStack) {
		    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
		  }
	
		  Stack.isStack = isStack;
	
		  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
		  var StackPrototype = Stack.prototype;
		  StackPrototype[IS_STACK_SENTINEL] = true;
		  StackPrototype.withMutations = MapPrototype.withMutations;
		  StackPrototype.asMutable = MapPrototype.asMutable;
		  StackPrototype.asImmutable = MapPrototype.asImmutable;
		  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
		  function makeStack(size, head, ownerID, hash) {
		    var map = Object.create(StackPrototype);
		    map.size = size;
		    map._head = head;
		    map.__ownerID = ownerID;
		    map.__hash = hash;
		    map.__altered = false;
		    return map;
		  }
	
		  var EMPTY_STACK;
		  function emptyStack() {
		    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
		  }
	
		  /**
		   * Contributes additional methods to a constructor
		   */
		  function mixin(ctor, methods) {
		    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
		    Object.keys(methods).forEach(keyCopier);
		    Object.getOwnPropertySymbols &&
		      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
		    return ctor;
		  }
	
		  Iterable.Iterator = Iterator;
	
		  mixin(Iterable, {
	
		    // ### Conversion to other types
	
		    toArray: function() {
		      assertNotInfinite(this.size);
		      var array = new Array(this.size || 0);
		      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
		      return array;
		    },
	
		    toIndexedSeq: function() {
		      return new ToIndexedSequence(this);
		    },
	
		    toJS: function() {
		      return this.toSeq().map(
		        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
		      ).__toJS();
		    },
	
		    toJSON: function() {
		      return this.toSeq().map(
		        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
		      ).__toJS();
		    },
	
		    toKeyedSeq: function() {
		      return new ToKeyedSequence(this, true);
		    },
	
		    toMap: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Map(this.toKeyedSeq());
		    },
	
		    toObject: function() {
		      assertNotInfinite(this.size);
		      var object = {};
		      this.__iterate(function(v, k)  { object[k] = v; });
		      return object;
		    },
	
		    toOrderedMap: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return OrderedMap(this.toKeyedSeq());
		    },
	
		    toOrderedSet: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toSet: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Set(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toSetSeq: function() {
		      return new ToSetSequence(this);
		    },
	
		    toSeq: function() {
		      return isIndexed(this) ? this.toIndexedSeq() :
		        isKeyed(this) ? this.toKeyedSeq() :
		        this.toSetSeq();
		    },
	
		    toStack: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Stack(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toList: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return List(isKeyed(this) ? this.valueSeq() : this);
		    },
	
	
		    // ### Common JavaScript methods and properties
	
		    toString: function() {
		      return '[Iterable]';
		    },
	
		    __toString: function(head, tail) {
		      if (this.size === 0) {
		        return head + tail;
		      }
		      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
		    },
	
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    concat: function() {var values = SLICE$0.call(arguments, 0);
		      return reify(this, concatFactory(this, values));
		    },
	
		    includes: function(searchValue) {
		      return this.some(function(value ) {return is(value, searchValue)});
		    },
	
		    entries: function() {
		      return this.__iterator(ITERATE_ENTRIES);
		    },
	
		    every: function(predicate, context) {
		      assertNotInfinite(this.size);
		      var returnValue = true;
		      this.__iterate(function(v, k, c)  {
		        if (!predicate.call(context, v, k, c)) {
		          returnValue = false;
		          return false;
		        }
		      });
		      return returnValue;
		    },
	
		    filter: function(predicate, context) {
		      return reify(this, filterFactory(this, predicate, context, true));
		    },
	
		    find: function(predicate, context, notSetValue) {
		      var entry = this.findEntry(predicate, context);
		      return entry ? entry[1] : notSetValue;
		    },
	
		    forEach: function(sideEffect, context) {
		      assertNotInfinite(this.size);
		      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
		    },
	
		    join: function(separator) {
		      assertNotInfinite(this.size);
		      separator = separator !== undefined ? '' + separator : ',';
		      var joined = '';
		      var isFirst = true;
		      this.__iterate(function(v ) {
		        isFirst ? (isFirst = false) : (joined += separator);
		        joined += v !== null && v !== undefined ? v.toString() : '';
		      });
		      return joined;
		    },
	
		    keys: function() {
		      return this.__iterator(ITERATE_KEYS);
		    },
	
		    map: function(mapper, context) {
		      return reify(this, mapFactory(this, mapper, context));
		    },
	
		    reduce: function(reducer, initialReduction, context) {
		      assertNotInfinite(this.size);
		      var reduction;
		      var useFirst;
		      if (arguments.length < 2) {
		        useFirst = true;
		      } else {
		        reduction = initialReduction;
		      }
		      this.__iterate(function(v, k, c)  {
		        if (useFirst) {
		          useFirst = false;
		          reduction = v;
		        } else {
		          reduction = reducer.call(context, reduction, v, k, c);
		        }
		      });
		      return reduction;
		    },
	
		    reduceRight: function(reducer, initialReduction, context) {
		      var reversed = this.toKeyedSeq().reverse();
		      return reversed.reduce.apply(reversed, arguments);
		    },
	
		    reverse: function() {
		      return reify(this, reverseFactory(this, true));
		    },
	
		    slice: function(begin, end) {
		      return reify(this, sliceFactory(this, begin, end, true));
		    },
	
		    some: function(predicate, context) {
		      return !this.every(not(predicate), context);
		    },
	
		    sort: function(comparator) {
		      return reify(this, sortFactory(this, comparator));
		    },
	
		    values: function() {
		      return this.__iterator(ITERATE_VALUES);
		    },
	
	
		    // ### More sequential methods
	
		    butLast: function() {
		      return this.slice(0, -1);
		    },
	
		    isEmpty: function() {
		      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
		    },
	
		    count: function(predicate, context) {
		      return ensureSize(
		        predicate ? this.toSeq().filter(predicate, context) : this
		      );
		    },
	
		    countBy: function(grouper, context) {
		      return countByFactory(this, grouper, context);
		    },
	
		    equals: function(other) {
		      return deepEqual(this, other);
		    },
	
		    entrySeq: function() {
		      var iterable = this;
		      if (iterable._cache) {
		        // We cache as an entries array, so we can just return the cache!
		        return new ArraySeq(iterable._cache);
		      }
		      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
		      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
		      return entriesSequence;
		    },
	
		    filterNot: function(predicate, context) {
		      return this.filter(not(predicate), context);
		    },
	
		    findEntry: function(predicate, context, notSetValue) {
		      var found = notSetValue;
		      this.__iterate(function(v, k, c)  {
		        if (predicate.call(context, v, k, c)) {
		          found = [k, v];
		          return false;
		        }
		      });
		      return found;
		    },
	
		    findKey: function(predicate, context) {
		      var entry = this.findEntry(predicate, context);
		      return entry && entry[0];
		    },
	
		    findLast: function(predicate, context, notSetValue) {
		      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
		    },
	
		    findLastEntry: function(predicate, context, notSetValue) {
		      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
		    },
	
		    findLastKey: function(predicate, context) {
		      return this.toKeyedSeq().reverse().findKey(predicate, context);
		    },
	
		    first: function() {
		      return this.find(returnTrue);
		    },
	
		    flatMap: function(mapper, context) {
		      return reify(this, flatMapFactory(this, mapper, context));
		    },
	
		    flatten: function(depth) {
		      return reify(this, flattenFactory(this, depth, true));
		    },
	
		    fromEntrySeq: function() {
		      return new FromEntriesSequence(this);
		    },
	
		    get: function(searchKey, notSetValue) {
		      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
		    },
	
		    getIn: function(searchKeyPath, notSetValue) {
		      var nested = this;
		      // Note: in an ES6 environment, we would prefer:
		      // for (var key of searchKeyPath) {
		      var iter = forceIterator(searchKeyPath);
		      var step;
		      while (!(step = iter.next()).done) {
		        var key = step.value;
		        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
		        if (nested === NOT_SET) {
		          return notSetValue;
		        }
		      }
		      return nested;
		    },
	
		    groupBy: function(grouper, context) {
		      return groupByFactory(this, grouper, context);
		    },
	
		    has: function(searchKey) {
		      return this.get(searchKey, NOT_SET) !== NOT_SET;
		    },
	
		    hasIn: function(searchKeyPath) {
		      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
		    },
	
		    isSubset: function(iter) {
		      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
		      return this.every(function(value ) {return iter.includes(value)});
		    },
	
		    isSuperset: function(iter) {
		      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
		      return iter.isSubset(this);
		    },
	
		    keyOf: function(searchValue) {
		      return this.findKey(function(value ) {return is(value, searchValue)});
		    },
	
		    keySeq: function() {
		      return this.toSeq().map(keyMapper).toIndexedSeq();
		    },
	
		    last: function() {
		      return this.toSeq().reverse().first();
		    },
	
		    lastKeyOf: function(searchValue) {
		      return this.toKeyedSeq().reverse().keyOf(searchValue);
		    },
	
		    max: function(comparator) {
		      return maxFactory(this, comparator);
		    },
	
		    maxBy: function(mapper, comparator) {
		      return maxFactory(this, comparator, mapper);
		    },
	
		    min: function(comparator) {
		      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
		    },
	
		    minBy: function(mapper, comparator) {
		      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
		    },
	
		    rest: function() {
		      return this.slice(1);
		    },
	
		    skip: function(amount) {
		      return this.slice(Math.max(0, amount));
		    },
	
		    skipLast: function(amount) {
		      return reify(this, this.toSeq().reverse().skip(amount).reverse());
		    },
	
		    skipWhile: function(predicate, context) {
		      return reify(this, skipWhileFactory(this, predicate, context, true));
		    },
	
		    skipUntil: function(predicate, context) {
		      return this.skipWhile(not(predicate), context);
		    },
	
		    sortBy: function(mapper, comparator) {
		      return reify(this, sortFactory(this, comparator, mapper));
		    },
	
		    take: function(amount) {
		      return this.slice(0, Math.max(0, amount));
		    },
	
		    takeLast: function(amount) {
		      return reify(this, this.toSeq().reverse().take(amount).reverse());
		    },
	
		    takeWhile: function(predicate, context) {
		      return reify(this, takeWhileFactory(this, predicate, context));
		    },
	
		    takeUntil: function(predicate, context) {
		      return this.takeWhile(not(predicate), context);
		    },
	
		    valueSeq: function() {
		      return this.toIndexedSeq();
		    },
	
	
		    // ### Hashable Object
	
		    hashCode: function() {
		      return this.__hash || (this.__hash = hashIterable(this));
		    }
	
	
		    // ### Internal
	
		    // abstract __iterate(fn, reverse)
	
		    // abstract __iterator(type, reverse)
		  });
	
		  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
		  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
		  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
		  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
		  var IterablePrototype = Iterable.prototype;
		  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
		  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
		  IterablePrototype.__toJS = IterablePrototype.toArray;
		  IterablePrototype.__toStringMapper = quoteString;
		  IterablePrototype.inspect =
		  IterablePrototype.toSource = function() { return this.toString(); };
		  IterablePrototype.chain = IterablePrototype.flatMap;
		  IterablePrototype.contains = IterablePrototype.includes;
	
		  mixin(KeyedIterable, {
	
		    // ### More sequential methods
	
		    flip: function() {
		      return reify(this, flipFactory(this));
		    },
	
		    mapEntries: function(mapper, context) {var this$0 = this;
		      var iterations = 0;
		      return reify(this,
		        this.toSeq().map(
		          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
		        ).fromEntrySeq()
		      );
		    },
	
		    mapKeys: function(mapper, context) {var this$0 = this;
		      return reify(this,
		        this.toSeq().flip().map(
		          function(k, v)  {return mapper.call(context, k, v, this$0)}
		        ).flip()
		      );
		    }
	
		  });
	
		  var KeyedIterablePrototype = KeyedIterable.prototype;
		  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
		  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
		  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
		  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
		  mixin(IndexedIterable, {
	
		    // ### Conversion to other types
	
		    toKeyedSeq: function() {
		      return new ToKeyedSequence(this, false);
		    },
	
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    filter: function(predicate, context) {
		      return reify(this, filterFactory(this, predicate, context, false));
		    },
	
		    findIndex: function(predicate, context) {
		      var entry = this.findEntry(predicate, context);
		      return entry ? entry[0] : -1;
		    },
	
		    indexOf: function(searchValue) {
		      var key = this.keyOf(searchValue);
		      return key === undefined ? -1 : key;
		    },
	
		    lastIndexOf: function(searchValue) {
		      var key = this.lastKeyOf(searchValue);
		      return key === undefined ? -1 : key;
		    },
	
		    reverse: function() {
		      return reify(this, reverseFactory(this, false));
		    },
	
		    slice: function(begin, end) {
		      return reify(this, sliceFactory(this, begin, end, false));
		    },
	
		    splice: function(index, removeNum /*, ...values*/) {
		      var numArgs = arguments.length;
		      removeNum = Math.max(removeNum | 0, 0);
		      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
		        return this;
		      }
		      // If index is negative, it should resolve relative to the size of the
		      // collection. However size may be expensive to compute if not cached, so
		      // only call count() if the number is in fact negative.
		      index = resolveBegin(index, index < 0 ? this.count() : this.size);
		      var spliced = this.slice(0, index);
		      return reify(
		        this,
		        numArgs === 1 ?
		          spliced :
		          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
		      );
		    },
	
	
		    // ### More collection methods
	
		    findLastIndex: function(predicate, context) {
		      var entry = this.findLastEntry(predicate, context);
		      return entry ? entry[0] : -1;
		    },
	
		    first: function() {
		      return this.get(0);
		    },
	
		    flatten: function(depth) {
		      return reify(this, flattenFactory(this, depth, false));
		    },
	
		    get: function(index, notSetValue) {
		      index = wrapIndex(this, index);
		      return (index < 0 || (this.size === Infinity ||
		          (this.size !== undefined && index > this.size))) ?
		        notSetValue :
		        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
		    },
	
		    has: function(index) {
		      index = wrapIndex(this, index);
		      return index >= 0 && (this.size !== undefined ?
		        this.size === Infinity || index < this.size :
		        this.indexOf(index) !== -1
		      );
		    },
	
		    interpose: function(separator) {
		      return reify(this, interposeFactory(this, separator));
		    },
	
		    interleave: function(/*...iterables*/) {
		      var iterables = [this].concat(arrCopy(arguments));
		      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
		      var interleaved = zipped.flatten(true);
		      if (zipped.size) {
		        interleaved.size = zipped.size * iterables.length;
		      }
		      return reify(this, interleaved);
		    },
	
		    keySeq: function() {
		      return Range(0, this.size);
		    },
	
		    last: function() {
		      return this.get(-1);
		    },
	
		    skipWhile: function(predicate, context) {
		      return reify(this, skipWhileFactory(this, predicate, context, false));
		    },
	
		    zip: function(/*, ...iterables */) {
		      var iterables = [this].concat(arrCopy(arguments));
		      return reify(this, zipWithFactory(this, defaultZipper, iterables));
		    },
	
		    zipWith: function(zipper/*, ...iterables */) {
		      var iterables = arrCopy(arguments);
		      iterables[0] = this;
		      return reify(this, zipWithFactory(this, zipper, iterables));
		    }
	
		  });
	
		  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
		  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
		  mixin(SetIterable, {
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    get: function(value, notSetValue) {
		      return this.has(value) ? value : notSetValue;
		    },
	
		    includes: function(value) {
		      return this.has(value);
		    },
	
	
		    // ### More sequential methods
	
		    keySeq: function() {
		      return this.valueSeq();
		    }
	
		  });
	
		  SetIterable.prototype.has = IterablePrototype.includes;
		  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
		  // Mixin subclasses
	
		  mixin(KeyedSeq, KeyedIterable.prototype);
		  mixin(IndexedSeq, IndexedIterable.prototype);
		  mixin(SetSeq, SetIterable.prototype);
	
		  mixin(KeyedCollection, KeyedIterable.prototype);
		  mixin(IndexedCollection, IndexedIterable.prototype);
		  mixin(SetCollection, SetIterable.prototype);
	
	
		  // #pragma Helper functions
	
		  function keyMapper(v, k) {
		    return k;
		  }
	
		  function entryMapper(v, k) {
		    return [k, v];
		  }
	
		  function not(predicate) {
		    return function() {
		      return !predicate.apply(this, arguments);
		    }
		  }
	
		  function neg(predicate) {
		    return function() {
		      return -predicate.apply(this, arguments);
		    }
		  }
	
		  function quoteString(value) {
		    return typeof value === 'string' ? JSON.stringify(value) : String(value);
		  }
	
		  function defaultZipper() {
		    return arrCopy(arguments);
		  }
	
		  function defaultNegComparator(a, b) {
		    return a < b ? 1 : a > b ? -1 : 0;
		  }
	
		  function hashIterable(iterable) {
		    if (iterable.size === Infinity) {
		      return 0;
		    }
		    var ordered = isOrdered(iterable);
		    var keyed = isKeyed(iterable);
		    var h = ordered ? 1 : 0;
		    var size = iterable.__iterate(
		      keyed ?
		        ordered ?
		          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
		          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
		        ordered ?
		          function(v ) { h = 31 * h + hash(v) | 0; } :
		          function(v ) { h = h + hash(v) | 0; }
		    );
		    return murmurHashOfSize(size, h);
		  }
	
		  function murmurHashOfSize(size, h) {
		    h = imul(h, 0xCC9E2D51);
		    h = imul(h << 15 | h >>> -15, 0x1B873593);
		    h = imul(h << 13 | h >>> -13, 5);
		    h = (h + 0xE6546B64 | 0) ^ size;
		    h = imul(h ^ h >>> 16, 0x85EBCA6B);
		    h = imul(h ^ h >>> 13, 0xC2B2AE35);
		    h = smi(h ^ h >>> 16);
		    return h;
		  }
	
		  function hashMerge(a, b) {
		    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
		  }
	
		  var Immutable = {
	
		    Iterable: Iterable,
	
		    Seq: Seq,
		    Collection: Collection,
		    Map: Map,
		    OrderedMap: OrderedMap,
		    List: List,
		    Stack: Stack,
		    Set: Set,
		    OrderedSet: OrderedSet,
	
		    Record: Record,
		    Range: Range,
		    Repeat: Repeat,
	
		    is: is,
		    fromJS: fromJS
	
		  };
	
		  return Immutable;
	
		}));
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		var identity = __webpack_require__(117),
		    overRest = __webpack_require__(331),
		    setToString = __webpack_require__(334);
	
		/**
		 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @returns {Function} Returns the new function.
		 */
		function baseRest(func, start) {
		  return setToString(overRest(func, start, identity), func + '');
		}
	
		module.exports = baseRest;
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(195);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-core.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-core.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(197);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-row.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-row.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 28 */
	[1786, 114],
	/* 29 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return value != null && (type == 'object' || type == 'function');
		}
	
		module.exports = isObject;
	
	
	/***/ },
	/* 30 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return value != null && typeof value == 'object';
		}
	
		module.exports = isObjectLike;
	
	
	/***/ },
	/* 31 */
	[1660, 53, 451, 478],
	/* 32 */
	30,
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var shallowCloneObject = __webpack_require__(36);
		var sameColumn = __webpack_require__(161);
		var ColumnUtils = __webpack_require__(10);
		var getScrollbarSize = __webpack_require__(35);
		var isColumnsImmutable = __webpack_require__(68);
	
		function setColumnWidths(columns, totalWidth) {
		  return columns.map(function (column) {
		    var colInfo = Object.assign({}, column);
		    if (column.width) {
		      if (/^([0-9]+)%$/.exec(column.width.toString())) {
		        colInfo.width = Math.floor(column.width / 100 * totalWidth);
		      }
		    }
		    return colInfo;
		  });
		}
	
		function setDefferedColumnWidths(columns, unallocatedWidth, minColumnWidth) {
		  var defferedColumns = columns.filter(function (c) {
		    return !c.width;
		  });
		  return columns.map(function (column) {
		    if (!column.width) {
		      if (unallocatedWidth <= 0) {
		        column.width = minColumnWidth;
		      } else {
		        column.width = Math.floor(unallocatedWidth / ColumnUtils.getSize(defferedColumns));
		      }
		    }
		    return column;
		  });
		}
	
		function setColumnOffsets(columns) {
		  var left = 0;
		  return columns.map(function (column) {
		    column.left = left;
		    left += column.width;
		    return column;
		  });
		}
	
		/**
		 * Update column metrics calculation.
		 *
		 * @param {ColumnMetricsType} metrics
		 */
		function recalculate(metrics) {
		  // compute width for columns which specify width
		  var columns = setColumnWidths(metrics.columns, metrics.totalWidth);
	
		  var unallocatedWidth = columns.filter(function (c) {
		    return c.width;
		  }).reduce(function (w, column) {
		    return w - column.width;
		  }, metrics.totalWidth);
		  unallocatedWidth -= getScrollbarSize();
	
		  var width = columns.filter(function (c) {
		    return c.width;
		  }).reduce(function (w, column) {
		    return w + column.width;
		  }, 0);
	
		  // compute width for columns which doesn't specify width
		  columns = setDefferedColumnWidths(columns, unallocatedWidth, metrics.minColumnWidth);
	
		  // compute left offset
		  columns = setColumnOffsets(columns);
	
		  return {
		    columns: columns,
		    width: width,
		    totalWidth: metrics.totalWidth,
		    minColumnWidth: metrics.minColumnWidth
		  };
		}
	
		/**
		 * Update column metrics calculation by resizing a column.
		 *
		 * @param {ColumnMetricsType} metrics
		 * @param {Column} column
		 * @param {number} width
		 */
		function resizeColumn(metrics, index, width) {
		  var column = ColumnUtils.getColumn(metrics.columns, index);
		  var metricsClone = shallowCloneObject(metrics);
		  metricsClone.columns = metrics.columns.slice(0);
	
		  var updatedColumn = shallowCloneObject(column);
		  updatedColumn.width = Math.max(width, metricsClone.minColumnWidth);
	
		  metricsClone = ColumnUtils.spliceColumn(metricsClone, index, updatedColumn);
	
		  return recalculate(metricsClone);
		}
	
		function areColumnsImmutable(prevColumns, nextColumns) {
		  return isColumnsImmutable(prevColumns) && isColumnsImmutable(nextColumns);
		}
	
		function compareEachColumn(prevColumns, nextColumns, isSameColumn) {
		  var i = void 0;
		  var len = void 0;
		  var column = void 0;
		  var prevColumnsByKey = {};
		  var nextColumnsByKey = {};
	
		  if (ColumnUtils.getSize(prevColumns) !== ColumnUtils.getSize(nextColumns)) {
		    return false;
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
		    column = prevColumns[i];
		    prevColumnsByKey[column.key] = column;
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(nextColumns); i < len; i++) {
		    column = nextColumns[i];
		    nextColumnsByKey[column.key] = column;
		    var prevColumn = prevColumnsByKey[column.key];
		    if (prevColumn === undefined || !isSameColumn(prevColumn, column)) {
		      return false;
		    }
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
		    column = prevColumns[i];
		    var nextColumn = nextColumnsByKey[column.key];
		    if (nextColumn === undefined) {
		      return false;
		    }
		  }
		  return true;
		}
	
		function sameColumns(prevColumns, nextColumns, isSameColumn) {
		  if (areColumnsImmutable(prevColumns, nextColumns)) {
		    return prevColumns === nextColumns;
		  }
	
		  return compareEachColumn(prevColumns, nextColumns, isSameColumn);
		}
	
		module.exports = { recalculate: recalculate, resizeColumn: resizeColumn, sameColumn: sameColumn, sameColumns: sameColumns };
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _OverflowCell = __webpack_require__(170);
	
		var _OverflowCell2 = _interopRequireDefault(_OverflowCell);
	
		var _RowComparer = __webpack_require__(62);
	
		var _RowComparer2 = _interopRequireDefault(_RowComparer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var Cell = __webpack_require__(59);
		var ColumnUtilsMixin = __webpack_require__(10);
		var cellMetaDataShape = __webpack_require__(14);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(27);
	
		var CellExpander = React.createClass({
		  displayName: 'CellExpander',
		  render: function render() {
		    return React.createElement(Cell, this.props);
		  }
		});
	
		// The list of the propTypes that we want to include in the Row div
		var knownDivPropertyKeys = ['height'];
	
		var Row = React.createClass({
		  displayName: 'Row',
	
	
		  propTypes: {
		    height: PropTypes.number.isRequired,
		    columns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
		    row: PropTypes.any.isRequired,
		    cellRenderer: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    isSelected: PropTypes.bool,
		    idx: PropTypes.number.isRequired,
		    expandedRows: PropTypes.arrayOf(PropTypes.object),
		    extraClasses: PropTypes.string,
		    forceUpdate: PropTypes.bool,
		    subRowDetails: PropTypes.object,
		    isRowHovered: PropTypes.bool,
		    colVisibleStart: PropTypes.number.isRequired,
		    colVisibleEnd: PropTypes.number.isRequired,
		    colDisplayStart: PropTypes.number.isRequired,
		    colDisplayEnd: PropTypes.number.isRequired,
		    isScrolling: React.PropTypes.bool.isRequired
		  },
	
		  mixins: [ColumnUtilsMixin],
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      cellRenderer: Cell,
		      isSelected: false,
		      height: 35
		    };
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return (0, _RowComparer2['default'])(nextProps, this.props);
		  },
		  handleDragEnter: function handleDragEnter() {
		    var handleDragEnterRow = this.props.cellMetaData.handleDragEnterRow;
		    if (handleDragEnterRow) {
		      handleDragEnterRow(this.props.idx);
		    }
		  },
		  getSelectedColumn: function getSelectedColumn() {
		    if (this.props.cellMetaData) {
		      var selected = this.props.cellMetaData.selected;
		      if (selected && selected.idx) {
		        return this.getColumn(this.props.columns, selected.idx);
		      }
		    }
		  },
		  getCellRenderer: function getCellRenderer(columnKey) {
		    var CellRenderer = this.props.cellRenderer;
		    if (this.props.subRowDetails && this.props.subRowDetails.field === columnKey) {
		      return CellExpander;
		    }
		    return CellRenderer;
		  },
		  getCell: function getCell(column, i, selectedColumn) {
		    var _this = this;
	
		    var CellRenderer = this.props.cellRenderer;
		    var _props = this.props,
		        colVisibleStart = _props.colVisibleStart,
		        colVisibleEnd = _props.colVisibleEnd,
		        idx = _props.idx,
		        cellMetaData = _props.cellMetaData;
		    var key = column.key,
		        formatter = column.formatter,
		        locked = column.locked;
	
		    var baseCellProps = { key: key + '-' + idx, idx: i, rowIdx: idx, height: this.getRowHeight(), column: column, cellMetaData: cellMetaData };
	
		    if ((i < colVisibleStart || i > colVisibleEnd) && !locked) {
		      return React.createElement(_OverflowCell2['default'], _extends({ ref: function ref(node) {
		          return _this.key = node;
		        } }, baseCellProps));
		    }
	
		    var _props2 = this.props,
		        row = _props2.row,
		        isSelected = _props2.isSelected;
	
		    var cellProps = {
		      ref: function ref(node) {
		        return _this.key = node;
		      },
		      value: this.getCellValue(key || i),
		      rowData: row,
		      isRowSelected: isSelected,
		      expandableOptions: this.getExpandableOptions(key),
		      selectedColumn: selectedColumn,
		      formatter: formatter,
		      isScrolling: this.props.isScrolling
		    };
	
		    return React.createElement(CellRenderer, _extends({}, baseCellProps, cellProps));
		  },
		  getCells: function getCells() {
		    var _this2 = this;
	
		    var cells = [];
		    var lockedCells = [];
		    var selectedColumn = this.getSelectedColumn();
		    if (this.props.columns) {
		      this.props.columns.forEach(function (column, i) {
		        var cell = _this2.getCell(column, i, selectedColumn);
		        if (column.locked) {
		          lockedCells.push(cell);
		        } else {
		          cells.push(cell);
		        }
		      });
		    }
	
		    return cells.concat(lockedCells);
		  },
		  getRowHeight: function getRowHeight() {
		    var rows = this.props.expandedRows || null;
		    if (rows && this.props.idx) {
		      var row = rows[this.props.idx] || null;
		      if (row) {
		        return row.height;
		      }
		    }
		    return this.props.height;
		  },
		  getCellValue: function getCellValue(key) {
		    var val = void 0;
		    if (key === 'select-row') {
		      return this.props.isSelected;
		    } else if (typeof this.props.row.get === 'function') {
		      val = this.props.row.get(key);
		    } else {
		      val = this.props.row[key];
		    }
		    return val;
		  },
		  isContextMenuDisplayed: function isContextMenuDisplayed() {
		    if (this.props.cellMetaData) {
		      var selected = this.props.cellMetaData.selected;
		      if (selected && selected.contextMenuDisplayed && selected.rowIdx === this.props.idx) {
		        return true;
		      }
		    }
		    return false;
		  },
		  getExpandableOptions: function getExpandableOptions(columnKey) {
		    return { canExpand: this.props.subRowDetails && this.props.subRowDetails.field === columnKey, expanded: this.props.subRowDetails && this.props.subRowDetails.expanded, children: this.props.subRowDetails && this.props.subRowDetails.children, treeDepth: this.props.subRowDetails ? this.props.subRowDetails.treeDepth : 0 };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var _this3 = this;
	
		    this.props.columns.forEach(function (column) {
		      if (column.locked) {
		        if (!_this3[column.key]) return;
		        _this3[column.key].setScrollLeft(scrollLeft);
		      }
		    });
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  renderCell: function renderCell(props) {
		    if (typeof this.props.cellRenderer === 'function') {
		      this.props.cellRenderer.call(this, props);
		    }
		    if (React.isValidElement(this.props.cellRenderer)) {
		      return React.cloneElement(this.props.cellRenderer, props);
		    }
	
		    return this.props.cellRenderer(props);
		  },
		  render: function render() {
		    var className = joinClasses('react-grid-Row', 'react-grid-Row--' + (this.props.idx % 2 === 0 ? 'even' : 'odd'), {
		      'row-selected': this.props.isSelected,
		      'row-context-menu': this.isContextMenuDisplayed()
		    }, this.props.extraClasses);
	
		    var style = {
		      height: this.getRowHeight(this.props),
		      overflow: 'hidden',
		      contain: 'layout'
		    };
	
		    var cells = this.getCells();
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: className, style: style, onDragEnter: this.handleDragEnter }),
		      React.isValidElement(this.props.row) ? this.props.row : cells
		    );
		  }
		});
	
		module.exports = Row;
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var size = void 0;
	
		function getScrollbarSize() {
		  if (size === undefined) {
		    var outer = document.createElement('div');
		    outer.style.width = '50px';
		    outer.style.height = '50px';
		    outer.style.position = 'absolute';
		    outer.style.top = '-200px';
		    outer.style.left = '-200px';
	
		    var inner = document.createElement('div');
		    inner.style.height = '100px';
		    inner.style.width = '100%';
	
		    outer.appendChild(inner);
		    document.body.appendChild(outer);
	
		    var outerWidth = outer.clientWidth;
		    outer.style.overflowY = 'scroll';
		    var innerWidth = inner.clientWidth;
	
		    document.body.removeChild(outer);
	
		    size = outerWidth - innerWidth;
		  }
	
		  return size;
		}
	
		module.exports = getScrollbarSize;
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		"use strict";
	
		function shallowCloneObject(obj) {
		  var result = {};
		  for (var k in obj) {
		    if (obj.hasOwnProperty(k)) {
		      result[k] = obj[k];
		    }
		  }
		  return result;
		}
	
		module.exports = shallowCloneObject;
	
	/***/ },
	/* 37 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var isFunction = function isFunction(functionToCheck) {
		  var getType = {};
		  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
		};
	
		module.exports = isFunction;
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(193);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.beginDrag = beginDrag;
		exports.publishDragSource = publishDragSource;
		exports.hover = hover;
		exports.drop = drop;
		exports.endDrag = endDrag;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isArray = __webpack_require__(19);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		var _isObject = __webpack_require__(29);
	
		var _isObject2 = _interopRequireDefault(_isObject);
	
		var _matchesType = __webpack_require__(104);
	
		var _matchesType2 = _interopRequireDefault(_matchesType);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
		var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
		var HOVER = exports.HOVER = 'dnd-core/HOVER';
		var DROP = exports.DROP = 'dnd-core/DROP';
		var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
	
		function beginDrag(sourceIds) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
		  var publishSource = options.publishSource,
		      clientOffset = options.clientOffset,
		      getSourceClientOffset = options.getSourceClientOffset;
	
		  (0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
	
		  var monitor = this.getMonitor();
		  var registry = this.getRegistry();
		  (0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
		  for (var i = 0; i < sourceIds.length; i++) {
		    (0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
		  }
	
		  var sourceId = null;
		  for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
		    if (monitor.canDragSource(sourceIds[_i])) {
		      sourceId = sourceIds[_i];
		      break;
		    }
		  }
		  if (sourceId === null) {
		    return;
		  }
	
		  var sourceClientOffset = null;
		  if (clientOffset) {
		    (0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
		    sourceClientOffset = getSourceClientOffset(sourceId);
		  }
	
		  var source = registry.getSource(sourceId);
		  var item = source.beginDrag(monitor, sourceId);
		  (0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
	
		  registry.pinSource(sourceId);
	
		  var itemType = registry.getSourceType(sourceId);
		  return {
		    type: BEGIN_DRAG,
		    itemType: itemType,
		    item: item,
		    sourceId: sourceId,
		    clientOffset: clientOffset,
		    sourceClientOffset: sourceClientOffset,
		    isSourcePublic: publishSource
		  };
		}
	
		function publishDragSource() {
		  var monitor = this.getMonitor();
		  if (!monitor.isDragging()) {
		    return;
		  }
	
		  return { type: PUBLISH_DRAG_SOURCE };
		}
	
		function hover(targetIdsArg) {
		  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		      _ref$clientOffset = _ref.clientOffset,
		      clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	
		  (0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
		  var targetIds = targetIdsArg.slice(0);
	
		  var monitor = this.getMonitor();
		  var registry = this.getRegistry();
		  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
		  (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
	
		  // First check invariants.
		  for (var i = 0; i < targetIds.length; i++) {
		    var targetId = targetIds[i];
		    (0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
		    var target = registry.getTarget(targetId);
		    (0, _invariant2.default)(target, 'Expected targetIds to be registered.');
		  }
	
		  var draggedItemType = monitor.getItemType();
	
		  // Remove those targetIds that don't match the targetType.  This
		  // fixes shallow isOver which would only be non-shallow because of
		  // non-matching targets.
		  for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
		    var _targetId = targetIds[_i2];
		    var targetType = registry.getTargetType(_targetId);
		    if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
		      targetIds.splice(_i2, 1);
		    }
		  }
	
		  // Finally call hover on all matching targets.
		  for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
		    var _targetId2 = targetIds[_i3];
		    var _target = registry.getTarget(_targetId2);
		    _target.hover(monitor, _targetId2);
		  }
	
		  return {
		    type: HOVER,
		    targetIds: targetIds,
		    clientOffset: clientOffset
		  };
		}
	
		function drop() {
		  var _this = this;
	
		  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		  var monitor = this.getMonitor();
		  var registry = this.getRegistry();
		  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
		  (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
		  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
		  targetIds.reverse();
		  targetIds.forEach(function (targetId, index) {
		    var target = registry.getTarget(targetId);
	
		    var dropResult = target.drop(monitor, targetId);
		    (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
		    if (typeof dropResult === 'undefined') {
		      dropResult = index === 0 ? {} : monitor.getDropResult();
		    }
	
		    _this.store.dispatch({
		      type: DROP,
		      dropResult: _extends({}, options, dropResult)
		    });
		  });
		}
	
		function endDrag() {
		  var monitor = this.getMonitor();
		  var registry = this.getRegistry();
		  (0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
		  var sourceId = monitor.getSourceId();
		  var source = registry.getSource(sourceId, true);
		  source.endDrag(monitor, sourceId);
	
		  registry.unpinSource();
	
		  return { type: END_DRAG };
		}
	
	/***/ },
	/* 40 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.addSource = addSource;
		exports.addTarget = addTarget;
		exports.removeSource = removeSource;
		exports.removeTarget = removeTarget;
		var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
		var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
		var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
		var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	
		function addSource(sourceId) {
		  return {
		    type: ADD_SOURCE,
		    sourceId: sourceId
		  };
		}
	
		function addTarget(targetId) {
		  return {
		    type: ADD_TARGET,
		    targetId: targetId
		  };
		}
	
		function removeSource(sourceId) {
		  return {
		    type: REMOVE_SOURCE,
		    sourceId: sourceId
		  };
		}
	
		function removeTarget(targetId) {
		  return {
		    type: REMOVE_TARGET,
		    targetId: targetId
		  };
		}
	
	/***/ },
	/* 41 */
	[1651, 46],
	/* 42 */
	[1660, 76, 305, 329],
	/* 43 */
	[1690, 314],
	/* 44 */
	[1697, 292, 306],
	/* 45 */
	[1774, 44],
	/* 46 */
	/***/ function(module, exports) {
	
		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}
	
		module.exports = eq;
	
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLike = __webpack_require__(82),
		    isObjectLike = __webpack_require__(30);
	
		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}
	
		module.exports = isArrayLikeObject;
	
	
	/***/ },
	/* 48 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _redux = __webpack_require__(396);
	
		var _reducers = __webpack_require__(354);
	
		var _reducers2 = _interopRequireDefault(_reducers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = (0, _redux.createStore)(_reducers2.default);
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = checkDecoratorArguments;
		function checkDecoratorArguments(functionName, signature) {
		  if (false) {
		    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
		      var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
		      if (arg && arg.prototype && arg.prototype.render) {
		        console.error( // eslint-disable-line no-console
		        'You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
		        return;
		      }
		    }
		  }
		}
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/react-select
		*/
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
			value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _reactInputAutosize = __webpack_require__(377);
	
		var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
		var _classnames = __webpack_require__(51);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _utilsDefaultArrowRenderer = __webpack_require__(391);
	
		var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);
	
		var _utilsDefaultFilterOptions = __webpack_require__(138);
	
		var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
		var _utilsDefaultMenuRenderer = __webpack_require__(139);
	
		var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
		var _utilsDefaultClearRenderer = __webpack_require__(392);
	
		var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);
	
		var _Async = __webpack_require__(386);
	
		var _Async2 = _interopRequireDefault(_Async);
	
		var _AsyncCreatable = __webpack_require__(387);
	
		var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
		var _Creatable = __webpack_require__(388);
	
		var _Creatable2 = _interopRequireDefault(_Creatable);
	
		var _Option = __webpack_require__(389);
	
		var _Option2 = _interopRequireDefault(_Option);
	
		var _Value = __webpack_require__(390);
	
		var _Value2 = _interopRequireDefault(_Value);
	
		function stringifyValue(value) {
			var valueType = typeof value;
			if (valueType === 'string') {
				return value;
			} else if (valueType === 'object') {
				return JSON.stringify(value);
			} else if (valueType === 'number' || valueType === 'boolean') {
				return String(value);
			} else {
				return '';
			}
		}
	
		var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
		var instanceId = 1;
	
		var Select = _react2['default'].createClass({
	
			displayName: 'Select',
	
			propTypes: {
				addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
				'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
				'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
				arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
				autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
				autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
				autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
				backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
				backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
				className: _react2['default'].PropTypes.string, // className for the outer element
				clearAllText: stringOrNode, // title for the "clear" control when multi: true
				clearRenderer: _react2['default'].PropTypes.func, // create clearable x element
				clearValueText: stringOrNode, // title for the "clear" control
				clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
				deleteRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
				delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
				disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
				escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
				filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
				filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
				ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
				ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
				inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
				inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
				instanceId: _react2['default'].PropTypes.string, // set the components instanceId
				isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
				joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
				labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
				matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
				matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
				menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
				menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
				menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
				menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
				multi: _react2['default'].PropTypes.bool, // multi-value input
				name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
				noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
				onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
				onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
				onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
				onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
				onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
				onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
				onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
				onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
				onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
				onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
				onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
				openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
				openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
				optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
				optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
				optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
				options: _react2['default'].PropTypes.array, // array of options
				pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
				placeholder: stringOrNode, // field placeholder, displayed when there's no value
				required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
				resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
				scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
				searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
				simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
				style: _react2['default'].PropTypes.object, // optional style to apply to the control
				tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
				tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
				value: _react2['default'].PropTypes.any, // initial field value
				valueComponent: _react2['default'].PropTypes.func, // value component to render
				valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
				valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
				wrapperStyle: _react2['default'].PropTypes.object },
	
			// optional style to apply to the component wrapper
			statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },
	
			getDefaultProps: function getDefaultProps() {
				return {
					addLabelText: 'Add "{label}"?',
					arrowRenderer: _utilsDefaultArrowRenderer2['default'],
					autosize: true,
					backspaceRemoves: true,
					backspaceToRemoveMessage: 'Press backspace to remove {label}',
					clearable: true,
					clearAllText: 'Clear all',
					clearRenderer: _utilsDefaultClearRenderer2['default'],
					clearValueText: 'Clear value',
					deleteRemoves: true,
					delimiter: ',',
					disabled: false,
					escapeClearsValue: true,
					filterOptions: _utilsDefaultFilterOptions2['default'],
					ignoreAccents: true,
					ignoreCase: true,
					inputProps: {},
					isLoading: false,
					joinValues: false,
					labelKey: 'label',
					matchPos: 'any',
					matchProp: 'any',
					menuBuffer: 0,
					menuRenderer: _utilsDefaultMenuRenderer2['default'],
					multi: false,
					noResultsText: 'No results found',
					onBlurResetsInput: true,
					onCloseResetsInput: true,
					openAfterFocus: false,
					optionComponent: _Option2['default'],
					pageSize: 5,
					placeholder: 'Select...',
					required: false,
					scrollMenuIntoView: true,
					searchable: true,
					simpleValue: false,
					tabSelectsValue: true,
					valueComponent: _Value2['default'],
					valueKey: 'value'
				};
			},
	
			getInitialState: function getInitialState() {
				return {
					inputValue: '',
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false,
					required: false
				};
			},
	
			componentWillMount: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], this.props.multi)
					});
				}
			},
	
			componentDidMount: function componentDidMount() {
				if (this.props.autofocus) {
					this.focus();
				}
			},
	
			componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: this.handleRequired(valueArray[0], nextProps.multi)
					});
				}
			},
	
			componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
				if (nextState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(nextState.isOpen);
					var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
					handler && handler();
				}
			},
	
			componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
					var menuNode = _reactDom2['default'].findDOMNode(this.menu);
					menuNode.scrollTop = focusedOptionNode.offsetTop;
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
					var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
			},
	
			componentWillUnmount: function componentWillUnmount() {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			},
	
			toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			},
	
			handleTouchOutside: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			},
	
			focus: function focus() {
				if (!this.input) return;
				this.input.focus();
	
				if (this.props.openAfterFocus) {
					this.setState({
						isOpen: true
					});
				}
			},
	
			blurInput: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			},
	
			handleTouchMove: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			},
	
			handleTouchStart: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			},
	
			handleTouchEnd: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			},
	
			handleTouchEndClearValue: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			},
	
			handleMouseDown: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					return;
				}
	
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: true,
						isPseudoFocused: false
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = true;
					this.focus();
				}
			},
	
			handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				if (!this.state.isOpen) {
					return;
				}
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			},
	
			handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			},
	
			closeMenu: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi,
						inputValue: ''
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi,
						inputValue: this.state.inputValue
					});
				}
				this.hasScrolledToOption = false;
			},
	
			handleInputFocus: function handleInputFocus(event) {
				if (this.props.disabled) return;
				var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
				this.setState({
					isFocused: true,
					isOpen: isOpen
				});
				this._openAfterFocus = false;
			},
	
			handleInputBlur: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = '';
				}
				this.setState(onBlurredState);
			},
	
			handleInputChange: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
					var nextState = this.props.onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && typeof nextState !== 'object') {
						newInputValue = '' + nextState;
					}
				}
	
				this.setState({
					isOpen: true,
					isPseudoFocused: false,
					inputValue: newInputValue
				});
			},
	
			handleKeyDown: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							return;
						}
						this.selectFocusedOption();
						return;
					case 13:
						// enter
						if (!this.state.isOpen) return;
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 27:
						// escape
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 38:
						// up
						this.focusPreviousOption();
						break;
					case 40:
						// down
						this.focusNextOption();
						break;
					case 33:
						// page up
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							return;
						}
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							return;
						}
						this.focusStartOption();
						break;
					case 46:
						// backspace
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						return;
					default:
						return;
				}
				event.preventDefault();
			},
	
			handleValueClick: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			},
	
			handleMenuScroll: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
					this.props.onMenuScrollToBottom();
				}
			},
	
			handleRequired: function handleRequired(value, multi) {
				if (!value) return true;
				return multi ? value.length === 0 : Object.keys(value).length === 0;
			},
	
			getOptionLabel: function getOptionLabel(op) {
				return op[this.props.labelKey];
			},
	
			/**
		  * Turns a value into an array from the given options
		  * @param	{String|Number|Array}	value		- the value of the select input
		  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
		  * @returns	{Array}	the value of the select represented in an array
		  */
			getValueArray: function getValueArray(value, nextProps) {
				var _this = this;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = typeof nextProps === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') value = value.split(props.delimiter);
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return _this.expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = this.expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			},
	
			/**
		  * Retrieve a value from the given options and valueKey
		  * @param	{String|Number|Array}	value	- the selected value(s)
		  * @param	{Object}		props	- the Select component's props (or nextProps)
		  */
			expandValue: function expandValue(value, props) {
				var valueType = typeof value;
				if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
				var options = props.options;
				var valueKey = props.valueKey;
	
				if (!options) return;
				for (var i = 0; i < options.length; i++) {
					if (options[i][valueKey] === value) return options[i];
				}
			},
	
			setValue: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (!this.props.onChange) return;
				if (this.props.required) {
					var required = this.handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				this.props.onChange(value);
			},
	
			selectValue: function selectValue(value) {
				var _this3 = this;
	
				//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
				this.hasScrolledToOption = false;
				if (this.props.multi) {
					this.setState({
						inputValue: '',
						focusedIndex: null
					}, function () {
						_this3.addValue(value);
					});
				} else {
					this.setState({
						isOpen: false,
						inputValue: '',
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			},
	
			addValue: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			},
	
			popValue: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(valueArray.slice(0, valueArray.length - 1));
			},
	
			removeValue: function removeValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i !== value;
				}));
				this.focus();
			},
	
			clearValue: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				event.stopPropagation();
				event.preventDefault();
				this.setValue(this.getResetValue());
				this.setState({
					isOpen: false,
					inputValue: ''
				}, this.focus);
			},
	
			getResetValue: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			},
	
			focusOption: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			},
	
			focusNextOption: function focusNextOption() {
				this.focusAdjacentOption('next');
			},
	
			focusPreviousOption: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			},
	
			focusPageUpOption: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			},
	
			focusPageDownOption: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			},
	
			focusStartOption: function focusStartOption() {
				this.focusAdjacentOption('start');
			},
	
			focusEndOption: function focusEndOption() {
				this.focusAdjacentOption('end');
			},
	
			focusAdjacentOption: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						inputValue: '',
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
					});
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var potentialIndex = focusedIndex + this.props.pageSize;
					if (potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			},
	
			getFocusedOption: function getFocusedOption() {
				return this._focusedOption;
			},
	
			getInputValue: function getInputValue() {
				return this.state.inputValue;
			},
	
			selectFocusedOption: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			},
	
			renderLoading: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2['default'].createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2['default'].createElement('span', { className: 'Select-loading' })
				);
			},
	
			renderValue: function renderValue(valueArray, isOpen) {
				var _this4 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					return !this.state.inputValue ? _react2['default'].createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2['default'].createElement(
							ValueComponent,
							{
								id: _this4._instancePrefix + '-value-' + i,
								instancePrefix: _this4._instancePrefix,
								disabled: _this4.props.disabled || value.clearableValue === false,
								key: 'value-' + i + '-' + value[_this4.props.valueKey],
								onClick: onClick,
								onRemove: _this4.removeValue,
								value: value
							},
							renderLabel(value, i),
							_react2['default'].createElement(
								'span',
								{ className: 'Select-aria-only' },
								' '
							)
						);
					});
				} else if (!this.state.inputValue) {
					if (isOpen) onClick = null;
					return _react2['default'].createElement(
						ValueComponent,
						{
							id: this._instancePrefix + '-value-item',
							disabled: this.props.disabled,
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			},
	
			renderInput: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this5 = this;
	
				var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
				var isOpen = !!this.state.isOpen;
	
				var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				// TODO: Check how this project includes Object.assign()
				var inputProps = _extends({}, this.props.inputProps, {
					role: 'combobox',
					'aria-expanded': '' + isOpen,
					'aria-owns': ariaOwns,
					'aria-haspopup': '' + isOpen,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-label': this.props['aria-label'],
					className: className,
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this5.input = _ref;
					},
					required: this.state.required,
					value: this.state.inputValue
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var _props$inputProps = this.props.inputProps;
					var inputClassName = _props$inputProps.inputClassName;
	
					var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);
	
					return _react2['default'].createElement('div', _extends({}, divProps, {
						role: 'combobox',
						'aria-expanded': isOpen,
						'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						className: className,
						tabIndex: this.props.tabIndex || 0,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function (ref) {
							return _this5.input = ref;
						},
						'aria-readonly': '' + !!this.props.disabled,
						style: { border: 0, width: 1, display: 'inline-block' } }));
				}
	
				if (this.props.autosize) {
					return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
				}
				return _react2['default'].createElement(
					'div',
					{ className: className },
					_react2['default'].createElement('input', inputProps)
				);
			},
	
			renderClear: function renderClear() {
				if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
				var clear = this.props.clearRenderer();
	
				return _react2['default'].createElement(
					'span',
					{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
						onMouseDown: this.clearValue,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEndClearValue
					},
					clear
				);
			},
	
			renderArrow: function renderArrow() {
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				return _react2['default'].createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			},
	
			filterOptions: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			},
	
			onOptionRef: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			},
	
			renderMenu: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey,
						onOptionRef: this.onOptionRef
					});
				} else if (this.props.noResultsText) {
					return _react2['default'].createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			},
	
			renderHiddenField: function renderHiddenField(valueArray) {
				var _this6 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this6.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2['default'].createElement('input', {
						type: 'hidden',
						ref: function (ref) {
							return _this6.value = ref;
						},
						name: this.props.name,
						value: value,
						disabled: this.props.disabled });
				}
				return valueArray.map(function (item, index) {
					return _react2['default'].createElement('input', { key: 'hidden.' + index,
						type: 'hidden',
						ref: 'value' + index,
						name: _this6.props.name,
						value: stringifyValue(item[_this6.props.valueKey]),
						disabled: _this6.props.disabled });
				});
			},
	
			getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = options.indexOf(focusedOption);
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			},
	
			renderOuter: function renderOuter(options, valueArray, focusedOption) {
				var _this7 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this7.menuContainer = ref;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2['default'].createElement(
						'div',
						{ ref: function (ref) {
								return _this7.menu = ref;
							}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
							style: this.props.menuStyle,
							onScroll: this.handleMenuScroll,
							onMouseDown: this.handleMouseDownOnMenu },
						menu
					)
				);
			},
	
			render: function render() {
				var _this8 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2['default'])('Select', this.props.className, {
					'Select--multi': this.props.multi,
					'Select--single': !this.props.multi,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'has-value': valueArray.length
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2['default'].createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2['default'].createElement(
					'div',
					{ ref: function (ref) {
							return _this8.wrapper = ref;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2['default'].createElement(
						'div',
						{ ref: function (ref) {
								return _this8.control = ref;
							},
							className: 'Select-control',
							style: this.props.style,
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchStart: this.handleTouchStart,
							onTouchMove: this.handleTouchMove
						},
						_react2['default'].createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
				);
			}
	
		});
	
		exports['default'] = Select;
		module.exports = exports['default'];
	
	/***/ },
	/* 51 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
		/* global define */
	
		(function () {
			'use strict';
	
			var hasOwn = {}.hasOwnProperty;
	
			function classNames () {
				var classes = [];
	
				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (!arg) continue;
	
					var argType = typeof arg;
	
					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}
	
				return classes.join(' ');
			}
	
			if (typeof module !== 'undefined' && module.exports) {
				module.exports = classNames;
			} else if (true) {
				// register as 'classnames', consistent with npm package name
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return classNames;
				}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else {
				window.classNames = classNames;
			}
		}());
	
	
	/***/ },
	/* 52 */
	[1616, 464, 465, 466, 467, 468],
	/* 53 */
	[1640, 12],
	/* 54 */
	[1651, 154],
	/* 55 */
	[1690, 461],
	/* 56 */
	[1774, 20],
	/* 57 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isSymbol = __webpack_require__(92);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/**
		 * Converts `value` to a string key if it's not a string or symbol.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {string|symbol} Returns the key.
		 */
		function toKey(value) {
		  if (typeof value == 'string' || isSymbol(value)) {
		    return value;
		  }
		  var result = (value + '');
		  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
		}
	
		module.exports = toKey;
	
	
	/***/ },
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keyMirror = __webpack_require__(199);
	
		var _keyMirror2 = _interopRequireDefault(_keyMirror);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var constants = {
		  UpdateActions: (0, _keyMirror2['default'])({
		    CELL_UPDATE: null,
		    COLUMN_FILL: null,
		    COPY_PASTE: null,
		    CELL_DRAG: null
		  }),
		  DragItemTypes: {
		    Column: 'column'
		  }
		};
	
		module.exports = constants;
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _underscore = __webpack_require__(96);
	
		var _underscore2 = _interopRequireDefault(_underscore);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var EditorContainer = __webpack_require__(180);
		var ExcelColumn = __webpack_require__(11);
		var isFunction = __webpack_require__(37);
		var CellMetaDataShape = __webpack_require__(14);
		var SimpleCellFormatter = __webpack_require__(183);
		var ColumnUtils = __webpack_require__(10);
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(38);
	
		// The list of the propTypes that we want to include in the Cell div
		var knownDivPropertyKeys = ['height', 'tabIndex', 'value'];
	
		var Cell = React.createClass({
		  displayName: 'Cell',
	
	
		  propTypes: {
		    rowIdx: React.PropTypes.number.isRequired,
		    idx: React.PropTypes.number.isRequired,
		    selected: React.PropTypes.shape({
		      idx: React.PropTypes.number.isRequired
		    }),
		    selectedColumn: React.PropTypes.object,
		    height: React.PropTypes.number,
		    tabIndex: React.PropTypes.number,
		    column: React.PropTypes.shape(ExcelColumn).isRequired,
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired,
		    isExpanded: React.PropTypes.bool,
		    isRowSelected: React.PropTypes.bool,
		    cellMetaData: React.PropTypes.shape(CellMetaDataShape).isRequired,
		    handleDragStart: React.PropTypes.func,
		    className: React.PropTypes.string,
		    cellControls: React.PropTypes.any,
		    rowData: React.PropTypes.object.isRequired,
		    forceUpdate: React.PropTypes.bool,
		    expandableOptions: React.PropTypes.object.isRequired,
		    isScrolling: React.PropTypes.bool.isRequired,
		    tooltip: React.PropTypes.string,
		    isCellValueChanging: React.PropTypes.func
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      tabIndex: -1,
		      isExpanded: false,
		      value: '',
		      isCellValueChanging: function isCellValueChanging(value, nextValue) {
		        return value !== nextValue;
		      }
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      isCellValueChanging: false
		    };
		  },
		  componentDidMount: function componentDidMount() {
		    this.checkFocus();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    this.setState({
		      isCellValueChanging: this.props.isCellValueChanging(this.props.value, nextProps.value)
		    });
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this.checkFocus();
		    var dragged = this.props.cellMetaData.dragged;
		    if (dragged && dragged.complete === true) {
		      this.props.cellMetaData.handleTerminateDrag();
		    }
		    if (this.state.isCellValueChanging && this.props.selectedColumn != null) {
		      this.applyUpdateClass();
		    }
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    var shouldUpdate = this.props.column.width !== nextProps.column.width || this.props.column.left !== nextProps.column.left || this.props.column.cellClass !== nextProps.column.cellClass || this.props.height !== nextProps.height || this.props.rowIdx !== nextProps.rowIdx || this.isCellSelectionChanging(nextProps) || this.isDraggedCellChanging(nextProps) || this.isCopyCellChanging(nextProps) || this.props.isRowSelected !== nextProps.isRowSelected || this.isSelected() || this.props.isCellValueChanging(this.props.value, nextProps.value) || this.props.forceUpdate === true || this.props.className !== nextProps.className || this.hasChangedDependentValues(nextProps);
		    return shouldUpdate;
		  },
		  onCellClick: function onCellClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
		      meta.onCellClick({ rowIdx: this.props.rowIdx, idx: this.props.idx }, e);
		    }
		  },
		  onCellContextMenu: function onCellContextMenu() {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellContextMenu && typeof meta.onCellContextMenu === 'function') {
		      meta.onCellContextMenu({ rowIdx: this.props.rowIdx, idx: this.props.idx });
		    }
		  },
		  onCellDoubleClick: function onCellDoubleClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellDoubleClick && typeof meta.onCellDoubleClick === 'function') {
		      meta.onCellDoubleClick({ rowIdx: this.props.rowIdx, idx: this.props.idx }, e);
		    }
		  },
		  onCellExpand: function onCellExpand(e) {
		    e.stopPropagation();
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellExpand != null) {
		      meta.onCellExpand({ rowIdx: this.props.rowIdx, idx: this.props.idx, rowData: this.props.rowData, expandArgs: this.props.expandableOptions });
		    }
		  },
		  onCellKeyDown: function onCellKeyDown(e) {
		    if (this.canExpand() && e.key === 'Enter') {
		      this.onCellExpand(e);
		    }
		  },
		  onDragHandleDoubleClick: function onDragHandleDoubleClick(e) {
		    e.stopPropagation();
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onDragHandleDoubleClick && typeof meta.onDragHandleDoubleClick === 'function') {
		      meta.onDragHandleDoubleClick({ rowIdx: this.props.rowIdx, idx: this.props.idx, rowData: this.getRowData(), e: e });
		    }
		  },
		  onDragOver: function onDragOver(e) {
		    e.preventDefault();
		  },
		  getStyle: function getStyle() {
		    var style = {
		      position: 'absolute',
		      width: this.props.column.width,
		      height: this.props.height,
		      left: this.props.column.left,
		      contain: 'layout'
		    };
		    return style;
		  },
		  getFormatter: function getFormatter() {
		    var col = this.props.column;
		    if (this.isActive()) {
		      return React.createElement(EditorContainer, { rowData: this.getRowData(), rowIdx: this.props.rowIdx, value: this.props.value, idx: this.props.idx, cellMetaData: this.props.cellMetaData, column: col, height: this.props.height });
		    }
	
		    return this.props.column.formatter;
		  },
		  getRowData: function getRowData() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
		    return props.rowData.toJSON ? props.rowData.toJSON() : props.rowData;
		  },
		  getFormatterDependencies: function getFormatterDependencies() {
		    // convention based method to get corresponding Id or Name of any Name or Id property
		    if (typeof this.props.column.getRowMetaData === 'function') {
		      return this.props.column.getRowMetaData(this.getRowData(), this.props.column);
		    }
		  },
		  getCellClass: function getCellClass() {
		    var className = joinClasses(this.props.column.cellClass, 'react-grid-Cell', this.props.className, this.props.column.locked ? 'react-grid-Cell--locked' : null);
		    var extraClasses = joinClasses({
		      'row-selected': this.props.isRowSelected,
		      editing: this.isActive(),
		      copied: this.isCopied() || this.wasDraggedOver() || this.isDraggedOverUpwards() || this.isDraggedOverDownwards(),
		      'is-dragged-over-up': this.isDraggedOverUpwards(),
		      'is-dragged-over-down': this.isDraggedOverDownwards(),
		      'was-dragged-over': this.wasDraggedOver(),
		      'cell-tooltip': this.props.tooltip ? true : false
		    });
		    return joinClasses(className, extraClasses);
		  },
		  getUpdateCellClass: function getUpdateCellClass() {
		    return this.props.column.getUpdateCellClass ? this.props.column.getUpdateCellClass(this.props.selectedColumn, this.props.column, this.state.isCellValueChanging) : '';
		  },
		  isColumnSelected: function isColumnSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.idx === this.props.idx;
		  },
		  isSelected: function isSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.rowIdx === this.props.rowIdx && meta.selected.idx === this.props.idx;
		  },
		  isActive: function isActive() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    return this.isSelected() && meta.selected.active === true;
		  },
		  isCellSelectionChanging: function isCellSelectionChanging(nextProps) {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    var nextSelected = nextProps.cellMetaData.selected;
		    if (meta.selected && nextSelected) {
		      return this.props.idx === nextSelected.idx || this.props.idx === meta.selected.idx;
		    }
	
		    return true;
		  },
		  isCellSelectEnabled: function isCellSelectEnabled() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    return meta.enableCellSelect;
		  },
		  hasChangedDependentValues: function hasChangedDependentValues(nextProps) {
		    var currentColumn = this.props.column;
		    var hasChangedDependentValues = false;
	
		    if (currentColumn.getRowMetaData) {
		      var currentRowMetaData = currentColumn.getRowMetaData(this.getRowData(), currentColumn);
		      var nextColumn = nextProps.column;
		      var nextRowMetaData = nextColumn.getRowMetaData(this.getRowData(nextProps), nextColumn);
	
		      hasChangedDependentValues = !_underscore2['default'].isEqual(currentRowMetaData, nextRowMetaData);
		    }
	
		    return hasChangedDependentValues;
		  },
		  applyUpdateClass: function applyUpdateClass() {
		    var updateCellClass = this.getUpdateCellClass();
		    // -> removing the class
		    if (updateCellClass != null && updateCellClass !== '') {
		      var cellDOMNode = ReactDOM.findDOMNode(this);
		      if (cellDOMNode.classList) {
		        cellDOMNode.classList.remove(updateCellClass);
		        // -> and re-adding the class
		        cellDOMNode.classList.add(updateCellClass);
		      } else if (cellDOMNode.className.indexOf(updateCellClass) === -1) {
		        // IE9 doesn't support classList, nor (I think) altering element.className
		        // without replacing it wholesale.
		        cellDOMNode.className = cellDOMNode.className + ' ' + updateCellClass;
		      }
		    }
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var ctrl = this; // flow on windows has an outdated react declaration, once that gets updated, we can remove this
		    if (ctrl.isMounted()) {
		      var node = ReactDOM.findDOMNode(this);
		      var transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		      node.style.webkitTransform = transform;
		      node.style.transform = transform;
		    }
		  },
		  isCopied: function isCopied() {
		    var copied = this.props.cellMetaData.copied;
		    return copied && copied.rowIdx === this.props.rowIdx && copied.idx === this.props.idx;
		  },
		  isDraggedOver: function isDraggedOver() {
		    var dragged = this.props.cellMetaData.dragged;
		    return dragged && dragged.overRowIdx === this.props.rowIdx && dragged.idx === this.props.idx;
		  },
		  wasDraggedOver: function wasDraggedOver() {
		    var dragged = this.props.cellMetaData.dragged;
		    return dragged && (dragged.overRowIdx < this.props.rowIdx && this.props.rowIdx < dragged.rowIdx || dragged.overRowIdx > this.props.rowIdx && this.props.rowIdx > dragged.rowIdx) && dragged.idx === this.props.idx;
		  },
		  isDraggedCellChanging: function isDraggedCellChanging(nextProps) {
		    var isChanging = void 0;
		    var dragged = this.props.cellMetaData.dragged;
		    var nextDragged = nextProps.cellMetaData.dragged;
		    if (dragged) {
		      isChanging = nextDragged && this.props.idx === nextDragged.idx || dragged && this.props.idx === dragged.idx;
		      return isChanging;
		    }
	
		    return false;
		  },
		  isCopyCellChanging: function isCopyCellChanging(nextProps) {
		    var isChanging = void 0;
		    var copied = this.props.cellMetaData.copied;
		    var nextCopied = nextProps.cellMetaData.copied;
		    if (copied) {
		      isChanging = nextCopied && this.props.idx === nextCopied.idx || copied && this.props.idx === copied.idx;
		      return isChanging;
		    }
		    return false;
		  },
		  isDraggedOverUpwards: function isDraggedOverUpwards() {
		    var dragged = this.props.cellMetaData.dragged;
		    return !this.isSelected() && this.isDraggedOver() && this.props.rowIdx < dragged.rowIdx;
		  },
		  isDraggedOverDownwards: function isDraggedOverDownwards() {
		    var dragged = this.props.cellMetaData.dragged;
		    return !this.isSelected() && this.isDraggedOver() && this.props.rowIdx > dragged.rowIdx;
		  },
		  isFocusedOnBody: function isFocusedOnBody() {
		    return document.activeElement == null || document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body';
		  },
		  isFocusedOnCell: function isFocusedOnCell() {
		    return document.activeElement && document.activeElement.className === 'react-grid-Cell';
		  },
		  checkFocus: function checkFocus() {
		    if (this.isSelected() && !this.isActive()) {
		      if (this.props.isScrolling && !this.props.cellMetaData.isScrollingVerticallyWithKeyboard && !this.props.cellMetaData.isScrollingHorizontallyWithKeyboard) {
		        return;
		      }
		      // Only focus to the current cell if the currently active node in the document is within the data grid.
		      // Meaning focus should not be stolen from elements that the grid doesnt control.
		      var dataGridDOMNode = this.props.cellMetaData && this.props.cellMetaData.getDataGridDOMNode ? this.props.cellMetaData.getDataGridDOMNode() : null;
		      if (this.isFocusedOnCell() || this.isFocusedOnBody() || dataGridDOMNode && dataGridDOMNode.contains(document.activeElement)) {
		        var cellDOMNode = ReactDOM.findDOMNode(this);
		        if (cellDOMNode) {
		          cellDOMNode.focus();
		        }
		      }
		    }
		  },
		  canEdit: function canEdit() {
		    return this.props.column.editor != null || this.props.column.editable;
		  },
		  canExpand: function canExpand() {
		    return this.props.expandableOptions && this.props.expandableOptions.canExpand;
		  },
		  createColumEventCallBack: function createColumEventCallBack(onColumnEvent, info) {
		    return function (e) {
		      onColumnEvent(e, info);
		    };
		  },
		  createCellEventCallBack: function createCellEventCallBack(gridEvent, columnEvent) {
		    return function (e) {
		      gridEvent(e);
		      columnEvent(e);
		    };
		  },
		  createEventDTO: function createEventDTO(gridEvents, columnEvents, onColumnEvent) {
		    var allEvents = Object.assign({}, gridEvents);
	
		    for (var eventKey in columnEvents) {
		      if (columnEvents.hasOwnProperty(eventKey)) {
		        var event = columnEvents[event];
		        var eventInfo = { rowIdx: this.props.rowIdx, idx: this.props.idx, name: eventKey };
		        var eventCallback = this.createColumEventCallBack(onColumnEvent, eventInfo);
	
		        if (allEvents.hasOwnProperty(eventKey)) {
		          var currentEvent = allEvents[eventKey];
		          allEvents[eventKey] = this.createCellEventCallBack(currentEvent, eventCallback);
		        } else {
		          allEvents[eventKey] = eventCallback;
		        }
		      }
		    }
	
		    return allEvents;
		  },
		  getEvents: function getEvents() {
		    var columnEvents = this.props.column ? Object.assign({}, this.props.column.events) : undefined;
		    var onColumnEvent = this.props.cellMetaData ? this.props.cellMetaData.onColumnEvent : undefined;
		    var gridEvents = {
		      onClick: this.onCellClick,
		      onDoubleClick: this.onCellDoubleClick,
		      onContextMenu: this.onCellContextMenu,
		      onDragOver: this.onDragOver
		    };
	
		    if (!columnEvents || !onColumnEvent) {
		      return gridEvents;
		    }
	
		    return this.createEventDTO(gridEvents, columnEvents, onColumnEvent);
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  renderCellContent: function renderCellContent(props) {
		    var CellContent = void 0;
		    var Formatter = this.getFormatter();
		    if (React.isValidElement(Formatter)) {
		      props.dependentValues = this.getFormatterDependencies();
		      CellContent = React.cloneElement(Formatter, props);
		    } else if (isFunction(Formatter)) {
		      CellContent = React.createElement(Formatter, { value: this.props.value, dependentValues: this.getFormatterDependencies() });
		    } else {
		      CellContent = React.createElement(SimpleCellFormatter, { value: this.props.value });
		    }
		    var cellExpander = void 0;
		    var marginLeft = this.props.expandableOptions ? this.props.expandableOptions.treeDepth * 30 : 0;
		    if (this.canExpand()) {
		      cellExpander = React.createElement(
		        'span',
		        { style: { float: 'left', marginLeft: marginLeft }, onClick: this.onCellExpand },
		        this.props.expandableOptions.expanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
		      );
		    }
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Cell__value' },
		      cellExpander,
		      React.createElement(
		        'span',
		        null,
		        CellContent
		      ),
		      ' ',
		      this.props.cellControls,
		      ' '
		    );
		  },
		  render: function render() {
		    if (this.props.column.hidden) {
		      return null;
		    }
	
		    var style = this.getStyle();
	
		    var className = this.getCellClass();
	
		    var cellContent = this.renderCellContent({
		      value: this.props.value,
		      column: this.props.column,
		      rowIdx: this.props.rowIdx,
		      isExpanded: this.props.isExpanded
		    });
	
		    var dragHandle = !this.isActive() && ColumnUtils.canEdit(this.props.column, this.props.rowData, this.props.cellMetaData.enableCellSelect) ? React.createElement(
		      'div',
		      { className: 'drag-handle', draggable: 'true', onDoubleClick: this.onDragHandleDoubleClick },
		      React.createElement('span', { style: { display: 'none' } })
		    ) : null;
		    var events = this.getEvents();
		    var tooltip = this.props.tooltip ? React.createElement(
		      'span',
		      { className: 'cell-tooltip-text' },
		      this.props.tooltip
		    ) : null;
	
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: className, style: style }, events),
		      cellContent,
		      dragHandle,
		      tooltip
		    );
		  }
		});
	
		module.exports = Cell;
	
	/***/ },
	/* 60 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var ExcelColumn = __webpack_require__(11);
		var ResizeHandle = __webpack_require__(173);
		__webpack_require__(18);
	
		var PropTypes = React.PropTypes;
	
		function simpleCellRenderer(objArgs) {
		  var headerText = objArgs.column.rowType === 'header' ? objArgs.column.name : '';
		  return React.createElement(
		    'div',
		    { className: 'widget-HeaderCell__value' },
		    headerText
		  );
		}
	
		var HeaderCell = React.createClass({
		  displayName: 'HeaderCell',
	
	
		  propTypes: {
		    renderer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
		    column: PropTypes.shape(ExcelColumn).isRequired,
		    onResize: PropTypes.func.isRequired,
		    height: PropTypes.number.isRequired,
		    onResizeEnd: PropTypes.func.isRequired,
		    className: PropTypes.string
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      renderer: simpleCellRenderer
		    };
		  },
		  getInitialState: function getInitialState() {
		    return { resizing: false };
		  },
		  onDragStart: function onDragStart(e) {
		    this.setState({ resizing: true });
		    // need to set dummy data for FF
		    if (e && e.dataTransfer && e.dataTransfer.setData) e.dataTransfer.setData('text/plain', 'dummy');
		  },
		  onDrag: function onDrag(e) {
		    var resize = this.props.onResize || null; // for flows sake, doesnt recognise a null check direct
		    if (resize) {
		      var _width = this.getWidthFromMouseEvent(e);
		      if (_width > 0) {
		        resize(this.props.column, _width);
		      }
		    }
		  },
		  onDragEnd: function onDragEnd(e) {
		    var width = this.getWidthFromMouseEvent(e);
		    this.props.onResizeEnd(this.props.column, width);
		    this.setState({ resizing: false });
		  },
		  getWidthFromMouseEvent: function getWidthFromMouseEvent(e) {
		    var right = e.pageX || e.touches && e.touches[0] && e.touches[0].pageX || e.changedTouches && e.changedTouches[e.changedTouches.length - 1].pageX;
		    var left = ReactDOM.findDOMNode(this).getBoundingClientRect().left;
		    return right - left;
		  },
		  getCell: function getCell() {
		    if (React.isValidElement(this.props.renderer)) {
		      // if it is a string, it's an HTML element, and column is not a valid property, so only pass height
		      if (typeof this.props.renderer.type === 'string') {
		        return React.cloneElement(this.props.renderer, { height: this.props.height });
		      }
		      return React.cloneElement(this.props.renderer, { column: this.props.column, height: this.props.height });
		    }
		    return this.props.renderer({ column: this.props.column });
		  },
		  getStyle: function getStyle() {
		    return {
		      width: this.props.column.width,
		      left: this.props.column.left,
		      display: 'inline-block',
		      position: 'absolute',
		      height: this.props.height,
		      margin: 0,
		      textOverflow: 'ellipsis',
		      whiteSpace: 'nowrap'
		    };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this);
		    node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		    node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		  },
		  render: function render() {
		    var resizeHandle = void 0;
		    if (this.props.column.resizable) {
		      resizeHandle = React.createElement(ResizeHandle, {
		        onDrag: this.onDrag,
		        onDragStart: this.onDragStart,
		        onDragEnd: this.onDragEnd
		      });
		    }
		    var className = joinClasses({
		      'react-grid-HeaderCell': true,
		      'react-grid-HeaderCell--resizing': this.state.resizing,
		      'react-grid-HeaderCell--locked': this.props.column.locked
		    });
		    className = joinClasses(className, this.props.className, this.props.column.cellClass);
		    var cell = this.getCell();
		    return React.createElement(
		      'div',
		      { className: className, style: this.getStyle() },
		      cell,
		      resizeHandle
		    );
		  }
		});
	
		module.exports = HeaderCell;
	
	/***/ },
	/* 61 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var KeyboardHandlerMixin = {
		  onKeyDown: function onKeyDown(e) {
		    if (this.isCtrlKeyHeldDown(e)) {
		      this.checkAndCall('onPressKeyWithCtrl', e);
		    } else if (this.isKeyExplicitlyHandled(e.key)) {
		      // break up individual keyPress events to have their own specific callbacks
		      // this allows multiple mixins to listen to onKeyDown events and somewhat reduces methodName clashing
		      var callBack = 'onPress' + e.key;
		      this.checkAndCall(callBack, e);
		    } else if (this.isKeyPrintable(e.keyCode)) {
		      this.checkAndCall('onPressChar', e);
		    }
	
		    // Track which keys are currently down for shift clicking etc
		    this._keysDown = this._keysDown || {};
		    this._keysDown[e.keyCode] = true;
		    if (this.props.onGridKeyDown && typeof this.props.onGridKeyDown === 'function') {
		      this.props.onGridKeyDown(e);
		    }
		  },
		  onKeyUp: function onKeyUp(e) {
		    // Track which keys are currently down for shift clicking etc
		    this._keysDown = this._keysDown || {};
		    delete this._keysDown[e.keyCode];
	
		    if (this.props.onGridKeyUp && typeof this.props.onGridKeyUp === 'function') {
		      this.props.onGridKeyUp(e);
		    }
		  },
		  isKeyDown: function isKeyDown(keyCode) {
		    if (!this._keysDown) return false;
		    return keyCode in this._keysDown;
		  },
		  isSingleKeyDown: function isSingleKeyDown(keyCode) {
		    if (!this._keysDown) return false;
		    return keyCode in this._keysDown && Object.keys(this._keysDown).length === 1;
		  },
	
	
		  // taken from http://stackoverflow.com/questions/12467240/determine-if-javascript-e-keycode-is-a-printable-non-control-character
		  isKeyPrintable: function isKeyPrintable(keycode) {
		    var valid = keycode > 47 && keycode < 58 || // number keys
		    keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
		    keycode > 64 && keycode < 91 || // letter keys
		    keycode > 95 && keycode < 112 || // numpad keys
		    keycode > 185 && keycode < 193 || // ;=,-./` (in order)
		    keycode > 218 && keycode < 223; // [\]' (in order)
	
		    return valid;
		  },
		  isKeyExplicitlyHandled: function isKeyExplicitlyHandled(key) {
		    return typeof this['onPress' + key] === 'function';
		  },
		  isCtrlKeyHeldDown: function isCtrlKeyHeldDown(e) {
		    return e.ctrlKey === true && e.key !== 'Control';
		  },
		  checkAndCall: function checkAndCall(methodName, args) {
		    if (typeof this[methodName] === 'function') {
		      this[methodName](args);
		    }
		  }
		};
	
		module.exports = KeyboardHandlerMixin;
	
	/***/ },
	/* 62 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.shouldRowUpdate = undefined;
	
		var _ColumnMetrics = __webpack_require__(33);
	
		var _ColumnMetrics2 = _interopRequireDefault(_ColumnMetrics);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function doesRowContainSelectedCell(props) {
		  var selected = props.cellMetaData.selected;
		  if (selected && selected.rowIdx === props.idx) {
		    return true;
		  }
		  return false;
		}
	
		function willRowBeDraggedOver(props) {
		  var dragged = props.cellMetaData.dragged;
		  return dragged != null && (dragged.rowIdx >= 0 || dragged.complete === true);
		}
	
		function hasRowBeenCopied(props) {
		  var copied = props.cellMetaData.copied;
		  return copied != null && copied.rowIdx === props.idx;
		}
	
		var shouldRowUpdate = exports.shouldRowUpdate = function shouldRowUpdate(nextProps, currentProps) {
		  return !_ColumnMetrics2['default'].sameColumns(currentProps.columns, nextProps.columns, _ColumnMetrics2['default'].sameColumn) || doesRowContainSelectedCell(currentProps) || doesRowContainSelectedCell(nextProps) || willRowBeDraggedOver(nextProps) || nextProps.row !== currentProps.row || currentProps.colDisplayStart !== nextProps.colDisplayStart || currentProps.colDisplayEnd !== nextProps.colDisplayEnd || currentProps.colVisibleStart !== nextProps.colVisibleStart || currentProps.colVisibleEnd !== nextProps.colVisibleEnd || hasRowBeenCopied(currentProps) || currentProps.isSelected !== nextProps.isSelected || nextProps.height !== currentProps.height || currentProps.isOver !== nextProps.isOver || currentProps.canDrop !== nextProps.canDrop || currentProps.forceUpdate === true;
		};
	
		exports['default'] = shouldRowUpdate;
	
	/***/ },
	/* 63 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var RowUtils = {
		  get: function get(row, property) {
		    if (typeof row.get === 'function') {
		      return row.get(property);
		    }
	
		    return row[property];
		  },
		  isRowSelected: function isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx) {
		    if (indexes && Object.prototype.toString.call(indexes) === '[object Array]') {
		      return indexes.indexOf(rowIdx) > -1;
		    } else if (keys && keys.rowKey && keys.values && Object.prototype.toString.call(keys.values) === '[object Array]') {
		      return keys.values.indexOf(rowData[keys.rowKey]) > -1;
		    } else if (isSelectedKey && rowData && typeof isSelectedKey === 'string') {
		      return rowData[isSelectedKey];
		    }
		    return false;
		  }
		};
	
		module.exports = RowUtils;
	
	/***/ },
	/* 64 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.SimpleRowsContainer = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SimpleRowsContainer = function SimpleRowsContainer(props) {
		  return _react2['default'].createElement(
		    'div',
		    { key: 'rows-container', style: { overflow: 'hidden' } },
		    props.rows
		  );
		};
	
		SimpleRowsContainer.propTypes = {
		  width: _react.PropTypes.number,
		  rows: _react.PropTypes.array
		};
	
		var RowsContainer = function (_React$Component) {
		  _inherits(RowsContainer, _React$Component);
	
		  function RowsContainer(props) {
		    _classCallCheck(this, RowsContainer);
	
		    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
		    _this.plugins = props.window ? props.window.ReactDataGridPlugins : window.ReactDataGridPlugins;
		    _this.hasContextMenu = _this.hasContextMenu.bind(_this);
		    _this.renderRowsWithContextMenu = _this.renderRowsWithContextMenu.bind(_this);
		    _this.getContextMenuContainer = _this.getContextMenuContainer.bind(_this);
		    _this.state = { ContextMenuContainer: _this.getContextMenuContainer(props) };
		    return _this;
		  }
	
		  RowsContainer.prototype.getContextMenuContainer = function getContextMenuContainer() {
		    if (this.hasContextMenu()) {
		      if (!this.plugins) {
		        throw new Error('You need to include ReactDataGrid UiPlugins in order to initialise context menu');
		      }
		      return this.plugins.Menu.ContextMenuLayer('reactDataGridContextMenu')(SimpleRowsContainer);
		    }
		  };
	
		  RowsContainer.prototype.hasContextMenu = function hasContextMenu() {
		    return this.props.contextMenu && _react2['default'].isValidElement(this.props.contextMenu);
		  };
	
		  RowsContainer.prototype.renderRowsWithContextMenu = function renderRowsWithContextMenu() {
		    var ContextMenuRowsContainer = this.state.ContextMenuContainer;
		    var newProps = { rowIdx: this.props.rowIdx, idx: this.props.idx };
		    var contextMenu = _react2['default'].cloneElement(this.props.contextMenu, newProps);
		    // Initialise the context menu if it is available
		    return _react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].createElement(ContextMenuRowsContainer, this.props),
		      contextMenu
		    );
		  };
	
		  RowsContainer.prototype.render = function render() {
		    return this.hasContextMenu() ? this.renderRowsWithContextMenu() : _react2['default'].createElement(SimpleRowsContainer, this.props);
		  };
	
		  return RowsContainer;
		}(_react2['default'].Component);
	
		RowsContainer.propTypes = {
		  contextMenu: _react.PropTypes.element,
		  rowIdx: _react.PropTypes.number,
		  idx: _react.PropTypes.number,
		  window: _react.PropTypes.object
		};
	
		exports['default'] = RowsContainer;
		exports.SimpleRowsContainer = SimpleRowsContainer;
	
	/***/ },
	/* 65 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		__webpack_require__(71);
	
		var CheckboxEditor = React.createClass({
		  displayName: 'CheckboxEditor',
	
	
		  propTypes: {
		    value: React.PropTypes.bool,
		    rowIdx: React.PropTypes.number,
		    column: React.PropTypes.shape({
		      key: React.PropTypes.string,
		      onCellChange: React.PropTypes.func
		    }),
		    dependentValues: React.PropTypes.object
		  },
	
		  handleChange: function handleChange(e) {
		    this.props.column.onCellChange(this.props.rowIdx, this.props.column.key, this.props.dependentValues, e);
		  },
		  render: function render() {
		    var checked = this.props.value != null ? this.props.value : false;
		    var checkboxName = 'checkbox' + this.props.rowIdx;
		    return React.createElement(
		      'div',
		      { className: 'react-grid-checkbox-container', onClick: this.handleChange },
		      React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: checkboxName, checked: checked }),
		      React.createElement('label', { htmlFor: checkboxName, className: 'react-grid-checkbox-label' })
		    );
		  }
		});
	
		module.exports = CheckboxEditor;
	
	/***/ },
	/* 66 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var ExcelColumn = __webpack_require__(11);
	
		var EditorBase = function (_React$Component) {
		  _inherits(EditorBase, _React$Component);
	
		  function EditorBase() {
		    _classCallCheck(this, EditorBase);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  EditorBase.prototype.getStyle = function getStyle() {
		    return {
		      width: '100%'
		    };
		  };
	
		  EditorBase.prototype.getValue = function getValue() {
		    var updated = {};
		    updated[this.props.column.key] = this.getInputNode().value;
		    return updated;
		  };
	
		  EditorBase.prototype.getInputNode = function getInputNode() {
		    var domNode = ReactDOM.findDOMNode(this);
		    if (domNode.tagName === 'INPUT') {
		      return domNode;
		    }
	
		    return domNode.querySelector('input:not([type=hidden])');
		  };
	
		  EditorBase.prototype.inheritContainerStyles = function inheritContainerStyles() {
		    return true;
		  };
	
		  return EditorBase;
		}(React.Component);
	
		EditorBase.propTypes = {
		  onKeyDown: React.PropTypes.func.isRequired,
		  value: React.PropTypes.any.isRequired,
		  onBlur: React.PropTypes.func.isRequired,
		  column: React.PropTypes.shape(ExcelColumn).isRequired,
		  commit: React.PropTypes.func.isRequired
		};
	
		module.exports = EditorBase;
	
	/***/ },
	/* 67 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
		var EditorBase = __webpack_require__(66);
	
		var SimpleTextEditor = function (_EditorBase) {
		  _inherits(SimpleTextEditor, _EditorBase);
	
		  function SimpleTextEditor() {
		    _classCallCheck(this, SimpleTextEditor);
	
		    return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
		  }
	
		  SimpleTextEditor.prototype.render = function render() {
		    var _this2 = this;
	
		    return React.createElement('input', { ref: function ref(node) {
		        return _this2.input = node;
		      }, type: 'text', onBlur: this.props.onBlur, className: 'form-control', defaultValue: this.props.value });
		  };
	
		  return SimpleTextEditor;
		}(EditorBase);
	
		module.exports = SimpleTextEditor;
	
	/***/ },
	/* 68 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = function isColumnsImmutable(columns) {
		  return typeof Immutable !== 'undefined' && columns instanceof Immutable.List;
		};
	
	/***/ },
	/* 69 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule shallowEqual
		 * @typechecks
		 * 
		 */
	
		'use strict';
	
		var hasOwnProperty = Object.prototype.hasOwnProperty;
	
		/**
		 * Performs equality by iterating through keys on an object and returning false
		 * when any key has values which are not strictly equal between the arguments.
		 * Returns true when the values of all keys are strictly equal.
		 */
		function shallowEqual(objA, objB) {
		  if (objA === objB) {
		    return true;
		  }
	
		  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
		    return false;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  var bHasOwnProperty = hasOwnProperty.bind(objB);
		  for (var i = 0; i < keysA.length; i++) {
		    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
		module.exports = shallowEqual;
	
	/***/ },
	/* 70 */
	/***/ function(module, exports) {
	
		'use strict';
	
		function ToObject(val) {
			if (val == null) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		module.exports = Object.assign || function (target, source) {
			var from;
			var keys;
			var to = ToObject(target);
	
			for (var s = 1; s < arguments.length; s++) {
				from = arguments[s];
				keys = Object.keys(Object(from));
	
				for (var i = 0; i < keys.length; i++) {
					to[keys[i]] = from[keys[i]];
				}
			}
	
			return to;
		};
	
	
	/***/ },
	/* 71 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(194);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 72 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = isDisposable;
	
		function isDisposable(obj) {
		  return Boolean(obj && typeof obj.dispose === 'function');
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 73 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = ownerDocument;
		function ownerDocument(node) {
		  return node && node.ownerDocument || document;
		}
		module.exports = exports["default"];
	
	/***/ },
	/* 74 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2015, Yahoo! Inc.
		 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
		 */
		'use strict';
	
		var REACT_STATICS = {
		    childContextTypes: true,
		    contextTypes: true,
		    defaultProps: true,
		    displayName: true,
		    getDefaultProps: true,
		    mixins: true,
		    propTypes: true,
		    type: true
		};
	
		var KNOWN_STATICS = {
		    name: true,
		    length: true,
		    prototype: true,
		    caller: true,
		    arguments: true,
		    arity: true
		};
	
		var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
		module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
		    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
		        var keys = Object.getOwnPropertyNames(sourceComponent);
	
		        /* istanbul ignore else */
		        if (isGetOwnPropertySymbolsAvailable) {
		            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
		        }
	
		        for (var i = 0; i < keys.length; ++i) {
		            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
		                try {
		                    targetComponent[keys[i]] = sourceComponent[keys[i]];
		                } catch (error) {
	
		                }
		            }
		        }
		    }
	
		    return targetComponent;
		};
	
	
	/***/ },
	/* 75 */
	[1636, 107, 332, 333],
	/* 76 */
	[1640, 28],
	/* 77 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIndexOf = __webpack_require__(288);
	
		/**
		 * A specialized version of `_.includes` for arrays without support for
		 * specifying an index to search from.
		 *
		 * @private
		 * @param {Array} [array] The array to inspect.
		 * @param {*} target The value to search for.
		 * @returns {boolean} Returns `true` if `target` is found, else `false`.
		 */
		function arrayIncludes(array, value) {
		  var length = array == null ? 0 : array.length;
		  return !!length && baseIndexOf(array, value, 0) > -1;
		}
	
		module.exports = arrayIncludes;
	
	
	/***/ },
	/* 78 */
	/***/ function(module, exports) {
	
		/**
		 * This function is like `arrayIncludes` except that it accepts a comparator.
		 *
		 * @private
		 * @param {Array} [array] The array to inspect.
		 * @param {*} target The value to search for.
		 * @param {Function} comparator The comparator invoked per element.
		 * @returns {boolean} Returns `true` if `target` is found, else `false`.
		 */
		function arrayIncludesWith(array, value, comparator) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    if (comparator(value, array[index])) {
		      return true;
		    }
		  }
		  return false;
		}
	
		module.exports = arrayIncludesWith;
	
	
	/***/ },
	/* 79 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.map` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the new mapped array.
		 */
		function arrayMap(array, iteratee) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      result = Array(length);
	
		  while (++index < length) {
		    result[index] = iteratee(array[index], index, array);
		  }
		  return result;
		}
	
		module.exports = arrayMap;
	
	
	/***/ },
	/* 80 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}
	
		module.exports = baseUnary;
	
	
	/***/ },
	/* 81 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if a `cache` value for `key` exists.
		 *
		 * @private
		 * @param {Object} cache The cache to query.
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function cacheHas(cache, key) {
		  return cache.has(key);
		}
	
		module.exports = cacheHas;
	
	
	/***/ },
	/* 82 */
	[1795, 119, 120],
	/* 83 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _store = __webpack_require__(48);
	
		var _store2 = _interopRequireDefault(_store);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		    getItem: function getItem() {
		        return _store2.default.getState().currentItem;
		    },
		    getPosition: function getPosition() {
		        var _store$getState = _store2.default.getState();
	
		        var x = _store$getState.x;
		        var y = _store$getState.y;
	
	
		        return { x: x, y: y };
		    },
		    hideMenu: function hideMenu() {
		        _store2.default.dispatch({
		            type: "SET_PARAMS",
		            data: {
		                isVisible: false,
		                currentItem: {}
		            }
		        });
		    }
		}; /* eslint-disable object-property-newline */
	
	/***/ },
	/* 84 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		var FILE = exports.FILE = '__NATIVE_FILE__';
		var URL = exports.URL = '__NATIVE_URL__';
		var TEXT = exports.TEXT = '__NATIVE_TEXT__';
	
	/***/ },
	/* 85 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = shallowEqual;
		function shallowEqual(objA, objB) {
		  if (objA === objB) {
		    return true;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  var hasOwn = Object.prototype.hasOwnProperty;
		  for (var i = 0; i < keysA.length; i += 1) {
		    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
		      return false;
		    }
	
		    var valA = objA[keysA[i]];
		    var valB = objB[keysA[i]];
	
		    if (valA !== valB) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
	/***/ },
	/* 86 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.ActionTypes = undefined;
		exports['default'] = createStore;
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _symbolObservable = __webpack_require__(403);
	
		var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		/**
		 * These are private action types reserved by Redux.
		 * For any unknown actions, you must return the current state.
		 * If the current state is undefined, you must return the initial state.
		 * Do not reference these action types directly in your code.
		 */
		var ActionTypes = exports.ActionTypes = {
		  INIT: '@@redux/INIT'
		};
	
		/**
		 * Creates a Redux store that holds the state tree.
		 * The only way to change the data in the store is to call `dispatch()` on it.
		 *
		 * There should only be a single store in your app. To specify how different
		 * parts of the state tree respond to actions, you may combine several reducers
		 * into a single reducer function by using `combineReducers`.
		 *
		 * @param {Function} reducer A function that returns the next state tree, given
		 * the current state tree and the action to handle.
		 *
		 * @param {any} [preloadedState] The initial state. You may optionally specify it
		 * to hydrate the state from the server in universal apps, or to restore a
		 * previously serialized user session.
		 * If you use `combineReducers` to produce the root reducer function, this must be
		 * an object with the same shape as `combineReducers` keys.
		 *
		 * @param {Function} enhancer The store enhancer. You may optionally specify it
		 * to enhance the store with third-party capabilities such as middleware,
		 * time travel, persistence, etc. The only store enhancer that ships with Redux
		 * is `applyMiddleware()`.
		 *
		 * @returns {Store} A Redux store that lets you read the state, dispatch actions
		 * and subscribe to changes.
		 */
		function createStore(reducer, preloadedState, enhancer) {
		  var _ref2;
	
		  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
		    enhancer = preloadedState;
		    preloadedState = undefined;
		  }
	
		  if (typeof enhancer !== 'undefined') {
		    if (typeof enhancer !== 'function') {
		      throw new Error('Expected the enhancer to be a function.');
		    }
	
		    return enhancer(createStore)(reducer, preloadedState);
		  }
	
		  if (typeof reducer !== 'function') {
		    throw new Error('Expected the reducer to be a function.');
		  }
	
		  var currentReducer = reducer;
		  var currentState = preloadedState;
		  var currentListeners = [];
		  var nextListeners = currentListeners;
		  var isDispatching = false;
	
		  function ensureCanMutateNextListeners() {
		    if (nextListeners === currentListeners) {
		      nextListeners = currentListeners.slice();
		    }
		  }
	
		  /**
		   * Reads the state tree managed by the store.
		   *
		   * @returns {any} The current state tree of your application.
		   */
		  function getState() {
		    return currentState;
		  }
	
		  /**
		   * Adds a change listener. It will be called any time an action is dispatched,
		   * and some part of the state tree may potentially have changed. You may then
		   * call `getState()` to read the current state tree inside the callback.
		   *
		   * You may call `dispatch()` from a change listener, with the following
		   * caveats:
		   *
		   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
		   * If you subscribe or unsubscribe while the listeners are being invoked, this
		   * will not have any effect on the `dispatch()` that is currently in progress.
		   * However, the next `dispatch()` call, whether nested or not, will use a more
		   * recent snapshot of the subscription list.
		   *
		   * 2. The listener should not expect to see all state changes, as the state
		   * might have been updated multiple times during a nested `dispatch()` before
		   * the listener is called. It is, however, guaranteed that all subscribers
		   * registered before the `dispatch()` started will be called with the latest
		   * state by the time it exits.
		   *
		   * @param {Function} listener A callback to be invoked on every dispatch.
		   * @returns {Function} A function to remove this change listener.
		   */
		  function subscribe(listener) {
		    if (typeof listener !== 'function') {
		      throw new Error('Expected listener to be a function.');
		    }
	
		    var isSubscribed = true;
	
		    ensureCanMutateNextListeners();
		    nextListeners.push(listener);
	
		    return function unsubscribe() {
		      if (!isSubscribed) {
		        return;
		      }
	
		      isSubscribed = false;
	
		      ensureCanMutateNextListeners();
		      var index = nextListeners.indexOf(listener);
		      nextListeners.splice(index, 1);
		    };
		  }
	
		  /**
		   * Dispatches an action. It is the only way to trigger a state change.
		   *
		   * The `reducer` function, used to create the store, will be called with the
		   * current state tree and the given `action`. Its return value will
		   * be considered the **next** state of the tree, and the change listeners
		   * will be notified.
		   *
		   * The base implementation only supports plain object actions. If you want to
		   * dispatch a Promise, an Observable, a thunk, or something else, you need to
		   * wrap your store creating function into the corresponding middleware. For
		   * example, see the documentation for the `redux-thunk` package. Even the
		   * middleware will eventually dispatch plain object actions using this method.
		   *
		   * @param {Object} action A plain object representing “what changed”. It is
		   * a good idea to keep actions serializable so you can record and replay user
		   * sessions, or use the time travelling `redux-devtools`. An action must have
		   * a `type` property which may not be `undefined`. It is a good idea to use
		   * string constants for action types.
		   *
		   * @returns {Object} For convenience, the same action object you dispatched.
		   *
		   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
		   * return something else (for example, a Promise you can await).
		   */
		  function dispatch(action) {
		    if (!(0, _isPlainObject2['default'])(action)) {
		      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
		    }
	
		    if (typeof action.type === 'undefined') {
		      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
		    }
	
		    if (isDispatching) {
		      throw new Error('Reducers may not dispatch actions.');
		    }
	
		    try {
		      isDispatching = true;
		      currentState = currentReducer(currentState, action);
		    } finally {
		      isDispatching = false;
		    }
	
		    var listeners = currentListeners = nextListeners;
		    for (var i = 0; i < listeners.length; i++) {
		      listeners[i]();
		    }
	
		    return action;
		  }
	
		  /**
		   * Replaces the reducer currently used by the store to calculate the state.
		   *
		   * You might need this if your app implements code splitting and you want to
		   * load some of the reducers dynamically. You might also need this if you
		   * implement a hot reloading mechanism for Redux.
		   *
		   * @param {Function} nextReducer The reducer for the store to use instead.
		   * @returns {void}
		   */
		  function replaceReducer(nextReducer) {
		    if (typeof nextReducer !== 'function') {
		      throw new Error('Expected the nextReducer to be a function.');
		    }
	
		    currentReducer = nextReducer;
		    dispatch({ type: ActionTypes.INIT });
		  }
	
		  /**
		   * Interoperability point for observable/reactive libraries.
		   * @returns {observable} A minimal observable of state changes.
		   * For more information, see the observable proposal:
		   * https://github.com/zenparsing/es-observable
		   */
		  function observable() {
		    var _ref;
	
		    var outerSubscribe = subscribe;
		    return _ref = {
		      /**
		       * The minimal observable subscription method.
		       * @param {Object} observer Any object that can be used as an observer.
		       * The observer object should have a `next` method.
		       * @returns {subscription} An object with an `unsubscribe` method that can
		       * be used to unsubscribe the observable from the store, and prevent further
		       * emission of values from the observable.
		       */
		      subscribe: function subscribe(observer) {
		        if (typeof observer !== 'object') {
		          throw new TypeError('Expected the observer to be an object.');
		        }
	
		        function observeState() {
		          if (observer.next) {
		            observer.next(getState());
		          }
		        }
	
		        observeState();
		        var unsubscribe = outerSubscribe(observeState);
		        return { unsubscribe: unsubscribe };
		      }
		    }, _ref[_symbolObservable2['default']] = function () {
		      return this;
		    }, _ref;
		  }
	
		  // When a store is created, an "INIT" action is dispatched so that every
		  // reducer returns their initial state. This effectively populates
		  // the initial state tree.
		  dispatch({ type: ActionTypes.INIT });
	
		  return _ref2 = {
		    dispatch: dispatch,
		    subscribe: subscribe,
		    getState: getState,
		    replaceReducer: replaceReducer
		  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
		}
	
	/***/ },
	/* 87 */
	[1619, 20, 12],
	/* 88 */
	[1624, 469, 470, 471, 472, 473],
	/* 89 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(13),
		    isSymbol = __webpack_require__(92);
	
		/** Used to match property names within property paths. */
		var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
		    reIsPlainProp = /^\w*$/;
	
		/**
		 * Checks if `value` is a property name and not a property path.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
		 */
		function isKey(value, object) {
		  if (isArray(value)) {
		    return false;
		  }
		  var type = typeof value;
		  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
		      value == null || isSymbol(value)) {
		    return true;
		  }
		  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
		    (object != null && value in Object(object));
		}
	
		module.exports = isKey;
	
	
	/***/ },
	/* 90 */
	/***/ function(module, exports) {
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
	
		module.exports = isLength;
	
	
	/***/ },
	/* 91 */
	29,
	/* 92 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGetTag = __webpack_require__(31),
		    isObjectLike = __webpack_require__(32);
	
		/** `Object#toString` result references. */
		var symbolTag = '[object Symbol]';
	
		/**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */
		function isSymbol(value) {
		  return typeof value == 'symbol' ||
		    (isObjectLike(value) && baseGetTag(value) == symbolTag);
		}
	
		module.exports = isSymbol;
	
	
	/***/ },
	/* 93 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayLikeKeys = __webpack_require__(416),
		    baseKeys = __webpack_require__(433),
		    isArrayLike = __webpack_require__(156);
	
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}
	
		module.exports = keys;
	
	
	/***/ },
	/* 94 */,
	/* 95 */,
	/* 96 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
		//     http://underscorejs.org
		//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
		//     Underscore may be freely distributed under the MIT license.
	
		(function() {
	
		  // Baseline setup
		  // --------------
	
		  // Establish the root object, `window` in the browser, or `exports` on the server.
		  var root = this;
	
		  // Save the previous value of the `_` variable.
		  var previousUnderscore = root._;
	
		  // Save bytes in the minified (but not gzipped) version:
		  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
		  // Create quick reference variables for speed access to core prototypes.
		  var
		    push             = ArrayProto.push,
		    slice            = ArrayProto.slice,
		    toString         = ObjProto.toString,
		    hasOwnProperty   = ObjProto.hasOwnProperty;
	
		  // All **ECMAScript 5** native function implementations that we hope to use
		  // are declared here.
		  var
		    nativeIsArray      = Array.isArray,
		    nativeKeys         = Object.keys,
		    nativeBind         = FuncProto.bind,
		    nativeCreate       = Object.create;
	
		  // Naked function reference for surrogate-prototype-swapping.
		  var Ctor = function(){};
	
		  // Create a safe reference to the Underscore object for use below.
		  var _ = function(obj) {
		    if (obj instanceof _) return obj;
		    if (!(this instanceof _)) return new _(obj);
		    this._wrapped = obj;
		  };
	
		  // Export the Underscore object for **Node.js**, with
		  // backwards-compatibility for the old `require()` API. If we're in
		  // the browser, add `_` as a global object.
		  if (true) {
		    if (typeof module !== 'undefined' && module.exports) {
		      exports = module.exports = _;
		    }
		    exports._ = _;
		  } else {
		    root._ = _;
		  }
	
		  // Current version.
		  _.VERSION = '1.8.3';
	
		  // Internal function that returns an efficient (for current engines) version
		  // of the passed-in callback, to be repeatedly applied in other Underscore
		  // functions.
		  var optimizeCb = function(func, context, argCount) {
		    if (context === void 0) return func;
		    switch (argCount == null ? 3 : argCount) {
		      case 1: return function(value) {
		        return func.call(context, value);
		      };
		      case 2: return function(value, other) {
		        return func.call(context, value, other);
		      };
		      case 3: return function(value, index, collection) {
		        return func.call(context, value, index, collection);
		      };
		      case 4: return function(accumulator, value, index, collection) {
		        return func.call(context, accumulator, value, index, collection);
		      };
		    }
		    return function() {
		      return func.apply(context, arguments);
		    };
		  };
	
		  // A mostly-internal function to generate callbacks that can be applied
		  // to each element in a collection, returning the desired result — either
		  // identity, an arbitrary callback, a property matcher, or a property accessor.
		  var cb = function(value, context, argCount) {
		    if (value == null) return _.identity;
		    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
		    if (_.isObject(value)) return _.matcher(value);
		    return _.property(value);
		  };
		  _.iteratee = function(value, context) {
		    return cb(value, context, Infinity);
		  };
	
		  // An internal function for creating assigner functions.
		  var createAssigner = function(keysFunc, undefinedOnly) {
		    return function(obj) {
		      var length = arguments.length;
		      if (length < 2 || obj == null) return obj;
		      for (var index = 1; index < length; index++) {
		        var source = arguments[index],
		            keys = keysFunc(source),
		            l = keys.length;
		        for (var i = 0; i < l; i++) {
		          var key = keys[i];
		          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
		        }
		      }
		      return obj;
		    };
		  };
	
		  // An internal function for creating a new object that inherits from another.
		  var baseCreate = function(prototype) {
		    if (!_.isObject(prototype)) return {};
		    if (nativeCreate) return nativeCreate(prototype);
		    Ctor.prototype = prototype;
		    var result = new Ctor;
		    Ctor.prototype = null;
		    return result;
		  };
	
		  var property = function(key) {
		    return function(obj) {
		      return obj == null ? void 0 : obj[key];
		    };
		  };
	
		  // Helper for collection methods to determine whether a collection
		  // should be iterated as an array or as an object
		  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
		  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
		  var getLength = property('length');
		  var isArrayLike = function(collection) {
		    var length = getLength(collection);
		    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
		  };
	
		  // Collection Functions
		  // --------------------
	
		  // The cornerstone, an `each` implementation, aka `forEach`.
		  // Handles raw objects in addition to array-likes. Treats all
		  // sparse array-likes as if they were dense.
		  _.each = _.forEach = function(obj, iteratee, context) {
		    iteratee = optimizeCb(iteratee, context);
		    var i, length;
		    if (isArrayLike(obj)) {
		      for (i = 0, length = obj.length; i < length; i++) {
		        iteratee(obj[i], i, obj);
		      }
		    } else {
		      var keys = _.keys(obj);
		      for (i = 0, length = keys.length; i < length; i++) {
		        iteratee(obj[keys[i]], keys[i], obj);
		      }
		    }
		    return obj;
		  };
	
		  // Return the results of applying the iteratee to each element.
		  _.map = _.collect = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length,
		        results = Array(length);
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      results[index] = iteratee(obj[currentKey], currentKey, obj);
		    }
		    return results;
		  };
	
		  // Create a reducing function iterating left or right.
		  function createReduce(dir) {
		    // Optimized iterator function as using arguments.length
		    // in the main function will deoptimize the, see #1991.
		    function iterator(obj, iteratee, memo, keys, index, length) {
		      for (; index >= 0 && index < length; index += dir) {
		        var currentKey = keys ? keys[index] : index;
		        memo = iteratee(memo, obj[currentKey], currentKey, obj);
		      }
		      return memo;
		    }
	
		    return function(obj, iteratee, memo, context) {
		      iteratee = optimizeCb(iteratee, context, 4);
		      var keys = !isArrayLike(obj) && _.keys(obj),
		          length = (keys || obj).length,
		          index = dir > 0 ? 0 : length - 1;
		      // Determine the initial value if none is provided.
		      if (arguments.length < 3) {
		        memo = obj[keys ? keys[index] : index];
		        index += dir;
		      }
		      return iterator(obj, iteratee, memo, keys, index, length);
		    };
		  }
	
		  // **Reduce** builds up a single result from a list of values, aka `inject`,
		  // or `foldl`.
		  _.reduce = _.foldl = _.inject = createReduce(1);
	
		  // The right-associative version of reduce, also known as `foldr`.
		  _.reduceRight = _.foldr = createReduce(-1);
	
		  // Return the first value which passes a truth test. Aliased as `detect`.
		  _.find = _.detect = function(obj, predicate, context) {
		    var key;
		    if (isArrayLike(obj)) {
		      key = _.findIndex(obj, predicate, context);
		    } else {
		      key = _.findKey(obj, predicate, context);
		    }
		    if (key !== void 0 && key !== -1) return obj[key];
		  };
	
		  // Return all the elements that pass a truth test.
		  // Aliased as `select`.
		  _.filter = _.select = function(obj, predicate, context) {
		    var results = [];
		    predicate = cb(predicate, context);
		    _.each(obj, function(value, index, list) {
		      if (predicate(value, index, list)) results.push(value);
		    });
		    return results;
		  };
	
		  // Return all the elements for which a truth test fails.
		  _.reject = function(obj, predicate, context) {
		    return _.filter(obj, _.negate(cb(predicate)), context);
		  };
	
		  // Determine whether all of the elements match a truth test.
		  // Aliased as `all`.
		  _.every = _.all = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length;
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      if (!predicate(obj[currentKey], currentKey, obj)) return false;
		    }
		    return true;
		  };
	
		  // Determine if at least one element in the object matches a truth test.
		  // Aliased as `any`.
		  _.some = _.any = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length;
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      if (predicate(obj[currentKey], currentKey, obj)) return true;
		    }
		    return false;
		  };
	
		  // Determine if the array or object contains a given item (using `===`).
		  // Aliased as `includes` and `include`.
		  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
		    if (!isArrayLike(obj)) obj = _.values(obj);
		    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
		    return _.indexOf(obj, item, fromIndex) >= 0;
		  };
	
		  // Invoke a method (with arguments) on every item in a collection.
		  _.invoke = function(obj, method) {
		    var args = slice.call(arguments, 2);
		    var isFunc = _.isFunction(method);
		    return _.map(obj, function(value) {
		      var func = isFunc ? method : value[method];
		      return func == null ? func : func.apply(value, args);
		    });
		  };
	
		  // Convenience version of a common use case of `map`: fetching a property.
		  _.pluck = function(obj, key) {
		    return _.map(obj, _.property(key));
		  };
	
		  // Convenience version of a common use case of `filter`: selecting only objects
		  // containing specific `key:value` pairs.
		  _.where = function(obj, attrs) {
		    return _.filter(obj, _.matcher(attrs));
		  };
	
		  // Convenience version of a common use case of `find`: getting the first object
		  // containing specific `key:value` pairs.
		  _.findWhere = function(obj, attrs) {
		    return _.find(obj, _.matcher(attrs));
		  };
	
		  // Return the maximum element (or element-based computation).
		  _.max = function(obj, iteratee, context) {
		    var result = -Infinity, lastComputed = -Infinity,
		        value, computed;
		    if (iteratee == null && obj != null) {
		      obj = isArrayLike(obj) ? obj : _.values(obj);
		      for (var i = 0, length = obj.length; i < length; i++) {
		        value = obj[i];
		        if (value > result) {
		          result = value;
		        }
		      }
		    } else {
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index, list) {
		        computed = iteratee(value, index, list);
		        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
		          result = value;
		          lastComputed = computed;
		        }
		      });
		    }
		    return result;
		  };
	
		  // Return the minimum element (or element-based computation).
		  _.min = function(obj, iteratee, context) {
		    var result = Infinity, lastComputed = Infinity,
		        value, computed;
		    if (iteratee == null && obj != null) {
		      obj = isArrayLike(obj) ? obj : _.values(obj);
		      for (var i = 0, length = obj.length; i < length; i++) {
		        value = obj[i];
		        if (value < result) {
		          result = value;
		        }
		      }
		    } else {
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index, list) {
		        computed = iteratee(value, index, list);
		        if (computed < lastComputed || computed === Infinity && result === Infinity) {
		          result = value;
		          lastComputed = computed;
		        }
		      });
		    }
		    return result;
		  };
	
		  // Shuffle a collection, using the modern version of the
		  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
		  _.shuffle = function(obj) {
		    var set = isArrayLike(obj) ? obj : _.values(obj);
		    var length = set.length;
		    var shuffled = Array(length);
		    for (var index = 0, rand; index < length; index++) {
		      rand = _.random(0, index);
		      if (rand !== index) shuffled[index] = shuffled[rand];
		      shuffled[rand] = set[index];
		    }
		    return shuffled;
		  };
	
		  // Sample **n** random values from a collection.
		  // If **n** is not specified, returns a single random element.
		  // The internal `guard` argument allows it to work with `map`.
		  _.sample = function(obj, n, guard) {
		    if (n == null || guard) {
		      if (!isArrayLike(obj)) obj = _.values(obj);
		      return obj[_.random(obj.length - 1)];
		    }
		    return _.shuffle(obj).slice(0, Math.max(0, n));
		  };
	
		  // Sort the object's values by a criterion produced by an iteratee.
		  _.sortBy = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    return _.pluck(_.map(obj, function(value, index, list) {
		      return {
		        value: value,
		        index: index,
		        criteria: iteratee(value, index, list)
		      };
		    }).sort(function(left, right) {
		      var a = left.criteria;
		      var b = right.criteria;
		      if (a !== b) {
		        if (a > b || a === void 0) return 1;
		        if (a < b || b === void 0) return -1;
		      }
		      return left.index - right.index;
		    }), 'value');
		  };
	
		  // An internal function used for aggregate "group by" operations.
		  var group = function(behavior) {
		    return function(obj, iteratee, context) {
		      var result = {};
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index) {
		        var key = iteratee(value, index, obj);
		        behavior(result, value, key);
		      });
		      return result;
		    };
		  };
	
		  // Groups the object's values by a criterion. Pass either a string attribute
		  // to group by, or a function that returns the criterion.
		  _.groupBy = group(function(result, value, key) {
		    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
		  });
	
		  // Indexes the object's values by a criterion, similar to `groupBy`, but for
		  // when you know that your index values will be unique.
		  _.indexBy = group(function(result, value, key) {
		    result[key] = value;
		  });
	
		  // Counts instances of an object that group by a certain criterion. Pass
		  // either a string attribute to count by, or a function that returns the
		  // criterion.
		  _.countBy = group(function(result, value, key) {
		    if (_.has(result, key)) result[key]++; else result[key] = 1;
		  });
	
		  // Safely create a real, live array from anything iterable.
		  _.toArray = function(obj) {
		    if (!obj) return [];
		    if (_.isArray(obj)) return slice.call(obj);
		    if (isArrayLike(obj)) return _.map(obj, _.identity);
		    return _.values(obj);
		  };
	
		  // Return the number of elements in an object.
		  _.size = function(obj) {
		    if (obj == null) return 0;
		    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
		  };
	
		  // Split a collection into two arrays: one whose elements all satisfy the given
		  // predicate, and one whose elements all do not satisfy the predicate.
		  _.partition = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var pass = [], fail = [];
		    _.each(obj, function(value, key, obj) {
		      (predicate(value, key, obj) ? pass : fail).push(value);
		    });
		    return [pass, fail];
		  };
	
		  // Array Functions
		  // ---------------
	
		  // Get the first element of an array. Passing **n** will return the first N
		  // values in the array. Aliased as `head` and `take`. The **guard** check
		  // allows it to work with `_.map`.
		  _.first = _.head = _.take = function(array, n, guard) {
		    if (array == null) return void 0;
		    if (n == null || guard) return array[0];
		    return _.initial(array, array.length - n);
		  };
	
		  // Returns everything but the last entry of the array. Especially useful on
		  // the arguments object. Passing **n** will return all the values in
		  // the array, excluding the last N.
		  _.initial = function(array, n, guard) {
		    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
		  };
	
		  // Get the last element of an array. Passing **n** will return the last N
		  // values in the array.
		  _.last = function(array, n, guard) {
		    if (array == null) return void 0;
		    if (n == null || guard) return array[array.length - 1];
		    return _.rest(array, Math.max(0, array.length - n));
		  };
	
		  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
		  // Especially useful on the arguments object. Passing an **n** will return
		  // the rest N values in the array.
		  _.rest = _.tail = _.drop = function(array, n, guard) {
		    return slice.call(array, n == null || guard ? 1 : n);
		  };
	
		  // Trim out all falsy values from an array.
		  _.compact = function(array) {
		    return _.filter(array, _.identity);
		  };
	
		  // Internal implementation of a recursive `flatten` function.
		  var flatten = function(input, shallow, strict, startIndex) {
		    var output = [], idx = 0;
		    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
		      var value = input[i];
		      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
		        //flatten current level of array or arguments object
		        if (!shallow) value = flatten(value, shallow, strict);
		        var j = 0, len = value.length;
		        output.length += len;
		        while (j < len) {
		          output[idx++] = value[j++];
		        }
		      } else if (!strict) {
		        output[idx++] = value;
		      }
		    }
		    return output;
		  };
	
		  // Flatten out an array, either recursively (by default), or just one level.
		  _.flatten = function(array, shallow) {
		    return flatten(array, shallow, false);
		  };
	
		  // Return a version of the array that does not contain the specified value(s).
		  _.without = function(array) {
		    return _.difference(array, slice.call(arguments, 1));
		  };
	
		  // Produce a duplicate-free version of the array. If the array has already
		  // been sorted, you have the option of using a faster algorithm.
		  // Aliased as `unique`.
		  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
		    if (!_.isBoolean(isSorted)) {
		      context = iteratee;
		      iteratee = isSorted;
		      isSorted = false;
		    }
		    if (iteratee != null) iteratee = cb(iteratee, context);
		    var result = [];
		    var seen = [];
		    for (var i = 0, length = getLength(array); i < length; i++) {
		      var value = array[i],
		          computed = iteratee ? iteratee(value, i, array) : value;
		      if (isSorted) {
		        if (!i || seen !== computed) result.push(value);
		        seen = computed;
		      } else if (iteratee) {
		        if (!_.contains(seen, computed)) {
		          seen.push(computed);
		          result.push(value);
		        }
		      } else if (!_.contains(result, value)) {
		        result.push(value);
		      }
		    }
		    return result;
		  };
	
		  // Produce an array that contains the union: each distinct element from all of
		  // the passed-in arrays.
		  _.union = function() {
		    return _.uniq(flatten(arguments, true, true));
		  };
	
		  // Produce an array that contains every item shared between all the
		  // passed-in arrays.
		  _.intersection = function(array) {
		    var result = [];
		    var argsLength = arguments.length;
		    for (var i = 0, length = getLength(array); i < length; i++) {
		      var item = array[i];
		      if (_.contains(result, item)) continue;
		      for (var j = 1; j < argsLength; j++) {
		        if (!_.contains(arguments[j], item)) break;
		      }
		      if (j === argsLength) result.push(item);
		    }
		    return result;
		  };
	
		  // Take the difference between one array and a number of other arrays.
		  // Only the elements present in just the first array will remain.
		  _.difference = function(array) {
		    var rest = flatten(arguments, true, true, 1);
		    return _.filter(array, function(value){
		      return !_.contains(rest, value);
		    });
		  };
	
		  // Zip together multiple lists into a single array -- elements that share
		  // an index go together.
		  _.zip = function() {
		    return _.unzip(arguments);
		  };
	
		  // Complement of _.zip. Unzip accepts an array of arrays and groups
		  // each array's elements on shared indices
		  _.unzip = function(array) {
		    var length = array && _.max(array, getLength).length || 0;
		    var result = Array(length);
	
		    for (var index = 0; index < length; index++) {
		      result[index] = _.pluck(array, index);
		    }
		    return result;
		  };
	
		  // Converts lists into objects. Pass either a single array of `[key, value]`
		  // pairs, or two parallel arrays of the same length -- one of keys, and one of
		  // the corresponding values.
		  _.object = function(list, values) {
		    var result = {};
		    for (var i = 0, length = getLength(list); i < length; i++) {
		      if (values) {
		        result[list[i]] = values[i];
		      } else {
		        result[list[i][0]] = list[i][1];
		      }
		    }
		    return result;
		  };
	
		  // Generator function to create the findIndex and findLastIndex functions
		  function createPredicateIndexFinder(dir) {
		    return function(array, predicate, context) {
		      predicate = cb(predicate, context);
		      var length = getLength(array);
		      var index = dir > 0 ? 0 : length - 1;
		      for (; index >= 0 && index < length; index += dir) {
		        if (predicate(array[index], index, array)) return index;
		      }
		      return -1;
		    };
		  }
	
		  // Returns the first index on an array-like that passes a predicate test
		  _.findIndex = createPredicateIndexFinder(1);
		  _.findLastIndex = createPredicateIndexFinder(-1);
	
		  // Use a comparator function to figure out the smallest index at which
		  // an object should be inserted so as to maintain order. Uses binary search.
		  _.sortedIndex = function(array, obj, iteratee, context) {
		    iteratee = cb(iteratee, context, 1);
		    var value = iteratee(obj);
		    var low = 0, high = getLength(array);
		    while (low < high) {
		      var mid = Math.floor((low + high) / 2);
		      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
		    }
		    return low;
		  };
	
		  // Generator function to create the indexOf and lastIndexOf functions
		  function createIndexFinder(dir, predicateFind, sortedIndex) {
		    return function(array, item, idx) {
		      var i = 0, length = getLength(array);
		      if (typeof idx == 'number') {
		        if (dir > 0) {
		            i = idx >= 0 ? idx : Math.max(idx + length, i);
		        } else {
		            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
		        }
		      } else if (sortedIndex && idx && length) {
		        idx = sortedIndex(array, item);
		        return array[idx] === item ? idx : -1;
		      }
		      if (item !== item) {
		        idx = predicateFind(slice.call(array, i, length), _.isNaN);
		        return idx >= 0 ? idx + i : -1;
		      }
		      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
		        if (array[idx] === item) return idx;
		      }
		      return -1;
		    };
		  }
	
		  // Return the position of the first occurrence of an item in an array,
		  // or -1 if the item is not included in the array.
		  // If the array is large and already in sort order, pass `true`
		  // for **isSorted** to use binary search.
		  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
		  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
		  // Generate an integer Array containing an arithmetic progression. A port of
		  // the native Python `range()` function. See
		  // [the Python documentation](http://docs.python.org/library/functions.html#range).
		  _.range = function(start, stop, step) {
		    if (stop == null) {
		      stop = start || 0;
		      start = 0;
		    }
		    step = step || 1;
	
		    var length = Math.max(Math.ceil((stop - start) / step), 0);
		    var range = Array(length);
	
		    for (var idx = 0; idx < length; idx++, start += step) {
		      range[idx] = start;
		    }
	
		    return range;
		  };
	
		  // Function (ahem) Functions
		  // ------------------
	
		  // Determines whether to execute a function as a constructor
		  // or a normal function with the provided arguments
		  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
		    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
		    var self = baseCreate(sourceFunc.prototype);
		    var result = sourceFunc.apply(self, args);
		    if (_.isObject(result)) return result;
		    return self;
		  };
	
		  // Create a function bound to a given object (assigning `this`, and arguments,
		  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
		  // available.
		  _.bind = function(func, context) {
		    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
		    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
		    var args = slice.call(arguments, 2);
		    var bound = function() {
		      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
		    };
		    return bound;
		  };
	
		  // Partially apply a function by creating a version that has had some of its
		  // arguments pre-filled, without changing its dynamic `this` context. _ acts
		  // as a placeholder, allowing any combination of arguments to be pre-filled.
		  _.partial = function(func) {
		    var boundArgs = slice.call(arguments, 1);
		    var bound = function() {
		      var position = 0, length = boundArgs.length;
		      var args = Array(length);
		      for (var i = 0; i < length; i++) {
		        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
		      }
		      while (position < arguments.length) args.push(arguments[position++]);
		      return executeBound(func, bound, this, this, args);
		    };
		    return bound;
		  };
	
		  // Bind a number of an object's methods to that object. Remaining arguments
		  // are the method names to be bound. Useful for ensuring that all callbacks
		  // defined on an object belong to it.
		  _.bindAll = function(obj) {
		    var i, length = arguments.length, key;
		    if (length <= 1) throw new Error('bindAll must be passed function names');
		    for (i = 1; i < length; i++) {
		      key = arguments[i];
		      obj[key] = _.bind(obj[key], obj);
		    }
		    return obj;
		  };
	
		  // Memoize an expensive function by storing its results.
		  _.memoize = function(func, hasher) {
		    var memoize = function(key) {
		      var cache = memoize.cache;
		      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
		      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
		      return cache[address];
		    };
		    memoize.cache = {};
		    return memoize;
		  };
	
		  // Delays a function for the given number of milliseconds, and then calls
		  // it with the arguments supplied.
		  _.delay = function(func, wait) {
		    var args = slice.call(arguments, 2);
		    return setTimeout(function(){
		      return func.apply(null, args);
		    }, wait);
		  };
	
		  // Defers a function, scheduling it to run after the current call stack has
		  // cleared.
		  _.defer = _.partial(_.delay, _, 1);
	
		  // Returns a function, that, when invoked, will only be triggered at most once
		  // during a given window of time. Normally, the throttled function will run
		  // as much as it can, without ever going more than once per `wait` duration;
		  // but if you'd like to disable the execution on the leading edge, pass
		  // `{leading: false}`. To disable execution on the trailing edge, ditto.
		  _.throttle = function(func, wait, options) {
		    var context, args, result;
		    var timeout = null;
		    var previous = 0;
		    if (!options) options = {};
		    var later = function() {
		      previous = options.leading === false ? 0 : _.now();
		      timeout = null;
		      result = func.apply(context, args);
		      if (!timeout) context = args = null;
		    };
		    return function() {
		      var now = _.now();
		      if (!previous && options.leading === false) previous = now;
		      var remaining = wait - (now - previous);
		      context = this;
		      args = arguments;
		      if (remaining <= 0 || remaining > wait) {
		        if (timeout) {
		          clearTimeout(timeout);
		          timeout = null;
		        }
		        previous = now;
		        result = func.apply(context, args);
		        if (!timeout) context = args = null;
		      } else if (!timeout && options.trailing !== false) {
		        timeout = setTimeout(later, remaining);
		      }
		      return result;
		    };
		  };
	
		  // Returns a function, that, as long as it continues to be invoked, will not
		  // be triggered. The function will be called after it stops being called for
		  // N milliseconds. If `immediate` is passed, trigger the function on the
		  // leading edge, instead of the trailing.
		  _.debounce = function(func, wait, immediate) {
		    var timeout, args, context, timestamp, result;
	
		    var later = function() {
		      var last = _.now() - timestamp;
	
		      if (last < wait && last >= 0) {
		        timeout = setTimeout(later, wait - last);
		      } else {
		        timeout = null;
		        if (!immediate) {
		          result = func.apply(context, args);
		          if (!timeout) context = args = null;
		        }
		      }
		    };
	
		    return function() {
		      context = this;
		      args = arguments;
		      timestamp = _.now();
		      var callNow = immediate && !timeout;
		      if (!timeout) timeout = setTimeout(later, wait);
		      if (callNow) {
		        result = func.apply(context, args);
		        context = args = null;
		      }
	
		      return result;
		    };
		  };
	
		  // Returns the first function passed as an argument to the second,
		  // allowing you to adjust arguments, run code before and after, and
		  // conditionally execute the original function.
		  _.wrap = function(func, wrapper) {
		    return _.partial(wrapper, func);
		  };
	
		  // Returns a negated version of the passed-in predicate.
		  _.negate = function(predicate) {
		    return function() {
		      return !predicate.apply(this, arguments);
		    };
		  };
	
		  // Returns a function that is the composition of a list of functions, each
		  // consuming the return value of the function that follows.
		  _.compose = function() {
		    var args = arguments;
		    var start = args.length - 1;
		    return function() {
		      var i = start;
		      var result = args[start].apply(this, arguments);
		      while (i--) result = args[i].call(this, result);
		      return result;
		    };
		  };
	
		  // Returns a function that will only be executed on and after the Nth call.
		  _.after = function(times, func) {
		    return function() {
		      if (--times < 1) {
		        return func.apply(this, arguments);
		      }
		    };
		  };
	
		  // Returns a function that will only be executed up to (but not including) the Nth call.
		  _.before = function(times, func) {
		    var memo;
		    return function() {
		      if (--times > 0) {
		        memo = func.apply(this, arguments);
		      }
		      if (times <= 1) func = null;
		      return memo;
		    };
		  };
	
		  // Returns a function that will be executed at most one time, no matter how
		  // often you call it. Useful for lazy initialization.
		  _.once = _.partial(_.before, 2);
	
		  // Object Functions
		  // ----------------
	
		  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
		  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
		  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
		                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
		  function collectNonEnumProps(obj, keys) {
		    var nonEnumIdx = nonEnumerableProps.length;
		    var constructor = obj.constructor;
		    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
		    // Constructor is a special case.
		    var prop = 'constructor';
		    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
		    while (nonEnumIdx--) {
		      prop = nonEnumerableProps[nonEnumIdx];
		      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
		        keys.push(prop);
		      }
		    }
		  }
	
		  // Retrieve the names of an object's own properties.
		  // Delegates to **ECMAScript 5**'s native `Object.keys`
		  _.keys = function(obj) {
		    if (!_.isObject(obj)) return [];
		    if (nativeKeys) return nativeKeys(obj);
		    var keys = [];
		    for (var key in obj) if (_.has(obj, key)) keys.push(key);
		    // Ahem, IE < 9.
		    if (hasEnumBug) collectNonEnumProps(obj, keys);
		    return keys;
		  };
	
		  // Retrieve all the property names of an object.
		  _.allKeys = function(obj) {
		    if (!_.isObject(obj)) return [];
		    var keys = [];
		    for (var key in obj) keys.push(key);
		    // Ahem, IE < 9.
		    if (hasEnumBug) collectNonEnumProps(obj, keys);
		    return keys;
		  };
	
		  // Retrieve the values of an object's properties.
		  _.values = function(obj) {
		    var keys = _.keys(obj);
		    var length = keys.length;
		    var values = Array(length);
		    for (var i = 0; i < length; i++) {
		      values[i] = obj[keys[i]];
		    }
		    return values;
		  };
	
		  // Returns the results of applying the iteratee to each element of the object
		  // In contrast to _.map it returns an object
		  _.mapObject = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    var keys =  _.keys(obj),
		          length = keys.length,
		          results = {},
		          currentKey;
		      for (var index = 0; index < length; index++) {
		        currentKey = keys[index];
		        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
		      }
		      return results;
		  };
	
		  // Convert an object into a list of `[key, value]` pairs.
		  _.pairs = function(obj) {
		    var keys = _.keys(obj);
		    var length = keys.length;
		    var pairs = Array(length);
		    for (var i = 0; i < length; i++) {
		      pairs[i] = [keys[i], obj[keys[i]]];
		    }
		    return pairs;
		  };
	
		  // Invert the keys and values of an object. The values must be serializable.
		  _.invert = function(obj) {
		    var result = {};
		    var keys = _.keys(obj);
		    for (var i = 0, length = keys.length; i < length; i++) {
		      result[obj[keys[i]]] = keys[i];
		    }
		    return result;
		  };
	
		  // Return a sorted list of the function names available on the object.
		  // Aliased as `methods`
		  _.functions = _.methods = function(obj) {
		    var names = [];
		    for (var key in obj) {
		      if (_.isFunction(obj[key])) names.push(key);
		    }
		    return names.sort();
		  };
	
		  // Extend a given object with all the properties in passed-in object(s).
		  _.extend = createAssigner(_.allKeys);
	
		  // Assigns a given object with all the own properties in the passed-in object(s)
		  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
		  _.extendOwn = _.assign = createAssigner(_.keys);
	
		  // Returns the first key on an object that passes a predicate test
		  _.findKey = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = _.keys(obj), key;
		    for (var i = 0, length = keys.length; i < length; i++) {
		      key = keys[i];
		      if (predicate(obj[key], key, obj)) return key;
		    }
		  };
	
		  // Return a copy of the object only containing the whitelisted properties.
		  _.pick = function(object, oiteratee, context) {
		    var result = {}, obj = object, iteratee, keys;
		    if (obj == null) return result;
		    if (_.isFunction(oiteratee)) {
		      keys = _.allKeys(obj);
		      iteratee = optimizeCb(oiteratee, context);
		    } else {
		      keys = flatten(arguments, false, false, 1);
		      iteratee = function(value, key, obj) { return key in obj; };
		      obj = Object(obj);
		    }
		    for (var i = 0, length = keys.length; i < length; i++) {
		      var key = keys[i];
		      var value = obj[key];
		      if (iteratee(value, key, obj)) result[key] = value;
		    }
		    return result;
		  };
	
		   // Return a copy of the object without the blacklisted properties.
		  _.omit = function(obj, iteratee, context) {
		    if (_.isFunction(iteratee)) {
		      iteratee = _.negate(iteratee);
		    } else {
		      var keys = _.map(flatten(arguments, false, false, 1), String);
		      iteratee = function(value, key) {
		        return !_.contains(keys, key);
		      };
		    }
		    return _.pick(obj, iteratee, context);
		  };
	
		  // Fill in a given object with default properties.
		  _.defaults = createAssigner(_.allKeys, true);
	
		  // Creates an object that inherits from the given prototype object.
		  // If additional properties are provided then they will be added to the
		  // created object.
		  _.create = function(prototype, props) {
		    var result = baseCreate(prototype);
		    if (props) _.extendOwn(result, props);
		    return result;
		  };
	
		  // Create a (shallow-cloned) duplicate of an object.
		  _.clone = function(obj) {
		    if (!_.isObject(obj)) return obj;
		    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
		  };
	
		  // Invokes interceptor with the obj, and then returns obj.
		  // The primary purpose of this method is to "tap into" a method chain, in
		  // order to perform operations on intermediate results within the chain.
		  _.tap = function(obj, interceptor) {
		    interceptor(obj);
		    return obj;
		  };
	
		  // Returns whether an object has a given set of `key:value` pairs.
		  _.isMatch = function(object, attrs) {
		    var keys = _.keys(attrs), length = keys.length;
		    if (object == null) return !length;
		    var obj = Object(object);
		    for (var i = 0; i < length; i++) {
		      var key = keys[i];
		      if (attrs[key] !== obj[key] || !(key in obj)) return false;
		    }
		    return true;
		  };
	
	
		  // Internal recursive comparison function for `isEqual`.
		  var eq = function(a, b, aStack, bStack) {
		    // Identical objects are equal. `0 === -0`, but they aren't identical.
		    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
		    if (a === b) return a !== 0 || 1 / a === 1 / b;
		    // A strict comparison is necessary because `null == undefined`.
		    if (a == null || b == null) return a === b;
		    // Unwrap any wrapped objects.
		    if (a instanceof _) a = a._wrapped;
		    if (b instanceof _) b = b._wrapped;
		    // Compare `[[Class]]` names.
		    var className = toString.call(a);
		    if (className !== toString.call(b)) return false;
		    switch (className) {
		      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
		      case '[object RegExp]':
		      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
		      case '[object String]':
		        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
		        // equivalent to `new String("5")`.
		        return '' + a === '' + b;
		      case '[object Number]':
		        // `NaN`s are equivalent, but non-reflexive.
		        // Object(NaN) is equivalent to NaN
		        if (+a !== +a) return +b !== +b;
		        // An `egal` comparison is performed for other numeric values.
		        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
		      case '[object Date]':
		      case '[object Boolean]':
		        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
		        // millisecond representations. Note that invalid dates with millisecond representations
		        // of `NaN` are not equivalent.
		        return +a === +b;
		    }
	
		    var areArrays = className === '[object Array]';
		    if (!areArrays) {
		      if (typeof a != 'object' || typeof b != 'object') return false;
	
		      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
		      // from different frames are.
		      var aCtor = a.constructor, bCtor = b.constructor;
		      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
		                               _.isFunction(bCtor) && bCtor instanceof bCtor)
		                          && ('constructor' in a && 'constructor' in b)) {
		        return false;
		      }
		    }
		    // Assume equality for cyclic structures. The algorithm for detecting cyclic
		    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
		    // Initializing stack of traversed objects.
		    // It's done here since we only need them for objects and arrays comparison.
		    aStack = aStack || [];
		    bStack = bStack || [];
		    var length = aStack.length;
		    while (length--) {
		      // Linear search. Performance is inversely proportional to the number of
		      // unique nested structures.
		      if (aStack[length] === a) return bStack[length] === b;
		    }
	
		    // Add the first object to the stack of traversed objects.
		    aStack.push(a);
		    bStack.push(b);
	
		    // Recursively compare objects and arrays.
		    if (areArrays) {
		      // Compare array lengths to determine if a deep comparison is necessary.
		      length = a.length;
		      if (length !== b.length) return false;
		      // Deep compare the contents, ignoring non-numeric properties.
		      while (length--) {
		        if (!eq(a[length], b[length], aStack, bStack)) return false;
		      }
		    } else {
		      // Deep compare objects.
		      var keys = _.keys(a), key;
		      length = keys.length;
		      // Ensure that both objects contain the same number of properties before comparing deep equality.
		      if (_.keys(b).length !== length) return false;
		      while (length--) {
		        // Deep compare each member
		        key = keys[length];
		        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
		      }
		    }
		    // Remove the first object from the stack of traversed objects.
		    aStack.pop();
		    bStack.pop();
		    return true;
		  };
	
		  // Perform a deep comparison to check if two objects are equal.
		  _.isEqual = function(a, b) {
		    return eq(a, b);
		  };
	
		  // Is a given array, string, or object empty?
		  // An "empty" object has no enumerable own-properties.
		  _.isEmpty = function(obj) {
		    if (obj == null) return true;
		    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
		    return _.keys(obj).length === 0;
		  };
	
		  // Is a given value a DOM element?
		  _.isElement = function(obj) {
		    return !!(obj && obj.nodeType === 1);
		  };
	
		  // Is a given value an array?
		  // Delegates to ECMA5's native Array.isArray
		  _.isArray = nativeIsArray || function(obj) {
		    return toString.call(obj) === '[object Array]';
		  };
	
		  // Is a given variable an object?
		  _.isObject = function(obj) {
		    var type = typeof obj;
		    return type === 'function' || type === 'object' && !!obj;
		  };
	
		  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
		  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
		    _['is' + name] = function(obj) {
		      return toString.call(obj) === '[object ' + name + ']';
		    };
		  });
	
		  // Define a fallback version of the method in browsers (ahem, IE < 9), where
		  // there isn't any inspectable "Arguments" type.
		  if (!_.isArguments(arguments)) {
		    _.isArguments = function(obj) {
		      return _.has(obj, 'callee');
		    };
		  }
	
		  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
		  // IE 11 (#1621), and in Safari 8 (#1929).
		  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
		    _.isFunction = function(obj) {
		      return typeof obj == 'function' || false;
		    };
		  }
	
		  // Is a given object a finite number?
		  _.isFinite = function(obj) {
		    return isFinite(obj) && !isNaN(parseFloat(obj));
		  };
	
		  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
		  _.isNaN = function(obj) {
		    return _.isNumber(obj) && obj !== +obj;
		  };
	
		  // Is a given value a boolean?
		  _.isBoolean = function(obj) {
		    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
		  };
	
		  // Is a given value equal to null?
		  _.isNull = function(obj) {
		    return obj === null;
		  };
	
		  // Is a given variable undefined?
		  _.isUndefined = function(obj) {
		    return obj === void 0;
		  };
	
		  // Shortcut function for checking if an object has a given property directly
		  // on itself (in other words, not on a prototype).
		  _.has = function(obj, key) {
		    return obj != null && hasOwnProperty.call(obj, key);
		  };
	
		  // Utility Functions
		  // -----------------
	
		  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
		  // previous owner. Returns a reference to the Underscore object.
		  _.noConflict = function() {
		    root._ = previousUnderscore;
		    return this;
		  };
	
		  // Keep the identity function around for default iteratees.
		  _.identity = function(value) {
		    return value;
		  };
	
		  // Predicate-generating functions. Often useful outside of Underscore.
		  _.constant = function(value) {
		    return function() {
		      return value;
		    };
		  };
	
		  _.noop = function(){};
	
		  _.property = property;
	
		  // Generates a function for a given object that returns a given property.
		  _.propertyOf = function(obj) {
		    return obj == null ? function(){} : function(key) {
		      return obj[key];
		    };
		  };
	
		  // Returns a predicate for checking whether an object has a given set of
		  // `key:value` pairs.
		  _.matcher = _.matches = function(attrs) {
		    attrs = _.extendOwn({}, attrs);
		    return function(obj) {
		      return _.isMatch(obj, attrs);
		    };
		  };
	
		  // Run a function **n** times.
		  _.times = function(n, iteratee, context) {
		    var accum = Array(Math.max(0, n));
		    iteratee = optimizeCb(iteratee, context, 1);
		    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
		    return accum;
		  };
	
		  // Return a random integer between min and max (inclusive).
		  _.random = function(min, max) {
		    if (max == null) {
		      max = min;
		      min = 0;
		    }
		    return min + Math.floor(Math.random() * (max - min + 1));
		  };
	
		  // A (possibly faster) way to get the current timestamp as an integer.
		  _.now = Date.now || function() {
		    return new Date().getTime();
		  };
	
		   // List of HTML entities for escaping.
		  var escapeMap = {
		    '&': '&amp;',
		    '<': '&lt;',
		    '>': '&gt;',
		    '"': '&quot;',
		    "'": '&#x27;',
		    '`': '&#x60;'
		  };
		  var unescapeMap = _.invert(escapeMap);
	
		  // Functions for escaping and unescaping strings to/from HTML interpolation.
		  var createEscaper = function(map) {
		    var escaper = function(match) {
		      return map[match];
		    };
		    // Regexes for identifying a key that needs to be escaped
		    var source = '(?:' + _.keys(map).join('|') + ')';
		    var testRegexp = RegExp(source);
		    var replaceRegexp = RegExp(source, 'g');
		    return function(string) {
		      string = string == null ? '' : '' + string;
		      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
		    };
		  };
		  _.escape = createEscaper(escapeMap);
		  _.unescape = createEscaper(unescapeMap);
	
		  // If the value of the named `property` is a function then invoke it with the
		  // `object` as context; otherwise, return it.
		  _.result = function(object, property, fallback) {
		    var value = object == null ? void 0 : object[property];
		    if (value === void 0) {
		      value = fallback;
		    }
		    return _.isFunction(value) ? value.call(object) : value;
		  };
	
		  // Generate a unique integer id (unique within the entire client session).
		  // Useful for temporary DOM ids.
		  var idCounter = 0;
		  _.uniqueId = function(prefix) {
		    var id = ++idCounter + '';
		    return prefix ? prefix + id : id;
		  };
	
		  // By default, Underscore uses ERB-style template delimiters, change the
		  // following template settings to use alternative delimiters.
		  _.templateSettings = {
		    evaluate    : /<%([\s\S]+?)%>/g,
		    interpolate : /<%=([\s\S]+?)%>/g,
		    escape      : /<%-([\s\S]+?)%>/g
		  };
	
		  // When customizing `templateSettings`, if you don't want to define an
		  // interpolation, evaluation or escaping regex, we need one that is
		  // guaranteed not to match.
		  var noMatch = /(.)^/;
	
		  // Certain characters need to be escaped so that they can be put into a
		  // string literal.
		  var escapes = {
		    "'":      "'",
		    '\\':     '\\',
		    '\r':     'r',
		    '\n':     'n',
		    '\u2028': 'u2028',
		    '\u2029': 'u2029'
		  };
	
		  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
		  var escapeChar = function(match) {
		    return '\\' + escapes[match];
		  };
	
		  // JavaScript micro-templating, similar to John Resig's implementation.
		  // Underscore templating handles arbitrary delimiters, preserves whitespace,
		  // and correctly escapes quotes within interpolated code.
		  // NB: `oldSettings` only exists for backwards compatibility.
		  _.template = function(text, settings, oldSettings) {
		    if (!settings && oldSettings) settings = oldSettings;
		    settings = _.defaults({}, settings, _.templateSettings);
	
		    // Combine delimiters into one regular expression via alternation.
		    var matcher = RegExp([
		      (settings.escape || noMatch).source,
		      (settings.interpolate || noMatch).source,
		      (settings.evaluate || noMatch).source
		    ].join('|') + '|$', 'g');
	
		    // Compile the template source, escaping string literals appropriately.
		    var index = 0;
		    var source = "__p+='";
		    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
		      source += text.slice(index, offset).replace(escaper, escapeChar);
		      index = offset + match.length;
	
		      if (escape) {
		        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
		      } else if (interpolate) {
		        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
		      } else if (evaluate) {
		        source += "';\n" + evaluate + "\n__p+='";
		      }
	
		      // Adobe VMs need the match returned to produce the correct offest.
		      return match;
		    });
		    source += "';\n";
	
		    // If a variable is not specified, place data values in local scope.
		    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
		    source = "var __t,__p='',__j=Array.prototype.join," +
		      "print=function(){__p+=__j.call(arguments,'');};\n" +
		      source + 'return __p;\n';
	
		    try {
		      var render = new Function(settings.variable || 'obj', '_', source);
		    } catch (e) {
		      e.source = source;
		      throw e;
		    }
	
		    var template = function(data) {
		      return render.call(this, data, _);
		    };
	
		    // Provide the compiled source as a convenience for precompilation.
		    var argument = settings.variable || 'obj';
		    template.source = 'function(' + argument + '){\n' + source + '}';
	
		    return template;
		  };
	
		  // Add a "chain" function. Start chaining a wrapped Underscore object.
		  _.chain = function(obj) {
		    var instance = _(obj);
		    instance._chain = true;
		    return instance;
		  };
	
		  // OOP
		  // ---------------
		  // If Underscore is called as a function, it returns a wrapped object that
		  // can be used OO-style. This wrapper holds altered versions of all the
		  // underscore functions. Wrapped objects may be chained.
	
		  // Helper function to continue chaining intermediate results.
		  var result = function(instance, obj) {
		    return instance._chain ? _(obj).chain() : obj;
		  };
	
		  // Add your own custom functions to the Underscore object.
		  _.mixin = function(obj) {
		    _.each(_.functions(obj), function(name) {
		      var func = _[name] = obj[name];
		      _.prototype[name] = function() {
		        var args = [this._wrapped];
		        push.apply(args, arguments);
		        return result(this, func.apply(_, args));
		      };
		    });
		  };
	
		  // Add all of the Underscore functions to the wrapper object.
		  _.mixin(_);
	
		  // Add all mutator Array functions to the wrapper.
		  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
		    var method = ArrayProto[name];
		    _.prototype[name] = function() {
		      var obj = this._wrapped;
		      method.apply(obj, arguments);
		      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
		      return result(this, obj);
		    };
		  });
	
		  // Add all accessor Array functions to the wrapper.
		  _.each(['concat', 'join', 'slice'], function(name) {
		    var method = ArrayProto[name];
		    _.prototype[name] = function() {
		      return result(this, method.apply(this._wrapped, arguments));
		    };
		  });
	
		  // Extracts the result from a wrapped and chained object.
		  _.prototype.value = function() {
		    return this._wrapped;
		  };
	
		  // Provide unwrapping proxy for some methods used in engine operations
		  // such as arithmetic and JSON stringification.
		  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
		  _.prototype.toString = function() {
		    return '' + this._wrapped;
		  };
	
		  // AMD registration happens at the end for compatibility with AMD loaders
		  // that may not enforce next-turn semantics on modules. Even though general
		  // practice for AMD registration is to be anonymous, underscore registers
		  // as a named module because, like jQuery, it is a base library that is
		  // popular enough to be bundled in a third party lib, but not be part of
		  // an AMD load request. Those cases could generate an error when an
		  // anonymous define() is called outside of a loader request.
		  if (true) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		      return _;
		    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  }
		}.call(this));
	
	
	/***/ },
	/* 97 */,
	/* 98 */,
	/* 99 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reselect = __webpack_require__(397);
	
		var _reactDataGrid = __webpack_require__(3);
	
		var isEmptyArray = _reactDataGrid.utils.isEmptyArray,
		    isEmptyObject = _reactDataGrid.utils.isEmptyObject;
	
		var groupRows = __webpack_require__(209);
		var filterRows = __webpack_require__(208);
		var sortRows = __webpack_require__(211);
	
		var getInputRows = function getInputRows(state) {
		  return state.rows;
		};
		var getFilters = function getFilters(state) {
		  return state.filters;
		};
		var getFilteredRows = (0, _reselect.createSelector)([getFilters, getInputRows], function (filters) {
		  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		  if (!filters || isEmptyObject(filters)) {
		    return rows;
		  }
		  return filterRows(filters, rows);
		});
	
		var getSortColumn = function getSortColumn(state) {
		  return state.sortColumn;
		};
		var getSortDirection = function getSortDirection(state) {
		  return state.sortDirection;
		};
		var getSortedRows = (0, _reselect.createSelector)([getFilteredRows, getSortColumn, getSortDirection], function (rows, sortColumn, sortDirection) {
		  if (!sortDirection && !sortColumn) {
		    return rows;
		  }
		  return sortRows(rows, sortColumn, sortDirection);
		});
	
		var getGroupedColumns = function getGroupedColumns(state) {
		  return state.groupBy;
		};
		var getExpandedRows = function getExpandedRows(state) {
		  return state.expandedRows;
		};
		var getFlattenedGroupedRows = (0, _reselect.createSelector)([getSortedRows, getGroupedColumns, getExpandedRows], function (rows, groupedColumns) {
		  var expandedRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		  if (!groupedColumns || isEmptyObject(groupedColumns) || isEmptyArray(groupedColumns)) {
		    return rows;
		  }
		  return groupRows(rows, groupedColumns, expandedRows);
		});
	
		var getSelectedKeys = function getSelectedKeys(state) {
		  return state.selectedKeys;
		};
		var getRowKey = function getRowKey(state) {
		  return state.rowKey;
		};
		var getSelectedRowsByKey = (0, _reselect.createSelector)([getRowKey, getSelectedKeys, getInputRows], function (rowKey, selectedKeys) {
		  var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
		  return selectedKeys.map(function (k) {
		    return rows.filter(function (r) {
		      return r[rowKey] === k;
		    })[0];
		  });
		});
	
		var Selectors = {
		  getRows: getFlattenedGroupedRows,
		  getSelectedRowsByKey: getSelectedRowsByKey
		};
		module.exports = Selectors;
	
	/***/ },
	/* 100 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _reactDnd = __webpack_require__(16);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var DragItemTypes = _reactDataGrid._constants.DragItemTypes;
	
		var DraggableHeaderCell = function (_Component) {
		  _inherits(DraggableHeaderCell, _Component);
	
		  function DraggableHeaderCell() {
		    _classCallCheck(this, DraggableHeaderCell);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  DraggableHeaderCell.prototype.componentDidMount = function componentDidMount() {
		    var connectDragPreview = this.props.connectDragPreview;
		    var img = new Image();
		    img.src = './assets/images/drag_column_full.png';
		    img.onload = function () {
		      connectDragPreview(img);
		    };
		  };
	
		  DraggableHeaderCell.prototype.setScrollLeft = function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this);
		    node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		    node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		  };
	
		  DraggableHeaderCell.prototype.render = function render() {
		    var _props = this.props,
		        connectDragSource = _props.connectDragSource,
		        isDragging = _props.isDragging;
	
		    if (isDragging) {
		      return null;
		    }
		    return connectDragSource(_react2['default'].createElement(
		      'div',
		      { style: { cursor: 'move' } },
		      _react2['default'].createElement(_reactDataGrid.HeaderCell, this.props)
		    ));
		  };
	
		  return DraggableHeaderCell;
		}(_react.Component);
	
		DraggableHeaderCell.propTypes = {
		  connectDragSource: _react.PropTypes.func.isRequired,
		  connectDragPreview: _react.PropTypes.func.isRequired,
		  isDragging: _react.PropTypes.bool.isRequired
		};
	
		function collect(connect, monitor) {
		  return {
		    connectDragSource: connect.dragSource(),
		    isDragging: monitor.isDragging(),
		    connectDragPreview: connect.dragPreview()
		  };
		}
	
		var headerCellSource = {
		  beginDrag: function beginDrag(props) {
		    return props.column;
		  },
		  endDrag: function endDrag(props) {
		    return props.column;
		  }
		};
	
		exports['default'] = (0, _reactDnd.DragSource)(DragItemTypes.Column, headerCellSource, collect)(DraggableHeaderCell);
	
	/***/ },
	/* 101 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var OWNER_COMPONENT_KEY = 'Owner > component';
		var WASTED_TIME_KEY = 'Wasted time (ms)';
		var WASTED_INSTANCES_KEY = 'Instances';
	
		var SummaryItemModel = function () {
		  function SummaryItemModel(summary) {
		    _classCallCheck(this, SummaryItemModel);
	
		    if ((typeof summary === 'undefined' ? 'undefined' : _typeof(summary)) === 'object') {
		      this._createModel(summary);
		    } else {
		      this._createEmptyModel(summary);
		    }
		  }
	
		  SummaryItemModel.prototype._createModel = function _createModel(summary) {
		    var _getComponentAndOwner2 = this._getComponentAndOwner(summary),
		        owner = _getComponentAndOwner2.owner,
		        component = _getComponentAndOwner2.component;
	
		    this.owner = owner;
		    this.component = component;
		    this.wastedInstances = summary[WASTED_INSTANCES_KEY];
		    this.wastedTime = summary[WASTED_TIME_KEY];
		  };
	
		  SummaryItemModel.prototype._createEmptyModel = function _createEmptyModel(componentName) {
		    this.owner = componentName;
		    this.component = componentName;
		    this.wastedInstances = 0;
		    this.wastedTime = 0;
		  };
	
		  SummaryItemModel.prototype._getComponentAndOwner = function _getComponentAndOwner(summary) {
		    var ownerAndComponent = summary[OWNER_COMPONENT_KEY];
		    var splitOwnerComponent = ownerAndComponent.split('>');
	
		    return {
		      owner: splitOwnerComponent[0].trim(),
		      component: splitOwnerComponent[1].trim()
		    };
		  };
	
		  return SummaryItemModel;
		}();
	
		exports['default'] = SummaryItemModel;
	
	/***/ },
	/* 102 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = dirtyHandlerIds;
		exports.areDirty = areDirty;
	
		var _xor = __webpack_require__(348);
	
		var _xor2 = _interopRequireDefault(_xor);
	
		var _intersection = __webpack_require__(341);
	
		var _intersection2 = _interopRequireDefault(_intersection);
	
		var _dragDrop = __webpack_require__(39);
	
		var _registry = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var NONE = [];
		var ALL = [];
	
		function dirtyHandlerIds() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
		  var action = arguments[1];
		  var dragOperation = arguments[2];
	
		  switch (action.type) {
		    case _dragDrop.HOVER:
		      break;
		    case _registry.ADD_SOURCE:
		    case _registry.ADD_TARGET:
		    case _registry.REMOVE_TARGET:
		    case _registry.REMOVE_SOURCE:
		      return NONE;
		    case _dragDrop.BEGIN_DRAG:
		    case _dragDrop.PUBLISH_DRAG_SOURCE:
		    case _dragDrop.END_DRAG:
		    case _dragDrop.DROP:
		    default:
		      return ALL;
		  }
	
		  var targetIds = action.targetIds;
		  var prevTargetIds = dragOperation.targetIds;
	
		  var result = (0, _xor2.default)(targetIds, prevTargetIds);
	
		  var didChange = false;
		  if (result.length === 0) {
		    for (var i = 0; i < targetIds.length; i++) {
		      if (targetIds[i] !== prevTargetIds[i]) {
		        didChange = true;
		        break;
		      }
		    }
		  } else {
		    didChange = true;
		  }
	
		  if (!didChange) {
		    return NONE;
		  }
	
		  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
		  var innermostTargetId = targetIds[targetIds.length - 1];
	
		  if (prevInnermostTargetId !== innermostTargetId) {
		    if (prevInnermostTargetId) {
		      result.push(prevInnermostTargetId);
		    }
		    if (innermostTargetId) {
		      result.push(innermostTargetId);
		    }
		  }
	
		  return result;
		}
	
		function areDirty(state, handlerIds) {
		  if (state === NONE) {
		    return false;
		  }
	
		  if (state === ALL || typeof handlerIds === 'undefined') {
		    return true;
		  }
	
		  return (0, _intersection2.default)(handlerIds, state).length > 0;
		}
	
	/***/ },
	/* 103 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.default = dragOffset;
		exports.getSourceClientOffset = getSourceClientOffset;
		exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
		var _dragDrop = __webpack_require__(39);
	
		var initialState = {
		  initialSourceClientOffset: null,
		  initialClientOffset: null,
		  clientOffset: null
		};
	
		function areOffsetsEqual(offsetA, offsetB) {
		  if (offsetA === offsetB) {
		    return true;
		  }
		  return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
		}
	
		function dragOffset() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		  var action = arguments[1];
	
		  switch (action.type) {
		    case _dragDrop.BEGIN_DRAG:
		      return {
		        initialSourceClientOffset: action.sourceClientOffset,
		        initialClientOffset: action.clientOffset,
		        clientOffset: action.clientOffset
		      };
		    case _dragDrop.HOVER:
		      if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
		        return state;
		      }
		      return _extends({}, state, {
		        clientOffset: action.clientOffset
		      });
		    case _dragDrop.END_DRAG:
		    case _dragDrop.DROP:
		      return initialState;
		    default:
		      return state;
		  }
		}
	
		function getSourceClientOffset(state) {
		  var clientOffset = state.clientOffset,
		      initialClientOffset = state.initialClientOffset,
		      initialSourceClientOffset = state.initialSourceClientOffset;
	
		  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
		    return null;
		  }
		  return {
		    x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
		    y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
		  };
		}
	
		function getDifferenceFromInitialOffset(state) {
		  var clientOffset = state.clientOffset,
		      initialClientOffset = state.initialClientOffset;
	
		  if (!clientOffset || !initialClientOffset) {
		    return null;
		  }
		  return {
		    x: clientOffset.x - initialClientOffset.x,
		    y: clientOffset.y - initialClientOffset.y
		  };
		}
	
	/***/ },
	/* 104 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = matchesType;
	
		var _isArray = __webpack_require__(19);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function matchesType(targetType, draggedItemType) {
		  if ((0, _isArray2.default)(targetType)) {
		    return targetType.some(function (t) {
		      return t === draggedItemType;
		    });
		  } else {
		    return targetType === draggedItemType;
		  }
		}
	
	/***/ },
	/* 105 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = hasClass;
		function hasClass(element, className) {
		  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
		}
		module.exports = exports["default"];
	
	/***/ },
	/* 106 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = camelizeStyleName;
	
		var _camelize = __webpack_require__(274);
	
		var _camelize2 = _interopRequireDefault(_camelize);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var msPattern = /^-ms-/; /**
		                          * Copyright 2014-2015, Facebook, Inc.
		                          * All rights reserved.
		                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
		                          */
		function camelizeStyleName(string) {
		  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 107 */
	[1624, 322, 323, 324, 325, 326],
	/* 108 */
	/***/ function(module, exports) {
	
		/**
		 * A faster alternative to `Function#apply`, this function invokes `func`
		 * with the `this` binding of `thisArg` and the arguments of `args`.
		 *
		 * @private
		 * @param {Function} func The function to invoke.
		 * @param {*} thisArg The `this` binding of `func`.
		 * @param {Array} args The arguments to invoke `func` with.
		 * @returns {*} Returns the result of `func`.
		 */
		function apply(func, thisArg, args) {
		  switch (args.length) {
		    case 0: return func.call(thisArg);
		    case 1: return func.call(thisArg, args[0]);
		    case 2: return func.call(thisArg, args[0], args[1]);
		    case 3: return func.call(thisArg, args[0], args[1], args[2]);
		  }
		  return func.apply(thisArg, args);
		}
	
		module.exports = apply;
	
	
	/***/ },
	/* 109 */
	[1656, 113],
	/* 110 */
	/***/ function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(75),
		    arrayIncludes = __webpack_require__(77),
		    arrayIncludesWith = __webpack_require__(78),
		    arrayMap = __webpack_require__(79),
		    baseUnary = __webpack_require__(80),
		    cacheHas = __webpack_require__(81);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * The base implementation of methods like `_.difference` without support
		 * for excluding multiple arrays or iteratee shorthands.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {Array} values The values to exclude.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new array of filtered values.
		 */
		function baseDifference(array, values, iteratee, comparator) {
		  var index = -1,
		      includes = arrayIncludes,
		      isCommon = true,
		      length = array.length,
		      result = [],
		      valuesLength = values.length;
	
		  if (!length) {
		    return result;
		  }
		  if (iteratee) {
		    values = arrayMap(values, baseUnary(iteratee));
		  }
		  if (comparator) {
		    includes = arrayIncludesWith;
		    isCommon = false;
		  }
		  else if (values.length >= LARGE_ARRAY_SIZE) {
		    includes = cacheHas;
		    isCommon = false;
		    values = new SetCache(values);
		  }
		  outer:
		  while (++index < length) {
		    var value = array[index],
		        computed = iteratee == null ? value : iteratee(value);
	
		    value = (comparator || value !== 0) ? value : 0;
		    if (isCommon && computed === computed) {
		      var valuesIndex = valuesLength;
		      while (valuesIndex--) {
		        if (values[valuesIndex] === computed) {
		          continue outer;
		        }
		      }
		      result.push(value);
		    }
		    else if (!includes(values, computed, comparator)) {
		      result.push(value);
		    }
		  }
		  return result;
		}
	
		module.exports = baseDifference;
	
	
	/***/ },
	/* 111 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayPush = __webpack_require__(285),
		    isFlattenable = __webpack_require__(312);
	
		/**
		 * The base implementation of `_.flatten` with support for restricting flattening.
		 *
		 * @private
		 * @param {Array} array The array to flatten.
		 * @param {number} depth The maximum recursion depth.
		 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
		 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
		 * @param {Array} [result=[]] The initial result value.
		 * @returns {Array} Returns the new flattened array.
		 */
		function baseFlatten(array, depth, predicate, isStrict, result) {
		  var index = -1,
		      length = array.length;
	
		  predicate || (predicate = isFlattenable);
		  result || (result = []);
	
		  while (++index < length) {
		    var value = array[index];
		    if (depth > 0 && predicate(value)) {
		      if (depth > 1) {
		        // Recursively flatten arrays (susceptible to call stack limits).
		        baseFlatten(value, depth - 1, predicate, isStrict, result);
		      } else {
		        arrayPush(result, value);
		      }
		    } else if (!isStrict) {
		      result[result.length] = value;
		    }
		  }
		  return result;
		}
	
		module.exports = baseFlatten;
	
	
	/***/ },
	/* 112 */
	/***/ function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(75),
		    arrayIncludes = __webpack_require__(77),
		    arrayIncludesWith = __webpack_require__(78),
		    cacheHas = __webpack_require__(81),
		    createSet = __webpack_require__(302),
		    setToArray = __webpack_require__(116);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new duplicate free array.
		 */
		function baseUniq(array, iteratee, comparator) {
		  var index = -1,
		      includes = arrayIncludes,
		      length = array.length,
		      isCommon = true,
		      result = [],
		      seen = result;
	
		  if (comparator) {
		    isCommon = false;
		    includes = arrayIncludesWith;
		  }
		  else if (length >= LARGE_ARRAY_SIZE) {
		    var set = iteratee ? null : createSet(array);
		    if (set) {
		      return setToArray(set);
		    }
		    isCommon = false;
		    includes = cacheHas;
		    seen = new SetCache;
		  }
		  else {
		    seen = iteratee ? [] : result;
		  }
		  outer:
		  while (++index < length) {
		    var value = array[index],
		        computed = iteratee ? iteratee(value) : value;
	
		    value = (comparator || value !== 0) ? value : 0;
		    if (isCommon && computed === computed) {
		      var seenIndex = seen.length;
		      while (seenIndex--) {
		        if (seen[seenIndex] === computed) {
		          continue outer;
		        }
		      }
		      if (iteratee) {
		        seen.push(computed);
		      }
		      result.push(value);
		    }
		    else if (!includes(seen, computed, comparator)) {
		      if (seen !== result) {
		        seen.push(computed);
		      }
		      result.push(value);
		    }
		  }
		  return result;
		}
	
		module.exports = baseUniq;
	
	
	/***/ },
	/* 113 */
	[1688, 44],
	/* 114 */
	/***/ function(module, exports, __webpack_require__) {
	
		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof (window) == 'object' && (window) && (window).Object === Object && (window);
	
		module.exports = freeGlobal;
	
	
	/***/ },
	/* 115 */
	/***/ function(module, exports) {
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;
	
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}
	
		module.exports = isIndex;
	
	
	/***/ },
	/* 116 */
	/***/ function(module, exports) {
	
		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);
	
		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}
	
		module.exports = setToArray;
	
	
	/***/ },
	/* 117 */
	/***/ function(module, exports) {
	
		/**
		 * This method returns the first argument it receives.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 *
		 * console.log(_.identity(object) === object);
		 * // => true
		 */
		function identity(value) {
		  return value;
		}
	
		module.exports = identity;
	
	
	/***/ },
	/* 118 */
	[1789, 290, 30],
	/* 119 */
	[1807, 42, 29],
	/* 120 */
	90,
	/* 121 */
	/***/ function(module, exports) {
	
		/**
		 * This method returns `undefined`.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.3.0
		 * @category Util
		 * @example
		 *
		 * _.times(2, _.noop);
		 * // => [undefined, undefined]
		 */
		function noop() {
		  // No operation performed.
		}
	
		module.exports = noop;
	
	
	/***/ },
	/* 122 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseDifference = __webpack_require__(110),
		    baseRest = __webpack_require__(25),
		    isArrayLikeObject = __webpack_require__(47);
	
		/**
		 * Creates an array excluding all given values using
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * **Note:** Unlike `_.pull`, this method returns a new array.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Array
		 * @param {Array} array The array to inspect.
		 * @param {...*} [values] The values to exclude.
		 * @returns {Array} Returns the new array of filtered values.
		 * @see _.difference, _.xor
		 * @example
		 *
		 * _.without([2, 1, 2, 3], 1, 2);
		 * // => [3]
		 */
		var without = baseRest(function(array, values) {
		  return isArrayLikeObject(array)
		    ? baseDifference(array, values)
		    : [];
		});
	
		module.exports = without;
	
	
	/***/ },
	/* 123 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _contextMenu = __webpack_require__(350);
	
		Object.defineProperty(exports, "ContextMenu", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_contextMenu).default;
		  }
		});
	
		var _contextmenuLayer = __webpack_require__(352);
	
		Object.defineProperty(exports, "ContextMenuLayer", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_contextmenuLayer).default;
		  }
		});
	
		var _menuItem = __webpack_require__(353);
	
		Object.defineProperty(exports, "MenuItem", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_menuItem).default;
		  }
		});
	
		var _monitor = __webpack_require__(83);
	
		Object.defineProperty(exports, "monitor", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_monitor).default;
		  }
		});
	
		var _submenu = __webpack_require__(355);
	
		Object.defineProperty(exports, "SubMenu", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_submenu).default;
		  }
		});
	
		var _connect = __webpack_require__(349);
	
		Object.defineProperty(exports, "connect", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_connect).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ },
	/* 124 */
	51,
	/* 125 */
	/***/ function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
	
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
	
	/***/ },
	/* 126 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.isSafari = exports.isFirefox = undefined;
	
		var _memoize = __webpack_require__(345);
	
		var _memoize2 = _interopRequireDefault(_memoize);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
		  return (/firefox/i.test(navigator.userAgent)
		  );
		});
		var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
		  return Boolean(window.safari);
		});
	
	/***/ },
	/* 127 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getEmptyImage = exports.NativeTypes = undefined;
		exports.default = createHTML5Backend;
	
		var _HTML5Backend = __webpack_require__(358);
	
		var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
	
		var _getEmptyImage = __webpack_require__(362);
	
		var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
	
		var _NativeTypes = __webpack_require__(84);
	
		var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.NativeTypes = NativeTypes;
		exports.getEmptyImage = _getEmptyImage2.default;
		function createHTML5Backend(manager) {
		  return new _HTML5Backend2.default(manager);
		}
	
	/***/ },
	/* 128 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.default = DragDropContext;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _dndCore = __webpack_require__(255);
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _hoistNonReactStatics = __webpack_require__(74);
	
		var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
		var _checkDecoratorArguments = __webpack_require__(49);
	
		var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
		  dragDropManager: _react.PropTypes.object.isRequired
		};
	
		var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
		  return {
		    dragDropManager: new _dndCore.DragDropManager(backend, context)
		  };
		};
	
		var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
		  // Auto-detect ES6 default export for people still using ES5
		  var backend = backendOrModule;
		  if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
		    backend = backend.default;
		  }
		  (0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
		  return backend;
		};
	
		function DragDropContext(backendOrModule) {
		  _checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	
		  var backend = unpackBackendForEs5Users(backendOrModule);
		  var childContext = createChildContext(backend);
	
		  return function decorateContext(DecoratedComponent) {
		    var _class, _temp;
	
		    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		    var DragDropContextContainer = (_temp = _class = function (_Component) {
		      _inherits(DragDropContextContainer, _Component);
	
		      function DragDropContextContainer() {
		        _classCallCheck(this, DragDropContextContainer);
	
		        return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
		      }
	
		      _createClass(DragDropContextContainer, [{
		        key: 'getDecoratedComponentInstance',
		        value: function getDecoratedComponentInstance() {
		          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
		          return this.child;
		        }
		      }, {
		        key: 'getManager',
		        value: function getManager() {
		          return childContext.dragDropManager;
		        }
		      }, {
		        key: 'getChildContext',
		        value: function getChildContext() {
		          return childContext;
		        }
		      }, {
		        key: 'render',
		        value: function render() {
		          var _this2 = this;
	
		          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
		            ref: function ref(child) {
		              return _this2.child = child;
		            }
		          }));
		        }
		      }]);
	
		      return DragDropContextContainer;
		    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
	
	
		    return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
		  };
		}
	
	/***/ },
	/* 129 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = areOptionsEqual;
	
		var _shallowEqual = __webpack_require__(85);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function areOptionsEqual(nextOptions, currentOptions) {
		  if (currentOptions === nextOptions) {
		    return true;
		  }
	
		  return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
		}
	
	/***/ },
	/* 130 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = decorateHandler;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _disposables = __webpack_require__(248);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _hoistNonReactStatics = __webpack_require__(74);
	
		var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
		var _shallowEqual = __webpack_require__(85);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _shallowEqualScalar = __webpack_require__(132);
	
		var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		function decorateHandler(_ref) {
		  var _class, _temp;
	
		  var DecoratedComponent = _ref.DecoratedComponent,
		      createHandler = _ref.createHandler,
		      createMonitor = _ref.createMonitor,
		      createConnector = _ref.createConnector,
		      registerHandler = _ref.registerHandler,
		      containerDisplayName = _ref.containerDisplayName,
		      getType = _ref.getType,
		      collect = _ref.collect,
		      options = _ref.options;
		  var _options$arePropsEqua = options.arePropsEqual,
		      arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
		  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		  var DragDropContainer = (_temp = _class = function (_Component) {
		    _inherits(DragDropContainer, _Component);
	
		    _createClass(DragDropContainer, [{
		      key: 'getHandlerId',
		      value: function getHandlerId() {
		        return this.handlerId;
		      }
		    }, {
		      key: 'getDecoratedComponentInstance',
		      value: function getDecoratedComponentInstance() {
		        return this.decoratedComponentInstance;
		      }
		    }, {
		      key: 'shouldComponentUpdate',
		      value: function shouldComponentUpdate(nextProps, nextState) {
		        return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
		      }
		    }]);
	
		    function DragDropContainer(props, context) {
		      _classCallCheck(this, DragDropContainer);
	
		      var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
	
		      _this.handleChange = _this.handleChange.bind(_this);
		      _this.handleChildRef = _this.handleChildRef.bind(_this);
	
		      (0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
		      _this.manager = _this.context.dragDropManager;
		      _this.handlerMonitor = createMonitor(_this.manager);
		      _this.handlerConnector = createConnector(_this.manager.getBackend());
		      _this.handler = createHandler(_this.handlerMonitor);
	
		      _this.disposable = new _disposables.SerialDisposable();
		      _this.receiveProps(props);
		      _this.state = _this.getCurrentState();
		      _this.dispose();
		      return _this;
		    }
	
		    _createClass(DragDropContainer, [{
		      key: 'componentDidMount',
		      value: function componentDidMount() {
		        this.isCurrentlyMounted = true;
		        this.disposable = new _disposables.SerialDisposable();
		        this.currentType = null;
		        this.receiveProps(this.props);
		        this.handleChange();
		      }
		    }, {
		      key: 'componentWillReceiveProps',
		      value: function componentWillReceiveProps(nextProps) {
		        if (!arePropsEqual(nextProps, this.props)) {
		          this.receiveProps(nextProps);
		          this.handleChange();
		        }
		      }
		    }, {
		      key: 'componentWillUnmount',
		      value: function componentWillUnmount() {
		        this.dispose();
		        this.isCurrentlyMounted = false;
		      }
		    }, {
		      key: 'receiveProps',
		      value: function receiveProps(props) {
		        this.handler.receiveProps(props);
		        this.receiveType(getType(props));
		      }
		    }, {
		      key: 'receiveType',
		      value: function receiveType(type) {
		        if (type === this.currentType) {
		          return;
		        }
	
		        this.currentType = type;
	
		        var _registerHandler = registerHandler(type, this.handler, this.manager),
		            handlerId = _registerHandler.handlerId,
		            unregister = _registerHandler.unregister;
	
		        this.handlerId = handlerId;
		        this.handlerMonitor.receiveHandlerId(handlerId);
		        this.handlerConnector.receiveHandlerId(handlerId);
	
		        var globalMonitor = this.manager.getMonitor();
		        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
		        this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
		      }
		    }, {
		      key: 'handleChange',
		      value: function handleChange() {
		        if (!this.isCurrentlyMounted) {
		          return;
		        }
	
		        var nextState = this.getCurrentState();
		        if (!(0, _shallowEqual2.default)(nextState, this.state)) {
		          this.setState(nextState);
		        }
		      }
		    }, {
		      key: 'dispose',
		      value: function dispose() {
		        this.disposable.dispose();
		        this.handlerConnector.receiveHandlerId(null);
		      }
		    }, {
		      key: 'handleChildRef',
		      value: function handleChildRef(component) {
		        this.decoratedComponentInstance = component;
		        this.handler.receiveComponent(component);
		      }
		    }, {
		      key: 'getCurrentState',
		      value: function getCurrentState() {
		        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
	
		        if (false) {
		          (0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
		        }
	
		        return nextState;
		      }
		    }, {
		      key: 'render',
		      value: function render() {
		        return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
		          ref: this.handleChildRef
		        }));
		      }
		    }]);
	
		    return DragDropContainer;
		  }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
		    dragDropManager: _react.PropTypes.object.isRequired
		  }, _temp);
	
	
		  return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
		}
	
	/***/ },
	/* 131 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		       value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.default = isValidType;
	
		var _isArray = __webpack_require__(19);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function isValidType(type, allowArray) {
		       return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
		              return isValidType(t, false);
		       });
		}
	
	/***/ },
	/* 132 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.default = shallowEqualScalar;
		function shallowEqualScalar(objA, objB) {
		  if (objA === objB) {
		    return true;
		  }
	
		  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
		    return false;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  var hasOwn = Object.prototype.hasOwnProperty;
		  for (var i = 0; i < keysA.length; i += 1) {
		    if (!hasOwn.call(objB, keysA[i])) {
		      return false;
		    }
	
		    var valA = objA[keysA[i]];
		    var valB = objB[keysA[i]];
	
		    if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
		      return false;
		    }
		  }
	
		  return true;
		}
	
	/***/ },
	/* 133 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = wrapConnectorHooks;
	
		var _react = __webpack_require__(2);
	
		var _cloneWithRef = __webpack_require__(376);
	
		var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function throwIfCompositeComponentElement(element) {
		  // Custom components can no longer be wrapped directly in React DnD 2.0
		  // so that we don't need to depend on findDOMNode() from react-dom.
		  if (typeof element.type === 'string') {
		    return;
		  }
	
		  var displayName = element.type.displayName || element.type.name || 'the component';
	
		  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
		}
	
		function wrapHookToRecognizeElement(hook) {
		  return function () {
		    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
		    // When passed a node, call the hook straight away.
		    if (!(0, _react.isValidElement)(elementOrNode)) {
		      var node = elementOrNode;
		      hook(node, options);
		      return undefined;
		    }
	
		    // If passed a ReactElement, clone it and attach this function as a ref.
		    // This helps us achieve a neat API where user doesn't even know that refs
		    // are being used under the hood.
		    var element = elementOrNode;
		    throwIfCompositeComponentElement(element);
	
		    // When no options are passed, use the hook directly
		    var ref = options ? function (node) {
		      return hook(node, options);
		    } : hook;
	
		    return (0, _cloneWithRef2.default)(element, ref);
		  };
		}
	
		function wrapConnectorHooks(hooks) {
		  var wrappedHooks = {};
	
		  Object.keys(hooks).forEach(function (key) {
		    var hook = hooks[key];
		    var wrappedHook = wrapHookToRecognizeElement(hook);
		    wrappedHooks[key] = function () {
		      return wrappedHook;
		    };
		  });
	
		  return wrappedHooks;
		}
	
	/***/ },
	/* 134 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getContainer;
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function getContainer(container, defaultContainer) {
		  container = typeof container === 'function' ? container() : container;
		  return _reactDom2.default.findDOMNode(container) || defaultContainer;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 135 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		exports.default = function (componentOrElement) {
		  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
		};
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _ownerDocument = __webpack_require__(73);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = exports['default'];
	
	/***/ },
	/* 136 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _createChainableTypeChecker = __webpack_require__(137);
	
		var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function validate(props, propName, componentName, location, propFullName) {
		  var propValue = props[propName];
		  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
		  if (_react2.default.isValidElement(propValue)) {
		    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
		  }
	
		  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
		    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
		  }
	
		  return null;
		}
	
		exports.default = (0, _createChainableTypeChecker2.default)(validate);
	
	/***/ },
	/* 137 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.default = createChainableTypeChecker;
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		// Mostly taken from ReactPropTypes.
	
		function createChainableTypeChecker(validate) {
		  function checkType(isRequired, props, propName, componentName, location, propFullName) {
		    var componentNameSafe = componentName || '<<anonymous>>';
		    var propFullNameSafe = propFullName || propName;
	
		    if (props[propName] == null) {
		      if (isRequired) {
		        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
		      }
	
		      return null;
		    }
	
		    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
		      args[_key - 6] = arguments[_key];
		    }
	
		    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
		  }
	
		  var chainedCheckType = checkType.bind(null, false);
		  chainedCheckType.isRequired = checkType.bind(null, true);
	
		  return chainedCheckType;
		}
	
	/***/ },
	/* 138 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _stripDiacritics = __webpack_require__(140);
	
		var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
		function filterOptions(options, filterValue, excludeOptions, props) {
			var _this = this;
	
			if (props.ignoreAccents) {
				filterValue = (0, _stripDiacritics2['default'])(filterValue);
			}
	
			if (props.ignoreCase) {
				filterValue = filterValue.toLowerCase();
			}
	
			if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
				return i[props.valueKey];
			});
	
			return options.filter(function (option) {
				if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
				if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
				if (!filterValue) return true;
				var valueTest = String(option[props.valueKey]);
				var labelTest = String(option[props.labelKey]);
				if (props.ignoreAccents) {
					if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
					if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
				}
				if (props.ignoreCase) {
					if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
					if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
				}
				return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
			});
		}
	
		module.exports = filterOptions;
	
	/***/ },
	/* 139 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _classnames = __webpack_require__(51);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function menuRenderer(_ref) {
			var focusedOption = _ref.focusedOption;
			var instancePrefix = _ref.instancePrefix;
			var labelKey = _ref.labelKey;
			var onFocus = _ref.onFocus;
			var onSelect = _ref.onSelect;
			var optionClassName = _ref.optionClassName;
			var optionComponent = _ref.optionComponent;
			var optionRenderer = _ref.optionRenderer;
			var options = _ref.options;
			var valueArray = _ref.valueArray;
			var valueKey = _ref.valueKey;
			var onOptionRef = _ref.onOptionRef;
	
			var Option = optionComponent;
	
			return options.map(function (option, i) {
				var isSelected = valueArray && valueArray.indexOf(option) > -1;
				var isFocused = option === focusedOption;
				var optionClass = (0, _classnames2['default'])(optionClassName, {
					'Select-option': true,
					'is-selected': isSelected,
					'is-focused': isFocused,
					'is-disabled': option.disabled
				});
	
				return _react2['default'].createElement(
					Option,
					{
						className: optionClass,
						instancePrefix: instancePrefix,
						isDisabled: option.disabled,
						isFocused: isFocused,
						isSelected: isSelected,
						key: 'option-' + i + '-' + option[valueKey],
						onFocus: onFocus,
						onSelect: onSelect,
						option: option,
						optionIndex: i,
						ref: function (ref) {
							onOptionRef(ref, isFocused);
						}
					},
					optionRenderer(option, i)
				);
			});
		}
	
		module.exports = menuRenderer;
	
	/***/ },
	/* 140 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
		module.exports = function stripDiacritics(str) {
			for (var i = 0; i < map.length; i++) {
				str = str.replace(map[i].letters, map[i].base);
			}
			return str;
		};
	
	/***/ },
	/* 141 */
	/***/ function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		exports["default"] = compose;
		/**
		 * Composes single-argument functions from right to left. The rightmost
		 * function can take multiple arguments as it provides the signature for
		 * the resulting composite function.
		 *
		 * @param {...Function} funcs The functions to compose.
		 * @returns {Function} A function obtained by composing the argument functions
		 * from right to left. For example, compose(f, g, h) is identical to doing
		 * (...args) => f(g(h(...args))).
		 */
	
		function compose() {
		  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
		    funcs[_key] = arguments[_key];
		  }
	
		  if (funcs.length === 0) {
		    return function (arg) {
		      return arg;
		    };
		  }
	
		  if (funcs.length === 1) {
		    return funcs[0];
		  }
	
		  var last = funcs[funcs.length - 1];
		  var rest = funcs.slice(0, -1);
		  return function () {
		    return rest.reduceRight(function (composed, f) {
		      return f(composed);
		    }, last.apply(undefined, arguments));
		  };
		}
	
	/***/ },
	/* 142 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = warning;
		/**
		 * Prints a warning in the console if it exists.
		 *
		 * @param {String} message The warning message.
		 * @returns {void}
		 */
		function warning(message) {
		  /* eslint-disable no-console */
		  if (typeof console !== 'undefined' && typeof console.error === 'function') {
		    console.error(message);
		  }
		  /* eslint-enable no-console */
		  try {
		    // This error was thrown as a convenience so that if you enable
		    // "break on all exceptions" in your console,
		    // it would pause the execution at this line.
		    throw new Error(message);
		    /* eslint-disable no-empty */
		  } catch (e) {}
		  /* eslint-enable no-empty */
		}
	
	/***/ },
	/* 143 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(243);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-toolbar.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-toolbar.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 144 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(52),
		    stackClear = __webpack_require__(483),
		    stackDelete = __webpack_require__(484),
		    stackGet = __webpack_require__(485),
		    stackHas = __webpack_require__(486),
		    stackSet = __webpack_require__(487);
	
		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  var data = this.__data__ = new ListCache(entries);
		  this.size = data.size;
		}
	
		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;
	
		module.exports = Stack;
	
	
	/***/ },
	/* 145 */
	/***/ function(module, exports, __webpack_require__) {
	
		var castPath = __webpack_require__(147),
		    toKey = __webpack_require__(57);
	
		/**
		 * The base implementation of `_.get` without support for default values.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @returns {*} Returns the resolved value.
		 */
		function baseGet(object, path) {
		  path = castPath(path, object);
	
		  var index = 0,
		      length = path.length;
	
		  while (object != null && index < length) {
		    object = object[toKey(path[index++])];
		  }
		  return (index && index == length) ? object : undefined;
		}
	
		module.exports = baseGet;
	
	
	/***/ },
	/* 146 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsEqualDeep = __webpack_require__(428),
		    isObjectLike = __webpack_require__(32);
	
		/**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {boolean} bitmask The bitmask flags.
		 *  1 - Unordered comparison
		 *  2 - Partial comparison
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, bitmask, customizer, stack) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
		}
	
		module.exports = baseIsEqual;
	
	
	/***/ },
	/* 147 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArray = __webpack_require__(13),
		    isKey = __webpack_require__(89),
		    stringToPath = __webpack_require__(488),
		    toString = __webpack_require__(497);
	
		/**
		 * Casts `value` to a path array if it's not one.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {Array} Returns the cast property path array.
		 */
		function castPath(value, object) {
		  if (isArray(value)) {
		    return value;
		  }
		  return isKey(value, object) ? [value] : stringToPath(toString(value));
		}
	
		module.exports = castPath;
	
	
	/***/ },
	/* 148 */
	/***/ function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(411),
		    arraySome = __webpack_require__(419),
		    cacheHas = __webpack_require__(441);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      arrLength = array.length,
		      othLength = other.length;
	
		  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(array);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var index = -1,
		      result = true,
		      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
		  stack.set(array, other);
		  stack.set(other, array);
	
		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index];
	
		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, arrValue, index, other, array, stack)
		        : customizer(arrValue, othValue, index, array, other, stack);
		    }
		    if (compared !== undefined) {
		      if (compared) {
		        continue;
		      }
		      result = false;
		      break;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (seen) {
		      if (!arraySome(other, function(othValue, othIndex) {
		            if (!cacheHas(seen, othIndex) &&
		                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
		              return seen.push(othIndex);
		            }
		          })) {
		        result = false;
		        break;
		      }
		    } else if (!(
		          arrValue === othValue ||
		            equalFunc(arrValue, othValue, bitmask, customizer, stack)
		        )) {
		      result = false;
		      break;
		    }
		  }
		  stack['delete'](array);
		  stack['delete'](other);
		  return result;
		}
	
		module.exports = equalArrays;
	
	
	/***/ },
	/* 149 */
	114,
	/* 150 */
	115,
	/* 151 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(91);
	
		/**
		 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` if suitable for strict
		 *  equality comparisons, else `false`.
		 */
		function isStrictComparable(value) {
		  return value === value && !isObject(value);
		}
	
		module.exports = isStrictComparable;
	
	
	/***/ },
	/* 152 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `matchesProperty` for source values suitable
		 * for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function matchesStrictComparable(key, srcValue) {
		  return function(object) {
		    if (object == null) {
		      return false;
		    }
		    return object[key] === srcValue &&
		      (srcValue !== undefined || (key in Object(object)));
		  };
		}
	
		module.exports = matchesStrictComparable;
	
	
	/***/ },
	/* 153 */
	/***/ function(module, exports) {
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to convert.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}
	
		module.exports = toSource;
	
	
	/***/ },
	/* 154 */
	46,
	/* 155 */
	[1789, 427, 32],
	/* 156 */
	[1795, 158, 90],
	/* 157 */
	[1801, 12, 496],
	/* 158 */
	[1807, 31, 91],
	/* 159 */
	[1810, 431, 440, 477],
	/* 160 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _shallowEqual = __webpack_require__(69);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _RowsContainer = __webpack_require__(64);
	
		var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
	
		var _RowGroup = __webpack_require__(174);
	
		var _RowGroup2 = _interopRequireDefault(_RowGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var PropTypes = React.PropTypes;
		var ScrollShim = __webpack_require__(175);
		var Row = __webpack_require__(34);
		var cellMetaDataShape = __webpack_require__(14);
		var RowUtils = __webpack_require__(63);
		__webpack_require__(26);
	
		var Canvas = React.createClass({
		  displayName: 'Canvas',
	
		  mixins: [ScrollShim],
	
		  propTypes: {
		    rowRenderer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
		    rowHeight: PropTypes.number.isRequired,
		    height: PropTypes.number.isRequired,
		    width: PropTypes.number,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    style: PropTypes.string,
		    className: PropTypes.string,
		    displayStart: PropTypes.number.isRequired,
		    displayEnd: PropTypes.number.isRequired,
		    visibleStart: PropTypes.number.isRequired,
		    visibleEnd: PropTypes.number.isRequired,
		    colVisibleStart: PropTypes.number.isRequired,
		    colVisibleEnd: PropTypes.number.isRequired,
		    colDisplayStart: PropTypes.number.isRequired,
		    colDisplayEnd: PropTypes.number.isRequired,
		    rowsCount: PropTypes.number.isRequired,
		    rowGetter: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.array.isRequired]),
		    expandedRows: PropTypes.array,
		    onRows: PropTypes.func,
		    onScroll: PropTypes.func,
		    columns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
		    cellMetaData: PropTypes.shape(cellMetaDataShape).isRequired,
		    selectedRows: PropTypes.array,
		    rowKey: React.PropTypes.string,
		    rowScrollTimeout: React.PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    rowGroupRenderer: React.PropTypes.func,
		    isScrolling: React.PropTypes.bool
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowRenderer: Row,
		      onRows: function onRows() {},
		      selectedRows: [],
		      rowScrollTimeout: 0
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      displayStart: this.props.displayStart,
		      displayEnd: this.props.displayEnd,
		      scrollingTimeout: null
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._currentRowsLength = 0;
		    this._currentRowsRange = { start: 0, end: 0 };
		    this._scroll = { scrollTop: 0, scrollLeft: 0 };
		  },
		  componentDidMount: function componentDidMount() {
		    this.onRows();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.displayStart !== this.state.displayStart || nextProps.displayEnd !== this.state.displayEnd) {
		      this.setState({
		        displayStart: nextProps.displayStart,
		        displayEnd: nextProps.displayEnd
		      });
		    }
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		    var shouldUpdate = nextState.displayStart !== this.state.displayStart || nextState.displayEnd !== this.state.displayEnd || nextState.scrollingTimeout !== this.state.scrollingTimeout || nextProps.rowsCount !== this.props.rowsCount || nextProps.rowHeight !== this.props.rowHeight || nextProps.columns !== this.props.columns || nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.cellMetaData !== this.props.cellMetaData || this.props.colDisplayStart !== nextProps.colDisplayStart || this.props.colDisplayEnd !== nextProps.colDisplayEnd || this.props.colVisibleStart !== nextProps.colVisibleStart || this.props.colVisibleEnd !== nextProps.colVisibleEnd || !(0, _shallowEqual2['default'])(nextProps.style, this.props.style);
		    return shouldUpdate;
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._currentRowsLength = 0;
		    this._currentRowsRange = { start: 0, end: 0 };
		    this._scroll = { scrollTop: 0, scrollLeft: 0 };
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    if (this._scroll.scrollTop !== 0 && this._scroll.scrollLeft !== 0) {
		      this.setScrollLeft(this._scroll.scrollLeft);
		    }
		    this.onRows();
		  },
		  onRows: function onRows() {
		    if (this._currentRowsRange !== { start: 0, end: 0 }) {
		      this.props.onRows(this._currentRowsRange);
		      this._currentRowsRange = { start: 0, end: 0 };
		    }
		  },
		  onScroll: function onScroll(e) {
		    if (ReactDOM.findDOMNode(this) !== e.target) {
		      return;
		    }
		    this.appendScrollShim();
		    var scrollLeft = e.target.scrollLeft;
		    var scrollTop = e.target.scrollTop;
		    var scroll = { scrollTop: scrollTop, scrollLeft: scrollLeft };
		    this._scroll = scroll;
		    this.props.onScroll(scroll);
		  },
		  getSubRows: function getSubRows(row) {
		    var subRowDetails = this.props.getSubRowDetails(row);
		    if (subRowDetails.expanded === true) {
		      return subRowDetails.children.map(function (r) {
		        return { row: r };
		      });
		    }
		  },
		  addSubRows: function addSubRows(rowsInput, row, i, displayEnd, treeDepth) {
		    var _this = this;
	
		    var subRowDetails = this.props.getSubRowDetails(row) || {};
		    var rows = rowsInput;
		    var increment = i;
		    if (increment < displayEnd) {
		      subRowDetails.treeDepth = treeDepth;
		      rows.push({ row: row, subRowDetails: subRowDetails });
		      increment++;
		    }
		    if (subRowDetails && subRowDetails.expanded) {
		      var subRows = this.getSubRows(row);
		      subRows.forEach(function (sr) {
		        var result = _this.addSubRows(rows, sr.row, increment, displayEnd, treeDepth + 1);
		        rows = result.rows;
		        increment = result.increment;
		      });
		    }
		    return { rows: rows, increment: increment };
		  },
		  getRows: function getRows(displayStart, displayEnd) {
		    this._currentRowsRange = { start: displayStart, end: displayEnd };
		    if (Array.isArray(this.props.rowGetter)) {
		      return this.props.rowGetter.slice(displayStart, displayEnd);
		    }
		    var rows = [];
		    var rowFetchIndex = displayStart;
		    var i = displayStart;
		    while (i < displayEnd) {
		      var row = this.props.rowGetter(rowFetchIndex);
		      if (this.props.getSubRowDetails) {
		        var treeDepth = 0;
		        var result = this.addSubRows(rows, row, i, displayEnd, treeDepth);
		        rows = result.rows;
		        i = result.increment;
		      } else {
		        rows.push({ row: row });
		        i++;
		      }
		      rowFetchIndex++;
		    }
		    return rows;
		  },
		  getScrollbarWidth: function getScrollbarWidth() {
		    var scrollbarWidth = 0;
		    // Get the scrollbar width
		    var canvas = ReactDOM.findDOMNode(this);
		    scrollbarWidth = canvas.offsetWidth - canvas.clientWidth;
		    return scrollbarWidth;
		  },
		  getScroll: function getScroll() {
		    var _ReactDOM$findDOMNode = ReactDOM.findDOMNode(this),
		        scrollTop = _ReactDOM$findDOMNode.scrollTop,
		        scrollLeft = _ReactDOM$findDOMNode.scrollLeft;
	
		    return { scrollTop: scrollTop, scrollLeft: scrollLeft };
		  },
		  isRowSelected: function isRowSelected(idx, row) {
		    var _this2 = this;
	
		    // Use selectedRows if set
		    if (this.props.selectedRows !== null) {
		      var selectedRows = this.props.selectedRows.filter(function (r) {
		        var rowKeyValue = row.get ? row.get(_this2.props.rowKey) : row[_this2.props.rowKey];
		        return r[_this2.props.rowKey] === rowKeyValue;
		      });
		      return selectedRows.length > 0 && selectedRows[0].isSelected;
		    }
	
		    // Else use new rowSelection props
		    if (this.props.rowSelection) {
		      var _props$rowSelection = this.props.rowSelection,
		          keys = _props$rowSelection.keys,
		          indexes = _props$rowSelection.indexes,
		          isSelectedKey = _props$rowSelection.isSelectedKey;
	
		      return RowUtils.isRowSelected(keys, indexes, isSelectedKey, row, idx);
		    }
	
		    return false;
		  },
	
	
		  _currentRowsLength: 0,
		  _currentRowsRange: { start: 0, end: 0 },
		  _scroll: { scrollTop: 0, scrollLeft: 0 },
	
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    if (this._currentRowsLength !== 0) {
		      if (!this.rows) return;
		      for (var i = 0, len = this._currentRowsLength; i < len; i++) {
		        if (this.rows[i]) {
		          var row = this.getRowByRef(i);
		          if (row && row.setScrollLeft) {
		            row.setScrollLeft(scrollLeft);
		          }
		        }
		      }
		    }
		  },
		  getRowByRef: function getRowByRef(i) {
		    // check if wrapped with React DND drop target
		    var wrappedRow = this.rows[i].getDecoratedComponentInstance ? this.rows[i].getDecoratedComponentInstance(i) : null;
		    if (wrappedRow) {
		      return wrappedRow.row;
		    }
		    return this.rows[i];
		  },
	
	
		  rows: [],
	
		  renderRow: function renderRow(props) {
		    var row = props.row;
		    if (row.__metaData && row.__metaData.isGroup) {
		      return React.createElement(_RowGroup2['default'], _extends({
		        key: props.key,
		        name: row.name
		      }, row.__metaData, {
		        row: props.row,
		        idx: props.idx,
		        height: props.height,
		        cellMetaData: this.props.cellMetaData,
		        renderer: this.props.rowGroupRenderer
		      }));
		    }
		    var RowsRenderer = this.props.rowRenderer;
		    if (typeof RowsRenderer === 'function') {
		      return React.createElement(RowsRenderer, props);
		    }
	
		    if (React.isValidElement(this.props.rowRenderer)) {
		      return React.cloneElement(this.props.rowRenderer, props);
		    }
		  },
		  renderPlaceholder: function renderPlaceholder(key, height) {
		    // just renders empty cells
		    // if we wanted to show gridlines, we'd need classes and position as with renderScrollingPlaceholder
		    return React.createElement(
		      'div',
		      { key: key, style: { height: height } },
		      this.props.columns.map(function (column, idx) {
		        return React.createElement('div', { style: { width: column.width }, key: idx });
		      })
		    );
		  },
		  render: function render() {
		    var _this3 = this;
	
		    var _state = this.state,
		        displayStart = _state.displayStart,
		        displayEnd = _state.displayEnd;
		    var _props = this.props,
		        rowHeight = _props.rowHeight,
		        rowsCount = _props.rowsCount;
	
	
		    var rows = this.getRows(displayStart, displayEnd).map(function (r, idx) {
		      return _this3.renderRow({
		        key: 'row-' + (displayStart + idx),
		        ref: function ref(node) {
		          return _this3.rows[idx] = node;
		        },
		        idx: displayStart + idx,
		        visibleStart: _this3.props.visibleStart,
		        visibleEnd: _this3.props.visibleEnd,
		        row: r.row,
		        height: rowHeight,
		        onMouseOver: _this3.onMouseOver,
		        columns: _this3.props.columns,
		        isSelected: _this3.isRowSelected(displayStart + idx, r.row, displayStart, displayEnd),
		        expandedRows: _this3.props.expandedRows,
		        cellMetaData: _this3.props.cellMetaData,
		        subRowDetails: r.subRowDetails,
		        colVisibleStart: _this3.props.colVisibleStart,
		        colVisibleEnd: _this3.props.colVisibleEnd,
		        colDisplayStart: _this3.props.colDisplayStart,
		        colDisplayEnd: _this3.props.colDisplayEnd,
		        isScrolling: _this3.props.isScrolling
		      });
		    });
	
		    this._currentRowsLength = rows.length;
	
		    if (displayStart > 0) {
		      rows.unshift(this.renderPlaceholder('top', displayStart * rowHeight));
		    }
	
		    if (rowsCount - displayEnd > 0) {
		      rows.push(this.renderPlaceholder('bottom', (rowsCount - displayEnd) * rowHeight));
		    }
	
		    var style = {
		      position: 'absolute',
		      top: 0,
		      left: 0,
		      overflowX: 'auto',
		      overflowY: 'scroll',
		      width: this.props.totalWidth,
		      height: this.props.height
		    };
	
		    return React.createElement(
		      'div',
		      {
		        style: style,
		        onScroll: this.onScroll,
		        className: joinClasses('react-grid-Canvas', this.props.className, { opaque: this.props.cellMetaData.selected && this.props.cellMetaData.selected.active }) },
		      React.createElement(_RowsContainer2['default'], {
		        width: this.props.width,
		        rows: rows,
		        contextMenu: this.props.contextMenu,
		        rowIdx: this.props.cellMetaData.selected.rowIdx,
		        idx: this.props.cellMetaData.selected.idx })
		    );
		  }
		});
	
		module.exports = Canvas;
	
	/***/ },
	/* 161 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isValidElement = __webpack_require__(2).isValidElement;
	
		module.exports = function sameColumn(a, b) {
		  var k = void 0;
	
		  for (k in a) {
		    if (a.hasOwnProperty(k)) {
		      if (typeof a[k] === 'function' && typeof b[k] === 'function' || isValidElement(a[k]) && isValidElement(b[k])) {
		        continue;
		      }
		      if (!b.hasOwnProperty(k) || a[k] !== b[k]) {
		        return false;
		      }
		    }
		  }
	
		  for (k in b) {
		    if (b.hasOwnProperty(k) && !a.hasOwnProperty(k)) {
		      return false;
		    }
		  }
	
		  return true;
		};
	
	/***/ },
	/* 162 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ColumnMetrics = __webpack_require__(33);
		var DOMMetrics = __webpack_require__(22);
		Object.assign = __webpack_require__(70);
		var PropTypes = __webpack_require__(2).PropTypes;
		var ColumnUtils = __webpack_require__(10);
	
		var Column = function Column() {
		  _classCallCheck(this, Column);
		};
	
		module.exports = {
		  mixins: [DOMMetrics.MetricsMixin],
	
		  propTypes: {
		    columns: PropTypes.arrayOf(Column),
		    minColumnWidth: PropTypes.number,
		    columnEquality: PropTypes.func,
		    onColumnResize: PropTypes.func
		  },
	
		  DOMMetrics: {
		    gridWidth: function gridWidth() {
		      return _reactDom2['default'].findDOMNode(this).parentElement.offsetWidth;
		    }
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      minColumnWidth: 80,
		      columnEquality: ColumnMetrics.sameColumn
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._mounted = true;
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.columns) {
		      if (!ColumnMetrics.sameColumns(this.props.columns, nextProps.columns, this.props.columnEquality) || nextProps.minWidth !== this.props.minWidth) {
		        var columnMetrics = this.createColumnMetrics(nextProps);
		        this.setState({ columnMetrics: columnMetrics });
		      }
		    }
		  },
		  getTotalWidth: function getTotalWidth() {
		    var totalWidth = 0;
		    if (this._mounted) {
		      totalWidth = this.DOMMetrics.gridWidth();
		    } else {
		      totalWidth = ColumnUtils.getSize(this.props.columns) * this.props.minColumnWidth;
		    }
		    return totalWidth;
		  },
		  getColumnMetricsType: function getColumnMetricsType(metrics) {
		    var totalWidth = metrics.totalWidth || this.getTotalWidth();
		    var currentMetrics = {
		      columns: metrics.columns,
		      totalWidth: totalWidth,
		      minColumnWidth: metrics.minColumnWidth
		    };
		    var updatedMetrics = ColumnMetrics.recalculate(currentMetrics);
		    return updatedMetrics;
		  },
		  getColumn: function getColumn(idx) {
		    var columns = this.state.columnMetrics.columns;
		    if (Array.isArray(columns)) {
		      return columns[idx];
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.get(idx);
		    }
		  },
		  getSize: function getSize() {
		    var columns = this.state.columnMetrics.columns;
		    if (Array.isArray(columns)) {
		      return columns.length;
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.size;
		    }
		  },
		  metricsUpdated: function metricsUpdated() {
		    var columnMetrics = this.createColumnMetrics();
		    this.setState({ columnMetrics: columnMetrics });
		  },
		  createColumnMetrics: function createColumnMetrics() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
		    var gridColumns = this.setupGridColumns(props);
		    return this.getColumnMetricsType({
		      columns: gridColumns,
		      minColumnWidth: this.props.minColumnWidth,
		      totalWidth: props.minWidth
		    });
		  },
		  onColumnResize: function onColumnResize(index, width) {
		    var columnMetrics = ColumnMetrics.resizeColumn(this.state.columnMetrics, index, width);
		    this.setState({ columnMetrics: columnMetrics });
		    if (this.props.onColumnResize) {
		      this.props.onColumnResize(index, width);
		    }
		  }
		};
	
	/***/ },
	/* 163 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(18);
	
		// The list of the propTypes that we want to include in the Draggable div
		var knownDivPropertyKeys = ['onDragStart', 'onDragEnd', 'onDrag', 'style'];
	
		var Draggable = React.createClass({
		  displayName: 'Draggable',
	
		  propTypes: {
		    onDragStart: PropTypes.func,
		    onDragEnd: PropTypes.func,
		    onDrag: PropTypes.func,
		    component: PropTypes.oneOfType([PropTypes.func, PropTypes.constructor]),
		    style: PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      onDragStart: function onDragStart() {
		        return true;
		      },
		      onDragEnd: function onDragEnd() {},
		      onDrag: function onDrag() {}
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      drag: null
		    };
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this.cleanUp();
		  },
		  onMouseDown: function onMouseDown(e) {
		    var drag = this.props.onDragStart(e);
	
		    if (drag === null && e.button !== 0) {
		      return;
		    }
	
		    window.addEventListener('mouseup', this.onMouseUp);
		    window.addEventListener('mousemove', this.onMouseMove);
		    window.addEventListener('touchend', this.onMouseUp);
		    window.addEventListener('touchmove', this.onMouseMove);
	
		    this.setState({ drag: drag });
		  },
		  onMouseMove: function onMouseMove(e) {
		    if (this.state.drag === null) {
		      return;
		    }
	
		    if (e.preventDefault) {
		      e.preventDefault();
		    }
	
		    this.props.onDrag(e);
		  },
		  onMouseUp: function onMouseUp(e) {
		    this.cleanUp();
		    this.props.onDragEnd(e, this.state.drag);
		    this.setState({ drag: null });
		  },
		  cleanUp: function cleanUp() {
		    window.removeEventListener('mouseup', this.onMouseUp);
		    window.removeEventListener('mousemove', this.onMouseMove);
		    window.removeEventListener('touchend', this.onMouseUp);
		    window.removeEventListener('touchmove', this.onMouseMove);
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  render: function render() {
		    return React.createElement('div', _extends({}, this.getKnownDivProps(), {
		      onMouseDown: this.onMouseDown,
		      onTouchStart: this.onMouseDown,
		      className: 'react-grid-HeaderCell__draggable' }));
		  }
		});
	
		module.exports = Draggable;
	
	/***/ },
	/* 164 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var PropTypes = React.PropTypes;
		var Header = __webpack_require__(166);
		var Viewport = __webpack_require__(176);
		var GridScrollMixin = __webpack_require__(165);
		var DOMMetrics = __webpack_require__(22);
		var cellMetaDataShape = __webpack_require__(14);
		__webpack_require__(26);
	
		var Grid = React.createClass({
		  displayName: 'Grid',
	
		  propTypes: {
		    rowGetter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
		    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		    columnMetrics: PropTypes.object,
		    minHeight: PropTypes.number,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    headerRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    rowHeight: PropTypes.number,
		    rowRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		    emptyRowsView: PropTypes.func,
		    expandedRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    selectedRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    rowsCount: PropTypes.number,
		    onRows: PropTypes.func,
		    sortColumn: React.PropTypes.string,
		    sortDirection: React.PropTypes.oneOf(['ASC', 'DESC', 'NONE']),
		    rowOffsetHeight: PropTypes.number.isRequired,
		    onViewportKeydown: PropTypes.func.isRequired,
		    onViewportKeyup: PropTypes.func,
		    onViewportDragStart: PropTypes.func.isRequired,
		    onViewportDragEnd: PropTypes.func.isRequired,
		    onViewportDoubleClick: PropTypes.func.isRequired,
		    onColumnResize: PropTypes.func,
		    onSort: PropTypes.func,
		    onHeaderDrop: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    rowKey: PropTypes.string.isRequired,
		    rowScrollTimeout: PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    draggableHeaderCell: PropTypes.func,
		    getValidFilterValues: PropTypes.func,
		    rowGroupRenderer: PropTypes.func,
		    overScan: PropTypes.object
		  },
	
		  mixins: [GridScrollMixin, DOMMetrics.MetricsComputatorMixin],
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowHeight: 35,
		      minHeight: 350
		    };
		  },
	
	
		  getStyle: function getStyle() {
		    return {
		      overflow: 'hidden',
		      outline: 0,
		      position: 'relative',
		      minHeight: this.props.minHeight
		    };
		  },
	
		  render: function render() {
		    var _this = this;
	
		    var headerRows = this.props.headerRows || [{ ref: function ref(node) {
		        return _this.row = node;
		      } }];
		    var EmptyRowsView = this.props.emptyRowsView;
	
		    return React.createElement(
		      'div',
		      { style: this.getStyle(), className: 'react-grid-Grid' },
		      React.createElement(Header, {
		        ref: function ref(input) {
		          _this.header = input;
		        },
		        columnMetrics: this.props.columnMetrics,
		        onColumnResize: this.props.onColumnResize,
		        height: this.props.rowHeight,
		        totalWidth: this.props.totalWidth,
		        headerRows: headerRows,
		        sortColumn: this.props.sortColumn,
		        sortDirection: this.props.sortDirection,
		        draggableHeaderCell: this.props.draggableHeaderCell,
		        onSort: this.props.onSort,
		        onHeaderDrop: this.props.onHeaderDrop,
		        onScroll: this.onHeaderScroll,
		        getValidFilterValues: this.props.getValidFilterValues,
		        cellMetaData: this.props.cellMetaData
		      }),
		      this.props.rowsCount >= 1 || this.props.rowsCount === 0 && !this.props.emptyRowsView ? React.createElement(
		        'div',
		        { ref: function ref(node) {
		            _this.viewPortContainer = node;
		          }, tabIndex: '0', onKeyDown: this.props.onViewportKeydown, onKeyUp: this.props.onViewportKeyup, onDoubleClick: this.props.onViewportDoubleClick, onDragStart: this.props.onViewportDragStart, onDragEnd: this.props.onViewportDragEnd },
		        React.createElement(Viewport, {
		          ref: function ref(node) {
		            _this.viewport = node;
		          },
		          rowKey: this.props.rowKey,
		          width: this.props.columnMetrics.width,
		          rowHeight: this.props.rowHeight,
		          rowRenderer: this.props.rowRenderer,
		          rowGetter: this.props.rowGetter,
		          rowsCount: this.props.rowsCount,
		          selectedRows: this.props.selectedRows,
		          expandedRows: this.props.expandedRows,
		          columnMetrics: this.props.columnMetrics,
		          totalWidth: this.props.totalWidth,
		          onScroll: this.onScroll,
		          onRows: this.props.onRows,
		          cellMetaData: this.props.cellMetaData,
		          rowOffsetHeight: this.props.rowOffsetHeight || this.props.rowHeight * headerRows.length,
		          minHeight: this.props.minHeight,
		          rowScrollTimeout: this.props.rowScrollTimeout,
		          contextMenu: this.props.contextMenu,
		          rowSelection: this.props.rowSelection,
		          getSubRowDetails: this.props.getSubRowDetails,
		          rowGroupRenderer: this.props.rowGroupRenderer,
		          overScan: this.props.overScan
		        })
		      ) : React.createElement(
		        'div',
		        { ref: function ref(node) {
		            _this.emptyView = node;
		          }, className: 'react-grid-Empty' },
		        React.createElement(EmptyRowsView, null)
		      )
		    );
		  }
		});
	
		module.exports = Grid;
	
	/***/ },
	/* 165 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ReactDOM = __webpack_require__(4);
	
		module.exports = {
		  componentDidMount: function componentDidMount() {
		    this._scrollLeft = this.viewport ? this.viewport.getScroll().scrollLeft : 0;
		    this._onScroll();
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this._onScroll();
		  },
		  componentWillMount: function componentWillMount() {
		    this._scrollLeft = undefined;
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._scrollLeft = undefined;
		  },
		  onScroll: function onScroll(props) {
		    if (this._scrollLeft !== props.scrollLeft) {
		      this._scrollLeft = props.scrollLeft;
		      this._onScroll();
		    }
		  },
		  onHeaderScroll: function onHeaderScroll(e) {
		    var scrollLeft = e.target.scrollLeft;
		    if (this._scrollLeft !== scrollLeft) {
		      this._scrollLeft = scrollLeft;
		      this.header.setScrollLeft(scrollLeft);
		      var canvas = ReactDOM.findDOMNode(this.viewport.canvas);
		      canvas.scrollLeft = scrollLeft;
		      this.viewport.canvas.setScrollLeft(scrollLeft);
		    }
		  },
		  _onScroll: function _onScroll() {
		    if (this._scrollLeft !== undefined) {
		      this.header.setScrollLeft(this._scrollLeft);
		      if (this.viewport) {
		        this.viewport.setScrollLeft(this._scrollLeft);
		      }
		    }
		  }
		};
	
	/***/ },
	/* 166 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var shallowCloneObject = __webpack_require__(36);
		var ColumnMetrics = __webpack_require__(33);
		var ColumnUtils = __webpack_require__(10);
		var HeaderRow = __webpack_require__(168);
		var getScrollbarSize = __webpack_require__(35);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		var cellMetaDataShape = __webpack_require__(14);
		__webpack_require__(18);
	
		// The list of the propTypes that we want to include in the Header div
		var knownDivPropertyKeys = ['height', 'onScroll'];
	
		var Header = React.createClass({
		  displayName: 'Header',
	
		  propTypes: {
		    columnMetrics: PropTypes.shape({ width: PropTypes.number.isRequired, columns: PropTypes.any }).isRequired,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    height: PropTypes.number.isRequired,
		    headerRows: PropTypes.array.isRequired,
		    sortColumn: PropTypes.string,
		    sortDirection: PropTypes.oneOf(['ASC', 'DESC', 'NONE']),
		    onSort: PropTypes.func,
		    onColumnResize: PropTypes.func,
		    onScroll: PropTypes.func,
		    onHeaderDrop: PropTypes.func,
		    draggableHeaderCell: PropTypes.func,
		    getValidFilterValues: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape)
		  },
	
		  getInitialState: function getInitialState() {
		    return { resizing: null };
		  },
		  componentWillReceiveProps: function componentWillReceiveProps() {
		    this.setState({ resizing: null });
		  },
	
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		    var update = !ColumnMetrics.sameColumns(this.props.columnMetrics.columns, nextProps.columnMetrics.columns, ColumnMetrics.sameColumn) || this.props.totalWidth !== nextProps.totalWidth || this.props.headerRows.length !== nextProps.headerRows.length || this.state.resizing !== nextState.resizing || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
		    return update;
		  },
	
		  onColumnResize: function onColumnResize(column, width) {
		    var state = this.state.resizing || this.props;
	
		    var pos = this.getColumnPosition(column);
	
		    if (pos != null) {
		      var _resizing = {
		        columnMetrics: shallowCloneObject(state.columnMetrics)
		      };
		      _resizing.columnMetrics = ColumnMetrics.resizeColumn(_resizing.columnMetrics, pos, width);
	
		      // we don't want to influence scrollLeft while resizing
		      if (_resizing.columnMetrics.totalWidth < state.columnMetrics.totalWidth) {
		        _resizing.columnMetrics.totalWidth = state.columnMetrics.totalWidth;
		      }
	
		      _resizing.column = ColumnUtils.getColumn(_resizing.columnMetrics.columns, pos);
		      this.setState({ resizing: _resizing });
		    }
		  },
		  onColumnResizeEnd: function onColumnResizeEnd(column, width) {
		    var pos = this.getColumnPosition(column);
		    if (pos !== null && this.props.onColumnResize) {
		      this.props.onColumnResize(pos, width || column.width);
		    }
		  },
		  getHeaderRows: function getHeaderRows() {
		    var _this = this;
	
		    var columnMetrics = this.getColumnMetrics();
		    var resizeColumn = void 0;
		    if (this.state.resizing) {
		      resizeColumn = this.state.resizing.column;
		    }
		    var headerRows = [];
		    this.props.headerRows.forEach(function (row, index) {
		      // To allow header filters to be visible
		      var rowHeight = 'auto';
		      if (row.rowType === 'filter') {
		        rowHeight = '500px';
		      }
		      var scrollbarSize = getScrollbarSize() > 0 ? getScrollbarSize() : 0;
		      var updatedWidth = isNaN(_this.props.totalWidth - scrollbarSize) ? _this.props.totalWidth : _this.props.totalWidth - scrollbarSize;
		      var headerRowStyle = {
		        position: 'absolute',
		        top: _this.getCombinedHeaderHeights(index),
		        left: 0,
		        width: updatedWidth,
		        overflowX: 'hidden',
		        minHeight: rowHeight
		      };
	
		      headerRows.push(React.createElement(HeaderRow, {
		        key: row.ref,
		        ref: function ref(node) {
		          return _this.row = node;
		        },
		        rowType: row.rowType,
		        style: headerRowStyle,
		        onColumnResize: _this.onColumnResize,
		        onColumnResizeEnd: _this.onColumnResizeEnd,
		        width: columnMetrics.width,
		        height: row.height || _this.props.height,
		        columns: columnMetrics.columns,
		        resizing: resizeColumn,
		        draggableHeaderCell: _this.props.draggableHeaderCell,
		        filterable: row.filterable,
		        onFilterChange: row.onFilterChange,
		        onHeaderDrop: _this.props.onHeaderDrop,
		        sortColumn: _this.props.sortColumn,
		        sortDirection: _this.props.sortDirection,
		        onSort: _this.props.onSort,
		        onScroll: _this.props.onScroll,
		        getValidFilterValues: _this.props.getValidFilterValues
		      }));
		    });
		    return headerRows;
		  },
		  getColumnMetrics: function getColumnMetrics() {
		    var columnMetrics = void 0;
		    if (this.state.resizing) {
		      columnMetrics = this.state.resizing.columnMetrics;
		    } else {
		      columnMetrics = this.props.columnMetrics;
		    }
		    return columnMetrics;
		  },
		  getColumnPosition: function getColumnPosition(column) {
		    var columnMetrics = this.getColumnMetrics();
		    var pos = -1;
		    columnMetrics.columns.forEach(function (c, idx) {
		      if (c.key === column.key) {
		        pos = idx;
		      }
		    });
		    return pos === -1 ? null : pos;
		  },
		  getCombinedHeaderHeights: function getCombinedHeaderHeights(until) {
		    var stopAt = this.props.headerRows.length;
		    if (typeof until !== 'undefined') {
		      stopAt = until;
		    }
	
		    var height = 0;
		    for (var index = 0; index < stopAt; index++) {
		      height += this.props.headerRows[index].height || this.props.height;
		    }
		    return height;
		  },
		  getStyle: function getStyle() {
		    return {
		      position: 'relative',
		      height: this.getCombinedHeaderHeights()
		    };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this.row);
		    node.scrollLeft = scrollLeft;
		    this.row.setScrollLeft(scrollLeft);
		    if (this.filterRow) {
		      var nodeFilters = this.filterRow;
		      nodeFilters.scrollLeft = scrollLeft;
		      this.filterRow.setScrollLeft(scrollLeft);
		    }
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
	
	
		  // Set the cell selection to -1 x -1 when clicking on the header
		  onHeaderClick: function onHeaderClick() {
		    this.props.cellMetaData.onCellClick({ rowIdx: -1, idx: -1 });
		  },
		  render: function render() {
		    var className = joinClasses({
		      'react-grid-Header': true,
		      'react-grid-Header--resizing': !!this.state.resizing
		    });
		    var headerRows = this.getHeaderRows();
	
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { style: this.getStyle(), className: className, onClick: this.onHeaderClick }),
		      headerRows
		    );
		  }
		});
	
		module.exports = Header;
	
	/***/ },
	/* 167 */
	/***/ function(module, exports) {
	
		"use strict";
	
		var HeaderCellType = {
		  SORTABLE: 0,
		  FILTERABLE: 1,
		  NONE: 2,
		  CHECKBOX: 3
		};
	
		module.exports = HeaderCellType;
	
	/***/ },
	/* 168 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var shallowEqual = __webpack_require__(69);
		var BaseHeaderCell = __webpack_require__(60);
		var getScrollbarSize = __webpack_require__(35);
		var ExcelColumn = __webpack_require__(11);
		var ColumnUtilsMixin = __webpack_require__(10);
		var SortableHeaderCell = __webpack_require__(179);
		var FilterableHeaderCell = __webpack_require__(178);
		var HeaderCellType = __webpack_require__(167);
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(18);
	
		var PropTypes = React.PropTypes;
	
		var HeaderRowStyle = {
		  overflow: React.PropTypes.string,
		  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		  height: React.PropTypes.number,
		  position: React.PropTypes.string
		};
	
		// The list of the propTypes that we want to include in the HeaderRow div
		var knownDivPropertyKeys = ['width', 'height', 'style', 'onScroll'];
	
		var HeaderRow = React.createClass({
		  displayName: 'HeaderRow',
	
		  propTypes: {
		    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    height: PropTypes.number.isRequired,
		    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
		    onColumnResize: PropTypes.func,
		    onSort: PropTypes.func.isRequired,
		    onColumnResizeEnd: PropTypes.func,
		    style: PropTypes.shape(HeaderRowStyle),
		    sortColumn: PropTypes.string,
		    sortDirection: React.PropTypes.oneOf(Object.keys(SortableHeaderCell.DEFINE_SORT)),
		    cellRenderer: PropTypes.func,
		    headerCellRenderer: PropTypes.func,
		    filterable: PropTypes.bool,
		    onFilterChange: PropTypes.func,
		    resizing: PropTypes.object,
		    onScroll: PropTypes.func,
		    rowType: PropTypes.string,
		    draggableHeaderCell: PropTypes.func,
		    onHeaderDrop: PropTypes.func
		  },
	
		  mixins: [ColumnUtilsMixin],
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.columns !== this.props.columns || !shallowEqual(nextProps.style, this.props.style) || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
		  },
	
	
		  cells: [],
	
		  getHeaderCellType: function getHeaderCellType(column) {
		    if (column.filterable) {
		      if (this.props.filterable) return HeaderCellType.FILTERABLE;
		    }
	
		    if (column.sortable) return HeaderCellType.SORTABLE;
	
		    return HeaderCellType.NONE;
		  },
		  getFilterableHeaderCell: function getFilterableHeaderCell(column) {
		    var FilterRenderer = FilterableHeaderCell;
		    if (column.filterRenderer !== undefined) {
		      FilterRenderer = column.filterRenderer;
		    }
		    return React.createElement(FilterRenderer, _extends({}, this.props, { onChange: this.props.onFilterChange }));
		  },
		  getSortableHeaderCell: function getSortableHeaderCell(column) {
		    var sortDirection = this.props.sortColumn === column.key ? this.props.sortDirection : SortableHeaderCell.DEFINE_SORT.NONE;
		    return React.createElement(SortableHeaderCell, { columnKey: column.key, onSort: this.props.onSort, sortDirection: sortDirection });
		  },
		  getHeaderRenderer: function getHeaderRenderer(column) {
		    var renderer = void 0;
		    if (column.headerRenderer && !this.props.filterable) {
		      renderer = column.headerRenderer;
		    } else {
		      var headerCellType = this.getHeaderCellType(column);
		      switch (headerCellType) {
		        case HeaderCellType.SORTABLE:
		          renderer = this.getSortableHeaderCell(column);
		          break;
		        case HeaderCellType.FILTERABLE:
		          renderer = this.getFilterableHeaderCell(column);
		          break;
		        default:
		          break;
		      }
		    }
		    return renderer;
		  },
		  getStyle: function getStyle() {
		    return {
		      overflow: 'hidden',
		      width: '100%',
		      height: this.props.height,
		      position: 'absolute'
		    };
		  },
		  getCells: function getCells() {
		    var _this = this;
	
		    var cells = [];
		    var lockedCells = [];
	
		    var _loop = function _loop(i, len) {
		      var column = Object.assign({ rowType: _this.props.rowType }, _this.getColumn(_this.props.columns, i));
		      var _renderer = _this.getHeaderRenderer(column);
		      if (column.key === 'select-row' && _this.props.rowType === 'filter') {
		        _renderer = React.createElement('div', null);
		      }
		      var HeaderCell = column.draggable ? _this.props.draggableHeaderCell : BaseHeaderCell;
		      var cell = React.createElement(HeaderCell, {
		        ref: function ref(node) {
		          return _this.cells[i] = node;
		        },
		        key: i,
		        height: _this.props.height,
		        column: column,
		        renderer: _renderer,
		        resizing: _this.props.resizing === column,
		        onResize: _this.props.onColumnResize,
		        onResizeEnd: _this.props.onColumnResizeEnd,
		        onHeaderDrop: _this.props.onHeaderDrop
		      });
		      if (column.locked) {
		        lockedCells.push(cell);
		      } else {
		        cells.push(cell);
		      }
		    };
	
		    for (var i = 0, len = this.getSize(this.props.columns); i < len; i++) {
		      _loop(i, len);
		    }
	
		    return cells.concat(lockedCells);
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var _this2 = this;
	
		    this.props.columns.forEach(function (column, i) {
		      if (column.locked) {
		        _this2.cells[i].setScrollLeft(scrollLeft);
		      }
		    });
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  render: function render() {
		    var cellsStyle = {
		      width: this.props.width ? this.props.width + getScrollbarSize() : '100%',
		      height: this.props.height,
		      whiteSpace: 'nowrap',
		      overflowX: 'hidden',
		      overflowY: 'hidden'
		    };
	
		    var cells = this.getCells();
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: 'react-grid-HeaderRow' }),
		      React.createElement(
		        'div',
		        { style: cellsStyle },
		        cells
		      )
		    );
		  }
		});
	
		module.exports = HeaderRow;
	
	/***/ },
	/* 169 */
	/***/ function(module, exports) {
	
		"use strict";
	
		module.exports = {
		  Backspace: 8,
		  Tab: 9,
		  Enter: 13,
		  Shift: 16,
		  Ctrl: 17,
		  Alt: 18,
		  PauseBreak: 19,
		  CapsLock: 20,
		  Escape: 27,
		  PageUp: 33,
		  PageDown: 34,
		  End: 35,
		  Home: 36,
		  LeftArrow: 37,
		  UpArrow: 38,
		  RightArrow: 39,
		  DownArrow: 40,
		  Insert: 45,
		  Delete: 46,
		  0: 48,
		  1: 49,
		  2: 50,
		  3: 51,
		  4: 52,
		  5: 53,
		  6: 54,
		  7: 55,
		  8: 56,
		  9: 57,
		  a: 65,
		  b: 66,
		  c: 67,
		  d: 68,
		  e: 69,
		  f: 70,
		  g: 71,
		  h: 72,
		  i: 73,
		  j: 74,
		  k: 75,
		  l: 76,
		  m: 77,
		  n: 78,
		  o: 79,
		  p: 80,
		  q: 81,
		  r: 82,
		  s: 83,
		  t: 84,
		  u: 85,
		  v: 86,
		  w: 87,
		  x: 88,
		  y: 89,
		  z: 90,
		  LeftWindowKey: 91,
		  RightWindowKey: 92,
		  SelectKey: 93,
		  NumPad0: 96,
		  NumPad1: 97,
		  NumPad2: 98,
		  NumPad3: 99,
		  NumPad4: 100,
		  NumPad5: 101,
		  NumPad6: 102,
		  NumPad7: 103,
		  NumPad8: 104,
		  NumPad9: 105,
		  Multiply: 106,
		  Add: 107,
		  Subtract: 109,
		  DecimalPoint: 110,
		  Divide: 111,
		  F1: 112,
		  F2: 113,
		  F3: 114,
		  F4: 115,
		  F5: 116,
		  F6: 117,
		  F7: 118,
		  F8: 119,
		  F9: 120,
		  F10: 121,
		  F12: 123,
		  NumLock: 144,
		  ScrollLock: 145,
		  SemiColon: 186,
		  EqualSign: 187,
		  Comma: 188,
		  Dash: 189,
		  Period: 190,
		  ForwardSlash: 191,
		  GraveAccent: 192,
		  OpenBracket: 219,
		  BackSlash: 220,
		  CloseBracket: 221,
		  SingleQuote: 222
		};
	
	/***/ },
	/* 170 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.OverflowCellComponent = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _focusableComponentWrapper = __webpack_require__(182);
	
		var _focusableComponentWrapper2 = _interopRequireDefault(_focusableComponentWrapper);
	
		__webpack_require__(38);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var OverflowCell = function (_React$Component) {
		  _inherits(OverflowCell, _React$Component);
	
		  function OverflowCell() {
		    _classCallCheck(this, OverflowCell);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  OverflowCell.prototype.getStyle = function getStyle() {
		    var style = {
		      position: 'absolute',
		      width: this.props.column.width,
		      height: this.props.height,
		      left: this.props.column.left,
		      border: '1px solid #eee'
		    };
		    return style;
		  };
	
		  OverflowCell.prototype.render = function render() {
		    return _react2['default'].createElement('div', { tabIndex: '-1', style: this.getStyle(), width: '100%', className: 'react-grid-Cell' });
		  };
	
		  return OverflowCell;
		}(_react2['default'].Component);
	
		OverflowCell.isSelected = function (props) {
		  var cellMetaData = props.cellMetaData,
		      rowIdx = props.rowIdx,
		      idx = props.idx;
	
		  if (cellMetaData == null) {
		    return false;
		  }
	
		  var selected = cellMetaData.selected;
	
	
		  return selected && selected.rowIdx === rowIdx && selected.idx === idx;
		};
	
		OverflowCell.isScrolling = function (props) {
		  return props.cellMetaData.isScrollingHorizontallyWithKeyboard;
		};
	
		OverflowCell.propTypes = {
		  rowIdx: _react2['default'].PropTypes.number,
		  idx: _react2['default'].PropTypes.number,
		  height: _react2['default'].PropTypes.number,
		  column: _react2['default'].PropTypes.object,
		  cellMetaData: _react2['default'].PropTypes.object
		};
	
		OverflowCell.displayName = 'Cell';
	
		var OverflowCellComponent = OverflowCell;
		exports['default'] = (0, _focusableComponentWrapper2['default'])(OverflowCell);
		exports.OverflowCellComponent = OverflowCellComponent;
	
	/***/ },
	/* 171 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _ExcelColumn = __webpack_require__(11);
	
		var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		exports['default'] = { ExcelColumn: _ExcelColumn2['default'] };
	
	/***/ },
	/* 172 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _AppConstants = __webpack_require__(58);
	
		var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var BaseGrid = __webpack_require__(164);
		var Row = __webpack_require__(34);
		var ExcelColumn = __webpack_require__(11);
		var KeyboardHandlerMixin = __webpack_require__(61);
		var CheckboxEditor = __webpack_require__(65);
		var DOMMetrics = __webpack_require__(22);
		var ColumnMetricsMixin = __webpack_require__(162);
		var RowUtils = __webpack_require__(63);
		var ColumnUtils = __webpack_require__(10);
		var KeyCodes = __webpack_require__(169);
	
		__webpack_require__(26);
		__webpack_require__(71);
	
		if (!Object.assign) {
		  Object.assign = __webpack_require__(70);
		}
	
		var ReactDataGrid = React.createClass({
		  displayName: 'ReactDataGrid',
	
	
		  mixins: [ColumnMetricsMixin, DOMMetrics.MetricsComputatorMixin, KeyboardHandlerMixin],
	
		  propTypes: {
		    rowHeight: React.PropTypes.number.isRequired,
		    headerRowHeight: React.PropTypes.number,
		    headerFiltersHeight: React.PropTypes.number,
		    minHeight: React.PropTypes.number.isRequired,
		    minWidth: React.PropTypes.number,
		    enableRowSelect: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]),
		    onRowUpdated: React.PropTypes.func,
		    rowGetter: React.PropTypes.func.isRequired,
		    rowsCount: React.PropTypes.number.isRequired,
		    toolbar: React.PropTypes.element,
		    enableCellSelect: React.PropTypes.bool,
		    columns: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]).isRequired,
		    onFilter: React.PropTypes.func,
		    onCellCopyPaste: React.PropTypes.func,
		    onCellsDragged: React.PropTypes.func,
		    onAddFilter: React.PropTypes.func,
		    onGridSort: React.PropTypes.func,
		    onDragHandleDoubleClick: React.PropTypes.func,
		    onGridRowsUpdated: React.PropTypes.func,
		    onRowSelect: React.PropTypes.func,
		    rowKey: React.PropTypes.string,
		    rowScrollTimeout: React.PropTypes.number,
		    onClearFilters: React.PropTypes.func,
		    contextMenu: React.PropTypes.element,
		    cellNavigationMode: React.PropTypes.oneOf(['none', 'loopOverRow', 'changeRow']),
		    onCellSelected: React.PropTypes.func,
		    onCellDeSelected: React.PropTypes.func,
		    onCellExpand: React.PropTypes.func,
		    enableDragAndDrop: React.PropTypes.bool,
		    onRowExpandToggle: React.PropTypes.func,
		    draggableHeaderCell: React.PropTypes.func,
		    getValidFilterValues: React.PropTypes.func,
		    rowSelection: React.PropTypes.shape({
		      enableShiftSelect: React.PropTypes.bool,
		      onRowsSelected: React.PropTypes.func,
		      onRowsDeselected: React.PropTypes.func,
		      showCheckbox: React.PropTypes.bool,
		      selectBy: React.PropTypes.oneOfType([React.PropTypes.shape({
		        indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		      }), React.PropTypes.shape({
		        isSelectedKey: React.PropTypes.string.isRequired
		      }), React.PropTypes.shape({
		        keys: React.PropTypes.shape({
		          values: React.PropTypes.array.isRequired,
		          rowKey: React.PropTypes.string.isRequired
		        }).isRequired
		      })]).isRequired
		    }),
		    onRowClick: React.PropTypes.func,
		    onGridKeyUp: React.PropTypes.func,
		    onGridKeyDown: React.PropTypes.func,
		    rowGroupRenderer: React.PropTypes.func,
		    rowActionsCell: React.PropTypes.func,
		    onCheckCellIsEditable: React.PropTypes.func,
		    /* called before cell is set active, returns a boolean to determine whether cell is editable */
		    overScan: React.PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      enableCellSelect: false,
		      tabIndex: -1,
		      rowHeight: 35,
		      headerFiltersHeight: 45,
		      enableRowSelect: false,
		      minHeight: 350,
		      rowKey: 'id',
		      rowScrollTimeout: 0,
		      cellNavigationMode: 'none',
		      overScan: {
		        colsStart: 5,
		        colsEnd: 5,
		        rowsStart: 5,
		        rowsEnd: 5
		      }
		    };
		  },
	
	
		  getInitialState: function getInitialState() {
		    var columnMetrics = this.createColumnMetrics();
		    var initialState = { columnMetrics: columnMetrics, selectedRows: [], copied: null, expandedRows: [], canFilter: false, columnFilters: {}, sortDirection: null, sortColumn: null, dragged: null, scrollOffset: 0, lastRowIdxUiSelected: -1 };
		    if (this.props.enableCellSelect) {
		      initialState.selected = { rowIdx: 0, idx: 0 };
		    } else {
		      initialState.selected = { rowIdx: -1, idx: -1 };
		    }
		    return initialState;
		  },
	
		  hasSelectedCellChanged: function hasSelectedCellChanged(selected) {
		    var previouslySelected = Object.assign({}, this.state.selected);
		    return previouslySelected.rowIdx !== selected.rowIdx || previouslySelected.idx !== selected.idx || previouslySelected.active === false;
		  },
	
		  onContextMenuHide: function onContextMenuHide() {
		    document.removeEventListener('click', this.onContextMenuHide);
		    var newSelected = Object.assign({}, this.state.selected, { contextMenuDisplayed: false });
		    this.setState({ selected: newSelected });
		  },
	
		  onColumnEvent: function onColumnEvent(ev, columnEvent) {
		    var idx = columnEvent.idx,
		        name = columnEvent.name;
	
	
		    if (name && typeof idx !== 'undefined') {
		      var column = this.getColumn(idx);
	
		      if (column && column.events && column.events[name] && typeof column.events[name] === 'function') {
		        var eventArgs = {
		          rowIdx: columnEvent.rowIdx,
		          idx: idx,
		          column: column
		        };
	
		        column.events[name](ev, eventArgs);
		      }
		    }
		  },
	
		  onSelect: function onSelect(selected) {
		    var _this = this;
	
		    if (this.state.selected.rowIdx !== selected.rowIdx || this.state.selected.idx !== selected.idx || this.state.selected.active === false) {
		      var _idx = selected.idx;
		      var _rowIdx = selected.rowIdx;
		      if (this.isCellWithinBounds(selected)) {
		        var oldSelection = this.state.selected;
		        this.setState({ selected: selected }, function () {
		          if (typeof _this.props.onCellDeSelected === 'function') {
		            _this.props.onCellDeSelected(oldSelection);
		          }
		          if (typeof _this.props.onCellSelected === 'function') {
		            _this.props.onCellSelected(selected);
		          }
		        });
		      } else if (_rowIdx === -1 && _idx === -1) {
		        // When it's outside of the grid, set rowIdx anyway
		        this.setState({ selected: { idx: _idx, rowIdx: _rowIdx } });
		      }
		    }
		  },
	
		  onCellClick: function onCellClick(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
	
		    if (this.props.onRowClick && typeof this.props.onRowClick === 'function') {
		      this.props.onRowClick(cell.rowIdx, this.props.rowGetter(cell.rowIdx));
		    }
		  },
	
		  onCellContextMenu: function onCellContextMenu(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx, contextMenuDisplayed: this.props.contextMenu });
		    if (this.props.contextMenu) {
		      document.addEventListener('click', this.onContextMenuHide);
		    }
		  },
	
		  onCellDoubleClick: function onCellDoubleClick(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
		    this.setActive('Enter');
		  },
	
		  onViewportDoubleClick: function onViewportDoubleClick() {
		    this.setActive();
		  },
	
		  onPressArrowUp: function onPressArrowUp(e) {
		    this.moveSelectedCell(e, -1, 0);
		  },
		  onPressArrowDown: function onPressArrowDown(e) {
		    this.moveSelectedCell(e, 1, 0);
		  },
		  onPressArrowLeft: function onPressArrowLeft(e) {
		    this.moveSelectedCell(e, 0, -1);
		  },
		  onPressArrowRight: function onPressArrowRight(e) {
		    this.moveSelectedCell(e, 0, 1);
		  },
		  onPressTab: function onPressTab(e) {
		    this.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
		  },
		  onPressEnter: function onPressEnter(e) {
		    this.setActive(e.key);
		  },
		  onPressDelete: function onPressDelete(e) {
		    this.setActive(e.key);
		  },
		  onPressEscape: function onPressEscape(e) {
		    this.setInactive(e.key);
		    this.handleCancelCopy();
		  },
		  onPressBackspace: function onPressBackspace(e) {
		    this.setActive(e.key);
		  },
		  onPressChar: function onPressChar(e) {
		    if (this.isKeyPrintable(e.keyCode)) {
		      this.setActive(e.keyCode);
		    }
		  },
		  onPressKeyWithCtrl: function onPressKeyWithCtrl(e) {
		    var keys = {
		      KeyCode_c: 99,
		      KeyCode_C: 67,
		      KeyCode_V: 86,
		      KeyCode_v: 118
		    };
	
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var col = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(col, row, this.props.enableCellSelect)) {
		      if (e.keyCode === keys.KeyCode_c || e.keyCode === keys.KeyCode_C) {
		        var _value = this.getSelectedValue();
		        this.handleCopy({ value: _value });
		      } else if (e.keyCode === keys.KeyCode_v || e.keyCode === keys.KeyCode_V) {
		        this.handlePaste();
		      }
		    }
		  },
		  onGridRowsUpdated: function onGridRowsUpdated(cellKey, fromRow, toRow, updated, action, originRow) {
		    var rowIds = [];
	
		    for (var i = fromRow; i <= toRow; i++) {
		      rowIds.push(this.props.rowGetter(i)[this.props.rowKey]);
		    }
	
		    var fromRowId = this.props.rowGetter(action === 'COPY_PASTE' ? originRow : fromRow)[this.props.rowKey];
		    var toRowId = this.props.rowGetter(toRow)[this.props.rowKey];
	
		    this.props.onGridRowsUpdated({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, fromRowId: fromRowId, toRowId: toRowId, rowIds: rowIds, updated: updated, action: action });
		  },
		  onCellCommit: function onCellCommit(commit) {
		    var selected = Object.assign({}, this.state.selected);
		    selected.active = false;
		    if (commit.key === 'Tab') {
		      selected.idx += 1;
		    }
		    var expandedRows = this.state.expandedRows;
		    // if(commit.changed && commit.changed.expandedHeight){
		    //   expandedRows = this.expandRow(commit.rowIdx, commit.changed.expandedHeight);
		    // }
		    this.setState({ selected: selected, expandedRows: expandedRows });
	
		    if (this.props.onRowUpdated) {
		      this.props.onRowUpdated(commit);
		    }
	
		    var targetRow = commit.rowIdx;
	
		    if (this.props.onGridRowsUpdated) {
		      this.onGridRowsUpdated(commit.cellKey, targetRow, targetRow, commit.updated, _AppConstants2['default'].UpdateActions.CELL_UPDATE);
		    }
		  },
		  onDragStart: function onDragStart(e) {
		    var idx = this.state.selected.idx;
		    // To prevent dragging down/up when reordering rows.
		    var isViewportDragging = e && e.target && e.target.className;
		    if (idx > -1 && isViewportDragging) {
		      var _value2 = this.getSelectedValue();
		      this.handleDragStart({ idx: this.state.selected.idx, rowIdx: this.state.selected.rowIdx, value: _value2 });
		      // need to set dummy data for FF
		      if (e && e.dataTransfer) {
		        if (e.dataTransfer.setData) {
		          e.dataTransfer.dropEffect = 'move';
		          e.dataTransfer.effectAllowed = 'move';
		          e.dataTransfer.setData('text/plain', '');
		        }
		      }
		    }
		  },
		  onToggleFilter: function onToggleFilter() {
		    var _this2 = this;
	
		    // setState() does not immediately mutate this.state but creates a pending state transition.
		    // Therefore if you want to do something after the state change occurs, pass it in as a callback function.
		    this.setState({ canFilter: !this.state.canFilter }, function () {
		      if (_this2.state.canFilter === false && _this2.props.onClearFilters) {
		        _this2.props.onClearFilters();
		      }
		    });
		  },
		  onDragHandleDoubleClick: function onDragHandleDoubleClick(e) {
		    if (this.props.onDragHandleDoubleClick) {
		      this.props.onDragHandleDoubleClick(e);
		    }
	
		    if (this.props.onGridRowsUpdated) {
		      var _onGridRowsUpdated;
	
		      var cellKey = this.getColumn(e.idx).key;
		      this.onGridRowsUpdated(cellKey, e.rowIdx, this.props.rowsCount - 1, (_onGridRowsUpdated = {}, _onGridRowsUpdated[cellKey] = e.rowData[cellKey], _onGridRowsUpdated), _AppConstants2['default'].UpdateActions.COLUMN_FILL);
		    }
		  },
		  onCellExpand: function onCellExpand(args) {
		    if (this.props.onCellExpand) {
		      this.props.onCellExpand(args);
		    }
		  },
		  onRowExpandToggle: function onRowExpandToggle(args) {
		    if (typeof this.props.onRowExpandToggle === 'function') {
		      this.props.onRowExpandToggle(args);
		    }
		  },
		  isCellWithinBounds: function isCellWithinBounds(_ref) {
		    var idx = _ref.idx,
		        rowIdx = _ref.rowIdx;
	
		    return idx >= 0 && rowIdx >= 0 && idx < ColumnUtils.getSize(this.state.columnMetrics.columns) && rowIdx < this.props.rowsCount;
		  },
		  handleDragStart: function handleDragStart(dragged) {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    if (this.isCellWithinBounds(dragged)) {
		      this.setState({ dragged: dragged });
		    }
		  },
		  handleDragEnd: function handleDragEnd() {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    var _state = this.state,
		        selected = _state.selected,
		        dragged = _state.dragged;
	
		    var column = this.getColumn(this.state.selected.idx);
		    if (selected && dragged && column) {
		      var cellKey = column.key;
		      var fromRow = selected.rowIdx < dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
		      var toRow = selected.rowIdx > dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
		      if (this.props.onCellsDragged) {
		        this.props.onCellsDragged({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, value: dragged.value });
		      }
		      if (this.props.onGridRowsUpdated) {
		        var _onGridRowsUpdated2;
	
		        this.onGridRowsUpdated(cellKey, fromRow, toRow, (_onGridRowsUpdated2 = {}, _onGridRowsUpdated2[cellKey] = dragged.value, _onGridRowsUpdated2), _AppConstants2['default'].UpdateActions.CELL_DRAG);
		      }
		    }
		    this.setState({ dragged: { complete: true } });
		  },
		  handleDragEnter: function handleDragEnter(row) {
		    if (!this.dragEnabled() || this.state.dragged == null) {
		      return;
		    }
		    var dragged = this.state.dragged;
		    dragged.overRowIdx = row;
		    this.setState({ dragged: dragged });
		  },
		  handleTerminateDrag: function handleTerminateDrag() {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    this.setState({ dragged: null });
		  },
		  handlePaste: function handlePaste() {
		    if (!this.copyPasteEnabled() || !this.state.copied) {
		      return;
		    }
		    var selected = this.state.selected;
		    var cellKey = this.getColumn(this.state.selected.idx).key;
		    var textToCopy = this.state.textToCopy;
		    var fromRow = this.state.copied.rowIdx;
		    var toRow = selected.rowIdx;
	
		    if (this.props.onCellCopyPaste) {
		      this.props.onCellCopyPaste({ cellKey: cellKey, rowIdx: toRow, value: textToCopy, fromRow: fromRow, toRow: toRow });
		    }
	
		    if (this.props.onGridRowsUpdated) {
		      var _onGridRowsUpdated3;
	
		      this.onGridRowsUpdated(cellKey, toRow, toRow, (_onGridRowsUpdated3 = {}, _onGridRowsUpdated3[cellKey] = textToCopy, _onGridRowsUpdated3), _AppConstants2['default'].UpdateActions.COPY_PASTE, fromRow);
		    }
		  },
		  handleCancelCopy: function handleCancelCopy() {
		    this.setState({ copied: null });
		  },
		  handleCopy: function handleCopy(args) {
		    if (!this.copyPasteEnabled()) {
		      return;
		    }
		    var textToCopy = args.value;
		    var selected = this.state.selected;
		    var copied = { idx: selected.idx, rowIdx: selected.rowIdx };
		    this.setState({ textToCopy: textToCopy, copied: copied });
		  },
	
	
		  handleSort: function handleSort(columnKey, direction) {
		    this.setState({ sortDirection: direction, sortColumn: columnKey }, function () {
		      this.props.onGridSort(columnKey, direction);
		    });
		  },
	
		  getSelectedRow: function getSelectedRow(rows, key) {
		    var _this3 = this;
	
		    var selectedRow = rows.filter(function (r) {
		      if (r[_this3.props.rowKey] === key) {
		        return true;
		      }
		      return false;
		    });
		    if (selectedRow.length > 0) {
		      return selectedRow[0];
		    }
		  },
		  useNewRowSelection: function useNewRowSelection() {
		    return this.props.rowSelection && this.props.rowSelection.selectBy;
		  },
	
		  // return false if not a shift select so can be handled as normal row selection
		  handleShiftSelect: function handleShiftSelect(rowIdx) {
		    if (this.state.lastRowIdxUiSelected > -1 && this.isSingleKeyDown(KeyCodes.Shift)) {
		      var _props$rowSelection$s = this.props.rowSelection.selectBy,
		          keys = _props$rowSelection$s.keys,
		          indexes = _props$rowSelection$s.indexes,
		          isSelectedKey = _props$rowSelection$s.isSelectedKey;
	
		      var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, this.props.rowGetter(rowIdx), rowIdx);
	
		      if (isPreviouslySelected) return false;
	
		      var handled = false;
	
		      if (rowIdx > this.state.lastRowIdxUiSelected) {
		        var rowsSelected = [];
	
		        for (var i = this.state.lastRowIdxUiSelected + 1; i <= rowIdx; i++) {
		          rowsSelected.push({ rowIdx: i, row: this.props.rowGetter(i) });
		        }
	
		        if (typeof this.props.rowSelection.onRowsSelected === 'function') {
		          this.props.rowSelection.onRowsSelected(rowsSelected);
		        }
	
		        handled = true;
		      } else if (rowIdx < this.state.lastRowIdxUiSelected) {
		        var _rowsSelected = [];
	
		        for (var _i = rowIdx; _i <= this.state.lastRowIdxUiSelected - 1; _i++) {
		          _rowsSelected.push({ rowIdx: _i, row: this.props.rowGetter(_i) });
		        }
	
		        if (typeof this.props.rowSelection.onRowsSelected === 'function') {
		          this.props.rowSelection.onRowsSelected(_rowsSelected);
		        }
	
		        handled = true;
		      }
	
		      if (handled) {
		        this.setState({ lastRowIdxUiSelected: rowIdx });
		      }
	
		      return handled;
		    }
	
		    return false;
		  },
		  handleNewRowSelect: function handleNewRowSelect(rowIdx, rowData) {
		    var _props$rowSelection$s2 = this.props.rowSelection.selectBy,
		        keys = _props$rowSelection$s2.keys,
		        indexes = _props$rowSelection$s2.indexes,
		        isSelectedKey = _props$rowSelection$s2.isSelectedKey;
	
		    var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx);
	
		    this.setState({ lastRowIdxUiSelected: isPreviouslySelected ? -1 : rowIdx, selected: { rowIdx: rowIdx, idx: 0 } });
	
		    if (isPreviouslySelected && typeof this.props.rowSelection.onRowsDeselected === 'function') {
		      this.props.rowSelection.onRowsDeselected([{ rowIdx: rowIdx, row: rowData }]);
		    } else if (!isPreviouslySelected && typeof this.props.rowSelection.onRowsSelected === 'function') {
		      this.props.rowSelection.onRowsSelected([{ rowIdx: rowIdx, row: rowData }]);
		    }
		  },
	
		  // columnKey not used here as this function will select the whole row,
		  // but needed to match the function signature in the CheckboxEditor
		  handleRowSelect: function handleRowSelect(rowIdx, columnKey, rowData, e) {
		    e.stopPropagation();
	
		    if (this.useNewRowSelection()) {
		      if (this.props.rowSelection.enableShiftSelect === true) {
		        if (!this.handleShiftSelect(rowIdx)) {
		          this.handleNewRowSelect(rowIdx, rowData);
		        }
		      } else {
		        this.handleNewRowSelect(rowIdx, rowData);
		      }
		    } else {
		      // Fallback to old onRowSelect handler
		      var _selectedRows = this.props.enableRowSelect === 'single' ? [] : this.state.selectedRows.slice(0);
		      var selectedRow = this.getSelectedRow(_selectedRows, rowData[this.props.rowKey]);
		      if (selectedRow) {
		        selectedRow.isSelected = !selectedRow.isSelected;
		      } else {
		        rowData.isSelected = true;
		        _selectedRows.push(rowData);
		      }
		      this.setState({ selectedRows: _selectedRows, selected: { rowIdx: rowIdx, idx: 0 } });
		      if (this.props.onRowSelect) {
		        this.props.onRowSelect(_selectedRows.filter(function (r) {
		          return r.isSelected === true;
		        }));
		      }
		    }
		  },
	
	
		  handleCheckboxChange: function handleCheckboxChange(e) {
		    var allRowsSelected = void 0;
		    if (e.currentTarget instanceof HTMLInputElement && e.currentTarget.checked === true) {
		      allRowsSelected = true;
		    } else {
		      allRowsSelected = false;
		    }
		    if (this.useNewRowSelection()) {
		      var _props$rowSelection$s3 = this.props.rowSelection.selectBy,
		          keys = _props$rowSelection$s3.keys,
		          indexes = _props$rowSelection$s3.indexes,
		          isSelectedKey = _props$rowSelection$s3.isSelectedKey;
	
	
		      if (allRowsSelected && typeof this.props.rowSelection.onRowsSelected === 'function') {
		        var _selectedRows2 = [];
		        for (var i = 0; i < this.props.rowsCount; i++) {
		          var rowData = this.props.rowGetter(i);
		          if (!RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, i)) {
		            _selectedRows2.push({ rowIdx: i, row: rowData });
		          }
		        }
	
		        if (_selectedRows2.length > 0) {
		          this.props.rowSelection.onRowsSelected(_selectedRows2);
		        }
		      } else if (!allRowsSelected && typeof this.props.rowSelection.onRowsDeselected === 'function') {
		        var deselectedRows = [];
		        for (var _i2 = 0; _i2 < this.props.rowsCount; _i2++) {
		          var _rowData = this.props.rowGetter(_i2);
		          if (RowUtils.isRowSelected(keys, indexes, isSelectedKey, _rowData, _i2)) {
		            deselectedRows.push({ rowIdx: _i2, row: _rowData });
		          }
		        }
	
		        if (deselectedRows.length > 0) {
		          this.props.rowSelection.onRowsDeselected(deselectedRows);
		        }
		      }
		    } else {
		      var _selectedRows3 = [];
		      for (var _i3 = 0; _i3 < this.props.rowsCount; _i3++) {
		        var row = Object.assign({}, this.props.rowGetter(_i3), { isSelected: allRowsSelected });
		        _selectedRows3.push(row);
		      }
		      this.setState({ selectedRows: _selectedRows3 });
		      if (typeof this.props.onRowSelect === 'function') {
		        this.props.onRowSelect(_selectedRows3.filter(function (r) {
		          return r.isSelected === true;
		        }));
		      }
		    }
		  },
	
		  getScrollOffSet: function getScrollOffSet() {
		    var scrollOffset = 0;
		    var canvas = ReactDOM.findDOMNode(this).querySelector('.react-grid-Canvas');
		    if (canvas) {
		      scrollOffset = canvas.offsetWidth - canvas.clientWidth;
		    }
		    this.setState({ scrollOffset: scrollOffset });
		  },
		  getRowOffsetHeight: function getRowOffsetHeight() {
		    var offsetHeight = 0;
		    this.getHeaderRows().forEach(function (row) {
		      return offsetHeight += parseFloat(row.height, 10);
		    });
		    return offsetHeight;
		  },
		  getHeaderRows: function getHeaderRows() {
		    var _this4 = this;
	
		    var rows = [{ ref: function ref(node) {
		        return _this4.row = node;
		      }, height: this.props.headerRowHeight || this.props.rowHeight, rowType: 'header' }];
		    if (this.state.canFilter === true) {
		      rows.push({
		        ref: function ref(node) {
		          return _this4.filterRow = node;
		        },
		        filterable: true,
		        onFilterChange: this.props.onAddFilter,
		        height: this.props.headerFiltersHeight,
		        rowType: 'filter'
		      });
		    }
		    return rows;
		  },
	
		  getInitialSelectedRows: function getInitialSelectedRows() {
		    var selectedRows = [];
		    for (var i = 0; i < this.props.rowsCount; i++) {
		      selectedRows.push(false);
		    }
		    return selectedRows;
		  },
		  getRowSelectionProps: function getRowSelectionProps() {
		    if (this.props.rowSelection) {
		      return this.props.rowSelection.selectBy;
		    }
	
		    return null;
		  },
		  getSelectedRows: function getSelectedRows() {
		    if (this.props.rowSelection) {
		      return null;
		    }
	
		    return this.state.selectedRows.filter(function (r) {
		      return r.isSelected === true;
		    });
		  },
		  getSelectedValue: function getSelectedValue() {
		    var rowIdx = this.state.selected.rowIdx;
		    var idx = this.state.selected.idx;
		    var cellKey = this.getColumn(idx).key;
		    var row = this.props.rowGetter(rowIdx);
		    return RowUtils.get(row, cellKey);
		  },
		  moveSelectedCell: function moveSelectedCell(e, rowDelta, cellDelta) {
		    // we need to prevent default as we control grid scroll
		    // otherwise it moves every time you left/right which is janky
		    e.preventDefault();
		    var rowIdx = void 0;
		    var idx = void 0;
		    var cellNavigationMode = this.props.cellNavigationMode;
	
		    if (cellNavigationMode !== 'none') {
		      var _calculateNextSelecti = this.calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta);
	
		      idx = _calculateNextSelecti.idx;
		      rowIdx = _calculateNextSelecti.rowIdx;
		    } else {
		      rowIdx = this.state.selected.rowIdx + rowDelta;
		      idx = this.state.selected.idx + cellDelta;
		    }
		    this.onSelect({ idx: idx, rowIdx: rowIdx });
		  },
		  getNbrColumns: function getNbrColumns() {
		    var _props = this.props,
		        columns = _props.columns,
		        enableRowSelect = _props.enableRowSelect;
	
		    return enableRowSelect ? columns.length + 1 : columns.length;
		  },
		  getDataGridDOMNode: function getDataGridDOMNode() {
		    if (!this._gridNode) {
		      this._gridNode = ReactDOM.findDOMNode(this);
		    }
		    return this._gridNode;
		  },
		  calculateNextSelectionPosition: function calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta) {
		    var _rowDelta = rowDelta;
		    var idx = this.state.selected.idx + cellDelta;
		    var nbrColumns = this.getNbrColumns();
		    if (cellDelta > 0) {
		      if (this.isAtLastCellInRow(nbrColumns)) {
		        if (cellNavigationMode === 'changeRow') {
		          _rowDelta = this.isAtLastRow() ? rowDelta : rowDelta + 1;
		          idx = this.isAtLastRow() ? idx : 0;
		        } else {
		          idx = 0;
		        }
		      }
		    } else if (cellDelta < 0) {
		      if (this.isAtFirstCellInRow()) {
		        if (cellNavigationMode === 'changeRow') {
		          _rowDelta = this.isAtFirstRow() ? rowDelta : rowDelta - 1;
		          idx = this.isAtFirstRow() ? 0 : nbrColumns - 1;
		        } else {
		          idx = nbrColumns - 1;
		        }
		      }
		    }
		    var rowIdx = this.state.selected.rowIdx + _rowDelta;
		    return { idx: idx, rowIdx: rowIdx };
		  },
		  isAtLastCellInRow: function isAtLastCellInRow(nbrColumns) {
		    return this.state.selected.idx === nbrColumns - 1;
		  },
		  isAtLastRow: function isAtLastRow() {
		    return this.state.selected.rowIdx === this.props.rowsCount - 1;
		  },
		  isAtFirstCellInRow: function isAtFirstCellInRow() {
		    return this.state.selected.idx === 0;
		  },
		  isAtFirstRow: function isAtFirstRow() {
		    return this.state.selected.rowIdx === 0;
		  },
		  openCellEditor: function openCellEditor(rowIdx, idx) {
		    var _this5 = this;
	
		    var row = this.props.rowGetter(rowIdx);
		    var col = this.getColumn(idx);
	
		    if (!ColumnUtils.canEdit(col, row, this.props.enableCellSelect)) {
		      return;
		    }
	
		    var selected = { rowIdx: rowIdx, idx: idx };
		    if (this.hasSelectedCellChanged(selected)) {
		      this.setState({ selected: selected }, function () {
		        _this5.setActive('Enter');
		      });
		    } else {
		      this.setActive('Enter');
		    }
		  },
		  scrollToColumn: function scrollToColumn(colIdx) {
		    var canvas = ReactDOM.findDOMNode(this).querySelector('.react-grid-Canvas');
		    if (canvas) {
		      var left = 0;
		      var locked = 0;
	
		      for (var i = 0; i < colIdx; i++) {
		        var column = this.getColumn(i);
		        if (column) {
		          if (column.width) {
		            left += column.width;
		          }
		          if (column.locked) {
		            locked += column.width;
		          }
		        }
		      }
	
		      var selectedColumn = this.getColumn(colIdx);
		      if (selectedColumn) {
		        var scrollLeft = left - locked - canvas.scrollLeft;
		        var scrollRight = left + selectedColumn.width - canvas.scrollLeft;
	
		        if (scrollLeft < 0) {
		          canvas.scrollLeft += scrollLeft;
		        } else if (scrollRight > canvas.clientWidth) {
		          var scrollAmount = scrollRight - canvas.clientWidth;
		          canvas.scrollLeft += scrollAmount;
		        }
		      }
		    }
		  },
		  setActive: function setActive(keyPressed) {
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var column = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(column, row, this.props.enableCellSelect) && !this.isActive()) {
		      var _selected = Object.assign({}, this.state.selected, { idx: idx, rowIdx: rowIdx, active: true, initialKeyCode: keyPressed });
		      var showEditor = true;
		      if (typeof this.props.onCheckCellIsEditable === 'function') {
		        var args = Object.assign({}, { row: row, column: column }, _selected);
		        showEditor = this.props.onCheckCellIsEditable(args);
		      }
		      if (showEditor !== false) {
		        this.setState({ selected: _selected }, this.scrollToColumn(idx));
		        this.handleCancelCopy();
		      }
		    }
		  },
		  setInactive: function setInactive() {
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var col = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(col, row, this.props.enableCellSelect) && this.isActive()) {
		      var _selected2 = Object.assign({}, this.state.selected, { idx: idx, rowIdx: rowIdx, active: false });
		      this.setState({ selected: _selected2 });
		    }
		  },
		  isActive: function isActive() {
		    return this.state.selected.active === true;
		  },
	
	
		  setupGridColumns: function setupGridColumns() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
		    var columns = props.columns;
	
		    if (this._cachedColumns === columns) {
		      return this._cachedComputedColumns;
		    }
	
		    this._cachedColumns = columns;
	
		    var cols = columns.slice(0);
		    var unshiftedCols = {};
		    if (this.props.rowActionsCell || props.enableRowSelect && !this.props.rowSelection || props.rowSelection && props.rowSelection.showCheckbox !== false) {
		      var headerRenderer = props.enableRowSelect === 'single' ? null : React.createElement(
		        'div',
		        { className: 'react-grid-checkbox-container' },
		        React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: 'select-all-checkbox', id: 'select-all-checkbox', onChange: this.handleCheckboxChange }),
		        React.createElement('label', { htmlFor: 'select-all-checkbox', className: 'react-grid-checkbox-label' })
		      );
		      var Formatter = this.props.rowActionsCell ? this.props.rowActionsCell : CheckboxEditor;
		      var selectColumn = {
		        key: 'select-row',
		        name: '',
		        formatter: React.createElement(Formatter, { rowSelection: this.props.rowSelection }),
		        onCellChange: this.handleRowSelect,
		        filterable: false,
		        headerRenderer: headerRenderer,
		        width: 60,
		        locked: true,
		        getRowMetaData: function getRowMetaData(rowData) {
		          return rowData;
		        },
		        cellClass: this.props.rowActionsCell ? 'rdg-row-actions-cell' : ''
		      };
		      unshiftedCols = cols.unshift(selectColumn);
		      cols = unshiftedCols > 0 ? cols : unshiftedCols;
		    }
		    this._cachedComputedColumns = cols;
	
		    return this._cachedComputedColumns;
		  },
	
		  copyPasteEnabled: function copyPasteEnabled() {
		    return this.props.onCellCopyPaste !== null;
		  },
	
		  dragEnabled: function dragEnabled() {
		    return this.props.onGridRowsUpdated !== undefined || this.props.onCellsDragged !== undefined;
		  },
	
		  renderToolbar: function renderToolbar() {
		    var Toolbar = this.props.toolbar;
		    if (React.isValidElement(Toolbar)) {
		      return React.cloneElement(Toolbar, { columns: this.props.columns, onToggleFilter: this.onToggleFilter, numberOfRows: this.props.rowsCount });
		    }
		  },
		  render: function render() {
		    var _this6 = this;
	
		    var cellMetaData = {
		      selected: this.state.selected,
		      dragged: this.state.dragged,
		      hoveredRowIdx: this.state.hoveredRowIdx,
		      onCellClick: this.onCellClick,
		      onCellContextMenu: this.onCellContextMenu,
		      onCellDoubleClick: this.onCellDoubleClick,
		      onCommit: this.onCellCommit,
		      onCommitCancel: this.setInactive,
		      copied: this.state.copied,
		      handleDragEnterRow: this.handleDragEnter,
		      handleTerminateDrag: this.handleTerminateDrag,
		      enableCellSelect: this.props.enableCellSelect,
		      onColumnEvent: this.onColumnEvent,
		      openCellEditor: this.openCellEditor,
		      onDragHandleDoubleClick: this.onDragHandleDoubleClick,
		      onCellExpand: this.onCellExpand,
		      onRowExpandToggle: this.onRowExpandToggle,
		      onRowHover: this.onRowHover,
		      getDataGridDOMNode: this.getDataGridDOMNode,
		      isScrollingVerticallyWithKeyboard: this.isKeyDown(KeyCodes.DownArrow) || this.isKeyDown(KeyCodes.UpArrow),
		      isScrollingHorizontallyWithKeyboard: this.isKeyDown(KeyCodes.LeftArrow) || this.isKeyDown(KeyCodes.RightArrow) || this.isKeyDown(KeyCodes.Tab)
		    };
	
		    var toolbar = this.renderToolbar();
		    var containerWidth = this.props.minWidth || this.DOMMetrics.gridWidth();
		    var gridWidth = containerWidth - this.state.scrollOffset;
	
		    // depending on the current lifecycle stage, gridWidth() may not initialize correctly
		    // this also handles cases where it always returns undefined -- such as when inside a div with display:none
		    // eg Bootstrap tabs and collapses
		    if (typeof containerWidth === 'undefined' || isNaN(containerWidth) || containerWidth === 0) {
		      containerWidth = '100%';
		    }
		    if (typeof gridWidth === 'undefined' || isNaN(gridWidth) || gridWidth === 0) {
		      gridWidth = '100%';
		    }
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Container', style: { width: containerWidth } },
		      toolbar,
		      React.createElement(
		        'div',
		        { className: 'react-grid-Main' },
		        React.createElement(BaseGrid, _extends({
		          ref: function ref(node) {
		            return _this6.base = node;
		          }
		        }, this.props, {
		          rowKey: this.props.rowKey,
		          headerRows: this.getHeaderRows(),
		          columnMetrics: this.state.columnMetrics,
		          rowGetter: this.props.rowGetter,
		          rowsCount: this.props.rowsCount,
		          rowHeight: this.props.rowHeight,
		          cellMetaData: cellMetaData,
		          selectedRows: this.getSelectedRows(),
		          rowSelection: this.getRowSelectionProps(),
		          expandedRows: this.state.expandedRows,
		          rowOffsetHeight: this.getRowOffsetHeight(),
		          sortColumn: this.state.sortColumn,
		          sortDirection: this.state.sortDirection,
		          onSort: this.handleSort,
		          minHeight: this.props.minHeight,
		          totalWidth: gridWidth,
		          onViewportKeydown: this.onKeyDown,
		          onViewportKeyup: this.onKeyUp,
		          onViewportDragStart: this.onDragStart,
		          onViewportDragEnd: this.handleDragEnd,
		          onViewportDoubleClick: this.onViewportDoubleClick,
		          onColumnResize: this.onColumnResize,
		          rowScrollTimeout: this.props.rowScrollTimeout,
		          contextMenu: this.props.contextMenu,
		          overScan: this.props.overScan }))
		      )
		    );
		  }
		});
	
		module.exports = ReactDataGrid;
	
	/***/ },
	/* 173 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var Draggable = __webpack_require__(163);
		__webpack_require__(18);
	
		var ResizeHandle = React.createClass({
		  displayName: 'ResizeHandle',
	
		  style: {
		    position: 'absolute',
		    top: 0,
		    right: 0,
		    width: 6,
		    height: '100%'
		  },
	
		  render: function render() {
		    return React.createElement(Draggable, _extends({}, this.props, {
		      className: 'react-grid-HeaderCell__resizeHandle',
		      style: this.style
		    }));
		  }
		});
	
		module.exports = ResizeHandle;
	
	/***/ },
	/* 174 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _classnames = __webpack_require__(9);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		__webpack_require__(27);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var RowGroup = function (_Component) {
		  _inherits(RowGroup, _Component);
	
		  function RowGroup() {
		    _classCallCheck(this, RowGroup);
	
		    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
		    _this.checkFocus = _this.checkFocus.bind(_this);
		    _this.isSelected = _this.isSelected.bind(_this);
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onRowExpandToggle = _this.onRowExpandToggle.bind(_this);
		    _this.onKeyDown = _this.onKeyDown.bind(_this);
		    _this.onRowExpandClick = _this.onRowExpandClick.bind(_this);
		    return _this;
		  }
	
		  RowGroup.prototype.componentDidMount = function componentDidMount() {
		    this.checkFocus();
		  };
	
		  RowGroup.prototype.componentDidUpdate = function componentDidUpdate() {
		    this.checkFocus();
		  };
	
		  RowGroup.prototype.isSelected = function isSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.rowIdx === this.props.idx;
		  };
	
		  RowGroup.prototype.onClick = function onClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
		      meta.onCellClick({ rowIdx: this.props.idx, idx: 0 }, e);
		    }
		  };
	
		  RowGroup.prototype.onKeyDown = function onKeyDown(e) {
		    if (e.key === 'ArrowLeft') {
		      this.onRowExpandToggle(false);
		    }
		    if (e.key === 'ArrowRight') {
		      this.onRowExpandToggle(true);
		    }
		    if (e.key === 'Enter') {
		      this.onRowExpandToggle(!this.props.isExpanded);
		    }
		  };
	
		  RowGroup.prototype.onRowExpandClick = function onRowExpandClick() {
		    this.onRowExpandToggle(!this.props.isExpanded);
		  };
	
		  RowGroup.prototype.onRowExpandToggle = function onRowExpandToggle(expand) {
		    var shouldExpand = expand == null ? !this.props.isExpanded : expand;
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onRowExpandToggle && typeof meta.onRowExpandToggle === 'function') {
		      meta.onRowExpandToggle({ rowIdx: this.props.idx, shouldExpand: shouldExpand, columnGroupName: this.props.columnGroupName, name: this.props.name });
		    }
		  };
	
		  RowGroup.prototype.getClassName = function getClassName() {
		    return (0, _classnames2['default'])('react-grid-row-group', 'react-grid-Row', { 'row-selected': this.isSelected() });
		  };
	
		  RowGroup.prototype.checkFocus = function checkFocus() {
		    if (this.isSelected()) {
		      _reactDom2['default'].findDOMNode(this).focus();
		    }
		  };
	
		  RowGroup.prototype.render = function render() {
		    var style = {
		      height: '50px',
		      overflow: 'hidden',
		      border: '1px solid #dddddd',
		      paddingTop: '15px',
		      paddingLeft: '5px'
		    };
		    var rowGroupRendererProps = Object.assign({ onRowExpandClick: this.onRowExpandClick }, this.props);
	
		    return _react2['default'].createElement(
		      'div',
		      { style: style, className: this.getClassName(), onClick: this.onClick, onKeyDown: this.onKeyDown, tabIndex: -1 },
		      _react2['default'].createElement(this.props.renderer, rowGroupRendererProps)
		    );
		  };
	
		  return RowGroup;
		}(_react.Component);
	
		RowGroup.propTypes = {
		  name: _react.PropTypes.string.isRequired,
		  columnGroupName: _react.PropTypes.string.isRequired,
		  isExpanded: _react.PropTypes.bool.isRequired,
		  treeDepth: _react.PropTypes.number.isRequired,
		  height: _react.PropTypes.number.isRequired,
		  cellMetaData: _react.PropTypes.object,
		  idx: _react.PropTypes.number.isRequired,
		  renderer: _react.PropTypes.func
		};
	
		var DefaultRowGroupRenderer = function DefaultRowGroupRenderer(props) {
		  var treeDepth = props.treeDepth || 0;
		  var marginLeft = treeDepth * 20;
	
		  return _react2['default'].createElement(
		    'div',
		    null,
		    _react2['default'].createElement(
		      'span',
		      { className: 'row-expand-icon', style: { float: 'left', marginLeft: marginLeft, cursor: 'pointer' }, onClick: props.onRowExpandClick },
		      props.isExpanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
		    ),
		    _react2['default'].createElement(
		      'strong',
		      null,
		      props.columnGroupName,
		      ' : ',
		      props.name
		    )
		  );
		};
	
		DefaultRowGroupRenderer.propTypes = {
		  onRowExpandClick: _react.PropTypes.func.isRequired,
		  isExpanded: _react.PropTypes.bool.isRequired,
		  treeDepth: _react.PropTypes.number.isRequired,
		  name: _react.PropTypes.string.isRequired,
		  columnGroupName: _react.PropTypes.string.isRequired
		};
	
		RowGroup.defaultProps = {
		  renderer: DefaultRowGroupRenderer
		};
	
		exports['default'] = RowGroup;
	
	/***/ },
	/* 175 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var ScrollShim = {
		  appendScrollShim: function appendScrollShim() {
		    if (!this._scrollShim) {
		      var size = this._scrollShimSize();
		      var shim = document.createElement('div');
		      if (shim.classList) {
		        shim.classList.add('react-grid-ScrollShim'); // flow - not compatible with HTMLElement
		      } else {
		        shim.className += ' react-grid-ScrollShim';
		      }
		      shim.style.position = 'absolute';
		      shim.style.top = 0;
		      shim.style.left = 0;
		      shim.style.width = size.width + 'px';
		      shim.style.height = size.height + 'px';
		      _reactDom2['default'].findDOMNode(this).appendChild(shim);
		      this._scrollShim = shim;
		    }
		    this._scheduleRemoveScrollShim();
		  },
		  _scrollShimSize: function _scrollShimSize() {
		    return {
		      width: this.props.width,
		      height: this.props.length * this.props.rowHeight
		    };
		  },
		  _scheduleRemoveScrollShim: function _scheduleRemoveScrollShim() {
		    if (this._scheduleRemoveScrollShimTimer) {
		      clearTimeout(this._scheduleRemoveScrollShimTimer);
		    }
		    this._scheduleRemoveScrollShimTimer = setTimeout(this._removeScrollShim, 200);
		  },
		  _removeScrollShim: function _removeScrollShim() {
		    if (this._scrollShim) {
		      this._scrollShim.parentNode.removeChild(this._scrollShim);
		      this._scrollShim = undefined;
		    }
		  }
		};
	
		module.exports = ScrollShim;
	
	/***/ },
	/* 176 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var Canvas = __webpack_require__(160);
		var ViewportScroll = __webpack_require__(177);
		var cellMetaDataShape = __webpack_require__(14);
		var PropTypes = React.PropTypes;
	
		var Viewport = React.createClass({
		  displayName: 'Viewport',
	
		  mixins: [ViewportScroll],
	
		  propTypes: {
		    rowOffsetHeight: PropTypes.number.isRequired,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
		    columnMetrics: PropTypes.object.isRequired,
		    rowGetter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
		    selectedRows: PropTypes.array,
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    expandedRows: PropTypes.array,
		    rowRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		    rowsCount: PropTypes.number.isRequired,
		    rowHeight: PropTypes.number.isRequired,
		    onRows: PropTypes.func,
		    onScroll: PropTypes.func,
		    minHeight: PropTypes.number,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    rowKey: PropTypes.string.isRequired,
		    rowScrollTimeout: PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    rowGroupRenderer: PropTypes.func
		  },
	
		  onScroll: function onScroll(scroll) {
		    this.updateScroll(scroll.scrollTop, scroll.scrollLeft, this.state.height, this.props.rowHeight, this.props.rowsCount);
	
		    if (this.props.onScroll) {
		      this.props.onScroll({ scrollTop: scroll.scrollTop, scrollLeft: scroll.scrollLeft });
		    }
		  },
		  getScroll: function getScroll() {
		    return this.canvas.getScroll();
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    this.canvas.setScrollLeft(scrollLeft);
		  },
		  render: function render() {
		    var _this = this;
	
		    var style = {
		      padding: 0,
		      bottom: 0,
		      left: 0,
		      right: 0,
		      overflow: 'hidden',
		      position: 'absolute',
		      top: this.props.rowOffsetHeight
		    };
		    return React.createElement(
		      'div',
		      {
		        className: 'react-grid-Viewport',
		        style: style },
		      React.createElement(Canvas, {
		        ref: function ref(node) {
		          return _this.canvas = node;
		        },
		        rowKey: this.props.rowKey,
		        totalWidth: this.props.totalWidth,
		        width: this.props.columnMetrics.width,
		        rowGetter: this.props.rowGetter,
		        rowsCount: this.props.rowsCount,
		        selectedRows: this.props.selectedRows,
		        expandedRows: this.props.expandedRows,
		        columns: this.props.columnMetrics.columns,
		        rowRenderer: this.props.rowRenderer,
		        displayStart: this.state.displayStart,
		        displayEnd: this.state.displayEnd,
		        visibleStart: this.state.visibleStart,
		        visibleEnd: this.state.visibleEnd,
		        colVisibleStart: this.state.colVisibleStart,
		        colVisibleEnd: this.state.colVisibleEnd,
		        colDisplayStart: this.state.colDisplayStart,
		        colDisplayEnd: this.state.colDisplayEnd,
		        cellMetaData: this.props.cellMetaData,
		        height: this.state.height,
		        rowHeight: this.props.rowHeight,
		        onScroll: this.onScroll,
		        onRows: this.props.onRows,
		        rowScrollTimeout: this.props.rowScrollTimeout,
		        contextMenu: this.props.contextMenu,
		        rowSelection: this.props.rowSelection,
		        getSubRowDetails: this.props.getSubRowDetails,
		        rowGroupRenderer: this.props.rowGroupRenderer,
		        isScrolling: this.state.isScrolling || false
		      })
		    );
		  }
		});
	
		module.exports = Viewport;
	
	/***/ },
	/* 177 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _ColumnUtils = __webpack_require__(10);
	
		var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var DOMMetrics = __webpack_require__(22);
		var min = Math.min;
		var max = Math.max;
		var floor = Math.floor;
		var ceil = Math.ceil;
	
		module.exports = {
		  mixins: [DOMMetrics.MetricsMixin],
	
		  DOMMetrics: {
		    viewportHeight: function viewportHeight() {
		      return ReactDOM.findDOMNode(this).offsetHeight;
		    },
		    viewportWidth: function viewportWidth() {
		      return ReactDOM.findDOMNode(this).offsetWidth;
		    }
		  },
	
		  propTypes: {
		    rowHeight: React.PropTypes.number,
		    rowsCount: React.PropTypes.number.isRequired
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowHeight: 30
		    };
		  },
		  getInitialState: function getInitialState() {
		    return this.getGridState(this.props);
		  },
		  getGridState: function getGridState(props) {
		    var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
		    var canvasHeight = props.minHeight - props.rowOffsetHeight;
		    var renderedRowsCount = ceil((props.minHeight - props.rowHeight) / props.rowHeight);
		    var totalRowCount = min(renderedRowsCount * 4, props.rowsCount);
		    return {
		      displayStart: 0,
		      displayEnd: totalRowCount,
		      visibleStart: 0,
		      visibleEnd: totalRowCount,
		      height: canvasHeight,
		      scrollTop: 0,
		      scrollLeft: 0,
		      colVisibleStart: 0,
		      colVisibleEnd: totalNumberColumns,
		      colDisplayStart: 0,
		      colDisplayEnd: totalNumberColumns
		    };
		  },
		  getRenderedColumnCount: function getRenderedColumnCount(displayStart, width) {
		    var remainingWidth = width > 0 ? width : this.props.columnMetrics.totalWidth;
		    if (remainingWidth === 0) {
		      remainingWidth = ReactDOM.findDOMNode(this).offsetWidth;
		    }
		    var columnIndex = displayStart;
		    var columnCount = 0;
		    while (remainingWidth > 0) {
		      var column = _ColumnUtils2['default'].getColumn(this.props.columnMetrics.columns, columnIndex);
	
		      if (!column) {
		        break;
		      }
	
		      columnCount++;
		      columnIndex++;
		      remainingWidth -= column.width;
		    }
		    return columnCount;
		  },
		  getVisibleColStart: function getVisibleColStart(scrollLeft) {
		    var remainingScroll = scrollLeft;
		    var columnIndex = -1;
		    while (remainingScroll >= 0) {
		      columnIndex++;
		      remainingScroll -= _ColumnUtils2['default'].getColumn(this.props.columnMetrics.columns, columnIndex).width;
		    }
		    return columnIndex;
		  },
		  resetScrollStateAfterDelay: function resetScrollStateAfterDelay() {
		    if (this.resetScrollStateTimeoutId) {
		      clearTimeout(this.resetScrollStateTimeoutId);
		    }
	
		    this.resetScrollStateTimeoutId = setTimeout(this.resetScrollStateAfterDelayCallback, 500);
		  },
		  resetScrollStateAfterDelayCallback: function resetScrollStateAfterDelayCallback() {
		    this.resetScrollStateTimeoutId = null;
		    this.setState({
		      isScrolling: false
		    });
		  },
		  updateScroll: function updateScroll(scrollTop, scrollLeft, height, rowHeight, length, width) {
		    var isScrolling = true;
		    this.resetScrollStateAfterDelay();
	
		    var renderedRowsCount = ceil(height / rowHeight);
	
		    var visibleStart = max(0, floor(scrollTop / rowHeight));
	
		    var visibleEnd = min(visibleStart + renderedRowsCount, length);
	
		    var displayStart = max(0, visibleStart - this.props.overScan.rowsStart);
	
		    var displayEnd = min(visibleEnd + this.props.overScan.rowsEnd, length);
	
		    var totalNumberColumns = _ColumnUtils2['default'].getSize(this.props.columnMetrics.columns);
		    var colVisibleStart = totalNumberColumns > 0 ? max(0, this.getVisibleColStart(scrollLeft)) : 0;
		    var renderedColumnCount = this.getRenderedColumnCount(colVisibleStart, width);
		    var colVisibleEnd = renderedColumnCount !== 0 ? colVisibleStart + renderedColumnCount : totalNumberColumns;
		    var colDisplayStart = max(0, colVisibleStart - this.props.overScan.colsStart);
		    var colDisplayEnd = min(colVisibleEnd + this.props.overScan.colsEnd, totalNumberColumns);
	
		    var nextScrollState = {
		      visibleStart: visibleStart,
		      visibleEnd: visibleEnd,
		      displayStart: displayStart,
		      displayEnd: displayEnd,
		      height: height,
		      scrollTop: scrollTop,
		      scrollLeft: scrollLeft,
		      colVisibleStart: colVisibleStart,
		      colVisibleEnd: colVisibleEnd,
		      colDisplayStart: colDisplayStart,
		      colDisplayEnd: colDisplayEnd,
		      isScrolling: isScrolling
		    };
	
		    this.setState(nextScrollState);
		  },
		  metricsUpdated: function metricsUpdated() {
		    var height = this.DOMMetrics.viewportHeight();
		    var width = this.DOMMetrics.viewportWidth();
		    if (height) {
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, height, this.props.rowHeight, this.props.rowsCount, width);
		    }
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (this.props.rowHeight !== nextProps.rowHeight || this.props.minHeight !== nextProps.minHeight || _ColumnUtils2['default'].getSize(this.props.columnMetrics.columns) !== _ColumnUtils2['default'].getSize(nextProps.columnMetrics.columns)) {
		      this.setState(this.getGridState(nextProps));
		    } else if (this.props.rowsCount !== nextProps.rowsCount) {
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height, nextProps.rowHeight, nextProps.rowsCount);
		      // Added to fix the hiding of the bottom scrollbar when showing the filters.
		    } else if (this.props.rowOffsetHeight !== nextProps.rowOffsetHeight) {
		      // The value of height can be positive or negative and will be added to the current height to cater for changes in the header height (due to the filer)
		      var _height = this.props.rowOffsetHeight - nextProps.rowOffsetHeight;
	
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height + _height, nextProps.rowHeight, nextProps.rowsCount);
		    }
		  }
		};
	
	/***/ },
	/* 178 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ExcelColumn = __webpack_require__(11);
	
		var FilterableHeaderCell = React.createClass({
		  displayName: 'FilterableHeaderCell',
	
	
		  propTypes: {
		    onChange: React.PropTypes.func.isRequired,
		    column: React.PropTypes.shape(ExcelColumn)
		  },
	
		  getInitialState: function getInitialState() {
		    return { filterTerm: '' };
		  },
		  handleChange: function handleChange(e) {
		    var val = e.target.value;
		    this.setState({ filterTerm: val });
		    this.props.onChange({ filterTerm: val, column: this.props.column });
		  },
	
	
		  renderInput: function renderInput() {
		    if (this.props.column.filterable === false) {
		      return React.createElement('span', null);
		    }
	
		    var inputKey = 'header-filter-' + this.props.column.key;
		    return React.createElement('input', { key: inputKey, type: 'text', className: 'form-control input-sm', placeholder: 'Search', value: this.state.filterTerm, onChange: this.handleChange });
		  },
	
		  render: function render() {
		    return React.createElement(
		      'div',
		      null,
		      React.createElement(
		        'div',
		        { className: 'form-group' },
		        this.renderInput()
		      )
		    );
		  }
		});
	
		module.exports = FilterableHeaderCell;
	
	/***/ },
	/* 179 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var DEFINE_SORT = {
		  ASC: 'ASC',
		  DESC: 'DESC',
		  NONE: 'NONE'
		};
	
		var SortableHeaderCell = React.createClass({
		  displayName: 'SortableHeaderCell',
	
		  propTypes: {
		    columnKey: React.PropTypes.string.isRequired,
		    column: React.PropTypes.shape({ name: React.PropTypes.node }),
		    onSort: React.PropTypes.func.isRequired,
		    sortDirection: React.PropTypes.oneOf(Object.keys(DEFINE_SORT))
		  },
	
		  onClick: function onClick() {
		    var direction = void 0;
		    switch (this.props.sortDirection) {
		      default:
		      case null:
		      case undefined:
		      case DEFINE_SORT.NONE:
		        direction = DEFINE_SORT.ASC;
		        break;
		      case DEFINE_SORT.ASC:
		        direction = DEFINE_SORT.DESC;
		        break;
		      case DEFINE_SORT.DESC:
		        direction = DEFINE_SORT.NONE;
		        break;
		    }
		    this.props.onSort(this.props.columnKey, direction);
		  },
	
		  getSortByText: function getSortByText() {
		    var unicodeKeys = {
		      ASC: '9650',
		      DESC: '9660'
		    };
		    return this.props.sortDirection === 'NONE' ? '' : String.fromCharCode(unicodeKeys[this.props.sortDirection]);
		  },
	
		  render: function render() {
		    var className = joinClasses({
		      'react-grid-HeaderCell-sortable': true,
		      'react-grid-HeaderCell-sortable--ascending': this.props.sortDirection === 'ASC',
		      'react-grid-HeaderCell-sortable--descending': this.props.sortDirection === 'DESC'
		    });
	
		    return React.createElement(
		      'div',
		      { className: className,
		        onClick: this.onClick,
		        style: { cursor: 'pointer' } },
		      React.createElement(
		        'span',
		        { className: 'pull-right' },
		        this.getSortByText()
		      ),
		      this.props.column.name
		    );
		  }
		});
	
		module.exports = SortableHeaderCell;
		module.exports.DEFINE_SORT = DEFINE_SORT;
	
	/***/ },
	/* 180 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var keyboardHandlerMixin = __webpack_require__(61);
		var SimpleTextEditor = __webpack_require__(67);
		var isFunction = __webpack_require__(37);
		__webpack_require__(26);
	
		var EditorContainer = React.createClass({
		  displayName: 'EditorContainer',
	
		  mixins: [keyboardHandlerMixin],
	
		  propTypes: {
		    rowIdx: React.PropTypes.number,
		    rowData: React.PropTypes.object.isRequired,
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired,
		    cellMetaData: React.PropTypes.shape({
		      selected: React.PropTypes.object.isRequired,
		      copied: React.PropTypes.object,
		      dragged: React.PropTypes.object,
		      onCellClick: React.PropTypes.func,
		      onCellDoubleClick: React.PropTypes.func,
		      onCommitCancel: React.PropTypes.func,
		      onCommit: React.PropTypes.func
		    }).isRequired,
		    column: React.PropTypes.object.isRequired,
		    height: React.PropTypes.number.isRequired
		  },
	
		  changeCommitted: false,
	
		  getInitialState: function getInitialState() {
		    return { isInvalid: false };
		  },
	
	
		  componentDidMount: function componentDidMount() {
		    var inputNode = this.getInputNode();
		    if (inputNode !== undefined) {
		      this.setTextInputFocus();
		      if (!this.getEditor().disableContainerStyles) {
		        inputNode.className += ' editor-main';
		        inputNode.style.height = this.props.height - 1 + 'px';
		      }
		    }
		  },
	
		  componentWillUnmount: function componentWillUnmount() {
		    if (!this.changeCommitted && !this.hasEscapeBeenPressed()) {
		      this.commit({ key: 'Enter' });
		    }
		  },
	
		  createEditor: function createEditor() {
		    var _this = this;
	
		    var editorRef = function editorRef(c) {
		      return _this.editor = c;
		    };
		    var editorProps = {
		      ref: editorRef,
		      column: this.props.column,
		      value: this.getInitialValue(),
		      onCommit: this.commit,
		      rowMetaData: this.getRowMetaData(),
		      rowData: this.props.rowData,
		      height: this.props.height,
		      onBlur: this.commit,
		      onOverrideKeyDown: this.onKeyDown
		    };
	
		    var CustomEditor = this.props.column.editor;
		    // return custom column editor or SimpleEditor if none specified
		    if (React.isValidElement(CustomEditor)) {
		      return React.cloneElement(CustomEditor, editorProps);
		    }
		    if (isFunction(CustomEditor)) {
		      return React.createElement(CustomEditor, _extends({ ref: editorRef }, editorProps));
		    }
	
		    return React.createElement(SimpleTextEditor, { ref: editorRef, column: this.props.column, value: this.getInitialValue(), onBlur: this.commit, rowMetaData: this.getRowMetaData(), onKeyDown: function onKeyDown() {}, commit: function commit() {} });
		  },
		  onPressEnter: function onPressEnter() {
		    this.commit({ key: 'Enter' });
		  },
		  onPressTab: function onPressTab() {
		    this.commit({ key: 'Tab' });
		  },
		  onPressEscape: function onPressEscape(e) {
		    if (!this.editorIsSelectOpen()) {
		      this.props.cellMetaData.onCommitCancel();
		    } else {
		      // prevent event from bubbling if editor has results to select
		      e.stopPropagation();
		    }
		  },
		  onPressArrowDown: function onPressArrowDown(e) {
		    if (this.editorHasResults()) {
		      // dont want to propogate as that then moves us round the grid
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowUp: function onPressArrowUp(e) {
		    if (this.editorHasResults()) {
		      // dont want to propogate as that then moves us round the grid
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowLeft: function onPressArrowLeft(e) {
		    // prevent event propogation. this disables left cell navigation
		    if (!this.isCaretAtBeginningOfInput()) {
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowRight: function onPressArrowRight(e) {
		    // prevent event propogation. this disables right cell navigation
		    if (!this.isCaretAtEndOfInput()) {
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  editorHasResults: function editorHasResults() {
		    if (isFunction(this.getEditor().hasResults)) {
		      return this.getEditor().hasResults();
		    }
	
		    return false;
		  },
		  editorIsSelectOpen: function editorIsSelectOpen() {
		    if (isFunction(this.getEditor().isSelectOpen)) {
		      return this.getEditor().isSelectOpen();
		    }
	
		    return false;
		  },
		  getRowMetaData: function getRowMetaData() {
		    // clone row data so editor cannot actually change this
		    // convention based method to get corresponding Id or Name of any Name or Id property
		    if (typeof this.props.column.getRowMetaData === 'function') {
		      return this.props.column.getRowMetaData(this.props.rowData, this.props.column);
		    }
		  },
		  getEditor: function getEditor() {
		    return this.editor;
		  },
		  getInputNode: function getInputNode() {
		    return this.getEditor().getInputNode();
		  },
		  getInitialValue: function getInitialValue() {
		    var selected = this.props.cellMetaData.selected;
		    var keyCode = selected.initialKeyCode;
		    if (keyCode === 'Delete' || keyCode === 'Backspace') {
		      return '';
		    } else if (keyCode === 'Enter') {
		      return this.props.value;
		    }
	
		    var text = keyCode ? String.fromCharCode(keyCode) : this.props.value;
		    return text;
		  },
		  getContainerClass: function getContainerClass() {
		    return joinClasses({
		      'has-error': this.state.isInvalid === true
		    });
		  },
		  commit: function commit(args) {
		    var opts = args || {};
		    var updated = this.getEditor().getValue();
		    if (this.isNewValueValid(updated)) {
		      this.changeCommitted = true;
		      var cellKey = this.props.column.key;
		      this.props.cellMetaData.onCommit({ cellKey: cellKey, rowIdx: this.props.rowIdx, updated: updated, key: opts.key });
		    }
		  },
		  isNewValueValid: function isNewValueValid(value) {
		    if (isFunction(this.getEditor().validate)) {
		      var isValid = this.getEditor().validate(value);
		      this.setState({ isInvalid: !isValid });
		      return isValid;
		    }
	
		    return true;
		  },
		  setCaretAtEndOfInput: function setCaretAtEndOfInput() {
		    var input = this.getInputNode();
		    // taken from http://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
		    var txtLength = input.value.length;
		    if (input.setSelectionRange) {
		      input.setSelectionRange(txtLength, txtLength);
		    } else if (input.createTextRange) {
		      var fieldRange = input.createTextRange();
		      fieldRange.moveStart('character', txtLength);
		      fieldRange.collapse();
		      fieldRange.select();
		    }
		  },
		  isCaretAtBeginningOfInput: function isCaretAtBeginningOfInput() {
		    var inputNode = this.getInputNode();
		    return inputNode.selectionStart === inputNode.selectionEnd && inputNode.selectionStart === 0;
		  },
		  isCaretAtEndOfInput: function isCaretAtEndOfInput() {
		    var inputNode = this.getInputNode();
		    return inputNode.selectionStart === inputNode.value.length;
		  },
		  isBodyClicked: function isBodyClicked(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return relatedTarget === null;
		  },
		  isViewportClicked: function isViewportClicked(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return relatedTarget.className.indexOf('react-grid-Viewport') > -1;
		  },
		  isClickInisdeEditor: function isClickInisdeEditor(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return e.currentTarget.contains(relatedTarget) || relatedTarget.className.indexOf('editing') > -1 || relatedTarget.className.indexOf('react-grid-Cell') > -1;
		  },
		  getRelatedTarget: function getRelatedTarget(e) {
		    return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		  },
		  handleRightClick: function handleRightClick(e) {
		    e.stopPropagation();
		  },
		  handleBlur: function handleBlur(e) {
		    e.stopPropagation();
		    if (this.isBodyClicked(e)) {
		      this.commit(e);
		    }
	
		    if (!this.isBodyClicked(e)) {
		      // prevent null reference
		      if (this.isViewportClicked(e) || !this.isClickInisdeEditor(e)) {
		        this.commit(e);
		      }
		    }
		  },
		  setTextInputFocus: function setTextInputFocus() {
		    var selected = this.props.cellMetaData.selected;
		    var keyCode = selected.initialKeyCode;
		    var inputNode = this.getInputNode();
		    inputNode.focus();
		    if (inputNode.tagName === 'INPUT') {
		      if (!this.isKeyPrintable(keyCode)) {
		        inputNode.focus();
		        inputNode.select();
		      } else {
		        inputNode.select();
		      }
		    }
		  },
		  hasEscapeBeenPressed: function hasEscapeBeenPressed() {
		    var pressed = false;
		    var escapeKey = 27;
		    if (window.event) {
		      if (window.event.keyCode === escapeKey) {
		        pressed = true;
		      } else if (window.event.which === escapeKey) {
		        pressed = true;
		      }
		    }
		    return pressed;
		  },
		  renderStatusIcon: function renderStatusIcon() {
		    if (this.state.isInvalid === true) {
		      return React.createElement('span', { className: 'glyphicon glyphicon-remove form-control-feedback' });
		    }
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { className: this.getContainerClass(), onBlur: this.handleBlur, onKeyDown: this.onKeyDown, onContextMenu: this.handleRightClick },
		      this.createEditor(),
		      this.renderStatusIcon()
		    );
		  }
		});
	
		module.exports = EditorContainer;
	
	/***/ },
	/* 181 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = {
		  CheckboxEditor: __webpack_require__(65),
		  EditorBase: __webpack_require__(66),
		  SimpleTextEditor: __webpack_require__(67)
		};
	
	/***/ },
	/* 182 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	
		var focusableComponentWrapper = function focusableComponentWrapper(WrappedComponent) {
		  return function (_Component) {
		    _inherits(ComponentWrapper, _Component);
	
		    function ComponentWrapper() {
		      _classCallCheck(this, ComponentWrapper);
	
		      var _this = _possibleConstructorReturn(this, _Component.call(this));
	
		      _this.checkFocus = _this.checkFocus.bind(_this);
		      _this.state = { isScrolling: false };
		      return _this;
		    }
	
		    ComponentWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		      return WrappedComponent.isSelected(this.props) !== WrappedComponent.isSelected(nextProps);
		    };
	
		    ComponentWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		      var isScrolling = WrappedComponent.isScrolling(nextProps);
		      if (isScrolling && !this.state.isScrolling) {
		        this.setState({ isScrolling: isScrolling });
		      }
		    };
	
		    ComponentWrapper.prototype.componentDidMount = function componentDidMount() {
		      this.checkFocus();
		    };
	
		    ComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
		      this.checkFocus();
		    };
	
		    ComponentWrapper.prototype.checkFocus = function checkFocus() {
		      if (WrappedComponent.isSelected(this.props) && this.state.isScrolling) {
		        this.focus();
		        this.setState({ isScrolling: false });
		      }
		    };
	
		    ComponentWrapper.prototype.focus = function focus() {
		      _reactDom2['default'].findDOMNode(this).focus();
		    };
	
		    ComponentWrapper.prototype.render = function render() {
		      return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
		    };
	
		    return ComponentWrapper;
		  }(_react.Component);
		};
	
		exports['default'] = focusableComponentWrapper;
	
	/***/ },
	/* 183 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var SimpleCellFormatter = React.createClass({
		  displayName: 'SimpleCellFormatter',
	
		  propTypes: {
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired
		  },
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.value !== this.props.value;
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { title: this.props.value },
		      this.props.value
		    );
		  }
		});
	
		module.exports = SimpleCellFormatter;
	
	/***/ },
	/* 184 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _GridPropHelpers = __webpack_require__(185);
	
		var _GridPropHelpers2 = _interopRequireDefault(_GridPropHelpers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = {
		  test: { GridPropHelpers: _GridPropHelpers2['default'] }
		};
	
	/***/ },
	/* 185 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var _rows = [];
		for (var i = 0; i < 1000; i++) {
		  _rows.push({
		    id: i,
		    title: 'Title ' + i,
		    count: i * 1000
		  });
		}
		module.exports = {
		  columns: [{
		    key: 'id',
		    name: 'ID',
		    width: 100
		  }, {
		    key: 'title',
		    name: 'Title',
		    width: 100
		  }, {
		    key: 'count',
		    name: 'Count',
		    width: 100
		  }],
		  rowGetter: function rowGetter(i) {
		    return _rows[i];
		  },
		  rowsCount: function rowsCount() {
		    return _rows.length;
		  },
		  cellMetaData: {
		    selected: { idx: 2, rowIdx: 3 },
		    dragged: null,
		    copied: null
		  }
		};
	
	/***/ },
	/* 186 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _RowComparer = __webpack_require__(62);
	
		var _RowComparer2 = _interopRequireDefault(_RowComparer);
	
		var _RowsContainer = __webpack_require__(64);
	
		var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var Grid = __webpack_require__(172);
	
	
		module.exports = Grid;
		module.exports.Row = __webpack_require__(34);
		module.exports.Cell = __webpack_require__(59);
		module.exports.HeaderCell = __webpack_require__(60);
		module.exports.RowComparer = _RowComparer2['default'];
		module.exports.RowsContainer = _RowsContainer2['default'];
		module.exports.editors = __webpack_require__(181);
		module.exports.utils = __webpack_require__(187);
		module.exports.shapes = __webpack_require__(171);
		module.exports._constants = __webpack_require__(58);
		module.exports._helpers = __webpack_require__(184);
	
	/***/ },
	/* 187 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = {
		  isEmptyArray: __webpack_require__(188),
		  isEmptyObject: __webpack_require__(189),
		  isFunction: __webpack_require__(37),
		  isImmutableCollection: __webpack_require__(190),
		  getMixedTypeValueRetriever: __webpack_require__(192),
		  isColumnsImmutable: __webpack_require__(68),
		  isImmutableMap: __webpack_require__(191)
		};
	
	/***/ },
	/* 188 */
	/***/ function(module, exports) {
	
		"use strict";
	
		var isEmptyArray = function isEmptyArray(obj) {
		  return Array.isArray(obj) && obj.length === 0;
		};
	
		module.exports = isEmptyArray;
	
	/***/ },
	/* 189 */
	/***/ function(module, exports) {
	
		"use strict";
	
		function isEmpty(obj) {
		  return Object.keys(obj).length === 0 && obj.constructor === Object;
		}
	
		module.exports = isEmpty;
	
	/***/ },
	/* 190 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _immutable = __webpack_require__(24);
	
		var isImmutableCollection = function isImmutableCollection(objToVerify) {
		  return _immutable.Iterable.isIterable(objToVerify);
		};
	
		module.exports = isImmutableCollection;
	
	/***/ },
	/* 191 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _immutable = __webpack_require__(24);
	
		module.exports = _immutable.Map.isMap;
	
	/***/ },
	/* 192 */
	/***/ function(module, exports) {
	
		"use strict";
	
		var getMixedTypeValueRetriever = function getMixedTypeValueRetriever(isImmutable) {
		  var retObj = {};
		  var retriever = function retriever(item, key) {
		    return item[key];
		  };
		  var immutableRetriever = function immutableRetriever(immutable, key) {
		    return immutable.get(key);
		  };
	
		  retObj.getValue = isImmutable ? immutableRetriever : retriever;
	
		  return retObj;
		};
	
		module.exports = getMixedTypeValueRetriever;
	
	/***/ },
	/* 193 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Cell{background-color:#fff;padding-left:8px;padding-right:8px;border-right:1px solid #eee;border-bottom:1px solid #ddd}.react-grid-Cell:focus{outline:2px solid #66afe9;outline-offset:-2px}.react-grid-Cell:focus .drag-handle{position:absolute;bottom:-5px;right:-4px;background:#66afe9;width:8px;height:8px;border:1px solid #fff;border-right:0;border-bottom:0;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Cell:not(.editing) .react-grid-Cell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-Cell.readonly{background-color:#000}.react-grid-Cell.copied{background:rgba(0,0,255,.2)!important}.react-grid-Cell--locked:last-of-type{border-right:1px solid #ddd;box-shadow:none;z-index:99}.react-grid-Cell:hover:focus .drag-handle .glyphicon-arrow-down{display:\"block\"}.react-grid-Cell.is-dragged-over-down{border-right:1px dashed #000;border-left:1px dashed #000;border-bottom:1px dashed #000}.react-grid-Cell.is-dragged-over-up{border-right:1px dashed #000;border-left:1px dashed #000;border-top:1px dashed #000}.react-grid-Cell.is-dragged-over-up .drag-handle{top:-5px}.react-grid-Cell:hover{background:#eee}.react-grid-cell .form-control-feedback{color:#a94442;position:absolute;top:0;right:10px;z-index:1000000;display:block;width:34px;height:34px}.react-grid-Cell.was-dragged-over{border-right:1px dashed #000;border-left:1px dashed #000}.react-grid-Cell:hover:focus .drag-handle{position:absolute;bottom:-8px;right:-7px;background:#fff;width:16px;height:16px;border:1px solid #66afe9;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Row.row-selected .react-grid-Cell{background-color:#dbecfa}.react-grid-Cell.editing{padding:0;overflow:visible!important}.react-grid-Cell.editing .has-error input{border:2px solid red!important;border-radius:2px!important}.react-grid-Cell__value ul{margin-top:0;margin-bottom:0;display:inline-block}.react-grid-Cell__value .btn-sm{padding:0}.cell-tooltip{position:relative;display:inline-block}.cell-tooltip .cell-tooltip-text{visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:-150%;left:50%;margin-left:-60px;opacity:1s}.cell-tooltip:hover .cell-tooltip-text{visibility:visible;opacity:.8}.cell-tooltip .cell-tooltip-text:after{content:\" \";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}.react-grid-Canvas.opaque .react-grid-Cell.cell-tooltip:hover .cell-tooltip-text{visibility:hidden}", ""]);
	
		// exports
	
	
	/***/ },
	/* 194 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".radio-custom,.react-grid-checkbox{opacity:0;position:absolute}.radio-custom,.radio-custom-label,.react-grid-checkbox,.react-grid-checkbox-label{display:inline-block;vertical-align:middle;margin:10px;cursor:pointer}.radio-custom-label,.react-grid-checkbox-label{position:relative}.radio-custom+.radio-custom-label:before,.react-grid-checkbox+.react-grid-checkbox-label:before{content:\"\";background:#fff;border:2px solid #ddd;display:inline-block;vertical-align:middle;width:20px;height:20px;text-align:center}.react-grid-checkbox:checked+.react-grid-checkbox-label:before{background:#005295;box-shadow:inset 0 0 0 4px #fff}.radio-custom:focus+.radio-custom-label,.react-grid-checkbox:focus+.react-grid-checkbox-label{outline:1px solid #ddd}.react-grid-HeaderCell input[type=checkbox]{z-index:99999}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0 10px}.react-grid-HeaderCell>.react-grid-checkbox-container>.react-grid-checkbox-label{margin:0}.radio-custom+.radio-custom-label:before{border-radius:50%}.radio-custom:checked+.radio-custom-label:before{background:#ccc;box-shadow:inset 0 0 0 4px #fff}", ""]);
	
		// exports
	
	
	/***/ },
	/* 195 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Container{clear:both;margin-top:0;padding:0}.react-grid-Main{background-color:#fff;color:inherit;padding:0;outline:1px solid #e7eaec;clear:both}.react-grid-Grid{border:1px solid #ddd}.react-grid-Canvas,.react-grid-Grid{background-color:#fff}.react-grid-Cell input.editor-main,select.editor-main{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input.editor-main:focus,select.editor-main:focus{border-color:#66afe9;border:2px solid #66afe9;background:#eee;border-radius:4px}.react-grid-Cell input.editor-main::-moz-placeholder,select.editor-main::-moz-placeholder{color:#999;opacity:1}.react-grid-Cell input.editor-main:-ms-input-placeholder,select.editor-main:-ms-input-placeholder{color:#999}.react-grid-Cell input.editor-main::-webkit-input-placeholder,select.editor-main::-webkit-input-placeholder{color:#999}.react-grid-Cell input.editor-main[disabled],.react-grid-Cell input.editor-main[readonly],fieldset[disabled] .react-grid-Cell input.editor-main,fieldset[disabled] select.editor-main,select.editor-main[disabled],select.editor-main[readonly]{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-grid-Cell input.editor-main,textareaselect.editor-main{height:auto}.react-grid-ScrollShim{z-index:10002}", ""]);
	
		// exports
	
	
	/***/ },
	/* 196 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Header{box-shadow:0 0 4px 0 #ddd;background:#f9f9f9}.react-grid-Header--resizing{cursor:ew-resize}.react-grid-HeaderCell,.react-grid-HeaderRow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-HeaderCell{background:#f9f9f9;padding:8px;font-weight:700;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.react-grid-HeaderCell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-HeaderCell__resizeHandle:hover{cursor:ew-resize;background:#ddd}.react-grid-HeaderCell--locked:last-of-type{box-shadow:none}.react-grid-HeaderCell--resizing .react-grid-HeaderCell__resizeHandle{background:#ddd}.react-grid-HeaderCell__draggable{cursor:col-resize}.rdg-can-drop>.react-grid-HeaderCell{background:#ececec}", ""]);
	
		// exports
	
	
	/***/ },
	/* 197 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Row.row-context-menu .react-grid-Cell,.react-grid-Row:hover .react-grid-Cell{background-color:#f2f2f2}.react-grid-Row:hover .rdg-row-index{display:none}.react-grid-Row:hover .rdg-actions-checkbox{display:block}.react-grid-Row:hover .rdg-drag-row-handle{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab;width:12px;height:30px;margin-left:0;background-image:url(\"data:image/svg+xml;base64, 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\");background-repeat:no-repeat}.react-grid-Row.row-selected,.react-grid-Row .row-selected{background-color:#dbecfa}.react-grid-row-group .row-expand-icon:hover{color:#777}.react-grid-row-index{padding:0 18px}.rdg-row-index{display:block;text-align:center}.rdg-row-actions-cell{padding:0}.rdg-actions-checkbox{display:none;text-align:center}.rdg-actions-checkbox.selected{display:block}.rdg-dragging{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.rdg-dragged-row{border-bottom:1px solid #000}", ""]);
	
		// exports
	
	
	/***/ },
	/* 198 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule invariant
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  if (false) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  }
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ },
	/* 199 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule keyMirror
		 * @typechecks static-only
		 */
	
		'use strict';
	
		var invariant = __webpack_require__(198);
	
		/**
		 * Constructs an enumeration with keys equal to their value.
		 *
		 * For example:
		 *
		 *   var COLORS = keyMirror({blue: null, red: null});
		 *   var myColor = COLORS.blue;
		 *   var isColorValid = !!COLORS[myColor];
		 *
		 * The last line could not be performed if the values of the generated enum were
		 * not equal to their keys.
		 *
		 *   Input:  {key1: val1, key2: val2}
		 *   Output: {key1: key1, key2: key2}
		 *
		 * @param {object} obj
		 * @return {object}
		 */
		var keyMirror = function (obj) {
		  var ret = {};
		  var key;
		  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
		  for (key in obj) {
		    if (!obj.hasOwnProperty(key)) {
		      continue;
		    }
		    ret[key] = key;
		  }
		  return ret;
		};
	
		module.exports = keyMirror;
	
	/***/ },
	/* 200 */,
	/* 201 */,
	/* 202 */,
	/* 203 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		// rawAsap provides everything we need except exception management.
		var rawAsap = __webpack_require__(204);
		// RawTasks are recycled to reduce GC churn.
		var freeTasks = [];
		// We queue errors to ensure they are thrown in right order (FIFO).
		// Array-as-queue is good enough here, since we are just dealing with exceptions.
		var pendingErrors = [];
		var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
		function throwFirstError() {
		    if (pendingErrors.length) {
		        throw pendingErrors.shift();
		    }
		}
	
		/**
		 * Calls a task as soon as possible after returning, in its own event, with priority
		 * over other events like animation, reflow, and repaint. An error thrown from an
		 * event will not interrupt, nor even substantially slow down the processing of
		 * other events, but will be rather postponed to a lower priority event.
		 * @param {{call}} task A callable object, typically a function that takes no
		 * arguments.
		 */
		module.exports = asap;
		function asap(task) {
		    var rawTask;
		    if (freeTasks.length) {
		        rawTask = freeTasks.pop();
		    } else {
		        rawTask = new RawTask();
		    }
		    rawTask.task = task;
		    rawAsap(rawTask);
		}
	
		// We wrap tasks with recyclable task objects.  A task object implements
		// `call`, just like a function.
		function RawTask() {
		    this.task = null;
		}
	
		// The sole purpose of wrapping the task is to catch the exception and recycle
		// the task object after its single use.
		RawTask.prototype.call = function () {
		    try {
		        this.task.call();
		    } catch (error) {
		        if (asap.onerror) {
		            // This hook exists purely for testing purposes.
		            // Its name will be periodically randomized to break any code that
		            // depends on its existence.
		            asap.onerror(error);
		        } else {
		            // In a web browser, exceptions are not fatal. However, to avoid
		            // slowing down the queue of pending tasks, we rethrow the error in a
		            // lower priority turn.
		            pendingErrors.push(error);
		            requestErrorThrow();
		        }
		    } finally {
		        this.task = null;
		        freeTasks[freeTasks.length] = this;
		    }
		};
	
	
	/***/ },
	/* 204 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		// Use the fastest means possible to execute a task in its own turn, with
		// priority over other events including IO, animation, reflow, and redraw
		// events in browsers.
		//
		// An exception thrown by a task will permanently interrupt the processing of
		// subsequent tasks. The higher level `asap` function ensures that if an
		// exception is thrown by a task, that the task queue will continue flushing as
		// soon as possible, but if you use `rawAsap` directly, you are responsible to
		// either ensure that no exceptions are thrown from your task, or to manually
		// call `rawAsap.requestFlush` if an exception is thrown.
		module.exports = rawAsap;
		function rawAsap(task) {
		    if (!queue.length) {
		        requestFlush();
		        flushing = true;
		    }
		    // Equivalent to push, but avoids a function call.
		    queue[queue.length] = task;
		}
	
		var queue = [];
		// Once a flush has been requested, no further calls to `requestFlush` are
		// necessary until the next `flush` completes.
		var flushing = false;
		// `requestFlush` is an implementation-specific method that attempts to kick
		// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
		// the event queue before yielding to the browser's own event loop.
		var requestFlush;
		// The position of the next task to execute in the task queue. This is
		// preserved between calls to `flush` so that it can be resumed if
		// a task throws an exception.
		var index = 0;
		// If a task schedules additional tasks recursively, the task queue can grow
		// unbounded. To prevent memory exhaustion, the task queue will periodically
		// truncate already-completed tasks.
		var capacity = 1024;
	
		// The flush function processes all tasks that have been scheduled with
		// `rawAsap` unless and until one of those tasks throws an exception.
		// If a task throws an exception, `flush` ensures that its state will remain
		// consistent and will resume where it left off when called again.
		// However, `flush` does not make any arrangements to be called again if an
		// exception is thrown.
		function flush() {
		    while (index < queue.length) {
		        var currentIndex = index;
		        // Advance the index before calling the task. This ensures that we will
		        // begin flushing on the next task the task throws an error.
		        index = index + 1;
		        queue[currentIndex].call();
		        // Prevent leaking memory for long chains of recursive calls to `asap`.
		        // If we call `asap` within tasks scheduled by `asap`, the queue will
		        // grow, but to avoid an O(n) walk for every task we execute, we don't
		        // shift tasks off the queue after they have been executed.
		        // Instead, we periodically shift 1024 tasks off the queue.
		        if (index > capacity) {
		            // Manually shift all values starting at the index back to the
		            // beginning of the queue.
		            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
		                queue[scan] = queue[scan + index];
		            }
		            queue.length -= index;
		            index = 0;
		        }
		    }
		    queue.length = 0;
		    index = 0;
		    flushing = false;
		}
	
		// `requestFlush` is implemented using a strategy based on data collected from
		// every available SauceLabs Selenium web driver worker at time of writing.
		// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
		// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
		// have WebKitMutationObserver but not un-prefixed MutationObserver.
		// Must use `global` or `self` instead of `window` to work in both frames and web
		// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
		/* globals self */
		var scope = typeof (window) !== "undefined" ? (window) : self;
		var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
		// MutationObservers are desirable because they have high priority and work
		// reliably everywhere they are implemented.
		// They are implemented in all modern browsers.
		//
		// - Android 4-4.3
		// - Chrome 26-34
		// - Firefox 14-29
		// - Internet Explorer 11
		// - iPad Safari 6-7.1
		// - iPhone Safari 7-7.1
		// - Safari 6-7
		if (typeof BrowserMutationObserver === "function") {
		    requestFlush = makeRequestCallFromMutationObserver(flush);
	
		// MessageChannels are desirable because they give direct access to the HTML
		// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
		// 11-12, and in web workers in many engines.
		// Although message channels yield to any queued rendering and IO tasks, they
		// would be better than imposing the 4ms delay of timers.
		// However, they do not work reliably in Internet Explorer or Safari.
	
		// Internet Explorer 10 is the only browser that has setImmediate but does
		// not have MutationObservers.
		// Although setImmediate yields to the browser's renderer, it would be
		// preferrable to falling back to setTimeout since it does not have
		// the minimum 4ms penalty.
		// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
		// Desktop to a lesser extent) that renders both setImmediate and
		// MessageChannel useless for the purposes of ASAP.
		// https://github.com/kriskowal/q/issues/396
	
		// Timers are implemented universally.
		// We fall back to timers in workers in most engines, and in foreground
		// contexts in the following browsers.
		// However, note that even this simple case requires nuances to operate in a
		// broad spectrum of browsers.
		//
		// - Firefox 3-13
		// - Internet Explorer 6-9
		// - iPad Safari 4.3
		// - Lynx 2.8.7
		} else {
		    requestFlush = makeRequestCallFromTimer(flush);
		}
	
		// `requestFlush` requests that the high priority event queue be flushed as
		// soon as possible.
		// This is useful to prevent an error thrown in a task from stalling the event
		// queue if the exception handled by Node.js’s
		// `process.on("uncaughtException")` or by a domain.
		rawAsap.requestFlush = requestFlush;
	
		// To request a high priority event, we induce a mutation observer by toggling
		// the text of a text node between "1" and "-1".
		function makeRequestCallFromMutationObserver(callback) {
		    var toggle = 1;
		    var observer = new BrowserMutationObserver(callback);
		    var node = document.createTextNode("");
		    observer.observe(node, {characterData: true});
		    return function requestCall() {
		        toggle = -toggle;
		        node.data = toggle;
		    };
		}
	
		// The message channel technique was discovered by Malte Ubl and was the
		// original foundation for this library.
		// http://www.nonblocking.io/2011/06/windownexttick.html
	
		// Safari 6.0.5 (at least) intermittently fails to create message ports on a
		// page's first load. Thankfully, this version of Safari supports
		// MutationObservers, so we don't need to fall back in that case.
	
		// function makeRequestCallFromMessageChannel(callback) {
		//     var channel = new MessageChannel();
		//     channel.port1.onmessage = callback;
		//     return function requestCall() {
		//         channel.port2.postMessage(0);
		//     };
		// }
	
		// For reasons explained above, we are also unable to use `setImmediate`
		// under any circumstances.
		// Even if we were, there is another bug in Internet Explorer 10.
		// It is not sufficient to assign `setImmediate` to `requestFlush` because
		// `setImmediate` must be called *by name* and therefore must be wrapped in a
		// closure.
		// Never forget.
	
		// function makeRequestCallFromSetImmediate(callback) {
		//     return function requestCall() {
		//         setImmediate(callback);
		//     };
		// }
	
		// Safari 6.0 has a problem where timers will get lost while the user is
		// scrolling. This problem does not impact ASAP because Safari 6.0 supports
		// mutation observers, so that implementation is used instead.
		// However, if we ever elect to use timers in Safari, the prevalent work-around
		// is to add a scroll event listener that calls for a flush.
	
		// `setTimeout` does not call the passed callback if the delay is less than
		// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
		// even then.
	
		function makeRequestCallFromTimer(callback) {
		    return function requestCall() {
		        // We dispatch a timeout with a specified delay of 0 for engines that
		        // can reliably accommodate that request. This will usually be snapped
		        // to a 4 milisecond delay, but once we're flushing, there's no delay
		        // between events.
		        var timeoutHandle = setTimeout(handleTimer, 0);
		        // However, since this timer gets frequently dropped in Firefox
		        // workers, we enlist an interval handle that will try to fire
		        // an event 20 times per second until it succeeds.
		        var intervalHandle = setInterval(handleTimer, 50);
	
		        function handleTimer() {
		            // Whichever timer succeeds will cancel both timers and
		            // execute the callback.
		            clearTimeout(timeoutHandle);
		            clearInterval(intervalHandle);
		            callback();
		        }
		    };
		}
	
		// This is for `asap.js` only.
		// Its name will be periodically randomized to break any code that depends on
		// its existence.
		rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
		// ASAP was originally a nextTick shim included in Q. This was factored out
		// into this ASAP package. It was later adapted to RSVP which made further
		// amendments. These decisions, particularly to marginalize MessageChannel and
		// to capture the MutationObserver implementation in a closure, were integrated
		// back into ASAP proper.
		// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	
	/***/ },
	/* 205 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		__webpack_require__(399);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactSelect = __webpack_require__(50);
	
		var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var isEmptyArray = _reactDataGrid.utils.isEmptyArray;
		var ExcelColumn = _reactDataGrid.shapes.ExcelColumn;
	
		var AutoCompleteFilter = function (_React$Component) {
		  _inherits(AutoCompleteFilter, _React$Component);
	
		  function AutoCompleteFilter(props) {
		    _classCallCheck(this, AutoCompleteFilter);
	
		    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
		    _this.getOptions = _this.getOptions.bind(_this);
		    _this.handleChange = _this.handleChange.bind(_this);
		    _this.filterValues = _this.filterValues.bind(_this);
		    _this.state = { options: _this.getOptions(), rawValue: '', placeholder: 'Search...' };
		    return _this;
		  }
	
		  AutoCompleteFilter.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
		    this.setState({ options: this.getOptions(newProps) });
		  };
	
		  AutoCompleteFilter.prototype.getOptions = function getOptions(newProps) {
		    var props = newProps || this.props;
		    var options = props.getValidFilterValues(props.column.key);
		    options = options.map(function (o) {
		      if (typeof o === 'string') {
		        return { value: o, label: o };
		      }
		      return o;
		    });
		    return options;
		  };
	
		  AutoCompleteFilter.prototype.columnValueContainsSearchTerms = function columnValueContainsSearchTerms(columnValue, filterTerms) {
		    var columnValueContainsSearchTerms = false;
	
		    for (var key in filterTerms) {
		      if (!filterTerms.hasOwnProperty(key)) {
		        continue;
		      }
	
		      if (columnValue !== undefined && filterTerms[key].value !== undefined) {
		        var strColumnValue = columnValue.toString();
		        var filterTermValue = filterTerms[key].value.toString();
		        var checkValueIndex = strColumnValue.trim().toLowerCase().indexOf(filterTermValue.trim().toLowerCase());
		        var columnMatchesSearch = checkValueIndex !== -1 && (checkValueIndex !== 0 || strColumnValue === filterTermValue);
		        if (columnMatchesSearch === true) {
		          columnValueContainsSearchTerms = true;
		          break;
		        }
		      }
		    }
	
		    return columnValueContainsSearchTerms;
		  };
	
		  AutoCompleteFilter.prototype.filterValues = function filterValues(row, columnFilter, columnKey) {
		    var include = true;
		    if (columnFilter === null) {
		      include = false;
		    } else if (!isEmptyArray(columnFilter.filterTerm)) {
		      include = this.columnValueContainsSearchTerms(row[columnKey], columnFilter.filterTerm);
		    }
		    return include;
		  };
	
		  AutoCompleteFilter.prototype.handleChange = function handleChange(value) {
		    var filters = value;
		    this.setState({ filters: filters });
		    this.props.onChange({ filterTerm: filters, column: this.props.column, rawValue: value, filterValues: this.filterValues });
		  };
	
		  AutoCompleteFilter.prototype.render = function render() {
		    var filterName = 'filter-' + this.props.column.key;
		    return _react2['default'].createElement(
		      'div',
		      { style: { width: this.props.column.width * 0.9 } },
		      _react2['default'].createElement(_reactSelect2['default'], {
		        name: filterName,
		        options: this.state.options,
		        placeholder: this.state.placeholder,
		        onChange: this.handleChange,
		        escapeClearsValue: true,
		        multi: true,
		        value: this.state.filters
		      })
		    );
		  };
	
		  return AutoCompleteFilter;
		}(_react2['default'].Component);
	
		AutoCompleteFilter.propTypes = {
		  onChange: _react.PropTypes.func.isRequired,
		  column: _react2['default'].PropTypes.shape(ExcelColumn),
		  getValidFilterValues: _react.PropTypes.func
		};
	
		exports['default'] = AutoCompleteFilter;
	
	/***/ },
	/* 206 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ExcelColumn = _reactDataGrid.shapes.ExcelColumn;
	
		var RuleType = {
		  Number: 1,
		  Range: 2,
		  GreaterThen: 3,
		  LessThen: 4
		};
	
		var NumericFilter = function (_React$Component) {
		  _inherits(NumericFilter, _React$Component);
	
		  function NumericFilter(props) {
		    _classCallCheck(this, NumericFilter);
	
		    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
		    _this.handleChange = _this.handleChange.bind(_this);
		    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
		    _this.getRules = _this.getRules.bind(_this);
		    return _this;
		  }
	
		  NumericFilter.prototype.filterValues = function filterValues(row, columnFilter, columnKey) {
		    if (columnFilter.filterTerm == null) {
		      return true;
		    }
		    var result = false;
		    // implement default filter logic
		    var value = parseInt(row[columnKey], 10);
		    for (var ruleKey in columnFilter.filterTerm) {
		      if (!columnFilter.filterTerm.hasOwnProperty(ruleKey)) {
		        continue;
		      }
	
		      var rule = columnFilter.filterTerm[ruleKey];
	
		      switch (rule.type) {
		        case RuleType.Number:
		          if (rule.value === value) {
		            result = true;
		          }
		          break;
		        case RuleType.GreaterThen:
		          if (rule.value <= value) {
		            result = true;
		          }
		          break;
		        case RuleType.LessThen:
		          if (rule.value >= value) {
		            result = true;
		          }
		          break;
		        case RuleType.Range:
		          if (rule.begin <= value && rule.end >= value) {
		            result = true;
		          }
		          break;
		        default:
		          // do nothing
		          break;
		      }
		    }
		    return result;
		  };
	
		  NumericFilter.prototype.getRules = function getRules(value) {
		    var rules = [];
		    if (value === '') {
		      return rules;
		    }
		    // check comma
		    var list = value.split(',');
		    if (list.length > 0) {
		      // handle each value with comma
		      for (var key in list) {
		        if (!list.hasOwnProperty(key)) {
		          continue;
		        }
	
		        var obj = list[key];
		        if (obj.indexOf('-') > 0) {
		          // handle dash
		          var begin = parseInt(obj.split('-')[0], 10);
		          var end = parseInt(obj.split('-')[1], 10);
		          rules.push({ type: RuleType.Range, begin: begin, end: end });
		        } else if (obj.indexOf('>') > -1) {
		          // handle greater then
		          var _begin = parseInt(obj.split('>')[1], 10);
		          rules.push({ type: RuleType.GreaterThen, value: _begin });
		        } else if (obj.indexOf('<') > -1) {
		          // handle less then
		          var _end = parseInt(obj.split('<')[1], 10);
		          rules.push({ type: RuleType.LessThen, value: _end });
		        } else {
		          // handle normal values
		          var numericValue = parseInt(obj, 10);
		          rules.push({ type: RuleType.Number, value: numericValue });
		        }
		      }
		    }
		    return rules;
		  };
	
		  NumericFilter.prototype.handleKeyPress = function handleKeyPress(e) {
		    // Validate the input
		    var regex = '>|<|-|,|([0-9])';
		    var result = RegExp(regex).test(e.key);
		    if (result === false) {
		      e.preventDefault();
		    }
		  };
	
		  NumericFilter.prototype.handleChange = function handleChange(e) {
		    var value = e.target.value;
		    var filters = this.getRules(value);
		    this.props.onChange({ filterTerm: filters.length > 0 ? filters : null, column: this.props.column, rawValue: value, filterValues: this.filterValues });
		  };
	
		  NumericFilter.prototype.render = function render() {
		    var inputKey = 'header-filter-' + this.props.column.key;
		    var columnStyle = {
		      float: 'left',
		      marginRight: 5,
		      maxWidth: '80%'
		    };
		    var badgeStyle = {
		      cursor: 'help'
		    };
	
		    var tooltipText = 'Input Methods: Range (x-y), Greater Then (>x), Less Then (<y)';
	
		    return _react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].createElement(
		        'div',
		        { style: columnStyle },
		        _react2['default'].createElement('input', { key: inputKey, type: 'text', placeholder: 'e.g. 3,10-15,>20', className: 'form-control input-sm', onChange: this.handleChange, onKeyPress: this.handleKeyPress })
		      ),
		      _react2['default'].createElement(
		        'div',
		        { className: 'input-sm' },
		        _react2['default'].createElement(
		          'span',
		          { className: 'badge', style: badgeStyle, title: tooltipText },
		          '?'
		        )
		      )
		    );
		  };
	
		  return NumericFilter;
		}(_react2['default'].Component);
	
		NumericFilter.propTypes = {
		  onChange: _react2['default'].PropTypes.func.isRequired,
		  column: _react2['default'].PropTypes.shape(ExcelColumn)
		};
		module.exports = NumericFilter;
	
	/***/ },
	/* 207 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _NumericFilter = __webpack_require__(206);
	
		var _NumericFilter2 = _interopRequireDefault(_NumericFilter);
	
		var _AutoCompleteFilter = __webpack_require__(205);
	
		var _AutoCompleteFilter2 = _interopRequireDefault(_AutoCompleteFilter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var Filters = {
		  NumericFilter: _NumericFilter2['default'],
		  AutoCompleteFilter: _AutoCompleteFilter2['default']
		};
	
		module.exports = Filters;
	
	/***/ },
	/* 208 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDataGrid = __webpack_require__(3);
	
		var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
		    isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
	
	
		var filterRows = function filterRows(filters) {
		  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
		  return rows.filter(function (r) {
		    var retriever = getMixedTypeValueRetriever(isImmutableCollection(r));
		    var include = true;
		    for (var columnKey in filters) {
		      if (filters.hasOwnProperty(columnKey)) {
		        var colFilter = filters[columnKey];
		        // check if custom filter function exists
		        if (colFilter.filterValues && typeof colFilter.filterValues === 'function') {
		          include = include & colFilter.filterValues(r, colFilter, columnKey);
		        } else if (typeof colFilter.filterTerm === 'string') {
		          // default filter action
		          var rowValue = retriever.getValue(r, columnKey);
		          if (rowValue) {
		            if (rowValue.toString().toLowerCase().indexOf(colFilter.filterTerm.toLowerCase()) === -1) {
		              include = include & false;
		            }
		          } else {
		            include = include & false;
		          }
		        }
		      }
		    }
		    return Boolean(include);
		  });
		};
	
		module.exports = filterRows;
	
	/***/ },
	/* 209 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDataGrid = __webpack_require__(3);
	
		var _RowGrouperResolver = __webpack_require__(210);
	
		var _RowGrouperResolver2 = _interopRequireDefault(_RowGrouperResolver);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
	
		var RowGrouper = function () {
		  function RowGrouper(columns, expandedRows) {
		    var isImmutable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
		    _classCallCheck(this, RowGrouper);
	
		    this.columns = columns.slice(0);
		    this.expandedRows = expandedRows;
		    this.resolver = new _RowGrouperResolver2['default'](isImmutable);
		  }
	
		  RowGrouper.prototype.isRowExpanded = function isRowExpanded(columnName, name) {
		    var isExpanded = true;
		    var expandedRowGroup = this.expandedRows[columnName];
		    if (expandedRowGroup && expandedRowGroup[name]) {
		      isExpanded = expandedRowGroup[name].isExpanded;
		    }
		    return isExpanded;
		  };
	
		  RowGrouper.prototype.groupRowsByColumn = function groupRowsByColumn(rows) {
		    var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
		    var nextColumnIndex = columnIndex;
		    var columnName = this.columns[columnIndex];
		    var groupedRows = this.resolver.getGroupedRows(rows, columnName);
		    var keys = this.resolver.getGroupKeys(groupedRows);
		    var dataviewRows = this.resolver.initRowsCollection();
	
		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];
		      var isExpanded = this.isRowExpanded(columnName, key);
		      var rowGroupHeader = { name: key, __metaData: { isGroup: true, treeDepth: columnIndex, isExpanded: isExpanded, columnGroupName: columnName } };
	
		      dataviewRows = this.resolver.addHeaderRow(rowGroupHeader, dataviewRows);
	
		      if (isExpanded) {
		        nextColumnIndex = columnIndex + 1;
		        if (this.columns.length > nextColumnIndex) {
		          dataviewRows = dataviewRows.concat(this.groupRowsByColumn(this.resolver.getRowObj(groupedRows, key), nextColumnIndex));
		          nextColumnIndex = columnIndex - 1;
		        } else {
		          dataviewRows = dataviewRows.concat(this.resolver.getRowObj(groupedRows, key));
		        }
		      }
		    }
		    return dataviewRows;
		  };
	
		  return RowGrouper;
		}();
	
		var groupRows = function groupRows(rows, groupedColumns, expandedRows) {
		  var rowGrouper = new RowGrouper(groupedColumns, expandedRows, isImmutableCollection(rows));
		  return rowGrouper.groupRowsByColumn(rows, 0);
		};
	
		module.exports = groupRows;
	
	/***/ },
	/* 210 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _immutable = __webpack_require__(24);
	
		var _groupBy = __webpack_require__(490);
	
		var _groupBy2 = _interopRequireDefault(_groupBy);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
		    isImmutableMap = _reactDataGrid.utils.isImmutableMap;
	
		var RowGrouperResolver = function () {
		  function RowGrouperResolver(isImmutable) {
		    _classCallCheck(this, RowGrouperResolver);
	
		    this.isImmutable = isImmutable;
		    this.getRowObj = getMixedTypeValueRetriever(isImmutable).getValue;
		  }
	
		  RowGrouperResolver.prototype.initRowsCollection = function initRowsCollection() {
		    return this.isImmutable ? new _immutable.List() : [];
		  };
	
		  RowGrouperResolver.prototype.getGroupedRows = function getGroupedRows(rows, columnName) {
		    return this.isImmutable ? rows.groupBy(function (x) {
		      return isImmutableMap(x) ? x.get(columnName) : x[columnName];
		    }) : (0, _groupBy2['default'])(rows, columnName);
		  };
	
		  RowGrouperResolver.prototype.getGroupKeys = function getGroupKeys(groupedRows) {
		    var getKeys = Object.keys;
		    if (this.isImmutable) {
		      getKeys = function getKeys(col) {
		        var keys = [];
		        var iterator = col.keys();
		        var item = iterator.next();
	
		        while (!item.done) {
		          keys.push(item.value);
		          item = iterator.next();
		        }
		        return keys;
		      };
		    }
		    return getKeys(groupedRows);
		  };
	
		  RowGrouperResolver.prototype.addHeaderRow = function addHeaderRow(rowGroupHeader, dataviewRows) {
		    var rows = dataviewRows;
		    var dvRows = rows.push(rowGroupHeader);
		    if (this.isImmutable) {
		      return dvRows;
		    }
		    return rows;
		  };
	
		  return RowGrouperResolver;
		}();
	
		exports['default'] = RowGrouperResolver;
	
	/***/ },
	/* 211 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDataGrid = __webpack_require__(3);
	
		var getMixedTypeValueRetriever = _reactDataGrid.utils.getMixedTypeValueRetriever,
		    isImmutableCollection = _reactDataGrid.utils.isImmutableCollection;
	
	
		var comparer = function comparer(a, b) {
		  if (a > b) {
		    return 1;
		  } else if (a < b) {
		    return -1;
		  }
		  return 0;
		};
	
		var sortRows = function sortRows(rows, sortColumn, sortDirection) {
		  var retriever = getMixedTypeValueRetriever(isImmutableCollection(rows));
		  var sortDirectionSign = sortDirection === 'ASC' ? 1 : -1;
		  var rowComparer = function rowComparer(a, b) {
		    return sortDirectionSign * comparer(retriever.getValue(a, sortColumn), retriever.getValue(b, sortColumn));
		  };
		  if (sortDirection === 'NONE') {
		    return rows;
		  }
		  return [].concat(rows).sort(rowComparer);
		};
	
		module.exports = sortRows;
		module.exports.comparer = comparer;
	
	/***/ },
	/* 212 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = {
		  Selectors: __webpack_require__(99)
		};
	
	/***/ },
	/* 213 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _reactDndHtml5Backend = __webpack_require__(127);
	
		var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
		var _DraggableHeaderCell = __webpack_require__(214);
	
		var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var DraggableContainer = function (_React$Component) {
		  _inherits(DraggableContainer, _React$Component);
	
		  function DraggableContainer() {
		    _classCallCheck(this, DraggableContainer);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  DraggableContainer.prototype.renderGrid = function renderGrid() {
		    return _react2['default'].Children.map(this.props.children, function (child) {
		      return _react2['default'].cloneElement(child, {
		        draggableHeaderCell: _DraggableHeaderCell2['default']
		      });
		    })[0];
		  };
	
		  DraggableContainer.prototype.render = function render() {
		    var grid = this.renderGrid();
		    return _react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].cloneElement(grid, this.props)
		    );
		  };
	
		  return DraggableContainer;
		}(_react2['default'].Component);
	
		DraggableContainer.propTypes = {
		  children: _react.PropTypes.element
		};
	
		exports['default'] = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2['default'])(DraggableContainer);
	
	/***/ },
	/* 214 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var DraggableHeaderCell = function (_React$Component) {
		  _inherits(DraggableHeaderCell, _React$Component);
	
		  function DraggableHeaderCell() {
		    _classCallCheck(this, DraggableHeaderCell);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  DraggableHeaderCell.prototype.render = function render() {
		    var _props = this.props,
		        connectDragSource = _props.connectDragSource,
		        connectDropTarget = _props.connectDropTarget,
		        isDragging = _props.isDragging,
		        isOver = _props.isOver,
		        canDrop = _props.canDrop;
	
	
		    var opacity = 1;
		    if (isDragging) {
		      opacity = 0.2;
		    }
	
		    // set drag source and drop target on header cell
		    // width: 0 - otherwise drag clone was wrongly positioned
		    return connectDragSource(connectDropTarget(_react2['default'].createElement(
		      'div',
		      {
		        style: { width: 0, cursor: 'move', opacity: opacity },
		        className: isOver && canDrop ? 'rdg-can-drop' : ''
		      },
		      _react2['default'].createElement(_reactDataGrid.HeaderCell, this.props)
		    )));
		  };
	
		  return DraggableHeaderCell;
		}(_react2['default'].Component);
	
		// drop source
	
	
		function collect(connect, monitor) {
		  return {
		    connectDragSource: connect.dragSource(),
		    isDragging: monitor.isDragging()
		  };
		}
	
		var headerCellSource = {
		  beginDrag: function beginDrag(props) {
		    return {
		      // source column
		      key: props.column.key
		    };
		  },
		  endDrag: function endDrag(props, monitor) {
		    // check if drop was made in droppable zone
		    if (monitor.didDrop()) {
		      var source = monitor.getDropResult().source;
		      var _target = monitor.getDropResult().target;
		      return props.onHeaderDrop(source, _target);
		    }
		  }
		};
	
		// drop target
		var target = {
		  drop: function drop(props, monitor) {
		    var source = monitor.getItem().key;
		    var targetKey = props.column.key;
		    return {
		      source: source,
		      target: targetKey
		    };
		  }
		};
	
		function targetCollect(connect, monitor) {
		  return {
		    connectDropTarget: connect.dropTarget(),
		    isOver: monitor.isOver(),
		    canDrop: monitor.canDrop(),
		    draggedHeader: monitor.getItem()
		  };
		}
	
		DraggableHeaderCell.propTypes = {
		  connectDragSource: _react.PropTypes.func.isRequired,
		  connectDropTarget: _react.PropTypes.func.isRequired,
		  isDragging: _react.PropTypes.bool.isRequired,
		  isOver: _react.PropTypes.bool,
		  canDrop: _react.PropTypes.bool
		};
	
		DraggableHeaderCell = (0, _reactDnd.DropTarget)('Column', target, targetCollect)(DraggableHeaderCell);
		DraggableHeaderCell = (0, _reactDnd.DragSource)('Column', headerCellSource, collect)(DraggableHeaderCell);
	
		exports['default'] = DraggableHeaderCell;
	
	/***/ },
	/* 215 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _DraggableContainer = __webpack_require__(213);
	
		var _DraggableContainer2 = _interopRequireDefault(_DraggableContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = { DraggableContainer: _DraggableContainer2['default'] };
	
	/***/ },
	/* 216 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDndHtml5Backend = __webpack_require__(127);
	
		var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
		var _reactDnd = __webpack_require__(16);
	
		var _DraggableHeaderCell = __webpack_require__(100);
	
		var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
	
		var _RowDragLayer = __webpack_require__(219);
	
		var _RowDragLayer2 = _interopRequireDefault(_RowDragLayer);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var isColumnsImmutable = _reactDataGrid.utils.isColumnsImmutable;
	
		var DraggableContainer = function (_Component) {
		  _inherits(DraggableContainer, _Component);
	
		  function DraggableContainer() {
		    _classCallCheck(this, DraggableContainer);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  DraggableContainer.prototype.getRows = function getRows(rowsCount, rowGetter) {
		    var rows = [];
		    for (var j = 0; j < rowsCount; j++) {
		      rows.push(rowGetter(j));
		    }
		    return rows;
		  };
	
		  DraggableContainer.prototype.renderGrid = function renderGrid() {
		    return _react2['default'].Children.map(this.props.children, function (child) {
		      return _react2['default'].cloneElement(child, { draggableHeaderCell: _DraggableHeaderCell2['default'] });
		    })[0];
		  };
	
		  DraggableContainer.prototype.render = function render() {
		    var grid = this.renderGrid();
		    var rowGetter = this.props.getDragPreviewRow || grid.props.rowGetter;
		    var rowsCount = grid.props.rowsCount;
		    var columns = grid.props.columns;
		    var rows = this.getRows(rowsCount, rowGetter);
		    return _react2['default'].createElement(
		      'div',
		      null,
		      grid,
		      _react2['default'].createElement(_RowDragLayer2['default'], { rowSelection: grid.props.rowSelection, rows: rows, columns: isColumnsImmutable(columns) ? columns.toArray() : columns })
		    );
		  };
	
		  return DraggableContainer;
		}(_react.Component);
	
		DraggableContainer.propTypes = {
		  children: _react2['default'].PropTypes.element.isRequired,
		  getDragPreviewRow: _react2['default'].PropTypes.func
		};
	
		exports['default'] = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2['default'])(DraggableContainer);
	
	/***/ },
	/* 217 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		__webpack_require__(400);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _reactDnd = __webpack_require__(16);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var rowDropTarget = function rowDropTarget(Row) {
		  return function (_React$Component) {
		    _inherits(_class, _React$Component);
	
		    function _class() {
		      _classCallCheck(this, _class);
	
		      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		    }
	
		    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		      return (0, _reactDataGrid.RowComparer)(nextProps, this.props);
		    };
	
		    _class.prototype.moveRow = function moveRow() {
		      _reactDom2['default'].findDOMNode(this).classList.add('slideUp');
		    };
	
		    _class.prototype.render = function render() {
		      var _this2 = this;
	
		      var _props = this.props,
		          connectDropTarget = _props.connectDropTarget,
		          isOver = _props.isOver,
		          canDrop = _props.canDrop;
	
		      var overlayTop = this.props.idx * this.props.height;
		      return connectDropTarget(_react2['default'].createElement(
		        'div',
		        null,
		        _react2['default'].createElement(Row, _extends({ ref: function ref(node) {
		            return _this2.row = node;
		          } }, this.props)),
		        isOver && canDrop && _react2['default'].createElement('div', { style: {
		            position: 'absolute',
		            top: overlayTop,
		            left: 0,
		            height: this.props.height,
		            width: '100%',
		            zIndex: 1,
		            borderBottom: '1px solid black'
		          } })
		      ));
		    };
	
		    return _class;
		  }(_react2['default'].Component);
		};
	
		var target = {
		  drop: function drop(props, monitor, component) {
		    // Obtain the dragged item
		    component.moveRow();
		    var rowSource = monitor.getItem();
		    var rowTarget = { idx: props.idx, data: props.row };
		    props.onRowDrop({ rowSource: rowSource, rowTarget: rowTarget });
		  }
		};
	
		function collect(connect, monitor) {
		  return {
		    connectDropTarget: connect.dropTarget(),
		    isOver: monitor.isOver(),
		    canDrop: monitor.canDrop(),
		    draggedRow: monitor.getItem()
		  };
		}
	
		exports['default'] = function (Row) {
		  return (0, _reactDnd.DropTarget)('Row', target, collect, { arePropsEqual: function arePropsEqual(nextProps, currentProps) {
		      return !(0, _reactDataGrid.RowComparer)(nextProps, currentProps);
		    } })(rowDropTarget(Row));
		};
	
	/***/ },
	/* 218 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		__webpack_require__(27);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var CheckboxEditor = _reactDataGrid.editors.CheckboxEditor;
	
		var RowActionsCell = function (_React$Component) {
		  _inherits(RowActionsCell, _React$Component);
	
		  function RowActionsCell() {
		    _classCallCheck(this, RowActionsCell);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  RowActionsCell.prototype.renderRowIndex = function renderRowIndex() {
		    return _react2['default'].createElement(
		      'div',
		      { className: 'rdg-row-index' },
		      this.props.rowIdx + 1
		    );
		  };
	
		  RowActionsCell.prototype.render = function render() {
		    var _props = this.props,
		        connectDragSource = _props.connectDragSource,
		        rowSelection = _props.rowSelection;
	
		    var rowHandleStyle = rowSelection != null ? { position: 'absolute', marginTop: '5px' } : {};
		    var isSelected = this.props.value;
		    var editorClass = isSelected ? 'rdg-actions-checkbox selected' : 'rdg-actions-checkbox';
	
		    return connectDragSource(_react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].createElement('div', { className: 'rdg-drag-row-handle', style: rowHandleStyle }),
		      !isSelected ? this.renderRowIndex() : null,
		      rowSelection != null && _react2['default'].createElement(
		        'div',
		        { className: editorClass },
		        _react2['default'].createElement(CheckboxEditor, { column: this.props.column, rowIdx: this.props.rowIdx, dependentValues: this.props.dependentValues, value: this.props.value })
		      )
		    ));
		  };
	
		  return RowActionsCell;
		}(_react2['default'].Component);
	
		RowActionsCell.propTypes = {
		  rowIdx: _react.PropTypes.number.isRequired,
		  connectDragSource: _react.PropTypes.func.isRequired,
		  connectDragPreview: _react.PropTypes.func.isRequired,
		  isDragging: _react.PropTypes.bool.isRequired,
		  isRowHovered: _react.PropTypes.bool,
		  column: _react.PropTypes.object,
		  dependentValues: _react.PropTypes.object,
		  value: _react.PropTypes.bool,
		  rowSelection: _react.PropTypes.object.isRequired
		};
	
		RowActionsCell.defaultProps = {
		  rowIdx: 0
		};
	
		function collect(connect, monitor) {
		  return {
		    connectDragSource: connect.dragSource(),
		    isDragging: monitor.isDragging(),
		    connectDragPreview: connect.dragPreview()
		  };
		}
	
		var rowIndexSource = {
		  beginDrag: function beginDrag(props) {
		    return { idx: props.rowIdx, data: props.dependentValues };
		  },
		  endDrag: function endDrag(props) {
		    return { idx: props.rowIdx, data: props.dependentValues };
		  }
		};
	
		exports['default'] = (0, _reactDnd.DragSource)('Row', rowIndexSource, collect)(RowActionsCell);
	
	/***/ },
	/* 219 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _Selectors = __webpack_require__(99);
	
		var _Selectors2 = _interopRequireDefault(_Selectors);
	
		__webpack_require__(38);
	
		__webpack_require__(27);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var layerStyles = {
		  cursor: '-webkit-grabbing',
		  position: 'fixed',
		  pointerEvents: 'none',
		  zIndex: 100,
		  left: 0,
		  top: 0,
		  width: '100%',
		  height: '100%'
		};
	
		function getItemStyles(props) {
		  var currentOffset = props.currentOffset;
	
		  if (!currentOffset) {
		    return {
		      display: 'none'
		    };
		  }
	
		  var x = currentOffset.x,
		      y = currentOffset.y;
	
		  var transform = 'translate(' + x + 'px, ' + y + 'px)';
		  return {
		    transform: transform,
		    WebkitTransform: transform
		  };
		}
	
		var CustomDragLayer = function (_Component) {
		  _inherits(CustomDragLayer, _Component);
	
		  function CustomDragLayer() {
		    _classCallCheck(this, CustomDragLayer);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  CustomDragLayer.prototype.isDraggedRowSelected = function isDraggedRowSelected(selectedRows) {
		    var _props = this.props,
		        item = _props.item,
		        rowSelection = _props.rowSelection;
	
		    if (selectedRows && selectedRows.length > 0) {
		      var key = rowSelection.selectBy.keys.rowKey;
		      return selectedRows.filter(function (r) {
		        return r[key] === item.data[key];
		      }).length > 0;
		    }
		    return false;
		  };
	
		  CustomDragLayer.prototype.getDraggedRows = function getDraggedRows() {
		    var draggedRows = void 0;
		    var rowSelection = this.props.rowSelection;
	
		    if (rowSelection && rowSelection.selectBy.keys) {
		      var rows = this.props.rows;
		      var _rowSelection$selectB = rowSelection.selectBy.keys,
		          rowKey = _rowSelection$selectB.rowKey,
		          values = _rowSelection$selectB.values;
	
		      var selectedRows = _Selectors2['default'].getSelectedRowsByKey({ rowKey: rowKey, selectedKeys: values, rows: rows });
		      draggedRows = this.isDraggedRowSelected(selectedRows) ? selectedRows : [this.props.rows[this.props.item.idx]];
		    } else {
		      draggedRows = [this.props.rows[this.props.item.idx]];
		    }
		    return draggedRows;
		  };
	
		  CustomDragLayer.prototype.renderDraggedRows = function renderDraggedRows() {
		    var _this2 = this;
	
		    var columns = this.props.columns;
		    return this.getDraggedRows().map(function (r, i) {
		      return _react2['default'].createElement(
		        'tr',
		        { key: 'dragged-row-' + i },
		        _this2.renderDraggedCells(r, i, columns)
		      );
		    });
		  };
	
		  CustomDragLayer.prototype.renderDraggedCells = function renderDraggedCells(item, rowIdx, columns) {
		    var cells = [];
		    if (item != null) {
		      columns.forEach(function (c) {
		        if (item.hasOwnProperty(c.key)) {
		          if (c.formatter) {
		            var Formatter = c.formatter;
		            var dependentValues = typeof c.getRowMetaData === 'function' ? c.getRowMetaData(item, c) : {};
		            cells.push(_react2['default'].createElement(
		              'td',
		              { key: 'dragged-cell-' + rowIdx + '-' + c.key, className: 'react-grid-Cell', style: { padding: '5px' } },
		              _react2['default'].createElement(Formatter, { dependentValues: dependentValues, value: item[c.key] })
		            ));
		          } else {
		            cells.push(_react2['default'].createElement(
		              'td',
		              { key: 'dragged-cell-' + rowIdx + '-' + c.key, className: 'react-grid-Cell', style: { padding: '5px' } },
		              item[c.key]
		            ));
		          }
		        }
		      });
		    }
		    return cells;
		  };
	
		  CustomDragLayer.prototype.render = function render() {
		    var isDragging = this.props.isDragging;
	
		    if (!isDragging) {
		      return null;
		    }
		    var draggedRows = this.renderDraggedRows();
		    return _react2['default'].createElement(
		      'div',
		      { style: layerStyles, className: 'rdg-dragging' },
		      _react2['default'].createElement(
		        'div',
		        { style: getItemStyles(this.props), className: 'rdg-dragging' },
		        _react2['default'].createElement(
		          'table',
		          null,
		          _react2['default'].createElement(
		            'tbody',
		            null,
		            draggedRows
		          )
		        )
		      )
		    );
		  };
	
		  return CustomDragLayer;
		}(_react.Component);
	
		CustomDragLayer.propTypes = {
		  item: _react.PropTypes.object,
		  itemType: _react.PropTypes.string,
		  currentOffset: _react.PropTypes.shape({
		    x: _react.PropTypes.number.isRequired,
		    y: _react.PropTypes.number.isRequired
		  }),
		  isDragging: _react.PropTypes.bool.isRequired,
		  rowSelection: _react.PropTypes.object,
		  rows: _react.PropTypes.array.isRequired,
		  columns: _react.PropTypes.array.isRequired
		};
	
		function collect(monitor) {
		  return {
		    item: monitor.getItem(),
		    itemType: monitor.getItemType(),
		    currentOffset: monitor.getSourceClientOffset(),
		    isDragging: monitor.isDragging()
		  };
		}
	
		exports['default'] = (0, _reactDnd.DragLayer)(collect)(CustomDragLayer);
	
	/***/ },
	/* 220 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _DragDropContainer = __webpack_require__(216);
	
		var _DragDropContainer2 = _interopRequireDefault(_DragDropContainer);
	
		var _DraggableHeaderCell = __webpack_require__(100);
	
		var _DraggableHeaderCell2 = _interopRequireDefault(_DraggableHeaderCell);
	
		var _RowActionsCell = __webpack_require__(218);
	
		var _RowActionsCell2 = _interopRequireDefault(_RowActionsCell);
	
		var _DropTargetRowContainer = __webpack_require__(217);
	
		var _DropTargetRowContainer2 = _interopRequireDefault(_DropTargetRowContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = { Container: _DragDropContainer2['default'], DraggableHeaderCell: _DraggableHeaderCell2['default'], RowActionsCell: _RowActionsCell2['default'], DropTargetRowContainer: _DropTargetRowContainer2['default'] };
	
	/***/ },
	/* 221 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var ReactAutocomplete = __webpack_require__(398);
	
		var _require = __webpack_require__(3),
		    ExcelColumn = _require.shapes.ExcelColumn;
	
		__webpack_require__(402);
	
		var optionPropType = React.PropTypes.shape({
		  id: React.PropTypes.required,
		  title: React.PropTypes.string
		});
	
		var AutoCompleteEditor = React.createClass({
		  displayName: 'AutoCompleteEditor',
	
	
		  propTypes: {
		    onCommit: React.PropTypes.func,
		    options: React.PropTypes.arrayOf(optionPropType),
		    label: React.PropTypes.any,
		    value: React.PropTypes.any,
		    height: React.PropTypes.number,
		    valueParams: React.PropTypes.arrayOf(React.PropTypes.string),
		    column: React.PropTypes.shape(ExcelColumn),
		    resultIdentifier: React.PropTypes.string,
		    search: React.PropTypes.string,
		    onKeyDown: React.PropTypes.func,
		    onFocus: React.PropTypes.func,
		    editorDisplayValue: React.PropTypes.func
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      resultIdentifier: 'id'
		    };
		  },
		  handleChange: function handleChange() {
		    this.props.onCommit();
		  },
		  getValue: function getValue() {
		    var value = void 0;
		    var updated = {};
		    if (this.hasResults() && this.isFocusedOnSuggestion()) {
		      value = this.getLabel(this.autoComplete.state.focusedValue);
		      if (this.props.valueParams) {
		        value = this.constuctValueFromParams(this.autoComplete.state.focusedValue, this.props.valueParams);
		      }
		    } else {
		      value = this.autoComplete.state.searchTerm;
		    }
	
		    updated[this.props.column.key] = value;
		    return updated;
		  },
		  getEditorDisplayValue: function getEditorDisplayValue() {
		    var displayValue = { title: '' };
		    var _props = this.props,
		        column = _props.column,
		        value = _props.value,
		        editorDisplayValue = _props.editorDisplayValue;
	
		    if (editorDisplayValue && typeof editorDisplayValue === 'function') {
		      displayValue.title = editorDisplayValue(column, value);
		    } else {
		      displayValue.title = value;
		    }
		    return displayValue;
		  },
		  getInputNode: function getInputNode() {
		    return ReactDOM.findDOMNode(this).getElementsByTagName('input')[0];
		  },
		  getLabel: function getLabel(item) {
		    var label = this.props.label != null ? this.props.label : 'title';
		    if (typeof label === 'function') {
		      return label(item);
		    } else if (typeof label === 'string') {
		      return item[label];
		    }
		  },
		  hasResults: function hasResults() {
		    return this.autoComplete.state.results.length > 0;
		  },
		  isFocusedOnSuggestion: function isFocusedOnSuggestion() {
		    var autoComplete = this.autoComplete;
		    return autoComplete.state.focusedValue != null;
		  },
		  constuctValueFromParams: function constuctValueFromParams(obj, props) {
		    if (!props) {
		      return '';
		    }
	
		    var ret = [];
		    for (var i = 0, ii = props.length; i < ii; i++) {
		      ret.push(obj[props[i]]);
		    }
		    return ret.join('|');
		  },
		  render: function render() {
		    var _this = this;
	
		    var label = this.props.label != null ? this.props.label : 'title';
		    return React.createElement(
		      'div',
		      { height: this.props.height, onKeyDown: this.props.onKeyDown },
		      React.createElement(ReactAutocomplete, { search: this.props.search, ref: function ref(node) {
		          return _this.autoComplete = node;
		        }, label: label, onChange: this.handleChange, onFocus: this.props.onFocus, resultIdentifier: this.props.resultIdentifier, options: this.props.options, value: this.getEditorDisplayValue() })
		    );
		  }
		});
	
		module.exports = AutoCompleteEditor;
	
	/***/ },
	/* 222 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		// Wrapper HOC used when having an editor which is a redux container.
		// Required since react-data-grid requires access to getInputNode, getValue,
		// howvever when doing this.getEditor() in react-data-grid we get a react
		// componenet wrapped by the redux connect function and thus wont have access
		// to the required methods.
		module.exports = function (ContainerEditor) {
		  return function (_Component) {
		    _inherits(ContainerEditorWrapper, _Component);
	
		    function ContainerEditorWrapper() {
		      _classCallCheck(this, ContainerEditorWrapper);
	
		      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		    }
	
		    ContainerEditorWrapper.prototype.getInputNode = function getInputNode() {
		      return this.editorRef.getInputNode();
		    };
	
		    ContainerEditorWrapper.prototype.getValue = function getValue() {
		      return this.editorRef.getValue();
		    };
	
		    ContainerEditorWrapper.prototype.render = function render() {
		      var _this2 = this;
	
		      return _react2['default'].createElement(ContainerEditor, _extends({ refCallback: function refCallback(ref) {
		          _this2.editorRef = ref;
		        } }, this.props));
		    };
	
		    return ContainerEditorWrapper;
		  }(_react.Component);
		};
	
	/***/ },
	/* 223 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
	
		var _require = __webpack_require__(3),
		    EditorBase = _require.editors.EditorBase;
	
		var DropDownEditor = function (_EditorBase) {
		  _inherits(DropDownEditor, _EditorBase);
	
		  function DropDownEditor() {
		    _classCallCheck(this, DropDownEditor);
	
		    return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
		  }
	
		  DropDownEditor.prototype.getInputNode = function getInputNode() {
		    return _reactDom2['default'].findDOMNode(this);
		  };
	
		  DropDownEditor.prototype.onClick = function onClick() {
		    this.getInputNode().focus();
		  };
	
		  DropDownEditor.prototype.onDoubleClick = function onDoubleClick() {
		    this.getInputNode().focus();
		  };
	
		  DropDownEditor.prototype.render = function render() {
		    return React.createElement(
		      'select',
		      { style: this.getStyle(), defaultValue: this.props.value, onBlur: this.props.onBlur, onChange: this.onChange },
		      this.renderOptions()
		    );
		  };
	
		  DropDownEditor.prototype.renderOptions = function renderOptions() {
		    var options = [];
		    this.props.options.forEach(function (name) {
		      if (typeof name === 'string') {
		        options.push(React.createElement(
		          'option',
		          { key: name, value: name },
		          name
		        ));
		      } else {
		        options.push(React.createElement(
		          'option',
		          { key: name.id, value: name.value, title: name.title },
		          name.text || name.value
		        ));
		      }
		    }, this);
		    return options;
		  };
	
		  return DropDownEditor;
		}(EditorBase);
	
		DropDownEditor.propTypes = {
		  options: React.PropTypes.arrayOf(React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
		    id: React.PropTypes.string,
		    title: React.PropTypes.string,
		    value: React.PropTypes.string,
		    text: React.PropTypes.string
		  })])).isRequired
		};
	
		module.exports = DropDownEditor;
	
	/***/ },
	/* 224 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _require = __webpack_require__(3),
		    _require$editors = _require.editors,
		    SimpleTextEditor = _require$editors.SimpleTextEditor,
		    CheckboxEditor = _require$editors.CheckboxEditor;
	
		var Editors = {
		  AutoComplete: __webpack_require__(221),
		  DropDownEditor: __webpack_require__(223),
		  ContainerEditorWrapper: __webpack_require__(222),
		  SimpleTextEditor: SimpleTextEditor,
		  CheckboxEditor: CheckboxEditor
		};
	
		module.exports = Editors;
	
	/***/ },
	/* 225 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// Used for displaying the value of a dropdown (using DropDownEditor) when not editing it.
		// Accepts the same parameters as the DropDownEditor.
		var React = __webpack_require__(2);
	
		var DropDownFormatter = React.createClass({
		  displayName: 'DropDownFormatter',
	
		  propTypes: {
		    options: React.PropTypes.arrayOf(React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
		      id: React.PropTypes.string,
		      title: React.PropTypes.string,
		      value: React.PropTypes.string,
		      text: React.PropTypes.string
		    })])).isRequired,
		    value: React.PropTypes.string.isRequired
		  },
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.value !== this.props.value;
		  },
		  render: function render() {
		    var value = this.props.value;
		    var option = this.props.options.filter(function (v) {
		      return v === value || v.value === value;
		    })[0];
		    if (!option) {
		      option = value;
		    }
		    var title = option.title || option.value || option;
		    var text = option.text || option.value || option;
		    return React.createElement(
		      'div',
		      { title: title },
		      text
		    );
		  }
		});
	
		module.exports = DropDownFormatter;
	
	/***/ },
	/* 226 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		__webpack_require__(401);
	
		var PendingPool = {};
		var ReadyPool = {};
	
		var ImageFormatter = React.createClass({
		  displayName: 'ImageFormatter',
	
		  propTypes: {
		    value: React.PropTypes.string.isRequired
		  },
	
		  getInitialState: function getInitialState() {
		    return {
		      ready: false
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._load(this.props.value);
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.value !== this.props.value) {
		      this.setState({ value: null });
		      this._load(nextProps.value);
		    }
		  },
		  _load: function _load(src) {
		    var imageSrc = src;
		    if (ReadyPool[imageSrc]) {
		      this.setState({ value: imageSrc });
		      return;
		    }
	
		    if (PendingPool[imageSrc]) {
		      PendingPool[imageSrc].push(this._onLoad);
		      return;
		    }
	
		    PendingPool[imageSrc] = [this._onLoad];
	
		    var img = new Image();
		    img.onload = function () {
		      PendingPool[imageSrc].forEach(function (callback) {
		        callback(imageSrc);
		      });
		      delete PendingPool[imageSrc];
		      img.onload = null;
		      imageSrc = undefined;
		    };
		    img.src = imageSrc;
		  },
		  _onLoad: function _onLoad(src) {
		    if (this.isMounted() && src === this.props.value) {
		      this.setState({
		        value: src
		      });
		    }
		  },
		  render: function render() {
		    var style = this.state.value ? { backgroundImage: 'url(' + this.state.value + ')' } : undefined;
	
		    return React.createElement('div', { className: 'react-grid-image', style: style });
		  }
		});
	
		module.exports = ImageFormatter;
	
	/***/ },
	/* 227 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// not including this
		// it currently requires the whole of moment, which we dont want to take as a dependency
		var ImageFormatter = __webpack_require__(226);
		var DropDownFormatter = __webpack_require__(225);
	
		var Formatters = {
		  ImageFormatter: ImageFormatter,
		  DropDownFormatter: DropDownFormatter
		};
	
		module.exports = Formatters;
	
	/***/ },
	/* 228 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Editors = __webpack_require__(224);
		var Formatters = __webpack_require__(227);
		var Toolbar = __webpack_require__(238);
		var ToolsPanel = __webpack_require__(239);
		var Data = __webpack_require__(212);
		var Menu = __webpack_require__(231);
		var Draggable = __webpack_require__(220);
		var DraggableHeader = __webpack_require__(215);
		var Filters = __webpack_require__(207);
	
		var _require = __webpack_require__(3),
		    rowComparer = _require.RowComparer;
	
		var performance = __webpack_require__(233);
		var Utils = { rowComparer: rowComparer, performance: performance };
	
		window.ReactDataGridPlugins = { Editors: Editors, Formatters: Formatters, Toolbar: Toolbar, Menu: Menu, Data: Data, ToolsPanel: ToolsPanel, Draggable: Draggable, DraggableHeader: DraggableHeader, Filters: Filters, Utils: Utils };
		module.exports = { Editors: Editors, Formatters: Formatters, Toolbar: Toolbar, Menu: Menu, Data: Data, ToolsPanel: ToolsPanel, Draggable: Draggable, DraggableHeader: DraggableHeader, Filters: Filters, Utils: Utils };
	
	/***/ },
	/* 229 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactContextmenu = __webpack_require__(123);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ReactDataGridContextMenu = function (_React$Component) {
		  _inherits(ReactDataGridContextMenu, _React$Component);
	
		  function ReactDataGridContextMenu() {
		    _classCallCheck(this, ReactDataGridContextMenu);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  ReactDataGridContextMenu.prototype.render = function render() {
		    return _react2['default'].createElement(
		      _reactContextmenu.ContextMenu,
		      { identifier: 'reactDataGridContextMenu' },
		      this.props.children
		    );
		  };
	
		  return ReactDataGridContextMenu;
		}(_react2['default'].Component);
	
		ReactDataGridContextMenu.propTypes = {
		  children: _react.PropTypes.node
		};
	
		exports['default'] = ReactDataGridContextMenu;
	
	/***/ },
	/* 230 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var MenuHeader = function (_React$Component) {
		  _inherits(MenuHeader, _React$Component);
	
		  function MenuHeader() {
		    _classCallCheck(this, MenuHeader);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  MenuHeader.prototype.render = function render() {
		    return _react2["default"].createElement(
		      "div",
		      { className: "react-context-menu-header" },
		      this.props.children
		    );
		  };
	
		  return MenuHeader;
		}(_react2["default"].Component);
	
		MenuHeader.propTypes = {
		  children: _react.PropTypes.any
		};
	
		exports["default"] = MenuHeader;
	
	/***/ },
	/* 231 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.ContextMenuLayer = exports.connect = exports.SubMenu = exports.monitor = exports.MenuItem = exports.MenuHeader = exports.ContextMenu = undefined;
	
		var _reactContextmenu = __webpack_require__(123);
	
		var _ContextMenu = __webpack_require__(229);
	
		var _ContextMenu2 = _interopRequireDefault(_ContextMenu);
	
		var _MenuHeader = __webpack_require__(230);
	
		var _MenuHeader2 = _interopRequireDefault(_MenuHeader);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		exports.ContextMenu = _ContextMenu2['default'];
		exports.MenuHeader = _MenuHeader2['default'];
		exports.MenuItem = _reactContextmenu.MenuItem;
		exports.monitor = _reactContextmenu.monitor;
		exports.SubMenu = _reactContextmenu.SubMenu;
		exports.connect = _reactContextmenu.connect;
		exports.ContextMenuLayer = _reactContextmenu.ContextMenuLayer;
	
	/***/ },
	/* 232 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _SummaryItemModel = __webpack_require__(101);
	
		var _SummaryItemModel2 = _interopRequireDefault(_SummaryItemModel);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var SummaryParser = function () {
		  function SummaryParser(summary) {
		    _classCallCheck(this, SummaryParser);
	
		    this._summary = this._parseSummary(summary);
		    this.getByOwner = this.getByOwner.bind(this);
		    this.getSumByOwner = this.getSumByOwner.bind(this);
		    this.getByComponent = this.getByComponent.bind(this);
		  }
	
		  SummaryParser.prototype._parseSummary = function _parseSummary(summary) {
		    return summary.map(function (s) {
		      return new _SummaryItemModel2['default'](s);
		    });
		  };
	
		  SummaryParser.prototype.getByOwner = function getByOwner(ownerName) {
		    return this._summary.filter(function (s) {
		      return s.owner === ownerName;
		    });
		  };
	
		  SummaryParser.prototype.getSumByOwner = function getSumByOwner(ownerName) {
		    var summaryItemsByOwner = this.getByOwner(ownerName);
		    var summaryItem = new _SummaryItemModel2['default'](ownerName);
	
		    summaryItemsByOwner.forEach(function (s) {
		      var wastedTime = summaryItem.wastedTime,
		          wastedInstances = summaryItem.wastedInstances;
	
		      summaryItem.wastedTime = wastedTime + s.wastedTime;
		      summaryItem.wastedInstances = wastedInstances + s.wastedInstances;
		    });
	
		    return summaryItem;
		  };
	
		  SummaryParser.prototype.getByComponent = function getByComponent(component) {
		    var componentSummaryItem = this._summary.filter(function (s) {
		      return s.component === component;
		    });
	
		    if (componentSummaryItem.length > 1) {
		      throw new Error('More then 1 result retrived for ' + component);
		    }
	
		    if (componentSummaryItem.length === 0) {
		      var emptySummary = new _SummaryItemModel2['default'](component);
		      componentSummaryItem = [emptySummary];
		    }
	
		    return componentSummaryItem[0];
		  };
	
		  return SummaryParser;
		}();
	
		exports['default'] = SummaryParser;
	
	/***/ },
	/* 233 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _SummaryParser = __webpack_require__(232);
	
		var _SummaryParser2 = _interopRequireDefault(_SummaryParser);
	
		var _SummaryItemModel = __webpack_require__(101);
	
		var _SummaryItemModel2 = _interopRequireDefault(_SummaryItemModel);
	
		var _whyDidYouUpdate = __webpack_require__(234);
	
		var _whyDidYouUpdate2 = _interopRequireDefault(_whyDidYouUpdate);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		exports['default'] = {
		  SummaryParser: _SummaryParser2['default'],
		  SummaryItemModel: _SummaryItemModel2['default'],
		  whyDidYouUpdate: _whyDidYouUpdate2['default']
		};
	
	/***/ },
	/* 234 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.NOTIFY_LEVELS = undefined;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _underscore = __webpack_require__(96);
	
		var _underscore2 = _interopRequireDefault(_underscore);
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
	
	
		var isRequiredUpdateObject = function isRequiredUpdateObject(o) {
		  return Array.isArray(o) || o && o.constructor === Object.prototype.constructor;
		};
		var NOTIFY_LEVELS = { DEBUG: 0, WARNING: 1, NONE: 2 };
		var isLogEnabled = function isLogEnabled(lvl) {
		  return lvl !== NOTIFY_LEVELS.NONE;
		};
		var isStatusTypeLoggable = function isStatusTypeLoggable(s, lvl) {
		  return s <= lvl;
		};
	
		var deepDiff = function deepDiff(o1, o2, p, notifyLevel) {
		  var notify = function notify(status, statusType) {
		    if (isStatusTypeLoggable(statusType, notifyLevel)) {
		      console.warn('Update %s', status);
		      console.log('%cbefore', 'font-weight: bold', o1);
		      console.log('%cafter ', 'font-weight: bold', o2);
		    }
		  };
	
		  if (!_underscore2['default'].isEqual(o1, o2)) {
		    console.group(p);
		    if ([o1, o2].every(_underscore2['default'].isFunction)) {
		      notify('avoidable?', NOTIFY_LEVELS.WARNING);
		    } else if (![o1, o2].every(isRequiredUpdateObject)) {
		      notify('required.', NOTIFY_LEVELS.DEBUG);
		    } else {
		      var keys = _underscore2['default'].union(_underscore2['default'].keys(o1), _underscore2['default'].keys(o2));
		      for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		        var _ref;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref = _i.value;
		        }
	
		        var key = _ref;
	
		        deepDiff(o1[key], o2[key], key);
		      }
		    }
	
		    console.groupEnd();
		  } else if (o1 !== o2) {
		    console.group(p);
		    notify('avoidable!', NOTIFY_LEVELS.WARNING);
		    if (_underscore2['default'].isObject(o1) && _underscore2['default'].isObject(o2)) {
		      var _keys = _underscore2['default'].union(_underscore2['default'].keys(o1), _underscore2['default'].keys(o2));
		      for (var _iterator2 = _keys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
		        var _ref2;
	
		        if (_isArray2) {
		          if (_i2 >= _iterator2.length) break;
		          _ref2 = _iterator2[_i2++];
		        } else {
		          _i2 = _iterator2.next();
		          if (_i2.done) break;
		          _ref2 = _i2.value;
		        }
	
		        var _key = _ref2;
	
		        deepDiff(o1[_key], o2[_key], _key);
		      }
		    }
		    console.groupEnd();
		  }
		};
	
		var whyDidYouUpdate = function whyDidYouUpdate(WrappedComponent) {
		  var notifyLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOTIFY_LEVELS.NONE;
	
		  return function (_Component) {
		    _inherits(WhyDidYouUpdateComponentWrapper, _Component);
	
		    function WhyDidYouUpdateComponentWrapper() {
		      _classCallCheck(this, WhyDidYouUpdateComponentWrapper);
	
		      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		    }
	
		    WhyDidYouUpdateComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
		      if (!isLogEnabled(notifyLevel)) {
		        return;
		      }
	
		      deepDiff({ props: prevProps, state: prevState }, { props: this.props, state: this.state }, WrappedComponent.displayName, notifyLevel);
		    };
	
		    WhyDidYouUpdateComponentWrapper.prototype.render = function render() {
		      return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
		    };
	
		    return WhyDidYouUpdateComponentWrapper;
		  }(_react.Component);
		};
	
		exports['default'] = whyDidYouUpdate;
		exports.NOTIFY_LEVELS = NOTIFY_LEVELS;
	
	/***/ },
	/* 235 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		__webpack_require__(143);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var propTypes = {
		  children: _react.PropTypes.array
		};
	
		var defaultProps = {
		  enableAddRow: true
		};
	
		var AdvancedToolbar = function (_Component) {
		  _inherits(AdvancedToolbar, _Component);
	
		  function AdvancedToolbar() {
		    _classCallCheck(this, AdvancedToolbar);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  AdvancedToolbar.prototype.render = function render() {
		    return _react2['default'].createElement(
		      'div',
		      { className: 'react-grid-Toolbar' },
		      this.props.children,
		      _react2['default'].createElement('div', { className: 'tools' })
		    );
		  };
	
		  return AdvancedToolbar;
		}(_react.Component);
	
		AdvancedToolbar.defaultProps = defaultProps;
		AdvancedToolbar.propTypes = propTypes;
	
		exports['default'] = AdvancedToolbar;
	
	/***/ },
	/* 236 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var GroupedColumnButton = function (_Component) {
		  _inherits(GroupedColumnButton, _Component);
	
		  function GroupedColumnButton() {
		    _classCallCheck(this, GroupedColumnButton);
	
		    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		  }
	
		  GroupedColumnButton.prototype.render = function render() {
		    var style = {
		      width: '80px',
		      overflow: 'hidden',
		      textOverflow: 'ellipsis',
		      whiteSpace: 'nowrap'
		    };
		    return _react2['default'].createElement(
		      'button',
		      { className: 'btn grouped-col-btn btn-sm' },
		      _react2['default'].createElement(
		        'span',
		        { style: style },
		        this.props.name
		      ),
		      _react2['default'].createElement('span', {
		        className: 'glyphicon glyphicon-trash',
		        style: { float: 'right', paddingLeft: '5px' },
		        onClick: this.props.onColumnGroupDeleted.bind(null, this.props.name) })
		    );
		  };
	
		  return GroupedColumnButton;
		}(_react.Component);
	
		exports['default'] = GroupedColumnButton;
	
	
		GroupedColumnButton.propTypes = {
		  name: _react.PropTypes.string.isRequired,
		  onColumnGroupDeleted: _react.PropTypes.func
		};
	
	/***/ },
	/* 237 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDnd = __webpack_require__(16);
	
		var _GroupedColumnButton = __webpack_require__(236);
	
		var _GroupedColumnButton2 = _interopRequireDefault(_GroupedColumnButton);
	
		var _reactDataGrid = __webpack_require__(3);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var DragItemTypes = _reactDataGrid._constants.DragItemTypes;
	
	
		var propTypes = {
		  isOver: _react.PropTypes.bool.isRequired,
		  connectDropTarget: _react.PropTypes.func,
		  canDrop: _react.PropTypes.bool.isRequired,
		  groupBy: _react.PropTypes.array,
		  noColumnsSelectedMessage: _react.PropTypes.string,
		  panelDescription: _react.PropTypes.string,
		  onColumnGroupDeleted: _react.PropTypes.func
		};
	
		var defaultProps = {
		  noColumnsSelectedMessage: 'Drag a column header here to group by that column',
		  panelDescription: 'Drag a column header here to group by that column'
		};
	
		var GroupedColumnsPanel = function (_Component) {
		  _inherits(GroupedColumnsPanel, _Component);
	
		  function GroupedColumnsPanel() {
		    _classCallCheck(this, GroupedColumnsPanel);
	
		    return _possibleConstructorReturn(this, _Component.call(this));
		  }
	
		  GroupedColumnsPanel.prototype.getPanelInstructionMessage = function getPanelInstructionMessage() {
		    var groupBy = this.props.groupBy;
	
		    return groupBy && groupBy.length > 0 ? this.props.panelDescription : this.props.noColumnsSelectedMessage;
		  };
	
		  GroupedColumnsPanel.prototype.renderGroupedColumns = function renderGroupedColumns() {
		    var _this2 = this;
	
		    return this.props.groupBy.map(function (c) {
		      return _react2['default'].createElement(_GroupedColumnButton2['default'], { key: c, name: c, onColumnGroupDeleted: _this2.props.onColumnGroupDeleted });
		    });
		  };
	
		  GroupedColumnsPanel.prototype.renderOverlay = function renderOverlay(color) {
		    return _react2['default'].createElement('div', { style: {
		        position: 'absolute',
		        top: 0,
		        left: 0,
		        height: '100%',
		        width: '100%',
		        zIndex: 1,
		        opacity: 0.5,
		        backgroundColor: color
		      } });
		  };
	
		  GroupedColumnsPanel.prototype.render = function render() {
		    var _props = this.props,
		        connectDropTarget = _props.connectDropTarget,
		        isOver = _props.isOver,
		        canDrop = _props.canDrop;
	
		    return connectDropTarget(_react2['default'].createElement(
		      'div',
		      { style: { padding: '2px', position: 'relative', margin: '-10px', display: 'inline-block', border: '1px solid #eee' } },
		      this.renderGroupedColumns(),
		      ' ',
		      _react2['default'].createElement(
		        'span',
		        null,
		        this.getPanelInstructionMessage()
		      ),
		      isOver && canDrop && this.renderOverlay('yellow'),
		      !isOver && canDrop && this.renderOverlay('#DBECFA')
		    ));
		  };
	
		  return GroupedColumnsPanel;
		}(_react.Component);
	
		GroupedColumnsPanel.defaultProps = defaultProps;
		GroupedColumnsPanel.propTypes = propTypes;
	
		var columnTarget = {
		  drop: function drop(props, monitor) {
		    // Obtain the dragged item
		    var item = monitor.getItem();
		    if (typeof props.onColumnGroupAdded === 'function') {
		      props.onColumnGroupAdded(item.key);
		    }
		  }
		};
	
		function collect(connect, monitor) {
		  return {
		    connectDropTarget: connect.dropTarget(),
		    isOver: monitor.isOver(),
		    canDrop: monitor.canDrop(),
		    draggedolumn: monitor.getItem()
		  };
		}
	
		exports['default'] = (0, _reactDnd.DropTarget)(DragItemTypes.Column, columnTarget, collect)(GroupedColumnsPanel);
	
	/***/ },
	/* 238 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		__webpack_require__(143);
	
		var Toolbar = React.createClass({
		  displayName: 'Toolbar',
	
		  propTypes: {
		    onAddRow: React.PropTypes.func,
		    onToggleFilter: React.PropTypes.func,
		    enableFilter: React.PropTypes.bool,
		    numberOfRows: React.PropTypes.number,
		    addRowButtonText: React.PropTypes.string,
		    filterRowsButtonText: React.PropTypes.string,
		    children: React.PropTypes.any
		  },
	
		  onAddRow: function onAddRow() {
		    if (this.props.onAddRow !== null && this.props.onAddRow instanceof Function) {
		      this.props.onAddRow({ newRowIndex: this.props.numberOfRows });
		    }
		  },
		  getDefaultProps: function getDefaultProps() {
		    return {
		      enableAddRow: true,
		      addRowButtonText: 'Add Row',
		      filterRowsButtonText: 'Filter Rows'
		    };
		  },
		  renderAddRowButton: function renderAddRowButton() {
		    if (this.props.onAddRow) {
		      return React.createElement(
		        'button',
		        { type: 'button', className: 'btn', onClick: this.onAddRow },
		        this.props.addRowButtonText
		      );
		    }
		  },
		  renderToggleFilterButton: function renderToggleFilterButton() {
		    if (this.props.enableFilter) {
		      return React.createElement(
		        'button',
		        { type: 'button', className: 'btn', onClick: this.props.onToggleFilter },
		        this.props.filterRowsButtonText
		      );
		    }
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Toolbar' },
		      React.createElement(
		        'div',
		        { className: 'tools' },
		        this.renderAddRowButton(),
		        this.renderToggleFilterButton(),
		        this.props.children
		      )
		    );
		  }
		});
	
		module.exports = Toolbar;
	
	/***/ },
	/* 239 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _AdvancedToolbar = __webpack_require__(235);
	
		var _AdvancedToolbar2 = _interopRequireDefault(_AdvancedToolbar);
	
		var _GroupedColumnsPanel = __webpack_require__(237);
	
		var _GroupedColumnsPanel2 = _interopRequireDefault(_GroupedColumnsPanel);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = { AdvancedToolbar: _AdvancedToolbar2['default'], GroupedColumnsPanel: _GroupedColumnsPanel2['default'] };
	
	/***/ },
	/* 240 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".Select{position:relative}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none}.is-searchable.is-open>.Select-control{cursor:text}.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text}.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1)}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:14px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.is-open .Select-arrow,.Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);
	
		// exports
	
	
	/***/ },
	/* 241 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".slideUp{animation-name:slideUp;-webkit-animation-name:slideUp;animation-duration:1s;-webkit-animation-duration:1s;animation-timing-function:ease;-webkit-animation-timing-function:ease;visibility:visible!important}@keyframes slideUp{0%{transform:translateY(100%)}50%{transform:translateY(-8%)}65%{transform:translateY(4%)}80%{transform:translateY(-4%)}95%{transform:translateY(2%)}to{transform:translateY(0)}}@-webkit-keyframes slideUp{0%{-webkit-transform:translateY(100%)}50%{-webkit-transform:translateY(-8%)}65%{-webkit-transform:translateY(4%)}80%{-webkit-transform:translateY(-4%)}95%{-webkit-transform:translateY(2%)}to{-webkit-transform:translateY(0)}}", ""]);
	
		// exports
	
	
	/***/ },
	/* 242 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-image{background:#efefef;background-size:100%;display:inline-block;height:40px;width:40px}", ""]);
	
		// exports
	
	
	/***/ },
	/* 243 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Toolbar{background-color:#fff;border-color:#e7eaec;border-image:none;border-style:solid solid none;border-width:1px;color:inherit;margin-bottom:0;padding:14px 15px 7px;height:48px}.react-grid-Toolbar .btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;color:inherit;background:#fff;border:1px solid #e7eaec}.react-grid-Toolbar .btn:hover{color:inherit;border:1px solid #d2d2d2}.react-grid-Toolbar .grouped-col-btn{background-color:#428bca;color:#fff}.react-grid-Toolbar .grouped-col-btn:hover{color:#fff}.react-grid-Toolbar .tools{display:inline-block;float:right;margin-top:0;position:relative;padding:0;margin-top:-6px}", ""]);
	
		// exports
	
	
	/***/ },
	/* 244 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-autocomplete-Autocomplete__search{display:block;width:100%;height:36px;padding:6px 12px;font-size:14px;line-height:1.6;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.react-autocomplete-Autocomplete__search:focus{border-color:#a21618;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(162,22,24,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(162,22,24,.6)}.react-autocomplete-Autocomplete__search::-moz-placeholder{color:#777;opacity:1}.react-autocomplete-Autocomplete__search:-ms-input-placeholder{color:#777}.react-autocomplete-Autocomplete__search::-webkit-input-placeholder{color:#777}.react-autocomplete-Autocomplete__search[disabled],.react-autocomplete-Autocomplete__search[readonly],fieldset[disabled] .react-autocomplete-Autocomplete__search{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-autocomplete-Autocomplete__search{height:auto}.react-autocomplete-Autocomplete__results{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box;min-width:250px;width:100%;max-height:200px;overflow:auto}.react-autocomplete-Autocomplete__results.pull-right{right:0;left:auto}.react-autocomplete-Autocomplete__results .divider{height:1px;margin:10px 0;overflow:hidden;background-color:#e5e5e5}.react-autocomplete-Autocomplete__results>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.6;color:#333;white-space:nowrap}.react-autocomplete-Autocomplete__results div.action-button{display:block!important;padding:4px}.react-autocomplete-Result{cursor:pointer}.react-autocomplete-Result>a{text-decoration:none}.react-autocomplete-Result--active{color:#262626;background-color:#f5f5f5}", ""]);
	
		// exports
	
	
	/***/ },
	/* 245 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
		var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
		exports.__esModule = true;
	
		var _isDisposable = __webpack_require__(72);
	
		var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
		/**
		 * Represents a group of disposable resources that are disposed together.
		 */
	
		var CompositeDisposable = (function () {
		  function CompositeDisposable() {
		    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
		      disposables[_key] = arguments[_key];
		    }
	
		    _classCallCheck(this, CompositeDisposable);
	
		    if (Array.isArray(disposables[0]) && disposables.length === 1) {
		      disposables = disposables[0];
		    }
	
		    for (var i = 0; i < disposables.length; i++) {
		      if (!_isDisposable2['default'](disposables[i])) {
		        throw new Error('Expected a disposable');
		      }
		    }
	
		    this.disposables = disposables;
		    this.isDisposed = false;
		  }
	
		  /**
		   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
		   * @param {Disposable} item Disposable to add.
		   */
	
		  CompositeDisposable.prototype.add = function add(item) {
		    if (this.isDisposed) {
		      item.dispose();
		    } else {
		      this.disposables.push(item);
		    }
		  };
	
		  /**
		   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
		   * @param {Disposable} item Disposable to remove.
		   * @returns {Boolean} true if found; false otherwise.
		   */
	
		  CompositeDisposable.prototype.remove = function remove(item) {
		    if (this.isDisposed) {
		      return false;
		    }
	
		    var index = this.disposables.indexOf(item);
		    if (index === -1) {
		      return false;
		    }
	
		    this.disposables.splice(index, 1);
		    item.dispose();
		    return true;
		  };
	
		  /**
		   * Disposes all disposables in the group and removes them from the group.
		   */
	
		  CompositeDisposable.prototype.dispose = function dispose() {
		    if (this.isDisposed) {
		      return;
		    }
	
		    var len = this.disposables.length;
		    var currentDisposables = new Array(len);
		    for (var i = 0; i < len; i++) {
		      currentDisposables[i] = this.disposables[i];
		    }
	
		    this.isDisposed = true;
		    this.disposables = [];
		    this.length = 0;
	
		    for (var i = 0; i < len; i++) {
		      currentDisposables[i].dispose();
		    }
		  };
	
		  return CompositeDisposable;
		})();
	
		exports['default'] = CompositeDisposable;
		module.exports = exports['default'];
	
	/***/ },
	/* 246 */
	/***/ function(module, exports) {
	
		"use strict";
	
		var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
		exports.__esModule = true;
		var noop = function noop() {};
	
		/**
		 * The basic disposable.
		 */
	
		var Disposable = (function () {
		  function Disposable(action) {
		    _classCallCheck(this, Disposable);
	
		    this.isDisposed = false;
		    this.action = action || noop;
		  }
	
		  Disposable.prototype.dispose = function dispose() {
		    if (!this.isDisposed) {
		      this.action.call(null);
		      this.isDisposed = true;
		    }
		  };
	
		  _createClass(Disposable, null, [{
		    key: "empty",
		    enumerable: true,
		    value: { dispose: noop }
		  }]);
	
		  return Disposable;
		})();
	
		exports["default"] = Disposable;
		module.exports = exports["default"];
	
	/***/ },
	/* 247 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
		var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
		exports.__esModule = true;
	
		var _isDisposable = __webpack_require__(72);
	
		var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
		var SerialDisposable = (function () {
		  function SerialDisposable() {
		    _classCallCheck(this, SerialDisposable);
	
		    this.isDisposed = false;
		    this.current = null;
		  }
	
		  /**
		   * Gets the underlying disposable.
		   * @return The underlying disposable.
		   */
	
		  SerialDisposable.prototype.getDisposable = function getDisposable() {
		    return this.current;
		  };
	
		  /**
		   * Sets the underlying disposable.
		   * @param {Disposable} value The new underlying disposable.
		   */
	
		  SerialDisposable.prototype.setDisposable = function setDisposable() {
		    var value = arguments[0] === undefined ? null : arguments[0];
	
		    if (value != null && !_isDisposable2['default'](value)) {
		      throw new Error('Expected either an empty value or a valid disposable');
		    }
	
		    var isDisposed = this.isDisposed;
		    var previous = undefined;
	
		    if (!isDisposed) {
		      previous = this.current;
		      this.current = value;
		    }
	
		    if (previous) {
		      previous.dispose();
		    }
	
		    if (isDisposed && value) {
		      value.dispose();
		    }
		  };
	
		  /**
		   * Disposes the underlying disposable as well as all future replacements.
		   */
	
		  SerialDisposable.prototype.dispose = function dispose() {
		    if (this.isDisposed) {
		      return;
		    }
	
		    this.isDisposed = true;
		    var previous = this.current;
		    this.current = null;
	
		    if (previous) {
		      previous.dispose();
		    }
		  };
	
		  return SerialDisposable;
		})();
	
		exports['default'] = SerialDisposable;
		module.exports = exports['default'];
	
	/***/ },
	/* 248 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
		exports.__esModule = true;
	
		var _isDisposable2 = __webpack_require__(72);
	
		var _isDisposable3 = _interopRequireWildcard(_isDisposable2);
	
		exports.isDisposable = _isDisposable3['default'];
	
		var _Disposable2 = __webpack_require__(246);
	
		var _Disposable3 = _interopRequireWildcard(_Disposable2);
	
		exports.Disposable = _Disposable3['default'];
	
		var _CompositeDisposable2 = __webpack_require__(245);
	
		var _CompositeDisposable3 = _interopRequireWildcard(_CompositeDisposable2);
	
		exports.CompositeDisposable = _CompositeDisposable3['default'];
	
		var _SerialDisposable2 = __webpack_require__(247);
	
		var _SerialDisposable3 = _interopRequireWildcard(_SerialDisposable2);
	
		exports.SerialDisposable = _SerialDisposable3['default'];
	
	/***/ },
	/* 249 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _createStore = __webpack_require__(86);
	
		var _createStore2 = _interopRequireDefault(_createStore);
	
		var _reducers = __webpack_require__(257);
	
		var _reducers2 = _interopRequireDefault(_reducers);
	
		var _dragDrop = __webpack_require__(39);
	
		var dragDropActions = _interopRequireWildcard(_dragDrop);
	
		var _DragDropMonitor = __webpack_require__(250);
	
		var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var DragDropManager = function () {
		  function DragDropManager(createBackend) {
		    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		    _classCallCheck(this, DragDropManager);
	
		    var store = (0, _createStore2.default)(_reducers2.default);
		    this.context = context;
		    this.store = store;
		    this.monitor = new _DragDropMonitor2.default(store);
		    this.registry = this.monitor.registry;
		    this.backend = createBackend(this);
	
		    store.subscribe(this.handleRefCountChange.bind(this));
		  }
	
		  _createClass(DragDropManager, [{
		    key: 'handleRefCountChange',
		    value: function handleRefCountChange() {
		      var shouldSetUp = this.store.getState().refCount > 0;
		      if (shouldSetUp && !this.isSetUp) {
		        this.backend.setup();
		        this.isSetUp = true;
		      } else if (!shouldSetUp && this.isSetUp) {
		        this.backend.teardown();
		        this.isSetUp = false;
		      }
		    }
		  }, {
		    key: 'getContext',
		    value: function getContext() {
		      return this.context;
		    }
		  }, {
		    key: 'getMonitor',
		    value: function getMonitor() {
		      return this.monitor;
		    }
		  }, {
		    key: 'getBackend',
		    value: function getBackend() {
		      return this.backend;
		    }
		  }, {
		    key: 'getRegistry',
		    value: function getRegistry() {
		      return this.registry;
		    }
		  }, {
		    key: 'getActions',
		    value: function getActions() {
		      var manager = this;
		      var dispatch = this.store.dispatch;
	
	
		      function bindActionCreator(actionCreator) {
		        return function () {
		          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		          }
	
		          var action = actionCreator.apply(manager, args);
		          if (typeof action !== 'undefined') {
		            dispatch(action);
		          }
		        };
		      }
	
		      return Object.keys(dragDropActions).filter(function (key) {
		        return typeof dragDropActions[key] === 'function';
		      }).reduce(function (boundActions, key) {
		        var action = dragDropActions[key];
		        boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
		        return boundActions;
		      }, {});
		    }
		  }]);
	
		  return DragDropManager;
		}();
	
		exports.default = DragDropManager;
	
	/***/ },
	/* 250 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isArray = __webpack_require__(19);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		var _matchesType = __webpack_require__(104);
	
		var _matchesType2 = _interopRequireDefault(_matchesType);
	
		var _HandlerRegistry = __webpack_require__(253);
	
		var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
		var _dragOffset = __webpack_require__(103);
	
		var _dirtyHandlerIds = __webpack_require__(102);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var DragDropMonitor = function () {
		  function DragDropMonitor(store) {
		    _classCallCheck(this, DragDropMonitor);
	
		    this.store = store;
		    this.registry = new _HandlerRegistry2.default(store);
		  }
	
		  _createClass(DragDropMonitor, [{
		    key: 'subscribeToStateChange',
		    value: function subscribeToStateChange(listener) {
		      var _this = this;
	
		      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		      var handlerIds = options.handlerIds;
	
		      (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
		      (0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
	
		      var prevStateId = this.store.getState().stateId;
		      var handleChange = function handleChange() {
		        var state = _this.store.getState();
		        var currentStateId = state.stateId;
		        try {
		          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
	
		          if (!canSkipListener) {
		            listener();
		          }
		        } finally {
		          prevStateId = currentStateId;
		        }
		      };
	
		      return this.store.subscribe(handleChange);
		    }
		  }, {
		    key: 'subscribeToOffsetChange',
		    value: function subscribeToOffsetChange(listener) {
		      var _this2 = this;
	
		      (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
	
		      var previousState = this.store.getState().dragOffset;
		      var handleChange = function handleChange() {
		        var nextState = _this2.store.getState().dragOffset;
		        if (nextState === previousState) {
		          return;
		        }
	
		        previousState = nextState;
		        listener();
		      };
	
		      return this.store.subscribe(handleChange);
		    }
		  }, {
		    key: 'canDragSource',
		    value: function canDragSource(sourceId) {
		      var source = this.registry.getSource(sourceId);
		      (0, _invariant2.default)(source, 'Expected to find a valid source.');
	
		      if (this.isDragging()) {
		        return false;
		      }
	
		      return source.canDrag(this, sourceId);
		    }
		  }, {
		    key: 'canDropOnTarget',
		    value: function canDropOnTarget(targetId) {
		      var target = this.registry.getTarget(targetId);
		      (0, _invariant2.default)(target, 'Expected to find a valid target.');
	
		      if (!this.isDragging() || this.didDrop()) {
		        return false;
		      }
	
		      var targetType = this.registry.getTargetType(targetId);
		      var draggedItemType = this.getItemType();
		      return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
		    }
		  }, {
		    key: 'isDragging',
		    value: function isDragging() {
		      return Boolean(this.getItemType());
		    }
		  }, {
		    key: 'isDraggingSource',
		    value: function isDraggingSource(sourceId) {
		      var source = this.registry.getSource(sourceId, true);
		      (0, _invariant2.default)(source, 'Expected to find a valid source.');
	
		      if (!this.isDragging() || !this.isSourcePublic()) {
		        return false;
		      }
	
		      var sourceType = this.registry.getSourceType(sourceId);
		      var draggedItemType = this.getItemType();
		      if (sourceType !== draggedItemType) {
		        return false;
		      }
	
		      return source.isDragging(this, sourceId);
		    }
		  }, {
		    key: 'isOverTarget',
		    value: function isOverTarget(targetId) {
		      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
		      var shallow = options.shallow;
	
		      if (!this.isDragging()) {
		        return false;
		      }
	
		      var targetType = this.registry.getTargetType(targetId);
		      var draggedItemType = this.getItemType();
		      if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
		        return false;
		      }
	
		      var targetIds = this.getTargetIds();
		      if (!targetIds.length) {
		        return false;
		      }
	
		      var index = targetIds.indexOf(targetId);
		      if (shallow) {
		        return index === targetIds.length - 1;
		      } else {
		        return index > -1;
		      }
		    }
		  }, {
		    key: 'getItemType',
		    value: function getItemType() {
		      return this.store.getState().dragOperation.itemType;
		    }
		  }, {
		    key: 'getItem',
		    value: function getItem() {
		      return this.store.getState().dragOperation.item;
		    }
		  }, {
		    key: 'getSourceId',
		    value: function getSourceId() {
		      return this.store.getState().dragOperation.sourceId;
		    }
		  }, {
		    key: 'getTargetIds',
		    value: function getTargetIds() {
		      return this.store.getState().dragOperation.targetIds;
		    }
		  }, {
		    key: 'getDropResult',
		    value: function getDropResult() {
		      return this.store.getState().dragOperation.dropResult;
		    }
		  }, {
		    key: 'didDrop',
		    value: function didDrop() {
		      return this.store.getState().dragOperation.didDrop;
		    }
		  }, {
		    key: 'isSourcePublic',
		    value: function isSourcePublic() {
		      return this.store.getState().dragOperation.isSourcePublic;
		    }
		  }, {
		    key: 'getInitialClientOffset',
		    value: function getInitialClientOffset() {
		      return this.store.getState().dragOffset.initialClientOffset;
		    }
		  }, {
		    key: 'getInitialSourceClientOffset',
		    value: function getInitialSourceClientOffset() {
		      return this.store.getState().dragOffset.initialSourceClientOffset;
		    }
		  }, {
		    key: 'getClientOffset',
		    value: function getClientOffset() {
		      return this.store.getState().dragOffset.clientOffset;
		    }
		  }, {
		    key: 'getSourceClientOffset',
		    value: function getSourceClientOffset() {
		      return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
		    }
		  }, {
		    key: 'getDifferenceFromInitialOffset',
		    value: function getDifferenceFromInitialOffset() {
		      return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
		    }
		  }]);
	
		  return DragDropMonitor;
		}();
	
		exports.default = DragDropMonitor;
	
	/***/ },
	/* 251 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var DragSource = function () {
		  function DragSource() {
		    _classCallCheck(this, DragSource);
		  }
	
		  _createClass(DragSource, [{
		    key: "canDrag",
		    value: function canDrag() {
		      return true;
		    }
		  }, {
		    key: "isDragging",
		    value: function isDragging(monitor, handle) {
		      return handle === monitor.getSourceId();
		    }
		  }, {
		    key: "endDrag",
		    value: function endDrag() {}
		  }]);
	
		  return DragSource;
		}();
	
		exports.default = DragSource;
	
	/***/ },
	/* 252 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var DropTarget = function () {
		  function DropTarget() {
		    _classCallCheck(this, DropTarget);
		  }
	
		  _createClass(DropTarget, [{
		    key: "canDrop",
		    value: function canDrop() {
		      return true;
		    }
		  }, {
		    key: "hover",
		    value: function hover() {}
		  }, {
		    key: "drop",
		    value: function drop() {}
		  }]);
	
		  return DropTarget;
		}();
	
		exports.default = DropTarget;
	
	/***/ },
	/* 253 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isArray = __webpack_require__(19);
	
		var _isArray2 = _interopRequireDefault(_isArray);
	
		var _asap = __webpack_require__(203);
	
		var _asap2 = _interopRequireDefault(_asap);
	
		var _registry = __webpack_require__(40);
	
		var _getNextUniqueId = __webpack_require__(260);
	
		var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var HandlerRoles = {
		  SOURCE: 'SOURCE',
		  TARGET: 'TARGET'
		};
	
		function validateSourceContract(source) {
		  (0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
		  (0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
		  (0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
		}
	
		function validateTargetContract(target) {
		  (0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
		  (0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
		  (0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
		}
	
		function validateType(type, allowArray) {
		  if (allowArray && (0, _isArray2.default)(type)) {
		    type.forEach(function (t) {
		      return validateType(t, false);
		    });
		    return;
		  }
	
		  (0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
		}
	
		function getNextHandlerId(role) {
		  var id = (0, _getNextUniqueId2.default)().toString();
		  switch (role) {
		    case HandlerRoles.SOURCE:
		      return 'S' + id;
		    case HandlerRoles.TARGET:
		      return 'T' + id;
		    default:
		      (0, _invariant2.default)(false, 'Unknown role: ' + role);
		  }
		}
	
		function parseRoleFromHandlerId(handlerId) {
		  switch (handlerId[0]) {
		    case 'S':
		      return HandlerRoles.SOURCE;
		    case 'T':
		      return HandlerRoles.TARGET;
		    default:
		      (0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
		  }
		}
	
		var HandlerRegistry = function () {
		  function HandlerRegistry(store) {
		    _classCallCheck(this, HandlerRegistry);
	
		    this.store = store;
	
		    this.types = {};
		    this.handlers = {};
	
		    this.pinnedSourceId = null;
		    this.pinnedSource = null;
		  }
	
		  _createClass(HandlerRegistry, [{
		    key: 'addSource',
		    value: function addSource(type, source) {
		      validateType(type);
		      validateSourceContract(source);
	
		      var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
		      this.store.dispatch((0, _registry.addSource)(sourceId));
		      return sourceId;
		    }
		  }, {
		    key: 'addTarget',
		    value: function addTarget(type, target) {
		      validateType(type, true);
		      validateTargetContract(target);
	
		      var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
		      this.store.dispatch((0, _registry.addTarget)(targetId));
		      return targetId;
		    }
		  }, {
		    key: 'addHandler',
		    value: function addHandler(role, type, handler) {
		      var id = getNextHandlerId(role);
		      this.types[id] = type;
		      this.handlers[id] = handler;
	
		      return id;
		    }
		  }, {
		    key: 'containsHandler',
		    value: function containsHandler(handler) {
		      var _this = this;
	
		      return Object.keys(this.handlers).some(function (key) {
		        return _this.handlers[key] === handler;
		      });
		    }
		  }, {
		    key: 'getSource',
		    value: function getSource(sourceId, includePinned) {
		      (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	
		      var isPinned = includePinned && sourceId === this.pinnedSourceId;
		      var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
		      return source;
		    }
		  }, {
		    key: 'getTarget',
		    value: function getTarget(targetId) {
		      (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
		      return this.handlers[targetId];
		    }
		  }, {
		    key: 'getSourceType',
		    value: function getSourceType(sourceId) {
		      (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
		      return this.types[sourceId];
		    }
		  }, {
		    key: 'getTargetType',
		    value: function getTargetType(targetId) {
		      (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
		      return this.types[targetId];
		    }
		  }, {
		    key: 'isSourceId',
		    value: function isSourceId(handlerId) {
		      var role = parseRoleFromHandlerId(handlerId);
		      return role === HandlerRoles.SOURCE;
		    }
		  }, {
		    key: 'isTargetId',
		    value: function isTargetId(handlerId) {
		      var role = parseRoleFromHandlerId(handlerId);
		      return role === HandlerRoles.TARGET;
		    }
		  }, {
		    key: 'removeSource',
		    value: function removeSource(sourceId) {
		      var _this2 = this;
	
		      (0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
		      this.store.dispatch((0, _registry.removeSource)(sourceId));
	
		      (0, _asap2.default)(function () {
		        delete _this2.handlers[sourceId];
		        delete _this2.types[sourceId];
		      });
		    }
		  }, {
		    key: 'removeTarget',
		    value: function removeTarget(targetId) {
		      var _this3 = this;
	
		      (0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
		      this.store.dispatch((0, _registry.removeTarget)(targetId));
	
		      (0, _asap2.default)(function () {
		        delete _this3.handlers[targetId];
		        delete _this3.types[targetId];
		      });
		    }
		  }, {
		    key: 'pinSource',
		    value: function pinSource(sourceId) {
		      var source = this.getSource(sourceId);
		      (0, _invariant2.default)(source, 'Expected an existing source.');
	
		      this.pinnedSourceId = sourceId;
		      this.pinnedSource = source;
		    }
		  }, {
		    key: 'unpinSource',
		    value: function unpinSource() {
		      (0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
	
		      this.pinnedSourceId = null;
		      this.pinnedSource = null;
		    }
		  }]);
	
		  return HandlerRegistry;
		}();
	
		exports.default = HandlerRegistry;
	
	/***/ },
	/* 254 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createBackend;
	
		var _noop = __webpack_require__(121);
	
		var _noop2 = _interopRequireDefault(_noop);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var TestBackend = function () {
		  function TestBackend(manager) {
		    _classCallCheck(this, TestBackend);
	
		    this.actions = manager.getActions();
		  }
	
		  _createClass(TestBackend, [{
		    key: 'setup',
		    value: function setup() {
		      this.didCallSetup = true;
		    }
		  }, {
		    key: 'teardown',
		    value: function teardown() {
		      this.didCallTeardown = true;
		    }
		  }, {
		    key: 'connectDragSource',
		    value: function connectDragSource() {
		      return _noop2.default;
		    }
		  }, {
		    key: 'connectDragPreview',
		    value: function connectDragPreview() {
		      return _noop2.default;
		    }
		  }, {
		    key: 'connectDropTarget',
		    value: function connectDropTarget() {
		      return _noop2.default;
		    }
		  }, {
		    key: 'simulateBeginDrag',
		    value: function simulateBeginDrag(sourceIds, options) {
		      this.actions.beginDrag(sourceIds, options);
		    }
		  }, {
		    key: 'simulatePublishDragSource',
		    value: function simulatePublishDragSource() {
		      this.actions.publishDragSource();
		    }
		  }, {
		    key: 'simulateHover',
		    value: function simulateHover(targetIds, options) {
		      this.actions.hover(targetIds, options);
		    }
		  }, {
		    key: 'simulateDrop',
		    value: function simulateDrop() {
		      this.actions.drop();
		    }
		  }, {
		    key: 'simulateEndDrag',
		    value: function simulateEndDrag() {
		      this.actions.endDrag();
		    }
		  }]);
	
		  return TestBackend;
		}();
	
		function createBackend(manager) {
		  return new TestBackend(manager);
		}
	
	/***/ },
	/* 255 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _DragDropManager = __webpack_require__(249);
	
		Object.defineProperty(exports, 'DragDropManager', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragDropManager).default;
		  }
		});
	
		var _DragSource = __webpack_require__(251);
	
		Object.defineProperty(exports, 'DragSource', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DragSource).default;
		  }
		});
	
		var _DropTarget = __webpack_require__(252);
	
		Object.defineProperty(exports, 'DropTarget', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_DropTarget).default;
		  }
		});
	
		var _createTestBackend = __webpack_require__(254);
	
		Object.defineProperty(exports, 'createTestBackend', {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_createTestBackend).default;
		  }
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ },
	/* 256 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.default = dragOperation;
	
		var _without = __webpack_require__(122);
	
		var _without2 = _interopRequireDefault(_without);
	
		var _dragDrop = __webpack_require__(39);
	
		var _registry = __webpack_require__(40);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var initialState = {
		  itemType: null,
		  item: null,
		  sourceId: null,
		  targetIds: [],
		  dropResult: null,
		  didDrop: false,
		  isSourcePublic: null
		};
	
		function dragOperation() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		  var action = arguments[1];
	
		  switch (action.type) {
		    case _dragDrop.BEGIN_DRAG:
		      return _extends({}, state, {
		        itemType: action.itemType,
		        item: action.item,
		        sourceId: action.sourceId,
		        isSourcePublic: action.isSourcePublic,
		        dropResult: null,
		        didDrop: false
		      });
		    case _dragDrop.PUBLISH_DRAG_SOURCE:
		      return _extends({}, state, {
		        isSourcePublic: true
		      });
		    case _dragDrop.HOVER:
		      return _extends({}, state, {
		        targetIds: action.targetIds
		      });
		    case _registry.REMOVE_TARGET:
		      if (state.targetIds.indexOf(action.targetId) === -1) {
		        return state;
		      }
		      return _extends({}, state, {
		        targetIds: (0, _without2.default)(state.targetIds, action.targetId)
		      });
		    case _dragDrop.DROP:
		      return _extends({}, state, {
		        dropResult: action.dropResult,
		        didDrop: true,
		        targetIds: []
		      });
		    case _dragDrop.END_DRAG:
		      return _extends({}, state, {
		        itemType: null,
		        item: null,
		        sourceId: null,
		        dropResult: null,
		        didDrop: false,
		        isSourcePublic: null,
		        targetIds: []
		      });
		    default:
		      return state;
		  }
		}
	
	/***/ },
	/* 257 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = reduce;
	
		var _dragOffset = __webpack_require__(103);
	
		var _dragOffset2 = _interopRequireDefault(_dragOffset);
	
		var _dragOperation = __webpack_require__(256);
	
		var _dragOperation2 = _interopRequireDefault(_dragOperation);
	
		var _refCount = __webpack_require__(258);
	
		var _refCount2 = _interopRequireDefault(_refCount);
	
		var _dirtyHandlerIds = __webpack_require__(102);
	
		var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
	
		var _stateId = __webpack_require__(259);
	
		var _stateId2 = _interopRequireDefault(_stateId);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function reduce() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		  var action = arguments[1];
	
		  return {
		    dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
		    dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
		    refCount: (0, _refCount2.default)(state.refCount, action),
		    dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
		    stateId: (0, _stateId2.default)(state.stateId)
		  };
		}
	
	/***/ },
	/* 258 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = refCount;
	
		var _registry = __webpack_require__(40);
	
		function refCount() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		  var action = arguments[1];
	
		  switch (action.type) {
		    case _registry.ADD_SOURCE:
		    case _registry.ADD_TARGET:
		      return state + 1;
		    case _registry.REMOVE_SOURCE:
		    case _registry.REMOVE_TARGET:
		      return state - 1;
		    default:
		      return state;
		  }
		}
	
	/***/ },
	/* 259 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = stateId;
		function stateId() {
		  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
		  return state + 1;
		}
	
	/***/ },
	/* 260 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getNextUniqueId;
		var nextUniqueId = 0;
	
		function getNextUniqueId() {
		  return nextUniqueId++;
		}
	
	/***/ },
	/* 261 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = activeElement;
	
		var _ownerDocument = __webpack_require__(73);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function activeElement() {
		  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();
	
		  try {
		    return doc.activeElement;
		  } catch (e) {/* ie throws if no active element */}
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 262 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = addClass;
	
		var _hasClass = __webpack_require__(105);
	
		var _hasClass2 = _interopRequireDefault(_hasClass);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function addClass(element, className) {
		  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 263 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.hasClass = exports.removeClass = exports.addClass = undefined;
	
		var _addClass = __webpack_require__(262);
	
		var _addClass2 = _interopRequireDefault(_addClass);
	
		var _removeClass = __webpack_require__(264);
	
		var _removeClass2 = _interopRequireDefault(_removeClass);
	
		var _hasClass = __webpack_require__(105);
	
		var _hasClass2 = _interopRequireDefault(_hasClass);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.addClass = _addClass2.default;
		exports.removeClass = _removeClass2.default;
		exports.hasClass = _hasClass2.default;
		exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };
	
	/***/ },
	/* 264 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = function removeClass(element, className) {
		  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
		};
	
	/***/ },
	/* 265 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _inDOM = __webpack_require__(23);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var off = function off() {};
		if (_inDOM2.default) {
		  off = function () {
		    if (document.addEventListener) return function (node, eventName, handler, capture) {
		      return node.removeEventListener(eventName, handler, capture || false);
		    };else if (document.attachEvent) return function (node, eventName, handler) {
		      return node.detachEvent('on' + eventName, handler);
		    };
		  }();
		}
	
		exports.default = off;
		module.exports = exports['default'];
	
	/***/ },
	/* 266 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _inDOM = __webpack_require__(23);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var on = function on() {};
		if (_inDOM2.default) {
		  on = function () {
	
		    if (document.addEventListener) return function (node, eventName, handler, capture) {
		      return node.addEventListener(eventName, handler, capture || false);
		    };else if (document.attachEvent) return function (node, eventName, handler) {
		      return node.attachEvent('on' + eventName, function (e) {
		        e = e || window.event;
		        e.target = e.target || e.srcElement;
		        e.currentTarget = node;
		        handler.call(node, e);
		      });
		    };
		  }();
		}
	
		exports.default = on;
		module.exports = exports['default'];
	
	/***/ },
	/* 267 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _inDOM = __webpack_require__(23);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function () {
		  // HTML DOM and SVG DOM may have different support levels,
		  // so we need to check on context instead of a document root element.
		  return _inDOM2.default ? function (context, node) {
		    if (context.contains) {
		      return context.contains(node);
		    } else if (context.compareDocumentPosition) {
		      return context === node || !!(context.compareDocumentPosition(node) & 16);
		    } else {
		      return fallback(context, node);
		    }
		  } : fallback;
		}();
	
		function fallback(context, node) {
		  if (node) do {
		    if (node === context) return true;
		  } while (node = node.parentNode);
	
		  return false;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 268 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getWindow;
		function getWindow(node) {
		  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
		}
		module.exports = exports["default"];
	
	/***/ },
	/* 269 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = _getComputedStyle;
	
		var _camelizeStyle = __webpack_require__(106);
	
		var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var rposition = /^(top|right|bottom|left)$/;
		var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
		function _getComputedStyle(node) {
		  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
		  var doc = node.ownerDocument;
	
		  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
		    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
		    getPropertyValue: function getPropertyValue(prop) {
		      var style = node.style;
	
		      prop = (0, _camelizeStyle2.default)(prop);
	
		      if (prop == 'float') prop = 'styleFloat';
	
		      var current = node.currentStyle[prop] || null;
	
		      if (current == null && style && style[prop]) current = style[prop];
	
		      if (rnumnonpx.test(current) && !rposition.test(prop)) {
		        // Remember the original values
		        var left = style.left;
		        var runStyle = node.runtimeStyle;
		        var rsLeft = runStyle && runStyle.left;
	
		        // Put in the new values to get a computed value out
		        if (rsLeft) runStyle.left = node.currentStyle.left;
	
		        style.left = prop === 'fontSize' ? '1em' : current;
		        current = style.pixelLeft + 'px';
	
		        // Revert the changed values
		        style.left = left;
		        if (rsLeft) runStyle.left = rsLeft;
		      }
	
		      return current;
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 270 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = style;
	
		var _camelizeStyle = __webpack_require__(106);
	
		var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
		var _hyphenateStyle = __webpack_require__(276);
	
		var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);
	
		var _getComputedStyle2 = __webpack_require__(269);
	
		var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);
	
		var _removeStyle = __webpack_require__(271);
	
		var _removeStyle2 = _interopRequireDefault(_removeStyle);
	
		var _properties = __webpack_require__(273);
	
		var _isTransform = __webpack_require__(272);
	
		var _isTransform2 = _interopRequireDefault(_isTransform);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function style(node, property, value) {
		  var css = '';
		  var transforms = '';
		  var props = property;
	
		  if (typeof property === 'string') {
		    if (value === undefined) {
		      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
		    } else {
		      (props = {})[property] = value;
		    }
		  }
	
		  Object.keys(props).forEach(function (key) {
		    var value = props[key];
		    if (!value && value !== 0) {
		      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
		    } else if ((0, _isTransform2.default)(key)) {
		      transforms += key + '(' + value + ') ';
		    } else {
		      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
		    }
		  });
	
		  if (transforms) {
		    css += _properties.transform + ': ' + transforms + ';';
		  }
	
		  node.style.cssText += ';' + css;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 271 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = removeStyle;
		function removeStyle(node, key) {
		  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 272 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isTransform;
		var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
		function isTransform(property) {
		  return !!(property && supportedTransforms.test(property));
		}
		module.exports = exports["default"];
	
	/***/ },
	/* 273 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
		var _inDOM = __webpack_require__(23);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var transform = 'transform';
		var prefix = void 0,
		    transitionEnd = void 0,
		    animationEnd = void 0;
		var transitionProperty = void 0,
		    transitionDuration = void 0,
		    transitionTiming = void 0,
		    transitionDelay = void 0;
		var animationName = void 0,
		    animationDuration = void 0,
		    animationTiming = void 0,
		    animationDelay = void 0;
	
		if (_inDOM2.default) {
		  var _getTransitionPropert = getTransitionProperties();
	
		  prefix = _getTransitionPropert.prefix;
		  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
		  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
		  exports.transform = transform = prefix + '-' + transform;
		  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
		  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
		  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
		  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
		  exports.animationName = animationName = prefix + '-animation-name';
		  exports.animationDuration = animationDuration = prefix + '-animation-duration';
		  exports.animationTiming = animationTiming = prefix + '-animation-delay';
		  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
		}
	
		exports.transform = transform;
		exports.transitionProperty = transitionProperty;
		exports.transitionTiming = transitionTiming;
		exports.transitionDelay = transitionDelay;
		exports.transitionDuration = transitionDuration;
		exports.transitionEnd = transitionEnd;
		exports.animationName = animationName;
		exports.animationDuration = animationDuration;
		exports.animationTiming = animationTiming;
		exports.animationDelay = animationDelay;
		exports.animationEnd = animationEnd;
		exports.default = {
		  transform: transform,
		  end: transitionEnd,
		  property: transitionProperty,
		  timing: transitionTiming,
		  delay: transitionDelay,
		  duration: transitionDuration
		};
	
	
		function getTransitionProperties() {
		  var style = document.createElement('div').style;
	
		  var vendorMap = {
		    O: function O(e) {
		      return 'o' + e.toLowerCase();
		    },
		    Moz: function Moz(e) {
		      return e.toLowerCase();
		    },
		    Webkit: function Webkit(e) {
		      return 'webkit' + e;
		    },
		    ms: function ms(e) {
		      return 'MS' + e;
		    }
		  };
	
		  var vendors = Object.keys(vendorMap);
	
		  var transitionEnd = void 0,
		      animationEnd = void 0;
		  var prefix = '';
	
		  for (var i = 0; i < vendors.length; i++) {
		    var vendor = vendors[i];
	
		    if (vendor + 'TransitionProperty' in style) {
		      prefix = '-' + vendor.toLowerCase();
		      transitionEnd = vendorMap[vendor]('TransitionEnd');
		      animationEnd = vendorMap[vendor]('AnimationEnd');
		      break;
		    }
		  }
	
		  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
		  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
		  style = null;
	
		  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
		}
	
	/***/ },
	/* 274 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = camelize;
		var rHyphen = /-(.)/g;
	
		function camelize(string) {
		  return string.replace(rHyphen, function (_, chr) {
		    return chr.toUpperCase();
		  });
		}
		module.exports = exports["default"];
	
	/***/ },
	/* 275 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = hyphenate;
	
		var rUpper = /([A-Z])/g;
	
		function hyphenate(string) {
		  return string.replace(rUpper, '-$1').toLowerCase();
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 276 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = hyphenateStyleName;
	
		var _hyphenate = __webpack_require__(275);
	
		var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var msPattern = /^ms-/; /**
		                         * Copyright 2013-2014, Facebook, Inc.
		                         * All rights reserved.
		                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
		                         */
	
		function hyphenateStyleName(string) {
		  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 277 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		exports.default = function (recalc) {
		  if (!size || recalc) {
		    if (_inDOM2.default) {
		      var scrollDiv = document.createElement('div');
	
		      scrollDiv.style.position = 'absolute';
		      scrollDiv.style.top = '-9999px';
		      scrollDiv.style.width = '50px';
		      scrollDiv.style.height = '50px';
		      scrollDiv.style.overflow = 'scroll';
	
		      document.body.appendChild(scrollDiv);
		      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
		      document.body.removeChild(scrollDiv);
		    }
		  }
	
		  return size;
		};
	
		var _inDOM = __webpack_require__(23);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var size = void 0;
	
		module.exports = exports['default'];
	
	/***/ },
	/* 278 */
	/***/ function(module, exports) {
	
		/**
		 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
		 * Build: `lodash modern modularize exports="npm" -o ./`
		 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
		 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
		 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
		 * Available under MIT license <https://lodash.com/license>
		 */
	
		/**
		 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
		 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(1);
		 * // => false
		 */
		function isObject(value) {
		  // Avoid a V8 JIT bug in Chrome 19-20.
		  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}
	
		module.exports = isObject;
	
	
	/***/ },
	/* 279 */
	[1610, 307, 308, 309, 310, 311],
	/* 280 */
	[1616, 317, 318, 319, 320, 321],
	/* 281 */
	[1619, 44, 28],
	/* 282 */
	[1629, 44, 28],
	/* 283 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.filter` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {Array} Returns the new filtered array.
		 */
		function arrayFilter(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      resIndex = 0,
		      result = [];
	
		  while (++index < length) {
		    var value = array[index];
		    if (predicate(value, index, array)) {
		      result[resIndex++] = value;
		    }
		  }
		  return result;
		}
	
		module.exports = arrayFilter;
	
	
	/***/ },
	/* 284 */
	[1648, 296, 118, 19, 342, 115, 343],
	/* 285 */
	/***/ function(module, exports) {
	
		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;
	
		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}
	
		module.exports = arrayPush;
	
	
	/***/ },
	/* 286 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseAssignValue = __webpack_require__(109),
		    eq = __webpack_require__(46);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignValue(object, key, value) {
		  var objValue = object[key];
		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
		      (value === undefined && !(key in object))) {
		    baseAssignValue(object, key, value);
		  }
		}
	
		module.exports = assignValue;
	
	
	/***/ },
	/* 287 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.findIndex` and `_.findLastIndex` without
		 * support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {Function} predicate The function invoked per iteration.
		 * @param {number} fromIndex The index to search from.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function baseFindIndex(array, predicate, fromIndex, fromRight) {
		  var length = array.length,
		      index = fromIndex + (fromRight ? 1 : -1);
	
		  while ((fromRight ? index-- : ++index < length)) {
		    if (predicate(array[index], index, array)) {
		      return index;
		    }
		  }
		  return -1;
		}
	
		module.exports = baseFindIndex;
	
	
	/***/ },
	/* 288 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseFindIndex = __webpack_require__(287),
		    baseIsNaN = __webpack_require__(291),
		    strictIndexOf = __webpack_require__(336);
	
		/**
		 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} value The value to search for.
		 * @param {number} fromIndex The index to search from.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function baseIndexOf(array, value, fromIndex) {
		  return value === value
		    ? strictIndexOf(array, value, fromIndex)
		    : baseFindIndex(array, baseIsNaN, fromIndex);
		}
	
		module.exports = baseIndexOf;
	
	
	/***/ },
	/* 289 */
	/***/ function(module, exports, __webpack_require__) {
	
		var SetCache = __webpack_require__(75),
		    arrayIncludes = __webpack_require__(77),
		    arrayIncludesWith = __webpack_require__(78),
		    arrayMap = __webpack_require__(79),
		    baseUnary = __webpack_require__(80),
		    cacheHas = __webpack_require__(81);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMin = Math.min;
	
		/**
		 * The base implementation of methods like `_.intersection`, without support
		 * for iteratee shorthands, that accepts an array of arrays to inspect.
		 *
		 * @private
		 * @param {Array} arrays The arrays to inspect.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new array of shared values.
		 */
		function baseIntersection(arrays, iteratee, comparator) {
		  var includes = comparator ? arrayIncludesWith : arrayIncludes,
		      length = arrays[0].length,
		      othLength = arrays.length,
		      othIndex = othLength,
		      caches = Array(othLength),
		      maxLength = Infinity,
		      result = [];
	
		  while (othIndex--) {
		    var array = arrays[othIndex];
		    if (othIndex && iteratee) {
		      array = arrayMap(array, baseUnary(iteratee));
		    }
		    maxLength = nativeMin(array.length, maxLength);
		    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
		      ? new SetCache(othIndex && array)
		      : undefined;
		  }
		  array = arrays[0];
	
		  var index = -1,
		      seen = caches[0];
	
		  outer:
		  while (++index < length && result.length < maxLength) {
		    var value = array[index],
		        computed = iteratee ? iteratee(value) : value;
	
		    value = (comparator || value !== 0) ? value : 0;
		    if (!(seen
		          ? cacheHas(seen, computed)
		          : includes(result, computed, comparator)
		        )) {
		      othIndex = othLength;
		      while (--othIndex) {
		        var cache = caches[othIndex];
		        if (!(cache
		              ? cacheHas(cache, computed)
		              : includes(arrays[othIndex], computed, comparator))
		            ) {
		          continue outer;
		        }
		      }
		      if (seen) {
		        seen.push(computed);
		      }
		      result.push(value);
		    }
		  }
		  return result;
		}
	
		module.exports = baseIntersection;
	
	
	/***/ },
	/* 290 */
	[1667, 42, 30],
	/* 291 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.isNaN` without support for number objects.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
		 */
		function baseIsNaN(value) {
		  return value !== value;
		}
	
		module.exports = baseIsNaN;
	
	
	/***/ },
	/* 292 */
	[1672, 119, 315, 29, 337],
	/* 293 */
	[1675, 42, 120, 30],
	/* 294 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(29),
		    isPrototype = __webpack_require__(316),
		    nativeKeysIn = __webpack_require__(327);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeysIn(object) {
		  if (!isObject(object)) {
		    return nativeKeysIn(object);
		  }
		  var isProto = isPrototype(object),
		      result = [];
	
		  for (var key in object) {
		    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = baseKeysIn;
	
	
	/***/ },
	/* 295 */
	/***/ function(module, exports, __webpack_require__) {
	
		var constant = __webpack_require__(339),
		    defineProperty = __webpack_require__(113),
		    identity = __webpack_require__(117);
	
		/**
		 * The base implementation of `setToString` without support for hot loop shorting.
		 *
		 * @private
		 * @param {Function} func The function to modify.
		 * @param {Function} string The `toString` result.
		 * @returns {Function} Returns `func`.
		 */
		var baseSetToString = !defineProperty ? identity : function(func, string) {
		  return defineProperty(func, 'toString', {
		    'configurable': true,
		    'enumerable': false,
		    'value': constant(string),
		    'writable': true
		  });
		};
	
		module.exports = baseSetToString;
	
	
	/***/ },
	/* 296 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);
	
		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}
	
		module.exports = baseTimes;
	
	
	/***/ },
	/* 297 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseDifference = __webpack_require__(110),
		    baseFlatten = __webpack_require__(111),
		    baseUniq = __webpack_require__(112);
	
		/**
		 * The base implementation of methods like `_.xor`, without support for
		 * iteratee shorthands, that accepts an array of arrays to inspect.
		 *
		 * @private
		 * @param {Array} arrays The arrays to inspect.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new array of values.
		 */
		function baseXor(arrays, iteratee, comparator) {
		  var length = arrays.length;
		  if (length < 2) {
		    return length ? baseUniq(arrays[0]) : [];
		  }
		  var index = -1,
		      result = Array(length);
	
		  while (++index < length) {
		    var array = arrays[index],
		        othIndex = -1;
	
		    while (++othIndex < length) {
		      if (othIndex != index) {
		        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
		      }
		    }
		  }
		  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
		}
	
		module.exports = baseXor;
	
	
	/***/ },
	/* 298 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLikeObject = __webpack_require__(47);
	
		/**
		 * Casts `value` to an empty array if it's not an array like object.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {Array|Object} Returns the cast array-like object.
		 */
		function castArrayLikeObject(value) {
		  return isArrayLikeObject(value) ? value : [];
		}
	
		module.exports = castArrayLikeObject;
	
	
	/***/ },
	/* 299 */
	/***/ function(module, exports, __webpack_require__) {
	
		var assignValue = __webpack_require__(286),
		    baseAssignValue = __webpack_require__(109);
	
		/**
		 * Copies properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy properties from.
		 * @param {Array} props The property identifiers to copy.
		 * @param {Object} [object={}] The object to copy properties to.
		 * @param {Function} [customizer] The function to customize copied values.
		 * @returns {Object} Returns `object`.
		 */
		function copyObject(source, props, object, customizer) {
		  var isNew = !object;
		  object || (object = {});
	
		  var index = -1,
		      length = props.length;
	
		  while (++index < length) {
		    var key = props[index];
	
		    var newValue = customizer
		      ? customizer(object[key], source[key], key, object, source)
		      : undefined;
	
		    if (newValue === undefined) {
		      newValue = source[key];
		    }
		    if (isNew) {
		      baseAssignValue(object, key, newValue);
		    } else {
		      assignValue(object, key, newValue);
		    }
		  }
		  return object;
		}
	
		module.exports = copyObject;
	
	
	/***/ },
	/* 300 */
	[1680, 28],
	/* 301 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseRest = __webpack_require__(25),
		    isIterateeCall = __webpack_require__(313);
	
		/**
		 * Creates a function like `_.assign`.
		 *
		 * @private
		 * @param {Function} assigner The function to assign values.
		 * @returns {Function} Returns the new assigner function.
		 */
		function createAssigner(assigner) {
		  return baseRest(function(object, sources) {
		    var index = -1,
		        length = sources.length,
		        customizer = length > 1 ? sources[length - 1] : undefined,
		        guard = length > 2 ? sources[2] : undefined;
	
		    customizer = (assigner.length > 3 && typeof customizer == 'function')
		      ? (length--, customizer)
		      : undefined;
	
		    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
		      customizer = length < 3 ? undefined : customizer;
		      length = 1;
		    }
		    object = Object(object);
		    while (++index < length) {
		      var source = sources[index];
		      if (source) {
		        assigner(object, source, index, customizer);
		      }
		    }
		    return object;
		  });
		}
	
		module.exports = createAssigner;
	
	
	/***/ },
	/* 302 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Set = __webpack_require__(282),
		    noop = __webpack_require__(121),
		    setToArray = __webpack_require__(116);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/**
		 * Creates a set object of `values`.
		 *
		 * @private
		 * @param {Array} values The values to add to the set.
		 * @returns {Object} Returns the new set.
		 */
		var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
		  return new Set(values);
		};
	
		module.exports = createSet;
	
	
	/***/ },
	/* 303 */
	/***/ function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(46);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
		 * of source objects to the destination object for all destination properties
		 * that resolve to `undefined`.
		 *
		 * @private
		 * @param {*} objValue The destination value.
		 * @param {*} srcValue The source value.
		 * @param {string} key The key of the property to assign.
		 * @param {Object} object The parent object of `objValue`.
		 * @returns {*} Returns the value to assign.
		 */
		function customDefaultsAssignIn(objValue, srcValue, key, object) {
		  if (objValue === undefined ||
		      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
		    return srcValue;
		  }
		  return objValue;
		}
	
		module.exports = customDefaultsAssignIn;
	
	
	/***/ },
	/* 304 */
	/***/ function(module, exports, __webpack_require__) {
	
		var overArg = __webpack_require__(330);
	
		/** Built-in value references. */
		var getPrototype = overArg(Object.getPrototypeOf, Object);
	
		module.exports = getPrototype;
	
	
	/***/ },
	/* 305 */
	[1700, 76],
	/* 306 */
	/***/ function(module, exports) {
	
		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}
	
		module.exports = getValue;
	
	
	/***/ },
	/* 307 */
	[1704, 45],
	/* 308 */
	/***/ function(module, exports) {
	
		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  var result = this.has(key) && delete this.__data__[key];
		  this.size -= result ? 1 : 0;
		  return result;
		}
	
		module.exports = hashDelete;
	
	
	/***/ },
	/* 309 */
	[1709, 45],
	/* 310 */
	[1714, 45],
	/* 311 */
	[1721, 45],
	/* 312 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(76),
		    isArguments = __webpack_require__(118),
		    isArray = __webpack_require__(19);
	
		/** Built-in value references. */
		var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
		/**
		 * Checks if `value` is a flattenable `arguments` object or array.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
		 */
		function isFlattenable(value) {
		  return isArray(value) || isArguments(value) ||
		    !!(spreadableSymbol && value && value[spreadableSymbol]);
		}
	
		module.exports = isFlattenable;
	
	
	/***/ },
	/* 313 */
	/***/ function(module, exports, __webpack_require__) {
	
		var eq = __webpack_require__(46),
		    isArrayLike = __webpack_require__(82),
		    isIndex = __webpack_require__(115),
		    isObject = __webpack_require__(29);
	
		/**
		 * Checks if the given arguments are from an iteratee call.
		 *
		 * @private
		 * @param {*} value The potential iteratee value argument.
		 * @param {*} index The potential iteratee index or key argument.
		 * @param {*} object The potential iteratee object argument.
		 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
		 *  else `false`.
		 */
		function isIterateeCall(value, index, object) {
		  if (!isObject(object)) {
		    return false;
		  }
		  var type = typeof index;
		  if (type == 'number'
		        ? (isArrayLike(object) && isIndex(index, object.length))
		        : (type == 'string' && index in object)
		      ) {
		    return eq(object[index], value);
		  }
		  return false;
		}
	
		module.exports = isIterateeCall;
	
	
	/***/ },
	/* 314 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}
	
		module.exports = isKeyable;
	
	
	/***/ },
	/* 315 */
	[1725, 300],
	/* 316 */
	/***/ function(module, exports) {
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
		  return value === proto;
		}
	
		module.exports = isPrototype;
	
	
	/***/ },
	/* 317 */
	/***/ function(module, exports) {
	
		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		  this.size = 0;
		}
	
		module.exports = listCacheClear;
	
	
	/***/ },
	/* 318 */
	[1732, 41],
	/* 319 */
	[1736, 41],
	/* 320 */
	[1742, 41],
	/* 321 */
	[1744, 41],
	/* 322 */
	[1749, 279, 280, 281],
	/* 323 */
	[1757, 43],
	/* 324 */
	[1761, 43],
	/* 325 */
	[1767, 43],
	/* 326 */
	[1772, 43],
	/* 327 */
	/***/ function(module, exports) {
	
		/**
		 * This function is like
		 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * except that it includes inherited enumerable properties.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function nativeKeysIn(object) {
		  var result = [];
		  if (object != null) {
		    for (var key in Object(object)) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = nativeKeysIn;
	
	
	/***/ },
	/* 328 */
	[1779, 114],
	/* 329 */
	/***/ function(module, exports) {
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;
	
		/**
		 * Converts `value` to a string using `Object.prototype.toString`.
		 *
		 * @private
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 */
		function objectToString(value) {
		  return nativeObjectToString.call(value);
		}
	
		module.exports = objectToString;
	
	
	/***/ },
	/* 330 */
	/***/ function(module, exports) {
	
		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}
	
		module.exports = overArg;
	
	
	/***/ },
	/* 331 */
	/***/ function(module, exports, __webpack_require__) {
	
		var apply = __webpack_require__(108);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max;
	
		/**
		 * A specialized version of `baseRest` which transforms the rest array.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @param {Function} transform The rest array transform.
		 * @returns {Function} Returns the new function.
		 */
		function overRest(func, start, transform) {
		  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
		  return function() {
		    var args = arguments,
		        index = -1,
		        length = nativeMax(args.length - start, 0),
		        array = Array(length);
	
		    while (++index < length) {
		      array[index] = args[start + index];
		    }
		    index = -1;
		    var otherArgs = Array(start + 1);
		    while (++index < start) {
		      otherArgs[index] = args[index];
		    }
		    otherArgs[start] = transform(array);
		    return apply(func, this, otherArgs);
		  };
		}
	
		module.exports = overRest;
	
	
	/***/ },
	/* 332 */
	/***/ function(module, exports) {
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */
		function setCacheAdd(value) {
		  this.__data__.set(value, HASH_UNDEFINED);
		  return this;
		}
	
		module.exports = setCacheAdd;
	
	
	/***/ },
	/* 333 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */
		function setCacheHas(value) {
		  return this.__data__.has(value);
		}
	
		module.exports = setCacheHas;
	
	
	/***/ },
	/* 334 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseSetToString = __webpack_require__(295),
		    shortOut = __webpack_require__(335);
	
		/**
		 * Sets the `toString` method of `func` to return `string`.
		 *
		 * @private
		 * @param {Function} func The function to modify.
		 * @param {Function} string The `toString` result.
		 * @returns {Function} Returns `func`.
		 */
		var setToString = shortOut(baseSetToString);
	
		module.exports = setToString;
	
	
	/***/ },
	/* 335 */
	/***/ function(module, exports) {
	
		/** Used to detect hot functions by number of calls within a span of milliseconds. */
		var HOT_COUNT = 800,
		    HOT_SPAN = 16;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeNow = Date.now;
	
		/**
		 * Creates a function that'll short out and invoke `identity` instead
		 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
		 * milliseconds.
		 *
		 * @private
		 * @param {Function} func The function to restrict.
		 * @returns {Function} Returns the new shortable function.
		 */
		function shortOut(func) {
		  var count = 0,
		      lastCalled = 0;
	
		  return function() {
		    var stamp = nativeNow(),
		        remaining = HOT_SPAN - (stamp - lastCalled);
	
		    lastCalled = stamp;
		    if (remaining > 0) {
		      if (++count >= HOT_COUNT) {
		        return arguments[0];
		      }
		    } else {
		      count = 0;
		    }
		    return func.apply(undefined, arguments);
		  };
		}
	
		module.exports = shortOut;
	
	
	/***/ },
	/* 336 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.indexOf` which performs strict equality
		 * comparisons of values, i.e. `===`.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} value The value to search for.
		 * @param {number} fromIndex The index to search from.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function strictIndexOf(array, value, fromIndex) {
		  var index = fromIndex - 1,
		      length = array.length;
	
		  while (++index < length) {
		    if (array[index] === value) {
		      return index;
		    }
		  }
		  return -1;
		}
	
		module.exports = strictIndexOf;
	
	
	/***/ },
	/* 337 */
	153,
	/* 338 */
	/***/ function(module, exports, __webpack_require__) {
	
		var copyObject = __webpack_require__(299),
		    createAssigner = __webpack_require__(301),
		    keysIn = __webpack_require__(344);
	
		/**
		 * This method is like `_.assignIn` except that it accepts `customizer`
		 * which is invoked to produce the assigned values. If `customizer` returns
		 * `undefined`, assignment is handled by the method instead. The `customizer`
		 * is invoked with five arguments: (objValue, srcValue, key, object, source).
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @alias extendWith
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} sources The source objects.
		 * @param {Function} [customizer] The function to customize assigned values.
		 * @returns {Object} Returns `object`.
		 * @see _.assignWith
		 * @example
		 *
		 * function customizer(objValue, srcValue) {
		 *   return _.isUndefined(objValue) ? srcValue : objValue;
		 * }
		 *
		 * var defaults = _.partialRight(_.assignInWith, customizer);
		 *
		 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
		 * // => { 'a': 1, 'b': 2 }
		 */
		var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
		  copyObject(source, keysIn(source), object, customizer);
		});
	
		module.exports = assignInWith;
	
	
	/***/ },
	/* 339 */
	/***/ function(module, exports) {
	
		/**
		 * Creates a function that returns `value`.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {*} value The value to return from the new function.
		 * @returns {Function} Returns the new constant function.
		 * @example
		 *
		 * var objects = _.times(2, _.constant({ 'a': 1 }));
		 *
		 * console.log(objects);
		 * // => [{ 'a': 1 }, { 'a': 1 }]
		 *
		 * console.log(objects[0] === objects[1]);
		 * // => true
		 */
		function constant(value) {
		  return function() {
		    return value;
		  };
		}
	
		module.exports = constant;
	
	
	/***/ },
	/* 340 */
	/***/ function(module, exports, __webpack_require__) {
	
		var apply = __webpack_require__(108),
		    assignInWith = __webpack_require__(338),
		    baseRest = __webpack_require__(25),
		    customDefaultsAssignIn = __webpack_require__(303);
	
		/**
		 * Assigns own and inherited enumerable string keyed properties of source
		 * objects to the destination object for all destination properties that
		 * resolve to `undefined`. Source objects are applied from left to right.
		 * Once a property is set, additional values of the same property are ignored.
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @see _.defaultsDeep
		 * @example
		 *
		 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
		 * // => { 'a': 1, 'b': 2 }
		 */
		var defaults = baseRest(function(args) {
		  args.push(undefined, customDefaultsAssignIn);
		  return apply(assignInWith, undefined, args);
		});
	
		module.exports = defaults;
	
	
	/***/ },
	/* 341 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayMap = __webpack_require__(79),
		    baseIntersection = __webpack_require__(289),
		    baseRest = __webpack_require__(25),
		    castArrayLikeObject = __webpack_require__(298);
	
		/**
		 * Creates an array of unique values that are included in all given arrays
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons. The order and references of result values are
		 * determined by the first array.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Array
		 * @param {...Array} [arrays] The arrays to inspect.
		 * @returns {Array} Returns the new array of intersecting values.
		 * @example
		 *
		 * _.intersection([2, 1], [2, 3]);
		 * // => [2]
		 */
		var intersection = baseRest(function(arrays) {
		  var mapped = arrayMap(arrays, castArrayLikeObject);
		  return (mapped.length && mapped[0] === arrays[0])
		    ? baseIntersection(mapped)
		    : [];
		});
	
		module.exports = intersection;
	
	
	/***/ },
	/* 342 */
	[1801, 28, 346],
	/* 343 */
	[1810, 293, 80, 328],
	/* 344 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayLikeKeys = __webpack_require__(284),
		    baseKeysIn = __webpack_require__(294),
		    isArrayLike = __webpack_require__(82);
	
		/**
		 * Creates an array of the own and inherited enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keysIn(new Foo);
		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
		 */
		function keysIn(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
		}
	
		module.exports = keysIn;
	
	
	/***/ },
	/* 345 */
	[1818, 107],
	/* 346 */
	/***/ function(module, exports) {
	
		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}
	
		module.exports = stubFalse;
	
	
	/***/ },
	/* 347 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseFlatten = __webpack_require__(111),
		    baseRest = __webpack_require__(25),
		    baseUniq = __webpack_require__(112),
		    isArrayLikeObject = __webpack_require__(47);
	
		/**
		 * Creates an array of unique values, in order, from all given arrays using
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Array
		 * @param {...Array} [arrays] The arrays to inspect.
		 * @returns {Array} Returns the new array of combined values.
		 * @example
		 *
		 * _.union([2], [1, 2]);
		 * // => [2, 1]
		 */
		var union = baseRest(function(arrays) {
		  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
		});
	
		module.exports = union;
	
	
	/***/ },
	/* 348 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayFilter = __webpack_require__(283),
		    baseRest = __webpack_require__(25),
		    baseXor = __webpack_require__(297),
		    isArrayLikeObject = __webpack_require__(47);
	
		/**
		 * Creates an array of unique values that is the
		 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
		 * of the given arrays. The order of result values is determined by the order
		 * they occur in the arrays.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Array
		 * @param {...Array} [arrays] The arrays to inspect.
		 * @returns {Array} Returns the new array of filtered values.
		 * @see _.difference, _.without
		 * @example
		 *
		 * _.xor([2, 1], [2, 3]);
		 * // => [1, 3]
		 */
		var xor = baseRest(function(arrays) {
		  return baseXor(arrayFilter(arrays, isArrayLikeObject));
		});
	
		module.exports = xor;
	
	
	/***/ },
	/* 349 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.default = function (Component) {
		    var displayName = Component.displayName || Component.name || "Component";
	
		    return _react2.default.createClass({
		        displayName: "ContextMenuConnector(" + displayName + ")",
		        getInitialState: function getInitialState() {
		            return {
		                item: _store2.default.getState().currentItem
		            };
		        },
		        componentDidMount: function componentDidMount() {
		            this.unsubscribe = _store2.default.subscribe(this.handleUpdate);
		        },
		        componentWillUnmount: function componentWillUnmount() {
		            this.unsubscribe();
		        },
		        handleUpdate: function handleUpdate() {
		            this.setState(this.getInitialState());
		        },
		        render: function render() {
		            return _react2.default.createElement(Component, _extends({}, this.props, { item: this.state.item }));
		        }
		    });
		};
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _store = __webpack_require__(48);
	
		var _store2 = _interopRequireDefault(_store);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ },
	/* 350 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _store = __webpack_require__(48);
	
		var _store2 = _interopRequireDefault(_store);
	
		var _wrapper = __webpack_require__(351);
	
		var _wrapper2 = _interopRequireDefault(_wrapper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var PropTypes = _react2.default.PropTypes;
	
	
		var ContextMenu = _react2.default.createClass({
		    displayName: "ContextMenu",
		    propTypes: {
		        identifier: PropTypes.string.isRequired
		    },
		    getInitialState: function getInitialState() {
		        return _store2.default.getState();
		    },
		    componentDidMount: function componentDidMount() {
		        this.unsubscribe = _store2.default.subscribe(this.handleUpdate);
		    },
		    componentWillUnmount: function componentWillUnmount() {
		        if (this.unsubscribe) this.unsubscribe();
		    },
		    handleUpdate: function handleUpdate() {
		        this.setState(this.getInitialState());
		    },
		    render: function render() {
		        return _react2.default.createElement(_wrapper2.default, _extends({}, this.props, this.state));
		    }
		});
	
		exports.default = ContextMenu;
	
	/***/ },
	/* 351 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _monitor = __webpack_require__(83);
	
		var _monitor2 = _interopRequireDefault(_monitor);
	
		var _Modal = __webpack_require__(378);
	
		var _Modal2 = _interopRequireDefault(_Modal);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var modalStyle = {
		    position: "fixed",
		    zIndex: 1040,
		    top: 0,
		    bottom: 0,
		    left: 0,
		    right: 0
		},
		    backdropStyle = _extends({}, modalStyle, {
		    zIndex: "auto",
		    backgroundColor: "transparent"
		}),
		    menuStyles = {
		    position: "fixed",
		    zIndex: "auto"
		};
	
		var ContextMenuWrapper = _react2.default.createClass({
		    displayName: "ContextMenuWrapper",
		    getInitialState: function getInitialState() {
		        return {
		            left: 0,
		            top: 0
		        };
		    },
		    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		        var _this = this;
	
		        if (nextProps.isVisible === nextProps.identifier) {
		            var wrapper = window.requestAnimationFrame || setTimeout;
	
		            wrapper(function () {
		                _this.setState(_this.getMenuPosition(nextProps.x, nextProps.y));
		                _this.menu.parentNode.addEventListener("contextmenu", _this.hideMenu);
		            });
		        }
		    },
		    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		        return this.props.isVisible !== nextProps.visible;
		    },
		    hideMenu: function hideMenu(e) {
		        e.preventDefault();
		        this.menu.parentNode.removeEventListener("contextmenu", this.hideMenu);
		        _monitor2.default.hideMenu();
		    },
		    getMenuPosition: function getMenuPosition(x, y) {
		        var scrollX = document.documentElement.scrollTop;
		        var scrollY = document.documentElement.scrollLeft;
		        var _window = window;
		        var innerWidth = _window.innerWidth;
		        var innerHeight = _window.innerHeight;
		        var rect = this.menu.getBoundingClientRect();
		        var menuStyles = {
		            top: y + scrollY,
		            left: x + scrollX
		        };
	
		        if (y + rect.height > innerHeight) {
		            menuStyles.top -= rect.height;
		        }
	
		        if (x + rect.width > innerWidth) {
		            menuStyles.left -= rect.width;
		        }
	
		        return menuStyles;
		    },
		    render: function render() {
		        var _this2 = this;
	
		        var _props = this.props;
		        var isVisible = _props.isVisible;
		        var identifier = _props.identifier;
		        var children = _props.children;
	
	
		        var style = _extends({}, menuStyles, this.state);
	
		        return _react2.default.createElement(
		            _Modal2.default,
		            { style: modalStyle, backdropStyle: backdropStyle,
		                show: isVisible === identifier, onHide: function onHide() {
		                    return _monitor2.default.hideMenu();
		                } },
		            _react2.default.createElement(
		                "nav",
		                { ref: function ref(c) {
		                        return _this2.menu = c;
		                    }, style: style,
		                    className: "react-context-menu" },
		                children
		            )
		        );
		    }
		});
	
		exports.default = ContextMenuWrapper;
	
	/***/ },
	/* 352 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		exports.default = function (identifier, configure) {
		    return function (Component) {
		        var displayName = Component.displayName || Component.name || "Component";
	
		        (0, _invariant2.default)(identifier && (typeof identifier === "string" || (typeof identifier === "undefined" ? "undefined" : _typeof(identifier)) === "symbol" || typeof identifier === "function"), "Expected identifier to be string, symbol or function. See %s", displayName);
	
		        if (configure) {
		            (0, _invariant2.default)(typeof configure === "function", "Expected configure to be a function. See %s", displayName);
		        }
	
		        return _react2.default.createClass({
		            displayName: displayName + "ContextMenuLayer",
		            getDefaultProps: function getDefaultProps() {
		                return {
		                    renderTag: "div",
		                    attributes: {}
		                };
		            },
	
		            mouseDown: false,
		            handleMouseDown: function handleMouseDown(event) {
		                var _this = this;
	
		                if (this.props.holdToDisplay >= 0 && event.button === 0) {
		                    event.persist();
	
		                    this.mouseDown = true;
		                    setTimeout(function () {
		                        if (_this.mouseDown) _this.handleContextClick(event);
		                    }, this.props.holdToDisplay);
		                }
		            },
		            handleTouchstart: function handleTouchstart(event) {
		                var _this2 = this;
	
		                event.persist();
	
		                this.mouseDown = true;
		                setTimeout(function () {
		                    if (_this2.mouseDown) _this2.handleContextClick(event);
		                }, this.props.holdToDisplay);
		            },
		            handleTouchEnd: function handleTouchEnd(event) {
		                event.preventDefault();
		                this.mouseDown = false;
		            },
		            handleMouseUp: function handleMouseUp(event) {
		                if (event.button === 0) {
		                    this.mouseDown = false;
		                }
		            },
		            handleContextClick: function handleContextClick(event) {
		                var currentItem = typeof configure === "function" ? configure(this.props) : {};
	
		                (0, _invariant2.default)((0, _lodash2.default)(currentItem), "Expected configure to return an object. See %s", displayName);
	
		                event.preventDefault();
	
		                var xPos = event.clientX || event.touches && event.touches[0].pageX,
		                    yPos = event.clientY || event.touches && event.touches[0].pageY;
	
		                _store2.default.dispatch({
		                    type: "SET_PARAMS",
		                    data: {
		                        x: xPos,
		                        y: yPos,
		                        currentItem: currentItem,
		                        isVisible: typeof identifier === "function" ? identifier(this.props) : identifier
		                    }
		                });
		            },
		            render: function render() {
		                var _props = this.props;
		                var _props$attributes = _props.attributes;
		                var _props$attributes$cla = _props$attributes.className;
		                var className = _props$attributes$cla === undefined ? "" : _props$attributes$cla;
	
		                var attributes = _objectWithoutProperties(_props$attributes, ["className"]);
	
		                var renderTag = _props.renderTag;
	
		                var props = _objectWithoutProperties(_props, ["attributes", "renderTag"]);
	
		                attributes.className = "react-context-menu-wrapper " + className;
		                attributes.onContextMenu = this.handleContextClick;
		                attributes.onMouseDown = this.handleMouseDown;
		                attributes.onMouseUp = this.handleMouseUp;
		                attributes.onTouchStart = this.handleTouchstart;
		                attributes.onTouchEnd = this.handleTouchEnd;
		                attributes.onMouseOut = this.handleMouseUp;
	
		                return _react2.default.createElement(renderTag, attributes, _react2.default.createElement(Component, props));
		            }
		        });
		    };
		};
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _lodash = __webpack_require__(278);
	
		var _lodash2 = _interopRequireDefault(_lodash);
	
		var _store = __webpack_require__(48);
	
		var _store2 = _interopRequireDefault(_store);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/***/ },
	/* 353 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(124);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _objectAssign = __webpack_require__(125);
	
		var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
		var _monitor = __webpack_require__(83);
	
		var _monitor2 = _interopRequireDefault(_monitor);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		var PropTypes = _react2.default.PropTypes;
	
	
		var MenuItem = _react2.default.createClass({
		    displayName: "MenuItem",
		    propTypes: {
		        onClick: PropTypes.func.isRequired,
		        data: PropTypes.object,
		        disabled: PropTypes.bool,
		        preventClose: PropTypes.bool
		    },
		    getDefaultProps: function getDefaultProps() {
		        return {
		            disabled: false,
		            data: {},
		            attributes: {}
		        };
		    },
		    handleClick: function handleClick(event) {
		        var _props = this.props;
		        var disabled = _props.disabled;
		        var onClick = _props.onClick;
		        var data = _props.data;
		        var preventClose = _props.preventClose;
	
	
		        event.preventDefault();
	
		        if (disabled) return;
	
		        (0, _objectAssign2.default)(data, _monitor2.default.getItem());
	
		        if (typeof onClick === "function") {
		            onClick(event, data);
		        }
	
		        if (preventClose) return;
	
		        _monitor2.default.hideMenu();
		    },
		    render: function render() {
		        var _props2 = this.props;
		        var disabled = _props2.disabled;
		        var children = _props2.children;
		        var _props2$attributes = _props2.attributes;
		        var _props2$attributes$cl = _props2$attributes.className;
		        var className = _props2$attributes$cl === undefined ? "" : _props2$attributes$cl;
		        var props = _objectWithoutProperties(_props2$attributes, ["className"]);
		        var menuItemClassNames = "react-context-menu-item " + className;
	
		        var classes = (0, _classnames2.default)({
		            "react-context-menu-link": true,
		            disabled: disabled
		        });
	
		        return _react2.default.createElement(
		            "div",
		            _extends({ className: menuItemClassNames }, props),
		            _react2.default.createElement(
		                "a",
		                { href: "#", className: classes, onClick: this.handleClick },
		                children
		            )
		        );
		    }
		});
	
		exports.default = MenuItem;
	
	/***/ },
	/* 354 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		exports.default = function () {
		    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
		    var action = arguments[1];
	
		    return action.type === "SET_PARAMS" ? (0, _objectAssign2.default)({}, state, action.data) : state;
		};
	
		var _objectAssign = __webpack_require__(125);
	
		var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var defaultState = {
		    x: 0,
		    y: 0,
		    isVisible: false,
		    currentItem: {}
		};
	
	/***/ },
	/* 355 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(124);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _wrapper = __webpack_require__(356);
	
		var _wrapper2 = _interopRequireDefault(_wrapper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var menuStyles = {
		    position: "relative",
		    zIndex: "auto"
		};
	
		var SubMenu = _react2.default.createClass({
		    displayName: "SubMenu",
		    propTypes: {
		        title: _react2.default.PropTypes.string.isRequired,
		        disabled: _react2.default.PropTypes.bool,
		        hoverDelay: _react2.default.PropTypes.number
		    },
		    getDefaultProps: function getDefaultProps() {
		        return {
		            hoverDelay: 500
		        };
		    },
		    getInitialState: function getInitialState() {
		        return {
		            visible: false
		        };
		    },
		    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		        return this.state.isVisible !== nextState.visible;
		    },
		    componentWillUnmount: function componentWillUnmount() {
		        if (this.opentimer) clearTimeout(this.opentimer);
	
		        if (this.closetimer) clearTimeout(this.closetimer);
		    },
		    handleClick: function handleClick(e) {
		        e.preventDefault();
		    },
		    handleMouseEnter: function handleMouseEnter() {
		        var _this = this;
	
		        if (this.closetimer) clearTimeout(this.closetimer);
	
		        if (this.props.disabled || this.state.visible) return;
	
		        this.opentimer = setTimeout(function () {
		            return _this.setState({ visible: true });
		        }, this.props.hoverDelay);
		    },
		    handleMouseLeave: function handleMouseLeave() {
		        var _this2 = this;
	
		        if (this.opentimer) clearTimeout(this.opentimer);
	
		        if (!this.state.visible) return;
	
		        this.closetimer = setTimeout(function () {
		            return _this2.setState({ visible: false });
		        }, this.props.hoverDelay);
		    },
		    render: function render() {
		        var _this3 = this;
	
		        var _props = this.props;
		        var disabled = _props.disabled;
		        var children = _props.children;
		        var title = _props.title;
		        var visible = this.state.visible;
	
	
		        var classes = (0, _classnames2.default)({
		            "react-context-menu-link": true,
		            disabled: disabled,
		            active: visible
		        }),
		            menuClasses = "react-context-menu-item submenu";
	
		        return _react2.default.createElement(
		            "div",
		            { ref: function ref(c) {
		                    return _this3.item = c;
		                }, className: menuClasses, style: menuStyles,
		                onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
		            _react2.default.createElement(
		                "a",
		                { href: "#", className: classes, onClick: this.handleClick },
		                title
		            ),
		            _react2.default.createElement(
		                _wrapper2.default,
		                { visible: visible },
		                children
		            )
		        );
		    }
		});
	
		exports.default = SubMenu;
	
	/***/ },
	/* 356 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var SubMenuWrapper = _react2.default.createClass({
		    displayName: "SubMenuWrapper",
		    propTypes: {
		        visible: _react2.default.PropTypes.bool
		    },
		    getInitialState: function getInitialState() {
		        return {
		            position: {
		                top: true,
		                right: true
		            }
		        };
		    },
		    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		        var _this = this;
	
		        if (nextProps.visible) {
		            var wrapper = window.requestAnimationFrame || setTimeout;
	
		            wrapper(function () {
		                _this.setState(_this.getMenuPosition());
		                _this.forceUpdate();
		            });
		        } else {
		            this.setState(this.getInitialState());
		        }
		    },
		    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		        return this.props.visible !== nextProps.visible;
		    },
		    getMenuPosition: function getMenuPosition() {
		        var _window = window;
		        var innerWidth = _window.innerWidth;
		        var innerHeight = _window.innerHeight;
		        var rect = this.menu.getBoundingClientRect();
		        var position = {};
	
		        if (rect.bottom > innerHeight) {
		            position.bottom = true;
		        } else {
		            position.top = true;
		        }
	
		        if (rect.right > innerWidth) {
		            position.left = true;
		        } else {
		            position.right = true;
		        }
	
		        return { position: position };
		    },
		    getPositionStyles: function getPositionStyles() {
		        var style = {};
		        var position = this.state.position;
	
	
		        if (position.top) style.top = 0;
		        if (position.bottom) style.bottom = 0;
		        if (position.right) style.left = "100%";
		        if (position.left) style.right = "100%";
	
		        return style;
		    },
		    render: function render() {
		        var _this2 = this;
	
		        var _props = this.props;
		        var children = _props.children;
		        var visible = _props.visible;
	
	
		        var style = _extends({
		            display: visible ? "block" : "none",
		            position: "absolute"
		        }, this.getPositionStyles());
	
		        return _react2.default.createElement(
		            "nav",
		            { ref: function ref(c) {
		                    return _this2.menu = c;
		                }, style: style, className: "react-context-menu" },
		            children
		        );
		    }
		});
	
		exports.default = SubMenuWrapper;
	
	/***/ },
	/* 357 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _union = __webpack_require__(347);
	
		var _union2 = _interopRequireDefault(_union);
	
		var _without = __webpack_require__(122);
	
		var _without2 = _interopRequireDefault(_without);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var EnterLeaveCounter = function () {
		  function EnterLeaveCounter() {
		    _classCallCheck(this, EnterLeaveCounter);
	
		    this.entered = [];
		  }
	
		  _createClass(EnterLeaveCounter, [{
		    key: 'enter',
		    value: function enter(enteringNode) {
		      var previousLength = this.entered.length;
	
		      var isNodeEntered = function isNodeEntered(node) {
		        return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
		      };
	
		      this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);
	
		      return previousLength === 0 && this.entered.length > 0;
		    }
		  }, {
		    key: 'leave',
		    value: function leave(leavingNode) {
		      var previousLength = this.entered.length;
	
		      this.entered = (0, _without2.default)(this.entered.filter(function (node) {
		        return document.documentElement.contains(node);
		      }), leavingNode);
	
		      return previousLength > 0 && this.entered.length === 0;
		    }
		  }, {
		    key: 'reset',
		    value: function reset() {
		      this.entered = [];
		    }
		  }]);
	
		  return EnterLeaveCounter;
		}();
	
		exports.default = EnterLeaveCounter;
	
	/***/ },
	/* 358 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _defaults = __webpack_require__(340);
	
		var _defaults2 = _interopRequireDefault(_defaults);
	
		var _shallowEqual = __webpack_require__(363);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _EnterLeaveCounter = __webpack_require__(357);
	
		var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
	
		var _BrowserDetector = __webpack_require__(126);
	
		var _OffsetUtils = __webpack_require__(361);
	
		var _NativeDragSources = __webpack_require__(360);
	
		var _NativeTypes = __webpack_require__(84);
	
		var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var HTML5Backend = function () {
		  function HTML5Backend(manager) {
		    _classCallCheck(this, HTML5Backend);
	
		    this.actions = manager.getActions();
		    this.monitor = manager.getMonitor();
		    this.registry = manager.getRegistry();
		    this.context = manager.getContext();
	
		    this.sourcePreviewNodes = {};
		    this.sourcePreviewNodeOptions = {};
		    this.sourceNodes = {};
		    this.sourceNodeOptions = {};
		    this.enterLeaveCounter = new _EnterLeaveCounter2.default();
	
		    this.dragStartSourceIds = [];
		    this.dropTargetIds = [];
		    this.dragEnterTargetIds = [];
		    this.currentNativeSource = null;
		    this.currentNativeHandle = null;
		    this.currentDragSourceNode = null;
		    this.currentDragSourceNodeOffset = null;
		    this.currentDragSourceNodeOffsetChanged = false;
		    this.altKeyPressed = false;
	
		    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
		    this.handleTopDragStart = this.handleTopDragStart.bind(this);
		    this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
		    this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
		    this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
		    this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
		    this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
		    this.handleTopDragOver = this.handleTopDragOver.bind(this);
		    this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
		    this.handleTopDrop = this.handleTopDrop.bind(this);
		    this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
		    this.handleSelectStart = this.handleSelectStart.bind(this);
		    this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
		    this.endDragNativeItem = this.endDragNativeItem.bind(this);
		  }
	
		  _createClass(HTML5Backend, [{
		    key: 'setup',
		    value: function setup() {
		      if (this.window === undefined) {
		        return;
		      }
	
		      if (this.window.__isReactDndBackendSetUp) {
		        // eslint-disable-line no-underscore-dangle
		        throw new Error('Cannot have two HTML5 backends at the same time.');
		      }
		      this.window.__isReactDndBackendSetUp = true; // eslint-disable-line no-underscore-dangle
		      this.addEventListeners(this.window);
		    }
		  }, {
		    key: 'teardown',
		    value: function teardown() {
		      if (this.window === undefined) {
		        return;
		      }
	
		      this.window.__isReactDndBackendSetUp = false; // eslint-disable-line no-underscore-dangle
		      this.removeEventListeners(this.window);
		      this.clearCurrentDragSourceNode();
		    }
		  }, {
		    key: 'addEventListeners',
		    value: function addEventListeners(target) {
		      target.addEventListener('dragstart', this.handleTopDragStart);
		      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
		      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
		      target.addEventListener('dragenter', this.handleTopDragEnter);
		      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
		      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
		      target.addEventListener('dragover', this.handleTopDragOver);
		      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
		      target.addEventListener('drop', this.handleTopDrop);
		      target.addEventListener('drop', this.handleTopDropCapture, true);
		    }
		  }, {
		    key: 'removeEventListeners',
		    value: function removeEventListeners(target) {
		      target.removeEventListener('dragstart', this.handleTopDragStart);
		      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
		      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
		      target.removeEventListener('dragenter', this.handleTopDragEnter);
		      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
		      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
		      target.removeEventListener('dragover', this.handleTopDragOver);
		      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
		      target.removeEventListener('drop', this.handleTopDrop);
		      target.removeEventListener('drop', this.handleTopDropCapture, true);
		    }
		  }, {
		    key: 'connectDragPreview',
		    value: function connectDragPreview(sourceId, node, options) {
		      var _this = this;
	
		      this.sourcePreviewNodeOptions[sourceId] = options;
		      this.sourcePreviewNodes[sourceId] = node;
	
		      return function () {
		        delete _this.sourcePreviewNodes[sourceId];
		        delete _this.sourcePreviewNodeOptions[sourceId];
		      };
		    }
		  }, {
		    key: 'connectDragSource',
		    value: function connectDragSource(sourceId, node, options) {
		      var _this2 = this;
	
		      this.sourceNodes[sourceId] = node;
		      this.sourceNodeOptions[sourceId] = options;
	
		      var handleDragStart = function handleDragStart(e) {
		        return _this2.handleDragStart(e, sourceId);
		      };
		      var handleSelectStart = function handleSelectStart(e) {
		        return _this2.handleSelectStart(e, sourceId);
		      };
	
		      node.setAttribute('draggable', true);
		      node.addEventListener('dragstart', handleDragStart);
		      node.addEventListener('selectstart', handleSelectStart);
	
		      return function () {
		        delete _this2.sourceNodes[sourceId];
		        delete _this2.sourceNodeOptions[sourceId];
	
		        node.removeEventListener('dragstart', handleDragStart);
		        node.removeEventListener('selectstart', handleSelectStart);
		        node.setAttribute('draggable', false);
		      };
		    }
		  }, {
		    key: 'connectDropTarget',
		    value: function connectDropTarget(targetId, node) {
		      var _this3 = this;
	
		      var handleDragEnter = function handleDragEnter(e) {
		        return _this3.handleDragEnter(e, targetId);
		      };
		      var handleDragOver = function handleDragOver(e) {
		        return _this3.handleDragOver(e, targetId);
		      };
		      var handleDrop = function handleDrop(e) {
		        return _this3.handleDrop(e, targetId);
		      };
	
		      node.addEventListener('dragenter', handleDragEnter);
		      node.addEventListener('dragover', handleDragOver);
		      node.addEventListener('drop', handleDrop);
	
		      return function () {
		        node.removeEventListener('dragenter', handleDragEnter);
		        node.removeEventListener('dragover', handleDragOver);
		        node.removeEventListener('drop', handleDrop);
		      };
		    }
		  }, {
		    key: 'getCurrentSourceNodeOptions',
		    value: function getCurrentSourceNodeOptions() {
		      var sourceId = this.monitor.getSourceId();
		      var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
		      return (0, _defaults2.default)(sourceNodeOptions || {}, {
		        dropEffect: this.altKeyPressed ? 'copy' : 'move'
		      });
		    }
		  }, {
		    key: 'getCurrentDropEffect',
		    value: function getCurrentDropEffect() {
		      if (this.isDraggingNativeItem()) {
		        // It makes more sense to default to 'copy' for native resources
		        return 'copy';
		      }
	
		      return this.getCurrentSourceNodeOptions().dropEffect;
		    }
		  }, {
		    key: 'getCurrentSourcePreviewNodeOptions',
		    value: function getCurrentSourcePreviewNodeOptions() {
		      var sourceId = this.monitor.getSourceId();
		      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
		      return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
		        anchorX: 0.5,
		        anchorY: 0.5,
		        captureDraggingState: false
		      });
		    }
		  }, {
		    key: 'getSourceClientOffset',
		    value: function getSourceClientOffset(sourceId) {
		      return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
		    }
		  }, {
		    key: 'isDraggingNativeItem',
		    value: function isDraggingNativeItem() {
		      var itemType = this.monitor.getItemType();
		      return Object.keys(NativeTypes).some(function (key) {
		        return NativeTypes[key] === itemType;
		      });
		    }
		  }, {
		    key: 'beginDragNativeItem',
		    value: function beginDragNativeItem(type) {
		      this.clearCurrentDragSourceNode();
	
		      var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
		      this.currentNativeSource = new SourceType();
		      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
		      this.actions.beginDrag([this.currentNativeHandle]);
	
		      // On Firefox, if mousemove fires, the drag is over but browser failed to tell us.
		      // This is not true for other browsers.
		      if ((0, _BrowserDetector.isFirefox)()) {
		        this.window.addEventListener('mousemove', this.endDragNativeItem, true);
		      }
		    }
		  }, {
		    key: 'endDragNativeItem',
		    value: function endDragNativeItem() {
		      if (!this.isDraggingNativeItem()) {
		        return;
		      }
	
		      if ((0, _BrowserDetector.isFirefox)()) {
		        this.window.removeEventListener('mousemove', this.endDragNativeItem, true);
		      }
	
		      this.actions.endDrag();
		      this.registry.removeSource(this.currentNativeHandle);
		      this.currentNativeHandle = null;
		      this.currentNativeSource = null;
		    }
		  }, {
		    key: 'endDragIfSourceWasRemovedFromDOM',
		    value: function endDragIfSourceWasRemovedFromDOM() {
		      var node = this.currentDragSourceNode;
		      if (document.body.contains(node)) {
		        return;
		      }
	
		      if (this.clearCurrentDragSourceNode()) {
		        this.actions.endDrag();
		      }
		    }
		  }, {
		    key: 'setCurrentDragSourceNode',
		    value: function setCurrentDragSourceNode(node) {
		      this.clearCurrentDragSourceNode();
		      this.currentDragSourceNode = node;
		      this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
		      this.currentDragSourceNodeOffsetChanged = false;
	
		      // Receiving a mouse event in the middle of a dragging operation
		      // means it has ended and the drag source node disappeared from DOM,
		      // so the browser didn't dispatch the dragend event.
		      this.window.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
		    }
		  }, {
		    key: 'clearCurrentDragSourceNode',
		    value: function clearCurrentDragSourceNode() {
		      if (this.currentDragSourceNode) {
		        this.currentDragSourceNode = null;
		        this.currentDragSourceNodeOffset = null;
		        this.currentDragSourceNodeOffsetChanged = false;
		        this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
		        return true;
		      }
	
		      return false;
		    }
		  }, {
		    key: 'checkIfCurrentDragSourceRectChanged',
		    value: function checkIfCurrentDragSourceRectChanged() {
		      var node = this.currentDragSourceNode;
		      if (!node) {
		        return false;
		      }
	
		      if (this.currentDragSourceNodeOffsetChanged) {
		        return true;
		      }
	
		      this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
	
		      return this.currentDragSourceNodeOffsetChanged;
		    }
		  }, {
		    key: 'handleTopDragStartCapture',
		    value: function handleTopDragStartCapture() {
		      this.clearCurrentDragSourceNode();
		      this.dragStartSourceIds = [];
		    }
		  }, {
		    key: 'handleDragStart',
		    value: function handleDragStart(e, sourceId) {
		      this.dragStartSourceIds.unshift(sourceId);
		    }
		  }, {
		    key: 'handleTopDragStart',
		    value: function handleTopDragStart(e) {
		      var _this4 = this;
	
		      var dragStartSourceIds = this.dragStartSourceIds;
	
		      this.dragStartSourceIds = null;
	
		      var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);
	
		      // Don't publish the source just yet (see why below)
		      this.actions.beginDrag(dragStartSourceIds, {
		        publishSource: false,
		        getSourceClientOffset: this.getSourceClientOffset,
		        clientOffset: clientOffset
		      });
	
		      var dataTransfer = e.dataTransfer;
	
		      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
		      if (this.monitor.isDragging()) {
		        if (typeof dataTransfer.setDragImage === 'function') {
		          // Use custom drag image if user specifies it.
		          // If child drag source refuses drag but parent agrees,
		          // use parent's node as drag image. Neither works in IE though.
		          var sourceId = this.monitor.getSourceId();
		          var sourceNode = this.sourceNodes[sourceId];
		          var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
		          var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
		              anchorX = _getCurrentSourcePrev.anchorX,
		              anchorY = _getCurrentSourcePrev.anchorY;
	
		          var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
		          var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint);
		          dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
		        }
	
		        try {
		          // Firefox won't drag without setting data
		          dataTransfer.setData('application/json', {});
		        } catch (err) {}
		        // IE doesn't support MIME types in setData
	
	
		        // Store drag source node so we can check whether
		        // it is removed from DOM and trigger endDrag manually.
		        this.setCurrentDragSourceNode(e.target);
	
		        // Now we are ready to publish the drag source.. or are we not?
	
		        var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
		            captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
	
		        if (!captureDraggingState) {
		          // Usually we want to publish it in the next tick so that browser
		          // is able to screenshot the current (not yet dragging) state.
		          //
		          // It also neatly avoids a situation where render() returns null
		          // in the same tick for the source element, and browser freaks out.
		          setTimeout(function () {
		            return _this4.actions.publishDragSource();
		          });
		        } else {
		          // In some cases the user may want to override this behavior, e.g.
		          // to work around IE not supporting custom drag previews.
		          //
		          // When using a custom drag layer, the only way to prevent
		          // the default drag preview from drawing in IE is to screenshot
		          // the dragging state in which the node itself has zero opacity
		          // and height. In this case, though, returning null from render()
		          // will abruptly end the dragging, which is not obvious.
		          //
		          // This is the reason such behavior is strictly opt-in.
		          this.actions.publishDragSource();
		        }
		      } else if (nativeType) {
		        // A native item (such as URL) dragged from inside the document
		        this.beginDragNativeItem(nativeType);
		      } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
		        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
		        // Just let it drag. It's a native type (URL or text) and will be picked up in
		        // dragenter handler.
		        return; // eslint-disable-line no-useless-return
		      } else {
		        // If by this time no drag source reacted, tell browser not to drag.
		        e.preventDefault();
		      }
		    }
		  }, {
		    key: 'handleTopDragEndCapture',
		    value: function handleTopDragEndCapture() {
		      if (this.clearCurrentDragSourceNode()) {
		        // Firefox can dispatch this event in an infinite loop
		        // if dragend handler does something like showing an alert.
		        // Only proceed if we have not handled it already.
		        this.actions.endDrag();
		      }
		    }
		  }, {
		    key: 'handleTopDragEnterCapture',
		    value: function handleTopDragEnterCapture(e) {
		      this.dragEnterTargetIds = [];
	
		      var isFirstEnter = this.enterLeaveCounter.enter(e.target);
		      if (!isFirstEnter || this.monitor.isDragging()) {
		        return;
		      }
	
		      var dataTransfer = e.dataTransfer;
	
		      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
		      if (nativeType) {
		        // A native item (such as file or URL) dragged from outside the document
		        this.beginDragNativeItem(nativeType);
		      }
		    }
		  }, {
		    key: 'handleDragEnter',
		    value: function handleDragEnter(e, targetId) {
		      this.dragEnterTargetIds.unshift(targetId);
		    }
		  }, {
		    key: 'handleTopDragEnter',
		    value: function handleTopDragEnter(e) {
		      var _this5 = this;
	
		      var dragEnterTargetIds = this.dragEnterTargetIds;
	
		      this.dragEnterTargetIds = [];
	
		      if (!this.monitor.isDragging()) {
		        // This is probably a native item type we don't understand.
		        return;
		      }
	
		      this.altKeyPressed = e.altKey;
	
		      if (!(0, _BrowserDetector.isFirefox)()) {
		        // Don't emit hover in `dragenter` on Firefox due to an edge case.
		        // If the target changes position as the result of `dragenter`, Firefox
		        // will still happily dispatch `dragover` despite target being no longer
		        // there. The easy solution is to only fire `hover` in `dragover` on FF.
		        this.actions.hover(dragEnterTargetIds, {
		          clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
		        });
		      }
	
		      var canDrop = dragEnterTargetIds.some(function (targetId) {
		        return _this5.monitor.canDropOnTarget(targetId);
		      });
	
		      if (canDrop) {
		        // IE requires this to fire dragover events
		        e.preventDefault();
		        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
		      }
		    }
		  }, {
		    key: 'handleTopDragOverCapture',
		    value: function handleTopDragOverCapture() {
		      this.dragOverTargetIds = [];
		    }
		  }, {
		    key: 'handleDragOver',
		    value: function handleDragOver(e, targetId) {
		      this.dragOverTargetIds.unshift(targetId);
		    }
		  }, {
		    key: 'handleTopDragOver',
		    value: function handleTopDragOver(e) {
		      var _this6 = this;
	
		      var dragOverTargetIds = this.dragOverTargetIds;
	
		      this.dragOverTargetIds = [];
	
		      if (!this.monitor.isDragging()) {
		        // This is probably a native item type we don't understand.
		        // Prevent default "drop and blow away the whole document" action.
		        e.preventDefault();
		        e.dataTransfer.dropEffect = 'none';
		        return;
		      }
	
		      this.altKeyPressed = e.altKey;
	
		      this.actions.hover(dragOverTargetIds, {
		        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
		      });
	
		      var canDrop = dragOverTargetIds.some(function (targetId) {
		        return _this6.monitor.canDropOnTarget(targetId);
		      });
	
		      if (canDrop) {
		        // Show user-specified drop effect.
		        e.preventDefault();
		        e.dataTransfer.dropEffect = this.getCurrentDropEffect();
		      } else if (this.isDraggingNativeItem()) {
		        // Don't show a nice cursor but still prevent default
		        // "drop and blow away the whole document" action.
		        e.preventDefault();
		        e.dataTransfer.dropEffect = 'none';
		      } else if (this.checkIfCurrentDragSourceRectChanged()) {
		        // Prevent animating to incorrect position.
		        // Drop effect must be other than 'none' to prevent animation.
		        e.preventDefault();
		        e.dataTransfer.dropEffect = 'move';
		      }
		    }
		  }, {
		    key: 'handleTopDragLeaveCapture',
		    value: function handleTopDragLeaveCapture(e) {
		      if (this.isDraggingNativeItem()) {
		        e.preventDefault();
		      }
	
		      var isLastLeave = this.enterLeaveCounter.leave(e.target);
		      if (!isLastLeave) {
		        return;
		      }
	
		      if (this.isDraggingNativeItem()) {
		        this.endDragNativeItem();
		      }
		    }
		  }, {
		    key: 'handleTopDropCapture',
		    value: function handleTopDropCapture(e) {
		      this.dropTargetIds = [];
		      e.preventDefault();
	
		      if (this.isDraggingNativeItem()) {
		        this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
		      }
	
		      this.enterLeaveCounter.reset();
		    }
		  }, {
		    key: 'handleDrop',
		    value: function handleDrop(e, targetId) {
		      this.dropTargetIds.unshift(targetId);
		    }
		  }, {
		    key: 'handleTopDrop',
		    value: function handleTopDrop(e) {
		      var dropTargetIds = this.dropTargetIds;
	
		      this.dropTargetIds = [];
	
		      this.actions.hover(dropTargetIds, {
		        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
		      });
		      this.actions.drop({ dropEffect: this.getCurrentDropEffect() });
	
		      if (this.isDraggingNativeItem()) {
		        this.endDragNativeItem();
		      } else {
		        this.endDragIfSourceWasRemovedFromDOM();
		      }
		    }
		  }, {
		    key: 'handleSelectStart',
		    value: function handleSelectStart(e) {
		      var target = e.target;
	
		      // Only IE requires us to explicitly say
		      // we want drag drop operation to start
	
		      if (typeof target.dragDrop !== 'function') {
		        return;
		      }
	
		      // Inputs and textareas should be selectable
		      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
		        return;
		      }
	
		      // For other targets, ask IE
		      // to enable drag and drop
		      e.preventDefault();
		      target.dragDrop();
		    }
		  }, {
		    key: 'window',
		    get: function get() {
		      if (this.context && this.context.window) {
		        return this.context.window;
		      } else if (typeof window !== 'undefined') {
		        return window;
		      }
		      return undefined;
		    }
		  }]);
	
		  return HTML5Backend;
		}();
	
		exports.default = HTML5Backend;
	
	/***/ },
	/* 359 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		/* eslint
		   no-plusplus: off,
		   no-mixed-operators: off
		*/
		var MonotonicInterpolant = function () {
		  function MonotonicInterpolant(xs, ys) {
		    _classCallCheck(this, MonotonicInterpolant);
	
		    var length = xs.length;
	
		    // Rearrange xs and ys so that xs is sorted
		    var indexes = [];
		    for (var i = 0; i < length; i++) {
		      indexes.push(i);
		    }
		    indexes.sort(function (a, b) {
		      return xs[a] < xs[b] ? -1 : 1;
		    });
	
		    // Get consecutive differences and slopes
		    var dys = [];
		    var dxs = [];
		    var ms = [];
		    var dx = void 0;
		    var dy = void 0;
		    for (var _i = 0; _i < length - 1; _i++) {
		      dx = xs[_i + 1] - xs[_i];
		      dy = ys[_i + 1] - ys[_i];
		      dxs.push(dx);
		      dys.push(dy);
		      ms.push(dy / dx);
		    }
	
		    // Get degree-1 coefficients
		    var c1s = [ms[0]];
		    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
		      var _m = ms[_i2];
		      var mNext = ms[_i2 + 1];
		      if (_m * mNext <= 0) {
		        c1s.push(0);
		      } else {
		        dx = dxs[_i2];
		        var dxNext = dxs[_i2 + 1];
		        var common = dx + dxNext;
		        c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
		      }
		    }
		    c1s.push(ms[ms.length - 1]);
	
		    // Get degree-2 and degree-3 coefficients
		    var c2s = [];
		    var c3s = [];
		    var m = void 0;
		    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
		      m = ms[_i3];
		      var c1 = c1s[_i3];
		      var invDx = 1 / dxs[_i3];
		      var _common = c1 + c1s[_i3 + 1] - m - m;
		      c2s.push((m - c1 - _common) * invDx);
		      c3s.push(_common * invDx * invDx);
		    }
	
		    this.xs = xs;
		    this.ys = ys;
		    this.c1s = c1s;
		    this.c2s = c2s;
		    this.c3s = c3s;
		  }
	
		  _createClass(MonotonicInterpolant, [{
		    key: "interpolate",
		    value: function interpolate(x) {
		      var xs = this.xs,
		          ys = this.ys,
		          c1s = this.c1s,
		          c2s = this.c2s,
		          c3s = this.c3s;
	
		      // The rightmost point in the dataset should give an exact result
	
		      var i = xs.length - 1;
		      if (x === xs[i]) {
		        return ys[i];
		      }
	
		      // Search for the interval x is in, returning the corresponding y if x is one of the original xs
		      var low = 0;
		      var high = c3s.length - 1;
		      var mid = void 0;
		      while (low <= high) {
		        mid = Math.floor(0.5 * (low + high));
		        var xHere = xs[mid];
		        if (xHere < x) {
		          low = mid + 1;
		        } else if (xHere > x) {
		          high = mid - 1;
		        } else {
		          return ys[mid];
		        }
		      }
		      i = Math.max(0, high);
	
		      // Interpolate
		      var diff = x - xs[i];
		      var diffSq = diff * diff;
		      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
		    }
		  }]);
	
		  return MonotonicInterpolant;
		}();
	
		exports.default = MonotonicInterpolant;
	
	/***/ },
	/* 360 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _nativeTypesConfig;
	
		exports.createNativeDragSource = createNativeDragSource;
		exports.matchNativeItemType = matchNativeItemType;
	
		var _NativeTypes = __webpack_require__(84);
	
		var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
		  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
		    return resultSoFar || dataTransfer.getData(typeToTry);
		  }, null);
	
		  return result != null ? // eslint-disable-line eqeqeq
		  result : defaultValue;
		}
	
		var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
		  exposeProperty: 'files',
		  matchesTypes: ['Files'],
		  getData: function getData(dataTransfer) {
		    return Array.prototype.slice.call(dataTransfer.files);
		  }
		}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
		  exposeProperty: 'urls',
		  matchesTypes: ['Url', 'text/uri-list'],
		  getData: function getData(dataTransfer, matchesTypes) {
		    return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
		  }
		}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
		  exposeProperty: 'text',
		  matchesTypes: ['Text', 'text/plain'],
		  getData: function getData(dataTransfer, matchesTypes) {
		    return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
		  }
		}), _nativeTypesConfig);
	
		function createNativeDragSource(type) {
		  var _nativeTypesConfig$ty = nativeTypesConfig[type],
		      exposeProperty = _nativeTypesConfig$ty.exposeProperty,
		      matchesTypes = _nativeTypesConfig$ty.matchesTypes,
		      getData = _nativeTypesConfig$ty.getData;
	
	
		  return function () {
		    function NativeDragSource() {
		      var _item, _mutatorMap;
	
		      _classCallCheck(this, NativeDragSource);
	
		      this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
		        console.warn( // eslint-disable-line no-console
		        'Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
		        return null;
		      }, _defineEnumerableProperties(_item, _mutatorMap), _item);
		    }
	
		    _createClass(NativeDragSource, [{
		      key: 'mutateItemByReadingDataTransfer',
		      value: function mutateItemByReadingDataTransfer(dataTransfer) {
		        delete this.item[exposeProperty];
		        this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
		      }
		    }, {
		      key: 'canDrag',
		      value: function canDrag() {
		        return true;
		      }
		    }, {
		      key: 'beginDrag',
		      value: function beginDrag() {
		        return this.item;
		      }
		    }, {
		      key: 'isDragging',
		      value: function isDragging(monitor, handle) {
		        return handle === monitor.getSourceId();
		      }
		    }, {
		      key: 'endDrag',
		      value: function endDrag() {}
		    }]);
	
		    return NativeDragSource;
		  }();
		}
	
		function matchNativeItemType(dataTransfer) {
		  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
		  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
		    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
		    return matchesTypes.some(function (t) {
		      return dataTransferTypes.indexOf(t) > -1;
		    });
		  })[0] || null;
		}
	
	/***/ },
	/* 361 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getNodeClientOffset = getNodeClientOffset;
		exports.getEventClientOffset = getEventClientOffset;
		exports.getDragPreviewOffset = getDragPreviewOffset;
	
		var _BrowserDetector = __webpack_require__(126);
	
		var _MonotonicInterpolant = __webpack_require__(359);
	
		var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* eslint
		   no-mixed-operators: off
		*/
		var ELEMENT_NODE = 1;
	
		function getNodeClientOffset(node) {
		  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
		  if (!el) {
		    return null;
		  }
	
		  var _el$getBoundingClient = el.getBoundingClientRect(),
		      top = _el$getBoundingClient.top,
		      left = _el$getBoundingClient.left;
	
		  return { x: left, y: top };
		}
	
		function getEventClientOffset(e) {
		  return {
		    x: e.clientX,
		    y: e.clientY
		  };
		}
	
		function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint) {
		  // The browsers will use the image intrinsic size under different conditions.
		  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
		  var isImage = dragPreview.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(dragPreview));
		  var dragPreviewNode = isImage ? sourceNode : dragPreview;
	
		  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
		  var offsetFromDragPreview = {
		    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
		    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
		  };
	
		  var sourceWidth = sourceNode.offsetWidth,
		      sourceHeight = sourceNode.offsetHeight;
		  var anchorX = anchorPoint.anchorX,
		      anchorY = anchorPoint.anchorY;
	
	
		  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
		  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
		  // Work around @2x coordinate discrepancies in browsers
		  if ((0, _BrowserDetector.isSafari)() && isImage) {
		    dragPreviewHeight /= window.devicePixelRatio;
		    dragPreviewWidth /= window.devicePixelRatio;
		  } else if ((0, _BrowserDetector.isFirefox)() && !isImage) {
		    dragPreviewHeight *= window.devicePixelRatio;
		    dragPreviewWidth *= window.devicePixelRatio;
		  }
	
		  // Interpolate coordinates depending on anchor point
		  // If you know a simpler way to do this, let me know
		  var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		  // Dock to the left
		  offsetFromDragPreview.x,
		  // Align at the center
		  offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
		  // Dock to the right
		  offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
		  var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		  // Dock to the top
		  offsetFromDragPreview.y,
		  // Align at the center
		  offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
		  // Dock to the bottom
		  offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
		  var x = interpolantX.interpolate(anchorX);
		  var y = interpolantY.interpolate(anchorY);
	
		  // Work around Safari 8 positioning bug
		  if ((0, _BrowserDetector.isSafari)() && isImage) {
		    // We'll have to wait for @3x to see if this is entirely correct
		    y += (window.devicePixelRatio - 1) * dragPreviewHeight;
		  }
	
		  return { x: x, y: y };
		}
	
	/***/ },
	/* 362 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getEmptyImage;
		var emptyImage = void 0;
		function getEmptyImage() {
		  if (!emptyImage) {
		    emptyImage = new Image();
		    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
		  }
	
		  return emptyImage;
		}
	
	/***/ },
	/* 363 */
	85,
	/* 364 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = undefined;
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _class, _temp;
	
		var _react = __webpack_require__(2);
	
		var _DragDropContext = __webpack_require__(128);
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		/**
		 * This class is a React-Component based version of the DragDropContext.
		 * This is an alternative to decorating an application component with an ES7 decorator.
		 */
		var DragDropContextProvider = (_temp = _class = function (_Component) {
		  _inherits(DragDropContextProvider, _Component);
	
		  function DragDropContextProvider(props, context) {
		    _classCallCheck(this, DragDropContextProvider);
	
		    var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
	
		    _this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
		    return _this;
		  }
	
		  _createClass(DragDropContextProvider, [{
		    key: 'getChildContext',
		    value: function getChildContext() {
		      var _this2 = this;
	
		      /**
		       * This property determines which window global to use for creating the DragDropManager.
		       * If a window has been injected explicitly via props, that is used first. If it is available
		       * as a context value, then use that, otherwise use the browser global.
		       */
		      var getWindow = function getWindow() {
		        if (_this2.props && _this2.props.window) {
		          return _this2.props.window;
		        } else if (_this2.context && _this2.context.window) {
		          return _this2.context.window;
		        } else if (typeof window !== 'undefined') {
		          return window;
		        }
		        return undefined;
		      };
	
		      return (0, _DragDropContext.createChildContext)(this.backend, { window: getWindow() });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      return _react.Children.only(this.props.children);
		    }
		  }]);
	
		  return DragDropContextProvider;
		}(_react.Component), _class.propTypes = {
		  backend: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]).isRequired,
		  children: _react.PropTypes.element.isRequired,
		  window: _react.PropTypes.object }, _class.defaultProps = {
		  window: undefined
		}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
		  window: _react.PropTypes.object
		}, _temp);
		exports.default = DragDropContextProvider;
	
	/***/ },
	/* 365 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = DragLayer;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _hoistNonReactStatics = __webpack_require__(74);
	
		var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _shallowEqual = __webpack_require__(85);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _shallowEqualScalar = __webpack_require__(132);
	
		var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
	
		var _checkDecoratorArguments = __webpack_require__(49);
	
		var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		function DragLayer(collect) {
		  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  _checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer ' + 'to be a function that collects props to inject into the component. ', 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
		  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
	
		  return function decorateLayer(DecoratedComponent) {
		    var _class, _temp;
	
		    var _options$arePropsEqua = options.arePropsEqual,
		        arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
	
		    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
		    var DragLayerContainer = (_temp = _class = function (_Component) {
		      _inherits(DragLayerContainer, _Component);
	
		      _createClass(DragLayerContainer, [{
		        key: 'getDecoratedComponentInstance',
		        value: function getDecoratedComponentInstance() {
		          (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can ' + 'not be a stateless component.');
		          return this.child;
		        }
		      }, {
		        key: 'shouldComponentUpdate',
		        value: function shouldComponentUpdate(nextProps, nextState) {
		          return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
		        }
		      }]);
	
		      function DragLayerContainer(props, context) {
		        _classCallCheck(this, DragLayerContainer);
	
		        var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
	
		        _this.handleChange = _this.handleChange.bind(_this);
	
		        _this.manager = context.dragDropManager;
		        (0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
		        _this.state = _this.getCurrentState();
		        return _this;
		      }
	
		      _createClass(DragLayerContainer, [{
		        key: 'componentDidMount',
		        value: function componentDidMount() {
		          this.isCurrentlyMounted = true;
	
		          var monitor = this.manager.getMonitor();
		          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
		          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
	
		          this.handleChange();
		        }
		      }, {
		        key: 'componentWillUnmount',
		        value: function componentWillUnmount() {
		          this.isCurrentlyMounted = false;
	
		          this.unsubscribeFromOffsetChange();
		          this.unsubscribeFromStateChange();
		        }
		      }, {
		        key: 'handleChange',
		        value: function handleChange() {
		          if (!this.isCurrentlyMounted) {
		            return;
		          }
	
		          var nextState = this.getCurrentState();
		          if (!(0, _shallowEqual2.default)(nextState, this.state)) {
		            this.setState(nextState);
		          }
		        }
		      }, {
		        key: 'getCurrentState',
		        value: function getCurrentState() {
		          var monitor = this.manager.getMonitor();
		          return collect(monitor);
		        }
		      }, {
		        key: 'render',
		        value: function render() {
		          var _this2 = this;
	
		          return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
		            ref: function ref(child) {
		              return _this2.child = child;
		            }
		          }));
		        }
		      }]);
	
		      return DragLayerContainer;
		    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
		      dragDropManager: _react.PropTypes.object.isRequired
		    }, _temp);
	
	
		    return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
		  };
		}
	
	/***/ },
	/* 366 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = DragSource;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _checkDecoratorArguments = __webpack_require__(49);
	
		var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
		var _decorateHandler = __webpack_require__(130);
	
		var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
		var _registerSource = __webpack_require__(374);
	
		var _registerSource2 = _interopRequireDefault(_registerSource);
	
		var _createSourceFactory = __webpack_require__(369);
	
		var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
		var _createSourceMonitor = __webpack_require__(370);
	
		var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
		var _createSourceConnector = __webpack_require__(368);
	
		var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
		var _isValidType = __webpack_require__(131);
	
		var _isValidType2 = _interopRequireDefault(_isValidType);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function DragSource(type, spec, collect) {
		  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		  _checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		  var getType = type;
		  if (typeof type !== 'function') {
		    (0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
		    getType = function getType() {
		      return type;
		    };
		  }
		  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
		  var createSource = (0, _createSourceFactory2.default)(spec);
		  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
		  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	
		  return function decorateSource(DecoratedComponent) {
		    return (0, _decorateHandler2.default)({
		      connectBackend: function connectBackend(backend, sourceId) {
		        return backend.connectDragSource(sourceId);
		      },
		      containerDisplayName: 'DragSource',
		      createHandler: createSource,
		      registerHandler: _registerSource2.default,
		      createMonitor: _createSourceMonitor2.default,
		      createConnector: _createSourceConnector2.default,
		      DecoratedComponent: DecoratedComponent,
		      getType: getType,
		      collect: collect,
		      options: options
		    });
		  };
		}
	
	/***/ },
	/* 367 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = DropTarget;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _checkDecoratorArguments = __webpack_require__(49);
	
		var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
	
		var _decorateHandler = __webpack_require__(130);
	
		var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
		var _registerTarget = __webpack_require__(375);
	
		var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
		var _createTargetFactory = __webpack_require__(372);
	
		var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
		var _createTargetMonitor = __webpack_require__(373);
	
		var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
		var _createTargetConnector = __webpack_require__(371);
	
		var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
		var _isValidType = __webpack_require__(131);
	
		var _isValidType2 = _interopRequireDefault(_isValidType);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function DropTarget(type, spec, collect) {
		  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		  _checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
		  var getType = type;
		  if (typeof type !== 'function') {
		    (0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
		    getType = function getType() {
		      return type;
		    };
		  }
		  (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
		  var createTarget = (0, _createTargetFactory2.default)(spec);
		  (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
		  (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	
		  return function decorateTarget(DecoratedComponent) {
		    return (0, _decorateHandler2.default)({
		      connectBackend: function connectBackend(backend, targetId) {
		        return backend.connectDropTarget(targetId);
		      },
		      containerDisplayName: 'DropTarget',
		      createHandler: createTarget,
		      registerHandler: _registerTarget2.default,
		      createMonitor: _createTargetMonitor2.default,
		      createConnector: _createTargetConnector2.default,
		      DecoratedComponent: DecoratedComponent,
		      getType: getType,
		      collect: collect,
		      options: options
		    });
		  };
		}
	
	/***/ },
	/* 368 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = createSourceConnector;
	
		var _wrapConnectorHooks = __webpack_require__(133);
	
		var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
		var _areOptionsEqual = __webpack_require__(129);
	
		var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function createSourceConnector(backend) {
		  var currentHandlerId = void 0;
	
		  var currentDragSourceNode = void 0;
		  var currentDragSourceOptions = void 0;
		  var disconnectCurrentDragSource = void 0;
	
		  var currentDragPreviewNode = void 0;
		  var currentDragPreviewOptions = void 0;
		  var disconnectCurrentDragPreview = void 0;
	
		  function reconnectDragSource() {
		    if (disconnectCurrentDragSource) {
		      disconnectCurrentDragSource();
		      disconnectCurrentDragSource = null;
		    }
	
		    if (currentHandlerId && currentDragSourceNode) {
		      disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
		    }
		  }
	
		  function reconnectDragPreview() {
		    if (disconnectCurrentDragPreview) {
		      disconnectCurrentDragPreview();
		      disconnectCurrentDragPreview = null;
		    }
	
		    if (currentHandlerId && currentDragPreviewNode) {
		      disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
		    }
		  }
	
		  function receiveHandlerId(handlerId) {
		    if (handlerId === currentHandlerId) {
		      return;
		    }
	
		    currentHandlerId = handlerId;
		    reconnectDragSource();
		    reconnectDragPreview();
		  }
	
		  var hooks = (0, _wrapConnectorHooks2.default)({
		    dragSource: function connectDragSource(node, options) {
		      if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
		        return;
		      }
	
		      currentDragSourceNode = node;
		      currentDragSourceOptions = options;
	
		      reconnectDragSource();
		    },
	
		    dragPreview: function connectDragPreview(node, options) {
		      if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
		        return;
		      }
	
		      currentDragPreviewNode = node;
		      currentDragPreviewOptions = options;
	
		      reconnectDragPreview();
		    }
		  });
	
		  return {
		    receiveHandlerId: receiveHandlerId,
		    hooks: hooks
		  };
		}
	
	/***/ },
	/* 369 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createSourceFactory;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
		var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
		function createSourceFactory(spec) {
		  Object.keys(spec).forEach(function (key) {
		    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
		    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		  });
		  REQUIRED_SPEC_METHODS.forEach(function (key) {
		    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
		  });
	
		  var Source = function () {
		    function Source(monitor) {
		      _classCallCheck(this, Source);
	
		      this.monitor = monitor;
		      this.props = null;
		      this.component = null;
		    }
	
		    _createClass(Source, [{
		      key: 'receiveProps',
		      value: function receiveProps(props) {
		        this.props = props;
		      }
		    }, {
		      key: 'receiveComponent',
		      value: function receiveComponent(component) {
		        this.component = component;
		      }
		    }, {
		      key: 'canDrag',
		      value: function canDrag() {
		        if (!spec.canDrag) {
		          return true;
		        }
	
		        return spec.canDrag(this.props, this.monitor);
		      }
		    }, {
		      key: 'isDragging',
		      value: function isDragging(globalMonitor, sourceId) {
		        if (!spec.isDragging) {
		          return sourceId === globalMonitor.getSourceId();
		        }
	
		        return spec.isDragging(this.props, this.monitor);
		      }
		    }, {
		      key: 'beginDrag',
		      value: function beginDrag() {
		        var item = spec.beginDrag(this.props, this.monitor, this.component);
		        if (false) {
		          (0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
		        }
		        return item;
		      }
		    }, {
		      key: 'endDrag',
		      value: function endDrag() {
		        if (!spec.endDrag) {
		          return;
		        }
	
		        spec.endDrag(this.props, this.monitor, this.component);
		      }
		    }]);
	
		    return Source;
		  }();
	
		  return function createSource(monitor) {
		    return new Source(monitor);
		  };
		}
	
	/***/ },
	/* 370 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createSourceMonitor;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var isCallingCanDrag = false;
		var isCallingIsDragging = false;
	
		var SourceMonitor = function () {
		  function SourceMonitor(manager) {
		    _classCallCheck(this, SourceMonitor);
	
		    this.internalMonitor = manager.getMonitor();
		  }
	
		  _createClass(SourceMonitor, [{
		    key: 'receiveHandlerId',
		    value: function receiveHandlerId(sourceId) {
		      this.sourceId = sourceId;
		    }
		  }, {
		    key: 'canDrag',
		    value: function canDrag() {
		      (0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
		      try {
		        isCallingCanDrag = true;
		        return this.internalMonitor.canDragSource(this.sourceId);
		      } finally {
		        isCallingCanDrag = false;
		      }
		    }
		  }, {
		    key: 'isDragging',
		    value: function isDragging() {
		      (0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');
	
		      try {
		        isCallingIsDragging = true;
		        return this.internalMonitor.isDraggingSource(this.sourceId);
		      } finally {
		        isCallingIsDragging = false;
		      }
		    }
		  }, {
		    key: 'getItemType',
		    value: function getItemType() {
		      return this.internalMonitor.getItemType();
		    }
		  }, {
		    key: 'getItem',
		    value: function getItem() {
		      return this.internalMonitor.getItem();
		    }
		  }, {
		    key: 'getDropResult',
		    value: function getDropResult() {
		      return this.internalMonitor.getDropResult();
		    }
		  }, {
		    key: 'didDrop',
		    value: function didDrop() {
		      return this.internalMonitor.didDrop();
		    }
		  }, {
		    key: 'getInitialClientOffset',
		    value: function getInitialClientOffset() {
		      return this.internalMonitor.getInitialClientOffset();
		    }
		  }, {
		    key: 'getInitialSourceClientOffset',
		    value: function getInitialSourceClientOffset() {
		      return this.internalMonitor.getInitialSourceClientOffset();
		    }
		  }, {
		    key: 'getSourceClientOffset',
		    value: function getSourceClientOffset() {
		      return this.internalMonitor.getSourceClientOffset();
		    }
		  }, {
		    key: 'getClientOffset',
		    value: function getClientOffset() {
		      return this.internalMonitor.getClientOffset();
		    }
		  }, {
		    key: 'getDifferenceFromInitialOffset',
		    value: function getDifferenceFromInitialOffset() {
		      return this.internalMonitor.getDifferenceFromInitialOffset();
		    }
		  }]);
	
		  return SourceMonitor;
		}();
	
		function createSourceMonitor(manager) {
		  return new SourceMonitor(manager);
		}
	
	/***/ },
	/* 371 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = createTargetConnector;
	
		var _wrapConnectorHooks = __webpack_require__(133);
	
		var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
	
		var _areOptionsEqual = __webpack_require__(129);
	
		var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function createTargetConnector(backend) {
		  var currentHandlerId = void 0;
	
		  var currentDropTargetNode = void 0;
		  var currentDropTargetOptions = void 0;
		  var disconnectCurrentDropTarget = void 0;
	
		  function reconnectDropTarget() {
		    if (disconnectCurrentDropTarget) {
		      disconnectCurrentDropTarget();
		      disconnectCurrentDropTarget = null;
		    }
	
		    if (currentHandlerId && currentDropTargetNode) {
		      disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
		    }
		  }
	
		  function receiveHandlerId(handlerId) {
		    if (handlerId === currentHandlerId) {
		      return;
		    }
	
		    currentHandlerId = handlerId;
		    reconnectDropTarget();
		  }
	
		  var hooks = (0, _wrapConnectorHooks2.default)({
		    dropTarget: function connectDropTarget(node, options) {
		      if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
		        return;
		      }
	
		      currentDropTargetNode = node;
		      currentDropTargetOptions = options;
	
		      reconnectDropTarget();
		    }
		  });
	
		  return {
		    receiveHandlerId: receiveHandlerId,
		    hooks: hooks
		  };
		}
	
	/***/ },
	/* 372 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createTargetFactory;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
		function createTargetFactory(spec) {
		  Object.keys(spec).forEach(function (key) {
		    (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
		    (0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
		  });
	
		  var Target = function () {
		    function Target(monitor) {
		      _classCallCheck(this, Target);
	
		      this.monitor = monitor;
		      this.props = null;
		      this.component = null;
		    }
	
		    _createClass(Target, [{
		      key: 'receiveProps',
		      value: function receiveProps(props) {
		        this.props = props;
		      }
		    }, {
		      key: 'receiveMonitor',
		      value: function receiveMonitor(monitor) {
		        this.monitor = monitor;
		      }
		    }, {
		      key: 'receiveComponent',
		      value: function receiveComponent(component) {
		        this.component = component;
		      }
		    }, {
		      key: 'canDrop',
		      value: function canDrop() {
		        if (!spec.canDrop) {
		          return true;
		        }
	
		        return spec.canDrop(this.props, this.monitor);
		      }
		    }, {
		      key: 'hover',
		      value: function hover() {
		        if (!spec.hover) {
		          return;
		        }
	
		        spec.hover(this.props, this.monitor, this.component);
		      }
		    }, {
		      key: 'drop',
		      value: function drop() {
		        if (!spec.drop) {
		          return undefined;
		        }
	
		        var dropResult = spec.drop(this.props, this.monitor, this.component);
		        if (false) {
		          (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
		        }
		        return dropResult;
		      }
		    }]);
	
		    return Target;
		  }();
	
		  return function createTarget(monitor) {
		    return new Target(monitor);
		  };
		}
	
	/***/ },
	/* 373 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		exports.default = createTargetMonitor;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var isCallingCanDrop = false;
	
		var TargetMonitor = function () {
		  function TargetMonitor(manager) {
		    _classCallCheck(this, TargetMonitor);
	
		    this.internalMonitor = manager.getMonitor();
		  }
	
		  _createClass(TargetMonitor, [{
		    key: 'receiveHandlerId',
		    value: function receiveHandlerId(targetId) {
		      this.targetId = targetId;
		    }
		  }, {
		    key: 'canDrop',
		    value: function canDrop() {
		      (0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');
	
		      try {
		        isCallingCanDrop = true;
		        return this.internalMonitor.canDropOnTarget(this.targetId);
		      } finally {
		        isCallingCanDrop = false;
		      }
		    }
		  }, {
		    key: 'isOver',
		    value: function isOver(options) {
		      return this.internalMonitor.isOverTarget(this.targetId, options);
		    }
		  }, {
		    key: 'getItemType',
		    value: function getItemType() {
		      return this.internalMonitor.getItemType();
		    }
		  }, {
		    key: 'getItem',
		    value: function getItem() {
		      return this.internalMonitor.getItem();
		    }
		  }, {
		    key: 'getDropResult',
		    value: function getDropResult() {
		      return this.internalMonitor.getDropResult();
		    }
		  }, {
		    key: 'didDrop',
		    value: function didDrop() {
		      return this.internalMonitor.didDrop();
		    }
		  }, {
		    key: 'getInitialClientOffset',
		    value: function getInitialClientOffset() {
		      return this.internalMonitor.getInitialClientOffset();
		    }
		  }, {
		    key: 'getInitialSourceClientOffset',
		    value: function getInitialSourceClientOffset() {
		      return this.internalMonitor.getInitialSourceClientOffset();
		    }
		  }, {
		    key: 'getSourceClientOffset',
		    value: function getSourceClientOffset() {
		      return this.internalMonitor.getSourceClientOffset();
		    }
		  }, {
		    key: 'getClientOffset',
		    value: function getClientOffset() {
		      return this.internalMonitor.getClientOffset();
		    }
		  }, {
		    key: 'getDifferenceFromInitialOffset',
		    value: function getDifferenceFromInitialOffset() {
		      return this.internalMonitor.getDifferenceFromInitialOffset();
		    }
		  }]);
	
		  return TargetMonitor;
		}();
	
		function createTargetMonitor(manager) {
		  return new TargetMonitor(manager);
		}
	
	/***/ },
	/* 374 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = registerSource;
		function registerSource(type, source, manager) {
		  var registry = manager.getRegistry();
		  var sourceId = registry.addSource(type, source);
	
		  function unregisterSource() {
		    registry.removeSource(sourceId);
		  }
	
		  return {
		    handlerId: sourceId,
		    unregister: unregisterSource
		  };
		}
	
	/***/ },
	/* 375 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = registerTarget;
		function registerTarget(type, target, manager) {
		  var registry = manager.getRegistry();
		  var targetId = registry.addTarget(type, target);
	
		  function unregisterTarget() {
		    registry.removeTarget(targetId);
		  }
	
		  return {
		    handlerId: targetId,
		    unregister: unregisterTarget
		  };
		}
	
	/***/ },
	/* 376 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = cloneWithRef;
	
		var _invariant = __webpack_require__(6);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _react = __webpack_require__(2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function cloneWithRef(element, newRef) {
		  var previousRef = element.ref;
		  (0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
		  if (!previousRef) {
		    // When there is no ref on the element, use the new ref directly
		    return (0, _react.cloneElement)(element, {
		      ref: newRef
		    });
		  }
	
		  return (0, _react.cloneElement)(element, {
		    ref: function ref(node) {
		      newRef(node);
	
		      if (previousRef) {
		        previousRef(node);
		      }
		    }
		  });
		}
	
	/***/ },
	/* 377 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
	
		var sizerStyle = { position: 'absolute', top: 0, left: 0, visibility: 'hidden', height: 0, overflow: 'scroll', whiteSpace: 'pre' };
	
		var AutosizeInput = React.createClass({
			displayName: 'AutosizeInput',
	
			propTypes: {
				className: React.PropTypes.string, // className for the outer element
				defaultValue: React.PropTypes.any, // default field value
				inputClassName: React.PropTypes.string, // className for the input element
				inputStyle: React.PropTypes.object, // css styles for the input element
				minWidth: React.PropTypes.oneOfType([// minimum width for input element
				React.PropTypes.number, React.PropTypes.string]),
				onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
				placeholder: React.PropTypes.string, // placeholder text
				placeholderIsMinWidth: React.PropTypes.bool, // don't collapse size to less than the placeholder
				style: React.PropTypes.object, // css styles for the outer element
				value: React.PropTypes.any },
			// field value
			getDefaultProps: function getDefaultProps() {
				return {
					minWidth: 1
				};
			},
			getInitialState: function getInitialState() {
				return {
					inputWidth: this.props.minWidth
				};
			},
			componentDidMount: function componentDidMount() {
				this.copyInputStyles();
				this.updateInputWidth();
			},
			componentDidUpdate: function componentDidUpdate() {
				this.updateInputWidth();
			},
			copyInputStyles: function copyInputStyles() {
				if (!this.isMounted() || !window.getComputedStyle) {
					return;
				}
				var inputStyle = window.getComputedStyle(this.refs.input);
				if (!inputStyle) {
					return;
				}
				var widthNode = this.refs.sizer;
				widthNode.style.fontSize = inputStyle.fontSize;
				widthNode.style.fontFamily = inputStyle.fontFamily;
				widthNode.style.fontWeight = inputStyle.fontWeight;
				widthNode.style.fontStyle = inputStyle.fontStyle;
				widthNode.style.letterSpacing = inputStyle.letterSpacing;
				if (this.props.placeholder) {
					var placeholderNode = this.refs.placeholderSizer;
					placeholderNode.style.fontSize = inputStyle.fontSize;
					placeholderNode.style.fontFamily = inputStyle.fontFamily;
					placeholderNode.style.fontWeight = inputStyle.fontWeight;
					placeholderNode.style.fontStyle = inputStyle.fontStyle;
					placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				}
			},
			updateInputWidth: function updateInputWidth() {
				if (!this.isMounted() || typeof this.refs.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = undefined;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.refs.sizer.scrollWidth, this.refs.placeholderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.refs.sizer.scrollWidth + 2;
				}
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			},
			getInput: function getInput() {
				return this.refs.input;
			},
			focus: function focus() {
				this.refs.input.focus();
			},
			blur: function blur() {
				this.refs.input.blur();
			},
			select: function select() {
				this.refs.input.select();
			},
			render: function render() {
				var sizerValue = this.props.defaultValue || this.props.value || '';
				var wrapperStyle = this.props.style || {};
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
				var inputStyle = _extends({}, this.props.inputStyle);
				inputStyle.width = this.state.inputWidth + 'px';
				inputStyle.boxSizing = 'content-box';
				var inputProps = _extends({}, this.props);
				inputProps.className = this.props.inputClassName;
				inputProps.style = inputStyle;
				// ensure props meant for `AutosizeInput` don't end up on the `input`
				delete inputProps.inputClassName;
				delete inputProps.inputStyle;
				delete inputProps.minWidth;
				delete inputProps.placeholderIsMinWidth;
				return React.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					React.createElement('input', _extends({}, inputProps, { ref: 'input' })),
					React.createElement(
						'div',
						{ ref: 'sizer', style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? React.createElement(
						'div',
						{ ref: 'placeholderSizer', style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		});
	
		module.exports = AutosizeInput;
	
	/***/ },
	/* 378 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _warning = __webpack_require__(406);
	
		var _warning2 = _interopRequireDefault(_warning);
	
		var _componentOrElement = __webpack_require__(136);
	
		var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
		var _elementType = __webpack_require__(385);
	
		var _elementType2 = _interopRequireDefault(_elementType);
	
		var _Portal = __webpack_require__(380);
	
		var _Portal2 = _interopRequireDefault(_Portal);
	
		var _ModalManager = __webpack_require__(379);
	
		var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
		var _ownerDocument = __webpack_require__(135);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		var _addEventListener = __webpack_require__(381);
	
		var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
		var _addFocusListener = __webpack_require__(382);
	
		var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
		var _inDOM = __webpack_require__(23);
	
		var _inDOM2 = _interopRequireDefault(_inDOM);
	
		var _activeElement = __webpack_require__(261);
	
		var _activeElement2 = _interopRequireDefault(_activeElement);
	
		var _contains = __webpack_require__(267);
	
		var _contains2 = _interopRequireDefault(_contains);
	
		var _getContainer = __webpack_require__(134);
	
		var _getContainer2 = _interopRequireDefault(_getContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var modalManager = new _ModalManager2.default();
	
		/**
		 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
		 * The Modal component renders its `children` node in front of a backdrop component.
		 *
		 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
		 *
		 * - Manages dialog stacking when one-at-a-time just isn't enough.
		 * - Creates a backdrop, for disabling interaction below the modal.
		 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
		 * - It disables scrolling of the page content while open.
		 * - Adds the appropriate ARIA roles are automatically.
		 * - Easily pluggable animations via a `<Transition/>` component.
		 *
		 * Note that, in the same way the backdrop element prevents users from clicking or interacting
		 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
		 * interact with page content while the Modal is open. To do this, we use a common technique of applying
		 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
		 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
		 * React hierarchy (such as the default: document.body).
		 */
		var Modal = _react2.default.createClass({
		  displayName: 'Modal',
	
	
		  propTypes: _extends({}, _Portal2.default.propTypes, {
	
		    /**
		     * Set the visibility of the Modal
		     */
		    show: _react2.default.PropTypes.bool,
	
		    /**
		     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
		     *
		     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
		     * page content can be placed behind a virtual backdrop as well as a visual one.
		     */
		    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
		    /**
		     * A callback fired when the Modal is opening.
		     */
		    onShow: _react2.default.PropTypes.func,
	
		    /**
		     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
		     *
		     * The `onHide` callback only signals intent from the Modal,
		     * you must actually set the `show` prop to `false` for the Modal to close.
		     */
		    onHide: _react2.default.PropTypes.func,
	
		    /**
		     * Include a backdrop component.
		     */
		    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
		    /**
		     * A function that returns a backdrop component. Useful for custom
		     * backdrop rendering.
		     *
		     * ```js
		     *  renderBackdrop={props => <MyBackdrop {...props} />}
		     * ```
		     */
		    renderBackdrop: _react2.default.PropTypes.func,
	
		    /**
		     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
		     */
		    onEscapeKeyUp: _react2.default.PropTypes.func,
	
		    /**
		     * A callback fired when the backdrop, if specified, is clicked.
		     */
		    onBackdropClick: _react2.default.PropTypes.func,
	
		    /**
		     * A style object for the backdrop component.
		     */
		    backdropStyle: _react2.default.PropTypes.object,
	
		    /**
		     * A css class or classes for the backdrop component.
		     */
		    backdropClassName: _react2.default.PropTypes.string,
	
		    /**
		     * A css class or set of classes applied to the modal container when the modal is open,
		     * and removed when it is closed.
		     */
		    containerClassName: _react2.default.PropTypes.string,
	
		    /**
		     * Close the modal when escape key is pressed
		     */
		    keyboard: _react2.default.PropTypes.bool,
	
		    /**
		     * A `<Transition/>` component to use for the dialog and backdrop components.
		     */
		    transition: _elementType2.default,
	
		    /**
		     * The `timeout` of the dialog transition if specified. This number is used to ensure that
		     * transition callbacks are always fired, even if browser transition events are canceled.
		     *
		     * See the Transition `timeout` prop for more infomation.
		     */
		    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
		    /**
		     * The `timeout` of the backdrop transition if specified. This number is used to
		     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
		     *
		     * See the Transition `timeout` prop for more infomation.
		     */
		    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
		    /**
		     * When `true` The modal will automatically shift focus to itself when it opens, and
		     * replace it to the last focused element when it closes. This also
		     * works correctly with any Modal children that have the `autoFocus` prop.
		     *
		     * Generally this should never be set to `false` as it makes the Modal less
		     * accessible to assistive technologies, like screen readers.
		     */
		    autoFocus: _react2.default.PropTypes.bool,
	
		    /**
		     * When `true` The modal will prevent focus from leaving the Modal while open.
		     *
		     * Generally this should never be set to `false` as it makes the Modal less
		     * accessible to assistive technologies, like screen readers.
		     */
		    enforceFocus: _react2.default.PropTypes.bool,
	
		    /**
		     * When `true` The modal will restore focus to previously focused element once
		     * modal is hidden
		     */
		    restoreFocus: _react2.default.PropTypes.bool,
	
		    /**
		     * Callback fired before the Modal transitions in
		     */
		    onEnter: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired as the Modal begins to transition in
		     */
		    onEntering: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired after the Modal finishes transitioning in
		     */
		    onEntered: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired right before the Modal transitions out
		     */
		    onExit: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired as the Modal begins to transition out
		     */
		    onExiting: _react2.default.PropTypes.func,
	
		    /**
		     * Callback fired after the Modal finishes transitioning out
		     */
		    onExited: _react2.default.PropTypes.func,
	
		    /**
		     * A ModalManager instance used to track and manage the state of open
		     * Modals. Useful when customizing how modals interact within a container
		     */
		    manager: _react2.default.PropTypes.object.isRequired
		  }),
	
		  getDefaultProps: function getDefaultProps() {
		    var noop = function noop() {};
	
		    return {
		      show: false,
		      backdrop: true,
		      keyboard: true,
		      autoFocus: true,
		      enforceFocus: true,
		      restoreFocus: true,
		      onHide: noop,
		      manager: modalManager,
		      renderBackdrop: function renderBackdrop(props) {
		        return _react2.default.createElement('div', props);
		      }
		    };
		  },
		  omitProps: function omitProps(props, propTypes) {
	
		    var keys = Object.keys(props);
		    var newProps = {};
		    keys.map(function (prop) {
		      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
		        newProps[prop] = props[prop];
		      }
		    });
	
		    return newProps;
		  },
		  getInitialState: function getInitialState() {
		    return { exited: !this.props.show };
		  },
		  render: function render() {
		    var _props = this.props,
		        show = _props.show,
		        container = _props.container,
		        children = _props.children,
		        Transition = _props.transition,
		        backdrop = _props.backdrop,
		        dialogTransitionTimeout = _props.dialogTransitionTimeout,
		        className = _props.className,
		        style = _props.style,
		        onExit = _props.onExit,
		        onExiting = _props.onExiting,
		        onEnter = _props.onEnter,
		        onEntering = _props.onEntering,
		        onEntered = _props.onEntered;
	
	
		    var dialog = _react2.default.Children.only(children);
		    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
		    var mountModal = show || Transition && !this.state.exited;
		    if (!mountModal) {
		      return null;
		    }
	
		    var _dialog$props = dialog.props,
		        role = _dialog$props.role,
		        tabIndex = _dialog$props.tabIndex;
	
	
		    if (role === undefined || tabIndex === undefined) {
		      dialog = (0, _react.cloneElement)(dialog, {
		        role: role === undefined ? 'document' : role,
		        tabIndex: tabIndex == null ? '-1' : tabIndex
		      });
		    }
	
		    if (Transition) {
		      dialog = _react2.default.createElement(
		        Transition,
		        {
		          transitionAppear: true,
		          unmountOnExit: true,
		          'in': show,
		          timeout: dialogTransitionTimeout,
		          onExit: onExit,
		          onExiting: onExiting,
		          onExited: this.handleHidden,
		          onEnter: onEnter,
		          onEntering: onEntering,
		          onEntered: onEntered
		        },
		        dialog
		      );
		    }
	
		    return _react2.default.createElement(
		      _Portal2.default,
		      {
		        ref: this.setMountNode,
		        container: container
		      },
		      _react2.default.createElement(
		        'div',
		        _extends({
		          ref: 'modal',
		          role: role || 'dialog'
		        }, filteredProps, {
		          style: style,
		          className: className
		        }),
		        backdrop && this.renderBackdrop(),
		        dialog
		      )
		    );
		  },
		  renderBackdrop: function renderBackdrop() {
		    var _this = this;
	
		    var _props2 = this.props,
		        backdropStyle = _props2.backdropStyle,
		        backdropClassName = _props2.backdropClassName,
		        renderBackdrop = _props2.renderBackdrop,
		        Transition = _props2.transition,
		        backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
		    var backdropRef = function backdropRef(ref) {
		      return _this.backdrop = ref;
		    };
	
		    var backdrop = _react2.default.createElement('div', {
		      ref: backdropRef,
		      style: this.props.backdropStyle,
		      className: this.props.backdropClassName,
		      onClick: this.handleBackdropClick
		    });
	
		    if (Transition) {
		      backdrop = _react2.default.createElement(
		        Transition,
		        { transitionAppear: true,
		          'in': this.props.show,
		          timeout: backdropTransitionTimeout
		        },
		        renderBackdrop({
		          ref: backdropRef,
		          style: backdropStyle,
		          className: backdropClassName,
		          onClick: this.handleBackdropClick
		        })
		      );
		    }
	
		    return backdrop;
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.show) {
		      this.setState({ exited: false });
		    } else if (!nextProps.transition) {
		      // Otherwise let handleHidden take care of marking exited.
		      this.setState({ exited: true });
		    }
		  },
		  componentWillUpdate: function componentWillUpdate(nextProps) {
		    if (!this.props.show && nextProps.show) {
		      this.checkForFocus();
		    }
		  },
		  componentDidMount: function componentDidMount() {
		    if (this.props.show) {
		      this.onShow();
		    }
		  },
		  componentDidUpdate: function componentDidUpdate(prevProps) {
		    var transition = this.props.transition;
	
	
		    if (prevProps.show && !this.props.show && !transition) {
		      // Otherwise handleHidden will call this.
		      this.onHide();
		    } else if (!prevProps.show && this.props.show) {
		      this.onShow();
		    }
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    var _props3 = this.props,
		        show = _props3.show,
		        transition = _props3.transition;
	
	
		    if (show || transition && !this.state.exited) {
		      this.onHide();
		    }
		  },
		  onShow: function onShow() {
		    var doc = (0, _ownerDocument2.default)(this);
		    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
		    this.props.manager.add(this, container, this.props.containerClassName);
	
		    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
		    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
		    this.focus();
	
		    if (this.props.onShow) {
		      this.props.onShow();
		    }
		  },
		  onHide: function onHide() {
		    this.props.manager.remove(this);
	
		    this._onDocumentKeyupListener.remove();
	
		    this._onFocusinListener.remove();
	
		    if (this.props.restoreFocus) {
		      this.restoreLastFocus();
		    }
		  },
		  setMountNode: function setMountNode(ref) {
		    this.mountNode = ref ? ref.getMountNode() : ref;
		  },
		  handleHidden: function handleHidden() {
		    this.setState({ exited: true });
		    this.onHide();
	
		    if (this.props.onExited) {
		      var _props4;
	
		      (_props4 = this.props).onExited.apply(_props4, arguments);
		    }
		  },
		  handleBackdropClick: function handleBackdropClick(e) {
		    if (e.target !== e.currentTarget) {
		      return;
		    }
	
		    if (this.props.onBackdropClick) {
		      this.props.onBackdropClick(e);
		    }
	
		    if (this.props.backdrop === true) {
		      this.props.onHide();
		    }
		  },
		  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
		    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
		      if (this.props.onEscapeKeyUp) {
		        this.props.onEscapeKeyUp(e);
		      }
		      this.props.onHide();
		    }
		  },
		  checkForFocus: function checkForFocus() {
		    if (_inDOM2.default) {
		      this.lastFocus = (0, _activeElement2.default)();
		    }
		  },
		  focus: function focus() {
		    var autoFocus = this.props.autoFocus;
		    var modalContent = this.getDialogElement();
		    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
		    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
		    if (modalContent && autoFocus && !focusInModal) {
		      this.lastFocus = current;
	
		      if (!modalContent.hasAttribute('tabIndex')) {
		        modalContent.setAttribute('tabIndex', -1);
		        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
		      }
	
		      modalContent.focus();
		    }
		  },
		  restoreLastFocus: function restoreLastFocus() {
		    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
		    if (this.lastFocus && this.lastFocus.focus) {
		      this.lastFocus.focus();
		      this.lastFocus = null;
		    }
		  },
		  enforceFocus: function enforceFocus() {
		    var enforceFocus = this.props.enforceFocus;
	
	
		    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
		      return;
		    }
	
		    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
		    var modal = this.getDialogElement();
	
		    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
		      modal.focus();
		    }
		  },
	
	
		  //instead of a ref, which might conflict with one the parent applied.
		  getDialogElement: function getDialogElement() {
		    var node = this.refs.modal;
		    return node && node.lastChild;
		  },
		  isTopModal: function isTopModal() {
		    return this.props.manager.isTopModal(this);
		  }
		});
	
		Modal.Manager = _ModalManager2.default;
	
		exports.default = Modal;
		module.exports = exports['default'];
	
	/***/ },
	/* 379 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _style = __webpack_require__(270);
	
		var _style2 = _interopRequireDefault(_style);
	
		var _class = __webpack_require__(263);
	
		var _class2 = _interopRequireDefault(_class);
	
		var _scrollbarSize = __webpack_require__(277);
	
		var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
		var _isOverflowing = __webpack_require__(383);
	
		var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
		var _manageAriaHidden = __webpack_require__(384);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function findIndexOf(arr, cb) {
		  var idx = -1;
		  arr.some(function (d, i) {
		    if (cb(d, i)) {
		      idx = i;
		      return true;
		    }
		  });
		  return idx;
		}
	
		function findContainer(data, modal) {
		  return findIndexOf(data, function (d) {
		    return d.modals.indexOf(modal) !== -1;
		  });
		}
	
		function setContainerStyle(state, container) {
		  var style = { overflow: 'hidden' };
	
		  // we are only interested in the actual `style` here
		  // becasue we will override it
		  state.style = {
		    overflow: container.style.overflow,
		    paddingRight: container.style.paddingRight
		  };
	
		  if (state.overflowing) {
		    // use computed style, here to get the real padding
		    // to add our scrollbar width
		    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
		  }
	
		  (0, _style2.default)(container, style);
		}
	
		function removeContainerStyle(_ref, container) {
		  var style = _ref.style;
	
	
		  Object.keys(style).forEach(function (key) {
		    return container.style[key] = style[key];
		  });
		}
		/**
		 * Proper state managment for containers and the modals in those containers.
		 *
		 * @internal Used by the Modal to ensure proper styling of containers.
		 */
	
		var ModalManager = function () {
		  function ModalManager() {
		    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		        _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
		        hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
		        _ref2$handleContainer = _ref2.handleContainerOverflow,
		        handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
		    _classCallCheck(this, ModalManager);
	
		    this.hideSiblingNodes = hideSiblingNodes;
		    this.handleContainerOverflow = handleContainerOverflow;
		    this.modals = [];
		    this.containers = [];
		    this.data = [];
		  }
	
		  _createClass(ModalManager, [{
		    key: 'add',
		    value: function add(modal, container, className) {
		      var modalIdx = this.modals.indexOf(modal);
		      var containerIdx = this.containers.indexOf(container);
	
		      if (modalIdx !== -1) {
		        return modalIdx;
		      }
	
		      modalIdx = this.modals.length;
		      this.modals.push(modal);
	
		      if (this.hideSiblingNodes) {
		        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
		      }
	
		      if (containerIdx !== -1) {
		        this.data[containerIdx].modals.push(modal);
		        return modalIdx;
		      }
	
		      var data = {
		        modals: [modal],
		        //right now only the first modal of a container will have its classes applied
		        classes: className ? className.split(/\s+/) : [],
	
		        overflowing: (0, _isOverflowing2.default)(container)
		      };
	
		      if (this.handleContainerOverflow) {
		        setContainerStyle(data, container);
		      }
	
		      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
		      this.containers.push(container);
		      this.data.push(data);
	
		      return modalIdx;
		    }
		  }, {
		    key: 'remove',
		    value: function remove(modal) {
		      var modalIdx = this.modals.indexOf(modal);
	
		      if (modalIdx === -1) {
		        return;
		      }
	
		      var containerIdx = findContainer(this.data, modal);
		      var data = this.data[containerIdx];
		      var container = this.containers[containerIdx];
	
		      data.modals.splice(data.modals.indexOf(modal), 1);
	
		      this.modals.splice(modalIdx, 1);
	
		      // if that was the last modal in a container,
		      // clean up the container
		      if (data.modals.length === 0) {
		        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
		        if (this.handleContainerOverflow) {
		          removeContainerStyle(data, container);
		        }
	
		        if (this.hideSiblingNodes) {
		          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
		        }
		        this.containers.splice(containerIdx, 1);
		        this.data.splice(containerIdx, 1);
		      } else if (this.hideSiblingNodes) {
		        //otherwise make sure the next top modal is visible to a SR
		        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
		      }
		    }
		  }, {
		    key: 'isTopModal',
		    value: function isTopModal(modal) {
		      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
		    }
		  }]);
	
		  return ModalManager;
		}();
	
		exports.default = ModalManager;
		module.exports = exports['default'];
	
	/***/ },
	/* 380 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _componentOrElement = __webpack_require__(136);
	
		var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
		var _ownerDocument = __webpack_require__(135);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		var _getContainer = __webpack_require__(134);
	
		var _getContainer2 = _interopRequireDefault(_getContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/**
		 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
		 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
		 * The children of `<Portal/>` component will be appended to the `container` specified.
		 */
		var Portal = _react2.default.createClass({
	
		  displayName: 'Portal',
	
		  propTypes: {
		    /**
		     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
		     * appended to it.
		     */
		    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
		  },
	
		  componentDidMount: function componentDidMount() {
		    this._renderOverlay();
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this._renderOverlay();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (this._overlayTarget && nextProps.container !== this.props.container) {
		      this._portalContainerNode.removeChild(this._overlayTarget);
		      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
		      this._portalContainerNode.appendChild(this._overlayTarget);
		    }
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._unrenderOverlay();
		    this._unmountOverlayTarget();
		  },
		  _mountOverlayTarget: function _mountOverlayTarget() {
		    if (!this._overlayTarget) {
		      this._overlayTarget = document.createElement('div');
		      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
		      this._portalContainerNode.appendChild(this._overlayTarget);
		    }
		  },
		  _unmountOverlayTarget: function _unmountOverlayTarget() {
		    if (this._overlayTarget) {
		      this._portalContainerNode.removeChild(this._overlayTarget);
		      this._overlayTarget = null;
		    }
		    this._portalContainerNode = null;
		  },
		  _renderOverlay: function _renderOverlay() {
	
		    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
		    // Save reference for future access.
		    if (overlay !== null) {
		      this._mountOverlayTarget();
		      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
		    } else {
		      // Unrender if the component is null for transitions to null
		      this._unrenderOverlay();
		      this._unmountOverlayTarget();
		    }
		  },
		  _unrenderOverlay: function _unrenderOverlay() {
		    if (this._overlayTarget) {
		      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
		      this._overlayInstance = null;
		    }
		  },
		  render: function render() {
		    return null;
		  },
		  getMountNode: function getMountNode() {
		    return this._overlayTarget;
		  },
		  getOverlayDOMNode: function getOverlayDOMNode() {
		    if (!this.isMounted()) {
		      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
		    }
	
		    if (this._overlayInstance) {
		      return _reactDom2.default.findDOMNode(this._overlayInstance);
		    }
	
		    return null;
		  }
		});
	
		exports.default = Portal;
		module.exports = exports['default'];
	
	/***/ },
	/* 381 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		exports.default = function (node, event, handler, capture) {
		  (0, _on2.default)(node, event, handler, capture);
	
		  return {
		    remove: function remove() {
		      (0, _off2.default)(node, event, handler, capture);
		    }
		  };
		};
	
		var _on = __webpack_require__(266);
	
		var _on2 = _interopRequireDefault(_on);
	
		var _off = __webpack_require__(265);
	
		var _off2 = _interopRequireDefault(_off);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = exports['default'];
	
	/***/ },
	/* 382 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = addFocusListener;
		/**
		 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
		 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
		 *
		 * We only allow one Listener at a time to avoid stack overflows
		 */
		function addFocusListener(handler) {
		  var useFocusin = !document.addEventListener;
		  var remove = void 0;
	
		  if (useFocusin) {
		    document.attachEvent('onfocusin', handler);
		    remove = function remove() {
		      return document.detachEvent('onfocusin', handler);
		    };
		  } else {
		    document.addEventListener('focus', handler, true);
		    remove = function remove() {
		      return document.removeEventListener('focus', handler, true);
		    };
		  }
	
		  return { remove: remove };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 383 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isOverflowing;
	
		var _isWindow = __webpack_require__(268);
	
		var _isWindow2 = _interopRequireDefault(_isWindow);
	
		var _ownerDocument = __webpack_require__(73);
	
		var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function isBody(node) {
		  return node && node.tagName.toLowerCase() === 'body';
		}
	
		function bodyIsOverflowing(node) {
		  var doc = (0, _ownerDocument2.default)(node);
		  var win = (0, _isWindow2.default)(doc);
		  var fullWidth = win.innerWidth;
	
		  // Support: ie8, no innerWidth
		  if (!fullWidth) {
		    var documentElementRect = doc.documentElement.getBoundingClientRect();
		    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
		  }
	
		  return doc.body.clientWidth < fullWidth;
		}
	
		function isOverflowing(container) {
		  var win = (0, _isWindow2.default)(container);
	
		  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 384 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.ariaHidden = ariaHidden;
		exports.hideSiblings = hideSiblings;
		exports.showSiblings = showSiblings;
	
		var BLACKLIST = ['template', 'script', 'style'];
	
		var isHidable = function isHidable(_ref) {
		  var nodeType = _ref.nodeType,
		      tagName = _ref.tagName;
		  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
		};
	
		var siblings = function siblings(container, mount, cb) {
		  mount = [].concat(mount);
	
		  [].forEach.call(container.children, function (node) {
		    if (mount.indexOf(node) === -1 && isHidable(node)) {
		      cb(node);
		    }
		  });
		};
	
		function ariaHidden(show, node) {
		  if (!node) {
		    return;
		  }
		  if (show) {
		    node.setAttribute('aria-hidden', 'true');
		  } else {
		    node.removeAttribute('aria-hidden');
		  }
		}
	
		function hideSiblings(container, mountNode) {
		  siblings(container, mountNode, function (node) {
		    return ariaHidden(true, node);
		  });
		}
	
		function showSiblings(container, mountNode) {
		  siblings(container, mountNode, function (node) {
		    return ariaHidden(false, node);
		  });
		}
	
	/***/ },
	/* 385 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _createChainableTypeChecker = __webpack_require__(137);
	
		var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function elementType(props, propName, componentName, location, propFullName) {
		  var propValue = props[propName];
		  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
		  if (_react2.default.isValidElement(propValue)) {
		    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
		  }
	
		  if (propType !== 'function' && propType !== 'string') {
		    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
		  }
	
		  return null;
		}
	
		exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	
	/***/ },
	/* 386 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
			value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
		var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Select = __webpack_require__(50);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		var _utilsStripDiacritics = __webpack_require__(140);
	
		var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
		var propTypes = {
			autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
			cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
			children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
			ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
			ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
			loadingPlaceholder: _react2['default'].PropTypes.oneOfType([// replaces the placeholder while options are loading
			_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
			loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
			options: _react.PropTypes.array.isRequired, // array of options
			placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
			_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
			noResultsText: _react2['default'].PropTypes.oneOfType([// field noResultsText, displayed when no options come back from the server
			_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
			_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
			onInputChange: _react2['default'].PropTypes.func, // optional for keeping track of what is being typed
			value: _react2['default'].PropTypes.any };
	
		// initial field value
		var defaultCache = {};
	
		var defaultProps = {
			autoload: true,
			cache: defaultCache,
			children: defaultChildren,
			ignoreAccents: true,
			ignoreCase: true,
			loadingPlaceholder: 'Loading...',
			options: [],
			searchPromptText: 'Type to search'
		};
	
		var Async = (function (_Component) {
			_inherits(Async, _Component);
	
			function Async(props, context) {
				_classCallCheck(this, Async);
	
				_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);
	
				this._cache = props.cache === defaultCache ? {} : props.cache;
	
				this.state = {
					isLoading: false,
					options: props.options
				};
	
				this._onInputChange = this._onInputChange.bind(this);
			}
	
			_createClass(Async, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					var autoload = this.props.autoload;
	
					if (autoload) {
						this.loadOptions('');
					}
				}
			}, {
				key: 'componentWillUpdate',
				value: function componentWillUpdate(nextProps, nextState) {
					var _this = this;
	
					var propertiesToSync = ['options'];
					propertiesToSync.forEach(function (prop) {
						if (_this.props[prop] !== nextProps[prop]) {
							_this.setState(_defineProperty({}, prop, nextProps[prop]));
						}
					});
				}
			}, {
				key: 'clearOptions',
				value: function clearOptions() {
					this.setState({ options: [] });
				}
			}, {
				key: 'loadOptions',
				value: function loadOptions(inputValue) {
					var _this2 = this;
	
					var loadOptions = this.props.loadOptions;
	
					var cache = this._cache;
	
					if (cache && cache.hasOwnProperty(inputValue)) {
						this.setState({
							options: cache[inputValue]
						});
	
						return;
					}
	
					var callback = function callback(error, data) {
						if (callback === _this2._callback) {
							_this2._callback = null;
	
							var options = data && data.options || [];
	
							if (cache) {
								cache[inputValue] = options;
							}
	
							_this2.setState({
								isLoading: false,
								options: options
							});
						}
					};
	
					// Ignore all but the most recent request
					this._callback = callback;
	
					var promise = loadOptions(inputValue, callback);
					if (promise) {
						promise.then(function (data) {
							return callback(null, data);
						}, function (error) {
							return callback(error);
						});
					}
	
					if (this._callback && !this.state.isLoading) {
						this.setState({
							isLoading: true
						});
					}
	
					return inputValue;
				}
			}, {
				key: '_onInputChange',
				value: function _onInputChange(inputValue) {
					var _props = this.props;
					var ignoreAccents = _props.ignoreAccents;
					var ignoreCase = _props.ignoreCase;
					var onInputChange = _props.onInputChange;
	
					if (ignoreAccents) {
						inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
					}
	
					if (ignoreCase) {
						inputValue = inputValue.toLowerCase();
					}
	
					if (onInputChange) {
						onInputChange(inputValue);
					}
	
					return this.loadOptions(inputValue);
				}
			}, {
				key: 'inputValue',
				value: function inputValue() {
					if (this.select) {
						return this.select.state.inputValue;
					}
					return '';
				}
			}, {
				key: 'noResultsText',
				value: function noResultsText() {
					var _props2 = this.props;
					var loadingPlaceholder = _props2.loadingPlaceholder;
					var noResultsText = _props2.noResultsText;
					var searchPromptText = _props2.searchPromptText;
					var isLoading = this.state.isLoading;
	
					var inputValue = this.inputValue();
	
					if (isLoading) {
						return loadingPlaceholder;
					}
					if (inputValue && noResultsText) {
						return noResultsText;
					}
					return searchPromptText;
				}
			}, {
				key: 'focus',
				value: function focus() {
					this.select.focus();
				}
			}, {
				key: 'render',
				value: function render() {
					var _this3 = this;
	
					var _props3 = this.props;
					var children = _props3.children;
					var loadingPlaceholder = _props3.loadingPlaceholder;
					var placeholder = _props3.placeholder;
					var _state = this.state;
					var isLoading = _state.isLoading;
					var options = _state.options;
	
					var props = {
						noResultsText: this.noResultsText(),
						placeholder: isLoading ? loadingPlaceholder : placeholder,
						options: isLoading && loadingPlaceholder ? [] : options,
						ref: function ref(_ref) {
							return _this3.select = _ref;
						},
						onChange: function onChange(newValues) {
							if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
								_this3.clearOptions();
							}
							_this3.props.onChange(newValues);
						}
					};
	
					return children(_extends({}, this.props, props, {
						isLoading: isLoading,
						onInputChange: this._onInputChange
					}));
				}
			}]);
	
			return Async;
		})(_react.Component);
	
		exports['default'] = Async;
	
		Async.propTypes = propTypes;
		Async.defaultProps = defaultProps;
	
		function defaultChildren(props) {
			return _react2['default'].createElement(_Select2['default'], props);
		};
		module.exports = exports['default'];
	
	/***/ },
	/* 387 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Select = __webpack_require__(50);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		function reduce(obj) {
			var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
			return Object.keys(obj).reduce(function (props, key) {
				var value = obj[key];
				if (value !== undefined) props[key] = value;
				return props;
			}, props);
		}
	
		var AsyncCreatable = _react2['default'].createClass({
			displayName: 'AsyncCreatableSelect',
	
			render: function render() {
				var _this = this;
	
				return _react2['default'].createElement(
					_Select2['default'].Async,
					this.props,
					function (asyncProps) {
						return _react2['default'].createElement(
							_Select2['default'].Creatable,
							_this.props,
							function (creatableProps) {
								return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
									onInputChange: function (input) {
										creatableProps.onInputChange(input);
										return asyncProps.onInputChange(input);
									},
									ref: function (ref) {
										creatableProps.ref(ref);
										asyncProps.ref(ref);
									}
								}));
							}
						);
					}
				);
			}
		});
	
		module.exports = AsyncCreatable;
	
	/***/ },
	/* 388 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Select = __webpack_require__(50);
	
		var _Select2 = _interopRequireDefault(_Select);
	
		var _utilsDefaultFilterOptions = __webpack_require__(138);
	
		var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
		var _utilsDefaultMenuRenderer = __webpack_require__(139);
	
		var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
		var Creatable = _react2['default'].createClass({
			displayName: 'CreatableSelect',
	
			propTypes: {
				// Child function responsible for creating the inner Select component
				// This component can be used to compose HOCs (eg Creatable and Async)
				// (props: Object): PropTypes.element
				children: _react2['default'].PropTypes.func,
	
				// See Select.propTypes.filterOptions
				filterOptions: _react2['default'].PropTypes.any,
	
				// Searches for any matching option within the set of options.
				// This function prevents duplicate options from being created.
				// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
				isOptionUnique: _react2['default'].PropTypes.func,
	
				// Determines if the current input text represents a valid option.
				// ({ label: string }): boolean
				isValidNewOption: _react2['default'].PropTypes.func,
	
				// See Select.propTypes.menuRenderer
				menuRenderer: _react2['default'].PropTypes.any,
	
				// Factory to create new option.
				// ({ label: string, labelKey: string, valueKey: string }): Object
				newOptionCreator: _react2['default'].PropTypes.func,
	
				// input change handler: function (inputValue) {}
				onInputChange: _react2['default'].PropTypes.func,
	
				// input keyDown handler: function (event) {}
				onInputKeyDown: _react2['default'].PropTypes.func,
	
				// new option click handler: function (option) {}
				onNewOptionClick: _react2['default'].PropTypes.func,
	
				// See Select.propTypes.options
				options: _react2['default'].PropTypes.array,
	
				// Creates prompt/placeholder option text.
				// (filterText: string): string
				promptTextCreator: _react2['default'].PropTypes.func,
	
				// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
				shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
			},
	
			// Default prop methods
			statics: {
				isOptionUnique: isOptionUnique,
				isValidNewOption: isValidNewOption,
				newOptionCreator: newOptionCreator,
				promptTextCreator: promptTextCreator,
				shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
			},
	
			getDefaultProps: function getDefaultProps() {
				return {
					filterOptions: _utilsDefaultFilterOptions2['default'],
					isOptionUnique: isOptionUnique,
					isValidNewOption: isValidNewOption,
					menuRenderer: _utilsDefaultMenuRenderer2['default'],
					newOptionCreator: newOptionCreator,
					promptTextCreator: promptTextCreator,
					shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
				};
			},
	
			createNewOption: function createNewOption() {
				var _props = this.props;
				var isValidNewOption = _props.isValidNewOption;
				var newOptionCreator = _props.newOptionCreator;
				var onNewOptionClick = _props.onNewOptionClick;
				var _props$options = _props.options;
				var options = _props$options === undefined ? [] : _props$options;
				var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			},
	
			filterOptions: function filterOptions() {
				var _props2 = this.props;
				var filterOptions = _props2.filterOptions;
				var isValidNewOption = _props2.isValidNewOption;
				var options = _props2.options;
				var promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
				var excludeOptions = arguments[2] || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var _prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: _prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			},
	
			isOptionUnique: function isOptionUnique(_ref2) {
				var option = _ref2.option;
				var options = _ref2.options;
				var isOptionUnique = this.props.isOptionUnique;
	
				options = options || this.select.filterOptions();
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			},
	
			menuRenderer: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			},
	
			onInputChange: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				if (onInputChange) {
					onInputChange(input);
				}
	
				// This value may be needed in between Select mounts (when this.select is null)
				this.inputValue = input;
			},
	
			onInputKeyDown: function onInputKeyDown(event) {
				var _props3 = this.props;
				var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
				var onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			},
	
			onOptionSelect: function onOptionSelect(option, event) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			},
	
			render: function render() {
				var _this = this;
	
				var _props4 = this.props;
				var newOptionCreator = _props4.newOptionCreator;
				var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;
	
				var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref) {
						_this.select = _ref;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref) {
							_this.labelKey = _ref.props.labelKey;
							_this.valueKey = _ref.props.valueKey;
						}
					}
				});
	
				return children(props);
			}
		});
	
		function defaultChildren(props) {
			return _react2['default'].createElement(_Select2['default'], props);
		};
	
		function isOptionUnique(_ref3) {
			var option = _ref3.option;
			var options = _ref3.options;
			var labelKey = _ref3.labelKey;
			var valueKey = _ref3.valueKey;
	
			return options.filter(function (existingOption) {
				return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
			}).length === 0;
		};
	
		function isValidNewOption(_ref4) {
			var label = _ref4.label;
	
			return !!label;
		};
	
		function newOptionCreator(_ref5) {
			var label = _ref5.label;
			var labelKey = _ref5.labelKey;
			var valueKey = _ref5.valueKey;
	
			var option = {};
			option[valueKey] = label;
			option[labelKey] = label;
			option.className = 'Select-create-option-placeholder';
			return option;
		};
	
		function promptTextCreator(label) {
			return 'Create option "' + label + '"';
		}
	
		function shouldKeyDownEventCreateNewOption(_ref6) {
			var keyCode = _ref6.keyCode;
	
			switch (keyCode) {
				case 9: // TAB
				case 13: // ENTER
				case 188:
					// COMMA
					return true;
			}
	
			return false;
		};
	
		module.exports = Creatable;
	
	/***/ },
	/* 389 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(51);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var Option = _react2['default'].createClass({
			displayName: 'Option',
	
			propTypes: {
				children: _react2['default'].PropTypes.node,
				className: _react2['default'].PropTypes.string, // className (based on mouse position)
				instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
				isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
				isFocused: _react2['default'].PropTypes.bool, // the option is focused
				isSelected: _react2['default'].PropTypes.bool, // the option is selected
				onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
				onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
				onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
				option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
				optionIndex: _react2['default'].PropTypes.number },
			// index of the option, used to generate unique ids for aria
			blockEvent: function blockEvent(event) {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.tagName !== 'A' || !('href' in event.target)) {
					return;
				}
				if (event.target.target) {
					window.open(event.target.href, event.target.target);
				} else {
					window.location.href = event.target.href;
				}
			},
	
			handleMouseDown: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			},
	
			handleMouseEnter: function handleMouseEnter(event) {
				this.onFocus(event);
			},
	
			handleMouseMove: function handleMouseMove(event) {
				this.onFocus(event);
			},
	
			handleTouchEnd: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			},
	
			handleTouchMove: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			},
	
			handleTouchStart: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			},
	
			onFocus: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			},
			render: function render() {
				var _props = this.props;
				var option = _props.option;
				var instancePrefix = _props.instancePrefix;
				var optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2['default'])(this.props.className, option.className);
	
				return option.disabled ? _react2['default'].createElement(
					'div',
					{ className: className,
						onMouseDown: this.blockEvent,
						onClick: this.blockEvent },
					this.props.children
				) : _react2['default'].createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		});
	
		module.exports = Option;
	
	/***/ },
	/* 390 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(51);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var Value = _react2['default'].createClass({
	
			displayName: 'Value',
	
			propTypes: {
				children: _react2['default'].PropTypes.node,
				disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
				id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
				onClick: _react2['default'].PropTypes.func, // method to handle click on value label
				onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
				value: _react2['default'].PropTypes.object.isRequired },
	
			// the option object for this value
			handleMouseDown: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			},
	
			onRemove: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			},
	
			handleTouchEndRemove: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			},
	
			handleTouchMove: function handleTouchMove(event) {
				// Set a flag that the view is being dragged
				this.dragging = true;
			},
	
			handleTouchStart: function handleTouchStart(event) {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			},
	
			renderRemoveIcon: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2['default'].createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'×'
				);
			},
	
			renderLabel: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2['default'].createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			},
	
			render: function render() {
				return _react2['default'].createElement(
					'div',
					{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
	
		});
	
		module.exports = Value;
	
	/***/ },
	/* 391 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		exports["default"] = arrowRenderer;
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function arrowRenderer(_ref) {
			var onMouseDown = _ref.onMouseDown;
	
			return _react2["default"].createElement("span", {
				className: "Select-arrow",
				onMouseDown: onMouseDown
			});
		}
	
		;
		module.exports = exports["default"];
	
	/***/ },
	/* 392 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
			value: true
		});
		exports['default'] = clearRenderer;
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function clearRenderer() {
			return _react2['default'].createElement('span', {
				className: 'Select-clear',
				dangerouslySetInnerHTML: { __html: '&times;' }
			});
		}
	
		;
		module.exports = exports['default'];
	
	/***/ },
	/* 393 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports['default'] = applyMiddleware;
	
		var _compose = __webpack_require__(141);
	
		var _compose2 = _interopRequireDefault(_compose);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		/**
		 * Creates a store enhancer that applies middleware to the dispatch method
		 * of the Redux store. This is handy for a variety of tasks, such as expressing
		 * asynchronous actions in a concise manner, or logging every action payload.
		 *
		 * See `redux-thunk` package as an example of the Redux middleware.
		 *
		 * Because middleware is potentially asynchronous, this should be the first
		 * store enhancer in the composition chain.
		 *
		 * Note that each middleware will be given the `dispatch` and `getState` functions
		 * as named arguments.
		 *
		 * @param {...Function} middlewares The middleware chain to be applied.
		 * @returns {Function} A store enhancer applying the middleware.
		 */
		function applyMiddleware() {
		  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
		    middlewares[_key] = arguments[_key];
		  }
	
		  return function (createStore) {
		    return function (reducer, preloadedState, enhancer) {
		      var store = createStore(reducer, preloadedState, enhancer);
		      var _dispatch = store.dispatch;
		      var chain = [];
	
		      var middlewareAPI = {
		        getState: store.getState,
		        dispatch: function dispatch(action) {
		          return _dispatch(action);
		        }
		      };
		      chain = middlewares.map(function (middleware) {
		        return middleware(middlewareAPI);
		      });
		      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
		      return _extends({}, store, {
		        dispatch: _dispatch
		      });
		    };
		  };
		}
	
	/***/ },
	/* 394 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = bindActionCreators;
		function bindActionCreator(actionCreator, dispatch) {
		  return function () {
		    return dispatch(actionCreator.apply(undefined, arguments));
		  };
		}
	
		/**
		 * Turns an object whose values are action creators, into an object with the
		 * same keys, but with every function wrapped into a `dispatch` call so they
		 * may be invoked directly. This is just a convenience method, as you can call
		 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
		 *
		 * For convenience, you can also pass a single function as the first argument,
		 * and get a function in return.
		 *
		 * @param {Function|Object} actionCreators An object whose values are action
		 * creator functions. One handy way to obtain it is to use ES6 `import * as`
		 * syntax. You may also pass a single function.
		 *
		 * @param {Function} dispatch The `dispatch` function available on your Redux
		 * store.
		 *
		 * @returns {Function|Object} The object mimicking the original object, but with
		 * every action creator wrapped into the `dispatch` call. If you passed a
		 * function as `actionCreators`, the return value will also be a single
		 * function.
		 */
		function bindActionCreators(actionCreators, dispatch) {
		  if (typeof actionCreators === 'function') {
		    return bindActionCreator(actionCreators, dispatch);
		  }
	
		  if (typeof actionCreators !== 'object' || actionCreators === null) {
		    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
		  }
	
		  var keys = Object.keys(actionCreators);
		  var boundActionCreators = {};
		  for (var i = 0; i < keys.length; i++) {
		    var key = keys[i];
		    var actionCreator = actionCreators[key];
		    if (typeof actionCreator === 'function') {
		      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
		    }
		  }
		  return boundActionCreators;
		}
	
	/***/ },
	/* 395 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = combineReducers;
	
		var _createStore = __webpack_require__(86);
	
		var _isPlainObject = __webpack_require__(15);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _warning = __webpack_require__(142);
	
		var _warning2 = _interopRequireDefault(_warning);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function getUndefinedStateErrorMessage(key, action) {
		  var actionType = action && action.type;
		  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
		  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
		}
	
		function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
		  var reducerKeys = Object.keys(reducers);
		  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
		  if (reducerKeys.length === 0) {
		    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
		  }
	
		  if (!(0, _isPlainObject2['default'])(inputState)) {
		    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
		  }
	
		  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
		    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
		  });
	
		  unexpectedKeys.forEach(function (key) {
		    unexpectedKeyCache[key] = true;
		  });
	
		  if (unexpectedKeys.length > 0) {
		    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
		  }
		}
	
		function assertReducerSanity(reducers) {
		  Object.keys(reducers).forEach(function (key) {
		    var reducer = reducers[key];
		    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
		    if (typeof initialState === 'undefined') {
		      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
		    }
	
		    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
		    if (typeof reducer(undefined, { type: type }) === 'undefined') {
		      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
		    }
		  });
		}
	
		/**
		 * Turns an object whose values are different reducer functions, into a single
		 * reducer function. It will call every child reducer, and gather their results
		 * into a single state object, whose keys correspond to the keys of the passed
		 * reducer functions.
		 *
		 * @param {Object} reducers An object whose values correspond to different
		 * reducer functions that need to be combined into one. One handy way to obtain
		 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
		 * undefined for any action. Instead, they should return their initial state
		 * if the state passed to them was undefined, and the current state for any
		 * unrecognized action.
		 *
		 * @returns {Function} A reducer function that invokes every reducer inside the
		 * passed object, and builds a state object with the same shape.
		 */
		function combineReducers(reducers) {
		  var reducerKeys = Object.keys(reducers);
		  var finalReducers = {};
		  for (var i = 0; i < reducerKeys.length; i++) {
		    var key = reducerKeys[i];
	
		    if (false) {
		      if (typeof reducers[key] === 'undefined') {
		        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
		      }
		    }
	
		    if (typeof reducers[key] === 'function') {
		      finalReducers[key] = reducers[key];
		    }
		  }
		  var finalReducerKeys = Object.keys(finalReducers);
	
		  if (false) {
		    var unexpectedKeyCache = {};
		  }
	
		  var sanityError;
		  try {
		    assertReducerSanity(finalReducers);
		  } catch (e) {
		    sanityError = e;
		  }
	
		  return function combination() {
		    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    var action = arguments[1];
	
		    if (sanityError) {
		      throw sanityError;
		    }
	
		    if (false) {
		      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
		      if (warningMessage) {
		        (0, _warning2['default'])(warningMessage);
		      }
		    }
	
		    var hasChanged = false;
		    var nextState = {};
		    for (var i = 0; i < finalReducerKeys.length; i++) {
		      var key = finalReducerKeys[i];
		      var reducer = finalReducers[key];
		      var previousStateForKey = state[key];
		      var nextStateForKey = reducer(previousStateForKey, action);
		      if (typeof nextStateForKey === 'undefined') {
		        var errorMessage = getUndefinedStateErrorMessage(key, action);
		        throw new Error(errorMessage);
		      }
		      nextState[key] = nextStateForKey;
		      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
		    }
		    return hasChanged ? nextState : state;
		  };
		}
	
	/***/ },
	/* 396 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
		var _createStore = __webpack_require__(86);
	
		var _createStore2 = _interopRequireDefault(_createStore);
	
		var _combineReducers = __webpack_require__(395);
	
		var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
		var _bindActionCreators = __webpack_require__(394);
	
		var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
		var _applyMiddleware = __webpack_require__(393);
	
		var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
		var _compose = __webpack_require__(141);
	
		var _compose2 = _interopRequireDefault(_compose);
	
		var _warning = __webpack_require__(142);
	
		var _warning2 = _interopRequireDefault(_warning);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		/*
		* This is a dummy function to check if the function name has been altered by minification.
		* If the function has been minified and NODE_ENV !== 'production', warn the user.
		*/
		function isCrushed() {}
	
		if (false) {
		  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
		}
	
		exports.createStore = _createStore2['default'];
		exports.combineReducers = _combineReducers2['default'];
		exports.bindActionCreators = _bindActionCreators2['default'];
		exports.applyMiddleware = _applyMiddleware2['default'];
		exports.compose = _compose2['default'];
	
	/***/ },
	/* 397 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.defaultMemoize = defaultMemoize;
		exports.createSelectorCreator = createSelectorCreator;
		exports.createStructuredSelector = createStructuredSelector;
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
		function defaultEqualityCheck(a, b) {
		  return a === b;
		}
	
		function defaultMemoize(func) {
		  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
	
		  var lastArgs = null;
		  var lastResult = null;
		  return function () {
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
	
		    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
		      return equalityCheck(value, lastArgs[index]);
		    })) {
		      lastResult = func.apply(undefined, args);
		    }
		    lastArgs = args;
		    return lastResult;
		  };
		}
	
		function getDependencies(funcs) {
		  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
		  if (!dependencies.every(function (dep) {
		    return typeof dep === 'function';
		  })) {
		    var dependencyTypes = dependencies.map(function (dep) {
		      return typeof dep;
		    }).join(', ');
		    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
		  }
	
		  return dependencies;
		}
	
		function createSelectorCreator(memoize) {
		  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		    memoizeOptions[_key2 - 1] = arguments[_key2];
		  }
	
		  return function () {
		    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		      funcs[_key3] = arguments[_key3];
		    }
	
		    var recomputations = 0;
		    var resultFunc = funcs.pop();
		    var dependencies = getDependencies(funcs);
	
		    var memoizedResultFunc = memoize.apply(undefined, [function () {
		      recomputations++;
		      return resultFunc.apply(undefined, arguments);
		    }].concat(memoizeOptions));
	
		    var selector = function selector(state, props) {
		      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
		        args[_key4 - 2] = arguments[_key4];
		      }
	
		      var params = dependencies.map(function (dependency) {
		        return dependency.apply(undefined, [state, props].concat(args));
		      });
		      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
		    };
	
		    selector.resultFunc = resultFunc;
		    selector.recomputations = function () {
		      return recomputations;
		    };
		    selector.resetRecomputations = function () {
		      return recomputations = 0;
		    };
		    return selector;
		  };
		}
	
		var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
		function createStructuredSelector(selectors) {
		  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
	
		  if (typeof selectors !== 'object') {
		    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
		  }
		  var objectKeys = Object.keys(selectors);
		  return selectorCreator(objectKeys.map(function (key) {
		    return selectors[key];
		  }), function () {
		    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		      values[_key5] = arguments[_key5];
		    }
	
		    return values.reduce(function (composition, value, index) {
		      composition[objectKeys[index]] = value;
		      return composition;
		    }, {});
		  });
		}
	
	/***/ },
	/* 398 */
	/***/ function(module, exports, __webpack_require__) {
	
		(function webpackUniversalModuleDefinition(root, factory) {
			if(true)
				module.exports = factory(__webpack_require__(2));
			else if(typeof define === 'function' && define.amd)
				define(["react"], factory);
			else if(typeof exports === 'object')
				exports["ReactAutocomplete"] = factory(require("react"));
			else
				root["ReactAutocomplete"] = factory(root["React"]);
		})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
		return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
	
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
	
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
	
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
	
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
	
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
	
	
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
	
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
	
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
	
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ function(module, exports, __webpack_require__) {
	
			"use strict";
	
			var React = __webpack_require__(1);
			var ReactDOM = __webpack_require__(2);
			var joinClasses = __webpack_require__(178);
	
			var Autocomplete = React.createClass({ displayName: "Autocomplete",
	
			  propTypes: {
			    options: React.PropTypes.any,
			    search: React.PropTypes.func,
			    resultRenderer: React.PropTypes.oneOfType([React.PropTypes.component, React.PropTypes.func]),
			    value: React.PropTypes.object,
			    onChange: React.PropTypes.func,
			    onError: React.PropTypes.func,
			    onFocus: React.PropTypes.func
			  },
	
			  getDefaultProps: function () {
			    return { search: searchArray };
			  },
	
			  getInitialState: function () {
			    var searchTerm = this.props.searchTerm ? this.props.searchTerm : this.props.value ? this.props.value.title : "";
			    return {
			      results: [],
			      showResults: false,
			      showResultsInProgress: false,
			      searchTerm: searchTerm,
			      focusedValue: null
			    };
			  },
	
			  getResultIdentifier: function (result) {
			    if (this.props.resultIdentifier === undefined) {
			      return result.id;
			    } else {
			      return result[this.props.resultIdentifier];
			    }
			  },
	
	
			  render: function () {
			    var className = joinClasses(this.props.className, "react-autocomplete-Autocomplete", this.state.showResults ? "react-autocomplete-Autocomplete--resultsShown" : undefined);
			    var style = {
			      position: "relative",
			      outline: "none"
			    };
			    return React.createElement("div", {
			      tabIndex: "1",
			      className: className,
			      onFocus: this.onFocus,
			      onBlur: this.onBlur,
			      style: style }, React.createElement("input", {
			      ref: "search",
			      className: "react-autocomplete-Autocomplete__search",
			      style: { width: "100%" },
			      onClick: this.showAllResults,
			      onChange: this.onQueryChange,
			      onFocus: this.onSearchInputFocus,
			      onBlur: this.onQueryBlur,
			      onKeyDown: this.onQueryKeyDown,
			      value: this.state.searchTerm }), React.createElement(Results, {
			      className: "react-autocomplete-Autocomplete__results",
			      onSelect: this.onValueChange,
			      onFocus: this.onValueFocus,
			      results: this.state.results,
			      focusedValue: this.state.focusedValue,
			      show: this.state.showResults,
			      renderer: this.props.resultRenderer,
			      label: this.props.label,
			      resultIdentifier: this.props.resultIdentifier }));
			  },
	
			  componentWillReceiveProps: function (nextProps) {
			    var searchTerm = nextProps.searchTerm ? nextProps.searchTerm : nextProps.value ? nextProps.value.title : "";
			    this.setState({ searchTerm: searchTerm });
			  },
	
			  componentWillMount: function () {
			    this.blurTimer = null;
			  },
	
			  /**
			    * Show results for a search term value.
			    *
			    * This method doesn't update search term value itself.
			    *
			    * @param {Search} searchTerm
			    */
			  showResults: function (searchTerm) {
			    this.setState({ showResultsInProgress: true });
			    this.props.search(this.props.options, searchTerm.trim(), this.onSearchComplete);
			  },
	
			  showAllResults: function () {
			    if (!this.state.showResultsInProgress && !this.state.showResults) {
			      this.showResults("");
			    }
			  },
	
			  onValueChange: function (value) {
			    var state = {
			      value: value,
			      showResults: false
			    };
	
			    if (value) {
			      state.searchTerm = value.title;
			    }
	
			    this.setState(state);
	
			    if (this.props.onChange) {
			      this.props.onChange(value);
			    }
			  },
	
			  onSearchComplete: function (err, results) {
			    if (err) {
			      if (this.props.onError) {
			        this.props.onError(err);
			      } else {
			        throw err;
			      }
			    }
	
			    this.setState({
			      showResultsInProgress: false,
			      showResults: true,
			      results: results
			    });
			  },
	
			  onValueFocus: function (value) {
			    this.setState({ focusedValue: value });
			  },
	
			  onQueryChange: function (e) {
			    var searchTerm = e.target.value;
			    this.setState({
			      searchTerm: searchTerm,
			      focusedValue: null
			    });
			    this.showResults(searchTerm);
			  },
	
			  onFocus: function () {
			    if (this.blurTimer) {
			      clearTimeout(this.blurTimer);
			      this.blurTimer = null;
			    }
			    this.refs.search.focus();
			  },
	
			  onSearchInputFocus: function () {
			    if (this.props.onFocus) {
			      this.props.onFocus();
			    }
	
			    this.showAllResults();
			  },
	
			  onBlur: function () {
			    // wrap in setTimeout so we can catch a click on results
			    this.blurTimer = setTimeout((function () {
			      if (this.isMounted()) {
			        this.setState({ showResults: false });
			      }
			    }).bind(this), 100);
			  },
	
			  onQueryKeyDown: function (e) {
			    if (e.key === "Enter") {
			      e.preventDefault();
			      if (this.state.focusedValue) {
			        this.onValueChange(this.state.focusedValue);
			      }
			    } else if (e.key === "ArrowUp" && this.state.showResults) {
			      e.preventDefault();
			      var prevIdx = Math.max(this.focusedValueIndex() - 1, 0);
			      this.setState({
			        focusedValue: this.state.results[prevIdx]
			      });
			    } else if (e.key === "ArrowDown") {
			      e.preventDefault();
			      if (this.state.showResults) {
			        var nextIdx = Math.min(this.focusedValueIndex() + (this.state.showResults ? 1 : 0), this.state.results.length - 1);
			        this.setState({
			          showResults: true,
			          focusedValue: this.state.results[nextIdx]
			        });
			      } else {
			        this.showAllResults();
			      }
			    }
			  },
	
			  focusedValueIndex: function () {
			    if (!this.state.focusedValue) {
			      return -1;
			    }
			    for (var i = 0, len = this.state.results.length; i < len; i++) {
			      if (this.getResultIdentifier(this.state.results[i]) === this.getResultIdentifier(this.state.focusedValue)) {
			        return i;
			      }
			    }
			    return -1;
			  }
			});
	
			var Results = React.createClass({ displayName: "Results",
	
			  getResultIdentifier: function (result) {
			    if (this.props.resultIdentifier === undefined) {
			      if (!result.id) {
			        throw Error("id property not found on result. You must specify a resultIdentifier and pass as props to autocomplete component");
			      }
			      return result.id;
			    } else {
			      return result[this.props.resultIdentifier];
			    }
			  },
	
			  render: function () {
			    var style = {
			      display: this.props.show ? "block" : "none",
			      position: "absolute",
			      listStyleType: "none"
			    };
			    var $__0 = this.props,
			        className = $__0.className,
			        props = (function (source, exclusion) {
			      var rest = {};var hasOwn = Object.prototype.hasOwnProperty;if (source == null) {
			        throw new TypeError();
			      }for (var key in source) {
			        if (hasOwn.call(source, key) && !hasOwn.call(exclusion, key)) {
			          rest[key] = source[key];
			        }
			      }return rest;
			    })($__0, { className: 1 });
	
			    return React.createElement("ul", { style: style, className: className + " react-autocomplete-Results" }, this.props.results.map(this.renderResult));
			  },
	
			  renderResult: function (result) {
			    var focused = this.props.focusedValue && this.getResultIdentifier(this.props.focusedValue) === this.getResultIdentifier(result);
			    var Renderer = this.props.renderer || Result;
			    return React.createElement(Renderer, {
			      ref: focused ? "focused" : undefined,
			      key: this.getResultIdentifier(result),
			      result: result,
			      focused: focused,
			      onMouseEnter: this.onMouseEnterResult,
			      onClick: this.props.onSelect,
			      label: this.props.label });
			  },
	
			  componentDidUpdate: function () {
			    this.scrollToFocused();
			  },
	
			  componentDidMount: function () {
			    this.scrollToFocused();
			  },
	
			  componentWillMount: function () {
			    this.ignoreFocus = false;
			  },
	
			  scrollToFocused: function () {
			    var focused = this.refs && this.refs.focused;
			    if (focused) {
			      var containerNode = ReactDOM.findDOMNode(this);
			      var scroll = containerNode.scrollTop;
			      var height = containerNode.offsetHeight;
	
			      var node = ReactDOM.findDOMNode(focused);
			      var top = node.offsetTop;
			      var bottom = top + node.offsetHeight;
	
			      // we update ignoreFocus to true if we change the scroll position so
			      // the mouseover event triggered because of that won't have an
			      // effect
			      if (top < scroll) {
			        this.ignoreFocus = true;
			        containerNode.scrollTop = top;
			      } else if (bottom - scroll > height) {
			        this.ignoreFocus = true;
			        containerNode.scrollTop = bottom - height;
			      }
			    }
			  },
	
			  onMouseEnterResult: function (e, result) {
			    // check if we need to prevent the next onFocus event because it was
			    // probably caused by a mouseover due to scroll position change
			    if (this.ignoreFocus) {
			      this.ignoreFocus = false;
			    } else {
			      // we need to make sure focused node is visible
			      // for some reason mouse events fire on visible nodes due to
			      // box-shadow
			      var containerNode = ReactDOM.findDOMNode(this);
			      var scroll = containerNode.scrollTop;
			      var height = containerNode.offsetHeight;
	
			      var node = e.target;
			      var top = node.offsetTop;
			      var bottom = top + node.offsetHeight;
	
			      if (bottom > scroll && top < scroll + height) {
			        this.props.onFocus(result);
			      }
			    }
			  }
			});
	
			var Result = React.createClass({ displayName: "Result",
	
			  getDefaultProps: function () {
			    return {
			      label: function (result) {
			        return result.title;
			      }
			    };
			  },
	
			  getLabel: function (result) {
			    if (typeof this.props.label === "function") {
			      return this.props.label(result);
			    } else if (typeof this.props.label === "string") {
			      return result[this.props.label];
			    }
			  },
	
			  render: function () {
			    var className = joinClasses({
			      "react-autocomplete-Result": true,
			      "react-autocomplete-Result--active": this.props.focused
			    });
	
			    return React.createElement("li", {
			      style: { listStyleType: "none" },
			      className: className,
			      onClick: this.onClick,
			      onMouseEnter: this.onMouseEnter }, React.createElement("a", null, this.getLabel(this.props.result)));
			  },
	
			  onClick: function () {
			    this.props.onClick(this.props.result);
			  },
	
			  onMouseEnter: function (e) {
			    if (this.props.onMouseEnter) {
			      this.props.onMouseEnter(e, this.props.result);
			    }
			  },
	
			  shouldComponentUpdate: function (nextProps) {
			    return nextProps.result.id !== this.props.result.id || nextProps.focused !== this.props.focused;
			  }
			});
	
			/**
			* Search options using specified search term treating options as an array
			* of candidates.
			*
			* @param {Array.<Object>} options
			* @param {String} searchTerm
			* @param {Callback} cb
			*/
			function searchArray(options, searchTerm, cb) {
			  if (!options) {
			    return cb(null, []);
			  }
	
			  searchTerm = new RegExp(searchTerm, "i");
	
			  var results = [];
	
			  for (var i = 0, len = options.length; i < len; i++) {
			    if (searchTerm.exec(options[i].title)) {
			      results.push(options[i]);
			    }
			  }
	
			  cb(null, results);
			}
	
			module.exports = Autocomplete;
	
		/***/ },
		/* 1 */
		/***/ function(module, exports) {
	
			module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
		/***/ },
		/* 2 */
		/***/ function(module, exports, __webpack_require__) {
	
			'use strict';
	
			module.exports = __webpack_require__(3);
	
	
		/***/ },
		/* 3 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
			'use strict';
	
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDefaultInjection = __webpack_require__(10);
			var ReactMount = __webpack_require__(166);
			var ReactReconciler = __webpack_require__(34);
			var ReactUpdates = __webpack_require__(31);
			var ReactVersion = __webpack_require__(171);
	
			var findDOMNode = __webpack_require__(172);
			var getHostComponentFromComposite = __webpack_require__(173);
			var renderSubtreeIntoContainer = __webpack_require__(174);
			var warning = __webpack_require__(18);
	
			ReactDefaultInjection.inject();
	
			var ReactDOM = {
			  findDOMNode: findDOMNode,
			  render: ReactMount.render,
			  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
			  version: ReactVersion,
	
			  /* eslint-disable camelcase */
			  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
			  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
			};
	
			// Inject the runtime into a devtools global hook regardless of browser.
			// Allows for debugging when the hook is injected on the page.
			if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
			  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
			    ComponentTree: {
			      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
			      getNodeFromInstance: function (inst) {
			        // inst is an internal instance (but could be a composite)
			        if (inst._renderedComponent) {
			          inst = getHostComponentFromComposite(inst);
			        }
			        if (inst) {
			          return ReactDOMComponentTree.getNodeFromInstance(inst);
			        } else {
			          return null;
			        }
			      }
			    },
			    Mount: ReactMount,
			    Reconciler: ReactReconciler
			  });
			}
	
			if (process.env.NODE_ENV !== 'production') {
			  var ExecutionEnvironment = __webpack_require__(22);
			  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
			    // First check if devtools is not installed
			    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
			      // If we're in Chrome or Firefox, provide a download link if not installed.
			      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
			        // Firefox does not have the issue with devtools loaded over file://
			        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
			        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
			      }
			    }
	
			    var testFunc = function testFn() {};
			    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
			    // If we're in IE8, check to see if we are in compatibility mode and provide
			    // information on preventing compatibility mode
			    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
			    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
			    var expectedFeatures = [
			    // shims
			    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
			    for (var i = 0; i < expectedFeatures.length; i++) {
			      if (!expectedFeatures[i]) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
			        break;
			      }
			    }
			  }
			}
	
			if (process.env.NODE_ENV !== 'production') {
			  var ReactInstrumentation = __webpack_require__(37);
			  var ReactDOMUnknownPropertyHook = __webpack_require__(175);
			  var ReactDOMNullInputValuePropHook = __webpack_require__(176);
			  var ReactDOMInvalidARIAHook = __webpack_require__(177);
	
			  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
			  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
			  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
			}
	
			module.exports = ReactDOM;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 4 */
		/***/ function(module, exports) {
	
			// shim for using process in browser
			var process = module.exports = {};
	
			// cached from whatever global is present so that test runners that stub it
			// don't break things.  But we need to wrap it in a try catch in case it is
			// wrapped in strict mode code which doesn't define any globals.  It's inside a
			// function because try/catches deoptimize in certain engines.
	
			var cachedSetTimeout;
			var cachedClearTimeout;
	
			function defaultSetTimout() {
			    throw new Error('setTimeout has not been defined');
			}
			function defaultClearTimeout () {
			    throw new Error('clearTimeout has not been defined');
			}
			(function () {
			    try {
			        if (typeof setTimeout === 'function') {
			            cachedSetTimeout = setTimeout;
			        } else {
			            cachedSetTimeout = defaultSetTimout;
			        }
			    } catch (e) {
			        cachedSetTimeout = defaultSetTimout;
			    }
			    try {
			        if (typeof clearTimeout === 'function') {
			            cachedClearTimeout = clearTimeout;
			        } else {
			            cachedClearTimeout = defaultClearTimeout;
			        }
			    } catch (e) {
			        cachedClearTimeout = defaultClearTimeout;
			    }
			} ())
			function runTimeout(fun) {
			    if (cachedSetTimeout === setTimeout) {
			        //normal enviroments in sane situations
			        return setTimeout(fun, 0);
			    }
			    // if setTimeout wasn't available but was latter defined
			    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
			        cachedSetTimeout = setTimeout;
			        return setTimeout(fun, 0);
			    }
			    try {
			        // when when somebody has screwed with setTimeout but no I.E. maddness
			        return cachedSetTimeout(fun, 0);
			    } catch(e){
			        try {
			            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
			            return cachedSetTimeout.call(null, fun, 0);
			        } catch(e){
			            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
			            return cachedSetTimeout.call(this, fun, 0);
			        }
			    }
	
	
			}
			function runClearTimeout(marker) {
			    if (cachedClearTimeout === clearTimeout) {
			        //normal enviroments in sane situations
			        return clearTimeout(marker);
			    }
			    // if clearTimeout wasn't available but was latter defined
			    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
			        cachedClearTimeout = clearTimeout;
			        return clearTimeout(marker);
			    }
			    try {
			        // when when somebody has screwed with setTimeout but no I.E. maddness
			        return cachedClearTimeout(marker);
			    } catch (e){
			        try {
			            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
			            return cachedClearTimeout.call(null, marker);
			        } catch (e){
			            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
			            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
			            return cachedClearTimeout.call(this, marker);
			        }
			    }
	
	
	
			}
			var queue = [];
			var draining = false;
			var currentQueue;
			var queueIndex = -1;
	
			function cleanUpNextTick() {
			    if (!draining || !currentQueue) {
			        return;
			    }
			    draining = false;
			    if (currentQueue.length) {
			        queue = currentQueue.concat(queue);
			    } else {
			        queueIndex = -1;
			    }
			    if (queue.length) {
			        drainQueue();
			    }
			}
	
			function drainQueue() {
			    if (draining) {
			        return;
			    }
			    var timeout = runTimeout(cleanUpNextTick);
			    draining = true;
	
			    var len = queue.length;
			    while(len) {
			        currentQueue = queue;
			        queue = [];
			        while (++queueIndex < len) {
			            if (currentQueue) {
			                currentQueue[queueIndex].run();
			            }
			        }
			        queueIndex = -1;
			        len = queue.length;
			    }
			    currentQueue = null;
			    draining = false;
			    runClearTimeout(timeout);
			}
	
			process.nextTick = function (fun) {
			    var args = new Array(arguments.length - 1);
			    if (arguments.length > 1) {
			        for (var i = 1; i < arguments.length; i++) {
			            args[i - 1] = arguments[i];
			        }
			    }
			    queue.push(new Item(fun, args));
			    if (queue.length === 1 && !draining) {
			        runTimeout(drainQueue);
			    }
			};
	
			// v8 likes predictible objects
			function Item(fun, array) {
			    this.fun = fun;
			    this.array = array;
			}
			Item.prototype.run = function () {
			    this.fun.apply(null, this.array);
			};
			process.title = 'browser';
			process.browser = true;
			process.env = {};
			process.argv = [];
			process.version = ''; // empty string to avoid regexp issues
			process.versions = {};
	
			function noop() {}
	
			process.on = noop;
			process.addListener = noop;
			process.once = noop;
			process.off = noop;
			process.removeListener = noop;
			process.removeAllListeners = noop;
			process.emit = noop;
	
			process.binding = function (name) {
			    throw new Error('process.binding is not supported');
			};
	
			process.cwd = function () { return '/' };
			process.chdir = function (dir) {
			    throw new Error('process.chdir is not supported');
			};
			process.umask = function() { return 0; };
	
	
		/***/ },
		/* 5 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var DOMProperty = __webpack_require__(7);
			var ReactDOMComponentFlags = __webpack_require__(9);
	
			var invariant = __webpack_require__(8);
	
			var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
			var Flags = ReactDOMComponentFlags;
	
			var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
			/**
			 * Check if a given node should be cached.
			 */
			function shouldPrecacheNode(node, nodeID) {
			  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
			}
	
			/**
			 * Drill down (through composites and empty components) until we get a host or
			 * host text component.
			 *
			 * This is pretty polymorphic but unavoidable with the current structure we have
			 * for `_renderedChildren`.
			 */
			function getRenderedHostOrTextFromComponent(component) {
			  var rendered;
			  while (rendered = component._renderedComponent) {
			    component = rendered;
			  }
			  return component;
			}
	
			/**
			 * Populate `_hostNode` on the rendered host/text component with the given
			 * DOM node. The passed `inst` can be a composite.
			 */
			function precacheNode(inst, node) {
			  var hostInst = getRenderedHostOrTextFromComponent(inst);
			  hostInst._hostNode = node;
			  node[internalInstanceKey] = hostInst;
			}
	
			function uncacheNode(inst) {
			  var node = inst._hostNode;
			  if (node) {
			    delete node[internalInstanceKey];
			    inst._hostNode = null;
			  }
			}
	
			/**
			 * Populate `_hostNode` on each child of `inst`, assuming that the children
			 * match up with the DOM (element) children of `node`.
			 *
			 * We cache entire levels at once to avoid an n^2 problem where we access the
			 * children of a node sequentially and have to walk from the start to our target
			 * node every time.
			 *
			 * Since we update `_renderedChildren` and the actual DOM at (slightly)
			 * different times, we could race here and see a newer `_renderedChildren` than
			 * the DOM nodes we see. To avoid this, ReactMultiChild calls
			 * `prepareToManageChildren` before we change `_renderedChildren`, at which
			 * time the container's child nodes are always cached (until it unmounts).
			 */
			function precacheChildNodes(inst, node) {
			  if (inst._flags & Flags.hasCachedChildNodes) {
			    return;
			  }
			  var children = inst._renderedChildren;
			  var childNode = node.firstChild;
			  outer: for (var name in children) {
			    if (!children.hasOwnProperty(name)) {
			      continue;
			    }
			    var childInst = children[name];
			    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
			    if (childID === 0) {
			      // We're currently unmounting this child in ReactMultiChild; skip it.
			      continue;
			    }
			    // We assume the child nodes are in the same order as the child instances.
			    for (; childNode !== null; childNode = childNode.nextSibling) {
			      if (shouldPrecacheNode(childNode, childID)) {
			        precacheNode(childInst, childNode);
			        continue outer;
			      }
			    }
			    // We reached the end of the DOM children without finding an ID match.
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
			  }
			  inst._flags |= Flags.hasCachedChildNodes;
			}
	
			/**
			 * Given a DOM node, return the closest ReactDOMComponent or
			 * ReactDOMTextComponent instance ancestor.
			 */
			function getClosestInstanceFromNode(node) {
			  if (node[internalInstanceKey]) {
			    return node[internalInstanceKey];
			  }
	
			  // Walk up the tree until we find an ancestor whose instance we have cached.
			  var parents = [];
			  while (!node[internalInstanceKey]) {
			    parents.push(node);
			    if (node.parentNode) {
			      node = node.parentNode;
			    } else {
			      // Top of the tree. This node must not be part of a React tree (or is
			      // unmounted, potentially).
			      return null;
			    }
			  }
	
			  var closest;
			  var inst;
			  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
			    closest = inst;
			    if (parents.length) {
			      precacheChildNodes(inst, node);
			    }
			  }
	
			  return closest;
			}
	
			/**
			 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
			 * instance, or null if the node was not rendered by this React.
			 */
			function getInstanceFromNode(node) {
			  var inst = getClosestInstanceFromNode(node);
			  if (inst != null && inst._hostNode === node) {
			    return inst;
			  } else {
			    return null;
			  }
			}
	
			/**
			 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
			 * DOM node.
			 */
			function getNodeFromInstance(inst) {
			  // Without this first invariant, passing a non-DOM-component triggers the next
			  // invariant for a missing parent, which is super confusing.
			  !(inst._hostNode !== undefined) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
			  if (inst._hostNode) {
			    return inst._hostNode;
			  }
	
			  // Walk up the tree until we find an ancestor whose DOM node we have cached.
			  var parents = [];
			  while (!inst._hostNode) {
			    parents.push(inst);
			    !inst._hostParent ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
			    inst = inst._hostParent;
			  }
	
			  // Now parents contains each ancestor that does *not* have a cached native
			  // node, and `inst` is the deepest ancestor that does.
			  for (; parents.length; inst = parents.pop()) {
			    precacheChildNodes(inst, inst._hostNode);
			  }
	
			  return inst._hostNode;
			}
	
			var ReactDOMComponentTree = {
			  getClosestInstanceFromNode: getClosestInstanceFromNode,
			  getInstanceFromNode: getInstanceFromNode,
			  getNodeFromInstance: getNodeFromInstance,
			  precacheChildNodes: precacheChildNodes,
			  precacheNode: precacheNode,
			  uncacheNode: uncacheNode
			};
	
			module.exports = ReactDOMComponentTree;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 6 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
			'use strict';
	
			/**
			 * WARNING: DO NOT manually require this module.
			 * This is a replacement for `invariant(...)` used by the error code system
			 * and will _only_ be required by the corresponding babel pass.
			 * It always throws.
			 */
	
			function reactProdInvariant(code) {
			  var argCount = arguments.length - 1;
	
			  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
			  for (var argIdx = 0; argIdx < argCount; argIdx++) {
			    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
			  }
	
			  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
			  var error = new Error(message);
			  error.name = 'Invariant Violation';
			  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
			  throw error;
			}
	
			module.exports = reactProdInvariant;
	
		/***/ },
		/* 7 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			function checkMask(value, bitmask) {
			  return (value & bitmask) === bitmask;
			}
	
			var DOMPropertyInjection = {
			  /**
			   * Mapping from normalized, camelcased property names to a configuration that
			   * specifies how the associated DOM property should be accessed or rendered.
			   */
			  MUST_USE_PROPERTY: 0x1,
			  HAS_BOOLEAN_VALUE: 0x4,
			  HAS_NUMERIC_VALUE: 0x8,
			  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
			  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
			  /**
			   * Inject some specialized knowledge about the DOM. This takes a config object
			   * with the following properties:
			   *
			   * isCustomAttribute: function that given an attribute name will return true
			   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
			   * attributes where it's impossible to enumerate all of the possible
			   * attribute names,
			   *
			   * Properties: object mapping DOM property name to one of the
			   * DOMPropertyInjection constants or null. If your attribute isn't in here,
			   * it won't get written to the DOM.
			   *
			   * DOMAttributeNames: object mapping React attribute name to the DOM
			   * attribute name. Attribute names not specified use the **lowercase**
			   * normalized name.
			   *
			   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
			   * attribute namespace URL. (Attribute names not specified use no namespace.)
			   *
			   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
			   * Property names not specified use the normalized name.
			   *
			   * DOMMutationMethods: Properties that require special mutation methods. If
			   * `value` is undefined, the mutation method should unset the property.
			   *
			   * @param {object} domPropertyConfig the config as described above.
			   */
			  injectDOMPropertyConfig: function (domPropertyConfig) {
			    var Injection = DOMPropertyInjection;
			    var Properties = domPropertyConfig.Properties || {};
			    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
			    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
			    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
			    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
			    if (domPropertyConfig.isCustomAttribute) {
			      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
			    }
	
			    for (var propName in Properties) {
			      !!DOMProperty.properties.hasOwnProperty(propName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
			      var lowerCased = propName.toLowerCase();
			      var propConfig = Properties[propName];
	
			      var propertyInfo = {
			        attributeName: lowerCased,
			        attributeNamespace: null,
			        propertyName: propName,
			        mutationMethod: null,
	
			        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
			        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
			        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
			        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
			        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
			      };
			      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
			      if (process.env.NODE_ENV !== 'production') {
			        DOMProperty.getPossibleStandardName[lowerCased] = propName;
			      }
	
			      if (DOMAttributeNames.hasOwnProperty(propName)) {
			        var attributeName = DOMAttributeNames[propName];
			        propertyInfo.attributeName = attributeName;
			        if (process.env.NODE_ENV !== 'production') {
			          DOMProperty.getPossibleStandardName[attributeName] = propName;
			        }
			      }
	
			      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
			        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
			      }
	
			      if (DOMPropertyNames.hasOwnProperty(propName)) {
			        propertyInfo.propertyName = DOMPropertyNames[propName];
			      }
	
			      if (DOMMutationMethods.hasOwnProperty(propName)) {
			        propertyInfo.mutationMethod = DOMMutationMethods[propName];
			      }
	
			      DOMProperty.properties[propName] = propertyInfo;
			    }
			  }
			};
	
			/* eslint-disable max-len */
			var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
			/* eslint-enable max-len */
	
			/**
			 * DOMProperty exports lookup objects that can be used like functions:
			 *
			 *   > DOMProperty.isValid['id']
			 *   true
			 *   > DOMProperty.isValid['foobar']
			 *   undefined
			 *
			 * Although this may be confusing, it performs better in general.
			 *
			 * @see http://jsperf.com/key-exists
			 * @see http://jsperf.com/key-missing
			 */
			var DOMProperty = {
	
			  ID_ATTRIBUTE_NAME: 'data-reactid',
			  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
			  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
			  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
			  /**
			   * Map from property "standard name" to an object with info about how to set
			   * the property in the DOM. Each object contains:
			   *
			   * attributeName:
			   *   Used when rendering markup or with `*Attribute()`.
			   * attributeNamespace
			   * propertyName:
			   *   Used on DOM node instances. (This includes properties that mutate due to
			   *   external factors.)
			   * mutationMethod:
			   *   If non-null, used instead of the property or `setAttribute()` after
			   *   initial render.
			   * mustUseProperty:
			   *   Whether the property must be accessed and mutated as an object property.
			   * hasBooleanValue:
			   *   Whether the property should be removed when set to a falsey value.
			   * hasNumericValue:
			   *   Whether the property must be numeric or parse as a numeric and should be
			   *   removed when set to a falsey value.
			   * hasPositiveNumericValue:
			   *   Whether the property must be positive numeric or parse as a positive
			   *   numeric and should be removed when set to a falsey value.
			   * hasOverloadedBooleanValue:
			   *   Whether the property can be used as a flag as well as with a value.
			   *   Removed when strictly equal to false; present without a value when
			   *   strictly equal to true; present with a value otherwise.
			   */
			  properties: {},
	
			  /**
			   * Mapping from lowercase property names to the properly cased version, used
			   * to warn in the case of missing properties. Available only in __DEV__.
			   *
			   * autofocus is predefined, because adding it to the property whitelist
			   * causes unintended side effects.
			   *
			   * @type {Object}
			   */
			  getPossibleStandardName: process.env.NODE_ENV !== 'production' ? { autofocus: 'autoFocus' } : null,
	
			  /**
			   * All of the isCustomAttribute() functions that have been injected.
			   */
			  _isCustomAttributeFunctions: [],
	
			  /**
			   * Checks whether a property name is a custom attribute.
			   * @method
			   */
			  isCustomAttribute: function (attributeName) {
			    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
			      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
			      if (isCustomAttributeFn(attributeName)) {
			        return true;
			      }
			    }
			    return false;
			  },
	
			  injection: DOMPropertyInjection
			};
	
			module.exports = DOMProperty;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 8 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Use invariant() to assert state which your program assumes to be true.
			 *
			 * Provide sprintf-style format (only %s is supported) and arguments
			 * to provide information about what broke and what you were
			 * expecting.
			 *
			 * The invariant message will be stripped in production, but the invariant
			 * will remain to ensure logic does not differ in production.
			 */
	
			var validateFormat = function validateFormat(format) {};
	
			if (process.env.NODE_ENV !== 'production') {
			  validateFormat = function validateFormat(format) {
			    if (format === undefined) {
			      throw new Error('invariant requires an error message argument');
			    }
			  };
			}
	
			function invariant(condition, format, a, b, c, d, e, f) {
			  validateFormat(format);
	
			  if (!condition) {
			    var error;
			    if (format === undefined) {
			      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
			    } else {
			      var args = [a, b, c, d, e, f];
			      var argIndex = 0;
			      error = new Error(format.replace(/%s/g, function () {
			        return args[argIndex++];
			      }));
			      error.name = 'Invariant Violation';
			    }
	
			    error.framesToPop = 1; // we don't care about invariant's own frame
			    throw error;
			  }
			}
	
			module.exports = invariant;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 9 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactDOMComponentFlags = {
			  hasCachedChildNodes: 1 << 0
			};
	
			module.exports = ReactDOMComponentFlags;
	
		/***/ },
		/* 10 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ARIADOMPropertyConfig = __webpack_require__(11);
			var BeforeInputEventPlugin = __webpack_require__(12);
			var ChangeEventPlugin = __webpack_require__(30);
			var DefaultEventPluginOrder = __webpack_require__(50);
			var EnterLeaveEventPlugin = __webpack_require__(51);
			var HTMLDOMPropertyConfig = __webpack_require__(56);
			var ReactComponentBrowserEnvironment = __webpack_require__(57);
			var ReactDOMComponent = __webpack_require__(70);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDOMEmptyComponent = __webpack_require__(137);
			var ReactDOMTreeTraversal = __webpack_require__(138);
			var ReactDOMTextComponent = __webpack_require__(139);
			var ReactDefaultBatchingStrategy = __webpack_require__(140);
			var ReactEventListener = __webpack_require__(141);
			var ReactInjection = __webpack_require__(144);
			var ReactReconcileTransaction = __webpack_require__(145);
			var SVGDOMPropertyConfig = __webpack_require__(153);
			var SelectEventPlugin = __webpack_require__(154);
			var SimpleEventPlugin = __webpack_require__(155);
	
			var alreadyInjected = false;
	
			function inject() {
			  if (alreadyInjected) {
			    // TODO: This is currently true because these injections are shared between
			    // the client and the server package. They should be built independently
			    // and not share any injection state. Then this problem will be solved.
			    return;
			  }
			  alreadyInjected = true;
	
			  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
			  /**
			   * Inject modules for resolving DOM hierarchy and plugin ordering.
			   */
			  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
			  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
			  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
			  /**
			   * Some important event plugins included by default (without having to require
			   * them).
			   */
			  ReactInjection.EventPluginHub.injectEventPluginsByName({
			    SimpleEventPlugin: SimpleEventPlugin,
			    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
			    ChangeEventPlugin: ChangeEventPlugin,
			    SelectEventPlugin: SelectEventPlugin,
			    BeforeInputEventPlugin: BeforeInputEventPlugin
			  });
	
			  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
			  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
			  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
			  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
			  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
			  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
			    return new ReactDOMEmptyComponent(instantiate);
			  });
	
			  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
			  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
			  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
			}
	
			module.exports = {
			  inject: inject
			};
	
		/***/ },
		/* 11 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ARIADOMPropertyConfig = {
			  Properties: {
			    // Global States and Properties
			    'aria-current': 0, // state
			    'aria-details': 0,
			    'aria-disabled': 0, // state
			    'aria-hidden': 0, // state
			    'aria-invalid': 0, // state
			    'aria-keyshortcuts': 0,
			    'aria-label': 0,
			    'aria-roledescription': 0,
			    // Widget Attributes
			    'aria-autocomplete': 0,
			    'aria-checked': 0,
			    'aria-expanded': 0,
			    'aria-haspopup': 0,
			    'aria-level': 0,
			    'aria-modal': 0,
			    'aria-multiline': 0,
			    'aria-multiselectable': 0,
			    'aria-orientation': 0,
			    'aria-placeholder': 0,
			    'aria-pressed': 0,
			    'aria-readonly': 0,
			    'aria-required': 0,
			    'aria-selected': 0,
			    'aria-sort': 0,
			    'aria-valuemax': 0,
			    'aria-valuemin': 0,
			    'aria-valuenow': 0,
			    'aria-valuetext': 0,
			    // Live Region Attributes
			    'aria-atomic': 0,
			    'aria-busy': 0,
			    'aria-live': 0,
			    'aria-relevant': 0,
			    // Drag-and-Drop Attributes
			    'aria-dropeffect': 0,
			    'aria-grabbed': 0,
			    // Relationship Attributes
			    'aria-activedescendant': 0,
			    'aria-colcount': 0,
			    'aria-colindex': 0,
			    'aria-colspan': 0,
			    'aria-controls': 0,
			    'aria-describedby': 0,
			    'aria-errormessage': 0,
			    'aria-flowto': 0,
			    'aria-labelledby': 0,
			    'aria-owns': 0,
			    'aria-posinset': 0,
			    'aria-rowcount': 0,
			    'aria-rowindex': 0,
			    'aria-rowspan': 0,
			    'aria-setsize': 0
			  },
			  DOMAttributeNames: {},
			  DOMPropertyNames: {}
			};
	
			module.exports = ARIADOMPropertyConfig;
	
		/***/ },
		/* 12 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPropagators = __webpack_require__(13);
			var ExecutionEnvironment = __webpack_require__(22);
			var FallbackCompositionState = __webpack_require__(23);
			var SyntheticCompositionEvent = __webpack_require__(27);
			var SyntheticInputEvent = __webpack_require__(29);
	
			var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
			var START_KEYCODE = 229;
	
			var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
			var documentMode = null;
			if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
			  documentMode = document.documentMode;
			}
	
			// Webkit offers a very useful `textInput` event that can be used to
			// directly represent `beforeInput`. The IE `textinput` event is not as
			// useful, so we don't use it.
			var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
			// In IE9+, we have access to composition events, but the data supplied
			// by the native compositionend event may be incorrect. Japanese ideographic
			// spaces, for instance (\u3000) are not recorded correctly.
			var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
			/**
			 * Opera <= 12 includes TextEvent in window, but does not fire
			 * text input events. Rely on keypress instead.
			 */
			function isPresto() {
			  var opera = window.opera;
			  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
			}
	
			var SPACEBAR_CODE = 32;
			var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
			// Events and their corresponding property names.
			var eventTypes = {
			  beforeInput: {
			    phasedRegistrationNames: {
			      bubbled: 'onBeforeInput',
			      captured: 'onBeforeInputCapture'
			    },
			    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
			  },
			  compositionEnd: {
			    phasedRegistrationNames: {
			      bubbled: 'onCompositionEnd',
			      captured: 'onCompositionEndCapture'
			    },
			    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
			  },
			  compositionStart: {
			    phasedRegistrationNames: {
			      bubbled: 'onCompositionStart',
			      captured: 'onCompositionStartCapture'
			    },
			    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
			  },
			  compositionUpdate: {
			    phasedRegistrationNames: {
			      bubbled: 'onCompositionUpdate',
			      captured: 'onCompositionUpdateCapture'
			    },
			    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
			  }
			};
	
			// Track whether we've ever handled a keypress on the space key.
			var hasSpaceKeypress = false;
	
			/**
			 * Return whether a native keypress event is assumed to be a command.
			 * This is required because Firefox fires `keypress` events for key commands
			 * (cut, copy, select-all, etc.) even though no character is inserted.
			 */
			function isKeypressCommand(nativeEvent) {
			  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
			  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
			  !(nativeEvent.ctrlKey && nativeEvent.altKey);
			}
	
			/**
			 * Translate native top level events into event types.
			 *
			 * @param {string} topLevelType
			 * @return {object}
			 */
			function getCompositionEventType(topLevelType) {
			  switch (topLevelType) {
			    case 'topCompositionStart':
			      return eventTypes.compositionStart;
			    case 'topCompositionEnd':
			      return eventTypes.compositionEnd;
			    case 'topCompositionUpdate':
			      return eventTypes.compositionUpdate;
			  }
			}
	
			/**
			 * Does our fallback best-guess model think this event signifies that
			 * composition has begun?
			 *
			 * @param {string} topLevelType
			 * @param {object} nativeEvent
			 * @return {boolean}
			 */
			function isFallbackCompositionStart(topLevelType, nativeEvent) {
			  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
			}
	
			/**
			 * Does our fallback mode think that this event is the end of composition?
			 *
			 * @param {string} topLevelType
			 * @param {object} nativeEvent
			 * @return {boolean}
			 */
			function isFallbackCompositionEnd(topLevelType, nativeEvent) {
			  switch (topLevelType) {
			    case 'topKeyUp':
			      // Command keys insert or clear IME input.
			      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
			    case 'topKeyDown':
			      // Expect IME keyCode on each keydown. If we get any other
			      // code we must have exited earlier.
			      return nativeEvent.keyCode !== START_KEYCODE;
			    case 'topKeyPress':
			    case 'topMouseDown':
			    case 'topBlur':
			      // Events are not possible without cancelling IME.
			      return true;
			    default:
			      return false;
			  }
			}
	
			/**
			 * Google Input Tools provides composition data via a CustomEvent,
			 * with the `data` property populated in the `detail` object. If this
			 * is available on the event object, use it. If not, this is a plain
			 * composition event and we have nothing special to extract.
			 *
			 * @param {object} nativeEvent
			 * @return {?string}
			 */
			function getDataFromCustomEvent(nativeEvent) {
			  var detail = nativeEvent.detail;
			  if (typeof detail === 'object' && 'data' in detail) {
			    return detail.data;
			  }
			  return null;
			}
	
			// Track the current IME composition fallback object, if any.
			var currentComposition = null;
	
			/**
			 * @return {?object} A SyntheticCompositionEvent.
			 */
			function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			  var eventType;
			  var fallbackData;
	
			  if (canUseCompositionEvent) {
			    eventType = getCompositionEventType(topLevelType);
			  } else if (!currentComposition) {
			    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
			      eventType = eventTypes.compositionStart;
			    }
			  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
			    eventType = eventTypes.compositionEnd;
			  }
	
			  if (!eventType) {
			    return null;
			  }
	
			  if (useFallbackCompositionData) {
			    // The current composition is stored statically and must not be
			    // overwritten while composition continues.
			    if (!currentComposition && eventType === eventTypes.compositionStart) {
			      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
			    } else if (eventType === eventTypes.compositionEnd) {
			      if (currentComposition) {
			        fallbackData = currentComposition.getData();
			      }
			    }
			  }
	
			  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
			  if (fallbackData) {
			    // Inject data generated from fallback path into the synthetic event.
			    // This matches the property of native CompositionEventInterface.
			    event.data = fallbackData;
			  } else {
			    var customData = getDataFromCustomEvent(nativeEvent);
			    if (customData !== null) {
			      event.data = customData;
			    }
			  }
	
			  EventPropagators.accumulateTwoPhaseDispatches(event);
			  return event;
			}
	
			/**
			 * @param {string} topLevelType Record from `EventConstants`.
			 * @param {object} nativeEvent Native browser event.
			 * @return {?string} The string corresponding to this `beforeInput` event.
			 */
			function getNativeBeforeInputChars(topLevelType, nativeEvent) {
			  switch (topLevelType) {
			    case 'topCompositionEnd':
			      return getDataFromCustomEvent(nativeEvent);
			    case 'topKeyPress':
			      /**
			       * If native `textInput` events are available, our goal is to make
			       * use of them. However, there is a special case: the spacebar key.
			       * In Webkit, preventing default on a spacebar `textInput` event
			       * cancels character insertion, but it *also* causes the browser
			       * to fall back to its default spacebar behavior of scrolling the
			       * page.
			       *
			       * Tracking at:
			       * https://code.google.com/p/chromium/issues/detail?id=355103
			       *
			       * To avoid this issue, use the keypress event as if no `textInput`
			       * event is available.
			       */
			      var which = nativeEvent.which;
			      if (which !== SPACEBAR_CODE) {
			        return null;
			      }
	
			      hasSpaceKeypress = true;
			      return SPACEBAR_CHAR;
	
			    case 'topTextInput':
			      // Record the characters to be added to the DOM.
			      var chars = nativeEvent.data;
	
			      // If it's a spacebar character, assume that we have already handled
			      // it at the keypress level and bail immediately. Android Chrome
			      // doesn't give us keycodes, so we need to blacklist it.
			      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
			        return null;
			      }
	
			      return chars;
	
			    default:
			      // For other native event types, do nothing.
			      return null;
			  }
			}
	
			/**
			 * For browsers that do not provide the `textInput` event, extract the
			 * appropriate string to use for SyntheticInputEvent.
			 *
			 * @param {string} topLevelType Record from `EventConstants`.
			 * @param {object} nativeEvent Native browser event.
			 * @return {?string} The fallback string for this `beforeInput` event.
			 */
			function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
			  // If we are currently composing (IME) and using a fallback to do so,
			  // try to extract the composed characters from the fallback object.
			  // If composition event is available, we extract a string only at
			  // compositionevent, otherwise extract it at fallback events.
			  if (currentComposition) {
			    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
			      var chars = currentComposition.getData();
			      FallbackCompositionState.release(currentComposition);
			      currentComposition = null;
			      return chars;
			    }
			    return null;
			  }
	
			  switch (topLevelType) {
			    case 'topPaste':
			      // If a paste event occurs after a keypress, throw out the input
			      // chars. Paste events should not lead to BeforeInput events.
			      return null;
			    case 'topKeyPress':
			      /**
			       * As of v27, Firefox may fire keypress events even when no character
			       * will be inserted. A few possibilities:
			       *
			       * - `which` is `0`. Arrow keys, Esc key, etc.
			       *
			       * - `which` is the pressed key code, but no char is available.
			       *   Ex: 'AltGr + d` in Polish. There is no modified character for
			       *   this key combination and no character is inserted into the
			       *   document, but FF fires the keypress for char code `100` anyway.
			       *   No `input` event will occur.
			       *
			       * - `which` is the pressed key code, but a command combination is
			       *   being used. Ex: `Cmd+C`. No character is inserted, and no
			       *   `input` event will occur.
			       */
			      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
			        return String.fromCharCode(nativeEvent.which);
			      }
			      return null;
			    case 'topCompositionEnd':
			      return useFallbackCompositionData ? null : nativeEvent.data;
			    default:
			      return null;
			  }
			}
	
			/**
			 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
			 * `textInput` or fallback behavior.
			 *
			 * @return {?object} A SyntheticInputEvent.
			 */
			function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			  var chars;
	
			  if (canUseTextInputEvent) {
			    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
			  } else {
			    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
			  }
	
			  // If no characters are being inserted, no BeforeInput event should
			  // be fired.
			  if (!chars) {
			    return null;
			  }
	
			  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
			  event.data = chars;
			  EventPropagators.accumulateTwoPhaseDispatches(event);
			  return event;
			}
	
			/**
			 * Create an `onBeforeInput` event to match
			 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
			 *
			 * This event plugin is based on the native `textInput` event
			 * available in Chrome, Safari, Opera, and IE. This event fires after
			 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
			 *
			 * `beforeInput` is spec'd but not implemented in any browsers, and
			 * the `input` event does not provide any useful information about what has
			 * actually been added, contrary to the spec. Thus, `textInput` is the best
			 * available event to identify the characters that have actually been inserted
			 * into the target node.
			 *
			 * This plugin is also responsible for emitting `composition` events, thus
			 * allowing us to share composition fallback code for both `beforeInput` and
			 * `composition` event types.
			 */
			var BeforeInputEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
			  }
			};
	
			module.exports = BeforeInputEventPlugin;
	
		/***/ },
		/* 13 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPluginHub = __webpack_require__(14);
			var EventPluginUtils = __webpack_require__(16);
	
			var accumulateInto = __webpack_require__(20);
			var forEachAccumulated = __webpack_require__(21);
			var warning = __webpack_require__(18);
	
			var getListener = EventPluginHub.getListener;
	
			/**
			 * Some event types have a notion of different registration names for different
			 * "phases" of propagation. This finds listeners by a given phase.
			 */
			function listenerAtPhase(inst, event, propagationPhase) {
			  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
			  return getListener(inst, registrationName);
			}
	
			/**
			 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
			 * here, allows us to not have to bind or create functions for each event.
			 * Mutating the event's members allows us to not have to create a wrapping
			 * "dispatch" object that pairs the event with the listener.
			 */
			function accumulateDirectionalDispatches(inst, phase, event) {
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
			  }
			  var listener = listenerAtPhase(inst, event, phase);
			  if (listener) {
			    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
			    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
			  }
			}
	
			/**
			 * Collect dispatches (must be entirely collected before dispatching - see unit
			 * tests). Lazily allocate the array to conserve memory.  We must loop through
			 * each event and perform the traversal for each one. We cannot perform a
			 * single traversal for the entire collection of events because each event may
			 * have a different target.
			 */
			function accumulateTwoPhaseDispatchesSingle(event) {
			  if (event && event.dispatchConfig.phasedRegistrationNames) {
			    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
			  }
			}
	
			/**
			 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
			 */
			function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
			  if (event && event.dispatchConfig.phasedRegistrationNames) {
			    var targetInst = event._targetInst;
			    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
			    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
			  }
			}
	
			/**
			 * Accumulates without regard to direction, does not look for phased
			 * registration names. Same as `accumulateDirectDispatchesSingle` but without
			 * requiring that the `dispatchMarker` be the same as the dispatched ID.
			 */
			function accumulateDispatches(inst, ignoredDirection, event) {
			  if (event && event.dispatchConfig.registrationName) {
			    var registrationName = event.dispatchConfig.registrationName;
			    var listener = getListener(inst, registrationName);
			    if (listener) {
			      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
			      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
			    }
			  }
			}
	
			/**
			 * Accumulates dispatches on an `SyntheticEvent`, but only for the
			 * `dispatchMarker`.
			 * @param {SyntheticEvent} event
			 */
			function accumulateDirectDispatchesSingle(event) {
			  if (event && event.dispatchConfig.registrationName) {
			    accumulateDispatches(event._targetInst, null, event);
			  }
			}
	
			function accumulateTwoPhaseDispatches(events) {
			  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
			}
	
			function accumulateTwoPhaseDispatchesSkipTarget(events) {
			  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
			}
	
			function accumulateEnterLeaveDispatches(leave, enter, from, to) {
			  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
			}
	
			function accumulateDirectDispatches(events) {
			  forEachAccumulated(events, accumulateDirectDispatchesSingle);
			}
	
			/**
			 * A small set of propagation patterns, each of which will accept a small amount
			 * of information, and generate a set of "dispatch ready event objects" - which
			 * are sets of events that have already been annotated with a set of dispatched
			 * listener functions/ids. The API is designed this way to discourage these
			 * propagation strategies from actually executing the dispatches, since we
			 * always want to collect the entire set of dispatches before executing event a
			 * single one.
			 *
			 * @constructor EventPropagators
			 */
			var EventPropagators = {
			  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
			  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
			  accumulateDirectDispatches: accumulateDirectDispatches,
			  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
			};
	
			module.exports = EventPropagators;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 14 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var EventPluginRegistry = __webpack_require__(15);
			var EventPluginUtils = __webpack_require__(16);
			var ReactErrorUtils = __webpack_require__(17);
	
			var accumulateInto = __webpack_require__(20);
			var forEachAccumulated = __webpack_require__(21);
			var invariant = __webpack_require__(8);
	
			/**
			 * Internal store for event listeners
			 */
			var listenerBank = {};
	
			/**
			 * Internal queue of events that have accumulated their dispatches and are
			 * waiting to have their dispatches executed.
			 */
			var eventQueue = null;
	
			/**
			 * Dispatches an event and releases it back into the pool, unless persistent.
			 *
			 * @param {?object} event Synthetic event to be dispatched.
			 * @param {boolean} simulated If the event is simulated (changes exn behavior)
			 * @private
			 */
			var executeDispatchesAndRelease = function (event, simulated) {
			  if (event) {
			    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
			    if (!event.isPersistent()) {
			      event.constructor.release(event);
			    }
			  }
			};
			var executeDispatchesAndReleaseSimulated = function (e) {
			  return executeDispatchesAndRelease(e, true);
			};
			var executeDispatchesAndReleaseTopLevel = function (e) {
			  return executeDispatchesAndRelease(e, false);
			};
	
			var getDictionaryKey = function (inst) {
			  // Prevents V8 performance issue:
			  // https://github.com/facebook/react/pull/7232
			  return '.' + inst._rootNodeID;
			};
	
			function isInteractive(tag) {
			  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
			}
	
			function shouldPreventMouseEvent(name, type, props) {
			  switch (name) {
			    case 'onClick':
			    case 'onClickCapture':
			    case 'onDoubleClick':
			    case 'onDoubleClickCapture':
			    case 'onMouseDown':
			    case 'onMouseDownCapture':
			    case 'onMouseMove':
			    case 'onMouseMoveCapture':
			    case 'onMouseUp':
			    case 'onMouseUpCapture':
			      return !!(props.disabled && isInteractive(type));
			    default:
			      return false;
			  }
			}
	
			/**
			 * This is a unified interface for event plugins to be installed and configured.
			 *
			 * Event plugins can implement the following properties:
			 *
			 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
			 *     Required. When a top-level event is fired, this method is expected to
			 *     extract synthetic events that will in turn be queued and dispatched.
			 *
			 *   `eventTypes` {object}
			 *     Optional, plugins that fire events must publish a mapping of registration
			 *     names that are used to register listeners. Values of this mapping must
			 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
			 *
			 *   `executeDispatch` {function(object, function, string)}
			 *     Optional, allows plugins to override how an event gets dispatched. By
			 *     default, the listener is simply invoked.
			 *
			 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
			 *
			 * @public
			 */
			var EventPluginHub = {
	
			  /**
			   * Methods for injecting dependencies.
			   */
			  injection: {
	
			    /**
			     * @param {array} InjectedEventPluginOrder
			     * @public
			     */
			    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
			    /**
			     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
			     */
			    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
			  },
	
			  /**
			   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
			   *
			   * @param {object} inst The instance, which is the source of events.
			   * @param {string} registrationName Name of listener (e.g. `onClick`).
			   * @param {function} listener The callback to store.
			   */
			  putListener: function (inst, registrationName, listener) {
			    !(typeof listener === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
			    var key = getDictionaryKey(inst);
			    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
			    bankForRegistrationName[key] = listener;
	
			    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
			    if (PluginModule && PluginModule.didPutListener) {
			      PluginModule.didPutListener(inst, registrationName, listener);
			    }
			  },
	
			  /**
			   * @param {object} inst The instance, which is the source of events.
			   * @param {string} registrationName Name of listener (e.g. `onClick`).
			   * @return {?function} The stored callback.
			   */
			  getListener: function (inst, registrationName) {
			    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
			    // live here; needs to be moved to a better place soon
			    var bankForRegistrationName = listenerBank[registrationName];
			    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
			      return null;
			    }
			    var key = getDictionaryKey(inst);
			    return bankForRegistrationName && bankForRegistrationName[key];
			  },
	
			  /**
			   * Deletes a listener from the registration bank.
			   *
			   * @param {object} inst The instance, which is the source of events.
			   * @param {string} registrationName Name of listener (e.g. `onClick`).
			   */
			  deleteListener: function (inst, registrationName) {
			    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
			    if (PluginModule && PluginModule.willDeleteListener) {
			      PluginModule.willDeleteListener(inst, registrationName);
			    }
	
			    var bankForRegistrationName = listenerBank[registrationName];
			    // TODO: This should never be null -- when is it?
			    if (bankForRegistrationName) {
			      var key = getDictionaryKey(inst);
			      delete bankForRegistrationName[key];
			    }
			  },
	
			  /**
			   * Deletes all listeners for the DOM element with the supplied ID.
			   *
			   * @param {object} inst The instance, which is the source of events.
			   */
			  deleteAllListeners: function (inst) {
			    var key = getDictionaryKey(inst);
			    for (var registrationName in listenerBank) {
			      if (!listenerBank.hasOwnProperty(registrationName)) {
			        continue;
			      }
	
			      if (!listenerBank[registrationName][key]) {
			        continue;
			      }
	
			      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
			      if (PluginModule && PluginModule.willDeleteListener) {
			        PluginModule.willDeleteListener(inst, registrationName);
			      }
	
			      delete listenerBank[registrationName][key];
			    }
			  },
	
			  /**
			   * Allows registered plugins an opportunity to extract events from top-level
			   * native browser events.
			   *
			   * @return {*} An accumulation of synthetic events.
			   * @internal
			   */
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    var events;
			    var plugins = EventPluginRegistry.plugins;
			    for (var i = 0; i < plugins.length; i++) {
			      // Not every plugin in the ordering may be loaded at runtime.
			      var possiblePlugin = plugins[i];
			      if (possiblePlugin) {
			        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
			        if (extractedEvents) {
			          events = accumulateInto(events, extractedEvents);
			        }
			      }
			    }
			    return events;
			  },
	
			  /**
			   * Enqueues a synthetic event that should be dispatched when
			   * `processEventQueue` is invoked.
			   *
			   * @param {*} events An accumulation of synthetic events.
			   * @internal
			   */
			  enqueueEvents: function (events) {
			    if (events) {
			      eventQueue = accumulateInto(eventQueue, events);
			    }
			  },
	
			  /**
			   * Dispatches all synthetic events on the event queue.
			   *
			   * @internal
			   */
			  processEventQueue: function (simulated) {
			    // Set `eventQueue` to null before processing it so that we can tell if more
			    // events get enqueued while processing.
			    var processingEventQueue = eventQueue;
			    eventQueue = null;
			    if (simulated) {
			      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
			    } else {
			      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
			    }
			    !!eventQueue ? process.env.NODE_ENV !== 'production' ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
			    // This would be a good time to rethrow if any of the event handlers threw.
			    ReactErrorUtils.rethrowCaughtError();
			  },
	
			  /**
			   * These are needed for tests only. Do not use!
			   */
			  __purge: function () {
			    listenerBank = {};
			  },
	
			  __getListenerBank: function () {
			    return listenerBank;
			  }
	
			};
	
			module.exports = EventPluginHub;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 15 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Injectable ordering of event plugins.
			 */
			var eventPluginOrder = null;
	
			/**
			 * Injectable mapping from names to event plugin modules.
			 */
			var namesToPlugins = {};
	
			/**
			 * Recomputes the plugin list using the injected plugins and plugin ordering.
			 *
			 * @private
			 */
			function recomputePluginOrdering() {
			  if (!eventPluginOrder) {
			    // Wait until an `eventPluginOrder` is injected.
			    return;
			  }
			  for (var pluginName in namesToPlugins) {
			    var pluginModule = namesToPlugins[pluginName];
			    var pluginIndex = eventPluginOrder.indexOf(pluginName);
			    !(pluginIndex > -1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
			    if (EventPluginRegistry.plugins[pluginIndex]) {
			      continue;
			    }
			    !pluginModule.extractEvents ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
			    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
			    var publishedEvents = pluginModule.eventTypes;
			    for (var eventName in publishedEvents) {
			      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
			    }
			  }
			}
	
			/**
			 * Publishes an event so that it can be dispatched by the supplied plugin.
			 *
			 * @param {object} dispatchConfig Dispatch configuration for the event.
			 * @param {object} PluginModule Plugin publishing the event.
			 * @return {boolean} True if the event was successfully published.
			 * @private
			 */
			function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
			  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
			  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
			  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
			  if (phasedRegistrationNames) {
			    for (var phaseName in phasedRegistrationNames) {
			      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
			        var phasedRegistrationName = phasedRegistrationNames[phaseName];
			        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
			      }
			    }
			    return true;
			  } else if (dispatchConfig.registrationName) {
			    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
			    return true;
			  }
			  return false;
			}
	
			/**
			 * Publishes a registration name that is used to identify dispatched events and
			 * can be used with `EventPluginHub.putListener` to register listeners.
			 *
			 * @param {string} registrationName Registration name to add.
			 * @param {object} PluginModule Plugin publishing the event.
			 * @private
			 */
			function publishRegistrationName(registrationName, pluginModule, eventName) {
			  !!EventPluginRegistry.registrationNameModules[registrationName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
			  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
			  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
			  if (process.env.NODE_ENV !== 'production') {
			    var lowerCasedName = registrationName.toLowerCase();
			    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
			    if (registrationName === 'onDoubleClick') {
			      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
			    }
			  }
			}
	
			/**
			 * Registers plugins so that they can extract and dispatch events.
			 *
			 * @see {EventPluginHub}
			 */
			var EventPluginRegistry = {
	
			  /**
			   * Ordered list of injected plugins.
			   */
			  plugins: [],
	
			  /**
			   * Mapping from event name to dispatch config
			   */
			  eventNameDispatchConfigs: {},
	
			  /**
			   * Mapping from registration name to plugin module
			   */
			  registrationNameModules: {},
	
			  /**
			   * Mapping from registration name to event name
			   */
			  registrationNameDependencies: {},
	
			  /**
			   * Mapping from lowercase registration names to the properly cased version,
			   * used to warn in the case of missing event handlers. Available
			   * only in __DEV__.
			   * @type {Object}
			   */
			  possibleRegistrationNames: process.env.NODE_ENV !== 'production' ? {} : null,
			  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
			  /**
			   * Injects an ordering of plugins (by plugin name). This allows the ordering
			   * to be decoupled from injection of the actual plugins so that ordering is
			   * always deterministic regardless of packaging, on-the-fly injection, etc.
			   *
			   * @param {array} InjectedEventPluginOrder
			   * @internal
			   * @see {EventPluginHub.injection.injectEventPluginOrder}
			   */
			  injectEventPluginOrder: function (injectedEventPluginOrder) {
			    !!eventPluginOrder ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
			    // Clone the ordering so it cannot be dynamically mutated.
			    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
			    recomputePluginOrdering();
			  },
	
			  /**
			   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
			   * in the ordering injected by `injectEventPluginOrder`.
			   *
			   * Plugins can be injected as part of page initialization or on-the-fly.
			   *
			   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
			   * @internal
			   * @see {EventPluginHub.injection.injectEventPluginsByName}
			   */
			  injectEventPluginsByName: function (injectedNamesToPlugins) {
			    var isOrderingDirty = false;
			    for (var pluginName in injectedNamesToPlugins) {
			      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
			        continue;
			      }
			      var pluginModule = injectedNamesToPlugins[pluginName];
			      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
			        !!namesToPlugins[pluginName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
			        namesToPlugins[pluginName] = pluginModule;
			        isOrderingDirty = true;
			      }
			    }
			    if (isOrderingDirty) {
			      recomputePluginOrdering();
			    }
			  },
	
			  /**
			   * Looks up the plugin for the supplied event.
			   *
			   * @param {object} event A synthetic event.
			   * @return {?object} The plugin that created the supplied event.
			   * @internal
			   */
			  getPluginModuleForEvent: function (event) {
			    var dispatchConfig = event.dispatchConfig;
			    if (dispatchConfig.registrationName) {
			      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
			    }
			    if (dispatchConfig.phasedRegistrationNames !== undefined) {
			      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
			      // that it is not undefined.
			      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
			      for (var phase in phasedRegistrationNames) {
			        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
			          continue;
			        }
			        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
			        if (pluginModule) {
			          return pluginModule;
			        }
			      }
			    }
			    return null;
			  },
	
			  /**
			   * Exposed for unit testing.
			   * @private
			   */
			  _resetEventPlugins: function () {
			    eventPluginOrder = null;
			    for (var pluginName in namesToPlugins) {
			      if (namesToPlugins.hasOwnProperty(pluginName)) {
			        delete namesToPlugins[pluginName];
			      }
			    }
			    EventPluginRegistry.plugins.length = 0;
	
			    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
			    for (var eventName in eventNameDispatchConfigs) {
			      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
			        delete eventNameDispatchConfigs[eventName];
			      }
			    }
	
			    var registrationNameModules = EventPluginRegistry.registrationNameModules;
			    for (var registrationName in registrationNameModules) {
			      if (registrationNameModules.hasOwnProperty(registrationName)) {
			        delete registrationNameModules[registrationName];
			      }
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
			      for (var lowerCasedName in possibleRegistrationNames) {
			        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
			          delete possibleRegistrationNames[lowerCasedName];
			        }
			      }
			    }
			  }
	
			};
	
			module.exports = EventPluginRegistry;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 16 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactErrorUtils = __webpack_require__(17);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			/**
			 * Injected dependencies:
			 */
	
			/**
			 * - `ComponentTree`: [required] Module that can convert between React instances
			 *   and actual node references.
			 */
			var ComponentTree;
			var TreeTraversal;
			var injection = {
			  injectComponentTree: function (Injected) {
			    ComponentTree = Injected;
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
			    }
			  },
			  injectTreeTraversal: function (Injected) {
			    TreeTraversal = Injected;
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
			    }
			  }
			};
	
			function isEndish(topLevelType) {
			  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
			}
	
			function isMoveish(topLevelType) {
			  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
			}
			function isStartish(topLevelType) {
			  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
			}
	
			var validateEventDispatches;
			if (process.env.NODE_ENV !== 'production') {
			  validateEventDispatches = function (event) {
			    var dispatchListeners = event._dispatchListeners;
			    var dispatchInstances = event._dispatchInstances;
	
			    var listenersIsArr = Array.isArray(dispatchListeners);
			    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
			    var instancesIsArr = Array.isArray(dispatchInstances);
			    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
			    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
			  };
			}
	
			/**
			 * Dispatch the event to the listener.
			 * @param {SyntheticEvent} event SyntheticEvent to handle
			 * @param {boolean} simulated If the event is simulated (changes exn behavior)
			 * @param {function} listener Application-level callback
			 * @param {*} inst Internal component instance
			 */
			function executeDispatch(event, simulated, listener, inst) {
			  var type = event.type || 'unknown-event';
			  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
			  if (simulated) {
			    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
			  } else {
			    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
			  }
			  event.currentTarget = null;
			}
	
			/**
			 * Standard/simple iteration through an event's collected dispatches.
			 */
			function executeDispatchesInOrder(event, simulated) {
			  var dispatchListeners = event._dispatchListeners;
			  var dispatchInstances = event._dispatchInstances;
			  if (process.env.NODE_ENV !== 'production') {
			    validateEventDispatches(event);
			  }
			  if (Array.isArray(dispatchListeners)) {
			    for (var i = 0; i < dispatchListeners.length; i++) {
			      if (event.isPropagationStopped()) {
			        break;
			      }
			      // Listeners and Instances are two parallel arrays that are always in sync.
			      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
			    }
			  } else if (dispatchListeners) {
			    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
			  }
			  event._dispatchListeners = null;
			  event._dispatchInstances = null;
			}
	
			/**
			 * Standard/simple iteration through an event's collected dispatches, but stops
			 * at the first dispatch execution returning true, and returns that id.
			 *
			 * @return {?string} id of the first dispatch execution who's listener returns
			 * true, or null if no listener returned true.
			 */
			function executeDispatchesInOrderStopAtTrueImpl(event) {
			  var dispatchListeners = event._dispatchListeners;
			  var dispatchInstances = event._dispatchInstances;
			  if (process.env.NODE_ENV !== 'production') {
			    validateEventDispatches(event);
			  }
			  if (Array.isArray(dispatchListeners)) {
			    for (var i = 0; i < dispatchListeners.length; i++) {
			      if (event.isPropagationStopped()) {
			        break;
			      }
			      // Listeners and Instances are two parallel arrays that are always in sync.
			      if (dispatchListeners[i](event, dispatchInstances[i])) {
			        return dispatchInstances[i];
			      }
			    }
			  } else if (dispatchListeners) {
			    if (dispatchListeners(event, dispatchInstances)) {
			      return dispatchInstances;
			    }
			  }
			  return null;
			}
	
			/**
			 * @see executeDispatchesInOrderStopAtTrueImpl
			 */
			function executeDispatchesInOrderStopAtTrue(event) {
			  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
			  event._dispatchInstances = null;
			  event._dispatchListeners = null;
			  return ret;
			}
	
			/**
			 * Execution of a "direct" dispatch - there must be at most one dispatch
			 * accumulated on the event or it is considered an error. It doesn't really make
			 * sense for an event with multiple dispatches (bubbled) to keep track of the
			 * return values at each dispatch execution, but it does tend to make sense when
			 * dealing with "direct" dispatches.
			 *
			 * @return {*} The return value of executing the single dispatch.
			 */
			function executeDirectDispatch(event) {
			  if (process.env.NODE_ENV !== 'production') {
			    validateEventDispatches(event);
			  }
			  var dispatchListener = event._dispatchListeners;
			  var dispatchInstance = event._dispatchInstances;
			  !!Array.isArray(dispatchListener) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
			  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
			  var res = dispatchListener ? dispatchListener(event) : null;
			  event.currentTarget = null;
			  event._dispatchListeners = null;
			  event._dispatchInstances = null;
			  return res;
			}
	
			/**
			 * @param {SyntheticEvent} event
			 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
			 */
			function hasDispatches(event) {
			  return !!event._dispatchListeners;
			}
	
			/**
			 * General utilities that are useful in creating custom Event Plugins.
			 */
			var EventPluginUtils = {
			  isEndish: isEndish,
			  isMoveish: isMoveish,
			  isStartish: isStartish,
	
			  executeDirectDispatch: executeDirectDispatch,
			  executeDispatchesInOrder: executeDispatchesInOrder,
			  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
			  hasDispatches: hasDispatches,
	
			  getInstanceFromNode: function (node) {
			    return ComponentTree.getInstanceFromNode(node);
			  },
			  getNodeFromInstance: function (node) {
			    return ComponentTree.getNodeFromInstance(node);
			  },
			  isAncestor: function (a, b) {
			    return TreeTraversal.isAncestor(a, b);
			  },
			  getLowestCommonAncestor: function (a, b) {
			    return TreeTraversal.getLowestCommonAncestor(a, b);
			  },
			  getParentInstance: function (inst) {
			    return TreeTraversal.getParentInstance(inst);
			  },
			  traverseTwoPhase: function (target, fn, arg) {
			    return TreeTraversal.traverseTwoPhase(target, fn, arg);
			  },
			  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
			    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
			  },
	
			  injection: injection
			};
	
			module.exports = EventPluginUtils;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 17 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var caughtError = null;
	
			/**
			 * Call a function while guarding against errors that happens within it.
			 *
			 * @param {String} name of the guard to use for logging or debugging
			 * @param {Function} func The function to invoke
			 * @param {*} a First argument
			 * @param {*} b Second argument
			 */
			function invokeGuardedCallback(name, func, a) {
			  try {
			    func(a);
			  } catch (x) {
			    if (caughtError === null) {
			      caughtError = x;
			    }
			  }
			}
	
			var ReactErrorUtils = {
			  invokeGuardedCallback: invokeGuardedCallback,
	
			  /**
			   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
			   * handler are sure to be rethrown by rethrowCaughtError.
			   */
			  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
			  /**
			   * During execution of guarded functions we will capture the first error which
			   * we will rethrow to be handled by the top level error handler.
			   */
			  rethrowCaughtError: function () {
			    if (caughtError) {
			      var error = caughtError;
			      caughtError = null;
			      throw error;
			    }
			  }
			};
	
			if (process.env.NODE_ENV !== 'production') {
			  /**
			   * To help development we can get better devtools integration by simulating a
			   * real browser event.
			   */
			  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
			    var fakeNode = document.createElement('react');
			    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
			      var boundFunc = func.bind(null, a);
			      var evtType = 'react-' + name;
			      fakeNode.addEventListener(evtType, boundFunc, false);
			      var evt = document.createEvent('Event');
			      // $FlowFixMe https://github.com/facebook/flow/issues/2336
			      evt.initEvent(evtType, false, false);
			      fakeNode.dispatchEvent(evt);
			      fakeNode.removeEventListener(evtType, boundFunc, false);
			    };
			  }
			}
	
			module.exports = ReactErrorUtils;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 18 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-2015, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyFunction = __webpack_require__(19);
	
			/**
			 * Similar to invariant but only logs a warning if the condition is not met.
			 * This can be used to log issues in development environments in critical
			 * paths. Removing the logging code for production environments will keep the
			 * same logic and follow the same code paths.
			 */
	
			var warning = emptyFunction;
	
			if (process.env.NODE_ENV !== 'production') {
			  (function () {
			    var printWarning = function printWarning(format) {
			      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			        args[_key - 1] = arguments[_key];
			      }
	
			      var argIndex = 0;
			      var message = 'Warning: ' + format.replace(/%s/g, function () {
			        return args[argIndex++];
			      });
			      if (typeof console !== 'undefined') {
			        console.error(message);
			      }
			      try {
			        // --- Welcome to debugging React ---
			        // This error was thrown as a convenience so that you can use this stack
			        // to find the callsite that caused this warning to fire.
			        throw new Error(message);
			      } catch (x) {}
			    };
	
			    warning = function warning(condition, format) {
			      if (format === undefined) {
			        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
			      }
	
			      if (format.indexOf('Failed Composite propType: ') === 0) {
			        return; // Ignore CompositeComponent proptype check.
			      }
	
			      if (!condition) {
			        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
			          args[_key2 - 2] = arguments[_key2];
			        }
	
			        printWarning.apply(undefined, [format].concat(args));
			      }
			    };
			  })();
			}
	
			module.exports = warning;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 19 */
		/***/ function(module, exports) {
	
			"use strict";
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			function makeEmptyFunction(arg) {
			  return function () {
			    return arg;
			  };
			}
	
			/**
			 * This function accepts and discards inputs; it has no side effects. This is
			 * primarily useful idiomatically for overridable function endpoints which
			 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
			 */
			var emptyFunction = function emptyFunction() {};
	
			emptyFunction.thatReturns = makeEmptyFunction;
			emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
			emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
			emptyFunction.thatReturnsNull = makeEmptyFunction(null);
			emptyFunction.thatReturnsThis = function () {
			  return this;
			};
			emptyFunction.thatReturnsArgument = function (arg) {
			  return arg;
			};
	
			module.exports = emptyFunction;
	
		/***/ },
		/* 20 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Accumulates items that must not be null or undefined into the first one. This
			 * is used to conserve memory by avoiding array allocations, and thus sacrifices
			 * API cleanness. Since `current` can be null before being passed in and not
			 * null after this function, make sure to assign it back to `current`:
			 *
			 * `a = accumulateInto(a, b);`
			 *
			 * This API should be sparingly used. Try `accumulate` for something cleaner.
			 *
			 * @return {*|array<*>} An accumulation of items.
			 */
	
			function accumulateInto(current, next) {
			  !(next != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
			  if (current == null) {
			    return next;
			  }
	
			  // Both are not empty. Warning: Never call x.concat(y) when you are not
			  // certain that x is an Array (x could be a string with concat method).
			  if (Array.isArray(current)) {
			    if (Array.isArray(next)) {
			      current.push.apply(current, next);
			      return current;
			    }
			    current.push(next);
			    return current;
			  }
	
			  if (Array.isArray(next)) {
			    // A bit too dangerous to mutate `next`.
			    return [current].concat(next);
			  }
	
			  return [current, next];
			}
	
			module.exports = accumulateInto;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 21 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * @param {array} arr an "accumulation" of items which is either an Array or
			 * a single item. Useful when paired with the `accumulate` module. This is a
			 * simple utility that allows us to reason about a collection of items, but
			 * handling the case when there is exactly one item (and we do not need to
			 * allocate an array).
			 */
	
			function forEachAccumulated(arr, cb, scope) {
			  if (Array.isArray(arr)) {
			    arr.forEach(cb, scope);
			  } else if (arr) {
			    cb.call(scope, arr);
			  }
			}
	
			module.exports = forEachAccumulated;
	
		/***/ },
		/* 22 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
			/**
			 * Simple, lightweight module assisting with the detection and context of
			 * Worker. Helps avoid circular dependencies and allows code to reason about
			 * whether or not they are in a Worker, even if they never include the main
			 * `ReactWorker` dependency.
			 */
			var ExecutionEnvironment = {
	
			  canUseDOM: canUseDOM,
	
			  canUseWorkers: typeof Worker !== 'undefined',
	
			  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			  canUseViewport: canUseDOM && !!window.screen,
	
			  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
			};
	
			module.exports = ExecutionEnvironment;
	
		/***/ },
		/* 23 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var PooledClass = __webpack_require__(25);
	
			var getTextContentAccessor = __webpack_require__(26);
	
			/**
			 * This helper class stores information about text content of a target node,
			 * allowing comparison of content before and after a given event.
			 *
			 * Identify the node where selection currently begins, then observe
			 * both its text content and its current position in the DOM. Since the
			 * browser may natively replace the target node during composition, we can
			 * use its position to find its replacement.
			 *
			 * @param {DOMEventTarget} root
			 */
			function FallbackCompositionState(root) {
			  this._root = root;
			  this._startText = this.getText();
			  this._fallbackText = null;
			}
	
			_assign(FallbackCompositionState.prototype, {
			  destructor: function () {
			    this._root = null;
			    this._startText = null;
			    this._fallbackText = null;
			  },
	
			  /**
			   * Get current text of input.
			   *
			   * @return {string}
			   */
			  getText: function () {
			    if ('value' in this._root) {
			      return this._root.value;
			    }
			    return this._root[getTextContentAccessor()];
			  },
	
			  /**
			   * Determine the differing substring between the initially stored
			   * text content and the current content.
			   *
			   * @return {string}
			   */
			  getData: function () {
			    if (this._fallbackText) {
			      return this._fallbackText;
			    }
	
			    var start;
			    var startValue = this._startText;
			    var startLength = startValue.length;
			    var end;
			    var endValue = this.getText();
			    var endLength = endValue.length;
	
			    for (start = 0; start < startLength; start++) {
			      if (startValue[start] !== endValue[start]) {
			        break;
			      }
			    }
	
			    var minEnd = startLength - start;
			    for (end = 1; end <= minEnd; end++) {
			      if (startValue[startLength - end] !== endValue[endLength - end]) {
			        break;
			      }
			    }
	
			    var sliceTail = end > 1 ? 1 - end : undefined;
			    this._fallbackText = endValue.slice(start, sliceTail);
			    return this._fallbackText;
			  }
			});
	
			PooledClass.addPoolingTo(FallbackCompositionState);
	
			module.exports = FallbackCompositionState;
	
		/***/ },
		/* 24 */
		/***/ function(module, exports) {
	
			/*
			object-assign
			(c) Sindre Sorhus
			@license MIT
			*/
	
			'use strict';
			/* eslint-disable no-unused-vars */
			var getOwnPropertySymbols = Object.getOwnPropertySymbols;
			var hasOwnProperty = Object.prototype.hasOwnProperty;
			var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
			function toObject(val) {
				if (val === null || val === undefined) {
					throw new TypeError('Object.assign cannot be called with null or undefined');
				}
	
				return Object(val);
			}
	
			function shouldUseNative() {
				try {
					if (!Object.assign) {
						return false;
					}
	
					// Detect buggy property enumeration order in older V8 versions.
	
					// https://bugs.chromium.org/p/v8/issues/detail?id=4118
					var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
					test1[5] = 'de';
					if (Object.getOwnPropertyNames(test1)[0] === '5') {
						return false;
					}
	
					// https://bugs.chromium.org/p/v8/issues/detail?id=3056
					var test2 = {};
					for (var i = 0; i < 10; i++) {
						test2['_' + String.fromCharCode(i)] = i;
					}
					var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
						return test2[n];
					});
					if (order2.join('') !== '0123456789') {
						return false;
					}
	
					// https://bugs.chromium.org/p/v8/issues/detail?id=3056
					var test3 = {};
					'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
						test3[letter] = letter;
					});
					if (Object.keys(Object.assign({}, test3)).join('') !==
							'abcdefghijklmnopqrst') {
						return false;
					}
	
					return true;
				} catch (err) {
					// We don't expect any of the above to throw, but better to be safe.
					return false;
				}
			}
	
			module.exports = shouldUseNative() ? Object.assign : function (target, source) {
				var from;
				var to = toObject(target);
				var symbols;
	
				for (var s = 1; s < arguments.length; s++) {
					from = Object(arguments[s]);
	
					for (var key in from) {
						if (hasOwnProperty.call(from, key)) {
							to[key] = from[key];
						}
					}
	
					if (getOwnPropertySymbols) {
						symbols = getOwnPropertySymbols(from);
						for (var i = 0; i < symbols.length; i++) {
							if (propIsEnumerable.call(from, symbols[i])) {
								to[symbols[i]] = from[symbols[i]];
							}
						}
					}
				}
	
				return to;
			};
	
	
		/***/ },
		/* 25 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Static poolers. Several custom versions for each potential number of
			 * arguments. A completely generic pooler is easy to implement, but would
			 * require accessing the `arguments` object. In each of these, `this` refers to
			 * the Class itself, not an instance. If any others are needed, simply add them
			 * here, or in their own files.
			 */
			var oneArgumentPooler = function (copyFieldsFrom) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, copyFieldsFrom);
			    return instance;
			  } else {
			    return new Klass(copyFieldsFrom);
			  }
			};
	
			var twoArgumentPooler = function (a1, a2) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2);
			    return instance;
			  } else {
			    return new Klass(a1, a2);
			  }
			};
	
			var threeArgumentPooler = function (a1, a2, a3) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2, a3);
			    return instance;
			  } else {
			    return new Klass(a1, a2, a3);
			  }
			};
	
			var fourArgumentPooler = function (a1, a2, a3, a4) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2, a3, a4);
			    return instance;
			  } else {
			    return new Klass(a1, a2, a3, a4);
			  }
			};
	
			var standardReleaser = function (instance) {
			  var Klass = this;
			  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
			  instance.destructor();
			  if (Klass.instancePool.length < Klass.poolSize) {
			    Klass.instancePool.push(instance);
			  }
			};
	
			var DEFAULT_POOL_SIZE = 10;
			var DEFAULT_POOLER = oneArgumentPooler;
	
			/**
			 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
			 * itself (statically) not adding any prototypical fields. Any CopyConstructor
			 * you give this may have a `poolSize` property, and will look for a
			 * prototypical `destructor` on instances.
			 *
			 * @param {Function} CopyConstructor Constructor that can be used to reset.
			 * @param {Function} pooler Customizable pooler.
			 */
			var addPoolingTo = function (CopyConstructor, pooler) {
			  // Casting as any so that flow ignores the actual implementation and trusts
			  // it to match the type we declared
			  var NewKlass = CopyConstructor;
			  NewKlass.instancePool = [];
			  NewKlass.getPooled = pooler || DEFAULT_POOLER;
			  if (!NewKlass.poolSize) {
			    NewKlass.poolSize = DEFAULT_POOL_SIZE;
			  }
			  NewKlass.release = standardReleaser;
			  return NewKlass;
			};
	
			var PooledClass = {
			  addPoolingTo: addPoolingTo,
			  oneArgumentPooler: oneArgumentPooler,
			  twoArgumentPooler: twoArgumentPooler,
			  threeArgumentPooler: threeArgumentPooler,
			  fourArgumentPooler: fourArgumentPooler
			};
	
			module.exports = PooledClass;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 26 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var contentKey = null;
	
			/**
			 * Gets the key used to access text content on a DOM node.
			 *
			 * @return {?string} Key used to access text content.
			 * @internal
			 */
			function getTextContentAccessor() {
			  if (!contentKey && ExecutionEnvironment.canUseDOM) {
			    // Prefer textContent to innerText because many browsers support both but
			    // SVG <text> elements don't support innerText even when <div> does.
			    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
			  }
			  return contentKey;
			}
	
			module.exports = getTextContentAccessor;
	
		/***/ },
		/* 27 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
			 */
			var CompositionEventInterface = {
			  data: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
			module.exports = SyntheticCompositionEvent;
	
		/***/ },
		/* 28 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var PooledClass = __webpack_require__(25);
	
			var emptyFunction = __webpack_require__(19);
			var warning = __webpack_require__(18);
	
			var didWarnForAddedNewProperty = false;
			var isProxySupported = typeof Proxy === 'function';
	
			var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var EventInterface = {
			  type: null,
			  target: null,
			  // currentTarget is set when dispatching; no use in copying it here
			  currentTarget: emptyFunction.thatReturnsNull,
			  eventPhase: null,
			  bubbles: null,
			  cancelable: null,
			  timeStamp: function (event) {
			    return event.timeStamp || Date.now();
			  },
			  defaultPrevented: null,
			  isTrusted: null
			};
	
			/**
			 * Synthetic events are dispatched by event plugins, typically in response to a
			 * top-level event delegation handler.
			 *
			 * These systems should generally use pooling to reduce the frequency of garbage
			 * collection. The system should check `isPersistent` to determine whether the
			 * event should be released into the pool after being dispatched. Users that
			 * need a persisted event should invoke `persist`.
			 *
			 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
			 * normalizing browser quirks. Subclasses do not necessarily have to implement a
			 * DOM interface; custom application-specific events can also subclass this.
			 *
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {*} targetInst Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @param {DOMEventTarget} nativeEventTarget Target node.
			 */
			function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
			  if (process.env.NODE_ENV !== 'production') {
			    // these have a getter/setter for warnings
			    delete this.nativeEvent;
			    delete this.preventDefault;
			    delete this.stopPropagation;
			  }
	
			  this.dispatchConfig = dispatchConfig;
			  this._targetInst = targetInst;
			  this.nativeEvent = nativeEvent;
	
			  var Interface = this.constructor.Interface;
			  for (var propName in Interface) {
			    if (!Interface.hasOwnProperty(propName)) {
			      continue;
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      delete this[propName]; // this has a getter/setter for warnings
			    }
			    var normalize = Interface[propName];
			    if (normalize) {
			      this[propName] = normalize(nativeEvent);
			    } else {
			      if (propName === 'target') {
			        this.target = nativeEventTarget;
			      } else {
			        this[propName] = nativeEvent[propName];
			      }
			    }
			  }
	
			  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
			  if (defaultPrevented) {
			    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
			  } else {
			    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
			  }
			  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
			  return this;
			}
	
			_assign(SyntheticEvent.prototype, {
	
			  preventDefault: function () {
			    this.defaultPrevented = true;
			    var event = this.nativeEvent;
			    if (!event) {
			      return;
			    }
	
			    if (event.preventDefault) {
			      event.preventDefault();
			    } else if (typeof event.returnValue !== 'unknown') {
			      // eslint-disable-line valid-typeof
			      event.returnValue = false;
			    }
			    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
			  },
	
			  stopPropagation: function () {
			    var event = this.nativeEvent;
			    if (!event) {
			      return;
			    }
	
			    if (event.stopPropagation) {
			      event.stopPropagation();
			    } else if (typeof event.cancelBubble !== 'unknown') {
			      // eslint-disable-line valid-typeof
			      // The ChangeEventPlugin registers a "propertychange" event for
			      // IE. This event does not support bubbling or cancelling, and
			      // any references to cancelBubble throw "Member not found".  A
			      // typeof check of "unknown" circumvents this issue (and is also
			      // IE specific).
			      event.cancelBubble = true;
			    }
	
			    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
			  },
	
			  /**
			   * We release all dispatched `SyntheticEvent`s after each event loop, adding
			   * them back into the pool. This allows a way to hold onto a reference that
			   * won't be added back into the pool.
			   */
			  persist: function () {
			    this.isPersistent = emptyFunction.thatReturnsTrue;
			  },
	
			  /**
			   * Checks if this event should be released back into the pool.
			   *
			   * @return {boolean} True if this should not be released, false otherwise.
			   */
			  isPersistent: emptyFunction.thatReturnsFalse,
	
			  /**
			   * `PooledClass` looks for `destructor` on each instance it releases.
			   */
			  destructor: function () {
			    var Interface = this.constructor.Interface;
			    for (var propName in Interface) {
			      if (process.env.NODE_ENV !== 'production') {
			        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
			      } else {
			        this[propName] = null;
			      }
			    }
			    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
			      this[shouldBeReleasedProperties[i]] = null;
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
			      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
			      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
			    }
			  }
	
			});
	
			SyntheticEvent.Interface = EventInterface;
	
			if (process.env.NODE_ENV !== 'production') {
			  if (isProxySupported) {
			    /*eslint-disable no-func-assign */
			    SyntheticEvent = new Proxy(SyntheticEvent, {
			      construct: function (target, args) {
			        return this.apply(target, Object.create(target.prototype), args);
			      },
			      apply: function (constructor, that, args) {
			        return new Proxy(constructor.apply(that, args), {
			          set: function (target, prop, value) {
			            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
			              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
			              didWarnForAddedNewProperty = true;
			            }
			            target[prop] = value;
			            return true;
			          }
			        });
			      }
			    });
			    /*eslint-enable no-func-assign */
			  }
			}
			/**
			 * Helper to reduce boilerplate when creating subclasses.
			 *
			 * @param {function} Class
			 * @param {?object} Interface
			 */
			SyntheticEvent.augmentClass = function (Class, Interface) {
			  var Super = this;
	
			  var E = function () {};
			  E.prototype = Super.prototype;
			  var prototype = new E();
	
			  _assign(prototype, Class.prototype);
			  Class.prototype = prototype;
			  Class.prototype.constructor = Class;
	
			  Class.Interface = _assign({}, Super.Interface, Interface);
			  Class.augmentClass = Super.augmentClass;
	
			  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
			};
	
			PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
			module.exports = SyntheticEvent;
	
			/**
			  * Helper to nullify syntheticEvent instance properties when destructing
			  *
			  * @param {object} SyntheticEvent
			  * @param {String} propName
			  * @return {object} defineProperty object
			  */
			function getPooledWarningPropertyDefinition(propName, getVal) {
			  var isFunction = typeof getVal === 'function';
			  return {
			    configurable: true,
			    set: set,
			    get: get
			  };
	
			  function set(val) {
			    var action = isFunction ? 'setting the method' : 'setting the property';
			    warn(action, 'This is effectively a no-op');
			    return val;
			  }
	
			  function get() {
			    var action = isFunction ? 'accessing the method' : 'accessing the property';
			    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
			    warn(action, result);
			    return getVal;
			  }
	
			  function warn(action, result) {
			    var warningCondition = false;
			    process.env.NODE_ENV !== 'production' ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
			  }
			}
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 29 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
			 *      /#events-inputevents
			 */
			var InputEventInterface = {
			  data: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
			module.exports = SyntheticInputEvent;
	
		/***/ },
		/* 30 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPluginHub = __webpack_require__(14);
			var EventPropagators = __webpack_require__(13);
			var ExecutionEnvironment = __webpack_require__(22);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
			var SyntheticEvent = __webpack_require__(28);
	
			var getEventTarget = __webpack_require__(47);
			var isEventSupported = __webpack_require__(48);
			var isTextInputElement = __webpack_require__(49);
	
			var eventTypes = {
			  change: {
			    phasedRegistrationNames: {
			      bubbled: 'onChange',
			      captured: 'onChangeCapture'
			    },
			    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
			  }
			};
	
			/**
			 * For IE shims
			 */
			var activeElement = null;
			var activeElementInst = null;
			var activeElementValue = null;
			var activeElementValueProp = null;
	
			/**
			 * SECTION: handle `change` event
			 */
			function shouldUseChangeEvent(elem) {
			  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
			  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
			}
	
			var doesChangeEventBubble = false;
			if (ExecutionEnvironment.canUseDOM) {
			  // See `handleChange` comment below
			  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
			}
	
			function manualDispatchChangeEvent(nativeEvent) {
			  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
			  EventPropagators.accumulateTwoPhaseDispatches(event);
	
			  // If change and propertychange bubbled, we'd just bind to it like all the
			  // other events and have it go through ReactBrowserEventEmitter. Since it
			  // doesn't, we manually listen for the events and so we have to enqueue and
			  // process the abstract event manually.
			  //
			  // Batching is necessary here in order to ensure that all event handlers run
			  // before the next rerender (including event handlers attached to ancestor
			  // elements instead of directly on the input). Without this, controlled
			  // components don't work properly in conjunction with event bubbling because
			  // the component is rerendered and the value reverted before all the event
			  // handlers can run. See https://github.com/facebook/react/issues/708.
			  ReactUpdates.batchedUpdates(runEventInBatch, event);
			}
	
			function runEventInBatch(event) {
			  EventPluginHub.enqueueEvents(event);
			  EventPluginHub.processEventQueue(false);
			}
	
			function startWatchingForChangeEventIE8(target, targetInst) {
			  activeElement = target;
			  activeElementInst = targetInst;
			  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
			}
	
			function stopWatchingForChangeEventIE8() {
			  if (!activeElement) {
			    return;
			  }
			  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
			  activeElement = null;
			  activeElementInst = null;
			}
	
			function getTargetInstForChangeEvent(topLevelType, targetInst) {
			  if (topLevelType === 'topChange') {
			    return targetInst;
			  }
			}
			function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
			  if (topLevelType === 'topFocus') {
			    // stopWatching() should be a noop here but we call it just in case we
			    // missed a blur event somehow.
			    stopWatchingForChangeEventIE8();
			    startWatchingForChangeEventIE8(target, targetInst);
			  } else if (topLevelType === 'topBlur') {
			    stopWatchingForChangeEventIE8();
			  }
			}
	
			/**
			 * SECTION: handle `input` event
			 */
			var isInputEventSupported = false;
			if (ExecutionEnvironment.canUseDOM) {
			  // IE9 claims to support the input event but fails to trigger it when
			  // deleting text, so we ignore its input events.
			  // IE10+ fire input events to often, such when a placeholder
			  // changes or when an input with a placeholder is focused.
			  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
			}
	
			/**
			 * (For IE <=11) Replacement getter/setter for the `value` property that gets
			 * set on the active element.
			 */
			var newValueProp = {
			  get: function () {
			    return activeElementValueProp.get.call(this);
			  },
			  set: function (val) {
			    // Cast to a string so we can do equality checks.
			    activeElementValue = '' + val;
			    activeElementValueProp.set.call(this, val);
			  }
			};
	
			/**
			 * (For IE <=11) Starts tracking propertychange events on the passed-in element
			 * and override the value property so that we can distinguish user events from
			 * value changes in JS.
			 */
			function startWatchingForValueChange(target, targetInst) {
			  activeElement = target;
			  activeElementInst = targetInst;
			  activeElementValue = target.value;
			  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
			  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
			  // on DOM elements
			  Object.defineProperty(activeElement, 'value', newValueProp);
			  if (activeElement.attachEvent) {
			    activeElement.attachEvent('onpropertychange', handlePropertyChange);
			  } else {
			    activeElement.addEventListener('propertychange', handlePropertyChange, false);
			  }
			}
	
			/**
			 * (For IE <=11) Removes the event listeners from the currently-tracked element,
			 * if any exists.
			 */
			function stopWatchingForValueChange() {
			  if (!activeElement) {
			    return;
			  }
	
			  // delete restores the original property definition
			  delete activeElement.value;
	
			  if (activeElement.detachEvent) {
			    activeElement.detachEvent('onpropertychange', handlePropertyChange);
			  } else {
			    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
			  }
	
			  activeElement = null;
			  activeElementInst = null;
			  activeElementValue = null;
			  activeElementValueProp = null;
			}
	
			/**
			 * (For IE <=11) Handles a propertychange event, sending a `change` event if
			 * the value of the active element has changed.
			 */
			function handlePropertyChange(nativeEvent) {
			  if (nativeEvent.propertyName !== 'value') {
			    return;
			  }
			  var value = nativeEvent.srcElement.value;
			  if (value === activeElementValue) {
			    return;
			  }
			  activeElementValue = value;
	
			  manualDispatchChangeEvent(nativeEvent);
			}
	
			/**
			 * If a `change` event should be fired, returns the target's ID.
			 */
			function getTargetInstForInputEvent(topLevelType, targetInst) {
			  if (topLevelType === 'topInput') {
			    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
			    // what we want so fall through here and trigger an abstract event
			    return targetInst;
			  }
			}
	
			function handleEventsForInputEventIE(topLevelType, target, targetInst) {
			  if (topLevelType === 'topFocus') {
			    // In IE8, we can capture almost all .value changes by adding a
			    // propertychange handler and looking for events with propertyName
			    // equal to 'value'
			    // In IE9-11, propertychange fires for most input events but is buggy and
			    // doesn't fire when text is deleted, but conveniently, selectionchange
			    // appears to fire in all of the remaining cases so we catch those and
			    // forward the event if the value has changed
			    // In either case, we don't want to call the event handler if the value
			    // is changed from JS so we redefine a setter for `.value` that updates
			    // our activeElementValue variable, allowing us to ignore those changes
			    //
			    // stopWatching() should be a noop here but we call it just in case we
			    // missed a blur event somehow.
			    stopWatchingForValueChange();
			    startWatchingForValueChange(target, targetInst);
			  } else if (topLevelType === 'topBlur') {
			    stopWatchingForValueChange();
			  }
			}
	
			// For IE8 and IE9.
			function getTargetInstForInputEventIE(topLevelType, targetInst) {
			  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
			    // On the selectionchange event, the target is just document which isn't
			    // helpful for us so just check activeElement instead.
			    //
			    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
			    // propertychange on the first input event after setting `value` from a
			    // script and fires only keydown, keypress, keyup. Catching keyup usually
			    // gets it and catching keydown lets us fire an event for the first
			    // keystroke if user does a key repeat (it'll be a little delayed: right
			    // before the second keystroke). Other input methods (e.g., paste) seem to
			    // fire selectionchange normally.
			    if (activeElement && activeElement.value !== activeElementValue) {
			      activeElementValue = activeElement.value;
			      return activeElementInst;
			    }
			  }
			}
	
			/**
			 * SECTION: handle `click` event
			 */
			function shouldUseClickEvent(elem) {
			  // Use the `click` event to detect changes to checkbox and radio inputs.
			  // This approach works across all browsers, whereas `change` does not fire
			  // until `blur` in IE8.
			  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
			}
	
			function getTargetInstForClickEvent(topLevelType, targetInst) {
			  if (topLevelType === 'topClick') {
			    return targetInst;
			  }
			}
	
			/**
			 * This plugin creates an `onChange` event that normalizes change events
			 * across form elements. This event fires at a time when it's possible to
			 * change the element's value without seeing a flicker.
			 *
			 * Supported elements are:
			 * - input (see `isTextInputElement`)
			 * - textarea
			 * - select
			 */
			var ChangeEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
			    var getTargetInstFunc, handleEventFunc;
			    if (shouldUseChangeEvent(targetNode)) {
			      if (doesChangeEventBubble) {
			        getTargetInstFunc = getTargetInstForChangeEvent;
			      } else {
			        handleEventFunc = handleEventsForChangeEventIE8;
			      }
			    } else if (isTextInputElement(targetNode)) {
			      if (isInputEventSupported) {
			        getTargetInstFunc = getTargetInstForInputEvent;
			      } else {
			        getTargetInstFunc = getTargetInstForInputEventIE;
			        handleEventFunc = handleEventsForInputEventIE;
			      }
			    } else if (shouldUseClickEvent(targetNode)) {
			      getTargetInstFunc = getTargetInstForClickEvent;
			    }
	
			    if (getTargetInstFunc) {
			      var inst = getTargetInstFunc(topLevelType, targetInst);
			      if (inst) {
			        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
			        event.type = 'change';
			        EventPropagators.accumulateTwoPhaseDispatches(event);
			        return event;
			      }
			    }
	
			    if (handleEventFunc) {
			      handleEventFunc(topLevelType, targetNode, targetInst);
			    }
			  }
	
			};
	
			module.exports = ChangeEventPlugin;
	
		/***/ },
		/* 31 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var CallbackQueue = __webpack_require__(32);
			var PooledClass = __webpack_require__(25);
			var ReactFeatureFlags = __webpack_require__(33);
			var ReactReconciler = __webpack_require__(34);
			var Transaction = __webpack_require__(46);
	
			var invariant = __webpack_require__(8);
	
			var dirtyComponents = [];
			var updateBatchNumber = 0;
			var asapCallbackQueue = CallbackQueue.getPooled();
			var asapEnqueued = false;
	
			var batchingStrategy = null;
	
			function ensureInjected() {
			  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
			}
	
			var NESTED_UPDATES = {
			  initialize: function () {
			    this.dirtyComponentsLength = dirtyComponents.length;
			  },
			  close: function () {
			    if (this.dirtyComponentsLength !== dirtyComponents.length) {
			      // Additional updates were enqueued by componentDidUpdate handlers or
			      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
			      // these new updates so that if A's componentDidUpdate calls setState on
			      // B, B will update before the callback A's updater provided when calling
			      // setState.
			      dirtyComponents.splice(0, this.dirtyComponentsLength);
			      flushBatchedUpdates();
			    } else {
			      dirtyComponents.length = 0;
			    }
			  }
			};
	
			var UPDATE_QUEUEING = {
			  initialize: function () {
			    this.callbackQueue.reset();
			  },
			  close: function () {
			    this.callbackQueue.notifyAll();
			  }
			};
	
			var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
			function ReactUpdatesFlushTransaction() {
			  this.reinitializeTransaction();
			  this.dirtyComponentsLength = null;
			  this.callbackQueue = CallbackQueue.getPooled();
			  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
			  /* useCreateElement */true);
			}
	
			_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
			  getTransactionWrappers: function () {
			    return TRANSACTION_WRAPPERS;
			  },
	
			  destructor: function () {
			    this.dirtyComponentsLength = null;
			    CallbackQueue.release(this.callbackQueue);
			    this.callbackQueue = null;
			    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
			    this.reconcileTransaction = null;
			  },
	
			  perform: function (method, scope, a) {
			    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
			    // with this transaction's wrappers around it.
			    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
			  }
			});
	
			PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
			function batchedUpdates(callback, a, b, c, d, e) {
			  ensureInjected();
			  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
			}
	
			/**
			 * Array comparator for ReactComponents by mount ordering.
			 *
			 * @param {ReactComponent} c1 first component you're comparing
			 * @param {ReactComponent} c2 second component you're comparing
			 * @return {number} Return value usable by Array.prototype.sort().
			 */
			function mountOrderComparator(c1, c2) {
			  return c1._mountOrder - c2._mountOrder;
			}
	
			function runBatchedUpdates(transaction) {
			  var len = transaction.dirtyComponentsLength;
			  !(len === dirtyComponents.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
			  // Since reconciling a component higher in the owner hierarchy usually (not
			  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
			  // them before their children by sorting the array.
			  dirtyComponents.sort(mountOrderComparator);
	
			  // Any updates enqueued while reconciling must be performed after this entire
			  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
			  // C, B could update twice in a single batch if C's render enqueues an update
			  // to B (since B would have already updated, we should skip it, and the only
			  // way we can know to do so is by checking the batch counter).
			  updateBatchNumber++;
	
			  for (var i = 0; i < len; i++) {
			    // If a component is unmounted before pending changes apply, it will still
			    // be here, but we assume that it has cleared its _pendingCallbacks and
			    // that performUpdateIfNecessary is a noop.
			    var component = dirtyComponents[i];
	
			    // If performUpdateIfNecessary happens to enqueue any new updates, we
			    // shouldn't execute the callbacks until the next render happens, so
			    // stash the callbacks first
			    var callbacks = component._pendingCallbacks;
			    component._pendingCallbacks = null;
	
			    var markerName;
			    if (ReactFeatureFlags.logTopLevelRenders) {
			      var namedComponent = component;
			      // Duck type TopLevelWrapper. This is probably always true.
			      if (component._currentElement.type.isReactTopLevelWrapper) {
			        namedComponent = component._renderedComponent;
			      }
			      markerName = 'React update: ' + namedComponent.getName();
			      console.time(markerName);
			    }
	
			    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
			    if (markerName) {
			      console.timeEnd(markerName);
			    }
	
			    if (callbacks) {
			      for (var j = 0; j < callbacks.length; j++) {
			        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
			      }
			    }
			  }
			}
	
			var flushBatchedUpdates = function () {
			  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
			  // array and perform any updates enqueued by mount-ready handlers (i.e.,
			  // componentDidUpdate) but we need to check here too in order to catch
			  // updates enqueued by setState callbacks and asap calls.
			  while (dirtyComponents.length || asapEnqueued) {
			    if (dirtyComponents.length) {
			      var transaction = ReactUpdatesFlushTransaction.getPooled();
			      transaction.perform(runBatchedUpdates, null, transaction);
			      ReactUpdatesFlushTransaction.release(transaction);
			    }
	
			    if (asapEnqueued) {
			      asapEnqueued = false;
			      var queue = asapCallbackQueue;
			      asapCallbackQueue = CallbackQueue.getPooled();
			      queue.notifyAll();
			      CallbackQueue.release(queue);
			    }
			  }
			};
	
			/**
			 * Mark a component as needing a rerender, adding an optional callback to a
			 * list of functions which will be executed once the rerender occurs.
			 */
			function enqueueUpdate(component) {
			  ensureInjected();
	
			  // Various parts of our code (such as ReactCompositeComponent's
			  // _renderValidatedComponent) assume that calls to render aren't nested;
			  // verify that that's the case. (This is called by each top-level update
			  // function, like setState, forceUpdate, etc.; creation and
			  // destruction of top-level components is guarded in ReactMount.)
	
			  if (!batchingStrategy.isBatchingUpdates) {
			    batchingStrategy.batchedUpdates(enqueueUpdate, component);
			    return;
			  }
	
			  dirtyComponents.push(component);
			  if (component._updateBatchNumber == null) {
			    component._updateBatchNumber = updateBatchNumber + 1;
			  }
			}
	
			/**
			 * Enqueue a callback to be run at the end of the current batching cycle. Throws
			 * if no updates are currently being performed.
			 */
			function asap(callback, context) {
			  !batchingStrategy.isBatchingUpdates ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
			  asapCallbackQueue.enqueue(callback, context);
			  asapEnqueued = true;
			}
	
			var ReactUpdatesInjection = {
			  injectReconcileTransaction: function (ReconcileTransaction) {
			    !ReconcileTransaction ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
			    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
			  },
	
			  injectBatchingStrategy: function (_batchingStrategy) {
			    !_batchingStrategy ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
			    !(typeof _batchingStrategy.batchedUpdates === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
			    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
			    batchingStrategy = _batchingStrategy;
			  }
			};
	
			var ReactUpdates = {
			  /**
			   * React references `ReactReconcileTransaction` using this property in order
			   * to allow dependency injection.
			   *
			   * @internal
			   */
			  ReactReconcileTransaction: null,
	
			  batchedUpdates: batchedUpdates,
			  enqueueUpdate: enqueueUpdate,
			  flushBatchedUpdates: flushBatchedUpdates,
			  injection: ReactUpdatesInjection,
			  asap: asap
			};
	
			module.exports = ReactUpdates;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 32 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
			var PooledClass = __webpack_require__(25);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * A specialized pseudo-event module to help keep track of components waiting to
			 * be notified when their DOM representations are available for use.
			 *
			 * This implements `PooledClass`, so you should never need to instantiate this.
			 * Instead, use `CallbackQueue.getPooled()`.
			 *
			 * @class ReactMountReady
			 * @implements PooledClass
			 * @internal
			 */
	
			var CallbackQueue = function () {
			  function CallbackQueue(arg) {
			    _classCallCheck(this, CallbackQueue);
	
			    this._callbacks = null;
			    this._contexts = null;
			    this._arg = arg;
			  }
	
			  /**
			   * Enqueues a callback to be invoked when `notifyAll` is invoked.
			   *
			   * @param {function} callback Invoked when `notifyAll` is invoked.
			   * @param {?object} context Context to call `callback` with.
			   * @internal
			   */
	
	
			  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
			    this._callbacks = this._callbacks || [];
			    this._callbacks.push(callback);
			    this._contexts = this._contexts || [];
			    this._contexts.push(context);
			  };
	
			  /**
			   * Invokes all enqueued callbacks and clears the queue. This is invoked after
			   * the DOM representation of a component has been created or updated.
			   *
			   * @internal
			   */
	
	
			  CallbackQueue.prototype.notifyAll = function notifyAll() {
			    var callbacks = this._callbacks;
			    var contexts = this._contexts;
			    var arg = this._arg;
			    if (callbacks && contexts) {
			      !(callbacks.length === contexts.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
			      this._callbacks = null;
			      this._contexts = null;
			      for (var i = 0; i < callbacks.length; i++) {
			        callbacks[i].call(contexts[i], arg);
			      }
			      callbacks.length = 0;
			      contexts.length = 0;
			    }
			  };
	
			  CallbackQueue.prototype.checkpoint = function checkpoint() {
			    return this._callbacks ? this._callbacks.length : 0;
			  };
	
			  CallbackQueue.prototype.rollback = function rollback(len) {
			    if (this._callbacks && this._contexts) {
			      this._callbacks.length = len;
			      this._contexts.length = len;
			    }
			  };
	
			  /**
			   * Resets the internal queue.
			   *
			   * @internal
			   */
	
	
			  CallbackQueue.prototype.reset = function reset() {
			    this._callbacks = null;
			    this._contexts = null;
			  };
	
			  /**
			   * `PooledClass` looks for this.
			   */
	
	
			  CallbackQueue.prototype.destructor = function destructor() {
			    this.reset();
			  };
	
			  return CallbackQueue;
			}();
	
			module.exports = PooledClass.addPoolingTo(CallbackQueue);
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 33 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactFeatureFlags = {
			  // When true, call console.time() before and .timeEnd() after each top-level
			  // render (both initial renders and updates). Useful when looking at prod-mode
			  // timeline profiles in Chrome, for example.
			  logTopLevelRenders: false
			};
	
			module.exports = ReactFeatureFlags;
	
		/***/ },
		/* 34 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactRef = __webpack_require__(35);
			var ReactInstrumentation = __webpack_require__(37);
	
			var warning = __webpack_require__(18);
	
			/**
			 * Helper to call ReactRef.attachRefs with this composite component, split out
			 * to avoid allocations in the transaction mount-ready queue.
			 */
			function attachRefs() {
			  ReactRef.attachRefs(this, this._currentElement);
			}
	
			var ReactReconciler = {
	
			  /**
			   * Initializes the component, renders markup, and registers event listeners.
			   *
			   * @param {ReactComponent} internalInstance
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {?object} the containing host component instance
			   * @param {?object} info about the host container
			   * @return {?string} Rendered markup to be inserted into the DOM.
			   * @final
			   * @internal
			   */
			  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
			  ) {
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
			      }
			    }
			    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
			    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
			      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
			      }
			    }
			    return markup;
			  },
	
			  /**
			   * Returns a value that can be passed to
			   * ReactComponentEnvironment.replaceNodeWithMarkup.
			   */
			  getHostNode: function (internalInstance) {
			    return internalInstance.getHostNode();
			  },
	
			  /**
			   * Releases any resources allocated by `mountComponent`.
			   *
			   * @final
			   * @internal
			   */
			  unmountComponent: function (internalInstance, safely) {
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
			      }
			    }
			    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
			    internalInstance.unmountComponent(safely);
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
			      }
			    }
			  },
	
			  /**
			   * Update a component using a new element.
			   *
			   * @param {ReactComponent} internalInstance
			   * @param {ReactElement} nextElement
			   * @param {ReactReconcileTransaction} transaction
			   * @param {object} context
			   * @internal
			   */
			  receiveComponent: function (internalInstance, nextElement, transaction, context) {
			    var prevElement = internalInstance._currentElement;
	
			    if (nextElement === prevElement && context === internalInstance._context) {
			      // Since elements are immutable after the owner is rendered,
			      // we can do a cheap identity compare here to determine if this is a
			      // superfluous reconcile. It's possible for state to be mutable but such
			      // change should trigger an update of the owner which would recreate
			      // the element. We explicitly check for the existence of an owner since
			      // it's possible for an element created outside a composite to be
			      // deeply mutated and reused.
	
			      // TODO: Bailing out early is just a perf optimization right?
			      // TODO: Removing the return statement should affect correctness?
			      return;
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
			      }
			    }
	
			    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
			    if (refsChanged) {
			      ReactRef.detachRefs(internalInstance, prevElement);
			    }
	
			    internalInstance.receiveComponent(nextElement, transaction, context);
	
			    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
			      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
			      }
			    }
			  },
	
			  /**
			   * Flush any dirty changes in a component.
			   *
			   * @param {ReactComponent} internalInstance
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   */
			  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
			    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
			      // The component's enqueued batch number should always be the current
			      // batch or the following one.
			      process.env.NODE_ENV !== 'production' ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
			      return;
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
			      }
			    }
			    internalInstance.performUpdateIfNecessary(transaction);
			    if (process.env.NODE_ENV !== 'production') {
			      if (internalInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
			      }
			    }
			  }
	
			};
	
			module.exports = ReactReconciler;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 35 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactOwner = __webpack_require__(36);
	
			var ReactRef = {};
	
			function attachRef(ref, component, owner) {
			  if (typeof ref === 'function') {
			    ref(component.getPublicInstance());
			  } else {
			    // Legacy ref
			    ReactOwner.addComponentAsRefTo(component, ref, owner);
			  }
			}
	
			function detachRef(ref, component, owner) {
			  if (typeof ref === 'function') {
			    ref(null);
			  } else {
			    // Legacy ref
			    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
			  }
			}
	
			ReactRef.attachRefs = function (instance, element) {
			  if (element === null || typeof element !== 'object') {
			    return;
			  }
			  var ref = element.ref;
			  if (ref != null) {
			    attachRef(ref, instance, element._owner);
			  }
			};
	
			ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
			  // If either the owner or a `ref` has changed, make sure the newest owner
			  // has stored a reference to `this`, and the previous owner (if different)
			  // has forgotten the reference to `this`. We use the element instead
			  // of the public this.props because the post processing cannot determine
			  // a ref. The ref conceptually lives on the element.
	
			  // TODO: Should this even be possible? The owner cannot change because
			  // it's forbidden by shouldUpdateReactComponent. The ref can change
			  // if you swap the keys of but not the refs. Reconsider where this check
			  // is made. It probably belongs where the key checking and
			  // instantiateReactComponent is done.
	
			  var prevRef = null;
			  var prevOwner = null;
			  if (prevElement !== null && typeof prevElement === 'object') {
			    prevRef = prevElement.ref;
			    prevOwner = prevElement._owner;
			  }
	
			  var nextRef = null;
			  var nextOwner = null;
			  if (nextElement !== null && typeof nextElement === 'object') {
			    nextRef = nextElement.ref;
			    nextOwner = nextElement._owner;
			  }
	
			  return prevRef !== nextRef ||
			  // If owner changes but we have an unchanged function ref, don't update refs
			  typeof nextRef === 'string' && nextOwner !== prevOwner;
			};
	
			ReactRef.detachRefs = function (instance, element) {
			  if (element === null || typeof element !== 'object') {
			    return;
			  }
			  var ref = element.ref;
			  if (ref != null) {
			    detachRef(ref, instance, element._owner);
			  }
			};
	
			module.exports = ReactRef;
	
		/***/ },
		/* 36 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * @param {?object} object
			 * @return {boolean} True if `object` is a valid owner.
			 * @final
			 */
			function isValidOwner(object) {
			  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
			}
	
			/**
			 * ReactOwners are capable of storing references to owned components.
			 *
			 * All components are capable of //being// referenced by owner components, but
			 * only ReactOwner components are capable of //referencing// owned components.
			 * The named reference is known as a "ref".
			 *
			 * Refs are available when mounted and updated during reconciliation.
			 *
			 *   var MyComponent = React.createClass({
			 *     render: function() {
			 *       return (
			 *         <div onClick={this.handleClick}>
			 *           <CustomComponent ref="custom" />
			 *         </div>
			 *       );
			 *     },
			 *     handleClick: function() {
			 *       this.refs.custom.handleClick();
			 *     },
			 *     componentDidMount: function() {
			 *       this.refs.custom.initialize();
			 *     }
			 *   });
			 *
			 * Refs should rarely be used. When refs are used, they should only be done to
			 * control data that is not handled by React's data flow.
			 *
			 * @class ReactOwner
			 */
			var ReactOwner = {
			  /**
			   * Adds a component by ref to an owner component.
			   *
			   * @param {ReactComponent} component Component to reference.
			   * @param {string} ref Name by which to refer to the component.
			   * @param {ReactOwner} owner Component on which to record the ref.
			   * @final
			   * @internal
			   */
			  addComponentAsRefTo: function (component, ref, owner) {
			    !isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
			    owner.attachRef(ref, component);
			  },
	
			  /**
			   * Removes a component by ref from an owner component.
			   *
			   * @param {ReactComponent} component Component to dereference.
			   * @param {string} ref Name of the ref to remove.
			   * @param {ReactOwner} owner Component on which the ref is recorded.
			   * @final
			   * @internal
			   */
			  removeComponentAsRefFrom: function (component, ref, owner) {
			    !isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
			    var ownerPublicInstance = owner.getPublicInstance();
			    // Check that `component`'s owner is still alive and that `component` is still the current ref
			    // because we do not want to detach the ref if another component stole it.
			    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
			      owner.detachRef(ref);
			    }
			  }
	
			};
	
			module.exports = ReactOwner;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 37 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
			var debugTool = null;
	
			if (process.env.NODE_ENV !== 'production') {
			  var ReactDebugTool = __webpack_require__(38);
			  debugTool = ReactDebugTool;
			}
	
			module.exports = { debugTool: debugTool };
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 38 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactInvalidSetStateWarningHook = __webpack_require__(39);
			var ReactHostOperationHistoryHook = __webpack_require__(40);
			var ReactComponentTreeHook = __webpack_require__(41);
			var ExecutionEnvironment = __webpack_require__(22);
	
			var performanceNow = __webpack_require__(44);
			var warning = __webpack_require__(18);
	
			var hooks = [];
			var didHookThrowForEvent = {};
	
			function callHook(event, fn, context, arg1, arg2, arg3, arg4, arg5) {
			  try {
			    fn.call(context, arg1, arg2, arg3, arg4, arg5);
			  } catch (e) {
			    process.env.NODE_ENV !== 'production' ? warning(didHookThrowForEvent[event], 'Exception thrown by hook while handling %s: %s', event, e + '\n' + e.stack) : void 0;
			    didHookThrowForEvent[event] = true;
			  }
			}
	
			function emitEvent(event, arg1, arg2, arg3, arg4, arg5) {
			  for (var i = 0; i < hooks.length; i++) {
			    var hook = hooks[i];
			    var fn = hook[event];
			    if (fn) {
			      callHook(event, fn, hook, arg1, arg2, arg3, arg4, arg5);
			    }
			  }
			}
	
			var isProfiling = false;
			var flushHistory = [];
			var lifeCycleTimerStack = [];
			var currentFlushNesting = 0;
			var currentFlushMeasurements = [];
			var currentFlushStartTime = 0;
			var currentTimerDebugID = null;
			var currentTimerStartTime = 0;
			var currentTimerNestedFlushDuration = 0;
			var currentTimerType = null;
	
			var lifeCycleTimerHasWarned = false;
	
			function clearHistory() {
			  ReactComponentTreeHook.purgeUnmountedComponents();
			  ReactHostOperationHistoryHook.clearHistory();
			}
	
			function getTreeSnapshot(registeredIDs) {
			  return registeredIDs.reduce(function (tree, id) {
			    var ownerID = ReactComponentTreeHook.getOwnerID(id);
			    var parentID = ReactComponentTreeHook.getParentID(id);
			    tree[id] = {
			      displayName: ReactComponentTreeHook.getDisplayName(id),
			      text: ReactComponentTreeHook.getText(id),
			      updateCount: ReactComponentTreeHook.getUpdateCount(id),
			      childIDs: ReactComponentTreeHook.getChildIDs(id),
			      // Text nodes don't have owners but this is close enough.
			      ownerID: ownerID || parentID && ReactComponentTreeHook.getOwnerID(parentID) || 0,
			      parentID: parentID
			    };
			    return tree;
			  }, {});
			}
	
			function resetMeasurements() {
			  var previousStartTime = currentFlushStartTime;
			  var previousMeasurements = currentFlushMeasurements;
			  var previousOperations = ReactHostOperationHistoryHook.getHistory();
	
			  if (currentFlushNesting === 0) {
			    currentFlushStartTime = 0;
			    currentFlushMeasurements = [];
			    clearHistory();
			    return;
			  }
	
			  if (previousMeasurements.length || previousOperations.length) {
			    var registeredIDs = ReactComponentTreeHook.getRegisteredIDs();
			    flushHistory.push({
			      duration: performanceNow() - previousStartTime,
			      measurements: previousMeasurements || [],
			      operations: previousOperations || [],
			      treeSnapshot: getTreeSnapshot(registeredIDs)
			    });
			  }
	
			  clearHistory();
			  currentFlushStartTime = performanceNow();
			  currentFlushMeasurements = [];
			}
	
			function checkDebugID(debugID) {
			  var allowRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
			  if (allowRoot && debugID === 0) {
			    return;
			  }
			  if (!debugID) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDebugTool: debugID may not be empty.') : void 0;
			  }
			}
	
			function beginLifeCycleTimer(debugID, timerType) {
			  if (currentFlushNesting === 0) {
			    return;
			  }
			  if (currentTimerType && !lifeCycleTimerHasWarned) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
			    lifeCycleTimerHasWarned = true;
			  }
			  currentTimerStartTime = performanceNow();
			  currentTimerNestedFlushDuration = 0;
			  currentTimerDebugID = debugID;
			  currentTimerType = timerType;
			}
	
			function endLifeCycleTimer(debugID, timerType) {
			  if (currentFlushNesting === 0) {
			    return;
			  }
			  if (currentTimerType !== timerType && !lifeCycleTimerHasWarned) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
			    lifeCycleTimerHasWarned = true;
			  }
			  if (isProfiling) {
			    currentFlushMeasurements.push({
			      timerType: timerType,
			      instanceID: debugID,
			      duration: performanceNow() - currentTimerStartTime - currentTimerNestedFlushDuration
			    });
			  }
			  currentTimerStartTime = 0;
			  currentTimerNestedFlushDuration = 0;
			  currentTimerDebugID = null;
			  currentTimerType = null;
			}
	
			function pauseCurrentLifeCycleTimer() {
			  var currentTimer = {
			    startTime: currentTimerStartTime,
			    nestedFlushStartTime: performanceNow(),
			    debugID: currentTimerDebugID,
			    timerType: currentTimerType
			  };
			  lifeCycleTimerStack.push(currentTimer);
			  currentTimerStartTime = 0;
			  currentTimerNestedFlushDuration = 0;
			  currentTimerDebugID = null;
			  currentTimerType = null;
			}
	
			function resumeCurrentLifeCycleTimer() {
			  var _lifeCycleTimerStack$ = lifeCycleTimerStack.pop(),
			      startTime = _lifeCycleTimerStack$.startTime,
			      nestedFlushStartTime = _lifeCycleTimerStack$.nestedFlushStartTime,
			      debugID = _lifeCycleTimerStack$.debugID,
			      timerType = _lifeCycleTimerStack$.timerType;
	
			  var nestedFlushDuration = performanceNow() - nestedFlushStartTime;
			  currentTimerStartTime = startTime;
			  currentTimerNestedFlushDuration += nestedFlushDuration;
			  currentTimerDebugID = debugID;
			  currentTimerType = timerType;
			}
	
			var lastMarkTimeStamp = 0;
			var canUsePerformanceMeasure =
			// $FlowFixMe https://github.com/facebook/flow/issues/2345
			typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';
	
			function shouldMark(debugID) {
			  if (!isProfiling || !canUsePerformanceMeasure) {
			    return false;
			  }
			  var element = ReactComponentTreeHook.getElement(debugID);
			  if (element == null || typeof element !== 'object') {
			    return false;
			  }
			  var isHostElement = typeof element.type === 'string';
			  if (isHostElement) {
			    return false;
			  }
			  return true;
			}
	
			function markBegin(debugID, markType) {
			  if (!shouldMark(debugID)) {
			    return;
			  }
	
			  var markName = debugID + '::' + markType;
			  lastMarkTimeStamp = performanceNow();
			  performance.mark(markName);
			}
	
			function markEnd(debugID, markType) {
			  if (!shouldMark(debugID)) {
			    return;
			  }
	
			  var markName = debugID + '::' + markType;
			  var displayName = ReactComponentTreeHook.getDisplayName(debugID) || 'Unknown';
	
			  // Chrome has an issue of dropping markers recorded too fast:
			  // https://bugs.chromium.org/p/chromium/issues/detail?id=640652
			  // To work around this, we will not report very small measurements.
			  // I determined the magic number by tweaking it back and forth.
			  // 0.05ms was enough to prevent the issue, but I set it to 0.1ms to be safe.
			  // When the bug is fixed, we can `measure()` unconditionally if we want to.
			  var timeStamp = performanceNow();
			  if (timeStamp - lastMarkTimeStamp > 0.1) {
			    var measurementName = displayName + ' [' + markType + ']';
			    performance.measure(measurementName, markName);
			  }
	
			  performance.clearMarks(markName);
			  performance.clearMeasures(measurementName);
			}
	
			var ReactDebugTool = {
			  addHook: function (hook) {
			    hooks.push(hook);
			  },
			  removeHook: function (hook) {
			    for (var i = 0; i < hooks.length; i++) {
			      if (hooks[i] === hook) {
			        hooks.splice(i, 1);
			        i--;
			      }
			    }
			  },
			  isProfiling: function () {
			    return isProfiling;
			  },
			  beginProfiling: function () {
			    if (isProfiling) {
			      return;
			    }
	
			    isProfiling = true;
			    flushHistory.length = 0;
			    resetMeasurements();
			    ReactDebugTool.addHook(ReactHostOperationHistoryHook);
			  },
			  endProfiling: function () {
			    if (!isProfiling) {
			      return;
			    }
	
			    isProfiling = false;
			    resetMeasurements();
			    ReactDebugTool.removeHook(ReactHostOperationHistoryHook);
			  },
			  getFlushHistory: function () {
			    return flushHistory;
			  },
			  onBeginFlush: function () {
			    currentFlushNesting++;
			    resetMeasurements();
			    pauseCurrentLifeCycleTimer();
			    emitEvent('onBeginFlush');
			  },
			  onEndFlush: function () {
			    resetMeasurements();
			    currentFlushNesting--;
			    resumeCurrentLifeCycleTimer();
			    emitEvent('onEndFlush');
			  },
			  onBeginLifeCycleTimer: function (debugID, timerType) {
			    checkDebugID(debugID);
			    emitEvent('onBeginLifeCycleTimer', debugID, timerType);
			    markBegin(debugID, timerType);
			    beginLifeCycleTimer(debugID, timerType);
			  },
			  onEndLifeCycleTimer: function (debugID, timerType) {
			    checkDebugID(debugID);
			    endLifeCycleTimer(debugID, timerType);
			    markEnd(debugID, timerType);
			    emitEvent('onEndLifeCycleTimer', debugID, timerType);
			  },
			  onBeginProcessingChildContext: function () {
			    emitEvent('onBeginProcessingChildContext');
			  },
			  onEndProcessingChildContext: function () {
			    emitEvent('onEndProcessingChildContext');
			  },
			  onHostOperation: function (operation) {
			    checkDebugID(operation.instanceID);
			    emitEvent('onHostOperation', operation);
			  },
			  onSetState: function () {
			    emitEvent('onSetState');
			  },
			  onSetChildren: function (debugID, childDebugIDs) {
			    checkDebugID(debugID);
			    childDebugIDs.forEach(checkDebugID);
			    emitEvent('onSetChildren', debugID, childDebugIDs);
			  },
			  onBeforeMountComponent: function (debugID, element, parentDebugID) {
			    checkDebugID(debugID);
			    checkDebugID(parentDebugID, true);
			    emitEvent('onBeforeMountComponent', debugID, element, parentDebugID);
			    markBegin(debugID, 'mount');
			  },
			  onMountComponent: function (debugID) {
			    checkDebugID(debugID);
			    markEnd(debugID, 'mount');
			    emitEvent('onMountComponent', debugID);
			  },
			  onBeforeUpdateComponent: function (debugID, element) {
			    checkDebugID(debugID);
			    emitEvent('onBeforeUpdateComponent', debugID, element);
			    markBegin(debugID, 'update');
			  },
			  onUpdateComponent: function (debugID) {
			    checkDebugID(debugID);
			    markEnd(debugID, 'update');
			    emitEvent('onUpdateComponent', debugID);
			  },
			  onBeforeUnmountComponent: function (debugID) {
			    checkDebugID(debugID);
			    emitEvent('onBeforeUnmountComponent', debugID);
			    markBegin(debugID, 'unmount');
			  },
			  onUnmountComponent: function (debugID) {
			    checkDebugID(debugID);
			    markEnd(debugID, 'unmount');
			    emitEvent('onUnmountComponent', debugID);
			  },
			  onTestEvent: function () {
			    emitEvent('onTestEvent');
			  }
			};
	
			// TODO remove these when RN/www gets updated
			ReactDebugTool.addDevtool = ReactDebugTool.addHook;
			ReactDebugTool.removeDevtool = ReactDebugTool.removeHook;
	
			ReactDebugTool.addHook(ReactInvalidSetStateWarningHook);
			ReactDebugTool.addHook(ReactComponentTreeHook);
			var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
			if (/[?&]react_perf\b/.test(url)) {
			  ReactDebugTool.beginProfiling();
			}
	
			module.exports = ReactDebugTool;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 39 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var warning = __webpack_require__(18);
	
			if (process.env.NODE_ENV !== 'production') {
			  var processingChildContext = false;
	
			  var warnInvalidSetState = function () {
			    process.env.NODE_ENV !== 'production' ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
			  };
			}
	
			var ReactInvalidSetStateWarningHook = {
			  onBeginProcessingChildContext: function () {
			    processingChildContext = true;
			  },
			  onEndProcessingChildContext: function () {
			    processingChildContext = false;
			  },
			  onSetState: function () {
			    warnInvalidSetState();
			  }
			};
	
			module.exports = ReactInvalidSetStateWarningHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 40 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var history = [];
	
			var ReactHostOperationHistoryHook = {
			  onHostOperation: function (operation) {
			    history.push(operation);
			  },
			  clearHistory: function () {
			    if (ReactHostOperationHistoryHook._preventClearing) {
			      // Should only be used for tests.
			      return;
			    }
	
			    history = [];
			  },
			  getHistory: function () {
			    return history;
			  }
			};
	
			module.exports = ReactHostOperationHistoryHook;
	
		/***/ },
		/* 41 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactCurrentOwner = __webpack_require__(43);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			function isNative(fn) {
			  // Based on isNative() from Lodash
			  var funcToString = Function.prototype.toString;
			  var hasOwnProperty = Object.prototype.hasOwnProperty;
			  var reIsNative = RegExp('^' + funcToString
			  // Take an example native function source for comparison
			  .call(hasOwnProperty)
			  // Strip regex characters so we can use it for regex
			  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
			  // Remove hasOwnProperty from the template to make it generic
			  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
			  try {
			    var source = funcToString.call(fn);
			    return reIsNative.test(source);
			  } catch (err) {
			    return false;
			  }
			}
	
			var canUseCollections =
			// Array.from
			typeof Array.from === 'function' &&
			// Map
			typeof Map === 'function' && isNative(Map) &&
			// Map.prototype.keys
			Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
			// Set
			typeof Set === 'function' && isNative(Set) &&
			// Set.prototype.keys
			Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
			var setItem;
			var getItem;
			var removeItem;
			var getItemIDs;
			var addRoot;
			var removeRoot;
			var getRootIDs;
	
			if (canUseCollections) {
			  var itemMap = new Map();
			  var rootIDSet = new Set();
	
			  setItem = function (id, item) {
			    itemMap.set(id, item);
			  };
			  getItem = function (id) {
			    return itemMap.get(id);
			  };
			  removeItem = function (id) {
			    itemMap['delete'](id);
			  };
			  getItemIDs = function () {
			    return Array.from(itemMap.keys());
			  };
	
			  addRoot = function (id) {
			    rootIDSet.add(id);
			  };
			  removeRoot = function (id) {
			    rootIDSet['delete'](id);
			  };
			  getRootIDs = function () {
			    return Array.from(rootIDSet.keys());
			  };
			} else {
			  var itemByKey = {};
			  var rootByKey = {};
	
			  // Use non-numeric keys to prevent V8 performance issues:
			  // https://github.com/facebook/react/pull/7232
			  var getKeyFromID = function (id) {
			    return '.' + id;
			  };
			  var getIDFromKey = function (key) {
			    return parseInt(key.substr(1), 10);
			  };
	
			  setItem = function (id, item) {
			    var key = getKeyFromID(id);
			    itemByKey[key] = item;
			  };
			  getItem = function (id) {
			    var key = getKeyFromID(id);
			    return itemByKey[key];
			  };
			  removeItem = function (id) {
			    var key = getKeyFromID(id);
			    delete itemByKey[key];
			  };
			  getItemIDs = function () {
			    return Object.keys(itemByKey).map(getIDFromKey);
			  };
	
			  addRoot = function (id) {
			    var key = getKeyFromID(id);
			    rootByKey[key] = true;
			  };
			  removeRoot = function (id) {
			    var key = getKeyFromID(id);
			    delete rootByKey[key];
			  };
			  getRootIDs = function () {
			    return Object.keys(rootByKey).map(getIDFromKey);
			  };
			}
	
			var unmountedIDs = [];
	
			function purgeDeep(id) {
			  var item = getItem(id);
			  if (item) {
			    var childIDs = item.childIDs;
	
			    removeItem(id);
			    childIDs.forEach(purgeDeep);
			  }
			}
	
			function describeComponentFrame(name, source, ownerName) {
			  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
			}
	
			function getDisplayName(element) {
			  if (element == null) {
			    return '#empty';
			  } else if (typeof element === 'string' || typeof element === 'number') {
			    return '#text';
			  } else if (typeof element.type === 'string') {
			    return element.type;
			  } else {
			    return element.type.displayName || element.type.name || 'Unknown';
			  }
			}
	
			function describeID(id) {
			  var name = ReactComponentTreeHook.getDisplayName(id);
			  var element = ReactComponentTreeHook.getElement(id);
			  var ownerID = ReactComponentTreeHook.getOwnerID(id);
			  var ownerName;
			  if (ownerID) {
			    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
			  }
			  process.env.NODE_ENV !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
			  return describeComponentFrame(name, element && element._source, ownerName);
			}
	
			var ReactComponentTreeHook = {
			  onSetChildren: function (id, nextChildIDs) {
			    var item = getItem(id);
			    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
			    item.childIDs = nextChildIDs;
	
			    for (var i = 0; i < nextChildIDs.length; i++) {
			      var nextChildID = nextChildIDs[i];
			      var nextChild = getItem(nextChildID);
			      !nextChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
			      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
			      !nextChild.isMounted ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
			      if (nextChild.parentID == null) {
			        nextChild.parentID = id;
			        // TODO: This shouldn't be necessary but mounting a new root during in
			        // componentWillMount currently causes not-yet-mounted components to
			        // be purged from our tree data so their parent id is missing.
			      }
			      !(nextChild.parentID === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
			    }
			  },
			  onBeforeMountComponent: function (id, element, parentID) {
			    var item = {
			      element: element,
			      parentID: parentID,
			      text: null,
			      childIDs: [],
			      isMounted: false,
			      updateCount: 0
			    };
			    setItem(id, item);
			  },
			  onBeforeUpdateComponent: function (id, element) {
			    var item = getItem(id);
			    if (!item || !item.isMounted) {
			      // We may end up here as a result of setState() in componentWillUnmount().
			      // In this case, ignore the element.
			      return;
			    }
			    item.element = element;
			  },
			  onMountComponent: function (id) {
			    var item = getItem(id);
			    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
			    item.isMounted = true;
			    var isRoot = item.parentID === 0;
			    if (isRoot) {
			      addRoot(id);
			    }
			  },
			  onUpdateComponent: function (id) {
			    var item = getItem(id);
			    if (!item || !item.isMounted) {
			      // We may end up here as a result of setState() in componentWillUnmount().
			      // In this case, ignore the element.
			      return;
			    }
			    item.updateCount++;
			  },
			  onUnmountComponent: function (id) {
			    var item = getItem(id);
			    if (item) {
			      // We need to check if it exists.
			      // `item` might not exist if it is inside an error boundary, and a sibling
			      // error boundary child threw while mounting. Then this instance never
			      // got a chance to mount, but it still gets an unmounting event during
			      // the error boundary cleanup.
			      item.isMounted = false;
			      var isRoot = item.parentID === 0;
			      if (isRoot) {
			        removeRoot(id);
			      }
			    }
			    unmountedIDs.push(id);
			  },
			  purgeUnmountedComponents: function () {
			    if (ReactComponentTreeHook._preventPurging) {
			      // Should only be used for testing.
			      return;
			    }
	
			    for (var i = 0; i < unmountedIDs.length; i++) {
			      var id = unmountedIDs[i];
			      purgeDeep(id);
			    }
			    unmountedIDs.length = 0;
			  },
			  isMounted: function (id) {
			    var item = getItem(id);
			    return item ? item.isMounted : false;
			  },
			  getCurrentStackAddendum: function (topElement) {
			    var info = '';
			    if (topElement) {
			      var name = getDisplayName(topElement);
			      var owner = topElement._owner;
			      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
			    }
	
			    var currentOwner = ReactCurrentOwner.current;
			    var id = currentOwner && currentOwner._debugID;
	
			    info += ReactComponentTreeHook.getStackAddendumByID(id);
			    return info;
			  },
			  getStackAddendumByID: function (id) {
			    var info = '';
			    while (id) {
			      info += describeID(id);
			      id = ReactComponentTreeHook.getParentID(id);
			    }
			    return info;
			  },
			  getChildIDs: function (id) {
			    var item = getItem(id);
			    return item ? item.childIDs : [];
			  },
			  getDisplayName: function (id) {
			    var element = ReactComponentTreeHook.getElement(id);
			    if (!element) {
			      return null;
			    }
			    return getDisplayName(element);
			  },
			  getElement: function (id) {
			    var item = getItem(id);
			    return item ? item.element : null;
			  },
			  getOwnerID: function (id) {
			    var element = ReactComponentTreeHook.getElement(id);
			    if (!element || !element._owner) {
			      return null;
			    }
			    return element._owner._debugID;
			  },
			  getParentID: function (id) {
			    var item = getItem(id);
			    return item ? item.parentID : null;
			  },
			  getSource: function (id) {
			    var item = getItem(id);
			    var element = item ? item.element : null;
			    var source = element != null ? element._source : null;
			    return source;
			  },
			  getText: function (id) {
			    var element = ReactComponentTreeHook.getElement(id);
			    if (typeof element === 'string') {
			      return element;
			    } else if (typeof element === 'number') {
			      return '' + element;
			    } else {
			      return null;
			    }
			  },
			  getUpdateCount: function (id) {
			    var item = getItem(id);
			    return item ? item.updateCount : 0;
			  },
	
	
			  getRootIDs: getRootIDs,
			  getRegisteredIDs: getItemIDs
			};
	
			module.exports = ReactComponentTreeHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 42 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
			'use strict';
	
			/**
			 * WARNING: DO NOT manually require this module.
			 * This is a replacement for `invariant(...)` used by the error code system
			 * and will _only_ be required by the corresponding babel pass.
			 * It always throws.
			 */
	
			function reactProdInvariant(code) {
			  var argCount = arguments.length - 1;
	
			  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
			  for (var argIdx = 0; argIdx < argCount; argIdx++) {
			    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
			  }
	
			  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
			  var error = new Error(message);
			  error.name = 'Invariant Violation';
			  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
			  throw error;
			}
	
			module.exports = reactProdInvariant;
	
		/***/ },
		/* 43 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * Keeps track of the current owner.
			 *
			 * The current owner is the component who should own any components that are
			 * currently being constructed.
			 */
			var ReactCurrentOwner = {
	
			  /**
			   * @internal
			   * @type {ReactComponent}
			   */
			  current: null
	
			};
	
			module.exports = ReactCurrentOwner;
	
		/***/ },
		/* 44 */
		/***/ function(module, exports, __webpack_require__) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var performance = __webpack_require__(45);
	
			var performanceNow;
	
			/**
			 * Detect if we can use `window.performance.now()` and gracefully fallback to
			 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
			 * because of Facebook's testing infrastructure.
			 */
			if (performance.now) {
			  performanceNow = function performanceNow() {
			    return performance.now();
			  };
			} else {
			  performanceNow = function performanceNow() {
			    return Date.now();
			  };
			}
	
			module.exports = performanceNow;
	
		/***/ },
		/* 45 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var performance;
	
			if (ExecutionEnvironment.canUseDOM) {
			  performance = window.performance || window.msPerformance || window.webkitPerformance;
			}
	
			module.exports = performance || {};
	
		/***/ },
		/* 46 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			var OBSERVED_ERROR = {};
	
			/**
			 * `Transaction` creates a black box that is able to wrap any method such that
			 * certain invariants are maintained before and after the method is invoked
			 * (Even if an exception is thrown while invoking the wrapped method). Whoever
			 * instantiates a transaction can provide enforcers of the invariants at
			 * creation time. The `Transaction` class itself will supply one additional
			 * automatic invariant for you - the invariant that any transaction instance
			 * should not be run while it is already being run. You would typically create a
			 * single instance of a `Transaction` for reuse multiple times, that potentially
			 * is used to wrap several different methods. Wrappers are extremely simple -
			 * they only require implementing two methods.
			 *
			 * <pre>
			 *                       wrappers (injected at creation time)
			 *                                      +        +
			 *                                      |        |
			 *                    +-----------------|--------|--------------+
			 *                    |                 v        |              |
			 *                    |      +---------------+   |              |
			 *                    |   +--|    wrapper1   |---|----+         |
			 *                    |   |  +---------------+   v    |         |
			 *                    |   |          +-------------+  |         |
			 *                    |   |     +----|   wrapper2  |--------+   |
			 *                    |   |     |    +-------------+  |     |   |
			 *                    |   |     |                     |     |   |
			 *                    |   v     v                     v     v   | wrapper
			 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
			 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
			 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
			 *                    | |   | |   |   |         |   |   | |   | |
			 *                    | |   | |   |   |         |   |   | |   | |
			 *                    | |   | |   |   |         |   |   | |   | |
			 *                    | +---+ +---+   +---------+   +---+ +---+ |
			 *                    |  initialize                    close    |
			 *                    +-----------------------------------------+
			 * </pre>
			 *
			 * Use cases:
			 * - Preserving the input selection ranges before/after reconciliation.
			 *   Restoring selection even in the event of an unexpected error.
			 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
			 *   while guaranteeing that afterwards, the event system is reactivated.
			 * - Flushing a queue of collected DOM mutations to the main UI thread after a
			 *   reconciliation takes place in a worker thread.
			 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
			 *   content.
			 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
			 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
			 * - (Future use case): Layout calculations before and after DOM updates.
			 *
			 * Transactional plugin API:
			 * - A module that has an `initialize` method that returns any precomputation.
			 * - and a `close` method that accepts the precomputation. `close` is invoked
			 *   when the wrapped process is completed, or has failed.
			 *
			 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
			 * that implement `initialize` and `close`.
			 * @return {Transaction} Single transaction for reuse in thread.
			 *
			 * @class Transaction
			 */
			var TransactionImpl = {
			  /**
			   * Sets up this instance so that it is prepared for collecting metrics. Does
			   * so such that this setup method may be used on an instance that is already
			   * initialized, in a way that does not consume additional memory upon reuse.
			   * That can be useful if you decide to make your subclass of this mixin a
			   * "PooledClass".
			   */
			  reinitializeTransaction: function () {
			    this.transactionWrappers = this.getTransactionWrappers();
			    if (this.wrapperInitData) {
			      this.wrapperInitData.length = 0;
			    } else {
			      this.wrapperInitData = [];
			    }
			    this._isInTransaction = false;
			  },
	
			  _isInTransaction: false,
	
			  /**
			   * @abstract
			   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
			   */
			  getTransactionWrappers: null,
	
			  isInTransaction: function () {
			    return !!this._isInTransaction;
			  },
	
			  /**
			   * Executes the function within a safety window. Use this for the top level
			   * methods that result in large amounts of computation/mutations that would
			   * need to be safety checked. The optional arguments helps prevent the need
			   * to bind in many cases.
			   *
			   * @param {function} method Member of scope to call.
			   * @param {Object} scope Scope to invoke from.
			   * @param {Object?=} a Argument to pass to the method.
			   * @param {Object?=} b Argument to pass to the method.
			   * @param {Object?=} c Argument to pass to the method.
			   * @param {Object?=} d Argument to pass to the method.
			   * @param {Object?=} e Argument to pass to the method.
			   * @param {Object?=} f Argument to pass to the method.
			   *
			   * @return {*} Return value from `method`.
			   */
			  perform: function (method, scope, a, b, c, d, e, f) {
			    !!this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
			    var errorThrown;
			    var ret;
			    try {
			      this._isInTransaction = true;
			      // Catching errors makes debugging more difficult, so we start with
			      // errorThrown set to true before setting it to false after calling
			      // close -- if it's still set to true in the finally block, it means
			      // one of these calls threw.
			      errorThrown = true;
			      this.initializeAll(0);
			      ret = method.call(scope, a, b, c, d, e, f);
			      errorThrown = false;
			    } finally {
			      try {
			        if (errorThrown) {
			          // If `method` throws, prefer to show that stack trace over any thrown
			          // by invoking `closeAll`.
			          try {
			            this.closeAll(0);
			          } catch (err) {}
			        } else {
			          // Since `method` didn't throw, we don't want to silence the exception
			          // here.
			          this.closeAll(0);
			        }
			      } finally {
			        this._isInTransaction = false;
			      }
			    }
			    return ret;
			  },
	
			  initializeAll: function (startIndex) {
			    var transactionWrappers = this.transactionWrappers;
			    for (var i = startIndex; i < transactionWrappers.length; i++) {
			      var wrapper = transactionWrappers[i];
			      try {
			        // Catching errors makes debugging more difficult, so we start with the
			        // OBSERVED_ERROR state before overwriting it with the real return value
			        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
			        // block, it means wrapper.initialize threw.
			        this.wrapperInitData[i] = OBSERVED_ERROR;
			        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
			      } finally {
			        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
			          // The initializer for wrapper i threw an error; initialize the
			          // remaining wrappers but silence any exceptions from them to ensure
			          // that the first error is the one to bubble up.
			          try {
			            this.initializeAll(i + 1);
			          } catch (err) {}
			        }
			      }
			    }
			  },
	
			  /**
			   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
			   * them the respective return values of `this.transactionWrappers.init[i]`
			   * (`close`rs that correspond to initializers that failed will not be
			   * invoked).
			   */
			  closeAll: function (startIndex) {
			    !this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
			    var transactionWrappers = this.transactionWrappers;
			    for (var i = startIndex; i < transactionWrappers.length; i++) {
			      var wrapper = transactionWrappers[i];
			      var initData = this.wrapperInitData[i];
			      var errorThrown;
			      try {
			        // Catching errors makes debugging more difficult, so we start with
			        // errorThrown set to true before setting it to false after calling
			        // close -- if it's still set to true in the finally block, it means
			        // wrapper.close threw.
			        errorThrown = true;
			        if (initData !== OBSERVED_ERROR && wrapper.close) {
			          wrapper.close.call(this, initData);
			        }
			        errorThrown = false;
			      } finally {
			        if (errorThrown) {
			          // The closer for wrapper i threw an error; close the remaining
			          // wrappers but silence any exceptions from them to ensure that the
			          // first error is the one to bubble up.
			          try {
			            this.closeAll(i + 1);
			          } catch (e) {}
			        }
			      }
			    }
			    this.wrapperInitData.length = 0;
			  }
			};
	
			module.exports = TransactionImpl;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 47 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Gets the target node from a native browser event by accounting for
			 * inconsistencies in browser DOM APIs.
			 *
			 * @param {object} nativeEvent Native browser event.
			 * @return {DOMEventTarget} Target node.
			 */
	
			function getEventTarget(nativeEvent) {
			  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
			  // Normalize SVG <use> element events #4963
			  if (target.correspondingUseElement) {
			    target = target.correspondingUseElement;
			  }
	
			  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
			  // @see http://www.quirksmode.org/js/events_properties.html
			  return target.nodeType === 3 ? target.parentNode : target;
			}
	
			module.exports = getEventTarget;
	
		/***/ },
		/* 48 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var useHasFeature;
			if (ExecutionEnvironment.canUseDOM) {
			  useHasFeature = document.implementation && document.implementation.hasFeature &&
			  // always returns true in newer browsers as per the standard.
			  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
			  document.implementation.hasFeature('', '') !== true;
			}
	
			/**
			 * Checks if an event is supported in the current execution environment.
			 *
			 * NOTE: This will not work correctly for non-generic events such as `change`,
			 * `reset`, `load`, `error`, and `select`.
			 *
			 * Borrows from Modernizr.
			 *
			 * @param {string} eventNameSuffix Event name, e.g. "click".
			 * @param {?boolean} capture Check if the capture phase is supported.
			 * @return {boolean} True if the event is supported.
			 * @internal
			 * @license Modernizr 3.0.0pre (Custom Build) | MIT
			 */
			function isEventSupported(eventNameSuffix, capture) {
			  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
			    return false;
			  }
	
			  var eventName = 'on' + eventNameSuffix;
			  var isSupported = eventName in document;
	
			  if (!isSupported) {
			    var element = document.createElement('div');
			    element.setAttribute(eventName, 'return;');
			    isSupported = typeof element[eventName] === 'function';
			  }
	
			  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
			    // This is the only way to test support for the `wheel` event in IE9+.
			    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
			  }
	
			  return isSupported;
			}
	
			module.exports = isEventSupported;
	
		/***/ },
		/* 49 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
			 */
	
			var supportedInputTypes = {
			  'color': true,
			  'date': true,
			  'datetime': true,
			  'datetime-local': true,
			  'email': true,
			  'month': true,
			  'number': true,
			  'password': true,
			  'range': true,
			  'search': true,
			  'tel': true,
			  'text': true,
			  'time': true,
			  'url': true,
			  'week': true
			};
	
			function isTextInputElement(elem) {
			  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
			  if (nodeName === 'input') {
			    return !!supportedInputTypes[elem.type];
			  }
	
			  if (nodeName === 'textarea') {
			    return true;
			  }
	
			  return false;
			}
	
			module.exports = isTextInputElement;
	
		/***/ },
		/* 50 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Module that is injectable into `EventPluginHub`, that specifies a
			 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
			 * plugins, without having to package every one of them. This is better than
			 * having plugins be ordered in the same order that they are injected because
			 * that ordering would be influenced by the packaging order.
			 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
			 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
			 */
	
			var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
			module.exports = DefaultEventPluginOrder;
	
		/***/ },
		/* 51 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPropagators = __webpack_require__(13);
			var ReactDOMComponentTree = __webpack_require__(5);
			var SyntheticMouseEvent = __webpack_require__(52);
	
			var eventTypes = {
			  mouseEnter: {
			    registrationName: 'onMouseEnter',
			    dependencies: ['topMouseOut', 'topMouseOver']
			  },
			  mouseLeave: {
			    registrationName: 'onMouseLeave',
			    dependencies: ['topMouseOut', 'topMouseOver']
			  }
			};
	
			var EnterLeaveEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  /**
			   * For almost every interaction we care about, there will be both a top-level
			   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
			   * we do not extract duplicate events. However, moving the mouse into the
			   * browser from outside will not fire a `mouseout` event. In this case, we use
			   * the `mouseover` top-level event.
			   */
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
			      return null;
			    }
			    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
			      // Must not be a mouse in or mouse out - ignoring.
			      return null;
			    }
	
			    var win;
			    if (nativeEventTarget.window === nativeEventTarget) {
			      // `nativeEventTarget` is probably a window object.
			      win = nativeEventTarget;
			    } else {
			      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
			      var doc = nativeEventTarget.ownerDocument;
			      if (doc) {
			        win = doc.defaultView || doc.parentWindow;
			      } else {
			        win = window;
			      }
			    }
	
			    var from;
			    var to;
			    if (topLevelType === 'topMouseOut') {
			      from = targetInst;
			      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
			      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
			    } else {
			      // Moving to a node from outside the window.
			      from = null;
			      to = targetInst;
			    }
	
			    if (from === to) {
			      // Nothing pertains to our managed components.
			      return null;
			    }
	
			    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
			    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
			    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
			    leave.type = 'mouseleave';
			    leave.target = fromNode;
			    leave.relatedTarget = toNode;
	
			    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
			    enter.type = 'mouseenter';
			    enter.target = toNode;
			    enter.relatedTarget = fromNode;
	
			    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
			    return [leave, enter];
			  }
	
			};
	
			module.exports = EnterLeaveEventPlugin;
	
		/***/ },
		/* 52 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticUIEvent = __webpack_require__(53);
			var ViewportMetrics = __webpack_require__(54);
	
			var getEventModifierState = __webpack_require__(55);
	
			/**
			 * @interface MouseEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var MouseEventInterface = {
			  screenX: null,
			  screenY: null,
			  clientX: null,
			  clientY: null,
			  ctrlKey: null,
			  shiftKey: null,
			  altKey: null,
			  metaKey: null,
			  getModifierState: getEventModifierState,
			  button: function (event) {
			    // Webkit, Firefox, IE9+
			    // which:  1 2 3
			    // button: 0 1 2 (standard)
			    var button = event.button;
			    if ('which' in event) {
			      return button;
			    }
			    // IE<9
			    // which:  undefined
			    // button: 0 0 0
			    // button: 1 4 2 (onmouseup)
			    return button === 2 ? 2 : button === 4 ? 1 : 0;
			  },
			  buttons: null,
			  relatedTarget: function (event) {
			    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
			  },
			  // "Proprietary" Interface.
			  pageX: function (event) {
			    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
			  },
			  pageY: function (event) {
			    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
			  }
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
			module.exports = SyntheticMouseEvent;
	
		/***/ },
		/* 53 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			var getEventTarget = __webpack_require__(47);
	
			/**
			 * @interface UIEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var UIEventInterface = {
			  view: function (event) {
			    if (event.view) {
			      return event.view;
			    }
	
			    var target = getEventTarget(event);
			    if (target.window === target) {
			      // target is a window object
			      return target;
			    }
	
			    var doc = target.ownerDocument;
			    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
			    if (doc) {
			      return doc.defaultView || doc.parentWindow;
			    } else {
			      return window;
			    }
			  },
			  detail: function (event) {
			    return event.detail || 0;
			  }
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticEvent}
			 */
			function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
			module.exports = SyntheticUIEvent;
	
		/***/ },
		/* 54 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ViewportMetrics = {
	
			  currentScrollLeft: 0,
	
			  currentScrollTop: 0,
	
			  refreshScrollValues: function (scrollPosition) {
			    ViewportMetrics.currentScrollLeft = scrollPosition.x;
			    ViewportMetrics.currentScrollTop = scrollPosition.y;
			  }
	
			};
	
			module.exports = ViewportMetrics;
	
		/***/ },
		/* 55 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Translation from modifier key to the associated property in the event.
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
			 */
	
			var modifierKeyToProp = {
			  'Alt': 'altKey',
			  'Control': 'ctrlKey',
			  'Meta': 'metaKey',
			  'Shift': 'shiftKey'
			};
	
			// IE8 does not implement getModifierState so we simply map it to the only
			// modifier keys exposed by the event itself, does not support Lock-keys.
			// Currently, all major browsers except Chrome seems to support Lock-keys.
			function modifierStateGetter(keyArg) {
			  var syntheticEvent = this;
			  var nativeEvent = syntheticEvent.nativeEvent;
			  if (nativeEvent.getModifierState) {
			    return nativeEvent.getModifierState(keyArg);
			  }
			  var keyProp = modifierKeyToProp[keyArg];
			  return keyProp ? !!nativeEvent[keyProp] : false;
			}
	
			function getEventModifierState(nativeEvent) {
			  return modifierStateGetter;
			}
	
			module.exports = getEventModifierState;
	
		/***/ },
		/* 56 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
	
			var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
			var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
			var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
			var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
			var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
			var HTMLDOMPropertyConfig = {
			  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
			  Properties: {
			    /**
			     * Standard Properties
			     */
			    accept: 0,
			    acceptCharset: 0,
			    accessKey: 0,
			    action: 0,
			    allowFullScreen: HAS_BOOLEAN_VALUE,
			    allowTransparency: 0,
			    alt: 0,
			    // specifies target context for links with `preload` type
			    as: 0,
			    async: HAS_BOOLEAN_VALUE,
			    autoComplete: 0,
			    // autoFocus is polyfilled/normalized by AutoFocusUtils
			    // autoFocus: HAS_BOOLEAN_VALUE,
			    autoPlay: HAS_BOOLEAN_VALUE,
			    capture: HAS_BOOLEAN_VALUE,
			    cellPadding: 0,
			    cellSpacing: 0,
			    charSet: 0,
			    challenge: 0,
			    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
			    cite: 0,
			    classID: 0,
			    className: 0,
			    cols: HAS_POSITIVE_NUMERIC_VALUE,
			    colSpan: 0,
			    content: 0,
			    contentEditable: 0,
			    contextMenu: 0,
			    controls: HAS_BOOLEAN_VALUE,
			    coords: 0,
			    crossOrigin: 0,
			    data: 0, // For `<object />` acts as `src`.
			    dateTime: 0,
			    'default': HAS_BOOLEAN_VALUE,
			    defer: HAS_BOOLEAN_VALUE,
			    dir: 0,
			    disabled: HAS_BOOLEAN_VALUE,
			    download: HAS_OVERLOADED_BOOLEAN_VALUE,
			    draggable: 0,
			    encType: 0,
			    form: 0,
			    formAction: 0,
			    formEncType: 0,
			    formMethod: 0,
			    formNoValidate: HAS_BOOLEAN_VALUE,
			    formTarget: 0,
			    frameBorder: 0,
			    headers: 0,
			    height: 0,
			    hidden: HAS_BOOLEAN_VALUE,
			    high: 0,
			    href: 0,
			    hrefLang: 0,
			    htmlFor: 0,
			    httpEquiv: 0,
			    icon: 0,
			    id: 0,
			    inputMode: 0,
			    integrity: 0,
			    is: 0,
			    keyParams: 0,
			    keyType: 0,
			    kind: 0,
			    label: 0,
			    lang: 0,
			    list: 0,
			    loop: HAS_BOOLEAN_VALUE,
			    low: 0,
			    manifest: 0,
			    marginHeight: 0,
			    marginWidth: 0,
			    max: 0,
			    maxLength: 0,
			    media: 0,
			    mediaGroup: 0,
			    method: 0,
			    min: 0,
			    minLength: 0,
			    // Caution; `option.selected` is not updated if `select.multiple` is
			    // disabled with `removeAttribute`.
			    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
			    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
			    name: 0,
			    nonce: 0,
			    noValidate: HAS_BOOLEAN_VALUE,
			    open: HAS_BOOLEAN_VALUE,
			    optimum: 0,
			    pattern: 0,
			    placeholder: 0,
			    playsInline: HAS_BOOLEAN_VALUE,
			    poster: 0,
			    preload: 0,
			    profile: 0,
			    radioGroup: 0,
			    readOnly: HAS_BOOLEAN_VALUE,
			    referrerPolicy: 0,
			    rel: 0,
			    required: HAS_BOOLEAN_VALUE,
			    reversed: HAS_BOOLEAN_VALUE,
			    role: 0,
			    rows: HAS_POSITIVE_NUMERIC_VALUE,
			    rowSpan: HAS_NUMERIC_VALUE,
			    sandbox: 0,
			    scope: 0,
			    scoped: HAS_BOOLEAN_VALUE,
			    scrolling: 0,
			    seamless: HAS_BOOLEAN_VALUE,
			    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
			    shape: 0,
			    size: HAS_POSITIVE_NUMERIC_VALUE,
			    sizes: 0,
			    span: HAS_POSITIVE_NUMERIC_VALUE,
			    spellCheck: 0,
			    src: 0,
			    srcDoc: 0,
			    srcLang: 0,
			    srcSet: 0,
			    start: HAS_NUMERIC_VALUE,
			    step: 0,
			    style: 0,
			    summary: 0,
			    tabIndex: 0,
			    target: 0,
			    title: 0,
			    // Setting .type throws on non-<input> tags
			    type: 0,
			    useMap: 0,
			    value: 0,
			    width: 0,
			    wmode: 0,
			    wrap: 0,
	
			    /**
			     * RDFa Properties
			     */
			    about: 0,
			    datatype: 0,
			    inlist: 0,
			    prefix: 0,
			    // property is also supported for OpenGraph in meta tags.
			    property: 0,
			    resource: 0,
			    'typeof': 0,
			    vocab: 0,
	
			    /**
			     * Non-standard Properties
			     */
			    // autoCapitalize and autoCorrect are supported in Mobile Safari for
			    // keyboard hints.
			    autoCapitalize: 0,
			    autoCorrect: 0,
			    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
			    autoSave: 0,
			    // color is for Safari mask-icon link
			    color: 0,
			    // itemProp, itemScope, itemType are for
			    // Microdata support. See http://schema.org/docs/gs.html
			    itemProp: 0,
			    itemScope: HAS_BOOLEAN_VALUE,
			    itemType: 0,
			    // itemID and itemRef are for Microdata support as well but
			    // only specified in the WHATWG spec document. See
			    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
			    itemID: 0,
			    itemRef: 0,
			    // results show looking glass icon and recent searches on input
			    // search fields in WebKit/Blink
			    results: 0,
			    // IE-only attribute that specifies security restrictions on an iframe
			    // as an alternative to the sandbox attribute on IE<10
			    security: 0,
			    // IE-only attribute that controls focus behavior
			    unselectable: 0
			  },
			  DOMAttributeNames: {
			    acceptCharset: 'accept-charset',
			    className: 'class',
			    htmlFor: 'for',
			    httpEquiv: 'http-equiv'
			  },
			  DOMPropertyNames: {}
			};
	
			module.exports = HTMLDOMPropertyConfig;
	
		/***/ },
		/* 57 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMChildrenOperations = __webpack_require__(58);
			var ReactDOMIDOperations = __webpack_require__(69);
	
			/**
			 * Abstracts away all functionality of the reconciler that requires knowledge of
			 * the browser context. TODO: These callers should be refactored to avoid the
			 * need for this injection.
			 */
			var ReactComponentBrowserEnvironment = {
	
			  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
			  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
			};
	
			module.exports = ReactComponentBrowserEnvironment;
	
		/***/ },
		/* 58 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMLazyTree = __webpack_require__(59);
			var Danger = __webpack_require__(65);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactInstrumentation = __webpack_require__(37);
	
			var createMicrosoftUnsafeLocalFunction = __webpack_require__(62);
			var setInnerHTML = __webpack_require__(61);
			var setTextContent = __webpack_require__(63);
	
			function getNodeAfter(parentNode, node) {
			  // Special case for text components, which return [open, close] comments
			  // from getHostNode.
			  if (Array.isArray(node)) {
			    node = node[1];
			  }
			  return node ? node.nextSibling : parentNode.firstChild;
			}
	
			/**
			 * Inserts `childNode` as a child of `parentNode` at the `index`.
			 *
			 * @param {DOMElement} parentNode Parent node in which to insert.
			 * @param {DOMElement} childNode Child node to insert.
			 * @param {number} index Index at which to insert the child.
			 * @internal
			 */
			var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
			  // We rely exclusively on `insertBefore(node, null)` instead of also using
			  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
			  // we are careful to use `null`.)
			  parentNode.insertBefore(childNode, referenceNode);
			});
	
			function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
			  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
			}
	
			function moveChild(parentNode, childNode, referenceNode) {
			  if (Array.isArray(childNode)) {
			    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
			  } else {
			    insertChildAt(parentNode, childNode, referenceNode);
			  }
			}
	
			function removeChild(parentNode, childNode) {
			  if (Array.isArray(childNode)) {
			    var closingComment = childNode[1];
			    childNode = childNode[0];
			    removeDelimitedText(parentNode, childNode, closingComment);
			    parentNode.removeChild(closingComment);
			  }
			  parentNode.removeChild(childNode);
			}
	
			function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
			  var node = openingComment;
			  while (true) {
			    var nextNode = node.nextSibling;
			    insertChildAt(parentNode, node, referenceNode);
			    if (node === closingComment) {
			      break;
			    }
			    node = nextNode;
			  }
			}
	
			function removeDelimitedText(parentNode, startNode, closingComment) {
			  while (true) {
			    var node = startNode.nextSibling;
			    if (node === closingComment) {
			      // The closing comment is removed by ReactMultiChild.
			      break;
			    } else {
			      parentNode.removeChild(node);
			    }
			  }
			}
	
			function replaceDelimitedText(openingComment, closingComment, stringText) {
			  var parentNode = openingComment.parentNode;
			  var nodeAfterComment = openingComment.nextSibling;
			  if (nodeAfterComment === closingComment) {
			    // There are no text nodes between the opening and closing comments; insert
			    // a new one if stringText isn't empty.
			    if (stringText) {
			      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
			    }
			  } else {
			    if (stringText) {
			      // Set the text content of the first node after the opening comment, and
			      // remove all following nodes up until the closing comment.
			      setTextContent(nodeAfterComment, stringText);
			      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
			    } else {
			      removeDelimitedText(parentNode, openingComment, closingComment);
			    }
			  }
	
			  if (process.env.NODE_ENV !== 'production') {
			    ReactInstrumentation.debugTool.onHostOperation({
			      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
			      type: 'replace text',
			      payload: stringText
			    });
			  }
			}
	
			var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
			if (process.env.NODE_ENV !== 'production') {
			  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
			    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
			    if (prevInstance._debugID !== 0) {
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: prevInstance._debugID,
			        type: 'replace with',
			        payload: markup.toString()
			      });
			    } else {
			      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
			      if (nextInstance._debugID !== 0) {
			        ReactInstrumentation.debugTool.onHostOperation({
			          instanceID: nextInstance._debugID,
			          type: 'mount',
			          payload: markup.toString()
			        });
			      }
			    }
			  };
			}
	
			/**
			 * Operations for updating with DOM children.
			 */
			var DOMChildrenOperations = {
	
			  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
			  replaceDelimitedText: replaceDelimitedText,
	
			  /**
			   * Updates a component's children by processing a series of updates. The
			   * update configurations are each expected to have a `parentNode` property.
			   *
			   * @param {array<object>} updates List of update configurations.
			   * @internal
			   */
			  processUpdates: function (parentNode, updates) {
			    if (process.env.NODE_ENV !== 'production') {
			      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
			    }
	
			    for (var k = 0; k < updates.length; k++) {
			      var update = updates[k];
			      switch (update.type) {
			        case 'INSERT_MARKUP':
			          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'insert child',
			              payload: { toIndex: update.toIndex, content: update.content.toString() }
			            });
			          }
			          break;
			        case 'MOVE_EXISTING':
			          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'move child',
			              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
			            });
			          }
			          break;
			        case 'SET_MARKUP':
			          setInnerHTML(parentNode, update.content);
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'replace children',
			              payload: update.content.toString()
			            });
			          }
			          break;
			        case 'TEXT_CONTENT':
			          setTextContent(parentNode, update.content);
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'replace text',
			              payload: update.content.toString()
			            });
			          }
			          break;
			        case 'REMOVE_NODE':
			          removeChild(parentNode, update.fromNode);
			          if (process.env.NODE_ENV !== 'production') {
			            ReactInstrumentation.debugTool.onHostOperation({
			              instanceID: parentNodeDebugID,
			              type: 'remove child',
			              payload: { fromIndex: update.fromIndex }
			            });
			          }
			          break;
			      }
			    }
			  }
	
			};
	
			module.exports = DOMChildrenOperations;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 59 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMNamespaces = __webpack_require__(60);
			var setInnerHTML = __webpack_require__(61);
	
			var createMicrosoftUnsafeLocalFunction = __webpack_require__(62);
			var setTextContent = __webpack_require__(63);
	
			var ELEMENT_NODE_TYPE = 1;
			var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
			/**
			 * In IE (8-11) and Edge, appending nodes with no children is dramatically
			 * faster than appending a full subtree, so we essentially queue up the
			 * .appendChild calls here and apply them so each node is added to its parent
			 * before any children are added.
			 *
			 * In other browsers, doing so is slower or neutral compared to the other order
			 * (in Firefox, twice as slow) so we only do this inversion in IE.
			 *
			 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
			 */
			var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
			function insertTreeChildren(tree) {
			  if (!enableLazy) {
			    return;
			  }
			  var node = tree.node;
			  var children = tree.children;
			  if (children.length) {
			    for (var i = 0; i < children.length; i++) {
			      insertTreeBefore(node, children[i], null);
			    }
			  } else if (tree.html != null) {
			    setInnerHTML(node, tree.html);
			  } else if (tree.text != null) {
			    setTextContent(node, tree.text);
			  }
			}
	
			var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
			  // DocumentFragments aren't actually part of the DOM after insertion so
			  // appending children won't update the DOM. We need to ensure the fragment
			  // is properly populated first, breaking out of our lazy approach for just
			  // this level. Also, some <object> plugins (like Flash Player) will read
			  // <param> nodes immediately upon insertion into the DOM, so <object>
			  // must also be populated prior to insertion into the DOM.
			  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
			    insertTreeChildren(tree);
			    parentNode.insertBefore(tree.node, referenceNode);
			  } else {
			    parentNode.insertBefore(tree.node, referenceNode);
			    insertTreeChildren(tree);
			  }
			});
	
			function replaceChildWithTree(oldNode, newTree) {
			  oldNode.parentNode.replaceChild(newTree.node, oldNode);
			  insertTreeChildren(newTree);
			}
	
			function queueChild(parentTree, childTree) {
			  if (enableLazy) {
			    parentTree.children.push(childTree);
			  } else {
			    parentTree.node.appendChild(childTree.node);
			  }
			}
	
			function queueHTML(tree, html) {
			  if (enableLazy) {
			    tree.html = html;
			  } else {
			    setInnerHTML(tree.node, html);
			  }
			}
	
			function queueText(tree, text) {
			  if (enableLazy) {
			    tree.text = text;
			  } else {
			    setTextContent(tree.node, text);
			  }
			}
	
			function toString() {
			  return this.node.nodeName;
			}
	
			function DOMLazyTree(node) {
			  return {
			    node: node,
			    children: [],
			    html: null,
			    text: null,
			    toString: toString
			  };
			}
	
			DOMLazyTree.insertTreeBefore = insertTreeBefore;
			DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
			DOMLazyTree.queueChild = queueChild;
			DOMLazyTree.queueHTML = queueHTML;
			DOMLazyTree.queueText = queueText;
	
			module.exports = DOMLazyTree;
	
		/***/ },
		/* 60 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMNamespaces = {
			  html: 'http://www.w3.org/1999/xhtml',
			  mathml: 'http://www.w3.org/1998/Math/MathML',
			  svg: 'http://www.w3.org/2000/svg'
			};
	
			module.exports = DOMNamespaces;
	
		/***/ },
		/* 61 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
			var DOMNamespaces = __webpack_require__(60);
	
			var WHITESPACE_TEST = /^[ \r\n\t\f]/;
			var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
			var createMicrosoftUnsafeLocalFunction = __webpack_require__(62);
	
			// SVG temp container for IE lacking innerHTML
			var reusableSVGContainer;
	
			/**
			 * Set the innerHTML property of a node, ensuring that whitespace is preserved
			 * even in IE8.
			 *
			 * @param {DOMElement} node
			 * @param {string} html
			 * @internal
			 */
			var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
			  // IE does not have innerHTML for SVG nodes, so instead we inject the
			  // new markup in a temp node and then move the child nodes across into
			  // the target node
			  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
			    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
			    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
			    var svgNode = reusableSVGContainer.firstChild;
			    while (svgNode.firstChild) {
			      node.appendChild(svgNode.firstChild);
			    }
			  } else {
			    node.innerHTML = html;
			  }
			});
	
			if (ExecutionEnvironment.canUseDOM) {
			  // IE8: When updating a just created node with innerHTML only leading
			  // whitespace is removed. When updating an existing node with innerHTML
			  // whitespace in root TextNodes is also collapsed.
			  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
			  // Feature detection; only IE8 is known to behave improperly like this.
			  var testElement = document.createElement('div');
			  testElement.innerHTML = ' ';
			  if (testElement.innerHTML === '') {
			    setInnerHTML = function (node, html) {
			      // Magic theory: IE8 supposedly differentiates between added and updated
			      // nodes when processing innerHTML, innerHTML on updated nodes suffers
			      // from worse whitespace behavior. Re-adding a node like this triggers
			      // the initial and more favorable whitespace behavior.
			      // TODO: What to do on a detached node?
			      if (node.parentNode) {
			        node.parentNode.replaceChild(node, node);
			      }
	
			      // We also implement a workaround for non-visible tags disappearing into
			      // thin air on IE8, this only happens if there is no visible text
			      // in-front of the non-visible tags. Piggyback on the whitespace fix
			      // and simply check if any non-visible tags appear in the source.
			      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
			        // Recover leading whitespace by temporarily prepending any character.
			        // \uFEFF has the potential advantage of being zero-width/invisible.
			        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
			        // in hopes that this is preserved even if "\uFEFF" is transformed to
			        // the actual Unicode character (by Babel, for example).
			        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
			        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
			        // deleteData leaves an empty `TextNode` which offsets the index of all
			        // children. Definitely want to avoid this.
			        var textNode = node.firstChild;
			        if (textNode.data.length === 1) {
			          node.removeChild(textNode);
			        } else {
			          textNode.deleteData(0, 1);
			        }
			      } else {
			        node.innerHTML = html;
			      }
			    };
			  }
			  testElement = null;
			}
	
			module.exports = setInnerHTML;
	
		/***/ },
		/* 62 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/* globals MSApp */
	
			'use strict';
	
			/**
			 * Create a function which has 'unsafe' privileges (required by windows8 apps)
			 */
	
			var createMicrosoftUnsafeLocalFunction = function (func) {
			  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
			    return function (arg0, arg1, arg2, arg3) {
			      MSApp.execUnsafeLocalFunction(function () {
			        return func(arg0, arg1, arg2, arg3);
			      });
			    };
			  } else {
			    return func;
			  }
			};
	
			module.exports = createMicrosoftUnsafeLocalFunction;
	
		/***/ },
		/* 63 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
			var escapeTextContentForBrowser = __webpack_require__(64);
			var setInnerHTML = __webpack_require__(61);
	
			/**
			 * Set the textContent property of a node, ensuring that whitespace is preserved
			 * even in IE8. innerText is a poor substitute for textContent and, among many
			 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
			 * as it should.
			 *
			 * @param {DOMElement} node
			 * @param {string} text
			 * @internal
			 */
			var setTextContent = function (node, text) {
			  if (text) {
			    var firstChild = node.firstChild;
	
			    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
			      firstChild.nodeValue = text;
			      return;
			    }
			  }
			  node.textContent = text;
			};
	
			if (ExecutionEnvironment.canUseDOM) {
			  if (!('textContent' in document.documentElement)) {
			    setTextContent = function (node, text) {
			      if (node.nodeType === 3) {
			        node.nodeValue = text;
			        return;
			      }
			      setInnerHTML(node, escapeTextContentForBrowser(text));
			    };
			  }
			}
	
			module.exports = setTextContent;
	
		/***/ },
		/* 64 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2016-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * Based on the escape-html library, which is used under the MIT License below:
			 *
			 * Copyright (c) 2012-2013 TJ Holowaychuk
			 * Copyright (c) 2015 Andreas Lubbe
			 * Copyright (c) 2015 Tiancheng "Timothy" Gu
			 *
			 * Permission is hereby granted, free of charge, to any person obtaining
			 * a copy of this software and associated documentation files (the
			 * 'Software'), to deal in the Software without restriction, including
			 * without limitation the rights to use, copy, modify, merge, publish,
			 * distribute, sublicense, and/or sell copies of the Software, and to
			 * permit persons to whom the Software is furnished to do so, subject to
			 * the following conditions:
			 *
			 * The above copyright notice and this permission notice shall be
			 * included in all copies or substantial portions of the Software.
			 *
			 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
			 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
			 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
			 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
			 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
			 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
			 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
			 *
			 */
	
			'use strict';
	
			// code copied and modified from escape-html
			/**
			 * Module variables.
			 * @private
			 */
	
			var matchHtmlRegExp = /["'&<>]/;
	
			/**
			 * Escape special characters in the given string of html.
			 *
			 * @param  {string} string The string to escape for inserting into HTML
			 * @return {string}
			 * @public
			 */
	
			function escapeHtml(string) {
			  var str = '' + string;
			  var match = matchHtmlRegExp.exec(str);
	
			  if (!match) {
			    return str;
			  }
	
			  var escape;
			  var html = '';
			  var index = 0;
			  var lastIndex = 0;
	
			  for (index = match.index; index < str.length; index++) {
			    switch (str.charCodeAt(index)) {
			      case 34:
			        // "
			        escape = '&quot;';
			        break;
			      case 38:
			        // &
			        escape = '&amp;';
			        break;
			      case 39:
			        // '
			        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
			        break;
			      case 60:
			        // <
			        escape = '&lt;';
			        break;
			      case 62:
			        // >
			        escape = '&gt;';
			        break;
			      default:
			        continue;
			    }
	
			    if (lastIndex !== index) {
			      html += str.substring(lastIndex, index);
			    }
	
			    lastIndex = index + 1;
			    html += escape;
			  }
	
			  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
			}
			// end code copied and modified from escape-html
	
	
			/**
			 * Escapes text to prevent scripting attacks.
			 *
			 * @param {*} text Text value to escape.
			 * @return {string} An escaped string.
			 */
			function escapeTextContentForBrowser(text) {
			  if (typeof text === 'boolean' || typeof text === 'number') {
			    // this shortcircuit helps perf for types that we know will never have
			    // special characters, especially given that this function is used often
			    // for numeric dom ids.
			    return '' + text;
			  }
			  return escapeHtml(text);
			}
	
			module.exports = escapeTextContentForBrowser;
	
		/***/ },
		/* 65 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var DOMLazyTree = __webpack_require__(59);
			var ExecutionEnvironment = __webpack_require__(22);
	
			var createNodesFromMarkup = __webpack_require__(66);
			var emptyFunction = __webpack_require__(19);
			var invariant = __webpack_require__(8);
	
			var Danger = {
	
			  /**
			   * Replaces a node with a string of markup at its current position within its
			   * parent. The markup must render into a single root node.
			   *
			   * @param {DOMElement} oldChild Child node to replace.
			   * @param {string} markup Markup to render in place of the child node.
			   * @internal
			   */
			  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
			    !ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
			    !markup ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
			    !(oldChild.nodeName !== 'HTML') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
			    if (typeof markup === 'string') {
			      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
			      oldChild.parentNode.replaceChild(newChild, oldChild);
			    } else {
			      DOMLazyTree.replaceChildWithTree(oldChild, markup);
			    }
			  }
	
			};
	
			module.exports = Danger;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 66 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			/*eslint-disable fb-www/unsafe-html*/
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var createArrayFromMixed = __webpack_require__(67);
			var getMarkupWrap = __webpack_require__(68);
			var invariant = __webpack_require__(8);
	
			/**
			 * Dummy container used to render all markup.
			 */
			var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
			/**
			 * Pattern used by `getNodeName`.
			 */
			var nodeNamePattern = /^\s*<(\w+)/;
	
			/**
			 * Extracts the `nodeName` of the first element in a string of markup.
			 *
			 * @param {string} markup String of markup.
			 * @return {?string} Node name of the supplied markup.
			 */
			function getNodeName(markup) {
			  var nodeNameMatch = markup.match(nodeNamePattern);
			  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
			}
	
			/**
			 * Creates an array containing the nodes rendered from the supplied markup. The
			 * optionally supplied `handleScript` function will be invoked once for each
			 * <script> element that is rendered. If no `handleScript` function is supplied,
			 * an exception is thrown if any <script> elements are rendered.
			 *
			 * @param {string} markup A string of valid HTML markup.
			 * @param {?function} handleScript Invoked once for each rendered <script>.
			 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
			 */
			function createNodesFromMarkup(markup, handleScript) {
			  var node = dummyNode;
			  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
			  var nodeName = getNodeName(markup);
	
			  var wrap = nodeName && getMarkupWrap(nodeName);
			  if (wrap) {
			    node.innerHTML = wrap[1] + markup + wrap[2];
	
			    var wrapDepth = wrap[0];
			    while (wrapDepth--) {
			      node = node.lastChild;
			    }
			  } else {
			    node.innerHTML = markup;
			  }
	
			  var scripts = node.getElementsByTagName('script');
			  if (scripts.length) {
			    !handleScript ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
			    createArrayFromMixed(scripts).forEach(handleScript);
			  }
	
			  var nodes = Array.from(node.childNodes);
			  while (node.lastChild) {
			    node.removeChild(node.lastChild);
			  }
			  return nodes;
			}
	
			module.exports = createNodesFromMarkup;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 67 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Convert array-like objects to arrays.
			 *
			 * This API assumes the caller knows the contents of the data type. For less
			 * well defined inputs use createArrayFromMixed.
			 *
			 * @param {object|function|filelist} obj
			 * @return {array}
			 */
			function toArray(obj) {
			  var length = obj.length;
	
			  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
			  // in old versions of Safari).
			  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
			  !(typeof length === 'number') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
			  !(length === 0 || length - 1 in obj) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
			  !(typeof obj.callee !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
			  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
			  // without method will throw during the slice call and skip straight to the
			  // fallback.
			  if (obj.hasOwnProperty) {
			    try {
			      return Array.prototype.slice.call(obj);
			    } catch (e) {
			      // IE < 9 does not support Array#slice on collections objects
			    }
			  }
	
			  // Fall back to copying key by key. This assumes all keys have a value,
			  // so will not preserve sparsely populated inputs.
			  var ret = Array(length);
			  for (var ii = 0; ii < length; ii++) {
			    ret[ii] = obj[ii];
			  }
			  return ret;
			}
	
			/**
			 * Perform a heuristic test to determine if an object is "array-like".
			 *
			 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
			 *   Joshu replied: "Mu."
			 *
			 * This function determines if its argument has "array nature": it returns
			 * true if the argument is an actual array, an `arguments' object, or an
			 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
			 *
			 * It will return false for other array-like objects like Filelist.
			 *
			 * @param {*} obj
			 * @return {boolean}
			 */
			function hasArrayNature(obj) {
			  return (
			    // not null/false
			    !!obj && (
			    // arrays are objects, NodeLists are functions in Safari
			    typeof obj == 'object' || typeof obj == 'function') &&
			    // quacks like an array
			    'length' in obj &&
			    // not window
			    !('setInterval' in obj) &&
			    // no DOM node should be considered an array-like
			    // a 'select' element has 'length' and 'item' properties on IE8
			    typeof obj.nodeType != 'number' && (
			    // a real array
			    Array.isArray(obj) ||
			    // arguments
			    'callee' in obj ||
			    // HTMLCollection/NodeList
			    'item' in obj)
			  );
			}
	
			/**
			 * Ensure that the argument is an array by wrapping it in an array if it is not.
			 * Creates a copy of the argument if it is already an array.
			 *
			 * This is mostly useful idiomatically:
			 *
			 *   var createArrayFromMixed = require('createArrayFromMixed');
			 *
			 *   function takesOneOrMoreThings(things) {
			 *     things = createArrayFromMixed(things);
			 *     ...
			 *   }
			 *
			 * This allows you to treat `things' as an array, but accept scalars in the API.
			 *
			 * If you need to convert an array-like object, like `arguments`, into an array
			 * use toArray instead.
			 *
			 * @param {*} obj
			 * @return {array}
			 */
			function createArrayFromMixed(obj) {
			  if (!hasArrayNature(obj)) {
			    return [obj];
			  } else if (Array.isArray(obj)) {
			    return obj.slice();
			  } else {
			    return toArray(obj);
			  }
			}
	
			module.exports = createArrayFromMixed;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 68 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/*eslint-disable fb-www/unsafe-html */
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Dummy container used to detect which wraps are necessary.
			 */
			var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
			/**
			 * Some browsers cannot use `innerHTML` to render certain elements standalone,
			 * so we wrap them, render the wrapped nodes, then extract the desired node.
			 *
			 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
			 */
	
			var shouldWrap = {};
	
			var selectWrap = [1, '<select multiple="true">', '</select>'];
			var tableWrap = [1, '<table>', '</table>'];
			var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
			var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
			var markupWrap = {
			  '*': [1, '?<div>', '</div>'],
	
			  'area': [1, '<map>', '</map>'],
			  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
			  'legend': [1, '<fieldset>', '</fieldset>'],
			  'param': [1, '<object>', '</object>'],
			  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
			  'optgroup': selectWrap,
			  'option': selectWrap,
	
			  'caption': tableWrap,
			  'colgroup': tableWrap,
			  'tbody': tableWrap,
			  'tfoot': tableWrap,
			  'thead': tableWrap,
	
			  'td': trWrap,
			  'th': trWrap
			};
	
			// Initialize the SVG elements since we know they'll always need to be wrapped
			// consistently. If they are created inside a <div> they will be initialized in
			// the wrong namespace (and will not display).
			var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
			svgElements.forEach(function (nodeName) {
			  markupWrap[nodeName] = svgWrap;
			  shouldWrap[nodeName] = true;
			});
	
			/**
			 * Gets the markup wrap configuration for the supplied `nodeName`.
			 *
			 * NOTE: This lazily detects which wraps are necessary for the current browser.
			 *
			 * @param {string} nodeName Lowercase `nodeName`.
			 * @return {?array} Markup wrap configuration, if applicable.
			 */
			function getMarkupWrap(nodeName) {
			  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
			  if (!markupWrap.hasOwnProperty(nodeName)) {
			    nodeName = '*';
			  }
			  if (!shouldWrap.hasOwnProperty(nodeName)) {
			    if (nodeName === '*') {
			      dummyNode.innerHTML = '<link />';
			    } else {
			      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
			    }
			    shouldWrap[nodeName] = !dummyNode.firstChild;
			  }
			  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
			}
	
			module.exports = getMarkupWrap;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 69 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMChildrenOperations = __webpack_require__(58);
			var ReactDOMComponentTree = __webpack_require__(5);
	
			/**
			 * Operations used to process updates to DOM nodes.
			 */
			var ReactDOMIDOperations = {
	
			  /**
			   * Updates a component's children by processing a series of updates.
			   *
			   * @param {array<object>} updates List of update configurations.
			   * @internal
			   */
			  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
			    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
			    DOMChildrenOperations.processUpdates(node, updates);
			  }
			};
	
			module.exports = ReactDOMIDOperations;
	
		/***/ },
		/* 70 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/* global hasOwnProperty:true */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var AutoFocusUtils = __webpack_require__(71);
			var CSSPropertyOperations = __webpack_require__(73);
			var DOMLazyTree = __webpack_require__(59);
			var DOMNamespaces = __webpack_require__(60);
			var DOMProperty = __webpack_require__(7);
			var DOMPropertyOperations = __webpack_require__(81);
			var EventPluginHub = __webpack_require__(14);
			var EventPluginRegistry = __webpack_require__(15);
			var ReactBrowserEventEmitter = __webpack_require__(83);
			var ReactDOMComponentFlags = __webpack_require__(9);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDOMInput = __webpack_require__(86);
			var ReactDOMOption = __webpack_require__(111);
			var ReactDOMSelect = __webpack_require__(112);
			var ReactDOMTextarea = __webpack_require__(113);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactMultiChild = __webpack_require__(114);
			var ReactServerRenderingTransaction = __webpack_require__(133);
	
			var emptyFunction = __webpack_require__(19);
			var escapeTextContentForBrowser = __webpack_require__(64);
			var invariant = __webpack_require__(8);
			var isEventSupported = __webpack_require__(48);
			var shallowEqual = __webpack_require__(123);
			var validateDOMNesting = __webpack_require__(136);
			var warning = __webpack_require__(18);
	
			var Flags = ReactDOMComponentFlags;
			var deleteListener = EventPluginHub.deleteListener;
			var getNode = ReactDOMComponentTree.getNodeFromInstance;
			var listenTo = ReactBrowserEventEmitter.listenTo;
			var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
			// For quickly matching children type, to test if can be treated as content.
			var CONTENT_TYPES = { 'string': true, 'number': true };
	
			var STYLE = 'style';
			var HTML = '__html';
			var RESERVED_PROPS = {
			  children: null,
			  dangerouslySetInnerHTML: null,
			  suppressContentEditableWarning: null
			};
	
			// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
			var DOC_FRAGMENT_TYPE = 11;
	
			function getDeclarationErrorAddendum(internalInstance) {
			  if (internalInstance) {
			    var owner = internalInstance._currentElement._owner || null;
			    if (owner) {
			      var name = owner.getName();
			      if (name) {
			        return ' This DOM node was rendered by `' + name + '`.';
			      }
			    }
			  }
			  return '';
			}
	
			function friendlyStringify(obj) {
			  if (typeof obj === 'object') {
			    if (Array.isArray(obj)) {
			      return '[' + obj.map(friendlyStringify).join(', ') + ']';
			    } else {
			      var pairs = [];
			      for (var key in obj) {
			        if (Object.prototype.hasOwnProperty.call(obj, key)) {
			          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
			          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
			        }
			      }
			      return '{' + pairs.join(', ') + '}';
			    }
			  } else if (typeof obj === 'string') {
			    return JSON.stringify(obj);
			  } else if (typeof obj === 'function') {
			    return '[function object]';
			  }
			  // Differs from JSON.stringify in that undefined because undefined and that
			  // inf and nan don't become null
			  return String(obj);
			}
	
			var styleMutationWarning = {};
	
			function checkAndWarnForMutatedStyle(style1, style2, component) {
			  if (style1 == null || style2 == null) {
			    return;
			  }
			  if (shallowEqual(style1, style2)) {
			    return;
			  }
	
			  var componentName = component._tag;
			  var owner = component._currentElement._owner;
			  var ownerName;
			  if (owner) {
			    ownerName = owner.getName();
			  }
	
			  var hash = ownerName + '|' + componentName;
	
			  if (styleMutationWarning.hasOwnProperty(hash)) {
			    return;
			  }
	
			  styleMutationWarning[hash] = true;
	
			  process.env.NODE_ENV !== 'production' ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
			}
	
			/**
			 * @param {object} component
			 * @param {?object} props
			 */
			function assertValidProps(component, props) {
			  if (!props) {
			    return;
			  }
			  // Note the use of `==` which checks for null or undefined.
			  if (voidElementTags[component._tag]) {
			    !(props.children == null && props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
			  }
			  if (props.dangerouslySetInnerHTML != null) {
			    !(props.children == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
			    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
			  }
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
			    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
			    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
			  }
			  !(props.style == null || typeof props.style === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
			}
	
			function enqueuePutListener(inst, registrationName, listener, transaction) {
			  if (transaction instanceof ReactServerRenderingTransaction) {
			    return;
			  }
			  if (process.env.NODE_ENV !== 'production') {
			    // IE8 has no API for event capturing and the `onScroll` event doesn't
			    // bubble.
			    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
			  }
			  var containerInfo = inst._hostContainerInfo;
			  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
			  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
			  listenTo(registrationName, doc);
			  transaction.getReactMountReady().enqueue(putListener, {
			    inst: inst,
			    registrationName: registrationName,
			    listener: listener
			  });
			}
	
			function putListener() {
			  var listenerToPut = this;
			  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
			}
	
			function inputPostMount() {
			  var inst = this;
			  ReactDOMInput.postMountWrapper(inst);
			}
	
			function textareaPostMount() {
			  var inst = this;
			  ReactDOMTextarea.postMountWrapper(inst);
			}
	
			function optionPostMount() {
			  var inst = this;
			  ReactDOMOption.postMountWrapper(inst);
			}
	
			var setAndValidateContentChildDev = emptyFunction;
			if (process.env.NODE_ENV !== 'production') {
			  setAndValidateContentChildDev = function (content) {
			    var hasExistingContent = this._contentDebugID != null;
			    var debugID = this._debugID;
			    // This ID represents the inlined child that has no backing instance:
			    var contentDebugID = -debugID;
	
			    if (content == null) {
			      if (hasExistingContent) {
			        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
			      }
			      this._contentDebugID = null;
			      return;
			    }
	
			    validateDOMNesting(null, String(content), this, this._ancestorInfo);
			    this._contentDebugID = contentDebugID;
			    if (hasExistingContent) {
			      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
			      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
			    } else {
			      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
			      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
			      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
			    }
			  };
			}
	
			// There are so many media events, it makes sense to just
			// maintain a list rather than create a `trapBubbledEvent` for each
			var mediaEvents = {
			  topAbort: 'abort',
			  topCanPlay: 'canplay',
			  topCanPlayThrough: 'canplaythrough',
			  topDurationChange: 'durationchange',
			  topEmptied: 'emptied',
			  topEncrypted: 'encrypted',
			  topEnded: 'ended',
			  topError: 'error',
			  topLoadedData: 'loadeddata',
			  topLoadedMetadata: 'loadedmetadata',
			  topLoadStart: 'loadstart',
			  topPause: 'pause',
			  topPlay: 'play',
			  topPlaying: 'playing',
			  topProgress: 'progress',
			  topRateChange: 'ratechange',
			  topSeeked: 'seeked',
			  topSeeking: 'seeking',
			  topStalled: 'stalled',
			  topSuspend: 'suspend',
			  topTimeUpdate: 'timeupdate',
			  topVolumeChange: 'volumechange',
			  topWaiting: 'waiting'
			};
	
			function trapBubbledEventsLocal() {
			  var inst = this;
			  // If a component renders to null or if another component fatals and causes
			  // the state of the tree to be corrupted, `node` here can be null.
			  !inst._rootNodeID ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
			  var node = getNode(inst);
			  !node ? process.env.NODE_ENV !== 'production' ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
			  switch (inst._tag) {
			    case 'iframe':
			    case 'object':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
			      break;
			    case 'video':
			    case 'audio':
	
			      inst._wrapperState.listeners = [];
			      // Create listener for each media event
			      for (var event in mediaEvents) {
			        if (mediaEvents.hasOwnProperty(event)) {
			          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
			        }
			      }
			      break;
			    case 'source':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
			      break;
			    case 'img':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
			      break;
			    case 'form':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
			      break;
			    case 'input':
			    case 'select':
			    case 'textarea':
			      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
			      break;
			  }
			}
	
			function postUpdateSelectWrapper() {
			  ReactDOMSelect.postUpdateWrapper(this);
			}
	
			// For HTML, certain tags should omit their close tag. We keep a whitelist for
			// those special-case tags.
	
			var omittedCloseTags = {
			  'area': true,
			  'base': true,
			  'br': true,
			  'col': true,
			  'embed': true,
			  'hr': true,
			  'img': true,
			  'input': true,
			  'keygen': true,
			  'link': true,
			  'meta': true,
			  'param': true,
			  'source': true,
			  'track': true,
			  'wbr': true
			};
	
			var newlineEatingTags = {
			  'listing': true,
			  'pre': true,
			  'textarea': true
			};
	
			// For HTML, certain tags cannot have children. This has the same purpose as
			// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
			var voidElementTags = _assign({
			  'menuitem': true
			}, omittedCloseTags);
	
			// We accept any tag to be rendered but since this gets injected into arbitrary
			// HTML, we want to make sure that it's a safe tag.
			// http://www.w3.org/TR/REC-xml/#NT-Name
	
			var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
			var validatedTagCache = {};
			var hasOwnProperty = {}.hasOwnProperty;
	
			function validateDangerousTag(tag) {
			  if (!hasOwnProperty.call(validatedTagCache, tag)) {
			    !VALID_TAG_REGEX.test(tag) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
			    validatedTagCache[tag] = true;
			  }
			}
	
			function isCustomComponent(tagName, props) {
			  return tagName.indexOf('-') >= 0 || props.is != null;
			}
	
			var globalIdCounter = 1;
	
			/**
			 * Creates a new React class that is idempotent and capable of containing other
			 * React components. It accepts event listeners and DOM properties that are
			 * valid according to `DOMProperty`.
			 *
			 *  - Event listeners: `onClick`, `onMouseDown`, etc.
			 *  - DOM properties: `className`, `name`, `title`, etc.
			 *
			 * The `style` property functions differently from the DOM API. It accepts an
			 * object mapping of style properties to values.
			 *
			 * @constructor ReactDOMComponent
			 * @extends ReactMultiChild
			 */
			function ReactDOMComponent(element) {
			  var tag = element.type;
			  validateDangerousTag(tag);
			  this._currentElement = element;
			  this._tag = tag.toLowerCase();
			  this._namespaceURI = null;
			  this._renderedChildren = null;
			  this._previousStyle = null;
			  this._previousStyleCopy = null;
			  this._hostNode = null;
			  this._hostParent = null;
			  this._rootNodeID = 0;
			  this._domID = 0;
			  this._hostContainerInfo = null;
			  this._wrapperState = null;
			  this._topLevelWrapper = null;
			  this._flags = 0;
			  if (process.env.NODE_ENV !== 'production') {
			    this._ancestorInfo = null;
			    setAndValidateContentChildDev.call(this, null);
			  }
			}
	
			ReactDOMComponent.displayName = 'ReactDOMComponent';
	
			ReactDOMComponent.Mixin = {
	
			  /**
			   * Generates root tag markup then recurses. This method has side effects and
			   * is not idempotent.
			   *
			   * @internal
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {?ReactDOMComponent} the parent component instance
			   * @param {?object} info about the host container
			   * @param {object} context
			   * @return {string} The computed markup.
			   */
			  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
			    this._rootNodeID = globalIdCounter++;
			    this._domID = hostContainerInfo._idCounter++;
			    this._hostParent = hostParent;
			    this._hostContainerInfo = hostContainerInfo;
	
			    var props = this._currentElement.props;
	
			    switch (this._tag) {
			      case 'audio':
			      case 'form':
			      case 'iframe':
			      case 'img':
			      case 'link':
			      case 'object':
			      case 'source':
			      case 'video':
			        this._wrapperState = {
			          listeners: null
			        };
			        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
			        break;
			      case 'input':
			        ReactDOMInput.mountWrapper(this, props, hostParent);
			        props = ReactDOMInput.getHostProps(this, props);
			        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
			        break;
			      case 'option':
			        ReactDOMOption.mountWrapper(this, props, hostParent);
			        props = ReactDOMOption.getHostProps(this, props);
			        break;
			      case 'select':
			        ReactDOMSelect.mountWrapper(this, props, hostParent);
			        props = ReactDOMSelect.getHostProps(this, props);
			        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
			        break;
			      case 'textarea':
			        ReactDOMTextarea.mountWrapper(this, props, hostParent);
			        props = ReactDOMTextarea.getHostProps(this, props);
			        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
			        break;
			    }
	
			    assertValidProps(this, props);
	
			    // We create tags in the namespace of their parent container, except HTML
			    // tags get no namespace.
			    var namespaceURI;
			    var parentTag;
			    if (hostParent != null) {
			      namespaceURI = hostParent._namespaceURI;
			      parentTag = hostParent._tag;
			    } else if (hostContainerInfo._tag) {
			      namespaceURI = hostContainerInfo._namespaceURI;
			      parentTag = hostContainerInfo._tag;
			    }
			    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
			      namespaceURI = DOMNamespaces.html;
			    }
			    if (namespaceURI === DOMNamespaces.html) {
			      if (this._tag === 'svg') {
			        namespaceURI = DOMNamespaces.svg;
			      } else if (this._tag === 'math') {
			        namespaceURI = DOMNamespaces.mathml;
			      }
			    }
			    this._namespaceURI = namespaceURI;
	
			    if (process.env.NODE_ENV !== 'production') {
			      var parentInfo;
			      if (hostParent != null) {
			        parentInfo = hostParent._ancestorInfo;
			      } else if (hostContainerInfo._tag) {
			        parentInfo = hostContainerInfo._ancestorInfo;
			      }
			      if (parentInfo) {
			        // parentInfo should always be present except for the top-level
			        // component when server rendering
			        validateDOMNesting(this._tag, null, this, parentInfo);
			      }
			      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
			    }
	
			    var mountImage;
			    if (transaction.useCreateElement) {
			      var ownerDocument = hostContainerInfo._ownerDocument;
			      var el;
			      if (namespaceURI === DOMNamespaces.html) {
			        if (this._tag === 'script') {
			          // Create the script via .innerHTML so its "parser-inserted" flag is
			          // set to true and it does not execute
			          var div = ownerDocument.createElement('div');
			          var type = this._currentElement.type;
			          div.innerHTML = '<' + type + '></' + type + '>';
			          el = div.removeChild(div.firstChild);
			        } else if (props.is) {
			          el = ownerDocument.createElement(this._currentElement.type, props.is);
			        } else {
			          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
			          // See discussion in https://github.com/facebook/react/pull/6896
			          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
			          el = ownerDocument.createElement(this._currentElement.type);
			        }
			      } else {
			        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
			      }
			      ReactDOMComponentTree.precacheNode(this, el);
			      this._flags |= Flags.hasCachedChildNodes;
			      if (!this._hostParent) {
			        DOMPropertyOperations.setAttributeForRoot(el);
			      }
			      this._updateDOMProperties(null, props, transaction);
			      var lazyTree = DOMLazyTree(el);
			      this._createInitialChildren(transaction, props, context, lazyTree);
			      mountImage = lazyTree;
			    } else {
			      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
			      var tagContent = this._createContentMarkup(transaction, props, context);
			      if (!tagContent && omittedCloseTags[this._tag]) {
			        mountImage = tagOpen + '/>';
			      } else {
			        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
			      }
			    }
	
			    switch (this._tag) {
			      case 'input':
			        transaction.getReactMountReady().enqueue(inputPostMount, this);
			        if (props.autoFocus) {
			          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
			        }
			        break;
			      case 'textarea':
			        transaction.getReactMountReady().enqueue(textareaPostMount, this);
			        if (props.autoFocus) {
			          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
			        }
			        break;
			      case 'select':
			        if (props.autoFocus) {
			          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
			        }
			        break;
			      case 'button':
			        if (props.autoFocus) {
			          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
			        }
			        break;
			      case 'option':
			        transaction.getReactMountReady().enqueue(optionPostMount, this);
			        break;
			    }
	
			    return mountImage;
			  },
	
			  /**
			   * Creates markup for the open tag and all attributes.
			   *
			   * This method has side effects because events get registered.
			   *
			   * Iterating over object properties is faster than iterating over arrays.
			   * @see http://jsperf.com/obj-vs-arr-iteration
			   *
			   * @private
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {object} props
			   * @return {string} Markup of opening tag.
			   */
			  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
			    var ret = '<' + this._currentElement.type;
	
			    for (var propKey in props) {
			      if (!props.hasOwnProperty(propKey)) {
			        continue;
			      }
			      var propValue = props[propKey];
			      if (propValue == null) {
			        continue;
			      }
			      if (registrationNameModules.hasOwnProperty(propKey)) {
			        if (propValue) {
			          enqueuePutListener(this, propKey, propValue, transaction);
			        }
			      } else {
			        if (propKey === STYLE) {
			          if (propValue) {
			            if (process.env.NODE_ENV !== 'production') {
			              // See `_updateDOMProperties`. style block
			              this._previousStyle = propValue;
			            }
			            propValue = this._previousStyleCopy = _assign({}, props.style);
			          }
			          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
			        }
			        var markup = null;
			        if (this._tag != null && isCustomComponent(this._tag, props)) {
			          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
			            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
			          }
			        } else {
			          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
			        }
			        if (markup) {
			          ret += ' ' + markup;
			        }
			      }
			    }
	
			    // For static pages, no need to put React ID and checksum. Saves lots of
			    // bytes.
			    if (transaction.renderToStaticMarkup) {
			      return ret;
			    }
	
			    if (!this._hostParent) {
			      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
			    }
			    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
			    return ret;
			  },
	
			  /**
			   * Creates markup for the content between the tags.
			   *
			   * @private
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {object} props
			   * @param {object} context
			   * @return {string} Content markup.
			   */
			  _createContentMarkup: function (transaction, props, context) {
			    var ret = '';
	
			    // Intentional use of != to avoid catching zero/false.
			    var innerHTML = props.dangerouslySetInnerHTML;
			    if (innerHTML != null) {
			      if (innerHTML.__html != null) {
			        ret = innerHTML.__html;
			      }
			    } else {
			      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
			      var childrenToUse = contentToUse != null ? null : props.children;
			      if (contentToUse != null) {
			        // TODO: Validate that text is allowed as a child of this node
			        ret = escapeTextContentForBrowser(contentToUse);
			        if (process.env.NODE_ENV !== 'production') {
			          setAndValidateContentChildDev.call(this, contentToUse);
			        }
			      } else if (childrenToUse != null) {
			        var mountImages = this.mountChildren(childrenToUse, transaction, context);
			        ret = mountImages.join('');
			      }
			    }
			    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
			      // text/html ignores the first character in these tags if it's a newline
			      // Prefer to break application/xml over text/html (for now) by adding
			      // a newline specifically to get eaten by the parser. (Alternately for
			      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
			      // \r is normalized out by HTMLTextAreaElement#value.)
			      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
			      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
			      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
			      // See: Parsing of "textarea" "listing" and "pre" elements
			      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
			      return '\n' + ret;
			    } else {
			      return ret;
			    }
			  },
	
			  _createInitialChildren: function (transaction, props, context, lazyTree) {
			    // Intentional use of != to avoid catching zero/false.
			    var innerHTML = props.dangerouslySetInnerHTML;
			    if (innerHTML != null) {
			      if (innerHTML.__html != null) {
			        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
			      }
			    } else {
			      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
			      var childrenToUse = contentToUse != null ? null : props.children;
			      // TODO: Validate that text is allowed as a child of this node
			      if (contentToUse != null) {
			        // Avoid setting textContent when the text is empty. In IE11 setting
			        // textContent on a text area will cause the placeholder to not
			        // show within the textarea until it has been focused and blurred again.
			        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
			        if (contentToUse !== '') {
			          if (process.env.NODE_ENV !== 'production') {
			            setAndValidateContentChildDev.call(this, contentToUse);
			          }
			          DOMLazyTree.queueText(lazyTree, contentToUse);
			        }
			      } else if (childrenToUse != null) {
			        var mountImages = this.mountChildren(childrenToUse, transaction, context);
			        for (var i = 0; i < mountImages.length; i++) {
			          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
			        }
			      }
			    }
			  },
	
			  /**
			   * Receives a next element and updates the component.
			   *
			   * @internal
			   * @param {ReactElement} nextElement
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {object} context
			   */
			  receiveComponent: function (nextElement, transaction, context) {
			    var prevElement = this._currentElement;
			    this._currentElement = nextElement;
			    this.updateComponent(transaction, prevElement, nextElement, context);
			  },
	
			  /**
			   * Updates a DOM component after it has already been allocated and
			   * attached to the DOM. Reconciles the root DOM node, then recurses.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @param {ReactElement} prevElement
			   * @param {ReactElement} nextElement
			   * @internal
			   * @overridable
			   */
			  updateComponent: function (transaction, prevElement, nextElement, context) {
			    var lastProps = prevElement.props;
			    var nextProps = this._currentElement.props;
	
			    switch (this._tag) {
			      case 'input':
			        lastProps = ReactDOMInput.getHostProps(this, lastProps);
			        nextProps = ReactDOMInput.getHostProps(this, nextProps);
			        break;
			      case 'option':
			        lastProps = ReactDOMOption.getHostProps(this, lastProps);
			        nextProps = ReactDOMOption.getHostProps(this, nextProps);
			        break;
			      case 'select':
			        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
			        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
			        break;
			      case 'textarea':
			        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
			        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
			        break;
			    }
	
			    assertValidProps(this, nextProps);
			    this._updateDOMProperties(lastProps, nextProps, transaction);
			    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
			    switch (this._tag) {
			      case 'input':
			        // Update the wrapper around inputs *after* updating props. This has to
			        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
			        // raise warnings and prevent the new value from being assigned.
			        ReactDOMInput.updateWrapper(this);
			        break;
			      case 'textarea':
			        ReactDOMTextarea.updateWrapper(this);
			        break;
			      case 'select':
			        // <select> value update needs to occur after <option> children
			        // reconciliation
			        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
			        break;
			    }
			  },
	
			  /**
			   * Reconciles the properties by detecting differences in property values and
			   * updating the DOM as necessary. This function is probably the single most
			   * critical path for performance optimization.
			   *
			   * TODO: Benchmark whether checking for changed values in memory actually
			   *       improves performance (especially statically positioned elements).
			   * TODO: Benchmark the effects of putting this at the top since 99% of props
			   *       do not change for a given reconciliation.
			   * TODO: Benchmark areas that can be improved with caching.
			   *
			   * @private
			   * @param {object} lastProps
			   * @param {object} nextProps
			   * @param {?DOMElement} node
			   */
			  _updateDOMProperties: function (lastProps, nextProps, transaction) {
			    var propKey;
			    var styleName;
			    var styleUpdates;
			    for (propKey in lastProps) {
			      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
			        continue;
			      }
			      if (propKey === STYLE) {
			        var lastStyle = this._previousStyleCopy;
			        for (styleName in lastStyle) {
			          if (lastStyle.hasOwnProperty(styleName)) {
			            styleUpdates = styleUpdates || {};
			            styleUpdates[styleName] = '';
			          }
			        }
			        this._previousStyleCopy = null;
			      } else if (registrationNameModules.hasOwnProperty(propKey)) {
			        if (lastProps[propKey]) {
			          // Only call deleteListener if there was a listener previously or
			          // else willDeleteListener gets called when there wasn't actually a
			          // listener (e.g., onClick={null})
			          deleteListener(this, propKey);
			        }
			      } else if (isCustomComponent(this._tag, lastProps)) {
			        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
			          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
			        }
			      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
			        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
			      }
			    }
			    for (propKey in nextProps) {
			      var nextProp = nextProps[propKey];
			      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
			      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
			        continue;
			      }
			      if (propKey === STYLE) {
			        if (nextProp) {
			          if (process.env.NODE_ENV !== 'production') {
			            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
			            this._previousStyle = nextProp;
			          }
			          nextProp = this._previousStyleCopy = _assign({}, nextProp);
			        } else {
			          this._previousStyleCopy = null;
			        }
			        if (lastProp) {
			          // Unset styles on `lastProp` but not on `nextProp`.
			          for (styleName in lastProp) {
			            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
			              styleUpdates = styleUpdates || {};
			              styleUpdates[styleName] = '';
			            }
			          }
			          // Update styles that changed since `lastProp`.
			          for (styleName in nextProp) {
			            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
			              styleUpdates = styleUpdates || {};
			              styleUpdates[styleName] = nextProp[styleName];
			            }
			          }
			        } else {
			          // Relies on `updateStylesByID` not mutating `styleUpdates`.
			          styleUpdates = nextProp;
			        }
			      } else if (registrationNameModules.hasOwnProperty(propKey)) {
			        if (nextProp) {
			          enqueuePutListener(this, propKey, nextProp, transaction);
			        } else if (lastProp) {
			          deleteListener(this, propKey);
			        }
			      } else if (isCustomComponent(this._tag, nextProps)) {
			        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
			          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
			        }
			      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
			        var node = getNode(this);
			        // If we're updating to null or undefined, we should remove the property
			        // from the DOM node instead of inadvertently setting to a string. This
			        // brings us in line with the same behavior we have on initial render.
			        if (nextProp != null) {
			          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
			        } else {
			          DOMPropertyOperations.deleteValueForProperty(node, propKey);
			        }
			      }
			    }
			    if (styleUpdates) {
			      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
			    }
			  },
	
			  /**
			   * Reconciles the children with the various properties that affect the
			   * children content.
			   *
			   * @param {object} lastProps
			   * @param {object} nextProps
			   * @param {ReactReconcileTransaction} transaction
			   * @param {object} context
			   */
			  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
			    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
			    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
			    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
			    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
			    // Note the use of `!=` which checks for null or undefined.
			    var lastChildren = lastContent != null ? null : lastProps.children;
			    var nextChildren = nextContent != null ? null : nextProps.children;
	
			    // If we're switching from children to content/html or vice versa, remove
			    // the old content
			    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
			    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
			    if (lastChildren != null && nextChildren == null) {
			      this.updateChildren(null, transaction, context);
			    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
			      this.updateTextContent('');
			      if (process.env.NODE_ENV !== 'production') {
			        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
			      }
			    }
	
			    if (nextContent != null) {
			      if (lastContent !== nextContent) {
			        this.updateTextContent('' + nextContent);
			        if (process.env.NODE_ENV !== 'production') {
			          setAndValidateContentChildDev.call(this, nextContent);
			        }
			      }
			    } else if (nextHtml != null) {
			      if (lastHtml !== nextHtml) {
			        this.updateMarkup('' + nextHtml);
			      }
			      if (process.env.NODE_ENV !== 'production') {
			        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
			      }
			    } else if (nextChildren != null) {
			      if (process.env.NODE_ENV !== 'production') {
			        setAndValidateContentChildDev.call(this, null);
			      }
	
			      this.updateChildren(nextChildren, transaction, context);
			    }
			  },
	
			  getHostNode: function () {
			    return getNode(this);
			  },
	
			  /**
			   * Destroys all event registrations for this instance. Does not remove from
			   * the DOM. That must be done by the parent.
			   *
			   * @internal
			   */
			  unmountComponent: function (safely) {
			    switch (this._tag) {
			      case 'audio':
			      case 'form':
			      case 'iframe':
			      case 'img':
			      case 'link':
			      case 'object':
			      case 'source':
			      case 'video':
			        var listeners = this._wrapperState.listeners;
			        if (listeners) {
			          for (var i = 0; i < listeners.length; i++) {
			            listeners[i].remove();
			          }
			        }
			        break;
			      case 'html':
			      case 'head':
			      case 'body':
			        /**
			         * Components like <html> <head> and <body> can't be removed or added
			         * easily in a cross-browser way, however it's valuable to be able to
			         * take advantage of React's reconciliation for styling and <title>
			         * management. So we just document it and throw in dangerous cases.
			         */
			         true ? process.env.NODE_ENV !== 'production' ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
			        break;
			    }
	
			    this.unmountChildren(safely);
			    ReactDOMComponentTree.uncacheNode(this);
			    EventPluginHub.deleteAllListeners(this);
			    this._rootNodeID = 0;
			    this._domID = 0;
			    this._wrapperState = null;
	
			    if (process.env.NODE_ENV !== 'production') {
			      setAndValidateContentChildDev.call(this, null);
			    }
			  },
	
			  getPublicInstance: function () {
			    return getNode(this);
			  }
	
			};
	
			_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
			module.exports = ReactDOMComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 71 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactDOMComponentTree = __webpack_require__(5);
	
			var focusNode = __webpack_require__(72);
	
			var AutoFocusUtils = {
			  focusDOMComponent: function () {
			    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
			  }
			};
	
			module.exports = AutoFocusUtils;
	
		/***/ },
		/* 72 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * @param {DOMElement} node input/textarea to focus
			 */
	
			function focusNode(node) {
			  // IE8 can throw "Can't move focus to the control because it is invisible,
			  // not enabled, or of a type that does not accept the focus." for all kinds of
			  // reasons that are too expensive and fragile to test.
			  try {
			    node.focus();
			  } catch (e) {}
			}
	
			module.exports = focusNode;
	
		/***/ },
		/* 73 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var CSSProperty = __webpack_require__(74);
			var ExecutionEnvironment = __webpack_require__(22);
			var ReactInstrumentation = __webpack_require__(37);
	
			var camelizeStyleName = __webpack_require__(75);
			var dangerousStyleValue = __webpack_require__(77);
			var hyphenateStyleName = __webpack_require__(78);
			var memoizeStringOnly = __webpack_require__(80);
			var warning = __webpack_require__(18);
	
			var processStyleName = memoizeStringOnly(function (styleName) {
			  return hyphenateStyleName(styleName);
			});
	
			var hasShorthandPropertyBug = false;
			var styleFloatAccessor = 'cssFloat';
			if (ExecutionEnvironment.canUseDOM) {
			  var tempStyle = document.createElement('div').style;
			  try {
			    // IE8 throws "Invalid argument." if resetting shorthand style properties.
			    tempStyle.font = '';
			  } catch (e) {
			    hasShorthandPropertyBug = true;
			  }
			  // IE8 only supports accessing cssFloat (standard) as styleFloat
			  if (document.documentElement.style.cssFloat === undefined) {
			    styleFloatAccessor = 'styleFloat';
			  }
			}
	
			if (process.env.NODE_ENV !== 'production') {
			  // 'msTransform' is correct, but the other prefixes should be capitalized
			  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
			  // style values shouldn't contain a semicolon
			  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
			  var warnedStyleNames = {};
			  var warnedStyleValues = {};
			  var warnedForNaNValue = false;
	
			  var warnHyphenatedStyleName = function (name, owner) {
			    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
			      return;
			    }
	
			    warnedStyleNames[name] = true;
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
			  };
	
			  var warnBadVendoredStyleName = function (name, owner) {
			    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
			      return;
			    }
	
			    warnedStyleNames[name] = true;
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
			  };
	
			  var warnStyleValueWithSemicolon = function (name, value, owner) {
			    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
			      return;
			    }
	
			    warnedStyleValues[value] = true;
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
			  };
	
			  var warnStyleValueIsNaN = function (name, value, owner) {
			    if (warnedForNaNValue) {
			      return;
			    }
	
			    warnedForNaNValue = true;
			    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
			  };
	
			  var checkRenderMessage = function (owner) {
			    if (owner) {
			      var name = owner.getName();
			      if (name) {
			        return ' Check the render method of `' + name + '`.';
			      }
			    }
			    return '';
			  };
	
			  /**
			   * @param {string} name
			   * @param {*} value
			   * @param {ReactDOMComponent} component
			   */
			  var warnValidStyle = function (name, value, component) {
			    var owner;
			    if (component) {
			      owner = component._currentElement._owner;
			    }
			    if (name.indexOf('-') > -1) {
			      warnHyphenatedStyleName(name, owner);
			    } else if (badVendoredStyleNamePattern.test(name)) {
			      warnBadVendoredStyleName(name, owner);
			    } else if (badStyleValueWithSemicolonPattern.test(value)) {
			      warnStyleValueWithSemicolon(name, value, owner);
			    }
	
			    if (typeof value === 'number' && isNaN(value)) {
			      warnStyleValueIsNaN(name, value, owner);
			    }
			  };
			}
	
			/**
			 * Operations for dealing with CSS properties.
			 */
			var CSSPropertyOperations = {
	
			  /**
			   * Serializes a mapping of style properties for use as inline styles:
			   *
			   *   > createMarkupForStyles({width: '200px', height: 0})
			   *   "width:200px;height:0;"
			   *
			   * Undefined values are ignored so that declarative programming is easier.
			   * The result should be HTML-escaped before insertion into the DOM.
			   *
			   * @param {object} styles
			   * @param {ReactDOMComponent} component
			   * @return {?string}
			   */
			  createMarkupForStyles: function (styles, component) {
			    var serialized = '';
			    for (var styleName in styles) {
			      if (!styles.hasOwnProperty(styleName)) {
			        continue;
			      }
			      var styleValue = styles[styleName];
			      if (process.env.NODE_ENV !== 'production') {
			        warnValidStyle(styleName, styleValue, component);
			      }
			      if (styleValue != null) {
			        serialized += processStyleName(styleName) + ':';
			        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
			      }
			    }
			    return serialized || null;
			  },
	
			  /**
			   * Sets the value for multiple styles on a node.  If a value is specified as
			   * '' (empty string), the corresponding style property will be unset.
			   *
			   * @param {DOMElement} node
			   * @param {object} styles
			   * @param {ReactDOMComponent} component
			   */
			  setValueForStyles: function (node, styles, component) {
			    if (process.env.NODE_ENV !== 'production') {
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: component._debugID,
			        type: 'update styles',
			        payload: styles
			      });
			    }
	
			    var style = node.style;
			    for (var styleName in styles) {
			      if (!styles.hasOwnProperty(styleName)) {
			        continue;
			      }
			      if (process.env.NODE_ENV !== 'production') {
			        warnValidStyle(styleName, styles[styleName], component);
			      }
			      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
			      if (styleName === 'float' || styleName === 'cssFloat') {
			        styleName = styleFloatAccessor;
			      }
			      if (styleValue) {
			        style[styleName] = styleValue;
			      } else {
			        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
			        if (expansion) {
			          // Shorthand property that IE8 won't like unsetting, so unset each
			          // component to placate it
			          for (var individualStyleName in expansion) {
			            style[individualStyleName] = '';
			          }
			        } else {
			          style[styleName] = '';
			        }
			      }
			    }
			  }
	
			};
	
			module.exports = CSSPropertyOperations;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 74 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * CSS properties which accept numbers but are not in units of "px".
			 */
	
			var isUnitlessNumber = {
			  animationIterationCount: true,
			  borderImageOutset: true,
			  borderImageSlice: true,
			  borderImageWidth: true,
			  boxFlex: true,
			  boxFlexGroup: true,
			  boxOrdinalGroup: true,
			  columnCount: true,
			  flex: true,
			  flexGrow: true,
			  flexPositive: true,
			  flexShrink: true,
			  flexNegative: true,
			  flexOrder: true,
			  gridRow: true,
			  gridColumn: true,
			  fontWeight: true,
			  lineClamp: true,
			  lineHeight: true,
			  opacity: true,
			  order: true,
			  orphans: true,
			  tabSize: true,
			  widows: true,
			  zIndex: true,
			  zoom: true,
	
			  // SVG-related properties
			  fillOpacity: true,
			  floodOpacity: true,
			  stopOpacity: true,
			  strokeDasharray: true,
			  strokeDashoffset: true,
			  strokeMiterlimit: true,
			  strokeOpacity: true,
			  strokeWidth: true
			};
	
			/**
			 * @param {string} prefix vendor-specific prefix, eg: Webkit
			 * @param {string} key style name, eg: transitionDuration
			 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
			 * WebkitTransitionDuration
			 */
			function prefixKey(prefix, key) {
			  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
			}
	
			/**
			 * Support style names that may come passed in prefixed by adding permutations
			 * of vendor prefixes.
			 */
			var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
			// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
			// infinite loop, because it iterates over the newly added props too.
			Object.keys(isUnitlessNumber).forEach(function (prop) {
			  prefixes.forEach(function (prefix) {
			    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
			  });
			});
	
			/**
			 * Most style properties can be unset by doing .style[prop] = '' but IE8
			 * doesn't like doing that with shorthand properties so for the properties that
			 * IE8 breaks on, which are listed here, we instead unset each of the
			 * individual properties. See http://bugs.jquery.com/ticket/12385.
			 * The 4-value 'clock' properties like margin, padding, border-width seem to
			 * behave without any problems. Curiously, list-style works too without any
			 * special prodding.
			 */
			var shorthandPropertyExpansions = {
			  background: {
			    backgroundAttachment: true,
			    backgroundColor: true,
			    backgroundImage: true,
			    backgroundPositionX: true,
			    backgroundPositionY: true,
			    backgroundRepeat: true
			  },
			  backgroundPosition: {
			    backgroundPositionX: true,
			    backgroundPositionY: true
			  },
			  border: {
			    borderWidth: true,
			    borderStyle: true,
			    borderColor: true
			  },
			  borderBottom: {
			    borderBottomWidth: true,
			    borderBottomStyle: true,
			    borderBottomColor: true
			  },
			  borderLeft: {
			    borderLeftWidth: true,
			    borderLeftStyle: true,
			    borderLeftColor: true
			  },
			  borderRight: {
			    borderRightWidth: true,
			    borderRightStyle: true,
			    borderRightColor: true
			  },
			  borderTop: {
			    borderTopWidth: true,
			    borderTopStyle: true,
			    borderTopColor: true
			  },
			  font: {
			    fontStyle: true,
			    fontVariant: true,
			    fontWeight: true,
			    fontSize: true,
			    lineHeight: true,
			    fontFamily: true
			  },
			  outline: {
			    outlineWidth: true,
			    outlineStyle: true,
			    outlineColor: true
			  }
			};
	
			var CSSProperty = {
			  isUnitlessNumber: isUnitlessNumber,
			  shorthandPropertyExpansions: shorthandPropertyExpansions
			};
	
			module.exports = CSSProperty;
	
		/***/ },
		/* 75 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			'use strict';
	
			var camelize = __webpack_require__(76);
	
			var msPattern = /^-ms-/;
	
			/**
			 * Camelcases a hyphenated CSS property name, for example:
			 *
			 *   > camelizeStyleName('background-color')
			 *   < "backgroundColor"
			 *   > camelizeStyleName('-moz-transition')
			 *   < "MozTransition"
			 *   > camelizeStyleName('-ms-transition')
			 *   < "msTransition"
			 *
			 * As Andi Smith suggests
			 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
			 * is converted to lowercase `ms`.
			 *
			 * @param {string} string
			 * @return {string}
			 */
			function camelizeStyleName(string) {
			  return camelize(string.replace(msPattern, 'ms-'));
			}
	
			module.exports = camelizeStyleName;
	
		/***/ },
		/* 76 */
		/***/ function(module, exports) {
	
			"use strict";
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var _hyphenPattern = /-(.)/g;
	
			/**
			 * Camelcases a hyphenated string, for example:
			 *
			 *   > camelize('background-color')
			 *   < "backgroundColor"
			 *
			 * @param {string} string
			 * @return {string}
			 */
			function camelize(string) {
			  return string.replace(_hyphenPattern, function (_, character) {
			    return character.toUpperCase();
			  });
			}
	
			module.exports = camelize;
	
		/***/ },
		/* 77 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var CSSProperty = __webpack_require__(74);
			var warning = __webpack_require__(18);
	
			var isUnitlessNumber = CSSProperty.isUnitlessNumber;
			var styleWarnings = {};
	
			/**
			 * Convert a value into the proper css writable value. The style name `name`
			 * should be logical (no hyphens), as specified
			 * in `CSSProperty.isUnitlessNumber`.
			 *
			 * @param {string} name CSS property name such as `topMargin`.
			 * @param {*} value CSS property value such as `10px`.
			 * @param {ReactDOMComponent} component
			 * @return {string} Normalized style value with dimensions applied.
			 */
			function dangerousStyleValue(name, value, component) {
			  // Note that we've removed escapeTextForBrowser() calls here since the
			  // whole string will be escaped when the attribute is injected into
			  // the markup. If you provide unsafe user data here they can inject
			  // arbitrary CSS which may be problematic (I couldn't repro this):
			  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
			  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
			  // This is not an XSS hole but instead a potential CSS injection issue
			  // which has lead to a greater discussion about how we're going to
			  // trust URLs moving forward. See #2115901
	
			  var isEmpty = value == null || typeof value === 'boolean' || value === '';
			  if (isEmpty) {
			    return '';
			  }
	
			  var isNonNumeric = isNaN(value);
			  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
			    return '' + value; // cast to string
			  }
	
			  if (typeof value === 'string') {
			    if (process.env.NODE_ENV !== 'production') {
			      // Allow '0' to pass through without warning. 0 is already special and
			      // doesn't require units, so we don't need to warn about it.
			      if (component && value !== '0') {
			        var owner = component._currentElement._owner;
			        var ownerName = owner ? owner.getName() : null;
			        if (ownerName && !styleWarnings[ownerName]) {
			          styleWarnings[ownerName] = {};
			        }
			        var warned = false;
			        if (ownerName) {
			          var warnings = styleWarnings[ownerName];
			          warned = warnings[name];
			          if (!warned) {
			            warnings[name] = true;
			          }
			        }
			        if (!warned) {
			          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
			        }
			      }
			    }
			    value = value.trim();
			  }
			  return value + 'px';
			}
	
			module.exports = dangerousStyleValue;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 78 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			'use strict';
	
			var hyphenate = __webpack_require__(79);
	
			var msPattern = /^ms-/;
	
			/**
			 * Hyphenates a camelcased CSS property name, for example:
			 *
			 *   > hyphenateStyleName('backgroundColor')
			 *   < "background-color"
			 *   > hyphenateStyleName('MozTransition')
			 *   < "-moz-transition"
			 *   > hyphenateStyleName('msTransition')
			 *   < "-ms-transition"
			 *
			 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
			 * is converted to `-ms-`.
			 *
			 * @param {string} string
			 * @return {string}
			 */
			function hyphenateStyleName(string) {
			  return hyphenate(string).replace(msPattern, '-ms-');
			}
	
			module.exports = hyphenateStyleName;
	
		/***/ },
		/* 79 */
		/***/ function(module, exports) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var _uppercasePattern = /([A-Z])/g;
	
			/**
			 * Hyphenates a camelcased string, for example:
			 *
			 *   > hyphenate('backgroundColor')
			 *   < "background-color"
			 *
			 * For CSS style names, use `hyphenateStyleName` instead which works properly
			 * with all vendor prefixes, including `ms`.
			 *
			 * @param {string} string
			 * @return {string}
			 */
			function hyphenate(string) {
			  return string.replace(_uppercasePattern, '-$1').toLowerCase();
			}
	
			module.exports = hyphenate;
	
		/***/ },
		/* 80 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 * @typechecks static-only
			 */
	
			'use strict';
	
			/**
			 * Memoizes the return value of a function that accepts one string argument.
			 */
	
			function memoizeStringOnly(callback) {
			  var cache = {};
			  return function (string) {
			    if (!cache.hasOwnProperty(string)) {
			      cache[string] = callback.call(this, string);
			    }
			    return cache[string];
			  };
			}
	
			module.exports = memoizeStringOnly;
	
		/***/ },
		/* 81 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactInstrumentation = __webpack_require__(37);
	
			var quoteAttributeValueForBrowser = __webpack_require__(82);
			var warning = __webpack_require__(18);
	
			var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
			var illegalAttributeNameCache = {};
			var validatedAttributeNameCache = {};
	
			function isAttributeNameSafe(attributeName) {
			  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
			    return true;
			  }
			  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
			    return false;
			  }
			  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
			    validatedAttributeNameCache[attributeName] = true;
			    return true;
			  }
			  illegalAttributeNameCache[attributeName] = true;
			  process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
			  return false;
			}
	
			function shouldIgnoreValue(propertyInfo, value) {
			  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
			}
	
			/**
			 * Operations for dealing with DOM properties.
			 */
			var DOMPropertyOperations = {
	
			  /**
			   * Creates markup for the ID property.
			   *
			   * @param {string} id Unescaped ID.
			   * @return {string} Markup string.
			   */
			  createMarkupForID: function (id) {
			    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
			  },
	
			  setAttributeForID: function (node, id) {
			    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
			  },
	
			  createMarkupForRoot: function () {
			    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
			  },
	
			  setAttributeForRoot: function (node) {
			    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
			  },
	
			  /**
			   * Creates markup for a property.
			   *
			   * @param {string} name
			   * @param {*} value
			   * @return {?string} Markup string, or null if the property was invalid.
			   */
			  createMarkupForProperty: function (name, value) {
			    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
			    if (propertyInfo) {
			      if (shouldIgnoreValue(propertyInfo, value)) {
			        return '';
			      }
			      var attributeName = propertyInfo.attributeName;
			      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
			        return attributeName + '=""';
			      }
			      return attributeName + '=' + quoteAttributeValueForBrowser(value);
			    } else if (DOMProperty.isCustomAttribute(name)) {
			      if (value == null) {
			        return '';
			      }
			      return name + '=' + quoteAttributeValueForBrowser(value);
			    }
			    return null;
			  },
	
			  /**
			   * Creates markup for a custom property.
			   *
			   * @param {string} name
			   * @param {*} value
			   * @return {string} Markup string, or empty string if the property was invalid.
			   */
			  createMarkupForCustomAttribute: function (name, value) {
			    if (!isAttributeNameSafe(name) || value == null) {
			      return '';
			    }
			    return name + '=' + quoteAttributeValueForBrowser(value);
			  },
	
			  /**
			   * Sets the value for a property on a node.
			   *
			   * @param {DOMElement} node
			   * @param {string} name
			   * @param {*} value
			   */
			  setValueForProperty: function (node, name, value) {
			    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
			    if (propertyInfo) {
			      var mutationMethod = propertyInfo.mutationMethod;
			      if (mutationMethod) {
			        mutationMethod(node, value);
			      } else if (shouldIgnoreValue(propertyInfo, value)) {
			        this.deleteValueForProperty(node, name);
			        return;
			      } else if (propertyInfo.mustUseProperty) {
			        // Contrary to `setAttribute`, object properties are properly
			        // `toString`ed by IE8/9.
			        node[propertyInfo.propertyName] = value;
			      } else {
			        var attributeName = propertyInfo.attributeName;
			        var namespace = propertyInfo.attributeNamespace;
			        // `setAttribute` with objects becomes only `[object]` in IE8/9,
			        // ('' + value) makes it output the correct toString()-value.
			        if (namespace) {
			          node.setAttributeNS(namespace, attributeName, '' + value);
			        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
			          node.setAttribute(attributeName, '');
			        } else {
			          node.setAttribute(attributeName, '' + value);
			        }
			      }
			    } else if (DOMProperty.isCustomAttribute(name)) {
			      DOMPropertyOperations.setValueForAttribute(node, name, value);
			      return;
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      var payload = {};
			      payload[name] = value;
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
			        type: 'update attribute',
			        payload: payload
			      });
			    }
			  },
	
			  setValueForAttribute: function (node, name, value) {
			    if (!isAttributeNameSafe(name)) {
			      return;
			    }
			    if (value == null) {
			      node.removeAttribute(name);
			    } else {
			      node.setAttribute(name, '' + value);
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      var payload = {};
			      payload[name] = value;
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
			        type: 'update attribute',
			        payload: payload
			      });
			    }
			  },
	
			  /**
			   * Deletes an attributes from a node.
			   *
			   * @param {DOMElement} node
			   * @param {string} name
			   */
			  deleteValueForAttribute: function (node, name) {
			    node.removeAttribute(name);
			    if (process.env.NODE_ENV !== 'production') {
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
			        type: 'remove attribute',
			        payload: name
			      });
			    }
			  },
	
			  /**
			   * Deletes the value for a property on a node.
			   *
			   * @param {DOMElement} node
			   * @param {string} name
			   */
			  deleteValueForProperty: function (node, name) {
			    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
			    if (propertyInfo) {
			      var mutationMethod = propertyInfo.mutationMethod;
			      if (mutationMethod) {
			        mutationMethod(node, undefined);
			      } else if (propertyInfo.mustUseProperty) {
			        var propName = propertyInfo.propertyName;
			        if (propertyInfo.hasBooleanValue) {
			          node[propName] = false;
			        } else {
			          node[propName] = '';
			        }
			      } else {
			        node.removeAttribute(propertyInfo.attributeName);
			      }
			    } else if (DOMProperty.isCustomAttribute(name)) {
			      node.removeAttribute(name);
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      ReactInstrumentation.debugTool.onHostOperation({
			        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
			        type: 'remove attribute',
			        payload: name
			      });
			    }
			  }
	
			};
	
			module.exports = DOMPropertyOperations;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 82 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var escapeTextContentForBrowser = __webpack_require__(64);
	
			/**
			 * Escapes attribute value to prevent scripting attacks.
			 *
			 * @param {*} value Value to escape.
			 * @return {string} An escaped string.
			 */
			function quoteAttributeValueForBrowser(value) {
			  return '"' + escapeTextContentForBrowser(value) + '"';
			}
	
			module.exports = quoteAttributeValueForBrowser;
	
		/***/ },
		/* 83 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var EventPluginRegistry = __webpack_require__(15);
			var ReactEventEmitterMixin = __webpack_require__(84);
			var ViewportMetrics = __webpack_require__(54);
	
			var getVendorPrefixedEventName = __webpack_require__(85);
			var isEventSupported = __webpack_require__(48);
	
			/**
			 * Summary of `ReactBrowserEventEmitter` event handling:
			 *
			 *  - Top-level delegation is used to trap most native browser events. This
			 *    may only occur in the main thread and is the responsibility of
			 *    ReactEventListener, which is injected and can therefore support pluggable
			 *    event sources. This is the only work that occurs in the main thread.
			 *
			 *  - We normalize and de-duplicate events to account for browser quirks. This
			 *    may be done in the worker thread.
			 *
			 *  - Forward these native events (with the associated top-level type used to
			 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
			 *    to extract any synthetic events.
			 *
			 *  - The `EventPluginHub` will then process each event by annotating them with
			 *    "dispatches", a sequence of listeners and IDs that care about that event.
			 *
			 *  - The `EventPluginHub` then dispatches the events.
			 *
			 * Overview of React and the event system:
			 *
			 * +------------+    .
			 * |    DOM     |    .
			 * +------------+    .
			 *       |           .
			 *       v           .
			 * +------------+    .
			 * | ReactEvent |    .
			 * |  Listener  |    .
			 * +------------+    .                         +-----------+
			 *       |           .               +--------+|SimpleEvent|
			 *       |           .               |         |Plugin     |
			 * +-----|------+    .               v         +-----------+
			 * |     |      |    .    +--------------+                    +------------+
			 * |     +-----------.--->|EventPluginHub|                    |    Event   |
			 * |            |    .    |              |     +-----------+  | Propagators|
			 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
			 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
			 * |            |    .    |              |     +-----------+  |  utilities |
			 * |     +-----------.--->|              |                    +------------+
			 * |     |      |    .    +--------------+
			 * +-----|------+    .                ^        +-----------+
			 *       |           .                |        |Enter/Leave|
			 *       +           .                +-------+|Plugin     |
			 * +-------------+   .                         +-----------+
			 * | application |   .
			 * |-------------|   .
			 * |             |   .
			 * |             |   .
			 * +-------------+   .
			 *                   .
			 *    React Core     .  General Purpose Event Plugin System
			 */
	
			var hasEventPageXY;
			var alreadyListeningTo = {};
			var isMonitoringScrollValue = false;
			var reactTopListenersCounter = 0;
	
			// For events like 'submit' which don't consistently bubble (which we trap at a
			// lower node than `document`), binding at `document` would cause duplicate
			// events so we don't include them here
			var topEventMapping = {
			  topAbort: 'abort',
			  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
			  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
			  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
			  topBlur: 'blur',
			  topCanPlay: 'canplay',
			  topCanPlayThrough: 'canplaythrough',
			  topChange: 'change',
			  topClick: 'click',
			  topCompositionEnd: 'compositionend',
			  topCompositionStart: 'compositionstart',
			  topCompositionUpdate: 'compositionupdate',
			  topContextMenu: 'contextmenu',
			  topCopy: 'copy',
			  topCut: 'cut',
			  topDoubleClick: 'dblclick',
			  topDrag: 'drag',
			  topDragEnd: 'dragend',
			  topDragEnter: 'dragenter',
			  topDragExit: 'dragexit',
			  topDragLeave: 'dragleave',
			  topDragOver: 'dragover',
			  topDragStart: 'dragstart',
			  topDrop: 'drop',
			  topDurationChange: 'durationchange',
			  topEmptied: 'emptied',
			  topEncrypted: 'encrypted',
			  topEnded: 'ended',
			  topError: 'error',
			  topFocus: 'focus',
			  topInput: 'input',
			  topKeyDown: 'keydown',
			  topKeyPress: 'keypress',
			  topKeyUp: 'keyup',
			  topLoadedData: 'loadeddata',
			  topLoadedMetadata: 'loadedmetadata',
			  topLoadStart: 'loadstart',
			  topMouseDown: 'mousedown',
			  topMouseMove: 'mousemove',
			  topMouseOut: 'mouseout',
			  topMouseOver: 'mouseover',
			  topMouseUp: 'mouseup',
			  topPaste: 'paste',
			  topPause: 'pause',
			  topPlay: 'play',
			  topPlaying: 'playing',
			  topProgress: 'progress',
			  topRateChange: 'ratechange',
			  topScroll: 'scroll',
			  topSeeked: 'seeked',
			  topSeeking: 'seeking',
			  topSelectionChange: 'selectionchange',
			  topStalled: 'stalled',
			  topSuspend: 'suspend',
			  topTextInput: 'textInput',
			  topTimeUpdate: 'timeupdate',
			  topTouchCancel: 'touchcancel',
			  topTouchEnd: 'touchend',
			  topTouchMove: 'touchmove',
			  topTouchStart: 'touchstart',
			  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
			  topVolumeChange: 'volumechange',
			  topWaiting: 'waiting',
			  topWheel: 'wheel'
			};
	
			/**
			 * To ensure no conflicts with other potential React instances on the page
			 */
			var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
			function getListeningForDocument(mountAt) {
			  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
			  // directly.
			  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
			    mountAt[topListenersIDKey] = reactTopListenersCounter++;
			    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
			  }
			  return alreadyListeningTo[mountAt[topListenersIDKey]];
			}
	
			/**
			 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
			 * example:
			 *
			 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
			 *
			 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
			 *
			 * @internal
			 */
			var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
			  /**
			   * Injectable event backend
			   */
			  ReactEventListener: null,
	
			  injection: {
			    /**
			     * @param {object} ReactEventListener
			     */
			    injectReactEventListener: function (ReactEventListener) {
			      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
			      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
			    }
			  },
	
			  /**
			   * Sets whether or not any created callbacks should be enabled.
			   *
			   * @param {boolean} enabled True if callbacks should be enabled.
			   */
			  setEnabled: function (enabled) {
			    if (ReactBrowserEventEmitter.ReactEventListener) {
			      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
			    }
			  },
	
			  /**
			   * @return {boolean} True if callbacks are enabled.
			   */
			  isEnabled: function () {
			    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
			  },
	
			  /**
			   * We listen for bubbled touch events on the document object.
			   *
			   * Firefox v8.01 (and possibly others) exhibited strange behavior when
			   * mounting `onmousemove` events at some node that was not the document
			   * element. The symptoms were that if your mouse is not moving over something
			   * contained within that mount point (for example on the background) the
			   * top-level listeners for `onmousemove` won't be called. However, if you
			   * register the `mousemove` on the document object, then it will of course
			   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
			   * top-level listeners to the document object only, at least for these
			   * movement types of events and possibly all events.
			   *
			   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
			   *
			   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
			   * they bubble to document.
			   *
			   * @param {string} registrationName Name of listener (e.g. `onClick`).
			   * @param {object} contentDocumentHandle Document which owns the container
			   */
			  listenTo: function (registrationName, contentDocumentHandle) {
			    var mountAt = contentDocumentHandle;
			    var isListening = getListeningForDocument(mountAt);
			    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
			    for (var i = 0; i < dependencies.length; i++) {
			      var dependency = dependencies[i];
			      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
			        if (dependency === 'topWheel') {
			          if (isEventSupported('wheel')) {
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
			          } else if (isEventSupported('mousewheel')) {
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
			          } else {
			            // Firefox needs to capture a different mouse scroll event.
			            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
			          }
			        } else if (dependency === 'topScroll') {
	
			          if (isEventSupported('scroll', true)) {
			            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
			          } else {
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
			          }
			        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
			          if (isEventSupported('focus', true)) {
			            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
			            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
			          } else if (isEventSupported('focusin')) {
			            // IE has `focusin` and `focusout` events which bubble.
			            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
			            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
			          }
	
			          // to make sure blur and focus event listeners are only attached once
			          isListening.topBlur = true;
			          isListening.topFocus = true;
			        } else if (topEventMapping.hasOwnProperty(dependency)) {
			          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
			        }
	
			        isListening[dependency] = true;
			      }
			    }
			  },
	
			  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
			    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
			  },
	
			  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
			    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
			  },
	
			  /**
			   * Protect against document.createEvent() returning null
			   * Some popup blocker extensions appear to do this:
			   * https://github.com/facebook/react/issues/6887
			   */
			  supportsEventPageXY: function () {
			    if (!document.createEvent) {
			      return false;
			    }
			    var ev = document.createEvent('MouseEvent');
			    return ev != null && 'pageX' in ev;
			  },
	
			  /**
			   * Listens to window scroll and resize events. We cache scroll values so that
			   * application code can access them without triggering reflows.
			   *
			   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
			   * pageX/pageY isn't supported (legacy browsers).
			   *
			   * NOTE: Scroll events do not bubble.
			   *
			   * @see http://www.quirksmode.org/dom/events/scroll.html
			   */
			  ensureScrollValueMonitoring: function () {
			    if (hasEventPageXY === undefined) {
			      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
			    }
			    if (!hasEventPageXY && !isMonitoringScrollValue) {
			      var refresh = ViewportMetrics.refreshScrollValues;
			      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
			      isMonitoringScrollValue = true;
			    }
			  }
	
			});
	
			module.exports = ReactBrowserEventEmitter;
	
		/***/ },
		/* 84 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPluginHub = __webpack_require__(14);
	
			function runEventQueueInBatch(events) {
			  EventPluginHub.enqueueEvents(events);
			  EventPluginHub.processEventQueue(false);
			}
	
			var ReactEventEmitterMixin = {
	
			  /**
			   * Streams a fired top-level event to `EventPluginHub` where plugins have the
			   * opportunity to create `ReactEvent`s to be dispatched.
			   */
			  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
			    runEventQueueInBatch(events);
			  }
			};
	
			module.exports = ReactEventEmitterMixin;
	
		/***/ },
		/* 85 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			/**
			 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
			 *
			 * @param {string} styleProp
			 * @param {string} eventName
			 * @returns {object}
			 */
			function makePrefixMap(styleProp, eventName) {
			  var prefixes = {};
	
			  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
			  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
			  prefixes['Moz' + styleProp] = 'moz' + eventName;
			  prefixes['ms' + styleProp] = 'MS' + eventName;
			  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
			  return prefixes;
			}
	
			/**
			 * A list of event names to a configurable list of vendor prefixes.
			 */
			var vendorPrefixes = {
			  animationend: makePrefixMap('Animation', 'AnimationEnd'),
			  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
			  animationstart: makePrefixMap('Animation', 'AnimationStart'),
			  transitionend: makePrefixMap('Transition', 'TransitionEnd')
			};
	
			/**
			 * Event names that have already been detected and prefixed (if applicable).
			 */
			var prefixedEventNames = {};
	
			/**
			 * Element to check for prefixes on.
			 */
			var style = {};
	
			/**
			 * Bootstrap if a DOM exists.
			 */
			if (ExecutionEnvironment.canUseDOM) {
			  style = document.createElement('div').style;
	
			  // On some platforms, in particular some releases of Android 4.x,
			  // the un-prefixed "animation" and "transition" properties are defined on the
			  // style object but the events that fire will still be prefixed, so we need
			  // to check if the un-prefixed events are usable, and if not remove them from the map.
			  if (!('AnimationEvent' in window)) {
			    delete vendorPrefixes.animationend.animation;
			    delete vendorPrefixes.animationiteration.animation;
			    delete vendorPrefixes.animationstart.animation;
			  }
	
			  // Same as above
			  if (!('TransitionEvent' in window)) {
			    delete vendorPrefixes.transitionend.transition;
			  }
			}
	
			/**
			 * Attempts to determine the correct vendor prefixed event name.
			 *
			 * @param {string} eventName
			 * @returns {string}
			 */
			function getVendorPrefixedEventName(eventName) {
			  if (prefixedEventNames[eventName]) {
			    return prefixedEventNames[eventName];
			  } else if (!vendorPrefixes[eventName]) {
			    return eventName;
			  }
	
			  var prefixMap = vendorPrefixes[eventName];
	
			  for (var styleProp in prefixMap) {
			    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
			      return prefixedEventNames[eventName] = prefixMap[styleProp];
			    }
			  }
	
			  return '';
			}
	
			module.exports = getVendorPrefixedEventName;
	
		/***/ },
		/* 86 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var DOMPropertyOperations = __webpack_require__(81);
			var LinkedValueUtils = __webpack_require__(87);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var didWarnValueLink = false;
			var didWarnCheckedLink = false;
			var didWarnValueDefaultValue = false;
			var didWarnCheckedDefaultChecked = false;
			var didWarnControlledToUncontrolled = false;
			var didWarnUncontrolledToControlled = false;
	
			function forceUpdateIfMounted() {
			  if (this._rootNodeID) {
			    // DOM component is still mounted; update
			    ReactDOMInput.updateWrapper(this);
			  }
			}
	
			function isControlled(props) {
			  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
			  return usesChecked ? props.checked != null : props.value != null;
			}
	
			/**
			 * Implements an <input> host component that allows setting these optional
			 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
			 *
			 * If `checked` or `value` are not supplied (or null/undefined), user actions
			 * that affect the checked state or value will trigger updates to the element.
			 *
			 * If they are supplied (and not null/undefined), the rendered element will not
			 * trigger updates to the element. Instead, the props must change in order for
			 * the rendered element to be updated.
			 *
			 * The rendered element will be initialized as unchecked (or `defaultChecked`)
			 * with an empty value (or `defaultValue`).
			 *
			 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
			 */
			var ReactDOMInput = {
			  getHostProps: function (inst, props) {
			    var value = LinkedValueUtils.getValue(props);
			    var checked = LinkedValueUtils.getChecked(props);
	
			    var hostProps = _assign({
			      // Make sure we set .type before any other properties (setting .value
			      // before .type means .value is lost in IE11 and below)
			      type: undefined,
			      // Make sure we set .step before .value (setting .value before .step
			      // means .value is rounded on mount, based upon step precision)
			      step: undefined,
			      // Make sure we set .min & .max before .value (to ensure proper order
			      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
			      min: undefined,
			      max: undefined
			    }, props, {
			      defaultChecked: undefined,
			      defaultValue: undefined,
			      value: value != null ? value : inst._wrapperState.initialValue,
			      checked: checked != null ? checked : inst._wrapperState.initialChecked,
			      onChange: inst._wrapperState.onChange
			    });
	
			    return hostProps;
			  },
	
			  mountWrapper: function (inst, props) {
			    if (process.env.NODE_ENV !== 'production') {
			      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
			      var owner = inst._currentElement._owner;
	
			      if (props.valueLink !== undefined && !didWarnValueLink) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
			        didWarnValueLink = true;
			      }
			      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
			        didWarnCheckedLink = true;
			      }
			      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
			        didWarnCheckedDefaultChecked = true;
			      }
			      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
			        didWarnValueDefaultValue = true;
			      }
			    }
	
			    var defaultValue = props.defaultValue;
			    inst._wrapperState = {
			      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
			      initialValue: props.value != null ? props.value : defaultValue,
			      listeners: null,
			      onChange: _handleChange.bind(inst)
			    };
	
			    if (process.env.NODE_ENV !== 'production') {
			      inst._wrapperState.controlled = isControlled(props);
			    }
			  },
	
			  updateWrapper: function (inst) {
			    var props = inst._currentElement.props;
	
			    if (process.env.NODE_ENV !== 'production') {
			      var controlled = isControlled(props);
			      var owner = inst._currentElement._owner;
	
			      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
			        didWarnUncontrolledToControlled = true;
			      }
			      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
			        didWarnControlledToUncontrolled = true;
			      }
			    }
	
			    // TODO: Shouldn't this be getChecked(props)?
			    var checked = props.checked;
			    if (checked != null) {
			      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
			    }
	
			    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			    var value = LinkedValueUtils.getValue(props);
			    if (value != null) {
	
			      // Cast `value` to a string to ensure the value is set correctly. While
			      // browsers typically do this as necessary, jsdom doesn't.
			      var newValue = '' + value;
	
			      // To avoid side effects (such as losing text selection), only set value if changed
			      if (newValue !== node.value) {
			        node.value = newValue;
			      }
			    } else {
			      if (props.value == null && props.defaultValue != null) {
			        // In Chrome, assigning defaultValue to certain input types triggers input validation.
			        // For number inputs, the display value loses trailing decimal points. For email inputs,
			        // Chrome raises "The specified value <x> is not a valid email address".
			        //
			        // Here we check to see if the defaultValue has actually changed, avoiding these problems
			        // when the user is inputting text
			        //
			        // https://github.com/facebook/react/issues/7253
			        if (node.defaultValue !== '' + props.defaultValue) {
			          node.defaultValue = '' + props.defaultValue;
			        }
			      }
			      if (props.checked == null && props.defaultChecked != null) {
			        node.defaultChecked = !!props.defaultChecked;
			      }
			    }
			  },
	
			  postMountWrapper: function (inst) {
			    var props = inst._currentElement.props;
	
			    // This is in postMount because we need access to the DOM node, which is not
			    // available until after the component has mounted.
			    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
			    // Detach value from defaultValue. We won't do anything if we're working on
			    // submit or reset inputs as those values & defaultValues are linked. They
			    // are not resetable nodes so this operation doesn't matter and actually
			    // removes browser-default values (eg "Submit Query") when no value is
			    // provided.
	
			    switch (props.type) {
			      case 'submit':
			      case 'reset':
			        break;
			      case 'color':
			      case 'date':
			      case 'datetime':
			      case 'datetime-local':
			      case 'month':
			      case 'time':
			      case 'week':
			        // This fixes the no-show issue on iOS Safari and Android Chrome:
			        // https://github.com/facebook/react/issues/7233
			        node.value = '';
			        node.value = node.defaultValue;
			        break;
			      default:
			        node.value = node.value;
			        break;
			    }
	
			    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
			    // this is needed to work around a chrome bug where setting defaultChecked
			    // will sometimes influence the value of checked (even after detachment).
			    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
			    // We need to temporarily unset name to avoid disrupting radio button groups.
			    var name = node.name;
			    if (name !== '') {
			      node.name = '';
			    }
			    node.defaultChecked = !node.defaultChecked;
			    node.defaultChecked = !node.defaultChecked;
			    if (name !== '') {
			      node.name = name;
			    }
			  }
			};
	
			function _handleChange(event) {
			  var props = this._currentElement.props;
	
			  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
			  // Here we use asap to wait until all updates have propagated, which
			  // is important when using controlled components within layers:
			  // https://github.com/facebook/react/issues/1698
			  ReactUpdates.asap(forceUpdateIfMounted, this);
	
			  var name = props.name;
			  if (props.type === 'radio' && name != null) {
			    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
			    var queryRoot = rootNode;
	
			    while (queryRoot.parentNode) {
			      queryRoot = queryRoot.parentNode;
			    }
	
			    // If `rootNode.form` was non-null, then we could try `form.elements`,
			    // but that sometimes behaves strangely in IE8. We could also try using
			    // `form.getElementsByName`, but that will only return direct children
			    // and won't include inputs that use the HTML5 `form=` attribute. Since
			    // the input might not even be in a form, let's just use the global
			    // `querySelectorAll` to ensure we don't miss anything.
			    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
			    for (var i = 0; i < group.length; i++) {
			      var otherNode = group[i];
			      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
			        continue;
			      }
			      // This will throw if radio buttons rendered by different copies of React
			      // and the same name are rendered into the same form (same as #1939).
			      // That's probably okay; we don't support it just as we don't support
			      // mixing React radio buttons with non-React ones.
			      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
			      !otherInstance ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
			      // If this is a controlled radio button group, forcing the input that
			      // was previously checked to update will cause it to be come re-checked
			      // as appropriate.
			      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
			    }
			  }
	
			  return returnValue;
			}
	
			module.exports = ReactDOMInput;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 87 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var React = __webpack_require__(88);
			var ReactPropTypesSecret = __webpack_require__(110);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var hasReadOnlyValue = {
			  'button': true,
			  'checkbox': true,
			  'image': true,
			  'hidden': true,
			  'radio': true,
			  'reset': true,
			  'submit': true
			};
	
			function _assertSingleLink(inputProps) {
			  !(inputProps.checkedLink == null || inputProps.valueLink == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
			}
			function _assertValueLink(inputProps) {
			  _assertSingleLink(inputProps);
			  !(inputProps.value == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
			}
	
			function _assertCheckedLink(inputProps) {
			  _assertSingleLink(inputProps);
			  !(inputProps.checked == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
			}
	
			var propTypes = {
			  value: function (props, propName, componentName) {
			    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
			      return null;
			    }
			    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
			  },
			  checked: function (props, propName, componentName) {
			    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
			      return null;
			    }
			    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
			  },
			  onChange: React.PropTypes.func
			};
	
			var loggedTypeFailures = {};
			function getDeclarationErrorAddendum(owner) {
			  if (owner) {
			    var name = owner.getName();
			    if (name) {
			      return ' Check the render method of `' + name + '`.';
			    }
			  }
			  return '';
			}
	
			/**
			 * Provide a linked `value` attribute for controlled forms. You should not use
			 * this outside of the ReactDOM controlled form components.
			 */
			var LinkedValueUtils = {
			  checkPropTypes: function (tagName, props, owner) {
			    for (var propName in propTypes) {
			      if (propTypes.hasOwnProperty(propName)) {
			        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
			      }
			      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
			        // Only monitor this failure once because there tends to be a lot of the
			        // same error.
			        loggedTypeFailures[error.message] = true;
	
			        var addendum = getDeclarationErrorAddendum(owner);
			        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
			      }
			    }
			  },
	
			  /**
			   * @param {object} inputProps Props for form component
			   * @return {*} current value of the input either from value prop or link.
			   */
			  getValue: function (inputProps) {
			    if (inputProps.valueLink) {
			      _assertValueLink(inputProps);
			      return inputProps.valueLink.value;
			    }
			    return inputProps.value;
			  },
	
			  /**
			   * @param {object} inputProps Props for form component
			   * @return {*} current checked status of the input either from checked prop
			   *             or link.
			   */
			  getChecked: function (inputProps) {
			    if (inputProps.checkedLink) {
			      _assertCheckedLink(inputProps);
			      return inputProps.checkedLink.value;
			    }
			    return inputProps.checked;
			  },
	
			  /**
			   * @param {object} inputProps Props for form component
			   * @param {SyntheticEvent} event change event to handle
			   */
			  executeOnChange: function (inputProps, event) {
			    if (inputProps.valueLink) {
			      _assertValueLink(inputProps);
			      return inputProps.valueLink.requestChange(event.target.value);
			    } else if (inputProps.checkedLink) {
			      _assertCheckedLink(inputProps);
			      return inputProps.checkedLink.requestChange(event.target.checked);
			    } else if (inputProps.onChange) {
			      return inputProps.onChange.call(undefined, event);
			    }
			  }
			};
	
			module.exports = LinkedValueUtils;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 88 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var ReactChildren = __webpack_require__(89);
			var ReactComponent = __webpack_require__(97);
			var ReactPureComponent = __webpack_require__(100);
			var ReactClass = __webpack_require__(101);
			var ReactDOMFactories = __webpack_require__(103);
			var ReactElement = __webpack_require__(91);
			var ReactPropTypes = __webpack_require__(107);
			var ReactVersion = __webpack_require__(108);
	
			var onlyChild = __webpack_require__(109);
			var warning = __webpack_require__(18);
	
			var createElement = ReactElement.createElement;
			var createFactory = ReactElement.createFactory;
			var cloneElement = ReactElement.cloneElement;
	
			if (process.env.NODE_ENV !== 'production') {
			  var ReactElementValidator = __webpack_require__(104);
			  createElement = ReactElementValidator.createElement;
			  createFactory = ReactElementValidator.createFactory;
			  cloneElement = ReactElementValidator.cloneElement;
			}
	
			var __spread = _assign;
	
			if (process.env.NODE_ENV !== 'production') {
			  var warned = false;
			  __spread = function () {
			    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
			    warned = true;
			    return _assign.apply(null, arguments);
			  };
			}
	
			var React = {
	
			  // Modern
	
			  Children: {
			    map: ReactChildren.map,
			    forEach: ReactChildren.forEach,
			    count: ReactChildren.count,
			    toArray: ReactChildren.toArray,
			    only: onlyChild
			  },
	
			  Component: ReactComponent,
			  PureComponent: ReactPureComponent,
	
			  createElement: createElement,
			  cloneElement: cloneElement,
			  isValidElement: ReactElement.isValidElement,
	
			  // Classic
	
			  PropTypes: ReactPropTypes,
			  createClass: ReactClass.createClass,
			  createFactory: createFactory,
			  createMixin: function (mixin) {
			    // Currently a noop. Will be used to validate and trace mixins.
			    return mixin;
			  },
	
			  // This looks DOM specific but these are actually isomorphic helpers
			  // since they are just generating DOM strings.
			  DOM: ReactDOMFactories,
	
			  version: ReactVersion,
	
			  // Deprecated hook for JSX spread, don't use this for anything.
			  __spread: __spread
			};
	
			module.exports = React;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 89 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var PooledClass = __webpack_require__(90);
			var ReactElement = __webpack_require__(91);
	
			var emptyFunction = __webpack_require__(19);
			var traverseAllChildren = __webpack_require__(94);
	
			var twoArgumentPooler = PooledClass.twoArgumentPooler;
			var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
			var userProvidedKeyEscapeRegex = /\/+/g;
			function escapeUserProvidedKey(text) {
			  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
			}
	
			/**
			 * PooledClass representing the bookkeeping associated with performing a child
			 * traversal. Allows avoiding binding callbacks.
			 *
			 * @constructor ForEachBookKeeping
			 * @param {!function} forEachFunction Function to perform traversal with.
			 * @param {?*} forEachContext Context to perform context with.
			 */
			function ForEachBookKeeping(forEachFunction, forEachContext) {
			  this.func = forEachFunction;
			  this.context = forEachContext;
			  this.count = 0;
			}
			ForEachBookKeeping.prototype.destructor = function () {
			  this.func = null;
			  this.context = null;
			  this.count = 0;
			};
			PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
			function forEachSingleChild(bookKeeping, child, name) {
			  var func = bookKeeping.func,
			      context = bookKeeping.context;
	
			  func.call(context, child, bookKeeping.count++);
			}
	
			/**
			 * Iterates through children that are typically specified as `props.children`.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
			 *
			 * The provided forEachFunc(child, index) will be called for each
			 * leaf child.
			 *
			 * @param {?*} children Children tree container.
			 * @param {function(*, int)} forEachFunc
			 * @param {*} forEachContext Context for forEachContext.
			 */
			function forEachChildren(children, forEachFunc, forEachContext) {
			  if (children == null) {
			    return children;
			  }
			  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
			  traverseAllChildren(children, forEachSingleChild, traverseContext);
			  ForEachBookKeeping.release(traverseContext);
			}
	
			/**
			 * PooledClass representing the bookkeeping associated with performing a child
			 * mapping. Allows avoiding binding callbacks.
			 *
			 * @constructor MapBookKeeping
			 * @param {!*} mapResult Object containing the ordered map of results.
			 * @param {!function} mapFunction Function to perform mapping with.
			 * @param {?*} mapContext Context to perform mapping with.
			 */
			function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
			  this.result = mapResult;
			  this.keyPrefix = keyPrefix;
			  this.func = mapFunction;
			  this.context = mapContext;
			  this.count = 0;
			}
			MapBookKeeping.prototype.destructor = function () {
			  this.result = null;
			  this.keyPrefix = null;
			  this.func = null;
			  this.context = null;
			  this.count = 0;
			};
			PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
			function mapSingleChildIntoContext(bookKeeping, child, childKey) {
			  var result = bookKeeping.result,
			      keyPrefix = bookKeeping.keyPrefix,
			      func = bookKeeping.func,
			      context = bookKeeping.context;
	
	
			  var mappedChild = func.call(context, child, bookKeeping.count++);
			  if (Array.isArray(mappedChild)) {
			    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
			  } else if (mappedChild != null) {
			    if (ReactElement.isValidElement(mappedChild)) {
			      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
			      // Keep both the (mapped) and old keys if they differ, just as
			      // traverseAllChildren used to do for objects as children
			      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
			    }
			    result.push(mappedChild);
			  }
			}
	
			function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
			  var escapedPrefix = '';
			  if (prefix != null) {
			    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
			  }
			  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
			  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
			  MapBookKeeping.release(traverseContext);
			}
	
			/**
			 * Maps children that are typically specified as `props.children`.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
			 *
			 * The provided mapFunction(child, key, index) will be called for each
			 * leaf child.
			 *
			 * @param {?*} children Children tree container.
			 * @param {function(*, int)} func The map function.
			 * @param {*} context Context for mapFunction.
			 * @return {object} Object containing the ordered map of results.
			 */
			function mapChildren(children, func, context) {
			  if (children == null) {
			    return children;
			  }
			  var result = [];
			  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
			  return result;
			}
	
			function forEachSingleChildDummy(traverseContext, child, name) {
			  return null;
			}
	
			/**
			 * Count the number of children that are typically specified as
			 * `props.children`.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
			 *
			 * @param {?*} children Children tree container.
			 * @return {number} The number of children.
			 */
			function countChildren(children, context) {
			  return traverseAllChildren(children, forEachSingleChildDummy, null);
			}
	
			/**
			 * Flatten a children object (typically specified as `props.children`) and
			 * return an array with appropriately re-keyed children.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
			 */
			function toArray(children) {
			  var result = [];
			  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
			  return result;
			}
	
			var ReactChildren = {
			  forEach: forEachChildren,
			  map: mapChildren,
			  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
			  count: countChildren,
			  toArray: toArray
			};
	
			module.exports = ReactChildren;
	
		/***/ },
		/* 90 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Static poolers. Several custom versions for each potential number of
			 * arguments. A completely generic pooler is easy to implement, but would
			 * require accessing the `arguments` object. In each of these, `this` refers to
			 * the Class itself, not an instance. If any others are needed, simply add them
			 * here, or in their own files.
			 */
			var oneArgumentPooler = function (copyFieldsFrom) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, copyFieldsFrom);
			    return instance;
			  } else {
			    return new Klass(copyFieldsFrom);
			  }
			};
	
			var twoArgumentPooler = function (a1, a2) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2);
			    return instance;
			  } else {
			    return new Klass(a1, a2);
			  }
			};
	
			var threeArgumentPooler = function (a1, a2, a3) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2, a3);
			    return instance;
			  } else {
			    return new Klass(a1, a2, a3);
			  }
			};
	
			var fourArgumentPooler = function (a1, a2, a3, a4) {
			  var Klass = this;
			  if (Klass.instancePool.length) {
			    var instance = Klass.instancePool.pop();
			    Klass.call(instance, a1, a2, a3, a4);
			    return instance;
			  } else {
			    return new Klass(a1, a2, a3, a4);
			  }
			};
	
			var standardReleaser = function (instance) {
			  var Klass = this;
			  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
			  instance.destructor();
			  if (Klass.instancePool.length < Klass.poolSize) {
			    Klass.instancePool.push(instance);
			  }
			};
	
			var DEFAULT_POOL_SIZE = 10;
			var DEFAULT_POOLER = oneArgumentPooler;
	
			/**
			 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
			 * itself (statically) not adding any prototypical fields. Any CopyConstructor
			 * you give this may have a `poolSize` property, and will look for a
			 * prototypical `destructor` on instances.
			 *
			 * @param {Function} CopyConstructor Constructor that can be used to reset.
			 * @param {Function} pooler Customizable pooler.
			 */
			var addPoolingTo = function (CopyConstructor, pooler) {
			  // Casting as any so that flow ignores the actual implementation and trusts
			  // it to match the type we declared
			  var NewKlass = CopyConstructor;
			  NewKlass.instancePool = [];
			  NewKlass.getPooled = pooler || DEFAULT_POOLER;
			  if (!NewKlass.poolSize) {
			    NewKlass.poolSize = DEFAULT_POOL_SIZE;
			  }
			  NewKlass.release = standardReleaser;
			  return NewKlass;
			};
	
			var PooledClass = {
			  addPoolingTo: addPoolingTo,
			  oneArgumentPooler: oneArgumentPooler,
			  twoArgumentPooler: twoArgumentPooler,
			  threeArgumentPooler: threeArgumentPooler,
			  fourArgumentPooler: fourArgumentPooler
			};
	
			module.exports = PooledClass;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 91 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var ReactCurrentOwner = __webpack_require__(43);
	
			var warning = __webpack_require__(18);
			var canDefineProperty = __webpack_require__(92);
			var hasOwnProperty = Object.prototype.hasOwnProperty;
	
			var REACT_ELEMENT_TYPE = __webpack_require__(93);
	
			var RESERVED_PROPS = {
			  key: true,
			  ref: true,
			  __self: true,
			  __source: true
			};
	
			var specialPropKeyWarningShown, specialPropRefWarningShown;
	
			function hasValidRef(config) {
			  if (process.env.NODE_ENV !== 'production') {
			    if (hasOwnProperty.call(config, 'ref')) {
			      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
			      if (getter && getter.isReactWarning) {
			        return false;
			      }
			    }
			  }
			  return config.ref !== undefined;
			}
	
			function hasValidKey(config) {
			  if (process.env.NODE_ENV !== 'production') {
			    if (hasOwnProperty.call(config, 'key')) {
			      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
			      if (getter && getter.isReactWarning) {
			        return false;
			      }
			    }
			  }
			  return config.key !== undefined;
			}
	
			function defineKeyPropWarningGetter(props, displayName) {
			  var warnAboutAccessingKey = function () {
			    if (!specialPropKeyWarningShown) {
			      specialPropKeyWarningShown = true;
			      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
			    }
			  };
			  warnAboutAccessingKey.isReactWarning = true;
			  Object.defineProperty(props, 'key', {
			    get: warnAboutAccessingKey,
			    configurable: true
			  });
			}
	
			function defineRefPropWarningGetter(props, displayName) {
			  var warnAboutAccessingRef = function () {
			    if (!specialPropRefWarningShown) {
			      specialPropRefWarningShown = true;
			      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
			    }
			  };
			  warnAboutAccessingRef.isReactWarning = true;
			  Object.defineProperty(props, 'ref', {
			    get: warnAboutAccessingRef,
			    configurable: true
			  });
			}
	
			/**
			 * Factory method to create a new React element. This no longer adheres to
			 * the class pattern, so do not use new to call it. Also, no instanceof check
			 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
			 * if something is a React Element.
			 *
			 * @param {*} type
			 * @param {*} key
			 * @param {string|object} ref
			 * @param {*} self A *temporary* helper to detect places where `this` is
			 * different from the `owner` when React.createElement is called, so that we
			 * can warn. We want to get rid of owner and replace string `ref`s with arrow
			 * functions, and as long as `this` and owner are the same, there will be no
			 * change in behavior.
			 * @param {*} source An annotation object (added by a transpiler or otherwise)
			 * indicating filename, line number, and/or other information.
			 * @param {*} owner
			 * @param {*} props
			 * @internal
			 */
			var ReactElement = function (type, key, ref, self, source, owner, props) {
			  var element = {
			    // This tag allow us to uniquely identify this as a React Element
			    $$typeof: REACT_ELEMENT_TYPE,
	
			    // Built-in properties that belong on the element
			    type: type,
			    key: key,
			    ref: ref,
			    props: props,
	
			    // Record the component responsible for creating this element.
			    _owner: owner
			  };
	
			  if (process.env.NODE_ENV !== 'production') {
			    // The validation flag is currently mutative. We put it on
			    // an external backing store so that we can freeze the whole object.
			    // This can be replaced with a WeakMap once they are implemented in
			    // commonly used development environments.
			    element._store = {};
	
			    // To make comparing ReactElements easier for testing purposes, we make
			    // the validation flag non-enumerable (where possible, which should
			    // include every environment we run tests in), so the test framework
			    // ignores it.
			    if (canDefineProperty) {
			      Object.defineProperty(element._store, 'validated', {
			        configurable: false,
			        enumerable: false,
			        writable: true,
			        value: false
			      });
			      // self and source are DEV only properties.
			      Object.defineProperty(element, '_self', {
			        configurable: false,
			        enumerable: false,
			        writable: false,
			        value: self
			      });
			      // Two elements created in two different places should be considered
			      // equal for testing purposes and therefore we hide it from enumeration.
			      Object.defineProperty(element, '_source', {
			        configurable: false,
			        enumerable: false,
			        writable: false,
			        value: source
			      });
			    } else {
			      element._store.validated = false;
			      element._self = self;
			      element._source = source;
			    }
			    if (Object.freeze) {
			      Object.freeze(element.props);
			      Object.freeze(element);
			    }
			  }
	
			  return element;
			};
	
			/**
			 * Create and return a new ReactElement of the given type.
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
			 */
			ReactElement.createElement = function (type, config, children) {
			  var propName;
	
			  // Reserved names are extracted
			  var props = {};
	
			  var key = null;
			  var ref = null;
			  var self = null;
			  var source = null;
	
			  if (config != null) {
			    if (hasValidRef(config)) {
			      ref = config.ref;
			    }
			    if (hasValidKey(config)) {
			      key = '' + config.key;
			    }
	
			    self = config.__self === undefined ? null : config.__self;
			    source = config.__source === undefined ? null : config.__source;
			    // Remaining properties are added to a new props object
			    for (propName in config) {
			      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
			        props[propName] = config[propName];
			      }
			    }
			  }
	
			  // Children can be more than one argument, and those are transferred onto
			  // the newly allocated props object.
			  var childrenLength = arguments.length - 2;
			  if (childrenLength === 1) {
			    props.children = children;
			  } else if (childrenLength > 1) {
			    var childArray = Array(childrenLength);
			    for (var i = 0; i < childrenLength; i++) {
			      childArray[i] = arguments[i + 2];
			    }
			    if (process.env.NODE_ENV !== 'production') {
			      if (Object.freeze) {
			        Object.freeze(childArray);
			      }
			    }
			    props.children = childArray;
			  }
	
			  // Resolve default props
			  if (type && type.defaultProps) {
			    var defaultProps = type.defaultProps;
			    for (propName in defaultProps) {
			      if (props[propName] === undefined) {
			        props[propName] = defaultProps[propName];
			      }
			    }
			  }
			  if (process.env.NODE_ENV !== 'production') {
			    if (key || ref) {
			      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
			        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
			        if (key) {
			          defineKeyPropWarningGetter(props, displayName);
			        }
			        if (ref) {
			          defineRefPropWarningGetter(props, displayName);
			        }
			      }
			    }
			  }
			  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
			};
	
			/**
			 * Return a function that produces ReactElements of a given type.
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
			 */
			ReactElement.createFactory = function (type) {
			  var factory = ReactElement.createElement.bind(null, type);
			  // Expose the type on the factory and the prototype so that it can be
			  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
			  // This should not be named `constructor` since this may not be the function
			  // that created the element, and it may not even be a constructor.
			  // Legacy hook TODO: Warn if this is accessed
			  factory.type = type;
			  return factory;
			};
	
			ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
			  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
			  return newElement;
			};
	
			/**
			 * Clone and return a new ReactElement using element as the starting point.
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
			 */
			ReactElement.cloneElement = function (element, config, children) {
			  var propName;
	
			  // Original props are copied
			  var props = _assign({}, element.props);
	
			  // Reserved names are extracted
			  var key = element.key;
			  var ref = element.ref;
			  // Self is preserved since the owner is preserved.
			  var self = element._self;
			  // Source is preserved since cloneElement is unlikely to be targeted by a
			  // transpiler, and the original source is probably a better indicator of the
			  // true owner.
			  var source = element._source;
	
			  // Owner will be preserved, unless ref is overridden
			  var owner = element._owner;
	
			  if (config != null) {
			    if (hasValidRef(config)) {
			      // Silently steal the ref from the parent.
			      ref = config.ref;
			      owner = ReactCurrentOwner.current;
			    }
			    if (hasValidKey(config)) {
			      key = '' + config.key;
			    }
	
			    // Remaining properties override existing props
			    var defaultProps;
			    if (element.type && element.type.defaultProps) {
			      defaultProps = element.type.defaultProps;
			    }
			    for (propName in config) {
			      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
			        if (config[propName] === undefined && defaultProps !== undefined) {
			          // Resolve default props
			          props[propName] = defaultProps[propName];
			        } else {
			          props[propName] = config[propName];
			        }
			      }
			    }
			  }
	
			  // Children can be more than one argument, and those are transferred onto
			  // the newly allocated props object.
			  var childrenLength = arguments.length - 2;
			  if (childrenLength === 1) {
			    props.children = children;
			  } else if (childrenLength > 1) {
			    var childArray = Array(childrenLength);
			    for (var i = 0; i < childrenLength; i++) {
			      childArray[i] = arguments[i + 2];
			    }
			    props.children = childArray;
			  }
	
			  return ReactElement(element.type, key, ref, self, source, owner, props);
			};
	
			/**
			 * Verifies the object is a ReactElement.
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
			 * @param {?object} object
			 * @return {boolean} True if `object` is a valid component.
			 * @final
			 */
			ReactElement.isValidElement = function (object) {
			  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
			};
	
			module.exports = ReactElement;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 92 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var canDefineProperty = false;
			if (process.env.NODE_ENV !== 'production') {
			  try {
			    // $FlowFixMe https://github.com/facebook/flow/issues/285
			    Object.defineProperty({}, 'x', { get: function () {} });
			    canDefineProperty = true;
			  } catch (x) {
			    // IE will fail on defineProperty
			  }
			}
	
			module.exports = canDefineProperty;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 93 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			// The Symbol used to tag the ReactElement type. If there is no native Symbol
			// nor polyfill, then a plain number is used for performance.
	
			var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
			module.exports = REACT_ELEMENT_TYPE;
	
		/***/ },
		/* 94 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var REACT_ELEMENT_TYPE = __webpack_require__(93);
	
			var getIteratorFn = __webpack_require__(95);
			var invariant = __webpack_require__(8);
			var KeyEscapeUtils = __webpack_require__(96);
			var warning = __webpack_require__(18);
	
			var SEPARATOR = '.';
			var SUBSEPARATOR = ':';
	
			/**
			 * This is inlined from ReactElement since this file is shared between
			 * isomorphic and renderers. We could extract this to a
			 *
			 */
	
			/**
			 * TODO: Test that a single child and an array with one item have the same key
			 * pattern.
			 */
	
			var didWarnAboutMaps = false;
	
			/**
			 * Generate a key string that identifies a component within a set.
			 *
			 * @param {*} component A component that could contain a manual key.
			 * @param {number} index Index that is used if a manual key is not provided.
			 * @return {string}
			 */
			function getComponentKey(component, index) {
			  // Do some typechecking here since we call this blindly. We want to ensure
			  // that we don't block potential future ES APIs.
			  if (component && typeof component === 'object' && component.key != null) {
			    // Explicit key
			    return KeyEscapeUtils.escape(component.key);
			  }
			  // Implicit key determined by the index in the set
			  return index.toString(36);
			}
	
			/**
			 * @param {?*} children Children tree container.
			 * @param {!string} nameSoFar Name of the key path so far.
			 * @param {!function} callback Callback to invoke with each child found.
			 * @param {?*} traverseContext Used to pass information throughout the traversal
			 * process.
			 * @return {!number} The number of children in this subtree.
			 */
			function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
			  var type = typeof children;
	
			  if (type === 'undefined' || type === 'boolean') {
			    // All of the above are perceived as null.
			    children = null;
			  }
	
			  if (children === null || type === 'string' || type === 'number' ||
			  // The following is inlined from ReactElement. This means we can optimize
			  // some checks. React Fiber also inlines this logic for similar purposes.
			  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
			    callback(traverseContext, children,
			    // If it's the only child, treat the name as if it was wrapped in an array
			    // so that it's consistent if the number of children grows.
			    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
			    return 1;
			  }
	
			  var child;
			  var nextName;
			  var subtreeCount = 0; // Count of children found in the current subtree.
			  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
			  if (Array.isArray(children)) {
			    for (var i = 0; i < children.length; i++) {
			      child = children[i];
			      nextName = nextNamePrefix + getComponentKey(child, i);
			      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			    }
			  } else {
			    var iteratorFn = getIteratorFn(children);
			    if (iteratorFn) {
			      var iterator = iteratorFn.call(children);
			      var step;
			      if (iteratorFn !== children.entries) {
			        var ii = 0;
			        while (!(step = iterator.next()).done) {
			          child = step.value;
			          nextName = nextNamePrefix + getComponentKey(child, ii++);
			          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			        }
			      } else {
			        if (process.env.NODE_ENV !== 'production') {
			          var mapsAsChildrenAddendum = '';
			          if (ReactCurrentOwner.current) {
			            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
			            if (mapsAsChildrenOwnerName) {
			              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
			            }
			          }
			          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
			          didWarnAboutMaps = true;
			        }
			        // Iterator will provide entry [k,v] tuples rather than values.
			        while (!(step = iterator.next()).done) {
			          var entry = step.value;
			          if (entry) {
			            child = entry[1];
			            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
			            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			          }
			        }
			      }
			    } else if (type === 'object') {
			      var addendum = '';
			      if (process.env.NODE_ENV !== 'production') {
			        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
			        if (children._isReactElement) {
			          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
			        }
			        if (ReactCurrentOwner.current) {
			          var name = ReactCurrentOwner.current.getName();
			          if (name) {
			            addendum += ' Check the render method of `' + name + '`.';
			          }
			        }
			      }
			      var childrenString = String(children);
			       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
			    }
			  }
	
			  return subtreeCount;
			}
	
			/**
			 * Traverses children that are typically specified as `props.children`, but
			 * might also be specified through attributes:
			 *
			 * - `traverseAllChildren(this.props.children, ...)`
			 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
			 *
			 * The `traverseContext` is an optional argument that is passed through the
			 * entire traversal. It can be used to store accumulations or anything else that
			 * the callback might find relevant.
			 *
			 * @param {?*} children Children tree object.
			 * @param {!function} callback To invoke upon traversing each child.
			 * @param {?*} traverseContext Context for traversal.
			 * @return {!number} The number of children in this subtree.
			 */
			function traverseAllChildren(children, callback, traverseContext) {
			  if (children == null) {
			    return 0;
			  }
	
			  return traverseAllChildrenImpl(children, '', callback, traverseContext);
			}
	
			module.exports = traverseAllChildren;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 95 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/* global Symbol */
	
			var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
			var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
			/**
			 * Returns the iterator method function contained on the iterable object.
			 *
			 * Be sure to invoke the function with the iterable as context:
			 *
			 *     var iteratorFn = getIteratorFn(myIterable);
			 *     if (iteratorFn) {
			 *       var iterator = iteratorFn.call(myIterable);
			 *       ...
			 *     }
			 *
			 * @param {?object} maybeIterable
			 * @return {?function}
			 */
			function getIteratorFn(maybeIterable) {
			  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
			  if (typeof iteratorFn === 'function') {
			    return iteratorFn;
			  }
			}
	
			module.exports = getIteratorFn;
	
		/***/ },
		/* 96 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * Escape and wrap key so it is safe to use as a reactid
			 *
			 * @param {string} key to be escaped.
			 * @return {string} the escaped key.
			 */
	
			function escape(key) {
			  var escapeRegex = /[=:]/g;
			  var escaperLookup = {
			    '=': '=0',
			    ':': '=2'
			  };
			  var escapedString = ('' + key).replace(escapeRegex, function (match) {
			    return escaperLookup[match];
			  });
	
			  return '$' + escapedString;
			}
	
			/**
			 * Unescape and unwrap key for human-readable display
			 *
			 * @param {string} key to unescape.
			 * @return {string} the unescaped key.
			 */
			function unescape(key) {
			  var unescapeRegex = /(=0|=2)/g;
			  var unescaperLookup = {
			    '=0': '=',
			    '=2': ':'
			  };
			  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
			  return ('' + keySubstring).replace(unescapeRegex, function (match) {
			    return unescaperLookup[match];
			  });
			}
	
			var KeyEscapeUtils = {
			  escape: escape,
			  unescape: unescape
			};
	
			module.exports = KeyEscapeUtils;
	
		/***/ },
		/* 97 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactNoopUpdateQueue = __webpack_require__(98);
	
			var canDefineProperty = __webpack_require__(92);
			var emptyObject = __webpack_require__(99);
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			/**
			 * Base class helpers for the updating state of a component.
			 */
			function ReactComponent(props, context, updater) {
			  this.props = props;
			  this.context = context;
			  this.refs = emptyObject;
			  // We initialize the default updater but the real one gets injected by the
			  // renderer.
			  this.updater = updater || ReactNoopUpdateQueue;
			}
	
			ReactComponent.prototype.isReactComponent = {};
	
			/**
			 * Sets a subset of the state. Always use this to mutate
			 * state. You should treat `this.state` as immutable.
			 *
			 * There is no guarantee that `this.state` will be immediately updated, so
			 * accessing `this.state` after calling this method may return the old value.
			 *
			 * There is no guarantee that calls to `setState` will run synchronously,
			 * as they may eventually be batched together.  You can provide an optional
			 * callback that will be executed when the call to setState is actually
			 * completed.
			 *
			 * When a function is provided to setState, it will be called at some point in
			 * the future (not synchronously). It will be called with the up to date
			 * component arguments (state, props, context). These values can be different
			 * from this.* because your function may be called after receiveProps but before
			 * shouldComponentUpdate, and this new state, props, and context will not yet be
			 * assigned to this.
			 *
			 * @param {object|function} partialState Next partial state or function to
			 *        produce next partial state to be merged with current state.
			 * @param {?function} callback Called after state is updated.
			 * @final
			 * @protected
			 */
			ReactComponent.prototype.setState = function (partialState, callback) {
			  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
			  this.updater.enqueueSetState(this, partialState);
			  if (callback) {
			    this.updater.enqueueCallback(this, callback, 'setState');
			  }
			};
	
			/**
			 * Forces an update. This should only be invoked when it is known with
			 * certainty that we are **not** in a DOM transaction.
			 *
			 * You may want to call this when you know that some deeper aspect of the
			 * component's state has changed but `setState` was not called.
			 *
			 * This will not invoke `shouldComponentUpdate`, but it will invoke
			 * `componentWillUpdate` and `componentDidUpdate`.
			 *
			 * @param {?function} callback Called after update is complete.
			 * @final
			 * @protected
			 */
			ReactComponent.prototype.forceUpdate = function (callback) {
			  this.updater.enqueueForceUpdate(this);
			  if (callback) {
			    this.updater.enqueueCallback(this, callback, 'forceUpdate');
			  }
			};
	
			/**
			 * Deprecated APIs. These APIs used to exist on classic React classes but since
			 * we would like to deprecate them, we're not going to move them over to this
			 * modern base class. Instead, we define a getter that warns if it's accessed.
			 */
			if (process.env.NODE_ENV !== 'production') {
			  var deprecatedAPIs = {
			    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
			    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
			  };
			  var defineDeprecationWarning = function (methodName, info) {
			    if (canDefineProperty) {
			      Object.defineProperty(ReactComponent.prototype, methodName, {
			        get: function () {
			          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
			          return undefined;
			        }
			      });
			    }
			  };
			  for (var fnName in deprecatedAPIs) {
			    if (deprecatedAPIs.hasOwnProperty(fnName)) {
			      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
			    }
			  }
			}
	
			module.exports = ReactComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 98 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var warning = __webpack_require__(18);
	
			function warnNoop(publicInstance, callerName) {
			  if (process.env.NODE_ENV !== 'production') {
			    var constructor = publicInstance.constructor;
			    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
			  }
			}
	
			/**
			 * This is the abstract API for an update queue.
			 */
			var ReactNoopUpdateQueue = {
	
			  /**
			   * Checks whether or not this composite component is mounted.
			   * @param {ReactClass} publicInstance The instance we want to test.
			   * @return {boolean} True if mounted, false otherwise.
			   * @protected
			   * @final
			   */
			  isMounted: function (publicInstance) {
			    return false;
			  },
	
			  /**
			   * Enqueue a callback that will be executed after all the pending updates
			   * have processed.
			   *
			   * @param {ReactClass} publicInstance The instance to use as `this` context.
			   * @param {?function} callback Called after state is updated.
			   * @internal
			   */
			  enqueueCallback: function (publicInstance, callback) {},
	
			  /**
			   * Forces an update. This should only be invoked when it is known with
			   * certainty that we are **not** in a DOM transaction.
			   *
			   * You may want to call this when you know that some deeper aspect of the
			   * component's state has changed but `setState` was not called.
			   *
			   * This will not invoke `shouldComponentUpdate`, but it will invoke
			   * `componentWillUpdate` and `componentDidUpdate`.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @internal
			   */
			  enqueueForceUpdate: function (publicInstance) {
			    warnNoop(publicInstance, 'forceUpdate');
			  },
	
			  /**
			   * Replaces all of the state. Always use this or `setState` to mutate state.
			   * You should treat `this.state` as immutable.
			   *
			   * There is no guarantee that `this.state` will be immediately updated, so
			   * accessing `this.state` after calling this method may return the old value.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object} completeState Next state.
			   * @internal
			   */
			  enqueueReplaceState: function (publicInstance, completeState) {
			    warnNoop(publicInstance, 'replaceState');
			  },
	
			  /**
			   * Sets a subset of the state. This only exists because _pendingState is
			   * internal. This provides a merging strategy that is not available to deep
			   * properties which is confusing. TODO: Expose pendingState or don't use it
			   * during the merge.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object} partialState Next partial state to be merged with state.
			   * @internal
			   */
			  enqueueSetState: function (publicInstance, partialState) {
			    warnNoop(publicInstance, 'setState');
			  }
			};
	
			module.exports = ReactNoopUpdateQueue;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 99 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyObject = {};
	
			if (process.env.NODE_ENV !== 'production') {
			  Object.freeze(emptyObject);
			}
	
			module.exports = emptyObject;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 100 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var ReactComponent = __webpack_require__(97);
			var ReactNoopUpdateQueue = __webpack_require__(98);
	
			var emptyObject = __webpack_require__(99);
	
			/**
			 * Base class helpers for the updating state of a component.
			 */
			function ReactPureComponent(props, context, updater) {
			  // Duplicated from ReactComponent.
			  this.props = props;
			  this.context = context;
			  this.refs = emptyObject;
			  // We initialize the default updater but the real one gets injected by the
			  // renderer.
			  this.updater = updater || ReactNoopUpdateQueue;
			}
	
			function ComponentDummy() {}
			ComponentDummy.prototype = ReactComponent.prototype;
			ReactPureComponent.prototype = new ComponentDummy();
			ReactPureComponent.prototype.constructor = ReactPureComponent;
			// Avoid an extra prototype jump for these methods.
			_assign(ReactPureComponent.prototype, ReactComponent.prototype);
			ReactPureComponent.prototype.isPureReactComponent = true;
	
			module.exports = ReactPureComponent;
	
		/***/ },
		/* 101 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42),
			    _assign = __webpack_require__(24);
	
			var ReactComponent = __webpack_require__(97);
			var ReactElement = __webpack_require__(91);
			var ReactPropTypeLocationNames = __webpack_require__(102);
			var ReactNoopUpdateQueue = __webpack_require__(98);
	
			var emptyObject = __webpack_require__(99);
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var MIXINS_KEY = 'mixins';
	
			// Helper function to allow the creation of anonymous functions which do not
			// have .name set to the name of the variable being assigned to.
			function identity(fn) {
			  return fn;
			}
	
			/**
			 * Policies that describe methods in `ReactClassInterface`.
			 */
	
	
			var injectedMixins = [];
	
			/**
			 * Composite components are higher-level components that compose other composite
			 * or host components.
			 *
			 * To create a new type of `ReactClass`, pass a specification of
			 * your new class to `React.createClass`. The only requirement of your class
			 * specification is that you implement a `render` method.
			 *
			 *   var MyComponent = React.createClass({
			 *     render: function() {
			 *       return <div>Hello World</div>;
			 *     }
			 *   });
			 *
			 * The class specification supports a specific protocol of methods that have
			 * special meaning (e.g. `render`). See `ReactClassInterface` for
			 * more the comprehensive protocol. Any other properties and methods in the
			 * class specification will be available on the prototype.
			 *
			 * @interface ReactClassInterface
			 * @internal
			 */
			var ReactClassInterface = {
	
			  /**
			   * An array of Mixin objects to include when defining your component.
			   *
			   * @type {array}
			   * @optional
			   */
			  mixins: 'DEFINE_MANY',
	
			  /**
			   * An object containing properties and methods that should be defined on
			   * the component's constructor instead of its prototype (static methods).
			   *
			   * @type {object}
			   * @optional
			   */
			  statics: 'DEFINE_MANY',
	
			  /**
			   * Definition of prop types for this component.
			   *
			   * @type {object}
			   * @optional
			   */
			  propTypes: 'DEFINE_MANY',
	
			  /**
			   * Definition of context types for this component.
			   *
			   * @type {object}
			   * @optional
			   */
			  contextTypes: 'DEFINE_MANY',
	
			  /**
			   * Definition of context types this component sets for its children.
			   *
			   * @type {object}
			   * @optional
			   */
			  childContextTypes: 'DEFINE_MANY',
	
			  // ==== Definition methods ====
	
			  /**
			   * Invoked when the component is mounted. Values in the mapping will be set on
			   * `this.props` if that prop is not specified (i.e. using an `in` check).
			   *
			   * This method is invoked before `getInitialState` and therefore cannot rely
			   * on `this.state` or use `this.setState`.
			   *
			   * @return {object}
			   * @optional
			   */
			  getDefaultProps: 'DEFINE_MANY_MERGED',
	
			  /**
			   * Invoked once before the component is mounted. The return value will be used
			   * as the initial value of `this.state`.
			   *
			   *   getInitialState: function() {
			   *     return {
			   *       isOn: false,
			   *       fooBaz: new BazFoo()
			   *     }
			   *   }
			   *
			   * @return {object}
			   * @optional
			   */
			  getInitialState: 'DEFINE_MANY_MERGED',
	
			  /**
			   * @return {object}
			   * @optional
			   */
			  getChildContext: 'DEFINE_MANY_MERGED',
	
			  /**
			   * Uses props from `this.props` and state from `this.state` to render the
			   * structure of the component.
			   *
			   * No guarantees are made about when or how often this method is invoked, so
			   * it must not have side effects.
			   *
			   *   render: function() {
			   *     var name = this.props.name;
			   *     return <div>Hello, {name}!</div>;
			   *   }
			   *
			   * @return {ReactComponent}
			   * @nosideeffects
			   * @required
			   */
			  render: 'DEFINE_ONCE',
	
			  // ==== Delegate methods ====
	
			  /**
			   * Invoked when the component is initially created and about to be mounted.
			   * This may have side effects, but any external subscriptions or data created
			   * by this method must be cleaned up in `componentWillUnmount`.
			   *
			   * @optional
			   */
			  componentWillMount: 'DEFINE_MANY',
	
			  /**
			   * Invoked when the component has been mounted and has a DOM representation.
			   * However, there is no guarantee that the DOM node is in the document.
			   *
			   * Use this as an opportunity to operate on the DOM when the component has
			   * been mounted (initialized and rendered) for the first time.
			   *
			   * @param {DOMElement} rootNode DOM element representing the component.
			   * @optional
			   */
			  componentDidMount: 'DEFINE_MANY',
	
			  /**
			   * Invoked before the component receives new props.
			   *
			   * Use this as an opportunity to react to a prop transition by updating the
			   * state using `this.setState`. Current props are accessed via `this.props`.
			   *
			   *   componentWillReceiveProps: function(nextProps, nextContext) {
			   *     this.setState({
			   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
			   *     });
			   *   }
			   *
			   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
			   * transition may cause a state change, but the opposite is not true. If you
			   * need it, you are probably looking for `componentWillUpdate`.
			   *
			   * @param {object} nextProps
			   * @optional
			   */
			  componentWillReceiveProps: 'DEFINE_MANY',
	
			  /**
			   * Invoked while deciding if the component should be updated as a result of
			   * receiving new props, state and/or context.
			   *
			   * Use this as an opportunity to `return false` when you're certain that the
			   * transition to the new props/state/context will not require a component
			   * update.
			   *
			   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
			   *     return !equal(nextProps, this.props) ||
			   *       !equal(nextState, this.state) ||
			   *       !equal(nextContext, this.context);
			   *   }
			   *
			   * @param {object} nextProps
			   * @param {?object} nextState
			   * @param {?object} nextContext
			   * @return {boolean} True if the component should update.
			   * @optional
			   */
			  shouldComponentUpdate: 'DEFINE_ONCE',
	
			  /**
			   * Invoked when the component is about to update due to a transition from
			   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
			   * and `nextContext`.
			   *
			   * Use this as an opportunity to perform preparation before an update occurs.
			   *
			   * NOTE: You **cannot** use `this.setState()` in this method.
			   *
			   * @param {object} nextProps
			   * @param {?object} nextState
			   * @param {?object} nextContext
			   * @param {ReactReconcileTransaction} transaction
			   * @optional
			   */
			  componentWillUpdate: 'DEFINE_MANY',
	
			  /**
			   * Invoked when the component's DOM representation has been updated.
			   *
			   * Use this as an opportunity to operate on the DOM when the component has
			   * been updated.
			   *
			   * @param {object} prevProps
			   * @param {?object} prevState
			   * @param {?object} prevContext
			   * @param {DOMElement} rootNode DOM element representing the component.
			   * @optional
			   */
			  componentDidUpdate: 'DEFINE_MANY',
	
			  /**
			   * Invoked when the component is about to be removed from its parent and have
			   * its DOM representation destroyed.
			   *
			   * Use this as an opportunity to deallocate any external resources.
			   *
			   * NOTE: There is no `componentDidUnmount` since your component will have been
			   * destroyed by that point.
			   *
			   * @optional
			   */
			  componentWillUnmount: 'DEFINE_MANY',
	
			  // ==== Advanced methods ====
	
			  /**
			   * Updates the component's currently mounted DOM representation.
			   *
			   * By default, this implements React's rendering and reconciliation algorithm.
			   * Sophisticated clients may wish to override this.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   * @overridable
			   */
			  updateComponent: 'OVERRIDE_BASE'
	
			};
	
			/**
			 * Mapping from class specification keys to special processing functions.
			 *
			 * Although these are declared like instance properties in the specification
			 * when defining classes using `React.createClass`, they are actually static
			 * and are accessible on the constructor instead of the prototype. Despite
			 * being static, they must be defined outside of the "statics" key under
			 * which all other static methods are defined.
			 */
			var RESERVED_SPEC_KEYS = {
			  displayName: function (Constructor, displayName) {
			    Constructor.displayName = displayName;
			  },
			  mixins: function (Constructor, mixins) {
			    if (mixins) {
			      for (var i = 0; i < mixins.length; i++) {
			        mixSpecIntoComponent(Constructor, mixins[i]);
			      }
			    }
			  },
			  childContextTypes: function (Constructor, childContextTypes) {
			    if (process.env.NODE_ENV !== 'production') {
			      validateTypeDef(Constructor, childContextTypes, 'childContext');
			    }
			    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
			  },
			  contextTypes: function (Constructor, contextTypes) {
			    if (process.env.NODE_ENV !== 'production') {
			      validateTypeDef(Constructor, contextTypes, 'context');
			    }
			    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
			  },
			  /**
			   * Special case getDefaultProps which should move into statics but requires
			   * automatic merging.
			   */
			  getDefaultProps: function (Constructor, getDefaultProps) {
			    if (Constructor.getDefaultProps) {
			      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
			    } else {
			      Constructor.getDefaultProps = getDefaultProps;
			    }
			  },
			  propTypes: function (Constructor, propTypes) {
			    if (process.env.NODE_ENV !== 'production') {
			      validateTypeDef(Constructor, propTypes, 'prop');
			    }
			    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
			  },
			  statics: function (Constructor, statics) {
			    mixStaticSpecIntoComponent(Constructor, statics);
			  },
			  autobind: function () {} };
	
			function validateTypeDef(Constructor, typeDef, location) {
			  for (var propName in typeDef) {
			    if (typeDef.hasOwnProperty(propName)) {
			      // use a warning instead of an invariant so components
			      // don't show up in prod but only in __DEV__
			      process.env.NODE_ENV !== 'production' ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
			    }
			  }
			}
	
			function validateMethodOverride(isAlreadyDefined, name) {
			  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
			  // Disallow overriding of base class methods unless explicitly allowed.
			  if (ReactClassMixin.hasOwnProperty(name)) {
			    !(specPolicy === 'OVERRIDE_BASE') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
			  }
	
			  // Disallow defining methods more than once unless explicitly allowed.
			  if (isAlreadyDefined) {
			    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
			  }
			}
	
			/**
			 * Mixin helper which handles policy validation and reserved
			 * specification keys when building React classes.
			 */
			function mixSpecIntoComponent(Constructor, spec) {
			  if (!spec) {
			    if (process.env.NODE_ENV !== 'production') {
			      var typeofSpec = typeof spec;
			      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
			      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
			    }
	
			    return;
			  }
	
			  !(typeof spec !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
			  !!ReactElement.isValidElement(spec) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
			  var proto = Constructor.prototype;
			  var autoBindPairs = proto.__reactAutoBindPairs;
	
			  // By handling mixins before any other properties, we ensure the same
			  // chaining order is applied to methods with DEFINE_MANY policy, whether
			  // mixins are listed before or after these methods in the spec.
			  if (spec.hasOwnProperty(MIXINS_KEY)) {
			    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
			  }
	
			  for (var name in spec) {
			    if (!spec.hasOwnProperty(name)) {
			      continue;
			    }
	
			    if (name === MIXINS_KEY) {
			      // We have already handled mixins in a special case above.
			      continue;
			    }
	
			    var property = spec[name];
			    var isAlreadyDefined = proto.hasOwnProperty(name);
			    validateMethodOverride(isAlreadyDefined, name);
	
			    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
			      RESERVED_SPEC_KEYS[name](Constructor, property);
			    } else {
			      // Setup methods on prototype:
			      // The following member methods should not be automatically bound:
			      // 1. Expected ReactClass methods (in the "interface").
			      // 2. Overridden methods (that were mixed in).
			      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
			      var isFunction = typeof property === 'function';
			      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
			      if (shouldAutoBind) {
			        autoBindPairs.push(name, property);
			        proto[name] = property;
			      } else {
			        if (isAlreadyDefined) {
			          var specPolicy = ReactClassInterface[name];
	
			          // These cases should already be caught by validateMethodOverride.
			          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
			          // For methods which are defined more than once, call the existing
			          // methods before calling the new property, merging if appropriate.
			          if (specPolicy === 'DEFINE_MANY_MERGED') {
			            proto[name] = createMergedResultFunction(proto[name], property);
			          } else if (specPolicy === 'DEFINE_MANY') {
			            proto[name] = createChainedFunction(proto[name], property);
			          }
			        } else {
			          proto[name] = property;
			          if (process.env.NODE_ENV !== 'production') {
			            // Add verbose displayName to the function, which helps when looking
			            // at profiling tools.
			            if (typeof property === 'function' && spec.displayName) {
			              proto[name].displayName = spec.displayName + '_' + name;
			            }
			          }
			        }
			      }
			    }
			  }
			}
	
			function mixStaticSpecIntoComponent(Constructor, statics) {
			  if (!statics) {
			    return;
			  }
			  for (var name in statics) {
			    var property = statics[name];
			    if (!statics.hasOwnProperty(name)) {
			      continue;
			    }
	
			    var isReserved = name in RESERVED_SPEC_KEYS;
			    !!isReserved ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
			    var isInherited = name in Constructor;
			    !!isInherited ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
			    Constructor[name] = property;
			  }
			}
	
			/**
			 * Merge two objects, but throw if both contain the same key.
			 *
			 * @param {object} one The first object, which is mutated.
			 * @param {object} two The second object
			 * @return {object} one after it has been mutated to contain everything in two.
			 */
			function mergeIntoWithNoDuplicateKeys(one, two) {
			  !(one && two && typeof one === 'object' && typeof two === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
			  for (var key in two) {
			    if (two.hasOwnProperty(key)) {
			      !(one[key] === undefined) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
			      one[key] = two[key];
			    }
			  }
			  return one;
			}
	
			/**
			 * Creates a function that invokes two functions and merges their return values.
			 *
			 * @param {function} one Function to invoke first.
			 * @param {function} two Function to invoke second.
			 * @return {function} Function that invokes the two argument functions.
			 * @private
			 */
			function createMergedResultFunction(one, two) {
			  return function mergedResult() {
			    var a = one.apply(this, arguments);
			    var b = two.apply(this, arguments);
			    if (a == null) {
			      return b;
			    } else if (b == null) {
			      return a;
			    }
			    var c = {};
			    mergeIntoWithNoDuplicateKeys(c, a);
			    mergeIntoWithNoDuplicateKeys(c, b);
			    return c;
			  };
			}
	
			/**
			 * Creates a function that invokes two functions and ignores their return vales.
			 *
			 * @param {function} one Function to invoke first.
			 * @param {function} two Function to invoke second.
			 * @return {function} Function that invokes the two argument functions.
			 * @private
			 */
			function createChainedFunction(one, two) {
			  return function chainedFunction() {
			    one.apply(this, arguments);
			    two.apply(this, arguments);
			  };
			}
	
			/**
			 * Binds a method to the component.
			 *
			 * @param {object} component Component whose method is going to be bound.
			 * @param {function} method Method to be bound.
			 * @return {function} The bound method.
			 */
			function bindAutoBindMethod(component, method) {
			  var boundMethod = method.bind(component);
			  if (process.env.NODE_ENV !== 'production') {
			    boundMethod.__reactBoundContext = component;
			    boundMethod.__reactBoundMethod = method;
			    boundMethod.__reactBoundArguments = null;
			    var componentName = component.constructor.displayName;
			    var _bind = boundMethod.bind;
			    boundMethod.bind = function (newThis) {
			      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
			        args[_key - 1] = arguments[_key];
			      }
	
			      // User is trying to bind() an autobound method; we effectively will
			      // ignore the value of "this" that the user is trying to use, so
			      // let's warn.
			      if (newThis !== component && newThis !== null) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
			      } else if (!args.length) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
			        return boundMethod;
			      }
			      var reboundMethod = _bind.apply(boundMethod, arguments);
			      reboundMethod.__reactBoundContext = component;
			      reboundMethod.__reactBoundMethod = method;
			      reboundMethod.__reactBoundArguments = args;
			      return reboundMethod;
			    };
			  }
			  return boundMethod;
			}
	
			/**
			 * Binds all auto-bound methods in a component.
			 *
			 * @param {object} component Component whose method is going to be bound.
			 */
			function bindAutoBindMethods(component) {
			  var pairs = component.__reactAutoBindPairs;
			  for (var i = 0; i < pairs.length; i += 2) {
			    var autoBindKey = pairs[i];
			    var method = pairs[i + 1];
			    component[autoBindKey] = bindAutoBindMethod(component, method);
			  }
			}
	
			/**
			 * Add more to the ReactClass base class. These are all legacy features and
			 * therefore not already part of the modern ReactComponent.
			 */
			var ReactClassMixin = {
	
			  /**
			   * TODO: This will be deprecated because state should always keep a consistent
			   * type signature and the only use case for this, is to avoid that.
			   */
			  replaceState: function (newState, callback) {
			    this.updater.enqueueReplaceState(this, newState);
			    if (callback) {
			      this.updater.enqueueCallback(this, callback, 'replaceState');
			    }
			  },
	
			  /**
			   * Checks whether or not this composite component is mounted.
			   * @return {boolean} True if mounted, false otherwise.
			   * @protected
			   * @final
			   */
			  isMounted: function () {
			    return this.updater.isMounted(this);
			  }
			};
	
			var ReactClassComponent = function () {};
			_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
			/**
			 * Module for creating composite components.
			 *
			 * @class ReactClass
			 */
			var ReactClass = {
	
			  /**
			   * Creates a composite component class given a class specification.
			   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
			   *
			   * @param {object} spec Class specification (which must define `render`).
			   * @return {function} Component constructor function.
			   * @public
			   */
			  createClass: function (spec) {
			    // To keep our warnings more understandable, we'll use a little hack here to
			    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
			    // unnecessarily identify a class without displayName as 'Constructor'.
			    var Constructor = identity(function (props, context, updater) {
			      // This constructor gets overridden by mocks. The argument is used
			      // by mocks to assert on what gets mounted.
	
			      if (process.env.NODE_ENV !== 'production') {
			        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
			      }
	
			      // Wire up auto-binding
			      if (this.__reactAutoBindPairs.length) {
			        bindAutoBindMethods(this);
			      }
	
			      this.props = props;
			      this.context = context;
			      this.refs = emptyObject;
			      this.updater = updater || ReactNoopUpdateQueue;
	
			      this.state = null;
	
			      // ReactClasses doesn't have constructors. Instead, they use the
			      // getInitialState and componentWillMount methods for initialization.
	
			      var initialState = this.getInitialState ? this.getInitialState() : null;
			      if (process.env.NODE_ENV !== 'production') {
			        // We allow auto-mocks to proceed as if they're returning null.
			        if (initialState === undefined && this.getInitialState._isMockFunction) {
			          // This is probably bad practice. Consider warning here and
			          // deprecating this convenience.
			          initialState = null;
			        }
			      }
			      !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
			      this.state = initialState;
			    });
			    Constructor.prototype = new ReactClassComponent();
			    Constructor.prototype.constructor = Constructor;
			    Constructor.prototype.__reactAutoBindPairs = [];
	
			    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
			    mixSpecIntoComponent(Constructor, spec);
	
			    // Initialize the defaultProps property after all mixins have been merged.
			    if (Constructor.getDefaultProps) {
			      Constructor.defaultProps = Constructor.getDefaultProps();
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      // This is a tag to indicate that the use of these method names is ok,
			      // since it's used with createClass. If it's not, then it's likely a
			      // mistake so we'll warn you to use the static property, property
			      // initializer or constructor respectively.
			      if (Constructor.getDefaultProps) {
			        Constructor.getDefaultProps.isReactClassApproved = {};
			      }
			      if (Constructor.prototype.getInitialState) {
			        Constructor.prototype.getInitialState.isReactClassApproved = {};
			      }
			    }
	
			    !Constructor.prototype.render ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
			    }
	
			    // Reduce time spent doing lookups by setting these on the prototype.
			    for (var methodName in ReactClassInterface) {
			      if (!Constructor.prototype[methodName]) {
			        Constructor.prototype[methodName] = null;
			      }
			    }
	
			    return Constructor;
			  },
	
			  injection: {
			    injectMixin: function (mixin) {
			      injectedMixins.push(mixin);
			    }
			  }
	
			};
	
			module.exports = ReactClass;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 102 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactPropTypeLocationNames = {};
	
			if (process.env.NODE_ENV !== 'production') {
			  ReactPropTypeLocationNames = {
			    prop: 'prop',
			    context: 'context',
			    childContext: 'child context'
			  };
			}
	
			module.exports = ReactPropTypeLocationNames;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 103 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactElement = __webpack_require__(91);
	
			/**
			 * Create a factory that creates HTML tag elements.
			 *
			 * @private
			 */
			var createDOMFactory = ReactElement.createFactory;
			if (process.env.NODE_ENV !== 'production') {
			  var ReactElementValidator = __webpack_require__(104);
			  createDOMFactory = ReactElementValidator.createFactory;
			}
	
			/**
			 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
			 * This is also accessible via `React.DOM`.
			 *
			 * @public
			 */
			var ReactDOMFactories = {
			  a: createDOMFactory('a'),
			  abbr: createDOMFactory('abbr'),
			  address: createDOMFactory('address'),
			  area: createDOMFactory('area'),
			  article: createDOMFactory('article'),
			  aside: createDOMFactory('aside'),
			  audio: createDOMFactory('audio'),
			  b: createDOMFactory('b'),
			  base: createDOMFactory('base'),
			  bdi: createDOMFactory('bdi'),
			  bdo: createDOMFactory('bdo'),
			  big: createDOMFactory('big'),
			  blockquote: createDOMFactory('blockquote'),
			  body: createDOMFactory('body'),
			  br: createDOMFactory('br'),
			  button: createDOMFactory('button'),
			  canvas: createDOMFactory('canvas'),
			  caption: createDOMFactory('caption'),
			  cite: createDOMFactory('cite'),
			  code: createDOMFactory('code'),
			  col: createDOMFactory('col'),
			  colgroup: createDOMFactory('colgroup'),
			  data: createDOMFactory('data'),
			  datalist: createDOMFactory('datalist'),
			  dd: createDOMFactory('dd'),
			  del: createDOMFactory('del'),
			  details: createDOMFactory('details'),
			  dfn: createDOMFactory('dfn'),
			  dialog: createDOMFactory('dialog'),
			  div: createDOMFactory('div'),
			  dl: createDOMFactory('dl'),
			  dt: createDOMFactory('dt'),
			  em: createDOMFactory('em'),
			  embed: createDOMFactory('embed'),
			  fieldset: createDOMFactory('fieldset'),
			  figcaption: createDOMFactory('figcaption'),
			  figure: createDOMFactory('figure'),
			  footer: createDOMFactory('footer'),
			  form: createDOMFactory('form'),
			  h1: createDOMFactory('h1'),
			  h2: createDOMFactory('h2'),
			  h3: createDOMFactory('h3'),
			  h4: createDOMFactory('h4'),
			  h5: createDOMFactory('h5'),
			  h6: createDOMFactory('h6'),
			  head: createDOMFactory('head'),
			  header: createDOMFactory('header'),
			  hgroup: createDOMFactory('hgroup'),
			  hr: createDOMFactory('hr'),
			  html: createDOMFactory('html'),
			  i: createDOMFactory('i'),
			  iframe: createDOMFactory('iframe'),
			  img: createDOMFactory('img'),
			  input: createDOMFactory('input'),
			  ins: createDOMFactory('ins'),
			  kbd: createDOMFactory('kbd'),
			  keygen: createDOMFactory('keygen'),
			  label: createDOMFactory('label'),
			  legend: createDOMFactory('legend'),
			  li: createDOMFactory('li'),
			  link: createDOMFactory('link'),
			  main: createDOMFactory('main'),
			  map: createDOMFactory('map'),
			  mark: createDOMFactory('mark'),
			  menu: createDOMFactory('menu'),
			  menuitem: createDOMFactory('menuitem'),
			  meta: createDOMFactory('meta'),
			  meter: createDOMFactory('meter'),
			  nav: createDOMFactory('nav'),
			  noscript: createDOMFactory('noscript'),
			  object: createDOMFactory('object'),
			  ol: createDOMFactory('ol'),
			  optgroup: createDOMFactory('optgroup'),
			  option: createDOMFactory('option'),
			  output: createDOMFactory('output'),
			  p: createDOMFactory('p'),
			  param: createDOMFactory('param'),
			  picture: createDOMFactory('picture'),
			  pre: createDOMFactory('pre'),
			  progress: createDOMFactory('progress'),
			  q: createDOMFactory('q'),
			  rp: createDOMFactory('rp'),
			  rt: createDOMFactory('rt'),
			  ruby: createDOMFactory('ruby'),
			  s: createDOMFactory('s'),
			  samp: createDOMFactory('samp'),
			  script: createDOMFactory('script'),
			  section: createDOMFactory('section'),
			  select: createDOMFactory('select'),
			  small: createDOMFactory('small'),
			  source: createDOMFactory('source'),
			  span: createDOMFactory('span'),
			  strong: createDOMFactory('strong'),
			  style: createDOMFactory('style'),
			  sub: createDOMFactory('sub'),
			  summary: createDOMFactory('summary'),
			  sup: createDOMFactory('sup'),
			  table: createDOMFactory('table'),
			  tbody: createDOMFactory('tbody'),
			  td: createDOMFactory('td'),
			  textarea: createDOMFactory('textarea'),
			  tfoot: createDOMFactory('tfoot'),
			  th: createDOMFactory('th'),
			  thead: createDOMFactory('thead'),
			  time: createDOMFactory('time'),
			  title: createDOMFactory('title'),
			  tr: createDOMFactory('tr'),
			  track: createDOMFactory('track'),
			  u: createDOMFactory('u'),
			  ul: createDOMFactory('ul'),
			  'var': createDOMFactory('var'),
			  video: createDOMFactory('video'),
			  wbr: createDOMFactory('wbr'),
	
			  // SVG
			  circle: createDOMFactory('circle'),
			  clipPath: createDOMFactory('clipPath'),
			  defs: createDOMFactory('defs'),
			  ellipse: createDOMFactory('ellipse'),
			  g: createDOMFactory('g'),
			  image: createDOMFactory('image'),
			  line: createDOMFactory('line'),
			  linearGradient: createDOMFactory('linearGradient'),
			  mask: createDOMFactory('mask'),
			  path: createDOMFactory('path'),
			  pattern: createDOMFactory('pattern'),
			  polygon: createDOMFactory('polygon'),
			  polyline: createDOMFactory('polyline'),
			  radialGradient: createDOMFactory('radialGradient'),
			  rect: createDOMFactory('rect'),
			  stop: createDOMFactory('stop'),
			  svg: createDOMFactory('svg'),
			  text: createDOMFactory('text'),
			  tspan: createDOMFactory('tspan')
			};
	
			module.exports = ReactDOMFactories;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 104 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			/**
			 * ReactElementValidator provides a wrapper around a element factory
			 * which validates the props passed to the element. This is intended to be
			 * used only in DEV and could be replaced by a static type checker for languages
			 * that support it.
			 */
	
			'use strict';
	
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactComponentTreeHook = __webpack_require__(41);
			var ReactElement = __webpack_require__(91);
	
			var checkReactTypeSpec = __webpack_require__(105);
	
			var canDefineProperty = __webpack_require__(92);
			var getIteratorFn = __webpack_require__(95);
			var warning = __webpack_require__(18);
	
			function getDeclarationErrorAddendum() {
			  if (ReactCurrentOwner.current) {
			    var name = ReactCurrentOwner.current.getName();
			    if (name) {
			      return ' Check the render method of `' + name + '`.';
			    }
			  }
			  return '';
			}
	
			/**
			 * Warn if there's no key explicitly set on dynamic arrays of children or
			 * object keys are not valid. This allows us to keep track of children between
			 * updates.
			 */
			var ownerHasKeyUseWarning = {};
	
			function getCurrentComponentErrorInfo(parentType) {
			  var info = getDeclarationErrorAddendum();
	
			  if (!info) {
			    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
			    if (parentName) {
			      info = ' Check the top-level render call using <' + parentName + '>.';
			    }
			  }
			  return info;
			}
	
			/**
			 * Warn if the element doesn't have an explicit key assigned to it.
			 * This element is in an array. The array could grow and shrink or be
			 * reordered. All children that haven't already been validated are required to
			 * have a "key" property assigned to it. Error statuses are cached so a warning
			 * will only be shown once.
			 *
			 * @internal
			 * @param {ReactElement} element Element that requires a key.
			 * @param {*} parentType element's parent's type.
			 */
			function validateExplicitKey(element, parentType) {
			  if (!element._store || element._store.validated || element.key != null) {
			    return;
			  }
			  element._store.validated = true;
	
			  var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});
	
			  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
			  if (memoizer[currentComponentErrorInfo]) {
			    return;
			  }
			  memoizer[currentComponentErrorInfo] = true;
	
			  // Usually the current owner is the offender, but if it accepts children as a
			  // property, it may be the creator of the child that's responsible for
			  // assigning it a key.
			  var childOwner = '';
			  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
			    // Give the component that originally created this child.
			    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
			  }
	
			  process.env.NODE_ENV !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
			}
	
			/**
			 * Ensure that every element either is passed in a static location, in an
			 * array with an explicit keys property defined, or in an object literal
			 * with valid key property.
			 *
			 * @internal
			 * @param {ReactNode} node Statically passed child of any type.
			 * @param {*} parentType node's parent's type.
			 */
			function validateChildKeys(node, parentType) {
			  if (typeof node !== 'object') {
			    return;
			  }
			  if (Array.isArray(node)) {
			    for (var i = 0; i < node.length; i++) {
			      var child = node[i];
			      if (ReactElement.isValidElement(child)) {
			        validateExplicitKey(child, parentType);
			      }
			    }
			  } else if (ReactElement.isValidElement(node)) {
			    // This element was passed in a valid location.
			    if (node._store) {
			      node._store.validated = true;
			    }
			  } else if (node) {
			    var iteratorFn = getIteratorFn(node);
			    // Entry iterators provide implicit keys.
			    if (iteratorFn) {
			      if (iteratorFn !== node.entries) {
			        var iterator = iteratorFn.call(node);
			        var step;
			        while (!(step = iterator.next()).done) {
			          if (ReactElement.isValidElement(step.value)) {
			            validateExplicitKey(step.value, parentType);
			          }
			        }
			      }
			    }
			  }
			}
	
			/**
			 * Given an element, validate that its props follow the propTypes definition,
			 * provided by the type.
			 *
			 * @param {ReactElement} element
			 */
			function validatePropTypes(element) {
			  var componentClass = element.type;
			  if (typeof componentClass !== 'function') {
			    return;
			  }
			  var name = componentClass.displayName || componentClass.name;
			  if (componentClass.propTypes) {
			    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
			  }
			  if (typeof componentClass.getDefaultProps === 'function') {
			    process.env.NODE_ENV !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
			  }
			}
	
			var ReactElementValidator = {
	
			  createElement: function (type, props, children) {
			    var validType = typeof type === 'string' || typeof type === 'function';
			    // We warn in this case but don't throw. We expect the element creation to
			    // succeed and there will likely be errors in render.
			    if (!validType) {
			      if (typeof type !== 'function' && typeof type !== 'string') {
			        var info = '';
			        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
			          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
			        }
			        info += getDeclarationErrorAddendum();
			        process.env.NODE_ENV !== 'production' ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
			      }
			    }
	
			    var element = ReactElement.createElement.apply(this, arguments);
	
			    // The result can be nullish if a mock or a custom function is used.
			    // TODO: Drop this when these are no longer allowed as the type argument.
			    if (element == null) {
			      return element;
			    }
	
			    // Skip key warning if the type isn't valid since our key validation logic
			    // doesn't expect a non-string/function type and can throw confusing errors.
			    // We don't want exception behavior to differ between dev and prod.
			    // (Rendering will throw with a helpful message and as soon as the type is
			    // fixed, the key warnings will appear.)
			    if (validType) {
			      for (var i = 2; i < arguments.length; i++) {
			        validateChildKeys(arguments[i], type);
			      }
			    }
	
			    validatePropTypes(element);
	
			    return element;
			  },
	
			  createFactory: function (type) {
			    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
			    // Legacy hook TODO: Warn if this is accessed
			    validatedFactory.type = type;
	
			    if (process.env.NODE_ENV !== 'production') {
			      if (canDefineProperty) {
			        Object.defineProperty(validatedFactory, 'type', {
			          enumerable: false,
			          get: function () {
			            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : void 0;
			            Object.defineProperty(this, 'type', {
			              value: type
			            });
			            return type;
			          }
			        });
			      }
			    }
	
			    return validatedFactory;
			  },
	
			  cloneElement: function (element, props, children) {
			    var newElement = ReactElement.cloneElement.apply(this, arguments);
			    for (var i = 2; i < arguments.length; i++) {
			      validateChildKeys(arguments[i], newElement.type);
			    }
			    validatePropTypes(newElement);
			    return newElement;
			  }
	
			};
	
			module.exports = ReactElementValidator;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 105 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactPropTypeLocationNames = __webpack_require__(102);
			var ReactPropTypesSecret = __webpack_require__(106);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var ReactComponentTreeHook;
	
			if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
			  // Temporary hack.
			  // Inline requires don't work well with Jest:
			  // https://github.com/facebook/react/issues/7240
			  // Remove the inline requires when we don't need them anymore:
			  // https://github.com/facebook/react/pull/7178
			  ReactComponentTreeHook = __webpack_require__(41);
			}
	
			var loggedTypeFailures = {};
	
			/**
			 * Assert that the values match with the type specs.
			 * Error messages are memorized and will only be shown once.
			 *
			 * @param {object} typeSpecs Map of name to a ReactPropType
			 * @param {object} values Runtime values that need to be type-checked
			 * @param {string} location e.g. "prop", "context", "child context"
			 * @param {string} componentName Name of the component for error messages.
			 * @param {?object} element The React element that is being type-checked
			 * @param {?number} debugID The React component instance that is being type-checked
			 * @private
			 */
			function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
			  for (var typeSpecName in typeSpecs) {
			    if (typeSpecs.hasOwnProperty(typeSpecName)) {
			      var error;
			      // Prop type validation may throw. In case they do, we don't want to
			      // fail the render phase where it didn't fail before. So we log it.
			      // After these have been cleaned up, we'll let them throw.
			      try {
			        // This is intentionally an invariant that gets caught. It's the same
			        // behavior as without this statement except with a better message.
			        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
			        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
			      } catch (ex) {
			        error = ex;
			      }
			      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
			      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
			        // Only monitor this failure once because there tends to be a lot of the
			        // same error.
			        loggedTypeFailures[error.message] = true;
	
			        var componentStackInfo = '';
	
			        if (process.env.NODE_ENV !== 'production') {
			          if (!ReactComponentTreeHook) {
			            ReactComponentTreeHook = __webpack_require__(41);
			          }
			          if (debugID !== null) {
			            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
			          } else if (element !== null) {
			            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
			          }
			        }
	
			        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
			      }
			    }
			  }
			}
	
			module.exports = checkReactTypeSpec;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 106 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
			module.exports = ReactPropTypesSecret;
	
		/***/ },
		/* 107 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactElement = __webpack_require__(91);
			var ReactPropTypeLocationNames = __webpack_require__(102);
			var ReactPropTypesSecret = __webpack_require__(106);
	
			var emptyFunction = __webpack_require__(19);
			var getIteratorFn = __webpack_require__(95);
			var warning = __webpack_require__(18);
	
			/**
			 * Collection of methods that allow declaration and validation of props that are
			 * supplied to React components. Example usage:
			 *
			 *   var Props = require('ReactPropTypes');
			 *   var MyArticle = React.createClass({
			 *     propTypes: {
			 *       // An optional string prop named "description".
			 *       description: Props.string,
			 *
			 *       // A required enum prop named "category".
			 *       category: Props.oneOf(['News','Photos']).isRequired,
			 *
			 *       // A prop named "dialog" that requires an instance of Dialog.
			 *       dialog: Props.instanceOf(Dialog).isRequired
			 *     },
			 *     render: function() { ... }
			 *   });
			 *
			 * A more formal specification of how these methods are used:
			 *
			 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
			 *   decl := ReactPropTypes.{type}(.isRequired)?
			 *
			 * Each and every declaration produces a function with the same signature. This
			 * allows the creation of custom validation functions. For example:
			 *
			 *  var MyLink = React.createClass({
			 *    propTypes: {
			 *      // An optional string or URI prop named "href".
			 *      href: function(props, propName, componentName) {
			 *        var propValue = props[propName];
			 *        if (propValue != null && typeof propValue !== 'string' &&
			 *            !(propValue instanceof URI)) {
			 *          return new Error(
			 *            'Expected a string or an URI for ' + propName + ' in ' +
			 *            componentName
			 *          );
			 *        }
			 *      }
			 *    },
			 *    render: function() {...}
			 *  });
			 *
			 * @internal
			 */
	
			var ANONYMOUS = '<<anonymous>>';
	
			var ReactPropTypes = {
			  array: createPrimitiveTypeChecker('array'),
			  bool: createPrimitiveTypeChecker('boolean'),
			  func: createPrimitiveTypeChecker('function'),
			  number: createPrimitiveTypeChecker('number'),
			  object: createPrimitiveTypeChecker('object'),
			  string: createPrimitiveTypeChecker('string'),
			  symbol: createPrimitiveTypeChecker('symbol'),
	
			  any: createAnyTypeChecker(),
			  arrayOf: createArrayOfTypeChecker,
			  element: createElementTypeChecker(),
			  instanceOf: createInstanceTypeChecker,
			  node: createNodeChecker(),
			  objectOf: createObjectOfTypeChecker,
			  oneOf: createEnumTypeChecker,
			  oneOfType: createUnionTypeChecker,
			  shape: createShapeTypeChecker
			};
	
			/**
			 * inlined Object.is polyfill to avoid requiring consumers ship their own
			 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
			 */
			/*eslint-disable no-self-compare*/
			function is(x, y) {
			  // SameValue algorithm
			  if (x === y) {
			    // Steps 1-5, 7-10
			    // Steps 6.b-6.e: +0 != -0
			    return x !== 0 || 1 / x === 1 / y;
			  } else {
			    // Step 6.a: NaN == NaN
			    return x !== x && y !== y;
			  }
			}
			/*eslint-enable no-self-compare*/
	
			/**
			 * We use an Error-like object for backward compatibility as people may call
			 * PropTypes directly and inspect their output. However we don't use real
			 * Errors anymore. We don't inspect their stack anyway, and creating them
			 * is prohibitively expensive if they are created too often, such as what
			 * happens in oneOfType() for any type before the one that matched.
			 */
			function PropTypeError(message) {
			  this.message = message;
			  this.stack = '';
			}
			// Make `instanceof Error` still work for returned errors.
			PropTypeError.prototype = Error.prototype;
	
			function createChainableTypeChecker(validate) {
			  if (process.env.NODE_ENV !== 'production') {
			    var manualPropTypeCallCache = {};
			  }
			  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
			    componentName = componentName || ANONYMOUS;
			    propFullName = propFullName || propName;
			    if (process.env.NODE_ENV !== 'production') {
			      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
			        var cacheKey = componentName + ':' + propName;
			        if (!manualPropTypeCallCache[cacheKey]) {
			          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
			          manualPropTypeCallCache[cacheKey] = true;
			        }
			      }
			    }
			    if (props[propName] == null) {
			      var locationName = ReactPropTypeLocationNames[location];
			      if (isRequired) {
			        if (props[propName] === null) {
			          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
			        }
			        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
			      }
			      return null;
			    } else {
			      return validate(props, propName, componentName, location, propFullName);
			    }
			  }
	
			  var chainedCheckType = checkType.bind(null, false);
			  chainedCheckType.isRequired = checkType.bind(null, true);
	
			  return chainedCheckType;
			}
	
			function createPrimitiveTypeChecker(expectedType) {
			  function validate(props, propName, componentName, location, propFullName, secret) {
			    var propValue = props[propName];
			    var propType = getPropType(propValue);
			    if (propType !== expectedType) {
			      var locationName = ReactPropTypeLocationNames[location];
			      // `propValue` being instance of, say, date/regexp, pass the 'object'
			      // check, but we can offer a more precise error message here rather than
			      // 'of type `object`'.
			      var preciseType = getPreciseType(propValue);
	
			      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
			    }
			    return null;
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function createAnyTypeChecker() {
			  return createChainableTypeChecker(emptyFunction.thatReturns(null));
			}
	
			function createArrayOfTypeChecker(typeChecker) {
			  function validate(props, propName, componentName, location, propFullName) {
			    if (typeof typeChecker !== 'function') {
			      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
			    }
			    var propValue = props[propName];
			    if (!Array.isArray(propValue)) {
			      var locationName = ReactPropTypeLocationNames[location];
			      var propType = getPropType(propValue);
			      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
			    }
			    for (var i = 0; i < propValue.length; i++) {
			      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
			      if (error instanceof Error) {
			        return error;
			      }
			    }
			    return null;
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function createElementTypeChecker() {
			  function validate(props, propName, componentName, location, propFullName) {
			    var propValue = props[propName];
			    if (!ReactElement.isValidElement(propValue)) {
			      var locationName = ReactPropTypeLocationNames[location];
			      var propType = getPropType(propValue);
			      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
			    }
			    return null;
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function createInstanceTypeChecker(expectedClass) {
			  function validate(props, propName, componentName, location, propFullName) {
			    if (!(props[propName] instanceof expectedClass)) {
			      var locationName = ReactPropTypeLocationNames[location];
			      var expectedClassName = expectedClass.name || ANONYMOUS;
			      var actualClassName = getClassName(props[propName]);
			      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
			    }
			    return null;
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function createEnumTypeChecker(expectedValues) {
			  if (!Array.isArray(expectedValues)) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
			    return emptyFunction.thatReturnsNull;
			  }
	
			  function validate(props, propName, componentName, location, propFullName) {
			    var propValue = props[propName];
			    for (var i = 0; i < expectedValues.length; i++) {
			      if (is(propValue, expectedValues[i])) {
			        return null;
			      }
			    }
	
			    var locationName = ReactPropTypeLocationNames[location];
			    var valuesString = JSON.stringify(expectedValues);
			    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function createObjectOfTypeChecker(typeChecker) {
			  function validate(props, propName, componentName, location, propFullName) {
			    if (typeof typeChecker !== 'function') {
			      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
			    }
			    var propValue = props[propName];
			    var propType = getPropType(propValue);
			    if (propType !== 'object') {
			      var locationName = ReactPropTypeLocationNames[location];
			      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
			    }
			    for (var key in propValue) {
			      if (propValue.hasOwnProperty(key)) {
			        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
			        if (error instanceof Error) {
			          return error;
			        }
			      }
			    }
			    return null;
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function createUnionTypeChecker(arrayOfTypeCheckers) {
			  if (!Array.isArray(arrayOfTypeCheckers)) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
			    return emptyFunction.thatReturnsNull;
			  }
	
			  function validate(props, propName, componentName, location, propFullName) {
			    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
			      var checker = arrayOfTypeCheckers[i];
			      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
			        return null;
			      }
			    }
	
			    var locationName = ReactPropTypeLocationNames[location];
			    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function createNodeChecker() {
			  function validate(props, propName, componentName, location, propFullName) {
			    if (!isNode(props[propName])) {
			      var locationName = ReactPropTypeLocationNames[location];
			      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
			    }
			    return null;
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function createShapeTypeChecker(shapeTypes) {
			  function validate(props, propName, componentName, location, propFullName) {
			    var propValue = props[propName];
			    var propType = getPropType(propValue);
			    if (propType !== 'object') {
			      var locationName = ReactPropTypeLocationNames[location];
			      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
			    }
			    for (var key in shapeTypes) {
			      var checker = shapeTypes[key];
			      if (!checker) {
			        continue;
			      }
			      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
			      if (error) {
			        return error;
			      }
			    }
			    return null;
			  }
			  return createChainableTypeChecker(validate);
			}
	
			function isNode(propValue) {
			  switch (typeof propValue) {
			    case 'number':
			    case 'string':
			    case 'undefined':
			      return true;
			    case 'boolean':
			      return !propValue;
			    case 'object':
			      if (Array.isArray(propValue)) {
			        return propValue.every(isNode);
			      }
			      if (propValue === null || ReactElement.isValidElement(propValue)) {
			        return true;
			      }
	
			      var iteratorFn = getIteratorFn(propValue);
			      if (iteratorFn) {
			        var iterator = iteratorFn.call(propValue);
			        var step;
			        if (iteratorFn !== propValue.entries) {
			          while (!(step = iterator.next()).done) {
			            if (!isNode(step.value)) {
			              return false;
			            }
			          }
			        } else {
			          // Iterator will provide entry [k,v] tuples rather than values.
			          while (!(step = iterator.next()).done) {
			            var entry = step.value;
			            if (entry) {
			              if (!isNode(entry[1])) {
			                return false;
			              }
			            }
			          }
			        }
			      } else {
			        return false;
			      }
	
			      return true;
			    default:
			      return false;
			  }
			}
	
			function isSymbol(propType, propValue) {
			  // Native Symbol.
			  if (propType === 'symbol') {
			    return true;
			  }
	
			  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
			  if (propValue['@@toStringTag'] === 'Symbol') {
			    return true;
			  }
	
			  // Fallback for non-spec compliant Symbols which are polyfilled.
			  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
			    return true;
			  }
	
			  return false;
			}
	
			// Equivalent of `typeof` but with special handling for array and regexp.
			function getPropType(propValue) {
			  var propType = typeof propValue;
			  if (Array.isArray(propValue)) {
			    return 'array';
			  }
			  if (propValue instanceof RegExp) {
			    // Old webkits (at least until Android 4.0) return 'function' rather than
			    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
			    // passes PropTypes.object.
			    return 'object';
			  }
			  if (isSymbol(propType, propValue)) {
			    return 'symbol';
			  }
			  return propType;
			}
	
			// This handles more types than `getPropType`. Only used for error messages.
			// See `createPrimitiveTypeChecker`.
			function getPreciseType(propValue) {
			  var propType = getPropType(propValue);
			  if (propType === 'object') {
			    if (propValue instanceof Date) {
			      return 'date';
			    } else if (propValue instanceof RegExp) {
			      return 'regexp';
			    }
			  }
			  return propType;
			}
	
			// Returns class name of the object, if any.
			function getClassName(propValue) {
			  if (!propValue.constructor || !propValue.constructor.name) {
			    return ANONYMOUS;
			  }
			  return propValue.constructor.name;
			}
	
			module.exports = ReactPropTypes;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 108 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			module.exports = '15.4.2';
	
		/***/ },
		/* 109 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
			'use strict';
	
			var _prodInvariant = __webpack_require__(42);
	
			var ReactElement = __webpack_require__(91);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Returns the first child in a collection of children and verifies that there
			 * is only one child in the collection.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
			 *
			 * The current implementation of this function assumes that a single child gets
			 * passed without a wrapper, but the purpose of this helper function is to
			 * abstract away the particular structure of children.
			 *
			 * @param {?object} children Child collection structure.
			 * @return {ReactElement} The first and only `ReactElement` contained in the
			 * structure.
			 */
			function onlyChild(children) {
			  !ReactElement.isValidElement(children) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
			  return children;
			}
	
			module.exports = onlyChild;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 110 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
			module.exports = ReactPropTypesSecret;
	
		/***/ },
		/* 111 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var React = __webpack_require__(88);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDOMSelect = __webpack_require__(112);
	
			var warning = __webpack_require__(18);
			var didWarnInvalidOptionChildren = false;
	
			function flattenChildren(children) {
			  var content = '';
	
			  // Flatten children and warn if they aren't strings or numbers;
			  // invalid types are ignored.
			  React.Children.forEach(children, function (child) {
			    if (child == null) {
			      return;
			    }
			    if (typeof child === 'string' || typeof child === 'number') {
			      content += child;
			    } else if (!didWarnInvalidOptionChildren) {
			      didWarnInvalidOptionChildren = true;
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
			    }
			  });
	
			  return content;
			}
	
			/**
			 * Implements an <option> host component that warns when `selected` is set.
			 */
			var ReactDOMOption = {
			  mountWrapper: function (inst, props, hostParent) {
			    // TODO (yungsters): Remove support for `selected` in <option>.
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
			    }
	
			    // Look up whether this option is 'selected'
			    var selectValue = null;
			    if (hostParent != null) {
			      var selectParent = hostParent;
	
			      if (selectParent._tag === 'optgroup') {
			        selectParent = selectParent._hostParent;
			      }
	
			      if (selectParent != null && selectParent._tag === 'select') {
			        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
			      }
			    }
	
			    // If the value is null (e.g., no specified value or after initial mount)
			    // or missing (e.g., for <datalist>), we don't change props.selected
			    var selected = null;
			    if (selectValue != null) {
			      var value;
			      if (props.value != null) {
			        value = props.value + '';
			      } else {
			        value = flattenChildren(props.children);
			      }
			      selected = false;
			      if (Array.isArray(selectValue)) {
			        // multiple
			        for (var i = 0; i < selectValue.length; i++) {
			          if ('' + selectValue[i] === value) {
			            selected = true;
			            break;
			          }
			        }
			      } else {
			        selected = '' + selectValue === value;
			      }
			    }
	
			    inst._wrapperState = { selected: selected };
			  },
	
			  postMountWrapper: function (inst) {
			    // value="" should make a value attribute (#6219)
			    var props = inst._currentElement.props;
			    if (props.value != null) {
			      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			      node.setAttribute('value', props.value);
			    }
			  },
	
			  getHostProps: function (inst, props) {
			    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
			    // Read state only from initial mount because <select> updates value
			    // manually; we need the initial state only for server rendering
			    if (inst._wrapperState.selected != null) {
			      hostProps.selected = inst._wrapperState.selected;
			    }
	
			    var content = flattenChildren(props.children);
	
			    if (content) {
			      hostProps.children = content;
			    }
	
			    return hostProps;
			  }
	
			};
	
			module.exports = ReactDOMOption;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 112 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var LinkedValueUtils = __webpack_require__(87);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
	
			var warning = __webpack_require__(18);
	
			var didWarnValueLink = false;
			var didWarnValueDefaultValue = false;
	
			function updateOptionsIfPendingUpdateAndMounted() {
			  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
			    this._wrapperState.pendingUpdate = false;
	
			    var props = this._currentElement.props;
			    var value = LinkedValueUtils.getValue(props);
	
			    if (value != null) {
			      updateOptions(this, Boolean(props.multiple), value);
			    }
			  }
			}
	
			function getDeclarationErrorAddendum(owner) {
			  if (owner) {
			    var name = owner.getName();
			    if (name) {
			      return ' Check the render method of `' + name + '`.';
			    }
			  }
			  return '';
			}
	
			var valuePropNames = ['value', 'defaultValue'];
	
			/**
			 * Validation function for `value` and `defaultValue`.
			 * @private
			 */
			function checkSelectPropTypes(inst, props) {
			  var owner = inst._currentElement._owner;
			  LinkedValueUtils.checkPropTypes('select', props, owner);
	
			  if (props.valueLink !== undefined && !didWarnValueLink) {
			    process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
			    didWarnValueLink = true;
			  }
	
			  for (var i = 0; i < valuePropNames.length; i++) {
			    var propName = valuePropNames[i];
			    if (props[propName] == null) {
			      continue;
			    }
			    var isArray = Array.isArray(props[propName]);
			    if (props.multiple && !isArray) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
			    } else if (!props.multiple && isArray) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
			    }
			  }
			}
	
			/**
			 * @param {ReactDOMComponent} inst
			 * @param {boolean} multiple
			 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
			 * @private
			 */
			function updateOptions(inst, multiple, propValue) {
			  var selectedValue, i;
			  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
			  if (multiple) {
			    selectedValue = {};
			    for (i = 0; i < propValue.length; i++) {
			      selectedValue['' + propValue[i]] = true;
			    }
			    for (i = 0; i < options.length; i++) {
			      var selected = selectedValue.hasOwnProperty(options[i].value);
			      if (options[i].selected !== selected) {
			        options[i].selected = selected;
			      }
			    }
			  } else {
			    // Do not set `select.value` as exact behavior isn't consistent across all
			    // browsers for all cases.
			    selectedValue = '' + propValue;
			    for (i = 0; i < options.length; i++) {
			      if (options[i].value === selectedValue) {
			        options[i].selected = true;
			        return;
			      }
			    }
			    if (options.length) {
			      options[0].selected = true;
			    }
			  }
			}
	
			/**
			 * Implements a <select> host component that allows optionally setting the
			 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
			 * stringable. If `multiple` is true, the prop must be an array of stringables.
			 *
			 * If `value` is not supplied (or null/undefined), user actions that change the
			 * selected option will trigger updates to the rendered options.
			 *
			 * If it is supplied (and not null/undefined), the rendered options will not
			 * update in response to user actions. Instead, the `value` prop must change in
			 * order for the rendered options to update.
			 *
			 * If `defaultValue` is provided, any options with the supplied values will be
			 * selected.
			 */
			var ReactDOMSelect = {
			  getHostProps: function (inst, props) {
			    return _assign({}, props, {
			      onChange: inst._wrapperState.onChange,
			      value: undefined
			    });
			  },
	
			  mountWrapper: function (inst, props) {
			    if (process.env.NODE_ENV !== 'production') {
			      checkSelectPropTypes(inst, props);
			    }
	
			    var value = LinkedValueUtils.getValue(props);
			    inst._wrapperState = {
			      pendingUpdate: false,
			      initialValue: value != null ? value : props.defaultValue,
			      listeners: null,
			      onChange: _handleChange.bind(inst),
			      wasMultiple: Boolean(props.multiple)
			    };
	
			    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
			      didWarnValueDefaultValue = true;
			    }
			  },
	
			  getSelectValueContext: function (inst) {
			    // ReactDOMOption looks at this initial value so the initial generated
			    // markup has correct `selected` attributes
			    return inst._wrapperState.initialValue;
			  },
	
			  postUpdateWrapper: function (inst) {
			    var props = inst._currentElement.props;
	
			    // After the initial mount, we control selected-ness manually so don't pass
			    // this value down
			    inst._wrapperState.initialValue = undefined;
	
			    var wasMultiple = inst._wrapperState.wasMultiple;
			    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
			    var value = LinkedValueUtils.getValue(props);
			    if (value != null) {
			      inst._wrapperState.pendingUpdate = false;
			      updateOptions(inst, Boolean(props.multiple), value);
			    } else if (wasMultiple !== Boolean(props.multiple)) {
			      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
			      if (props.defaultValue != null) {
			        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
			      } else {
			        // Revert the select back to its default unselected state.
			        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
			      }
			    }
			  }
			};
	
			function _handleChange(event) {
			  var props = this._currentElement.props;
			  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
			  if (this._rootNodeID) {
			    this._wrapperState.pendingUpdate = true;
			  }
			  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
			  return returnValue;
			}
	
			module.exports = ReactDOMSelect;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 113 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var LinkedValueUtils = __webpack_require__(87);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var didWarnValueLink = false;
			var didWarnValDefaultVal = false;
	
			function forceUpdateIfMounted() {
			  if (this._rootNodeID) {
			    // DOM component is still mounted; update
			    ReactDOMTextarea.updateWrapper(this);
			  }
			}
	
			/**
			 * Implements a <textarea> host component that allows setting `value`, and
			 * `defaultValue`. This differs from the traditional DOM API because value is
			 * usually set as PCDATA children.
			 *
			 * If `value` is not supplied (or null/undefined), user actions that affect the
			 * value will trigger updates to the element.
			 *
			 * If `value` is supplied (and not null/undefined), the rendered element will
			 * not trigger updates to the element. Instead, the `value` prop must change in
			 * order for the rendered element to be updated.
			 *
			 * The rendered element will be initialized with an empty value, the prop
			 * `defaultValue` if specified, or the children content (deprecated).
			 */
			var ReactDOMTextarea = {
			  getHostProps: function (inst, props) {
			    !(props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
			    // Always set children to the same thing. In IE9, the selection range will
			    // get reset if `textContent` is mutated.  We could add a check in setTextContent
			    // to only set the value if/when the value differs from the node value (which would
			    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
			    // The value can be a boolean or object so that's why it's forced to be a string.
			    var hostProps = _assign({}, props, {
			      value: undefined,
			      defaultValue: undefined,
			      children: '' + inst._wrapperState.initialValue,
			      onChange: inst._wrapperState.onChange
			    });
	
			    return hostProps;
			  },
	
			  mountWrapper: function (inst, props) {
			    if (process.env.NODE_ENV !== 'production') {
			      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
			      if (props.valueLink !== undefined && !didWarnValueLink) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
			        didWarnValueLink = true;
			      }
			      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
			        didWarnValDefaultVal = true;
			      }
			    }
	
			    var value = LinkedValueUtils.getValue(props);
			    var initialValue = value;
	
			    // Only bother fetching default value if we're going to use it
			    if (value == null) {
			      var defaultValue = props.defaultValue;
			      // TODO (yungsters): Remove support for children content in <textarea>.
			      var children = props.children;
			      if (children != null) {
			        if (process.env.NODE_ENV !== 'production') {
			          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
			        }
			        !(defaultValue == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
			        if (Array.isArray(children)) {
			          !(children.length <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
			          children = children[0];
			        }
	
			        defaultValue = '' + children;
			      }
			      if (defaultValue == null) {
			        defaultValue = '';
			      }
			      initialValue = defaultValue;
			    }
	
			    inst._wrapperState = {
			      initialValue: '' + initialValue,
			      listeners: null,
			      onChange: _handleChange.bind(inst)
			    };
			  },
	
			  updateWrapper: function (inst) {
			    var props = inst._currentElement.props;
	
			    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			    var value = LinkedValueUtils.getValue(props);
			    if (value != null) {
			      // Cast `value` to a string to ensure the value is set correctly. While
			      // browsers typically do this as necessary, jsdom doesn't.
			      var newValue = '' + value;
	
			      // To avoid side effects (such as losing text selection), only set value if changed
			      if (newValue !== node.value) {
			        node.value = newValue;
			      }
			      if (props.defaultValue == null) {
			        node.defaultValue = newValue;
			      }
			    }
			    if (props.defaultValue != null) {
			      node.defaultValue = props.defaultValue;
			    }
			  },
	
			  postMountWrapper: function (inst) {
			    // This is in postMount because we need access to the DOM node, which is not
			    // available until after the component has mounted.
			    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			    var textContent = node.textContent;
	
			    // Only set node.value if textContent is equal to the expected
			    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
			    // will populate textContent as well.
			    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
			    if (textContent === inst._wrapperState.initialValue) {
			      node.value = textContent;
			    }
			  }
			};
	
			function _handleChange(event) {
			  var props = this._currentElement.props;
			  var returnValue = LinkedValueUtils.executeOnChange(props, event);
			  ReactUpdates.asap(forceUpdateIfMounted, this);
			  return returnValue;
			}
	
			module.exports = ReactDOMTextarea;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 114 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactComponentEnvironment = __webpack_require__(115);
			var ReactInstanceMap = __webpack_require__(116);
			var ReactInstrumentation = __webpack_require__(37);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactReconciler = __webpack_require__(34);
			var ReactChildReconciler = __webpack_require__(117);
	
			var emptyFunction = __webpack_require__(19);
			var flattenChildren = __webpack_require__(132);
			var invariant = __webpack_require__(8);
	
			/**
			 * Make an update for markup to be rendered and inserted at a supplied index.
			 *
			 * @param {string} markup Markup that renders into an element.
			 * @param {number} toIndex Destination index.
			 * @private
			 */
			function makeInsertMarkup(markup, afterNode, toIndex) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'INSERT_MARKUP',
			    content: markup,
			    fromIndex: null,
			    fromNode: null,
			    toIndex: toIndex,
			    afterNode: afterNode
			  };
			}
	
			/**
			 * Make an update for moving an existing element to another index.
			 *
			 * @param {number} fromIndex Source index of the existing element.
			 * @param {number} toIndex Destination index of the element.
			 * @private
			 */
			function makeMove(child, afterNode, toIndex) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'MOVE_EXISTING',
			    content: null,
			    fromIndex: child._mountIndex,
			    fromNode: ReactReconciler.getHostNode(child),
			    toIndex: toIndex,
			    afterNode: afterNode
			  };
			}
	
			/**
			 * Make an update for removing an element at an index.
			 *
			 * @param {number} fromIndex Index of the element to remove.
			 * @private
			 */
			function makeRemove(child, node) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'REMOVE_NODE',
			    content: null,
			    fromIndex: child._mountIndex,
			    fromNode: node,
			    toIndex: null,
			    afterNode: null
			  };
			}
	
			/**
			 * Make an update for setting the markup of a node.
			 *
			 * @param {string} markup Markup that renders into an element.
			 * @private
			 */
			function makeSetMarkup(markup) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'SET_MARKUP',
			    content: markup,
			    fromIndex: null,
			    fromNode: null,
			    toIndex: null,
			    afterNode: null
			  };
			}
	
			/**
			 * Make an update for setting the text content.
			 *
			 * @param {string} textContent Text content to set.
			 * @private
			 */
			function makeTextContent(textContent) {
			  // NOTE: Null values reduce hidden classes.
			  return {
			    type: 'TEXT_CONTENT',
			    content: textContent,
			    fromIndex: null,
			    fromNode: null,
			    toIndex: null,
			    afterNode: null
			  };
			}
	
			/**
			 * Push an update, if any, onto the queue. Creates a new queue if none is
			 * passed and always returns the queue. Mutative.
			 */
			function enqueue(queue, update) {
			  if (update) {
			    queue = queue || [];
			    queue.push(update);
			  }
			  return queue;
			}
	
			/**
			 * Processes any enqueued updates.
			 *
			 * @private
			 */
			function processQueue(inst, updateQueue) {
			  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
			}
	
			var setChildrenForInstrumentation = emptyFunction;
			if (process.env.NODE_ENV !== 'production') {
			  var getDebugID = function (inst) {
			    if (!inst._debugID) {
			      // Check for ART-like instances. TODO: This is silly/gross.
			      var internal;
			      if (internal = ReactInstanceMap.get(inst)) {
			        inst = internal;
			      }
			    }
			    return inst._debugID;
			  };
			  setChildrenForInstrumentation = function (children) {
			    var debugID = getDebugID(this);
			    // TODO: React Native empty components are also multichild.
			    // This means they still get into this method but don't have _debugID.
			    if (debugID !== 0) {
			      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
			        return children[key]._debugID;
			      }) : []);
			    }
			  };
			}
	
			/**
			 * ReactMultiChild are capable of reconciling multiple children.
			 *
			 * @class ReactMultiChild
			 * @internal
			 */
			var ReactMultiChild = {
	
			  /**
			   * Provides common functionality for components that must reconcile multiple
			   * children. This is used by `ReactDOMComponent` to mount, update, and
			   * unmount child components.
			   *
			   * @lends {ReactMultiChild.prototype}
			   */
			  Mixin: {
	
			    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
			      if (process.env.NODE_ENV !== 'production') {
			        var selfDebugID = getDebugID(this);
			        if (this._currentElement) {
			          try {
			            ReactCurrentOwner.current = this._currentElement._owner;
			            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
			          } finally {
			            ReactCurrentOwner.current = null;
			          }
			        }
			      }
			      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
			    },
	
			    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
			      var nextChildren;
			      var selfDebugID = 0;
			      if (process.env.NODE_ENV !== 'production') {
			        selfDebugID = getDebugID(this);
			        if (this._currentElement) {
			          try {
			            ReactCurrentOwner.current = this._currentElement._owner;
			            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
			          } finally {
			            ReactCurrentOwner.current = null;
			          }
			          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
			          return nextChildren;
			        }
			      }
			      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
			      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
			      return nextChildren;
			    },
	
			    /**
			     * Generates a "mount image" for each of the supplied children. In the case
			     * of `ReactDOMComponent`, a mount image is a string of markup.
			     *
			     * @param {?object} nestedChildren Nested child maps.
			     * @return {array} An array of mounted representations.
			     * @internal
			     */
			    mountChildren: function (nestedChildren, transaction, context) {
			      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
			      this._renderedChildren = children;
	
			      var mountImages = [];
			      var index = 0;
			      for (var name in children) {
			        if (children.hasOwnProperty(name)) {
			          var child = children[name];
			          var selfDebugID = 0;
			          if (process.env.NODE_ENV !== 'production') {
			            selfDebugID = getDebugID(this);
			          }
			          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
			          child._mountIndex = index++;
			          mountImages.push(mountImage);
			        }
			      }
	
			      if (process.env.NODE_ENV !== 'production') {
			        setChildrenForInstrumentation.call(this, children);
			      }
	
			      return mountImages;
			    },
	
			    /**
			     * Replaces any rendered children with a text content string.
			     *
			     * @param {string} nextContent String of content.
			     * @internal
			     */
			    updateTextContent: function (nextContent) {
			      var prevChildren = this._renderedChildren;
			      // Remove any rendered children.
			      ReactChildReconciler.unmountChildren(prevChildren, false);
			      for (var name in prevChildren) {
			        if (prevChildren.hasOwnProperty(name)) {
			           true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
			        }
			      }
			      // Set new text content.
			      var updates = [makeTextContent(nextContent)];
			      processQueue(this, updates);
			    },
	
			    /**
			     * Replaces any rendered children with a markup string.
			     *
			     * @param {string} nextMarkup String of markup.
			     * @internal
			     */
			    updateMarkup: function (nextMarkup) {
			      var prevChildren = this._renderedChildren;
			      // Remove any rendered children.
			      ReactChildReconciler.unmountChildren(prevChildren, false);
			      for (var name in prevChildren) {
			        if (prevChildren.hasOwnProperty(name)) {
			           true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
			        }
			      }
			      var updates = [makeSetMarkup(nextMarkup)];
			      processQueue(this, updates);
			    },
	
			    /**
			     * Updates the rendered children with new children.
			     *
			     * @param {?object} nextNestedChildrenElements Nested child element maps.
			     * @param {ReactReconcileTransaction} transaction
			     * @internal
			     */
			    updateChildren: function (nextNestedChildrenElements, transaction, context) {
			      // Hook used by React ART
			      this._updateChildren(nextNestedChildrenElements, transaction, context);
			    },
	
			    /**
			     * @param {?object} nextNestedChildrenElements Nested child element maps.
			     * @param {ReactReconcileTransaction} transaction
			     * @final
			     * @protected
			     */
			    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
			      var prevChildren = this._renderedChildren;
			      var removedNodes = {};
			      var mountImages = [];
			      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
			      if (!nextChildren && !prevChildren) {
			        return;
			      }
			      var updates = null;
			      var name;
			      // `nextIndex` will increment for each child in `nextChildren`, but
			      // `lastIndex` will be the last index visited in `prevChildren`.
			      var nextIndex = 0;
			      var lastIndex = 0;
			      // `nextMountIndex` will increment for each newly mounted child.
			      var nextMountIndex = 0;
			      var lastPlacedNode = null;
			      for (name in nextChildren) {
			        if (!nextChildren.hasOwnProperty(name)) {
			          continue;
			        }
			        var prevChild = prevChildren && prevChildren[name];
			        var nextChild = nextChildren[name];
			        if (prevChild === nextChild) {
			          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
			          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
			          prevChild._mountIndex = nextIndex;
			        } else {
			          if (prevChild) {
			            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
			            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
			            // The `removedNodes` loop below will actually remove the child.
			          }
			          // The child must be instantiated before it's mounted.
			          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
			          nextMountIndex++;
			        }
			        nextIndex++;
			        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
			      }
			      // Remove children that are no longer present.
			      for (name in removedNodes) {
			        if (removedNodes.hasOwnProperty(name)) {
			          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
			        }
			      }
			      if (updates) {
			        processQueue(this, updates);
			      }
			      this._renderedChildren = nextChildren;
	
			      if (process.env.NODE_ENV !== 'production') {
			        setChildrenForInstrumentation.call(this, nextChildren);
			      }
			    },
	
			    /**
			     * Unmounts all rendered children. This should be used to clean up children
			     * when this component is unmounted. It does not actually perform any
			     * backend operations.
			     *
			     * @internal
			     */
			    unmountChildren: function (safely) {
			      var renderedChildren = this._renderedChildren;
			      ReactChildReconciler.unmountChildren(renderedChildren, safely);
			      this._renderedChildren = null;
			    },
	
			    /**
			     * Moves a child component to the supplied index.
			     *
			     * @param {ReactComponent} child Component to move.
			     * @param {number} toIndex Destination index of the element.
			     * @param {number} lastIndex Last index visited of the siblings of `child`.
			     * @protected
			     */
			    moveChild: function (child, afterNode, toIndex, lastIndex) {
			      // If the index of `child` is less than `lastIndex`, then it needs to
			      // be moved. Otherwise, we do not need to move it because a child will be
			      // inserted or moved before `child`.
			      if (child._mountIndex < lastIndex) {
			        return makeMove(child, afterNode, toIndex);
			      }
			    },
	
			    /**
			     * Creates a child component.
			     *
			     * @param {ReactComponent} child Component to create.
			     * @param {string} mountImage Markup to insert.
			     * @protected
			     */
			    createChild: function (child, afterNode, mountImage) {
			      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
			    },
	
			    /**
			     * Removes a child component.
			     *
			     * @param {ReactComponent} child Child to remove.
			     * @protected
			     */
			    removeChild: function (child, node) {
			      return makeRemove(child, node);
			    },
	
			    /**
			     * Mounts a child with the supplied name.
			     *
			     * NOTE: This is part of `updateChildren` and is here for readability.
			     *
			     * @param {ReactComponent} child Component to mount.
			     * @param {string} name Name of the child.
			     * @param {number} index Index at which to insert the child.
			     * @param {ReactReconcileTransaction} transaction
			     * @private
			     */
			    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
			      child._mountIndex = index;
			      return this.createChild(child, afterNode, mountImage);
			    },
	
			    /**
			     * Unmounts a rendered child.
			     *
			     * NOTE: This is part of `updateChildren` and is here for readability.
			     *
			     * @param {ReactComponent} child Component to unmount.
			     * @private
			     */
			    _unmountChild: function (child, node) {
			      var update = this.removeChild(child, node);
			      child._mountIndex = null;
			      return update;
			    }
	
			  }
	
			};
	
			module.exports = ReactMultiChild;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 115 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			var injected = false;
	
			var ReactComponentEnvironment = {
	
			  /**
			   * Optionally injectable hook for swapping out mount images in the middle of
			   * the tree.
			   */
			  replaceNodeWithMarkup: null,
	
			  /**
			   * Optionally injectable hook for processing a queue of child updates. Will
			   * later move into MultiChildComponents.
			   */
			  processChildrenUpdates: null,
	
			  injection: {
			    injectEnvironment: function (environment) {
			      !!injected ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
			      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
			      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
			      injected = true;
			    }
			  }
	
			};
	
			module.exports = ReactComponentEnvironment;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 116 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * `ReactInstanceMap` maintains a mapping from a public facing stateful
			 * instance (key) and the internal representation (value). This allows public
			 * methods to accept the user facing instance as an argument and map them back
			 * to internal methods.
			 */
	
			// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
			var ReactInstanceMap = {
	
			  /**
			   * This API should be called `delete` but we'd have to make sure to always
			   * transform these to strings for IE support. When this transform is fully
			   * supported we can rename it.
			   */
			  remove: function (key) {
			    key._reactInternalInstance = undefined;
			  },
	
			  get: function (key) {
			    return key._reactInternalInstance;
			  },
	
			  has: function (key) {
			    return key._reactInternalInstance !== undefined;
			  },
	
			  set: function (key, value) {
			    key._reactInternalInstance = value;
			  }
	
			};
	
			module.exports = ReactInstanceMap;
	
		/***/ },
		/* 117 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactReconciler = __webpack_require__(34);
	
			var instantiateReactComponent = __webpack_require__(118);
			var KeyEscapeUtils = __webpack_require__(128);
			var shouldUpdateReactComponent = __webpack_require__(124);
			var traverseAllChildren = __webpack_require__(129);
			var warning = __webpack_require__(18);
	
			var ReactComponentTreeHook;
	
			if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
			  // Temporary hack.
			  // Inline requires don't work well with Jest:
			  // https://github.com/facebook/react/issues/7240
			  // Remove the inline requires when we don't need them anymore:
			  // https://github.com/facebook/react/pull/7178
			  ReactComponentTreeHook = __webpack_require__(41);
			}
	
			function instantiateChild(childInstances, child, name, selfDebugID) {
			  // We found a component instance.
			  var keyUnique = childInstances[name] === undefined;
			  if (process.env.NODE_ENV !== 'production') {
			    if (!ReactComponentTreeHook) {
			      ReactComponentTreeHook = __webpack_require__(41);
			    }
			    if (!keyUnique) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
			    }
			  }
			  if (child != null && keyUnique) {
			    childInstances[name] = instantiateReactComponent(child, true);
			  }
			}
	
			/**
			 * ReactChildReconciler provides helpers for initializing or updating a set of
			 * children. Its output is suitable for passing it onto ReactMultiChild which
			 * does diffed reordering and insertion.
			 */
			var ReactChildReconciler = {
			  /**
			   * Generates a "mount image" for each of the supplied children. In the case
			   * of `ReactDOMComponent`, a mount image is a string of markup.
			   *
			   * @param {?object} nestedChildNodes Nested child maps.
			   * @return {?object} A set of child instances.
			   * @internal
			   */
			  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
			  ) {
			    if (nestedChildNodes == null) {
			      return null;
			    }
			    var childInstances = {};
	
			    if (process.env.NODE_ENV !== 'production') {
			      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
			        return instantiateChild(childInsts, child, name, selfDebugID);
			      }, childInstances);
			    } else {
			      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
			    }
			    return childInstances;
			  },
	
			  /**
			   * Updates the rendered children and returns a new set of children.
			   *
			   * @param {?object} prevChildren Previously initialized set of children.
			   * @param {?object} nextChildren Flat child element maps.
			   * @param {ReactReconcileTransaction} transaction
			   * @param {object} context
			   * @return {?object} A new set of child instances.
			   * @internal
			   */
			  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
			  ) {
			    // We currently don't have a way to track moves here but if we use iterators
			    // instead of for..in we can zip the iterators and check if an item has
			    // moved.
			    // TODO: If nothing has changed, return the prevChildren object so that we
			    // can quickly bailout if nothing has changed.
			    if (!nextChildren && !prevChildren) {
			      return;
			    }
			    var name;
			    var prevChild;
			    for (name in nextChildren) {
			      if (!nextChildren.hasOwnProperty(name)) {
			        continue;
			      }
			      prevChild = prevChildren && prevChildren[name];
			      var prevElement = prevChild && prevChild._currentElement;
			      var nextElement = nextChildren[name];
			      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
			        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
			        nextChildren[name] = prevChild;
			      } else {
			        if (prevChild) {
			          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
			          ReactReconciler.unmountComponent(prevChild, false);
			        }
			        // The child must be instantiated before it's mounted.
			        var nextChildInstance = instantiateReactComponent(nextElement, true);
			        nextChildren[name] = nextChildInstance;
			        // Creating mount image now ensures refs are resolved in right order
			        // (see https://github.com/facebook/react/pull/7101 for explanation).
			        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
			        mountImages.push(nextChildMountImage);
			      }
			    }
			    // Unmount children that are no longer present.
			    for (name in prevChildren) {
			      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
			        prevChild = prevChildren[name];
			        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
			        ReactReconciler.unmountComponent(prevChild, false);
			      }
			    }
			  },
	
			  /**
			   * Unmounts all rendered children. This should be used to clean up children
			   * when this component is unmounted.
			   *
			   * @param {?object} renderedChildren Previously initialized set of children.
			   * @internal
			   */
			  unmountChildren: function (renderedChildren, safely) {
			    for (var name in renderedChildren) {
			      if (renderedChildren.hasOwnProperty(name)) {
			        var renderedChild = renderedChildren[name];
			        ReactReconciler.unmountComponent(renderedChild, safely);
			      }
			    }
			  }
	
			};
	
			module.exports = ReactChildReconciler;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 118 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var ReactCompositeComponent = __webpack_require__(119);
			var ReactEmptyComponent = __webpack_require__(125);
			var ReactHostComponent = __webpack_require__(126);
	
			var getNextDebugID = __webpack_require__(127);
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			// To avoid a cyclic dependency, we create the final class in this module
			var ReactCompositeComponentWrapper = function (element) {
			  this.construct(element);
			};
			_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
			  _instantiateReactComponent: instantiateReactComponent
			});
	
			function getDeclarationErrorAddendum(owner) {
			  if (owner) {
			    var name = owner.getName();
			    if (name) {
			      return ' Check the render method of `' + name + '`.';
			    }
			  }
			  return '';
			}
	
			/**
			 * Check if the type reference is a known internal type. I.e. not a user
			 * provided composite type.
			 *
			 * @param {function} type
			 * @return {boolean} Returns true if this is a valid internal type.
			 */
			function isInternalComponentType(type) {
			  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
			}
	
			/**
			 * Given a ReactNode, create an instance that will actually be mounted.
			 *
			 * @param {ReactNode} node
			 * @param {boolean} shouldHaveDebugID
			 * @return {object} A new instance of the element's constructor.
			 * @protected
			 */
			function instantiateReactComponent(node, shouldHaveDebugID) {
			  var instance;
	
			  if (node === null || node === false) {
			    instance = ReactEmptyComponent.create(instantiateReactComponent);
			  } else if (typeof node === 'object') {
			    var element = node;
			    var type = element.type;
			    if (typeof type !== 'function' && typeof type !== 'string') {
			      var info = '';
			      if (process.env.NODE_ENV !== 'production') {
			        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
			          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
			        }
			      }
			      info += getDeclarationErrorAddendum(element._owner);
			       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
			    }
	
			    // Special case string values
			    if (typeof element.type === 'string') {
			      instance = ReactHostComponent.createInternalComponent(element);
			    } else if (isInternalComponentType(element.type)) {
			      // This is temporarily available for custom components that are not string
			      // representations. I.e. ART. Once those are updated to use the string
			      // representation, we can drop this code path.
			      instance = new element.type(element);
	
			      // We renamed this. Allow the old name for compat. :(
			      if (!instance.getHostNode) {
			        instance.getHostNode = instance.getNativeNode;
			      }
			    } else {
			      instance = new ReactCompositeComponentWrapper(element);
			    }
			  } else if (typeof node === 'string' || typeof node === 'number') {
			    instance = ReactHostComponent.createInstanceForText(node);
			  } else {
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
			  }
	
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
			  }
	
			  // These two fields are used by the DOM and ART diffing algorithms
			  // respectively. Instead of using expandos on components, we should be
			  // storing the state needed by the diffing algorithms elsewhere.
			  instance._mountIndex = 0;
			  instance._mountImage = null;
	
			  if (process.env.NODE_ENV !== 'production') {
			    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
			  }
	
			  // Internal instances should fully constructed at this point, so they should
			  // not get any new fields added to them at this point.
			  if (process.env.NODE_ENV !== 'production') {
			    if (Object.preventExtensions) {
			      Object.preventExtensions(instance);
			    }
			  }
	
			  return instance;
			}
	
			module.exports = instantiateReactComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 119 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var React = __webpack_require__(88);
			var ReactComponentEnvironment = __webpack_require__(115);
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactErrorUtils = __webpack_require__(17);
			var ReactInstanceMap = __webpack_require__(116);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactNodeTypes = __webpack_require__(120);
			var ReactReconciler = __webpack_require__(34);
	
			if (process.env.NODE_ENV !== 'production') {
			  var checkReactTypeSpec = __webpack_require__(121);
			}
	
			var emptyObject = __webpack_require__(99);
			var invariant = __webpack_require__(8);
			var shallowEqual = __webpack_require__(123);
			var shouldUpdateReactComponent = __webpack_require__(124);
			var warning = __webpack_require__(18);
	
			var CompositeTypes = {
			  ImpureClass: 0,
			  PureClass: 1,
			  StatelessFunctional: 2
			};
	
			function StatelessComponent(Component) {}
			StatelessComponent.prototype.render = function () {
			  var Component = ReactInstanceMap.get(this)._currentElement.type;
			  var element = Component(this.props, this.context, this.updater);
			  warnIfInvalidElement(Component, element);
			  return element;
			};
	
			function warnIfInvalidElement(Component, element) {
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
			    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
			  }
			}
	
			function shouldConstruct(Component) {
			  return !!(Component.prototype && Component.prototype.isReactComponent);
			}
	
			function isPureComponent(Component) {
			  return !!(Component.prototype && Component.prototype.isPureReactComponent);
			}
	
			// Separated into a function to contain deoptimizations caused by try/finally.
			function measureLifeCyclePerf(fn, debugID, timerType) {
			  if (debugID === 0) {
			    // Top-level wrappers (see ReactMount) and empty components (see
			    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
			    // Both are implementation details that should go away in the future.
			    return fn();
			  }
	
			  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
			  try {
			    return fn();
			  } finally {
			    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
			  }
			}
	
			/**
			 * ------------------ The Life-Cycle of a Composite Component ------------------
			 *
			 * - constructor: Initialization of state. The instance is now retained.
			 *   - componentWillMount
			 *   - render
			 *   - [children's constructors]
			 *     - [children's componentWillMount and render]
			 *     - [children's componentDidMount]
			 *     - componentDidMount
			 *
			 *       Update Phases:
			 *       - componentWillReceiveProps (only called if parent updated)
			 *       - shouldComponentUpdate
			 *         - componentWillUpdate
			 *           - render
			 *           - [children's constructors or receive props phases]
			 *         - componentDidUpdate
			 *
			 *     - componentWillUnmount
			 *     - [children's componentWillUnmount]
			 *   - [children destroyed]
			 * - (destroyed): The instance is now blank, released by React and ready for GC.
			 *
			 * -----------------------------------------------------------------------------
			 */
	
			/**
			 * An incrementing ID assigned to each component when it is mounted. This is
			 * used to enforce the order in which `ReactUpdates` updates dirty components.
			 *
			 * @private
			 */
			var nextMountID = 1;
	
			/**
			 * @lends {ReactCompositeComponent.prototype}
			 */
			var ReactCompositeComponent = {
	
			  /**
			   * Base constructor for all composite component.
			   *
			   * @param {ReactElement} element
			   * @final
			   * @internal
			   */
			  construct: function (element) {
			    this._currentElement = element;
			    this._rootNodeID = 0;
			    this._compositeType = null;
			    this._instance = null;
			    this._hostParent = null;
			    this._hostContainerInfo = null;
	
			    // See ReactUpdateQueue
			    this._updateBatchNumber = null;
			    this._pendingElement = null;
			    this._pendingStateQueue = null;
			    this._pendingReplaceState = false;
			    this._pendingForceUpdate = false;
	
			    this._renderedNodeType = null;
			    this._renderedComponent = null;
			    this._context = null;
			    this._mountOrder = 0;
			    this._topLevelWrapper = null;
	
			    // See ReactUpdates and ReactUpdateQueue.
			    this._pendingCallbacks = null;
	
			    // ComponentWillUnmount shall only be called once
			    this._calledComponentWillUnmount = false;
	
			    if (process.env.NODE_ENV !== 'production') {
			      this._warnedAboutRefsInRender = false;
			    }
			  },
	
			  /**
			   * Initializes the component, renders markup, and registers event listeners.
			   *
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @param {?object} hostParent
			   * @param {?object} hostContainerInfo
			   * @param {?object} context
			   * @return {?string} Rendered markup to be inserted into the DOM.
			   * @final
			   * @internal
			   */
			  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
			    var _this = this;
	
			    this._context = context;
			    this._mountOrder = nextMountID++;
			    this._hostParent = hostParent;
			    this._hostContainerInfo = hostContainerInfo;
	
			    var publicProps = this._currentElement.props;
			    var publicContext = this._processContext(context);
	
			    var Component = this._currentElement.type;
	
			    var updateQueue = transaction.getUpdateQueue();
	
			    // Initialize the public class
			    var doConstruct = shouldConstruct(Component);
			    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
			    var renderedElement;
	
			    // Support functional components
			    if (!doConstruct && (inst == null || inst.render == null)) {
			      renderedElement = inst;
			      warnIfInvalidElement(Component, renderedElement);
			      !(inst === null || inst === false || React.isValidElement(inst)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
			      inst = new StatelessComponent(Component);
			      this._compositeType = CompositeTypes.StatelessFunctional;
			    } else {
			      if (isPureComponent(Component)) {
			        this._compositeType = CompositeTypes.PureClass;
			      } else {
			        this._compositeType = CompositeTypes.ImpureClass;
			      }
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      // This will throw later in _renderValidatedComponent, but add an early
			      // warning now to help debugging
			      if (inst.render == null) {
			        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
			      }
	
			      var propsMutated = inst.props !== publicProps;
			      var componentName = Component.displayName || Component.name || 'Component';
	
			      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
			    }
	
			    // These should be set up in the constructor, but as a convenience for
			    // simpler class abstractions, we set them up after the fact.
			    inst.props = publicProps;
			    inst.context = publicContext;
			    inst.refs = emptyObject;
			    inst.updater = updateQueue;
	
			    this._instance = inst;
	
			    // Store a reference from the instance back to the internal representation
			    ReactInstanceMap.set(inst, this);
	
			    if (process.env.NODE_ENV !== 'production') {
			      // Since plain JS classes are defined without any special initialization
			      // logic, we can not catch common errors early. Therefore, we have to
			      // catch them here, at initialization time, instead.
			      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
			      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
			    }
	
			    var initialState = inst.state;
			    if (initialState === undefined) {
			      inst.state = initialState = null;
			    }
			    !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
			    this._pendingStateQueue = null;
			    this._pendingReplaceState = false;
			    this._pendingForceUpdate = false;
	
			    var markup;
			    if (inst.unstable_handleError) {
			      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
			    } else {
			      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
			    }
	
			    if (inst.componentDidMount) {
			      if (process.env.NODE_ENV !== 'production') {
			        transaction.getReactMountReady().enqueue(function () {
			          measureLifeCyclePerf(function () {
			            return inst.componentDidMount();
			          }, _this._debugID, 'componentDidMount');
			        });
			      } else {
			        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
			      }
			    }
	
			    return markup;
			  },
	
			  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
			    if (process.env.NODE_ENV !== 'production') {
			      ReactCurrentOwner.current = this;
			      try {
			        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
			      } finally {
			        ReactCurrentOwner.current = null;
			      }
			    } else {
			      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
			    }
			  },
	
			  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
			    var Component = this._currentElement.type;
	
			    if (doConstruct) {
			      if (process.env.NODE_ENV !== 'production') {
			        return measureLifeCyclePerf(function () {
			          return new Component(publicProps, publicContext, updateQueue);
			        }, this._debugID, 'ctor');
			      } else {
			        return new Component(publicProps, publicContext, updateQueue);
			      }
			    }
	
			    // This can still be an instance in case of factory components
			    // but we'll count this as time spent rendering as the more common case.
			    if (process.env.NODE_ENV !== 'production') {
			      return measureLifeCyclePerf(function () {
			        return Component(publicProps, publicContext, updateQueue);
			      }, this._debugID, 'render');
			    } else {
			      return Component(publicProps, publicContext, updateQueue);
			    }
			  },
	
			  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
			    var markup;
			    var checkpoint = transaction.checkpoint();
			    try {
			      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
			    } catch (e) {
			      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
			      transaction.rollback(checkpoint);
			      this._instance.unstable_handleError(e);
			      if (this._pendingStateQueue) {
			        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
			      }
			      checkpoint = transaction.checkpoint();
	
			      this._renderedComponent.unmountComponent(true);
			      transaction.rollback(checkpoint);
	
			      // Try again - we've informed the component about the error, so they can render an error message this time.
			      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
			      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
			    }
			    return markup;
			  },
	
			  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
			    var inst = this._instance;
	
			    var debugID = 0;
			    if (process.env.NODE_ENV !== 'production') {
			      debugID = this._debugID;
			    }
	
			    if (inst.componentWillMount) {
			      if (process.env.NODE_ENV !== 'production') {
			        measureLifeCyclePerf(function () {
			          return inst.componentWillMount();
			        }, debugID, 'componentWillMount');
			      } else {
			        inst.componentWillMount();
			      }
			      // When mounting, calls to `setState` by `componentWillMount` will set
			      // `this._pendingStateQueue` without triggering a re-render.
			      if (this._pendingStateQueue) {
			        inst.state = this._processPendingState(inst.props, inst.context);
			      }
			    }
	
			    // If not a stateless component, we now render
			    if (renderedElement === undefined) {
			      renderedElement = this._renderValidatedComponent();
			    }
	
			    var nodeType = ReactNodeTypes.getType(renderedElement);
			    this._renderedNodeType = nodeType;
			    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
			    );
			    this._renderedComponent = child;
	
			    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
			    if (process.env.NODE_ENV !== 'production') {
			      if (debugID !== 0) {
			        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
			        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
			      }
			    }
	
			    return markup;
			  },
	
			  getHostNode: function () {
			    return ReactReconciler.getHostNode(this._renderedComponent);
			  },
	
			  /**
			   * Releases any resources allocated by `mountComponent`.
			   *
			   * @final
			   * @internal
			   */
			  unmountComponent: function (safely) {
			    if (!this._renderedComponent) {
			      return;
			    }
	
			    var inst = this._instance;
	
			    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
			      inst._calledComponentWillUnmount = true;
	
			      if (safely) {
			        var name = this.getName() + '.componentWillUnmount()';
			        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
			      } else {
			        if (process.env.NODE_ENV !== 'production') {
			          measureLifeCyclePerf(function () {
			            return inst.componentWillUnmount();
			          }, this._debugID, 'componentWillUnmount');
			        } else {
			          inst.componentWillUnmount();
			        }
			      }
			    }
	
			    if (this._renderedComponent) {
			      ReactReconciler.unmountComponent(this._renderedComponent, safely);
			      this._renderedNodeType = null;
			      this._renderedComponent = null;
			      this._instance = null;
			    }
	
			    // Reset pending fields
			    // Even if this component is scheduled for another update in ReactUpdates,
			    // it would still be ignored because these fields are reset.
			    this._pendingStateQueue = null;
			    this._pendingReplaceState = false;
			    this._pendingForceUpdate = false;
			    this._pendingCallbacks = null;
			    this._pendingElement = null;
	
			    // These fields do not really need to be reset since this object is no
			    // longer accessible.
			    this._context = null;
			    this._rootNodeID = 0;
			    this._topLevelWrapper = null;
	
			    // Delete the reference from the instance to this internal representation
			    // which allow the internals to be properly cleaned up even if the user
			    // leaks a reference to the public instance.
			    ReactInstanceMap.remove(inst);
	
			    // Some existing components rely on inst.props even after they've been
			    // destroyed (in event handlers).
			    // TODO: inst.props = null;
			    // TODO: inst.state = null;
			    // TODO: inst.context = null;
			  },
	
			  /**
			   * Filters the context object to only contain keys specified in
			   * `contextTypes`
			   *
			   * @param {object} context
			   * @return {?object}
			   * @private
			   */
			  _maskContext: function (context) {
			    var Component = this._currentElement.type;
			    var contextTypes = Component.contextTypes;
			    if (!contextTypes) {
			      return emptyObject;
			    }
			    var maskedContext = {};
			    for (var contextName in contextTypes) {
			      maskedContext[contextName] = context[contextName];
			    }
			    return maskedContext;
			  },
	
			  /**
			   * Filters the context object to only contain keys specified in
			   * `contextTypes`, and asserts that they are valid.
			   *
			   * @param {object} context
			   * @return {?object}
			   * @private
			   */
			  _processContext: function (context) {
			    var maskedContext = this._maskContext(context);
			    if (process.env.NODE_ENV !== 'production') {
			      var Component = this._currentElement.type;
			      if (Component.contextTypes) {
			        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
			      }
			    }
			    return maskedContext;
			  },
	
			  /**
			   * @param {object} currentContext
			   * @return {object}
			   * @private
			   */
			  _processChildContext: function (currentContext) {
			    var Component = this._currentElement.type;
			    var inst = this._instance;
			    var childContext;
	
			    if (inst.getChildContext) {
			      if (process.env.NODE_ENV !== 'production') {
			        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
			        try {
			          childContext = inst.getChildContext();
			        } finally {
			          ReactInstrumentation.debugTool.onEndProcessingChildContext();
			        }
			      } else {
			        childContext = inst.getChildContext();
			      }
			    }
	
			    if (childContext) {
			      !(typeof Component.childContextTypes === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
			      if (process.env.NODE_ENV !== 'production') {
			        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
			      }
			      for (var name in childContext) {
			        !(name in Component.childContextTypes) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
			      }
			      return _assign({}, currentContext, childContext);
			    }
			    return currentContext;
			  },
	
			  /**
			   * Assert that the context types are valid
			   *
			   * @param {object} typeSpecs Map of context field to a ReactPropType
			   * @param {object} values Runtime values that need to be type-checked
			   * @param {string} location e.g. "prop", "context", "child context"
			   * @private
			   */
			  _checkContextTypes: function (typeSpecs, values, location) {
			    if (process.env.NODE_ENV !== 'production') {
			      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
			    }
			  },
	
			  receiveComponent: function (nextElement, transaction, nextContext) {
			    var prevElement = this._currentElement;
			    var prevContext = this._context;
	
			    this._pendingElement = null;
	
			    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
			  },
	
			  /**
			   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
			   * is set, update the component.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   */
			  performUpdateIfNecessary: function (transaction) {
			    if (this._pendingElement != null) {
			      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
			    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
			      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
			    } else {
			      this._updateBatchNumber = null;
			    }
			  },
	
			  /**
			   * Perform an update to a mounted component. The componentWillReceiveProps and
			   * shouldComponentUpdate methods are called, then (assuming the update isn't
			   * skipped) the remaining update lifecycle methods are called and the DOM
			   * representation is updated.
			   *
			   * By default, this implements React's rendering and reconciliation algorithm.
			   * Sophisticated clients may wish to override this.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @param {ReactElement} prevParentElement
			   * @param {ReactElement} nextParentElement
			   * @internal
			   * @overridable
			   */
			  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
			    var inst = this._instance;
			    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
			    var willReceive = false;
			    var nextContext;
	
			    // Determine if the context has changed or not
			    if (this._context === nextUnmaskedContext) {
			      nextContext = inst.context;
			    } else {
			      nextContext = this._processContext(nextUnmaskedContext);
			      willReceive = true;
			    }
	
			    var prevProps = prevParentElement.props;
			    var nextProps = nextParentElement.props;
	
			    // Not a simple state update but a props update
			    if (prevParentElement !== nextParentElement) {
			      willReceive = true;
			    }
	
			    // An update here will schedule an update but immediately set
			    // _pendingStateQueue which will ensure that any state updates gets
			    // immediately reconciled instead of waiting for the next batch.
			    if (willReceive && inst.componentWillReceiveProps) {
			      if (process.env.NODE_ENV !== 'production') {
			        measureLifeCyclePerf(function () {
			          return inst.componentWillReceiveProps(nextProps, nextContext);
			        }, this._debugID, 'componentWillReceiveProps');
			      } else {
			        inst.componentWillReceiveProps(nextProps, nextContext);
			      }
			    }
	
			    var nextState = this._processPendingState(nextProps, nextContext);
			    var shouldUpdate = true;
	
			    if (!this._pendingForceUpdate) {
			      if (inst.shouldComponentUpdate) {
			        if (process.env.NODE_ENV !== 'production') {
			          shouldUpdate = measureLifeCyclePerf(function () {
			            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
			          }, this._debugID, 'shouldComponentUpdate');
			        } else {
			          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
			        }
			      } else {
			        if (this._compositeType === CompositeTypes.PureClass) {
			          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
			        }
			      }
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
			    }
	
			    this._updateBatchNumber = null;
			    if (shouldUpdate) {
			      this._pendingForceUpdate = false;
			      // Will set `this.props`, `this.state` and `this.context`.
			      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
			    } else {
			      // If it's determined that a component should not update, we still want
			      // to set props and state but we shortcut the rest of the update.
			      this._currentElement = nextParentElement;
			      this._context = nextUnmaskedContext;
			      inst.props = nextProps;
			      inst.state = nextState;
			      inst.context = nextContext;
			    }
			  },
	
			  _processPendingState: function (props, context) {
			    var inst = this._instance;
			    var queue = this._pendingStateQueue;
			    var replace = this._pendingReplaceState;
			    this._pendingReplaceState = false;
			    this._pendingStateQueue = null;
	
			    if (!queue) {
			      return inst.state;
			    }
	
			    if (replace && queue.length === 1) {
			      return queue[0];
			    }
	
			    var nextState = _assign({}, replace ? queue[0] : inst.state);
			    for (var i = replace ? 1 : 0; i < queue.length; i++) {
			      var partial = queue[i];
			      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
			    }
	
			    return nextState;
			  },
	
			  /**
			   * Merges new props and state, notifies delegate methods of update and
			   * performs update.
			   *
			   * @param {ReactElement} nextElement Next element
			   * @param {object} nextProps Next public object to set as properties.
			   * @param {?object} nextState Next object to set as state.
			   * @param {?object} nextContext Next public object to set as context.
			   * @param {ReactReconcileTransaction} transaction
			   * @param {?object} unmaskedContext
			   * @private
			   */
			  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
			    var _this2 = this;
	
			    var inst = this._instance;
	
			    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
			    var prevProps;
			    var prevState;
			    var prevContext;
			    if (hasComponentDidUpdate) {
			      prevProps = inst.props;
			      prevState = inst.state;
			      prevContext = inst.context;
			    }
	
			    if (inst.componentWillUpdate) {
			      if (process.env.NODE_ENV !== 'production') {
			        measureLifeCyclePerf(function () {
			          return inst.componentWillUpdate(nextProps, nextState, nextContext);
			        }, this._debugID, 'componentWillUpdate');
			      } else {
			        inst.componentWillUpdate(nextProps, nextState, nextContext);
			      }
			    }
	
			    this._currentElement = nextElement;
			    this._context = unmaskedContext;
			    inst.props = nextProps;
			    inst.state = nextState;
			    inst.context = nextContext;
	
			    this._updateRenderedComponent(transaction, unmaskedContext);
	
			    if (hasComponentDidUpdate) {
			      if (process.env.NODE_ENV !== 'production') {
			        transaction.getReactMountReady().enqueue(function () {
			          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
			        });
			      } else {
			        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
			      }
			    }
			  },
	
			  /**
			   * Call the component's `render` method and update the DOM accordingly.
			   *
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   */
			  _updateRenderedComponent: function (transaction, context) {
			    var prevComponentInstance = this._renderedComponent;
			    var prevRenderedElement = prevComponentInstance._currentElement;
			    var nextRenderedElement = this._renderValidatedComponent();
	
			    var debugID = 0;
			    if (process.env.NODE_ENV !== 'production') {
			      debugID = this._debugID;
			    }
	
			    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
			      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
			    } else {
			      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
			      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
			      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
			      this._renderedNodeType = nodeType;
			      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
			      );
			      this._renderedComponent = child;
	
			      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
			      if (process.env.NODE_ENV !== 'production') {
			        if (debugID !== 0) {
			          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
			          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
			        }
			      }
	
			      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
			    }
			  },
	
			  /**
			   * Overridden in shallow rendering.
			   *
			   * @protected
			   */
			  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
			    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
			  },
	
			  /**
			   * @protected
			   */
			  _renderValidatedComponentWithoutOwnerOrContext: function () {
			    var inst = this._instance;
			    var renderedElement;
	
			    if (process.env.NODE_ENV !== 'production') {
			      renderedElement = measureLifeCyclePerf(function () {
			        return inst.render();
			      }, this._debugID, 'render');
			    } else {
			      renderedElement = inst.render();
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      // We allow auto-mocks to proceed as if they're returning null.
			      if (renderedElement === undefined && inst.render._isMockFunction) {
			        // This is probably bad practice. Consider warning here and
			        // deprecating this convenience.
			        renderedElement = null;
			      }
			    }
	
			    return renderedElement;
			  },
	
			  /**
			   * @private
			   */
			  _renderValidatedComponent: function () {
			    var renderedElement;
			    if (process.env.NODE_ENV !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
			      ReactCurrentOwner.current = this;
			      try {
			        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
			      } finally {
			        ReactCurrentOwner.current = null;
			      }
			    } else {
			      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
			    }
			    !(
			    // TODO: An `isValidNode` function would probably be more appropriate
			    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
			    return renderedElement;
			  },
	
			  /**
			   * Lazily allocates the refs object and stores `component` as `ref`.
			   *
			   * @param {string} ref Reference name.
			   * @param {component} component Component to store as `ref`.
			   * @final
			   * @private
			   */
			  attachRef: function (ref, component) {
			    var inst = this.getPublicInstance();
			    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
			    var publicComponentInstance = component.getPublicInstance();
			    if (process.env.NODE_ENV !== 'production') {
			      var componentName = component && component.getName ? component.getName() : 'a component';
			      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
			    }
			    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
			    refs[ref] = publicComponentInstance;
			  },
	
			  /**
			   * Detaches a reference name.
			   *
			   * @param {string} ref Name to dereference.
			   * @final
			   * @private
			   */
			  detachRef: function (ref) {
			    var refs = this.getPublicInstance().refs;
			    delete refs[ref];
			  },
	
			  /**
			   * Get a text description of the component that can be used to identify it
			   * in error messages.
			   * @return {string} The name or null.
			   * @internal
			   */
			  getName: function () {
			    var type = this._currentElement.type;
			    var constructor = this._instance && this._instance.constructor;
			    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
			  },
	
			  /**
			   * Get the publicly accessible representation of this component - i.e. what
			   * is exposed by refs and returned by render. Can be null for stateless
			   * components.
			   *
			   * @return {ReactComponent} the public component instance.
			   * @internal
			   */
			  getPublicInstance: function () {
			    var inst = this._instance;
			    if (this._compositeType === CompositeTypes.StatelessFunctional) {
			      return null;
			    }
			    return inst;
			  },
	
			  // Stub
			  _instantiateReactComponent: null
	
			};
	
			module.exports = ReactCompositeComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 120 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var React = __webpack_require__(88);
	
			var invariant = __webpack_require__(8);
	
			var ReactNodeTypes = {
			  HOST: 0,
			  COMPOSITE: 1,
			  EMPTY: 2,
	
			  getType: function (node) {
			    if (node === null || node === false) {
			      return ReactNodeTypes.EMPTY;
			    } else if (React.isValidElement(node)) {
			      if (typeof node.type === 'function') {
			        return ReactNodeTypes.COMPOSITE;
			      } else {
			        return ReactNodeTypes.HOST;
			      }
			    }
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
			  }
			};
	
			module.exports = ReactNodeTypes;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 121 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactPropTypeLocationNames = __webpack_require__(122);
			var ReactPropTypesSecret = __webpack_require__(110);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			var ReactComponentTreeHook;
	
			if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
			  // Temporary hack.
			  // Inline requires don't work well with Jest:
			  // https://github.com/facebook/react/issues/7240
			  // Remove the inline requires when we don't need them anymore:
			  // https://github.com/facebook/react/pull/7178
			  ReactComponentTreeHook = __webpack_require__(41);
			}
	
			var loggedTypeFailures = {};
	
			/**
			 * Assert that the values match with the type specs.
			 * Error messages are memorized and will only be shown once.
			 *
			 * @param {object} typeSpecs Map of name to a ReactPropType
			 * @param {object} values Runtime values that need to be type-checked
			 * @param {string} location e.g. "prop", "context", "child context"
			 * @param {string} componentName Name of the component for error messages.
			 * @param {?object} element The React element that is being type-checked
			 * @param {?number} debugID The React component instance that is being type-checked
			 * @private
			 */
			function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
			  for (var typeSpecName in typeSpecs) {
			    if (typeSpecs.hasOwnProperty(typeSpecName)) {
			      var error;
			      // Prop type validation may throw. In case they do, we don't want to
			      // fail the render phase where it didn't fail before. So we log it.
			      // After these have been cleaned up, we'll let them throw.
			      try {
			        // This is intentionally an invariant that gets caught. It's the same
			        // behavior as without this statement except with a better message.
			        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
			        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
			      } catch (ex) {
			        error = ex;
			      }
			      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
			      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
			        // Only monitor this failure once because there tends to be a lot of the
			        // same error.
			        loggedTypeFailures[error.message] = true;
	
			        var componentStackInfo = '';
	
			        if (process.env.NODE_ENV !== 'production') {
			          if (!ReactComponentTreeHook) {
			            ReactComponentTreeHook = __webpack_require__(41);
			          }
			          if (debugID !== null) {
			            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
			          } else if (element !== null) {
			            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
			          }
			        }
	
			        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
			      }
			    }
			  }
			}
	
			module.exports = checkReactTypeSpec;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 122 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var ReactPropTypeLocationNames = {};
	
			if (process.env.NODE_ENV !== 'production') {
			  ReactPropTypeLocationNames = {
			    prop: 'prop',
			    context: 'context',
			    childContext: 'child context'
			  };
			}
	
			module.exports = ReactPropTypeLocationNames;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 123 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 * 
			 */
	
			/*eslint-disable no-self-compare */
	
			'use strict';
	
			var hasOwnProperty = Object.prototype.hasOwnProperty;
	
			/**
			 * inlined Object.is polyfill to avoid requiring consumers ship their own
			 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
			 */
			function is(x, y) {
			  // SameValue algorithm
			  if (x === y) {
			    // Steps 1-5, 7-10
			    // Steps 6.b-6.e: +0 != -0
			    // Added the nonzero y check to make Flow happy, but it is redundant
			    return x !== 0 || y !== 0 || 1 / x === 1 / y;
			  } else {
			    // Step 6.a: NaN == NaN
			    return x !== x && y !== y;
			  }
			}
	
			/**
			 * Performs equality by iterating through keys on an object and returning false
			 * when any key has values which are not strictly equal between the arguments.
			 * Returns true when the values of all keys are strictly equal.
			 */
			function shallowEqual(objA, objB) {
			  if (is(objA, objB)) {
			    return true;
			  }
	
			  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
			    return false;
			  }
	
			  var keysA = Object.keys(objA);
			  var keysB = Object.keys(objB);
	
			  if (keysA.length !== keysB.length) {
			    return false;
			  }
	
			  // Test for A's keys different from B.
			  for (var i = 0; i < keysA.length; i++) {
			    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
			      return false;
			    }
			  }
	
			  return true;
			}
	
			module.exports = shallowEqual;
	
		/***/ },
		/* 124 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Given a `prevElement` and `nextElement`, determines if the existing
			 * instance should be updated as opposed to being destroyed or replaced by a new
			 * instance. Both arguments are elements. This ensures that this logic can
			 * operate on stateless trees without any backing instance.
			 *
			 * @param {?object} prevElement
			 * @param {?object} nextElement
			 * @return {boolean} True if the existing instance should be updated.
			 * @protected
			 */
	
			function shouldUpdateReactComponent(prevElement, nextElement) {
			  var prevEmpty = prevElement === null || prevElement === false;
			  var nextEmpty = nextElement === null || nextElement === false;
			  if (prevEmpty || nextEmpty) {
			    return prevEmpty === nextEmpty;
			  }
	
			  var prevType = typeof prevElement;
			  var nextType = typeof nextElement;
			  if (prevType === 'string' || prevType === 'number') {
			    return nextType === 'string' || nextType === 'number';
			  } else {
			    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
			  }
			}
	
			module.exports = shouldUpdateReactComponent;
	
		/***/ },
		/* 125 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var emptyComponentFactory;
	
			var ReactEmptyComponentInjection = {
			  injectEmptyComponentFactory: function (factory) {
			    emptyComponentFactory = factory;
			  }
			};
	
			var ReactEmptyComponent = {
			  create: function (instantiate) {
			    return emptyComponentFactory(instantiate);
			  }
			};
	
			ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
			module.exports = ReactEmptyComponent;
	
		/***/ },
		/* 126 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			var genericComponentClass = null;
			var textComponentClass = null;
	
			var ReactHostComponentInjection = {
			  // This accepts a class that receives the tag string. This is a catch all
			  // that can render any kind of tag.
			  injectGenericComponentClass: function (componentClass) {
			    genericComponentClass = componentClass;
			  },
			  // This accepts a text component class that takes the text string to be
			  // rendered as props.
			  injectTextComponentClass: function (componentClass) {
			    textComponentClass = componentClass;
			  }
			};
	
			/**
			 * Get a host internal component class for a specific tag.
			 *
			 * @param {ReactElement} element The element to create.
			 * @return {function} The internal class constructor function.
			 */
			function createInternalComponent(element) {
			  !genericComponentClass ? process.env.NODE_ENV !== 'production' ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
			  return new genericComponentClass(element);
			}
	
			/**
			 * @param {ReactText} text
			 * @return {ReactComponent}
			 */
			function createInstanceForText(text) {
			  return new textComponentClass(text);
			}
	
			/**
			 * @param {ReactComponent} component
			 * @return {boolean}
			 */
			function isTextComponent(component) {
			  return component instanceof textComponentClass;
			}
	
			var ReactHostComponent = {
			  createInternalComponent: createInternalComponent,
			  createInstanceForText: createInstanceForText,
			  isTextComponent: isTextComponent,
			  injection: ReactHostComponentInjection
			};
	
			module.exports = ReactHostComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 127 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var nextDebugID = 1;
	
			function getNextDebugID() {
			  return nextDebugID++;
			}
	
			module.exports = getNextDebugID;
	
		/***/ },
		/* 128 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/**
			 * Escape and wrap key so it is safe to use as a reactid
			 *
			 * @param {string} key to be escaped.
			 * @return {string} the escaped key.
			 */
	
			function escape(key) {
			  var escapeRegex = /[=:]/g;
			  var escaperLookup = {
			    '=': '=0',
			    ':': '=2'
			  };
			  var escapedString = ('' + key).replace(escapeRegex, function (match) {
			    return escaperLookup[match];
			  });
	
			  return '$' + escapedString;
			}
	
			/**
			 * Unescape and unwrap key for human-readable display
			 *
			 * @param {string} key to unescape.
			 * @return {string} the unescaped key.
			 */
			function unescape(key) {
			  var unescapeRegex = /(=0|=2)/g;
			  var unescaperLookup = {
			    '=0': '=',
			    '=2': ':'
			  };
			  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
			  return ('' + keySubstring).replace(unescapeRegex, function (match) {
			    return unescaperLookup[match];
			  });
			}
	
			var KeyEscapeUtils = {
			  escape: escape,
			  unescape: unescape
			};
	
			module.exports = KeyEscapeUtils;
	
		/***/ },
		/* 129 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var REACT_ELEMENT_TYPE = __webpack_require__(130);
	
			var getIteratorFn = __webpack_require__(131);
			var invariant = __webpack_require__(8);
			var KeyEscapeUtils = __webpack_require__(128);
			var warning = __webpack_require__(18);
	
			var SEPARATOR = '.';
			var SUBSEPARATOR = ':';
	
			/**
			 * This is inlined from ReactElement since this file is shared between
			 * isomorphic and renderers. We could extract this to a
			 *
			 */
	
			/**
			 * TODO: Test that a single child and an array with one item have the same key
			 * pattern.
			 */
	
			var didWarnAboutMaps = false;
	
			/**
			 * Generate a key string that identifies a component within a set.
			 *
			 * @param {*} component A component that could contain a manual key.
			 * @param {number} index Index that is used if a manual key is not provided.
			 * @return {string}
			 */
			function getComponentKey(component, index) {
			  // Do some typechecking here since we call this blindly. We want to ensure
			  // that we don't block potential future ES APIs.
			  if (component && typeof component === 'object' && component.key != null) {
			    // Explicit key
			    return KeyEscapeUtils.escape(component.key);
			  }
			  // Implicit key determined by the index in the set
			  return index.toString(36);
			}
	
			/**
			 * @param {?*} children Children tree container.
			 * @param {!string} nameSoFar Name of the key path so far.
			 * @param {!function} callback Callback to invoke with each child found.
			 * @param {?*} traverseContext Used to pass information throughout the traversal
			 * process.
			 * @return {!number} The number of children in this subtree.
			 */
			function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
			  var type = typeof children;
	
			  if (type === 'undefined' || type === 'boolean') {
			    // All of the above are perceived as null.
			    children = null;
			  }
	
			  if (children === null || type === 'string' || type === 'number' ||
			  // The following is inlined from ReactElement. This means we can optimize
			  // some checks. React Fiber also inlines this logic for similar purposes.
			  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
			    callback(traverseContext, children,
			    // If it's the only child, treat the name as if it was wrapped in an array
			    // so that it's consistent if the number of children grows.
			    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
			    return 1;
			  }
	
			  var child;
			  var nextName;
			  var subtreeCount = 0; // Count of children found in the current subtree.
			  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
			  if (Array.isArray(children)) {
			    for (var i = 0; i < children.length; i++) {
			      child = children[i];
			      nextName = nextNamePrefix + getComponentKey(child, i);
			      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			    }
			  } else {
			    var iteratorFn = getIteratorFn(children);
			    if (iteratorFn) {
			      var iterator = iteratorFn.call(children);
			      var step;
			      if (iteratorFn !== children.entries) {
			        var ii = 0;
			        while (!(step = iterator.next()).done) {
			          child = step.value;
			          nextName = nextNamePrefix + getComponentKey(child, ii++);
			          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			        }
			      } else {
			        if (process.env.NODE_ENV !== 'production') {
			          var mapsAsChildrenAddendum = '';
			          if (ReactCurrentOwner.current) {
			            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
			            if (mapsAsChildrenOwnerName) {
			              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
			            }
			          }
			          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
			          didWarnAboutMaps = true;
			        }
			        // Iterator will provide entry [k,v] tuples rather than values.
			        while (!(step = iterator.next()).done) {
			          var entry = step.value;
			          if (entry) {
			            child = entry[1];
			            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
			            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
			          }
			        }
			      }
			    } else if (type === 'object') {
			      var addendum = '';
			      if (process.env.NODE_ENV !== 'production') {
			        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
			        if (children._isReactElement) {
			          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
			        }
			        if (ReactCurrentOwner.current) {
			          var name = ReactCurrentOwner.current.getName();
			          if (name) {
			            addendum += ' Check the render method of `' + name + '`.';
			          }
			        }
			      }
			      var childrenString = String(children);
			       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
			    }
			  }
	
			  return subtreeCount;
			}
	
			/**
			 * Traverses children that are typically specified as `props.children`, but
			 * might also be specified through attributes:
			 *
			 * - `traverseAllChildren(this.props.children, ...)`
			 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
			 *
			 * The `traverseContext` is an optional argument that is passed through the
			 * entire traversal. It can be used to store accumulations or anything else that
			 * the callback might find relevant.
			 *
			 * @param {?*} children Children tree object.
			 * @param {!function} callback To invoke upon traversing each child.
			 * @param {?*} traverseContext Context for traversal.
			 * @return {!number} The number of children in this subtree.
			 */
			function traverseAllChildren(children, callback, traverseContext) {
			  if (children == null) {
			    return 0;
			  }
	
			  return traverseAllChildrenImpl(children, '', callback, traverseContext);
			}
	
			module.exports = traverseAllChildren;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 130 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			// The Symbol used to tag the ReactElement type. If there is no native Symbol
			// nor polyfill, then a plain number is used for performance.
	
			var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
			module.exports = REACT_ELEMENT_TYPE;
	
		/***/ },
		/* 131 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			/* global Symbol */
	
			var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
			var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
			/**
			 * Returns the iterator method function contained on the iterable object.
			 *
			 * Be sure to invoke the function with the iterable as context:
			 *
			 *     var iteratorFn = getIteratorFn(myIterable);
			 *     if (iteratorFn) {
			 *       var iterator = iteratorFn.call(myIterable);
			 *       ...
			 *     }
			 *
			 * @param {?object} maybeIterable
			 * @return {?function}
			 */
			function getIteratorFn(maybeIterable) {
			  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
			  if (typeof iteratorFn === 'function') {
			    return iteratorFn;
			  }
			}
	
			module.exports = getIteratorFn;
	
		/***/ },
		/* 132 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var KeyEscapeUtils = __webpack_require__(128);
			var traverseAllChildren = __webpack_require__(129);
			var warning = __webpack_require__(18);
	
			var ReactComponentTreeHook;
	
			if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
			  // Temporary hack.
			  // Inline requires don't work well with Jest:
			  // https://github.com/facebook/react/issues/7240
			  // Remove the inline requires when we don't need them anymore:
			  // https://github.com/facebook/react/pull/7178
			  ReactComponentTreeHook = __webpack_require__(41);
			}
	
			/**
			 * @param {function} traverseContext Context passed through traversal.
			 * @param {?ReactComponent} child React child component.
			 * @param {!string} name String name of key path to child.
			 * @param {number=} selfDebugID Optional debugID of the current internal instance.
			 */
			function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
			  // We found a component instance.
			  if (traverseContext && typeof traverseContext === 'object') {
			    var result = traverseContext;
			    var keyUnique = result[name] === undefined;
			    if (process.env.NODE_ENV !== 'production') {
			      if (!ReactComponentTreeHook) {
			        ReactComponentTreeHook = __webpack_require__(41);
			      }
			      if (!keyUnique) {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
			      }
			    }
			    if (keyUnique && child != null) {
			      result[name] = child;
			    }
			  }
			}
	
			/**
			 * Flattens children that are typically specified as `props.children`. Any null
			 * children will not be included in the resulting object.
			 * @return {!object} flattened children keyed by name.
			 */
			function flattenChildren(children, selfDebugID) {
			  if (children == null) {
			    return children;
			  }
			  var result = {};
	
			  if (process.env.NODE_ENV !== 'production') {
			    traverseAllChildren(children, function (traverseContext, child, name) {
			      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
			    }, result);
			  } else {
			    traverseAllChildren(children, flattenSingleChildIntoContext, result);
			  }
			  return result;
			}
	
			module.exports = flattenChildren;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 133 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var PooledClass = __webpack_require__(25);
			var Transaction = __webpack_require__(46);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactServerUpdateQueue = __webpack_require__(134);
	
			/**
			 * Executed within the scope of the `Transaction` instance. Consider these as
			 * being member methods, but with an implied ordering while being isolated from
			 * each other.
			 */
			var TRANSACTION_WRAPPERS = [];
	
			if (process.env.NODE_ENV !== 'production') {
			  TRANSACTION_WRAPPERS.push({
			    initialize: ReactInstrumentation.debugTool.onBeginFlush,
			    close: ReactInstrumentation.debugTool.onEndFlush
			  });
			}
	
			var noopCallbackQueue = {
			  enqueue: function () {}
			};
	
			/**
			 * @class ReactServerRenderingTransaction
			 * @param {boolean} renderToStaticMarkup
			 */
			function ReactServerRenderingTransaction(renderToStaticMarkup) {
			  this.reinitializeTransaction();
			  this.renderToStaticMarkup = renderToStaticMarkup;
			  this.useCreateElement = false;
			  this.updateQueue = new ReactServerUpdateQueue(this);
			}
	
			var Mixin = {
			  /**
			   * @see Transaction
			   * @abstract
			   * @final
			   * @return {array} Empty list of operation wrap procedures.
			   */
			  getTransactionWrappers: function () {
			    return TRANSACTION_WRAPPERS;
			  },
	
			  /**
			   * @return {object} The queue to collect `onDOMReady` callbacks with.
			   */
			  getReactMountReady: function () {
			    return noopCallbackQueue;
			  },
	
			  /**
			   * @return {object} The queue to collect React async events.
			   */
			  getUpdateQueue: function () {
			    return this.updateQueue;
			  },
	
			  /**
			   * `PooledClass` looks for this, and will invoke this before allowing this
			   * instance to be reused.
			   */
			  destructor: function () {},
	
			  checkpoint: function () {},
	
			  rollback: function () {}
			};
	
			_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
			PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
			module.exports = ReactServerRenderingTransaction;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 134 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
			var ReactUpdateQueue = __webpack_require__(135);
	
			var warning = __webpack_require__(18);
	
			function warnNoop(publicInstance, callerName) {
			  if (process.env.NODE_ENV !== 'production') {
			    var constructor = publicInstance.constructor;
			    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
			  }
			}
	
			/**
			 * This is the update queue used for server rendering.
			 * It delegates to ReactUpdateQueue while server rendering is in progress and
			 * switches to ReactNoopUpdateQueue after the transaction has completed.
			 * @class ReactServerUpdateQueue
			 * @param {Transaction} transaction
			 */
	
			var ReactServerUpdateQueue = function () {
			  function ReactServerUpdateQueue(transaction) {
			    _classCallCheck(this, ReactServerUpdateQueue);
	
			    this.transaction = transaction;
			  }
	
			  /**
			   * Checks whether or not this composite component is mounted.
			   * @param {ReactClass} publicInstance The instance we want to test.
			   * @return {boolean} True if mounted, false otherwise.
			   * @protected
			   * @final
			   */
	
	
			  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
			    return false;
			  };
	
			  /**
			   * Enqueue a callback that will be executed after all the pending updates
			   * have processed.
			   *
			   * @param {ReactClass} publicInstance The instance to use as `this` context.
			   * @param {?function} callback Called after state is updated.
			   * @internal
			   */
	
	
			  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
			    if (this.transaction.isInTransaction()) {
			      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
			    }
			  };
	
			  /**
			   * Forces an update. This should only be invoked when it is known with
			   * certainty that we are **not** in a DOM transaction.
			   *
			   * You may want to call this when you know that some deeper aspect of the
			   * component's state has changed but `setState` was not called.
			   *
			   * This will not invoke `shouldComponentUpdate`, but it will invoke
			   * `componentWillUpdate` and `componentDidUpdate`.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @internal
			   */
	
	
			  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
			    if (this.transaction.isInTransaction()) {
			      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
			    } else {
			      warnNoop(publicInstance, 'forceUpdate');
			    }
			  };
	
			  /**
			   * Replaces all of the state. Always use this or `setState` to mutate state.
			   * You should treat `this.state` as immutable.
			   *
			   * There is no guarantee that `this.state` will be immediately updated, so
			   * accessing `this.state` after calling this method may return the old value.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object|function} completeState Next state.
			   * @internal
			   */
	
	
			  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
			    if (this.transaction.isInTransaction()) {
			      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
			    } else {
			      warnNoop(publicInstance, 'replaceState');
			    }
			  };
	
			  /**
			   * Sets a subset of the state. This only exists because _pendingState is
			   * internal. This provides a merging strategy that is not available to deep
			   * properties which is confusing. TODO: Expose pendingState or don't use it
			   * during the merge.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object|function} partialState Next partial state to be merged with state.
			   * @internal
			   */
	
	
			  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
			    if (this.transaction.isInTransaction()) {
			      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
			    } else {
			      warnNoop(publicInstance, 'setState');
			    }
			  };
	
			  return ReactServerUpdateQueue;
			}();
	
			module.exports = ReactServerUpdateQueue;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 135 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactInstanceMap = __webpack_require__(116);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactUpdates = __webpack_require__(31);
	
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			function enqueueUpdate(internalInstance) {
			  ReactUpdates.enqueueUpdate(internalInstance);
			}
	
			function formatUnexpectedArgument(arg) {
			  var type = typeof arg;
			  if (type !== 'object') {
			    return type;
			  }
			  var displayName = arg.constructor && arg.constructor.name || type;
			  var keys = Object.keys(arg);
			  if (keys.length > 0 && keys.length < 20) {
			    return displayName + ' (keys: ' + keys.join(', ') + ')';
			  }
			  return displayName;
			}
	
			function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
			  var internalInstance = ReactInstanceMap.get(publicInstance);
			  if (!internalInstance) {
			    if (process.env.NODE_ENV !== 'production') {
			      var ctor = publicInstance.constructor;
			      // Only warn when we have a callerName. Otherwise we should be silent.
			      // We're probably calling from enqueueCallback. We don't want to warn
			      // there because we already warned for the corresponding lifecycle method.
			      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
			    }
			    return null;
			  }
	
			  if (process.env.NODE_ENV !== 'production') {
			    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
			  }
	
			  return internalInstance;
			}
	
			/**
			 * ReactUpdateQueue allows for state updates to be scheduled into a later
			 * reconciliation step.
			 */
			var ReactUpdateQueue = {
	
			  /**
			   * Checks whether or not this composite component is mounted.
			   * @param {ReactClass} publicInstance The instance we want to test.
			   * @return {boolean} True if mounted, false otherwise.
			   * @protected
			   * @final
			   */
			  isMounted: function (publicInstance) {
			    if (process.env.NODE_ENV !== 'production') {
			      var owner = ReactCurrentOwner.current;
			      if (owner !== null) {
			        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
			        owner._warnedAboutRefsInRender = true;
			      }
			    }
			    var internalInstance = ReactInstanceMap.get(publicInstance);
			    if (internalInstance) {
			      // During componentWillMount and render this will still be null but after
			      // that will always render to something. At least for now. So we can use
			      // this hack.
			      return !!internalInstance._renderedComponent;
			    } else {
			      return false;
			    }
			  },
	
			  /**
			   * Enqueue a callback that will be executed after all the pending updates
			   * have processed.
			   *
			   * @param {ReactClass} publicInstance The instance to use as `this` context.
			   * @param {?function} callback Called after state is updated.
			   * @param {string} callerName Name of the calling function in the public API.
			   * @internal
			   */
			  enqueueCallback: function (publicInstance, callback, callerName) {
			    ReactUpdateQueue.validateCallback(callback, callerName);
			    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
			    // Previously we would throw an error if we didn't have an internal
			    // instance. Since we want to make it a no-op instead, we mirror the same
			    // behavior we have in other enqueue* methods.
			    // We also need to ignore callbacks in componentWillMount. See
			    // enqueueUpdates.
			    if (!internalInstance) {
			      return null;
			    }
	
			    if (internalInstance._pendingCallbacks) {
			      internalInstance._pendingCallbacks.push(callback);
			    } else {
			      internalInstance._pendingCallbacks = [callback];
			    }
			    // TODO: The callback here is ignored when setState is called from
			    // componentWillMount. Either fix it or disallow doing so completely in
			    // favor of getInitialState. Alternatively, we can disallow
			    // componentWillMount during server-side rendering.
			    enqueueUpdate(internalInstance);
			  },
	
			  enqueueCallbackInternal: function (internalInstance, callback) {
			    if (internalInstance._pendingCallbacks) {
			      internalInstance._pendingCallbacks.push(callback);
			    } else {
			      internalInstance._pendingCallbacks = [callback];
			    }
			    enqueueUpdate(internalInstance);
			  },
	
			  /**
			   * Forces an update. This should only be invoked when it is known with
			   * certainty that we are **not** in a DOM transaction.
			   *
			   * You may want to call this when you know that some deeper aspect of the
			   * component's state has changed but `setState` was not called.
			   *
			   * This will not invoke `shouldComponentUpdate`, but it will invoke
			   * `componentWillUpdate` and `componentDidUpdate`.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @internal
			   */
			  enqueueForceUpdate: function (publicInstance) {
			    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
			    if (!internalInstance) {
			      return;
			    }
	
			    internalInstance._pendingForceUpdate = true;
	
			    enqueueUpdate(internalInstance);
			  },
	
			  /**
			   * Replaces all of the state. Always use this or `setState` to mutate state.
			   * You should treat `this.state` as immutable.
			   *
			   * There is no guarantee that `this.state` will be immediately updated, so
			   * accessing `this.state` after calling this method may return the old value.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object} completeState Next state.
			   * @internal
			   */
			  enqueueReplaceState: function (publicInstance, completeState) {
			    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
			    if (!internalInstance) {
			      return;
			    }
	
			    internalInstance._pendingStateQueue = [completeState];
			    internalInstance._pendingReplaceState = true;
	
			    enqueueUpdate(internalInstance);
			  },
	
			  /**
			   * Sets a subset of the state. This only exists because _pendingState is
			   * internal. This provides a merging strategy that is not available to deep
			   * properties which is confusing. TODO: Expose pendingState or don't use it
			   * during the merge.
			   *
			   * @param {ReactClass} publicInstance The instance that should rerender.
			   * @param {object} partialState Next partial state to be merged with state.
			   * @internal
			   */
			  enqueueSetState: function (publicInstance, partialState) {
			    if (process.env.NODE_ENV !== 'production') {
			      ReactInstrumentation.debugTool.onSetState();
			      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
			    }
	
			    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
			    if (!internalInstance) {
			      return;
			    }
	
			    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
			    queue.push(partialState);
	
			    enqueueUpdate(internalInstance);
			  },
	
			  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
			    internalInstance._pendingElement = nextElement;
			    // TODO: introduce _pendingContext instead of setting it directly.
			    internalInstance._context = nextContext;
			    enqueueUpdate(internalInstance);
			  },
	
			  validateCallback: function (callback, callerName) {
			    !(!callback || typeof callback === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
			  }
	
			};
	
			module.exports = ReactUpdateQueue;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 136 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var emptyFunction = __webpack_require__(19);
			var warning = __webpack_require__(18);
	
			var validateDOMNesting = emptyFunction;
	
			if (process.env.NODE_ENV !== 'production') {
			  // This validation code was written based on the HTML5 parsing spec:
			  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
			  //
			  // Note: this does not catch all invalid nesting, nor does it try to (as it's
			  // not clear what practical benefit doing so provides); instead, we warn only
			  // for cases where the parser will give a parse tree differing from what React
			  // intended. For example, <b><div></div></b> is invalid but we don't warn
			  // because it still parses correctly; we do warn for other cases like nested
			  // <p> tags where the beginning of the second element implicitly closes the
			  // first, causing a confusing mess.
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#special
			  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
			  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
			  // TODO: Distinguish by namespace here -- for <title>, including it here
			  // errs on the side of fewer warnings
			  'foreignObject', 'desc', 'title'];
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
			  var buttonScopeTags = inScopeTags.concat(['button']);
	
			  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
			  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
			  var emptyAncestorInfo = {
			    current: null,
	
			    formTag: null,
			    aTagInScope: null,
			    buttonTagInScope: null,
			    nobrTagInScope: null,
			    pTagInButtonScope: null,
	
			    listItemTagAutoclosing: null,
			    dlItemTagAutoclosing: null
			  };
	
			  var updatedAncestorInfo = function (oldInfo, tag, instance) {
			    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
			    var info = { tag: tag, instance: instance };
	
			    if (inScopeTags.indexOf(tag) !== -1) {
			      ancestorInfo.aTagInScope = null;
			      ancestorInfo.buttonTagInScope = null;
			      ancestorInfo.nobrTagInScope = null;
			    }
			    if (buttonScopeTags.indexOf(tag) !== -1) {
			      ancestorInfo.pTagInButtonScope = null;
			    }
	
			    // See rules for 'li', 'dd', 'dt' start tags in
			    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
			    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
			      ancestorInfo.listItemTagAutoclosing = null;
			      ancestorInfo.dlItemTagAutoclosing = null;
			    }
	
			    ancestorInfo.current = info;
	
			    if (tag === 'form') {
			      ancestorInfo.formTag = info;
			    }
			    if (tag === 'a') {
			      ancestorInfo.aTagInScope = info;
			    }
			    if (tag === 'button') {
			      ancestorInfo.buttonTagInScope = info;
			    }
			    if (tag === 'nobr') {
			      ancestorInfo.nobrTagInScope = info;
			    }
			    if (tag === 'p') {
			      ancestorInfo.pTagInButtonScope = info;
			    }
			    if (tag === 'li') {
			      ancestorInfo.listItemTagAutoclosing = info;
			    }
			    if (tag === 'dd' || tag === 'dt') {
			      ancestorInfo.dlItemTagAutoclosing = info;
			    }
	
			    return ancestorInfo;
			  };
	
			  /**
			   * Returns whether
			   */
			  var isTagValidWithParent = function (tag, parentTag) {
			    // First, let's check if we're in an unusual parsing mode...
			    switch (parentTag) {
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
			      case 'select':
			        return tag === 'option' || tag === 'optgroup' || tag === '#text';
			      case 'optgroup':
			        return tag === 'option' || tag === '#text';
			      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
			      // but
			      case 'option':
			        return tag === '#text';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
			      // No special behavior since these rules fall back to "in body" mode for
			      // all except special table nodes which cause bad parsing behavior anyway.
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
			      case 'tr':
			        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
			      case 'tbody':
			      case 'thead':
			      case 'tfoot':
			        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
			      case 'colgroup':
			        return tag === 'col' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
			      case 'table':
			        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
			      case 'head':
			        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
			      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
			      case 'html':
			        return tag === 'head' || tag === 'body';
			      case '#document':
			        return tag === 'html';
			    }
	
			    // Probably in the "in body" parsing mode, so we outlaw only tag combos
			    // where the parsing rules cause implicit opens or closes to be added.
			    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
			    switch (tag) {
			      case 'h1':
			      case 'h2':
			      case 'h3':
			      case 'h4':
			      case 'h5':
			      case 'h6':
			        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
			      case 'rp':
			      case 'rt':
			        return impliedEndTags.indexOf(parentTag) === -1;
	
			      case 'body':
			      case 'caption':
			      case 'col':
			      case 'colgroup':
			      case 'frame':
			      case 'head':
			      case 'html':
			      case 'tbody':
			      case 'td':
			      case 'tfoot':
			      case 'th':
			      case 'thead':
			      case 'tr':
			        // These tags are only valid with a few parents that have special child
			        // parsing rules -- if we're down here, then none of those matched and
			        // so we allow it only if we don't know what the parent is, as all other
			        // cases are invalid.
			        return parentTag == null;
			    }
	
			    return true;
			  };
	
			  /**
			   * Returns whether
			   */
			  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
			    switch (tag) {
			      case 'address':
			      case 'article':
			      case 'aside':
			      case 'blockquote':
			      case 'center':
			      case 'details':
			      case 'dialog':
			      case 'dir':
			      case 'div':
			      case 'dl':
			      case 'fieldset':
			      case 'figcaption':
			      case 'figure':
			      case 'footer':
			      case 'header':
			      case 'hgroup':
			      case 'main':
			      case 'menu':
			      case 'nav':
			      case 'ol':
			      case 'p':
			      case 'section':
			      case 'summary':
			      case 'ul':
	
			      case 'pre':
			      case 'listing':
	
			      case 'table':
	
			      case 'hr':
	
			      case 'xmp':
	
			      case 'h1':
			      case 'h2':
			      case 'h3':
			      case 'h4':
			      case 'h5':
			      case 'h6':
			        return ancestorInfo.pTagInButtonScope;
	
			      case 'form':
			        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
			      case 'li':
			        return ancestorInfo.listItemTagAutoclosing;
	
			      case 'dd':
			      case 'dt':
			        return ancestorInfo.dlItemTagAutoclosing;
	
			      case 'button':
			        return ancestorInfo.buttonTagInScope;
	
			      case 'a':
			        // Spec says something about storing a list of markers, but it sounds
			        // equivalent to this check.
			        return ancestorInfo.aTagInScope;
	
			      case 'nobr':
			        return ancestorInfo.nobrTagInScope;
			    }
	
			    return null;
			  };
	
			  /**
			   * Given a ReactCompositeComponent instance, return a list of its recursive
			   * owners, starting at the root and ending with the instance itself.
			   */
			  var findOwnerStack = function (instance) {
			    if (!instance) {
			      return [];
			    }
	
			    var stack = [];
			    do {
			      stack.push(instance);
			    } while (instance = instance._currentElement._owner);
			    stack.reverse();
			    return stack;
			  };
	
			  var didWarn = {};
	
			  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
			    ancestorInfo = ancestorInfo || emptyAncestorInfo;
			    var parentInfo = ancestorInfo.current;
			    var parentTag = parentInfo && parentInfo.tag;
	
			    if (childText != null) {
			      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
			      childTag = '#text';
			    }
	
			    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
			    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
			    var problematic = invalidParent || invalidAncestor;
	
			    if (problematic) {
			      var ancestorTag = problematic.tag;
			      var ancestorInstance = problematic.instance;
	
			      var childOwner = childInstance && childInstance._currentElement._owner;
			      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
			      var childOwners = findOwnerStack(childOwner);
			      var ancestorOwners = findOwnerStack(ancestorOwner);
	
			      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
			      var i;
	
			      var deepestCommon = -1;
			      for (i = 0; i < minStackLen; i++) {
			        if (childOwners[i] === ancestorOwners[i]) {
			          deepestCommon = i;
			        } else {
			          break;
			        }
			      }
	
			      var UNKNOWN = '(unknown)';
			      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
			        return inst.getName() || UNKNOWN;
			      });
			      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
			        return inst.getName() || UNKNOWN;
			      });
			      var ownerInfo = [].concat(
			      // If the parent and child instances have a common owner ancestor, start
			      // with that -- otherwise we just start with the parent's owners.
			      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
			      // If we're warning about an invalid (non-parent) ancestry, add '...'
			      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
			      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
			      if (didWarn[warnKey]) {
			        return;
			      }
			      didWarn[warnKey] = true;
	
			      var tagDisplayName = childTag;
			      var whitespaceInfo = '';
			      if (childTag === '#text') {
			        if (/\S/.test(childText)) {
			          tagDisplayName = 'Text nodes';
			        } else {
			          tagDisplayName = 'Whitespace text nodes';
			          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
			        }
			      } else {
			        tagDisplayName = '<' + childTag + '>';
			      }
	
			      if (invalidParent) {
			        var info = '';
			        if (ancestorTag === 'table' && childTag === 'tr') {
			          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
			        }
			        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
			      } else {
			        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
			      }
			    }
			  };
	
			  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
			  // For testing
			  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
			    ancestorInfo = ancestorInfo || emptyAncestorInfo;
			    var parentInfo = ancestorInfo.current;
			    var parentTag = parentInfo && parentInfo.tag;
			    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
			  };
			}
	
			module.exports = validateDOMNesting;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 137 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2014-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var DOMLazyTree = __webpack_require__(59);
			var ReactDOMComponentTree = __webpack_require__(5);
	
			var ReactDOMEmptyComponent = function (instantiate) {
			  // ReactCompositeComponent uses this:
			  this._currentElement = null;
			  // ReactDOMComponentTree uses these:
			  this._hostNode = null;
			  this._hostParent = null;
			  this._hostContainerInfo = null;
			  this._domID = 0;
			};
			_assign(ReactDOMEmptyComponent.prototype, {
			  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
			    var domID = hostContainerInfo._idCounter++;
			    this._domID = domID;
			    this._hostParent = hostParent;
			    this._hostContainerInfo = hostContainerInfo;
	
			    var nodeValue = ' react-empty: ' + this._domID + ' ';
			    if (transaction.useCreateElement) {
			      var ownerDocument = hostContainerInfo._ownerDocument;
			      var node = ownerDocument.createComment(nodeValue);
			      ReactDOMComponentTree.precacheNode(this, node);
			      return DOMLazyTree(node);
			    } else {
			      if (transaction.renderToStaticMarkup) {
			        // Normally we'd insert a comment node, but since this is a situation
			        // where React won't take over (static pages), we can simply return
			        // nothing.
			        return '';
			      }
			      return '<!--' + nodeValue + '-->';
			    }
			  },
			  receiveComponent: function () {},
			  getHostNode: function () {
			    return ReactDOMComponentTree.getNodeFromInstance(this);
			  },
			  unmountComponent: function () {
			    ReactDOMComponentTree.uncacheNode(this);
			  }
			});
	
			module.exports = ReactDOMEmptyComponent;
	
		/***/ },
		/* 138 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2015-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var invariant = __webpack_require__(8);
	
			/**
			 * Return the lowest common ancestor of A and B, or null if they are in
			 * different trees.
			 */
			function getLowestCommonAncestor(instA, instB) {
			  !('_hostNode' in instA) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
			  !('_hostNode' in instB) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
			  var depthA = 0;
			  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
			    depthA++;
			  }
			  var depthB = 0;
			  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
			    depthB++;
			  }
	
			  // If A is deeper, crawl up.
			  while (depthA - depthB > 0) {
			    instA = instA._hostParent;
			    depthA--;
			  }
	
			  // If B is deeper, crawl up.
			  while (depthB - depthA > 0) {
			    instB = instB._hostParent;
			    depthB--;
			  }
	
			  // Walk in lockstep until we find a match.
			  var depth = depthA;
			  while (depth--) {
			    if (instA === instB) {
			      return instA;
			    }
			    instA = instA._hostParent;
			    instB = instB._hostParent;
			  }
			  return null;
			}
	
			/**
			 * Return if A is an ancestor of B.
			 */
			function isAncestor(instA, instB) {
			  !('_hostNode' in instA) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
			  !('_hostNode' in instB) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
			  while (instB) {
			    if (instB === instA) {
			      return true;
			    }
			    instB = instB._hostParent;
			  }
			  return false;
			}
	
			/**
			 * Return the parent instance of the passed-in instance.
			 */
			function getParentInstance(inst) {
			  !('_hostNode' in inst) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
			  return inst._hostParent;
			}
	
			/**
			 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
			 */
			function traverseTwoPhase(inst, fn, arg) {
			  var path = [];
			  while (inst) {
			    path.push(inst);
			    inst = inst._hostParent;
			  }
			  var i;
			  for (i = path.length; i-- > 0;) {
			    fn(path[i], 'captured', arg);
			  }
			  for (i = 0; i < path.length; i++) {
			    fn(path[i], 'bubbled', arg);
			  }
			}
	
			/**
			 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
			 * should would receive a `mouseEnter` or `mouseLeave` event.
			 *
			 * Does not invoke the callback on the nearest common ancestor because nothing
			 * "entered" or "left" that element.
			 */
			function traverseEnterLeave(from, to, fn, argFrom, argTo) {
			  var common = from && to ? getLowestCommonAncestor(from, to) : null;
			  var pathFrom = [];
			  while (from && from !== common) {
			    pathFrom.push(from);
			    from = from._hostParent;
			  }
			  var pathTo = [];
			  while (to && to !== common) {
			    pathTo.push(to);
			    to = to._hostParent;
			  }
			  var i;
			  for (i = 0; i < pathFrom.length; i++) {
			    fn(pathFrom[i], 'bubbled', argFrom);
			  }
			  for (i = pathTo.length; i-- > 0;) {
			    fn(pathTo[i], 'captured', argTo);
			  }
			}
	
			module.exports = {
			  isAncestor: isAncestor,
			  getLowestCommonAncestor: getLowestCommonAncestor,
			  getParentInstance: getParentInstance,
			  traverseTwoPhase: traverseTwoPhase,
			  traverseEnterLeave: traverseEnterLeave
			};
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 139 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6),
			    _assign = __webpack_require__(24);
	
			var DOMChildrenOperations = __webpack_require__(58);
			var DOMLazyTree = __webpack_require__(59);
			var ReactDOMComponentTree = __webpack_require__(5);
	
			var escapeTextContentForBrowser = __webpack_require__(64);
			var invariant = __webpack_require__(8);
			var validateDOMNesting = __webpack_require__(136);
	
			/**
			 * Text nodes violate a couple assumptions that React makes about components:
			 *
			 *  - When mounting text into the DOM, adjacent text nodes are merged.
			 *  - Text nodes cannot be assigned a React root ID.
			 *
			 * This component is used to wrap strings between comment nodes so that they
			 * can undergo the same reconciliation that is applied to elements.
			 *
			 * TODO: Investigate representing React components in the DOM with text nodes.
			 *
			 * @class ReactDOMTextComponent
			 * @extends ReactComponent
			 * @internal
			 */
			var ReactDOMTextComponent = function (text) {
			  // TODO: This is really a ReactText (ReactNode), not a ReactElement
			  this._currentElement = text;
			  this._stringText = '' + text;
			  // ReactDOMComponentTree uses these:
			  this._hostNode = null;
			  this._hostParent = null;
	
			  // Properties
			  this._domID = 0;
			  this._mountIndex = 0;
			  this._closingComment = null;
			  this._commentNodes = null;
			};
	
			_assign(ReactDOMTextComponent.prototype, {
	
			  /**
			   * Creates the markup for this text node. This node is not intended to have
			   * any features besides containing text content.
			   *
			   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
			   * @return {string} Markup for this text node.
			   * @internal
			   */
			  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
			    if (process.env.NODE_ENV !== 'production') {
			      var parentInfo;
			      if (hostParent != null) {
			        parentInfo = hostParent._ancestorInfo;
			      } else if (hostContainerInfo != null) {
			        parentInfo = hostContainerInfo._ancestorInfo;
			      }
			      if (parentInfo) {
			        // parentInfo should always be present except for the top-level
			        // component when server rendering
			        validateDOMNesting(null, this._stringText, this, parentInfo);
			      }
			    }
	
			    var domID = hostContainerInfo._idCounter++;
			    var openingValue = ' react-text: ' + domID + ' ';
			    var closingValue = ' /react-text ';
			    this._domID = domID;
			    this._hostParent = hostParent;
			    if (transaction.useCreateElement) {
			      var ownerDocument = hostContainerInfo._ownerDocument;
			      var openingComment = ownerDocument.createComment(openingValue);
			      var closingComment = ownerDocument.createComment(closingValue);
			      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
			      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
			      if (this._stringText) {
			        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
			      }
			      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
			      ReactDOMComponentTree.precacheNode(this, openingComment);
			      this._closingComment = closingComment;
			      return lazyTree;
			    } else {
			      var escapedText = escapeTextContentForBrowser(this._stringText);
	
			      if (transaction.renderToStaticMarkup) {
			        // Normally we'd wrap this between comment nodes for the reasons stated
			        // above, but since this is a situation where React won't take over
			        // (static pages), we can simply return the text as it is.
			        return escapedText;
			      }
	
			      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
			    }
			  },
	
			  /**
			   * Updates this component by updating the text content.
			   *
			   * @param {ReactText} nextText The next text content
			   * @param {ReactReconcileTransaction} transaction
			   * @internal
			   */
			  receiveComponent: function (nextText, transaction) {
			    if (nextText !== this._currentElement) {
			      this._currentElement = nextText;
			      var nextStringText = '' + nextText;
			      if (nextStringText !== this._stringText) {
			        // TODO: Save this as pending props and use performUpdateIfNecessary
			        // and/or updateComponent to do the actual update for consistency with
			        // other component types?
			        this._stringText = nextStringText;
			        var commentNodes = this.getHostNode();
			        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
			      }
			    }
			  },
	
			  getHostNode: function () {
			    var hostNode = this._commentNodes;
			    if (hostNode) {
			      return hostNode;
			    }
			    if (!this._closingComment) {
			      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
			      var node = openingComment.nextSibling;
			      while (true) {
			        !(node != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
			        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
			          this._closingComment = node;
			          break;
			        }
			        node = node.nextSibling;
			      }
			    }
			    hostNode = [this._hostNode, this._closingComment];
			    this._commentNodes = hostNode;
			    return hostNode;
			  },
	
			  unmountComponent: function () {
			    this._closingComment = null;
			    this._commentNodes = null;
			    ReactDOMComponentTree.uncacheNode(this);
			  }
	
			});
	
			module.exports = ReactDOMTextComponent;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 140 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var ReactUpdates = __webpack_require__(31);
			var Transaction = __webpack_require__(46);
	
			var emptyFunction = __webpack_require__(19);
	
			var RESET_BATCHED_UPDATES = {
			  initialize: emptyFunction,
			  close: function () {
			    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
			  }
			};
	
			var FLUSH_BATCHED_UPDATES = {
			  initialize: emptyFunction,
			  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
			};
	
			var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
			function ReactDefaultBatchingStrategyTransaction() {
			  this.reinitializeTransaction();
			}
	
			_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
			  getTransactionWrappers: function () {
			    return TRANSACTION_WRAPPERS;
			  }
			});
	
			var transaction = new ReactDefaultBatchingStrategyTransaction();
	
			var ReactDefaultBatchingStrategy = {
			  isBatchingUpdates: false,
	
			  /**
			   * Call the provided function in a context within which calls to `setState`
			   * and friends are batched such that components aren't updated unnecessarily.
			   */
			  batchedUpdates: function (callback, a, b, c, d, e) {
			    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
			    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
			    // The code is written this way to avoid extra allocations
			    if (alreadyBatchingUpdates) {
			      return callback(a, b, c, d, e);
			    } else {
			      return transaction.perform(callback, null, a, b, c, d, e);
			    }
			  }
			};
	
			module.exports = ReactDefaultBatchingStrategy;
	
		/***/ },
		/* 141 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var EventListener = __webpack_require__(142);
			var ExecutionEnvironment = __webpack_require__(22);
			var PooledClass = __webpack_require__(25);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactUpdates = __webpack_require__(31);
	
			var getEventTarget = __webpack_require__(47);
			var getUnboundedScrollPosition = __webpack_require__(143);
	
			/**
			 * Find the deepest React component completely containing the root of the
			 * passed-in instance (for use when entire React trees are nested within each
			 * other). If React trees are not nested, returns null.
			 */
			function findParent(inst) {
			  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
			  // traversal, but caching is difficult to do correctly without using a
			  // mutation observer to listen for all DOM changes.
			  while (inst._hostParent) {
			    inst = inst._hostParent;
			  }
			  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
			  var container = rootNode.parentNode;
			  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
			}
	
			// Used to store ancestor hierarchy in top level callback
			function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
			  this.topLevelType = topLevelType;
			  this.nativeEvent = nativeEvent;
			  this.ancestors = [];
			}
			_assign(TopLevelCallbackBookKeeping.prototype, {
			  destructor: function () {
			    this.topLevelType = null;
			    this.nativeEvent = null;
			    this.ancestors.length = 0;
			  }
			});
			PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
			function handleTopLevelImpl(bookKeeping) {
			  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
			  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
			  // Loop through the hierarchy, in case there's any nested components.
			  // It's important that we build the array of ancestors before calling any
			  // event handlers, because event handlers can modify the DOM, leading to
			  // inconsistencies with ReactMount's node cache. See #1105.
			  var ancestor = targetInst;
			  do {
			    bookKeeping.ancestors.push(ancestor);
			    ancestor = ancestor && findParent(ancestor);
			  } while (ancestor);
	
			  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
			    targetInst = bookKeeping.ancestors[i];
			    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
			  }
			}
	
			function scrollValueMonitor(cb) {
			  var scrollPosition = getUnboundedScrollPosition(window);
			  cb(scrollPosition);
			}
	
			var ReactEventListener = {
			  _enabled: true,
			  _handleTopLevel: null,
	
			  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
			  setHandleTopLevel: function (handleTopLevel) {
			    ReactEventListener._handleTopLevel = handleTopLevel;
			  },
	
			  setEnabled: function (enabled) {
			    ReactEventListener._enabled = !!enabled;
			  },
	
			  isEnabled: function () {
			    return ReactEventListener._enabled;
			  },
	
			  /**
			   * Traps top-level events by using event bubbling.
			   *
			   * @param {string} topLevelType Record from `EventConstants`.
			   * @param {string} handlerBaseName Event name (e.g. "click").
			   * @param {object} element Element on which to attach listener.
			   * @return {?object} An object with a remove function which will forcefully
			   *                  remove the listener.
			   * @internal
			   */
			  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
			    if (!element) {
			      return null;
			    }
			    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
			  },
	
			  /**
			   * Traps a top-level event by using event capturing.
			   *
			   * @param {string} topLevelType Record from `EventConstants`.
			   * @param {string} handlerBaseName Event name (e.g. "click").
			   * @param {object} element Element on which to attach listener.
			   * @return {?object} An object with a remove function which will forcefully
			   *                  remove the listener.
			   * @internal
			   */
			  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
			    if (!element) {
			      return null;
			    }
			    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
			  },
	
			  monitorScrollValue: function (refresh) {
			    var callback = scrollValueMonitor.bind(null, refresh);
			    EventListener.listen(window, 'scroll', callback);
			  },
	
			  dispatchEvent: function (topLevelType, nativeEvent) {
			    if (!ReactEventListener._enabled) {
			      return;
			    }
	
			    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
			    try {
			      // Event queue being processed in the same cycle allows
			      // `preventDefault`.
			      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
			    } finally {
			      TopLevelCallbackBookKeeping.release(bookKeeping);
			    }
			  }
			};
	
			module.exports = ReactEventListener;
	
		/***/ },
		/* 142 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 *
			 * Licensed under the Apache License, Version 2.0 (the "License");
			 * you may not use this file except in compliance with the License.
			 * You may obtain a copy of the License at
			 *
			 * http://www.apache.org/licenses/LICENSE-2.0
			 *
			 * Unless required by applicable law or agreed to in writing, software
			 * distributed under the License is distributed on an "AS IS" BASIS,
			 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
			 * See the License for the specific language governing permissions and
			 * limitations under the License.
			 *
			 * @typechecks
			 */
	
			var emptyFunction = __webpack_require__(19);
	
			/**
			 * Upstream version of event listener. Does not take into account specific
			 * nature of platform.
			 */
			var EventListener = {
			  /**
			   * Listen to DOM events during the bubble phase.
			   *
			   * @param {DOMEventTarget} target DOM element to register listener on.
			   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
			   * @param {function} callback Callback function.
			   * @return {object} Object with a `remove` method.
			   */
			  listen: function listen(target, eventType, callback) {
			    if (target.addEventListener) {
			      target.addEventListener(eventType, callback, false);
			      return {
			        remove: function remove() {
			          target.removeEventListener(eventType, callback, false);
			        }
			      };
			    } else if (target.attachEvent) {
			      target.attachEvent('on' + eventType, callback);
			      return {
			        remove: function remove() {
			          target.detachEvent('on' + eventType, callback);
			        }
			      };
			    }
			  },
	
			  /**
			   * Listen to DOM events during the capture phase.
			   *
			   * @param {DOMEventTarget} target DOM element to register listener on.
			   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
			   * @param {function} callback Callback function.
			   * @return {object} Object with a `remove` method.
			   */
			  capture: function capture(target, eventType, callback) {
			    if (target.addEventListener) {
			      target.addEventListener(eventType, callback, true);
			      return {
			        remove: function remove() {
			          target.removeEventListener(eventType, callback, true);
			        }
			      };
			    } else {
			      if (process.env.NODE_ENV !== 'production') {
			        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
			      }
			      return {
			        remove: emptyFunction
			      };
			    }
			  },
	
			  registerDefault: function registerDefault() {}
			};
	
			module.exports = EventListener;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 143 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			'use strict';
	
			/**
			 * Gets the scroll position of the supplied element or window.
			 *
			 * The return values are unbounded, unlike `getScrollPosition`. This means they
			 * may be negative or exceed the element boundaries (which is possible using
			 * inertial scrolling).
			 *
			 * @param {DOMWindow|DOMElement} scrollable
			 * @return {object} Map with `x` and `y` keys.
			 */
	
			function getUnboundedScrollPosition(scrollable) {
			  if (scrollable === window) {
			    return {
			      x: window.pageXOffset || document.documentElement.scrollLeft,
			      y: window.pageYOffset || document.documentElement.scrollTop
			    };
			  }
			  return {
			    x: scrollable.scrollLeft,
			    y: scrollable.scrollTop
			  };
			}
	
			module.exports = getUnboundedScrollPosition;
	
		/***/ },
		/* 144 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
			var EventPluginHub = __webpack_require__(14);
			var EventPluginUtils = __webpack_require__(16);
			var ReactComponentEnvironment = __webpack_require__(115);
			var ReactEmptyComponent = __webpack_require__(125);
			var ReactBrowserEventEmitter = __webpack_require__(83);
			var ReactHostComponent = __webpack_require__(126);
			var ReactUpdates = __webpack_require__(31);
	
			var ReactInjection = {
			  Component: ReactComponentEnvironment.injection,
			  DOMProperty: DOMProperty.injection,
			  EmptyComponent: ReactEmptyComponent.injection,
			  EventPluginHub: EventPluginHub.injection,
			  EventPluginUtils: EventPluginUtils.injection,
			  EventEmitter: ReactBrowserEventEmitter.injection,
			  HostComponent: ReactHostComponent.injection,
			  Updates: ReactUpdates.injection
			};
	
			module.exports = ReactInjection;
	
		/***/ },
		/* 145 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _assign = __webpack_require__(24);
	
			var CallbackQueue = __webpack_require__(32);
			var PooledClass = __webpack_require__(25);
			var ReactBrowserEventEmitter = __webpack_require__(83);
			var ReactInputSelection = __webpack_require__(146);
			var ReactInstrumentation = __webpack_require__(37);
			var Transaction = __webpack_require__(46);
			var ReactUpdateQueue = __webpack_require__(135);
	
			/**
			 * Ensures that, when possible, the selection range (currently selected text
			 * input) is not disturbed by performing the transaction.
			 */
			var SELECTION_RESTORATION = {
			  /**
			   * @return {Selection} Selection information.
			   */
			  initialize: ReactInputSelection.getSelectionInformation,
			  /**
			   * @param {Selection} sel Selection information returned from `initialize`.
			   */
			  close: ReactInputSelection.restoreSelection
			};
	
			/**
			 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
			 * high level DOM manipulations (like temporarily removing a text input from the
			 * DOM).
			 */
			var EVENT_SUPPRESSION = {
			  /**
			   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
			   * the reconciliation.
			   */
			  initialize: function () {
			    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
			    ReactBrowserEventEmitter.setEnabled(false);
			    return currentlyEnabled;
			  },
	
			  /**
			   * @param {boolean} previouslyEnabled Enabled status of
			   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
			   *   restores the previous value.
			   */
			  close: function (previouslyEnabled) {
			    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
			  }
			};
	
			/**
			 * Provides a queue for collecting `componentDidMount` and
			 * `componentDidUpdate` callbacks during the transaction.
			 */
			var ON_DOM_READY_QUEUEING = {
			  /**
			   * Initializes the internal `onDOMReady` queue.
			   */
			  initialize: function () {
			    this.reactMountReady.reset();
			  },
	
			  /**
			   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
			   */
			  close: function () {
			    this.reactMountReady.notifyAll();
			  }
			};
	
			/**
			 * Executed within the scope of the `Transaction` instance. Consider these as
			 * being member methods, but with an implied ordering while being isolated from
			 * each other.
			 */
			var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
			if (process.env.NODE_ENV !== 'production') {
			  TRANSACTION_WRAPPERS.push({
			    initialize: ReactInstrumentation.debugTool.onBeginFlush,
			    close: ReactInstrumentation.debugTool.onEndFlush
			  });
			}
	
			/**
			 * Currently:
			 * - The order that these are listed in the transaction is critical:
			 * - Suppresses events.
			 * - Restores selection range.
			 *
			 * Future:
			 * - Restore document/overflow scroll positions that were unintentionally
			 *   modified via DOM insertions above the top viewport boundary.
			 * - Implement/integrate with customized constraint based layout system and keep
			 *   track of which dimensions must be remeasured.
			 *
			 * @class ReactReconcileTransaction
			 */
			function ReactReconcileTransaction(useCreateElement) {
			  this.reinitializeTransaction();
			  // Only server-side rendering really needs this option (see
			  // `ReactServerRendering`), but server-side uses
			  // `ReactServerRenderingTransaction` instead. This option is here so that it's
			  // accessible and defaults to false when `ReactDOMComponent` and
			  // `ReactDOMTextComponent` checks it in `mountComponent`.`
			  this.renderToStaticMarkup = false;
			  this.reactMountReady = CallbackQueue.getPooled(null);
			  this.useCreateElement = useCreateElement;
			}
	
			var Mixin = {
			  /**
			   * @see Transaction
			   * @abstract
			   * @final
			   * @return {array<object>} List of operation wrap procedures.
			   *   TODO: convert to array<TransactionWrapper>
			   */
			  getTransactionWrappers: function () {
			    return TRANSACTION_WRAPPERS;
			  },
	
			  /**
			   * @return {object} The queue to collect `onDOMReady` callbacks with.
			   */
			  getReactMountReady: function () {
			    return this.reactMountReady;
			  },
	
			  /**
			   * @return {object} The queue to collect React async events.
			   */
			  getUpdateQueue: function () {
			    return ReactUpdateQueue;
			  },
	
			  /**
			   * Save current transaction state -- if the return value from this method is
			   * passed to `rollback`, the transaction will be reset to that state.
			   */
			  checkpoint: function () {
			    // reactMountReady is the our only stateful wrapper
			    return this.reactMountReady.checkpoint();
			  },
	
			  rollback: function (checkpoint) {
			    this.reactMountReady.rollback(checkpoint);
			  },
	
			  /**
			   * `PooledClass` looks for this, and will invoke this before allowing this
			   * instance to be reused.
			   */
			  destructor: function () {
			    CallbackQueue.release(this.reactMountReady);
			    this.reactMountReady = null;
			  }
			};
	
			_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
			PooledClass.addPoolingTo(ReactReconcileTransaction);
	
			module.exports = ReactReconcileTransaction;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 146 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactDOMSelection = __webpack_require__(147);
	
			var containsNode = __webpack_require__(149);
			var focusNode = __webpack_require__(72);
			var getActiveElement = __webpack_require__(152);
	
			function isInDocument(node) {
			  return containsNode(document.documentElement, node);
			}
	
			/**
			 * @ReactInputSelection: React input selection module. Based on Selection.js,
			 * but modified to be suitable for react and has a couple of bug fixes (doesn't
			 * assume buttons have range selections allowed).
			 * Input selection module for React.
			 */
			var ReactInputSelection = {
	
			  hasSelectionCapabilities: function (elem) {
			    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
			    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
			  },
	
			  getSelectionInformation: function () {
			    var focusedElem = getActiveElement();
			    return {
			      focusedElem: focusedElem,
			      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
			    };
			  },
	
			  /**
			   * @restoreSelection: If any selection information was potentially lost,
			   * restore it. This is useful when performing operations that could remove dom
			   * nodes and place them back in, resulting in focus being lost.
			   */
			  restoreSelection: function (priorSelectionInformation) {
			    var curFocusedElem = getActiveElement();
			    var priorFocusedElem = priorSelectionInformation.focusedElem;
			    var priorSelectionRange = priorSelectionInformation.selectionRange;
			    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
			      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
			        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
			      }
			      focusNode(priorFocusedElem);
			    }
			  },
	
			  /**
			   * @getSelection: Gets the selection bounds of a focused textarea, input or
			   * contentEditable node.
			   * -@input: Look up selection bounds of this input
			   * -@return {start: selectionStart, end: selectionEnd}
			   */
			  getSelection: function (input) {
			    var selection;
	
			    if ('selectionStart' in input) {
			      // Modern browser with input or textarea.
			      selection = {
			        start: input.selectionStart,
			        end: input.selectionEnd
			      };
			    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
			      // IE8 input.
			      var range = document.selection.createRange();
			      // There can only be one selection per document in IE, so it must
			      // be in our element.
			      if (range.parentElement() === input) {
			        selection = {
			          start: -range.moveStart('character', -input.value.length),
			          end: -range.moveEnd('character', -input.value.length)
			        };
			      }
			    } else {
			      // Content editable or old IE textarea.
			      selection = ReactDOMSelection.getOffsets(input);
			    }
	
			    return selection || { start: 0, end: 0 };
			  },
	
			  /**
			   * @setSelection: Sets the selection bounds of a textarea or input and focuses
			   * the input.
			   * -@input     Set selection bounds of this input or textarea
			   * -@offsets   Object of same form that is returned from get*
			   */
			  setSelection: function (input, offsets) {
			    var start = offsets.start;
			    var end = offsets.end;
			    if (end === undefined) {
			      end = start;
			    }
	
			    if ('selectionStart' in input) {
			      input.selectionStart = start;
			      input.selectionEnd = Math.min(end, input.value.length);
			    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
			      var range = input.createTextRange();
			      range.collapse(true);
			      range.moveStart('character', start);
			      range.moveEnd('character', end - start);
			      range.select();
			    } else {
			      ReactDOMSelection.setOffsets(input, offsets);
			    }
			  }
			};
	
			module.exports = ReactInputSelection;
	
		/***/ },
		/* 147 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ExecutionEnvironment = __webpack_require__(22);
	
			var getNodeForCharacterOffset = __webpack_require__(148);
			var getTextContentAccessor = __webpack_require__(26);
	
			/**
			 * While `isCollapsed` is available on the Selection object and `collapsed`
			 * is available on the Range object, IE11 sometimes gets them wrong.
			 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
			 */
			function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
			  return anchorNode === focusNode && anchorOffset === focusOffset;
			}
	
			/**
			 * Get the appropriate anchor and focus node/offset pairs for IE.
			 *
			 * The catch here is that IE's selection API doesn't provide information
			 * about whether the selection is forward or backward, so we have to
			 * behave as though it's always forward.
			 *
			 * IE text differs from modern selection in that it behaves as though
			 * block elements end with a new line. This means character offsets will
			 * differ between the two APIs.
			 *
			 * @param {DOMElement} node
			 * @return {object}
			 */
			function getIEOffsets(node) {
			  var selection = document.selection;
			  var selectedRange = selection.createRange();
			  var selectedLength = selectedRange.text.length;
	
			  // Duplicate selection so we can move range without breaking user selection.
			  var fromStart = selectedRange.duplicate();
			  fromStart.moveToElementText(node);
			  fromStart.setEndPoint('EndToStart', selectedRange);
	
			  var startOffset = fromStart.text.length;
			  var endOffset = startOffset + selectedLength;
	
			  return {
			    start: startOffset,
			    end: endOffset
			  };
			}
	
			/**
			 * @param {DOMElement} node
			 * @return {?object}
			 */
			function getModernOffsets(node) {
			  var selection = window.getSelection && window.getSelection();
	
			  if (!selection || selection.rangeCount === 0) {
			    return null;
			  }
	
			  var anchorNode = selection.anchorNode;
			  var anchorOffset = selection.anchorOffset;
			  var focusNode = selection.focusNode;
			  var focusOffset = selection.focusOffset;
	
			  var currentRange = selection.getRangeAt(0);
	
			  // In Firefox, range.startContainer and range.endContainer can be "anonymous
			  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
			  // divs do not seem to expose properties, triggering a "Permission denied
			  // error" if any of its properties are accessed. The only seemingly possible
			  // way to avoid erroring is to access a property that typically works for
			  // non-anonymous divs and catch any error that may otherwise arise. See
			  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
			  try {
			    /* eslint-disable no-unused-expressions */
			    currentRange.startContainer.nodeType;
			    currentRange.endContainer.nodeType;
			    /* eslint-enable no-unused-expressions */
			  } catch (e) {
			    return null;
			  }
	
			  // If the node and offset values are the same, the selection is collapsed.
			  // `Selection.isCollapsed` is available natively, but IE sometimes gets
			  // this value wrong.
			  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
			  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
			  var tempRange = currentRange.cloneRange();
			  tempRange.selectNodeContents(node);
			  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
			  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
			  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
			  var end = start + rangeLength;
	
			  // Detect whether the selection is backward.
			  var detectionRange = document.createRange();
			  detectionRange.setStart(anchorNode, anchorOffset);
			  detectionRange.setEnd(focusNode, focusOffset);
			  var isBackward = detectionRange.collapsed;
	
			  return {
			    start: isBackward ? end : start,
			    end: isBackward ? start : end
			  };
			}
	
			/**
			 * @param {DOMElement|DOMTextNode} node
			 * @param {object} offsets
			 */
			function setIEOffsets(node, offsets) {
			  var range = document.selection.createRange().duplicate();
			  var start, end;
	
			  if (offsets.end === undefined) {
			    start = offsets.start;
			    end = start;
			  } else if (offsets.start > offsets.end) {
			    start = offsets.end;
			    end = offsets.start;
			  } else {
			    start = offsets.start;
			    end = offsets.end;
			  }
	
			  range.moveToElementText(node);
			  range.moveStart('character', start);
			  range.setEndPoint('EndToStart', range);
			  range.moveEnd('character', end - start);
			  range.select();
			}
	
			/**
			 * In modern non-IE browsers, we can support both forward and backward
			 * selections.
			 *
			 * Note: IE10+ supports the Selection object, but it does not support
			 * the `extend` method, which means that even in modern IE, it's not possible
			 * to programmatically create a backward selection. Thus, for all IE
			 * versions, we use the old IE API to create our selections.
			 *
			 * @param {DOMElement|DOMTextNode} node
			 * @param {object} offsets
			 */
			function setModernOffsets(node, offsets) {
			  if (!window.getSelection) {
			    return;
			  }
	
			  var selection = window.getSelection();
			  var length = node[getTextContentAccessor()].length;
			  var start = Math.min(offsets.start, length);
			  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
			  // IE 11 uses modern selection, but doesn't support the extend method.
			  // Flip backward selections, so we can set with a single range.
			  if (!selection.extend && start > end) {
			    var temp = end;
			    end = start;
			    start = temp;
			  }
	
			  var startMarker = getNodeForCharacterOffset(node, start);
			  var endMarker = getNodeForCharacterOffset(node, end);
	
			  if (startMarker && endMarker) {
			    var range = document.createRange();
			    range.setStart(startMarker.node, startMarker.offset);
			    selection.removeAllRanges();
	
			    if (start > end) {
			      selection.addRange(range);
			      selection.extend(endMarker.node, endMarker.offset);
			    } else {
			      range.setEnd(endMarker.node, endMarker.offset);
			      selection.addRange(range);
			    }
			  }
			}
	
			var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
			var ReactDOMSelection = {
			  /**
			   * @param {DOMElement} node
			   */
			  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
			  /**
			   * @param {DOMElement|DOMTextNode} node
			   * @param {object} offsets
			   */
			  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
			};
	
			module.exports = ReactDOMSelection;
	
		/***/ },
		/* 148 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * Given any node return the first leaf node without children.
			 *
			 * @param {DOMElement|DOMTextNode} node
			 * @return {DOMElement|DOMTextNode}
			 */
	
			function getLeafNode(node) {
			  while (node && node.firstChild) {
			    node = node.firstChild;
			  }
			  return node;
			}
	
			/**
			 * Get the next sibling within a container. This will walk up the
			 * DOM if a node's siblings have been exhausted.
			 *
			 * @param {DOMElement|DOMTextNode} node
			 * @return {?DOMElement|DOMTextNode}
			 */
			function getSiblingNode(node) {
			  while (node) {
			    if (node.nextSibling) {
			      return node.nextSibling;
			    }
			    node = node.parentNode;
			  }
			}
	
			/**
			 * Get object describing the nodes which contain characters at offset.
			 *
			 * @param {DOMElement|DOMTextNode} root
			 * @param {number} offset
			 * @return {?object}
			 */
			function getNodeForCharacterOffset(root, offset) {
			  var node = getLeafNode(root);
			  var nodeStart = 0;
			  var nodeEnd = 0;
	
			  while (node) {
			    if (node.nodeType === 3) {
			      nodeEnd = nodeStart + node.textContent.length;
	
			      if (nodeStart <= offset && nodeEnd >= offset) {
			        return {
			          node: node,
			          offset: offset - nodeStart
			        };
			      }
	
			      nodeStart = nodeEnd;
			    }
	
			    node = getLeafNode(getSiblingNode(node));
			  }
			}
	
			module.exports = getNodeForCharacterOffset;
	
		/***/ },
		/* 149 */
		/***/ function(module, exports, __webpack_require__) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			var isTextNode = __webpack_require__(150);
	
			/*eslint-disable no-bitwise */
	
			/**
			 * Checks if a given DOM node contains or is another DOM node.
			 */
			function containsNode(outerNode, innerNode) {
			  if (!outerNode || !innerNode) {
			    return false;
			  } else if (outerNode === innerNode) {
			    return true;
			  } else if (isTextNode(outerNode)) {
			    return false;
			  } else if (isTextNode(innerNode)) {
			    return containsNode(outerNode, innerNode.parentNode);
			  } else if ('contains' in outerNode) {
			    return outerNode.contains(innerNode);
			  } else if (outerNode.compareDocumentPosition) {
			    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
			  } else {
			    return false;
			  }
			}
	
			module.exports = containsNode;
	
		/***/ },
		/* 150 */
		/***/ function(module, exports, __webpack_require__) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			var isNode = __webpack_require__(151);
	
			/**
			 * @param {*} object The object to check.
			 * @return {boolean} Whether or not the object is a DOM text node.
			 */
			function isTextNode(object) {
			  return isNode(object) && object.nodeType == 3;
			}
	
			module.exports = isTextNode;
	
		/***/ },
		/* 151 */
		/***/ function(module, exports) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			/**
			 * @param {*} object The object to check.
			 * @return {boolean} Whether or not the object is a DOM node.
			 */
			function isNode(object) {
			  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
			}
	
			module.exports = isNode;
	
		/***/ },
		/* 152 */
		/***/ function(module, exports) {
	
			'use strict';
	
			/**
			 * Copyright (c) 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * @typechecks
			 */
	
			/* eslint-disable fb-www/typeof-undefined */
	
			/**
			 * Same as document.activeElement but wraps in a try-catch block. In IE it is
			 * not safe to call document.activeElement if there is nothing focused.
			 *
			 * The activeElement will be null only if the document or document body is not
			 * yet defined.
			 */
			function getActiveElement() /*?DOMElement*/{
			  if (typeof document === 'undefined') {
			    return null;
			  }
			  try {
			    return document.activeElement || document.body;
			  } catch (e) {
			    return document.body;
			  }
			}
	
			module.exports = getActiveElement;
	
		/***/ },
		/* 153 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var NS = {
			  xlink: 'http://www.w3.org/1999/xlink',
			  xml: 'http://www.w3.org/XML/1998/namespace'
			};
	
			// We use attributes for everything SVG so let's avoid some duplication and run
			// code instead.
			// The following are all specified in the HTML config already so we exclude here.
			// - class (as className)
			// - color
			// - height
			// - id
			// - lang
			// - max
			// - media
			// - method
			// - min
			// - name
			// - style
			// - target
			// - type
			// - width
			var ATTRS = {
			  accentHeight: 'accent-height',
			  accumulate: 0,
			  additive: 0,
			  alignmentBaseline: 'alignment-baseline',
			  allowReorder: 'allowReorder',
			  alphabetic: 0,
			  amplitude: 0,
			  arabicForm: 'arabic-form',
			  ascent: 0,
			  attributeName: 'attributeName',
			  attributeType: 'attributeType',
			  autoReverse: 'autoReverse',
			  azimuth: 0,
			  baseFrequency: 'baseFrequency',
			  baseProfile: 'baseProfile',
			  baselineShift: 'baseline-shift',
			  bbox: 0,
			  begin: 0,
			  bias: 0,
			  by: 0,
			  calcMode: 'calcMode',
			  capHeight: 'cap-height',
			  clip: 0,
			  clipPath: 'clip-path',
			  clipRule: 'clip-rule',
			  clipPathUnits: 'clipPathUnits',
			  colorInterpolation: 'color-interpolation',
			  colorInterpolationFilters: 'color-interpolation-filters',
			  colorProfile: 'color-profile',
			  colorRendering: 'color-rendering',
			  contentScriptType: 'contentScriptType',
			  contentStyleType: 'contentStyleType',
			  cursor: 0,
			  cx: 0,
			  cy: 0,
			  d: 0,
			  decelerate: 0,
			  descent: 0,
			  diffuseConstant: 'diffuseConstant',
			  direction: 0,
			  display: 0,
			  divisor: 0,
			  dominantBaseline: 'dominant-baseline',
			  dur: 0,
			  dx: 0,
			  dy: 0,
			  edgeMode: 'edgeMode',
			  elevation: 0,
			  enableBackground: 'enable-background',
			  end: 0,
			  exponent: 0,
			  externalResourcesRequired: 'externalResourcesRequired',
			  fill: 0,
			  fillOpacity: 'fill-opacity',
			  fillRule: 'fill-rule',
			  filter: 0,
			  filterRes: 'filterRes',
			  filterUnits: 'filterUnits',
			  floodColor: 'flood-color',
			  floodOpacity: 'flood-opacity',
			  focusable: 0,
			  fontFamily: 'font-family',
			  fontSize: 'font-size',
			  fontSizeAdjust: 'font-size-adjust',
			  fontStretch: 'font-stretch',
			  fontStyle: 'font-style',
			  fontVariant: 'font-variant',
			  fontWeight: 'font-weight',
			  format: 0,
			  from: 0,
			  fx: 0,
			  fy: 0,
			  g1: 0,
			  g2: 0,
			  glyphName: 'glyph-name',
			  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
			  glyphOrientationVertical: 'glyph-orientation-vertical',
			  glyphRef: 'glyphRef',
			  gradientTransform: 'gradientTransform',
			  gradientUnits: 'gradientUnits',
			  hanging: 0,
			  horizAdvX: 'horiz-adv-x',
			  horizOriginX: 'horiz-origin-x',
			  ideographic: 0,
			  imageRendering: 'image-rendering',
			  'in': 0,
			  in2: 0,
			  intercept: 0,
			  k: 0,
			  k1: 0,
			  k2: 0,
			  k3: 0,
			  k4: 0,
			  kernelMatrix: 'kernelMatrix',
			  kernelUnitLength: 'kernelUnitLength',
			  kerning: 0,
			  keyPoints: 'keyPoints',
			  keySplines: 'keySplines',
			  keyTimes: 'keyTimes',
			  lengthAdjust: 'lengthAdjust',
			  letterSpacing: 'letter-spacing',
			  lightingColor: 'lighting-color',
			  limitingConeAngle: 'limitingConeAngle',
			  local: 0,
			  markerEnd: 'marker-end',
			  markerMid: 'marker-mid',
			  markerStart: 'marker-start',
			  markerHeight: 'markerHeight',
			  markerUnits: 'markerUnits',
			  markerWidth: 'markerWidth',
			  mask: 0,
			  maskContentUnits: 'maskContentUnits',
			  maskUnits: 'maskUnits',
			  mathematical: 0,
			  mode: 0,
			  numOctaves: 'numOctaves',
			  offset: 0,
			  opacity: 0,
			  operator: 0,
			  order: 0,
			  orient: 0,
			  orientation: 0,
			  origin: 0,
			  overflow: 0,
			  overlinePosition: 'overline-position',
			  overlineThickness: 'overline-thickness',
			  paintOrder: 'paint-order',
			  panose1: 'panose-1',
			  pathLength: 'pathLength',
			  patternContentUnits: 'patternContentUnits',
			  patternTransform: 'patternTransform',
			  patternUnits: 'patternUnits',
			  pointerEvents: 'pointer-events',
			  points: 0,
			  pointsAtX: 'pointsAtX',
			  pointsAtY: 'pointsAtY',
			  pointsAtZ: 'pointsAtZ',
			  preserveAlpha: 'preserveAlpha',
			  preserveAspectRatio: 'preserveAspectRatio',
			  primitiveUnits: 'primitiveUnits',
			  r: 0,
			  radius: 0,
			  refX: 'refX',
			  refY: 'refY',
			  renderingIntent: 'rendering-intent',
			  repeatCount: 'repeatCount',
			  repeatDur: 'repeatDur',
			  requiredExtensions: 'requiredExtensions',
			  requiredFeatures: 'requiredFeatures',
			  restart: 0,
			  result: 0,
			  rotate: 0,
			  rx: 0,
			  ry: 0,
			  scale: 0,
			  seed: 0,
			  shapeRendering: 'shape-rendering',
			  slope: 0,
			  spacing: 0,
			  specularConstant: 'specularConstant',
			  specularExponent: 'specularExponent',
			  speed: 0,
			  spreadMethod: 'spreadMethod',
			  startOffset: 'startOffset',
			  stdDeviation: 'stdDeviation',
			  stemh: 0,
			  stemv: 0,
			  stitchTiles: 'stitchTiles',
			  stopColor: 'stop-color',
			  stopOpacity: 'stop-opacity',
			  strikethroughPosition: 'strikethrough-position',
			  strikethroughThickness: 'strikethrough-thickness',
			  string: 0,
			  stroke: 0,
			  strokeDasharray: 'stroke-dasharray',
			  strokeDashoffset: 'stroke-dashoffset',
			  strokeLinecap: 'stroke-linecap',
			  strokeLinejoin: 'stroke-linejoin',
			  strokeMiterlimit: 'stroke-miterlimit',
			  strokeOpacity: 'stroke-opacity',
			  strokeWidth: 'stroke-width',
			  surfaceScale: 'surfaceScale',
			  systemLanguage: 'systemLanguage',
			  tableValues: 'tableValues',
			  targetX: 'targetX',
			  targetY: 'targetY',
			  textAnchor: 'text-anchor',
			  textDecoration: 'text-decoration',
			  textRendering: 'text-rendering',
			  textLength: 'textLength',
			  to: 0,
			  transform: 0,
			  u1: 0,
			  u2: 0,
			  underlinePosition: 'underline-position',
			  underlineThickness: 'underline-thickness',
			  unicode: 0,
			  unicodeBidi: 'unicode-bidi',
			  unicodeRange: 'unicode-range',
			  unitsPerEm: 'units-per-em',
			  vAlphabetic: 'v-alphabetic',
			  vHanging: 'v-hanging',
			  vIdeographic: 'v-ideographic',
			  vMathematical: 'v-mathematical',
			  values: 0,
			  vectorEffect: 'vector-effect',
			  version: 0,
			  vertAdvY: 'vert-adv-y',
			  vertOriginX: 'vert-origin-x',
			  vertOriginY: 'vert-origin-y',
			  viewBox: 'viewBox',
			  viewTarget: 'viewTarget',
			  visibility: 0,
			  widths: 0,
			  wordSpacing: 'word-spacing',
			  writingMode: 'writing-mode',
			  x: 0,
			  xHeight: 'x-height',
			  x1: 0,
			  x2: 0,
			  xChannelSelector: 'xChannelSelector',
			  xlinkActuate: 'xlink:actuate',
			  xlinkArcrole: 'xlink:arcrole',
			  xlinkHref: 'xlink:href',
			  xlinkRole: 'xlink:role',
			  xlinkShow: 'xlink:show',
			  xlinkTitle: 'xlink:title',
			  xlinkType: 'xlink:type',
			  xmlBase: 'xml:base',
			  xmlns: 0,
			  xmlnsXlink: 'xmlns:xlink',
			  xmlLang: 'xml:lang',
			  xmlSpace: 'xml:space',
			  y: 0,
			  y1: 0,
			  y2: 0,
			  yChannelSelector: 'yChannelSelector',
			  z: 0,
			  zoomAndPan: 'zoomAndPan'
			};
	
			var SVGDOMPropertyConfig = {
			  Properties: {},
			  DOMAttributeNamespaces: {
			    xlinkActuate: NS.xlink,
			    xlinkArcrole: NS.xlink,
			    xlinkHref: NS.xlink,
			    xlinkRole: NS.xlink,
			    xlinkShow: NS.xlink,
			    xlinkTitle: NS.xlink,
			    xlinkType: NS.xlink,
			    xmlBase: NS.xml,
			    xmlLang: NS.xml,
			    xmlSpace: NS.xml
			  },
			  DOMAttributeNames: {}
			};
	
			Object.keys(ATTRS).forEach(function (key) {
			  SVGDOMPropertyConfig.Properties[key] = 0;
			  if (ATTRS[key]) {
			    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
			  }
			});
	
			module.exports = SVGDOMPropertyConfig;
	
		/***/ },
		/* 154 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var EventPropagators = __webpack_require__(13);
			var ExecutionEnvironment = __webpack_require__(22);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactInputSelection = __webpack_require__(146);
			var SyntheticEvent = __webpack_require__(28);
	
			var getActiveElement = __webpack_require__(152);
			var isTextInputElement = __webpack_require__(49);
			var shallowEqual = __webpack_require__(123);
	
			var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
			var eventTypes = {
			  select: {
			    phasedRegistrationNames: {
			      bubbled: 'onSelect',
			      captured: 'onSelectCapture'
			    },
			    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
			  }
			};
	
			var activeElement = null;
			var activeElementInst = null;
			var lastSelection = null;
			var mouseDown = false;
	
			// Track whether a listener exists for this plugin. If none exist, we do
			// not extract events. See #3639.
			var hasListener = false;
	
			/**
			 * Get an object which is a unique representation of the current selection.
			 *
			 * The return value will not be consistent across nodes or browsers, but
			 * two identical selections on the same node will return identical objects.
			 *
			 * @param {DOMElement} node
			 * @return {object}
			 */
			function getSelection(node) {
			  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
			    return {
			      start: node.selectionStart,
			      end: node.selectionEnd
			    };
			  } else if (window.getSelection) {
			    var selection = window.getSelection();
			    return {
			      anchorNode: selection.anchorNode,
			      anchorOffset: selection.anchorOffset,
			      focusNode: selection.focusNode,
			      focusOffset: selection.focusOffset
			    };
			  } else if (document.selection) {
			    var range = document.selection.createRange();
			    return {
			      parentElement: range.parentElement(),
			      text: range.text,
			      top: range.boundingTop,
			      left: range.boundingLeft
			    };
			  }
			}
	
			/**
			 * Poll selection to see whether it's changed.
			 *
			 * @param {object} nativeEvent
			 * @return {?SyntheticEvent}
			 */
			function constructSelectEvent(nativeEvent, nativeEventTarget) {
			  // Ensure we have the right element, and that the user is not dragging a
			  // selection (this matches native `select` event behavior). In HTML5, select
			  // fires only on input and textarea thus if there's no focused element we
			  // won't dispatch.
			  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
			    return null;
			  }
	
			  // Only fire when selection has actually changed.
			  var currentSelection = getSelection(activeElement);
			  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
			    lastSelection = currentSelection;
	
			    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
			    syntheticEvent.type = 'select';
			    syntheticEvent.target = activeElement;
	
			    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
			    return syntheticEvent;
			  }
	
			  return null;
			}
	
			/**
			 * This plugin creates an `onSelect` event that normalizes select events
			 * across form elements.
			 *
			 * Supported elements are:
			 * - input (see `isTextInputElement`)
			 * - textarea
			 * - contentEditable
			 *
			 * This differs from native browser implementations in the following ways:
			 * - Fires on contentEditable fields as well as inputs.
			 * - Fires for collapsed selection.
			 * - Fires after user input.
			 */
			var SelectEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    if (!hasListener) {
			      return null;
			    }
	
			    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
			    switch (topLevelType) {
			      // Track the input node that has focus.
			      case 'topFocus':
			        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
			          activeElement = targetNode;
			          activeElementInst = targetInst;
			          lastSelection = null;
			        }
			        break;
			      case 'topBlur':
			        activeElement = null;
			        activeElementInst = null;
			        lastSelection = null;
			        break;
	
			      // Don't fire the event while the user is dragging. This matches the
			      // semantics of the native select event.
			      case 'topMouseDown':
			        mouseDown = true;
			        break;
			      case 'topContextMenu':
			      case 'topMouseUp':
			        mouseDown = false;
			        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
			      // Chrome and IE fire non-standard event when selection is changed (and
			      // sometimes when it hasn't). IE's event fires out of order with respect
			      // to key and input events on deletion, so we discard it.
			      //
			      // Firefox doesn't support selectionchange, so check selection status
			      // after each key entry. The selection changes after keydown and before
			      // keyup, but we check on keydown as well in the case of holding down a
			      // key, when multiple keydown events are fired but only one keyup is.
			      // This is also our approach for IE handling, for the reason above.
			      case 'topSelectionChange':
			        if (skipSelectionChangeEvent) {
			          break;
			        }
			      // falls through
			      case 'topKeyDown':
			      case 'topKeyUp':
			        return constructSelectEvent(nativeEvent, nativeEventTarget);
			    }
	
			    return null;
			  },
	
			  didPutListener: function (inst, registrationName, listener) {
			    if (registrationName === 'onSelect') {
			      hasListener = true;
			    }
			  }
			};
	
			module.exports = SelectEventPlugin;
	
		/***/ },
		/* 155 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var EventListener = __webpack_require__(142);
			var EventPropagators = __webpack_require__(13);
			var ReactDOMComponentTree = __webpack_require__(5);
			var SyntheticAnimationEvent = __webpack_require__(156);
			var SyntheticClipboardEvent = __webpack_require__(157);
			var SyntheticEvent = __webpack_require__(28);
			var SyntheticFocusEvent = __webpack_require__(158);
			var SyntheticKeyboardEvent = __webpack_require__(159);
			var SyntheticMouseEvent = __webpack_require__(52);
			var SyntheticDragEvent = __webpack_require__(162);
			var SyntheticTouchEvent = __webpack_require__(163);
			var SyntheticTransitionEvent = __webpack_require__(164);
			var SyntheticUIEvent = __webpack_require__(53);
			var SyntheticWheelEvent = __webpack_require__(165);
	
			var emptyFunction = __webpack_require__(19);
			var getEventCharCode = __webpack_require__(160);
			var invariant = __webpack_require__(8);
	
			/**
			 * Turns
			 * ['abort', ...]
			 * into
			 * eventTypes = {
			 *   'abort': {
			 *     phasedRegistrationNames: {
			 *       bubbled: 'onAbort',
			 *       captured: 'onAbortCapture',
			 *     },
			 *     dependencies: ['topAbort'],
			 *   },
			 *   ...
			 * };
			 * topLevelEventsToDispatchConfig = {
			 *   'topAbort': { sameConfig }
			 * };
			 */
			var eventTypes = {};
			var topLevelEventsToDispatchConfig = {};
			['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
			  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
			  var onEvent = 'on' + capitalizedEvent;
			  var topEvent = 'top' + capitalizedEvent;
	
			  var type = {
			    phasedRegistrationNames: {
			      bubbled: onEvent,
			      captured: onEvent + 'Capture'
			    },
			    dependencies: [topEvent]
			  };
			  eventTypes[event] = type;
			  topLevelEventsToDispatchConfig[topEvent] = type;
			});
	
			var onClickListeners = {};
	
			function getDictionaryKey(inst) {
			  // Prevents V8 performance issue:
			  // https://github.com/facebook/react/pull/7232
			  return '.' + inst._rootNodeID;
			}
	
			function isInteractive(tag) {
			  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
			}
	
			var SimpleEventPlugin = {
	
			  eventTypes: eventTypes,
	
			  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
			    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
			    if (!dispatchConfig) {
			      return null;
			    }
			    var EventConstructor;
			    switch (topLevelType) {
			      case 'topAbort':
			      case 'topCanPlay':
			      case 'topCanPlayThrough':
			      case 'topDurationChange':
			      case 'topEmptied':
			      case 'topEncrypted':
			      case 'topEnded':
			      case 'topError':
			      case 'topInput':
			      case 'topInvalid':
			      case 'topLoad':
			      case 'topLoadedData':
			      case 'topLoadedMetadata':
			      case 'topLoadStart':
			      case 'topPause':
			      case 'topPlay':
			      case 'topPlaying':
			      case 'topProgress':
			      case 'topRateChange':
			      case 'topReset':
			      case 'topSeeked':
			      case 'topSeeking':
			      case 'topStalled':
			      case 'topSubmit':
			      case 'topSuspend':
			      case 'topTimeUpdate':
			      case 'topVolumeChange':
			      case 'topWaiting':
			        // HTML Events
			        // @see http://www.w3.org/TR/html5/index.html#events-0
			        EventConstructor = SyntheticEvent;
			        break;
			      case 'topKeyPress':
			        // Firefox creates a keypress event for function keys too. This removes
			        // the unwanted keypress events. Enter is however both printable and
			        // non-printable. One would expect Tab to be as well (but it isn't).
			        if (getEventCharCode(nativeEvent) === 0) {
			          return null;
			        }
			      /* falls through */
			      case 'topKeyDown':
			      case 'topKeyUp':
			        EventConstructor = SyntheticKeyboardEvent;
			        break;
			      case 'topBlur':
			      case 'topFocus':
			        EventConstructor = SyntheticFocusEvent;
			        break;
			      case 'topClick':
			        // Firefox creates a click event on right mouse clicks. This removes the
			        // unwanted click events.
			        if (nativeEvent.button === 2) {
			          return null;
			        }
			      /* falls through */
			      case 'topDoubleClick':
			      case 'topMouseDown':
			      case 'topMouseMove':
			      case 'topMouseUp':
			      // TODO: Disabled elements should not respond to mouse events
			      /* falls through */
			      case 'topMouseOut':
			      case 'topMouseOver':
			      case 'topContextMenu':
			        EventConstructor = SyntheticMouseEvent;
			        break;
			      case 'topDrag':
			      case 'topDragEnd':
			      case 'topDragEnter':
			      case 'topDragExit':
			      case 'topDragLeave':
			      case 'topDragOver':
			      case 'topDragStart':
			      case 'topDrop':
			        EventConstructor = SyntheticDragEvent;
			        break;
			      case 'topTouchCancel':
			      case 'topTouchEnd':
			      case 'topTouchMove':
			      case 'topTouchStart':
			        EventConstructor = SyntheticTouchEvent;
			        break;
			      case 'topAnimationEnd':
			      case 'topAnimationIteration':
			      case 'topAnimationStart':
			        EventConstructor = SyntheticAnimationEvent;
			        break;
			      case 'topTransitionEnd':
			        EventConstructor = SyntheticTransitionEvent;
			        break;
			      case 'topScroll':
			        EventConstructor = SyntheticUIEvent;
			        break;
			      case 'topWheel':
			        EventConstructor = SyntheticWheelEvent;
			        break;
			      case 'topCopy':
			      case 'topCut':
			      case 'topPaste':
			        EventConstructor = SyntheticClipboardEvent;
			        break;
			    }
			    !EventConstructor ? process.env.NODE_ENV !== 'production' ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
			    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
			    EventPropagators.accumulateTwoPhaseDispatches(event);
			    return event;
			  },
	
			  didPutListener: function (inst, registrationName, listener) {
			    // Mobile Safari does not fire properly bubble click events on
			    // non-interactive elements, which means delegated click listeners do not
			    // fire. The workaround for this bug involves attaching an empty click
			    // listener on the target node.
			    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
			    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
			      var key = getDictionaryKey(inst);
			      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
			      if (!onClickListeners[key]) {
			        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
			      }
			    }
			  },
	
			  willDeleteListener: function (inst, registrationName) {
			    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
			      var key = getDictionaryKey(inst);
			      onClickListeners[key].remove();
			      delete onClickListeners[key];
			    }
			  }
	
			};
	
			module.exports = SimpleEventPlugin;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 156 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
			 */
			var AnimationEventInterface = {
			  animationName: null,
			  elapsedTime: null,
			  pseudoElement: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticEvent}
			 */
			function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
			module.exports = SyntheticAnimationEvent;
	
		/***/ },
		/* 157 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/clipboard-apis/
			 */
			var ClipboardEventInterface = {
			  clipboardData: function (event) {
			    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
			  }
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
			module.exports = SyntheticClipboardEvent;
	
		/***/ },
		/* 158 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticUIEvent = __webpack_require__(53);
	
			/**
			 * @interface FocusEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var FocusEventInterface = {
			  relatedTarget: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
			module.exports = SyntheticFocusEvent;
	
		/***/ },
		/* 159 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticUIEvent = __webpack_require__(53);
	
			var getEventCharCode = __webpack_require__(160);
			var getEventKey = __webpack_require__(161);
			var getEventModifierState = __webpack_require__(55);
	
			/**
			 * @interface KeyboardEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var KeyboardEventInterface = {
			  key: getEventKey,
			  location: null,
			  ctrlKey: null,
			  shiftKey: null,
			  altKey: null,
			  metaKey: null,
			  repeat: null,
			  locale: null,
			  getModifierState: getEventModifierState,
			  // Legacy Interface
			  charCode: function (event) {
			    // `charCode` is the result of a KeyPress event and represents the value of
			    // the actual printable character.
	
			    // KeyPress is deprecated, but its replacement is not yet final and not
			    // implemented in any major browser. Only KeyPress has charCode.
			    if (event.type === 'keypress') {
			      return getEventCharCode(event);
			    }
			    return 0;
			  },
			  keyCode: function (event) {
			    // `keyCode` is the result of a KeyDown/Up event and represents the value of
			    // physical keyboard key.
	
			    // The actual meaning of the value depends on the users' keyboard layout
			    // which cannot be detected. Assuming that it is a US keyboard layout
			    // provides a surprisingly accurate mapping for US and European users.
			    // Due to this, it is left to the user to implement at this time.
			    if (event.type === 'keydown' || event.type === 'keyup') {
			      return event.keyCode;
			    }
			    return 0;
			  },
			  which: function (event) {
			    // `which` is an alias for either `keyCode` or `charCode` depending on the
			    // type of the event.
			    if (event.type === 'keypress') {
			      return getEventCharCode(event);
			    }
			    if (event.type === 'keydown' || event.type === 'keyup') {
			      return event.keyCode;
			    }
			    return 0;
			  }
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
			module.exports = SyntheticKeyboardEvent;
	
		/***/ },
		/* 160 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			/**
			 * `charCode` represents the actual "character code" and is safe to use with
			 * `String.fromCharCode`. As such, only keys that correspond to printable
			 * characters produce a valid `charCode`, the only exception to this is Enter.
			 * The Tab-key is considered non-printable and does not have a `charCode`,
			 * presumably because it does not produce a tab-character in browsers.
			 *
			 * @param {object} nativeEvent Native browser event.
			 * @return {number} Normalized `charCode` property.
			 */
	
			function getEventCharCode(nativeEvent) {
			  var charCode;
			  var keyCode = nativeEvent.keyCode;
	
			  if ('charCode' in nativeEvent) {
			    charCode = nativeEvent.charCode;
	
			    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
			    if (charCode === 0 && keyCode === 13) {
			      charCode = 13;
			    }
			  } else {
			    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
			    charCode = keyCode;
			  }
	
			  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
			  // Must not discard the (non-)printable Enter-key.
			  if (charCode >= 32 || charCode === 13) {
			    return charCode;
			  }
	
			  return 0;
			}
	
			module.exports = getEventCharCode;
	
		/***/ },
		/* 161 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var getEventCharCode = __webpack_require__(160);
	
			/**
			 * Normalization of deprecated HTML5 `key` values
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
			 */
			var normalizeKey = {
			  'Esc': 'Escape',
			  'Spacebar': ' ',
			  'Left': 'ArrowLeft',
			  'Up': 'ArrowUp',
			  'Right': 'ArrowRight',
			  'Down': 'ArrowDown',
			  'Del': 'Delete',
			  'Win': 'OS',
			  'Menu': 'ContextMenu',
			  'Apps': 'ContextMenu',
			  'Scroll': 'ScrollLock',
			  'MozPrintableKey': 'Unidentified'
			};
	
			/**
			 * Translation from legacy `keyCode` to HTML5 `key`
			 * Only special keys supported, all others depend on keyboard layout or browser
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
			 */
			var translateToKey = {
			  8: 'Backspace',
			  9: 'Tab',
			  12: 'Clear',
			  13: 'Enter',
			  16: 'Shift',
			  17: 'Control',
			  18: 'Alt',
			  19: 'Pause',
			  20: 'CapsLock',
			  27: 'Escape',
			  32: ' ',
			  33: 'PageUp',
			  34: 'PageDown',
			  35: 'End',
			  36: 'Home',
			  37: 'ArrowLeft',
			  38: 'ArrowUp',
			  39: 'ArrowRight',
			  40: 'ArrowDown',
			  45: 'Insert',
			  46: 'Delete',
			  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
			  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
			  144: 'NumLock',
			  145: 'ScrollLock',
			  224: 'Meta'
			};
	
			/**
			 * @param {object} nativeEvent Native browser event.
			 * @return {string} Normalized `key` property.
			 */
			function getEventKey(nativeEvent) {
			  if (nativeEvent.key) {
			    // Normalize inconsistent values reported by browsers due to
			    // implementations of a working draft specification.
	
			    // FireFox implements `key` but returns `MozPrintableKey` for all
			    // printable characters (normalized to `Unidentified`), ignore it.
			    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
			    if (key !== 'Unidentified') {
			      return key;
			    }
			  }
	
			  // Browser does not implement `key`, polyfill as much of it as we can.
			  if (nativeEvent.type === 'keypress') {
			    var charCode = getEventCharCode(nativeEvent);
	
			    // The enter-key is technically both printable and non-printable and can
			    // thus be captured by `keypress`, no other non-printable key should.
			    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
			  }
			  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
			    // While user keyboard layout determines the actual meaning of each
			    // `keyCode` value, almost all function keys have a universal value.
			    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
			  }
			  return '';
			}
	
			module.exports = getEventKey;
	
		/***/ },
		/* 162 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticMouseEvent = __webpack_require__(52);
	
			/**
			 * @interface DragEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var DragEventInterface = {
			  dataTransfer: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
			module.exports = SyntheticDragEvent;
	
		/***/ },
		/* 163 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticUIEvent = __webpack_require__(53);
	
			var getEventModifierState = __webpack_require__(55);
	
			/**
			 * @interface TouchEvent
			 * @see http://www.w3.org/TR/touch-events/
			 */
			var TouchEventInterface = {
			  touches: null,
			  targetTouches: null,
			  changedTouches: null,
			  altKey: null,
			  metaKey: null,
			  ctrlKey: null,
			  shiftKey: null,
			  getModifierState: getEventModifierState
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticUIEvent}
			 */
			function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
			module.exports = SyntheticTouchEvent;
	
		/***/ },
		/* 164 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticEvent = __webpack_require__(28);
	
			/**
			 * @interface Event
			 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
			 */
			var TransitionEventInterface = {
			  propertyName: null,
			  elapsedTime: null,
			  pseudoElement: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticEvent}
			 */
			function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
			module.exports = SyntheticTransitionEvent;
	
		/***/ },
		/* 165 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var SyntheticMouseEvent = __webpack_require__(52);
	
			/**
			 * @interface WheelEvent
			 * @see http://www.w3.org/TR/DOM-Level-3-Events/
			 */
			var WheelEventInterface = {
			  deltaX: function (event) {
			    return 'deltaX' in event ? event.deltaX :
			    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
			    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
			  },
			  deltaY: function (event) {
			    return 'deltaY' in event ? event.deltaY :
			    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
			    'wheelDeltaY' in event ? -event.wheelDeltaY :
			    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
			    'wheelDelta' in event ? -event.wheelDelta : 0;
			  },
			  deltaZ: null,
	
			  // Browsers without "deltaMode" is reporting in raw wheel delta where one
			  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
			  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
			  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
			  deltaMode: null
			};
	
			/**
			 * @param {object} dispatchConfig Configuration used to dispatch this event.
			 * @param {string} dispatchMarker Marker identifying the event target.
			 * @param {object} nativeEvent Native browser event.
			 * @extends {SyntheticMouseEvent}
			 */
			function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
			  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
			}
	
			SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
			module.exports = SyntheticWheelEvent;
	
		/***/ },
		/* 166 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var DOMLazyTree = __webpack_require__(59);
			var DOMProperty = __webpack_require__(7);
			var React = __webpack_require__(88);
			var ReactBrowserEventEmitter = __webpack_require__(83);
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactDOMContainerInfo = __webpack_require__(167);
			var ReactDOMFeatureFlags = __webpack_require__(168);
			var ReactFeatureFlags = __webpack_require__(33);
			var ReactInstanceMap = __webpack_require__(116);
			var ReactInstrumentation = __webpack_require__(37);
			var ReactMarkupChecksum = __webpack_require__(169);
			var ReactReconciler = __webpack_require__(34);
			var ReactUpdateQueue = __webpack_require__(135);
			var ReactUpdates = __webpack_require__(31);
	
			var emptyObject = __webpack_require__(99);
			var instantiateReactComponent = __webpack_require__(118);
			var invariant = __webpack_require__(8);
			var setInnerHTML = __webpack_require__(61);
			var shouldUpdateReactComponent = __webpack_require__(124);
			var warning = __webpack_require__(18);
	
			var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
			var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
			var ELEMENT_NODE_TYPE = 1;
			var DOC_NODE_TYPE = 9;
			var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
			var instancesByReactRootID = {};
	
			/**
			 * Finds the index of the first character
			 * that's not common between the two given strings.
			 *
			 * @return {number} the index of the character where the strings diverge
			 */
			function firstDifferenceIndex(string1, string2) {
			  var minLen = Math.min(string1.length, string2.length);
			  for (var i = 0; i < minLen; i++) {
			    if (string1.charAt(i) !== string2.charAt(i)) {
			      return i;
			    }
			  }
			  return string1.length === string2.length ? -1 : minLen;
			}
	
			/**
			 * @param {DOMElement|DOMDocument} container DOM element that may contain
			 * a React component
			 * @return {?*} DOM element that may have the reactRoot ID, or null.
			 */
			function getReactRootElementInContainer(container) {
			  if (!container) {
			    return null;
			  }
	
			  if (container.nodeType === DOC_NODE_TYPE) {
			    return container.documentElement;
			  } else {
			    return container.firstChild;
			  }
			}
	
			function internalGetID(node) {
			  // If node is something like a window, document, or text node, none of
			  // which support attributes or a .getAttribute method, gracefully return
			  // the empty string, as if the attribute were missing.
			  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
			}
	
			/**
			 * Mounts this component and inserts it into the DOM.
			 *
			 * @param {ReactComponent} componentInstance The instance to mount.
			 * @param {DOMElement} container DOM element to mount into.
			 * @param {ReactReconcileTransaction} transaction
			 * @param {boolean} shouldReuseMarkup If true, do not insert markup
			 */
			function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
			  var markerName;
			  if (ReactFeatureFlags.logTopLevelRenders) {
			    var wrappedElement = wrapperInstance._currentElement.props.child;
			    var type = wrappedElement.type;
			    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
			    console.time(markerName);
			  }
	
			  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
			  );
	
			  if (markerName) {
			    console.timeEnd(markerName);
			  }
	
			  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
			  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
			}
	
			/**
			 * Batched mount.
			 *
			 * @param {ReactComponent} componentInstance The instance to mount.
			 * @param {DOMElement} container DOM element to mount into.
			 * @param {boolean} shouldReuseMarkup If true, do not insert markup
			 */
			function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
			  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
			  /* useCreateElement */
			  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
			  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
			  ReactUpdates.ReactReconcileTransaction.release(transaction);
			}
	
			/**
			 * Unmounts a component and removes it from the DOM.
			 *
			 * @param {ReactComponent} instance React component instance.
			 * @param {DOMElement} container DOM element to unmount from.
			 * @final
			 * @internal
			 * @see {ReactMount.unmountComponentAtNode}
			 */
			function unmountComponentFromNode(instance, container, safely) {
			  if (process.env.NODE_ENV !== 'production') {
			    ReactInstrumentation.debugTool.onBeginFlush();
			  }
			  ReactReconciler.unmountComponent(instance, safely);
			  if (process.env.NODE_ENV !== 'production') {
			    ReactInstrumentation.debugTool.onEndFlush();
			  }
	
			  if (container.nodeType === DOC_NODE_TYPE) {
			    container = container.documentElement;
			  }
	
			  // http://jsperf.com/emptying-a-node
			  while (container.lastChild) {
			    container.removeChild(container.lastChild);
			  }
			}
	
			/**
			 * True if the supplied DOM node has a direct React-rendered child that is
			 * not a React root element. Useful for warning in `render`,
			 * `unmountComponentAtNode`, etc.
			 *
			 * @param {?DOMElement} node The candidate DOM node.
			 * @return {boolean} True if the DOM element contains a direct child that was
			 * rendered by React but is not a root element.
			 * @internal
			 */
			function hasNonRootReactChild(container) {
			  var rootEl = getReactRootElementInContainer(container);
			  if (rootEl) {
			    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
			    return !!(inst && inst._hostParent);
			  }
			}
	
			/**
			 * True if the supplied DOM node is a React DOM element and
			 * it has been rendered by another copy of React.
			 *
			 * @param {?DOMElement} node The candidate DOM node.
			 * @return {boolean} True if the DOM has been rendered by another copy of React
			 * @internal
			 */
			function nodeIsRenderedByOtherInstance(container) {
			  var rootEl = getReactRootElementInContainer(container);
			  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
			}
	
			/**
			 * True if the supplied DOM node is a valid node element.
			 *
			 * @param {?DOMElement} node The candidate DOM node.
			 * @return {boolean} True if the DOM is a valid DOM node.
			 * @internal
			 */
			function isValidContainer(node) {
			  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
			}
	
			/**
			 * True if the supplied DOM node is a valid React node element.
			 *
			 * @param {?DOMElement} node The candidate DOM node.
			 * @return {boolean} True if the DOM is a valid React DOM node.
			 * @internal
			 */
			function isReactNode(node) {
			  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
			}
	
			function getHostRootInstanceInContainer(container) {
			  var rootEl = getReactRootElementInContainer(container);
			  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
			  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
			}
	
			function getTopLevelWrapperInContainer(container) {
			  var root = getHostRootInstanceInContainer(container);
			  return root ? root._hostContainerInfo._topLevelWrapper : null;
			}
	
			/**
			 * Temporary (?) hack so that we can store all top-level pending updates on
			 * composites instead of having to worry about different types of components
			 * here.
			 */
			var topLevelRootCounter = 1;
			var TopLevelWrapper = function () {
			  this.rootID = topLevelRootCounter++;
			};
			TopLevelWrapper.prototype.isReactComponent = {};
			if (process.env.NODE_ENV !== 'production') {
			  TopLevelWrapper.displayName = 'TopLevelWrapper';
			}
			TopLevelWrapper.prototype.render = function () {
			  return this.props.child;
			};
			TopLevelWrapper.isReactTopLevelWrapper = true;
	
			/**
			 * Mounting is the process of initializing a React component by creating its
			 * representative DOM elements and inserting them into a supplied `container`.
			 * Any prior content inside `container` is destroyed in the process.
			 *
			 *   ReactMount.render(
			 *     component,
			 *     document.getElementById('container')
			 *   );
			 *
			 *   <div id="container">                   <-- Supplied `container`.
			 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
			 *       // ...                                 component.
			 *     </div>
			 *   </div>
			 *
			 * Inside of `container`, the first element rendered is the "reactRoot".
			 */
			var ReactMount = {
	
			  TopLevelWrapper: TopLevelWrapper,
	
			  /**
			   * Used by devtools. The keys are not important.
			   */
			  _instancesByReactRootID: instancesByReactRootID,
	
			  /**
			   * This is a hook provided to support rendering React components while
			   * ensuring that the apparent scroll position of its `container` does not
			   * change.
			   *
			   * @param {DOMElement} container The `container` being rendered into.
			   * @param {function} renderCallback This must be called once to do the render.
			   */
			  scrollMonitor: function (container, renderCallback) {
			    renderCallback();
			  },
	
			  /**
			   * Take a component that's already mounted into the DOM and replace its props
			   * @param {ReactComponent} prevComponent component instance already in the DOM
			   * @param {ReactElement} nextElement component instance to render
			   * @param {DOMElement} container container to render into
			   * @param {?function} callback function triggered on completion
			   */
			  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
			    ReactMount.scrollMonitor(container, function () {
			      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
			      if (callback) {
			        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
			      }
			    });
	
			    return prevComponent;
			  },
	
			  /**
			   * Render a new component into the DOM. Hooked by hooks!
			   *
			   * @param {ReactElement} nextElement element to render
			   * @param {DOMElement} container container to render into
			   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
			   * @return {ReactComponent} nextComponent
			   */
			  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
			    // Various parts of our code (such as ReactCompositeComponent's
			    // _renderValidatedComponent) assume that calls to render aren't nested;
			    // verify that that's the case.
			    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
			    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
			    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
			    var componentInstance = instantiateReactComponent(nextElement, false);
	
			    // The initial render is synchronous but any updates that happen during
			    // rendering, in componentWillMount or componentDidMount, will be batched
			    // according to the current batching strategy.
	
			    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
			    var wrapperID = componentInstance._instance.rootID;
			    instancesByReactRootID[wrapperID] = componentInstance;
	
			    return componentInstance;
			  },
	
			  /**
			   * Renders a React component into the DOM in the supplied `container`.
			   *
			   * If the React component was previously rendered into `container`, this will
			   * perform an update on it and only mutate the DOM as necessary to reflect the
			   * latest React component.
			   *
			   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
			   * @param {ReactElement} nextElement Component element to render.
			   * @param {DOMElement} container DOM element to render into.
			   * @param {?function} callback function triggered on completion
			   * @return {ReactComponent} Component instance rendered in `container`.
			   */
			  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
			    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
			    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
			  },
	
			  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
			    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
			    !React.isValidElement(nextElement) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
			    // Check if it quacks like an element
			    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
			    process.env.NODE_ENV !== 'production' ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
			    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
			    var nextContext;
			    if (parentComponent) {
			      var parentInst = ReactInstanceMap.get(parentComponent);
			      nextContext = parentInst._processChildContext(parentInst._context);
			    } else {
			      nextContext = emptyObject;
			    }
	
			    var prevComponent = getTopLevelWrapperInContainer(container);
	
			    if (prevComponent) {
			      var prevWrappedElement = prevComponent._currentElement;
			      var prevElement = prevWrappedElement.props.child;
			      if (shouldUpdateReactComponent(prevElement, nextElement)) {
			        var publicInst = prevComponent._renderedComponent.getPublicInstance();
			        var updatedCallback = callback && function () {
			          callback.call(publicInst);
			        };
			        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
			        return publicInst;
			      } else {
			        ReactMount.unmountComponentAtNode(container);
			      }
			    }
	
			    var reactRootElement = getReactRootElementInContainer(container);
			    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
			    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
			      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
			        var rootElementSibling = reactRootElement;
			        while (rootElementSibling) {
			          if (internalGetID(rootElementSibling)) {
			            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
			            break;
			          }
			          rootElementSibling = rootElementSibling.nextSibling;
			        }
			      }
			    }
	
			    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
			    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
			    if (callback) {
			      callback.call(component);
			    }
			    return component;
			  },
	
			  /**
			   * Renders a React component into the DOM in the supplied `container`.
			   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
			   *
			   * If the React component was previously rendered into `container`, this will
			   * perform an update on it and only mutate the DOM as necessary to reflect the
			   * latest React component.
			   *
			   * @param {ReactElement} nextElement Component element to render.
			   * @param {DOMElement} container DOM element to render into.
			   * @param {?function} callback function triggered on completion
			   * @return {ReactComponent} Component instance rendered in `container`.
			   */
			  render: function (nextElement, container, callback) {
			    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
			  },
	
			  /**
			   * Unmounts and destroys the React component rendered in the `container`.
			   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
			   *
			   * @param {DOMElement} container DOM element containing a React component.
			   * @return {boolean} True if a component was found in and unmounted from
			   *                   `container`
			   */
			  unmountComponentAtNode: function (container) {
			    // Various parts of our code (such as ReactCompositeComponent's
			    // _renderValidatedComponent) assume that calls to render aren't nested;
			    // verify that that's the case. (Strictly speaking, unmounting won't cause a
			    // render but we still don't expect to be in a render call here.)
			    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
			    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
			    if (process.env.NODE_ENV !== 'production') {
			      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
			    }
	
			    var prevComponent = getTopLevelWrapperInContainer(container);
			    if (!prevComponent) {
			      // Check if the node being unmounted was rendered by React, but isn't a
			      // root node.
			      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
			      // Check if the container itself is a React root node.
			      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
			      if (process.env.NODE_ENV !== 'production') {
			        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
			      }
	
			      return false;
			    }
			    delete instancesByReactRootID[prevComponent._instance.rootID];
			    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
			    return true;
			  },
	
			  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
			    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
			    if (shouldReuseMarkup) {
			      var rootElement = getReactRootElementInContainer(container);
			      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
			        ReactDOMComponentTree.precacheNode(instance, rootElement);
			        return;
			      } else {
			        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
			        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
			        var rootMarkup = rootElement.outerHTML;
			        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
			        var normalizedMarkup = markup;
			        if (process.env.NODE_ENV !== 'production') {
			          // because rootMarkup is retrieved from the DOM, various normalizations
			          // will have occurred which will not be present in `markup`. Here,
			          // insert markup into a <div> or <iframe> depending on the container
			          // type to perform the same normalizations before comparing.
			          var normalizer;
			          if (container.nodeType === ELEMENT_NODE_TYPE) {
			            normalizer = document.createElement('div');
			            normalizer.innerHTML = markup;
			            normalizedMarkup = normalizer.innerHTML;
			          } else {
			            normalizer = document.createElement('iframe');
			            document.body.appendChild(normalizer);
			            normalizer.contentDocument.write(markup);
			            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
			            document.body.removeChild(normalizer);
			          }
			        }
	
			        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
			        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
			        !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
			        if (process.env.NODE_ENV !== 'production') {
			          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
			        }
			      }
			    }
	
			    !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
			    if (transaction.useCreateElement) {
			      while (container.lastChild) {
			        container.removeChild(container.lastChild);
			      }
			      DOMLazyTree.insertTreeBefore(container, markup, null);
			    } else {
			      setInnerHTML(container, markup);
			      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
			    }
	
			    if (process.env.NODE_ENV !== 'production') {
			      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
			      if (hostNode._debugID !== 0) {
			        ReactInstrumentation.debugTool.onHostOperation({
			          instanceID: hostNode._debugID,
			          type: 'mount',
			          payload: markup.toString()
			        });
			      }
			    }
			  }
			};
	
			module.exports = ReactMount;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 167 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var validateDOMNesting = __webpack_require__(136);
	
			var DOC_NODE_TYPE = 9;
	
			function ReactDOMContainerInfo(topLevelWrapper, node) {
			  var info = {
			    _topLevelWrapper: topLevelWrapper,
			    _idCounter: 1,
			    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
			    _node: node,
			    _tag: node ? node.nodeName.toLowerCase() : null,
			    _namespaceURI: node ? node.namespaceURI : null
			  };
			  if (process.env.NODE_ENV !== 'production') {
			    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
			  }
			  return info;
			}
	
			module.exports = ReactDOMContainerInfo;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 168 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactDOMFeatureFlags = {
			  useCreateElement: true,
			  useFiber: false
			};
	
			module.exports = ReactDOMFeatureFlags;
	
		/***/ },
		/* 169 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var adler32 = __webpack_require__(170);
	
			var TAG_END = /\/?>/;
			var COMMENT_START = /^<\!\-\-/;
	
			var ReactMarkupChecksum = {
			  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
			  /**
			   * @param {string} markup Markup string
			   * @return {string} Markup string with checksum attribute attached
			   */
			  addChecksumToMarkup: function (markup) {
			    var checksum = adler32(markup);
	
			    // Add checksum (handle both parent tags, comments and self-closing tags)
			    if (COMMENT_START.test(markup)) {
			      return markup;
			    } else {
			      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
			    }
			  },
	
			  /**
			   * @param {string} markup to use
			   * @param {DOMElement} element root React element
			   * @returns {boolean} whether or not the markup is the same
			   */
			  canReuseMarkup: function (markup, element) {
			    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
			    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
			    var markupChecksum = adler32(markup);
			    return markupChecksum === existingChecksum;
			  }
			};
	
			module.exports = ReactMarkupChecksum;
	
		/***/ },
		/* 170 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 * 
			 */
	
			'use strict';
	
			var MOD = 65521;
	
			// adler32 is not cryptographically strong, and is only used to sanity check that
			// markup generated on the server matches the markup generated on the client.
			// This implementation (a modified version of the SheetJS version) has been optimized
			// for our use case, at the expense of conforming to the adler32 specification
			// for non-ascii inputs.
			function adler32(data) {
			  var a = 1;
			  var b = 0;
			  var i = 0;
			  var l = data.length;
			  var m = l & ~0x3;
			  while (i < m) {
			    var n = Math.min(i + 4096, m);
			    for (; i < n; i += 4) {
			      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
			    }
			    a %= MOD;
			    b %= MOD;
			  }
			  for (; i < l; i++) {
			    b += a += data.charCodeAt(i);
			  }
			  a %= MOD;
			  b %= MOD;
			  return a | b << 16;
			}
	
			module.exports = adler32;
	
		/***/ },
		/* 171 */
		/***/ function(module, exports) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			module.exports = '15.4.2';
	
		/***/ },
		/* 172 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var _prodInvariant = __webpack_require__(6);
	
			var ReactCurrentOwner = __webpack_require__(43);
			var ReactDOMComponentTree = __webpack_require__(5);
			var ReactInstanceMap = __webpack_require__(116);
	
			var getHostComponentFromComposite = __webpack_require__(173);
			var invariant = __webpack_require__(8);
			var warning = __webpack_require__(18);
	
			/**
			 * Returns the DOM node rendered by this element.
			 *
			 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
			 *
			 * @param {ReactComponent|DOMElement} componentOrElement
			 * @return {?DOMElement} The root node of this element.
			 */
			function findDOMNode(componentOrElement) {
			  if (process.env.NODE_ENV !== 'production') {
			    var owner = ReactCurrentOwner.current;
			    if (owner !== null) {
			      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
			      owner._warnedAboutRefsInRender = true;
			    }
			  }
			  if (componentOrElement == null) {
			    return null;
			  }
			  if (componentOrElement.nodeType === 1) {
			    return componentOrElement;
			  }
	
			  var inst = ReactInstanceMap.get(componentOrElement);
			  if (inst) {
			    inst = getHostComponentFromComposite(inst);
			    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
			  }
	
			  if (typeof componentOrElement.render === 'function') {
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
			  } else {
			     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
			  }
			}
	
			module.exports = findDOMNode;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 173 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactNodeTypes = __webpack_require__(120);
	
			function getHostComponentFromComposite(inst) {
			  var type;
	
			  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
			    inst = inst._renderedComponent;
			  }
	
			  if (type === ReactNodeTypes.HOST) {
			    return inst._renderedComponent;
			  } else if (type === ReactNodeTypes.EMPTY) {
			    return null;
			  }
			}
	
			module.exports = getHostComponentFromComposite;
	
		/***/ },
		/* 174 */
		/***/ function(module, exports, __webpack_require__) {
	
			/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactMount = __webpack_require__(166);
	
			module.exports = ReactMount.renderSubtreeIntoContainer;
	
		/***/ },
		/* 175 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
			var EventPluginRegistry = __webpack_require__(15);
			var ReactComponentTreeHook = __webpack_require__(41);
	
			var warning = __webpack_require__(18);
	
			if (process.env.NODE_ENV !== 'production') {
			  var reactProps = {
			    children: true,
			    dangerouslySetInnerHTML: true,
			    key: true,
			    ref: true,
	
			    autoFocus: true,
			    defaultValue: true,
			    valueLink: true,
			    defaultChecked: true,
			    checkedLink: true,
			    innerHTML: true,
			    suppressContentEditableWarning: true,
			    onFocusIn: true,
			    onFocusOut: true
			  };
			  var warnedProperties = {};
	
			  var validateProperty = function (tagName, name, debugID) {
			    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
			      return true;
			    }
			    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
			      return true;
			    }
			    if (EventPluginRegistry.registrationNameModules.hasOwnProperty(name)) {
			      return true;
			    }
			    warnedProperties[name] = true;
			    var lowerCasedName = name.toLowerCase();
	
			    // data-* attributes should be lowercase; suggest the lowercase version
			    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
			    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
			    if (standardName != null) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown DOM property %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			      return true;
			    } else if (registrationName != null) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown event handler property %s. Did you mean `%s`?%s', name, registrationName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			      return true;
			    } else {
			      // We were unable to guess which prop the user intended.
			      // It is likely that the user was just blindly spreading/forwarding props
			      // Components should be careful to only render valid props/attributes.
			      // Warning will be invoked in warnUnknownProperties to allow grouping.
			      return false;
			    }
			  };
			}
	
			var warnUnknownProperties = function (debugID, element) {
			  var unknownProps = [];
			  for (var key in element.props) {
			    var isValid = validateProperty(element.type, key, debugID);
			    if (!isValid) {
			      unknownProps.push(key);
			    }
			  }
	
			  var unknownPropString = unknownProps.map(function (prop) {
			    return '`' + prop + '`';
			  }).join(', ');
	
			  if (unknownProps.length === 1) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown prop %s on <%s> tag. Remove this prop from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			  } else if (unknownProps.length > 1) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown props %s on <%s> tag. Remove these props from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			  }
			};
	
			function handleElement(debugID, element) {
			  if (element == null || typeof element.type !== 'string') {
			    return;
			  }
			  if (element.type.indexOf('-') >= 0 || element.props.is) {
			    return;
			  }
			  warnUnknownProperties(debugID, element);
			}
	
			var ReactDOMUnknownPropertyHook = {
			  onBeforeMountComponent: function (debugID, element) {
			    handleElement(debugID, element);
			  },
			  onBeforeUpdateComponent: function (debugID, element) {
			    handleElement(debugID, element);
			  }
			};
	
			module.exports = ReactDOMUnknownPropertyHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 176 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var ReactComponentTreeHook = __webpack_require__(41);
	
			var warning = __webpack_require__(18);
	
			var didWarnValueNull = false;
	
			function handleElement(debugID, element) {
			  if (element == null) {
			    return;
			  }
			  if (element.type !== 'input' && element.type !== 'textarea' && element.type !== 'select') {
			    return;
			  }
			  if (element.props != null && element.props.value === null && !didWarnValueNull) {
			    process.env.NODE_ENV !== 'production' ? warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	
			    didWarnValueNull = true;
			  }
			}
	
			var ReactDOMNullInputValuePropHook = {
			  onBeforeMountComponent: function (debugID, element) {
			    handleElement(debugID, element);
			  },
			  onBeforeUpdateComponent: function (debugID, element) {
			    handleElement(debugID, element);
			  }
			};
	
			module.exports = ReactDOMNullInputValuePropHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 177 */
		/***/ function(module, exports, __webpack_require__) {
	
			/* WEBPACK VAR INJECTION */(function(process) {/**
			 * Copyright 2013-present, Facebook, Inc.
			 * All rights reserved.
			 *
			 * This source code is licensed under the BSD-style license found in the
			 * LICENSE file in the root directory of this source tree. An additional grant
			 * of patent rights can be found in the PATENTS file in the same directory.
			 *
			 */
	
			'use strict';
	
			var DOMProperty = __webpack_require__(7);
			var ReactComponentTreeHook = __webpack_require__(41);
	
			var warning = __webpack_require__(18);
	
			var warnedProperties = {};
			var rARIA = new RegExp('^(aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	
			function validateProperty(tagName, name, debugID) {
			  if (warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
			    return true;
			  }
	
			  if (rARIA.test(name)) {
			    var lowerCasedName = name.toLowerCase();
			    var standardName = DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
			    // If this is an aria-* attribute, but is not listed in the known DOM
			    // DOM properties, then it is an invalid aria-* attribute.
			    if (standardName == null) {
			      warnedProperties[name] = true;
			      return false;
			    }
			    // aria-* attributes should be lowercase; suggest the lowercase version.
			    if (name !== standardName) {
			      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown ARIA attribute %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			      warnedProperties[name] = true;
			      return true;
			    }
			  }
	
			  return true;
			}
	
			function warnInvalidARIAProps(debugID, element) {
			  var invalidProps = [];
	
			  for (var key in element.props) {
			    var isValid = validateProperty(element.type, key, debugID);
			    if (!isValid) {
			      invalidProps.push(key);
			    }
			  }
	
			  var unknownPropString = invalidProps.map(function (prop) {
			    return '`' + prop + '`';
			  }).join(', ');
	
			  if (invalidProps.length === 1) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			  } else if (invalidProps.length > 1) {
			    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
			  }
			}
	
			function handleElement(debugID, element) {
			  if (element == null || typeof element.type !== 'string') {
			    return;
			  }
			  if (element.type.indexOf('-') >= 0 || element.props.is) {
			    return;
			  }
	
			  warnInvalidARIAProps(debugID, element);
			}
	
			var ReactDOMInvalidARIAHook = {
			  onBeforeMountComponent: function (debugID, element) {
			    if (process.env.NODE_ENV !== 'production') {
			      handleElement(debugID, element);
			    }
			  },
			  onBeforeUpdateComponent: function (debugID, element) {
			    if (process.env.NODE_ENV !== 'production') {
			      handleElement(debugID, element);
			    }
			  }
			};
	
			module.exports = ReactDOMInvalidARIAHook;
			/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
		/***/ },
		/* 178 */
		/***/ function(module, exports, __webpack_require__) {
	
			var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
			  Copyright (c) 2015 Jed Watson.
			  Licensed under the MIT License (MIT), see
			  http://jedwatson.github.io/classnames
			*/
	
			function classNames() {
				var classes = '';
				var arg;
	
				for (var i = 0; i < arguments.length; i++) {
					arg = arguments[i];
					if (!arg) {
						continue;
					}
	
					if ('string' === typeof arg || 'number' === typeof arg) {
						classes += ' ' + arg;
					} else if (Object.prototype.toString.call(arg) === '[object Array]') {
						classes += ' ' + classNames.apply(null, arg);
					} else if ('object' === typeof arg) {
						for (var key in arg) {
							if (!arg.hasOwnProperty(key) || !arg[key]) {
								continue;
							}
							classes += ' ' + key;
						}
					}
				}
				return classes.substr(1);
			}
	
			// safely export classNames for node / browserify
			if (typeof module !== 'undefined' && module.exports) {
				module.exports = classNames;
			}
	
			// safely export classNames for RequireJS
			if (true) {
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
					return classNames;
				}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			}
	
	
		/***/ }
		/******/ ])
		});
		;
	
	/***/ },
	/* 399 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(240);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../../css-loader/index.js!./react-select.css", function() {
					var newContent = require("!!../../css-loader/index.js!./react-select.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 400 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(241);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-drop-target.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-drop-target.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 401 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(242);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-image.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-image.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 402 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(244);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./ron-react-autocomplete.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./ron-react-autocomplete.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 403 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(404);
	
	
	/***/ },
	/* 404 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _ponyfill = __webpack_require__(405);
	
		var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var root; /* global window */
	
	
		if (typeof self !== 'undefined') {
		  root = self;
		} else if (typeof window !== 'undefined') {
		  root = window;
		} else if (typeof (window) !== 'undefined') {
		  root = (window);
		} else if (true) {
		  root = module;
		} else {
		  root = Function('return this')();
		}
	
		var result = (0, _ponyfill2['default'])(root);
		exports['default'] = result;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))
	
	/***/ },
	/* 405 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		exports['default'] = symbolObservablePonyfill;
		function symbolObservablePonyfill(root) {
			var result;
			var _Symbol = root.Symbol;
	
			if (typeof _Symbol === 'function') {
				if (_Symbol.observable) {
					result = _Symbol.observable;
				} else {
					result = _Symbol('observable');
					_Symbol.observable = result;
				}
			} else {
				result = '@@observable';
			}
	
			return result;
		};
	
	/***/ },
	/* 406 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = function() {};
	
		if (false) {
		  warning = function(condition, format, args) {
		    var len = arguments.length;
		    args = new Array(len > 2 ? len - 2 : 0);
		    for (var key = 2; key < len; key++) {
		      args[key - 2] = arguments[key];
		    }
		    if (format === undefined) {
		      throw new Error(
		        '`warning(condition, format, ...args)` requires a warning ' +
		        'message argument'
		      );
		    }
	
		    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
		      throw new Error(
		        'The warning format should be able to uniquely identify this ' +
		        'warning. Please, use a more descriptive format than: ' + format
		      );
		    }
	
		    if (!condition) {
		      var argIndex = 0;
		      var message = 'Warning: ' +
		        format.replace(/%s/g, function() {
		          return args[argIndex++];
		        });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch(x) {}
		    }
		  };
		}
	
		module.exports = warning;
	
	
	/***/ },
	/* 407 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(20),
		    root = __webpack_require__(12);
	
		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView');
	
		module.exports = DataView;
	
	
	/***/ },
	/* 408 */
	[1610, 456, 457, 458, 459, 460],
	/* 409 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(20),
		    root = __webpack_require__(12);
	
		/* Built-in method references that are verified to be native. */
		var Promise = getNative(root, 'Promise');
	
		module.exports = Promise;
	
	
	/***/ },
	/* 410 */
	[1629, 20, 12],
	/* 411 */
	[1636, 88, 480, 481],
	/* 412 */
	/***/ function(module, exports, __webpack_require__) {
	
		var root = __webpack_require__(12);
	
		/** Built-in value references. */
		var Uint8Array = root.Uint8Array;
	
		module.exports = Uint8Array;
	
	
	/***/ },
	/* 413 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getNative = __webpack_require__(20),
		    root = __webpack_require__(12);
	
		/* Built-in method references that are verified to be native. */
		var WeakMap = getNative(root, 'WeakMap');
	
		module.exports = WeakMap;
	
	
	/***/ },
	/* 414 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `baseAggregator` for arrays.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} setter The function to set `accumulator` values.
		 * @param {Function} iteratee The iteratee to transform keys.
		 * @param {Object} accumulator The initial aggregated object.
		 * @returns {Function} Returns `accumulator`.
		 */
		function arrayAggregator(array, setter, iteratee, accumulator) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    var value = array[index];
		    setter(accumulator, value, iteratee(value), array);
		  }
		  return accumulator;
		}
	
		module.exports = arrayAggregator;
	
	
	/***/ },
	/* 415 */
	283,
	/* 416 */
	[1648, 438, 155, 13, 157, 150, 159],
	/* 417 */
	79,
	/* 418 */
	285,
	/* 419 */
	/***/ function(module, exports) {
	
		/**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}
	
		module.exports = arraySome;
	
	
	/***/ },
	/* 420 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseEach = __webpack_require__(422);
	
		/**
		 * Aggregates elements of `collection` on `accumulator` with keys transformed
		 * by `iteratee` and values set by `setter`.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} setter The function to set `accumulator` values.
		 * @param {Function} iteratee The iteratee to transform keys.
		 * @param {Object} accumulator The initial aggregated object.
		 * @returns {Function} Returns `accumulator`.
		 */
		function baseAggregator(collection, setter, iteratee, accumulator) {
		  baseEach(collection, function(value, key, collection) {
		    setter(accumulator, value, iteratee(value), collection);
		  });
		  return accumulator;
		}
	
		module.exports = baseAggregator;
	
	
	/***/ },
	/* 421 */
	[1656, 446],
	/* 422 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseForOwn = __webpack_require__(424),
		    createBaseEach = __webpack_require__(444);
	
		/**
		 * The base implementation of `_.forEach` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array|Object} Returns `collection`.
		 */
		var baseEach = createBaseEach(baseForOwn);
	
		module.exports = baseEach;
	
	
	/***/ },
	/* 423 */
	/***/ function(module, exports, __webpack_require__) {
	
		var createBaseFor = __webpack_require__(445);
	
		/**
		 * The base implementation of `baseForOwn` which iterates over `object`
		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */
		var baseFor = createBaseFor();
	
		module.exports = baseFor;
	
	
	/***/ },
	/* 424 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseFor = __webpack_require__(423),
		    keys = __webpack_require__(93);
	
		/**
		 * The base implementation of `_.forOwn` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Object} Returns `object`.
		 */
		function baseForOwn(object, iteratee) {
		  return object && baseFor(object, iteratee, keys);
		}
	
		module.exports = baseForOwn;
	
	
	/***/ },
	/* 425 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayPush = __webpack_require__(418),
		    isArray = __webpack_require__(13);
	
		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}
	
		module.exports = baseGetAllKeys;
	
	
	/***/ },
	/* 426 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.hasIn` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */
		function baseHasIn(object, key) {
		  return object != null && key in Object(object);
		}
	
		module.exports = baseHasIn;
	
	
	/***/ },
	/* 427 */
	[1667, 31, 32],
	/* 428 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Stack = __webpack_require__(144),
		    equalArrays = __webpack_require__(148),
		    equalByTag = __webpack_require__(447),
		    equalObjects = __webpack_require__(448),
		    getTag = __webpack_require__(453),
		    isArray = __webpack_require__(13),
		    isBuffer = __webpack_require__(157),
		    isTypedArray = __webpack_require__(159);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1;
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    objectTag = '[object Object]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = objIsArr ? arrayTag : getTag(object),
		      othTag = othIsArr ? arrayTag : getTag(other);
	
		  objTag = objTag == argsTag ? objectTag : objTag;
		  othTag = othTag == argsTag ? objectTag : othTag;
	
		  var objIsObj = objTag == objectTag,
		      othIsObj = othTag == objectTag,
		      isSameTag = objTag == othTag;
	
		  if (isSameTag && isBuffer(object)) {
		    if (!isBuffer(other)) {
		      return false;
		    }
		    objIsArr = true;
		    objIsObj = false;
		  }
		  if (isSameTag && !objIsObj) {
		    stack || (stack = new Stack);
		    return (objIsArr || isTypedArray(object))
		      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
		      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
		  }
		  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
		    if (objIsWrapped || othIsWrapped) {
		      var objUnwrapped = objIsWrapped ? object.value() : object,
		          othUnwrapped = othIsWrapped ? other.value() : other;
	
		      stack || (stack = new Stack);
		      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  stack || (stack = new Stack);
		  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
		}
	
		module.exports = baseIsEqualDeep;
	
	
	/***/ },
	/* 429 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Stack = __webpack_require__(144),
		    baseIsEqual = __webpack_require__(146);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * The base implementation of `_.isMatch` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to inspect.
		 * @param {Object} source The object of property values to match.
		 * @param {Array} matchData The property names, values, and compare flags to match.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
		 */
		function baseIsMatch(object, source, matchData, customizer) {
		  var index = matchData.length,
		      length = index,
		      noCustomizer = !customizer;
	
		  if (object == null) {
		    return !length;
		  }
		  object = Object(object);
		  while (index--) {
		    var data = matchData[index];
		    if ((noCustomizer && data[2])
		          ? data[1] !== object[data[0]]
		          : !(data[0] in object)
		        ) {
		      return false;
		    }
		  }
		  while (++index < length) {
		    data = matchData[index];
		    var key = data[0],
		        objValue = object[key],
		        srcValue = data[1];
	
		    if (noCustomizer && data[2]) {
		      if (objValue === undefined && !(key in object)) {
		        return false;
		      }
		    } else {
		      var stack = new Stack;
		      if (customizer) {
		        var result = customizer(objValue, srcValue, key, object, source, stack);
		      }
		      if (!(result === undefined
		            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
		            : result
		          )) {
		        return false;
		      }
		    }
		  }
		  return true;
		}
	
		module.exports = baseIsMatch;
	
	
	/***/ },
	/* 430 */
	[1672, 158, 462, 91, 153],
	/* 431 */
	[1675, 31, 90, 32],
	/* 432 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseMatches = __webpack_require__(434),
		    baseMatchesProperty = __webpack_require__(435),
		    identity = __webpack_require__(492),
		    isArray = __webpack_require__(13),
		    property = __webpack_require__(494);
	
		/**
		 * The base implementation of `_.iteratee`.
		 *
		 * @private
		 * @param {*} [value=_.identity] The value to convert to an iteratee.
		 * @returns {Function} Returns the iteratee.
		 */
		function baseIteratee(value) {
		  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
		  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
		  if (typeof value == 'function') {
		    return value;
		  }
		  if (value == null) {
		    return identity;
		  }
		  if (typeof value == 'object') {
		    return isArray(value)
		      ? baseMatchesProperty(value[0], value[1])
		      : baseMatches(value);
		  }
		  return property(value);
		}
	
		module.exports = baseIteratee;
	
	
	/***/ },
	/* 433 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isPrototype = __webpack_require__(463),
		    nativeKeys = __webpack_require__(476);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = baseKeys;
	
	
	/***/ },
	/* 434 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsMatch = __webpack_require__(429),
		    getMatchData = __webpack_require__(450),
		    matchesStrictComparable = __webpack_require__(152);
	
		/**
		 * The base implementation of `_.matches` which doesn't clone `source`.
		 *
		 * @private
		 * @param {Object} source The object of property values to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function baseMatches(source) {
		  var matchData = getMatchData(source);
		  if (matchData.length == 1 && matchData[0][2]) {
		    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
		  }
		  return function(object) {
		    return object === source || baseIsMatch(object, source, matchData);
		  };
		}
	
		module.exports = baseMatches;
	
	
	/***/ },
	/* 435 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseIsEqual = __webpack_require__(146),
		    get = __webpack_require__(489),
		    hasIn = __webpack_require__(491),
		    isKey = __webpack_require__(89),
		    isStrictComparable = __webpack_require__(151),
		    matchesStrictComparable = __webpack_require__(152),
		    toKey = __webpack_require__(57);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
		 *
		 * @private
		 * @param {string} path The path of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function baseMatchesProperty(path, srcValue) {
		  if (isKey(path) && isStrictComparable(srcValue)) {
		    return matchesStrictComparable(toKey(path), srcValue);
		  }
		  return function(object) {
		    var objValue = get(object, path);
		    return (objValue === undefined && objValue === srcValue)
		      ? hasIn(object, path)
		      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
		  };
		}
	
		module.exports = baseMatchesProperty;
	
	
	/***/ },
	/* 436 */
	/***/ function(module, exports) {
	
		/**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function baseProperty(key) {
		  return function(object) {
		    return object == null ? undefined : object[key];
		  };
		}
	
		module.exports = baseProperty;
	
	
	/***/ },
	/* 437 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGet = __webpack_require__(145);
	
		/**
		 * A specialized version of `baseProperty` which supports deep paths.
		 *
		 * @private
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function basePropertyDeep(path) {
		  return function(object) {
		    return baseGet(object, path);
		  };
		}
	
		module.exports = basePropertyDeep;
	
	
	/***/ },
	/* 438 */
	296,
	/* 439 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(53),
		    arrayMap = __webpack_require__(417),
		    isArray = __webpack_require__(13),
		    isSymbol = __webpack_require__(92);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
		/**
		 * The base implementation of `_.toString` which doesn't convert nullish
		 * values to empty strings.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 */
		function baseToString(value) {
		  // Exit early for strings to avoid a performance hit in some environments.
		  if (typeof value == 'string') {
		    return value;
		  }
		  if (isArray(value)) {
		    // Recursively convert values (susceptible to call stack limits).
		    return arrayMap(value, baseToString) + '';
		  }
		  if (isSymbol(value)) {
		    return symbolToString ? symbolToString.call(value) : '';
		  }
		  var result = (value + '');
		  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
		}
	
		module.exports = baseToString;
	
	
	/***/ },
	/* 440 */
	80,
	/* 441 */
	81,
	/* 442 */
	[1680, 12],
	/* 443 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayAggregator = __webpack_require__(414),
		    baseAggregator = __webpack_require__(420),
		    baseIteratee = __webpack_require__(432),
		    isArray = __webpack_require__(13);
	
		/**
		 * Creates a function like `_.groupBy`.
		 *
		 * @private
		 * @param {Function} setter The function to set accumulator values.
		 * @param {Function} [initializer] The accumulator object initializer.
		 * @returns {Function} Returns the new aggregator function.
		 */
		function createAggregator(setter, initializer) {
		  return function(collection, iteratee) {
		    var func = isArray(collection) ? arrayAggregator : baseAggregator,
		        accumulator = initializer ? initializer() : {};
	
		    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
		  };
		}
	
		module.exports = createAggregator;
	
	
	/***/ },
	/* 444 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isArrayLike = __webpack_require__(156);
	
		/**
		 * Creates a `baseEach` or `baseEachRight` function.
		 *
		 * @private
		 * @param {Function} eachFunc The function to iterate over a collection.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseEach(eachFunc, fromRight) {
		  return function(collection, iteratee) {
		    if (collection == null) {
		      return collection;
		    }
		    if (!isArrayLike(collection)) {
		      return eachFunc(collection, iteratee);
		    }
		    var length = collection.length,
		        index = fromRight ? length : -1,
		        iterable = Object(collection);
	
		    while ((fromRight ? index-- : ++index < length)) {
		      if (iteratee(iterable[index], index, iterable) === false) {
		        break;
		      }
		    }
		    return collection;
		  };
		}
	
		module.exports = createBaseEach;
	
	
	/***/ },
	/* 445 */
	/***/ function(module, exports) {
	
		/**
		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseFor(fromRight) {
		  return function(object, iteratee, keysFunc) {
		    var index = -1,
		        iterable = Object(object),
		        props = keysFunc(object),
		        length = props.length;
	
		    while (length--) {
		      var key = props[fromRight ? length : ++index];
		      if (iteratee(iterable[key], key, iterable) === false) {
		        break;
		      }
		    }
		    return object;
		  };
		}
	
		module.exports = createBaseFor;
	
	
	/***/ },
	/* 446 */
	[1688, 20],
	/* 447 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Symbol = __webpack_require__(53),
		    Uint8Array = __webpack_require__(412),
		    eq = __webpack_require__(154),
		    equalArrays = __webpack_require__(148),
		    mapToArray = __webpack_require__(474),
		    setToArray = __webpack_require__(482);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/** `Object#toString` result references. */
		var boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]';
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
		  switch (tag) {
		    case dataViewTag:
		      if ((object.byteLength != other.byteLength) ||
		          (object.byteOffset != other.byteOffset)) {
		        return false;
		      }
		      object = object.buffer;
		      other = other.buffer;
	
		    case arrayBufferTag:
		      if ((object.byteLength != other.byteLength) ||
		          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
		        return false;
		      }
		      return true;
	
		    case boolTag:
		    case dateTag:
		    case numberTag:
		      // Coerce booleans to `1` or `0` and dates to milliseconds.
		      // Invalid dates are coerced to `NaN`.
		      return eq(+object, +other);
	
		    case errorTag:
		      return object.name == other.name && object.message == other.message;
	
		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings, primitives and objects,
		      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
		      // for more details.
		      return object == (other + '');
	
		    case mapTag:
		      var convert = mapToArray;
	
		    case setTag:
		      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
		      convert || (convert = setToArray);
	
		      if (object.size != other.size && !isPartial) {
		        return false;
		      }
		      // Assume cyclic values are equal.
		      var stacked = stack.get(object);
		      if (stacked) {
		        return stacked == other;
		      }
		      bitmask |= COMPARE_UNORDERED_FLAG;
	
		      // Recursively compare objects (susceptible to call stack limits).
		      stack.set(object, other);
		      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
		      stack['delete'](object);
		      return result;
	
		    case symbolTag:
		      if (symbolValueOf) {
		        return symbolValueOf.call(object) == symbolValueOf.call(other);
		      }
		  }
		  return false;
		}
	
		module.exports = equalByTag;
	
	
	/***/ },
	/* 448 */
	/***/ function(module, exports, __webpack_require__) {
	
		var getAllKeys = __webpack_require__(449);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1;
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      objProps = getAllKeys(object),
		      objLength = objProps.length,
		      othProps = getAllKeys(other),
		      othLength = othProps.length;
	
		  if (objLength != othLength && !isPartial) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
		      return false;
		    }
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(object);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var result = true;
		  stack.set(object, other);
		  stack.set(other, object);
	
		  var skipCtor = isPartial;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key];
	
		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, objValue, key, other, object, stack)
		        : customizer(objValue, othValue, key, object, other, stack);
		    }
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(compared === undefined
		          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
		          : compared
		        )) {
		      result = false;
		      break;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (result && !skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;
	
		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor &&
		        ('constructor' in object && 'constructor' in other) &&
		        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
		          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      result = false;
		    }
		  }
		  stack['delete'](object);
		  stack['delete'](other);
		  return result;
		}
	
		module.exports = equalObjects;
	
	
	/***/ },
	/* 449 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGetAllKeys = __webpack_require__(425),
		    getSymbols = __webpack_require__(452),
		    keys = __webpack_require__(93);
	
		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}
	
		module.exports = getAllKeys;
	
	
	/***/ },
	/* 450 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isStrictComparable = __webpack_require__(151),
		    keys = __webpack_require__(93);
	
		/**
		 * Gets the property names, values, and compare flags of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the match data of `object`.
		 */
		function getMatchData(object) {
		  var result = keys(object),
		      length = result.length;
	
		  while (length--) {
		    var key = result[length],
		        value = object[key];
	
		    result[length] = [key, value, isStrictComparable(value)];
		  }
		  return result;
		}
	
		module.exports = getMatchData;
	
	
	/***/ },
	/* 451 */
	[1700, 53],
	/* 452 */
	/***/ function(module, exports, __webpack_require__) {
	
		var arrayFilter = __webpack_require__(415),
		    stubArray = __webpack_require__(495);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols;
	
		/**
		 * Creates an array of the own enumerable symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
		  if (object == null) {
		    return [];
		  }
		  object = Object(object);
		  return arrayFilter(nativeGetSymbols(object), function(symbol) {
		    return propertyIsEnumerable.call(object, symbol);
		  });
		};
	
		module.exports = getSymbols;
	
	
	/***/ },
	/* 453 */
	/***/ function(module, exports, __webpack_require__) {
	
		var DataView = __webpack_require__(407),
		    Map = __webpack_require__(87),
		    Promise = __webpack_require__(409),
		    Set = __webpack_require__(410),
		    WeakMap = __webpack_require__(413),
		    baseGetTag = __webpack_require__(31),
		    toSource = __webpack_require__(153);
	
		/** `Object#toString` result references. */
		var mapTag = '[object Map]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    setTag = '[object Set]',
		    weakMapTag = '[object WeakMap]';
	
		var dataViewTag = '[object DataView]';
	
		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);
	
		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;
	
		// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = baseGetTag(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : '';
	
		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}
	
		module.exports = getTag;
	
	
	/***/ },
	/* 454 */
	306,
	/* 455 */
	/***/ function(module, exports, __webpack_require__) {
	
		var castPath = __webpack_require__(147),
		    isArguments = __webpack_require__(155),
		    isArray = __webpack_require__(13),
		    isIndex = __webpack_require__(150),
		    isLength = __webpack_require__(90),
		    toKey = __webpack_require__(57);
	
		/**
		 * Checks if `path` exists on `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @param {Function} hasFunc The function to check properties.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 */
		function hasPath(object, path, hasFunc) {
		  path = castPath(path, object);
	
		  var index = -1,
		      length = path.length,
		      result = false;
	
		  while (++index < length) {
		    var key = toKey(path[index]);
		    if (!(result = object != null && hasFunc(object, key))) {
		      break;
		    }
		    object = object[key];
		  }
		  if (result || ++index != length) {
		    return result;
		  }
		  length = object == null ? 0 : object.length;
		  return !!length && isLength(length) && isIndex(key, length) &&
		    (isArray(object) || isArguments(object));
		}
	
		module.exports = hasPath;
	
	
	/***/ },
	/* 456 */
	[1704, 56],
	/* 457 */
	308,
	/* 458 */
	[1709, 56],
	/* 459 */
	[1714, 56],
	/* 460 */
	[1721, 56],
	/* 461 */
	314,
	/* 462 */
	[1725, 442],
	/* 463 */
	316,
	/* 464 */
	317,
	/* 465 */
	[1732, 54],
	/* 466 */
	[1736, 54],
	/* 467 */
	[1742, 54],
	/* 468 */
	[1744, 54],
	/* 469 */
	[1749, 408, 52, 87],
	/* 470 */
	[1757, 55],
	/* 471 */
	[1761, 55],
	/* 472 */
	[1767, 55],
	/* 473 */
	[1772, 55],
	/* 474 */
	/***/ function(module, exports) {
	
		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);
	
		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}
	
		module.exports = mapToArray;
	
	
	/***/ },
	/* 475 */
	/***/ function(module, exports, __webpack_require__) {
	
		var memoize = __webpack_require__(493);
	
		/** Used as the maximum memoize cache size. */
		var MAX_MEMOIZE_SIZE = 500;
	
		/**
		 * A specialized version of `_.memoize` which clears the memoized function's
		 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
		 *
		 * @private
		 * @param {Function} func The function to have its output memoized.
		 * @returns {Function} Returns the new memoized function.
		 */
		function memoizeCapped(func) {
		  var result = memoize(func, function(key) {
		    if (cache.size === MAX_MEMOIZE_SIZE) {
		      cache.clear();
		    }
		    return key;
		  });
	
		  var cache = result.cache;
		  return result;
		}
	
		module.exports = memoizeCapped;
	
	
	/***/ },
	/* 476 */
	/***/ function(module, exports, __webpack_require__) {
	
		var overArg = __webpack_require__(479);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeKeys = overArg(Object.keys, Object);
	
		module.exports = nativeKeys;
	
	
	/***/ },
	/* 477 */
	[1779, 149],
	/* 478 */
	329,
	/* 479 */
	330,
	/* 480 */
	332,
	/* 481 */
	333,
	/* 482 */
	116,
	/* 483 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(52);
	
		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		  this.size = 0;
		}
	
		module.exports = stackClear;
	
	
	/***/ },
	/* 484 */
	/***/ function(module, exports) {
	
		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  var data = this.__data__,
		      result = data['delete'](key);
	
		  this.size = data.size;
		  return result;
		}
	
		module.exports = stackDelete;
	
	
	/***/ },
	/* 485 */
	/***/ function(module, exports) {
	
		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}
	
		module.exports = stackGet;
	
	
	/***/ },
	/* 486 */
	/***/ function(module, exports) {
	
		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}
	
		module.exports = stackHas;
	
	
	/***/ },
	/* 487 */
	/***/ function(module, exports, __webpack_require__) {
	
		var ListCache = __webpack_require__(52),
		    Map = __webpack_require__(87),
		    MapCache = __webpack_require__(88);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var data = this.__data__;
		  if (data instanceof ListCache) {
		    var pairs = data.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      this.size = ++data.size;
		      return this;
		    }
		    data = this.__data__ = new MapCache(pairs);
		  }
		  data.set(key, value);
		  this.size = data.size;
		  return this;
		}
	
		module.exports = stackSet;
	
	
	/***/ },
	/* 488 */
	/***/ function(module, exports, __webpack_require__) {
	
		var memoizeCapped = __webpack_require__(475);
	
		/** Used to match property names within property paths. */
		var reLeadingDot = /^\./,
		    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
		/** Used to match backslashes in property paths. */
		var reEscapeChar = /\\(\\)?/g;
	
		/**
		 * Converts `string` to a property path array.
		 *
		 * @private
		 * @param {string} string The string to convert.
		 * @returns {Array} Returns the property path array.
		 */
		var stringToPath = memoizeCapped(function(string) {
		  var result = [];
		  if (reLeadingDot.test(string)) {
		    result.push('');
		  }
		  string.replace(rePropName, function(match, number, quote, string) {
		    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
		  });
		  return result;
		});
	
		module.exports = stringToPath;
	
	
	/***/ },
	/* 489 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseGet = __webpack_require__(145);
	
		/**
		 * Gets the value at `path` of `object`. If the resolved value is
		 * `undefined`, the `defaultValue` is returned in its place.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.7.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
		 * @returns {*} Returns the resolved value.
		 * @example
		 *
		 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
		 *
		 * _.get(object, 'a[0].b.c');
		 * // => 3
		 *
		 * _.get(object, ['a', '0', 'b', 'c']);
		 * // => 3
		 *
		 * _.get(object, 'a.b.c', 'default');
		 * // => 'default'
		 */
		function get(object, path, defaultValue) {
		  var result = object == null ? undefined : baseGet(object, path);
		  return result === undefined ? defaultValue : result;
		}
	
		module.exports = get;
	
	
	/***/ },
	/* 490 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseAssignValue = __webpack_require__(421),
		    createAggregator = __webpack_require__(443);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Creates an object composed of keys generated from the results of running
		 * each element of `collection` thru `iteratee`. The order of grouped values
		 * is determined by the order they occur in `collection`. The corresponding
		 * value of each key is an array of elements responsible for generating the
		 * key. The iteratee is invoked with one argument: (value).
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Collection
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
		 * @returns {Object} Returns the composed aggregate object.
		 * @example
		 *
		 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
		 * // => { '4': [4.2], '6': [6.1, 6.3] }
		 *
		 * // The `_.property` iteratee shorthand.
		 * _.groupBy(['one', 'two', 'three'], 'length');
		 * // => { '3': ['one', 'two'], '5': ['three'] }
		 */
		var groupBy = createAggregator(function(result, value, key) {
		  if (hasOwnProperty.call(result, key)) {
		    result[key].push(value);
		  } else {
		    baseAssignValue(result, key, [value]);
		  }
		});
	
		module.exports = groupBy;
	
	
	/***/ },
	/* 491 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseHasIn = __webpack_require__(426),
		    hasPath = __webpack_require__(455);
	
		/**
		 * Checks if `path` is a direct or inherited property of `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 * @example
		 *
		 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
		 *
		 * _.hasIn(object, 'a');
		 * // => true
		 *
		 * _.hasIn(object, 'a.b');
		 * // => true
		 *
		 * _.hasIn(object, ['a', 'b']);
		 * // => true
		 *
		 * _.hasIn(object, 'b');
		 * // => false
		 */
		function hasIn(object, path) {
		  return object != null && hasPath(object, path, baseHasIn);
		}
	
		module.exports = hasIn;
	
	
	/***/ },
	/* 492 */
	117,
	/* 493 */
	[1818, 88],
	/* 494 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseProperty = __webpack_require__(436),
		    basePropertyDeep = __webpack_require__(437),
		    isKey = __webpack_require__(89),
		    toKey = __webpack_require__(57);
	
		/**
		 * Creates a function that returns the value at `path` of a given object.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 * @example
		 *
		 * var objects = [
		 *   { 'a': { 'b': 2 } },
		 *   { 'a': { 'b': 1 } }
		 * ];
		 *
		 * _.map(objects, _.property('a.b'));
		 * // => [2, 1]
		 *
		 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
		 * // => [1, 2]
		 */
		function property(path) {
		  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
		}
	
		module.exports = property;
	
	
	/***/ },
	/* 495 */
	/***/ function(module, exports) {
	
		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}
	
		module.exports = stubArray;
	
	
	/***/ },
	/* 496 */
	346,
	/* 497 */
	/***/ function(module, exports, __webpack_require__) {
	
		var baseToString = __webpack_require__(439);
	
		/**
		 * Converts `value` to a string. An empty string is returned for `null`
		 * and `undefined` values. The sign of `-0` is preserved.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 * @example
		 *
		 * _.toString(null);
		 * // => ''
		 *
		 * _.toString(-0);
		 * // => '-0'
		 *
		 * _.toString([1, 2, 3]);
		 * // => '1,2,3'
		 */
		function toString(value) {
		  return value == null ? '' : baseToString(value);
		}
	
		module.exports = toString;
	
	
	/***/ },
	/* 498 */,
	/* 499 */,
	/* 500 */,
	/* 501 */,
	/* 502 */,
	/* 503 */,
	/* 504 */,
	/* 505 */,
	/* 506 */,
	/* 507 */,
	/* 508 */,
	/* 509 */,
	/* 510 */,
	/* 511 */,
	/* 512 */,
	/* 513 */,
	/* 514 */,
	/* 515 */,
	/* 516 */,
	/* 517 */,
	/* 518 */,
	/* 519 */,
	/* 520 */,
	/* 521 */,
	/* 522 */,
	/* 523 */,
	/* 524 */,
	/* 525 */,
	/* 526 */,
	/* 527 */,
	/* 528 */,
	/* 529 */,
	/* 530 */,
	/* 531 */,
	/* 532 */,
	/* 533 */,
	/* 534 */,
	/* 535 */,
	/* 536 */,
	/* 537 */,
	/* 538 */,
	/* 539 */,
	/* 540 */,
	/* 541 */,
	/* 542 */,
	/* 543 */,
	/* 544 */,
	/* 545 */,
	/* 546 */,
	/* 547 */,
	/* 548 */,
	/* 549 */,
	/* 550 */,
	/* 551 */,
	/* 552 */,
	/* 553 */,
	/* 554 */,
	/* 555 */,
	/* 556 */,
	/* 557 */,
	/* 558 */,
	/* 559 */,
	/* 560 */,
	/* 561 */,
	/* 562 */,
	/* 563 */,
	/* 564 */,
	/* 565 */,
	/* 566 */,
	/* 567 */,
	/* 568 */,
	/* 569 */,
	/* 570 */,
	/* 571 */,
	/* 572 */,
	/* 573 */,
	/* 574 */,
	/* 575 */,
	/* 576 */,
	/* 577 */,
	/* 578 */,
	/* 579 */,
	/* 580 */,
	/* 581 */,
	/* 582 */,
	/* 583 */,
	/* 584 */,
	/* 585 */,
	/* 586 */,
	/* 587 */,
	/* 588 */,
	/* 589 */,
	/* 590 */,
	/* 591 */,
	/* 592 */,
	/* 593 */,
	/* 594 */,
	/* 595 */,
	/* 596 */,
	/* 597 */,
	/* 598 */,
	/* 599 */,
	/* 600 */,
	/* 601 */,
	/* 602 */,
	/* 603 */,
	/* 604 */,
	/* 605 */,
	/* 606 */,
	/* 607 */,
	/* 608 */,
	/* 609 */,
	/* 610 */,
	/* 611 */,
	/* 612 */,
	/* 613 */,
	/* 614 */,
	/* 615 */,
	/* 616 */,
	/* 617 */,
	/* 618 */,
	/* 619 */,
	/* 620 */,
	/* 621 */,
	/* 622 */,
	/* 623 */,
	/* 624 */,
	/* 625 */,
	/* 626 */,
	/* 627 */,
	/* 628 */,
	/* 629 */,
	/* 630 */,
	/* 631 */,
	/* 632 */,
	/* 633 */,
	/* 634 */,
	/* 635 */,
	/* 636 */,
	/* 637 */,
	/* 638 */,
	/* 639 */,
	/* 640 */,
	/* 641 */,
	/* 642 */,
	/* 643 */,
	/* 644 */,
	/* 645 */,
	/* 646 */,
	/* 647 */,
	/* 648 */,
	/* 649 */,
	/* 650 */,
	/* 651 */,
	/* 652 */,
	/* 653 */,
	/* 654 */,
	/* 655 */,
	/* 656 */,
	/* 657 */,
	/* 658 */,
	/* 659 */,
	/* 660 */,
	/* 661 */,
	/* 662 */,
	/* 663 */,
	/* 664 */,
	/* 665 */,
	/* 666 */,
	/* 667 */,
	/* 668 */,
	/* 669 */,
	/* 670 */,
	/* 671 */,
	/* 672 */,
	/* 673 */,
	/* 674 */,
	/* 675 */,
	/* 676 */,
	/* 677 */,
	/* 678 */,
	/* 679 */,
	/* 680 */,
	/* 681 */,
	/* 682 */,
	/* 683 */,
	/* 684 */,
	/* 685 */,
	/* 686 */,
	/* 687 */,
	/* 688 */,
	/* 689 */,
	/* 690 */,
	/* 691 */,
	/* 692 */,
	/* 693 */,
	/* 694 */,
	/* 695 */,
	/* 696 */,
	/* 697 */,
	/* 698 */,
	/* 699 */,
	/* 700 */,
	/* 701 */,
	/* 702 */,
	/* 703 */,
	/* 704 */,
	/* 705 */,
	/* 706 */,
	/* 707 */,
	/* 708 */,
	/* 709 */,
	/* 710 */,
	/* 711 */,
	/* 712 */,
	/* 713 */,
	/* 714 */,
	/* 715 */,
	/* 716 */,
	/* 717 */,
	/* 718 */,
	/* 719 */,
	/* 720 */,
	/* 721 */,
	/* 722 */,
	/* 723 */,
	/* 724 */,
	/* 725 */,
	/* 726 */,
	/* 727 */,
	/* 728 */,
	/* 729 */,
	/* 730 */,
	/* 731 */,
	/* 732 */,
	/* 733 */,
	/* 734 */,
	/* 735 */,
	/* 736 */,
	/* 737 */,
	/* 738 */,
	/* 739 */,
	/* 740 */,
	/* 741 */,
	/* 742 */,
	/* 743 */,
	/* 744 */,
	/* 745 */,
	/* 746 */,
	/* 747 */,
	/* 748 */,
	/* 749 */,
	/* 750 */,
	/* 751 */,
	/* 752 */,
	/* 753 */,
	/* 754 */,
	/* 755 */,
	/* 756 */,
	/* 757 */,
	/* 758 */,
	/* 759 */,
	/* 760 */,
	/* 761 */,
	/* 762 */,
	/* 763 */,
	/* 764 */,
	/* 765 */,
	/* 766 */,
	/* 767 */,
	/* 768 */,
	/* 769 */,
	/* 770 */,
	/* 771 */,
	/* 772 */,
	/* 773 */,
	/* 774 */,
	/* 775 */,
	/* 776 */,
	/* 777 */,
	/* 778 */,
	/* 779 */,
	/* 780 */,
	/* 781 */,
	/* 782 */,
	/* 783 */,
	/* 784 */,
	/* 785 */,
	/* 786 */,
	/* 787 */,
	/* 788 */,
	/* 789 */,
	/* 790 */,
	/* 791 */,
	/* 792 */,
	/* 793 */,
	/* 794 */,
	/* 795 */,
	/* 796 */,
	/* 797 */,
	/* 798 */,
	/* 799 */,
	/* 800 */,
	/* 801 */,
	/* 802 */,
	/* 803 */,
	/* 804 */,
	/* 805 */,
	/* 806 */,
	/* 807 */,
	/* 808 */,
	/* 809 */,
	/* 810 */,
	/* 811 */,
	/* 812 */,
	/* 813 */,
	/* 814 */,
	/* 815 */,
	/* 816 */,
	/* 817 */,
	/* 818 */,
	/* 819 */,
	/* 820 */,
	/* 821 */,
	/* 822 */,
	/* 823 */,
	/* 824 */,
	/* 825 */,
	/* 826 */,
	/* 827 */,
	/* 828 */,
	/* 829 */,
	/* 830 */,
	/* 831 */,
	/* 832 */,
	/* 833 */,
	/* 834 */,
	/* 835 */,
	/* 836 */,
	/* 837 */,
	/* 838 */,
	/* 839 */,
	/* 840 */,
	/* 841 */,
	/* 842 */,
	/* 843 */,
	/* 844 */,
	/* 845 */,
	/* 846 */,
	/* 847 */,
	/* 848 */,
	/* 849 */,
	/* 850 */,
	/* 851 */,
	/* 852 */,
	/* 853 */,
	/* 854 */,
	/* 855 */,
	/* 856 */,
	/* 857 */,
	/* 858 */,
	/* 859 */,
	/* 860 */,
	/* 861 */,
	/* 862 */,
	/* 863 */,
	/* 864 */,
	/* 865 */,
	/* 866 */,
	/* 867 */,
	/* 868 */,
	/* 869 */,
	/* 870 */,
	/* 871 */,
	/* 872 */,
	/* 873 */,
	/* 874 */,
	/* 875 */,
	/* 876 */,
	/* 877 */,
	/* 878 */,
	/* 879 */,
	/* 880 */,
	/* 881 */,
	/* 882 */,
	/* 883 */,
	/* 884 */,
	/* 885 */,
	/* 886 */,
	/* 887 */,
	/* 888 */,
	/* 889 */,
	/* 890 */,
	/* 891 */,
	/* 892 */,
	/* 893 */,
	/* 894 */,
	/* 895 */,
	/* 896 */,
	/* 897 */,
	/* 898 */,
	/* 899 */,
	/* 900 */,
	/* 901 */,
	/* 902 */,
	/* 903 */,
	/* 904 */,
	/* 905 */,
	/* 906 */,
	/* 907 */,
	/* 908 */,
	/* 909 */,
	/* 910 */,
	/* 911 */,
	/* 912 */,
	/* 913 */,
	/* 914 */,
	/* 915 */,
	/* 916 */,
	/* 917 */,
	/* 918 */,
	/* 919 */,
	/* 920 */,
	/* 921 */,
	/* 922 */,
	/* 923 */,
	/* 924 */,
	/* 925 */,
	/* 926 */,
	/* 927 */,
	/* 928 */,
	/* 929 */,
	/* 930 */,
	/* 931 */,
	/* 932 */,
	/* 933 */,
	/* 934 */,
	/* 935 */,
	/* 936 */,
	/* 937 */,
	/* 938 */,
	/* 939 */,
	/* 940 */,
	/* 941 */,
	/* 942 */,
	/* 943 */,
	/* 944 */,
	/* 945 */,
	/* 946 */,
	/* 947 */,
	/* 948 */,
	/* 949 */,
	/* 950 */,
	/* 951 */,
	/* 952 */,
	/* 953 */,
	/* 954 */,
	/* 955 */,
	/* 956 */,
	/* 957 */,
	/* 958 */,
	/* 959 */,
	/* 960 */,
	/* 961 */,
	/* 962 */,
	/* 963 */,
	/* 964 */,
	/* 965 */,
	/* 966 */,
	/* 967 */,
	/* 968 */,
	/* 969 */,
	/* 970 */,
	/* 971 */,
	/* 972 */,
	/* 973 */,
	/* 974 */,
	/* 975 */,
	/* 976 */,
	/* 977 */,
	/* 978 */,
	/* 979 */,
	/* 980 */,
	/* 981 */,
	/* 982 */,
	/* 983 */,
	/* 984 */,
	/* 985 */,
	/* 986 */,
	/* 987 */,
	/* 988 */,
	/* 989 */,
	/* 990 */,
	/* 991 */,
	/* 992 */,
	/* 993 */,
	/* 994 */,
	/* 995 */,
	/* 996 */,
	/* 997 */,
	/* 998 */,
	/* 999 */,
	/* 1000 */,
	/* 1001 */,
	/* 1002 */,
	/* 1003 */,
	/* 1004 */,
	/* 1005 */,
	/* 1006 */,
	/* 1007 */,
	/* 1008 */,
	/* 1009 */,
	/* 1010 */,
	/* 1011 */,
	/* 1012 */,
	/* 1013 */,
	/* 1014 */,
	/* 1015 */,
	/* 1016 */,
	/* 1017 */,
	/* 1018 */,
	/* 1019 */,
	/* 1020 */,
	/* 1021 */,
	/* 1022 */,
	/* 1023 */,
	/* 1024 */,
	/* 1025 */,
	/* 1026 */,
	/* 1027 */,
	/* 1028 */,
	/* 1029 */,
	/* 1030 */,
	/* 1031 */,
	/* 1032 */,
	/* 1033 */,
	/* 1034 */,
	/* 1035 */,
	/* 1036 */,
	/* 1037 */,
	/* 1038 */,
	/* 1039 */,
	/* 1040 */,
	/* 1041 */,
	/* 1042 */,
	/* 1043 */,
	/* 1044 */,
	/* 1045 */,
	/* 1046 */,
	/* 1047 */,
	/* 1048 */,
	/* 1049 */,
	/* 1050 */,
	/* 1051 */,
	/* 1052 */,
	/* 1053 */,
	/* 1054 */,
	/* 1055 */,
	/* 1056 */,
	/* 1057 */,
	/* 1058 */,
	/* 1059 */,
	/* 1060 */,
	/* 1061 */,
	/* 1062 */,
	/* 1063 */,
	/* 1064 */,
	/* 1065 */,
	/* 1066 */,
	/* 1067 */,
	/* 1068 */,
	/* 1069 */,
	/* 1070 */,
	/* 1071 */,
	/* 1072 */,
	/* 1073 */,
	/* 1074 */,
	/* 1075 */,
	/* 1076 */,
	/* 1077 */,
	/* 1078 */,
	/* 1079 */,
	/* 1080 */,
	/* 1081 */,
	/* 1082 */,
	/* 1083 */,
	/* 1084 */,
	/* 1085 */,
	/* 1086 */,
	/* 1087 */,
	/* 1088 */,
	/* 1089 */,
	/* 1090 */,
	/* 1091 */,
	/* 1092 */,
	/* 1093 */,
	/* 1094 */,
	/* 1095 */,
	/* 1096 */,
	/* 1097 */,
	/* 1098 */,
	/* 1099 */,
	/* 1100 */,
	/* 1101 */,
	/* 1102 */,
	/* 1103 */,
	/* 1104 */,
	/* 1105 */,
	/* 1106 */,
	/* 1107 */,
	/* 1108 */,
	/* 1109 */,
	/* 1110 */,
	/* 1111 */,
	/* 1112 */,
	/* 1113 */,
	/* 1114 */,
	/* 1115 */,
	/* 1116 */,
	/* 1117 */,
	/* 1118 */,
	/* 1119 */,
	/* 1120 */,
	/* 1121 */,
	/* 1122 */,
	/* 1123 */,
	/* 1124 */,
	/* 1125 */,
	/* 1126 */,
	/* 1127 */,
	/* 1128 */,
	/* 1129 */,
	/* 1130 */,
	/* 1131 */,
	/* 1132 */,
	/* 1133 */,
	/* 1134 */,
	/* 1135 */,
	/* 1136 */,
	/* 1137 */,
	/* 1138 */,
	/* 1139 */,
	/* 1140 */,
	/* 1141 */,
	/* 1142 */,
	/* 1143 */,
	/* 1144 */,
	/* 1145 */,
	/* 1146 */,
	/* 1147 */,
	/* 1148 */,
	/* 1149 */,
	/* 1150 */,
	/* 1151 */,
	/* 1152 */,
	/* 1153 */,
	/* 1154 */,
	/* 1155 */,
	/* 1156 */,
	/* 1157 */,
	/* 1158 */,
	/* 1159 */,
	/* 1160 */,
	/* 1161 */,
	/* 1162 */,
	/* 1163 */,
	/* 1164 */,
	/* 1165 */,
	/* 1166 */,
	/* 1167 */,
	/* 1168 */,
	/* 1169 */,
	/* 1170 */,
	/* 1171 */,
	/* 1172 */,
	/* 1173 */,
	/* 1174 */,
	/* 1175 */,
	/* 1176 */,
	/* 1177 */,
	/* 1178 */,
	/* 1179 */,
	/* 1180 */,
	/* 1181 */,
	/* 1182 */,
	/* 1183 */,
	/* 1184 */,
	/* 1185 */,
	/* 1186 */,
	/* 1187 */,
	/* 1188 */,
	/* 1189 */,
	/* 1190 */,
	/* 1191 */,
	/* 1192 */,
	/* 1193 */,
	/* 1194 */,
	/* 1195 */,
	/* 1196 */,
	/* 1197 */,
	/* 1198 */,
	/* 1199 */,
	/* 1200 */,
	/* 1201 */,
	/* 1202 */,
	/* 1203 */,
	/* 1204 */,
	/* 1205 */,
	/* 1206 */,
	/* 1207 */,
	/* 1208 */,
	/* 1209 */,
	/* 1210 */,
	/* 1211 */,
	/* 1212 */,
	/* 1213 */,
	/* 1214 */,
	/* 1215 */,
	/* 1216 */,
	/* 1217 */,
	/* 1218 */,
	/* 1219 */,
	/* 1220 */,
	/* 1221 */,
	/* 1222 */,
	/* 1223 */,
	/* 1224 */,
	/* 1225 */,
	/* 1226 */,
	/* 1227 */,
	/* 1228 */,
	/* 1229 */,
	/* 1230 */,
	/* 1231 */,
	/* 1232 */,
	/* 1233 */,
	/* 1234 */,
	/* 1235 */,
	/* 1236 */,
	/* 1237 */,
	/* 1238 */,
	/* 1239 */,
	/* 1240 */,
	/* 1241 */,
	/* 1242 */,
	/* 1243 */,
	/* 1244 */,
	/* 1245 */,
	/* 1246 */,
	/* 1247 */,
	/* 1248 */,
	/* 1249 */,
	/* 1250 */,
	/* 1251 */,
	/* 1252 */,
	/* 1253 */,
	/* 1254 */,
	/* 1255 */,
	/* 1256 */,
	/* 1257 */,
	/* 1258 */,
	/* 1259 */,
	/* 1260 */,
	/* 1261 */,
	/* 1262 */,
	/* 1263 */,
	/* 1264 */,
	/* 1265 */,
	/* 1266 */,
	/* 1267 */,
	/* 1268 */,
	/* 1269 */,
	/* 1270 */,
	/* 1271 */,
	/* 1272 */,
	/* 1273 */,
	/* 1274 */,
	/* 1275 */,
	/* 1276 */,
	/* 1277 */,
	/* 1278 */,
	/* 1279 */,
	/* 1280 */,
	/* 1281 */,
	/* 1282 */,
	/* 1283 */,
	/* 1284 */,
	/* 1285 */,
	/* 1286 */,
	/* 1287 */,
	/* 1288 */,
	/* 1289 */,
	/* 1290 */,
	/* 1291 */,
	/* 1292 */,
	/* 1293 */,
	/* 1294 */,
	/* 1295 */,
	/* 1296 */,
	/* 1297 */,
	/* 1298 */,
	/* 1299 */,
	/* 1300 */,
	/* 1301 */,
	/* 1302 */,
	/* 1303 */,
	/* 1304 */,
	/* 1305 */,
	/* 1306 */,
	/* 1307 */,
	/* 1308 */,
	/* 1309 */,
	/* 1310 */,
	/* 1311 */,
	/* 1312 */,
	/* 1313 */,
	/* 1314 */,
	/* 1315 */,
	/* 1316 */,
	/* 1317 */,
	/* 1318 */,
	/* 1319 */,
	/* 1320 */,
	/* 1321 */,
	/* 1322 */,
	/* 1323 */,
	/* 1324 */,
	/* 1325 */,
	/* 1326 */,
	/* 1327 */,
	/* 1328 */,
	/* 1329 */,
	/* 1330 */,
	/* 1331 */,
	/* 1332 */,
	/* 1333 */,
	/* 1334 */,
	/* 1335 */,
	/* 1336 */,
	/* 1337 */,
	/* 1338 */,
	/* 1339 */,
	/* 1340 */,
	/* 1341 */,
	/* 1342 */,
	/* 1343 */,
	/* 1344 */,
	/* 1345 */,
	/* 1346 */,
	/* 1347 */,
	/* 1348 */,
	/* 1349 */,
	/* 1350 */,
	/* 1351 */,
	/* 1352 */,
	/* 1353 */,
	/* 1354 */,
	/* 1355 */,
	/* 1356 */,
	/* 1357 */,
	/* 1358 */,
	/* 1359 */,
	/* 1360 */,
	/* 1361 */,
	/* 1362 */,
	/* 1363 */,
	/* 1364 */,
	/* 1365 */,
	/* 1366 */,
	/* 1367 */,
	/* 1368 */,
	/* 1369 */,
	/* 1370 */,
	/* 1371 */,
	/* 1372 */,
	/* 1373 */,
	/* 1374 */,
	/* 1375 */,
	/* 1376 */,
	/* 1377 */,
	/* 1378 */,
	/* 1379 */,
	/* 1380 */,
	/* 1381 */,
	/* 1382 */,
	/* 1383 */,
	/* 1384 */,
	/* 1385 */,
	/* 1386 */,
	/* 1387 */,
	/* 1388 */,
	/* 1389 */,
	/* 1390 */,
	/* 1391 */,
	/* 1392 */,
	/* 1393 */,
	/* 1394 */,
	/* 1395 */,
	/* 1396 */,
	/* 1397 */,
	/* 1398 */,
	/* 1399 */,
	/* 1400 */,
	/* 1401 */,
	/* 1402 */,
	/* 1403 */,
	/* 1404 */,
	/* 1405 */,
	/* 1406 */,
	/* 1407 */,
	/* 1408 */,
	/* 1409 */,
	/* 1410 */,
	/* 1411 */,
	/* 1412 */,
	/* 1413 */,
	/* 1414 */,
	/* 1415 */,
	/* 1416 */,
	/* 1417 */,
	/* 1418 */,
	/* 1419 */,
	/* 1420 */,
	/* 1421 */,
	/* 1422 */,
	/* 1423 */,
	/* 1424 */,
	/* 1425 */,
	/* 1426 */,
	/* 1427 */,
	/* 1428 */,
	/* 1429 */,
	/* 1430 */,
	/* 1431 */,
	/* 1432 */,
	/* 1433 */,
	/* 1434 */,
	/* 1435 */,
	/* 1436 */,
	/* 1437 */,
	/* 1438 */,
	/* 1439 */,
	/* 1440 */,
	/* 1441 */,
	/* 1442 */,
	/* 1443 */,
	/* 1444 */,
	/* 1445 */,
	/* 1446 */,
	/* 1447 */,
	/* 1448 */,
	/* 1449 */,
	/* 1450 */,
	/* 1451 */,
	/* 1452 */,
	/* 1453 */,
	/* 1454 */,
	/* 1455 */,
	/* 1456 */,
	/* 1457 */,
	/* 1458 */,
	/* 1459 */,
	/* 1460 */,
	/* 1461 */,
	/* 1462 */,
	/* 1463 */,
	/* 1464 */,
	/* 1465 */,
	/* 1466 */,
	/* 1467 */,
	/* 1468 */,
	/* 1469 */,
	/* 1470 */,
	/* 1471 */,
	/* 1472 */,
	/* 1473 */,
	/* 1474 */,
	/* 1475 */,
	/* 1476 */,
	/* 1477 */,
	/* 1478 */,
	/* 1479 */,
	/* 1480 */,
	/* 1481 */,
	/* 1482 */,
	/* 1483 */,
	/* 1484 */,
	/* 1485 */,
	/* 1486 */,
	/* 1487 */,
	/* 1488 */,
	/* 1489 */,
	/* 1490 */,
	/* 1491 */,
	/* 1492 */,
	/* 1493 */,
	/* 1494 */,
	/* 1495 */,
	/* 1496 */,
	/* 1497 */,
	/* 1498 */,
	/* 1499 */,
	/* 1500 */,
	/* 1501 */,
	/* 1502 */,
	/* 1503 */,
	/* 1504 */,
	/* 1505 */,
	/* 1506 */,
	/* 1507 */,
	/* 1508 */,
	/* 1509 */,
	/* 1510 */,
	/* 1511 */,
	/* 1512 */,
	/* 1513 */,
	/* 1514 */,
	/* 1515 */,
	/* 1516 */,
	/* 1517 */,
	/* 1518 */,
	/* 1519 */,
	/* 1520 */,
	/* 1521 */,
	/* 1522 */,
	/* 1523 */,
	/* 1524 */,
	/* 1525 */,
	/* 1526 */,
	/* 1527 */,
	/* 1528 */,
	/* 1529 */,
	/* 1530 */,
	/* 1531 */,
	/* 1532 */,
	/* 1533 */,
	/* 1534 */,
	/* 1535 */,
	/* 1536 */,
	/* 1537 */,
	/* 1538 */,
	/* 1539 */,
	/* 1540 */,
	/* 1541 */,
	/* 1542 */,
	/* 1543 */,
	/* 1544 */,
	/* 1545 */,
	/* 1546 */,
	/* 1547 */,
	/* 1548 */,
	/* 1549 */,
	/* 1550 */,
	/* 1551 */,
	/* 1552 */,
	/* 1553 */,
	/* 1554 */,
	/* 1555 */,
	/* 1556 */,
	/* 1557 */,
	/* 1558 */,
	/* 1559 */,
	/* 1560 */,
	/* 1561 */,
	/* 1562 */,
	/* 1563 */,
	/* 1564 */,
	/* 1565 */,
	/* 1566 */,
	/* 1567 */,
	/* 1568 */,
	/* 1569 */,
	/* 1570 */,
	/* 1571 */,
	/* 1572 */,
	/* 1573 */,
	/* 1574 */,
	/* 1575 */,
	/* 1576 */,
	/* 1577 */,
	/* 1578 */,
	/* 1579 */,
	/* 1580 */,
	/* 1581 */,
	/* 1582 */,
	/* 1583 */,
	/* 1584 */,
	/* 1585 */,
	/* 1586 */,
	/* 1587 */,
	/* 1588 */,
	/* 1589 */,
	/* 1590 */,
	/* 1591 */,
	/* 1592 */,
	/* 1593 */,
	/* 1594 */,
	/* 1595 */,
	/* 1596 */,
	/* 1597 */,
	/* 1598 */,
	/* 1599 */,
	/* 1600 */,
	/* 1601 */,
	/* 1602 */,
	/* 1603 */,
	/* 1604 */,
	/* 1605 */,
	/* 1606 */,
	/* 1607 */,
	/* 1608 */,
	/* 1609 */,
	/* 1610 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
	
		var hashClear = __webpack_require__(__webpack_module_template_argument_0__),
		    hashDelete = __webpack_require__(__webpack_module_template_argument_1__),
		    hashGet = __webpack_require__(__webpack_module_template_argument_2__),
		    hashHas = __webpack_require__(__webpack_module_template_argument_3__),
		    hashSet = __webpack_require__(__webpack_module_template_argument_4__);
	
		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;
	
		module.exports = Hash;
	
	
	/***/ },
	/* 1611 */,
	/* 1612 */,
	/* 1613 */,
	/* 1614 */,
	/* 1615 */,
	/* 1616 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
	
		var listCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
		    listCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
		    listCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
		    listCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
		    listCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;
	
		module.exports = ListCache;
	
	
	/***/ },
	/* 1617 */,
	/* 1618 */,
	/* 1619 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var getNative = __webpack_require__(__webpack_module_template_argument_0__),
		    root = __webpack_require__(__webpack_module_template_argument_1__);
	
		/* Built-in method references that are verified to be native. */
		var Map = getNative(root, 'Map');
	
		module.exports = Map;
	
	
	/***/ },
	/* 1620 */,
	/* 1621 */,
	/* 1622 */,
	/* 1623 */,
	/* 1624 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {
	
		var mapCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
		    mapCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
		    mapCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
		    mapCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
		    mapCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;
	
		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}
	
		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;
	
		module.exports = MapCache;
	
	
	/***/ },
	/* 1625 */,
	/* 1626 */,
	/* 1627 */,
	/* 1628 */,
	/* 1629 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var getNative = __webpack_require__(__webpack_module_template_argument_0__),
		    root = __webpack_require__(__webpack_module_template_argument_1__);
	
		/* Built-in method references that are verified to be native. */
		var Set = getNative(root, 'Set');
	
		module.exports = Set;
	
	
	/***/ },
	/* 1630 */,
	/* 1631 */,
	/* 1632 */,
	/* 1633 */,
	/* 1634 */,
	/* 1635 */,
	/* 1636 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var MapCache = __webpack_require__(__webpack_module_template_argument_0__),
		    setCacheAdd = __webpack_require__(__webpack_module_template_argument_1__),
		    setCacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
		/**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */
		function SetCache(values) {
		  var index = -1,
		      length = values == null ? 0 : values.length;
	
		  this.__data__ = new MapCache;
		  while (++index < length) {
		    this.add(values[index]);
		  }
		}
	
		// Add methods to `SetCache`.
		SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
		SetCache.prototype.has = setCacheHas;
	
		module.exports = SetCache;
	
	
	/***/ },
	/* 1637 */,
	/* 1638 */,
	/* 1639 */,
	/* 1640 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var root = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Built-in value references. */
		var Symbol = root.Symbol;
	
		module.exports = Symbol;
	
	
	/***/ },
	/* 1641 */,
	/* 1642 */,
	/* 1643 */,
	/* 1644 */,
	/* 1645 */,
	/* 1646 */,
	/* 1647 */,
	/* 1648 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {
	
		var baseTimes = __webpack_require__(__webpack_module_template_argument_0__),
		    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
		    isArray = __webpack_require__(__webpack_module_template_argument_2__),
		    isBuffer = __webpack_require__(__webpack_module_template_argument_3__),
		    isIndex = __webpack_require__(__webpack_module_template_argument_4__),
		    isTypedArray = __webpack_require__(__webpack_module_template_argument_5__);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  var isArr = isArray(value),
		      isArg = !isArr && isArguments(value),
		      isBuff = !isArr && !isArg && isBuffer(value),
		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
		      skipIndexes = isArr || isArg || isBuff || isType,
		      result = skipIndexes ? baseTimes(value.length, String) : [],
		      length = result.length;
	
		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (
		           // Safari 9 has enumerable `arguments.length` in strict mode.
		           key == 'length' ||
		           // Node.js 0.10 has enumerable non-index properties on buffers.
		           (isBuff && (key == 'offset' || key == 'parent')) ||
		           // PhantomJS 2 has enumerable non-index properties on typed arrays.
		           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
		           // Skip index properties.
		           isIndex(key, length)
		        ))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = arrayLikeKeys;
	
	
	/***/ },
	/* 1649 */,
	/* 1650 */,
	/* 1651 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var eq = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}
	
		module.exports = assocIndexOf;
	
	
	/***/ },
	/* 1652 */,
	/* 1653 */,
	/* 1654 */,
	/* 1655 */,
	/* 1656 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * The base implementation of `assignValue` and `assignMergeValue` without
		 * value checks.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function baseAssignValue(object, key, value) {
		  if (key == '__proto__' && defineProperty) {
		    defineProperty(object, key, {
		      'configurable': true,
		      'enumerable': true,
		      'value': value,
		      'writable': true
		    });
		  } else {
		    object[key] = value;
		  }
		}
	
		module.exports = baseAssignValue;
	
	
	/***/ },
	/* 1657 */,
	/* 1658 */,
	/* 1659 */,
	/* 1660 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
		    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
		    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
		/** `Object#toString` result references. */
		var nullTag = '[object Null]',
		    undefinedTag = '[object Undefined]';
	
		/** Built-in value references. */
		var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
		/**
		 * The base implementation of `getTag` without fallbacks for buggy environments.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  if (value == null) {
		    return value === undefined ? undefinedTag : nullTag;
		  }
		  return (symToStringTag && symToStringTag in Object(value))
		    ? getRawTag(value)
		    : objectToString(value);
		}
	
		module.exports = baseGetTag;
	
	
	/***/ },
	/* 1661 */,
	/* 1662 */,
	/* 1663 */,
	/* 1664 */,
	/* 1665 */,
	/* 1666 */,
	/* 1667 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
		    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]';
	
		/**
		 * The base implementation of `_.isArguments`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 */
		function baseIsArguments(value) {
		  return isObjectLike(value) && baseGetTag(value) == argsTag;
		}
	
		module.exports = baseIsArguments;
	
	
	/***/ },
	/* 1668 */,
	/* 1669 */,
	/* 1670 */,
	/* 1671 */,
	/* 1672 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {
	
		var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
		    isMasked = __webpack_require__(__webpack_module_template_argument_1__),
		    isObject = __webpack_require__(__webpack_module_template_argument_2__),
		    toSource = __webpack_require__(__webpack_module_template_argument_3__);
	
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype,
		    objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);
	
		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}
	
		module.exports = baseIsNative;
	
	
	/***/ },
	/* 1673 */,
	/* 1674 */,
	/* 1675 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
		    isLength = __webpack_require__(__webpack_module_template_argument_1__),
		    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;
	
		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
		}
	
		module.exports = baseIsTypedArray;
	
	
	/***/ },
	/* 1676 */,
	/* 1677 */,
	/* 1678 */,
	/* 1679 */,
	/* 1680 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var root = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];
	
		module.exports = coreJsData;
	
	
	/***/ },
	/* 1681 */,
	/* 1682 */,
	/* 1683 */,
	/* 1684 */,
	/* 1685 */,
	/* 1686 */,
	/* 1687 */,
	/* 1688 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
		var defineProperty = (function() {
		  try {
		    var func = getNative(Object, 'defineProperty');
		    func({}, '', {});
		    return func;
		  } catch (e) {}
		}());
	
		module.exports = defineProperty;
	
	
	/***/ },
	/* 1689 */,
	/* 1690 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var isKeyable = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}
	
		module.exports = getMapData;
	
	
	/***/ },
	/* 1691 */,
	/* 1692 */,
	/* 1693 */,
	/* 1694 */,
	/* 1695 */,
	/* 1696 */,
	/* 1697 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var baseIsNative = __webpack_require__(__webpack_module_template_argument_0__),
		    getValue = __webpack_require__(__webpack_module_template_argument_1__);
	
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}
	
		module.exports = getNative;
	
	
	/***/ },
	/* 1698 */,
	/* 1699 */,
	/* 1700 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;
	
		/** Built-in value references. */
		var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
		/**
		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the raw `toStringTag`.
		 */
		function getRawTag(value) {
		  var isOwn = hasOwnProperty.call(value, symToStringTag),
		      tag = value[symToStringTag];
	
		  try {
		    value[symToStringTag] = undefined;
		    var unmasked = true;
		  } catch (e) {}
	
		  var result = nativeObjectToString.call(value);
		  if (unmasked) {
		    if (isOwn) {
		      value[symToStringTag] = tag;
		    } else {
		      delete value[symToStringTag];
		    }
		  }
		  return result;
		}
	
		module.exports = getRawTag;
	
	
	/***/ },
	/* 1701 */,
	/* 1702 */,
	/* 1703 */,
	/* 1704 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		  this.size = 0;
		}
	
		module.exports = hashClear;
	
	
	/***/ },
	/* 1705 */,
	/* 1706 */,
	/* 1707 */,
	/* 1708 */,
	/* 1709 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}
	
		module.exports = hashGet;
	
	
	/***/ },
	/* 1710 */,
	/* 1711 */,
	/* 1712 */,
	/* 1713 */,
	/* 1714 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
		}
	
		module.exports = hashHas;
	
	
	/***/ },
	/* 1715 */,
	/* 1716 */,
	/* 1717 */,
	/* 1718 */,
	/* 1719 */,
	/* 1720 */,
	/* 1721 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  this.size += this.has(key) ? 0 : 1;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}
	
		module.exports = hashSet;
	
	
	/***/ },
	/* 1722 */,
	/* 1723 */,
	/* 1724 */,
	/* 1725 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var coreJsData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());
	
		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}
	
		module.exports = isMasked;
	
	
	/***/ },
	/* 1726 */,
	/* 1727 */,
	/* 1728 */,
	/* 1729 */,
	/* 1730 */,
	/* 1731 */,
	/* 1732 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Used for built-in method references. */
		var arrayProto = Array.prototype;
	
		/** Built-in value references. */
		var splice = arrayProto.splice;
	
		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  --this.size;
		  return true;
		}
	
		module.exports = listCacheDelete;
	
	
	/***/ },
	/* 1733 */,
	/* 1734 */,
	/* 1735 */,
	/* 1736 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  return index < 0 ? undefined : data[index][1];
		}
	
		module.exports = listCacheGet;
	
	
	/***/ },
	/* 1737 */,
	/* 1738 */,
	/* 1739 */,
	/* 1740 */,
	/* 1741 */,
	/* 1742 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}
	
		module.exports = listCacheHas;
	
	
	/***/ },
	/* 1743 */,
	/* 1744 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    ++this.size;
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}
	
		module.exports = listCacheSet;
	
	
	/***/ },
	/* 1745 */,
	/* 1746 */,
	/* 1747 */,
	/* 1748 */,
	/* 1749 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var Hash = __webpack_require__(__webpack_module_template_argument_0__),
		    ListCache = __webpack_require__(__webpack_module_template_argument_1__),
		    Map = __webpack_require__(__webpack_module_template_argument_2__);
	
		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.size = 0;
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}
	
		module.exports = mapCacheClear;
	
	
	/***/ },
	/* 1750 */,
	/* 1751 */,
	/* 1752 */,
	/* 1753 */,
	/* 1754 */,
	/* 1755 */,
	/* 1756 */,
	/* 1757 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  var result = getMapData(this, key)['delete'](key);
		  this.size -= result ? 1 : 0;
		  return result;
		}
	
		module.exports = mapCacheDelete;
	
	
	/***/ },
	/* 1758 */,
	/* 1759 */,
	/* 1760 */,
	/* 1761 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}
	
		module.exports = mapCacheGet;
	
	
	/***/ },
	/* 1762 */,
	/* 1763 */,
	/* 1764 */,
	/* 1765 */,
	/* 1766 */,
	/* 1767 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}
	
		module.exports = mapCacheHas;
	
	
	/***/ },
	/* 1768 */,
	/* 1769 */,
	/* 1770 */,
	/* 1771 */,
	/* 1772 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  var data = getMapData(this, key),
		      size = data.size;
	
		  data.set(key, value);
		  this.size += data.size == size ? 0 : 1;
		  return this;
		}
	
		module.exports = mapCacheSet;
	
	
	/***/ },
	/* 1773 */,
	/* 1774 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
		/* Built-in method references that are verified to be native. */
		var nativeCreate = getNative(Object, 'create');
	
		module.exports = nativeCreate;
	
	
	/***/ },
	/* 1775 */,
	/* 1776 */,
	/* 1777 */,
	/* 1778 */,
	/* 1779 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;
	
		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());
	
		module.exports = nodeUtil;
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))
	
	/***/ },
	/* 1780 */,
	/* 1781 */,
	/* 1782 */,
	/* 1783 */,
	/* 1784 */,
	/* 1785 */,
	/* 1786 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();
	
		module.exports = root;
	
	
	/***/ },
	/* 1787 */,
	/* 1788 */,
	/* 1789 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var baseIsArguments = __webpack_require__(__webpack_module_template_argument_0__),
		    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
		  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
		    !propertyIsEnumerable.call(value, 'callee');
		};
	
		module.exports = isArguments;
	
	
	/***/ },
	/* 1790 */,
	/* 1791 */,
	/* 1792 */,
	/* 1793 */,
	/* 1794 */,
	/* 1795 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
		    isLength = __webpack_require__(__webpack_module_template_argument_1__);
	
		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}
	
		module.exports = isArrayLike;
	
	
	/***/ },
	/* 1796 */,
	/* 1797 */,
	/* 1798 */,
	/* 1799 */,
	/* 1800 */,
	/* 1801 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(__webpack_module_template_argument_0__),
		    stubFalse = __webpack_require__(__webpack_module_template_argument_1__);
	
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;
	
		module.exports = isBuffer;
	
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)(module)))
	
	/***/ },
	/* 1802 */,
	/* 1803 */,
	/* 1804 */,
	/* 1805 */,
	/* 1806 */,
	/* 1807 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {
	
		var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
		    isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
		/** `Object#toString` result references. */
		var asyncTag = '[object AsyncFunction]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    proxyTag = '[object Proxy]';
	
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  if (!isObject(value)) {
		    return false;
		  }
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 9 which returns 'object' for typed arrays and other constructors.
		  var tag = baseGetTag(value);
		  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
		}
	
		module.exports = isFunction;
	
	
	/***/ },
	/* 1808 */,
	/* 1809 */,
	/* 1810 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {
	
		var baseIsTypedArray = __webpack_require__(__webpack_module_template_argument_0__),
		    baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
		    nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);
	
		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
		module.exports = isTypedArray;
	
	
	/***/ },
	/* 1811 */,
	/* 1812 */,
	/* 1813 */,
	/* 1814 */,
	/* 1815 */,
	/* 1816 */,
	/* 1817 */,
	/* 1818 */
	/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {
	
		var MapCache = __webpack_require__(__webpack_module_template_argument_0__);
	
		/** Error message constants. */
		var FUNC_ERROR_TEXT = 'Expected a function';
	
		/**
		 * Creates a function that memoizes the result of `func`. If `resolver` is
		 * provided, it determines the cache key for storing the result based on the
		 * arguments provided to the memoized function. By default, the first argument
		 * provided to the memoized function is used as the map cache key. The `func`
		 * is invoked with the `this` binding of the memoized function.
		 *
		 * **Note:** The cache is exposed as the `cache` property on the memoized
		 * function. Its creation may be customized by replacing the `_.memoize.Cache`
		 * constructor with one whose instances implement the
		 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
		 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to have its output memoized.
		 * @param {Function} [resolver] The function to resolve the cache key.
		 * @returns {Function} Returns the new memoized function.
		 * @example
		 *
		 * var object = { 'a': 1, 'b': 2 };
		 * var other = { 'c': 3, 'd': 4 };
		 *
		 * var values = _.memoize(_.values);
		 * values(object);
		 * // => [1, 2]
		 *
		 * values(other);
		 * // => [3, 4]
		 *
		 * object.a = 2;
		 * values(object);
		 * // => [1, 2]
		 *
		 * // Modify the result cache.
		 * values.cache.set(object, ['a', 'b']);
		 * values(object);
		 * // => ['a', 'b']
		 *
		 * // Replace `_.memoize.Cache`.
		 * _.memoize.Cache = WeakMap;
		 */
		function memoize(func, resolver) {
		  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  var memoized = function() {
		    var args = arguments,
		        key = resolver ? resolver.apply(this, args) : args[0],
		        cache = memoized.cache;
	
		    if (cache.has(key)) {
		      return cache.get(key);
		    }
		    var result = func.apply(this, args);
		    memoized.cache = cache.set(key, result) || cache;
		    return result;
		  };
		  memoized.cache = new (memoize.Cache || MapCache);
		  return memoized;
		}
	
		// Expose `MapCache`.
		memoize.Cache = MapCache;
	
		module.exports = memoize;
	
	
	/***/ }
	/******/ ])))
	});
	;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(23));
		else if(typeof define === 'function' && define.amd)
			define(["react", "react-dom"], factory);
		else if(typeof exports === 'object')
			exports["ReactDataGrid"] = factory(require("react"), require("react-dom"));
		else
			root["ReactDataGrid"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(186);
	
	
	/***/ },
	/* 1 */,
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */,
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */,
	/* 6 */,
	/* 7 */
	/***/ function(module, exports) {
	
		/*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
		// css base code, injected by the css-loader
		module.exports = function() {
			var list = [];
	
			// return the list of modules as css string
			list.toString = function toString() {
				var result = [];
				for(var i = 0; i < this.length; i++) {
					var item = this[i];
					if(item[2]) {
						result.push("@media " + item[2] + "{" + item[1] + "}");
					} else {
						result.push(item[1]);
					}
				}
				return result.join("");
			};
	
			// import a list of modules into the list
			list.i = function(modules, mediaQuery) {
				if(typeof modules === "string")
					modules = [[null, modules, ""]];
				var alreadyImportedModules = {};
				for(var i = 0; i < this.length; i++) {
					var id = this[i][0];
					if(typeof id === "number")
						alreadyImportedModules[id] = true;
				}
				for(i = 0; i < modules.length; i++) {
					var item = modules[i];
					// skip already imported module
					// this implementation is not 100% perfect for weird media query combinations
					//  when a module is imported multiple times with different media queries.
					//  I hope this will never occur (Hey this way we have smaller bundles)
					if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
						if(mediaQuery && !item[2]) {
							item[2] = mediaQuery;
						} else if(mediaQuery) {
							item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
						}
						list.push(item);
					}
				}
			};
			return list;
		};
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
		var stylesInDom = {},
			memoize = function(fn) {
				var memo;
				return function () {
					if (typeof memo === "undefined") memo = fn.apply(this, arguments);
					return memo;
				};
			},
			isOldIE = memoize(function() {
				return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
			}),
			getHeadElement = memoize(function () {
				return document.head || document.getElementsByTagName("head")[0];
			}),
			singletonElement = null,
			singletonCounter = 0,
			styleElementsInsertedAtTop = [];
	
		module.exports = function(list, options) {
			if(false) {
				if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
			}
	
			options = options || {};
			// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
			// tags it will allow on a page
			if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
			// By default, add <style> tags to the bottom of <head>.
			if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
			var styles = listToStyles(list);
			addStylesToDom(styles, options);
	
			return function update(newList) {
				var mayRemove = [];
				for(var i = 0; i < styles.length; i++) {
					var item = styles[i];
					var domStyle = stylesInDom[item.id];
					domStyle.refs--;
					mayRemove.push(domStyle);
				}
				if(newList) {
					var newStyles = listToStyles(newList);
					addStylesToDom(newStyles, options);
				}
				for(var i = 0; i < mayRemove.length; i++) {
					var domStyle = mayRemove[i];
					if(domStyle.refs === 0) {
						for(var j = 0; j < domStyle.parts.length; j++)
							domStyle.parts[j]();
						delete stylesInDom[domStyle.id];
					}
				}
			};
		}
	
		function addStylesToDom(styles, options) {
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				if(domStyle) {
					domStyle.refs++;
					for(var j = 0; j < domStyle.parts.length; j++) {
						domStyle.parts[j](item.parts[j]);
					}
					for(; j < item.parts.length; j++) {
						domStyle.parts.push(addStyle(item.parts[j], options));
					}
				} else {
					var parts = [];
					for(var j = 0; j < item.parts.length; j++) {
						parts.push(addStyle(item.parts[j], options));
					}
					stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
				}
			}
		}
	
		function listToStyles(list) {
			var styles = [];
			var newStyles = {};
			for(var i = 0; i < list.length; i++) {
				var item = list[i];
				var id = item[0];
				var css = item[1];
				var media = item[2];
				var sourceMap = item[3];
				var part = {css: css, media: media, sourceMap: sourceMap};
				if(!newStyles[id])
					styles.push(newStyles[id] = {id: id, parts: [part]});
				else
					newStyles[id].parts.push(part);
			}
			return styles;
		}
	
		function insertStyleElement(options, styleElement) {
			var head = getHeadElement();
			var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
			if (options.insertAt === "top") {
				if(!lastStyleElementInsertedAtTop) {
					head.insertBefore(styleElement, head.firstChild);
				} else if(lastStyleElementInsertedAtTop.nextSibling) {
					head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
				} else {
					head.appendChild(styleElement);
				}
				styleElementsInsertedAtTop.push(styleElement);
			} else if (options.insertAt === "bottom") {
				head.appendChild(styleElement);
			} else {
				throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
			}
		}
	
		function removeStyleElement(styleElement) {
			styleElement.parentNode.removeChild(styleElement);
			var idx = styleElementsInsertedAtTop.indexOf(styleElement);
			if(idx >= 0) {
				styleElementsInsertedAtTop.splice(idx, 1);
			}
		}
	
		function createStyleElement(options) {
			var styleElement = document.createElement("style");
			styleElement.type = "text/css";
			insertStyleElement(options, styleElement);
			return styleElement;
		}
	
		function createLinkElement(options) {
			var linkElement = document.createElement("link");
			linkElement.rel = "stylesheet";
			insertStyleElement(options, linkElement);
			return linkElement;
		}
	
		function addStyle(obj, options) {
			var styleElement, update, remove;
	
			if (options.singleton) {
				var styleIndex = singletonCounter++;
				styleElement = singletonElement || (singletonElement = createStyleElement(options));
				update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
				remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
			} else if(obj.sourceMap &&
				typeof URL === "function" &&
				typeof URL.createObjectURL === "function" &&
				typeof URL.revokeObjectURL === "function" &&
				typeof Blob === "function" &&
				typeof btoa === "function") {
				styleElement = createLinkElement(options);
				update = updateLink.bind(null, styleElement);
				remove = function() {
					removeStyleElement(styleElement);
					if(styleElement.href)
						URL.revokeObjectURL(styleElement.href);
				};
			} else {
				styleElement = createStyleElement(options);
				update = applyToTag.bind(null, styleElement);
				remove = function() {
					removeStyleElement(styleElement);
				};
			}
	
			update(obj);
	
			return function updateStyle(newObj) {
				if(newObj) {
					if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
						return;
					update(obj = newObj);
				} else {
					remove();
				}
			};
		}
	
		var replaceText = (function () {
			var textStore = [];
	
			return function (index, replacement) {
				textStore[index] = replacement;
				return textStore.filter(Boolean).join('\n');
			};
		})();
	
		function applyToSingletonTag(styleElement, index, remove, obj) {
			var css = remove ? "" : obj.css;
	
			if (styleElement.styleSheet) {
				styleElement.styleSheet.cssText = replaceText(index, css);
			} else {
				var cssNode = document.createTextNode(css);
				var childNodes = styleElement.childNodes;
				if (childNodes[index]) styleElement.removeChild(childNodes[index]);
				if (childNodes.length) {
					styleElement.insertBefore(cssNode, childNodes[index]);
				} else {
					styleElement.appendChild(cssNode);
				}
			}
		}
	
		function applyToTag(styleElement, obj) {
			var css = obj.css;
			var media = obj.media;
	
			if(media) {
				styleElement.setAttribute("media", media)
			}
	
			if(styleElement.styleSheet) {
				styleElement.styleSheet.cssText = css;
			} else {
				while(styleElement.firstChild) {
					styleElement.removeChild(styleElement.firstChild);
				}
				styleElement.appendChild(document.createTextNode(css));
			}
		}
	
		function updateLink(linkElement, obj) {
			var css = obj.css;
			var sourceMap = obj.sourceMap;
	
			if(sourceMap) {
				// http://stackoverflow.com/a/26603875
				css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
			}
	
			var blob = new Blob([css], { type: "text/css" });
	
			var oldSrc = linkElement.href;
	
			linkElement.href = URL.createObjectURL(blob);
	
			if(oldSrc)
				URL.revokeObjectURL(oldSrc);
		}
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2015 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	
		function classNames() {
			var classes = '';
			var arg;
	
			for (var i = 0; i < arguments.length; i++) {
				arg = arguments[i];
				if (!arg) {
					continue;
				}
	
				if ('string' === typeof arg || 'number' === typeof arg) {
					classes += ' ' + arg;
				} else if (Object.prototype.toString.call(arg) === '[object Array]') {
					classes += ' ' + classNames.apply(null, arg);
				} else if ('object' === typeof arg) {
					for (var key in arg) {
						if (!arg.hasOwnProperty(key) || !arg[key]) {
							continue;
						}
						classes += ' ' + key;
					}
				}
			}
			return classes.substr(1);
		}
	
		// safely export classNames for node / browserify
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		}
	
		// safely export classNames for RequireJS
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = {
		  getColumn: function getColumn(columns, idx) {
		    if (Array.isArray(columns)) {
		      return columns[idx];
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.get(idx);
		    }
		  },
		  spliceColumn: function spliceColumn(metrics, idx, column) {
		    if (Array.isArray(metrics.columns)) {
		      metrics.columns.splice(idx, 1, column);
		    } else if (typeof Immutable !== 'undefined') {
		      metrics.columns = metrics.columns.splice(idx, 1, column);
		    }
		    return metrics;
		  },
		  getSize: function getSize(columns) {
		    if (Array.isArray(columns)) {
		      return columns.length;
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.size;
		    }
		  },
	
	
		  // Logic extented to allow for functions to be passed down in column.editable
		  // this allows us to deicde whether we can be edting from a cell level
		  canEdit: function canEdit(col, rowData, enableCellSelect) {
		    if (col.editable != null && typeof col.editable === 'function') {
		      return enableCellSelect === true && col.editable(rowData);
		    }
		    return enableCellSelect === true && (!!col.editor || !!col.editable);
		  }
		};
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var ExcelColumnShape = {
		  name: React.PropTypes.node.isRequired,
		  key: React.PropTypes.string.isRequired,
		  width: React.PropTypes.number.isRequired,
		  filterable: React.PropTypes.bool
		};
	
		module.exports = ExcelColumnShape;
	
	/***/ },
	/* 12 */,
	/* 13 */,
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var PropTypes = __webpack_require__(2).PropTypes;
	
		module.exports = {
		  selected: PropTypes.object.isRequired,
		  copied: PropTypes.object,
		  dragged: PropTypes.object,
		  onCellClick: PropTypes.func.isRequired,
		  onCellDoubleClick: PropTypes.func.isRequired,
		  onCommit: PropTypes.func.isRequired,
		  onCommitCancel: PropTypes.func.isRequired,
		  handleDragEnterRow: PropTypes.func.isRequired,
		  handleTerminateDrag: PropTypes.func.isRequired
		};
	
	/***/ },
	/* 15 */,
	/* 16 */,
	/* 17 */
	/***/ function(module, exports) {
	
		"use strict";
	
		function createObjectWithProperties(originalObj, properties) {
		  var result = {};
		  for (var _iterator = properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var property = _ref;
	
		    if (originalObj[property]) {
		      result[property] = originalObj[property];
		    }
		  }
		  return result;
		}
	
		module.exports = createObjectWithProperties;
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(196);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-header.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-header.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 19 */,
	/* 20 */,
	/* 21 */,
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var shallowCloneObject = __webpack_require__(36);
	
		var contextTypes = {
		  metricsComputator: React.PropTypes.object
		};
	
		var MetricsComputatorMixin = {
	
		  childContextTypes: contextTypes,
	
		  getChildContext: function getChildContext() {
		    return { metricsComputator: this };
		  },
		  getMetricImpl: function getMetricImpl(name) {
		    return this._DOMMetrics.metrics[name].value;
		  },
		  registerMetricsImpl: function registerMetricsImpl(component, metrics) {
		    var getters = {};
		    var s = this._DOMMetrics;
	
		    for (var name in metrics) {
		      if (s.metrics[name] !== undefined) {
		        throw new Error('DOM metric ' + name + ' is already defined');
		      }
		      s.metrics[name] = { component: component, computator: metrics[name].bind(component) };
		      getters[name] = this.getMetricImpl.bind(null, name);
		    }
	
		    if (s.components.indexOf(component) === -1) {
		      s.components.push(component);
		    }
	
		    return getters;
		  },
		  unregisterMetricsFor: function unregisterMetricsFor(component) {
		    var s = this._DOMMetrics;
		    var idx = s.components.indexOf(component);
	
		    if (idx > -1) {
		      s.components.splice(idx, 1);
	
		      var name = void 0;
		      var metricsToDelete = {};
	
		      for (name in s.metrics) {
		        if (s.metrics[name].component === component) {
		          metricsToDelete[name] = true;
		        }
		      }
	
		      for (name in metricsToDelete) {
		        if (metricsToDelete.hasOwnProperty(name)) {
		          delete s.metrics[name];
		        }
		      }
		    }
		  },
		  updateMetrics: function updateMetrics() {
		    var s = this._DOMMetrics;
	
		    var needUpdate = false;
	
		    for (var name in s.metrics) {
		      if (!s.metrics.hasOwnProperty(name)) continue;
	
		      var newMetric = s.metrics[name].computator();
		      if (newMetric !== s.metrics[name].value) {
		        needUpdate = true;
		      }
		      s.metrics[name].value = newMetric;
		    }
	
		    if (needUpdate) {
		      for (var i = 0, len = s.components.length; i < len; i++) {
		        if (s.components[i].metricsUpdated) {
		          s.components[i].metricsUpdated();
		        }
		      }
		    }
		  },
		  componentWillMount: function componentWillMount() {
		    this._DOMMetrics = {
		      metrics: {},
		      components: []
		    };
		  },
		  componentDidMount: function componentDidMount() {
		    if (window.addEventListener) {
		      window.addEventListener('resize', this.updateMetrics);
		    } else {
		      window.attachEvent('resize', this.updateMetrics);
		    }
		    this.updateMetrics();
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    window.removeEventListener('resize', this.updateMetrics);
		  }
		};
	
		var MetricsMixin = {
	
		  contextTypes: contextTypes,
	
		  componentWillMount: function componentWillMount() {
		    if (this.DOMMetrics) {
		      this._DOMMetricsDefs = shallowCloneObject(this.DOMMetrics);
	
		      this.DOMMetrics = {};
		      for (var name in this._DOMMetricsDefs) {
		        if (!this._DOMMetricsDefs.hasOwnProperty(name)) continue;
	
		        this.DOMMetrics[name] = function () {};
		      }
		    }
		  },
		  componentDidMount: function componentDidMount() {
		    if (this.DOMMetrics) {
		      this.DOMMetrics = this.registerMetrics(this._DOMMetricsDefs);
		    }
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    if (!this.registerMetricsImpl) {
		      return this.context.metricsComputator.unregisterMetricsFor(this);
		    }
		    if (this.hasOwnProperty('DOMMetrics')) {
		      delete this.DOMMetrics;
		    }
		  },
		  registerMetrics: function registerMetrics(metrics) {
		    if (this.registerMetricsImpl) {
		      return this.registerMetricsImpl(this, metrics);
		    }
	
		    return this.context.metricsComputator.registerMetricsImpl(this, metrics);
		  },
		  getMetric: function getMetric(name) {
		    if (this.getMetricImpl) {
		      return this.getMetricImpl(name);
		    }
	
		    return this.context.metricsComputator.getMetricImpl(name);
		  }
		};
	
		module.exports = {
		  MetricsComputatorMixin: MetricsComputatorMixin,
		  MetricsMixin: MetricsMixin
		};
	
	/***/ },
	/* 23 */,
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 *  Copyright (c) 2014-2015, Facebook, Inc.
		 *  All rights reserved.
		 *
		 *  This source code is licensed under the BSD-style license found in the
		 *  LICENSE file in the root directory of this source tree. An additional grant
		 *  of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		(function (global, factory) {
		   true ? module.exports = factory() :
		  typeof define === 'function' && define.amd ? define(factory) :
		  (global.Immutable = factory());
		}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
		  function createClass(ctor, superClass) {
		    if (superClass) {
		      ctor.prototype = Object.create(superClass.prototype);
		    }
		    ctor.prototype.constructor = ctor;
		  }
	
		  function Iterable(value) {
		      return isIterable(value) ? value : Seq(value);
		    }
	
	
		  createClass(KeyedIterable, Iterable);
		    function KeyedIterable(value) {
		      return isKeyed(value) ? value : KeyedSeq(value);
		    }
	
	
		  createClass(IndexedIterable, Iterable);
		    function IndexedIterable(value) {
		      return isIndexed(value) ? value : IndexedSeq(value);
		    }
	
	
		  createClass(SetIterable, Iterable);
		    function SetIterable(value) {
		      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
		    }
	
	
	
		  function isIterable(maybeIterable) {
		    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
		  }
	
		  function isKeyed(maybeKeyed) {
		    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
		  }
	
		  function isIndexed(maybeIndexed) {
		    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
		  }
	
		  function isAssociative(maybeAssociative) {
		    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
		  }
	
		  function isOrdered(maybeOrdered) {
		    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
		  }
	
		  Iterable.isIterable = isIterable;
		  Iterable.isKeyed = isKeyed;
		  Iterable.isIndexed = isIndexed;
		  Iterable.isAssociative = isAssociative;
		  Iterable.isOrdered = isOrdered;
	
		  Iterable.Keyed = KeyedIterable;
		  Iterable.Indexed = IndexedIterable;
		  Iterable.Set = SetIterable;
	
	
		  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
		  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
		  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
		  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
		  // Used for setting prototype methods that IE8 chokes on.
		  var DELETE = 'delete';
	
		  // Constants describing the size of trie nodes.
		  var SHIFT = 5; // Resulted in best performance after ______?
		  var SIZE = 1 << SHIFT;
		  var MASK = SIZE - 1;
	
		  // A consistent shared value representing "not set" which equals nothing other
		  // than itself, and nothing that could be provided externally.
		  var NOT_SET = {};
	
		  // Boolean references, Rough equivalent of `bool &`.
		  var CHANGE_LENGTH = { value: false };
		  var DID_ALTER = { value: false };
	
		  function MakeRef(ref) {
		    ref.value = false;
		    return ref;
		  }
	
		  function SetRef(ref) {
		    ref && (ref.value = true);
		  }
	
		  // A function which returns a value representing an "owner" for transient writes
		  // to tries. The return value will only ever equal itself, and will not equal
		  // the return of any subsequent call of this function.
		  function OwnerID() {}
	
		  // http://jsperf.com/copy-array-inline
		  function arrCopy(arr, offset) {
		    offset = offset || 0;
		    var len = Math.max(0, arr.length - offset);
		    var newArr = new Array(len);
		    for (var ii = 0; ii < len; ii++) {
		      newArr[ii] = arr[ii + offset];
		    }
		    return newArr;
		  }
	
		  function ensureSize(iter) {
		    if (iter.size === undefined) {
		      iter.size = iter.__iterate(returnTrue);
		    }
		    return iter.size;
		  }
	
		  function wrapIndex(iter, index) {
		    // This implements "is array index" which the ECMAString spec defines as:
		    //
		    //     A String property name P is an array index if and only if
		    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
		    //     to 2^32−1.
		    //
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
		    if (typeof index !== 'number') {
		      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
		      if ('' + uint32Index !== index || uint32Index === 4294967295) {
		        return NaN;
		      }
		      index = uint32Index;
		    }
		    return index < 0 ? ensureSize(iter) + index : index;
		  }
	
		  function returnTrue() {
		    return true;
		  }
	
		  function wholeSlice(begin, end, size) {
		    return (begin === 0 || (size !== undefined && begin <= -size)) &&
		      (end === undefined || (size !== undefined && end >= size));
		  }
	
		  function resolveBegin(begin, size) {
		    return resolveIndex(begin, size, 0);
		  }
	
		  function resolveEnd(end, size) {
		    return resolveIndex(end, size, size);
		  }
	
		  function resolveIndex(index, size, defaultIndex) {
		    return index === undefined ?
		      defaultIndex :
		      index < 0 ?
		        Math.max(0, size + index) :
		        size === undefined ?
		          index :
		          Math.min(size, index);
		  }
	
		  /* global Symbol */
	
		  var ITERATE_KEYS = 0;
		  var ITERATE_VALUES = 1;
		  var ITERATE_ENTRIES = 2;
	
		  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
		  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
		  function Iterator(next) {
		      this.next = next;
		    }
	
		    Iterator.prototype.toString = function() {
		      return '[Iterator]';
		    };
	
	
		  Iterator.KEYS = ITERATE_KEYS;
		  Iterator.VALUES = ITERATE_VALUES;
		  Iterator.ENTRIES = ITERATE_ENTRIES;
	
		  Iterator.prototype.inspect =
		  Iterator.prototype.toSource = function () { return this.toString(); }
		  Iterator.prototype[ITERATOR_SYMBOL] = function () {
		    return this;
		  };
	
	
		  function iteratorValue(type, k, v, iteratorResult) {
		    var value = type === 0 ? k : type === 1 ? v : [k, v];
		    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
		      value: value, done: false
		    });
		    return iteratorResult;
		  }
	
		  function iteratorDone() {
		    return { value: undefined, done: true };
		  }
	
		  function hasIterator(maybeIterable) {
		    return !!getIteratorFn(maybeIterable);
		  }
	
		  function isIterator(maybeIterator) {
		    return maybeIterator && typeof maybeIterator.next === 'function';
		  }
	
		  function getIterator(iterable) {
		    var iteratorFn = getIteratorFn(iterable);
		    return iteratorFn && iteratorFn.call(iterable);
		  }
	
		  function getIteratorFn(iterable) {
		    var iteratorFn = iterable && (
		      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
		      iterable[FAUX_ITERATOR_SYMBOL]
		    );
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  function isArrayLike(value) {
		    return value && typeof value.length === 'number';
		  }
	
		  createClass(Seq, Iterable);
		    function Seq(value) {
		      return value === null || value === undefined ? emptySequence() :
		        isIterable(value) ? value.toSeq() : seqFromValue(value);
		    }
	
		    Seq.of = function(/*...values*/) {
		      return Seq(arguments);
		    };
	
		    Seq.prototype.toSeq = function() {
		      return this;
		    };
	
		    Seq.prototype.toString = function() {
		      return this.__toString('Seq {', '}');
		    };
	
		    Seq.prototype.cacheResult = function() {
		      if (!this._cache && this.__iterateUncached) {
		        this._cache = this.entrySeq().toArray();
		        this.size = this._cache.length;
		      }
		      return this;
		    };
	
		    // abstract __iterateUncached(fn, reverse)
	
		    Seq.prototype.__iterate = function(fn, reverse) {
		      return seqIterate(this, fn, reverse, true);
		    };
	
		    // abstract __iteratorUncached(type, reverse)
	
		    Seq.prototype.__iterator = function(type, reverse) {
		      return seqIterator(this, type, reverse, true);
		    };
	
	
	
		  createClass(KeyedSeq, Seq);
		    function KeyedSeq(value) {
		      return value === null || value === undefined ?
		        emptySequence().toKeyedSeq() :
		        isIterable(value) ?
		          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
		          keyedSeqFromValue(value);
		    }
	
		    KeyedSeq.prototype.toKeyedSeq = function() {
		      return this;
		    };
	
	
	
		  createClass(IndexedSeq, Seq);
		    function IndexedSeq(value) {
		      return value === null || value === undefined ? emptySequence() :
		        !isIterable(value) ? indexedSeqFromValue(value) :
		        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
		    }
	
		    IndexedSeq.of = function(/*...values*/) {
		      return IndexedSeq(arguments);
		    };
	
		    IndexedSeq.prototype.toIndexedSeq = function() {
		      return this;
		    };
	
		    IndexedSeq.prototype.toString = function() {
		      return this.__toString('Seq [', ']');
		    };
	
		    IndexedSeq.prototype.__iterate = function(fn, reverse) {
		      return seqIterate(this, fn, reverse, false);
		    };
	
		    IndexedSeq.prototype.__iterator = function(type, reverse) {
		      return seqIterator(this, type, reverse, false);
		    };
	
	
	
		  createClass(SetSeq, Seq);
		    function SetSeq(value) {
		      return (
		        value === null || value === undefined ? emptySequence() :
		        !isIterable(value) ? indexedSeqFromValue(value) :
		        isKeyed(value) ? value.entrySeq() : value
		      ).toSetSeq();
		    }
	
		    SetSeq.of = function(/*...values*/) {
		      return SetSeq(arguments);
		    };
	
		    SetSeq.prototype.toSetSeq = function() {
		      return this;
		    };
	
	
	
		  Seq.isSeq = isSeq;
		  Seq.Keyed = KeyedSeq;
		  Seq.Set = SetSeq;
		  Seq.Indexed = IndexedSeq;
	
		  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
		  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
		  createClass(ArraySeq, IndexedSeq);
		    function ArraySeq(array) {
		      this._array = array;
		      this.size = array.length;
		    }
	
		    ArraySeq.prototype.get = function(index, notSetValue) {
		      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
		    };
	
		    ArraySeq.prototype.__iterate = function(fn, reverse) {
		      var array = this._array;
		      var maxIndex = array.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    ArraySeq.prototype.__iterator = function(type, reverse) {
		      var array = this._array;
		      var maxIndex = array.length - 1;
		      var ii = 0;
		      return new Iterator(function() 
		        {return ii > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
		      );
		    };
	
	
	
		  createClass(ObjectSeq, KeyedSeq);
		    function ObjectSeq(object) {
		      var keys = Object.keys(object);
		      this._object = object;
		      this._keys = keys;
		      this.size = keys.length;
		    }
	
		    ObjectSeq.prototype.get = function(key, notSetValue) {
		      if (notSetValue !== undefined && !this.has(key)) {
		        return notSetValue;
		      }
		      return this._object[key];
		    };
	
		    ObjectSeq.prototype.has = function(key) {
		      return this._object.hasOwnProperty(key);
		    };
	
		    ObjectSeq.prototype.__iterate = function(fn, reverse) {
		      var object = this._object;
		      var keys = this._keys;
		      var maxIndex = keys.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        var key = keys[reverse ? maxIndex - ii : ii];
		        if (fn(object[key], key, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    ObjectSeq.prototype.__iterator = function(type, reverse) {
		      var object = this._object;
		      var keys = this._keys;
		      var maxIndex = keys.length - 1;
		      var ii = 0;
		      return new Iterator(function()  {
		        var key = keys[reverse ? maxIndex - ii : ii];
		        return ii++ > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, key, object[key]);
		      });
		    };
	
		  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
		  createClass(IterableSeq, IndexedSeq);
		    function IterableSeq(iterable) {
		      this._iterable = iterable;
		      this.size = iterable.length || iterable.size;
		    }
	
		    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterable = this._iterable;
		      var iterator = getIterator(iterable);
		      var iterations = 0;
		      if (isIterator(iterator)) {
		        var step;
		        while (!(step = iterator.next()).done) {
		          if (fn(step.value, iterations++, this) === false) {
		            break;
		          }
		        }
		      }
		      return iterations;
		    };
	
		    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterable = this._iterable;
		      var iterator = getIterator(iterable);
		      if (!isIterator(iterator)) {
		        return new Iterator(iteratorDone);
		      }
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step : iteratorValue(type, iterations++, step.value);
		      });
		    };
	
	
	
		  createClass(IteratorSeq, IndexedSeq);
		    function IteratorSeq(iterator) {
		      this._iterator = iterator;
		      this._iteratorCache = [];
		    }
	
		    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterator = this._iterator;
		      var cache = this._iteratorCache;
		      var iterations = 0;
		      while (iterations < cache.length) {
		        if (fn(cache[iterations], iterations++, this) === false) {
		          return iterations;
		        }
		      }
		      var step;
		      while (!(step = iterator.next()).done) {
		        var val = step.value;
		        cache[iterations] = val;
		        if (fn(val, iterations++, this) === false) {
		          break;
		        }
		      }
		      return iterations;
		    };
	
		    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = this._iterator;
		      var cache = this._iteratorCache;
		      var iterations = 0;
		      return new Iterator(function()  {
		        if (iterations >= cache.length) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          cache[iterations] = step.value;
		        }
		        return iteratorValue(type, iterations, cache[iterations++]);
		      });
		    };
	
	
	
	
		  // # pragma Helper functions
	
		  function isSeq(maybeSeq) {
		    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
		  }
	
		  var EMPTY_SEQ;
	
		  function emptySequence() {
		    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
		  }
	
		  function keyedSeqFromValue(value) {
		    var seq =
		      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
		      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
		      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
		      typeof value === 'object' ? new ObjectSeq(value) :
		      undefined;
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of [k, v] entries, '+
		        'or keyed object: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function indexedSeqFromValue(value) {
		    var seq = maybeIndexedSeqFromValue(value);
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of values: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function seqFromValue(value) {
		    var seq = maybeIndexedSeqFromValue(value) ||
		      (typeof value === 'object' && new ObjectSeq(value));
		    if (!seq) {
		      throw new TypeError(
		        'Expected Array or iterable object of values, or keyed object: ' + value
		      );
		    }
		    return seq;
		  }
	
		  function maybeIndexedSeqFromValue(value) {
		    return (
		      isArrayLike(value) ? new ArraySeq(value) :
		      isIterator(value) ? new IteratorSeq(value) :
		      hasIterator(value) ? new IterableSeq(value) :
		      undefined
		    );
		  }
	
		  function seqIterate(seq, fn, reverse, useKeys) {
		    var cache = seq._cache;
		    if (cache) {
		      var maxIndex = cache.length - 1;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        var entry = cache[reverse ? maxIndex - ii : ii];
		        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    }
		    return seq.__iterateUncached(fn, reverse);
		  }
	
		  function seqIterator(seq, type, reverse, useKeys) {
		    var cache = seq._cache;
		    if (cache) {
		      var maxIndex = cache.length - 1;
		      var ii = 0;
		      return new Iterator(function()  {
		        var entry = cache[reverse ? maxIndex - ii : ii];
		        return ii++ > maxIndex ?
		          iteratorDone() :
		          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
		      });
		    }
		    return seq.__iteratorUncached(type, reverse);
		  }
	
		  function fromJS(json, converter) {
		    return converter ?
		      fromJSWith(converter, json, '', {'': json}) :
		      fromJSDefault(json);
		  }
	
		  function fromJSWith(converter, json, key, parentJSON) {
		    if (Array.isArray(json)) {
		      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
		    }
		    if (isPlainObj(json)) {
		      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
		    }
		    return json;
		  }
	
		  function fromJSDefault(json) {
		    if (Array.isArray(json)) {
		      return IndexedSeq(json).map(fromJSDefault).toList();
		    }
		    if (isPlainObj(json)) {
		      return KeyedSeq(json).map(fromJSDefault).toMap();
		    }
		    return json;
		  }
	
		  function isPlainObj(value) {
		    return value && (value.constructor === Object || value.constructor === undefined);
		  }
	
		  /**
		   * An extension of the "same-value" algorithm as [described for use by ES6 Map
		   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
		   *
		   * NaN is considered the same as NaN, however -0 and 0 are considered the same
		   * value, which is different from the algorithm described by
		   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
		   *
		   * This is extended further to allow Objects to describe the values they
		   * represent, by way of `valueOf` or `equals` (and `hashCode`).
		   *
		   * Note: because of this extension, the key equality of Immutable.Map and the
		   * value equality of Immutable.Set will differ from ES6 Map and Set.
		   *
		   * ### Defining custom values
		   *
		   * The easiest way to describe the value an object represents is by implementing
		   * `valueOf`. For example, `Date` represents a value by returning a unix
		   * timestamp for `valueOf`:
		   *
		   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
		   *     var date2 = new Date(1234567890000);
		   *     date1.valueOf(); // 1234567890000
		   *     assert( date1 !== date2 );
		   *     assert( Immutable.is( date1, date2 ) );
		   *
		   * Note: overriding `valueOf` may have other implications if you use this object
		   * where JavaScript expects a primitive, such as implicit string coercion.
		   *
		   * For more complex types, especially collections, implementing `valueOf` may
		   * not be performant. An alternative is to implement `equals` and `hashCode`.
		   *
		   * `equals` takes another object, presumably of similar type, and returns true
		   * if the it is equal. Equality is symmetrical, so the same result should be
		   * returned if this and the argument are flipped.
		   *
		   *     assert( a.equals(b) === b.equals(a) );
		   *
		   * `hashCode` returns a 32bit integer number representing the object which will
		   * be used to determine how to store the value object in a Map or Set. You must
		   * provide both or neither methods, one must not exist without the other.
		   *
		   * Also, an important relationship between these methods must be upheld: if two
		   * values are equal, they *must* return the same hashCode. If the values are not
		   * equal, they might have the same hashCode; this is called a hash collision,
		   * and while undesirable for performance reasons, it is acceptable.
		   *
		   *     if (a.equals(b)) {
		   *       assert( a.hashCode() === b.hashCode() );
		   *     }
		   *
		   * All Immutable collections implement `equals` and `hashCode`.
		   *
		   */
		  function is(valueA, valueB) {
		    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
		      return true;
		    }
		    if (!valueA || !valueB) {
		      return false;
		    }
		    if (typeof valueA.valueOf === 'function' &&
		        typeof valueB.valueOf === 'function') {
		      valueA = valueA.valueOf();
		      valueB = valueB.valueOf();
		      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
		        return true;
		      }
		      if (!valueA || !valueB) {
		        return false;
		      }
		    }
		    if (typeof valueA.equals === 'function' &&
		        typeof valueB.equals === 'function' &&
		        valueA.equals(valueB)) {
		      return true;
		    }
		    return false;
		  }
	
		  function deepEqual(a, b) {
		    if (a === b) {
		      return true;
		    }
	
		    if (
		      !isIterable(b) ||
		      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
		      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
		      isKeyed(a) !== isKeyed(b) ||
		      isIndexed(a) !== isIndexed(b) ||
		      isOrdered(a) !== isOrdered(b)
		    ) {
		      return false;
		    }
	
		    if (a.size === 0 && b.size === 0) {
		      return true;
		    }
	
		    var notAssociative = !isAssociative(a);
	
		    if (isOrdered(a)) {
		      var entries = a.entries();
		      return b.every(function(v, k)  {
		        var entry = entries.next().value;
		        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
		      }) && entries.next().done;
		    }
	
		    var flipped = false;
	
		    if (a.size === undefined) {
		      if (b.size === undefined) {
		        if (typeof a.cacheResult === 'function') {
		          a.cacheResult();
		        }
		      } else {
		        flipped = true;
		        var _ = a;
		        a = b;
		        b = _;
		      }
		    }
	
		    var allEqual = true;
		    var bSize = b.__iterate(function(v, k)  {
		      if (notAssociative ? !a.has(v) :
		          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
		        allEqual = false;
		        return false;
		      }
		    });
	
		    return allEqual && a.size === bSize;
		  }
	
		  createClass(Repeat, IndexedSeq);
	
		    function Repeat(value, times) {
		      if (!(this instanceof Repeat)) {
		        return new Repeat(value, times);
		      }
		      this._value = value;
		      this.size = times === undefined ? Infinity : Math.max(0, times);
		      if (this.size === 0) {
		        if (EMPTY_REPEAT) {
		          return EMPTY_REPEAT;
		        }
		        EMPTY_REPEAT = this;
		      }
		    }
	
		    Repeat.prototype.toString = function() {
		      if (this.size === 0) {
		        return 'Repeat []';
		      }
		      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
		    };
	
		    Repeat.prototype.get = function(index, notSetValue) {
		      return this.has(index) ? this._value : notSetValue;
		    };
	
		    Repeat.prototype.includes = function(searchValue) {
		      return is(this._value, searchValue);
		    };
	
		    Repeat.prototype.slice = function(begin, end) {
		      var size = this.size;
		      return wholeSlice(begin, end, size) ? this :
		        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
		    };
	
		    Repeat.prototype.reverse = function() {
		      return this;
		    };
	
		    Repeat.prototype.indexOf = function(searchValue) {
		      if (is(this._value, searchValue)) {
		        return 0;
		      }
		      return -1;
		    };
	
		    Repeat.prototype.lastIndexOf = function(searchValue) {
		      if (is(this._value, searchValue)) {
		        return this.size;
		      }
		      return -1;
		    };
	
		    Repeat.prototype.__iterate = function(fn, reverse) {
		      for (var ii = 0; ii < this.size; ii++) {
		        if (fn(this._value, ii, this) === false) {
		          return ii + 1;
		        }
		      }
		      return ii;
		    };
	
		    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
		      var ii = 0;
		      return new Iterator(function() 
		        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
		      );
		    };
	
		    Repeat.prototype.equals = function(other) {
		      return other instanceof Repeat ?
		        is(this._value, other._value) :
		        deepEqual(other);
		    };
	
	
		  var EMPTY_REPEAT;
	
		  function invariant(condition, error) {
		    if (!condition) throw new Error(error);
		  }
	
		  createClass(Range, IndexedSeq);
	
		    function Range(start, end, step) {
		      if (!(this instanceof Range)) {
		        return new Range(start, end, step);
		      }
		      invariant(step !== 0, 'Cannot step a Range by 0');
		      start = start || 0;
		      if (end === undefined) {
		        end = Infinity;
		      }
		      step = step === undefined ? 1 : Math.abs(step);
		      if (end < start) {
		        step = -step;
		      }
		      this._start = start;
		      this._end = end;
		      this._step = step;
		      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
		      if (this.size === 0) {
		        if (EMPTY_RANGE) {
		          return EMPTY_RANGE;
		        }
		        EMPTY_RANGE = this;
		      }
		    }
	
		    Range.prototype.toString = function() {
		      if (this.size === 0) {
		        return 'Range []';
		      }
		      return 'Range [ ' +
		        this._start + '...' + this._end +
		        (this._step !== 1 ? ' by ' + this._step : '') +
		      ' ]';
		    };
	
		    Range.prototype.get = function(index, notSetValue) {
		      return this.has(index) ?
		        this._start + wrapIndex(this, index) * this._step :
		        notSetValue;
		    };
	
		    Range.prototype.includes = function(searchValue) {
		      var possibleIndex = (searchValue - this._start) / this._step;
		      return possibleIndex >= 0 &&
		        possibleIndex < this.size &&
		        possibleIndex === Math.floor(possibleIndex);
		    };
	
		    Range.prototype.slice = function(begin, end) {
		      if (wholeSlice(begin, end, this.size)) {
		        return this;
		      }
		      begin = resolveBegin(begin, this.size);
		      end = resolveEnd(end, this.size);
		      if (end <= begin) {
		        return new Range(0, 0);
		      }
		      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
		    };
	
		    Range.prototype.indexOf = function(searchValue) {
		      var offsetValue = searchValue - this._start;
		      if (offsetValue % this._step === 0) {
		        var index = offsetValue / this._step;
		        if (index >= 0 && index < this.size) {
		          return index
		        }
		      }
		      return -1;
		    };
	
		    Range.prototype.lastIndexOf = function(searchValue) {
		      return this.indexOf(searchValue);
		    };
	
		    Range.prototype.__iterate = function(fn, reverse) {
		      var maxIndex = this.size - 1;
		      var step = this._step;
		      var value = reverse ? this._start + maxIndex * step : this._start;
		      for (var ii = 0; ii <= maxIndex; ii++) {
		        if (fn(value, ii, this) === false) {
		          return ii + 1;
		        }
		        value += reverse ? -step : step;
		      }
		      return ii;
		    };
	
		    Range.prototype.__iterator = function(type, reverse) {
		      var maxIndex = this.size - 1;
		      var step = this._step;
		      var value = reverse ? this._start + maxIndex * step : this._start;
		      var ii = 0;
		      return new Iterator(function()  {
		        var v = value;
		        value += reverse ? -step : step;
		        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
		      });
		    };
	
		    Range.prototype.equals = function(other) {
		      return other instanceof Range ?
		        this._start === other._start &&
		        this._end === other._end &&
		        this._step === other._step :
		        deepEqual(this, other);
		    };
	
	
		  var EMPTY_RANGE;
	
		  createClass(Collection, Iterable);
		    function Collection() {
		      throw TypeError('Abstract');
		    }
	
	
		  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
		  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
		  createClass(SetCollection, Collection);function SetCollection() {}
	
	
		  Collection.Keyed = KeyedCollection;
		  Collection.Indexed = IndexedCollection;
		  Collection.Set = SetCollection;
	
		  var imul =
		    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
		    Math.imul :
		    function imul(a, b) {
		      a = a | 0; // int
		      b = b | 0; // int
		      var c = a & 0xffff;
		      var d = b & 0xffff;
		      // Shift by 0 fixes the sign on the high part.
		      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
		    };
	
		  // v8 has an optimization for storing 31-bit signed numbers.
		  // Values which have either 00 or 11 as the high order bits qualify.
		  // This function drops the highest order bit in a signed number, maintaining
		  // the sign bit.
		  function smi(i32) {
		    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
		  }
	
		  function hash(o) {
		    if (o === false || o === null || o === undefined) {
		      return 0;
		    }
		    if (typeof o.valueOf === 'function') {
		      o = o.valueOf();
		      if (o === false || o === null || o === undefined) {
		        return 0;
		      }
		    }
		    if (o === true) {
		      return 1;
		    }
		    var type = typeof o;
		    if (type === 'number') {
		      if (o !== o || o === Infinity) {
		        return 0;
		      }
		      var h = o | 0;
		      if (h !== o) {
		        h ^= o * 0xFFFFFFFF;
		      }
		      while (o > 0xFFFFFFFF) {
		        o /= 0xFFFFFFFF;
		        h ^= o;
		      }
		      return smi(h);
		    }
		    if (type === 'string') {
		      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
		    }
		    if (typeof o.hashCode === 'function') {
		      return o.hashCode();
		    }
		    if (type === 'object') {
		      return hashJSObj(o);
		    }
		    if (typeof o.toString === 'function') {
		      return hashString(o.toString());
		    }
		    throw new Error('Value type ' + type + ' cannot be hashed.');
		  }
	
		  function cachedHashString(string) {
		    var hash = stringHashCache[string];
		    if (hash === undefined) {
		      hash = hashString(string);
		      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
		        STRING_HASH_CACHE_SIZE = 0;
		        stringHashCache = {};
		      }
		      STRING_HASH_CACHE_SIZE++;
		      stringHashCache[string] = hash;
		    }
		    return hash;
		  }
	
		  // http://jsperf.com/hashing-strings
		  function hashString(string) {
		    // This is the hash from JVM
		    // The hash code for a string is computed as
		    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
		    // where s[i] is the ith character of the string and n is the length of
		    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
		    // (exclusive) by dropping high bits.
		    var hash = 0;
		    for (var ii = 0; ii < string.length; ii++) {
		      hash = 31 * hash + string.charCodeAt(ii) | 0;
		    }
		    return smi(hash);
		  }
	
		  function hashJSObj(obj) {
		    var hash;
		    if (usingWeakMap) {
		      hash = weakMap.get(obj);
		      if (hash !== undefined) {
		        return hash;
		      }
		    }
	
		    hash = obj[UID_HASH_KEY];
		    if (hash !== undefined) {
		      return hash;
		    }
	
		    if (!canDefineProperty) {
		      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
		      if (hash !== undefined) {
		        return hash;
		      }
	
		      hash = getIENodeHash(obj);
		      if (hash !== undefined) {
		        return hash;
		      }
		    }
	
		    hash = ++objHashUID;
		    if (objHashUID & 0x40000000) {
		      objHashUID = 0;
		    }
	
		    if (usingWeakMap) {
		      weakMap.set(obj, hash);
		    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
		      throw new Error('Non-extensible objects are not allowed as keys.');
		    } else if (canDefineProperty) {
		      Object.defineProperty(obj, UID_HASH_KEY, {
		        'enumerable': false,
		        'configurable': false,
		        'writable': false,
		        'value': hash
		      });
		    } else if (obj.propertyIsEnumerable !== undefined &&
		               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
		      // Since we can't define a non-enumerable property on the object
		      // we'll hijack one of the less-used non-enumerable properties to
		      // save our hash on it. Since this is a function it will not show up in
		      // `JSON.stringify` which is what we want.
		      obj.propertyIsEnumerable = function() {
		        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
		      };
		      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
		    } else if (obj.nodeType !== undefined) {
		      // At this point we couldn't get the IE `uniqueID` to use as a hash
		      // and we couldn't use a non-enumerable property to exploit the
		      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
		      // itself.
		      obj[UID_HASH_KEY] = hash;
		    } else {
		      throw new Error('Unable to set a non-enumerable property on object.');
		    }
	
		    return hash;
		  }
	
		  // Get references to ES5 object methods.
		  var isExtensible = Object.isExtensible;
	
		  // True if Object.defineProperty works as expected. IE8 fails this test.
		  var canDefineProperty = (function() {
		    try {
		      Object.defineProperty({}, '@', {});
		      return true;
		    } catch (e) {
		      return false;
		    }
		  }());
	
		  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
		  // and avoid memory leaks from the IE cloneNode bug.
		  function getIENodeHash(node) {
		    if (node && node.nodeType > 0) {
		      switch (node.nodeType) {
		        case 1: // Element
		          return node.uniqueID;
		        case 9: // Document
		          return node.documentElement && node.documentElement.uniqueID;
		      }
		    }
		  }
	
		  // If possible, use a WeakMap.
		  var usingWeakMap = typeof WeakMap === 'function';
		  var weakMap;
		  if (usingWeakMap) {
		    weakMap = new WeakMap();
		  }
	
		  var objHashUID = 0;
	
		  var UID_HASH_KEY = '__immutablehash__';
		  if (typeof Symbol === 'function') {
		    UID_HASH_KEY = Symbol(UID_HASH_KEY);
		  }
	
		  var STRING_HASH_CACHE_MIN_STRLEN = 16;
		  var STRING_HASH_CACHE_MAX_SIZE = 255;
		  var STRING_HASH_CACHE_SIZE = 0;
		  var stringHashCache = {};
	
		  function assertNotInfinite(size) {
		    invariant(
		      size !== Infinity,
		      'Cannot perform this action with an infinite size.'
		    );
		  }
	
		  createClass(Map, KeyedCollection);
	
		    // @pragma Construction
	
		    function Map(value) {
		      return value === null || value === undefined ? emptyMap() :
		        isMap(value) && !isOrdered(value) ? value :
		        emptyMap().withMutations(function(map ) {
		          var iter = KeyedIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v, k)  {return map.set(k, v)});
		        });
		    }
	
		    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
		      return emptyMap().withMutations(function(map ) {
		        for (var i = 0; i < keyValues.length; i += 2) {
		          if (i + 1 >= keyValues.length) {
		            throw new Error('Missing value for key: ' + keyValues[i]);
		          }
		          map.set(keyValues[i], keyValues[i + 1]);
		        }
		      });
		    };
	
		    Map.prototype.toString = function() {
		      return this.__toString('Map {', '}');
		    };
	
		    // @pragma Access
	
		    Map.prototype.get = function(k, notSetValue) {
		      return this._root ?
		        this._root.get(0, undefined, k, notSetValue) :
		        notSetValue;
		    };
	
		    // @pragma Modification
	
		    Map.prototype.set = function(k, v) {
		      return updateMap(this, k, v);
		    };
	
		    Map.prototype.setIn = function(keyPath, v) {
		      return this.updateIn(keyPath, NOT_SET, function()  {return v});
		    };
	
		    Map.prototype.remove = function(k) {
		      return updateMap(this, k, NOT_SET);
		    };
	
		    Map.prototype.deleteIn = function(keyPath) {
		      return this.updateIn(keyPath, function()  {return NOT_SET});
		    };
	
		    Map.prototype.update = function(k, notSetValue, updater) {
		      return arguments.length === 1 ?
		        k(this) :
		        this.updateIn([k], notSetValue, updater);
		    };
	
		    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
		      if (!updater) {
		        updater = notSetValue;
		        notSetValue = undefined;
		      }
		      var updatedValue = updateInDeepMap(
		        this,
		        forceIterator(keyPath),
		        notSetValue,
		        updater
		      );
		      return updatedValue === NOT_SET ? undefined : updatedValue;
		    };
	
		    Map.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._root = null;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyMap();
		    };
	
		    // @pragma Composition
	
		    Map.prototype.merge = function(/*...iters*/) {
		      return mergeIntoMapWith(this, undefined, arguments);
		    };
	
		    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoMapWith(this, merger, iters);
		    };
	
		    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
		      return this.updateIn(
		        keyPath,
		        emptyMap(),
		        function(m ) {return typeof m.merge === 'function' ?
		          m.merge.apply(m, iters) :
		          iters[iters.length - 1]}
		      );
		    };
	
		    Map.prototype.mergeDeep = function(/*...iters*/) {
		      return mergeIntoMapWith(this, deepMerger, arguments);
		    };
	
		    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
		    };
	
		    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
		      return this.updateIn(
		        keyPath,
		        emptyMap(),
		        function(m ) {return typeof m.mergeDeep === 'function' ?
		          m.mergeDeep.apply(m, iters) :
		          iters[iters.length - 1]}
		      );
		    };
	
		    Map.prototype.sort = function(comparator) {
		      // Late binding
		      return OrderedMap(sortFactory(this, comparator));
		    };
	
		    Map.prototype.sortBy = function(mapper, comparator) {
		      // Late binding
		      return OrderedMap(sortFactory(this, comparator, mapper));
		    };
	
		    // @pragma Mutability
	
		    Map.prototype.withMutations = function(fn) {
		      var mutable = this.asMutable();
		      fn(mutable);
		      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
		    };
	
		    Map.prototype.asMutable = function() {
		      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
		    };
	
		    Map.prototype.asImmutable = function() {
		      return this.__ensureOwner();
		    };
	
		    Map.prototype.wasAltered = function() {
		      return this.__altered;
		    };
	
		    Map.prototype.__iterator = function(type, reverse) {
		      return new MapIterator(this, type, reverse);
		    };
	
		    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      this._root && this._root.iterate(function(entry ) {
		        iterations++;
		        return fn(entry[1], entry[0], this$0);
		      }, reverse);
		      return iterations;
		    };
	
		    Map.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this.__altered = false;
		        return this;
		      }
		      return makeMap(this.size, this._root, ownerID, this.__hash);
		    };
	
	
		  function isMap(maybeMap) {
		    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
		  }
	
		  Map.isMap = isMap;
	
		  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
		  var MapPrototype = Map.prototype;
		  MapPrototype[IS_MAP_SENTINEL] = true;
		  MapPrototype[DELETE] = MapPrototype.remove;
		  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
		  // #pragma Trie Nodes
	
	
	
		    function ArrayMapNode(ownerID, entries) {
		      this.ownerID = ownerID;
		      this.entries = entries;
		    }
	
		    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      var entries = this.entries;
		      for (var ii = 0, len = entries.length; ii < len; ii++) {
		        if (is(key, entries[ii][0])) {
		          return entries[ii][1];
		        }
		      }
		      return notSetValue;
		    };
	
		    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      var removed = value === NOT_SET;
	
		      var entries = this.entries;
		      var idx = 0;
		      for (var len = entries.length; idx < len; idx++) {
		        if (is(key, entries[idx][0])) {
		          break;
		        }
		      }
		      var exists = idx < len;
	
		      if (exists ? entries[idx][1] === value : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
		      (removed || !exists) && SetRef(didChangeSize);
	
		      if (removed && entries.length === 1) {
		        return; // undefined
		      }
	
		      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
		        return createNodes(ownerID, entries, key, value);
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newEntries = isEditable ? entries : arrCopy(entries);
	
		      if (exists) {
		        if (removed) {
		          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
		        } else {
		          newEntries[idx] = [key, value];
		        }
		      } else {
		        newEntries.push([key, value]);
		      }
	
		      if (isEditable) {
		        this.entries = newEntries;
		        return this;
		      }
	
		      return new ArrayMapNode(ownerID, newEntries);
		    };
	
	
	
	
		    function BitmapIndexedNode(ownerID, bitmap, nodes) {
		      this.ownerID = ownerID;
		      this.bitmap = bitmap;
		      this.nodes = nodes;
		    }
	
		    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
		      var bitmap = this.bitmap;
		      return (bitmap & bit) === 0 ? notSetValue :
		        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
		    };
	
		    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var bit = 1 << keyHashFrag;
		      var bitmap = this.bitmap;
		      var exists = (bitmap & bit) !== 0;
	
		      if (!exists && value === NOT_SET) {
		        return this;
		      }
	
		      var idx = popCount(bitmap & (bit - 1));
		      var nodes = this.nodes;
		      var node = exists ? nodes[idx] : undefined;
		      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
		      if (newNode === node) {
		        return this;
		      }
	
		      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
		        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
		      }
	
		      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
		        return nodes[idx ^ 1];
		      }
	
		      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
		        return newNode;
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
		      var newNodes = exists ? newNode ?
		        setIn(nodes, idx, newNode, isEditable) :
		        spliceOut(nodes, idx, isEditable) :
		        spliceIn(nodes, idx, newNode, isEditable);
	
		      if (isEditable) {
		        this.bitmap = newBitmap;
		        this.nodes = newNodes;
		        return this;
		      }
	
		      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
		    };
	
	
	
	
		    function HashArrayMapNode(ownerID, count, nodes) {
		      this.ownerID = ownerID;
		      this.count = count;
		      this.nodes = nodes;
		    }
	
		    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var node = this.nodes[idx];
		      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
		    };
	
		    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
		      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
		      var removed = value === NOT_SET;
		      var nodes = this.nodes;
		      var node = nodes[idx];
	
		      if (removed && !node) {
		        return this;
		      }
	
		      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
		      if (newNode === node) {
		        return this;
		      }
	
		      var newCount = this.count;
		      if (!node) {
		        newCount++;
		      } else if (!newNode) {
		        newCount--;
		        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
		          return packNodes(ownerID, nodes, newCount, idx);
		        }
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
		      if (isEditable) {
		        this.count = newCount;
		        this.nodes = newNodes;
		        return this;
		      }
	
		      return new HashArrayMapNode(ownerID, newCount, newNodes);
		    };
	
	
	
	
		    function HashCollisionNode(ownerID, keyHash, entries) {
		      this.ownerID = ownerID;
		      this.keyHash = keyHash;
		      this.entries = entries;
		    }
	
		    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      var entries = this.entries;
		      for (var ii = 0, len = entries.length; ii < len; ii++) {
		        if (is(key, entries[ii][0])) {
		          return entries[ii][1];
		        }
		      }
		      return notSetValue;
		    };
	
		    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      if (keyHash === undefined) {
		        keyHash = hash(key);
		      }
	
		      var removed = value === NOT_SET;
	
		      if (keyHash !== this.keyHash) {
		        if (removed) {
		          return this;
		        }
		        SetRef(didAlter);
		        SetRef(didChangeSize);
		        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
		      }
	
		      var entries = this.entries;
		      var idx = 0;
		      for (var len = entries.length; idx < len; idx++) {
		        if (is(key, entries[idx][0])) {
		          break;
		        }
		      }
		      var exists = idx < len;
	
		      if (exists ? entries[idx][1] === value : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
		      (removed || !exists) && SetRef(didChangeSize);
	
		      if (removed && len === 2) {
		        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
		      }
	
		      var isEditable = ownerID && ownerID === this.ownerID;
		      var newEntries = isEditable ? entries : arrCopy(entries);
	
		      if (exists) {
		        if (removed) {
		          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
		        } else {
		          newEntries[idx] = [key, value];
		        }
		      } else {
		        newEntries.push([key, value]);
		      }
	
		      if (isEditable) {
		        this.entries = newEntries;
		        return this;
		      }
	
		      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
		    };
	
	
	
	
		    function ValueNode(ownerID, keyHash, entry) {
		      this.ownerID = ownerID;
		      this.keyHash = keyHash;
		      this.entry = entry;
		    }
	
		    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
		      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
		    };
	
		    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		      var removed = value === NOT_SET;
		      var keyMatch = is(key, this.entry[0]);
		      if (keyMatch ? value === this.entry[1] : removed) {
		        return this;
		      }
	
		      SetRef(didAlter);
	
		      if (removed) {
		        SetRef(didChangeSize);
		        return; // undefined
		      }
	
		      if (keyMatch) {
		        if (ownerID && ownerID === this.ownerID) {
		          this.entry[1] = value;
		          return this;
		        }
		        return new ValueNode(ownerID, this.keyHash, [key, value]);
		      }
	
		      SetRef(didChangeSize);
		      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
		    };
	
	
	
		  // #pragma Iterators
	
		  ArrayMapNode.prototype.iterate =
		  HashCollisionNode.prototype.iterate = function (fn, reverse) {
		    var entries = this.entries;
		    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
		      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
		        return false;
		      }
		    }
		  }
	
		  BitmapIndexedNode.prototype.iterate =
		  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
		    var nodes = this.nodes;
		    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
		      var node = nodes[reverse ? maxIndex - ii : ii];
		      if (node && node.iterate(fn, reverse) === false) {
		        return false;
		      }
		    }
		  }
	
		  ValueNode.prototype.iterate = function (fn, reverse) {
		    return fn(this.entry);
		  }
	
		  createClass(MapIterator, Iterator);
	
		    function MapIterator(map, type, reverse) {
		      this._type = type;
		      this._reverse = reverse;
		      this._stack = map._root && mapIteratorFrame(map._root);
		    }
	
		    MapIterator.prototype.next = function() {
		      var type = this._type;
		      var stack = this._stack;
		      while (stack) {
		        var node = stack.node;
		        var index = stack.index++;
		        var maxIndex;
		        if (node.entry) {
		          if (index === 0) {
		            return mapIteratorValue(type, node.entry);
		          }
		        } else if (node.entries) {
		          maxIndex = node.entries.length - 1;
		          if (index <= maxIndex) {
		            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
		          }
		        } else {
		          maxIndex = node.nodes.length - 1;
		          if (index <= maxIndex) {
		            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
		            if (subNode) {
		              if (subNode.entry) {
		                return mapIteratorValue(type, subNode.entry);
		              }
		              stack = this._stack = mapIteratorFrame(subNode, stack);
		            }
		            continue;
		          }
		        }
		        stack = this._stack = this._stack.__prev;
		      }
		      return iteratorDone();
		    };
	
	
		  function mapIteratorValue(type, entry) {
		    return iteratorValue(type, entry[0], entry[1]);
		  }
	
		  function mapIteratorFrame(node, prev) {
		    return {
		      node: node,
		      index: 0,
		      __prev: prev
		    };
		  }
	
		  function makeMap(size, root, ownerID, hash) {
		    var map = Object.create(MapPrototype);
		    map.size = size;
		    map._root = root;
		    map.__ownerID = ownerID;
		    map.__hash = hash;
		    map.__altered = false;
		    return map;
		  }
	
		  var EMPTY_MAP;
		  function emptyMap() {
		    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
		  }
	
		  function updateMap(map, k, v) {
		    var newRoot;
		    var newSize;
		    if (!map._root) {
		      if (v === NOT_SET) {
		        return map;
		      }
		      newSize = 1;
		      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
		    } else {
		      var didChangeSize = MakeRef(CHANGE_LENGTH);
		      var didAlter = MakeRef(DID_ALTER);
		      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
		      if (!didAlter.value) {
		        return map;
		      }
		      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
		    }
		    if (map.__ownerID) {
		      map.size = newSize;
		      map._root = newRoot;
		      map.__hash = undefined;
		      map.__altered = true;
		      return map;
		    }
		    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
		  }
	
		  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
		    if (!node) {
		      if (value === NOT_SET) {
		        return node;
		      }
		      SetRef(didAlter);
		      SetRef(didChangeSize);
		      return new ValueNode(ownerID, keyHash, [key, value]);
		    }
		    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
		  }
	
		  function isLeafNode(node) {
		    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
		  }
	
		  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
		    if (node.keyHash === keyHash) {
		      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
		    }
	
		    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
		    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
		    var newNode;
		    var nodes = idx1 === idx2 ?
		      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
		      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
		    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
		  }
	
		  function createNodes(ownerID, entries, key, value) {
		    if (!ownerID) {
		      ownerID = new OwnerID();
		    }
		    var node = new ValueNode(ownerID, hash(key), [key, value]);
		    for (var ii = 0; ii < entries.length; ii++) {
		      var entry = entries[ii];
		      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
		    }
		    return node;
		  }
	
		  function packNodes(ownerID, nodes, count, excluding) {
		    var bitmap = 0;
		    var packedII = 0;
		    var packedNodes = new Array(count);
		    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
		      var node = nodes[ii];
		      if (node !== undefined && ii !== excluding) {
		        bitmap |= bit;
		        packedNodes[packedII++] = node;
		      }
		    }
		    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
		  }
	
		  function expandNodes(ownerID, nodes, bitmap, including, node) {
		    var count = 0;
		    var expandedNodes = new Array(SIZE);
		    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
		      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
		    }
		    expandedNodes[including] = node;
		    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
		  }
	
		  function mergeIntoMapWith(map, merger, iterables) {
		    var iters = [];
		    for (var ii = 0; ii < iterables.length; ii++) {
		      var value = iterables[ii];
		      var iter = KeyedIterable(value);
		      if (!isIterable(value)) {
		        iter = iter.map(function(v ) {return fromJS(v)});
		      }
		      iters.push(iter);
		    }
		    return mergeIntoCollectionWith(map, merger, iters);
		  }
	
		  function deepMerger(existing, value, key) {
		    return existing && existing.mergeDeep && isIterable(value) ?
		      existing.mergeDeep(value) :
		      is(existing, value) ? existing : value;
		  }
	
		  function deepMergerWith(merger) {
		    return function(existing, value, key)  {
		      if (existing && existing.mergeDeepWith && isIterable(value)) {
		        return existing.mergeDeepWith(merger, value);
		      }
		      var nextValue = merger(existing, value, key);
		      return is(existing, nextValue) ? existing : nextValue;
		    };
		  }
	
		  function mergeIntoCollectionWith(collection, merger, iters) {
		    iters = iters.filter(function(x ) {return x.size !== 0});
		    if (iters.length === 0) {
		      return collection;
		    }
		    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
		      return collection.constructor(iters[0]);
		    }
		    return collection.withMutations(function(collection ) {
		      var mergeIntoMap = merger ?
		        function(value, key)  {
		          collection.update(key, NOT_SET, function(existing )
		            {return existing === NOT_SET ? value : merger(existing, value, key)}
		          );
		        } :
		        function(value, key)  {
		          collection.set(key, value);
		        }
		      for (var ii = 0; ii < iters.length; ii++) {
		        iters[ii].forEach(mergeIntoMap);
		      }
		    });
		  }
	
		  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
		    var isNotSet = existing === NOT_SET;
		    var step = keyPathIter.next();
		    if (step.done) {
		      var existingValue = isNotSet ? notSetValue : existing;
		      var newValue = updater(existingValue);
		      return newValue === existingValue ? existing : newValue;
		    }
		    invariant(
		      isNotSet || (existing && existing.set),
		      'invalid keyPath'
		    );
		    var key = step.value;
		    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
		    var nextUpdated = updateInDeepMap(
		      nextExisting,
		      keyPathIter,
		      notSetValue,
		      updater
		    );
		    return nextUpdated === nextExisting ? existing :
		      nextUpdated === NOT_SET ? existing.remove(key) :
		      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
		  }
	
		  function popCount(x) {
		    x = x - ((x >> 1) & 0x55555555);
		    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
		    x = (x + (x >> 4)) & 0x0f0f0f0f;
		    x = x + (x >> 8);
		    x = x + (x >> 16);
		    return x & 0x7f;
		  }
	
		  function setIn(array, idx, val, canEdit) {
		    var newArray = canEdit ? array : arrCopy(array);
		    newArray[idx] = val;
		    return newArray;
		  }
	
		  function spliceIn(array, idx, val, canEdit) {
		    var newLen = array.length + 1;
		    if (canEdit && idx + 1 === newLen) {
		      array[idx] = val;
		      return array;
		    }
		    var newArray = new Array(newLen);
		    var after = 0;
		    for (var ii = 0; ii < newLen; ii++) {
		      if (ii === idx) {
		        newArray[ii] = val;
		        after = -1;
		      } else {
		        newArray[ii] = array[ii + after];
		      }
		    }
		    return newArray;
		  }
	
		  function spliceOut(array, idx, canEdit) {
		    var newLen = array.length - 1;
		    if (canEdit && idx === newLen) {
		      array.pop();
		      return array;
		    }
		    var newArray = new Array(newLen);
		    var after = 0;
		    for (var ii = 0; ii < newLen; ii++) {
		      if (ii === idx) {
		        after = 1;
		      }
		      newArray[ii] = array[ii + after];
		    }
		    return newArray;
		  }
	
		  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
		  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
		  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
		  createClass(List, IndexedCollection);
	
		    // @pragma Construction
	
		    function List(value) {
		      var empty = emptyList();
		      if (value === null || value === undefined) {
		        return empty;
		      }
		      if (isList(value)) {
		        return value;
		      }
		      var iter = IndexedIterable(value);
		      var size = iter.size;
		      if (size === 0) {
		        return empty;
		      }
		      assertNotInfinite(size);
		      if (size > 0 && size < SIZE) {
		        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
		      }
		      return empty.withMutations(function(list ) {
		        list.setSize(size);
		        iter.forEach(function(v, i)  {return list.set(i, v)});
		      });
		    }
	
		    List.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    List.prototype.toString = function() {
		      return this.__toString('List [', ']');
		    };
	
		    // @pragma Access
	
		    List.prototype.get = function(index, notSetValue) {
		      index = wrapIndex(this, index);
		      if (index >= 0 && index < this.size) {
		        index += this._origin;
		        var node = listNodeFor(this, index);
		        return node && node.array[index & MASK];
		      }
		      return notSetValue;
		    };
	
		    // @pragma Modification
	
		    List.prototype.set = function(index, value) {
		      return updateList(this, index, value);
		    };
	
		    List.prototype.remove = function(index) {
		      return !this.has(index) ? this :
		        index === 0 ? this.shift() :
		        index === this.size - 1 ? this.pop() :
		        this.splice(index, 1);
		    };
	
		    List.prototype.insert = function(index, value) {
		      return this.splice(index, 0, value);
		    };
	
		    List.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = this._origin = this._capacity = 0;
		        this._level = SHIFT;
		        this._root = this._tail = null;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyList();
		    };
	
		    List.prototype.push = function(/*...values*/) {
		      var values = arguments;
		      var oldSize = this.size;
		      return this.withMutations(function(list ) {
		        setListBounds(list, 0, oldSize + values.length);
		        for (var ii = 0; ii < values.length; ii++) {
		          list.set(oldSize + ii, values[ii]);
		        }
		      });
		    };
	
		    List.prototype.pop = function() {
		      return setListBounds(this, 0, -1);
		    };
	
		    List.prototype.unshift = function(/*...values*/) {
		      var values = arguments;
		      return this.withMutations(function(list ) {
		        setListBounds(list, -values.length);
		        for (var ii = 0; ii < values.length; ii++) {
		          list.set(ii, values[ii]);
		        }
		      });
		    };
	
		    List.prototype.shift = function() {
		      return setListBounds(this, 1);
		    };
	
		    // @pragma Composition
	
		    List.prototype.merge = function(/*...iters*/) {
		      return mergeIntoListWith(this, undefined, arguments);
		    };
	
		    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoListWith(this, merger, iters);
		    };
	
		    List.prototype.mergeDeep = function(/*...iters*/) {
		      return mergeIntoListWith(this, deepMerger, arguments);
		    };
	
		    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return mergeIntoListWith(this, deepMergerWith(merger), iters);
		    };
	
		    List.prototype.setSize = function(size) {
		      return setListBounds(this, 0, size);
		    };
	
		    // @pragma Iteration
	
		    List.prototype.slice = function(begin, end) {
		      var size = this.size;
		      if (wholeSlice(begin, end, size)) {
		        return this;
		      }
		      return setListBounds(
		        this,
		        resolveBegin(begin, size),
		        resolveEnd(end, size)
		      );
		    };
	
		    List.prototype.__iterator = function(type, reverse) {
		      var index = 0;
		      var values = iterateList(this, reverse);
		      return new Iterator(function()  {
		        var value = values();
		        return value === DONE ?
		          iteratorDone() :
		          iteratorValue(type, index++, value);
		      });
		    };
	
		    List.prototype.__iterate = function(fn, reverse) {
		      var index = 0;
		      var values = iterateList(this, reverse);
		      var value;
		      while ((value = values()) !== DONE) {
		        if (fn(value, index++, this) === false) {
		          break;
		        }
		      }
		      return index;
		    };
	
		    List.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        return this;
		      }
		      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
		    };
	
	
		  function isList(maybeList) {
		    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
		  }
	
		  List.isList = isList;
	
		  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
		  var ListPrototype = List.prototype;
		  ListPrototype[IS_LIST_SENTINEL] = true;
		  ListPrototype[DELETE] = ListPrototype.remove;
		  ListPrototype.setIn = MapPrototype.setIn;
		  ListPrototype.deleteIn =
		  ListPrototype.removeIn = MapPrototype.removeIn;
		  ListPrototype.update = MapPrototype.update;
		  ListPrototype.updateIn = MapPrototype.updateIn;
		  ListPrototype.mergeIn = MapPrototype.mergeIn;
		  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
		  ListPrototype.withMutations = MapPrototype.withMutations;
		  ListPrototype.asMutable = MapPrototype.asMutable;
		  ListPrototype.asImmutable = MapPrototype.asImmutable;
		  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
		    function VNode(array, ownerID) {
		      this.array = array;
		      this.ownerID = ownerID;
		    }
	
		    // TODO: seems like these methods are very similar
	
		    VNode.prototype.removeBefore = function(ownerID, level, index) {
		      if (index === level ? 1 << level : 0 || this.array.length === 0) {
		        return this;
		      }
		      var originIndex = (index >>> level) & MASK;
		      if (originIndex >= this.array.length) {
		        return new VNode([], ownerID);
		      }
		      var removingFirst = originIndex === 0;
		      var newChild;
		      if (level > 0) {
		        var oldChild = this.array[originIndex];
		        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
		        if (newChild === oldChild && removingFirst) {
		          return this;
		        }
		      }
		      if (removingFirst && !newChild) {
		        return this;
		      }
		      var editable = editableVNode(this, ownerID);
		      if (!removingFirst) {
		        for (var ii = 0; ii < originIndex; ii++) {
		          editable.array[ii] = undefined;
		        }
		      }
		      if (newChild) {
		        editable.array[originIndex] = newChild;
		      }
		      return editable;
		    };
	
		    VNode.prototype.removeAfter = function(ownerID, level, index) {
		      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
		        return this;
		      }
		      var sizeIndex = ((index - 1) >>> level) & MASK;
		      if (sizeIndex >= this.array.length) {
		        return this;
		      }
	
		      var newChild;
		      if (level > 0) {
		        var oldChild = this.array[sizeIndex];
		        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
		        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
		          return this;
		        }
		      }
	
		      var editable = editableVNode(this, ownerID);
		      editable.array.splice(sizeIndex + 1);
		      if (newChild) {
		        editable.array[sizeIndex] = newChild;
		      }
		      return editable;
		    };
	
	
	
		  var DONE = {};
	
		  function iterateList(list, reverse) {
		    var left = list._origin;
		    var right = list._capacity;
		    var tailPos = getTailOffset(right);
		    var tail = list._tail;
	
		    return iterateNodeOrLeaf(list._root, list._level, 0);
	
		    function iterateNodeOrLeaf(node, level, offset) {
		      return level === 0 ?
		        iterateLeaf(node, offset) :
		        iterateNode(node, level, offset);
		    }
	
		    function iterateLeaf(node, offset) {
		      var array = offset === tailPos ? tail && tail.array : node && node.array;
		      var from = offset > left ? 0 : left - offset;
		      var to = right - offset;
		      if (to > SIZE) {
		        to = SIZE;
		      }
		      return function()  {
		        if (from === to) {
		          return DONE;
		        }
		        var idx = reverse ? --to : from++;
		        return array && array[idx];
		      };
		    }
	
		    function iterateNode(node, level, offset) {
		      var values;
		      var array = node && node.array;
		      var from = offset > left ? 0 : (left - offset) >> level;
		      var to = ((right - offset) >> level) + 1;
		      if (to > SIZE) {
		        to = SIZE;
		      }
		      return function()  {
		        do {
		          if (values) {
		            var value = values();
		            if (value !== DONE) {
		              return value;
		            }
		            values = null;
		          }
		          if (from === to) {
		            return DONE;
		          }
		          var idx = reverse ? --to : from++;
		          values = iterateNodeOrLeaf(
		            array && array[idx], level - SHIFT, offset + (idx << level)
		          );
		        } while (true);
		      };
		    }
		  }
	
		  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
		    var list = Object.create(ListPrototype);
		    list.size = capacity - origin;
		    list._origin = origin;
		    list._capacity = capacity;
		    list._level = level;
		    list._root = root;
		    list._tail = tail;
		    list.__ownerID = ownerID;
		    list.__hash = hash;
		    list.__altered = false;
		    return list;
		  }
	
		  var EMPTY_LIST;
		  function emptyList() {
		    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
		  }
	
		  function updateList(list, index, value) {
		    index = wrapIndex(list, index);
	
		    if (index !== index) {
		      return list;
		    }
	
		    if (index >= list.size || index < 0) {
		      return list.withMutations(function(list ) {
		        index < 0 ?
		          setListBounds(list, index).set(0, value) :
		          setListBounds(list, 0, index + 1).set(index, value)
		      });
		    }
	
		    index += list._origin;
	
		    var newTail = list._tail;
		    var newRoot = list._root;
		    var didAlter = MakeRef(DID_ALTER);
		    if (index >= getTailOffset(list._capacity)) {
		      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
		    } else {
		      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
		    }
	
		    if (!didAlter.value) {
		      return list;
		    }
	
		    if (list.__ownerID) {
		      list._root = newRoot;
		      list._tail = newTail;
		      list.__hash = undefined;
		      list.__altered = true;
		      return list;
		    }
		    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
		  }
	
		  function updateVNode(node, ownerID, level, index, value, didAlter) {
		    var idx = (index >>> level) & MASK;
		    var nodeHas = node && idx < node.array.length;
		    if (!nodeHas && value === undefined) {
		      return node;
		    }
	
		    var newNode;
	
		    if (level > 0) {
		      var lowerNode = node && node.array[idx];
		      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
		      if (newLowerNode === lowerNode) {
		        return node;
		      }
		      newNode = editableVNode(node, ownerID);
		      newNode.array[idx] = newLowerNode;
		      return newNode;
		    }
	
		    if (nodeHas && node.array[idx] === value) {
		      return node;
		    }
	
		    SetRef(didAlter);
	
		    newNode = editableVNode(node, ownerID);
		    if (value === undefined && idx === newNode.array.length - 1) {
		      newNode.array.pop();
		    } else {
		      newNode.array[idx] = value;
		    }
		    return newNode;
		  }
	
		  function editableVNode(node, ownerID) {
		    if (ownerID && node && ownerID === node.ownerID) {
		      return node;
		    }
		    return new VNode(node ? node.array.slice() : [], ownerID);
		  }
	
		  function listNodeFor(list, rawIndex) {
		    if (rawIndex >= getTailOffset(list._capacity)) {
		      return list._tail;
		    }
		    if (rawIndex < 1 << (list._level + SHIFT)) {
		      var node = list._root;
		      var level = list._level;
		      while (node && level > 0) {
		        node = node.array[(rawIndex >>> level) & MASK];
		        level -= SHIFT;
		      }
		      return node;
		    }
		  }
	
		  function setListBounds(list, begin, end) {
		    // Sanitize begin & end using this shorthand for ToInt32(argument)
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
		    if (begin !== undefined) {
		      begin = begin | 0;
		    }
		    if (end !== undefined) {
		      end = end | 0;
		    }
		    var owner = list.__ownerID || new OwnerID();
		    var oldOrigin = list._origin;
		    var oldCapacity = list._capacity;
		    var newOrigin = oldOrigin + begin;
		    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
		    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
		      return list;
		    }
	
		    // If it's going to end after it starts, it's empty.
		    if (newOrigin >= newCapacity) {
		      return list.clear();
		    }
	
		    var newLevel = list._level;
		    var newRoot = list._root;
	
		    // New origin might need creating a higher root.
		    var offsetShift = 0;
		    while (newOrigin + offsetShift < 0) {
		      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
		      newLevel += SHIFT;
		      offsetShift += 1 << newLevel;
		    }
		    if (offsetShift) {
		      newOrigin += offsetShift;
		      oldOrigin += offsetShift;
		      newCapacity += offsetShift;
		      oldCapacity += offsetShift;
		    }
	
		    var oldTailOffset = getTailOffset(oldCapacity);
		    var newTailOffset = getTailOffset(newCapacity);
	
		    // New size might need creating a higher root.
		    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
		      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
		      newLevel += SHIFT;
		    }
	
		    // Locate or create the new tail.
		    var oldTail = list._tail;
		    var newTail = newTailOffset < oldTailOffset ?
		      listNodeFor(list, newCapacity - 1) :
		      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
		    // Merge Tail into tree.
		    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
		      newRoot = editableVNode(newRoot, owner);
		      var node = newRoot;
		      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
		        var idx = (oldTailOffset >>> level) & MASK;
		        node = node.array[idx] = editableVNode(node.array[idx], owner);
		      }
		      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
		    }
	
		    // If the size has been reduced, there's a chance the tail needs to be trimmed.
		    if (newCapacity < oldCapacity) {
		      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
		    }
	
		    // If the new origin is within the tail, then we do not need a root.
		    if (newOrigin >= newTailOffset) {
		      newOrigin -= newTailOffset;
		      newCapacity -= newTailOffset;
		      newLevel = SHIFT;
		      newRoot = null;
		      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
		    // Otherwise, if the root has been trimmed, garbage collect.
		    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
		      offsetShift = 0;
	
		      // Identify the new top root node of the subtree of the old root.
		      while (newRoot) {
		        var beginIndex = (newOrigin >>> newLevel) & MASK;
		        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
		          break;
		        }
		        if (beginIndex) {
		          offsetShift += (1 << newLevel) * beginIndex;
		        }
		        newLevel -= SHIFT;
		        newRoot = newRoot.array[beginIndex];
		      }
	
		      // Trim the new sides of the new root.
		      if (newRoot && newOrigin > oldOrigin) {
		        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
		      }
		      if (newRoot && newTailOffset < oldTailOffset) {
		        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
		      }
		      if (offsetShift) {
		        newOrigin -= offsetShift;
		        newCapacity -= offsetShift;
		      }
		    }
	
		    if (list.__ownerID) {
		      list.size = newCapacity - newOrigin;
		      list._origin = newOrigin;
		      list._capacity = newCapacity;
		      list._level = newLevel;
		      list._root = newRoot;
		      list._tail = newTail;
		      list.__hash = undefined;
		      list.__altered = true;
		      return list;
		    }
		    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
		  }
	
		  function mergeIntoListWith(list, merger, iterables) {
		    var iters = [];
		    var maxSize = 0;
		    for (var ii = 0; ii < iterables.length; ii++) {
		      var value = iterables[ii];
		      var iter = IndexedIterable(value);
		      if (iter.size > maxSize) {
		        maxSize = iter.size;
		      }
		      if (!isIterable(value)) {
		        iter = iter.map(function(v ) {return fromJS(v)});
		      }
		      iters.push(iter);
		    }
		    if (maxSize > list.size) {
		      list = list.setSize(maxSize);
		    }
		    return mergeIntoCollectionWith(list, merger, iters);
		  }
	
		  function getTailOffset(size) {
		    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
		  }
	
		  createClass(OrderedMap, Map);
	
		    // @pragma Construction
	
		    function OrderedMap(value) {
		      return value === null || value === undefined ? emptyOrderedMap() :
		        isOrderedMap(value) ? value :
		        emptyOrderedMap().withMutations(function(map ) {
		          var iter = KeyedIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v, k)  {return map.set(k, v)});
		        });
		    }
	
		    OrderedMap.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    OrderedMap.prototype.toString = function() {
		      return this.__toString('OrderedMap {', '}');
		    };
	
		    // @pragma Access
	
		    OrderedMap.prototype.get = function(k, notSetValue) {
		      var index = this._map.get(k);
		      return index !== undefined ? this._list.get(index)[1] : notSetValue;
		    };
	
		    // @pragma Modification
	
		    OrderedMap.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._map.clear();
		        this._list.clear();
		        return this;
		      }
		      return emptyOrderedMap();
		    };
	
		    OrderedMap.prototype.set = function(k, v) {
		      return updateOrderedMap(this, k, v);
		    };
	
		    OrderedMap.prototype.remove = function(k) {
		      return updateOrderedMap(this, k, NOT_SET);
		    };
	
		    OrderedMap.prototype.wasAltered = function() {
		      return this._map.wasAltered() || this._list.wasAltered();
		    };
	
		    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._list.__iterate(
		        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
		        reverse
		      );
		    };
	
		    OrderedMap.prototype.__iterator = function(type, reverse) {
		      return this._list.fromEntrySeq().__iterator(type, reverse);
		    };
	
		    OrderedMap.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map.__ensureOwner(ownerID);
		      var newList = this._list.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        this._list = newList;
		        return this;
		      }
		      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
		    };
	
	
		  function isOrderedMap(maybeOrderedMap) {
		    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
		  }
	
		  OrderedMap.isOrderedMap = isOrderedMap;
	
		  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
		  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
		  function makeOrderedMap(map, list, ownerID, hash) {
		    var omap = Object.create(OrderedMap.prototype);
		    omap.size = map ? map.size : 0;
		    omap._map = map;
		    omap._list = list;
		    omap.__ownerID = ownerID;
		    omap.__hash = hash;
		    return omap;
		  }
	
		  var EMPTY_ORDERED_MAP;
		  function emptyOrderedMap() {
		    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
		  }
	
		  function updateOrderedMap(omap, k, v) {
		    var map = omap._map;
		    var list = omap._list;
		    var i = map.get(k);
		    var has = i !== undefined;
		    var newMap;
		    var newList;
		    if (v === NOT_SET) { // removed
		      if (!has) {
		        return omap;
		      }
		      if (list.size >= SIZE && list.size >= map.size * 2) {
		        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
		        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
		        if (omap.__ownerID) {
		          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
		        }
		      } else {
		        newMap = map.remove(k);
		        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
		      }
		    } else {
		      if (has) {
		        if (v === list.get(i)[1]) {
		          return omap;
		        }
		        newMap = map;
		        newList = list.set(i, [k, v]);
		      } else {
		        newMap = map.set(k, list.size);
		        newList = list.set(list.size, [k, v]);
		      }
		    }
		    if (omap.__ownerID) {
		      omap.size = newMap.size;
		      omap._map = newMap;
		      omap._list = newList;
		      omap.__hash = undefined;
		      return omap;
		    }
		    return makeOrderedMap(newMap, newList);
		  }
	
		  createClass(ToKeyedSequence, KeyedSeq);
		    function ToKeyedSequence(indexed, useKeys) {
		      this._iter = indexed;
		      this._useKeys = useKeys;
		      this.size = indexed.size;
		    }
	
		    ToKeyedSequence.prototype.get = function(key, notSetValue) {
		      return this._iter.get(key, notSetValue);
		    };
	
		    ToKeyedSequence.prototype.has = function(key) {
		      return this._iter.has(key);
		    };
	
		    ToKeyedSequence.prototype.valueSeq = function() {
		      return this._iter.valueSeq();
		    };
	
		    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
		      var reversedSequence = reverseFactory(this, true);
		      if (!this._useKeys) {
		        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
		      }
		      return reversedSequence;
		    };
	
		    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
		      var mappedSequence = mapFactory(this, mapper, context);
		      if (!this._useKeys) {
		        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
		      }
		      return mappedSequence;
		    };
	
		    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var ii;
		      return this._iter.__iterate(
		        this._useKeys ?
		          function(v, k)  {return fn(v, k, this$0)} :
		          ((ii = reverse ? resolveSize(this) : 0),
		            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
		        reverse
		      );
		    };
	
		    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
		      if (this._useKeys) {
		        return this._iter.__iterator(type, reverse);
		      }
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      var ii = reverse ? resolveSize(this) : 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
		      });
		    };
	
		  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
		  createClass(ToIndexedSequence, IndexedSeq);
		    function ToIndexedSequence(iter) {
		      this._iter = iter;
		      this.size = iter.size;
		    }
	
		    ToIndexedSequence.prototype.includes = function(value) {
		      return this._iter.includes(value);
		    };
	
		    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
		    };
	
		    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, iterations++, step.value, step)
		      });
		    };
	
	
	
		  createClass(ToSetSequence, SetSeq);
		    function ToSetSequence(iter) {
		      this._iter = iter;
		      this.size = iter.size;
		    }
	
		    ToSetSequence.prototype.has = function(key) {
		      return this._iter.includes(key);
		    };
	
		    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
		    };
	
		    ToSetSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      return new Iterator(function()  {
		        var step = iterator.next();
		        return step.done ? step :
		          iteratorValue(type, step.value, step.value, step);
		      });
		    };
	
	
	
		  createClass(FromEntriesSequence, KeyedSeq);
		    function FromEntriesSequence(entries) {
		      this._iter = entries;
		      this.size = entries.size;
		    }
	
		    FromEntriesSequence.prototype.entrySeq = function() {
		      return this._iter.toSeq();
		    };
	
		    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._iter.__iterate(function(entry ) {
		        // Check if entry exists first so array access doesn't throw for holes
		        // in the parent iteration.
		        if (entry) {
		          validateEntry(entry);
		          var indexedIterable = isIterable(entry);
		          return fn(
		            indexedIterable ? entry.get(1) : entry[1],
		            indexedIterable ? entry.get(0) : entry[0],
		            this$0
		          );
		        }
		      }, reverse);
		    };
	
		    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
		      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
		      return new Iterator(function()  {
		        while (true) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          var entry = step.value;
		          // Check if entry exists first so array access doesn't throw for holes
		          // in the parent iteration.
		          if (entry) {
		            validateEntry(entry);
		            var indexedIterable = isIterable(entry);
		            return iteratorValue(
		              type,
		              indexedIterable ? entry.get(0) : entry[0],
		              indexedIterable ? entry.get(1) : entry[1],
		              step
		            );
		          }
		        }
		      });
		    };
	
	
		  ToIndexedSequence.prototype.cacheResult =
		  ToKeyedSequence.prototype.cacheResult =
		  ToSetSequence.prototype.cacheResult =
		  FromEntriesSequence.prototype.cacheResult =
		    cacheResultThrough;
	
	
		  function flipFactory(iterable) {
		    var flipSequence = makeSequence(iterable);
		    flipSequence._iter = iterable;
		    flipSequence.size = iterable.size;
		    flipSequence.flip = function()  {return iterable};
		    flipSequence.reverse = function () {
		      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
		      reversedSequence.flip = function()  {return iterable.reverse()};
		      return reversedSequence;
		    };
		    flipSequence.has = function(key ) {return iterable.includes(key)};
		    flipSequence.includes = function(key ) {return iterable.has(key)};
		    flipSequence.cacheResult = cacheResultThrough;
		    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
		    }
		    flipSequence.__iteratorUncached = function(type, reverse) {
		      if (type === ITERATE_ENTRIES) {
		        var iterator = iterable.__iterator(type, reverse);
		        return new Iterator(function()  {
		          var step = iterator.next();
		          if (!step.done) {
		            var k = step.value[0];
		            step.value[0] = step.value[1];
		            step.value[1] = k;
		          }
		          return step;
		        });
		      }
		      return iterable.__iterator(
		        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
		        reverse
		      );
		    }
		    return flipSequence;
		  }
	
	
		  function mapFactory(iterable, mapper, context) {
		    var mappedSequence = makeSequence(iterable);
		    mappedSequence.size = iterable.size;
		    mappedSequence.has = function(key ) {return iterable.has(key)};
		    mappedSequence.get = function(key, notSetValue)  {
		      var v = iterable.get(key, NOT_SET);
		      return v === NOT_SET ?
		        notSetValue :
		        mapper.call(context, v, key, iterable);
		    };
		    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(
		        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
		        reverse
		      );
		    }
		    mappedSequence.__iteratorUncached = function (type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      return new Iterator(function()  {
		        var step = iterator.next();
		        if (step.done) {
		          return step;
		        }
		        var entry = step.value;
		        var key = entry[0];
		        return iteratorValue(
		          type,
		          key,
		          mapper.call(context, entry[1], key, iterable),
		          step
		        );
		      });
		    }
		    return mappedSequence;
		  }
	
	
		  function reverseFactory(iterable, useKeys) {
		    var reversedSequence = makeSequence(iterable);
		    reversedSequence._iter = iterable;
		    reversedSequence.size = iterable.size;
		    reversedSequence.reverse = function()  {return iterable};
		    if (iterable.flip) {
		      reversedSequence.flip = function () {
		        var flipSequence = flipFactory(iterable);
		        flipSequence.reverse = function()  {return iterable.flip()};
		        return flipSequence;
		      };
		    }
		    reversedSequence.get = function(key, notSetValue) 
		      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
		    reversedSequence.has = function(key )
		      {return iterable.has(useKeys ? key : -1 - key)};
		    reversedSequence.includes = function(value ) {return iterable.includes(value)};
		    reversedSequence.cacheResult = cacheResultThrough;
		    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
		      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
		    };
		    reversedSequence.__iterator =
		      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
		    return reversedSequence;
		  }
	
	
		  function filterFactory(iterable, predicate, context, useKeys) {
		    var filterSequence = makeSequence(iterable);
		    if (useKeys) {
		      filterSequence.has = function(key ) {
		        var v = iterable.get(key, NOT_SET);
		        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
		      };
		      filterSequence.get = function(key, notSetValue)  {
		        var v = iterable.get(key, NOT_SET);
		        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
		          v : notSetValue;
		      };
		    }
		    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c)  {
		        if (predicate.call(context, v, k, c)) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0);
		        }
		      }, reverse);
		      return iterations;
		    };
		    filterSequence.__iteratorUncached = function (type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (true) {
		          var step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		          var entry = step.value;
		          var key = entry[0];
		          var value = entry[1];
		          if (predicate.call(context, value, key, iterable)) {
		            return iteratorValue(type, useKeys ? key : iterations++, value, step);
		          }
		        }
		      });
		    }
		    return filterSequence;
		  }
	
	
		  function countByFactory(iterable, grouper, context) {
		    var groups = Map().asMutable();
		    iterable.__iterate(function(v, k)  {
		      groups.update(
		        grouper.call(context, v, k, iterable),
		        0,
		        function(a ) {return a + 1}
		      );
		    });
		    return groups.asImmutable();
		  }
	
	
		  function groupByFactory(iterable, grouper, context) {
		    var isKeyedIter = isKeyed(iterable);
		    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
		    iterable.__iterate(function(v, k)  {
		      groups.update(
		        grouper.call(context, v, k, iterable),
		        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
		      );
		    });
		    var coerce = iterableClass(iterable);
		    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
		  }
	
	
		  function sliceFactory(iterable, begin, end, useKeys) {
		    var originalSize = iterable.size;
	
		    // Sanitize begin & end using this shorthand for ToInt32(argument)
		    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
		    if (begin !== undefined) {
		      begin = begin | 0;
		    }
		    if (end !== undefined) {
		      if (end === Infinity) {
		        end = originalSize;
		      } else {
		        end = end | 0;
		      }
		    }
	
		    if (wholeSlice(begin, end, originalSize)) {
		      return iterable;
		    }
	
		    var resolvedBegin = resolveBegin(begin, originalSize);
		    var resolvedEnd = resolveEnd(end, originalSize);
	
		    // begin or end will be NaN if they were provided as negative numbers and
		    // this iterable's size is unknown. In that case, cache first so there is
		    // a known size and these do not resolve to NaN.
		    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
		      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
		    }
	
		    // Note: resolvedEnd is undefined when the original sequence's length is
		    // unknown and this slice did not supply an end and should contain all
		    // elements after resolvedBegin.
		    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
		    var resolvedSize = resolvedEnd - resolvedBegin;
		    var sliceSize;
		    if (resolvedSize === resolvedSize) {
		      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
		    }
	
		    var sliceSeq = makeSequence(iterable);
	
		    // If iterable.size is undefined, the size of the realized sliceSeq is
		    // unknown at this point unless the number of items to slice is 0
		    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
		    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
		      sliceSeq.get = function (index, notSetValue) {
		        index = wrapIndex(this, index);
		        return index >= 0 && index < sliceSize ?
		          iterable.get(index + resolvedBegin, notSetValue) :
		          notSetValue;
		      }
		    }
	
		    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      if (sliceSize === 0) {
		        return 0;
		      }
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var skipped = 0;
		      var isSkipping = true;
		      var iterations = 0;
		      iterable.__iterate(function(v, k)  {
		        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
		                 iterations !== sliceSize;
		        }
		      });
		      return iterations;
		    };
	
		    sliceSeq.__iteratorUncached = function(type, reverse) {
		      if (sliceSize !== 0 && reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      // Don't bother instantiating parent iterator if taking 0.
		      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
		      var skipped = 0;
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (skipped++ < resolvedBegin) {
		          iterator.next();
		        }
		        if (++iterations > sliceSize) {
		          return iteratorDone();
		        }
		        var step = iterator.next();
		        if (useKeys || type === ITERATE_VALUES) {
		          return step;
		        } else if (type === ITERATE_KEYS) {
		          return iteratorValue(type, iterations - 1, undefined, step);
		        } else {
		          return iteratorValue(type, iterations - 1, step.value[1], step);
		        }
		      });
		    }
	
		    return sliceSeq;
		  }
	
	
		  function takeWhileFactory(iterable, predicate, context) {
		    var takeSequence = makeSequence(iterable);
		    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c) 
		        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
		      );
		      return iterations;
		    };
		    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var iterating = true;
		      return new Iterator(function()  {
		        if (!iterating) {
		          return iteratorDone();
		        }
		        var step = iterator.next();
		        if (step.done) {
		          return step;
		        }
		        var entry = step.value;
		        var k = entry[0];
		        var v = entry[1];
		        if (!predicate.call(context, v, k, this$0)) {
		          iterating = false;
		          return iteratorDone();
		        }
		        return type === ITERATE_ENTRIES ? step :
		          iteratorValue(type, k, v, step);
		      });
		    };
		    return takeSequence;
		  }
	
	
		  function skipWhileFactory(iterable, predicate, context, useKeys) {
		    var skipSequence = makeSequence(iterable);
		    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterate(fn, reverse);
		      }
		      var isSkipping = true;
		      var iterations = 0;
		      iterable.__iterate(function(v, k, c)  {
		        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
		          iterations++;
		          return fn(v, useKeys ? k : iterations - 1, this$0);
		        }
		      });
		      return iterations;
		    };
		    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
		      if (reverse) {
		        return this.cacheResult().__iterator(type, reverse);
		      }
		      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
		      var skipping = true;
		      var iterations = 0;
		      return new Iterator(function()  {
		        var step, k, v;
		        do {
		          step = iterator.next();
		          if (step.done) {
		            if (useKeys || type === ITERATE_VALUES) {
		              return step;
		            } else if (type === ITERATE_KEYS) {
		              return iteratorValue(type, iterations++, undefined, step);
		            } else {
		              return iteratorValue(type, iterations++, step.value[1], step);
		            }
		          }
		          var entry = step.value;
		          k = entry[0];
		          v = entry[1];
		          skipping && (skipping = predicate.call(context, v, k, this$0));
		        } while (skipping);
		        return type === ITERATE_ENTRIES ? step :
		          iteratorValue(type, k, v, step);
		      });
		    };
		    return skipSequence;
		  }
	
	
		  function concatFactory(iterable, values) {
		    var isKeyedIterable = isKeyed(iterable);
		    var iters = [iterable].concat(values).map(function(v ) {
		      if (!isIterable(v)) {
		        v = isKeyedIterable ?
		          keyedSeqFromValue(v) :
		          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
		      } else if (isKeyedIterable) {
		        v = KeyedIterable(v);
		      }
		      return v;
		    }).filter(function(v ) {return v.size !== 0});
	
		    if (iters.length === 0) {
		      return iterable;
		    }
	
		    if (iters.length === 1) {
		      var singleton = iters[0];
		      if (singleton === iterable ||
		          isKeyedIterable && isKeyed(singleton) ||
		          isIndexed(iterable) && isIndexed(singleton)) {
		        return singleton;
		      }
		    }
	
		    var concatSeq = new ArraySeq(iters);
		    if (isKeyedIterable) {
		      concatSeq = concatSeq.toKeyedSeq();
		    } else if (!isIndexed(iterable)) {
		      concatSeq = concatSeq.toSetSeq();
		    }
		    concatSeq = concatSeq.flatten(true);
		    concatSeq.size = iters.reduce(
		      function(sum, seq)  {
		        if (sum !== undefined) {
		          var size = seq.size;
		          if (size !== undefined) {
		            return sum + size;
		          }
		        }
		      },
		      0
		    );
		    return concatSeq;
		  }
	
	
		  function flattenFactory(iterable, depth, useKeys) {
		    var flatSequence = makeSequence(iterable);
		    flatSequence.__iterateUncached = function(fn, reverse) {
		      var iterations = 0;
		      var stopped = false;
		      function flatDeep(iter, currentDepth) {var this$0 = this;
		        iter.__iterate(function(v, k)  {
		          if ((!depth || currentDepth < depth) && isIterable(v)) {
		            flatDeep(v, currentDepth + 1);
		          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
		            stopped = true;
		          }
		          return !stopped;
		        }, reverse);
		      }
		      flatDeep(iterable, 0);
		      return iterations;
		    }
		    flatSequence.__iteratorUncached = function(type, reverse) {
		      var iterator = iterable.__iterator(type, reverse);
		      var stack = [];
		      var iterations = 0;
		      return new Iterator(function()  {
		        while (iterator) {
		          var step = iterator.next();
		          if (step.done !== false) {
		            iterator = stack.pop();
		            continue;
		          }
		          var v = step.value;
		          if (type === ITERATE_ENTRIES) {
		            v = v[1];
		          }
		          if ((!depth || stack.length < depth) && isIterable(v)) {
		            stack.push(iterator);
		            iterator = v.__iterator(type, reverse);
		          } else {
		            return useKeys ? step : iteratorValue(type, iterations++, v, step);
		          }
		        }
		        return iteratorDone();
		      });
		    }
		    return flatSequence;
		  }
	
	
		  function flatMapFactory(iterable, mapper, context) {
		    var coerce = iterableClass(iterable);
		    return iterable.toSeq().map(
		      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
		    ).flatten(true);
		  }
	
	
		  function interposeFactory(iterable, separator) {
		    var interposedSequence = makeSequence(iterable);
		    interposedSequence.size = iterable.size && iterable.size * 2 -1;
		    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
		      var iterations = 0;
		      iterable.__iterate(function(v, k) 
		        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
		        fn(v, iterations++, this$0) !== false},
		        reverse
		      );
		      return iterations;
		    };
		    interposedSequence.__iteratorUncached = function(type, reverse) {
		      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
		      var iterations = 0;
		      var step;
		      return new Iterator(function()  {
		        if (!step || iterations % 2) {
		          step = iterator.next();
		          if (step.done) {
		            return step;
		          }
		        }
		        return iterations % 2 ?
		          iteratorValue(type, iterations++, separator) :
		          iteratorValue(type, iterations++, step.value, step);
		      });
		    };
		    return interposedSequence;
		  }
	
	
		  function sortFactory(iterable, comparator, mapper) {
		    if (!comparator) {
		      comparator = defaultComparator;
		    }
		    var isKeyedIterable = isKeyed(iterable);
		    var index = 0;
		    var entries = iterable.toSeq().map(
		      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
		    ).toArray();
		    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
		      isKeyedIterable ?
		      function(v, i)  { entries[i].length = 2; } :
		      function(v, i)  { entries[i] = v[1]; }
		    );
		    return isKeyedIterable ? KeyedSeq(entries) :
		      isIndexed(iterable) ? IndexedSeq(entries) :
		      SetSeq(entries);
		  }
	
	
		  function maxFactory(iterable, comparator, mapper) {
		    if (!comparator) {
		      comparator = defaultComparator;
		    }
		    if (mapper) {
		      var entry = iterable.toSeq()
		        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
		        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
		      return entry && entry[0];
		    } else {
		      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
		    }
		  }
	
		  function maxCompare(comparator, a, b) {
		    var comp = comparator(b, a);
		    // b is considered the new max if the comparator declares them equal, but
		    // they are not equal and b is in fact a nullish value.
		    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
		  }
	
	
		  function zipWithFactory(keyIter, zipper, iters) {
		    var zipSequence = makeSequence(keyIter);
		    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
		    // Note: this a generic base implementation of __iterate in terms of
		    // __iterator which may be more generically useful in the future.
		    zipSequence.__iterate = function(fn, reverse) {
		      /* generic:
		      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
		      var step;
		      var iterations = 0;
		      while (!(step = iterator.next()).done) {
		        iterations++;
		        if (fn(step.value[1], step.value[0], this) === false) {
		          break;
		        }
		      }
		      return iterations;
		      */
		      // indexed:
		      var iterator = this.__iterator(ITERATE_VALUES, reverse);
		      var step;
		      var iterations = 0;
		      while (!(step = iterator.next()).done) {
		        if (fn(step.value, iterations++, this) === false) {
		          break;
		        }
		      }
		      return iterations;
		    };
		    zipSequence.__iteratorUncached = function(type, reverse) {
		      var iterators = iters.map(function(i )
		        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
		      );
		      var iterations = 0;
		      var isDone = false;
		      return new Iterator(function()  {
		        var steps;
		        if (!isDone) {
		          steps = iterators.map(function(i ) {return i.next()});
		          isDone = steps.some(function(s ) {return s.done});
		        }
		        if (isDone) {
		          return iteratorDone();
		        }
		        return iteratorValue(
		          type,
		          iterations++,
		          zipper.apply(null, steps.map(function(s ) {return s.value}))
		        );
		      });
		    };
		    return zipSequence
		  }
	
	
		  // #pragma Helper Functions
	
		  function reify(iter, seq) {
		    return isSeq(iter) ? seq : iter.constructor(seq);
		  }
	
		  function validateEntry(entry) {
		    if (entry !== Object(entry)) {
		      throw new TypeError('Expected [K, V] tuple: ' + entry);
		    }
		  }
	
		  function resolveSize(iter) {
		    assertNotInfinite(iter.size);
		    return ensureSize(iter);
		  }
	
		  function iterableClass(iterable) {
		    return isKeyed(iterable) ? KeyedIterable :
		      isIndexed(iterable) ? IndexedIterable :
		      SetIterable;
		  }
	
		  function makeSequence(iterable) {
		    return Object.create(
		      (
		        isKeyed(iterable) ? KeyedSeq :
		        isIndexed(iterable) ? IndexedSeq :
		        SetSeq
		      ).prototype
		    );
		  }
	
		  function cacheResultThrough() {
		    if (this._iter.cacheResult) {
		      this._iter.cacheResult();
		      this.size = this._iter.size;
		      return this;
		    } else {
		      return Seq.prototype.cacheResult.call(this);
		    }
		  }
	
		  function defaultComparator(a, b) {
		    return a > b ? 1 : a < b ? -1 : 0;
		  }
	
		  function forceIterator(keyPath) {
		    var iter = getIterator(keyPath);
		    if (!iter) {
		      // Array might not be iterable in this environment, so we need a fallback
		      // to our wrapped type.
		      if (!isArrayLike(keyPath)) {
		        throw new TypeError('Expected iterable or array-like: ' + keyPath);
		      }
		      iter = getIterator(Iterable(keyPath));
		    }
		    return iter;
		  }
	
		  createClass(Record, KeyedCollection);
	
		    function Record(defaultValues, name) {
		      var hasInitialized;
	
		      var RecordType = function Record(values) {
		        if (values instanceof RecordType) {
		          return values;
		        }
		        if (!(this instanceof RecordType)) {
		          return new RecordType(values);
		        }
		        if (!hasInitialized) {
		          hasInitialized = true;
		          var keys = Object.keys(defaultValues);
		          setProps(RecordTypePrototype, keys);
		          RecordTypePrototype.size = keys.length;
		          RecordTypePrototype._name = name;
		          RecordTypePrototype._keys = keys;
		          RecordTypePrototype._defaultValues = defaultValues;
		        }
		        this._map = Map(values);
		      };
	
		      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
		      RecordTypePrototype.constructor = RecordType;
	
		      return RecordType;
		    }
	
		    Record.prototype.toString = function() {
		      return this.__toString(recordName(this) + ' {', '}');
		    };
	
		    // @pragma Access
	
		    Record.prototype.has = function(k) {
		      return this._defaultValues.hasOwnProperty(k);
		    };
	
		    Record.prototype.get = function(k, notSetValue) {
		      if (!this.has(k)) {
		        return notSetValue;
		      }
		      var defaultVal = this._defaultValues[k];
		      return this._map ? this._map.get(k, defaultVal) : defaultVal;
		    };
	
		    // @pragma Modification
	
		    Record.prototype.clear = function() {
		      if (this.__ownerID) {
		        this._map && this._map.clear();
		        return this;
		      }
		      var RecordType = this.constructor;
		      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
		    };
	
		    Record.prototype.set = function(k, v) {
		      if (!this.has(k)) {
		        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
		      }
		      if (this._map && !this._map.has(k)) {
		        var defaultVal = this._defaultValues[k];
		        if (v === defaultVal) {
		          return this;
		        }
		      }
		      var newMap = this._map && this._map.set(k, v);
		      if (this.__ownerID || newMap === this._map) {
		        return this;
		      }
		      return makeRecord(this, newMap);
		    };
	
		    Record.prototype.remove = function(k) {
		      if (!this.has(k)) {
		        return this;
		      }
		      var newMap = this._map && this._map.remove(k);
		      if (this.__ownerID || newMap === this._map) {
		        return this;
		      }
		      return makeRecord(this, newMap);
		    };
	
		    Record.prototype.wasAltered = function() {
		      return this._map.wasAltered();
		    };
	
		    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
		      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
		    };
	
		    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
		    };
	
		    Record.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map && this._map.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        return this;
		      }
		      return makeRecord(this, newMap, ownerID);
		    };
	
	
		  var RecordPrototype = Record.prototype;
		  RecordPrototype[DELETE] = RecordPrototype.remove;
		  RecordPrototype.deleteIn =
		  RecordPrototype.removeIn = MapPrototype.removeIn;
		  RecordPrototype.merge = MapPrototype.merge;
		  RecordPrototype.mergeWith = MapPrototype.mergeWith;
		  RecordPrototype.mergeIn = MapPrototype.mergeIn;
		  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
		  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
		  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
		  RecordPrototype.setIn = MapPrototype.setIn;
		  RecordPrototype.update = MapPrototype.update;
		  RecordPrototype.updateIn = MapPrototype.updateIn;
		  RecordPrototype.withMutations = MapPrototype.withMutations;
		  RecordPrototype.asMutable = MapPrototype.asMutable;
		  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
		  function makeRecord(likeRecord, map, ownerID) {
		    var record = Object.create(Object.getPrototypeOf(likeRecord));
		    record._map = map;
		    record.__ownerID = ownerID;
		    return record;
		  }
	
		  function recordName(record) {
		    return record._name || record.constructor.name || 'Record';
		  }
	
		  function setProps(prototype, names) {
		    try {
		      names.forEach(setProp.bind(undefined, prototype));
		    } catch (error) {
		      // Object.defineProperty failed. Probably IE8.
		    }
		  }
	
		  function setProp(prototype, name) {
		    Object.defineProperty(prototype, name, {
		      get: function() {
		        return this.get(name);
		      },
		      set: function(value) {
		        invariant(this.__ownerID, 'Cannot set on an immutable record.');
		        this.set(name, value);
		      }
		    });
		  }
	
		  createClass(Set, SetCollection);
	
		    // @pragma Construction
	
		    function Set(value) {
		      return value === null || value === undefined ? emptySet() :
		        isSet(value) && !isOrdered(value) ? value :
		        emptySet().withMutations(function(set ) {
		          var iter = SetIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v ) {return set.add(v)});
		        });
		    }
	
		    Set.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    Set.fromKeys = function(value) {
		      return this(KeyedIterable(value).keySeq());
		    };
	
		    Set.prototype.toString = function() {
		      return this.__toString('Set {', '}');
		    };
	
		    // @pragma Access
	
		    Set.prototype.has = function(value) {
		      return this._map.has(value);
		    };
	
		    // @pragma Modification
	
		    Set.prototype.add = function(value) {
		      return updateSet(this, this._map.set(value, true));
		    };
	
		    Set.prototype.remove = function(value) {
		      return updateSet(this, this._map.remove(value));
		    };
	
		    Set.prototype.clear = function() {
		      return updateSet(this, this._map.clear());
		    };
	
		    // @pragma Composition
	
		    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
		      iters = iters.filter(function(x ) {return x.size !== 0});
		      if (iters.length === 0) {
		        return this;
		      }
		      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
		        return this.constructor(iters[0]);
		      }
		      return this.withMutations(function(set ) {
		        for (var ii = 0; ii < iters.length; ii++) {
		          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
		        }
		      });
		    };
	
		    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
		      if (iters.length === 0) {
		        return this;
		      }
		      iters = iters.map(function(iter ) {return SetIterable(iter)});
		      var originalSet = this;
		      return this.withMutations(function(set ) {
		        originalSet.forEach(function(value ) {
		          if (!iters.every(function(iter ) {return iter.includes(value)})) {
		            set.remove(value);
		          }
		        });
		      });
		    };
	
		    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
		      if (iters.length === 0) {
		        return this;
		      }
		      iters = iters.map(function(iter ) {return SetIterable(iter)});
		      var originalSet = this;
		      return this.withMutations(function(set ) {
		        originalSet.forEach(function(value ) {
		          if (iters.some(function(iter ) {return iter.includes(value)})) {
		            set.remove(value);
		          }
		        });
		      });
		    };
	
		    Set.prototype.merge = function() {
		      return this.union.apply(this, arguments);
		    };
	
		    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
		      return this.union.apply(this, iters);
		    };
	
		    Set.prototype.sort = function(comparator) {
		      // Late binding
		      return OrderedSet(sortFactory(this, comparator));
		    };
	
		    Set.prototype.sortBy = function(mapper, comparator) {
		      // Late binding
		      return OrderedSet(sortFactory(this, comparator, mapper));
		    };
	
		    Set.prototype.wasAltered = function() {
		      return this._map.wasAltered();
		    };
	
		    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
		      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
		    };
	
		    Set.prototype.__iterator = function(type, reverse) {
		      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
		    };
	
		    Set.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      var newMap = this._map.__ensureOwner(ownerID);
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this._map = newMap;
		        return this;
		      }
		      return this.__make(newMap, ownerID);
		    };
	
	
		  function isSet(maybeSet) {
		    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
		  }
	
		  Set.isSet = isSet;
	
		  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
		  var SetPrototype = Set.prototype;
		  SetPrototype[IS_SET_SENTINEL] = true;
		  SetPrototype[DELETE] = SetPrototype.remove;
		  SetPrototype.mergeDeep = SetPrototype.merge;
		  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
		  SetPrototype.withMutations = MapPrototype.withMutations;
		  SetPrototype.asMutable = MapPrototype.asMutable;
		  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
		  SetPrototype.__empty = emptySet;
		  SetPrototype.__make = makeSet;
	
		  function updateSet(set, newMap) {
		    if (set.__ownerID) {
		      set.size = newMap.size;
		      set._map = newMap;
		      return set;
		    }
		    return newMap === set._map ? set :
		      newMap.size === 0 ? set.__empty() :
		      set.__make(newMap);
		  }
	
		  function makeSet(map, ownerID) {
		    var set = Object.create(SetPrototype);
		    set.size = map ? map.size : 0;
		    set._map = map;
		    set.__ownerID = ownerID;
		    return set;
		  }
	
		  var EMPTY_SET;
		  function emptySet() {
		    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
		  }
	
		  createClass(OrderedSet, Set);
	
		    // @pragma Construction
	
		    function OrderedSet(value) {
		      return value === null || value === undefined ? emptyOrderedSet() :
		        isOrderedSet(value) ? value :
		        emptyOrderedSet().withMutations(function(set ) {
		          var iter = SetIterable(value);
		          assertNotInfinite(iter.size);
		          iter.forEach(function(v ) {return set.add(v)});
		        });
		    }
	
		    OrderedSet.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    OrderedSet.fromKeys = function(value) {
		      return this(KeyedIterable(value).keySeq());
		    };
	
		    OrderedSet.prototype.toString = function() {
		      return this.__toString('OrderedSet {', '}');
		    };
	
	
		  function isOrderedSet(maybeOrderedSet) {
		    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
		  }
	
		  OrderedSet.isOrderedSet = isOrderedSet;
	
		  var OrderedSetPrototype = OrderedSet.prototype;
		  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
		  OrderedSetPrototype.__empty = emptyOrderedSet;
		  OrderedSetPrototype.__make = makeOrderedSet;
	
		  function makeOrderedSet(map, ownerID) {
		    var set = Object.create(OrderedSetPrototype);
		    set.size = map ? map.size : 0;
		    set._map = map;
		    set.__ownerID = ownerID;
		    return set;
		  }
	
		  var EMPTY_ORDERED_SET;
		  function emptyOrderedSet() {
		    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
		  }
	
		  createClass(Stack, IndexedCollection);
	
		    // @pragma Construction
	
		    function Stack(value) {
		      return value === null || value === undefined ? emptyStack() :
		        isStack(value) ? value :
		        emptyStack().unshiftAll(value);
		    }
	
		    Stack.of = function(/*...values*/) {
		      return this(arguments);
		    };
	
		    Stack.prototype.toString = function() {
		      return this.__toString('Stack [', ']');
		    };
	
		    // @pragma Access
	
		    Stack.prototype.get = function(index, notSetValue) {
		      var head = this._head;
		      index = wrapIndex(this, index);
		      while (head && index--) {
		        head = head.next;
		      }
		      return head ? head.value : notSetValue;
		    };
	
		    Stack.prototype.peek = function() {
		      return this._head && this._head.value;
		    };
	
		    // @pragma Modification
	
		    Stack.prototype.push = function(/*...values*/) {
		      if (arguments.length === 0) {
		        return this;
		      }
		      var newSize = this.size + arguments.length;
		      var head = this._head;
		      for (var ii = arguments.length - 1; ii >= 0; ii--) {
		        head = {
		          value: arguments[ii],
		          next: head
		        };
		      }
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    Stack.prototype.pushAll = function(iter) {
		      iter = IndexedIterable(iter);
		      if (iter.size === 0) {
		        return this;
		      }
		      assertNotInfinite(iter.size);
		      var newSize = this.size;
		      var head = this._head;
		      iter.reverse().forEach(function(value ) {
		        newSize++;
		        head = {
		          value: value,
		          next: head
		        };
		      });
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    Stack.prototype.pop = function() {
		      return this.slice(1);
		    };
	
		    Stack.prototype.unshift = function(/*...values*/) {
		      return this.push.apply(this, arguments);
		    };
	
		    Stack.prototype.unshiftAll = function(iter) {
		      return this.pushAll(iter);
		    };
	
		    Stack.prototype.shift = function() {
		      return this.pop.apply(this, arguments);
		    };
	
		    Stack.prototype.clear = function() {
		      if (this.size === 0) {
		        return this;
		      }
		      if (this.__ownerID) {
		        this.size = 0;
		        this._head = undefined;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return emptyStack();
		    };
	
		    Stack.prototype.slice = function(begin, end) {
		      if (wholeSlice(begin, end, this.size)) {
		        return this;
		      }
		      var resolvedBegin = resolveBegin(begin, this.size);
		      var resolvedEnd = resolveEnd(end, this.size);
		      if (resolvedEnd !== this.size) {
		        // super.slice(begin, end);
		        return IndexedCollection.prototype.slice.call(this, begin, end);
		      }
		      var newSize = this.size - resolvedBegin;
		      var head = this._head;
		      while (resolvedBegin--) {
		        head = head.next;
		      }
		      if (this.__ownerID) {
		        this.size = newSize;
		        this._head = head;
		        this.__hash = undefined;
		        this.__altered = true;
		        return this;
		      }
		      return makeStack(newSize, head);
		    };
	
		    // @pragma Mutability
	
		    Stack.prototype.__ensureOwner = function(ownerID) {
		      if (ownerID === this.__ownerID) {
		        return this;
		      }
		      if (!ownerID) {
		        this.__ownerID = ownerID;
		        this.__altered = false;
		        return this;
		      }
		      return makeStack(this.size, this._head, ownerID, this.__hash);
		    };
	
		    // @pragma Iteration
	
		    Stack.prototype.__iterate = function(fn, reverse) {
		      if (reverse) {
		        return this.reverse().__iterate(fn);
		      }
		      var iterations = 0;
		      var node = this._head;
		      while (node) {
		        if (fn(node.value, iterations++, this) === false) {
		          break;
		        }
		        node = node.next;
		      }
		      return iterations;
		    };
	
		    Stack.prototype.__iterator = function(type, reverse) {
		      if (reverse) {
		        return this.reverse().__iterator(type);
		      }
		      var iterations = 0;
		      var node = this._head;
		      return new Iterator(function()  {
		        if (node) {
		          var value = node.value;
		          node = node.next;
		          return iteratorValue(type, iterations++, value);
		        }
		        return iteratorDone();
		      });
		    };
	
	
		  function isStack(maybeStack) {
		    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
		  }
	
		  Stack.isStack = isStack;
	
		  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
		  var StackPrototype = Stack.prototype;
		  StackPrototype[IS_STACK_SENTINEL] = true;
		  StackPrototype.withMutations = MapPrototype.withMutations;
		  StackPrototype.asMutable = MapPrototype.asMutable;
		  StackPrototype.asImmutable = MapPrototype.asImmutable;
		  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
		  function makeStack(size, head, ownerID, hash) {
		    var map = Object.create(StackPrototype);
		    map.size = size;
		    map._head = head;
		    map.__ownerID = ownerID;
		    map.__hash = hash;
		    map.__altered = false;
		    return map;
		  }
	
		  var EMPTY_STACK;
		  function emptyStack() {
		    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
		  }
	
		  /**
		   * Contributes additional methods to a constructor
		   */
		  function mixin(ctor, methods) {
		    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
		    Object.keys(methods).forEach(keyCopier);
		    Object.getOwnPropertySymbols &&
		      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
		    return ctor;
		  }
	
		  Iterable.Iterator = Iterator;
	
		  mixin(Iterable, {
	
		    // ### Conversion to other types
	
		    toArray: function() {
		      assertNotInfinite(this.size);
		      var array = new Array(this.size || 0);
		      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
		      return array;
		    },
	
		    toIndexedSeq: function() {
		      return new ToIndexedSequence(this);
		    },
	
		    toJS: function() {
		      return this.toSeq().map(
		        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
		      ).__toJS();
		    },
	
		    toJSON: function() {
		      return this.toSeq().map(
		        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
		      ).__toJS();
		    },
	
		    toKeyedSeq: function() {
		      return new ToKeyedSequence(this, true);
		    },
	
		    toMap: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Map(this.toKeyedSeq());
		    },
	
		    toObject: function() {
		      assertNotInfinite(this.size);
		      var object = {};
		      this.__iterate(function(v, k)  { object[k] = v; });
		      return object;
		    },
	
		    toOrderedMap: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return OrderedMap(this.toKeyedSeq());
		    },
	
		    toOrderedSet: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toSet: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Set(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toSetSeq: function() {
		      return new ToSetSequence(this);
		    },
	
		    toSeq: function() {
		      return isIndexed(this) ? this.toIndexedSeq() :
		        isKeyed(this) ? this.toKeyedSeq() :
		        this.toSetSeq();
		    },
	
		    toStack: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return Stack(isKeyed(this) ? this.valueSeq() : this);
		    },
	
		    toList: function() {
		      // Use Late Binding here to solve the circular dependency.
		      return List(isKeyed(this) ? this.valueSeq() : this);
		    },
	
	
		    // ### Common JavaScript methods and properties
	
		    toString: function() {
		      return '[Iterable]';
		    },
	
		    __toString: function(head, tail) {
		      if (this.size === 0) {
		        return head + tail;
		      }
		      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
		    },
	
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    concat: function() {var values = SLICE$0.call(arguments, 0);
		      return reify(this, concatFactory(this, values));
		    },
	
		    includes: function(searchValue) {
		      return this.some(function(value ) {return is(value, searchValue)});
		    },
	
		    entries: function() {
		      return this.__iterator(ITERATE_ENTRIES);
		    },
	
		    every: function(predicate, context) {
		      assertNotInfinite(this.size);
		      var returnValue = true;
		      this.__iterate(function(v, k, c)  {
		        if (!predicate.call(context, v, k, c)) {
		          returnValue = false;
		          return false;
		        }
		      });
		      return returnValue;
		    },
	
		    filter: function(predicate, context) {
		      return reify(this, filterFactory(this, predicate, context, true));
		    },
	
		    find: function(predicate, context, notSetValue) {
		      var entry = this.findEntry(predicate, context);
		      return entry ? entry[1] : notSetValue;
		    },
	
		    forEach: function(sideEffect, context) {
		      assertNotInfinite(this.size);
		      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
		    },
	
		    join: function(separator) {
		      assertNotInfinite(this.size);
		      separator = separator !== undefined ? '' + separator : ',';
		      var joined = '';
		      var isFirst = true;
		      this.__iterate(function(v ) {
		        isFirst ? (isFirst = false) : (joined += separator);
		        joined += v !== null && v !== undefined ? v.toString() : '';
		      });
		      return joined;
		    },
	
		    keys: function() {
		      return this.__iterator(ITERATE_KEYS);
		    },
	
		    map: function(mapper, context) {
		      return reify(this, mapFactory(this, mapper, context));
		    },
	
		    reduce: function(reducer, initialReduction, context) {
		      assertNotInfinite(this.size);
		      var reduction;
		      var useFirst;
		      if (arguments.length < 2) {
		        useFirst = true;
		      } else {
		        reduction = initialReduction;
		      }
		      this.__iterate(function(v, k, c)  {
		        if (useFirst) {
		          useFirst = false;
		          reduction = v;
		        } else {
		          reduction = reducer.call(context, reduction, v, k, c);
		        }
		      });
		      return reduction;
		    },
	
		    reduceRight: function(reducer, initialReduction, context) {
		      var reversed = this.toKeyedSeq().reverse();
		      return reversed.reduce.apply(reversed, arguments);
		    },
	
		    reverse: function() {
		      return reify(this, reverseFactory(this, true));
		    },
	
		    slice: function(begin, end) {
		      return reify(this, sliceFactory(this, begin, end, true));
		    },
	
		    some: function(predicate, context) {
		      return !this.every(not(predicate), context);
		    },
	
		    sort: function(comparator) {
		      return reify(this, sortFactory(this, comparator));
		    },
	
		    values: function() {
		      return this.__iterator(ITERATE_VALUES);
		    },
	
	
		    // ### More sequential methods
	
		    butLast: function() {
		      return this.slice(0, -1);
		    },
	
		    isEmpty: function() {
		      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
		    },
	
		    count: function(predicate, context) {
		      return ensureSize(
		        predicate ? this.toSeq().filter(predicate, context) : this
		      );
		    },
	
		    countBy: function(grouper, context) {
		      return countByFactory(this, grouper, context);
		    },
	
		    equals: function(other) {
		      return deepEqual(this, other);
		    },
	
		    entrySeq: function() {
		      var iterable = this;
		      if (iterable._cache) {
		        // We cache as an entries array, so we can just return the cache!
		        return new ArraySeq(iterable._cache);
		      }
		      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
		      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
		      return entriesSequence;
		    },
	
		    filterNot: function(predicate, context) {
		      return this.filter(not(predicate), context);
		    },
	
		    findEntry: function(predicate, context, notSetValue) {
		      var found = notSetValue;
		      this.__iterate(function(v, k, c)  {
		        if (predicate.call(context, v, k, c)) {
		          found = [k, v];
		          return false;
		        }
		      });
		      return found;
		    },
	
		    findKey: function(predicate, context) {
		      var entry = this.findEntry(predicate, context);
		      return entry && entry[0];
		    },
	
		    findLast: function(predicate, context, notSetValue) {
		      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
		    },
	
		    findLastEntry: function(predicate, context, notSetValue) {
		      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
		    },
	
		    findLastKey: function(predicate, context) {
		      return this.toKeyedSeq().reverse().findKey(predicate, context);
		    },
	
		    first: function() {
		      return this.find(returnTrue);
		    },
	
		    flatMap: function(mapper, context) {
		      return reify(this, flatMapFactory(this, mapper, context));
		    },
	
		    flatten: function(depth) {
		      return reify(this, flattenFactory(this, depth, true));
		    },
	
		    fromEntrySeq: function() {
		      return new FromEntriesSequence(this);
		    },
	
		    get: function(searchKey, notSetValue) {
		      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
		    },
	
		    getIn: function(searchKeyPath, notSetValue) {
		      var nested = this;
		      // Note: in an ES6 environment, we would prefer:
		      // for (var key of searchKeyPath) {
		      var iter = forceIterator(searchKeyPath);
		      var step;
		      while (!(step = iter.next()).done) {
		        var key = step.value;
		        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
		        if (nested === NOT_SET) {
		          return notSetValue;
		        }
		      }
		      return nested;
		    },
	
		    groupBy: function(grouper, context) {
		      return groupByFactory(this, grouper, context);
		    },
	
		    has: function(searchKey) {
		      return this.get(searchKey, NOT_SET) !== NOT_SET;
		    },
	
		    hasIn: function(searchKeyPath) {
		      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
		    },
	
		    isSubset: function(iter) {
		      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
		      return this.every(function(value ) {return iter.includes(value)});
		    },
	
		    isSuperset: function(iter) {
		      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
		      return iter.isSubset(this);
		    },
	
		    keyOf: function(searchValue) {
		      return this.findKey(function(value ) {return is(value, searchValue)});
		    },
	
		    keySeq: function() {
		      return this.toSeq().map(keyMapper).toIndexedSeq();
		    },
	
		    last: function() {
		      return this.toSeq().reverse().first();
		    },
	
		    lastKeyOf: function(searchValue) {
		      return this.toKeyedSeq().reverse().keyOf(searchValue);
		    },
	
		    max: function(comparator) {
		      return maxFactory(this, comparator);
		    },
	
		    maxBy: function(mapper, comparator) {
		      return maxFactory(this, comparator, mapper);
		    },
	
		    min: function(comparator) {
		      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
		    },
	
		    minBy: function(mapper, comparator) {
		      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
		    },
	
		    rest: function() {
		      return this.slice(1);
		    },
	
		    skip: function(amount) {
		      return this.slice(Math.max(0, amount));
		    },
	
		    skipLast: function(amount) {
		      return reify(this, this.toSeq().reverse().skip(amount).reverse());
		    },
	
		    skipWhile: function(predicate, context) {
		      return reify(this, skipWhileFactory(this, predicate, context, true));
		    },
	
		    skipUntil: function(predicate, context) {
		      return this.skipWhile(not(predicate), context);
		    },
	
		    sortBy: function(mapper, comparator) {
		      return reify(this, sortFactory(this, comparator, mapper));
		    },
	
		    take: function(amount) {
		      return this.slice(0, Math.max(0, amount));
		    },
	
		    takeLast: function(amount) {
		      return reify(this, this.toSeq().reverse().take(amount).reverse());
		    },
	
		    takeWhile: function(predicate, context) {
		      return reify(this, takeWhileFactory(this, predicate, context));
		    },
	
		    takeUntil: function(predicate, context) {
		      return this.takeWhile(not(predicate), context);
		    },
	
		    valueSeq: function() {
		      return this.toIndexedSeq();
		    },
	
	
		    // ### Hashable Object
	
		    hashCode: function() {
		      return this.__hash || (this.__hash = hashIterable(this));
		    }
	
	
		    // ### Internal
	
		    // abstract __iterate(fn, reverse)
	
		    // abstract __iterator(type, reverse)
		  });
	
		  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
		  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
		  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
		  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
		  var IterablePrototype = Iterable.prototype;
		  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
		  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
		  IterablePrototype.__toJS = IterablePrototype.toArray;
		  IterablePrototype.__toStringMapper = quoteString;
		  IterablePrototype.inspect =
		  IterablePrototype.toSource = function() { return this.toString(); };
		  IterablePrototype.chain = IterablePrototype.flatMap;
		  IterablePrototype.contains = IterablePrototype.includes;
	
		  mixin(KeyedIterable, {
	
		    // ### More sequential methods
	
		    flip: function() {
		      return reify(this, flipFactory(this));
		    },
	
		    mapEntries: function(mapper, context) {var this$0 = this;
		      var iterations = 0;
		      return reify(this,
		        this.toSeq().map(
		          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
		        ).fromEntrySeq()
		      );
		    },
	
		    mapKeys: function(mapper, context) {var this$0 = this;
		      return reify(this,
		        this.toSeq().flip().map(
		          function(k, v)  {return mapper.call(context, k, v, this$0)}
		        ).flip()
		      );
		    }
	
		  });
	
		  var KeyedIterablePrototype = KeyedIterable.prototype;
		  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
		  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
		  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
		  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
		  mixin(IndexedIterable, {
	
		    // ### Conversion to other types
	
		    toKeyedSeq: function() {
		      return new ToKeyedSequence(this, false);
		    },
	
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    filter: function(predicate, context) {
		      return reify(this, filterFactory(this, predicate, context, false));
		    },
	
		    findIndex: function(predicate, context) {
		      var entry = this.findEntry(predicate, context);
		      return entry ? entry[0] : -1;
		    },
	
		    indexOf: function(searchValue) {
		      var key = this.keyOf(searchValue);
		      return key === undefined ? -1 : key;
		    },
	
		    lastIndexOf: function(searchValue) {
		      var key = this.lastKeyOf(searchValue);
		      return key === undefined ? -1 : key;
		    },
	
		    reverse: function() {
		      return reify(this, reverseFactory(this, false));
		    },
	
		    slice: function(begin, end) {
		      return reify(this, sliceFactory(this, begin, end, false));
		    },
	
		    splice: function(index, removeNum /*, ...values*/) {
		      var numArgs = arguments.length;
		      removeNum = Math.max(removeNum | 0, 0);
		      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
		        return this;
		      }
		      // If index is negative, it should resolve relative to the size of the
		      // collection. However size may be expensive to compute if not cached, so
		      // only call count() if the number is in fact negative.
		      index = resolveBegin(index, index < 0 ? this.count() : this.size);
		      var spliced = this.slice(0, index);
		      return reify(
		        this,
		        numArgs === 1 ?
		          spliced :
		          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
		      );
		    },
	
	
		    // ### More collection methods
	
		    findLastIndex: function(predicate, context) {
		      var entry = this.findLastEntry(predicate, context);
		      return entry ? entry[0] : -1;
		    },
	
		    first: function() {
		      return this.get(0);
		    },
	
		    flatten: function(depth) {
		      return reify(this, flattenFactory(this, depth, false));
		    },
	
		    get: function(index, notSetValue) {
		      index = wrapIndex(this, index);
		      return (index < 0 || (this.size === Infinity ||
		          (this.size !== undefined && index > this.size))) ?
		        notSetValue :
		        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
		    },
	
		    has: function(index) {
		      index = wrapIndex(this, index);
		      return index >= 0 && (this.size !== undefined ?
		        this.size === Infinity || index < this.size :
		        this.indexOf(index) !== -1
		      );
		    },
	
		    interpose: function(separator) {
		      return reify(this, interposeFactory(this, separator));
		    },
	
		    interleave: function(/*...iterables*/) {
		      var iterables = [this].concat(arrCopy(arguments));
		      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
		      var interleaved = zipped.flatten(true);
		      if (zipped.size) {
		        interleaved.size = zipped.size * iterables.length;
		      }
		      return reify(this, interleaved);
		    },
	
		    keySeq: function() {
		      return Range(0, this.size);
		    },
	
		    last: function() {
		      return this.get(-1);
		    },
	
		    skipWhile: function(predicate, context) {
		      return reify(this, skipWhileFactory(this, predicate, context, false));
		    },
	
		    zip: function(/*, ...iterables */) {
		      var iterables = [this].concat(arrCopy(arguments));
		      return reify(this, zipWithFactory(this, defaultZipper, iterables));
		    },
	
		    zipWith: function(zipper/*, ...iterables */) {
		      var iterables = arrCopy(arguments);
		      iterables[0] = this;
		      return reify(this, zipWithFactory(this, zipper, iterables));
		    }
	
		  });
	
		  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
		  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
		  mixin(SetIterable, {
	
		    // ### ES6 Collection methods (ES6 Array and Map)
	
		    get: function(value, notSetValue) {
		      return this.has(value) ? value : notSetValue;
		    },
	
		    includes: function(value) {
		      return this.has(value);
		    },
	
	
		    // ### More sequential methods
	
		    keySeq: function() {
		      return this.valueSeq();
		    }
	
		  });
	
		  SetIterable.prototype.has = IterablePrototype.includes;
		  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
		  // Mixin subclasses
	
		  mixin(KeyedSeq, KeyedIterable.prototype);
		  mixin(IndexedSeq, IndexedIterable.prototype);
		  mixin(SetSeq, SetIterable.prototype);
	
		  mixin(KeyedCollection, KeyedIterable.prototype);
		  mixin(IndexedCollection, IndexedIterable.prototype);
		  mixin(SetCollection, SetIterable.prototype);
	
	
		  // #pragma Helper functions
	
		  function keyMapper(v, k) {
		    return k;
		  }
	
		  function entryMapper(v, k) {
		    return [k, v];
		  }
	
		  function not(predicate) {
		    return function() {
		      return !predicate.apply(this, arguments);
		    }
		  }
	
		  function neg(predicate) {
		    return function() {
		      return -predicate.apply(this, arguments);
		    }
		  }
	
		  function quoteString(value) {
		    return typeof value === 'string' ? JSON.stringify(value) : String(value);
		  }
	
		  function defaultZipper() {
		    return arrCopy(arguments);
		  }
	
		  function defaultNegComparator(a, b) {
		    return a < b ? 1 : a > b ? -1 : 0;
		  }
	
		  function hashIterable(iterable) {
		    if (iterable.size === Infinity) {
		      return 0;
		    }
		    var ordered = isOrdered(iterable);
		    var keyed = isKeyed(iterable);
		    var h = ordered ? 1 : 0;
		    var size = iterable.__iterate(
		      keyed ?
		        ordered ?
		          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
		          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
		        ordered ?
		          function(v ) { h = 31 * h + hash(v) | 0; } :
		          function(v ) { h = h + hash(v) | 0; }
		    );
		    return murmurHashOfSize(size, h);
		  }
	
		  function murmurHashOfSize(size, h) {
		    h = imul(h, 0xCC9E2D51);
		    h = imul(h << 15 | h >>> -15, 0x1B873593);
		    h = imul(h << 13 | h >>> -13, 5);
		    h = (h + 0xE6546B64 | 0) ^ size;
		    h = imul(h ^ h >>> 16, 0x85EBCA6B);
		    h = imul(h ^ h >>> 13, 0xC2B2AE35);
		    h = smi(h ^ h >>> 16);
		    return h;
		  }
	
		  function hashMerge(a, b) {
		    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
		  }
	
		  var Immutable = {
	
		    Iterable: Iterable,
	
		    Seq: Seq,
		    Collection: Collection,
		    Map: Map,
		    OrderedMap: OrderedMap,
		    List: List,
		    Stack: Stack,
		    Set: Set,
		    OrderedSet: OrderedSet,
	
		    Record: Record,
		    Range: Range,
		    Repeat: Repeat,
	
		    is: is,
		    fromJS: fromJS
	
		  };
	
		  return Immutable;
	
		}));
	
	/***/ },
	/* 25 */,
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(195);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-core.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-core.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(197);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-row.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-row.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 28 */,
	/* 29 */,
	/* 30 */,
	/* 31 */,
	/* 32 */,
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var shallowCloneObject = __webpack_require__(36);
		var sameColumn = __webpack_require__(161);
		var ColumnUtils = __webpack_require__(10);
		var getScrollbarSize = __webpack_require__(35);
		var isColumnsImmutable = __webpack_require__(68);
	
		function setColumnWidths(columns, totalWidth) {
		  return columns.map(function (column) {
		    var colInfo = Object.assign({}, column);
		    if (column.width) {
		      if (/^([0-9]+)%$/.exec(column.width.toString())) {
		        colInfo.width = Math.floor(column.width / 100 * totalWidth);
		      }
		    }
		    return colInfo;
		  });
		}
	
		function setDefferedColumnWidths(columns, unallocatedWidth, minColumnWidth) {
		  var defferedColumns = columns.filter(function (c) {
		    return !c.width;
		  });
		  return columns.map(function (column) {
		    if (!column.width) {
		      if (unallocatedWidth <= 0) {
		        column.width = minColumnWidth;
		      } else {
		        column.width = Math.floor(unallocatedWidth / ColumnUtils.getSize(defferedColumns));
		      }
		    }
		    return column;
		  });
		}
	
		function setColumnOffsets(columns) {
		  var left = 0;
		  return columns.map(function (column) {
		    column.left = left;
		    left += column.width;
		    return column;
		  });
		}
	
		/**
		 * Update column metrics calculation.
		 *
		 * @param {ColumnMetricsType} metrics
		 */
		function recalculate(metrics) {
		  // compute width for columns which specify width
		  var columns = setColumnWidths(metrics.columns, metrics.totalWidth);
	
		  var unallocatedWidth = columns.filter(function (c) {
		    return c.width;
		  }).reduce(function (w, column) {
		    return w - column.width;
		  }, metrics.totalWidth);
		  unallocatedWidth -= getScrollbarSize();
	
		  var width = columns.filter(function (c) {
		    return c.width;
		  }).reduce(function (w, column) {
		    return w + column.width;
		  }, 0);
	
		  // compute width for columns which doesn't specify width
		  columns = setDefferedColumnWidths(columns, unallocatedWidth, metrics.minColumnWidth);
	
		  // compute left offset
		  columns = setColumnOffsets(columns);
	
		  return {
		    columns: columns,
		    width: width,
		    totalWidth: metrics.totalWidth,
		    minColumnWidth: metrics.minColumnWidth
		  };
		}
	
		/**
		 * Update column metrics calculation by resizing a column.
		 *
		 * @param {ColumnMetricsType} metrics
		 * @param {Column} column
		 * @param {number} width
		 */
		function resizeColumn(metrics, index, width) {
		  var column = ColumnUtils.getColumn(metrics.columns, index);
		  var metricsClone = shallowCloneObject(metrics);
		  metricsClone.columns = metrics.columns.slice(0);
	
		  var updatedColumn = shallowCloneObject(column);
		  updatedColumn.width = Math.max(width, metricsClone.minColumnWidth);
	
		  metricsClone = ColumnUtils.spliceColumn(metricsClone, index, updatedColumn);
	
		  return recalculate(metricsClone);
		}
	
		function areColumnsImmutable(prevColumns, nextColumns) {
		  return isColumnsImmutable(prevColumns) && isColumnsImmutable(nextColumns);
		}
	
		function compareEachColumn(prevColumns, nextColumns, isSameColumn) {
		  var i = void 0;
		  var len = void 0;
		  var column = void 0;
		  var prevColumnsByKey = {};
		  var nextColumnsByKey = {};
	
		  if (ColumnUtils.getSize(prevColumns) !== ColumnUtils.getSize(nextColumns)) {
		    return false;
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
		    column = prevColumns[i];
		    prevColumnsByKey[column.key] = column;
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(nextColumns); i < len; i++) {
		    column = nextColumns[i];
		    nextColumnsByKey[column.key] = column;
		    var prevColumn = prevColumnsByKey[column.key];
		    if (prevColumn === undefined || !isSameColumn(prevColumn, column)) {
		      return false;
		    }
		  }
	
		  for (i = 0, len = ColumnUtils.getSize(prevColumns); i < len; i++) {
		    column = prevColumns[i];
		    var nextColumn = nextColumnsByKey[column.key];
		    if (nextColumn === undefined) {
		      return false;
		    }
		  }
		  return true;
		}
	
		function sameColumns(prevColumns, nextColumns, isSameColumn) {
		  if (areColumnsImmutable(prevColumns, nextColumns)) {
		    return prevColumns === nextColumns;
		  }
	
		  return compareEachColumn(prevColumns, nextColumns, isSameColumn);
		}
	
		module.exports = { recalculate: recalculate, resizeColumn: resizeColumn, sameColumn: sameColumn, sameColumns: sameColumns };
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _OverflowCell = __webpack_require__(170);
	
		var _OverflowCell2 = _interopRequireDefault(_OverflowCell);
	
		var _RowComparer = __webpack_require__(62);
	
		var _RowComparer2 = _interopRequireDefault(_RowComparer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var Cell = __webpack_require__(59);
		var ColumnUtilsMixin = __webpack_require__(10);
		var cellMetaDataShape = __webpack_require__(14);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(27);
	
		var CellExpander = React.createClass({
		  displayName: 'CellExpander',
		  render: function render() {
		    return React.createElement(Cell, this.props);
		  }
		});
	
		// The list of the propTypes that we want to include in the Row div
		var knownDivPropertyKeys = ['height'];
	
		var Row = React.createClass({
		  displayName: 'Row',
	
	
		  propTypes: {
		    height: PropTypes.number.isRequired,
		    columns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
		    row: PropTypes.any.isRequired,
		    cellRenderer: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    isSelected: PropTypes.bool,
		    idx: PropTypes.number.isRequired,
		    expandedRows: PropTypes.arrayOf(PropTypes.object),
		    extraClasses: PropTypes.string,
		    forceUpdate: PropTypes.bool,
		    subRowDetails: PropTypes.object,
		    isRowHovered: PropTypes.bool,
		    colVisibleStart: PropTypes.number.isRequired,
		    colVisibleEnd: PropTypes.number.isRequired,
		    colDisplayStart: PropTypes.number.isRequired,
		    colDisplayEnd: PropTypes.number.isRequired,
		    isScrolling: React.PropTypes.bool.isRequired
		  },
	
		  mixins: [ColumnUtilsMixin],
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      cellRenderer: Cell,
		      isSelected: false,
		      height: 35
		    };
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return (0, _RowComparer2['default'])(nextProps, this.props);
		  },
		  handleDragEnter: function handleDragEnter() {
		    var handleDragEnterRow = this.props.cellMetaData.handleDragEnterRow;
		    if (handleDragEnterRow) {
		      handleDragEnterRow(this.props.idx);
		    }
		  },
		  getSelectedColumn: function getSelectedColumn() {
		    if (this.props.cellMetaData) {
		      var selected = this.props.cellMetaData.selected;
		      if (selected && selected.idx) {
		        return this.getColumn(this.props.columns, selected.idx);
		      }
		    }
		  },
		  getCellRenderer: function getCellRenderer(columnKey) {
		    var CellRenderer = this.props.cellRenderer;
		    if (this.props.subRowDetails && this.props.subRowDetails.field === columnKey) {
		      return CellExpander;
		    }
		    return CellRenderer;
		  },
		  getCell: function getCell(column, i, selectedColumn) {
		    var _this = this;
	
		    var CellRenderer = this.props.cellRenderer;
		    var _props = this.props,
		        colVisibleStart = _props.colVisibleStart,
		        colVisibleEnd = _props.colVisibleEnd,
		        idx = _props.idx,
		        cellMetaData = _props.cellMetaData;
		    var key = column.key,
		        formatter = column.formatter,
		        locked = column.locked;
	
		    var baseCellProps = { key: key + '-' + idx, idx: i, rowIdx: idx, height: this.getRowHeight(), column: column, cellMetaData: cellMetaData };
	
		    if ((i < colVisibleStart || i > colVisibleEnd) && !locked) {
		      return React.createElement(_OverflowCell2['default'], _extends({ ref: function ref(node) {
		          return _this.key = node;
		        } }, baseCellProps));
		    }
	
		    var _props2 = this.props,
		        row = _props2.row,
		        isSelected = _props2.isSelected;
	
		    var cellProps = {
		      ref: function ref(node) {
		        return _this.key = node;
		      },
		      value: this.getCellValue(key || i),
		      rowData: row,
		      isRowSelected: isSelected,
		      expandableOptions: this.getExpandableOptions(key),
		      selectedColumn: selectedColumn,
		      formatter: formatter,
		      isScrolling: this.props.isScrolling
		    };
	
		    return React.createElement(CellRenderer, _extends({}, baseCellProps, cellProps));
		  },
		  getCells: function getCells() {
		    var _this2 = this;
	
		    var cells = [];
		    var lockedCells = [];
		    var selectedColumn = this.getSelectedColumn();
		    if (this.props.columns) {
		      this.props.columns.forEach(function (column, i) {
		        var cell = _this2.getCell(column, i, selectedColumn);
		        if (column.locked) {
		          lockedCells.push(cell);
		        } else {
		          cells.push(cell);
		        }
		      });
		    }
	
		    return cells.concat(lockedCells);
		  },
		  getRowHeight: function getRowHeight() {
		    var rows = this.props.expandedRows || null;
		    if (rows && this.props.idx) {
		      var row = rows[this.props.idx] || null;
		      if (row) {
		        return row.height;
		      }
		    }
		    return this.props.height;
		  },
		  getCellValue: function getCellValue(key) {
		    var val = void 0;
		    if (key === 'select-row') {
		      return this.props.isSelected;
		    } else if (typeof this.props.row.get === 'function') {
		      val = this.props.row.get(key);
		    } else {
		      val = this.props.row[key];
		    }
		    return val;
		  },
		  isContextMenuDisplayed: function isContextMenuDisplayed() {
		    if (this.props.cellMetaData) {
		      var selected = this.props.cellMetaData.selected;
		      if (selected && selected.contextMenuDisplayed && selected.rowIdx === this.props.idx) {
		        return true;
		      }
		    }
		    return false;
		  },
		  getExpandableOptions: function getExpandableOptions(columnKey) {
		    return { canExpand: this.props.subRowDetails && this.props.subRowDetails.field === columnKey, expanded: this.props.subRowDetails && this.props.subRowDetails.expanded, children: this.props.subRowDetails && this.props.subRowDetails.children, treeDepth: this.props.subRowDetails ? this.props.subRowDetails.treeDepth : 0 };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var _this3 = this;
	
		    this.props.columns.forEach(function (column) {
		      if (column.locked) {
		        if (!_this3[column.key]) return;
		        _this3[column.key].setScrollLeft(scrollLeft);
		      }
		    });
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  renderCell: function renderCell(props) {
		    if (typeof this.props.cellRenderer === 'function') {
		      this.props.cellRenderer.call(this, props);
		    }
		    if (React.isValidElement(this.props.cellRenderer)) {
		      return React.cloneElement(this.props.cellRenderer, props);
		    }
	
		    return this.props.cellRenderer(props);
		  },
		  render: function render() {
		    var className = joinClasses('react-grid-Row', 'react-grid-Row--' + (this.props.idx % 2 === 0 ? 'even' : 'odd'), {
		      'row-selected': this.props.isSelected,
		      'row-context-menu': this.isContextMenuDisplayed()
		    }, this.props.extraClasses);
	
		    var style = {
		      height: this.getRowHeight(this.props),
		      overflow: 'hidden',
		      contain: 'layout'
		    };
	
		    var cells = this.getCells();
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: className, style: style, onDragEnter: this.handleDragEnter }),
		      React.isValidElement(this.props.row) ? this.props.row : cells
		    );
		  }
		});
	
		module.exports = Row;
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var size = void 0;
	
		function getScrollbarSize() {
		  if (size === undefined) {
		    var outer = document.createElement('div');
		    outer.style.width = '50px';
		    outer.style.height = '50px';
		    outer.style.position = 'absolute';
		    outer.style.top = '-200px';
		    outer.style.left = '-200px';
	
		    var inner = document.createElement('div');
		    inner.style.height = '100px';
		    inner.style.width = '100%';
	
		    outer.appendChild(inner);
		    document.body.appendChild(outer);
	
		    var outerWidth = outer.clientWidth;
		    outer.style.overflowY = 'scroll';
		    var innerWidth = inner.clientWidth;
	
		    document.body.removeChild(outer);
	
		    size = outerWidth - innerWidth;
		  }
	
		  return size;
		}
	
		module.exports = getScrollbarSize;
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		"use strict";
	
		function shallowCloneObject(obj) {
		  var result = {};
		  for (var k in obj) {
		    if (obj.hasOwnProperty(k)) {
		      result[k] = obj[k];
		    }
		  }
		  return result;
		}
	
		module.exports = shallowCloneObject;
	
	/***/ },
	/* 37 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var isFunction = function isFunction(functionToCheck) {
		  var getType = {};
		  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
		};
	
		module.exports = isFunction;
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(193);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-cell.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 39 */,
	/* 40 */,
	/* 41 */,
	/* 42 */,
	/* 43 */,
	/* 44 */,
	/* 45 */,
	/* 46 */,
	/* 47 */,
	/* 48 */,
	/* 49 */,
	/* 50 */,
	/* 51 */,
	/* 52 */,
	/* 53 */,
	/* 54 */,
	/* 55 */,
	/* 56 */,
	/* 57 */,
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keyMirror = __webpack_require__(199);
	
		var _keyMirror2 = _interopRequireDefault(_keyMirror);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var constants = {
		  UpdateActions: (0, _keyMirror2['default'])({
		    CELL_UPDATE: null,
		    COLUMN_FILL: null,
		    COPY_PASTE: null,
		    CELL_DRAG: null
		  }),
		  DragItemTypes: {
		    Column: 'column'
		  }
		};
	
		module.exports = constants;
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _underscore = __webpack_require__(96);
	
		var _underscore2 = _interopRequireDefault(_underscore);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var EditorContainer = __webpack_require__(180);
		var ExcelColumn = __webpack_require__(11);
		var isFunction = __webpack_require__(37);
		var CellMetaDataShape = __webpack_require__(14);
		var SimpleCellFormatter = __webpack_require__(183);
		var ColumnUtils = __webpack_require__(10);
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(38);
	
		// The list of the propTypes that we want to include in the Cell div
		var knownDivPropertyKeys = ['height', 'tabIndex', 'value'];
	
		var Cell = React.createClass({
		  displayName: 'Cell',
	
	
		  propTypes: {
		    rowIdx: React.PropTypes.number.isRequired,
		    idx: React.PropTypes.number.isRequired,
		    selected: React.PropTypes.shape({
		      idx: React.PropTypes.number.isRequired
		    }),
		    selectedColumn: React.PropTypes.object,
		    height: React.PropTypes.number,
		    tabIndex: React.PropTypes.number,
		    column: React.PropTypes.shape(ExcelColumn).isRequired,
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired,
		    isExpanded: React.PropTypes.bool,
		    isRowSelected: React.PropTypes.bool,
		    cellMetaData: React.PropTypes.shape(CellMetaDataShape).isRequired,
		    handleDragStart: React.PropTypes.func,
		    className: React.PropTypes.string,
		    cellControls: React.PropTypes.any,
		    rowData: React.PropTypes.object.isRequired,
		    forceUpdate: React.PropTypes.bool,
		    expandableOptions: React.PropTypes.object.isRequired,
		    isScrolling: React.PropTypes.bool.isRequired,
		    tooltip: React.PropTypes.string,
		    isCellValueChanging: React.PropTypes.func
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      tabIndex: -1,
		      isExpanded: false,
		      value: '',
		      isCellValueChanging: function isCellValueChanging(value, nextValue) {
		        return value !== nextValue;
		      }
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      isCellValueChanging: false
		    };
		  },
		  componentDidMount: function componentDidMount() {
		    this.checkFocus();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    this.setState({
		      isCellValueChanging: this.props.isCellValueChanging(this.props.value, nextProps.value)
		    });
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this.checkFocus();
		    var dragged = this.props.cellMetaData.dragged;
		    if (dragged && dragged.complete === true) {
		      this.props.cellMetaData.handleTerminateDrag();
		    }
		    if (this.state.isCellValueChanging && this.props.selectedColumn != null) {
		      this.applyUpdateClass();
		    }
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    var shouldUpdate = this.props.column.width !== nextProps.column.width || this.props.column.left !== nextProps.column.left || this.props.column.cellClass !== nextProps.column.cellClass || this.props.height !== nextProps.height || this.props.rowIdx !== nextProps.rowIdx || this.isCellSelectionChanging(nextProps) || this.isDraggedCellChanging(nextProps) || this.isCopyCellChanging(nextProps) || this.props.isRowSelected !== nextProps.isRowSelected || this.isSelected() || this.props.isCellValueChanging(this.props.value, nextProps.value) || this.props.forceUpdate === true || this.props.className !== nextProps.className || this.hasChangedDependentValues(nextProps);
		    return shouldUpdate;
		  },
		  onCellClick: function onCellClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
		      meta.onCellClick({ rowIdx: this.props.rowIdx, idx: this.props.idx }, e);
		    }
		  },
		  onCellContextMenu: function onCellContextMenu() {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellContextMenu && typeof meta.onCellContextMenu === 'function') {
		      meta.onCellContextMenu({ rowIdx: this.props.rowIdx, idx: this.props.idx });
		    }
		  },
		  onCellDoubleClick: function onCellDoubleClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellDoubleClick && typeof meta.onCellDoubleClick === 'function') {
		      meta.onCellDoubleClick({ rowIdx: this.props.rowIdx, idx: this.props.idx }, e);
		    }
		  },
		  onCellExpand: function onCellExpand(e) {
		    e.stopPropagation();
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellExpand != null) {
		      meta.onCellExpand({ rowIdx: this.props.rowIdx, idx: this.props.idx, rowData: this.props.rowData, expandArgs: this.props.expandableOptions });
		    }
		  },
		  onCellKeyDown: function onCellKeyDown(e) {
		    if (this.canExpand() && e.key === 'Enter') {
		      this.onCellExpand(e);
		    }
		  },
		  onDragHandleDoubleClick: function onDragHandleDoubleClick(e) {
		    e.stopPropagation();
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onDragHandleDoubleClick && typeof meta.onDragHandleDoubleClick === 'function') {
		      meta.onDragHandleDoubleClick({ rowIdx: this.props.rowIdx, idx: this.props.idx, rowData: this.getRowData(), e: e });
		    }
		  },
		  onDragOver: function onDragOver(e) {
		    e.preventDefault();
		  },
		  getStyle: function getStyle() {
		    var style = {
		      position: 'absolute',
		      width: this.props.column.width,
		      height: this.props.height,
		      left: this.props.column.left,
		      contain: 'layout'
		    };
		    return style;
		  },
		  getFormatter: function getFormatter() {
		    var col = this.props.column;
		    if (this.isActive()) {
		      return React.createElement(EditorContainer, { rowData: this.getRowData(), rowIdx: this.props.rowIdx, value: this.props.value, idx: this.props.idx, cellMetaData: this.props.cellMetaData, column: col, height: this.props.height });
		    }
	
		    return this.props.column.formatter;
		  },
		  getRowData: function getRowData() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
		    return props.rowData.toJSON ? props.rowData.toJSON() : props.rowData;
		  },
		  getFormatterDependencies: function getFormatterDependencies() {
		    // convention based method to get corresponding Id or Name of any Name or Id property
		    if (typeof this.props.column.getRowMetaData === 'function') {
		      return this.props.column.getRowMetaData(this.getRowData(), this.props.column);
		    }
		  },
		  getCellClass: function getCellClass() {
		    var className = joinClasses(this.props.column.cellClass, 'react-grid-Cell', this.props.className, this.props.column.locked ? 'react-grid-Cell--locked' : null);
		    var extraClasses = joinClasses({
		      'row-selected': this.props.isRowSelected,
		      editing: this.isActive(),
		      copied: this.isCopied() || this.wasDraggedOver() || this.isDraggedOverUpwards() || this.isDraggedOverDownwards(),
		      'is-dragged-over-up': this.isDraggedOverUpwards(),
		      'is-dragged-over-down': this.isDraggedOverDownwards(),
		      'was-dragged-over': this.wasDraggedOver(),
		      'cell-tooltip': this.props.tooltip ? true : false
		    });
		    return joinClasses(className, extraClasses);
		  },
		  getUpdateCellClass: function getUpdateCellClass() {
		    return this.props.column.getUpdateCellClass ? this.props.column.getUpdateCellClass(this.props.selectedColumn, this.props.column, this.state.isCellValueChanging) : '';
		  },
		  isColumnSelected: function isColumnSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.idx === this.props.idx;
		  },
		  isSelected: function isSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.rowIdx === this.props.rowIdx && meta.selected.idx === this.props.idx;
		  },
		  isActive: function isActive() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    return this.isSelected() && meta.selected.active === true;
		  },
		  isCellSelectionChanging: function isCellSelectionChanging(nextProps) {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    var nextSelected = nextProps.cellMetaData.selected;
		    if (meta.selected && nextSelected) {
		      return this.props.idx === nextSelected.idx || this.props.idx === meta.selected.idx;
		    }
	
		    return true;
		  },
		  isCellSelectEnabled: function isCellSelectEnabled() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
		    return meta.enableCellSelect;
		  },
		  hasChangedDependentValues: function hasChangedDependentValues(nextProps) {
		    var currentColumn = this.props.column;
		    var hasChangedDependentValues = false;
	
		    if (currentColumn.getRowMetaData) {
		      var currentRowMetaData = currentColumn.getRowMetaData(this.getRowData(), currentColumn);
		      var nextColumn = nextProps.column;
		      var nextRowMetaData = nextColumn.getRowMetaData(this.getRowData(nextProps), nextColumn);
	
		      hasChangedDependentValues = !_underscore2['default'].isEqual(currentRowMetaData, nextRowMetaData);
		    }
	
		    return hasChangedDependentValues;
		  },
		  applyUpdateClass: function applyUpdateClass() {
		    var updateCellClass = this.getUpdateCellClass();
		    // -> removing the class
		    if (updateCellClass != null && updateCellClass !== '') {
		      var cellDOMNode = ReactDOM.findDOMNode(this);
		      if (cellDOMNode.classList) {
		        cellDOMNode.classList.remove(updateCellClass);
		        // -> and re-adding the class
		        cellDOMNode.classList.add(updateCellClass);
		      } else if (cellDOMNode.className.indexOf(updateCellClass) === -1) {
		        // IE9 doesn't support classList, nor (I think) altering element.className
		        // without replacing it wholesale.
		        cellDOMNode.className = cellDOMNode.className + ' ' + updateCellClass;
		      }
		    }
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var ctrl = this; // flow on windows has an outdated react declaration, once that gets updated, we can remove this
		    if (ctrl.isMounted()) {
		      var node = ReactDOM.findDOMNode(this);
		      var transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		      node.style.webkitTransform = transform;
		      node.style.transform = transform;
		    }
		  },
		  isCopied: function isCopied() {
		    var copied = this.props.cellMetaData.copied;
		    return copied && copied.rowIdx === this.props.rowIdx && copied.idx === this.props.idx;
		  },
		  isDraggedOver: function isDraggedOver() {
		    var dragged = this.props.cellMetaData.dragged;
		    return dragged && dragged.overRowIdx === this.props.rowIdx && dragged.idx === this.props.idx;
		  },
		  wasDraggedOver: function wasDraggedOver() {
		    var dragged = this.props.cellMetaData.dragged;
		    return dragged && (dragged.overRowIdx < this.props.rowIdx && this.props.rowIdx < dragged.rowIdx || dragged.overRowIdx > this.props.rowIdx && this.props.rowIdx > dragged.rowIdx) && dragged.idx === this.props.idx;
		  },
		  isDraggedCellChanging: function isDraggedCellChanging(nextProps) {
		    var isChanging = void 0;
		    var dragged = this.props.cellMetaData.dragged;
		    var nextDragged = nextProps.cellMetaData.dragged;
		    if (dragged) {
		      isChanging = nextDragged && this.props.idx === nextDragged.idx || dragged && this.props.idx === dragged.idx;
		      return isChanging;
		    }
	
		    return false;
		  },
		  isCopyCellChanging: function isCopyCellChanging(nextProps) {
		    var isChanging = void 0;
		    var copied = this.props.cellMetaData.copied;
		    var nextCopied = nextProps.cellMetaData.copied;
		    if (copied) {
		      isChanging = nextCopied && this.props.idx === nextCopied.idx || copied && this.props.idx === copied.idx;
		      return isChanging;
		    }
		    return false;
		  },
		  isDraggedOverUpwards: function isDraggedOverUpwards() {
		    var dragged = this.props.cellMetaData.dragged;
		    return !this.isSelected() && this.isDraggedOver() && this.props.rowIdx < dragged.rowIdx;
		  },
		  isDraggedOverDownwards: function isDraggedOverDownwards() {
		    var dragged = this.props.cellMetaData.dragged;
		    return !this.isSelected() && this.isDraggedOver() && this.props.rowIdx > dragged.rowIdx;
		  },
		  isFocusedOnBody: function isFocusedOnBody() {
		    return document.activeElement == null || document.activeElement.nodeName && typeof document.activeElement.nodeName === 'string' && document.activeElement.nodeName.toLowerCase() === 'body';
		  },
		  isFocusedOnCell: function isFocusedOnCell() {
		    return document.activeElement && document.activeElement.className === 'react-grid-Cell';
		  },
		  checkFocus: function checkFocus() {
		    if (this.isSelected() && !this.isActive()) {
		      if (this.props.isScrolling && !this.props.cellMetaData.isScrollingVerticallyWithKeyboard && !this.props.cellMetaData.isScrollingHorizontallyWithKeyboard) {
		        return;
		      }
		      // Only focus to the current cell if the currently active node in the document is within the data grid.
		      // Meaning focus should not be stolen from elements that the grid doesnt control.
		      var dataGridDOMNode = this.props.cellMetaData && this.props.cellMetaData.getDataGridDOMNode ? this.props.cellMetaData.getDataGridDOMNode() : null;
		      if (this.isFocusedOnCell() || this.isFocusedOnBody() || dataGridDOMNode && dataGridDOMNode.contains(document.activeElement)) {
		        var cellDOMNode = ReactDOM.findDOMNode(this);
		        if (cellDOMNode) {
		          cellDOMNode.focus();
		        }
		      }
		    }
		  },
		  canEdit: function canEdit() {
		    return this.props.column.editor != null || this.props.column.editable;
		  },
		  canExpand: function canExpand() {
		    return this.props.expandableOptions && this.props.expandableOptions.canExpand;
		  },
		  createColumEventCallBack: function createColumEventCallBack(onColumnEvent, info) {
		    return function (e) {
		      onColumnEvent(e, info);
		    };
		  },
		  createCellEventCallBack: function createCellEventCallBack(gridEvent, columnEvent) {
		    return function (e) {
		      gridEvent(e);
		      columnEvent(e);
		    };
		  },
		  createEventDTO: function createEventDTO(gridEvents, columnEvents, onColumnEvent) {
		    var allEvents = Object.assign({}, gridEvents);
	
		    for (var eventKey in columnEvents) {
		      if (columnEvents.hasOwnProperty(eventKey)) {
		        var event = columnEvents[event];
		        var eventInfo = { rowIdx: this.props.rowIdx, idx: this.props.idx, name: eventKey };
		        var eventCallback = this.createColumEventCallBack(onColumnEvent, eventInfo);
	
		        if (allEvents.hasOwnProperty(eventKey)) {
		          var currentEvent = allEvents[eventKey];
		          allEvents[eventKey] = this.createCellEventCallBack(currentEvent, eventCallback);
		        } else {
		          allEvents[eventKey] = eventCallback;
		        }
		      }
		    }
	
		    return allEvents;
		  },
		  getEvents: function getEvents() {
		    var columnEvents = this.props.column ? Object.assign({}, this.props.column.events) : undefined;
		    var onColumnEvent = this.props.cellMetaData ? this.props.cellMetaData.onColumnEvent : undefined;
		    var gridEvents = {
		      onClick: this.onCellClick,
		      onDoubleClick: this.onCellDoubleClick,
		      onContextMenu: this.onCellContextMenu,
		      onDragOver: this.onDragOver
		    };
	
		    if (!columnEvents || !onColumnEvent) {
		      return gridEvents;
		    }
	
		    return this.createEventDTO(gridEvents, columnEvents, onColumnEvent);
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  renderCellContent: function renderCellContent(props) {
		    var CellContent = void 0;
		    var Formatter = this.getFormatter();
		    if (React.isValidElement(Formatter)) {
		      props.dependentValues = this.getFormatterDependencies();
		      CellContent = React.cloneElement(Formatter, props);
		    } else if (isFunction(Formatter)) {
		      CellContent = React.createElement(Formatter, { value: this.props.value, dependentValues: this.getFormatterDependencies() });
		    } else {
		      CellContent = React.createElement(SimpleCellFormatter, { value: this.props.value });
		    }
		    var cellExpander = void 0;
		    var marginLeft = this.props.expandableOptions ? this.props.expandableOptions.treeDepth * 30 : 0;
		    if (this.canExpand()) {
		      cellExpander = React.createElement(
		        'span',
		        { style: { float: 'left', marginLeft: marginLeft }, onClick: this.onCellExpand },
		        this.props.expandableOptions.expanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
		      );
		    }
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Cell__value' },
		      cellExpander,
		      React.createElement(
		        'span',
		        null,
		        CellContent
		      ),
		      ' ',
		      this.props.cellControls,
		      ' '
		    );
		  },
		  render: function render() {
		    if (this.props.column.hidden) {
		      return null;
		    }
	
		    var style = this.getStyle();
	
		    var className = this.getCellClass();
	
		    var cellContent = this.renderCellContent({
		      value: this.props.value,
		      column: this.props.column,
		      rowIdx: this.props.rowIdx,
		      isExpanded: this.props.isExpanded
		    });
	
		    var dragHandle = !this.isActive() && ColumnUtils.canEdit(this.props.column, this.props.rowData, this.props.cellMetaData.enableCellSelect) ? React.createElement(
		      'div',
		      { className: 'drag-handle', draggable: 'true', onDoubleClick: this.onDragHandleDoubleClick },
		      React.createElement('span', { style: { display: 'none' } })
		    ) : null;
		    var events = this.getEvents();
		    var tooltip = this.props.tooltip ? React.createElement(
		      'span',
		      { className: 'cell-tooltip-text' },
		      this.props.tooltip
		    ) : null;
	
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: className, style: style }, events),
		      cellContent,
		      dragHandle,
		      tooltip
		    );
		  }
		});
	
		module.exports = Cell;
	
	/***/ },
	/* 60 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var ExcelColumn = __webpack_require__(11);
		var ResizeHandle = __webpack_require__(173);
		__webpack_require__(18);
	
		var PropTypes = React.PropTypes;
	
		function simpleCellRenderer(objArgs) {
		  var headerText = objArgs.column.rowType === 'header' ? objArgs.column.name : '';
		  return React.createElement(
		    'div',
		    { className: 'widget-HeaderCell__value' },
		    headerText
		  );
		}
	
		var HeaderCell = React.createClass({
		  displayName: 'HeaderCell',
	
	
		  propTypes: {
		    renderer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
		    column: PropTypes.shape(ExcelColumn).isRequired,
		    onResize: PropTypes.func.isRequired,
		    height: PropTypes.number.isRequired,
		    onResizeEnd: PropTypes.func.isRequired,
		    className: PropTypes.string
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      renderer: simpleCellRenderer
		    };
		  },
		  getInitialState: function getInitialState() {
		    return { resizing: false };
		  },
		  onDragStart: function onDragStart(e) {
		    this.setState({ resizing: true });
		    // need to set dummy data for FF
		    if (e && e.dataTransfer && e.dataTransfer.setData) e.dataTransfer.setData('text/plain', 'dummy');
		  },
		  onDrag: function onDrag(e) {
		    var resize = this.props.onResize || null; // for flows sake, doesnt recognise a null check direct
		    if (resize) {
		      var _width = this.getWidthFromMouseEvent(e);
		      if (_width > 0) {
		        resize(this.props.column, _width);
		      }
		    }
		  },
		  onDragEnd: function onDragEnd(e) {
		    var width = this.getWidthFromMouseEvent(e);
		    this.props.onResizeEnd(this.props.column, width);
		    this.setState({ resizing: false });
		  },
		  getWidthFromMouseEvent: function getWidthFromMouseEvent(e) {
		    var right = e.pageX || e.touches && e.touches[0] && e.touches[0].pageX || e.changedTouches && e.changedTouches[e.changedTouches.length - 1].pageX;
		    var left = ReactDOM.findDOMNode(this).getBoundingClientRect().left;
		    return right - left;
		  },
		  getCell: function getCell() {
		    if (React.isValidElement(this.props.renderer)) {
		      // if it is a string, it's an HTML element, and column is not a valid property, so only pass height
		      if (typeof this.props.renderer.type === 'string') {
		        return React.cloneElement(this.props.renderer, { height: this.props.height });
		      }
		      return React.cloneElement(this.props.renderer, { column: this.props.column, height: this.props.height });
		    }
		    return this.props.renderer({ column: this.props.column });
		  },
		  getStyle: function getStyle() {
		    return {
		      width: this.props.column.width,
		      left: this.props.column.left,
		      display: 'inline-block',
		      position: 'absolute',
		      height: this.props.height,
		      margin: 0,
		      textOverflow: 'ellipsis',
		      whiteSpace: 'nowrap'
		    };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this);
		    node.style.webkitTransform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		    node.style.transform = 'translate3d(' + scrollLeft + 'px, 0px, 0px)';
		  },
		  render: function render() {
		    var resizeHandle = void 0;
		    if (this.props.column.resizable) {
		      resizeHandle = React.createElement(ResizeHandle, {
		        onDrag: this.onDrag,
		        onDragStart: this.onDragStart,
		        onDragEnd: this.onDragEnd
		      });
		    }
		    var className = joinClasses({
		      'react-grid-HeaderCell': true,
		      'react-grid-HeaderCell--resizing': this.state.resizing,
		      'react-grid-HeaderCell--locked': this.props.column.locked
		    });
		    className = joinClasses(className, this.props.className, this.props.column.cellClass);
		    var cell = this.getCell();
		    return React.createElement(
		      'div',
		      { className: className, style: this.getStyle() },
		      cell,
		      resizeHandle
		    );
		  }
		});
	
		module.exports = HeaderCell;
	
	/***/ },
	/* 61 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var KeyboardHandlerMixin = {
		  onKeyDown: function onKeyDown(e) {
		    if (this.isCtrlKeyHeldDown(e)) {
		      this.checkAndCall('onPressKeyWithCtrl', e);
		    } else if (this.isKeyExplicitlyHandled(e.key)) {
		      // break up individual keyPress events to have their own specific callbacks
		      // this allows multiple mixins to listen to onKeyDown events and somewhat reduces methodName clashing
		      var callBack = 'onPress' + e.key;
		      this.checkAndCall(callBack, e);
		    } else if (this.isKeyPrintable(e.keyCode)) {
		      this.checkAndCall('onPressChar', e);
		    }
	
		    // Track which keys are currently down for shift clicking etc
		    this._keysDown = this._keysDown || {};
		    this._keysDown[e.keyCode] = true;
		    if (this.props.onGridKeyDown && typeof this.props.onGridKeyDown === 'function') {
		      this.props.onGridKeyDown(e);
		    }
		  },
		  onKeyUp: function onKeyUp(e) {
		    // Track which keys are currently down for shift clicking etc
		    this._keysDown = this._keysDown || {};
		    delete this._keysDown[e.keyCode];
	
		    if (this.props.onGridKeyUp && typeof this.props.onGridKeyUp === 'function') {
		      this.props.onGridKeyUp(e);
		    }
		  },
		  isKeyDown: function isKeyDown(keyCode) {
		    if (!this._keysDown) return false;
		    return keyCode in this._keysDown;
		  },
		  isSingleKeyDown: function isSingleKeyDown(keyCode) {
		    if (!this._keysDown) return false;
		    return keyCode in this._keysDown && Object.keys(this._keysDown).length === 1;
		  },
	
	
		  // taken from http://stackoverflow.com/questions/12467240/determine-if-javascript-e-keycode-is-a-printable-non-control-character
		  isKeyPrintable: function isKeyPrintable(keycode) {
		    var valid = keycode > 47 && keycode < 58 || // number keys
		    keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
		    keycode > 64 && keycode < 91 || // letter keys
		    keycode > 95 && keycode < 112 || // numpad keys
		    keycode > 185 && keycode < 193 || // ;=,-./` (in order)
		    keycode > 218 && keycode < 223; // [\]' (in order)
	
		    return valid;
		  },
		  isKeyExplicitlyHandled: function isKeyExplicitlyHandled(key) {
		    return typeof this['onPress' + key] === 'function';
		  },
		  isCtrlKeyHeldDown: function isCtrlKeyHeldDown(e) {
		    return e.ctrlKey === true && e.key !== 'Control';
		  },
		  checkAndCall: function checkAndCall(methodName, args) {
		    if (typeof this[methodName] === 'function') {
		      this[methodName](args);
		    }
		  }
		};
	
		module.exports = KeyboardHandlerMixin;
	
	/***/ },
	/* 62 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.shouldRowUpdate = undefined;
	
		var _ColumnMetrics = __webpack_require__(33);
	
		var _ColumnMetrics2 = _interopRequireDefault(_ColumnMetrics);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function doesRowContainSelectedCell(props) {
		  var selected = props.cellMetaData.selected;
		  if (selected && selected.rowIdx === props.idx) {
		    return true;
		  }
		  return false;
		}
	
		function willRowBeDraggedOver(props) {
		  var dragged = props.cellMetaData.dragged;
		  return dragged != null && (dragged.rowIdx >= 0 || dragged.complete === true);
		}
	
		function hasRowBeenCopied(props) {
		  var copied = props.cellMetaData.copied;
		  return copied != null && copied.rowIdx === props.idx;
		}
	
		var shouldRowUpdate = exports.shouldRowUpdate = function shouldRowUpdate(nextProps, currentProps) {
		  return !_ColumnMetrics2['default'].sameColumns(currentProps.columns, nextProps.columns, _ColumnMetrics2['default'].sameColumn) || doesRowContainSelectedCell(currentProps) || doesRowContainSelectedCell(nextProps) || willRowBeDraggedOver(nextProps) || nextProps.row !== currentProps.row || currentProps.colDisplayStart !== nextProps.colDisplayStart || currentProps.colDisplayEnd !== nextProps.colDisplayEnd || currentProps.colVisibleStart !== nextProps.colVisibleStart || currentProps.colVisibleEnd !== nextProps.colVisibleEnd || hasRowBeenCopied(currentProps) || currentProps.isSelected !== nextProps.isSelected || nextProps.height !== currentProps.height || currentProps.isOver !== nextProps.isOver || currentProps.canDrop !== nextProps.canDrop || currentProps.forceUpdate === true;
		};
	
		exports['default'] = shouldRowUpdate;
	
	/***/ },
	/* 63 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var RowUtils = {
		  get: function get(row, property) {
		    if (typeof row.get === 'function') {
		      return row.get(property);
		    }
	
		    return row[property];
		  },
		  isRowSelected: function isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx) {
		    if (indexes && Object.prototype.toString.call(indexes) === '[object Array]') {
		      return indexes.indexOf(rowIdx) > -1;
		    } else if (keys && keys.rowKey && keys.values && Object.prototype.toString.call(keys.values) === '[object Array]') {
		      return keys.values.indexOf(rowData[keys.rowKey]) > -1;
		    } else if (isSelectedKey && rowData && typeof isSelectedKey === 'string') {
		      return rowData[isSelectedKey];
		    }
		    return false;
		  }
		};
	
		module.exports = RowUtils;
	
	/***/ },
	/* 64 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.SimpleRowsContainer = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SimpleRowsContainer = function SimpleRowsContainer(props) {
		  return _react2['default'].createElement(
		    'div',
		    { key: 'rows-container', style: { overflow: 'hidden' } },
		    props.rows
		  );
		};
	
		SimpleRowsContainer.propTypes = {
		  width: _react.PropTypes.number,
		  rows: _react.PropTypes.array
		};
	
		var RowsContainer = function (_React$Component) {
		  _inherits(RowsContainer, _React$Component);
	
		  function RowsContainer(props) {
		    _classCallCheck(this, RowsContainer);
	
		    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
		    _this.plugins = props.window ? props.window.ReactDataGridPlugins : window.ReactDataGridPlugins;
		    _this.hasContextMenu = _this.hasContextMenu.bind(_this);
		    _this.renderRowsWithContextMenu = _this.renderRowsWithContextMenu.bind(_this);
		    _this.getContextMenuContainer = _this.getContextMenuContainer.bind(_this);
		    _this.state = { ContextMenuContainer: _this.getContextMenuContainer(props) };
		    return _this;
		  }
	
		  RowsContainer.prototype.getContextMenuContainer = function getContextMenuContainer() {
		    if (this.hasContextMenu()) {
		      if (!this.plugins) {
		        throw new Error('You need to include ReactDataGrid UiPlugins in order to initialise context menu');
		      }
		      return this.plugins.Menu.ContextMenuLayer('reactDataGridContextMenu')(SimpleRowsContainer);
		    }
		  };
	
		  RowsContainer.prototype.hasContextMenu = function hasContextMenu() {
		    return this.props.contextMenu && _react2['default'].isValidElement(this.props.contextMenu);
		  };
	
		  RowsContainer.prototype.renderRowsWithContextMenu = function renderRowsWithContextMenu() {
		    var ContextMenuRowsContainer = this.state.ContextMenuContainer;
		    var newProps = { rowIdx: this.props.rowIdx, idx: this.props.idx };
		    var contextMenu = _react2['default'].cloneElement(this.props.contextMenu, newProps);
		    // Initialise the context menu if it is available
		    return _react2['default'].createElement(
		      'div',
		      null,
		      _react2['default'].createElement(ContextMenuRowsContainer, this.props),
		      contextMenu
		    );
		  };
	
		  RowsContainer.prototype.render = function render() {
		    return this.hasContextMenu() ? this.renderRowsWithContextMenu() : _react2['default'].createElement(SimpleRowsContainer, this.props);
		  };
	
		  return RowsContainer;
		}(_react2['default'].Component);
	
		RowsContainer.propTypes = {
		  contextMenu: _react.PropTypes.element,
		  rowIdx: _react.PropTypes.number,
		  idx: _react.PropTypes.number,
		  window: _react.PropTypes.object
		};
	
		exports['default'] = RowsContainer;
		exports.SimpleRowsContainer = SimpleRowsContainer;
	
	/***/ },
	/* 65 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		__webpack_require__(71);
	
		var CheckboxEditor = React.createClass({
		  displayName: 'CheckboxEditor',
	
	
		  propTypes: {
		    value: React.PropTypes.bool,
		    rowIdx: React.PropTypes.number,
		    column: React.PropTypes.shape({
		      key: React.PropTypes.string,
		      onCellChange: React.PropTypes.func
		    }),
		    dependentValues: React.PropTypes.object
		  },
	
		  handleChange: function handleChange(e) {
		    this.props.column.onCellChange(this.props.rowIdx, this.props.column.key, this.props.dependentValues, e);
		  },
		  render: function render() {
		    var checked = this.props.value != null ? this.props.value : false;
		    var checkboxName = 'checkbox' + this.props.rowIdx;
		    return React.createElement(
		      'div',
		      { className: 'react-grid-checkbox-container', onClick: this.handleChange },
		      React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: checkboxName, checked: checked }),
		      React.createElement('label', { htmlFor: checkboxName, className: 'react-grid-checkbox-label' })
		    );
		  }
		});
	
		module.exports = CheckboxEditor;
	
	/***/ },
	/* 66 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var ExcelColumn = __webpack_require__(11);
	
		var EditorBase = function (_React$Component) {
		  _inherits(EditorBase, _React$Component);
	
		  function EditorBase() {
		    _classCallCheck(this, EditorBase);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  EditorBase.prototype.getStyle = function getStyle() {
		    return {
		      width: '100%'
		    };
		  };
	
		  EditorBase.prototype.getValue = function getValue() {
		    var updated = {};
		    updated[this.props.column.key] = this.getInputNode().value;
		    return updated;
		  };
	
		  EditorBase.prototype.getInputNode = function getInputNode() {
		    var domNode = ReactDOM.findDOMNode(this);
		    if (domNode.tagName === 'INPUT') {
		      return domNode;
		    }
	
		    return domNode.querySelector('input:not([type=hidden])');
		  };
	
		  EditorBase.prototype.inheritContainerStyles = function inheritContainerStyles() {
		    return true;
		  };
	
		  return EditorBase;
		}(React.Component);
	
		EditorBase.propTypes = {
		  onKeyDown: React.PropTypes.func.isRequired,
		  value: React.PropTypes.any.isRequired,
		  onBlur: React.PropTypes.func.isRequired,
		  column: React.PropTypes.shape(ExcelColumn).isRequired,
		  commit: React.PropTypes.func.isRequired
		};
	
		module.exports = EditorBase;
	
	/***/ },
	/* 67 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var React = __webpack_require__(2);
		var EditorBase = __webpack_require__(66);
	
		var SimpleTextEditor = function (_EditorBase) {
		  _inherits(SimpleTextEditor, _EditorBase);
	
		  function SimpleTextEditor() {
		    _classCallCheck(this, SimpleTextEditor);
	
		    return _possibleConstructorReturn(this, _EditorBase.apply(this, arguments));
		  }
	
		  SimpleTextEditor.prototype.render = function render() {
		    var _this2 = this;
	
		    return React.createElement('input', { ref: function ref(node) {
		        return _this2.input = node;
		      }, type: 'text', onBlur: this.props.onBlur, className: 'form-control', defaultValue: this.props.value });
		  };
	
		  return SimpleTextEditor;
		}(EditorBase);
	
		module.exports = SimpleTextEditor;
	
	/***/ },
	/* 68 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = function isColumnsImmutable(columns) {
		  return typeof Immutable !== 'undefined' && columns instanceof Immutable.List;
		};
	
	/***/ },
	/* 69 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule shallowEqual
		 * @typechecks
		 * 
		 */
	
		'use strict';
	
		var hasOwnProperty = Object.prototype.hasOwnProperty;
	
		/**
		 * Performs equality by iterating through keys on an object and returning false
		 * when any key has values which are not strictly equal between the arguments.
		 * Returns true when the values of all keys are strictly equal.
		 */
		function shallowEqual(objA, objB) {
		  if (objA === objB) {
		    return true;
		  }
	
		  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
		    return false;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  var bHasOwnProperty = hasOwnProperty.bind(objB);
		  for (var i = 0; i < keysA.length; i++) {
		    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
		module.exports = shallowEqual;
	
	/***/ },
	/* 70 */
	/***/ function(module, exports) {
	
		'use strict';
	
		function ToObject(val) {
			if (val == null) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		module.exports = Object.assign || function (target, source) {
			var from;
			var keys;
			var to = ToObject(target);
	
			for (var s = 1; s < arguments.length; s++) {
				from = arguments[s];
				keys = Object.keys(Object(from));
	
				for (var i = 0; i < keys.length; i++) {
					to[keys[i]] = from[keys[i]];
				}
			}
	
			return to;
		};
	
	
	/***/ },
	/* 71 */
	/***/ function(module, exports, __webpack_require__) {
	
		// style-loader: Adds some css to the DOM by adding a <style> tag
	
		// load the styles
		var content = __webpack_require__(194);
		if(typeof content === 'string') content = [[module.id, content, '']];
		// add the styles to the DOM
		var update = __webpack_require__(8)(content, {});
		if(content.locals) module.exports = content.locals;
		// Hot Module Replacement
		if(false) {
			// When the styles change, update the <style> tags
			if(!content.locals) {
				module.hot.accept("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css", function() {
					var newContent = require("!!../node_modules/css-loader/index.js!./react-data-grid-checkbox.css");
					if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
					update(newContent);
				});
			}
			// When the module is disposed, remove the <style> tags
			module.hot.dispose(function() { update(); });
		}
	
	/***/ },
	/* 72 */,
	/* 73 */,
	/* 74 */,
	/* 75 */,
	/* 76 */,
	/* 77 */,
	/* 78 */,
	/* 79 */,
	/* 80 */,
	/* 81 */,
	/* 82 */,
	/* 83 */,
	/* 84 */,
	/* 85 */,
	/* 86 */,
	/* 87 */,
	/* 88 */,
	/* 89 */,
	/* 90 */,
	/* 91 */,
	/* 92 */,
	/* 93 */,
	/* 94 */,
	/* 95 */,
	/* 96 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
		//     http://underscorejs.org
		//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
		//     Underscore may be freely distributed under the MIT license.
	
		(function() {
	
		  // Baseline setup
		  // --------------
	
		  // Establish the root object, `window` in the browser, or `exports` on the server.
		  var root = this;
	
		  // Save the previous value of the `_` variable.
		  var previousUnderscore = root._;
	
		  // Save bytes in the minified (but not gzipped) version:
		  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
		  // Create quick reference variables for speed access to core prototypes.
		  var
		    push             = ArrayProto.push,
		    slice            = ArrayProto.slice,
		    toString         = ObjProto.toString,
		    hasOwnProperty   = ObjProto.hasOwnProperty;
	
		  // All **ECMAScript 5** native function implementations that we hope to use
		  // are declared here.
		  var
		    nativeIsArray      = Array.isArray,
		    nativeKeys         = Object.keys,
		    nativeBind         = FuncProto.bind,
		    nativeCreate       = Object.create;
	
		  // Naked function reference for surrogate-prototype-swapping.
		  var Ctor = function(){};
	
		  // Create a safe reference to the Underscore object for use below.
		  var _ = function(obj) {
		    if (obj instanceof _) return obj;
		    if (!(this instanceof _)) return new _(obj);
		    this._wrapped = obj;
		  };
	
		  // Export the Underscore object for **Node.js**, with
		  // backwards-compatibility for the old `require()` API. If we're in
		  // the browser, add `_` as a global object.
		  if (true) {
		    if (typeof module !== 'undefined' && module.exports) {
		      exports = module.exports = _;
		    }
		    exports._ = _;
		  } else {
		    root._ = _;
		  }
	
		  // Current version.
		  _.VERSION = '1.8.3';
	
		  // Internal function that returns an efficient (for current engines) version
		  // of the passed-in callback, to be repeatedly applied in other Underscore
		  // functions.
		  var optimizeCb = function(func, context, argCount) {
		    if (context === void 0) return func;
		    switch (argCount == null ? 3 : argCount) {
		      case 1: return function(value) {
		        return func.call(context, value);
		      };
		      case 2: return function(value, other) {
		        return func.call(context, value, other);
		      };
		      case 3: return function(value, index, collection) {
		        return func.call(context, value, index, collection);
		      };
		      case 4: return function(accumulator, value, index, collection) {
		        return func.call(context, accumulator, value, index, collection);
		      };
		    }
		    return function() {
		      return func.apply(context, arguments);
		    };
		  };
	
		  // A mostly-internal function to generate callbacks that can be applied
		  // to each element in a collection, returning the desired result — either
		  // identity, an arbitrary callback, a property matcher, or a property accessor.
		  var cb = function(value, context, argCount) {
		    if (value == null) return _.identity;
		    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
		    if (_.isObject(value)) return _.matcher(value);
		    return _.property(value);
		  };
		  _.iteratee = function(value, context) {
		    return cb(value, context, Infinity);
		  };
	
		  // An internal function for creating assigner functions.
		  var createAssigner = function(keysFunc, undefinedOnly) {
		    return function(obj) {
		      var length = arguments.length;
		      if (length < 2 || obj == null) return obj;
		      for (var index = 1; index < length; index++) {
		        var source = arguments[index],
		            keys = keysFunc(source),
		            l = keys.length;
		        for (var i = 0; i < l; i++) {
		          var key = keys[i];
		          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
		        }
		      }
		      return obj;
		    };
		  };
	
		  // An internal function for creating a new object that inherits from another.
		  var baseCreate = function(prototype) {
		    if (!_.isObject(prototype)) return {};
		    if (nativeCreate) return nativeCreate(prototype);
		    Ctor.prototype = prototype;
		    var result = new Ctor;
		    Ctor.prototype = null;
		    return result;
		  };
	
		  var property = function(key) {
		    return function(obj) {
		      return obj == null ? void 0 : obj[key];
		    };
		  };
	
		  // Helper for collection methods to determine whether a collection
		  // should be iterated as an array or as an object
		  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
		  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
		  var getLength = property('length');
		  var isArrayLike = function(collection) {
		    var length = getLength(collection);
		    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
		  };
	
		  // Collection Functions
		  // --------------------
	
		  // The cornerstone, an `each` implementation, aka `forEach`.
		  // Handles raw objects in addition to array-likes. Treats all
		  // sparse array-likes as if they were dense.
		  _.each = _.forEach = function(obj, iteratee, context) {
		    iteratee = optimizeCb(iteratee, context);
		    var i, length;
		    if (isArrayLike(obj)) {
		      for (i = 0, length = obj.length; i < length; i++) {
		        iteratee(obj[i], i, obj);
		      }
		    } else {
		      var keys = _.keys(obj);
		      for (i = 0, length = keys.length; i < length; i++) {
		        iteratee(obj[keys[i]], keys[i], obj);
		      }
		    }
		    return obj;
		  };
	
		  // Return the results of applying the iteratee to each element.
		  _.map = _.collect = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length,
		        results = Array(length);
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      results[index] = iteratee(obj[currentKey], currentKey, obj);
		    }
		    return results;
		  };
	
		  // Create a reducing function iterating left or right.
		  function createReduce(dir) {
		    // Optimized iterator function as using arguments.length
		    // in the main function will deoptimize the, see #1991.
		    function iterator(obj, iteratee, memo, keys, index, length) {
		      for (; index >= 0 && index < length; index += dir) {
		        var currentKey = keys ? keys[index] : index;
		        memo = iteratee(memo, obj[currentKey], currentKey, obj);
		      }
		      return memo;
		    }
	
		    return function(obj, iteratee, memo, context) {
		      iteratee = optimizeCb(iteratee, context, 4);
		      var keys = !isArrayLike(obj) && _.keys(obj),
		          length = (keys || obj).length,
		          index = dir > 0 ? 0 : length - 1;
		      // Determine the initial value if none is provided.
		      if (arguments.length < 3) {
		        memo = obj[keys ? keys[index] : index];
		        index += dir;
		      }
		      return iterator(obj, iteratee, memo, keys, index, length);
		    };
		  }
	
		  // **Reduce** builds up a single result from a list of values, aka `inject`,
		  // or `foldl`.
		  _.reduce = _.foldl = _.inject = createReduce(1);
	
		  // The right-associative version of reduce, also known as `foldr`.
		  _.reduceRight = _.foldr = createReduce(-1);
	
		  // Return the first value which passes a truth test. Aliased as `detect`.
		  _.find = _.detect = function(obj, predicate, context) {
		    var key;
		    if (isArrayLike(obj)) {
		      key = _.findIndex(obj, predicate, context);
		    } else {
		      key = _.findKey(obj, predicate, context);
		    }
		    if (key !== void 0 && key !== -1) return obj[key];
		  };
	
		  // Return all the elements that pass a truth test.
		  // Aliased as `select`.
		  _.filter = _.select = function(obj, predicate, context) {
		    var results = [];
		    predicate = cb(predicate, context);
		    _.each(obj, function(value, index, list) {
		      if (predicate(value, index, list)) results.push(value);
		    });
		    return results;
		  };
	
		  // Return all the elements for which a truth test fails.
		  _.reject = function(obj, predicate, context) {
		    return _.filter(obj, _.negate(cb(predicate)), context);
		  };
	
		  // Determine whether all of the elements match a truth test.
		  // Aliased as `all`.
		  _.every = _.all = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length;
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      if (!predicate(obj[currentKey], currentKey, obj)) return false;
		    }
		    return true;
		  };
	
		  // Determine if at least one element in the object matches a truth test.
		  // Aliased as `any`.
		  _.some = _.any = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = !isArrayLike(obj) && _.keys(obj),
		        length = (keys || obj).length;
		    for (var index = 0; index < length; index++) {
		      var currentKey = keys ? keys[index] : index;
		      if (predicate(obj[currentKey], currentKey, obj)) return true;
		    }
		    return false;
		  };
	
		  // Determine if the array or object contains a given item (using `===`).
		  // Aliased as `includes` and `include`.
		  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
		    if (!isArrayLike(obj)) obj = _.values(obj);
		    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
		    return _.indexOf(obj, item, fromIndex) >= 0;
		  };
	
		  // Invoke a method (with arguments) on every item in a collection.
		  _.invoke = function(obj, method) {
		    var args = slice.call(arguments, 2);
		    var isFunc = _.isFunction(method);
		    return _.map(obj, function(value) {
		      var func = isFunc ? method : value[method];
		      return func == null ? func : func.apply(value, args);
		    });
		  };
	
		  // Convenience version of a common use case of `map`: fetching a property.
		  _.pluck = function(obj, key) {
		    return _.map(obj, _.property(key));
		  };
	
		  // Convenience version of a common use case of `filter`: selecting only objects
		  // containing specific `key:value` pairs.
		  _.where = function(obj, attrs) {
		    return _.filter(obj, _.matcher(attrs));
		  };
	
		  // Convenience version of a common use case of `find`: getting the first object
		  // containing specific `key:value` pairs.
		  _.findWhere = function(obj, attrs) {
		    return _.find(obj, _.matcher(attrs));
		  };
	
		  // Return the maximum element (or element-based computation).
		  _.max = function(obj, iteratee, context) {
		    var result = -Infinity, lastComputed = -Infinity,
		        value, computed;
		    if (iteratee == null && obj != null) {
		      obj = isArrayLike(obj) ? obj : _.values(obj);
		      for (var i = 0, length = obj.length; i < length; i++) {
		        value = obj[i];
		        if (value > result) {
		          result = value;
		        }
		      }
		    } else {
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index, list) {
		        computed = iteratee(value, index, list);
		        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
		          result = value;
		          lastComputed = computed;
		        }
		      });
		    }
		    return result;
		  };
	
		  // Return the minimum element (or element-based computation).
		  _.min = function(obj, iteratee, context) {
		    var result = Infinity, lastComputed = Infinity,
		        value, computed;
		    if (iteratee == null && obj != null) {
		      obj = isArrayLike(obj) ? obj : _.values(obj);
		      for (var i = 0, length = obj.length; i < length; i++) {
		        value = obj[i];
		        if (value < result) {
		          result = value;
		        }
		      }
		    } else {
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index, list) {
		        computed = iteratee(value, index, list);
		        if (computed < lastComputed || computed === Infinity && result === Infinity) {
		          result = value;
		          lastComputed = computed;
		        }
		      });
		    }
		    return result;
		  };
	
		  // Shuffle a collection, using the modern version of the
		  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
		  _.shuffle = function(obj) {
		    var set = isArrayLike(obj) ? obj : _.values(obj);
		    var length = set.length;
		    var shuffled = Array(length);
		    for (var index = 0, rand; index < length; index++) {
		      rand = _.random(0, index);
		      if (rand !== index) shuffled[index] = shuffled[rand];
		      shuffled[rand] = set[index];
		    }
		    return shuffled;
		  };
	
		  // Sample **n** random values from a collection.
		  // If **n** is not specified, returns a single random element.
		  // The internal `guard` argument allows it to work with `map`.
		  _.sample = function(obj, n, guard) {
		    if (n == null || guard) {
		      if (!isArrayLike(obj)) obj = _.values(obj);
		      return obj[_.random(obj.length - 1)];
		    }
		    return _.shuffle(obj).slice(0, Math.max(0, n));
		  };
	
		  // Sort the object's values by a criterion produced by an iteratee.
		  _.sortBy = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    return _.pluck(_.map(obj, function(value, index, list) {
		      return {
		        value: value,
		        index: index,
		        criteria: iteratee(value, index, list)
		      };
		    }).sort(function(left, right) {
		      var a = left.criteria;
		      var b = right.criteria;
		      if (a !== b) {
		        if (a > b || a === void 0) return 1;
		        if (a < b || b === void 0) return -1;
		      }
		      return left.index - right.index;
		    }), 'value');
		  };
	
		  // An internal function used for aggregate "group by" operations.
		  var group = function(behavior) {
		    return function(obj, iteratee, context) {
		      var result = {};
		      iteratee = cb(iteratee, context);
		      _.each(obj, function(value, index) {
		        var key = iteratee(value, index, obj);
		        behavior(result, value, key);
		      });
		      return result;
		    };
		  };
	
		  // Groups the object's values by a criterion. Pass either a string attribute
		  // to group by, or a function that returns the criterion.
		  _.groupBy = group(function(result, value, key) {
		    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
		  });
	
		  // Indexes the object's values by a criterion, similar to `groupBy`, but for
		  // when you know that your index values will be unique.
		  _.indexBy = group(function(result, value, key) {
		    result[key] = value;
		  });
	
		  // Counts instances of an object that group by a certain criterion. Pass
		  // either a string attribute to count by, or a function that returns the
		  // criterion.
		  _.countBy = group(function(result, value, key) {
		    if (_.has(result, key)) result[key]++; else result[key] = 1;
		  });
	
		  // Safely create a real, live array from anything iterable.
		  _.toArray = function(obj) {
		    if (!obj) return [];
		    if (_.isArray(obj)) return slice.call(obj);
		    if (isArrayLike(obj)) return _.map(obj, _.identity);
		    return _.values(obj);
		  };
	
		  // Return the number of elements in an object.
		  _.size = function(obj) {
		    if (obj == null) return 0;
		    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
		  };
	
		  // Split a collection into two arrays: one whose elements all satisfy the given
		  // predicate, and one whose elements all do not satisfy the predicate.
		  _.partition = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var pass = [], fail = [];
		    _.each(obj, function(value, key, obj) {
		      (predicate(value, key, obj) ? pass : fail).push(value);
		    });
		    return [pass, fail];
		  };
	
		  // Array Functions
		  // ---------------
	
		  // Get the first element of an array. Passing **n** will return the first N
		  // values in the array. Aliased as `head` and `take`. The **guard** check
		  // allows it to work with `_.map`.
		  _.first = _.head = _.take = function(array, n, guard) {
		    if (array == null) return void 0;
		    if (n == null || guard) return array[0];
		    return _.initial(array, array.length - n);
		  };
	
		  // Returns everything but the last entry of the array. Especially useful on
		  // the arguments object. Passing **n** will return all the values in
		  // the array, excluding the last N.
		  _.initial = function(array, n, guard) {
		    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
		  };
	
		  // Get the last element of an array. Passing **n** will return the last N
		  // values in the array.
		  _.last = function(array, n, guard) {
		    if (array == null) return void 0;
		    if (n == null || guard) return array[array.length - 1];
		    return _.rest(array, Math.max(0, array.length - n));
		  };
	
		  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
		  // Especially useful on the arguments object. Passing an **n** will return
		  // the rest N values in the array.
		  _.rest = _.tail = _.drop = function(array, n, guard) {
		    return slice.call(array, n == null || guard ? 1 : n);
		  };
	
		  // Trim out all falsy values from an array.
		  _.compact = function(array) {
		    return _.filter(array, _.identity);
		  };
	
		  // Internal implementation of a recursive `flatten` function.
		  var flatten = function(input, shallow, strict, startIndex) {
		    var output = [], idx = 0;
		    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
		      var value = input[i];
		      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
		        //flatten current level of array or arguments object
		        if (!shallow) value = flatten(value, shallow, strict);
		        var j = 0, len = value.length;
		        output.length += len;
		        while (j < len) {
		          output[idx++] = value[j++];
		        }
		      } else if (!strict) {
		        output[idx++] = value;
		      }
		    }
		    return output;
		  };
	
		  // Flatten out an array, either recursively (by default), or just one level.
		  _.flatten = function(array, shallow) {
		    return flatten(array, shallow, false);
		  };
	
		  // Return a version of the array that does not contain the specified value(s).
		  _.without = function(array) {
		    return _.difference(array, slice.call(arguments, 1));
		  };
	
		  // Produce a duplicate-free version of the array. If the array has already
		  // been sorted, you have the option of using a faster algorithm.
		  // Aliased as `unique`.
		  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
		    if (!_.isBoolean(isSorted)) {
		      context = iteratee;
		      iteratee = isSorted;
		      isSorted = false;
		    }
		    if (iteratee != null) iteratee = cb(iteratee, context);
		    var result = [];
		    var seen = [];
		    for (var i = 0, length = getLength(array); i < length; i++) {
		      var value = array[i],
		          computed = iteratee ? iteratee(value, i, array) : value;
		      if (isSorted) {
		        if (!i || seen !== computed) result.push(value);
		        seen = computed;
		      } else if (iteratee) {
		        if (!_.contains(seen, computed)) {
		          seen.push(computed);
		          result.push(value);
		        }
		      } else if (!_.contains(result, value)) {
		        result.push(value);
		      }
		    }
		    return result;
		  };
	
		  // Produce an array that contains the union: each distinct element from all of
		  // the passed-in arrays.
		  _.union = function() {
		    return _.uniq(flatten(arguments, true, true));
		  };
	
		  // Produce an array that contains every item shared between all the
		  // passed-in arrays.
		  _.intersection = function(array) {
		    var result = [];
		    var argsLength = arguments.length;
		    for (var i = 0, length = getLength(array); i < length; i++) {
		      var item = array[i];
		      if (_.contains(result, item)) continue;
		      for (var j = 1; j < argsLength; j++) {
		        if (!_.contains(arguments[j], item)) break;
		      }
		      if (j === argsLength) result.push(item);
		    }
		    return result;
		  };
	
		  // Take the difference between one array and a number of other arrays.
		  // Only the elements present in just the first array will remain.
		  _.difference = function(array) {
		    var rest = flatten(arguments, true, true, 1);
		    return _.filter(array, function(value){
		      return !_.contains(rest, value);
		    });
		  };
	
		  // Zip together multiple lists into a single array -- elements that share
		  // an index go together.
		  _.zip = function() {
		    return _.unzip(arguments);
		  };
	
		  // Complement of _.zip. Unzip accepts an array of arrays and groups
		  // each array's elements on shared indices
		  _.unzip = function(array) {
		    var length = array && _.max(array, getLength).length || 0;
		    var result = Array(length);
	
		    for (var index = 0; index < length; index++) {
		      result[index] = _.pluck(array, index);
		    }
		    return result;
		  };
	
		  // Converts lists into objects. Pass either a single array of `[key, value]`
		  // pairs, or two parallel arrays of the same length -- one of keys, and one of
		  // the corresponding values.
		  _.object = function(list, values) {
		    var result = {};
		    for (var i = 0, length = getLength(list); i < length; i++) {
		      if (values) {
		        result[list[i]] = values[i];
		      } else {
		        result[list[i][0]] = list[i][1];
		      }
		    }
		    return result;
		  };
	
		  // Generator function to create the findIndex and findLastIndex functions
		  function createPredicateIndexFinder(dir) {
		    return function(array, predicate, context) {
		      predicate = cb(predicate, context);
		      var length = getLength(array);
		      var index = dir > 0 ? 0 : length - 1;
		      for (; index >= 0 && index < length; index += dir) {
		        if (predicate(array[index], index, array)) return index;
		      }
		      return -1;
		    };
		  }
	
		  // Returns the first index on an array-like that passes a predicate test
		  _.findIndex = createPredicateIndexFinder(1);
		  _.findLastIndex = createPredicateIndexFinder(-1);
	
		  // Use a comparator function to figure out the smallest index at which
		  // an object should be inserted so as to maintain order. Uses binary search.
		  _.sortedIndex = function(array, obj, iteratee, context) {
		    iteratee = cb(iteratee, context, 1);
		    var value = iteratee(obj);
		    var low = 0, high = getLength(array);
		    while (low < high) {
		      var mid = Math.floor((low + high) / 2);
		      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
		    }
		    return low;
		  };
	
		  // Generator function to create the indexOf and lastIndexOf functions
		  function createIndexFinder(dir, predicateFind, sortedIndex) {
		    return function(array, item, idx) {
		      var i = 0, length = getLength(array);
		      if (typeof idx == 'number') {
		        if (dir > 0) {
		            i = idx >= 0 ? idx : Math.max(idx + length, i);
		        } else {
		            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
		        }
		      } else if (sortedIndex && idx && length) {
		        idx = sortedIndex(array, item);
		        return array[idx] === item ? idx : -1;
		      }
		      if (item !== item) {
		        idx = predicateFind(slice.call(array, i, length), _.isNaN);
		        return idx >= 0 ? idx + i : -1;
		      }
		      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
		        if (array[idx] === item) return idx;
		      }
		      return -1;
		    };
		  }
	
		  // Return the position of the first occurrence of an item in an array,
		  // or -1 if the item is not included in the array.
		  // If the array is large and already in sort order, pass `true`
		  // for **isSorted** to use binary search.
		  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
		  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
		  // Generate an integer Array containing an arithmetic progression. A port of
		  // the native Python `range()` function. See
		  // [the Python documentation](http://docs.python.org/library/functions.html#range).
		  _.range = function(start, stop, step) {
		    if (stop == null) {
		      stop = start || 0;
		      start = 0;
		    }
		    step = step || 1;
	
		    var length = Math.max(Math.ceil((stop - start) / step), 0);
		    var range = Array(length);
	
		    for (var idx = 0; idx < length; idx++, start += step) {
		      range[idx] = start;
		    }
	
		    return range;
		  };
	
		  // Function (ahem) Functions
		  // ------------------
	
		  // Determines whether to execute a function as a constructor
		  // or a normal function with the provided arguments
		  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
		    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
		    var self = baseCreate(sourceFunc.prototype);
		    var result = sourceFunc.apply(self, args);
		    if (_.isObject(result)) return result;
		    return self;
		  };
	
		  // Create a function bound to a given object (assigning `this`, and arguments,
		  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
		  // available.
		  _.bind = function(func, context) {
		    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
		    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
		    var args = slice.call(arguments, 2);
		    var bound = function() {
		      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
		    };
		    return bound;
		  };
	
		  // Partially apply a function by creating a version that has had some of its
		  // arguments pre-filled, without changing its dynamic `this` context. _ acts
		  // as a placeholder, allowing any combination of arguments to be pre-filled.
		  _.partial = function(func) {
		    var boundArgs = slice.call(arguments, 1);
		    var bound = function() {
		      var position = 0, length = boundArgs.length;
		      var args = Array(length);
		      for (var i = 0; i < length; i++) {
		        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
		      }
		      while (position < arguments.length) args.push(arguments[position++]);
		      return executeBound(func, bound, this, this, args);
		    };
		    return bound;
		  };
	
		  // Bind a number of an object's methods to that object. Remaining arguments
		  // are the method names to be bound. Useful for ensuring that all callbacks
		  // defined on an object belong to it.
		  _.bindAll = function(obj) {
		    var i, length = arguments.length, key;
		    if (length <= 1) throw new Error('bindAll must be passed function names');
		    for (i = 1; i < length; i++) {
		      key = arguments[i];
		      obj[key] = _.bind(obj[key], obj);
		    }
		    return obj;
		  };
	
		  // Memoize an expensive function by storing its results.
		  _.memoize = function(func, hasher) {
		    var memoize = function(key) {
		      var cache = memoize.cache;
		      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
		      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
		      return cache[address];
		    };
		    memoize.cache = {};
		    return memoize;
		  };
	
		  // Delays a function for the given number of milliseconds, and then calls
		  // it with the arguments supplied.
		  _.delay = function(func, wait) {
		    var args = slice.call(arguments, 2);
		    return setTimeout(function(){
		      return func.apply(null, args);
		    }, wait);
		  };
	
		  // Defers a function, scheduling it to run after the current call stack has
		  // cleared.
		  _.defer = _.partial(_.delay, _, 1);
	
		  // Returns a function, that, when invoked, will only be triggered at most once
		  // during a given window of time. Normally, the throttled function will run
		  // as much as it can, without ever going more than once per `wait` duration;
		  // but if you'd like to disable the execution on the leading edge, pass
		  // `{leading: false}`. To disable execution on the trailing edge, ditto.
		  _.throttle = function(func, wait, options) {
		    var context, args, result;
		    var timeout = null;
		    var previous = 0;
		    if (!options) options = {};
		    var later = function() {
		      previous = options.leading === false ? 0 : _.now();
		      timeout = null;
		      result = func.apply(context, args);
		      if (!timeout) context = args = null;
		    };
		    return function() {
		      var now = _.now();
		      if (!previous && options.leading === false) previous = now;
		      var remaining = wait - (now - previous);
		      context = this;
		      args = arguments;
		      if (remaining <= 0 || remaining > wait) {
		        if (timeout) {
		          clearTimeout(timeout);
		          timeout = null;
		        }
		        previous = now;
		        result = func.apply(context, args);
		        if (!timeout) context = args = null;
		      } else if (!timeout && options.trailing !== false) {
		        timeout = setTimeout(later, remaining);
		      }
		      return result;
		    };
		  };
	
		  // Returns a function, that, as long as it continues to be invoked, will not
		  // be triggered. The function will be called after it stops being called for
		  // N milliseconds. If `immediate` is passed, trigger the function on the
		  // leading edge, instead of the trailing.
		  _.debounce = function(func, wait, immediate) {
		    var timeout, args, context, timestamp, result;
	
		    var later = function() {
		      var last = _.now() - timestamp;
	
		      if (last < wait && last >= 0) {
		        timeout = setTimeout(later, wait - last);
		      } else {
		        timeout = null;
		        if (!immediate) {
		          result = func.apply(context, args);
		          if (!timeout) context = args = null;
		        }
		      }
		    };
	
		    return function() {
		      context = this;
		      args = arguments;
		      timestamp = _.now();
		      var callNow = immediate && !timeout;
		      if (!timeout) timeout = setTimeout(later, wait);
		      if (callNow) {
		        result = func.apply(context, args);
		        context = args = null;
		      }
	
		      return result;
		    };
		  };
	
		  // Returns the first function passed as an argument to the second,
		  // allowing you to adjust arguments, run code before and after, and
		  // conditionally execute the original function.
		  _.wrap = function(func, wrapper) {
		    return _.partial(wrapper, func);
		  };
	
		  // Returns a negated version of the passed-in predicate.
		  _.negate = function(predicate) {
		    return function() {
		      return !predicate.apply(this, arguments);
		    };
		  };
	
		  // Returns a function that is the composition of a list of functions, each
		  // consuming the return value of the function that follows.
		  _.compose = function() {
		    var args = arguments;
		    var start = args.length - 1;
		    return function() {
		      var i = start;
		      var result = args[start].apply(this, arguments);
		      while (i--) result = args[i].call(this, result);
		      return result;
		    };
		  };
	
		  // Returns a function that will only be executed on and after the Nth call.
		  _.after = function(times, func) {
		    return function() {
		      if (--times < 1) {
		        return func.apply(this, arguments);
		      }
		    };
		  };
	
		  // Returns a function that will only be executed up to (but not including) the Nth call.
		  _.before = function(times, func) {
		    var memo;
		    return function() {
		      if (--times > 0) {
		        memo = func.apply(this, arguments);
		      }
		      if (times <= 1) func = null;
		      return memo;
		    };
		  };
	
		  // Returns a function that will be executed at most one time, no matter how
		  // often you call it. Useful for lazy initialization.
		  _.once = _.partial(_.before, 2);
	
		  // Object Functions
		  // ----------------
	
		  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
		  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
		  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
		                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
		  function collectNonEnumProps(obj, keys) {
		    var nonEnumIdx = nonEnumerableProps.length;
		    var constructor = obj.constructor;
		    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
		    // Constructor is a special case.
		    var prop = 'constructor';
		    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
		    while (nonEnumIdx--) {
		      prop = nonEnumerableProps[nonEnumIdx];
		      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
		        keys.push(prop);
		      }
		    }
		  }
	
		  // Retrieve the names of an object's own properties.
		  // Delegates to **ECMAScript 5**'s native `Object.keys`
		  _.keys = function(obj) {
		    if (!_.isObject(obj)) return [];
		    if (nativeKeys) return nativeKeys(obj);
		    var keys = [];
		    for (var key in obj) if (_.has(obj, key)) keys.push(key);
		    // Ahem, IE < 9.
		    if (hasEnumBug) collectNonEnumProps(obj, keys);
		    return keys;
		  };
	
		  // Retrieve all the property names of an object.
		  _.allKeys = function(obj) {
		    if (!_.isObject(obj)) return [];
		    var keys = [];
		    for (var key in obj) keys.push(key);
		    // Ahem, IE < 9.
		    if (hasEnumBug) collectNonEnumProps(obj, keys);
		    return keys;
		  };
	
		  // Retrieve the values of an object's properties.
		  _.values = function(obj) {
		    var keys = _.keys(obj);
		    var length = keys.length;
		    var values = Array(length);
		    for (var i = 0; i < length; i++) {
		      values[i] = obj[keys[i]];
		    }
		    return values;
		  };
	
		  // Returns the results of applying the iteratee to each element of the object
		  // In contrast to _.map it returns an object
		  _.mapObject = function(obj, iteratee, context) {
		    iteratee = cb(iteratee, context);
		    var keys =  _.keys(obj),
		          length = keys.length,
		          results = {},
		          currentKey;
		      for (var index = 0; index < length; index++) {
		        currentKey = keys[index];
		        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
		      }
		      return results;
		  };
	
		  // Convert an object into a list of `[key, value]` pairs.
		  _.pairs = function(obj) {
		    var keys = _.keys(obj);
		    var length = keys.length;
		    var pairs = Array(length);
		    for (var i = 0; i < length; i++) {
		      pairs[i] = [keys[i], obj[keys[i]]];
		    }
		    return pairs;
		  };
	
		  // Invert the keys and values of an object. The values must be serializable.
		  _.invert = function(obj) {
		    var result = {};
		    var keys = _.keys(obj);
		    for (var i = 0, length = keys.length; i < length; i++) {
		      result[obj[keys[i]]] = keys[i];
		    }
		    return result;
		  };
	
		  // Return a sorted list of the function names available on the object.
		  // Aliased as `methods`
		  _.functions = _.methods = function(obj) {
		    var names = [];
		    for (var key in obj) {
		      if (_.isFunction(obj[key])) names.push(key);
		    }
		    return names.sort();
		  };
	
		  // Extend a given object with all the properties in passed-in object(s).
		  _.extend = createAssigner(_.allKeys);
	
		  // Assigns a given object with all the own properties in the passed-in object(s)
		  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
		  _.extendOwn = _.assign = createAssigner(_.keys);
	
		  // Returns the first key on an object that passes a predicate test
		  _.findKey = function(obj, predicate, context) {
		    predicate = cb(predicate, context);
		    var keys = _.keys(obj), key;
		    for (var i = 0, length = keys.length; i < length; i++) {
		      key = keys[i];
		      if (predicate(obj[key], key, obj)) return key;
		    }
		  };
	
		  // Return a copy of the object only containing the whitelisted properties.
		  _.pick = function(object, oiteratee, context) {
		    var result = {}, obj = object, iteratee, keys;
		    if (obj == null) return result;
		    if (_.isFunction(oiteratee)) {
		      keys = _.allKeys(obj);
		      iteratee = optimizeCb(oiteratee, context);
		    } else {
		      keys = flatten(arguments, false, false, 1);
		      iteratee = function(value, key, obj) { return key in obj; };
		      obj = Object(obj);
		    }
		    for (var i = 0, length = keys.length; i < length; i++) {
		      var key = keys[i];
		      var value = obj[key];
		      if (iteratee(value, key, obj)) result[key] = value;
		    }
		    return result;
		  };
	
		   // Return a copy of the object without the blacklisted properties.
		  _.omit = function(obj, iteratee, context) {
		    if (_.isFunction(iteratee)) {
		      iteratee = _.negate(iteratee);
		    } else {
		      var keys = _.map(flatten(arguments, false, false, 1), String);
		      iteratee = function(value, key) {
		        return !_.contains(keys, key);
		      };
		    }
		    return _.pick(obj, iteratee, context);
		  };
	
		  // Fill in a given object with default properties.
		  _.defaults = createAssigner(_.allKeys, true);
	
		  // Creates an object that inherits from the given prototype object.
		  // If additional properties are provided then they will be added to the
		  // created object.
		  _.create = function(prototype, props) {
		    var result = baseCreate(prototype);
		    if (props) _.extendOwn(result, props);
		    return result;
		  };
	
		  // Create a (shallow-cloned) duplicate of an object.
		  _.clone = function(obj) {
		    if (!_.isObject(obj)) return obj;
		    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
		  };
	
		  // Invokes interceptor with the obj, and then returns obj.
		  // The primary purpose of this method is to "tap into" a method chain, in
		  // order to perform operations on intermediate results within the chain.
		  _.tap = function(obj, interceptor) {
		    interceptor(obj);
		    return obj;
		  };
	
		  // Returns whether an object has a given set of `key:value` pairs.
		  _.isMatch = function(object, attrs) {
		    var keys = _.keys(attrs), length = keys.length;
		    if (object == null) return !length;
		    var obj = Object(object);
		    for (var i = 0; i < length; i++) {
		      var key = keys[i];
		      if (attrs[key] !== obj[key] || !(key in obj)) return false;
		    }
		    return true;
		  };
	
	
		  // Internal recursive comparison function for `isEqual`.
		  var eq = function(a, b, aStack, bStack) {
		    // Identical objects are equal. `0 === -0`, but they aren't identical.
		    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
		    if (a === b) return a !== 0 || 1 / a === 1 / b;
		    // A strict comparison is necessary because `null == undefined`.
		    if (a == null || b == null) return a === b;
		    // Unwrap any wrapped objects.
		    if (a instanceof _) a = a._wrapped;
		    if (b instanceof _) b = b._wrapped;
		    // Compare `[[Class]]` names.
		    var className = toString.call(a);
		    if (className !== toString.call(b)) return false;
		    switch (className) {
		      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
		      case '[object RegExp]':
		      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
		      case '[object String]':
		        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
		        // equivalent to `new String("5")`.
		        return '' + a === '' + b;
		      case '[object Number]':
		        // `NaN`s are equivalent, but non-reflexive.
		        // Object(NaN) is equivalent to NaN
		        if (+a !== +a) return +b !== +b;
		        // An `egal` comparison is performed for other numeric values.
		        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
		      case '[object Date]':
		      case '[object Boolean]':
		        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
		        // millisecond representations. Note that invalid dates with millisecond representations
		        // of `NaN` are not equivalent.
		        return +a === +b;
		    }
	
		    var areArrays = className === '[object Array]';
		    if (!areArrays) {
		      if (typeof a != 'object' || typeof b != 'object') return false;
	
		      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
		      // from different frames are.
		      var aCtor = a.constructor, bCtor = b.constructor;
		      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
		                               _.isFunction(bCtor) && bCtor instanceof bCtor)
		                          && ('constructor' in a && 'constructor' in b)) {
		        return false;
		      }
		    }
		    // Assume equality for cyclic structures. The algorithm for detecting cyclic
		    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
		    // Initializing stack of traversed objects.
		    // It's done here since we only need them for objects and arrays comparison.
		    aStack = aStack || [];
		    bStack = bStack || [];
		    var length = aStack.length;
		    while (length--) {
		      // Linear search. Performance is inversely proportional to the number of
		      // unique nested structures.
		      if (aStack[length] === a) return bStack[length] === b;
		    }
	
		    // Add the first object to the stack of traversed objects.
		    aStack.push(a);
		    bStack.push(b);
	
		    // Recursively compare objects and arrays.
		    if (areArrays) {
		      // Compare array lengths to determine if a deep comparison is necessary.
		      length = a.length;
		      if (length !== b.length) return false;
		      // Deep compare the contents, ignoring non-numeric properties.
		      while (length--) {
		        if (!eq(a[length], b[length], aStack, bStack)) return false;
		      }
		    } else {
		      // Deep compare objects.
		      var keys = _.keys(a), key;
		      length = keys.length;
		      // Ensure that both objects contain the same number of properties before comparing deep equality.
		      if (_.keys(b).length !== length) return false;
		      while (length--) {
		        // Deep compare each member
		        key = keys[length];
		        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
		      }
		    }
		    // Remove the first object from the stack of traversed objects.
		    aStack.pop();
		    bStack.pop();
		    return true;
		  };
	
		  // Perform a deep comparison to check if two objects are equal.
		  _.isEqual = function(a, b) {
		    return eq(a, b);
		  };
	
		  // Is a given array, string, or object empty?
		  // An "empty" object has no enumerable own-properties.
		  _.isEmpty = function(obj) {
		    if (obj == null) return true;
		    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
		    return _.keys(obj).length === 0;
		  };
	
		  // Is a given value a DOM element?
		  _.isElement = function(obj) {
		    return !!(obj && obj.nodeType === 1);
		  };
	
		  // Is a given value an array?
		  // Delegates to ECMA5's native Array.isArray
		  _.isArray = nativeIsArray || function(obj) {
		    return toString.call(obj) === '[object Array]';
		  };
	
		  // Is a given variable an object?
		  _.isObject = function(obj) {
		    var type = typeof obj;
		    return type === 'function' || type === 'object' && !!obj;
		  };
	
		  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
		  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
		    _['is' + name] = function(obj) {
		      return toString.call(obj) === '[object ' + name + ']';
		    };
		  });
	
		  // Define a fallback version of the method in browsers (ahem, IE < 9), where
		  // there isn't any inspectable "Arguments" type.
		  if (!_.isArguments(arguments)) {
		    _.isArguments = function(obj) {
		      return _.has(obj, 'callee');
		    };
		  }
	
		  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
		  // IE 11 (#1621), and in Safari 8 (#1929).
		  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
		    _.isFunction = function(obj) {
		      return typeof obj == 'function' || false;
		    };
		  }
	
		  // Is a given object a finite number?
		  _.isFinite = function(obj) {
		    return isFinite(obj) && !isNaN(parseFloat(obj));
		  };
	
		  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
		  _.isNaN = function(obj) {
		    return _.isNumber(obj) && obj !== +obj;
		  };
	
		  // Is a given value a boolean?
		  _.isBoolean = function(obj) {
		    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
		  };
	
		  // Is a given value equal to null?
		  _.isNull = function(obj) {
		    return obj === null;
		  };
	
		  // Is a given variable undefined?
		  _.isUndefined = function(obj) {
		    return obj === void 0;
		  };
	
		  // Shortcut function for checking if an object has a given property directly
		  // on itself (in other words, not on a prototype).
		  _.has = function(obj, key) {
		    return obj != null && hasOwnProperty.call(obj, key);
		  };
	
		  // Utility Functions
		  // -----------------
	
		  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
		  // previous owner. Returns a reference to the Underscore object.
		  _.noConflict = function() {
		    root._ = previousUnderscore;
		    return this;
		  };
	
		  // Keep the identity function around for default iteratees.
		  _.identity = function(value) {
		    return value;
		  };
	
		  // Predicate-generating functions. Often useful outside of Underscore.
		  _.constant = function(value) {
		    return function() {
		      return value;
		    };
		  };
	
		  _.noop = function(){};
	
		  _.property = property;
	
		  // Generates a function for a given object that returns a given property.
		  _.propertyOf = function(obj) {
		    return obj == null ? function(){} : function(key) {
		      return obj[key];
		    };
		  };
	
		  // Returns a predicate for checking whether an object has a given set of
		  // `key:value` pairs.
		  _.matcher = _.matches = function(attrs) {
		    attrs = _.extendOwn({}, attrs);
		    return function(obj) {
		      return _.isMatch(obj, attrs);
		    };
		  };
	
		  // Run a function **n** times.
		  _.times = function(n, iteratee, context) {
		    var accum = Array(Math.max(0, n));
		    iteratee = optimizeCb(iteratee, context, 1);
		    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
		    return accum;
		  };
	
		  // Return a random integer between min and max (inclusive).
		  _.random = function(min, max) {
		    if (max == null) {
		      max = min;
		      min = 0;
		    }
		    return min + Math.floor(Math.random() * (max - min + 1));
		  };
	
		  // A (possibly faster) way to get the current timestamp as an integer.
		  _.now = Date.now || function() {
		    return new Date().getTime();
		  };
	
		   // List of HTML entities for escaping.
		  var escapeMap = {
		    '&': '&amp;',
		    '<': '&lt;',
		    '>': '&gt;',
		    '"': '&quot;',
		    "'": '&#x27;',
		    '`': '&#x60;'
		  };
		  var unescapeMap = _.invert(escapeMap);
	
		  // Functions for escaping and unescaping strings to/from HTML interpolation.
		  var createEscaper = function(map) {
		    var escaper = function(match) {
		      return map[match];
		    };
		    // Regexes for identifying a key that needs to be escaped
		    var source = '(?:' + _.keys(map).join('|') + ')';
		    var testRegexp = RegExp(source);
		    var replaceRegexp = RegExp(source, 'g');
		    return function(string) {
		      string = string == null ? '' : '' + string;
		      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
		    };
		  };
		  _.escape = createEscaper(escapeMap);
		  _.unescape = createEscaper(unescapeMap);
	
		  // If the value of the named `property` is a function then invoke it with the
		  // `object` as context; otherwise, return it.
		  _.result = function(object, property, fallback) {
		    var value = object == null ? void 0 : object[property];
		    if (value === void 0) {
		      value = fallback;
		    }
		    return _.isFunction(value) ? value.call(object) : value;
		  };
	
		  // Generate a unique integer id (unique within the entire client session).
		  // Useful for temporary DOM ids.
		  var idCounter = 0;
		  _.uniqueId = function(prefix) {
		    var id = ++idCounter + '';
		    return prefix ? prefix + id : id;
		  };
	
		  // By default, Underscore uses ERB-style template delimiters, change the
		  // following template settings to use alternative delimiters.
		  _.templateSettings = {
		    evaluate    : /<%([\s\S]+?)%>/g,
		    interpolate : /<%=([\s\S]+?)%>/g,
		    escape      : /<%-([\s\S]+?)%>/g
		  };
	
		  // When customizing `templateSettings`, if you don't want to define an
		  // interpolation, evaluation or escaping regex, we need one that is
		  // guaranteed not to match.
		  var noMatch = /(.)^/;
	
		  // Certain characters need to be escaped so that they can be put into a
		  // string literal.
		  var escapes = {
		    "'":      "'",
		    '\\':     '\\',
		    '\r':     'r',
		    '\n':     'n',
		    '\u2028': 'u2028',
		    '\u2029': 'u2029'
		  };
	
		  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
		  var escapeChar = function(match) {
		    return '\\' + escapes[match];
		  };
	
		  // JavaScript micro-templating, similar to John Resig's implementation.
		  // Underscore templating handles arbitrary delimiters, preserves whitespace,
		  // and correctly escapes quotes within interpolated code.
		  // NB: `oldSettings` only exists for backwards compatibility.
		  _.template = function(text, settings, oldSettings) {
		    if (!settings && oldSettings) settings = oldSettings;
		    settings = _.defaults({}, settings, _.templateSettings);
	
		    // Combine delimiters into one regular expression via alternation.
		    var matcher = RegExp([
		      (settings.escape || noMatch).source,
		      (settings.interpolate || noMatch).source,
		      (settings.evaluate || noMatch).source
		    ].join('|') + '|$', 'g');
	
		    // Compile the template source, escaping string literals appropriately.
		    var index = 0;
		    var source = "__p+='";
		    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
		      source += text.slice(index, offset).replace(escaper, escapeChar);
		      index = offset + match.length;
	
		      if (escape) {
		        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
		      } else if (interpolate) {
		        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
		      } else if (evaluate) {
		        source += "';\n" + evaluate + "\n__p+='";
		      }
	
		      // Adobe VMs need the match returned to produce the correct offest.
		      return match;
		    });
		    source += "';\n";
	
		    // If a variable is not specified, place data values in local scope.
		    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
		    source = "var __t,__p='',__j=Array.prototype.join," +
		      "print=function(){__p+=__j.call(arguments,'');};\n" +
		      source + 'return __p;\n';
	
		    try {
		      var render = new Function(settings.variable || 'obj', '_', source);
		    } catch (e) {
		      e.source = source;
		      throw e;
		    }
	
		    var template = function(data) {
		      return render.call(this, data, _);
		    };
	
		    // Provide the compiled source as a convenience for precompilation.
		    var argument = settings.variable || 'obj';
		    template.source = 'function(' + argument + '){\n' + source + '}';
	
		    return template;
		  };
	
		  // Add a "chain" function. Start chaining a wrapped Underscore object.
		  _.chain = function(obj) {
		    var instance = _(obj);
		    instance._chain = true;
		    return instance;
		  };
	
		  // OOP
		  // ---------------
		  // If Underscore is called as a function, it returns a wrapped object that
		  // can be used OO-style. This wrapper holds altered versions of all the
		  // underscore functions. Wrapped objects may be chained.
	
		  // Helper function to continue chaining intermediate results.
		  var result = function(instance, obj) {
		    return instance._chain ? _(obj).chain() : obj;
		  };
	
		  // Add your own custom functions to the Underscore object.
		  _.mixin = function(obj) {
		    _.each(_.functions(obj), function(name) {
		      var func = _[name] = obj[name];
		      _.prototype[name] = function() {
		        var args = [this._wrapped];
		        push.apply(args, arguments);
		        return result(this, func.apply(_, args));
		      };
		    });
		  };
	
		  // Add all of the Underscore functions to the wrapper object.
		  _.mixin(_);
	
		  // Add all mutator Array functions to the wrapper.
		  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
		    var method = ArrayProto[name];
		    _.prototype[name] = function() {
		      var obj = this._wrapped;
		      method.apply(obj, arguments);
		      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
		      return result(this, obj);
		    };
		  });
	
		  // Add all accessor Array functions to the wrapper.
		  _.each(['concat', 'join', 'slice'], function(name) {
		    var method = ArrayProto[name];
		    _.prototype[name] = function() {
		      return result(this, method.apply(this._wrapped, arguments));
		    };
		  });
	
		  // Extracts the result from a wrapped and chained object.
		  _.prototype.value = function() {
		    return this._wrapped;
		  };
	
		  // Provide unwrapping proxy for some methods used in engine operations
		  // such as arithmetic and JSON stringification.
		  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
		  _.prototype.toString = function() {
		    return '' + this._wrapped;
		  };
	
		  // AMD registration happens at the end for compatibility with AMD loaders
		  // that may not enforce next-turn semantics on modules. Even though general
		  // practice for AMD registration is to be anonymous, underscore registers
		  // as a named module because, like jQuery, it is a base library that is
		  // popular enough to be bundled in a third party lib, but not be part of
		  // an AMD load request. Those cases could generate an error when an
		  // anonymous define() is called outside of a loader request.
		  if (true) {
		    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		      return _;
		    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  }
		}.call(this));
	
	
	/***/ },
	/* 97 */,
	/* 98 */,
	/* 99 */,
	/* 100 */,
	/* 101 */,
	/* 102 */,
	/* 103 */,
	/* 104 */,
	/* 105 */,
	/* 106 */,
	/* 107 */,
	/* 108 */,
	/* 109 */,
	/* 110 */,
	/* 111 */,
	/* 112 */,
	/* 113 */,
	/* 114 */,
	/* 115 */,
	/* 116 */,
	/* 117 */,
	/* 118 */,
	/* 119 */,
	/* 120 */,
	/* 121 */,
	/* 122 */,
	/* 123 */,
	/* 124 */,
	/* 125 */,
	/* 126 */,
	/* 127 */,
	/* 128 */,
	/* 129 */,
	/* 130 */,
	/* 131 */,
	/* 132 */,
	/* 133 */,
	/* 134 */,
	/* 135 */,
	/* 136 */,
	/* 137 */,
	/* 138 */,
	/* 139 */,
	/* 140 */,
	/* 141 */,
	/* 142 */,
	/* 143 */,
	/* 144 */,
	/* 145 */,
	/* 146 */,
	/* 147 */,
	/* 148 */,
	/* 149 */,
	/* 150 */,
	/* 151 */,
	/* 152 */,
	/* 153 */,
	/* 154 */,
	/* 155 */,
	/* 156 */,
	/* 157 */,
	/* 158 */,
	/* 159 */,
	/* 160 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _shallowEqual = __webpack_require__(69);
	
		var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
		var _RowsContainer = __webpack_require__(64);
	
		var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
	
		var _RowGroup = __webpack_require__(174);
	
		var _RowGroup2 = _interopRequireDefault(_RowGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var PropTypes = React.PropTypes;
		var ScrollShim = __webpack_require__(175);
		var Row = __webpack_require__(34);
		var cellMetaDataShape = __webpack_require__(14);
		var RowUtils = __webpack_require__(63);
		__webpack_require__(26);
	
		var Canvas = React.createClass({
		  displayName: 'Canvas',
	
		  mixins: [ScrollShim],
	
		  propTypes: {
		    rowRenderer: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
		    rowHeight: PropTypes.number.isRequired,
		    height: PropTypes.number.isRequired,
		    width: PropTypes.number,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    style: PropTypes.string,
		    className: PropTypes.string,
		    displayStart: PropTypes.number.isRequired,
		    displayEnd: PropTypes.number.isRequired,
		    visibleStart: PropTypes.number.isRequired,
		    visibleEnd: PropTypes.number.isRequired,
		    colVisibleStart: PropTypes.number.isRequired,
		    colVisibleEnd: PropTypes.number.isRequired,
		    colDisplayStart: PropTypes.number.isRequired,
		    colDisplayEnd: PropTypes.number.isRequired,
		    rowsCount: PropTypes.number.isRequired,
		    rowGetter: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.array.isRequired]),
		    expandedRows: PropTypes.array,
		    onRows: PropTypes.func,
		    onScroll: PropTypes.func,
		    columns: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
		    cellMetaData: PropTypes.shape(cellMetaDataShape).isRequired,
		    selectedRows: PropTypes.array,
		    rowKey: React.PropTypes.string,
		    rowScrollTimeout: React.PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    rowGroupRenderer: React.PropTypes.func,
		    isScrolling: React.PropTypes.bool
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowRenderer: Row,
		      onRows: function onRows() {},
		      selectedRows: [],
		      rowScrollTimeout: 0
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      displayStart: this.props.displayStart,
		      displayEnd: this.props.displayEnd,
		      scrollingTimeout: null
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._currentRowsLength = 0;
		    this._currentRowsRange = { start: 0, end: 0 };
		    this._scroll = { scrollTop: 0, scrollLeft: 0 };
		  },
		  componentDidMount: function componentDidMount() {
		    this.onRows();
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.displayStart !== this.state.displayStart || nextProps.displayEnd !== this.state.displayEnd) {
		      this.setState({
		        displayStart: nextProps.displayStart,
		        displayEnd: nextProps.displayEnd
		      });
		    }
		  },
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		    var shouldUpdate = nextState.displayStart !== this.state.displayStart || nextState.displayEnd !== this.state.displayEnd || nextState.scrollingTimeout !== this.state.scrollingTimeout || nextProps.rowsCount !== this.props.rowsCount || nextProps.rowHeight !== this.props.rowHeight || nextProps.columns !== this.props.columns || nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.cellMetaData !== this.props.cellMetaData || this.props.colDisplayStart !== nextProps.colDisplayStart || this.props.colDisplayEnd !== nextProps.colDisplayEnd || this.props.colVisibleStart !== nextProps.colVisibleStart || this.props.colVisibleEnd !== nextProps.colVisibleEnd || !(0, _shallowEqual2['default'])(nextProps.style, this.props.style);
		    return shouldUpdate;
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._currentRowsLength = 0;
		    this._currentRowsRange = { start: 0, end: 0 };
		    this._scroll = { scrollTop: 0, scrollLeft: 0 };
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    if (this._scroll.scrollTop !== 0 && this._scroll.scrollLeft !== 0) {
		      this.setScrollLeft(this._scroll.scrollLeft);
		    }
		    this.onRows();
		  },
		  onRows: function onRows() {
		    if (this._currentRowsRange !== { start: 0, end: 0 }) {
		      this.props.onRows(this._currentRowsRange);
		      this._currentRowsRange = { start: 0, end: 0 };
		    }
		  },
		  onScroll: function onScroll(e) {
		    if (ReactDOM.findDOMNode(this) !== e.target) {
		      return;
		    }
		    this.appendScrollShim();
		    var scrollLeft = e.target.scrollLeft;
		    var scrollTop = e.target.scrollTop;
		    var scroll = { scrollTop: scrollTop, scrollLeft: scrollLeft };
		    this._scroll = scroll;
		    this.props.onScroll(scroll);
		  },
		  getSubRows: function getSubRows(row) {
		    var subRowDetails = this.props.getSubRowDetails(row);
		    if (subRowDetails.expanded === true) {
		      return subRowDetails.children.map(function (r) {
		        return { row: r };
		      });
		    }
		  },
		  addSubRows: function addSubRows(rowsInput, row, i, displayEnd, treeDepth) {
		    var _this = this;
	
		    var subRowDetails = this.props.getSubRowDetails(row) || {};
		    var rows = rowsInput;
		    var increment = i;
		    if (increment < displayEnd) {
		      subRowDetails.treeDepth = treeDepth;
		      rows.push({ row: row, subRowDetails: subRowDetails });
		      increment++;
		    }
		    if (subRowDetails && subRowDetails.expanded) {
		      var subRows = this.getSubRows(row);
		      subRows.forEach(function (sr) {
		        var result = _this.addSubRows(rows, sr.row, increment, displayEnd, treeDepth + 1);
		        rows = result.rows;
		        increment = result.increment;
		      });
		    }
		    return { rows: rows, increment: increment };
		  },
		  getRows: function getRows(displayStart, displayEnd) {
		    this._currentRowsRange = { start: displayStart, end: displayEnd };
		    if (Array.isArray(this.props.rowGetter)) {
		      return this.props.rowGetter.slice(displayStart, displayEnd);
		    }
		    var rows = [];
		    var rowFetchIndex = displayStart;
		    var i = displayStart;
		    while (i < displayEnd) {
		      var row = this.props.rowGetter(rowFetchIndex);
		      if (this.props.getSubRowDetails) {
		        var treeDepth = 0;
		        var result = this.addSubRows(rows, row, i, displayEnd, treeDepth);
		        rows = result.rows;
		        i = result.increment;
		      } else {
		        rows.push({ row: row });
		        i++;
		      }
		      rowFetchIndex++;
		    }
		    return rows;
		  },
		  getScrollbarWidth: function getScrollbarWidth() {
		    var scrollbarWidth = 0;
		    // Get the scrollbar width
		    var canvas = ReactDOM.findDOMNode(this);
		    scrollbarWidth = canvas.offsetWidth - canvas.clientWidth;
		    return scrollbarWidth;
		  },
		  getScroll: function getScroll() {
		    var _ReactDOM$findDOMNode = ReactDOM.findDOMNode(this),
		        scrollTop = _ReactDOM$findDOMNode.scrollTop,
		        scrollLeft = _ReactDOM$findDOMNode.scrollLeft;
	
		    return { scrollTop: scrollTop, scrollLeft: scrollLeft };
		  },
		  isRowSelected: function isRowSelected(idx, row) {
		    var _this2 = this;
	
		    // Use selectedRows if set
		    if (this.props.selectedRows !== null) {
		      var selectedRows = this.props.selectedRows.filter(function (r) {
		        var rowKeyValue = row.get ? row.get(_this2.props.rowKey) : row[_this2.props.rowKey];
		        return r[_this2.props.rowKey] === rowKeyValue;
		      });
		      return selectedRows.length > 0 && selectedRows[0].isSelected;
		    }
	
		    // Else use new rowSelection props
		    if (this.props.rowSelection) {
		      var _props$rowSelection = this.props.rowSelection,
		          keys = _props$rowSelection.keys,
		          indexes = _props$rowSelection.indexes,
		          isSelectedKey = _props$rowSelection.isSelectedKey;
	
		      return RowUtils.isRowSelected(keys, indexes, isSelectedKey, row, idx);
		    }
	
		    return false;
		  },
	
	
		  _currentRowsLength: 0,
		  _currentRowsRange: { start: 0, end: 0 },
		  _scroll: { scrollTop: 0, scrollLeft: 0 },
	
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    if (this._currentRowsLength !== 0) {
		      if (!this.rows) return;
		      for (var i = 0, len = this._currentRowsLength; i < len; i++) {
		        if (this.rows[i]) {
		          var row = this.getRowByRef(i);
		          if (row && row.setScrollLeft) {
		            row.setScrollLeft(scrollLeft);
		          }
		        }
		      }
		    }
		  },
		  getRowByRef: function getRowByRef(i) {
		    // check if wrapped with React DND drop target
		    var wrappedRow = this.rows[i].getDecoratedComponentInstance ? this.rows[i].getDecoratedComponentInstance(i) : null;
		    if (wrappedRow) {
		      return wrappedRow.row;
		    }
		    return this.rows[i];
		  },
	
	
		  rows: [],
	
		  renderRow: function renderRow(props) {
		    var row = props.row;
		    if (row.__metaData && row.__metaData.isGroup) {
		      return React.createElement(_RowGroup2['default'], _extends({
		        key: props.key,
		        name: row.name
		      }, row.__metaData, {
		        row: props.row,
		        idx: props.idx,
		        height: props.height,
		        cellMetaData: this.props.cellMetaData,
		        renderer: this.props.rowGroupRenderer
		      }));
		    }
		    var RowsRenderer = this.props.rowRenderer;
		    if (typeof RowsRenderer === 'function') {
		      return React.createElement(RowsRenderer, props);
		    }
	
		    if (React.isValidElement(this.props.rowRenderer)) {
		      return React.cloneElement(this.props.rowRenderer, props);
		    }
		  },
		  renderPlaceholder: function renderPlaceholder(key, height) {
		    // just renders empty cells
		    // if we wanted to show gridlines, we'd need classes and position as with renderScrollingPlaceholder
		    return React.createElement(
		      'div',
		      { key: key, style: { height: height } },
		      this.props.columns.map(function (column, idx) {
		        return React.createElement('div', { style: { width: column.width }, key: idx });
		      })
		    );
		  },
		  render: function render() {
		    var _this3 = this;
	
		    var _state = this.state,
		        displayStart = _state.displayStart,
		        displayEnd = _state.displayEnd;
		    var _props = this.props,
		        rowHeight = _props.rowHeight,
		        rowsCount = _props.rowsCount;
	
	
		    var rows = this.getRows(displayStart, displayEnd).map(function (r, idx) {
		      return _this3.renderRow({
		        key: 'row-' + (displayStart + idx),
		        ref: function ref(node) {
		          return _this3.rows[idx] = node;
		        },
		        idx: displayStart + idx,
		        visibleStart: _this3.props.visibleStart,
		        visibleEnd: _this3.props.visibleEnd,
		        row: r.row,
		        height: rowHeight,
		        onMouseOver: _this3.onMouseOver,
		        columns: _this3.props.columns,
		        isSelected: _this3.isRowSelected(displayStart + idx, r.row, displayStart, displayEnd),
		        expandedRows: _this3.props.expandedRows,
		        cellMetaData: _this3.props.cellMetaData,
		        subRowDetails: r.subRowDetails,
		        colVisibleStart: _this3.props.colVisibleStart,
		        colVisibleEnd: _this3.props.colVisibleEnd,
		        colDisplayStart: _this3.props.colDisplayStart,
		        colDisplayEnd: _this3.props.colDisplayEnd,
		        isScrolling: _this3.props.isScrolling
		      });
		    });
	
		    this._currentRowsLength = rows.length;
	
		    if (displayStart > 0) {
		      rows.unshift(this.renderPlaceholder('top', displayStart * rowHeight));
		    }
	
		    if (rowsCount - displayEnd > 0) {
		      rows.push(this.renderPlaceholder('bottom', (rowsCount - displayEnd) * rowHeight));
		    }
	
		    var style = {
		      position: 'absolute',
		      top: 0,
		      left: 0,
		      overflowX: 'auto',
		      overflowY: 'scroll',
		      width: this.props.totalWidth,
		      height: this.props.height
		    };
	
		    return React.createElement(
		      'div',
		      {
		        style: style,
		        onScroll: this.onScroll,
		        className: joinClasses('react-grid-Canvas', this.props.className, { opaque: this.props.cellMetaData.selected && this.props.cellMetaData.selected.active }) },
		      React.createElement(_RowsContainer2['default'], {
		        width: this.props.width,
		        rows: rows,
		        contextMenu: this.props.contextMenu,
		        rowIdx: this.props.cellMetaData.selected.rowIdx,
		        idx: this.props.cellMetaData.selected.idx })
		    );
		  }
		});
	
		module.exports = Canvas;
	
	/***/ },
	/* 161 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isValidElement = __webpack_require__(2).isValidElement;
	
		module.exports = function sameColumn(a, b) {
		  var k = void 0;
	
		  for (k in a) {
		    if (a.hasOwnProperty(k)) {
		      if (typeof a[k] === 'function' && typeof b[k] === 'function' || isValidElement(a[k]) && isValidElement(b[k])) {
		        continue;
		      }
		      if (!b.hasOwnProperty(k) || a[k] !== b[k]) {
		        return false;
		      }
		    }
		  }
	
		  for (k in b) {
		    if (b.hasOwnProperty(k) && !a.hasOwnProperty(k)) {
		      return false;
		    }
		  }
	
		  return true;
		};
	
	/***/ },
	/* 162 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ColumnMetrics = __webpack_require__(33);
		var DOMMetrics = __webpack_require__(22);
		Object.assign = __webpack_require__(70);
		var PropTypes = __webpack_require__(2).PropTypes;
		var ColumnUtils = __webpack_require__(10);
	
		var Column = function Column() {
		  _classCallCheck(this, Column);
		};
	
		module.exports = {
		  mixins: [DOMMetrics.MetricsMixin],
	
		  propTypes: {
		    columns: PropTypes.arrayOf(Column),
		    minColumnWidth: PropTypes.number,
		    columnEquality: PropTypes.func,
		    onColumnResize: PropTypes.func
		  },
	
		  DOMMetrics: {
		    gridWidth: function gridWidth() {
		      return _reactDom2['default'].findDOMNode(this).parentElement.offsetWidth;
		    }
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      minColumnWidth: 80,
		      columnEquality: ColumnMetrics.sameColumn
		    };
		  },
		  componentWillMount: function componentWillMount() {
		    this._mounted = true;
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (nextProps.columns) {
		      if (!ColumnMetrics.sameColumns(this.props.columns, nextProps.columns, this.props.columnEquality) || nextProps.minWidth !== this.props.minWidth) {
		        var columnMetrics = this.createColumnMetrics(nextProps);
		        this.setState({ columnMetrics: columnMetrics });
		      }
		    }
		  },
		  getTotalWidth: function getTotalWidth() {
		    var totalWidth = 0;
		    if (this._mounted) {
		      totalWidth = this.DOMMetrics.gridWidth();
		    } else {
		      totalWidth = ColumnUtils.getSize(this.props.columns) * this.props.minColumnWidth;
		    }
		    return totalWidth;
		  },
		  getColumnMetricsType: function getColumnMetricsType(metrics) {
		    var totalWidth = metrics.totalWidth || this.getTotalWidth();
		    var currentMetrics = {
		      columns: metrics.columns,
		      totalWidth: totalWidth,
		      minColumnWidth: metrics.minColumnWidth
		    };
		    var updatedMetrics = ColumnMetrics.recalculate(currentMetrics);
		    return updatedMetrics;
		  },
		  getColumn: function getColumn(idx) {
		    var columns = this.state.columnMetrics.columns;
		    if (Array.isArray(columns)) {
		      return columns[idx];
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.get(idx);
		    }
		  },
		  getSize: function getSize() {
		    var columns = this.state.columnMetrics.columns;
		    if (Array.isArray(columns)) {
		      return columns.length;
		    } else if (typeof Immutable !== 'undefined') {
		      return columns.size;
		    }
		  },
		  metricsUpdated: function metricsUpdated() {
		    var columnMetrics = this.createColumnMetrics();
		    this.setState({ columnMetrics: columnMetrics });
		  },
		  createColumnMetrics: function createColumnMetrics() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
		    var gridColumns = this.setupGridColumns(props);
		    return this.getColumnMetricsType({
		      columns: gridColumns,
		      minColumnWidth: this.props.minColumnWidth,
		      totalWidth: props.minWidth
		    });
		  },
		  onColumnResize: function onColumnResize(index, width) {
		    var columnMetrics = ColumnMetrics.resizeColumn(this.state.columnMetrics, index, width);
		    this.setState({ columnMetrics: columnMetrics });
		    if (this.props.onColumnResize) {
		      this.props.onColumnResize(index, width);
		    }
		  }
		};
	
	/***/ },
	/* 163 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(18);
	
		// The list of the propTypes that we want to include in the Draggable div
		var knownDivPropertyKeys = ['onDragStart', 'onDragEnd', 'onDrag', 'style'];
	
		var Draggable = React.createClass({
		  displayName: 'Draggable',
	
		  propTypes: {
		    onDragStart: PropTypes.func,
		    onDragEnd: PropTypes.func,
		    onDrag: PropTypes.func,
		    component: PropTypes.oneOfType([PropTypes.func, PropTypes.constructor]),
		    style: PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      onDragStart: function onDragStart() {
		        return true;
		      },
		      onDragEnd: function onDragEnd() {},
		      onDrag: function onDrag() {}
		    };
		  },
		  getInitialState: function getInitialState() {
		    return {
		      drag: null
		    };
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this.cleanUp();
		  },
		  onMouseDown: function onMouseDown(e) {
		    var drag = this.props.onDragStart(e);
	
		    if (drag === null && e.button !== 0) {
		      return;
		    }
	
		    window.addEventListener('mouseup', this.onMouseUp);
		    window.addEventListener('mousemove', this.onMouseMove);
		    window.addEventListener('touchend', this.onMouseUp);
		    window.addEventListener('touchmove', this.onMouseMove);
	
		    this.setState({ drag: drag });
		  },
		  onMouseMove: function onMouseMove(e) {
		    if (this.state.drag === null) {
		      return;
		    }
	
		    if (e.preventDefault) {
		      e.preventDefault();
		    }
	
		    this.props.onDrag(e);
		  },
		  onMouseUp: function onMouseUp(e) {
		    this.cleanUp();
		    this.props.onDragEnd(e, this.state.drag);
		    this.setState({ drag: null });
		  },
		  cleanUp: function cleanUp() {
		    window.removeEventListener('mouseup', this.onMouseUp);
		    window.removeEventListener('mousemove', this.onMouseMove);
		    window.removeEventListener('touchend', this.onMouseUp);
		    window.removeEventListener('touchmove', this.onMouseMove);
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  render: function render() {
		    return React.createElement('div', _extends({}, this.getKnownDivProps(), {
		      onMouseDown: this.onMouseDown,
		      onTouchStart: this.onMouseDown,
		      className: 'react-grid-HeaderCell__draggable' }));
		  }
		});
	
		module.exports = Draggable;
	
	/***/ },
	/* 164 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var PropTypes = React.PropTypes;
		var Header = __webpack_require__(166);
		var Viewport = __webpack_require__(176);
		var GridScrollMixin = __webpack_require__(165);
		var DOMMetrics = __webpack_require__(22);
		var cellMetaDataShape = __webpack_require__(14);
		__webpack_require__(26);
	
		var Grid = React.createClass({
		  displayName: 'Grid',
	
		  propTypes: {
		    rowGetter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
		    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		    columnMetrics: PropTypes.object,
		    minHeight: PropTypes.number,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    headerRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    rowHeight: PropTypes.number,
		    rowRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		    emptyRowsView: PropTypes.func,
		    expandedRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    selectedRows: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    rowsCount: PropTypes.number,
		    onRows: PropTypes.func,
		    sortColumn: React.PropTypes.string,
		    sortDirection: React.PropTypes.oneOf(['ASC', 'DESC', 'NONE']),
		    rowOffsetHeight: PropTypes.number.isRequired,
		    onViewportKeydown: PropTypes.func.isRequired,
		    onViewportKeyup: PropTypes.func,
		    onViewportDragStart: PropTypes.func.isRequired,
		    onViewportDragEnd: PropTypes.func.isRequired,
		    onViewportDoubleClick: PropTypes.func.isRequired,
		    onColumnResize: PropTypes.func,
		    onSort: PropTypes.func,
		    onHeaderDrop: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    rowKey: PropTypes.string.isRequired,
		    rowScrollTimeout: PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    draggableHeaderCell: PropTypes.func,
		    getValidFilterValues: PropTypes.func,
		    rowGroupRenderer: PropTypes.func,
		    overScan: PropTypes.object
		  },
	
		  mixins: [GridScrollMixin, DOMMetrics.MetricsComputatorMixin],
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowHeight: 35,
		      minHeight: 350
		    };
		  },
	
	
		  getStyle: function getStyle() {
		    return {
		      overflow: 'hidden',
		      outline: 0,
		      position: 'relative',
		      minHeight: this.props.minHeight
		    };
		  },
	
		  render: function render() {
		    var _this = this;
	
		    var headerRows = this.props.headerRows || [{ ref: function ref(node) {
		        return _this.row = node;
		      } }];
		    var EmptyRowsView = this.props.emptyRowsView;
	
		    return React.createElement(
		      'div',
		      { style: this.getStyle(), className: 'react-grid-Grid' },
		      React.createElement(Header, {
		        ref: function ref(input) {
		          _this.header = input;
		        },
		        columnMetrics: this.props.columnMetrics,
		        onColumnResize: this.props.onColumnResize,
		        height: this.props.rowHeight,
		        totalWidth: this.props.totalWidth,
		        headerRows: headerRows,
		        sortColumn: this.props.sortColumn,
		        sortDirection: this.props.sortDirection,
		        draggableHeaderCell: this.props.draggableHeaderCell,
		        onSort: this.props.onSort,
		        onHeaderDrop: this.props.onHeaderDrop,
		        onScroll: this.onHeaderScroll,
		        getValidFilterValues: this.props.getValidFilterValues,
		        cellMetaData: this.props.cellMetaData
		      }),
		      this.props.rowsCount >= 1 || this.props.rowsCount === 0 && !this.props.emptyRowsView ? React.createElement(
		        'div',
		        { ref: function ref(node) {
		            _this.viewPortContainer = node;
		          }, tabIndex: '0', onKeyDown: this.props.onViewportKeydown, onKeyUp: this.props.onViewportKeyup, onDoubleClick: this.props.onViewportDoubleClick, onDragStart: this.props.onViewportDragStart, onDragEnd: this.props.onViewportDragEnd },
		        React.createElement(Viewport, {
		          ref: function ref(node) {
		            _this.viewport = node;
		          },
		          rowKey: this.props.rowKey,
		          width: this.props.columnMetrics.width,
		          rowHeight: this.props.rowHeight,
		          rowRenderer: this.props.rowRenderer,
		          rowGetter: this.props.rowGetter,
		          rowsCount: this.props.rowsCount,
		          selectedRows: this.props.selectedRows,
		          expandedRows: this.props.expandedRows,
		          columnMetrics: this.props.columnMetrics,
		          totalWidth: this.props.totalWidth,
		          onScroll: this.onScroll,
		          onRows: this.props.onRows,
		          cellMetaData: this.props.cellMetaData,
		          rowOffsetHeight: this.props.rowOffsetHeight || this.props.rowHeight * headerRows.length,
		          minHeight: this.props.minHeight,
		          rowScrollTimeout: this.props.rowScrollTimeout,
		          contextMenu: this.props.contextMenu,
		          rowSelection: this.props.rowSelection,
		          getSubRowDetails: this.props.getSubRowDetails,
		          rowGroupRenderer: this.props.rowGroupRenderer,
		          overScan: this.props.overScan
		        })
		      ) : React.createElement(
		        'div',
		        { ref: function ref(node) {
		            _this.emptyView = node;
		          }, className: 'react-grid-Empty' },
		        React.createElement(EmptyRowsView, null)
		      )
		    );
		  }
		});
	
		module.exports = Grid;
	
	/***/ },
	/* 165 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ReactDOM = __webpack_require__(4);
	
		module.exports = {
		  componentDidMount: function componentDidMount() {
		    this._scrollLeft = this.viewport ? this.viewport.getScroll().scrollLeft : 0;
		    this._onScroll();
		  },
		  componentDidUpdate: function componentDidUpdate() {
		    this._onScroll();
		  },
		  componentWillMount: function componentWillMount() {
		    this._scrollLeft = undefined;
		  },
		  componentWillUnmount: function componentWillUnmount() {
		    this._scrollLeft = undefined;
		  },
		  onScroll: function onScroll(props) {
		    if (this._scrollLeft !== props.scrollLeft) {
		      this._scrollLeft = props.scrollLeft;
		      this._onScroll();
		    }
		  },
		  onHeaderScroll: function onHeaderScroll(e) {
		    var scrollLeft = e.target.scrollLeft;
		    if (this._scrollLeft !== scrollLeft) {
		      this._scrollLeft = scrollLeft;
		      this.header.setScrollLeft(scrollLeft);
		      var canvas = ReactDOM.findDOMNode(this.viewport.canvas);
		      canvas.scrollLeft = scrollLeft;
		      this.viewport.canvas.setScrollLeft(scrollLeft);
		    }
		  },
		  _onScroll: function _onScroll() {
		    if (this._scrollLeft !== undefined) {
		      this.header.setScrollLeft(this._scrollLeft);
		      if (this.viewport) {
		        this.viewport.setScrollLeft(this._scrollLeft);
		      }
		    }
		  }
		};
	
	/***/ },
	/* 166 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var joinClasses = __webpack_require__(9);
		var shallowCloneObject = __webpack_require__(36);
		var ColumnMetrics = __webpack_require__(33);
		var ColumnUtils = __webpack_require__(10);
		var HeaderRow = __webpack_require__(168);
		var getScrollbarSize = __webpack_require__(35);
		var PropTypes = React.PropTypes;
		var createObjectWithProperties = __webpack_require__(17);
		var cellMetaDataShape = __webpack_require__(14);
		__webpack_require__(18);
	
		// The list of the propTypes that we want to include in the Header div
		var knownDivPropertyKeys = ['height', 'onScroll'];
	
		var Header = React.createClass({
		  displayName: 'Header',
	
		  propTypes: {
		    columnMetrics: PropTypes.shape({ width: PropTypes.number.isRequired, columns: PropTypes.any }).isRequired,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    height: PropTypes.number.isRequired,
		    headerRows: PropTypes.array.isRequired,
		    sortColumn: PropTypes.string,
		    sortDirection: PropTypes.oneOf(['ASC', 'DESC', 'NONE']),
		    onSort: PropTypes.func,
		    onColumnResize: PropTypes.func,
		    onScroll: PropTypes.func,
		    onHeaderDrop: PropTypes.func,
		    draggableHeaderCell: PropTypes.func,
		    getValidFilterValues: PropTypes.func,
		    cellMetaData: PropTypes.shape(cellMetaDataShape)
		  },
	
		  getInitialState: function getInitialState() {
		    return { resizing: null };
		  },
		  componentWillReceiveProps: function componentWillReceiveProps() {
		    this.setState({ resizing: null });
		  },
	
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
		    var update = !ColumnMetrics.sameColumns(this.props.columnMetrics.columns, nextProps.columnMetrics.columns, ColumnMetrics.sameColumn) || this.props.totalWidth !== nextProps.totalWidth || this.props.headerRows.length !== nextProps.headerRows.length || this.state.resizing !== nextState.resizing || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
		    return update;
		  },
	
		  onColumnResize: function onColumnResize(column, width) {
		    var state = this.state.resizing || this.props;
	
		    var pos = this.getColumnPosition(column);
	
		    if (pos != null) {
		      var _resizing = {
		        columnMetrics: shallowCloneObject(state.columnMetrics)
		      };
		      _resizing.columnMetrics = ColumnMetrics.resizeColumn(_resizing.columnMetrics, pos, width);
	
		      // we don't want to influence scrollLeft while resizing
		      if (_resizing.columnMetrics.totalWidth < state.columnMetrics.totalWidth) {
		        _resizing.columnMetrics.totalWidth = state.columnMetrics.totalWidth;
		      }
	
		      _resizing.column = ColumnUtils.getColumn(_resizing.columnMetrics.columns, pos);
		      this.setState({ resizing: _resizing });
		    }
		  },
		  onColumnResizeEnd: function onColumnResizeEnd(column, width) {
		    var pos = this.getColumnPosition(column);
		    if (pos !== null && this.props.onColumnResize) {
		      this.props.onColumnResize(pos, width || column.width);
		    }
		  },
		  getHeaderRows: function getHeaderRows() {
		    var _this = this;
	
		    var columnMetrics = this.getColumnMetrics();
		    var resizeColumn = void 0;
		    if (this.state.resizing) {
		      resizeColumn = this.state.resizing.column;
		    }
		    var headerRows = [];
		    this.props.headerRows.forEach(function (row, index) {
		      // To allow header filters to be visible
		      var rowHeight = 'auto';
		      if (row.rowType === 'filter') {
		        rowHeight = '500px';
		      }
		      var scrollbarSize = getScrollbarSize() > 0 ? getScrollbarSize() : 0;
		      var updatedWidth = isNaN(_this.props.totalWidth - scrollbarSize) ? _this.props.totalWidth : _this.props.totalWidth - scrollbarSize;
		      var headerRowStyle = {
		        position: 'absolute',
		        top: _this.getCombinedHeaderHeights(index),
		        left: 0,
		        width: updatedWidth,
		        overflowX: 'hidden',
		        minHeight: rowHeight
		      };
	
		      headerRows.push(React.createElement(HeaderRow, {
		        key: row.ref,
		        ref: function ref(node) {
		          return _this.row = node;
		        },
		        rowType: row.rowType,
		        style: headerRowStyle,
		        onColumnResize: _this.onColumnResize,
		        onColumnResizeEnd: _this.onColumnResizeEnd,
		        width: columnMetrics.width,
		        height: row.height || _this.props.height,
		        columns: columnMetrics.columns,
		        resizing: resizeColumn,
		        draggableHeaderCell: _this.props.draggableHeaderCell,
		        filterable: row.filterable,
		        onFilterChange: row.onFilterChange,
		        onHeaderDrop: _this.props.onHeaderDrop,
		        sortColumn: _this.props.sortColumn,
		        sortDirection: _this.props.sortDirection,
		        onSort: _this.props.onSort,
		        onScroll: _this.props.onScroll,
		        getValidFilterValues: _this.props.getValidFilterValues
		      }));
		    });
		    return headerRows;
		  },
		  getColumnMetrics: function getColumnMetrics() {
		    var columnMetrics = void 0;
		    if (this.state.resizing) {
		      columnMetrics = this.state.resizing.columnMetrics;
		    } else {
		      columnMetrics = this.props.columnMetrics;
		    }
		    return columnMetrics;
		  },
		  getColumnPosition: function getColumnPosition(column) {
		    var columnMetrics = this.getColumnMetrics();
		    var pos = -1;
		    columnMetrics.columns.forEach(function (c, idx) {
		      if (c.key === column.key) {
		        pos = idx;
		      }
		    });
		    return pos === -1 ? null : pos;
		  },
		  getCombinedHeaderHeights: function getCombinedHeaderHeights(until) {
		    var stopAt = this.props.headerRows.length;
		    if (typeof until !== 'undefined') {
		      stopAt = until;
		    }
	
		    var height = 0;
		    for (var index = 0; index < stopAt; index++) {
		      height += this.props.headerRows[index].height || this.props.height;
		    }
		    return height;
		  },
		  getStyle: function getStyle() {
		    return {
		      position: 'relative',
		      height: this.getCombinedHeaderHeights()
		    };
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var node = ReactDOM.findDOMNode(this.row);
		    node.scrollLeft = scrollLeft;
		    this.row.setScrollLeft(scrollLeft);
		    if (this.filterRow) {
		      var nodeFilters = this.filterRow;
		      nodeFilters.scrollLeft = scrollLeft;
		      this.filterRow.setScrollLeft(scrollLeft);
		    }
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
	
	
		  // Set the cell selection to -1 x -1 when clicking on the header
		  onHeaderClick: function onHeaderClick() {
		    this.props.cellMetaData.onCellClick({ rowIdx: -1, idx: -1 });
		  },
		  render: function render() {
		    var className = joinClasses({
		      'react-grid-Header': true,
		      'react-grid-Header--resizing': !!this.state.resizing
		    });
		    var headerRows = this.getHeaderRows();
	
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { style: this.getStyle(), className: className, onClick: this.onHeaderClick }),
		      headerRows
		    );
		  }
		});
	
		module.exports = Header;
	
	/***/ },
	/* 167 */
	/***/ function(module, exports) {
	
		"use strict";
	
		var HeaderCellType = {
		  SORTABLE: 0,
		  FILTERABLE: 1,
		  NONE: 2,
		  CHECKBOX: 3
		};
	
		module.exports = HeaderCellType;
	
	/***/ },
	/* 168 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var shallowEqual = __webpack_require__(69);
		var BaseHeaderCell = __webpack_require__(60);
		var getScrollbarSize = __webpack_require__(35);
		var ExcelColumn = __webpack_require__(11);
		var ColumnUtilsMixin = __webpack_require__(10);
		var SortableHeaderCell = __webpack_require__(179);
		var FilterableHeaderCell = __webpack_require__(178);
		var HeaderCellType = __webpack_require__(167);
		var createObjectWithProperties = __webpack_require__(17);
		__webpack_require__(18);
	
		var PropTypes = React.PropTypes;
	
		var HeaderRowStyle = {
		  overflow: React.PropTypes.string,
		  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		  height: React.PropTypes.number,
		  position: React.PropTypes.string
		};
	
		// The list of the propTypes that we want to include in the HeaderRow div
		var knownDivPropertyKeys = ['width', 'height', 'style', 'onScroll'];
	
		var HeaderRow = React.createClass({
		  displayName: 'HeaderRow',
	
		  propTypes: {
		    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		    height: PropTypes.number.isRequired,
		    columns: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
		    onColumnResize: PropTypes.func,
		    onSort: PropTypes.func.isRequired,
		    onColumnResizeEnd: PropTypes.func,
		    style: PropTypes.shape(HeaderRowStyle),
		    sortColumn: PropTypes.string,
		    sortDirection: React.PropTypes.oneOf(Object.keys(SortableHeaderCell.DEFINE_SORT)),
		    cellRenderer: PropTypes.func,
		    headerCellRenderer: PropTypes.func,
		    filterable: PropTypes.bool,
		    onFilterChange: PropTypes.func,
		    resizing: PropTypes.object,
		    onScroll: PropTypes.func,
		    rowType: PropTypes.string,
		    draggableHeaderCell: PropTypes.func,
		    onHeaderDrop: PropTypes.func
		  },
	
		  mixins: [ColumnUtilsMixin],
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.width !== this.props.width || nextProps.height !== this.props.height || nextProps.columns !== this.props.columns || !shallowEqual(nextProps.style, this.props.style) || this.props.sortColumn !== nextProps.sortColumn || this.props.sortDirection !== nextProps.sortDirection;
		  },
	
	
		  cells: [],
	
		  getHeaderCellType: function getHeaderCellType(column) {
		    if (column.filterable) {
		      if (this.props.filterable) return HeaderCellType.FILTERABLE;
		    }
	
		    if (column.sortable) return HeaderCellType.SORTABLE;
	
		    return HeaderCellType.NONE;
		  },
		  getFilterableHeaderCell: function getFilterableHeaderCell(column) {
		    var FilterRenderer = FilterableHeaderCell;
		    if (column.filterRenderer !== undefined) {
		      FilterRenderer = column.filterRenderer;
		    }
		    return React.createElement(FilterRenderer, _extends({}, this.props, { onChange: this.props.onFilterChange }));
		  },
		  getSortableHeaderCell: function getSortableHeaderCell(column) {
		    var sortDirection = this.props.sortColumn === column.key ? this.props.sortDirection : SortableHeaderCell.DEFINE_SORT.NONE;
		    return React.createElement(SortableHeaderCell, { columnKey: column.key, onSort: this.props.onSort, sortDirection: sortDirection });
		  },
		  getHeaderRenderer: function getHeaderRenderer(column) {
		    var renderer = void 0;
		    if (column.headerRenderer && !this.props.filterable) {
		      renderer = column.headerRenderer;
		    } else {
		      var headerCellType = this.getHeaderCellType(column);
		      switch (headerCellType) {
		        case HeaderCellType.SORTABLE:
		          renderer = this.getSortableHeaderCell(column);
		          break;
		        case HeaderCellType.FILTERABLE:
		          renderer = this.getFilterableHeaderCell(column);
		          break;
		        default:
		          break;
		      }
		    }
		    return renderer;
		  },
		  getStyle: function getStyle() {
		    return {
		      overflow: 'hidden',
		      width: '100%',
		      height: this.props.height,
		      position: 'absolute'
		    };
		  },
		  getCells: function getCells() {
		    var _this = this;
	
		    var cells = [];
		    var lockedCells = [];
	
		    var _loop = function _loop(i, len) {
		      var column = Object.assign({ rowType: _this.props.rowType }, _this.getColumn(_this.props.columns, i));
		      var _renderer = _this.getHeaderRenderer(column);
		      if (column.key === 'select-row' && _this.props.rowType === 'filter') {
		        _renderer = React.createElement('div', null);
		      }
		      var HeaderCell = column.draggable ? _this.props.draggableHeaderCell : BaseHeaderCell;
		      var cell = React.createElement(HeaderCell, {
		        ref: function ref(node) {
		          return _this.cells[i] = node;
		        },
		        key: i,
		        height: _this.props.height,
		        column: column,
		        renderer: _renderer,
		        resizing: _this.props.resizing === column,
		        onResize: _this.props.onColumnResize,
		        onResizeEnd: _this.props.onColumnResizeEnd,
		        onHeaderDrop: _this.props.onHeaderDrop
		      });
		      if (column.locked) {
		        lockedCells.push(cell);
		      } else {
		        cells.push(cell);
		      }
		    };
	
		    for (var i = 0, len = this.getSize(this.props.columns); i < len; i++) {
		      _loop(i, len);
		    }
	
		    return cells.concat(lockedCells);
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    var _this2 = this;
	
		    this.props.columns.forEach(function (column, i) {
		      if (column.locked) {
		        _this2.cells[i].setScrollLeft(scrollLeft);
		      }
		    });
		  },
		  getKnownDivProps: function getKnownDivProps() {
		    return createObjectWithProperties(this.props, knownDivPropertyKeys);
		  },
		  render: function render() {
		    var cellsStyle = {
		      width: this.props.width ? this.props.width + getScrollbarSize() : '100%',
		      height: this.props.height,
		      whiteSpace: 'nowrap',
		      overflowX: 'hidden',
		      overflowY: 'hidden'
		    };
	
		    var cells = this.getCells();
		    return React.createElement(
		      'div',
		      _extends({}, this.getKnownDivProps(), { className: 'react-grid-HeaderRow' }),
		      React.createElement(
		        'div',
		        { style: cellsStyle },
		        cells
		      )
		    );
		  }
		});
	
		module.exports = HeaderRow;
	
	/***/ },
	/* 169 */
	/***/ function(module, exports) {
	
		"use strict";
	
		module.exports = {
		  Backspace: 8,
		  Tab: 9,
		  Enter: 13,
		  Shift: 16,
		  Ctrl: 17,
		  Alt: 18,
		  PauseBreak: 19,
		  CapsLock: 20,
		  Escape: 27,
		  PageUp: 33,
		  PageDown: 34,
		  End: 35,
		  Home: 36,
		  LeftArrow: 37,
		  UpArrow: 38,
		  RightArrow: 39,
		  DownArrow: 40,
		  Insert: 45,
		  Delete: 46,
		  0: 48,
		  1: 49,
		  2: 50,
		  3: 51,
		  4: 52,
		  5: 53,
		  6: 54,
		  7: 55,
		  8: 56,
		  9: 57,
		  a: 65,
		  b: 66,
		  c: 67,
		  d: 68,
		  e: 69,
		  f: 70,
		  g: 71,
		  h: 72,
		  i: 73,
		  j: 74,
		  k: 75,
		  l: 76,
		  m: 77,
		  n: 78,
		  o: 79,
		  p: 80,
		  q: 81,
		  r: 82,
		  s: 83,
		  t: 84,
		  u: 85,
		  v: 86,
		  w: 87,
		  x: 88,
		  y: 89,
		  z: 90,
		  LeftWindowKey: 91,
		  RightWindowKey: 92,
		  SelectKey: 93,
		  NumPad0: 96,
		  NumPad1: 97,
		  NumPad2: 98,
		  NumPad3: 99,
		  NumPad4: 100,
		  NumPad5: 101,
		  NumPad6: 102,
		  NumPad7: 103,
		  NumPad8: 104,
		  NumPad9: 105,
		  Multiply: 106,
		  Add: 107,
		  Subtract: 109,
		  DecimalPoint: 110,
		  Divide: 111,
		  F1: 112,
		  F2: 113,
		  F3: 114,
		  F4: 115,
		  F5: 116,
		  F6: 117,
		  F7: 118,
		  F8: 119,
		  F9: 120,
		  F10: 121,
		  F12: 123,
		  NumLock: 144,
		  ScrollLock: 145,
		  SemiColon: 186,
		  EqualSign: 187,
		  Comma: 188,
		  Dash: 189,
		  Period: 190,
		  ForwardSlash: 191,
		  GraveAccent: 192,
		  OpenBracket: 219,
		  BackSlash: 220,
		  CloseBracket: 221,
		  SingleQuote: 222
		};
	
	/***/ },
	/* 170 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.OverflowCellComponent = undefined;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _focusableComponentWrapper = __webpack_require__(182);
	
		var _focusableComponentWrapper2 = _interopRequireDefault(_focusableComponentWrapper);
	
		__webpack_require__(38);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var OverflowCell = function (_React$Component) {
		  _inherits(OverflowCell, _React$Component);
	
		  function OverflowCell() {
		    _classCallCheck(this, OverflowCell);
	
		    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		  }
	
		  OverflowCell.prototype.getStyle = function getStyle() {
		    var style = {
		      position: 'absolute',
		      width: this.props.column.width,
		      height: this.props.height,
		      left: this.props.column.left,
		      border: '1px solid #eee'
		    };
		    return style;
		  };
	
		  OverflowCell.prototype.render = function render() {
		    return _react2['default'].createElement('div', { tabIndex: '-1', style: this.getStyle(), width: '100%', className: 'react-grid-Cell' });
		  };
	
		  return OverflowCell;
		}(_react2['default'].Component);
	
		OverflowCell.isSelected = function (props) {
		  var cellMetaData = props.cellMetaData,
		      rowIdx = props.rowIdx,
		      idx = props.idx;
	
		  if (cellMetaData == null) {
		    return false;
		  }
	
		  var selected = cellMetaData.selected;
	
	
		  return selected && selected.rowIdx === rowIdx && selected.idx === idx;
		};
	
		OverflowCell.isScrolling = function (props) {
		  return props.cellMetaData.isScrollingHorizontallyWithKeyboard;
		};
	
		OverflowCell.propTypes = {
		  rowIdx: _react2['default'].PropTypes.number,
		  idx: _react2['default'].PropTypes.number,
		  height: _react2['default'].PropTypes.number,
		  column: _react2['default'].PropTypes.object,
		  cellMetaData: _react2['default'].PropTypes.object
		};
	
		OverflowCell.displayName = 'Cell';
	
		var OverflowCellComponent = OverflowCell;
		exports['default'] = (0, _focusableComponentWrapper2['default'])(OverflowCell);
		exports.OverflowCellComponent = OverflowCellComponent;
	
	/***/ },
	/* 171 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _ExcelColumn = __webpack_require__(11);
	
		var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		exports['default'] = { ExcelColumn: _ExcelColumn2['default'] };
	
	/***/ },
	/* 172 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _AppConstants = __webpack_require__(58);
	
		var _AppConstants2 = _interopRequireDefault(_AppConstants);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var BaseGrid = __webpack_require__(164);
		var Row = __webpack_require__(34);
		var ExcelColumn = __webpack_require__(11);
		var KeyboardHandlerMixin = __webpack_require__(61);
		var CheckboxEditor = __webpack_require__(65);
		var DOMMetrics = __webpack_require__(22);
		var ColumnMetricsMixin = __webpack_require__(162);
		var RowUtils = __webpack_require__(63);
		var ColumnUtils = __webpack_require__(10);
		var KeyCodes = __webpack_require__(169);
	
		__webpack_require__(26);
		__webpack_require__(71);
	
		if (!Object.assign) {
		  Object.assign = __webpack_require__(70);
		}
	
		var ReactDataGrid = React.createClass({
		  displayName: 'ReactDataGrid',
	
	
		  mixins: [ColumnMetricsMixin, DOMMetrics.MetricsComputatorMixin, KeyboardHandlerMixin],
	
		  propTypes: {
		    rowHeight: React.PropTypes.number.isRequired,
		    headerRowHeight: React.PropTypes.number,
		    headerFiltersHeight: React.PropTypes.number,
		    minHeight: React.PropTypes.number.isRequired,
		    minWidth: React.PropTypes.number,
		    enableRowSelect: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]),
		    onRowUpdated: React.PropTypes.func,
		    rowGetter: React.PropTypes.func.isRequired,
		    rowsCount: React.PropTypes.number.isRequired,
		    toolbar: React.PropTypes.element,
		    enableCellSelect: React.PropTypes.bool,
		    columns: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]).isRequired,
		    onFilter: React.PropTypes.func,
		    onCellCopyPaste: React.PropTypes.func,
		    onCellsDragged: React.PropTypes.func,
		    onAddFilter: React.PropTypes.func,
		    onGridSort: React.PropTypes.func,
		    onDragHandleDoubleClick: React.PropTypes.func,
		    onGridRowsUpdated: React.PropTypes.func,
		    onRowSelect: React.PropTypes.func,
		    rowKey: React.PropTypes.string,
		    rowScrollTimeout: React.PropTypes.number,
		    onClearFilters: React.PropTypes.func,
		    contextMenu: React.PropTypes.element,
		    cellNavigationMode: React.PropTypes.oneOf(['none', 'loopOverRow', 'changeRow']),
		    onCellSelected: React.PropTypes.func,
		    onCellDeSelected: React.PropTypes.func,
		    onCellExpand: React.PropTypes.func,
		    enableDragAndDrop: React.PropTypes.bool,
		    onRowExpandToggle: React.PropTypes.func,
		    draggableHeaderCell: React.PropTypes.func,
		    getValidFilterValues: React.PropTypes.func,
		    rowSelection: React.PropTypes.shape({
		      enableShiftSelect: React.PropTypes.bool,
		      onRowsSelected: React.PropTypes.func,
		      onRowsDeselected: React.PropTypes.func,
		      showCheckbox: React.PropTypes.bool,
		      selectBy: React.PropTypes.oneOfType([React.PropTypes.shape({
		        indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		      }), React.PropTypes.shape({
		        isSelectedKey: React.PropTypes.string.isRequired
		      }), React.PropTypes.shape({
		        keys: React.PropTypes.shape({
		          values: React.PropTypes.array.isRequired,
		          rowKey: React.PropTypes.string.isRequired
		        }).isRequired
		      })]).isRequired
		    }),
		    onRowClick: React.PropTypes.func,
		    onGridKeyUp: React.PropTypes.func,
		    onGridKeyDown: React.PropTypes.func,
		    rowGroupRenderer: React.PropTypes.func,
		    rowActionsCell: React.PropTypes.func,
		    onCheckCellIsEditable: React.PropTypes.func,
		    /* called before cell is set active, returns a boolean to determine whether cell is editable */
		    overScan: React.PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      enableCellSelect: false,
		      tabIndex: -1,
		      rowHeight: 35,
		      headerFiltersHeight: 45,
		      enableRowSelect: false,
		      minHeight: 350,
		      rowKey: 'id',
		      rowScrollTimeout: 0,
		      cellNavigationMode: 'none',
		      overScan: {
		        colsStart: 5,
		        colsEnd: 5,
		        rowsStart: 5,
		        rowsEnd: 5
		      }
		    };
		  },
	
	
		  getInitialState: function getInitialState() {
		    var columnMetrics = this.createColumnMetrics();
		    var initialState = { columnMetrics: columnMetrics, selectedRows: [], copied: null, expandedRows: [], canFilter: false, columnFilters: {}, sortDirection: null, sortColumn: null, dragged: null, scrollOffset: 0, lastRowIdxUiSelected: -1 };
		    if (this.props.enableCellSelect) {
		      initialState.selected = { rowIdx: 0, idx: 0 };
		    } else {
		      initialState.selected = { rowIdx: -1, idx: -1 };
		    }
		    return initialState;
		  },
	
		  hasSelectedCellChanged: function hasSelectedCellChanged(selected) {
		    var previouslySelected = Object.assign({}, this.state.selected);
		    return previouslySelected.rowIdx !== selected.rowIdx || previouslySelected.idx !== selected.idx || previouslySelected.active === false;
		  },
	
		  onContextMenuHide: function onContextMenuHide() {
		    document.removeEventListener('click', this.onContextMenuHide);
		    var newSelected = Object.assign({}, this.state.selected, { contextMenuDisplayed: false });
		    this.setState({ selected: newSelected });
		  },
	
		  onColumnEvent: function onColumnEvent(ev, columnEvent) {
		    var idx = columnEvent.idx,
		        name = columnEvent.name;
	
	
		    if (name && typeof idx !== 'undefined') {
		      var column = this.getColumn(idx);
	
		      if (column && column.events && column.events[name] && typeof column.events[name] === 'function') {
		        var eventArgs = {
		          rowIdx: columnEvent.rowIdx,
		          idx: idx,
		          column: column
		        };
	
		        column.events[name](ev, eventArgs);
		      }
		    }
		  },
	
		  onSelect: function onSelect(selected) {
		    var _this = this;
	
		    if (this.state.selected.rowIdx !== selected.rowIdx || this.state.selected.idx !== selected.idx || this.state.selected.active === false) {
		      var _idx = selected.idx;
		      var _rowIdx = selected.rowIdx;
		      if (this.isCellWithinBounds(selected)) {
		        var oldSelection = this.state.selected;
		        this.setState({ selected: selected }, function () {
		          if (typeof _this.props.onCellDeSelected === 'function') {
		            _this.props.onCellDeSelected(oldSelection);
		          }
		          if (typeof _this.props.onCellSelected === 'function') {
		            _this.props.onCellSelected(selected);
		          }
		        });
		      } else if (_rowIdx === -1 && _idx === -1) {
		        // When it's outside of the grid, set rowIdx anyway
		        this.setState({ selected: { idx: _idx, rowIdx: _rowIdx } });
		      }
		    }
		  },
	
		  onCellClick: function onCellClick(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
	
		    if (this.props.onRowClick && typeof this.props.onRowClick === 'function') {
		      this.props.onRowClick(cell.rowIdx, this.props.rowGetter(cell.rowIdx));
		    }
		  },
	
		  onCellContextMenu: function onCellContextMenu(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx, contextMenuDisplayed: this.props.contextMenu });
		    if (this.props.contextMenu) {
		      document.addEventListener('click', this.onContextMenuHide);
		    }
		  },
	
		  onCellDoubleClick: function onCellDoubleClick(cell) {
		    this.onSelect({ rowIdx: cell.rowIdx, idx: cell.idx });
		    this.setActive('Enter');
		  },
	
		  onViewportDoubleClick: function onViewportDoubleClick() {
		    this.setActive();
		  },
	
		  onPressArrowUp: function onPressArrowUp(e) {
		    this.moveSelectedCell(e, -1, 0);
		  },
		  onPressArrowDown: function onPressArrowDown(e) {
		    this.moveSelectedCell(e, 1, 0);
		  },
		  onPressArrowLeft: function onPressArrowLeft(e) {
		    this.moveSelectedCell(e, 0, -1);
		  },
		  onPressArrowRight: function onPressArrowRight(e) {
		    this.moveSelectedCell(e, 0, 1);
		  },
		  onPressTab: function onPressTab(e) {
		    this.moveSelectedCell(e, 0, e.shiftKey ? -1 : 1);
		  },
		  onPressEnter: function onPressEnter(e) {
		    this.setActive(e.key);
		  },
		  onPressDelete: function onPressDelete(e) {
		    this.setActive(e.key);
		  },
		  onPressEscape: function onPressEscape(e) {
		    this.setInactive(e.key);
		    this.handleCancelCopy();
		  },
		  onPressBackspace: function onPressBackspace(e) {
		    this.setActive(e.key);
		  },
		  onPressChar: function onPressChar(e) {
		    if (this.isKeyPrintable(e.keyCode)) {
		      this.setActive(e.keyCode);
		    }
		  },
		  onPressKeyWithCtrl: function onPressKeyWithCtrl(e) {
		    var keys = {
		      KeyCode_c: 99,
		      KeyCode_C: 67,
		      KeyCode_V: 86,
		      KeyCode_v: 118
		    };
	
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var col = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(col, row, this.props.enableCellSelect)) {
		      if (e.keyCode === keys.KeyCode_c || e.keyCode === keys.KeyCode_C) {
		        var _value = this.getSelectedValue();
		        this.handleCopy({ value: _value });
		      } else if (e.keyCode === keys.KeyCode_v || e.keyCode === keys.KeyCode_V) {
		        this.handlePaste();
		      }
		    }
		  },
		  onGridRowsUpdated: function onGridRowsUpdated(cellKey, fromRow, toRow, updated, action, originRow) {
		    var rowIds = [];
	
		    for (var i = fromRow; i <= toRow; i++) {
		      rowIds.push(this.props.rowGetter(i)[this.props.rowKey]);
		    }
	
		    var fromRowId = this.props.rowGetter(action === 'COPY_PASTE' ? originRow : fromRow)[this.props.rowKey];
		    var toRowId = this.props.rowGetter(toRow)[this.props.rowKey];
	
		    this.props.onGridRowsUpdated({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, fromRowId: fromRowId, toRowId: toRowId, rowIds: rowIds, updated: updated, action: action });
		  },
		  onCellCommit: function onCellCommit(commit) {
		    var selected = Object.assign({}, this.state.selected);
		    selected.active = false;
		    if (commit.key === 'Tab') {
		      selected.idx += 1;
		    }
		    var expandedRows = this.state.expandedRows;
		    // if(commit.changed && commit.changed.expandedHeight){
		    //   expandedRows = this.expandRow(commit.rowIdx, commit.changed.expandedHeight);
		    // }
		    this.setState({ selected: selected, expandedRows: expandedRows });
	
		    if (this.props.onRowUpdated) {
		      this.props.onRowUpdated(commit);
		    }
	
		    var targetRow = commit.rowIdx;
	
		    if (this.props.onGridRowsUpdated) {
		      this.onGridRowsUpdated(commit.cellKey, targetRow, targetRow, commit.updated, _AppConstants2['default'].UpdateActions.CELL_UPDATE);
		    }
		  },
		  onDragStart: function onDragStart(e) {
		    var idx = this.state.selected.idx;
		    // To prevent dragging down/up when reordering rows.
		    var isViewportDragging = e && e.target && e.target.className;
		    if (idx > -1 && isViewportDragging) {
		      var _value2 = this.getSelectedValue();
		      this.handleDragStart({ idx: this.state.selected.idx, rowIdx: this.state.selected.rowIdx, value: _value2 });
		      // need to set dummy data for FF
		      if (e && e.dataTransfer) {
		        if (e.dataTransfer.setData) {
		          e.dataTransfer.dropEffect = 'move';
		          e.dataTransfer.effectAllowed = 'move';
		          e.dataTransfer.setData('text/plain', '');
		        }
		      }
		    }
		  },
		  onToggleFilter: function onToggleFilter() {
		    var _this2 = this;
	
		    // setState() does not immediately mutate this.state but creates a pending state transition.
		    // Therefore if you want to do something after the state change occurs, pass it in as a callback function.
		    this.setState({ canFilter: !this.state.canFilter }, function () {
		      if (_this2.state.canFilter === false && _this2.props.onClearFilters) {
		        _this2.props.onClearFilters();
		      }
		    });
		  },
		  onDragHandleDoubleClick: function onDragHandleDoubleClick(e) {
		    if (this.props.onDragHandleDoubleClick) {
		      this.props.onDragHandleDoubleClick(e);
		    }
	
		    if (this.props.onGridRowsUpdated) {
		      var _onGridRowsUpdated;
	
		      var cellKey = this.getColumn(e.idx).key;
		      this.onGridRowsUpdated(cellKey, e.rowIdx, this.props.rowsCount - 1, (_onGridRowsUpdated = {}, _onGridRowsUpdated[cellKey] = e.rowData[cellKey], _onGridRowsUpdated), _AppConstants2['default'].UpdateActions.COLUMN_FILL);
		    }
		  },
		  onCellExpand: function onCellExpand(args) {
		    if (this.props.onCellExpand) {
		      this.props.onCellExpand(args);
		    }
		  },
		  onRowExpandToggle: function onRowExpandToggle(args) {
		    if (typeof this.props.onRowExpandToggle === 'function') {
		      this.props.onRowExpandToggle(args);
		    }
		  },
		  isCellWithinBounds: function isCellWithinBounds(_ref) {
		    var idx = _ref.idx,
		        rowIdx = _ref.rowIdx;
	
		    return idx >= 0 && rowIdx >= 0 && idx < ColumnUtils.getSize(this.state.columnMetrics.columns) && rowIdx < this.props.rowsCount;
		  },
		  handleDragStart: function handleDragStart(dragged) {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    if (this.isCellWithinBounds(dragged)) {
		      this.setState({ dragged: dragged });
		    }
		  },
		  handleDragEnd: function handleDragEnd() {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    var _state = this.state,
		        selected = _state.selected,
		        dragged = _state.dragged;
	
		    var column = this.getColumn(this.state.selected.idx);
		    if (selected && dragged && column) {
		      var cellKey = column.key;
		      var fromRow = selected.rowIdx < dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
		      var toRow = selected.rowIdx > dragged.overRowIdx ? selected.rowIdx : dragged.overRowIdx;
		      if (this.props.onCellsDragged) {
		        this.props.onCellsDragged({ cellKey: cellKey, fromRow: fromRow, toRow: toRow, value: dragged.value });
		      }
		      if (this.props.onGridRowsUpdated) {
		        var _onGridRowsUpdated2;
	
		        this.onGridRowsUpdated(cellKey, fromRow, toRow, (_onGridRowsUpdated2 = {}, _onGridRowsUpdated2[cellKey] = dragged.value, _onGridRowsUpdated2), _AppConstants2['default'].UpdateActions.CELL_DRAG);
		      }
		    }
		    this.setState({ dragged: { complete: true } });
		  },
		  handleDragEnter: function handleDragEnter(row) {
		    if (!this.dragEnabled() || this.state.dragged == null) {
		      return;
		    }
		    var dragged = this.state.dragged;
		    dragged.overRowIdx = row;
		    this.setState({ dragged: dragged });
		  },
		  handleTerminateDrag: function handleTerminateDrag() {
		    if (!this.dragEnabled()) {
		      return;
		    }
		    this.setState({ dragged: null });
		  },
		  handlePaste: function handlePaste() {
		    if (!this.copyPasteEnabled() || !this.state.copied) {
		      return;
		    }
		    var selected = this.state.selected;
		    var cellKey = this.getColumn(this.state.selected.idx).key;
		    var textToCopy = this.state.textToCopy;
		    var fromRow = this.state.copied.rowIdx;
		    var toRow = selected.rowIdx;
	
		    if (this.props.onCellCopyPaste) {
		      this.props.onCellCopyPaste({ cellKey: cellKey, rowIdx: toRow, value: textToCopy, fromRow: fromRow, toRow: toRow });
		    }
	
		    if (this.props.onGridRowsUpdated) {
		      var _onGridRowsUpdated3;
	
		      this.onGridRowsUpdated(cellKey, toRow, toRow, (_onGridRowsUpdated3 = {}, _onGridRowsUpdated3[cellKey] = textToCopy, _onGridRowsUpdated3), _AppConstants2['default'].UpdateActions.COPY_PASTE, fromRow);
		    }
		  },
		  handleCancelCopy: function handleCancelCopy() {
		    this.setState({ copied: null });
		  },
		  handleCopy: function handleCopy(args) {
		    if (!this.copyPasteEnabled()) {
		      return;
		    }
		    var textToCopy = args.value;
		    var selected = this.state.selected;
		    var copied = { idx: selected.idx, rowIdx: selected.rowIdx };
		    this.setState({ textToCopy: textToCopy, copied: copied });
		  },
	
	
		  handleSort: function handleSort(columnKey, direction) {
		    this.setState({ sortDirection: direction, sortColumn: columnKey }, function () {
		      this.props.onGridSort(columnKey, direction);
		    });
		  },
	
		  getSelectedRow: function getSelectedRow(rows, key) {
		    var _this3 = this;
	
		    var selectedRow = rows.filter(function (r) {
		      if (r[_this3.props.rowKey] === key) {
		        return true;
		      }
		      return false;
		    });
		    if (selectedRow.length > 0) {
		      return selectedRow[0];
		    }
		  },
		  useNewRowSelection: function useNewRowSelection() {
		    return this.props.rowSelection && this.props.rowSelection.selectBy;
		  },
	
		  // return false if not a shift select so can be handled as normal row selection
		  handleShiftSelect: function handleShiftSelect(rowIdx) {
		    if (this.state.lastRowIdxUiSelected > -1 && this.isSingleKeyDown(KeyCodes.Shift)) {
		      var _props$rowSelection$s = this.props.rowSelection.selectBy,
		          keys = _props$rowSelection$s.keys,
		          indexes = _props$rowSelection$s.indexes,
		          isSelectedKey = _props$rowSelection$s.isSelectedKey;
	
		      var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, this.props.rowGetter(rowIdx), rowIdx);
	
		      if (isPreviouslySelected) return false;
	
		      var handled = false;
	
		      if (rowIdx > this.state.lastRowIdxUiSelected) {
		        var rowsSelected = [];
	
		        for (var i = this.state.lastRowIdxUiSelected + 1; i <= rowIdx; i++) {
		          rowsSelected.push({ rowIdx: i, row: this.props.rowGetter(i) });
		        }
	
		        if (typeof this.props.rowSelection.onRowsSelected === 'function') {
		          this.props.rowSelection.onRowsSelected(rowsSelected);
		        }
	
		        handled = true;
		      } else if (rowIdx < this.state.lastRowIdxUiSelected) {
		        var _rowsSelected = [];
	
		        for (var _i = rowIdx; _i <= this.state.lastRowIdxUiSelected - 1; _i++) {
		          _rowsSelected.push({ rowIdx: _i, row: this.props.rowGetter(_i) });
		        }
	
		        if (typeof this.props.rowSelection.onRowsSelected === 'function') {
		          this.props.rowSelection.onRowsSelected(_rowsSelected);
		        }
	
		        handled = true;
		      }
	
		      if (handled) {
		        this.setState({ lastRowIdxUiSelected: rowIdx });
		      }
	
		      return handled;
		    }
	
		    return false;
		  },
		  handleNewRowSelect: function handleNewRowSelect(rowIdx, rowData) {
		    var _props$rowSelection$s2 = this.props.rowSelection.selectBy,
		        keys = _props$rowSelection$s2.keys,
		        indexes = _props$rowSelection$s2.indexes,
		        isSelectedKey = _props$rowSelection$s2.isSelectedKey;
	
		    var isPreviouslySelected = RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, rowIdx);
	
		    this.setState({ lastRowIdxUiSelected: isPreviouslySelected ? -1 : rowIdx, selected: { rowIdx: rowIdx, idx: 0 } });
	
		    if (isPreviouslySelected && typeof this.props.rowSelection.onRowsDeselected === 'function') {
		      this.props.rowSelection.onRowsDeselected([{ rowIdx: rowIdx, row: rowData }]);
		    } else if (!isPreviouslySelected && typeof this.props.rowSelection.onRowsSelected === 'function') {
		      this.props.rowSelection.onRowsSelected([{ rowIdx: rowIdx, row: rowData }]);
		    }
		  },
	
		  // columnKey not used here as this function will select the whole row,
		  // but needed to match the function signature in the CheckboxEditor
		  handleRowSelect: function handleRowSelect(rowIdx, columnKey, rowData, e) {
		    e.stopPropagation();
	
		    if (this.useNewRowSelection()) {
		      if (this.props.rowSelection.enableShiftSelect === true) {
		        if (!this.handleShiftSelect(rowIdx)) {
		          this.handleNewRowSelect(rowIdx, rowData);
		        }
		      } else {
		        this.handleNewRowSelect(rowIdx, rowData);
		      }
		    } else {
		      // Fallback to old onRowSelect handler
		      var _selectedRows = this.props.enableRowSelect === 'single' ? [] : this.state.selectedRows.slice(0);
		      var selectedRow = this.getSelectedRow(_selectedRows, rowData[this.props.rowKey]);
		      if (selectedRow) {
		        selectedRow.isSelected = !selectedRow.isSelected;
		      } else {
		        rowData.isSelected = true;
		        _selectedRows.push(rowData);
		      }
		      this.setState({ selectedRows: _selectedRows, selected: { rowIdx: rowIdx, idx: 0 } });
		      if (this.props.onRowSelect) {
		        this.props.onRowSelect(_selectedRows.filter(function (r) {
		          return r.isSelected === true;
		        }));
		      }
		    }
		  },
	
	
		  handleCheckboxChange: function handleCheckboxChange(e) {
		    var allRowsSelected = void 0;
		    if (e.currentTarget instanceof HTMLInputElement && e.currentTarget.checked === true) {
		      allRowsSelected = true;
		    } else {
		      allRowsSelected = false;
		    }
		    if (this.useNewRowSelection()) {
		      var _props$rowSelection$s3 = this.props.rowSelection.selectBy,
		          keys = _props$rowSelection$s3.keys,
		          indexes = _props$rowSelection$s3.indexes,
		          isSelectedKey = _props$rowSelection$s3.isSelectedKey;
	
	
		      if (allRowsSelected && typeof this.props.rowSelection.onRowsSelected === 'function') {
		        var _selectedRows2 = [];
		        for (var i = 0; i < this.props.rowsCount; i++) {
		          var rowData = this.props.rowGetter(i);
		          if (!RowUtils.isRowSelected(keys, indexes, isSelectedKey, rowData, i)) {
		            _selectedRows2.push({ rowIdx: i, row: rowData });
		          }
		        }
	
		        if (_selectedRows2.length > 0) {
		          this.props.rowSelection.onRowsSelected(_selectedRows2);
		        }
		      } else if (!allRowsSelected && typeof this.props.rowSelection.onRowsDeselected === 'function') {
		        var deselectedRows = [];
		        for (var _i2 = 0; _i2 < this.props.rowsCount; _i2++) {
		          var _rowData = this.props.rowGetter(_i2);
		          if (RowUtils.isRowSelected(keys, indexes, isSelectedKey, _rowData, _i2)) {
		            deselectedRows.push({ rowIdx: _i2, row: _rowData });
		          }
		        }
	
		        if (deselectedRows.length > 0) {
		          this.props.rowSelection.onRowsDeselected(deselectedRows);
		        }
		      }
		    } else {
		      var _selectedRows3 = [];
		      for (var _i3 = 0; _i3 < this.props.rowsCount; _i3++) {
		        var row = Object.assign({}, this.props.rowGetter(_i3), { isSelected: allRowsSelected });
		        _selectedRows3.push(row);
		      }
		      this.setState({ selectedRows: _selectedRows3 });
		      if (typeof this.props.onRowSelect === 'function') {
		        this.props.onRowSelect(_selectedRows3.filter(function (r) {
		          return r.isSelected === true;
		        }));
		      }
		    }
		  },
	
		  getScrollOffSet: function getScrollOffSet() {
		    var scrollOffset = 0;
		    var canvas = ReactDOM.findDOMNode(this).querySelector('.react-grid-Canvas');
		    if (canvas) {
		      scrollOffset = canvas.offsetWidth - canvas.clientWidth;
		    }
		    this.setState({ scrollOffset: scrollOffset });
		  },
		  getRowOffsetHeight: function getRowOffsetHeight() {
		    var offsetHeight = 0;
		    this.getHeaderRows().forEach(function (row) {
		      return offsetHeight += parseFloat(row.height, 10);
		    });
		    return offsetHeight;
		  },
		  getHeaderRows: function getHeaderRows() {
		    var _this4 = this;
	
		    var rows = [{ ref: function ref(node) {
		        return _this4.row = node;
		      }, height: this.props.headerRowHeight || this.props.rowHeight, rowType: 'header' }];
		    if (this.state.canFilter === true) {
		      rows.push({
		        ref: function ref(node) {
		          return _this4.filterRow = node;
		        },
		        filterable: true,
		        onFilterChange: this.props.onAddFilter,
		        height: this.props.headerFiltersHeight,
		        rowType: 'filter'
		      });
		    }
		    return rows;
		  },
	
		  getInitialSelectedRows: function getInitialSelectedRows() {
		    var selectedRows = [];
		    for (var i = 0; i < this.props.rowsCount; i++) {
		      selectedRows.push(false);
		    }
		    return selectedRows;
		  },
		  getRowSelectionProps: function getRowSelectionProps() {
		    if (this.props.rowSelection) {
		      return this.props.rowSelection.selectBy;
		    }
	
		    return null;
		  },
		  getSelectedRows: function getSelectedRows() {
		    if (this.props.rowSelection) {
		      return null;
		    }
	
		    return this.state.selectedRows.filter(function (r) {
		      return r.isSelected === true;
		    });
		  },
		  getSelectedValue: function getSelectedValue() {
		    var rowIdx = this.state.selected.rowIdx;
		    var idx = this.state.selected.idx;
		    var cellKey = this.getColumn(idx).key;
		    var row = this.props.rowGetter(rowIdx);
		    return RowUtils.get(row, cellKey);
		  },
		  moveSelectedCell: function moveSelectedCell(e, rowDelta, cellDelta) {
		    // we need to prevent default as we control grid scroll
		    // otherwise it moves every time you left/right which is janky
		    e.preventDefault();
		    var rowIdx = void 0;
		    var idx = void 0;
		    var cellNavigationMode = this.props.cellNavigationMode;
	
		    if (cellNavigationMode !== 'none') {
		      var _calculateNextSelecti = this.calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta);
	
		      idx = _calculateNextSelecti.idx;
		      rowIdx = _calculateNextSelecti.rowIdx;
		    } else {
		      rowIdx = this.state.selected.rowIdx + rowDelta;
		      idx = this.state.selected.idx + cellDelta;
		    }
		    this.onSelect({ idx: idx, rowIdx: rowIdx });
		  },
		  getNbrColumns: function getNbrColumns() {
		    var _props = this.props,
		        columns = _props.columns,
		        enableRowSelect = _props.enableRowSelect;
	
		    return enableRowSelect ? columns.length + 1 : columns.length;
		  },
		  getDataGridDOMNode: function getDataGridDOMNode() {
		    if (!this._gridNode) {
		      this._gridNode = ReactDOM.findDOMNode(this);
		    }
		    return this._gridNode;
		  },
		  calculateNextSelectionPosition: function calculateNextSelectionPosition(cellNavigationMode, cellDelta, rowDelta) {
		    var _rowDelta = rowDelta;
		    var idx = this.state.selected.idx + cellDelta;
		    var nbrColumns = this.getNbrColumns();
		    if (cellDelta > 0) {
		      if (this.isAtLastCellInRow(nbrColumns)) {
		        if (cellNavigationMode === 'changeRow') {
		          _rowDelta = this.isAtLastRow() ? rowDelta : rowDelta + 1;
		          idx = this.isAtLastRow() ? idx : 0;
		        } else {
		          idx = 0;
		        }
		      }
		    } else if (cellDelta < 0) {
		      if (this.isAtFirstCellInRow()) {
		        if (cellNavigationMode === 'changeRow') {
		          _rowDelta = this.isAtFirstRow() ? rowDelta : rowDelta - 1;
		          idx = this.isAtFirstRow() ? 0 : nbrColumns - 1;
		        } else {
		          idx = nbrColumns - 1;
		        }
		      }
		    }
		    var rowIdx = this.state.selected.rowIdx + _rowDelta;
		    return { idx: idx, rowIdx: rowIdx };
		  },
		  isAtLastCellInRow: function isAtLastCellInRow(nbrColumns) {
		    return this.state.selected.idx === nbrColumns - 1;
		  },
		  isAtLastRow: function isAtLastRow() {
		    return this.state.selected.rowIdx === this.props.rowsCount - 1;
		  },
		  isAtFirstCellInRow: function isAtFirstCellInRow() {
		    return this.state.selected.idx === 0;
		  },
		  isAtFirstRow: function isAtFirstRow() {
		    return this.state.selected.rowIdx === 0;
		  },
		  openCellEditor: function openCellEditor(rowIdx, idx) {
		    var _this5 = this;
	
		    var row = this.props.rowGetter(rowIdx);
		    var col = this.getColumn(idx);
	
		    if (!ColumnUtils.canEdit(col, row, this.props.enableCellSelect)) {
		      return;
		    }
	
		    var selected = { rowIdx: rowIdx, idx: idx };
		    if (this.hasSelectedCellChanged(selected)) {
		      this.setState({ selected: selected }, function () {
		        _this5.setActive('Enter');
		      });
		    } else {
		      this.setActive('Enter');
		    }
		  },
		  scrollToColumn: function scrollToColumn(colIdx) {
		    var canvas = ReactDOM.findDOMNode(this).querySelector('.react-grid-Canvas');
		    if (canvas) {
		      var left = 0;
		      var locked = 0;
	
		      for (var i = 0; i < colIdx; i++) {
		        var column = this.getColumn(i);
		        if (column) {
		          if (column.width) {
		            left += column.width;
		          }
		          if (column.locked) {
		            locked += column.width;
		          }
		        }
		      }
	
		      var selectedColumn = this.getColumn(colIdx);
		      if (selectedColumn) {
		        var scrollLeft = left - locked - canvas.scrollLeft;
		        var scrollRight = left + selectedColumn.width - canvas.scrollLeft;
	
		        if (scrollLeft < 0) {
		          canvas.scrollLeft += scrollLeft;
		        } else if (scrollRight > canvas.clientWidth) {
		          var scrollAmount = scrollRight - canvas.clientWidth;
		          canvas.scrollLeft += scrollAmount;
		        }
		      }
		    }
		  },
		  setActive: function setActive(keyPressed) {
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var column = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(column, row, this.props.enableCellSelect) && !this.isActive()) {
		      var _selected = Object.assign({}, this.state.selected, { idx: idx, rowIdx: rowIdx, active: true, initialKeyCode: keyPressed });
		      var showEditor = true;
		      if (typeof this.props.onCheckCellIsEditable === 'function') {
		        var args = Object.assign({}, { row: row, column: column }, _selected);
		        showEditor = this.props.onCheckCellIsEditable(args);
		      }
		      if (showEditor !== false) {
		        this.setState({ selected: _selected }, this.scrollToColumn(idx));
		        this.handleCancelCopy();
		      }
		    }
		  },
		  setInactive: function setInactive() {
		    var rowIdx = this.state.selected.rowIdx;
		    var row = this.props.rowGetter(rowIdx);
	
		    var idx = this.state.selected.idx;
		    var col = this.getColumn(idx);
	
		    if (ColumnUtils.canEdit(col, row, this.props.enableCellSelect) && this.isActive()) {
		      var _selected2 = Object.assign({}, this.state.selected, { idx: idx, rowIdx: rowIdx, active: false });
		      this.setState({ selected: _selected2 });
		    }
		  },
		  isActive: function isActive() {
		    return this.state.selected.active === true;
		  },
	
	
		  setupGridColumns: function setupGridColumns() {
		    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
		    var columns = props.columns;
	
		    if (this._cachedColumns === columns) {
		      return this._cachedComputedColumns;
		    }
	
		    this._cachedColumns = columns;
	
		    var cols = columns.slice(0);
		    var unshiftedCols = {};
		    if (this.props.rowActionsCell || props.enableRowSelect && !this.props.rowSelection || props.rowSelection && props.rowSelection.showCheckbox !== false) {
		      var headerRenderer = props.enableRowSelect === 'single' ? null : React.createElement(
		        'div',
		        { className: 'react-grid-checkbox-container' },
		        React.createElement('input', { className: 'react-grid-checkbox', type: 'checkbox', name: 'select-all-checkbox', id: 'select-all-checkbox', onChange: this.handleCheckboxChange }),
		        React.createElement('label', { htmlFor: 'select-all-checkbox', className: 'react-grid-checkbox-label' })
		      );
		      var Formatter = this.props.rowActionsCell ? this.props.rowActionsCell : CheckboxEditor;
		      var selectColumn = {
		        key: 'select-row',
		        name: '',
		        formatter: React.createElement(Formatter, { rowSelection: this.props.rowSelection }),
		        onCellChange: this.handleRowSelect,
		        filterable: false,
		        headerRenderer: headerRenderer,
		        width: 60,
		        locked: true,
		        getRowMetaData: function getRowMetaData(rowData) {
		          return rowData;
		        },
		        cellClass: this.props.rowActionsCell ? 'rdg-row-actions-cell' : ''
		      };
		      unshiftedCols = cols.unshift(selectColumn);
		      cols = unshiftedCols > 0 ? cols : unshiftedCols;
		    }
		    this._cachedComputedColumns = cols;
	
		    return this._cachedComputedColumns;
		  },
	
		  copyPasteEnabled: function copyPasteEnabled() {
		    return this.props.onCellCopyPaste !== null;
		  },
	
		  dragEnabled: function dragEnabled() {
		    return this.props.onGridRowsUpdated !== undefined || this.props.onCellsDragged !== undefined;
		  },
	
		  renderToolbar: function renderToolbar() {
		    var Toolbar = this.props.toolbar;
		    if (React.isValidElement(Toolbar)) {
		      return React.cloneElement(Toolbar, { columns: this.props.columns, onToggleFilter: this.onToggleFilter, numberOfRows: this.props.rowsCount });
		    }
		  },
		  render: function render() {
		    var _this6 = this;
	
		    var cellMetaData = {
		      selected: this.state.selected,
		      dragged: this.state.dragged,
		      hoveredRowIdx: this.state.hoveredRowIdx,
		      onCellClick: this.onCellClick,
		      onCellContextMenu: this.onCellContextMenu,
		      onCellDoubleClick: this.onCellDoubleClick,
		      onCommit: this.onCellCommit,
		      onCommitCancel: this.setInactive,
		      copied: this.state.copied,
		      handleDragEnterRow: this.handleDragEnter,
		      handleTerminateDrag: this.handleTerminateDrag,
		      enableCellSelect: this.props.enableCellSelect,
		      onColumnEvent: this.onColumnEvent,
		      openCellEditor: this.openCellEditor,
		      onDragHandleDoubleClick: this.onDragHandleDoubleClick,
		      onCellExpand: this.onCellExpand,
		      onRowExpandToggle: this.onRowExpandToggle,
		      onRowHover: this.onRowHover,
		      getDataGridDOMNode: this.getDataGridDOMNode,
		      isScrollingVerticallyWithKeyboard: this.isKeyDown(KeyCodes.DownArrow) || this.isKeyDown(KeyCodes.UpArrow),
		      isScrollingHorizontallyWithKeyboard: this.isKeyDown(KeyCodes.LeftArrow) || this.isKeyDown(KeyCodes.RightArrow) || this.isKeyDown(KeyCodes.Tab)
		    };
	
		    var toolbar = this.renderToolbar();
		    var containerWidth = this.props.minWidth || this.DOMMetrics.gridWidth();
		    var gridWidth = containerWidth - this.state.scrollOffset;
	
		    // depending on the current lifecycle stage, gridWidth() may not initialize correctly
		    // this also handles cases where it always returns undefined -- such as when inside a div with display:none
		    // eg Bootstrap tabs and collapses
		    if (typeof containerWidth === 'undefined' || isNaN(containerWidth) || containerWidth === 0) {
		      containerWidth = '100%';
		    }
		    if (typeof gridWidth === 'undefined' || isNaN(gridWidth) || gridWidth === 0) {
		      gridWidth = '100%';
		    }
		    return React.createElement(
		      'div',
		      { className: 'react-grid-Container', style: { width: containerWidth } },
		      toolbar,
		      React.createElement(
		        'div',
		        { className: 'react-grid-Main' },
		        React.createElement(BaseGrid, _extends({
		          ref: function ref(node) {
		            return _this6.base = node;
		          }
		        }, this.props, {
		          rowKey: this.props.rowKey,
		          headerRows: this.getHeaderRows(),
		          columnMetrics: this.state.columnMetrics,
		          rowGetter: this.props.rowGetter,
		          rowsCount: this.props.rowsCount,
		          rowHeight: this.props.rowHeight,
		          cellMetaData: cellMetaData,
		          selectedRows: this.getSelectedRows(),
		          rowSelection: this.getRowSelectionProps(),
		          expandedRows: this.state.expandedRows,
		          rowOffsetHeight: this.getRowOffsetHeight(),
		          sortColumn: this.state.sortColumn,
		          sortDirection: this.state.sortDirection,
		          onSort: this.handleSort,
		          minHeight: this.props.minHeight,
		          totalWidth: gridWidth,
		          onViewportKeydown: this.onKeyDown,
		          onViewportKeyup: this.onKeyUp,
		          onViewportDragStart: this.onDragStart,
		          onViewportDragEnd: this.handleDragEnd,
		          onViewportDoubleClick: this.onViewportDoubleClick,
		          onColumnResize: this.onColumnResize,
		          rowScrollTimeout: this.props.rowScrollTimeout,
		          contextMenu: this.props.contextMenu,
		          overScan: this.props.overScan }))
		      )
		    );
		  }
		});
	
		module.exports = ReactDataGrid;
	
	/***/ },
	/* 173 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var Draggable = __webpack_require__(163);
		__webpack_require__(18);
	
		var ResizeHandle = React.createClass({
		  displayName: 'ResizeHandle',
	
		  style: {
		    position: 'absolute',
		    top: 0,
		    right: 0,
		    width: 6,
		    height: '100%'
		  },
	
		  render: function render() {
		    return React.createElement(Draggable, _extends({}, this.props, {
		      className: 'react-grid-HeaderCell__resizeHandle',
		      style: this.style
		    }));
		  }
		});
	
		module.exports = ResizeHandle;
	
	/***/ },
	/* 174 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _classnames = __webpack_require__(9);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		__webpack_require__(27);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var RowGroup = function (_Component) {
		  _inherits(RowGroup, _Component);
	
		  function RowGroup() {
		    _classCallCheck(this, RowGroup);
	
		    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
		    _this.checkFocus = _this.checkFocus.bind(_this);
		    _this.isSelected = _this.isSelected.bind(_this);
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onRowExpandToggle = _this.onRowExpandToggle.bind(_this);
		    _this.onKeyDown = _this.onKeyDown.bind(_this);
		    _this.onRowExpandClick = _this.onRowExpandClick.bind(_this);
		    return _this;
		  }
	
		  RowGroup.prototype.componentDidMount = function componentDidMount() {
		    this.checkFocus();
		  };
	
		  RowGroup.prototype.componentDidUpdate = function componentDidUpdate() {
		    this.checkFocus();
		  };
	
		  RowGroup.prototype.isSelected = function isSelected() {
		    var meta = this.props.cellMetaData;
		    if (meta == null) {
		      return false;
		    }
	
		    return meta.selected && meta.selected.rowIdx === this.props.idx;
		  };
	
		  RowGroup.prototype.onClick = function onClick(e) {
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onCellClick && typeof meta.onCellClick === 'function') {
		      meta.onCellClick({ rowIdx: this.props.idx, idx: 0 }, e);
		    }
		  };
	
		  RowGroup.prototype.onKeyDown = function onKeyDown(e) {
		    if (e.key === 'ArrowLeft') {
		      this.onRowExpandToggle(false);
		    }
		    if (e.key === 'ArrowRight') {
		      this.onRowExpandToggle(true);
		    }
		    if (e.key === 'Enter') {
		      this.onRowExpandToggle(!this.props.isExpanded);
		    }
		  };
	
		  RowGroup.prototype.onRowExpandClick = function onRowExpandClick() {
		    this.onRowExpandToggle(!this.props.isExpanded);
		  };
	
		  RowGroup.prototype.onRowExpandToggle = function onRowExpandToggle(expand) {
		    var shouldExpand = expand == null ? !this.props.isExpanded : expand;
		    var meta = this.props.cellMetaData;
		    if (meta != null && meta.onRowExpandToggle && typeof meta.onRowExpandToggle === 'function') {
		      meta.onRowExpandToggle({ rowIdx: this.props.idx, shouldExpand: shouldExpand, columnGroupName: this.props.columnGroupName, name: this.props.name });
		    }
		  };
	
		  RowGroup.prototype.getClassName = function getClassName() {
		    return (0, _classnames2['default'])('react-grid-row-group', 'react-grid-Row', { 'row-selected': this.isSelected() });
		  };
	
		  RowGroup.prototype.checkFocus = function checkFocus() {
		    if (this.isSelected()) {
		      _reactDom2['default'].findDOMNode(this).focus();
		    }
		  };
	
		  RowGroup.prototype.render = function render() {
		    var style = {
		      height: '50px',
		      overflow: 'hidden',
		      border: '1px solid #dddddd',
		      paddingTop: '15px',
		      paddingLeft: '5px'
		    };
		    var rowGroupRendererProps = Object.assign({ onRowExpandClick: this.onRowExpandClick }, this.props);
	
		    return _react2['default'].createElement(
		      'div',
		      { style: style, className: this.getClassName(), onClick: this.onClick, onKeyDown: this.onKeyDown, tabIndex: -1 },
		      _react2['default'].createElement(this.props.renderer, rowGroupRendererProps)
		    );
		  };
	
		  return RowGroup;
		}(_react.Component);
	
		RowGroup.propTypes = {
		  name: _react.PropTypes.string.isRequired,
		  columnGroupName: _react.PropTypes.string.isRequired,
		  isExpanded: _react.PropTypes.bool.isRequired,
		  treeDepth: _react.PropTypes.number.isRequired,
		  height: _react.PropTypes.number.isRequired,
		  cellMetaData: _react.PropTypes.object,
		  idx: _react.PropTypes.number.isRequired,
		  renderer: _react.PropTypes.func
		};
	
		var DefaultRowGroupRenderer = function DefaultRowGroupRenderer(props) {
		  var treeDepth = props.treeDepth || 0;
		  var marginLeft = treeDepth * 20;
	
		  return _react2['default'].createElement(
		    'div',
		    null,
		    _react2['default'].createElement(
		      'span',
		      { className: 'row-expand-icon', style: { float: 'left', marginLeft: marginLeft, cursor: 'pointer' }, onClick: props.onRowExpandClick },
		      props.isExpanded ? String.fromCharCode('9660') : String.fromCharCode('9658')
		    ),
		    _react2['default'].createElement(
		      'strong',
		      null,
		      props.columnGroupName,
		      ' : ',
		      props.name
		    )
		  );
		};
	
		DefaultRowGroupRenderer.propTypes = {
		  onRowExpandClick: _react.PropTypes.func.isRequired,
		  isExpanded: _react.PropTypes.bool.isRequired,
		  treeDepth: _react.PropTypes.number.isRequired,
		  name: _react.PropTypes.string.isRequired,
		  columnGroupName: _react.PropTypes.string.isRequired
		};
	
		RowGroup.defaultProps = {
		  renderer: DefaultRowGroupRenderer
		};
	
		exports['default'] = RowGroup;
	
	/***/ },
	/* 175 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var ScrollShim = {
		  appendScrollShim: function appendScrollShim() {
		    if (!this._scrollShim) {
		      var size = this._scrollShimSize();
		      var shim = document.createElement('div');
		      if (shim.classList) {
		        shim.classList.add('react-grid-ScrollShim'); // flow - not compatible with HTMLElement
		      } else {
		        shim.className += ' react-grid-ScrollShim';
		      }
		      shim.style.position = 'absolute';
		      shim.style.top = 0;
		      shim.style.left = 0;
		      shim.style.width = size.width + 'px';
		      shim.style.height = size.height + 'px';
		      _reactDom2['default'].findDOMNode(this).appendChild(shim);
		      this._scrollShim = shim;
		    }
		    this._scheduleRemoveScrollShim();
		  },
		  _scrollShimSize: function _scrollShimSize() {
		    return {
		      width: this.props.width,
		      height: this.props.length * this.props.rowHeight
		    };
		  },
		  _scheduleRemoveScrollShim: function _scheduleRemoveScrollShim() {
		    if (this._scheduleRemoveScrollShimTimer) {
		      clearTimeout(this._scheduleRemoveScrollShimTimer);
		    }
		    this._scheduleRemoveScrollShimTimer = setTimeout(this._removeScrollShim, 200);
		  },
		  _removeScrollShim: function _removeScrollShim() {
		    if (this._scrollShim) {
		      this._scrollShim.parentNode.removeChild(this._scrollShim);
		      this._scrollShim = undefined;
		    }
		  }
		};
	
		module.exports = ScrollShim;
	
	/***/ },
	/* 176 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var Canvas = __webpack_require__(160);
		var ViewportScroll = __webpack_require__(177);
		var cellMetaDataShape = __webpack_require__(14);
		var PropTypes = React.PropTypes;
	
		var Viewport = React.createClass({
		  displayName: 'Viewport',
	
		  mixins: [ViewportScroll],
	
		  propTypes: {
		    rowOffsetHeight: PropTypes.number.isRequired,
		    totalWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
		    columnMetrics: PropTypes.object.isRequired,
		    rowGetter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
		    selectedRows: PropTypes.array,
		    rowSelection: React.PropTypes.oneOfType([React.PropTypes.shape({
		      indexes: React.PropTypes.arrayOf(React.PropTypes.number).isRequired
		    }), React.PropTypes.shape({
		      isSelectedKey: React.PropTypes.string.isRequired
		    }), React.PropTypes.shape({
		      keys: React.PropTypes.shape({
		        values: React.PropTypes.array.isRequired,
		        rowKey: React.PropTypes.string.isRequired
		      }).isRequired
		    })]),
		    expandedRows: PropTypes.array,
		    rowRenderer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		    rowsCount: PropTypes.number.isRequired,
		    rowHeight: PropTypes.number.isRequired,
		    onRows: PropTypes.func,
		    onScroll: PropTypes.func,
		    minHeight: PropTypes.number,
		    cellMetaData: PropTypes.shape(cellMetaDataShape),
		    rowKey: PropTypes.string.isRequired,
		    rowScrollTimeout: PropTypes.number,
		    contextMenu: PropTypes.element,
		    getSubRowDetails: PropTypes.func,
		    rowGroupRenderer: PropTypes.func
		  },
	
		  onScroll: function onScroll(scroll) {
		    this.updateScroll(scroll.scrollTop, scroll.scrollLeft, this.state.height, this.props.rowHeight, this.props.rowsCount);
	
		    if (this.props.onScroll) {
		      this.props.onScroll({ scrollTop: scroll.scrollTop, scrollLeft: scroll.scrollLeft });
		    }
		  },
		  getScroll: function getScroll() {
		    return this.canvas.getScroll();
		  },
		  setScrollLeft: function setScrollLeft(scrollLeft) {
		    this.canvas.setScrollLeft(scrollLeft);
		  },
		  render: function render() {
		    var _this = this;
	
		    var style = {
		      padding: 0,
		      bottom: 0,
		      left: 0,
		      right: 0,
		      overflow: 'hidden',
		      position: 'absolute',
		      top: this.props.rowOffsetHeight
		    };
		    return React.createElement(
		      'div',
		      {
		        className: 'react-grid-Viewport',
		        style: style },
		      React.createElement(Canvas, {
		        ref: function ref(node) {
		          return _this.canvas = node;
		        },
		        rowKey: this.props.rowKey,
		        totalWidth: this.props.totalWidth,
		        width: this.props.columnMetrics.width,
		        rowGetter: this.props.rowGetter,
		        rowsCount: this.props.rowsCount,
		        selectedRows: this.props.selectedRows,
		        expandedRows: this.props.expandedRows,
		        columns: this.props.columnMetrics.columns,
		        rowRenderer: this.props.rowRenderer,
		        displayStart: this.state.displayStart,
		        displayEnd: this.state.displayEnd,
		        visibleStart: this.state.visibleStart,
		        visibleEnd: this.state.visibleEnd,
		        colVisibleStart: this.state.colVisibleStart,
		        colVisibleEnd: this.state.colVisibleEnd,
		        colDisplayStart: this.state.colDisplayStart,
		        colDisplayEnd: this.state.colDisplayEnd,
		        cellMetaData: this.props.cellMetaData,
		        height: this.state.height,
		        rowHeight: this.props.rowHeight,
		        onScroll: this.onScroll,
		        onRows: this.props.onRows,
		        rowScrollTimeout: this.props.rowScrollTimeout,
		        contextMenu: this.props.contextMenu,
		        rowSelection: this.props.rowSelection,
		        getSubRowDetails: this.props.getSubRowDetails,
		        rowGroupRenderer: this.props.rowGroupRenderer,
		        isScrolling: this.state.isScrolling || false
		      })
		    );
		  }
		});
	
		module.exports = Viewport;
	
	/***/ },
	/* 177 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _ColumnUtils = __webpack_require__(10);
	
		var _ColumnUtils2 = _interopRequireDefault(_ColumnUtils);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var React = __webpack_require__(2);
		var ReactDOM = __webpack_require__(4);
		var DOMMetrics = __webpack_require__(22);
		var min = Math.min;
		var max = Math.max;
		var floor = Math.floor;
		var ceil = Math.ceil;
	
		module.exports = {
		  mixins: [DOMMetrics.MetricsMixin],
	
		  DOMMetrics: {
		    viewportHeight: function viewportHeight() {
		      return ReactDOM.findDOMNode(this).offsetHeight;
		    },
		    viewportWidth: function viewportWidth() {
		      return ReactDOM.findDOMNode(this).offsetWidth;
		    }
		  },
	
		  propTypes: {
		    rowHeight: React.PropTypes.number,
		    rowsCount: React.PropTypes.number.isRequired
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      rowHeight: 30
		    };
		  },
		  getInitialState: function getInitialState() {
		    return this.getGridState(this.props);
		  },
		  getGridState: function getGridState(props) {
		    var totalNumberColumns = _ColumnUtils2['default'].getSize(props.columnMetrics.columns);
		    var canvasHeight = props.minHeight - props.rowOffsetHeight;
		    var renderedRowsCount = ceil((props.minHeight - props.rowHeight) / props.rowHeight);
		    var totalRowCount = min(renderedRowsCount * 4, props.rowsCount);
		    return {
		      displayStart: 0,
		      displayEnd: totalRowCount,
		      visibleStart: 0,
		      visibleEnd: totalRowCount,
		      height: canvasHeight,
		      scrollTop: 0,
		      scrollLeft: 0,
		      colVisibleStart: 0,
		      colVisibleEnd: totalNumberColumns,
		      colDisplayStart: 0,
		      colDisplayEnd: totalNumberColumns
		    };
		  },
		  getRenderedColumnCount: function getRenderedColumnCount(displayStart, width) {
		    var remainingWidth = width > 0 ? width : this.props.columnMetrics.totalWidth;
		    if (remainingWidth === 0) {
		      remainingWidth = ReactDOM.findDOMNode(this).offsetWidth;
		    }
		    var columnIndex = displayStart;
		    var columnCount = 0;
		    while (remainingWidth > 0) {
		      var column = _ColumnUtils2['default'].getColumn(this.props.columnMetrics.columns, columnIndex);
	
		      if (!column) {
		        break;
		      }
	
		      columnCount++;
		      columnIndex++;
		      remainingWidth -= column.width;
		    }
		    return columnCount;
		  },
		  getVisibleColStart: function getVisibleColStart(scrollLeft) {
		    var remainingScroll = scrollLeft;
		    var columnIndex = -1;
		    while (remainingScroll >= 0) {
		      columnIndex++;
		      remainingScroll -= _ColumnUtils2['default'].getColumn(this.props.columnMetrics.columns, columnIndex).width;
		    }
		    return columnIndex;
		  },
		  resetScrollStateAfterDelay: function resetScrollStateAfterDelay() {
		    if (this.resetScrollStateTimeoutId) {
		      clearTimeout(this.resetScrollStateTimeoutId);
		    }
	
		    this.resetScrollStateTimeoutId = setTimeout(this.resetScrollStateAfterDelayCallback, 500);
		  },
		  resetScrollStateAfterDelayCallback: function resetScrollStateAfterDelayCallback() {
		    this.resetScrollStateTimeoutId = null;
		    this.setState({
		      isScrolling: false
		    });
		  },
		  updateScroll: function updateScroll(scrollTop, scrollLeft, height, rowHeight, length, width) {
		    var isScrolling = true;
		    this.resetScrollStateAfterDelay();
	
		    var renderedRowsCount = ceil(height / rowHeight);
	
		    var visibleStart = max(0, floor(scrollTop / rowHeight));
	
		    var visibleEnd = min(visibleStart + renderedRowsCount, length);
	
		    var displayStart = max(0, visibleStart - this.props.overScan.rowsStart);
	
		    var displayEnd = min(visibleEnd + this.props.overScan.rowsEnd, length);
	
		    var totalNumberColumns = _ColumnUtils2['default'].getSize(this.props.columnMetrics.columns);
		    var colVisibleStart = totalNumberColumns > 0 ? max(0, this.getVisibleColStart(scrollLeft)) : 0;
		    var renderedColumnCount = this.getRenderedColumnCount(colVisibleStart, width);
		    var colVisibleEnd = renderedColumnCount !== 0 ? colVisibleStart + renderedColumnCount : totalNumberColumns;
		    var colDisplayStart = max(0, colVisibleStart - this.props.overScan.colsStart);
		    var colDisplayEnd = min(colVisibleEnd + this.props.overScan.colsEnd, totalNumberColumns);
	
		    var nextScrollState = {
		      visibleStart: visibleStart,
		      visibleEnd: visibleEnd,
		      displayStart: displayStart,
		      displayEnd: displayEnd,
		      height: height,
		      scrollTop: scrollTop,
		      scrollLeft: scrollLeft,
		      colVisibleStart: colVisibleStart,
		      colVisibleEnd: colVisibleEnd,
		      colDisplayStart: colDisplayStart,
		      colDisplayEnd: colDisplayEnd,
		      isScrolling: isScrolling
		    };
	
		    this.setState(nextScrollState);
		  },
		  metricsUpdated: function metricsUpdated() {
		    var height = this.DOMMetrics.viewportHeight();
		    var width = this.DOMMetrics.viewportWidth();
		    if (height) {
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, height, this.props.rowHeight, this.props.rowsCount, width);
		    }
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    if (this.props.rowHeight !== nextProps.rowHeight || this.props.minHeight !== nextProps.minHeight || _ColumnUtils2['default'].getSize(this.props.columnMetrics.columns) !== _ColumnUtils2['default'].getSize(nextProps.columnMetrics.columns)) {
		      this.setState(this.getGridState(nextProps));
		    } else if (this.props.rowsCount !== nextProps.rowsCount) {
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height, nextProps.rowHeight, nextProps.rowsCount);
		      // Added to fix the hiding of the bottom scrollbar when showing the filters.
		    } else if (this.props.rowOffsetHeight !== nextProps.rowOffsetHeight) {
		      // The value of height can be positive or negative and will be added to the current height to cater for changes in the header height (due to the filer)
		      var _height = this.props.rowOffsetHeight - nextProps.rowOffsetHeight;
	
		      this.updateScroll(this.state.scrollTop, this.state.scrollLeft, this.state.height + _height, nextProps.rowHeight, nextProps.rowsCount);
		    }
		  }
		};
	
	/***/ },
	/* 178 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var ExcelColumn = __webpack_require__(11);
	
		var FilterableHeaderCell = React.createClass({
		  displayName: 'FilterableHeaderCell',
	
	
		  propTypes: {
		    onChange: React.PropTypes.func.isRequired,
		    column: React.PropTypes.shape(ExcelColumn)
		  },
	
		  getInitialState: function getInitialState() {
		    return { filterTerm: '' };
		  },
		  handleChange: function handleChange(e) {
		    var val = e.target.value;
		    this.setState({ filterTerm: val });
		    this.props.onChange({ filterTerm: val, column: this.props.column });
		  },
	
	
		  renderInput: function renderInput() {
		    if (this.props.column.filterable === false) {
		      return React.createElement('span', null);
		    }
	
		    var inputKey = 'header-filter-' + this.props.column.key;
		    return React.createElement('input', { key: inputKey, type: 'text', className: 'form-control input-sm', placeholder: 'Search', value: this.state.filterTerm, onChange: this.handleChange });
		  },
	
		  render: function render() {
		    return React.createElement(
		      'div',
		      null,
		      React.createElement(
		        'div',
		        { className: 'form-group' },
		        this.renderInput()
		      )
		    );
		  }
		});
	
		module.exports = FilterableHeaderCell;
	
	/***/ },
	/* 179 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var DEFINE_SORT = {
		  ASC: 'ASC',
		  DESC: 'DESC',
		  NONE: 'NONE'
		};
	
		var SortableHeaderCell = React.createClass({
		  displayName: 'SortableHeaderCell',
	
		  propTypes: {
		    columnKey: React.PropTypes.string.isRequired,
		    column: React.PropTypes.shape({ name: React.PropTypes.node }),
		    onSort: React.PropTypes.func.isRequired,
		    sortDirection: React.PropTypes.oneOf(Object.keys(DEFINE_SORT))
		  },
	
		  onClick: function onClick() {
		    var direction = void 0;
		    switch (this.props.sortDirection) {
		      default:
		      case null:
		      case undefined:
		      case DEFINE_SORT.NONE:
		        direction = DEFINE_SORT.ASC;
		        break;
		      case DEFINE_SORT.ASC:
		        direction = DEFINE_SORT.DESC;
		        break;
		      case DEFINE_SORT.DESC:
		        direction = DEFINE_SORT.NONE;
		        break;
		    }
		    this.props.onSort(this.props.columnKey, direction);
		  },
	
		  getSortByText: function getSortByText() {
		    var unicodeKeys = {
		      ASC: '9650',
		      DESC: '9660'
		    };
		    return this.props.sortDirection === 'NONE' ? '' : String.fromCharCode(unicodeKeys[this.props.sortDirection]);
		  },
	
		  render: function render() {
		    var className = joinClasses({
		      'react-grid-HeaderCell-sortable': true,
		      'react-grid-HeaderCell-sortable--ascending': this.props.sortDirection === 'ASC',
		      'react-grid-HeaderCell-sortable--descending': this.props.sortDirection === 'DESC'
		    });
	
		    return React.createElement(
		      'div',
		      { className: className,
		        onClick: this.onClick,
		        style: { cursor: 'pointer' } },
		      React.createElement(
		        'span',
		        { className: 'pull-right' },
		        this.getSortByText()
		      ),
		      this.props.column.name
		    );
		  }
		});
	
		module.exports = SortableHeaderCell;
		module.exports.DEFINE_SORT = DEFINE_SORT;
	
	/***/ },
	/* 180 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var React = __webpack_require__(2);
		var joinClasses = __webpack_require__(9);
		var keyboardHandlerMixin = __webpack_require__(61);
		var SimpleTextEditor = __webpack_require__(67);
		var isFunction = __webpack_require__(37);
		__webpack_require__(26);
	
		var EditorContainer = React.createClass({
		  displayName: 'EditorContainer',
	
		  mixins: [keyboardHandlerMixin],
	
		  propTypes: {
		    rowIdx: React.PropTypes.number,
		    rowData: React.PropTypes.object.isRequired,
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired,
		    cellMetaData: React.PropTypes.shape({
		      selected: React.PropTypes.object.isRequired,
		      copied: React.PropTypes.object,
		      dragged: React.PropTypes.object,
		      onCellClick: React.PropTypes.func,
		      onCellDoubleClick: React.PropTypes.func,
		      onCommitCancel: React.PropTypes.func,
		      onCommit: React.PropTypes.func
		    }).isRequired,
		    column: React.PropTypes.object.isRequired,
		    height: React.PropTypes.number.isRequired
		  },
	
		  changeCommitted: false,
	
		  getInitialState: function getInitialState() {
		    return { isInvalid: false };
		  },
	
	
		  componentDidMount: function componentDidMount() {
		    var inputNode = this.getInputNode();
		    if (inputNode !== undefined) {
		      this.setTextInputFocus();
		      if (!this.getEditor().disableContainerStyles) {
		        inputNode.className += ' editor-main';
		        inputNode.style.height = this.props.height - 1 + 'px';
		      }
		    }
		  },
	
		  componentWillUnmount: function componentWillUnmount() {
		    if (!this.changeCommitted && !this.hasEscapeBeenPressed()) {
		      this.commit({ key: 'Enter' });
		    }
		  },
	
		  createEditor: function createEditor() {
		    var _this = this;
	
		    var editorRef = function editorRef(c) {
		      return _this.editor = c;
		    };
		    var editorProps = {
		      ref: editorRef,
		      column: this.props.column,
		      value: this.getInitialValue(),
		      onCommit: this.commit,
		      rowMetaData: this.getRowMetaData(),
		      rowData: this.props.rowData,
		      height: this.props.height,
		      onBlur: this.commit,
		      onOverrideKeyDown: this.onKeyDown
		    };
	
		    var CustomEditor = this.props.column.editor;
		    // return custom column editor or SimpleEditor if none specified
		    if (React.isValidElement(CustomEditor)) {
		      return React.cloneElement(CustomEditor, editorProps);
		    }
		    if (isFunction(CustomEditor)) {
		      return React.createElement(CustomEditor, _extends({ ref: editorRef }, editorProps));
		    }
	
		    return React.createElement(SimpleTextEditor, { ref: editorRef, column: this.props.column, value: this.getInitialValue(), onBlur: this.commit, rowMetaData: this.getRowMetaData(), onKeyDown: function onKeyDown() {}, commit: function commit() {} });
		  },
		  onPressEnter: function onPressEnter() {
		    this.commit({ key: 'Enter' });
		  },
		  onPressTab: function onPressTab() {
		    this.commit({ key: 'Tab' });
		  },
		  onPressEscape: function onPressEscape(e) {
		    if (!this.editorIsSelectOpen()) {
		      this.props.cellMetaData.onCommitCancel();
		    } else {
		      // prevent event from bubbling if editor has results to select
		      e.stopPropagation();
		    }
		  },
		  onPressArrowDown: function onPressArrowDown(e) {
		    if (this.editorHasResults()) {
		      // dont want to propogate as that then moves us round the grid
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowUp: function onPressArrowUp(e) {
		    if (this.editorHasResults()) {
		      // dont want to propogate as that then moves us round the grid
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowLeft: function onPressArrowLeft(e) {
		    // prevent event propogation. this disables left cell navigation
		    if (!this.isCaretAtBeginningOfInput()) {
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  onPressArrowRight: function onPressArrowRight(e) {
		    // prevent event propogation. this disables right cell navigation
		    if (!this.isCaretAtEndOfInput()) {
		      e.stopPropagation();
		    } else {
		      this.commit(e);
		    }
		  },
		  editorHasResults: function editorHasResults() {
		    if (isFunction(this.getEditor().hasResults)) {
		      return this.getEditor().hasResults();
		    }
	
		    return false;
		  },
		  editorIsSelectOpen: function editorIsSelectOpen() {
		    if (isFunction(this.getEditor().isSelectOpen)) {
		      return this.getEditor().isSelectOpen();
		    }
	
		    return false;
		  },
		  getRowMetaData: function getRowMetaData() {
		    // clone row data so editor cannot actually change this
		    // convention based method to get corresponding Id or Name of any Name or Id property
		    if (typeof this.props.column.getRowMetaData === 'function') {
		      return this.props.column.getRowMetaData(this.props.rowData, this.props.column);
		    }
		  },
		  getEditor: function getEditor() {
		    return this.editor;
		  },
		  getInputNode: function getInputNode() {
		    return this.getEditor().getInputNode();
		  },
		  getInitialValue: function getInitialValue() {
		    var selected = this.props.cellMetaData.selected;
		    var keyCode = selected.initialKeyCode;
		    if (keyCode === 'Delete' || keyCode === 'Backspace') {
		      return '';
		    } else if (keyCode === 'Enter') {
		      return this.props.value;
		    }
	
		    var text = keyCode ? String.fromCharCode(keyCode) : this.props.value;
		    return text;
		  },
		  getContainerClass: function getContainerClass() {
		    return joinClasses({
		      'has-error': this.state.isInvalid === true
		    });
		  },
		  commit: function commit(args) {
		    var opts = args || {};
		    var updated = this.getEditor().getValue();
		    if (this.isNewValueValid(updated)) {
		      this.changeCommitted = true;
		      var cellKey = this.props.column.key;
		      this.props.cellMetaData.onCommit({ cellKey: cellKey, rowIdx: this.props.rowIdx, updated: updated, key: opts.key });
		    }
		  },
		  isNewValueValid: function isNewValueValid(value) {
		    if (isFunction(this.getEditor().validate)) {
		      var isValid = this.getEditor().validate(value);
		      this.setState({ isInvalid: !isValid });
		      return isValid;
		    }
	
		    return true;
		  },
		  setCaretAtEndOfInput: function setCaretAtEndOfInput() {
		    var input = this.getInputNode();
		    // taken from http://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
		    var txtLength = input.value.length;
		    if (input.setSelectionRange) {
		      input.setSelectionRange(txtLength, txtLength);
		    } else if (input.createTextRange) {
		      var fieldRange = input.createTextRange();
		      fieldRange.moveStart('character', txtLength);
		      fieldRange.collapse();
		      fieldRange.select();
		    }
		  },
		  isCaretAtBeginningOfInput: function isCaretAtBeginningOfInput() {
		    var inputNode = this.getInputNode();
		    return inputNode.selectionStart === inputNode.selectionEnd && inputNode.selectionStart === 0;
		  },
		  isCaretAtEndOfInput: function isCaretAtEndOfInput() {
		    var inputNode = this.getInputNode();
		    return inputNode.selectionStart === inputNode.value.length;
		  },
		  isBodyClicked: function isBodyClicked(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return relatedTarget === null;
		  },
		  isViewportClicked: function isViewportClicked(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return relatedTarget.className.indexOf('react-grid-Viewport') > -1;
		  },
		  isClickInisdeEditor: function isClickInisdeEditor(e) {
		    var relatedTarget = this.getRelatedTarget(e);
		    return e.currentTarget.contains(relatedTarget) || relatedTarget.className.indexOf('editing') > -1 || relatedTarget.className.indexOf('react-grid-Cell') > -1;
		  },
		  getRelatedTarget: function getRelatedTarget(e) {
		    return e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		  },
		  handleRightClick: function handleRightClick(e) {
		    e.stopPropagation();
		  },
		  handleBlur: function handleBlur(e) {
		    e.stopPropagation();
		    if (this.isBodyClicked(e)) {
		      this.commit(e);
		    }
	
		    if (!this.isBodyClicked(e)) {
		      // prevent null reference
		      if (this.isViewportClicked(e) || !this.isClickInisdeEditor(e)) {
		        this.commit(e);
		      }
		    }
		  },
		  setTextInputFocus: function setTextInputFocus() {
		    var selected = this.props.cellMetaData.selected;
		    var keyCode = selected.initialKeyCode;
		    var inputNode = this.getInputNode();
		    inputNode.focus();
		    if (inputNode.tagName === 'INPUT') {
		      if (!this.isKeyPrintable(keyCode)) {
		        inputNode.focus();
		        inputNode.select();
		      } else {
		        inputNode.select();
		      }
		    }
		  },
		  hasEscapeBeenPressed: function hasEscapeBeenPressed() {
		    var pressed = false;
		    var escapeKey = 27;
		    if (window.event) {
		      if (window.event.keyCode === escapeKey) {
		        pressed = true;
		      } else if (window.event.which === escapeKey) {
		        pressed = true;
		      }
		    }
		    return pressed;
		  },
		  renderStatusIcon: function renderStatusIcon() {
		    if (this.state.isInvalid === true) {
		      return React.createElement('span', { className: 'glyphicon glyphicon-remove form-control-feedback' });
		    }
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { className: this.getContainerClass(), onBlur: this.handleBlur, onKeyDown: this.onKeyDown, onContextMenu: this.handleRightClick },
		      this.createEditor(),
		      this.renderStatusIcon()
		    );
		  }
		});
	
		module.exports = EditorContainer;
	
	/***/ },
	/* 181 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = {
		  CheckboxEditor: __webpack_require__(65),
		  EditorBase: __webpack_require__(66),
		  SimpleTextEditor: __webpack_require__(67)
		};
	
	/***/ },
	/* 182 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(2);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(4);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	
		var focusableComponentWrapper = function focusableComponentWrapper(WrappedComponent) {
		  return function (_Component) {
		    _inherits(ComponentWrapper, _Component);
	
		    function ComponentWrapper() {
		      _classCallCheck(this, ComponentWrapper);
	
		      var _this = _possibleConstructorReturn(this, _Component.call(this));
	
		      _this.checkFocus = _this.checkFocus.bind(_this);
		      _this.state = { isScrolling: false };
		      return _this;
		    }
	
		    ComponentWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		      return WrappedComponent.isSelected(this.props) !== WrappedComponent.isSelected(nextProps);
		    };
	
		    ComponentWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		      var isScrolling = WrappedComponent.isScrolling(nextProps);
		      if (isScrolling && !this.state.isScrolling) {
		        this.setState({ isScrolling: isScrolling });
		      }
		    };
	
		    ComponentWrapper.prototype.componentDidMount = function componentDidMount() {
		      this.checkFocus();
		    };
	
		    ComponentWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
		      this.checkFocus();
		    };
	
		    ComponentWrapper.prototype.checkFocus = function checkFocus() {
		      if (WrappedComponent.isSelected(this.props) && this.state.isScrolling) {
		        this.focus();
		        this.setState({ isScrolling: false });
		      }
		    };
	
		    ComponentWrapper.prototype.focus = function focus() {
		      _reactDom2['default'].findDOMNode(this).focus();
		    };
	
		    ComponentWrapper.prototype.render = function render() {
		      return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, this.state));
		    };
	
		    return ComponentWrapper;
		  }(_react.Component);
		};
	
		exports['default'] = focusableComponentWrapper;
	
	/***/ },
	/* 183 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var SimpleCellFormatter = React.createClass({
		  displayName: 'SimpleCellFormatter',
	
		  propTypes: {
		    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number, React.PropTypes.object, React.PropTypes.bool]).isRequired
		  },
	
		  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
		    return nextProps.value !== this.props.value;
		  },
		  render: function render() {
		    return React.createElement(
		      'div',
		      { title: this.props.value },
		      this.props.value
		    );
		  }
		});
	
		module.exports = SimpleCellFormatter;
	
	/***/ },
	/* 184 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _GridPropHelpers = __webpack_require__(185);
	
		var _GridPropHelpers2 = _interopRequireDefault(_GridPropHelpers);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = {
		  test: { GridPropHelpers: _GridPropHelpers2['default'] }
		};
	
	/***/ },
	/* 185 */
	/***/ function(module, exports) {
	
		'use strict';
	
		var _rows = [];
		for (var i = 0; i < 1000; i++) {
		  _rows.push({
		    id: i,
		    title: 'Title ' + i,
		    count: i * 1000
		  });
		}
		module.exports = {
		  columns: [{
		    key: 'id',
		    name: 'ID',
		    width: 100
		  }, {
		    key: 'title',
		    name: 'Title',
		    width: 100
		  }, {
		    key: 'count',
		    name: 'Count',
		    width: 100
		  }],
		  rowGetter: function rowGetter(i) {
		    return _rows[i];
		  },
		  rowsCount: function rowsCount() {
		    return _rows.length;
		  },
		  cellMetaData: {
		    selected: { idx: 2, rowIdx: 3 },
		    dragged: null,
		    copied: null
		  }
		};
	
	/***/ },
	/* 186 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _RowComparer = __webpack_require__(62);
	
		var _RowComparer2 = _interopRequireDefault(_RowComparer);
	
		var _RowsContainer = __webpack_require__(64);
	
		var _RowsContainer2 = _interopRequireDefault(_RowsContainer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var Grid = __webpack_require__(172);
	
	
		module.exports = Grid;
		module.exports.Row = __webpack_require__(34);
		module.exports.Cell = __webpack_require__(59);
		module.exports.HeaderCell = __webpack_require__(60);
		module.exports.RowComparer = _RowComparer2['default'];
		module.exports.RowsContainer = _RowsContainer2['default'];
		module.exports.editors = __webpack_require__(181);
		module.exports.utils = __webpack_require__(187);
		module.exports.shapes = __webpack_require__(171);
		module.exports._constants = __webpack_require__(58);
		module.exports._helpers = __webpack_require__(184);
	
	/***/ },
	/* 187 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = {
		  isEmptyArray: __webpack_require__(188),
		  isEmptyObject: __webpack_require__(189),
		  isFunction: __webpack_require__(37),
		  isImmutableCollection: __webpack_require__(190),
		  getMixedTypeValueRetriever: __webpack_require__(192),
		  isColumnsImmutable: __webpack_require__(68),
		  isImmutableMap: __webpack_require__(191)
		};
	
	/***/ },
	/* 188 */
	/***/ function(module, exports) {
	
		"use strict";
	
		var isEmptyArray = function isEmptyArray(obj) {
		  return Array.isArray(obj) && obj.length === 0;
		};
	
		module.exports = isEmptyArray;
	
	/***/ },
	/* 189 */
	/***/ function(module, exports) {
	
		"use strict";
	
		function isEmpty(obj) {
		  return Object.keys(obj).length === 0 && obj.constructor === Object;
		}
	
		module.exports = isEmpty;
	
	/***/ },
	/* 190 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _immutable = __webpack_require__(24);
	
		var isImmutableCollection = function isImmutableCollection(objToVerify) {
		  return _immutable.Iterable.isIterable(objToVerify);
		};
	
		module.exports = isImmutableCollection;
	
	/***/ },
	/* 191 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _immutable = __webpack_require__(24);
	
		module.exports = _immutable.Map.isMap;
	
	/***/ },
	/* 192 */
	/***/ function(module, exports) {
	
		"use strict";
	
		var getMixedTypeValueRetriever = function getMixedTypeValueRetriever(isImmutable) {
		  var retObj = {};
		  var retriever = function retriever(item, key) {
		    return item[key];
		  };
		  var immutableRetriever = function immutableRetriever(immutable, key) {
		    return immutable.get(key);
		  };
	
		  retObj.getValue = isImmutable ? immutableRetriever : retriever;
	
		  return retObj;
		};
	
		module.exports = getMixedTypeValueRetriever;
	
	/***/ },
	/* 193 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Cell{background-color:#fff;padding-left:8px;padding-right:8px;border-right:1px solid #eee;border-bottom:1px solid #ddd}.react-grid-Cell:focus{outline:2px solid #66afe9;outline-offset:-2px}.react-grid-Cell:focus .drag-handle{position:absolute;bottom:-5px;right:-4px;background:#66afe9;width:8px;height:8px;border:1px solid #fff;border-right:0;border-bottom:0;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Cell:not(.editing) .react-grid-Cell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-Cell.readonly{background-color:#000}.react-grid-Cell.copied{background:rgba(0,0,255,.2)!important}.react-grid-Cell--locked:last-of-type{border-right:1px solid #ddd;box-shadow:none;z-index:99}.react-grid-Cell:hover:focus .drag-handle .glyphicon-arrow-down{display:\"block\"}.react-grid-Cell.is-dragged-over-down{border-right:1px dashed #000;border-left:1px dashed #000;border-bottom:1px dashed #000}.react-grid-Cell.is-dragged-over-up{border-right:1px dashed #000;border-left:1px dashed #000;border-top:1px dashed #000}.react-grid-Cell.is-dragged-over-up .drag-handle{top:-5px}.react-grid-Cell:hover{background:#eee}.react-grid-cell .form-control-feedback{color:#a94442;position:absolute;top:0;right:10px;z-index:1000000;display:block;width:34px;height:34px}.react-grid-Cell.was-dragged-over{border-right:1px dashed #000;border-left:1px dashed #000}.react-grid-Cell:hover:focus .drag-handle{position:absolute;bottom:-8px;right:-7px;background:#fff;width:16px;height:16px;border:1px solid #66afe9;z-index:8;cursor:crosshair;cursor:-webkit-grab}.react-grid-Row.row-selected .react-grid-Cell{background-color:#dbecfa}.react-grid-Cell.editing{padding:0;overflow:visible!important}.react-grid-Cell.editing .has-error input{border:2px solid red!important;border-radius:2px!important}.react-grid-Cell__value ul{margin-top:0;margin-bottom:0;display:inline-block}.react-grid-Cell__value .btn-sm{padding:0}.cell-tooltip{position:relative;display:inline-block}.cell-tooltip .cell-tooltip-text{visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;bottom:-150%;left:50%;margin-left:-60px;opacity:1s}.cell-tooltip:hover .cell-tooltip-text{visibility:visible;opacity:.8}.cell-tooltip .cell-tooltip-text:after{content:\" \";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}.react-grid-Canvas.opaque .react-grid-Cell.cell-tooltip:hover .cell-tooltip-text{visibility:hidden}", ""]);
	
		// exports
	
	
	/***/ },
	/* 194 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".radio-custom,.react-grid-checkbox{opacity:0;position:absolute}.radio-custom,.radio-custom-label,.react-grid-checkbox,.react-grid-checkbox-label{display:inline-block;vertical-align:middle;margin:10px;cursor:pointer}.radio-custom-label,.react-grid-checkbox-label{position:relative}.radio-custom+.radio-custom-label:before,.react-grid-checkbox+.react-grid-checkbox-label:before{content:\"\";background:#fff;border:2px solid #ddd;display:inline-block;vertical-align:middle;width:20px;height:20px;text-align:center}.react-grid-checkbox:checked+.react-grid-checkbox-label:before{background:#005295;box-shadow:inset 0 0 0 4px #fff}.radio-custom:focus+.radio-custom-label,.react-grid-checkbox:focus+.react-grid-checkbox-label{outline:1px solid #ddd}.react-grid-HeaderCell input[type=checkbox]{z-index:99999}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0 10px}.react-grid-HeaderCell>.react-grid-checkbox-container>.react-grid-checkbox-label{margin:0}.radio-custom+.radio-custom-label:before{border-radius:50%}.radio-custom:checked+.radio-custom-label:before{background:#ccc;box-shadow:inset 0 0 0 4px #fff}", ""]);
	
		// exports
	
	
	/***/ },
	/* 195 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Container{clear:both;margin-top:0;padding:0}.react-grid-Main{background-color:#fff;color:inherit;padding:0;outline:1px solid #e7eaec;clear:both}.react-grid-Grid{border:1px solid #ddd}.react-grid-Canvas,.react-grid-Grid{background-color:#fff}.react-grid-Cell input.editor-main,select.editor-main{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input.editor-main:focus,select.editor-main:focus{border-color:#66afe9;border:2px solid #66afe9;background:#eee;border-radius:4px}.react-grid-Cell input.editor-main::-moz-placeholder,select.editor-main::-moz-placeholder{color:#999;opacity:1}.react-grid-Cell input.editor-main:-ms-input-placeholder,select.editor-main:-ms-input-placeholder{color:#999}.react-grid-Cell input.editor-main::-webkit-input-placeholder,select.editor-main::-webkit-input-placeholder{color:#999}.react-grid-Cell input.editor-main[disabled],.react-grid-Cell input.editor-main[readonly],fieldset[disabled] .react-grid-Cell input.editor-main,fieldset[disabled] select.editor-main,select.editor-main[disabled],select.editor-main[readonly]{cursor:not-allowed;background-color:#eee;opacity:1}textarea.react-grid-Cell input.editor-main,textareaselect.editor-main{height:auto}.react-grid-ScrollShim{z-index:10002}", ""]);
	
		// exports
	
	
	/***/ },
	/* 196 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Header{box-shadow:0 0 4px 0 #ddd;background:#f9f9f9}.react-grid-Header--resizing{cursor:ew-resize}.react-grid-HeaderCell,.react-grid-HeaderRow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-HeaderCell{background:#f9f9f9;padding:8px;font-weight:700;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.react-grid-HeaderCell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-HeaderCell__resizeHandle:hover{cursor:ew-resize;background:#ddd}.react-grid-HeaderCell--locked:last-of-type{box-shadow:none}.react-grid-HeaderCell--resizing .react-grid-HeaderCell__resizeHandle{background:#ddd}.react-grid-HeaderCell__draggable{cursor:col-resize}.rdg-can-drop>.react-grid-HeaderCell{background:#ececec}", ""]);
	
		// exports
	
	
	/***/ },
	/* 197 */
	/***/ function(module, exports, __webpack_require__) {
	
		exports = module.exports = __webpack_require__(7)();
		// imports
	
	
		// module
		exports.push([module.id, ".react-grid-Row.row-context-menu .react-grid-Cell,.react-grid-Row:hover .react-grid-Cell{background-color:#f2f2f2}.react-grid-Row:hover .rdg-row-index{display:none}.react-grid-Row:hover .rdg-actions-checkbox{display:block}.react-grid-Row:hover .rdg-drag-row-handle{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab;width:12px;height:30px;margin-left:0;background-image:url(\"data:image/svg+xml;base64, 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\");background-repeat:no-repeat}.react-grid-Row.row-selected,.react-grid-Row .row-selected{background-color:#dbecfa}.react-grid-row-group .row-expand-icon:hover{color:#777}.react-grid-row-index{padding:0 18px}.rdg-row-index{display:block;text-align:center}.rdg-row-actions-cell{padding:0}.rdg-actions-checkbox{display:none;text-align:center}.rdg-actions-checkbox.selected{display:block}.rdg-dragging{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.rdg-dragged-row{border-bottom:1px solid #000}", ""]);
	
		// exports
	
	
	/***/ },
	/* 198 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule invariant
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  if (false) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  }
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ },
	/* 199 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @providesModule keyMirror
		 * @typechecks static-only
		 */
	
		'use strict';
	
		var invariant = __webpack_require__(198);
	
		/**
		 * Constructs an enumeration with keys equal to their value.
		 *
		 * For example:
		 *
		 *   var COLORS = keyMirror({blue: null, red: null});
		 *   var myColor = COLORS.blue;
		 *   var isColorValid = !!COLORS[myColor];
		 *
		 * The last line could not be performed if the values of the generated enum were
		 * not equal to their keys.
		 *
		 *   Input:  {key1: val1, key2: val2}
		 *   Output: {key1: key1, key2: key2}
		 *
		 * @param {object} obj
		 * @return {object}
		 */
		var keyMirror = function (obj) {
		  var ret = {};
		  var key;
		  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
		  for (key in obj) {
		    if (!obj.hasOwnProperty(key)) {
		      continue;
		    }
		    ret[key] = key;
		  }
		  return ret;
		};
	
		module.exports = keyMirror;
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 463 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(12);
	
	var focusNode = __webpack_require__(118);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(46);
	var ExecutionEnvironment = __webpack_require__(15);
	var FallbackCompositionState = __webpack_require__(471);
	var SyntheticCompositionEvent = __webpack_require__(508);
	var SyntheticInputEvent = __webpack_require__(511);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(243);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(18);
	
	var camelizeStyleName = __webpack_require__(411);
	var dangerousStyleValue = __webpack_require__(517);
	var hyphenateStyleName = __webpack_require__(418);
	var memoizeStringOnly = __webpack_require__(421);
	var warning = __webpack_require__(7);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(45);
	var EventPropagators = __webpack_require__(46);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactUpdates = __webpack_require__(21);
	var SyntheticEvent = __webpack_require__(24);
	
	var getEventTarget = __webpack_require__(91);
	var isEventSupported = __webpack_require__(92);
	var isTextInputElement = __webpack_require__(260);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var DOMLazyTree = __webpack_require__(35);
	var ExecutionEnvironment = __webpack_require__(15);
	
	var createNodesFromMarkup = __webpack_require__(414);
	var emptyFunction = __webpack_require__(16);
	var invariant = __webpack_require__(5);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(12);
	var SyntheticMouseEvent = __webpack_require__(58);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(30);
	
	var getTextContentAccessor = __webpack_require__(258);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(36);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(37);
	
	var instantiateReactComponent = __webpack_require__(259);
	var KeyEscapeUtils = __webpack_require__(83);
	var shouldUpdateReactComponent = __webpack_require__(93);
	var traverseAllChildren = __webpack_require__(262);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(275);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(241)))

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(79);
	var ReactDOMIDOperations = __webpack_require__(481);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8),
	    _assign = __webpack_require__(11);
	
	var React = __webpack_require__(39);
	var ReactComponentEnvironment = __webpack_require__(85);
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactErrorUtils = __webpack_require__(86);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactNodeTypes = __webpack_require__(253);
	var ReactReconciler = __webpack_require__(37);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(5);
	var shallowEqual = __webpack_require__(74);
	var shouldUpdateReactComponent = __webpack_require__(93);
	var warning = __webpack_require__(7);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactDefaultInjection = __webpack_require__(489);
	var ReactMount = __webpack_require__(252);
	var ReactReconciler = __webpack_require__(37);
	var ReactUpdates = __webpack_require__(21);
	var ReactVersion = __webpack_require__(502);
	
	var findDOMNode = __webpack_require__(518);
	var getHostComponentFromComposite = __webpack_require__(257);
	var renderSubtreeIntoContainer = __webpack_require__(526);
	var warning = __webpack_require__(7);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8),
	    _assign = __webpack_require__(11);
	
	var AutoFocusUtils = __webpack_require__(464);
	var CSSPropertyOperations = __webpack_require__(466);
	var DOMLazyTree = __webpack_require__(35);
	var DOMNamespaces = __webpack_require__(80);
	var DOMProperty = __webpack_require__(36);
	var DOMPropertyOperations = __webpack_require__(245);
	var EventPluginHub = __webpack_require__(45);
	var EventPluginRegistry = __webpack_require__(81);
	var ReactBrowserEventEmitter = __webpack_require__(57);
	var ReactDOMComponentFlags = __webpack_require__(246);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactDOMInput = __webpack_require__(482);
	var ReactDOMOption = __webpack_require__(483);
	var ReactDOMSelect = __webpack_require__(247);
	var ReactDOMTextarea = __webpack_require__(486);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactMultiChild = __webpack_require__(495);
	var ReactServerRenderingTransaction = __webpack_require__(500);
	
	var emptyFunction = __webpack_require__(16);
	var escapeTextContentForBrowser = __webpack_require__(60);
	var invariant = __webpack_require__(5);
	var isEventSupported = __webpack_require__(92);
	var shallowEqual = __webpack_require__(74);
	var validateDOMNesting = __webpack_require__(94);
	var warning = __webpack_require__(7);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(94);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(12);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 480 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(79);
	var ReactDOMComponentTree = __webpack_require__(12);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8),
	    _assign = __webpack_require__(11);
	
	var DOMPropertyOperations = __webpack_require__(245);
	var LinkedValueUtils = __webpack_require__(84);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactUpdates = __webpack_require__(21);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var React = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactDOMSelect = __webpack_require__(247);
	
	var warning = __webpack_require__(7);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var getNodeForCharacterOffset = __webpack_require__(523);
	var getTextContentAccessor = __webpack_require__(258);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8),
	    _assign = __webpack_require__(11);
	
	var DOMChildrenOperations = __webpack_require__(79);
	var DOMLazyTree = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(12);
	
	var escapeTextContentForBrowser = __webpack_require__(60);
	var invariant = __webpack_require__(5);
	var validateDOMNesting = __webpack_require__(94);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8),
	    _assign = __webpack_require__(11);
	
	var LinkedValueUtils = __webpack_require__(84);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactUpdates = __webpack_require__(21);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactUpdates = __webpack_require__(21);
	var Transaction = __webpack_require__(59);
	
	var emptyFunction = __webpack_require__(16);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(463);
	var BeforeInputEventPlugin = __webpack_require__(465);
	var ChangeEventPlugin = __webpack_require__(467);
	var DefaultEventPluginOrder = __webpack_require__(469);
	var EnterLeaveEventPlugin = __webpack_require__(470);
	var HTMLDOMPropertyConfig = __webpack_require__(472);
	var ReactComponentBrowserEnvironment = __webpack_require__(474);
	var ReactDOMComponent = __webpack_require__(477);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactDOMEmptyComponent = __webpack_require__(479);
	var ReactDOMTreeTraversal = __webpack_require__(487);
	var ReactDOMTextComponent = __webpack_require__(485);
	var ReactDefaultBatchingStrategy = __webpack_require__(488);
	var ReactEventListener = __webpack_require__(492);
	var ReactInjection = __webpack_require__(493);
	var ReactReconcileTransaction = __webpack_require__(498);
	var SVGDOMPropertyConfig = __webpack_require__(503);
	var SelectEventPlugin = __webpack_require__(504);
	var SimpleEventPlugin = __webpack_require__(505);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 490 */
276,
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(45);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var EventListener = __webpack_require__(117);
	var ExecutionEnvironment = __webpack_require__(15);
	var PooledClass = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactUpdates = __webpack_require__(21);
	
	var getEventTarget = __webpack_require__(91);
	var getUnboundedScrollPosition = __webpack_require__(416);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(36);
	var EventPluginHub = __webpack_require__(45);
	var EventPluginUtils = __webpack_require__(82);
	var ReactComponentEnvironment = __webpack_require__(85);
	var ReactEmptyComponent = __webpack_require__(248);
	var ReactBrowserEventEmitter = __webpack_require__(57);
	var ReactHostComponent = __webpack_require__(250);
	var ReactUpdates = __webpack_require__(21);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(516);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var ReactComponentEnvironment = __webpack_require__(85);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactInstrumentation = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactReconciler = __webpack_require__(37);
	var ReactChildReconciler = __webpack_require__(473);
	
	var emptyFunction = __webpack_require__(16);
	var flattenChildren = __webpack_require__(519);
	var invariant = __webpack_require__(5);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 497 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var CallbackQueue = __webpack_require__(244);
	var PooledClass = __webpack_require__(30);
	var ReactBrowserEventEmitter = __webpack_require__(57);
	var ReactInputSelection = __webpack_require__(251);
	var ReactInstrumentation = __webpack_require__(18);
	var Transaction = __webpack_require__(59);
	var ReactUpdateQueue = __webpack_require__(87);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(496);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(30);
	var Transaction = __webpack_require__(59);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactServerUpdateQueue = __webpack_require__(501);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(87);
	
	var warning = __webpack_require__(7);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 502 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 503 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(46);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactInputSelection = __webpack_require__(251);
	var SyntheticEvent = __webpack_require__(24);
	
	var getActiveElement = __webpack_require__(119);
	var isTextInputElement = __webpack_require__(260);
	var shallowEqual = __webpack_require__(74);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var EventListener = __webpack_require__(117);
	var EventPropagators = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(12);
	var SyntheticAnimationEvent = __webpack_require__(506);
	var SyntheticClipboardEvent = __webpack_require__(507);
	var SyntheticEvent = __webpack_require__(24);
	var SyntheticFocusEvent = __webpack_require__(510);
	var SyntheticKeyboardEvent = __webpack_require__(512);
	var SyntheticMouseEvent = __webpack_require__(58);
	var SyntheticDragEvent = __webpack_require__(509);
	var SyntheticTouchEvent = __webpack_require__(513);
	var SyntheticTransitionEvent = __webpack_require__(514);
	var SyntheticUIEvent = __webpack_require__(48);
	var SyntheticWheelEvent = __webpack_require__(515);
	
	var emptyFunction = __webpack_require__(16);
	var getEventCharCode = __webpack_require__(89);
	var invariant = __webpack_require__(5);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(24);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(24);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(24);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(58);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(48);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(24);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(48);
	
	var getEventCharCode = __webpack_require__(89);
	var getEventKey = __webpack_require__(520);
	var getEventModifierState = __webpack_require__(90);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(48);
	
	var getEventModifierState = __webpack_require__(90);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(24);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(58);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 516 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(243);
	var warning = __webpack_require__(7);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(8);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(12);
	var ReactInstanceMap = __webpack_require__(47);
	
	var getHostComponentFromComposite = __webpack_require__(257);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(83);
	var traverseAllChildren = __webpack_require__(262);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(275);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(241)))

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(89);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 521 */
279,
/* 522 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 523 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(60);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(252);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 527 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  position: 'absolute',
	  width: '1px',
	  height: '1px',
	  padding: '0px',
	  margin: '-1px',
	  overflow: 'hidden',
	  clip: 'rect(0px, 0px, 0px, 0px)',
	  border: '0px'
	};
	module.exports = exports['default'];

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	
	var sizerStyle = { position: 'absolute', top: 0, left: 0, visibility: 'hidden', height: 0, overflow: 'scroll', whiteSpace: 'pre' };
	
	var AutosizeInput = React.createClass({
		displayName: 'AutosizeInput',
	
		propTypes: {
			className: React.PropTypes.string, // className for the outer element
			defaultValue: React.PropTypes.any, // default field value
			inputClassName: React.PropTypes.string, // className for the input element
			inputStyle: React.PropTypes.object, // css styles for the input element
			minWidth: React.PropTypes.oneOfType([// minimum width for input element
			React.PropTypes.number, React.PropTypes.string]),
			onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
			placeholder: React.PropTypes.string, // placeholder text
			placeholderIsMinWidth: React.PropTypes.bool, // don't collapse size to less than the placeholder
			style: React.PropTypes.object, // css styles for the outer element
			value: React.PropTypes.any },
		// field value
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth
			};
		},
		componentDidMount: function componentDidMount() {
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate() {
			this.updateInputWidth();
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.isMounted() || !window.getComputedStyle) {
				return;
			}
			var inputStyle = window.getComputedStyle(this.refs.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.refs.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			if (this.props.placeholder) {
				var placeholderNode = this.refs.placeholderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			}
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.isMounted() || typeof this.refs.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = undefined;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.refs.sizer.scrollWidth, this.refs.placeholderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.refs.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.refs.input;
		},
		focus: function focus() {
			this.refs.input.focus();
		},
		blur: function blur() {
			this.refs.input.blur();
		},
		select: function select() {
			this.refs.input.select();
		},
		render: function render() {
			var sizerValue = this.props.defaultValue || this.props.value || '';
			var wrapperStyle = this.props.style || {};
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';
			var inputProps = _extends({}, this.props);
			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.placeholderIsMinWidth;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('input', _extends({}, inputProps, { ref: 'input' })),
				React.createElement(
					'div',
					{ ref: 'sizer', style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? React.createElement(
					'div',
					{ ref: 'placeholderSizer', style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(263);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(264);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(26);
	
	var _InternalPropTypes = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(26);
	
	var _InternalPropTypes = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(130);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(55);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(97);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(31);
	
	var _RouterContext = __webpack_require__(62);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(26);
	
	var _RouterUtils = __webpack_require__(265);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(62);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(95);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(62);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(451);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(267);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(38);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(95);
	
	var _makeStateWithLocation = __webpack_require__(268);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(38);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(130);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(267);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(38);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(34);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(266);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(97);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(26);
	
	var _RouterUtils = __webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(95);
	
	var _makeStateWithLocation = __webpack_require__(268);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(38);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(55);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(97);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(13);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(454);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(27);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsStripDiacritics = __webpack_require__(272);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var propTypes = {
		autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
		children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
		loadingPlaceholder: _react2['default'].PropTypes.oneOfType([// replaces the placeholder while options are loading
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		options: _react.PropTypes.array.isRequired, // array of options
		placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		noResultsText: _react2['default'].PropTypes.oneOfType([// field noResultsText, displayed when no options come back from the server
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
		searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
		_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
		onInputChange: _react2['default'].PropTypes.func, // optional for keeping track of what is being typed
		value: _react2['default'].PropTypes.any };
	
	// initial field value
	var defaultCache = {};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = (function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);
	
			this._cache = props.cache === defaultCache ? {} : props.cache;
	
			this.state = {
				isLoading: false,
				options: props.options
			};
	
			this._onInputChange = this._onInputChange.bind(this);
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps, nextState) {
				var _this = this;
	
				var propertiesToSync = ['options'];
				propertiesToSync.forEach(function (prop) {
					if (_this.props[prop] !== nextProps[prop]) {
						_this.setState(_defineProperty({}, prop, nextProps[prop]));
					}
				});
			}
		}, {
			key: 'clearOptions',
			value: function clearOptions() {
				this.setState({ options: [] });
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && cache.hasOwnProperty(inputValue)) {
					this.setState({
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						var options = data && data.options || [];
	
						if (cache) {
							cache[inputValue] = options;
						}
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
	
				return inputValue;
			}
		}, {
			key: '_onInputChange',
			value: function _onInputChange(inputValue) {
				var _props = this.props;
				var ignoreAccents = _props.ignoreAccents;
				var ignoreCase = _props.ignoreCase;
				var onInputChange = _props.onInputChange;
	
				if (ignoreAccents) {
					inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
				}
	
				if (ignoreCase) {
					inputValue = inputValue.toLowerCase();
				}
	
				if (onInputChange) {
					onInputChange(inputValue);
				}
	
				return this.loadOptions(inputValue);
			}
		}, {
			key: 'inputValue',
			value: function inputValue() {
				if (this.select) {
					return this.select.state.inputValue;
				}
				return '';
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props;
				var loadingPlaceholder = _props2.loadingPlaceholder;
				var noResultsText = _props2.noResultsText;
				var searchPromptText = _props2.searchPromptText;
				var isLoading = this.state.isLoading;
	
				var inputValue = this.inputValue();
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props;
				var children = _props3.children;
				var loadingPlaceholder = _props3.loadingPlaceholder;
				var placeholder = _props3.placeholder;
				var _state = this.state;
				var isLoading = _state.isLoading;
				var options = _state.options;
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					},
					onChange: function onChange(newValues) {
						if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
							_this3.clearOptions();
						}
						_this3.props.onChange(newValues);
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this._onInputChange
				}));
			}
		}]);
	
		return Async;
	})(_react.Component);
	
	exports['default'] = Async;
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	module.exports = exports['default'];

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(27);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function reduce(obj) {
		var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		return Object.keys(obj).reduce(function (props, key) {
			var value = obj[key];
			if (value !== undefined) props[key] = value;
			return props;
		}, props);
	}
	
	var AsyncCreatable = _react2['default'].createClass({
		displayName: 'AsyncCreatableSelect',
	
		render: function render() {
			var _this = this;
	
			return _react2['default'].createElement(
				_Select2['default'].Async,
				this.props,
				function (asyncProps) {
					return _react2['default'].createElement(
						_Select2['default'].Creatable,
						_this.props,
						function (creatableProps) {
							return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
								onInputChange: function (input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								},
								ref: function (ref) {
									creatableProps.ref(ref);
									asyncProps.ref(ref);
								}
							}));
						}
					);
				}
			);
		}
	});
	
	module.exports = AsyncCreatable;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(27);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsDefaultFilterOptions = __webpack_require__(270);
	
	var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);
	
	var _utilsDefaultMenuRenderer = __webpack_require__(271);
	
	var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);
	
	var Creatable = _react2['default'].createClass({
		displayName: 'CreatableSelect',
	
		propTypes: {
			// Child function responsible for creating the inner Select component
			// This component can be used to compose HOCs (eg Creatable and Async)
			// (props: Object): PropTypes.element
			children: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.filterOptions
			filterOptions: _react2['default'].PropTypes.any,
	
			// Searches for any matching option within the set of options.
			// This function prevents duplicate options from being created.
			// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
			isOptionUnique: _react2['default'].PropTypes.func,
	
			// Determines if the current input text represents a valid option.
			// ({ label: string }): boolean
			isValidNewOption: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.menuRenderer
			menuRenderer: _react2['default'].PropTypes.any,
	
			// Factory to create new option.
			// ({ label: string, labelKey: string, valueKey: string }): Object
			newOptionCreator: _react2['default'].PropTypes.func,
	
			// input change handler: function (inputValue) {}
			onInputChange: _react2['default'].PropTypes.func,
	
			// input keyDown handler: function (event) {}
			onInputKeyDown: _react2['default'].PropTypes.func,
	
			// new option click handler: function (option) {}
			onNewOptionClick: _react2['default'].PropTypes.func,
	
			// See Select.propTypes.options
			options: _react2['default'].PropTypes.array,
	
			// Creates prompt/placeholder option text.
			// (filterText: string): string
			promptTextCreator: _react2['default'].PropTypes.func,
	
			// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
			shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
		},
	
		// Default prop methods
		statics: {
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				filterOptions: _utilsDefaultFilterOptions2['default'],
				isOptionUnique: isOptionUnique,
				isValidNewOption: isValidNewOption,
				menuRenderer: _utilsDefaultMenuRenderer2['default'],
				newOptionCreator: newOptionCreator,
				promptTextCreator: promptTextCreator,
				shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
			};
		},
	
		createNewOption: function createNewOption() {
			var _props = this.props;
			var isValidNewOption = _props.isValidNewOption;
			var newOptionCreator = _props.newOptionCreator;
			var onNewOptionClick = _props.onNewOptionClick;
			var _props$options = _props.options;
			var options = _props$options === undefined ? [] : _props$options;
			var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;
	
			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });
	
				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);
	
						this.select.selectValue(option);
					}
				}
			}
		},
	
		filterOptions: function filterOptions() {
			var _props2 = this.props;
			var filterOptions = _props2.filterOptions;
			var isValidNewOption = _props2.isValidNewOption;
			var options = _props2.options;
			var promptTextCreator = _props2.promptTextCreator;
	
			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
			var excludeOptions = arguments[2] || [];
	
			var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;
	
				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});
	
				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});
	
				if (_isOptionUnique2) {
					var _prompt = promptTextCreator(this.inputValue);
	
					this._createPlaceholderOption = _newOptionCreator({
						label: _prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}
	
			return filteredOptions;
		},
	
		isOptionUnique: function isOptionUnique(_ref2) {
			var option = _ref2.option;
			var options = _ref2.options;
			var isOptionUnique = this.props.isOptionUnique;
	
			options = options || this.select.filterOptions();
	
			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		},
	
		menuRenderer: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;
	
			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		},
	
		onInputChange: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;
	
			if (onInputChange) {
				onInputChange(input);
			}
	
			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		},
	
		onInputKeyDown: function onInputKeyDown(event) {
			var _props3 = this.props;
			var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
			var onInputKeyDown = _props3.onInputKeyDown;
	
			var focusedOption = this.select.getFocusedOption();
	
			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();
	
				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		},
	
		onOptionSelect: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		},
	
		render: function render() {
			var _this = this;
	
			var _props4 = this.props;
			var newOptionCreator = _props4.newOptionCreator;
			var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;
	
			var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);
	
			var children = this.props.children;
	
			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.
			if (!children) {
				children = defaultChildren;
			}
	
			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref) {
					_this.select = _ref;
	
					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref) {
						_this.labelKey = _ref.props.labelKey;
						_this.valueKey = _ref.props.valueKey;
					}
				}
			});
	
			return children(props);
		}
	});
	
	function defaultChildren(props) {
		return _react2['default'].createElement(_Select2['default'], props);
	};
	
	function isOptionUnique(_ref3) {
		var option = _ref3.option;
		var options = _ref3.options;
		var labelKey = _ref3.labelKey;
		var valueKey = _ref3.valueKey;
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	function isValidNewOption(_ref4) {
		var label = _ref4.label;
	
		return !!label;
	};
	
	function newOptionCreator(_ref5) {
		var label = _ref5.label;
		var labelKey = _ref5.labelKey;
		var valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
		return option;
	};
	
	function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	}
	
	function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
		}
	
		return false;
	};
	
	module.exports = Creatable;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Option = _react2['default'].createClass({
		displayName: 'Option',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			className: _react2['default'].PropTypes.string, // className (based on mouse position)
			instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
			isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
			isFocused: _react2['default'].PropTypes.bool, // the option is focused
			isSelected: _react2['default'].PropTypes.bool, // the option is selected
			onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
			onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
			onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
			option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
			optionIndex: _react2['default'].PropTypes.number },
		// index of the option, used to generate unique ids for aria
		blockEvent: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		},
	
		handleMouseDown: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		},
	
		handleMouseEnter: function handleMouseEnter(event) {
			this.onFocus(event);
		},
	
		handleMouseMove: function handleMouseMove(event) {
			this.onFocus(event);
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			this.handleMouseDown(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		onFocus: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		},
		render: function render() {
			var _props = this.props;
			var option = _props.option;
			var instancePrefix = _props.instancePrefix;
			var optionIndex = _props.optionIndex;
	
			var className = (0, _classnames2['default'])(this.props.className, option.className);
	
			return option.disabled ? _react2['default'].createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2['default'].createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	});
	
	module.exports = Option;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Value = _react2['default'].createClass({
	
		displayName: 'Value',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
			id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
			onClick: _react2['default'].PropTypes.func, // method to handle click on value label
			onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
			value: _react2['default'].PropTypes.object.isRequired },
	
		// the option object for this value
		handleMouseDown: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		},
	
		onRemove: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		},
	
		handleTouchEndRemove: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.onRemove(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		renderRemoveIcon: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'×'
			);
		},
	
		renderLabel: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2['default'].createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		},
	
		render: function render() {
			return _react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	
	});
	
	module.exports = Value;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports["default"] = arrowRenderer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2["default"].createElement("span", {
			className: "Select-arrow",
			onMouseDown: onMouseDown
		});
	}
	
	;
	module.exports = exports["default"];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = clearRenderer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function clearRenderer() {
		return _react2['default'].createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	}
	
	;
	module.exports = exports['default'];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(52);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'TabPanel',
	
	  propTypes: {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]),
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    selected: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	    tabId: _propTypes2.default.string
	  },
	
	  contextTypes: {
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selected: false,
	      id: null,
	      tabId: null
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        selected = _props.selected,
	        id = _props.id,
	        tabId = _props.tabId,
	        style = _props.style,
	        attributes = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'id', 'tabId', 'style']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__TabPanel', className, {
	          'ReactTabs__TabPanel--selected': selected
	        }),
	        role: 'tabpanel',
	        id: id,
	        'aria-labelledby': tabId,
	        style: _extends({}, style, { display: selected ? null : 'none' })
	      }),
	      this.context.forceRenderTabPanel || selected ? children : null
	    );
	  }
	});

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(52);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(23);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jsStylesheet = __webpack_require__(455);
	
	var _jsStylesheet2 = _interopRequireDefault(_jsStylesheet);
	
	var _uuid = __webpack_require__(561);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _childrenPropType = __webpack_require__(559);
	
	var _childrenPropType2 = _interopRequireDefault(_childrenPropType);
	
	var _Tab = __webpack_require__(64);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Determine if a node from event.target is a Tab element
	function isTabNode(node) {
	  return node.nodeName === 'LI' && node.getAttribute('role') === 'tab';
	}
	
	// Determine if a tab node is disabled
	function isTabDisabled(node) {
	  return node.getAttribute('aria-disabled') === 'true';
	}
	
	var useDefaultStyles = true;
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'Tabs',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    selectedIndex: _propTypes2.default.number,
	    onSelect: _propTypes2.default.func,
	    focus: _propTypes2.default.bool,
	    children: _childrenPropType2.default,
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  childContextTypes: {
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  statics: {
	    setUseDefaultStyles: function setUseDefaultStyles(use) {
	      useDefaultStyles = use;
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selectedIndex: -1,
	      focus: false,
	      forceRenderTabPanel: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.copyPropsToState(this.props, this.state);
	  },
	  getChildContext: function getChildContext() {
	    return {
	      forceRenderTabPanel: this.props.forceRenderTabPanel
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (useDefaultStyles) {
	      (0, _jsStylesheet2.default)(__webpack_require__(560)); // eslint-disable-line global-require
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var _this = this;
	
	    // Use a transactional update to prevent race conditions
	    // when reading the state in copyPropsToState
	    // See https://github.com/reactjs/react-tabs/issues/51
	    this.setState(function (state) {
	      return _this.copyPropsToState(newProps, state);
	    });
	  },
	  setSelected: function setSelected(index, focus) {
	    // Don't do anything if nothing has changed
	    if (index === this.state.selectedIndex) return;
	    // Check index boundary
	    if (index < 0 || index >= this.getTabsCount()) return;
	
	    // Keep reference to last index for event handler
	    var last = this.state.selectedIndex;
	
	    // Check if the change event handler cancels the tab change
	    var cancel = false;
	
	    // Call change event handler
	    if (typeof this.props.onSelect === 'function') {
	      cancel = this.props.onSelect(index, last) === false;
	    }
	
	    if (!cancel) {
	      // Update selected index
	      this.setState({ selectedIndex: index, focus: focus === true });
	    }
	  },
	  getNextTab: function getNextTab(index) {
	    var count = this.getTabsCount();
	
	    // Look for non-disabled tab from index to the last tab on the right
	    for (var i = index + 1; i < count; i++) {
	      var tab = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(tab))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from first on left to index
	    for (var _i = 0; _i < index; _i++) {
	      var _tab = this.getTab(_i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(_tab))) {
	        return _i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  },
	  getPrevTab: function getPrevTab(index) {
	    var i = index;
	
	    // Look for non-disabled tab from index to first tab on the left
	    while (i--) {
	      var tab = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(tab))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from last tab on right to index
	    i = this.getTabsCount();
	    while (i-- > index) {
	      var _tab2 = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(_tab2))) {
	        return i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  },
	  getTabsCount: function getTabsCount() {
	    return this.props.children && this.props.children[0] ? _react2.default.Children.count(this.props.children[0].props.children) : 0;
	  },
	  getPanelsCount: function getPanelsCount() {
	    return _react2.default.Children.count(this.props.children.slice(1));
	  },
	  getTabList: function getTabList() {
	    return this.refs.tablist;
	  },
	  getTab: function getTab(index) {
	    return this.refs['tabs-' + index];
	  },
	  getPanel: function getPanel(index) {
	    return this.refs['panels-' + index];
	  },
	  getChildren: function getChildren() {
	    var index = 0;
	    var count = 0;
	    var children = this.props.children;
	    var state = this.state;
	    var tabIds = this.tabIds = this.tabIds || [];
	    var panelIds = this.panelIds = this.panelIds || [];
	    var diff = this.tabIds.length - this.getTabsCount();
	
	    // Add ids if new tabs have been added
	    // Don't bother removing ids, just keep them in case they are added again
	    // This is more efficient, and keeps the uuid counter under control
	    while (diff++ < 0) {
	      tabIds.push((0, _uuid2.default)());
	      panelIds.push((0, _uuid2.default)());
	    }
	
	    // Map children to dynamically setup refs
	    return _react2.default.Children.map(children, function (child) {
	      // null happens when conditionally rendering TabPanel/Tab
	      // see https://github.com/reactjs/react-tabs/issues/37
	      if (child === null) {
	        return null;
	      }
	
	      var result = null;
	
	      // Clone TabList and Tab components to have refs
	      if (count++ === 0) {
	        // TODO try setting the uuid in the "constructor" for `Tab`/`TabPanel`
	        result = (0, _react.cloneElement)(child, {
	          ref: 'tablist',
	          children: _react2.default.Children.map(child.props.children, function (tab) {
	            // null happens when conditionally rendering TabPanel/Tab
	            // see https://github.com/reactjs/react-tabs/issues/37
	            if (tab === null) {
	              return null;
	            }
	
	            var ref = 'tabs-' + index;
	            var id = tabIds[index];
	            var panelId = panelIds[index];
	            var selected = state.selectedIndex === index;
	            var focus = selected && state.focus;
	
	            index++;
	
	            if (tab.type === _Tab2.default) {
	              return (0, _react.cloneElement)(tab, {
	                ref: ref,
	                id: id,
	                panelId: panelId,
	                selected: selected,
	                focus: focus
	              });
	            }
	
	            return tab;
	          })
	        });
	
	        // Reset index for panels
	        index = 0;
	      }
	      // Clone TabPanel components to have refs
	      else {
	          var ref = 'panels-' + index;
	          var id = panelIds[index];
	          var tabId = tabIds[index];
	          var selected = state.selectedIndex === index;
	
	          index++;
	
	          result = (0, _react.cloneElement)(child, {
	            ref: ref,
	            id: id,
	            tabId: tabId,
	            selected: selected
	          });
	        }
	
	      return result;
	    });
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    if (this.isTabFromContainer(e.target)) {
	      var index = this.state.selectedIndex;
	      var preventDefault = false;
	
	      // Select next tab to the left
	      if (e.keyCode === 37 || e.keyCode === 38) {
	        index = this.getPrevTab(index);
	        preventDefault = true;
	      }
	      // Select next tab to the right
	      /* eslint brace-style:0 */
	      else if (e.keyCode === 39 || e.keyCode === 40) {
	          index = this.getNextTab(index);
	          preventDefault = true;
	        }
	
	      // This prevents scrollbars from moving around
	      if (preventDefault) {
	        e.preventDefault();
	      }
	
	      this.setSelected(index, true);
	    }
	  },
	  handleClick: function handleClick(e) {
	    var node = e.target;
	    do {
	      // eslint-disable-line no-cond-assign
	      if (this.isTabFromContainer(node)) {
	        if (isTabDisabled(node)) {
	          return;
	        }
	
	        var index = [].slice.call(node.parentNode.children).indexOf(node);
	        this.setSelected(index);
	        return;
	      }
	    } while ((node = node.parentNode) !== null);
	  },
	
	
	  // This is an anti-pattern, so sue me
	  copyPropsToState: function copyPropsToState(props, state) {
	    var selectedIndex = props.selectedIndex;
	
	    // If no selectedIndex prop was supplied, then try
	    // preserving the existing selectedIndex from state.
	    // If the state has not selectedIndex, default
	    // to the first tab in the TabList.
	    //
	    // TODO: Need automation testing around this
	    // Manual testing can be done using examples/focus
	    // See 'should preserve selectedIndex when typing' in specs/Tabs.spec.js
	    if (selectedIndex === -1) {
	      if (state && state.selectedIndex) {
	        selectedIndex = state.selectedIndex;
	      } else {
	        selectedIndex = 0;
	      }
	    }
	
	    return {
	      selectedIndex: selectedIndex,
	      focus: props.focus
	    };
	  },
	
	
	  /**
	   * Determine if a node from event.target is a Tab element for the current Tabs container.
	   * If the clicked element is not a Tab, it returns false.
	   * If it finds another Tabs container between the Tab and `this`, it returns false.
	   */
	  isTabFromContainer: function isTabFromContainer(node) {
	    // return immediately if the clicked element is not a Tab.
	    if (!isTabNode(node)) {
	      return false;
	    }
	
	    // Check if the first occurrence of a Tabs container is `this` one.
	    var nodeAncestor = node.parentElement;
	    var tabsNode = (0, _reactDom.findDOMNode)(this);
	    do {
	      if (nodeAncestor === tabsNode) return true;else if (nodeAncestor.getAttribute('data-tabs')) break;
	
	      nodeAncestor = nodeAncestor.parentElement;
	    } while (nodeAncestor);
	
	    return false;
	  },
	  render: function render() {
	    var _this2 = this;
	
	    // This fixes an issue with focus management.
	    //
	    // Ultimately, when focus is true, and an input has focus,
	    // and any change on that input causes a state change/re-render,
	    // focus gets sent back to the active tab, and input loses focus.
	    //
	    // Since the focus state only needs to be remembered
	    // for the current render, we can reset it once the
	    // render has happened.
	    //
	    // Don't use setState, because we don't want to re-render.
	    //
	    // See https://github.com/reactjs/react-tabs/pull/7
	    if (this.state.focus) {
	      setTimeout(function () {
	        _this2.state.focus = false;
	      }, 0);
	    }
	
	    var _props = this.props,
	        className = _props.className,
	        attributes = _objectWithoutProperties(_props, ['className']);
	
	    // Delete all known props, so they don't get added to DOM
	
	
	    delete attributes.selectedIndex;
	    delete attributes.onSelect;
	    delete attributes.focus;
	    delete attributes.children;
	    delete attributes.forceRenderTabPanel;
	    delete attributes.onClick;
	    delete attributes.onKeyDown;
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs', 'react-tabs', className),
	        onClick: this.handleClick,
	        onKeyDown: this.handleKeyDown,
	        'data-tabs': true
	      }),
	      this.getChildren()
	    );
	  }
	});

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tab = __webpack_require__(64);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabList = __webpack_require__(273);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function childrenPropTypes(props, propName) {
	  var error = void 0;
	  var tabsCount = 0;
	  var panelsCount = 0;
	  var children = props[propName];
	
	  _react2.default.Children.forEach(children, function (child) {
	    // null happens when conditionally rendering TabPanel/Tab
	    // see https://github.com/reactjs/react-tabs/issues/37
	    if (child === null) {
	      return;
	    }
	
	    if (child.type === _TabList2.default) {
	      _react2.default.Children.forEach(child.props.children, function (c) {
	        // null happens when conditionally rendering TabPanel/Tab
	        // see https://github.com/reactjs/react-tabs/issues/37
	        if (c === null) {
	          return;
	        }
	
	        if (c.type === _Tab2.default) {
	          tabsCount++;
	        }
	      });
	    } else if (child.type.displayName === 'TabPanel') {
	      panelsCount++;
	    } else {
	      error = new Error('Expected \'TabList\' or \'TabPanel\' but found \'' + (child.type.displayName || child.type) + '\'');
	    }
	  });
	
	  if (tabsCount !== panelsCount) {
	    error = new Error("There should be an equal number of 'Tabs' and 'TabPanels'." + ('Received ' + tabsCount + ' \'Tabs\' and ' + panelsCount + ' \'TabPanels\'.'));
	  }
	
	  return error;
	};

/***/ },
/* 560 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  '.react-tabs [role=tablist]': {
	    'border-bottom': '1px solid #aaa',
	    margin: '0 0 10px',
	    padding: '0'
	  },
	
	  '.react-tabs [role=tab]': {
	    display: 'inline-block',
	    border: '1px solid transparent',
	    'border-bottom': 'none',
	    bottom: '-1px',
	    position: 'relative',
	    'list-style': 'none',
	    padding: '6px 12px',
	    cursor: 'pointer'
	  },
	
	  '.react-tabs [role=tab][aria-selected=true]': {
	    background: '#fff',
	    'border-color': '#aaa',
	    color: 'black',
	    'border-radius': '5px 5px 0 0',
	    '-moz-border-radius': '5px 5px 0 0',
	    '-webkit-border-radius': '5px 5px 0 0'
	  },
	
	  '.react-tabs [role=tab][aria-disabled=true]': {
	    color: 'GrayText',
	    cursor: 'default'
	  },
	
	  '.react-tabs [role=tab]:focus': {
	    'box-shadow': '0 0 5px hsl(208, 99%, 50%)',
	    'border-color': 'hsl(208, 99%, 50%)',
	    outline: 'none'
	  },
	
	  '.react-tabs [role=tab]:focus:after': {
	    content: '""',
	    position: 'absolute',
	    height: '5px',
	    left: '-4px',
	    right: '-4px',
	    bottom: '-5px',
	    background: '#fff'
	  }
	};

/***/ },
/* 561 */
/***/ function(module, exports) {

	"use strict";
	
	// Get a universally unique identifier
	var count = 0;
	module.exports = function uuid() {
	  return "react-tabs-" + count++;
	};

/***/ },
/* 562 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 *  Copyright (c) 2015-present, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var GLOBAL = typeof window === 'undefined' ? global : window;
	
	var setter = function(_setter, _clearer, array) {
	  return function(callback, delta) {
	    var id = _setter(function() {
	      _clearer.call(this, id);
	      callback.apply(this, arguments);
	    }.bind(this), delta);
	
	    if (!this[array]) {
	      this[array] = [id];
	    } else {
	      this[array].push(id);
	    }
	    return id;
	  };
	};
	
	var clearer = function(_clearer, array) {
	  return function(id) {
	    if (this[array]) {
	      var index = this[array].indexOf(id);
	      if (index !== -1) {
	        this[array].splice(index, 1);
	      }
	    }
	    _clearer(id);
	  };
	};
	
	var _timeouts = 'TimerMixin_timeouts';
	var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts);
	var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts);
	
	var _intervals = 'TimerMixin_intervals';
	var _clearInterval = clearer(GLOBAL.clearInterval, _intervals);
	var _setInterval = setter(GLOBAL.setInterval, function() {/* noop */}, _intervals);
	
	var _immediates = 'TimerMixin_immediates';
	var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates);
	var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates);
	
	var _rafs = 'TimerMixin_rafs';
	var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs);
	var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs);
	
	var TimerMixin = {
	  componentWillUnmount: function() {
	    this[_timeouts] && this[_timeouts].forEach(function(id) {
	      GLOBAL.clearTimeout(id);
	    });
	    this[_timeouts] = null;
	    this[_intervals] && this[_intervals].forEach(function(id) {
	      GLOBAL.clearInterval(id);
	    });
	    this[_intervals] = null;
	    this[_immediates] && this[_immediates].forEach(function(id) {
	      GLOBAL.clearImmediate(id);
	    });
	    this[_immediates] = null;
	    this[_rafs] && this[_rafs].forEach(function(id) {
	      GLOBAL.cancelAnimationFrame(id);
	    });
	    this[_rafs] = null;
	  },
	
	  setTimeout: _setTimeout,
	  clearTimeout: _clearTimeout,
	
	  setInterval: _setInterval,
	  clearInterval: _clearInterval,
	
	  setImmediate: _setImmediate,
	  clearImmediate: _clearImmediate,
	
	  requestAnimationFrame: _requestAnimationFrame,
	  cancelAnimationFrame: _cancelAnimationFrame,
	};
	
	module.exports = TimerMixin;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 563 */
83,
/* 564 */
[581, 41],
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(564);
	var ReactElement = __webpack_require__(40);
	
	var emptyFunction = __webpack_require__(16);
	var traverseAllChildren = __webpack_require__(573);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(41),
	    _assign = __webpack_require__(11);
	
	var ReactComponent = __webpack_require__(98);
	var ReactElement = __webpack_require__(40);
	var ReactPropTypeLocationNames = __webpack_require__(277);
	var ReactNoopUpdateQueue = __webpack_require__(99);
	
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(7);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(40);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(40);
	var ReactPropTypeLocationNames = __webpack_require__(277);
	var ReactPropTypesSecret = __webpack_require__(569);
	
	var emptyFunction = __webpack_require__(16);
	var getIteratorFn = __webpack_require__(279);
	var warning = __webpack_require__(7);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 569 */
497,
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactComponent = __webpack_require__(98);
	var ReactNoopUpdateQueue = __webpack_require__(99);
	
	var emptyObject = __webpack_require__(33);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 571 */
502,
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(41);
	
	var ReactElement = __webpack_require__(40);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(41);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var REACT_ELEMENT_TYPE = __webpack_require__(276);
	
	var getIteratorFn = __webpack_require__(279);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(563);
	var warning = __webpack_require__(7);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["ReactAutocomplete"] = factory(require("react"));
		else
			root["ReactAutocomplete"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var React = __webpack_require__(1);
		var ReactDOM = __webpack_require__(2);
		var joinClasses = __webpack_require__(178);
	
		var Autocomplete = React.createClass({ displayName: "Autocomplete",
	
		  propTypes: {
		    options: React.PropTypes.any,
		    search: React.PropTypes.func,
		    resultRenderer: React.PropTypes.oneOfType([React.PropTypes.component, React.PropTypes.func]),
		    value: React.PropTypes.object,
		    onChange: React.PropTypes.func,
		    onError: React.PropTypes.func,
		    onFocus: React.PropTypes.func
		  },
	
		  getDefaultProps: function () {
		    return { search: searchArray };
		  },
	
		  getInitialState: function () {
		    var searchTerm = this.props.searchTerm ? this.props.searchTerm : this.props.value ? this.props.value.title : "";
		    return {
		      results: [],
		      showResults: false,
		      showResultsInProgress: false,
		      searchTerm: searchTerm,
		      focusedValue: null
		    };
		  },
	
		  getResultIdentifier: function (result) {
		    if (this.props.resultIdentifier === undefined) {
		      return result.id;
		    } else {
		      return result[this.props.resultIdentifier];
		    }
		  },
	
	
		  render: function () {
		    var className = joinClasses(this.props.className, "react-autocomplete-Autocomplete", this.state.showResults ? "react-autocomplete-Autocomplete--resultsShown" : undefined);
		    var style = {
		      position: "relative",
		      outline: "none"
		    };
		    return React.createElement("div", {
		      tabIndex: "1",
		      className: className,
		      onFocus: this.onFocus,
		      onBlur: this.onBlur,
		      style: style }, React.createElement("input", {
		      ref: "search",
		      className: "react-autocomplete-Autocomplete__search",
		      style: { width: "100%" },
		      onClick: this.showAllResults,
		      onChange: this.onQueryChange,
		      onFocus: this.onSearchInputFocus,
		      onBlur: this.onQueryBlur,
		      onKeyDown: this.onQueryKeyDown,
		      value: this.state.searchTerm }), React.createElement(Results, {
		      className: "react-autocomplete-Autocomplete__results",
		      onSelect: this.onValueChange,
		      onFocus: this.onValueFocus,
		      results: this.state.results,
		      focusedValue: this.state.focusedValue,
		      show: this.state.showResults,
		      renderer: this.props.resultRenderer,
		      label: this.props.label,
		      resultIdentifier: this.props.resultIdentifier }));
		  },
	
		  componentWillReceiveProps: function (nextProps) {
		    var searchTerm = nextProps.searchTerm ? nextProps.searchTerm : nextProps.value ? nextProps.value.title : "";
		    this.setState({ searchTerm: searchTerm });
		  },
	
		  componentWillMount: function () {
		    this.blurTimer = null;
		  },
	
		  /**
		    * Show results for a search term value.
		    *
		    * This method doesn't update search term value itself.
		    *
		    * @param {Search} searchTerm
		    */
		  showResults: function (searchTerm) {
		    this.setState({ showResultsInProgress: true });
		    this.props.search(this.props.options, searchTerm.trim(), this.onSearchComplete);
		  },
	
		  showAllResults: function () {
		    if (!this.state.showResultsInProgress && !this.state.showResults) {
		      this.showResults("");
		    }
		  },
	
		  onValueChange: function (value) {
		    var state = {
		      value: value,
		      showResults: false
		    };
	
		    if (value) {
		      state.searchTerm = value.title;
		    }
	
		    this.setState(state);
	
		    if (this.props.onChange) {
		      this.props.onChange(value);
		    }
		  },
	
		  onSearchComplete: function (err, results) {
		    if (err) {
		      if (this.props.onError) {
		        this.props.onError(err);
		      } else {
		        throw err;
		      }
		    }
	
		    this.setState({
		      showResultsInProgress: false,
		      showResults: true,
		      results: results
		    });
		  },
	
		  onValueFocus: function (value) {
		    this.setState({ focusedValue: value });
		  },
	
		  onQueryChange: function (e) {
		    var searchTerm = e.target.value;
		    this.setState({
		      searchTerm: searchTerm,
		      focusedValue: null
		    });
		    this.showResults(searchTerm);
		  },
	
		  onFocus: function () {
		    if (this.blurTimer) {
		      clearTimeout(this.blurTimer);
		      this.blurTimer = null;
		    }
		    this.refs.search.focus();
		  },
	
		  onSearchInputFocus: function () {
		    if (this.props.onFocus) {
		      this.props.onFocus();
		    }
	
		    this.showAllResults();
		  },
	
		  onBlur: function () {
		    // wrap in setTimeout so we can catch a click on results
		    this.blurTimer = setTimeout((function () {
		      if (this.isMounted()) {
		        this.setState({ showResults: false });
		      }
		    }).bind(this), 100);
		  },
	
		  onQueryKeyDown: function (e) {
		    if (e.key === "Enter") {
		      e.preventDefault();
		      if (this.state.focusedValue) {
		        this.onValueChange(this.state.focusedValue);
		      }
		    } else if (e.key === "ArrowUp" && this.state.showResults) {
		      e.preventDefault();
		      var prevIdx = Math.max(this.focusedValueIndex() - 1, 0);
		      this.setState({
		        focusedValue: this.state.results[prevIdx]
		      });
		    } else if (e.key === "ArrowDown") {
		      e.preventDefault();
		      if (this.state.showResults) {
		        var nextIdx = Math.min(this.focusedValueIndex() + (this.state.showResults ? 1 : 0), this.state.results.length - 1);
		        this.setState({
		          showResults: true,
		          focusedValue: this.state.results[nextIdx]
		        });
		      } else {
		        this.showAllResults();
		      }
		    }
		  },
	
		  focusedValueIndex: function () {
		    if (!this.state.focusedValue) {
		      return -1;
		    }
		    for (var i = 0, len = this.state.results.length; i < len; i++) {
		      if (this.getResultIdentifier(this.state.results[i]) === this.getResultIdentifier(this.state.focusedValue)) {
		        return i;
		      }
		    }
		    return -1;
		  }
		});
	
		var Results = React.createClass({ displayName: "Results",
	
		  getResultIdentifier: function (result) {
		    if (this.props.resultIdentifier === undefined) {
		      if (!result.id) {
		        throw Error("id property not found on result. You must specify a resultIdentifier and pass as props to autocomplete component");
		      }
		      return result.id;
		    } else {
		      return result[this.props.resultIdentifier];
		    }
		  },
	
		  render: function () {
		    var style = {
		      display: this.props.show ? "block" : "none",
		      position: "absolute",
		      listStyleType: "none"
		    };
		    var $__0 = this.props,
		        className = $__0.className,
		        props = (function (source, exclusion) {
		      var rest = {};var hasOwn = Object.prototype.hasOwnProperty;if (source == null) {
		        throw new TypeError();
		      }for (var key in source) {
		        if (hasOwn.call(source, key) && !hasOwn.call(exclusion, key)) {
		          rest[key] = source[key];
		        }
		      }return rest;
		    })($__0, { className: 1 });
	
		    return React.createElement("ul", { style: style, className: className + " react-autocomplete-Results" }, this.props.results.map(this.renderResult));
		  },
	
		  renderResult: function (result) {
		    var focused = this.props.focusedValue && this.getResultIdentifier(this.props.focusedValue) === this.getResultIdentifier(result);
		    var Renderer = this.props.renderer || Result;
		    return React.createElement(Renderer, {
		      ref: focused ? "focused" : undefined,
		      key: this.getResultIdentifier(result),
		      result: result,
		      focused: focused,
		      onMouseEnter: this.onMouseEnterResult,
		      onClick: this.props.onSelect,
		      label: this.props.label });
		  },
	
		  componentDidUpdate: function () {
		    this.scrollToFocused();
		  },
	
		  componentDidMount: function () {
		    this.scrollToFocused();
		  },
	
		  componentWillMount: function () {
		    this.ignoreFocus = false;
		  },
	
		  scrollToFocused: function () {
		    var focused = this.refs && this.refs.focused;
		    if (focused) {
		      var containerNode = ReactDOM.findDOMNode(this);
		      var scroll = containerNode.scrollTop;
		      var height = containerNode.offsetHeight;
	
		      var node = ReactDOM.findDOMNode(focused);
		      var top = node.offsetTop;
		      var bottom = top + node.offsetHeight;
	
		      // we update ignoreFocus to true if we change the scroll position so
		      // the mouseover event triggered because of that won't have an
		      // effect
		      if (top < scroll) {
		        this.ignoreFocus = true;
		        containerNode.scrollTop = top;
		      } else if (bottom - scroll > height) {
		        this.ignoreFocus = true;
		        containerNode.scrollTop = bottom - height;
		      }
		    }
		  },
	
		  onMouseEnterResult: function (e, result) {
		    // check if we need to prevent the next onFocus event because it was
		    // probably caused by a mouseover due to scroll position change
		    if (this.ignoreFocus) {
		      this.ignoreFocus = false;
		    } else {
		      // we need to make sure focused node is visible
		      // for some reason mouse events fire on visible nodes due to
		      // box-shadow
		      var containerNode = ReactDOM.findDOMNode(this);
		      var scroll = containerNode.scrollTop;
		      var height = containerNode.offsetHeight;
	
		      var node = e.target;
		      var top = node.offsetTop;
		      var bottom = top + node.offsetHeight;
	
		      if (bottom > scroll && top < scroll + height) {
		        this.props.onFocus(result);
		      }
		    }
		  }
		});
	
		var Result = React.createClass({ displayName: "Result",
	
		  getDefaultProps: function () {
		    return {
		      label: function (result) {
		        return result.title;
		      }
		    };
		  },
	
		  getLabel: function (result) {
		    if (typeof this.props.label === "function") {
		      return this.props.label(result);
		    } else if (typeof this.props.label === "string") {
		      return result[this.props.label];
		    }
		  },
	
		  render: function () {
		    var className = joinClasses({
		      "react-autocomplete-Result": true,
		      "react-autocomplete-Result--active": this.props.focused
		    });
	
		    return React.createElement("li", {
		      style: { listStyleType: "none" },
		      className: className,
		      onClick: this.onClick,
		      onMouseEnter: this.onMouseEnter }, React.createElement("a", null, this.getLabel(this.props.result)));
		  },
	
		  onClick: function () {
		    this.props.onClick(this.props.result);
		  },
	
		  onMouseEnter: function (e) {
		    if (this.props.onMouseEnter) {
		      this.props.onMouseEnter(e, this.props.result);
		    }
		  },
	
		  shouldComponentUpdate: function (nextProps) {
		    return nextProps.result.id !== this.props.result.id || nextProps.focused !== this.props.focused;
		  }
		});
	
		/**
		* Search options using specified search term treating options as an array
		* of candidates.
		*
		* @param {Array.<Object>} options
		* @param {String} searchTerm
		* @param {Callback} cb
		*/
		function searchArray(options, searchTerm, cb) {
		  if (!options) {
		    return cb(null, []);
		  }
	
		  searchTerm = new RegExp(searchTerm, "i");
	
		  var results = [];
	
		  for (var i = 0, len = options.length; i < len; i++) {
		    if (searchTerm.exec(options[i].title)) {
		      results.push(options[i]);
		    }
		  }
	
		  cb(null, results);
		}
	
		module.exports = Autocomplete;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(3);
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
		'use strict';
	
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactDefaultInjection = __webpack_require__(10);
		var ReactMount = __webpack_require__(166);
		var ReactReconciler = __webpack_require__(34);
		var ReactUpdates = __webpack_require__(31);
		var ReactVersion = __webpack_require__(171);
	
		var findDOMNode = __webpack_require__(172);
		var getHostComponentFromComposite = __webpack_require__(173);
		var renderSubtreeIntoContainer = __webpack_require__(174);
		var warning = __webpack_require__(18);
	
		ReactDefaultInjection.inject();
	
		var ReactDOM = {
		  findDOMNode: findDOMNode,
		  render: ReactMount.render,
		  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
		  version: ReactVersion,
	
		  /* eslint-disable camelcase */
		  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
		  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
		};
	
		// Inject the runtime into a devtools global hook regardless of browser.
		// Allows for debugging when the hook is injected on the page.
		if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
		  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
		    ComponentTree: {
		      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
		      getNodeFromInstance: function (inst) {
		        // inst is an internal instance (but could be a composite)
		        if (inst._renderedComponent) {
		          inst = getHostComponentFromComposite(inst);
		        }
		        if (inst) {
		          return ReactDOMComponentTree.getNodeFromInstance(inst);
		        } else {
		          return null;
		        }
		      }
		    },
		    Mount: ReactMount,
		    Reconciler: ReactReconciler
		  });
		}
	
		if (process.env.NODE_ENV !== 'production') {
		  var ExecutionEnvironment = __webpack_require__(22);
		  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
		    // First check if devtools is not installed
		    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
		      // If we're in Chrome or Firefox, provide a download link if not installed.
		      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
		        // Firefox does not have the issue with devtools loaded over file://
		        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
		        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
		      }
		    }
	
		    var testFunc = function testFn() {};
		    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
		    // If we're in IE8, check to see if we are in compatibility mode and provide
		    // information on preventing compatibility mode
		    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
		    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
		    var expectedFeatures = [
		    // shims
		    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
		    for (var i = 0; i < expectedFeatures.length; i++) {
		      if (!expectedFeatures[i]) {
		        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
		        break;
		      }
		    }
		  }
		}
	
		if (process.env.NODE_ENV !== 'production') {
		  var ReactInstrumentation = __webpack_require__(37);
		  var ReactDOMUnknownPropertyHook = __webpack_require__(175);
		  var ReactDOMNullInputValuePropHook = __webpack_require__(176);
		  var ReactDOMInvalidARIAHook = __webpack_require__(177);
	
		  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
		  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
		  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
		}
	
		module.exports = ReactDOM;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
	
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
	
		var cachedSetTimeout;
		var cachedClearTimeout;
	
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
	
	
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
	
	
	
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
	
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
	
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
	
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
	
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
	
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
	
		function noop() {}
	
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
	
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
	
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var DOMProperty = __webpack_require__(7);
		var ReactDOMComponentFlags = __webpack_require__(9);
	
		var invariant = __webpack_require__(8);
	
		var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
		var Flags = ReactDOMComponentFlags;
	
		var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
		/**
		 * Check if a given node should be cached.
		 */
		function shouldPrecacheNode(node, nodeID) {
		  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
		}
	
		/**
		 * Drill down (through composites and empty components) until we get a host or
		 * host text component.
		 *
		 * This is pretty polymorphic but unavoidable with the current structure we have
		 * for `_renderedChildren`.
		 */
		function getRenderedHostOrTextFromComponent(component) {
		  var rendered;
		  while (rendered = component._renderedComponent) {
		    component = rendered;
		  }
		  return component;
		}
	
		/**
		 * Populate `_hostNode` on the rendered host/text component with the given
		 * DOM node. The passed `inst` can be a composite.
		 */
		function precacheNode(inst, node) {
		  var hostInst = getRenderedHostOrTextFromComponent(inst);
		  hostInst._hostNode = node;
		  node[internalInstanceKey] = hostInst;
		}
	
		function uncacheNode(inst) {
		  var node = inst._hostNode;
		  if (node) {
		    delete node[internalInstanceKey];
		    inst._hostNode = null;
		  }
		}
	
		/**
		 * Populate `_hostNode` on each child of `inst`, assuming that the children
		 * match up with the DOM (element) children of `node`.
		 *
		 * We cache entire levels at once to avoid an n^2 problem where we access the
		 * children of a node sequentially and have to walk from the start to our target
		 * node every time.
		 *
		 * Since we update `_renderedChildren` and the actual DOM at (slightly)
		 * different times, we could race here and see a newer `_renderedChildren` than
		 * the DOM nodes we see. To avoid this, ReactMultiChild calls
		 * `prepareToManageChildren` before we change `_renderedChildren`, at which
		 * time the container's child nodes are always cached (until it unmounts).
		 */
		function precacheChildNodes(inst, node) {
		  if (inst._flags & Flags.hasCachedChildNodes) {
		    return;
		  }
		  var children = inst._renderedChildren;
		  var childNode = node.firstChild;
		  outer: for (var name in children) {
		    if (!children.hasOwnProperty(name)) {
		      continue;
		    }
		    var childInst = children[name];
		    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
		    if (childID === 0) {
		      // We're currently unmounting this child in ReactMultiChild; skip it.
		      continue;
		    }
		    // We assume the child nodes are in the same order as the child instances.
		    for (; childNode !== null; childNode = childNode.nextSibling) {
		      if (shouldPrecacheNode(childNode, childID)) {
		        precacheNode(childInst, childNode);
		        continue outer;
		      }
		    }
		    // We reached the end of the DOM children without finding an ID match.
		     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
		  }
		  inst._flags |= Flags.hasCachedChildNodes;
		}
	
		/**
		 * Given a DOM node, return the closest ReactDOMComponent or
		 * ReactDOMTextComponent instance ancestor.
		 */
		function getClosestInstanceFromNode(node) {
		  if (node[internalInstanceKey]) {
		    return node[internalInstanceKey];
		  }
	
		  // Walk up the tree until we find an ancestor whose instance we have cached.
		  var parents = [];
		  while (!node[internalInstanceKey]) {
		    parents.push(node);
		    if (node.parentNode) {
		      node = node.parentNode;
		    } else {
		      // Top of the tree. This node must not be part of a React tree (or is
		      // unmounted, potentially).
		      return null;
		    }
		  }
	
		  var closest;
		  var inst;
		  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
		    closest = inst;
		    if (parents.length) {
		      precacheChildNodes(inst, node);
		    }
		  }
	
		  return closest;
		}
	
		/**
		 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
		 * instance, or null if the node was not rendered by this React.
		 */
		function getInstanceFromNode(node) {
		  var inst = getClosestInstanceFromNode(node);
		  if (inst != null && inst._hostNode === node) {
		    return inst;
		  } else {
		    return null;
		  }
		}
	
		/**
		 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
		 * DOM node.
		 */
		function getNodeFromInstance(inst) {
		  // Without this first invariant, passing a non-DOM-component triggers the next
		  // invariant for a missing parent, which is super confusing.
		  !(inst._hostNode !== undefined) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
		  if (inst._hostNode) {
		    return inst._hostNode;
		  }
	
		  // Walk up the tree until we find an ancestor whose DOM node we have cached.
		  var parents = [];
		  while (!inst._hostNode) {
		    parents.push(inst);
		    !inst._hostParent ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
		    inst = inst._hostParent;
		  }
	
		  // Now parents contains each ancestor that does *not* have a cached native
		  // node, and `inst` is the deepest ancestor that does.
		  for (; parents.length; inst = parents.pop()) {
		    precacheChildNodes(inst, inst._hostNode);
		  }
	
		  return inst._hostNode;
		}
	
		var ReactDOMComponentTree = {
		  getClosestInstanceFromNode: getClosestInstanceFromNode,
		  getInstanceFromNode: getInstanceFromNode,
		  getNodeFromInstance: getNodeFromInstance,
		  precacheChildNodes: precacheChildNodes,
		  precacheNode: precacheNode,
		  uncacheNode: uncacheNode
		};
	
		module.exports = ReactDOMComponentTree;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
		'use strict';
	
		/**
		 * WARNING: DO NOT manually require this module.
		 * This is a replacement for `invariant(...)` used by the error code system
		 * and will _only_ be required by the corresponding babel pass.
		 * It always throws.
		 */
	
		function reactProdInvariant(code) {
		  var argCount = arguments.length - 1;
	
		  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
		  for (var argIdx = 0; argIdx < argCount; argIdx++) {
		    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
		  }
	
		  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
		  var error = new Error(message);
		  error.name = 'Invariant Violation';
		  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
		  throw error;
		}
	
		module.exports = reactProdInvariant;
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		function checkMask(value, bitmask) {
		  return (value & bitmask) === bitmask;
		}
	
		var DOMPropertyInjection = {
		  /**
		   * Mapping from normalized, camelcased property names to a configuration that
		   * specifies how the associated DOM property should be accessed or rendered.
		   */
		  MUST_USE_PROPERTY: 0x1,
		  HAS_BOOLEAN_VALUE: 0x4,
		  HAS_NUMERIC_VALUE: 0x8,
		  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
		  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
		  /**
		   * Inject some specialized knowledge about the DOM. This takes a config object
		   * with the following properties:
		   *
		   * isCustomAttribute: function that given an attribute name will return true
		   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
		   * attributes where it's impossible to enumerate all of the possible
		   * attribute names,
		   *
		   * Properties: object mapping DOM property name to one of the
		   * DOMPropertyInjection constants or null. If your attribute isn't in here,
		   * it won't get written to the DOM.
		   *
		   * DOMAttributeNames: object mapping React attribute name to the DOM
		   * attribute name. Attribute names not specified use the **lowercase**
		   * normalized name.
		   *
		   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
		   * attribute namespace URL. (Attribute names not specified use no namespace.)
		   *
		   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
		   * Property names not specified use the normalized name.
		   *
		   * DOMMutationMethods: Properties that require special mutation methods. If
		   * `value` is undefined, the mutation method should unset the property.
		   *
		   * @param {object} domPropertyConfig the config as described above.
		   */
		  injectDOMPropertyConfig: function (domPropertyConfig) {
		    var Injection = DOMPropertyInjection;
		    var Properties = domPropertyConfig.Properties || {};
		    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
		    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
		    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
		    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
		    if (domPropertyConfig.isCustomAttribute) {
		      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
		    }
	
		    for (var propName in Properties) {
		      !!DOMProperty.properties.hasOwnProperty(propName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
		      var lowerCased = propName.toLowerCase();
		      var propConfig = Properties[propName];
	
		      var propertyInfo = {
		        attributeName: lowerCased,
		        attributeNamespace: null,
		        propertyName: propName,
		        mutationMethod: null,
	
		        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
		        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
		        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
		        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
		        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
		      };
		      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
		      if (process.env.NODE_ENV !== 'production') {
		        DOMProperty.getPossibleStandardName[lowerCased] = propName;
		      }
	
		      if (DOMAttributeNames.hasOwnProperty(propName)) {
		        var attributeName = DOMAttributeNames[propName];
		        propertyInfo.attributeName = attributeName;
		        if (process.env.NODE_ENV !== 'production') {
		          DOMProperty.getPossibleStandardName[attributeName] = propName;
		        }
		      }
	
		      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
		        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
		      }
	
		      if (DOMPropertyNames.hasOwnProperty(propName)) {
		        propertyInfo.propertyName = DOMPropertyNames[propName];
		      }
	
		      if (DOMMutationMethods.hasOwnProperty(propName)) {
		        propertyInfo.mutationMethod = DOMMutationMethods[propName];
		      }
	
		      DOMProperty.properties[propName] = propertyInfo;
		    }
		  }
		};
	
		/* eslint-disable max-len */
		var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
		/* eslint-enable max-len */
	
		/**
		 * DOMProperty exports lookup objects that can be used like functions:
		 *
		 *   > DOMProperty.isValid['id']
		 *   true
		 *   > DOMProperty.isValid['foobar']
		 *   undefined
		 *
		 * Although this may be confusing, it performs better in general.
		 *
		 * @see http://jsperf.com/key-exists
		 * @see http://jsperf.com/key-missing
		 */
		var DOMProperty = {
	
		  ID_ATTRIBUTE_NAME: 'data-reactid',
		  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
		  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
		  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
		  /**
		   * Map from property "standard name" to an object with info about how to set
		   * the property in the DOM. Each object contains:
		   *
		   * attributeName:
		   *   Used when rendering markup or with `*Attribute()`.
		   * attributeNamespace
		   * propertyName:
		   *   Used on DOM node instances. (This includes properties that mutate due to
		   *   external factors.)
		   * mutationMethod:
		   *   If non-null, used instead of the property or `setAttribute()` after
		   *   initial render.
		   * mustUseProperty:
		   *   Whether the property must be accessed and mutated as an object property.
		   * hasBooleanValue:
		   *   Whether the property should be removed when set to a falsey value.
		   * hasNumericValue:
		   *   Whether the property must be numeric or parse as a numeric and should be
		   *   removed when set to a falsey value.
		   * hasPositiveNumericValue:
		   *   Whether the property must be positive numeric or parse as a positive
		   *   numeric and should be removed when set to a falsey value.
		   * hasOverloadedBooleanValue:
		   *   Whether the property can be used as a flag as well as with a value.
		   *   Removed when strictly equal to false; present without a value when
		   *   strictly equal to true; present with a value otherwise.
		   */
		  properties: {},
	
		  /**
		   * Mapping from lowercase property names to the properly cased version, used
		   * to warn in the case of missing properties. Available only in __DEV__.
		   *
		   * autofocus is predefined, because adding it to the property whitelist
		   * causes unintended side effects.
		   *
		   * @type {Object}
		   */
		  getPossibleStandardName: process.env.NODE_ENV !== 'production' ? { autofocus: 'autoFocus' } : null,
	
		  /**
		   * All of the isCustomAttribute() functions that have been injected.
		   */
		  _isCustomAttributeFunctions: [],
	
		  /**
		   * Checks whether a property name is a custom attribute.
		   * @method
		   */
		  isCustomAttribute: function (attributeName) {
		    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
		      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
		      if (isCustomAttributeFn(attributeName)) {
		        return true;
		      }
		    }
		    return false;
		  },
	
		  injection: DOMPropertyInjection
		};
	
		module.exports = DOMProperty;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (process.env.NODE_ENV !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2015-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactDOMComponentFlags = {
		  hasCachedChildNodes: 1 << 0
		};
	
		module.exports = ReactDOMComponentFlags;
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ARIADOMPropertyConfig = __webpack_require__(11);
		var BeforeInputEventPlugin = __webpack_require__(12);
		var ChangeEventPlugin = __webpack_require__(30);
		var DefaultEventPluginOrder = __webpack_require__(50);
		var EnterLeaveEventPlugin = __webpack_require__(51);
		var HTMLDOMPropertyConfig = __webpack_require__(56);
		var ReactComponentBrowserEnvironment = __webpack_require__(57);
		var ReactDOMComponent = __webpack_require__(70);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactDOMEmptyComponent = __webpack_require__(137);
		var ReactDOMTreeTraversal = __webpack_require__(138);
		var ReactDOMTextComponent = __webpack_require__(139);
		var ReactDefaultBatchingStrategy = __webpack_require__(140);
		var ReactEventListener = __webpack_require__(141);
		var ReactInjection = __webpack_require__(144);
		var ReactReconcileTransaction = __webpack_require__(145);
		var SVGDOMPropertyConfig = __webpack_require__(153);
		var SelectEventPlugin = __webpack_require__(154);
		var SimpleEventPlugin = __webpack_require__(155);
	
		var alreadyInjected = false;
	
		function inject() {
		  if (alreadyInjected) {
		    // TODO: This is currently true because these injections are shared between
		    // the client and the server package. They should be built independently
		    // and not share any injection state. Then this problem will be solved.
		    return;
		  }
		  alreadyInjected = true;
	
		  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
		  /**
		   * Inject modules for resolving DOM hierarchy and plugin ordering.
		   */
		  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
		  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
		  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
		  /**
		   * Some important event plugins included by default (without having to require
		   * them).
		   */
		  ReactInjection.EventPluginHub.injectEventPluginsByName({
		    SimpleEventPlugin: SimpleEventPlugin,
		    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
		    ChangeEventPlugin: ChangeEventPlugin,
		    SelectEventPlugin: SelectEventPlugin,
		    BeforeInputEventPlugin: BeforeInputEventPlugin
		  });
	
		  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
		  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
		  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
		  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
		  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
		  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
		    return new ReactDOMEmptyComponent(instantiate);
		  });
	
		  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
		  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
		  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
		}
	
		module.exports = {
		  inject: inject
		};
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ARIADOMPropertyConfig = {
		  Properties: {
		    // Global States and Properties
		    'aria-current': 0, // state
		    'aria-details': 0,
		    'aria-disabled': 0, // state
		    'aria-hidden': 0, // state
		    'aria-invalid': 0, // state
		    'aria-keyshortcuts': 0,
		    'aria-label': 0,
		    'aria-roledescription': 0,
		    // Widget Attributes
		    'aria-autocomplete': 0,
		    'aria-checked': 0,
		    'aria-expanded': 0,
		    'aria-haspopup': 0,
		    'aria-level': 0,
		    'aria-modal': 0,
		    'aria-multiline': 0,
		    'aria-multiselectable': 0,
		    'aria-orientation': 0,
		    'aria-placeholder': 0,
		    'aria-pressed': 0,
		    'aria-readonly': 0,
		    'aria-required': 0,
		    'aria-selected': 0,
		    'aria-sort': 0,
		    'aria-valuemax': 0,
		    'aria-valuemin': 0,
		    'aria-valuenow': 0,
		    'aria-valuetext': 0,
		    // Live Region Attributes
		    'aria-atomic': 0,
		    'aria-busy': 0,
		    'aria-live': 0,
		    'aria-relevant': 0,
		    // Drag-and-Drop Attributes
		    'aria-dropeffect': 0,
		    'aria-grabbed': 0,
		    // Relationship Attributes
		    'aria-activedescendant': 0,
		    'aria-colcount': 0,
		    'aria-colindex': 0,
		    'aria-colspan': 0,
		    'aria-controls': 0,
		    'aria-describedby': 0,
		    'aria-errormessage': 0,
		    'aria-flowto': 0,
		    'aria-labelledby': 0,
		    'aria-owns': 0,
		    'aria-posinset': 0,
		    'aria-rowcount': 0,
		    'aria-rowindex': 0,
		    'aria-rowspan': 0,
		    'aria-setsize': 0
		  },
		  DOMAttributeNames: {},
		  DOMPropertyNames: {}
		};
	
		module.exports = ARIADOMPropertyConfig;
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var EventPropagators = __webpack_require__(13);
		var ExecutionEnvironment = __webpack_require__(22);
		var FallbackCompositionState = __webpack_require__(23);
		var SyntheticCompositionEvent = __webpack_require__(27);
		var SyntheticInputEvent = __webpack_require__(29);
	
		var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
		var START_KEYCODE = 229;
	
		var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
		var documentMode = null;
		if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
		  documentMode = document.documentMode;
		}
	
		// Webkit offers a very useful `textInput` event that can be used to
		// directly represent `beforeInput`. The IE `textinput` event is not as
		// useful, so we don't use it.
		var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
		// In IE9+, we have access to composition events, but the data supplied
		// by the native compositionend event may be incorrect. Japanese ideographic
		// spaces, for instance (\u3000) are not recorded correctly.
		var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
		/**
		 * Opera <= 12 includes TextEvent in window, but does not fire
		 * text input events. Rely on keypress instead.
		 */
		function isPresto() {
		  var opera = window.opera;
		  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
		}
	
		var SPACEBAR_CODE = 32;
		var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
		// Events and their corresponding property names.
		var eventTypes = {
		  beforeInput: {
		    phasedRegistrationNames: {
		      bubbled: 'onBeforeInput',
		      captured: 'onBeforeInputCapture'
		    },
		    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
		  },
		  compositionEnd: {
		    phasedRegistrationNames: {
		      bubbled: 'onCompositionEnd',
		      captured: 'onCompositionEndCapture'
		    },
		    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
		  },
		  compositionStart: {
		    phasedRegistrationNames: {
		      bubbled: 'onCompositionStart',
		      captured: 'onCompositionStartCapture'
		    },
		    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
		  },
		  compositionUpdate: {
		    phasedRegistrationNames: {
		      bubbled: 'onCompositionUpdate',
		      captured: 'onCompositionUpdateCapture'
		    },
		    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
		  }
		};
	
		// Track whether we've ever handled a keypress on the space key.
		var hasSpaceKeypress = false;
	
		/**
		 * Return whether a native keypress event is assumed to be a command.
		 * This is required because Firefox fires `keypress` events for key commands
		 * (cut, copy, select-all, etc.) even though no character is inserted.
		 */
		function isKeypressCommand(nativeEvent) {
		  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
		  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
		  !(nativeEvent.ctrlKey && nativeEvent.altKey);
		}
	
		/**
		 * Translate native top level events into event types.
		 *
		 * @param {string} topLevelType
		 * @return {object}
		 */
		function getCompositionEventType(topLevelType) {
		  switch (topLevelType) {
		    case 'topCompositionStart':
		      return eventTypes.compositionStart;
		    case 'topCompositionEnd':
		      return eventTypes.compositionEnd;
		    case 'topCompositionUpdate':
		      return eventTypes.compositionUpdate;
		  }
		}
	
		/**
		 * Does our fallback best-guess model think this event signifies that
		 * composition has begun?
		 *
		 * @param {string} topLevelType
		 * @param {object} nativeEvent
		 * @return {boolean}
		 */
		function isFallbackCompositionStart(topLevelType, nativeEvent) {
		  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
		}
	
		/**
		 * Does our fallback mode think that this event is the end of composition?
		 *
		 * @param {string} topLevelType
		 * @param {object} nativeEvent
		 * @return {boolean}
		 */
		function isFallbackCompositionEnd(topLevelType, nativeEvent) {
		  switch (topLevelType) {
		    case 'topKeyUp':
		      // Command keys insert or clear IME input.
		      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
		    case 'topKeyDown':
		      // Expect IME keyCode on each keydown. If we get any other
		      // code we must have exited earlier.
		      return nativeEvent.keyCode !== START_KEYCODE;
		    case 'topKeyPress':
		    case 'topMouseDown':
		    case 'topBlur':
		      // Events are not possible without cancelling IME.
		      return true;
		    default:
		      return false;
		  }
		}
	
		/**
		 * Google Input Tools provides composition data via a CustomEvent,
		 * with the `data` property populated in the `detail` object. If this
		 * is available on the event object, use it. If not, this is a plain
		 * composition event and we have nothing special to extract.
		 *
		 * @param {object} nativeEvent
		 * @return {?string}
		 */
		function getDataFromCustomEvent(nativeEvent) {
		  var detail = nativeEvent.detail;
		  if (typeof detail === 'object' && 'data' in detail) {
		    return detail.data;
		  }
		  return null;
		}
	
		// Track the current IME composition fallback object, if any.
		var currentComposition = null;
	
		/**
		 * @return {?object} A SyntheticCompositionEvent.
		 */
		function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		  var eventType;
		  var fallbackData;
	
		  if (canUseCompositionEvent) {
		    eventType = getCompositionEventType(topLevelType);
		  } else if (!currentComposition) {
		    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
		      eventType = eventTypes.compositionStart;
		    }
		  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
		    eventType = eventTypes.compositionEnd;
		  }
	
		  if (!eventType) {
		    return null;
		  }
	
		  if (useFallbackCompositionData) {
		    // The current composition is stored statically and must not be
		    // overwritten while composition continues.
		    if (!currentComposition && eventType === eventTypes.compositionStart) {
		      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
		    } else if (eventType === eventTypes.compositionEnd) {
		      if (currentComposition) {
		        fallbackData = currentComposition.getData();
		      }
		    }
		  }
	
		  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
		  if (fallbackData) {
		    // Inject data generated from fallback path into the synthetic event.
		    // This matches the property of native CompositionEventInterface.
		    event.data = fallbackData;
		  } else {
		    var customData = getDataFromCustomEvent(nativeEvent);
		    if (customData !== null) {
		      event.data = customData;
		    }
		  }
	
		  EventPropagators.accumulateTwoPhaseDispatches(event);
		  return event;
		}
	
		/**
		 * @param {string} topLevelType Record from `EventConstants`.
		 * @param {object} nativeEvent Native browser event.
		 * @return {?string} The string corresponding to this `beforeInput` event.
		 */
		function getNativeBeforeInputChars(topLevelType, nativeEvent) {
		  switch (topLevelType) {
		    case 'topCompositionEnd':
		      return getDataFromCustomEvent(nativeEvent);
		    case 'topKeyPress':
		      /**
		       * If native `textInput` events are available, our goal is to make
		       * use of them. However, there is a special case: the spacebar key.
		       * In Webkit, preventing default on a spacebar `textInput` event
		       * cancels character insertion, but it *also* causes the browser
		       * to fall back to its default spacebar behavior of scrolling the
		       * page.
		       *
		       * Tracking at:
		       * https://code.google.com/p/chromium/issues/detail?id=355103
		       *
		       * To avoid this issue, use the keypress event as if no `textInput`
		       * event is available.
		       */
		      var which = nativeEvent.which;
		      if (which !== SPACEBAR_CODE) {
		        return null;
		      }
	
		      hasSpaceKeypress = true;
		      return SPACEBAR_CHAR;
	
		    case 'topTextInput':
		      // Record the characters to be added to the DOM.
		      var chars = nativeEvent.data;
	
		      // If it's a spacebar character, assume that we have already handled
		      // it at the keypress level and bail immediately. Android Chrome
		      // doesn't give us keycodes, so we need to blacklist it.
		      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
		        return null;
		      }
	
		      return chars;
	
		    default:
		      // For other native event types, do nothing.
		      return null;
		  }
		}
	
		/**
		 * For browsers that do not provide the `textInput` event, extract the
		 * appropriate string to use for SyntheticInputEvent.
		 *
		 * @param {string} topLevelType Record from `EventConstants`.
		 * @param {object} nativeEvent Native browser event.
		 * @return {?string} The fallback string for this `beforeInput` event.
		 */
		function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
		  // If we are currently composing (IME) and using a fallback to do so,
		  // try to extract the composed characters from the fallback object.
		  // If composition event is available, we extract a string only at
		  // compositionevent, otherwise extract it at fallback events.
		  if (currentComposition) {
		    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
		      var chars = currentComposition.getData();
		      FallbackCompositionState.release(currentComposition);
		      currentComposition = null;
		      return chars;
		    }
		    return null;
		  }
	
		  switch (topLevelType) {
		    case 'topPaste':
		      // If a paste event occurs after a keypress, throw out the input
		      // chars. Paste events should not lead to BeforeInput events.
		      return null;
		    case 'topKeyPress':
		      /**
		       * As of v27, Firefox may fire keypress events even when no character
		       * will be inserted. A few possibilities:
		       *
		       * - `which` is `0`. Arrow keys, Esc key, etc.
		       *
		       * - `which` is the pressed key code, but no char is available.
		       *   Ex: 'AltGr + d` in Polish. There is no modified character for
		       *   this key combination and no character is inserted into the
		       *   document, but FF fires the keypress for char code `100` anyway.
		       *   No `input` event will occur.
		       *
		       * - `which` is the pressed key code, but a command combination is
		       *   being used. Ex: `Cmd+C`. No character is inserted, and no
		       *   `input` event will occur.
		       */
		      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
		        return String.fromCharCode(nativeEvent.which);
		      }
		      return null;
		    case 'topCompositionEnd':
		      return useFallbackCompositionData ? null : nativeEvent.data;
		    default:
		      return null;
		  }
		}
	
		/**
		 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
		 * `textInput` or fallback behavior.
		 *
		 * @return {?object} A SyntheticInputEvent.
		 */
		function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		  var chars;
	
		  if (canUseTextInputEvent) {
		    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
		  } else {
		    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
		  }
	
		  // If no characters are being inserted, no BeforeInput event should
		  // be fired.
		  if (!chars) {
		    return null;
		  }
	
		  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
		  event.data = chars;
		  EventPropagators.accumulateTwoPhaseDispatches(event);
		  return event;
		}
	
		/**
		 * Create an `onBeforeInput` event to match
		 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
		 *
		 * This event plugin is based on the native `textInput` event
		 * available in Chrome, Safari, Opera, and IE. This event fires after
		 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
		 *
		 * `beforeInput` is spec'd but not implemented in any browsers, and
		 * the `input` event does not provide any useful information about what has
		 * actually been added, contrary to the spec. Thus, `textInput` is the best
		 * available event to identify the characters that have actually been inserted
		 * into the target node.
		 *
		 * This plugin is also responsible for emitting `composition` events, thus
		 * allowing us to share composition fallback code for both `beforeInput` and
		 * `composition` event types.
		 */
		var BeforeInputEventPlugin = {
	
		  eventTypes: eventTypes,
	
		  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
		  }
		};
	
		module.exports = BeforeInputEventPlugin;
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var EventPluginHub = __webpack_require__(14);
		var EventPluginUtils = __webpack_require__(16);
	
		var accumulateInto = __webpack_require__(20);
		var forEachAccumulated = __webpack_require__(21);
		var warning = __webpack_require__(18);
	
		var getListener = EventPluginHub.getListener;
	
		/**
		 * Some event types have a notion of different registration names for different
		 * "phases" of propagation. This finds listeners by a given phase.
		 */
		function listenerAtPhase(inst, event, propagationPhase) {
		  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
		  return getListener(inst, registrationName);
		}
	
		/**
		 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
		 * here, allows us to not have to bind or create functions for each event.
		 * Mutating the event's members allows us to not have to create a wrapping
		 * "dispatch" object that pairs the event with the listener.
		 */
		function accumulateDirectionalDispatches(inst, phase, event) {
		  if (process.env.NODE_ENV !== 'production') {
		    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
		  }
		  var listener = listenerAtPhase(inst, event, phase);
		  if (listener) {
		    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
		    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
		  }
		}
	
		/**
		 * Collect dispatches (must be entirely collected before dispatching - see unit
		 * tests). Lazily allocate the array to conserve memory.  We must loop through
		 * each event and perform the traversal for each one. We cannot perform a
		 * single traversal for the entire collection of events because each event may
		 * have a different target.
		 */
		function accumulateTwoPhaseDispatchesSingle(event) {
		  if (event && event.dispatchConfig.phasedRegistrationNames) {
		    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
		  }
		}
	
		/**
		 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
		 */
		function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
		  if (event && event.dispatchConfig.phasedRegistrationNames) {
		    var targetInst = event._targetInst;
		    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
		    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
		  }
		}
	
		/**
		 * Accumulates without regard to direction, does not look for phased
		 * registration names. Same as `accumulateDirectDispatchesSingle` but without
		 * requiring that the `dispatchMarker` be the same as the dispatched ID.
		 */
		function accumulateDispatches(inst, ignoredDirection, event) {
		  if (event && event.dispatchConfig.registrationName) {
		    var registrationName = event.dispatchConfig.registrationName;
		    var listener = getListener(inst, registrationName);
		    if (listener) {
		      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
		      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
		    }
		  }
		}
	
		/**
		 * Accumulates dispatches on an `SyntheticEvent`, but only for the
		 * `dispatchMarker`.
		 * @param {SyntheticEvent} event
		 */
		function accumulateDirectDispatchesSingle(event) {
		  if (event && event.dispatchConfig.registrationName) {
		    accumulateDispatches(event._targetInst, null, event);
		  }
		}
	
		function accumulateTwoPhaseDispatches(events) {
		  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
		}
	
		function accumulateTwoPhaseDispatchesSkipTarget(events) {
		  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
		}
	
		function accumulateEnterLeaveDispatches(leave, enter, from, to) {
		  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
		}
	
		function accumulateDirectDispatches(events) {
		  forEachAccumulated(events, accumulateDirectDispatchesSingle);
		}
	
		/**
		 * A small set of propagation patterns, each of which will accept a small amount
		 * of information, and generate a set of "dispatch ready event objects" - which
		 * are sets of events that have already been annotated with a set of dispatched
		 * listener functions/ids. The API is designed this way to discourage these
		 * propagation strategies from actually executing the dispatches, since we
		 * always want to collect the entire set of dispatches before executing event a
		 * single one.
		 *
		 * @constructor EventPropagators
		 */
		var EventPropagators = {
		  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
		  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
		  accumulateDirectDispatches: accumulateDirectDispatches,
		  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
		};
	
		module.exports = EventPropagators;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var EventPluginRegistry = __webpack_require__(15);
		var EventPluginUtils = __webpack_require__(16);
		var ReactErrorUtils = __webpack_require__(17);
	
		var accumulateInto = __webpack_require__(20);
		var forEachAccumulated = __webpack_require__(21);
		var invariant = __webpack_require__(8);
	
		/**
		 * Internal store for event listeners
		 */
		var listenerBank = {};
	
		/**
		 * Internal queue of events that have accumulated their dispatches and are
		 * waiting to have their dispatches executed.
		 */
		var eventQueue = null;
	
		/**
		 * Dispatches an event and releases it back into the pool, unless persistent.
		 *
		 * @param {?object} event Synthetic event to be dispatched.
		 * @param {boolean} simulated If the event is simulated (changes exn behavior)
		 * @private
		 */
		var executeDispatchesAndRelease = function (event, simulated) {
		  if (event) {
		    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
		    if (!event.isPersistent()) {
		      event.constructor.release(event);
		    }
		  }
		};
		var executeDispatchesAndReleaseSimulated = function (e) {
		  return executeDispatchesAndRelease(e, true);
		};
		var executeDispatchesAndReleaseTopLevel = function (e) {
		  return executeDispatchesAndRelease(e, false);
		};
	
		var getDictionaryKey = function (inst) {
		  // Prevents V8 performance issue:
		  // https://github.com/facebook/react/pull/7232
		  return '.' + inst._rootNodeID;
		};
	
		function isInteractive(tag) {
		  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
		}
	
		function shouldPreventMouseEvent(name, type, props) {
		  switch (name) {
		    case 'onClick':
		    case 'onClickCapture':
		    case 'onDoubleClick':
		    case 'onDoubleClickCapture':
		    case 'onMouseDown':
		    case 'onMouseDownCapture':
		    case 'onMouseMove':
		    case 'onMouseMoveCapture':
		    case 'onMouseUp':
		    case 'onMouseUpCapture':
		      return !!(props.disabled && isInteractive(type));
		    default:
		      return false;
		  }
		}
	
		/**
		 * This is a unified interface for event plugins to be installed and configured.
		 *
		 * Event plugins can implement the following properties:
		 *
		 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
		 *     Required. When a top-level event is fired, this method is expected to
		 *     extract synthetic events that will in turn be queued and dispatched.
		 *
		 *   `eventTypes` {object}
		 *     Optional, plugins that fire events must publish a mapping of registration
		 *     names that are used to register listeners. Values of this mapping must
		 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
		 *
		 *   `executeDispatch` {function(object, function, string)}
		 *     Optional, allows plugins to override how an event gets dispatched. By
		 *     default, the listener is simply invoked.
		 *
		 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
		 *
		 * @public
		 */
		var EventPluginHub = {
	
		  /**
		   * Methods for injecting dependencies.
		   */
		  injection: {
	
		    /**
		     * @param {array} InjectedEventPluginOrder
		     * @public
		     */
		    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
		    /**
		     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
		     */
		    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
		  },
	
		  /**
		   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
		   *
		   * @param {object} inst The instance, which is the source of events.
		   * @param {string} registrationName Name of listener (e.g. `onClick`).
		   * @param {function} listener The callback to store.
		   */
		  putListener: function (inst, registrationName, listener) {
		    !(typeof listener === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
		    var key = getDictionaryKey(inst);
		    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
		    bankForRegistrationName[key] = listener;
	
		    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
		    if (PluginModule && PluginModule.didPutListener) {
		      PluginModule.didPutListener(inst, registrationName, listener);
		    }
		  },
	
		  /**
		   * @param {object} inst The instance, which is the source of events.
		   * @param {string} registrationName Name of listener (e.g. `onClick`).
		   * @return {?function} The stored callback.
		   */
		  getListener: function (inst, registrationName) {
		    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
		    // live here; needs to be moved to a better place soon
		    var bankForRegistrationName = listenerBank[registrationName];
		    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
		      return null;
		    }
		    var key = getDictionaryKey(inst);
		    return bankForRegistrationName && bankForRegistrationName[key];
		  },
	
		  /**
		   * Deletes a listener from the registration bank.
		   *
		   * @param {object} inst The instance, which is the source of events.
		   * @param {string} registrationName Name of listener (e.g. `onClick`).
		   */
		  deleteListener: function (inst, registrationName) {
		    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
		    if (PluginModule && PluginModule.willDeleteListener) {
		      PluginModule.willDeleteListener(inst, registrationName);
		    }
	
		    var bankForRegistrationName = listenerBank[registrationName];
		    // TODO: This should never be null -- when is it?
		    if (bankForRegistrationName) {
		      var key = getDictionaryKey(inst);
		      delete bankForRegistrationName[key];
		    }
		  },
	
		  /**
		   * Deletes all listeners for the DOM element with the supplied ID.
		   *
		   * @param {object} inst The instance, which is the source of events.
		   */
		  deleteAllListeners: function (inst) {
		    var key = getDictionaryKey(inst);
		    for (var registrationName in listenerBank) {
		      if (!listenerBank.hasOwnProperty(registrationName)) {
		        continue;
		      }
	
		      if (!listenerBank[registrationName][key]) {
		        continue;
		      }
	
		      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
		      if (PluginModule && PluginModule.willDeleteListener) {
		        PluginModule.willDeleteListener(inst, registrationName);
		      }
	
		      delete listenerBank[registrationName][key];
		    }
		  },
	
		  /**
		   * Allows registered plugins an opportunity to extract events from top-level
		   * native browser events.
		   *
		   * @return {*} An accumulation of synthetic events.
		   * @internal
		   */
		  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		    var events;
		    var plugins = EventPluginRegistry.plugins;
		    for (var i = 0; i < plugins.length; i++) {
		      // Not every plugin in the ordering may be loaded at runtime.
		      var possiblePlugin = plugins[i];
		      if (possiblePlugin) {
		        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
		        if (extractedEvents) {
		          events = accumulateInto(events, extractedEvents);
		        }
		      }
		    }
		    return events;
		  },
	
		  /**
		   * Enqueues a synthetic event that should be dispatched when
		   * `processEventQueue` is invoked.
		   *
		   * @param {*} events An accumulation of synthetic events.
		   * @internal
		   */
		  enqueueEvents: function (events) {
		    if (events) {
		      eventQueue = accumulateInto(eventQueue, events);
		    }
		  },
	
		  /**
		   * Dispatches all synthetic events on the event queue.
		   *
		   * @internal
		   */
		  processEventQueue: function (simulated) {
		    // Set `eventQueue` to null before processing it so that we can tell if more
		    // events get enqueued while processing.
		    var processingEventQueue = eventQueue;
		    eventQueue = null;
		    if (simulated) {
		      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
		    } else {
		      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
		    }
		    !!eventQueue ? process.env.NODE_ENV !== 'production' ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
		    // This would be a good time to rethrow if any of the event handlers threw.
		    ReactErrorUtils.rethrowCaughtError();
		  },
	
		  /**
		   * These are needed for tests only. Do not use!
		   */
		  __purge: function () {
		    listenerBank = {};
		  },
	
		  __getListenerBank: function () {
		    return listenerBank;
		  }
	
		};
	
		module.exports = EventPluginHub;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * Injectable ordering of event plugins.
		 */
		var eventPluginOrder = null;
	
		/**
		 * Injectable mapping from names to event plugin modules.
		 */
		var namesToPlugins = {};
	
		/**
		 * Recomputes the plugin list using the injected plugins and plugin ordering.
		 *
		 * @private
		 */
		function recomputePluginOrdering() {
		  if (!eventPluginOrder) {
		    // Wait until an `eventPluginOrder` is injected.
		    return;
		  }
		  for (var pluginName in namesToPlugins) {
		    var pluginModule = namesToPlugins[pluginName];
		    var pluginIndex = eventPluginOrder.indexOf(pluginName);
		    !(pluginIndex > -1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
		    if (EventPluginRegistry.plugins[pluginIndex]) {
		      continue;
		    }
		    !pluginModule.extractEvents ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
		    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
		    var publishedEvents = pluginModule.eventTypes;
		    for (var eventName in publishedEvents) {
		      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
		    }
		  }
		}
	
		/**
		 * Publishes an event so that it can be dispatched by the supplied plugin.
		 *
		 * @param {object} dispatchConfig Dispatch configuration for the event.
		 * @param {object} PluginModule Plugin publishing the event.
		 * @return {boolean} True if the event was successfully published.
		 * @private
		 */
		function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
		  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
		  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
		  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
		  if (phasedRegistrationNames) {
		    for (var phaseName in phasedRegistrationNames) {
		      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
		        var phasedRegistrationName = phasedRegistrationNames[phaseName];
		        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
		      }
		    }
		    return true;
		  } else if (dispatchConfig.registrationName) {
		    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
		    return true;
		  }
		  return false;
		}
	
		/**
		 * Publishes a registration name that is used to identify dispatched events and
		 * can be used with `EventPluginHub.putListener` to register listeners.
		 *
		 * @param {string} registrationName Registration name to add.
		 * @param {object} PluginModule Plugin publishing the event.
		 * @private
		 */
		function publishRegistrationName(registrationName, pluginModule, eventName) {
		  !!EventPluginRegistry.registrationNameModules[registrationName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
		  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
		  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
		  if (process.env.NODE_ENV !== 'production') {
		    var lowerCasedName = registrationName.toLowerCase();
		    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
		    if (registrationName === 'onDoubleClick') {
		      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
		    }
		  }
		}
	
		/**
		 * Registers plugins so that they can extract and dispatch events.
		 *
		 * @see {EventPluginHub}
		 */
		var EventPluginRegistry = {
	
		  /**
		   * Ordered list of injected plugins.
		   */
		  plugins: [],
	
		  /**
		   * Mapping from event name to dispatch config
		   */
		  eventNameDispatchConfigs: {},
	
		  /**
		   * Mapping from registration name to plugin module
		   */
		  registrationNameModules: {},
	
		  /**
		   * Mapping from registration name to event name
		   */
		  registrationNameDependencies: {},
	
		  /**
		   * Mapping from lowercase registration names to the properly cased version,
		   * used to warn in the case of missing event handlers. Available
		   * only in __DEV__.
		   * @type {Object}
		   */
		  possibleRegistrationNames: process.env.NODE_ENV !== 'production' ? {} : null,
		  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
		  /**
		   * Injects an ordering of plugins (by plugin name). This allows the ordering
		   * to be decoupled from injection of the actual plugins so that ordering is
		   * always deterministic regardless of packaging, on-the-fly injection, etc.
		   *
		   * @param {array} InjectedEventPluginOrder
		   * @internal
		   * @see {EventPluginHub.injection.injectEventPluginOrder}
		   */
		  injectEventPluginOrder: function (injectedEventPluginOrder) {
		    !!eventPluginOrder ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
		    // Clone the ordering so it cannot be dynamically mutated.
		    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
		    recomputePluginOrdering();
		  },
	
		  /**
		   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
		   * in the ordering injected by `injectEventPluginOrder`.
		   *
		   * Plugins can be injected as part of page initialization or on-the-fly.
		   *
		   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
		   * @internal
		   * @see {EventPluginHub.injection.injectEventPluginsByName}
		   */
		  injectEventPluginsByName: function (injectedNamesToPlugins) {
		    var isOrderingDirty = false;
		    for (var pluginName in injectedNamesToPlugins) {
		      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
		        continue;
		      }
		      var pluginModule = injectedNamesToPlugins[pluginName];
		      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
		        !!namesToPlugins[pluginName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
		        namesToPlugins[pluginName] = pluginModule;
		        isOrderingDirty = true;
		      }
		    }
		    if (isOrderingDirty) {
		      recomputePluginOrdering();
		    }
		  },
	
		  /**
		   * Looks up the plugin for the supplied event.
		   *
		   * @param {object} event A synthetic event.
		   * @return {?object} The plugin that created the supplied event.
		   * @internal
		   */
		  getPluginModuleForEvent: function (event) {
		    var dispatchConfig = event.dispatchConfig;
		    if (dispatchConfig.registrationName) {
		      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
		    }
		    if (dispatchConfig.phasedRegistrationNames !== undefined) {
		      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
		      // that it is not undefined.
		      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
		      for (var phase in phasedRegistrationNames) {
		        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
		          continue;
		        }
		        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
		        if (pluginModule) {
		          return pluginModule;
		        }
		      }
		    }
		    return null;
		  },
	
		  /**
		   * Exposed for unit testing.
		   * @private
		   */
		  _resetEventPlugins: function () {
		    eventPluginOrder = null;
		    for (var pluginName in namesToPlugins) {
		      if (namesToPlugins.hasOwnProperty(pluginName)) {
		        delete namesToPlugins[pluginName];
		      }
		    }
		    EventPluginRegistry.plugins.length = 0;
	
		    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
		    for (var eventName in eventNameDispatchConfigs) {
		      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
		        delete eventNameDispatchConfigs[eventName];
		      }
		    }
	
		    var registrationNameModules = EventPluginRegistry.registrationNameModules;
		    for (var registrationName in registrationNameModules) {
		      if (registrationNameModules.hasOwnProperty(registrationName)) {
		        delete registrationNameModules[registrationName];
		      }
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
		      for (var lowerCasedName in possibleRegistrationNames) {
		        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
		          delete possibleRegistrationNames[lowerCasedName];
		        }
		      }
		    }
		  }
	
		};
	
		module.exports = EventPluginRegistry;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var ReactErrorUtils = __webpack_require__(17);
	
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		/**
		 * Injected dependencies:
		 */
	
		/**
		 * - `ComponentTree`: [required] Module that can convert between React instances
		 *   and actual node references.
		 */
		var ComponentTree;
		var TreeTraversal;
		var injection = {
		  injectComponentTree: function (Injected) {
		    ComponentTree = Injected;
		    if (process.env.NODE_ENV !== 'production') {
		      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
		    }
		  },
		  injectTreeTraversal: function (Injected) {
		    TreeTraversal = Injected;
		    if (process.env.NODE_ENV !== 'production') {
		      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
		    }
		  }
		};
	
		function isEndish(topLevelType) {
		  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
		}
	
		function isMoveish(topLevelType) {
		  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
		}
		function isStartish(topLevelType) {
		  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
		}
	
		var validateEventDispatches;
		if (process.env.NODE_ENV !== 'production') {
		  validateEventDispatches = function (event) {
		    var dispatchListeners = event._dispatchListeners;
		    var dispatchInstances = event._dispatchInstances;
	
		    var listenersIsArr = Array.isArray(dispatchListeners);
		    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
		    var instancesIsArr = Array.isArray(dispatchInstances);
		    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
		    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
		  };
		}
	
		/**
		 * Dispatch the event to the listener.
		 * @param {SyntheticEvent} event SyntheticEvent to handle
		 * @param {boolean} simulated If the event is simulated (changes exn behavior)
		 * @param {function} listener Application-level callback
		 * @param {*} inst Internal component instance
		 */
		function executeDispatch(event, simulated, listener, inst) {
		  var type = event.type || 'unknown-event';
		  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
		  if (simulated) {
		    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
		  } else {
		    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
		  }
		  event.currentTarget = null;
		}
	
		/**
		 * Standard/simple iteration through an event's collected dispatches.
		 */
		function executeDispatchesInOrder(event, simulated) {
		  var dispatchListeners = event._dispatchListeners;
		  var dispatchInstances = event._dispatchInstances;
		  if (process.env.NODE_ENV !== 'production') {
		    validateEventDispatches(event);
		  }
		  if (Array.isArray(dispatchListeners)) {
		    for (var i = 0; i < dispatchListeners.length; i++) {
		      if (event.isPropagationStopped()) {
		        break;
		      }
		      // Listeners and Instances are two parallel arrays that are always in sync.
		      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
		    }
		  } else if (dispatchListeners) {
		    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
		  }
		  event._dispatchListeners = null;
		  event._dispatchInstances = null;
		}
	
		/**
		 * Standard/simple iteration through an event's collected dispatches, but stops
		 * at the first dispatch execution returning true, and returns that id.
		 *
		 * @return {?string} id of the first dispatch execution who's listener returns
		 * true, or null if no listener returned true.
		 */
		function executeDispatchesInOrderStopAtTrueImpl(event) {
		  var dispatchListeners = event._dispatchListeners;
		  var dispatchInstances = event._dispatchInstances;
		  if (process.env.NODE_ENV !== 'production') {
		    validateEventDispatches(event);
		  }
		  if (Array.isArray(dispatchListeners)) {
		    for (var i = 0; i < dispatchListeners.length; i++) {
		      if (event.isPropagationStopped()) {
		        break;
		      }
		      // Listeners and Instances are two parallel arrays that are always in sync.
		      if (dispatchListeners[i](event, dispatchInstances[i])) {
		        return dispatchInstances[i];
		      }
		    }
		  } else if (dispatchListeners) {
		    if (dispatchListeners(event, dispatchInstances)) {
		      return dispatchInstances;
		    }
		  }
		  return null;
		}
	
		/**
		 * @see executeDispatchesInOrderStopAtTrueImpl
		 */
		function executeDispatchesInOrderStopAtTrue(event) {
		  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
		  event._dispatchInstances = null;
		  event._dispatchListeners = null;
		  return ret;
		}
	
		/**
		 * Execution of a "direct" dispatch - there must be at most one dispatch
		 * accumulated on the event or it is considered an error. It doesn't really make
		 * sense for an event with multiple dispatches (bubbled) to keep track of the
		 * return values at each dispatch execution, but it does tend to make sense when
		 * dealing with "direct" dispatches.
		 *
		 * @return {*} The return value of executing the single dispatch.
		 */
		function executeDirectDispatch(event) {
		  if (process.env.NODE_ENV !== 'production') {
		    validateEventDispatches(event);
		  }
		  var dispatchListener = event._dispatchListeners;
		  var dispatchInstance = event._dispatchInstances;
		  !!Array.isArray(dispatchListener) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
		  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
		  var res = dispatchListener ? dispatchListener(event) : null;
		  event.currentTarget = null;
		  event._dispatchListeners = null;
		  event._dispatchInstances = null;
		  return res;
		}
	
		/**
		 * @param {SyntheticEvent} event
		 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
		 */
		function hasDispatches(event) {
		  return !!event._dispatchListeners;
		}
	
		/**
		 * General utilities that are useful in creating custom Event Plugins.
		 */
		var EventPluginUtils = {
		  isEndish: isEndish,
		  isMoveish: isMoveish,
		  isStartish: isStartish,
	
		  executeDirectDispatch: executeDirectDispatch,
		  executeDispatchesInOrder: executeDispatchesInOrder,
		  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
		  hasDispatches: hasDispatches,
	
		  getInstanceFromNode: function (node) {
		    return ComponentTree.getInstanceFromNode(node);
		  },
		  getNodeFromInstance: function (node) {
		    return ComponentTree.getNodeFromInstance(node);
		  },
		  isAncestor: function (a, b) {
		    return TreeTraversal.isAncestor(a, b);
		  },
		  getLowestCommonAncestor: function (a, b) {
		    return TreeTraversal.getLowestCommonAncestor(a, b);
		  },
		  getParentInstance: function (inst) {
		    return TreeTraversal.getParentInstance(inst);
		  },
		  traverseTwoPhase: function (target, fn, arg) {
		    return TreeTraversal.traverseTwoPhase(target, fn, arg);
		  },
		  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
		    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
		  },
	
		  injection: injection
		};
	
		module.exports = EventPluginUtils;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var caughtError = null;
	
		/**
		 * Call a function while guarding against errors that happens within it.
		 *
		 * @param {String} name of the guard to use for logging or debugging
		 * @param {Function} func The function to invoke
		 * @param {*} a First argument
		 * @param {*} b Second argument
		 */
		function invokeGuardedCallback(name, func, a) {
		  try {
		    func(a);
		  } catch (x) {
		    if (caughtError === null) {
		      caughtError = x;
		    }
		  }
		}
	
		var ReactErrorUtils = {
		  invokeGuardedCallback: invokeGuardedCallback,
	
		  /**
		   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
		   * handler are sure to be rethrown by rethrowCaughtError.
		   */
		  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
		  /**
		   * During execution of guarded functions we will capture the first error which
		   * we will rethrow to be handled by the top level error handler.
		   */
		  rethrowCaughtError: function () {
		    if (caughtError) {
		      var error = caughtError;
		      caughtError = null;
		      throw error;
		    }
		  }
		};
	
		if (process.env.NODE_ENV !== 'production') {
		  /**
		   * To help development we can get better devtools integration by simulating a
		   * real browser event.
		   */
		  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
		    var fakeNode = document.createElement('react');
		    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
		      var boundFunc = func.bind(null, a);
		      var evtType = 'react-' + name;
		      fakeNode.addEventListener(evtType, boundFunc, false);
		      var evt = document.createEvent('Event');
		      // $FlowFixMe https://github.com/facebook/flow/issues/2336
		      evt.initEvent(evtType, false, false);
		      fakeNode.dispatchEvent(evt);
		      fakeNode.removeEventListener(evtType, boundFunc, false);
		    };
		  }
		}
	
		module.exports = ReactErrorUtils;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(19);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if (process.env.NODE_ENV !== 'production') {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
	
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
	
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
	
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
	
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
	
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
	
		module.exports = warning;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * Accumulates items that must not be null or undefined into the first one. This
		 * is used to conserve memory by avoiding array allocations, and thus sacrifices
		 * API cleanness. Since `current` can be null before being passed in and not
		 * null after this function, make sure to assign it back to `current`:
		 *
		 * `a = accumulateInto(a, b);`
		 *
		 * This API should be sparingly used. Try `accumulate` for something cleaner.
		 *
		 * @return {*|array<*>} An accumulation of items.
		 */
	
		function accumulateInto(current, next) {
		  !(next != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
		  if (current == null) {
		    return next;
		  }
	
		  // Both are not empty. Warning: Never call x.concat(y) when you are not
		  // certain that x is an Array (x could be a string with concat method).
		  if (Array.isArray(current)) {
		    if (Array.isArray(next)) {
		      current.push.apply(current, next);
		      return current;
		    }
		    current.push(next);
		    return current;
		  }
	
		  if (Array.isArray(next)) {
		    // A bit too dangerous to mutate `next`.
		    return [current].concat(next);
		  }
	
		  return [current, next];
		}
	
		module.exports = accumulateInto;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		/**
		 * @param {array} arr an "accumulation" of items which is either an Array or
		 * a single item. Useful when paired with the `accumulate` module. This is a
		 * simple utility that allows us to reason about a collection of items, but
		 * handling the case when there is exactly one item (and we do not need to
		 * allocate an array).
		 */
	
		function forEachAccumulated(arr, cb, scope) {
		  if (Array.isArray(arr)) {
		    arr.forEach(cb, scope);
		  } else if (arr) {
		    cb.call(scope, arr);
		  }
		}
	
		module.exports = forEachAccumulated;
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
		/**
		 * Simple, lightweight module assisting with the detection and context of
		 * Worker. Helps avoid circular dependencies and allows code to reason about
		 * whether or not they are in a Worker, even if they never include the main
		 * `ReactWorker` dependency.
		 */
		var ExecutionEnvironment = {
	
		  canUseDOM: canUseDOM,
	
		  canUseWorkers: typeof Worker !== 'undefined',
	
		  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
		  canUseViewport: canUseDOM && !!window.screen,
	
		  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
		};
	
		module.exports = ExecutionEnvironment;
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var PooledClass = __webpack_require__(25);
	
		var getTextContentAccessor = __webpack_require__(26);
	
		/**
		 * This helper class stores information about text content of a target node,
		 * allowing comparison of content before and after a given event.
		 *
		 * Identify the node where selection currently begins, then observe
		 * both its text content and its current position in the DOM. Since the
		 * browser may natively replace the target node during composition, we can
		 * use its position to find its replacement.
		 *
		 * @param {DOMEventTarget} root
		 */
		function FallbackCompositionState(root) {
		  this._root = root;
		  this._startText = this.getText();
		  this._fallbackText = null;
		}
	
		_assign(FallbackCompositionState.prototype, {
		  destructor: function () {
		    this._root = null;
		    this._startText = null;
		    this._fallbackText = null;
		  },
	
		  /**
		   * Get current text of input.
		   *
		   * @return {string}
		   */
		  getText: function () {
		    if ('value' in this._root) {
		      return this._root.value;
		    }
		    return this._root[getTextContentAccessor()];
		  },
	
		  /**
		   * Determine the differing substring between the initially stored
		   * text content and the current content.
		   *
		   * @return {string}
		   */
		  getData: function () {
		    if (this._fallbackText) {
		      return this._fallbackText;
		    }
	
		    var start;
		    var startValue = this._startText;
		    var startLength = startValue.length;
		    var end;
		    var endValue = this.getText();
		    var endLength = endValue.length;
	
		    for (start = 0; start < startLength; start++) {
		      if (startValue[start] !== endValue[start]) {
		        break;
		      }
		    }
	
		    var minEnd = startLength - start;
		    for (end = 1; end <= minEnd; end++) {
		      if (startValue[startLength - end] !== endValue[endLength - end]) {
		        break;
		      }
		    }
	
		    var sliceTail = end > 1 ? 1 - end : undefined;
		    this._fallbackText = endValue.slice(start, sliceTail);
		    return this._fallbackText;
		  }
		});
	
		PooledClass.addPoolingTo(FallbackCompositionState);
	
		module.exports = FallbackCompositionState;
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		/*
		object-assign
		(c) Sindre Sorhus
		@license MIT
		*/
	
		'use strict';
		/* eslint-disable no-unused-vars */
		var getOwnPropertySymbols = Object.getOwnPropertySymbols;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
		function toObject(val) {
			if (val === null || val === undefined) {
				throw new TypeError('Object.assign cannot be called with null or undefined');
			}
	
			return Object(val);
		}
	
		function shouldUseNative() {
			try {
				if (!Object.assign) {
					return false;
				}
	
				// Detect buggy property enumeration order in older V8 versions.
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=4118
				var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
				test1[5] = 'de';
				if (Object.getOwnPropertyNames(test1)[0] === '5') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test2 = {};
				for (var i = 0; i < 10; i++) {
					test2['_' + String.fromCharCode(i)] = i;
				}
				var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
					return test2[n];
				});
				if (order2.join('') !== '0123456789') {
					return false;
				}
	
				// https://bugs.chromium.org/p/v8/issues/detail?id=3056
				var test3 = {};
				'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
					test3[letter] = letter;
				});
				if (Object.keys(Object.assign({}, test3)).join('') !==
						'abcdefghijklmnopqrst') {
					return false;
				}
	
				return true;
			} catch (err) {
				// We don't expect any of the above to throw, but better to be safe.
				return false;
			}
		}
	
		module.exports = shouldUseNative() ? Object.assign : function (target, source) {
			var from;
			var to = toObject(target);
			var symbols;
	
			for (var s = 1; s < arguments.length; s++) {
				from = Object(arguments[s]);
	
				for (var key in from) {
					if (hasOwnProperty.call(from, key)) {
						to[key] = from[key];
					}
				}
	
				if (getOwnPropertySymbols) {
					symbols = getOwnPropertySymbols(from);
					for (var i = 0; i < symbols.length; i++) {
						if (propIsEnumerable.call(from, symbols[i])) {
							to[symbols[i]] = from[symbols[i]];
						}
					}
				}
			}
	
			return to;
		};
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * Static poolers. Several custom versions for each potential number of
		 * arguments. A completely generic pooler is easy to implement, but would
		 * require accessing the `arguments` object. In each of these, `this` refers to
		 * the Class itself, not an instance. If any others are needed, simply add them
		 * here, or in their own files.
		 */
		var oneArgumentPooler = function (copyFieldsFrom) {
		  var Klass = this;
		  if (Klass.instancePool.length) {
		    var instance = Klass.instancePool.pop();
		    Klass.call(instance, copyFieldsFrom);
		    return instance;
		  } else {
		    return new Klass(copyFieldsFrom);
		  }
		};
	
		var twoArgumentPooler = function (a1, a2) {
		  var Klass = this;
		  if (Klass.instancePool.length) {
		    var instance = Klass.instancePool.pop();
		    Klass.call(instance, a1, a2);
		    return instance;
		  } else {
		    return new Klass(a1, a2);
		  }
		};
	
		var threeArgumentPooler = function (a1, a2, a3) {
		  var Klass = this;
		  if (Klass.instancePool.length) {
		    var instance = Klass.instancePool.pop();
		    Klass.call(instance, a1, a2, a3);
		    return instance;
		  } else {
		    return new Klass(a1, a2, a3);
		  }
		};
	
		var fourArgumentPooler = function (a1, a2, a3, a4) {
		  var Klass = this;
		  if (Klass.instancePool.length) {
		    var instance = Klass.instancePool.pop();
		    Klass.call(instance, a1, a2, a3, a4);
		    return instance;
		  } else {
		    return new Klass(a1, a2, a3, a4);
		  }
		};
	
		var standardReleaser = function (instance) {
		  var Klass = this;
		  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
		  instance.destructor();
		  if (Klass.instancePool.length < Klass.poolSize) {
		    Klass.instancePool.push(instance);
		  }
		};
	
		var DEFAULT_POOL_SIZE = 10;
		var DEFAULT_POOLER = oneArgumentPooler;
	
		/**
		 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
		 * itself (statically) not adding any prototypical fields. Any CopyConstructor
		 * you give this may have a `poolSize` property, and will look for a
		 * prototypical `destructor` on instances.
		 *
		 * @param {Function} CopyConstructor Constructor that can be used to reset.
		 * @param {Function} pooler Customizable pooler.
		 */
		var addPoolingTo = function (CopyConstructor, pooler) {
		  // Casting as any so that flow ignores the actual implementation and trusts
		  // it to match the type we declared
		  var NewKlass = CopyConstructor;
		  NewKlass.instancePool = [];
		  NewKlass.getPooled = pooler || DEFAULT_POOLER;
		  if (!NewKlass.poolSize) {
		    NewKlass.poolSize = DEFAULT_POOL_SIZE;
		  }
		  NewKlass.release = standardReleaser;
		  return NewKlass;
		};
	
		var PooledClass = {
		  addPoolingTo: addPoolingTo,
		  oneArgumentPooler: oneArgumentPooler,
		  twoArgumentPooler: twoArgumentPooler,
		  threeArgumentPooler: threeArgumentPooler,
		  fourArgumentPooler: fourArgumentPooler
		};
	
		module.exports = PooledClass;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ExecutionEnvironment = __webpack_require__(22);
	
		var contentKey = null;
	
		/**
		 * Gets the key used to access text content on a DOM node.
		 *
		 * @return {?string} Key used to access text content.
		 * @internal
		 */
		function getTextContentAccessor() {
		  if (!contentKey && ExecutionEnvironment.canUseDOM) {
		    // Prefer textContent to innerText because many browsers support both but
		    // SVG <text> elements don't support innerText even when <div> does.
		    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
		  }
		  return contentKey;
		}
	
		module.exports = getTextContentAccessor;
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticEvent = __webpack_require__(28);
	
		/**
		 * @interface Event
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
		 */
		var CompositionEventInterface = {
		  data: null
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticUIEvent}
		 */
		function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
		module.exports = SyntheticCompositionEvent;
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var PooledClass = __webpack_require__(25);
	
		var emptyFunction = __webpack_require__(19);
		var warning = __webpack_require__(18);
	
		var didWarnForAddedNewProperty = false;
		var isProxySupported = typeof Proxy === 'function';
	
		var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
		/**
		 * @interface Event
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/
		 */
		var EventInterface = {
		  type: null,
		  target: null,
		  // currentTarget is set when dispatching; no use in copying it here
		  currentTarget: emptyFunction.thatReturnsNull,
		  eventPhase: null,
		  bubbles: null,
		  cancelable: null,
		  timeStamp: function (event) {
		    return event.timeStamp || Date.now();
		  },
		  defaultPrevented: null,
		  isTrusted: null
		};
	
		/**
		 * Synthetic events are dispatched by event plugins, typically in response to a
		 * top-level event delegation handler.
		 *
		 * These systems should generally use pooling to reduce the frequency of garbage
		 * collection. The system should check `isPersistent` to determine whether the
		 * event should be released into the pool after being dispatched. Users that
		 * need a persisted event should invoke `persist`.
		 *
		 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
		 * normalizing browser quirks. Subclasses do not necessarily have to implement a
		 * DOM interface; custom application-specific events can also subclass this.
		 *
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {*} targetInst Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @param {DOMEventTarget} nativeEventTarget Target node.
		 */
		function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
		  if (process.env.NODE_ENV !== 'production') {
		    // these have a getter/setter for warnings
		    delete this.nativeEvent;
		    delete this.preventDefault;
		    delete this.stopPropagation;
		  }
	
		  this.dispatchConfig = dispatchConfig;
		  this._targetInst = targetInst;
		  this.nativeEvent = nativeEvent;
	
		  var Interface = this.constructor.Interface;
		  for (var propName in Interface) {
		    if (!Interface.hasOwnProperty(propName)) {
		      continue;
		    }
		    if (process.env.NODE_ENV !== 'production') {
		      delete this[propName]; // this has a getter/setter for warnings
		    }
		    var normalize = Interface[propName];
		    if (normalize) {
		      this[propName] = normalize(nativeEvent);
		    } else {
		      if (propName === 'target') {
		        this.target = nativeEventTarget;
		      } else {
		        this[propName] = nativeEvent[propName];
		      }
		    }
		  }
	
		  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
		  if (defaultPrevented) {
		    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
		  } else {
		    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
		  }
		  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
		  return this;
		}
	
		_assign(SyntheticEvent.prototype, {
	
		  preventDefault: function () {
		    this.defaultPrevented = true;
		    var event = this.nativeEvent;
		    if (!event) {
		      return;
		    }
	
		    if (event.preventDefault) {
		      event.preventDefault();
		    } else if (typeof event.returnValue !== 'unknown') {
		      // eslint-disable-line valid-typeof
		      event.returnValue = false;
		    }
		    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
		  },
	
		  stopPropagation: function () {
		    var event = this.nativeEvent;
		    if (!event) {
		      return;
		    }
	
		    if (event.stopPropagation) {
		      event.stopPropagation();
		    } else if (typeof event.cancelBubble !== 'unknown') {
		      // eslint-disable-line valid-typeof
		      // The ChangeEventPlugin registers a "propertychange" event for
		      // IE. This event does not support bubbling or cancelling, and
		      // any references to cancelBubble throw "Member not found".  A
		      // typeof check of "unknown" circumvents this issue (and is also
		      // IE specific).
		      event.cancelBubble = true;
		    }
	
		    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
		  },
	
		  /**
		   * We release all dispatched `SyntheticEvent`s after each event loop, adding
		   * them back into the pool. This allows a way to hold onto a reference that
		   * won't be added back into the pool.
		   */
		  persist: function () {
		    this.isPersistent = emptyFunction.thatReturnsTrue;
		  },
	
		  /**
		   * Checks if this event should be released back into the pool.
		   *
		   * @return {boolean} True if this should not be released, false otherwise.
		   */
		  isPersistent: emptyFunction.thatReturnsFalse,
	
		  /**
		   * `PooledClass` looks for `destructor` on each instance it releases.
		   */
		  destructor: function () {
		    var Interface = this.constructor.Interface;
		    for (var propName in Interface) {
		      if (process.env.NODE_ENV !== 'production') {
		        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
		      } else {
		        this[propName] = null;
		      }
		    }
		    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
		      this[shouldBeReleasedProperties[i]] = null;
		    }
		    if (process.env.NODE_ENV !== 'production') {
		      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
		      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
		      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
		    }
		  }
	
		});
	
		SyntheticEvent.Interface = EventInterface;
	
		if (process.env.NODE_ENV !== 'production') {
		  if (isProxySupported) {
		    /*eslint-disable no-func-assign */
		    SyntheticEvent = new Proxy(SyntheticEvent, {
		      construct: function (target, args) {
		        return this.apply(target, Object.create(target.prototype), args);
		      },
		      apply: function (constructor, that, args) {
		        return new Proxy(constructor.apply(that, args), {
		          set: function (target, prop, value) {
		            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
		              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
		              didWarnForAddedNewProperty = true;
		            }
		            target[prop] = value;
		            return true;
		          }
		        });
		      }
		    });
		    /*eslint-enable no-func-assign */
		  }
		}
		/**
		 * Helper to reduce boilerplate when creating subclasses.
		 *
		 * @param {function} Class
		 * @param {?object} Interface
		 */
		SyntheticEvent.augmentClass = function (Class, Interface) {
		  var Super = this;
	
		  var E = function () {};
		  E.prototype = Super.prototype;
		  var prototype = new E();
	
		  _assign(prototype, Class.prototype);
		  Class.prototype = prototype;
		  Class.prototype.constructor = Class;
	
		  Class.Interface = _assign({}, Super.Interface, Interface);
		  Class.augmentClass = Super.augmentClass;
	
		  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
		};
	
		PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
		module.exports = SyntheticEvent;
	
		/**
		  * Helper to nullify syntheticEvent instance properties when destructing
		  *
		  * @param {object} SyntheticEvent
		  * @param {String} propName
		  * @return {object} defineProperty object
		  */
		function getPooledWarningPropertyDefinition(propName, getVal) {
		  var isFunction = typeof getVal === 'function';
		  return {
		    configurable: true,
		    set: set,
		    get: get
		  };
	
		  function set(val) {
		    var action = isFunction ? 'setting the method' : 'setting the property';
		    warn(action, 'This is effectively a no-op');
		    return val;
		  }
	
		  function get() {
		    var action = isFunction ? 'accessing the method' : 'accessing the property';
		    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
		    warn(action, result);
		    return getVal;
		  }
	
		  function warn(action, result) {
		    var warningCondition = false;
		    process.env.NODE_ENV !== 'production' ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
		  }
		}
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 29 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticEvent = __webpack_require__(28);
	
		/**
		 * @interface Event
		 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
		 *      /#events-inputevents
		 */
		var InputEventInterface = {
		  data: null
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticUIEvent}
		 */
		function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
		module.exports = SyntheticInputEvent;
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var EventPluginHub = __webpack_require__(14);
		var EventPropagators = __webpack_require__(13);
		var ExecutionEnvironment = __webpack_require__(22);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactUpdates = __webpack_require__(31);
		var SyntheticEvent = __webpack_require__(28);
	
		var getEventTarget = __webpack_require__(47);
		var isEventSupported = __webpack_require__(48);
		var isTextInputElement = __webpack_require__(49);
	
		var eventTypes = {
		  change: {
		    phasedRegistrationNames: {
		      bubbled: 'onChange',
		      captured: 'onChangeCapture'
		    },
		    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
		  }
		};
	
		/**
		 * For IE shims
		 */
		var activeElement = null;
		var activeElementInst = null;
		var activeElementValue = null;
		var activeElementValueProp = null;
	
		/**
		 * SECTION: handle `change` event
		 */
		function shouldUseChangeEvent(elem) {
		  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
		  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
		}
	
		var doesChangeEventBubble = false;
		if (ExecutionEnvironment.canUseDOM) {
		  // See `handleChange` comment below
		  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
		}
	
		function manualDispatchChangeEvent(nativeEvent) {
		  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
		  EventPropagators.accumulateTwoPhaseDispatches(event);
	
		  // If change and propertychange bubbled, we'd just bind to it like all the
		  // other events and have it go through ReactBrowserEventEmitter. Since it
		  // doesn't, we manually listen for the events and so we have to enqueue and
		  // process the abstract event manually.
		  //
		  // Batching is necessary here in order to ensure that all event handlers run
		  // before the next rerender (including event handlers attached to ancestor
		  // elements instead of directly on the input). Without this, controlled
		  // components don't work properly in conjunction with event bubbling because
		  // the component is rerendered and the value reverted before all the event
		  // handlers can run. See https://github.com/facebook/react/issues/708.
		  ReactUpdates.batchedUpdates(runEventInBatch, event);
		}
	
		function runEventInBatch(event) {
		  EventPluginHub.enqueueEvents(event);
		  EventPluginHub.processEventQueue(false);
		}
	
		function startWatchingForChangeEventIE8(target, targetInst) {
		  activeElement = target;
		  activeElementInst = targetInst;
		  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
		}
	
		function stopWatchingForChangeEventIE8() {
		  if (!activeElement) {
		    return;
		  }
		  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
		  activeElement = null;
		  activeElementInst = null;
		}
	
		function getTargetInstForChangeEvent(topLevelType, targetInst) {
		  if (topLevelType === 'topChange') {
		    return targetInst;
		  }
		}
		function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
		  if (topLevelType === 'topFocus') {
		    // stopWatching() should be a noop here but we call it just in case we
		    // missed a blur event somehow.
		    stopWatchingForChangeEventIE8();
		    startWatchingForChangeEventIE8(target, targetInst);
		  } else if (topLevelType === 'topBlur') {
		    stopWatchingForChangeEventIE8();
		  }
		}
	
		/**
		 * SECTION: handle `input` event
		 */
		var isInputEventSupported = false;
		if (ExecutionEnvironment.canUseDOM) {
		  // IE9 claims to support the input event but fails to trigger it when
		  // deleting text, so we ignore its input events.
		  // IE10+ fire input events to often, such when a placeholder
		  // changes or when an input with a placeholder is focused.
		  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
		}
	
		/**
		 * (For IE <=11) Replacement getter/setter for the `value` property that gets
		 * set on the active element.
		 */
		var newValueProp = {
		  get: function () {
		    return activeElementValueProp.get.call(this);
		  },
		  set: function (val) {
		    // Cast to a string so we can do equality checks.
		    activeElementValue = '' + val;
		    activeElementValueProp.set.call(this, val);
		  }
		};
	
		/**
		 * (For IE <=11) Starts tracking propertychange events on the passed-in element
		 * and override the value property so that we can distinguish user events from
		 * value changes in JS.
		 */
		function startWatchingForValueChange(target, targetInst) {
		  activeElement = target;
		  activeElementInst = targetInst;
		  activeElementValue = target.value;
		  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
		  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
		  // on DOM elements
		  Object.defineProperty(activeElement, 'value', newValueProp);
		  if (activeElement.attachEvent) {
		    activeElement.attachEvent('onpropertychange', handlePropertyChange);
		  } else {
		    activeElement.addEventListener('propertychange', handlePropertyChange, false);
		  }
		}
	
		/**
		 * (For IE <=11) Removes the event listeners from the currently-tracked element,
		 * if any exists.
		 */
		function stopWatchingForValueChange() {
		  if (!activeElement) {
		    return;
		  }
	
		  // delete restores the original property definition
		  delete activeElement.value;
	
		  if (activeElement.detachEvent) {
		    activeElement.detachEvent('onpropertychange', handlePropertyChange);
		  } else {
		    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
		  }
	
		  activeElement = null;
		  activeElementInst = null;
		  activeElementValue = null;
		  activeElementValueProp = null;
		}
	
		/**
		 * (For IE <=11) Handles a propertychange event, sending a `change` event if
		 * the value of the active element has changed.
		 */
		function handlePropertyChange(nativeEvent) {
		  if (nativeEvent.propertyName !== 'value') {
		    return;
		  }
		  var value = nativeEvent.srcElement.value;
		  if (value === activeElementValue) {
		    return;
		  }
		  activeElementValue = value;
	
		  manualDispatchChangeEvent(nativeEvent);
		}
	
		/**
		 * If a `change` event should be fired, returns the target's ID.
		 */
		function getTargetInstForInputEvent(topLevelType, targetInst) {
		  if (topLevelType === 'topInput') {
		    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
		    // what we want so fall through here and trigger an abstract event
		    return targetInst;
		  }
		}
	
		function handleEventsForInputEventIE(topLevelType, target, targetInst) {
		  if (topLevelType === 'topFocus') {
		    // In IE8, we can capture almost all .value changes by adding a
		    // propertychange handler and looking for events with propertyName
		    // equal to 'value'
		    // In IE9-11, propertychange fires for most input events but is buggy and
		    // doesn't fire when text is deleted, but conveniently, selectionchange
		    // appears to fire in all of the remaining cases so we catch those and
		    // forward the event if the value has changed
		    // In either case, we don't want to call the event handler if the value
		    // is changed from JS so we redefine a setter for `.value` that updates
		    // our activeElementValue variable, allowing us to ignore those changes
		    //
		    // stopWatching() should be a noop here but we call it just in case we
		    // missed a blur event somehow.
		    stopWatchingForValueChange();
		    startWatchingForValueChange(target, targetInst);
		  } else if (topLevelType === 'topBlur') {
		    stopWatchingForValueChange();
		  }
		}
	
		// For IE8 and IE9.
		function getTargetInstForInputEventIE(topLevelType, targetInst) {
		  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
		    // On the selectionchange event, the target is just document which isn't
		    // helpful for us so just check activeElement instead.
		    //
		    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
		    // propertychange on the first input event after setting `value` from a
		    // script and fires only keydown, keypress, keyup. Catching keyup usually
		    // gets it and catching keydown lets us fire an event for the first
		    // keystroke if user does a key repeat (it'll be a little delayed: right
		    // before the second keystroke). Other input methods (e.g., paste) seem to
		    // fire selectionchange normally.
		    if (activeElement && activeElement.value !== activeElementValue) {
		      activeElementValue = activeElement.value;
		      return activeElementInst;
		    }
		  }
		}
	
		/**
		 * SECTION: handle `click` event
		 */
		function shouldUseClickEvent(elem) {
		  // Use the `click` event to detect changes to checkbox and radio inputs.
		  // This approach works across all browsers, whereas `change` does not fire
		  // until `blur` in IE8.
		  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
		}
	
		function getTargetInstForClickEvent(topLevelType, targetInst) {
		  if (topLevelType === 'topClick') {
		    return targetInst;
		  }
		}
	
		/**
		 * This plugin creates an `onChange` event that normalizes change events
		 * across form elements. This event fires at a time when it's possible to
		 * change the element's value without seeing a flicker.
		 *
		 * Supported elements are:
		 * - input (see `isTextInputElement`)
		 * - textarea
		 * - select
		 */
		var ChangeEventPlugin = {
	
		  eventTypes: eventTypes,
	
		  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
		    var getTargetInstFunc, handleEventFunc;
		    if (shouldUseChangeEvent(targetNode)) {
		      if (doesChangeEventBubble) {
		        getTargetInstFunc = getTargetInstForChangeEvent;
		      } else {
		        handleEventFunc = handleEventsForChangeEventIE8;
		      }
		    } else if (isTextInputElement(targetNode)) {
		      if (isInputEventSupported) {
		        getTargetInstFunc = getTargetInstForInputEvent;
		      } else {
		        getTargetInstFunc = getTargetInstForInputEventIE;
		        handleEventFunc = handleEventsForInputEventIE;
		      }
		    } else if (shouldUseClickEvent(targetNode)) {
		      getTargetInstFunc = getTargetInstForClickEvent;
		    }
	
		    if (getTargetInstFunc) {
		      var inst = getTargetInstFunc(topLevelType, targetInst);
		      if (inst) {
		        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
		        event.type = 'change';
		        EventPropagators.accumulateTwoPhaseDispatches(event);
		        return event;
		      }
		    }
	
		    if (handleEventFunc) {
		      handleEventFunc(topLevelType, targetNode, targetInst);
		    }
		  }
	
		};
	
		module.exports = ChangeEventPlugin;
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6),
		    _assign = __webpack_require__(24);
	
		var CallbackQueue = __webpack_require__(32);
		var PooledClass = __webpack_require__(25);
		var ReactFeatureFlags = __webpack_require__(33);
		var ReactReconciler = __webpack_require__(34);
		var Transaction = __webpack_require__(46);
	
		var invariant = __webpack_require__(8);
	
		var dirtyComponents = [];
		var updateBatchNumber = 0;
		var asapCallbackQueue = CallbackQueue.getPooled();
		var asapEnqueued = false;
	
		var batchingStrategy = null;
	
		function ensureInjected() {
		  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
		}
	
		var NESTED_UPDATES = {
		  initialize: function () {
		    this.dirtyComponentsLength = dirtyComponents.length;
		  },
		  close: function () {
		    if (this.dirtyComponentsLength !== dirtyComponents.length) {
		      // Additional updates were enqueued by componentDidUpdate handlers or
		      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
		      // these new updates so that if A's componentDidUpdate calls setState on
		      // B, B will update before the callback A's updater provided when calling
		      // setState.
		      dirtyComponents.splice(0, this.dirtyComponentsLength);
		      flushBatchedUpdates();
		    } else {
		      dirtyComponents.length = 0;
		    }
		  }
		};
	
		var UPDATE_QUEUEING = {
		  initialize: function () {
		    this.callbackQueue.reset();
		  },
		  close: function () {
		    this.callbackQueue.notifyAll();
		  }
		};
	
		var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
		function ReactUpdatesFlushTransaction() {
		  this.reinitializeTransaction();
		  this.dirtyComponentsLength = null;
		  this.callbackQueue = CallbackQueue.getPooled();
		  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
		  /* useCreateElement */true);
		}
	
		_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
		  getTransactionWrappers: function () {
		    return TRANSACTION_WRAPPERS;
		  },
	
		  destructor: function () {
		    this.dirtyComponentsLength = null;
		    CallbackQueue.release(this.callbackQueue);
		    this.callbackQueue = null;
		    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
		    this.reconcileTransaction = null;
		  },
	
		  perform: function (method, scope, a) {
		    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
		    // with this transaction's wrappers around it.
		    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
		  }
		});
	
		PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
		function batchedUpdates(callback, a, b, c, d, e) {
		  ensureInjected();
		  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
		}
	
		/**
		 * Array comparator for ReactComponents by mount ordering.
		 *
		 * @param {ReactComponent} c1 first component you're comparing
		 * @param {ReactComponent} c2 second component you're comparing
		 * @return {number} Return value usable by Array.prototype.sort().
		 */
		function mountOrderComparator(c1, c2) {
		  return c1._mountOrder - c2._mountOrder;
		}
	
		function runBatchedUpdates(transaction) {
		  var len = transaction.dirtyComponentsLength;
		  !(len === dirtyComponents.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
		  // Since reconciling a component higher in the owner hierarchy usually (not
		  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
		  // them before their children by sorting the array.
		  dirtyComponents.sort(mountOrderComparator);
	
		  // Any updates enqueued while reconciling must be performed after this entire
		  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
		  // C, B could update twice in a single batch if C's render enqueues an update
		  // to B (since B would have already updated, we should skip it, and the only
		  // way we can know to do so is by checking the batch counter).
		  updateBatchNumber++;
	
		  for (var i = 0; i < len; i++) {
		    // If a component is unmounted before pending changes apply, it will still
		    // be here, but we assume that it has cleared its _pendingCallbacks and
		    // that performUpdateIfNecessary is a noop.
		    var component = dirtyComponents[i];
	
		    // If performUpdateIfNecessary happens to enqueue any new updates, we
		    // shouldn't execute the callbacks until the next render happens, so
		    // stash the callbacks first
		    var callbacks = component._pendingCallbacks;
		    component._pendingCallbacks = null;
	
		    var markerName;
		    if (ReactFeatureFlags.logTopLevelRenders) {
		      var namedComponent = component;
		      // Duck type TopLevelWrapper. This is probably always true.
		      if (component._currentElement.type.isReactTopLevelWrapper) {
		        namedComponent = component._renderedComponent;
		      }
		      markerName = 'React update: ' + namedComponent.getName();
		      console.time(markerName);
		    }
	
		    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
		    if (markerName) {
		      console.timeEnd(markerName);
		    }
	
		    if (callbacks) {
		      for (var j = 0; j < callbacks.length; j++) {
		        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
		      }
		    }
		  }
		}
	
		var flushBatchedUpdates = function () {
		  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
		  // array and perform any updates enqueued by mount-ready handlers (i.e.,
		  // componentDidUpdate) but we need to check here too in order to catch
		  // updates enqueued by setState callbacks and asap calls.
		  while (dirtyComponents.length || asapEnqueued) {
		    if (dirtyComponents.length) {
		      var transaction = ReactUpdatesFlushTransaction.getPooled();
		      transaction.perform(runBatchedUpdates, null, transaction);
		      ReactUpdatesFlushTransaction.release(transaction);
		    }
	
		    if (asapEnqueued) {
		      asapEnqueued = false;
		      var queue = asapCallbackQueue;
		      asapCallbackQueue = CallbackQueue.getPooled();
		      queue.notifyAll();
		      CallbackQueue.release(queue);
		    }
		  }
		};
	
		/**
		 * Mark a component as needing a rerender, adding an optional callback to a
		 * list of functions which will be executed once the rerender occurs.
		 */
		function enqueueUpdate(component) {
		  ensureInjected();
	
		  // Various parts of our code (such as ReactCompositeComponent's
		  // _renderValidatedComponent) assume that calls to render aren't nested;
		  // verify that that's the case. (This is called by each top-level update
		  // function, like setState, forceUpdate, etc.; creation and
		  // destruction of top-level components is guarded in ReactMount.)
	
		  if (!batchingStrategy.isBatchingUpdates) {
		    batchingStrategy.batchedUpdates(enqueueUpdate, component);
		    return;
		  }
	
		  dirtyComponents.push(component);
		  if (component._updateBatchNumber == null) {
		    component._updateBatchNumber = updateBatchNumber + 1;
		  }
		}
	
		/**
		 * Enqueue a callback to be run at the end of the current batching cycle. Throws
		 * if no updates are currently being performed.
		 */
		function asap(callback, context) {
		  !batchingStrategy.isBatchingUpdates ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
		  asapCallbackQueue.enqueue(callback, context);
		  asapEnqueued = true;
		}
	
		var ReactUpdatesInjection = {
		  injectReconcileTransaction: function (ReconcileTransaction) {
		    !ReconcileTransaction ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
		    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
		  },
	
		  injectBatchingStrategy: function (_batchingStrategy) {
		    !_batchingStrategy ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
		    !(typeof _batchingStrategy.batchedUpdates === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
		    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
		    batchingStrategy = _batchingStrategy;
		  }
		};
	
		var ReactUpdates = {
		  /**
		   * React references `ReactReconcileTransaction` using this property in order
		   * to allow dependency injection.
		   *
		   * @internal
		   */
		  ReactReconcileTransaction: null,
	
		  batchedUpdates: batchedUpdates,
		  enqueueUpdate: enqueueUpdate,
		  flushBatchedUpdates: flushBatchedUpdates,
		  injection: ReactUpdatesInjection,
		  asap: asap
		};
	
		module.exports = ReactUpdates;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var PooledClass = __webpack_require__(25);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * A specialized pseudo-event module to help keep track of components waiting to
		 * be notified when their DOM representations are available for use.
		 *
		 * This implements `PooledClass`, so you should never need to instantiate this.
		 * Instead, use `CallbackQueue.getPooled()`.
		 *
		 * @class ReactMountReady
		 * @implements PooledClass
		 * @internal
		 */
	
		var CallbackQueue = function () {
		  function CallbackQueue(arg) {
		    _classCallCheck(this, CallbackQueue);
	
		    this._callbacks = null;
		    this._contexts = null;
		    this._arg = arg;
		  }
	
		  /**
		   * Enqueues a callback to be invoked when `notifyAll` is invoked.
		   *
		   * @param {function} callback Invoked when `notifyAll` is invoked.
		   * @param {?object} context Context to call `callback` with.
		   * @internal
		   */
	
	
		  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
		    this._callbacks = this._callbacks || [];
		    this._callbacks.push(callback);
		    this._contexts = this._contexts || [];
		    this._contexts.push(context);
		  };
	
		  /**
		   * Invokes all enqueued callbacks and clears the queue. This is invoked after
		   * the DOM representation of a component has been created or updated.
		   *
		   * @internal
		   */
	
	
		  CallbackQueue.prototype.notifyAll = function notifyAll() {
		    var callbacks = this._callbacks;
		    var contexts = this._contexts;
		    var arg = this._arg;
		    if (callbacks && contexts) {
		      !(callbacks.length === contexts.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
		      this._callbacks = null;
		      this._contexts = null;
		      for (var i = 0; i < callbacks.length; i++) {
		        callbacks[i].call(contexts[i], arg);
		      }
		      callbacks.length = 0;
		      contexts.length = 0;
		    }
		  };
	
		  CallbackQueue.prototype.checkpoint = function checkpoint() {
		    return this._callbacks ? this._callbacks.length : 0;
		  };
	
		  CallbackQueue.prototype.rollback = function rollback(len) {
		    if (this._callbacks && this._contexts) {
		      this._callbacks.length = len;
		      this._contexts.length = len;
		    }
		  };
	
		  /**
		   * Resets the internal queue.
		   *
		   * @internal
		   */
	
	
		  CallbackQueue.prototype.reset = function reset() {
		    this._callbacks = null;
		    this._contexts = null;
		  };
	
		  /**
		   * `PooledClass` looks for this.
		   */
	
	
		  CallbackQueue.prototype.destructor = function destructor() {
		    this.reset();
		  };
	
		  return CallbackQueue;
		}();
	
		module.exports = PooledClass.addPoolingTo(CallbackQueue);
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 33 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var ReactFeatureFlags = {
		  // When true, call console.time() before and .timeEnd() after each top-level
		  // render (both initial renders and updates). Useful when looking at prod-mode
		  // timeline profiles in Chrome, for example.
		  logTopLevelRenders: false
		};
	
		module.exports = ReactFeatureFlags;
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactRef = __webpack_require__(35);
		var ReactInstrumentation = __webpack_require__(37);
	
		var warning = __webpack_require__(18);
	
		/**
		 * Helper to call ReactRef.attachRefs with this composite component, split out
		 * to avoid allocations in the transaction mount-ready queue.
		 */
		function attachRefs() {
		  ReactRef.attachRefs(this, this._currentElement);
		}
	
		var ReactReconciler = {
	
		  /**
		   * Initializes the component, renders markup, and registers event listeners.
		   *
		   * @param {ReactComponent} internalInstance
		   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
		   * @param {?object} the containing host component instance
		   * @param {?object} info about the host container
		   * @return {?string} Rendered markup to be inserted into the DOM.
		   * @final
		   * @internal
		   */
		  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
		  ) {
		    if (process.env.NODE_ENV !== 'production') {
		      if (internalInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
		      }
		    }
		    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
		    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
		      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
		    }
		    if (process.env.NODE_ENV !== 'production') {
		      if (internalInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
		      }
		    }
		    return markup;
		  },
	
		  /**
		   * Returns a value that can be passed to
		   * ReactComponentEnvironment.replaceNodeWithMarkup.
		   */
		  getHostNode: function (internalInstance) {
		    return internalInstance.getHostNode();
		  },
	
		  /**
		   * Releases any resources allocated by `mountComponent`.
		   *
		   * @final
		   * @internal
		   */
		  unmountComponent: function (internalInstance, safely) {
		    if (process.env.NODE_ENV !== 'production') {
		      if (internalInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
		      }
		    }
		    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
		    internalInstance.unmountComponent(safely);
		    if (process.env.NODE_ENV !== 'production') {
		      if (internalInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
		      }
		    }
		  },
	
		  /**
		   * Update a component using a new element.
		   *
		   * @param {ReactComponent} internalInstance
		   * @param {ReactElement} nextElement
		   * @param {ReactReconcileTransaction} transaction
		   * @param {object} context
		   * @internal
		   */
		  receiveComponent: function (internalInstance, nextElement, transaction, context) {
		    var prevElement = internalInstance._currentElement;
	
		    if (nextElement === prevElement && context === internalInstance._context) {
		      // Since elements are immutable after the owner is rendered,
		      // we can do a cheap identity compare here to determine if this is a
		      // superfluous reconcile. It's possible for state to be mutable but such
		      // change should trigger an update of the owner which would recreate
		      // the element. We explicitly check for the existence of an owner since
		      // it's possible for an element created outside a composite to be
		      // deeply mutated and reused.
	
		      // TODO: Bailing out early is just a perf optimization right?
		      // TODO: Removing the return statement should affect correctness?
		      return;
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      if (internalInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
		      }
		    }
	
		    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
		    if (refsChanged) {
		      ReactRef.detachRefs(internalInstance, prevElement);
		    }
	
		    internalInstance.receiveComponent(nextElement, transaction, context);
	
		    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
		      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      if (internalInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
		      }
		    }
		  },
	
		  /**
		   * Flush any dirty changes in a component.
		   *
		   * @param {ReactComponent} internalInstance
		   * @param {ReactReconcileTransaction} transaction
		   * @internal
		   */
		  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
		    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
		      // The component's enqueued batch number should always be the current
		      // batch or the following one.
		      process.env.NODE_ENV !== 'production' ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
		      return;
		    }
		    if (process.env.NODE_ENV !== 'production') {
		      if (internalInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
		      }
		    }
		    internalInstance.performUpdateIfNecessary(transaction);
		    if (process.env.NODE_ENV !== 'production') {
		      if (internalInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
		      }
		    }
		  }
	
		};
	
		module.exports = ReactReconciler;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var ReactOwner = __webpack_require__(36);
	
		var ReactRef = {};
	
		function attachRef(ref, component, owner) {
		  if (typeof ref === 'function') {
		    ref(component.getPublicInstance());
		  } else {
		    // Legacy ref
		    ReactOwner.addComponentAsRefTo(component, ref, owner);
		  }
		}
	
		function detachRef(ref, component, owner) {
		  if (typeof ref === 'function') {
		    ref(null);
		  } else {
		    // Legacy ref
		    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
		  }
		}
	
		ReactRef.attachRefs = function (instance, element) {
		  if (element === null || typeof element !== 'object') {
		    return;
		  }
		  var ref = element.ref;
		  if (ref != null) {
		    attachRef(ref, instance, element._owner);
		  }
		};
	
		ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
		  // If either the owner or a `ref` has changed, make sure the newest owner
		  // has stored a reference to `this`, and the previous owner (if different)
		  // has forgotten the reference to `this`. We use the element instead
		  // of the public this.props because the post processing cannot determine
		  // a ref. The ref conceptually lives on the element.
	
		  // TODO: Should this even be possible? The owner cannot change because
		  // it's forbidden by shouldUpdateReactComponent. The ref can change
		  // if you swap the keys of but not the refs. Reconsider where this check
		  // is made. It probably belongs where the key checking and
		  // instantiateReactComponent is done.
	
		  var prevRef = null;
		  var prevOwner = null;
		  if (prevElement !== null && typeof prevElement === 'object') {
		    prevRef = prevElement.ref;
		    prevOwner = prevElement._owner;
		  }
	
		  var nextRef = null;
		  var nextOwner = null;
		  if (nextElement !== null && typeof nextElement === 'object') {
		    nextRef = nextElement.ref;
		    nextOwner = nextElement._owner;
		  }
	
		  return prevRef !== nextRef ||
		  // If owner changes but we have an unchanged function ref, don't update refs
		  typeof nextRef === 'string' && nextOwner !== prevOwner;
		};
	
		ReactRef.detachRefs = function (instance, element) {
		  if (element === null || typeof element !== 'object') {
		    return;
		  }
		  var ref = element.ref;
		  if (ref != null) {
		    detachRef(ref, instance, element._owner);
		  }
		};
	
		module.exports = ReactRef;
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * @param {?object} object
		 * @return {boolean} True if `object` is a valid owner.
		 * @final
		 */
		function isValidOwner(object) {
		  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
		}
	
		/**
		 * ReactOwners are capable of storing references to owned components.
		 *
		 * All components are capable of //being// referenced by owner components, but
		 * only ReactOwner components are capable of //referencing// owned components.
		 * The named reference is known as a "ref".
		 *
		 * Refs are available when mounted and updated during reconciliation.
		 *
		 *   var MyComponent = React.createClass({
		 *     render: function() {
		 *       return (
		 *         <div onClick={this.handleClick}>
		 *           <CustomComponent ref="custom" />
		 *         </div>
		 *       );
		 *     },
		 *     handleClick: function() {
		 *       this.refs.custom.handleClick();
		 *     },
		 *     componentDidMount: function() {
		 *       this.refs.custom.initialize();
		 *     }
		 *   });
		 *
		 * Refs should rarely be used. When refs are used, they should only be done to
		 * control data that is not handled by React's data flow.
		 *
		 * @class ReactOwner
		 */
		var ReactOwner = {
		  /**
		   * Adds a component by ref to an owner component.
		   *
		   * @param {ReactComponent} component Component to reference.
		   * @param {string} ref Name by which to refer to the component.
		   * @param {ReactOwner} owner Component on which to record the ref.
		   * @final
		   * @internal
		   */
		  addComponentAsRefTo: function (component, ref, owner) {
		    !isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
		    owner.attachRef(ref, component);
		  },
	
		  /**
		   * Removes a component by ref from an owner component.
		   *
		   * @param {ReactComponent} component Component to dereference.
		   * @param {string} ref Name of the ref to remove.
		   * @param {ReactOwner} owner Component on which the ref is recorded.
		   * @final
		   * @internal
		   */
		  removeComponentAsRefFrom: function (component, ref, owner) {
		    !isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
		    var ownerPublicInstance = owner.getPublicInstance();
		    // Check that `component`'s owner is still alive and that `component` is still the current ref
		    // because we do not want to detach the ref if another component stole it.
		    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
		      owner.detachRef(ref);
		    }
		  }
	
		};
	
		module.exports = ReactOwner;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2016-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
		var debugTool = null;
	
		if (process.env.NODE_ENV !== 'production') {
		  var ReactDebugTool = __webpack_require__(38);
		  debugTool = ReactDebugTool;
		}
	
		module.exports = { debugTool: debugTool };
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2016-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var ReactInvalidSetStateWarningHook = __webpack_require__(39);
		var ReactHostOperationHistoryHook = __webpack_require__(40);
		var ReactComponentTreeHook = __webpack_require__(41);
		var ExecutionEnvironment = __webpack_require__(22);
	
		var performanceNow = __webpack_require__(44);
		var warning = __webpack_require__(18);
	
		var hooks = [];
		var didHookThrowForEvent = {};
	
		function callHook(event, fn, context, arg1, arg2, arg3, arg4, arg5) {
		  try {
		    fn.call(context, arg1, arg2, arg3, arg4, arg5);
		  } catch (e) {
		    process.env.NODE_ENV !== 'production' ? warning(didHookThrowForEvent[event], 'Exception thrown by hook while handling %s: %s', event, e + '\n' + e.stack) : void 0;
		    didHookThrowForEvent[event] = true;
		  }
		}
	
		function emitEvent(event, arg1, arg2, arg3, arg4, arg5) {
		  for (var i = 0; i < hooks.length; i++) {
		    var hook = hooks[i];
		    var fn = hook[event];
		    if (fn) {
		      callHook(event, fn, hook, arg1, arg2, arg3, arg4, arg5);
		    }
		  }
		}
	
		var isProfiling = false;
		var flushHistory = [];
		var lifeCycleTimerStack = [];
		var currentFlushNesting = 0;
		var currentFlushMeasurements = [];
		var currentFlushStartTime = 0;
		var currentTimerDebugID = null;
		var currentTimerStartTime = 0;
		var currentTimerNestedFlushDuration = 0;
		var currentTimerType = null;
	
		var lifeCycleTimerHasWarned = false;
	
		function clearHistory() {
		  ReactComponentTreeHook.purgeUnmountedComponents();
		  ReactHostOperationHistoryHook.clearHistory();
		}
	
		function getTreeSnapshot(registeredIDs) {
		  return registeredIDs.reduce(function (tree, id) {
		    var ownerID = ReactComponentTreeHook.getOwnerID(id);
		    var parentID = ReactComponentTreeHook.getParentID(id);
		    tree[id] = {
		      displayName: ReactComponentTreeHook.getDisplayName(id),
		      text: ReactComponentTreeHook.getText(id),
		      updateCount: ReactComponentTreeHook.getUpdateCount(id),
		      childIDs: ReactComponentTreeHook.getChildIDs(id),
		      // Text nodes don't have owners but this is close enough.
		      ownerID: ownerID || parentID && ReactComponentTreeHook.getOwnerID(parentID) || 0,
		      parentID: parentID
		    };
		    return tree;
		  }, {});
		}
	
		function resetMeasurements() {
		  var previousStartTime = currentFlushStartTime;
		  var previousMeasurements = currentFlushMeasurements;
		  var previousOperations = ReactHostOperationHistoryHook.getHistory();
	
		  if (currentFlushNesting === 0) {
		    currentFlushStartTime = 0;
		    currentFlushMeasurements = [];
		    clearHistory();
		    return;
		  }
	
		  if (previousMeasurements.length || previousOperations.length) {
		    var registeredIDs = ReactComponentTreeHook.getRegisteredIDs();
		    flushHistory.push({
		      duration: performanceNow() - previousStartTime,
		      measurements: previousMeasurements || [],
		      operations: previousOperations || [],
		      treeSnapshot: getTreeSnapshot(registeredIDs)
		    });
		  }
	
		  clearHistory();
		  currentFlushStartTime = performanceNow();
		  currentFlushMeasurements = [];
		}
	
		function checkDebugID(debugID) {
		  var allowRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		  if (allowRoot && debugID === 0) {
		    return;
		  }
		  if (!debugID) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDebugTool: debugID may not be empty.') : void 0;
		  }
		}
	
		function beginLifeCycleTimer(debugID, timerType) {
		  if (currentFlushNesting === 0) {
		    return;
		  }
		  if (currentTimerType && !lifeCycleTimerHasWarned) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
		    lifeCycleTimerHasWarned = true;
		  }
		  currentTimerStartTime = performanceNow();
		  currentTimerNestedFlushDuration = 0;
		  currentTimerDebugID = debugID;
		  currentTimerType = timerType;
		}
	
		function endLifeCycleTimer(debugID, timerType) {
		  if (currentFlushNesting === 0) {
		    return;
		  }
		  if (currentTimerType !== timerType && !lifeCycleTimerHasWarned) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
		    lifeCycleTimerHasWarned = true;
		  }
		  if (isProfiling) {
		    currentFlushMeasurements.push({
		      timerType: timerType,
		      instanceID: debugID,
		      duration: performanceNow() - currentTimerStartTime - currentTimerNestedFlushDuration
		    });
		  }
		  currentTimerStartTime = 0;
		  currentTimerNestedFlushDuration = 0;
		  currentTimerDebugID = null;
		  currentTimerType = null;
		}
	
		function pauseCurrentLifeCycleTimer() {
		  var currentTimer = {
		    startTime: currentTimerStartTime,
		    nestedFlushStartTime: performanceNow(),
		    debugID: currentTimerDebugID,
		    timerType: currentTimerType
		  };
		  lifeCycleTimerStack.push(currentTimer);
		  currentTimerStartTime = 0;
		  currentTimerNestedFlushDuration = 0;
		  currentTimerDebugID = null;
		  currentTimerType = null;
		}
	
		function resumeCurrentLifeCycleTimer() {
		  var _lifeCycleTimerStack$ = lifeCycleTimerStack.pop(),
		      startTime = _lifeCycleTimerStack$.startTime,
		      nestedFlushStartTime = _lifeCycleTimerStack$.nestedFlushStartTime,
		      debugID = _lifeCycleTimerStack$.debugID,
		      timerType = _lifeCycleTimerStack$.timerType;
	
		  var nestedFlushDuration = performanceNow() - nestedFlushStartTime;
		  currentTimerStartTime = startTime;
		  currentTimerNestedFlushDuration += nestedFlushDuration;
		  currentTimerDebugID = debugID;
		  currentTimerType = timerType;
		}
	
		var lastMarkTimeStamp = 0;
		var canUsePerformanceMeasure =
		// $FlowFixMe https://github.com/facebook/flow/issues/2345
		typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';
	
		function shouldMark(debugID) {
		  if (!isProfiling || !canUsePerformanceMeasure) {
		    return false;
		  }
		  var element = ReactComponentTreeHook.getElement(debugID);
		  if (element == null || typeof element !== 'object') {
		    return false;
		  }
		  var isHostElement = typeof element.type === 'string';
		  if (isHostElement) {
		    return false;
		  }
		  return true;
		}
	
		function markBegin(debugID, markType) {
		  if (!shouldMark(debugID)) {
		    return;
		  }
	
		  var markName = debugID + '::' + markType;
		  lastMarkTimeStamp = performanceNow();
		  performance.mark(markName);
		}
	
		function markEnd(debugID, markType) {
		  if (!shouldMark(debugID)) {
		    return;
		  }
	
		  var markName = debugID + '::' + markType;
		  var displayName = ReactComponentTreeHook.getDisplayName(debugID) || 'Unknown';
	
		  // Chrome has an issue of dropping markers recorded too fast:
		  // https://bugs.chromium.org/p/chromium/issues/detail?id=640652
		  // To work around this, we will not report very small measurements.
		  // I determined the magic number by tweaking it back and forth.
		  // 0.05ms was enough to prevent the issue, but I set it to 0.1ms to be safe.
		  // When the bug is fixed, we can `measure()` unconditionally if we want to.
		  var timeStamp = performanceNow();
		  if (timeStamp - lastMarkTimeStamp > 0.1) {
		    var measurementName = displayName + ' [' + markType + ']';
		    performance.measure(measurementName, markName);
		  }
	
		  performance.clearMarks(markName);
		  performance.clearMeasures(measurementName);
		}
	
		var ReactDebugTool = {
		  addHook: function (hook) {
		    hooks.push(hook);
		  },
		  removeHook: function (hook) {
		    for (var i = 0; i < hooks.length; i++) {
		      if (hooks[i] === hook) {
		        hooks.splice(i, 1);
		        i--;
		      }
		    }
		  },
		  isProfiling: function () {
		    return isProfiling;
		  },
		  beginProfiling: function () {
		    if (isProfiling) {
		      return;
		    }
	
		    isProfiling = true;
		    flushHistory.length = 0;
		    resetMeasurements();
		    ReactDebugTool.addHook(ReactHostOperationHistoryHook);
		  },
		  endProfiling: function () {
		    if (!isProfiling) {
		      return;
		    }
	
		    isProfiling = false;
		    resetMeasurements();
		    ReactDebugTool.removeHook(ReactHostOperationHistoryHook);
		  },
		  getFlushHistory: function () {
		    return flushHistory;
		  },
		  onBeginFlush: function () {
		    currentFlushNesting++;
		    resetMeasurements();
		    pauseCurrentLifeCycleTimer();
		    emitEvent('onBeginFlush');
		  },
		  onEndFlush: function () {
		    resetMeasurements();
		    currentFlushNesting--;
		    resumeCurrentLifeCycleTimer();
		    emitEvent('onEndFlush');
		  },
		  onBeginLifeCycleTimer: function (debugID, timerType) {
		    checkDebugID(debugID);
		    emitEvent('onBeginLifeCycleTimer', debugID, timerType);
		    markBegin(debugID, timerType);
		    beginLifeCycleTimer(debugID, timerType);
		  },
		  onEndLifeCycleTimer: function (debugID, timerType) {
		    checkDebugID(debugID);
		    endLifeCycleTimer(debugID, timerType);
		    markEnd(debugID, timerType);
		    emitEvent('onEndLifeCycleTimer', debugID, timerType);
		  },
		  onBeginProcessingChildContext: function () {
		    emitEvent('onBeginProcessingChildContext');
		  },
		  onEndProcessingChildContext: function () {
		    emitEvent('onEndProcessingChildContext');
		  },
		  onHostOperation: function (operation) {
		    checkDebugID(operation.instanceID);
		    emitEvent('onHostOperation', operation);
		  },
		  onSetState: function () {
		    emitEvent('onSetState');
		  },
		  onSetChildren: function (debugID, childDebugIDs) {
		    checkDebugID(debugID);
		    childDebugIDs.forEach(checkDebugID);
		    emitEvent('onSetChildren', debugID, childDebugIDs);
		  },
		  onBeforeMountComponent: function (debugID, element, parentDebugID) {
		    checkDebugID(debugID);
		    checkDebugID(parentDebugID, true);
		    emitEvent('onBeforeMountComponent', debugID, element, parentDebugID);
		    markBegin(debugID, 'mount');
		  },
		  onMountComponent: function (debugID) {
		    checkDebugID(debugID);
		    markEnd(debugID, 'mount');
		    emitEvent('onMountComponent', debugID);
		  },
		  onBeforeUpdateComponent: function (debugID, element) {
		    checkDebugID(debugID);
		    emitEvent('onBeforeUpdateComponent', debugID, element);
		    markBegin(debugID, 'update');
		  },
		  onUpdateComponent: function (debugID) {
		    checkDebugID(debugID);
		    markEnd(debugID, 'update');
		    emitEvent('onUpdateComponent', debugID);
		  },
		  onBeforeUnmountComponent: function (debugID) {
		    checkDebugID(debugID);
		    emitEvent('onBeforeUnmountComponent', debugID);
		    markBegin(debugID, 'unmount');
		  },
		  onUnmountComponent: function (debugID) {
		    checkDebugID(debugID);
		    markEnd(debugID, 'unmount');
		    emitEvent('onUnmountComponent', debugID);
		  },
		  onTestEvent: function () {
		    emitEvent('onTestEvent');
		  }
		};
	
		// TODO remove these when RN/www gets updated
		ReactDebugTool.addDevtool = ReactDebugTool.addHook;
		ReactDebugTool.removeDevtool = ReactDebugTool.removeHook;
	
		ReactDebugTool.addHook(ReactInvalidSetStateWarningHook);
		ReactDebugTool.addHook(ReactComponentTreeHook);
		var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
		if (/[?&]react_perf\b/.test(url)) {
		  ReactDebugTool.beginProfiling();
		}
	
		module.exports = ReactDebugTool;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2016-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var warning = __webpack_require__(18);
	
		if (process.env.NODE_ENV !== 'production') {
		  var processingChildContext = false;
	
		  var warnInvalidSetState = function () {
		    process.env.NODE_ENV !== 'production' ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
		  };
		}
	
		var ReactInvalidSetStateWarningHook = {
		  onBeginProcessingChildContext: function () {
		    processingChildContext = true;
		  },
		  onEndProcessingChildContext: function () {
		    processingChildContext = false;
		  },
		  onSetState: function () {
		    warnInvalidSetState();
		  }
		};
	
		module.exports = ReactInvalidSetStateWarningHook;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 40 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2016-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var history = [];
	
		var ReactHostOperationHistoryHook = {
		  onHostOperation: function (operation) {
		    history.push(operation);
		  },
		  clearHistory: function () {
		    if (ReactHostOperationHistoryHook._preventClearing) {
		      // Should only be used for tests.
		      return;
		    }
	
		    history = [];
		  },
		  getHistory: function () {
		    return history;
		  }
		};
	
		module.exports = ReactHostOperationHistoryHook;
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2016-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(42);
	
		var ReactCurrentOwner = __webpack_require__(43);
	
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		function isNative(fn) {
		  // Based on isNative() from Lodash
		  var funcToString = Function.prototype.toString;
		  var hasOwnProperty = Object.prototype.hasOwnProperty;
		  var reIsNative = RegExp('^' + funcToString
		  // Take an example native function source for comparison
		  .call(hasOwnProperty)
		  // Strip regex characters so we can use it for regex
		  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
		  // Remove hasOwnProperty from the template to make it generic
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
		  try {
		    var source = funcToString.call(fn);
		    return reIsNative.test(source);
		  } catch (err) {
		    return false;
		  }
		}
	
		var canUseCollections =
		// Array.from
		typeof Array.from === 'function' &&
		// Map
		typeof Map === 'function' && isNative(Map) &&
		// Map.prototype.keys
		Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
		// Set
		typeof Set === 'function' && isNative(Set) &&
		// Set.prototype.keys
		Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
		var setItem;
		var getItem;
		var removeItem;
		var getItemIDs;
		var addRoot;
		var removeRoot;
		var getRootIDs;
	
		if (canUseCollections) {
		  var itemMap = new Map();
		  var rootIDSet = new Set();
	
		  setItem = function (id, item) {
		    itemMap.set(id, item);
		  };
		  getItem = function (id) {
		    return itemMap.get(id);
		  };
		  removeItem = function (id) {
		    itemMap['delete'](id);
		  };
		  getItemIDs = function () {
		    return Array.from(itemMap.keys());
		  };
	
		  addRoot = function (id) {
		    rootIDSet.add(id);
		  };
		  removeRoot = function (id) {
		    rootIDSet['delete'](id);
		  };
		  getRootIDs = function () {
		    return Array.from(rootIDSet.keys());
		  };
		} else {
		  var itemByKey = {};
		  var rootByKey = {};
	
		  // Use non-numeric keys to prevent V8 performance issues:
		  // https://github.com/facebook/react/pull/7232
		  var getKeyFromID = function (id) {
		    return '.' + id;
		  };
		  var getIDFromKey = function (key) {
		    return parseInt(key.substr(1), 10);
		  };
	
		  setItem = function (id, item) {
		    var key = getKeyFromID(id);
		    itemByKey[key] = item;
		  };
		  getItem = function (id) {
		    var key = getKeyFromID(id);
		    return itemByKey[key];
		  };
		  removeItem = function (id) {
		    var key = getKeyFromID(id);
		    delete itemByKey[key];
		  };
		  getItemIDs = function () {
		    return Object.keys(itemByKey).map(getIDFromKey);
		  };
	
		  addRoot = function (id) {
		    var key = getKeyFromID(id);
		    rootByKey[key] = true;
		  };
		  removeRoot = function (id) {
		    var key = getKeyFromID(id);
		    delete rootByKey[key];
		  };
		  getRootIDs = function () {
		    return Object.keys(rootByKey).map(getIDFromKey);
		  };
		}
	
		var unmountedIDs = [];
	
		function purgeDeep(id) {
		  var item = getItem(id);
		  if (item) {
		    var childIDs = item.childIDs;
	
		    removeItem(id);
		    childIDs.forEach(purgeDeep);
		  }
		}
	
		function describeComponentFrame(name, source, ownerName) {
		  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
		}
	
		function getDisplayName(element) {
		  if (element == null) {
		    return '#empty';
		  } else if (typeof element === 'string' || typeof element === 'number') {
		    return '#text';
		  } else if (typeof element.type === 'string') {
		    return element.type;
		  } else {
		    return element.type.displayName || element.type.name || 'Unknown';
		  }
		}
	
		function describeID(id) {
		  var name = ReactComponentTreeHook.getDisplayName(id);
		  var element = ReactComponentTreeHook.getElement(id);
		  var ownerID = ReactComponentTreeHook.getOwnerID(id);
		  var ownerName;
		  if (ownerID) {
		    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
		  }
		  process.env.NODE_ENV !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
		  return describeComponentFrame(name, element && element._source, ownerName);
		}
	
		var ReactComponentTreeHook = {
		  onSetChildren: function (id, nextChildIDs) {
		    var item = getItem(id);
		    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
		    item.childIDs = nextChildIDs;
	
		    for (var i = 0; i < nextChildIDs.length; i++) {
		      var nextChildID = nextChildIDs[i];
		      var nextChild = getItem(nextChildID);
		      !nextChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
		      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
		      !nextChild.isMounted ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
		      if (nextChild.parentID == null) {
		        nextChild.parentID = id;
		        // TODO: This shouldn't be necessary but mounting a new root during in
		        // componentWillMount currently causes not-yet-mounted components to
		        // be purged from our tree data so their parent id is missing.
		      }
		      !(nextChild.parentID === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
		    }
		  },
		  onBeforeMountComponent: function (id, element, parentID) {
		    var item = {
		      element: element,
		      parentID: parentID,
		      text: null,
		      childIDs: [],
		      isMounted: false,
		      updateCount: 0
		    };
		    setItem(id, item);
		  },
		  onBeforeUpdateComponent: function (id, element) {
		    var item = getItem(id);
		    if (!item || !item.isMounted) {
		      // We may end up here as a result of setState() in componentWillUnmount().
		      // In this case, ignore the element.
		      return;
		    }
		    item.element = element;
		  },
		  onMountComponent: function (id) {
		    var item = getItem(id);
		    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
		    item.isMounted = true;
		    var isRoot = item.parentID === 0;
		    if (isRoot) {
		      addRoot(id);
		    }
		  },
		  onUpdateComponent: function (id) {
		    var item = getItem(id);
		    if (!item || !item.isMounted) {
		      // We may end up here as a result of setState() in componentWillUnmount().
		      // In this case, ignore the element.
		      return;
		    }
		    item.updateCount++;
		  },
		  onUnmountComponent: function (id) {
		    var item = getItem(id);
		    if (item) {
		      // We need to check if it exists.
		      // `item` might not exist if it is inside an error boundary, and a sibling
		      // error boundary child threw while mounting. Then this instance never
		      // got a chance to mount, but it still gets an unmounting event during
		      // the error boundary cleanup.
		      item.isMounted = false;
		      var isRoot = item.parentID === 0;
		      if (isRoot) {
		        removeRoot(id);
		      }
		    }
		    unmountedIDs.push(id);
		  },
		  purgeUnmountedComponents: function () {
		    if (ReactComponentTreeHook._preventPurging) {
		      // Should only be used for testing.
		      return;
		    }
	
		    for (var i = 0; i < unmountedIDs.length; i++) {
		      var id = unmountedIDs[i];
		      purgeDeep(id);
		    }
		    unmountedIDs.length = 0;
		  },
		  isMounted: function (id) {
		    var item = getItem(id);
		    return item ? item.isMounted : false;
		  },
		  getCurrentStackAddendum: function (topElement) {
		    var info = '';
		    if (topElement) {
		      var name = getDisplayName(topElement);
		      var owner = topElement._owner;
		      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
		    }
	
		    var currentOwner = ReactCurrentOwner.current;
		    var id = currentOwner && currentOwner._debugID;
	
		    info += ReactComponentTreeHook.getStackAddendumByID(id);
		    return info;
		  },
		  getStackAddendumByID: function (id) {
		    var info = '';
		    while (id) {
		      info += describeID(id);
		      id = ReactComponentTreeHook.getParentID(id);
		    }
		    return info;
		  },
		  getChildIDs: function (id) {
		    var item = getItem(id);
		    return item ? item.childIDs : [];
		  },
		  getDisplayName: function (id) {
		    var element = ReactComponentTreeHook.getElement(id);
		    if (!element) {
		      return null;
		    }
		    return getDisplayName(element);
		  },
		  getElement: function (id) {
		    var item = getItem(id);
		    return item ? item.element : null;
		  },
		  getOwnerID: function (id) {
		    var element = ReactComponentTreeHook.getElement(id);
		    if (!element || !element._owner) {
		      return null;
		    }
		    return element._owner._debugID;
		  },
		  getParentID: function (id) {
		    var item = getItem(id);
		    return item ? item.parentID : null;
		  },
		  getSource: function (id) {
		    var item = getItem(id);
		    var element = item ? item.element : null;
		    var source = element != null ? element._source : null;
		    return source;
		  },
		  getText: function (id) {
		    var element = ReactComponentTreeHook.getElement(id);
		    if (typeof element === 'string') {
		      return element;
		    } else if (typeof element === 'number') {
		      return '' + element;
		    } else {
		      return null;
		    }
		  },
		  getUpdateCount: function (id) {
		    var item = getItem(id);
		    return item ? item.updateCount : 0;
		  },
	
	
		  getRootIDs: getRootIDs,
		  getRegisteredIDs: getItemIDs
		};
	
		module.exports = ReactComponentTreeHook;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 42 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
		'use strict';
	
		/**
		 * WARNING: DO NOT manually require this module.
		 * This is a replacement for `invariant(...)` used by the error code system
		 * and will _only_ be required by the corresponding babel pass.
		 * It always throws.
		 */
	
		function reactProdInvariant(code) {
		  var argCount = arguments.length - 1;
	
		  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
		  for (var argIdx = 0; argIdx < argCount; argIdx++) {
		    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
		  }
	
		  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
		  var error = new Error(message);
		  error.name = 'Invariant Violation';
		  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
		  throw error;
		}
	
		module.exports = reactProdInvariant;
	
	/***/ },
	/* 43 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		/**
		 * Keeps track of the current owner.
		 *
		 * The current owner is the component who should own any components that are
		 * currently being constructed.
		 */
		var ReactCurrentOwner = {
	
		  /**
		   * @internal
		   * @type {ReactComponent}
		   */
		  current: null
	
		};
	
		module.exports = ReactCurrentOwner;
	
	/***/ },
	/* 44 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		var performance = __webpack_require__(45);
	
		var performanceNow;
	
		/**
		 * Detect if we can use `window.performance.now()` and gracefully fallback to
		 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
		 * because of Facebook's testing infrastructure.
		 */
		if (performance.now) {
		  performanceNow = function performanceNow() {
		    return performance.now();
		  };
		} else {
		  performanceNow = function performanceNow() {
		    return Date.now();
		  };
		}
	
		module.exports = performanceNow;
	
	/***/ },
	/* 45 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		'use strict';
	
		var ExecutionEnvironment = __webpack_require__(22);
	
		var performance;
	
		if (ExecutionEnvironment.canUseDOM) {
		  performance = window.performance || window.msPerformance || window.webkitPerformance;
		}
	
		module.exports = performance || {};
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		var OBSERVED_ERROR = {};
	
		/**
		 * `Transaction` creates a black box that is able to wrap any method such that
		 * certain invariants are maintained before and after the method is invoked
		 * (Even if an exception is thrown while invoking the wrapped method). Whoever
		 * instantiates a transaction can provide enforcers of the invariants at
		 * creation time. The `Transaction` class itself will supply one additional
		 * automatic invariant for you - the invariant that any transaction instance
		 * should not be run while it is already being run. You would typically create a
		 * single instance of a `Transaction` for reuse multiple times, that potentially
		 * is used to wrap several different methods. Wrappers are extremely simple -
		 * they only require implementing two methods.
		 *
		 * <pre>
		 *                       wrappers (injected at creation time)
		 *                                      +        +
		 *                                      |        |
		 *                    +-----------------|--------|--------------+
		 *                    |                 v        |              |
		 *                    |      +---------------+   |              |
		 *                    |   +--|    wrapper1   |---|----+         |
		 *                    |   |  +---------------+   v    |         |
		 *                    |   |          +-------------+  |         |
		 *                    |   |     +----|   wrapper2  |--------+   |
		 *                    |   |     |    +-------------+  |     |   |
		 *                    |   |     |                     |     |   |
		 *                    |   v     v                     v     v   | wrapper
		 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
		 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
		 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
		 *                    | |   | |   |   |         |   |   | |   | |
		 *                    | |   | |   |   |         |   |   | |   | |
		 *                    | |   | |   |   |         |   |   | |   | |
		 *                    | +---+ +---+   +---------+   +---+ +---+ |
		 *                    |  initialize                    close    |
		 *                    +-----------------------------------------+
		 * </pre>
		 *
		 * Use cases:
		 * - Preserving the input selection ranges before/after reconciliation.
		 *   Restoring selection even in the event of an unexpected error.
		 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
		 *   while guaranteeing that afterwards, the event system is reactivated.
		 * - Flushing a queue of collected DOM mutations to the main UI thread after a
		 *   reconciliation takes place in a worker thread.
		 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
		 *   content.
		 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
		 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
		 * - (Future use case): Layout calculations before and after DOM updates.
		 *
		 * Transactional plugin API:
		 * - A module that has an `initialize` method that returns any precomputation.
		 * - and a `close` method that accepts the precomputation. `close` is invoked
		 *   when the wrapped process is completed, or has failed.
		 *
		 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
		 * that implement `initialize` and `close`.
		 * @return {Transaction} Single transaction for reuse in thread.
		 *
		 * @class Transaction
		 */
		var TransactionImpl = {
		  /**
		   * Sets up this instance so that it is prepared for collecting metrics. Does
		   * so such that this setup method may be used on an instance that is already
		   * initialized, in a way that does not consume additional memory upon reuse.
		   * That can be useful if you decide to make your subclass of this mixin a
		   * "PooledClass".
		   */
		  reinitializeTransaction: function () {
		    this.transactionWrappers = this.getTransactionWrappers();
		    if (this.wrapperInitData) {
		      this.wrapperInitData.length = 0;
		    } else {
		      this.wrapperInitData = [];
		    }
		    this._isInTransaction = false;
		  },
	
		  _isInTransaction: false,
	
		  /**
		   * @abstract
		   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
		   */
		  getTransactionWrappers: null,
	
		  isInTransaction: function () {
		    return !!this._isInTransaction;
		  },
	
		  /**
		   * Executes the function within a safety window. Use this for the top level
		   * methods that result in large amounts of computation/mutations that would
		   * need to be safety checked. The optional arguments helps prevent the need
		   * to bind in many cases.
		   *
		   * @param {function} method Member of scope to call.
		   * @param {Object} scope Scope to invoke from.
		   * @param {Object?=} a Argument to pass to the method.
		   * @param {Object?=} b Argument to pass to the method.
		   * @param {Object?=} c Argument to pass to the method.
		   * @param {Object?=} d Argument to pass to the method.
		   * @param {Object?=} e Argument to pass to the method.
		   * @param {Object?=} f Argument to pass to the method.
		   *
		   * @return {*} Return value from `method`.
		   */
		  perform: function (method, scope, a, b, c, d, e, f) {
		    !!this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
		    var errorThrown;
		    var ret;
		    try {
		      this._isInTransaction = true;
		      // Catching errors makes debugging more difficult, so we start with
		      // errorThrown set to true before setting it to false after calling
		      // close -- if it's still set to true in the finally block, it means
		      // one of these calls threw.
		      errorThrown = true;
		      this.initializeAll(0);
		      ret = method.call(scope, a, b, c, d, e, f);
		      errorThrown = false;
		    } finally {
		      try {
		        if (errorThrown) {
		          // If `method` throws, prefer to show that stack trace over any thrown
		          // by invoking `closeAll`.
		          try {
		            this.closeAll(0);
		          } catch (err) {}
		        } else {
		          // Since `method` didn't throw, we don't want to silence the exception
		          // here.
		          this.closeAll(0);
		        }
		      } finally {
		        this._isInTransaction = false;
		      }
		    }
		    return ret;
		  },
	
		  initializeAll: function (startIndex) {
		    var transactionWrappers = this.transactionWrappers;
		    for (var i = startIndex; i < transactionWrappers.length; i++) {
		      var wrapper = transactionWrappers[i];
		      try {
		        // Catching errors makes debugging more difficult, so we start with the
		        // OBSERVED_ERROR state before overwriting it with the real return value
		        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
		        // block, it means wrapper.initialize threw.
		        this.wrapperInitData[i] = OBSERVED_ERROR;
		        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
		      } finally {
		        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
		          // The initializer for wrapper i threw an error; initialize the
		          // remaining wrappers but silence any exceptions from them to ensure
		          // that the first error is the one to bubble up.
		          try {
		            this.initializeAll(i + 1);
		          } catch (err) {}
		        }
		      }
		    }
		  },
	
		  /**
		   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
		   * them the respective return values of `this.transactionWrappers.init[i]`
		   * (`close`rs that correspond to initializers that failed will not be
		   * invoked).
		   */
		  closeAll: function (startIndex) {
		    !this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
		    var transactionWrappers = this.transactionWrappers;
		    for (var i = startIndex; i < transactionWrappers.length; i++) {
		      var wrapper = transactionWrappers[i];
		      var initData = this.wrapperInitData[i];
		      var errorThrown;
		      try {
		        // Catching errors makes debugging more difficult, so we start with
		        // errorThrown set to true before setting it to false after calling
		        // close -- if it's still set to true in the finally block, it means
		        // wrapper.close threw.
		        errorThrown = true;
		        if (initData !== OBSERVED_ERROR && wrapper.close) {
		          wrapper.close.call(this, initData);
		        }
		        errorThrown = false;
		      } finally {
		        if (errorThrown) {
		          // The closer for wrapper i threw an error; close the remaining
		          // wrappers but silence any exceptions from them to ensure that the
		          // first error is the one to bubble up.
		          try {
		            this.closeAll(i + 1);
		          } catch (e) {}
		        }
		      }
		    }
		    this.wrapperInitData.length = 0;
		  }
		};
	
		module.exports = TransactionImpl;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 47 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Gets the target node from a native browser event by accounting for
		 * inconsistencies in browser DOM APIs.
		 *
		 * @param {object} nativeEvent Native browser event.
		 * @return {DOMEventTarget} Target node.
		 */
	
		function getEventTarget(nativeEvent) {
		  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
		  // Normalize SVG <use> element events #4963
		  if (target.correspondingUseElement) {
		    target = target.correspondingUseElement;
		  }
	
		  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
		  // @see http://www.quirksmode.org/js/events_properties.html
		  return target.nodeType === 3 ? target.parentNode : target;
		}
	
		module.exports = getEventTarget;
	
	/***/ },
	/* 48 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ExecutionEnvironment = __webpack_require__(22);
	
		var useHasFeature;
		if (ExecutionEnvironment.canUseDOM) {
		  useHasFeature = document.implementation && document.implementation.hasFeature &&
		  // always returns true in newer browsers as per the standard.
		  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
		  document.implementation.hasFeature('', '') !== true;
		}
	
		/**
		 * Checks if an event is supported in the current execution environment.
		 *
		 * NOTE: This will not work correctly for non-generic events such as `change`,
		 * `reset`, `load`, `error`, and `select`.
		 *
		 * Borrows from Modernizr.
		 *
		 * @param {string} eventNameSuffix Event name, e.g. "click".
		 * @param {?boolean} capture Check if the capture phase is supported.
		 * @return {boolean} True if the event is supported.
		 * @internal
		 * @license Modernizr 3.0.0pre (Custom Build) | MIT
		 */
		function isEventSupported(eventNameSuffix, capture) {
		  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
		    return false;
		  }
	
		  var eventName = 'on' + eventNameSuffix;
		  var isSupported = eventName in document;
	
		  if (!isSupported) {
		    var element = document.createElement('div');
		    element.setAttribute(eventName, 'return;');
		    isSupported = typeof element[eventName] === 'function';
		  }
	
		  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
		    // This is the only way to test support for the `wheel` event in IE9+.
		    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
		  }
	
		  return isSupported;
		}
	
		module.exports = isEventSupported;
	
	/***/ },
	/* 49 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		/**
		 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
		 */
	
		var supportedInputTypes = {
		  'color': true,
		  'date': true,
		  'datetime': true,
		  'datetime-local': true,
		  'email': true,
		  'month': true,
		  'number': true,
		  'password': true,
		  'range': true,
		  'search': true,
		  'tel': true,
		  'text': true,
		  'time': true,
		  'url': true,
		  'week': true
		};
	
		function isTextInputElement(elem) {
		  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
		  if (nodeName === 'input') {
		    return !!supportedInputTypes[elem.type];
		  }
	
		  if (nodeName === 'textarea') {
		    return true;
		  }
	
		  return false;
		}
	
		module.exports = isTextInputElement;
	
	/***/ },
	/* 50 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Module that is injectable into `EventPluginHub`, that specifies a
		 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
		 * plugins, without having to package every one of them. This is better than
		 * having plugins be ordered in the same order that they are injected because
		 * that ordering would be influenced by the packaging order.
		 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
		 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
		 */
	
		var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
		module.exports = DefaultEventPluginOrder;
	
	/***/ },
	/* 51 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var EventPropagators = __webpack_require__(13);
		var ReactDOMComponentTree = __webpack_require__(5);
		var SyntheticMouseEvent = __webpack_require__(52);
	
		var eventTypes = {
		  mouseEnter: {
		    registrationName: 'onMouseEnter',
		    dependencies: ['topMouseOut', 'topMouseOver']
		  },
		  mouseLeave: {
		    registrationName: 'onMouseLeave',
		    dependencies: ['topMouseOut', 'topMouseOver']
		  }
		};
	
		var EnterLeaveEventPlugin = {
	
		  eventTypes: eventTypes,
	
		  /**
		   * For almost every interaction we care about, there will be both a top-level
		   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
		   * we do not extract duplicate events. However, moving the mouse into the
		   * browser from outside will not fire a `mouseout` event. In this case, we use
		   * the `mouseover` top-level event.
		   */
		  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
		      return null;
		    }
		    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
		      // Must not be a mouse in or mouse out - ignoring.
		      return null;
		    }
	
		    var win;
		    if (nativeEventTarget.window === nativeEventTarget) {
		      // `nativeEventTarget` is probably a window object.
		      win = nativeEventTarget;
		    } else {
		      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
		      var doc = nativeEventTarget.ownerDocument;
		      if (doc) {
		        win = doc.defaultView || doc.parentWindow;
		      } else {
		        win = window;
		      }
		    }
	
		    var from;
		    var to;
		    if (topLevelType === 'topMouseOut') {
		      from = targetInst;
		      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
		      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
		    } else {
		      // Moving to a node from outside the window.
		      from = null;
		      to = targetInst;
		    }
	
		    if (from === to) {
		      // Nothing pertains to our managed components.
		      return null;
		    }
	
		    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
		    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
		    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
		    leave.type = 'mouseleave';
		    leave.target = fromNode;
		    leave.relatedTarget = toNode;
	
		    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
		    enter.type = 'mouseenter';
		    enter.target = toNode;
		    enter.relatedTarget = fromNode;
	
		    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
		    return [leave, enter];
		  }
	
		};
	
		module.exports = EnterLeaveEventPlugin;
	
	/***/ },
	/* 52 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticUIEvent = __webpack_require__(53);
		var ViewportMetrics = __webpack_require__(54);
	
		var getEventModifierState = __webpack_require__(55);
	
		/**
		 * @interface MouseEvent
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/
		 */
		var MouseEventInterface = {
		  screenX: null,
		  screenY: null,
		  clientX: null,
		  clientY: null,
		  ctrlKey: null,
		  shiftKey: null,
		  altKey: null,
		  metaKey: null,
		  getModifierState: getEventModifierState,
		  button: function (event) {
		    // Webkit, Firefox, IE9+
		    // which:  1 2 3
		    // button: 0 1 2 (standard)
		    var button = event.button;
		    if ('which' in event) {
		      return button;
		    }
		    // IE<9
		    // which:  undefined
		    // button: 0 0 0
		    // button: 1 4 2 (onmouseup)
		    return button === 2 ? 2 : button === 4 ? 1 : 0;
		  },
		  buttons: null,
		  relatedTarget: function (event) {
		    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
		  },
		  // "Proprietary" Interface.
		  pageX: function (event) {
		    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
		  },
		  pageY: function (event) {
		    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
		  }
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticUIEvent}
		 */
		function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
		module.exports = SyntheticMouseEvent;
	
	/***/ },
	/* 53 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticEvent = __webpack_require__(28);
	
		var getEventTarget = __webpack_require__(47);
	
		/**
		 * @interface UIEvent
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/
		 */
		var UIEventInterface = {
		  view: function (event) {
		    if (event.view) {
		      return event.view;
		    }
	
		    var target = getEventTarget(event);
		    if (target.window === target) {
		      // target is a window object
		      return target;
		    }
	
		    var doc = target.ownerDocument;
		    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
		    if (doc) {
		      return doc.defaultView || doc.parentWindow;
		    } else {
		      return window;
		    }
		  },
		  detail: function (event) {
		    return event.detail || 0;
		  }
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticEvent}
		 */
		function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
		module.exports = SyntheticUIEvent;
	
	/***/ },
	/* 54 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ViewportMetrics = {
	
		  currentScrollLeft: 0,
	
		  currentScrollTop: 0,
	
		  refreshScrollValues: function (scrollPosition) {
		    ViewportMetrics.currentScrollLeft = scrollPosition.x;
		    ViewportMetrics.currentScrollTop = scrollPosition.y;
		  }
	
		};
	
		module.exports = ViewportMetrics;
	
	/***/ },
	/* 55 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Translation from modifier key to the associated property in the event.
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
		 */
	
		var modifierKeyToProp = {
		  'Alt': 'altKey',
		  'Control': 'ctrlKey',
		  'Meta': 'metaKey',
		  'Shift': 'shiftKey'
		};
	
		// IE8 does not implement getModifierState so we simply map it to the only
		// modifier keys exposed by the event itself, does not support Lock-keys.
		// Currently, all major browsers except Chrome seems to support Lock-keys.
		function modifierStateGetter(keyArg) {
		  var syntheticEvent = this;
		  var nativeEvent = syntheticEvent.nativeEvent;
		  if (nativeEvent.getModifierState) {
		    return nativeEvent.getModifierState(keyArg);
		  }
		  var keyProp = modifierKeyToProp[keyArg];
		  return keyProp ? !!nativeEvent[keyProp] : false;
		}
	
		function getEventModifierState(nativeEvent) {
		  return modifierStateGetter;
		}
	
		module.exports = getEventModifierState;
	
	/***/ },
	/* 56 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMProperty = __webpack_require__(7);
	
		var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
		var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
		var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
		var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
		var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
		var HTMLDOMPropertyConfig = {
		  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
		  Properties: {
		    /**
		     * Standard Properties
		     */
		    accept: 0,
		    acceptCharset: 0,
		    accessKey: 0,
		    action: 0,
		    allowFullScreen: HAS_BOOLEAN_VALUE,
		    allowTransparency: 0,
		    alt: 0,
		    // specifies target context for links with `preload` type
		    as: 0,
		    async: HAS_BOOLEAN_VALUE,
		    autoComplete: 0,
		    // autoFocus is polyfilled/normalized by AutoFocusUtils
		    // autoFocus: HAS_BOOLEAN_VALUE,
		    autoPlay: HAS_BOOLEAN_VALUE,
		    capture: HAS_BOOLEAN_VALUE,
		    cellPadding: 0,
		    cellSpacing: 0,
		    charSet: 0,
		    challenge: 0,
		    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
		    cite: 0,
		    classID: 0,
		    className: 0,
		    cols: HAS_POSITIVE_NUMERIC_VALUE,
		    colSpan: 0,
		    content: 0,
		    contentEditable: 0,
		    contextMenu: 0,
		    controls: HAS_BOOLEAN_VALUE,
		    coords: 0,
		    crossOrigin: 0,
		    data: 0, // For `<object />` acts as `src`.
		    dateTime: 0,
		    'default': HAS_BOOLEAN_VALUE,
		    defer: HAS_BOOLEAN_VALUE,
		    dir: 0,
		    disabled: HAS_BOOLEAN_VALUE,
		    download: HAS_OVERLOADED_BOOLEAN_VALUE,
		    draggable: 0,
		    encType: 0,
		    form: 0,
		    formAction: 0,
		    formEncType: 0,
		    formMethod: 0,
		    formNoValidate: HAS_BOOLEAN_VALUE,
		    formTarget: 0,
		    frameBorder: 0,
		    headers: 0,
		    height: 0,
		    hidden: HAS_BOOLEAN_VALUE,
		    high: 0,
		    href: 0,
		    hrefLang: 0,
		    htmlFor: 0,
		    httpEquiv: 0,
		    icon: 0,
		    id: 0,
		    inputMode: 0,
		    integrity: 0,
		    is: 0,
		    keyParams: 0,
		    keyType: 0,
		    kind: 0,
		    label: 0,
		    lang: 0,
		    list: 0,
		    loop: HAS_BOOLEAN_VALUE,
		    low: 0,
		    manifest: 0,
		    marginHeight: 0,
		    marginWidth: 0,
		    max: 0,
		    maxLength: 0,
		    media: 0,
		    mediaGroup: 0,
		    method: 0,
		    min: 0,
		    minLength: 0,
		    // Caution; `option.selected` is not updated if `select.multiple` is
		    // disabled with `removeAttribute`.
		    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
		    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
		    name: 0,
		    nonce: 0,
		    noValidate: HAS_BOOLEAN_VALUE,
		    open: HAS_BOOLEAN_VALUE,
		    optimum: 0,
		    pattern: 0,
		    placeholder: 0,
		    playsInline: HAS_BOOLEAN_VALUE,
		    poster: 0,
		    preload: 0,
		    profile: 0,
		    radioGroup: 0,
		    readOnly: HAS_BOOLEAN_VALUE,
		    referrerPolicy: 0,
		    rel: 0,
		    required: HAS_BOOLEAN_VALUE,
		    reversed: HAS_BOOLEAN_VALUE,
		    role: 0,
		    rows: HAS_POSITIVE_NUMERIC_VALUE,
		    rowSpan: HAS_NUMERIC_VALUE,
		    sandbox: 0,
		    scope: 0,
		    scoped: HAS_BOOLEAN_VALUE,
		    scrolling: 0,
		    seamless: HAS_BOOLEAN_VALUE,
		    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
		    shape: 0,
		    size: HAS_POSITIVE_NUMERIC_VALUE,
		    sizes: 0,
		    span: HAS_POSITIVE_NUMERIC_VALUE,
		    spellCheck: 0,
		    src: 0,
		    srcDoc: 0,
		    srcLang: 0,
		    srcSet: 0,
		    start: HAS_NUMERIC_VALUE,
		    step: 0,
		    style: 0,
		    summary: 0,
		    tabIndex: 0,
		    target: 0,
		    title: 0,
		    // Setting .type throws on non-<input> tags
		    type: 0,
		    useMap: 0,
		    value: 0,
		    width: 0,
		    wmode: 0,
		    wrap: 0,
	
		    /**
		     * RDFa Properties
		     */
		    about: 0,
		    datatype: 0,
		    inlist: 0,
		    prefix: 0,
		    // property is also supported for OpenGraph in meta tags.
		    property: 0,
		    resource: 0,
		    'typeof': 0,
		    vocab: 0,
	
		    /**
		     * Non-standard Properties
		     */
		    // autoCapitalize and autoCorrect are supported in Mobile Safari for
		    // keyboard hints.
		    autoCapitalize: 0,
		    autoCorrect: 0,
		    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
		    autoSave: 0,
		    // color is for Safari mask-icon link
		    color: 0,
		    // itemProp, itemScope, itemType are for
		    // Microdata support. See http://schema.org/docs/gs.html
		    itemProp: 0,
		    itemScope: HAS_BOOLEAN_VALUE,
		    itemType: 0,
		    // itemID and itemRef are for Microdata support as well but
		    // only specified in the WHATWG spec document. See
		    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
		    itemID: 0,
		    itemRef: 0,
		    // results show looking glass icon and recent searches on input
		    // search fields in WebKit/Blink
		    results: 0,
		    // IE-only attribute that specifies security restrictions on an iframe
		    // as an alternative to the sandbox attribute on IE<10
		    security: 0,
		    // IE-only attribute that controls focus behavior
		    unselectable: 0
		  },
		  DOMAttributeNames: {
		    acceptCharset: 'accept-charset',
		    className: 'class',
		    htmlFor: 'for',
		    httpEquiv: 'http-equiv'
		  },
		  DOMPropertyNames: {}
		};
	
		module.exports = HTMLDOMPropertyConfig;
	
	/***/ },
	/* 57 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMChildrenOperations = __webpack_require__(58);
		var ReactDOMIDOperations = __webpack_require__(69);
	
		/**
		 * Abstracts away all functionality of the reconciler that requires knowledge of
		 * the browser context. TODO: These callers should be refactored to avoid the
		 * need for this injection.
		 */
		var ReactComponentBrowserEnvironment = {
	
		  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
		  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
		};
	
		module.exports = ReactComponentBrowserEnvironment;
	
	/***/ },
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMLazyTree = __webpack_require__(59);
		var Danger = __webpack_require__(65);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactInstrumentation = __webpack_require__(37);
	
		var createMicrosoftUnsafeLocalFunction = __webpack_require__(62);
		var setInnerHTML = __webpack_require__(61);
		var setTextContent = __webpack_require__(63);
	
		function getNodeAfter(parentNode, node) {
		  // Special case for text components, which return [open, close] comments
		  // from getHostNode.
		  if (Array.isArray(node)) {
		    node = node[1];
		  }
		  return node ? node.nextSibling : parentNode.firstChild;
		}
	
		/**
		 * Inserts `childNode` as a child of `parentNode` at the `index`.
		 *
		 * @param {DOMElement} parentNode Parent node in which to insert.
		 * @param {DOMElement} childNode Child node to insert.
		 * @param {number} index Index at which to insert the child.
		 * @internal
		 */
		var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
		  // We rely exclusively on `insertBefore(node, null)` instead of also using
		  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
		  // we are careful to use `null`.)
		  parentNode.insertBefore(childNode, referenceNode);
		});
	
		function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
		  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
		}
	
		function moveChild(parentNode, childNode, referenceNode) {
		  if (Array.isArray(childNode)) {
		    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
		  } else {
		    insertChildAt(parentNode, childNode, referenceNode);
		  }
		}
	
		function removeChild(parentNode, childNode) {
		  if (Array.isArray(childNode)) {
		    var closingComment = childNode[1];
		    childNode = childNode[0];
		    removeDelimitedText(parentNode, childNode, closingComment);
		    parentNode.removeChild(closingComment);
		  }
		  parentNode.removeChild(childNode);
		}
	
		function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
		  var node = openingComment;
		  while (true) {
		    var nextNode = node.nextSibling;
		    insertChildAt(parentNode, node, referenceNode);
		    if (node === closingComment) {
		      break;
		    }
		    node = nextNode;
		  }
		}
	
		function removeDelimitedText(parentNode, startNode, closingComment) {
		  while (true) {
		    var node = startNode.nextSibling;
		    if (node === closingComment) {
		      // The closing comment is removed by ReactMultiChild.
		      break;
		    } else {
		      parentNode.removeChild(node);
		    }
		  }
		}
	
		function replaceDelimitedText(openingComment, closingComment, stringText) {
		  var parentNode = openingComment.parentNode;
		  var nodeAfterComment = openingComment.nextSibling;
		  if (nodeAfterComment === closingComment) {
		    // There are no text nodes between the opening and closing comments; insert
		    // a new one if stringText isn't empty.
		    if (stringText) {
		      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
		    }
		  } else {
		    if (stringText) {
		      // Set the text content of the first node after the opening comment, and
		      // remove all following nodes up until the closing comment.
		      setTextContent(nodeAfterComment, stringText);
		      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
		    } else {
		      removeDelimitedText(parentNode, openingComment, closingComment);
		    }
		  }
	
		  if (process.env.NODE_ENV !== 'production') {
		    ReactInstrumentation.debugTool.onHostOperation({
		      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
		      type: 'replace text',
		      payload: stringText
		    });
		  }
		}
	
		var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
		if (process.env.NODE_ENV !== 'production') {
		  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
		    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
		    if (prevInstance._debugID !== 0) {
		      ReactInstrumentation.debugTool.onHostOperation({
		        instanceID: prevInstance._debugID,
		        type: 'replace with',
		        payload: markup.toString()
		      });
		    } else {
		      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
		      if (nextInstance._debugID !== 0) {
		        ReactInstrumentation.debugTool.onHostOperation({
		          instanceID: nextInstance._debugID,
		          type: 'mount',
		          payload: markup.toString()
		        });
		      }
		    }
		  };
		}
	
		/**
		 * Operations for updating with DOM children.
		 */
		var DOMChildrenOperations = {
	
		  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
		  replaceDelimitedText: replaceDelimitedText,
	
		  /**
		   * Updates a component's children by processing a series of updates. The
		   * update configurations are each expected to have a `parentNode` property.
		   *
		   * @param {array<object>} updates List of update configurations.
		   * @internal
		   */
		  processUpdates: function (parentNode, updates) {
		    if (process.env.NODE_ENV !== 'production') {
		      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
		    }
	
		    for (var k = 0; k < updates.length; k++) {
		      var update = updates[k];
		      switch (update.type) {
		        case 'INSERT_MARKUP':
		          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
		          if (process.env.NODE_ENV !== 'production') {
		            ReactInstrumentation.debugTool.onHostOperation({
		              instanceID: parentNodeDebugID,
		              type: 'insert child',
		              payload: { toIndex: update.toIndex, content: update.content.toString() }
		            });
		          }
		          break;
		        case 'MOVE_EXISTING':
		          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
		          if (process.env.NODE_ENV !== 'production') {
		            ReactInstrumentation.debugTool.onHostOperation({
		              instanceID: parentNodeDebugID,
		              type: 'move child',
		              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
		            });
		          }
		          break;
		        case 'SET_MARKUP':
		          setInnerHTML(parentNode, update.content);
		          if (process.env.NODE_ENV !== 'production') {
		            ReactInstrumentation.debugTool.onHostOperation({
		              instanceID: parentNodeDebugID,
		              type: 'replace children',
		              payload: update.content.toString()
		            });
		          }
		          break;
		        case 'TEXT_CONTENT':
		          setTextContent(parentNode, update.content);
		          if (process.env.NODE_ENV !== 'production') {
		            ReactInstrumentation.debugTool.onHostOperation({
		              instanceID: parentNodeDebugID,
		              type: 'replace text',
		              payload: update.content.toString()
		            });
		          }
		          break;
		        case 'REMOVE_NODE':
		          removeChild(parentNode, update.fromNode);
		          if (process.env.NODE_ENV !== 'production') {
		            ReactInstrumentation.debugTool.onHostOperation({
		              instanceID: parentNodeDebugID,
		              type: 'remove child',
		              payload: { fromIndex: update.fromIndex }
		            });
		          }
		          break;
		      }
		    }
		  }
	
		};
	
		module.exports = DOMChildrenOperations;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2015-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMNamespaces = __webpack_require__(60);
		var setInnerHTML = __webpack_require__(61);
	
		var createMicrosoftUnsafeLocalFunction = __webpack_require__(62);
		var setTextContent = __webpack_require__(63);
	
		var ELEMENT_NODE_TYPE = 1;
		var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
		/**
		 * In IE (8-11) and Edge, appending nodes with no children is dramatically
		 * faster than appending a full subtree, so we essentially queue up the
		 * .appendChild calls here and apply them so each node is added to its parent
		 * before any children are added.
		 *
		 * In other browsers, doing so is slower or neutral compared to the other order
		 * (in Firefox, twice as slow) so we only do this inversion in IE.
		 *
		 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
		 */
		var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
		function insertTreeChildren(tree) {
		  if (!enableLazy) {
		    return;
		  }
		  var node = tree.node;
		  var children = tree.children;
		  if (children.length) {
		    for (var i = 0; i < children.length; i++) {
		      insertTreeBefore(node, children[i], null);
		    }
		  } else if (tree.html != null) {
		    setInnerHTML(node, tree.html);
		  } else if (tree.text != null) {
		    setTextContent(node, tree.text);
		  }
		}
	
		var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
		  // DocumentFragments aren't actually part of the DOM after insertion so
		  // appending children won't update the DOM. We need to ensure the fragment
		  // is properly populated first, breaking out of our lazy approach for just
		  // this level. Also, some <object> plugins (like Flash Player) will read
		  // <param> nodes immediately upon insertion into the DOM, so <object>
		  // must also be populated prior to insertion into the DOM.
		  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
		    insertTreeChildren(tree);
		    parentNode.insertBefore(tree.node, referenceNode);
		  } else {
		    parentNode.insertBefore(tree.node, referenceNode);
		    insertTreeChildren(tree);
		  }
		});
	
		function replaceChildWithTree(oldNode, newTree) {
		  oldNode.parentNode.replaceChild(newTree.node, oldNode);
		  insertTreeChildren(newTree);
		}
	
		function queueChild(parentTree, childTree) {
		  if (enableLazy) {
		    parentTree.children.push(childTree);
		  } else {
		    parentTree.node.appendChild(childTree.node);
		  }
		}
	
		function queueHTML(tree, html) {
		  if (enableLazy) {
		    tree.html = html;
		  } else {
		    setInnerHTML(tree.node, html);
		  }
		}
	
		function queueText(tree, text) {
		  if (enableLazy) {
		    tree.text = text;
		  } else {
		    setTextContent(tree.node, text);
		  }
		}
	
		function toString() {
		  return this.node.nodeName;
		}
	
		function DOMLazyTree(node) {
		  return {
		    node: node,
		    children: [],
		    html: null,
		    text: null,
		    toString: toString
		  };
		}
	
		DOMLazyTree.insertTreeBefore = insertTreeBefore;
		DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
		DOMLazyTree.queueChild = queueChild;
		DOMLazyTree.queueHTML = queueHTML;
		DOMLazyTree.queueText = queueText;
	
		module.exports = DOMLazyTree;
	
	/***/ },
	/* 60 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMNamespaces = {
		  html: 'http://www.w3.org/1999/xhtml',
		  mathml: 'http://www.w3.org/1998/Math/MathML',
		  svg: 'http://www.w3.org/2000/svg'
		};
	
		module.exports = DOMNamespaces;
	
	/***/ },
	/* 61 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ExecutionEnvironment = __webpack_require__(22);
		var DOMNamespaces = __webpack_require__(60);
	
		var WHITESPACE_TEST = /^[ \r\n\t\f]/;
		var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
		var createMicrosoftUnsafeLocalFunction = __webpack_require__(62);
	
		// SVG temp container for IE lacking innerHTML
		var reusableSVGContainer;
	
		/**
		 * Set the innerHTML property of a node, ensuring that whitespace is preserved
		 * even in IE8.
		 *
		 * @param {DOMElement} node
		 * @param {string} html
		 * @internal
		 */
		var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
		  // IE does not have innerHTML for SVG nodes, so instead we inject the
		  // new markup in a temp node and then move the child nodes across into
		  // the target node
		  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
		    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
		    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
		    var svgNode = reusableSVGContainer.firstChild;
		    while (svgNode.firstChild) {
		      node.appendChild(svgNode.firstChild);
		    }
		  } else {
		    node.innerHTML = html;
		  }
		});
	
		if (ExecutionEnvironment.canUseDOM) {
		  // IE8: When updating a just created node with innerHTML only leading
		  // whitespace is removed. When updating an existing node with innerHTML
		  // whitespace in root TextNodes is also collapsed.
		  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
		  // Feature detection; only IE8 is known to behave improperly like this.
		  var testElement = document.createElement('div');
		  testElement.innerHTML = ' ';
		  if (testElement.innerHTML === '') {
		    setInnerHTML = function (node, html) {
		      // Magic theory: IE8 supposedly differentiates between added and updated
		      // nodes when processing innerHTML, innerHTML on updated nodes suffers
		      // from worse whitespace behavior. Re-adding a node like this triggers
		      // the initial and more favorable whitespace behavior.
		      // TODO: What to do on a detached node?
		      if (node.parentNode) {
		        node.parentNode.replaceChild(node, node);
		      }
	
		      // We also implement a workaround for non-visible tags disappearing into
		      // thin air on IE8, this only happens if there is no visible text
		      // in-front of the non-visible tags. Piggyback on the whitespace fix
		      // and simply check if any non-visible tags appear in the source.
		      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
		        // Recover leading whitespace by temporarily prepending any character.
		        // \uFEFF has the potential advantage of being zero-width/invisible.
		        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
		        // in hopes that this is preserved even if "\uFEFF" is transformed to
		        // the actual Unicode character (by Babel, for example).
		        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
		        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
		        // deleteData leaves an empty `TextNode` which offsets the index of all
		        // children. Definitely want to avoid this.
		        var textNode = node.firstChild;
		        if (textNode.data.length === 1) {
		          node.removeChild(textNode);
		        } else {
		          textNode.deleteData(0, 1);
		        }
		      } else {
		        node.innerHTML = html;
		      }
		    };
		  }
		  testElement = null;
		}
	
		module.exports = setInnerHTML;
	
	/***/ },
	/* 62 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		/* globals MSApp */
	
		'use strict';
	
		/**
		 * Create a function which has 'unsafe' privileges (required by windows8 apps)
		 */
	
		var createMicrosoftUnsafeLocalFunction = function (func) {
		  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
		    return function (arg0, arg1, arg2, arg3) {
		      MSApp.execUnsafeLocalFunction(function () {
		        return func(arg0, arg1, arg2, arg3);
		      });
		    };
		  } else {
		    return func;
		  }
		};
	
		module.exports = createMicrosoftUnsafeLocalFunction;
	
	/***/ },
	/* 63 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ExecutionEnvironment = __webpack_require__(22);
		var escapeTextContentForBrowser = __webpack_require__(64);
		var setInnerHTML = __webpack_require__(61);
	
		/**
		 * Set the textContent property of a node, ensuring that whitespace is preserved
		 * even in IE8. innerText is a poor substitute for textContent and, among many
		 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
		 * as it should.
		 *
		 * @param {DOMElement} node
		 * @param {string} text
		 * @internal
		 */
		var setTextContent = function (node, text) {
		  if (text) {
		    var firstChild = node.firstChild;
	
		    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
		      firstChild.nodeValue = text;
		      return;
		    }
		  }
		  node.textContent = text;
		};
	
		if (ExecutionEnvironment.canUseDOM) {
		  if (!('textContent' in document.documentElement)) {
		    setTextContent = function (node, text) {
		      if (node.nodeType === 3) {
		        node.nodeValue = text;
		        return;
		      }
		      setInnerHTML(node, escapeTextContentForBrowser(text));
		    };
		  }
		}
	
		module.exports = setTextContent;
	
	/***/ },
	/* 64 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2016-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * Based on the escape-html library, which is used under the MIT License below:
		 *
		 * Copyright (c) 2012-2013 TJ Holowaychuk
		 * Copyright (c) 2015 Andreas Lubbe
		 * Copyright (c) 2015 Tiancheng "Timothy" Gu
		 *
		 * Permission is hereby granted, free of charge, to any person obtaining
		 * a copy of this software and associated documentation files (the
		 * 'Software'), to deal in the Software without restriction, including
		 * without limitation the rights to use, copy, modify, merge, publish,
		 * distribute, sublicense, and/or sell copies of the Software, and to
		 * permit persons to whom the Software is furnished to do so, subject to
		 * the following conditions:
		 *
		 * The above copyright notice and this permission notice shall be
		 * included in all copies or substantial portions of the Software.
		 *
		 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
		 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
		 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
		 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
		 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
		 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
		 *
		 */
	
		'use strict';
	
		// code copied and modified from escape-html
		/**
		 * Module variables.
		 * @private
		 */
	
		var matchHtmlRegExp = /["'&<>]/;
	
		/**
		 * Escape special characters in the given string of html.
		 *
		 * @param  {string} string The string to escape for inserting into HTML
		 * @return {string}
		 * @public
		 */
	
		function escapeHtml(string) {
		  var str = '' + string;
		  var match = matchHtmlRegExp.exec(str);
	
		  if (!match) {
		    return str;
		  }
	
		  var escape;
		  var html = '';
		  var index = 0;
		  var lastIndex = 0;
	
		  for (index = match.index; index < str.length; index++) {
		    switch (str.charCodeAt(index)) {
		      case 34:
		        // "
		        escape = '&quot;';
		        break;
		      case 38:
		        // &
		        escape = '&amp;';
		        break;
		      case 39:
		        // '
		        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
		        break;
		      case 60:
		        // <
		        escape = '&lt;';
		        break;
		      case 62:
		        // >
		        escape = '&gt;';
		        break;
		      default:
		        continue;
		    }
	
		    if (lastIndex !== index) {
		      html += str.substring(lastIndex, index);
		    }
	
		    lastIndex = index + 1;
		    html += escape;
		  }
	
		  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
		}
		// end code copied and modified from escape-html
	
	
		/**
		 * Escapes text to prevent scripting attacks.
		 *
		 * @param {*} text Text value to escape.
		 * @return {string} An escaped string.
		 */
		function escapeTextContentForBrowser(text) {
		  if (typeof text === 'boolean' || typeof text === 'number') {
		    // this shortcircuit helps perf for types that we know will never have
		    // special characters, especially given that this function is used often
		    // for numeric dom ids.
		    return '' + text;
		  }
		  return escapeHtml(text);
		}
	
		module.exports = escapeTextContentForBrowser;
	
	/***/ },
	/* 65 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var DOMLazyTree = __webpack_require__(59);
		var ExecutionEnvironment = __webpack_require__(22);
	
		var createNodesFromMarkup = __webpack_require__(66);
		var emptyFunction = __webpack_require__(19);
		var invariant = __webpack_require__(8);
	
		var Danger = {
	
		  /**
		   * Replaces a node with a string of markup at its current position within its
		   * parent. The markup must render into a single root node.
		   *
		   * @param {DOMElement} oldChild Child node to replace.
		   * @param {string} markup Markup to render in place of the child node.
		   * @internal
		   */
		  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
		    !ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
		    !markup ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
		    !(oldChild.nodeName !== 'HTML') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
		    if (typeof markup === 'string') {
		      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
		      oldChild.parentNode.replaceChild(newChild, oldChild);
		    } else {
		      DOMLazyTree.replaceChildWithTree(oldChild, markup);
		    }
		  }
	
		};
	
		module.exports = Danger;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 66 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		/*eslint-disable fb-www/unsafe-html*/
	
		var ExecutionEnvironment = __webpack_require__(22);
	
		var createArrayFromMixed = __webpack_require__(67);
		var getMarkupWrap = __webpack_require__(68);
		var invariant = __webpack_require__(8);
	
		/**
		 * Dummy container used to render all markup.
		 */
		var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
		/**
		 * Pattern used by `getNodeName`.
		 */
		var nodeNamePattern = /^\s*<(\w+)/;
	
		/**
		 * Extracts the `nodeName` of the first element in a string of markup.
		 *
		 * @param {string} markup String of markup.
		 * @return {?string} Node name of the supplied markup.
		 */
		function getNodeName(markup) {
		  var nodeNameMatch = markup.match(nodeNamePattern);
		  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
		}
	
		/**
		 * Creates an array containing the nodes rendered from the supplied markup. The
		 * optionally supplied `handleScript` function will be invoked once for each
		 * <script> element that is rendered. If no `handleScript` function is supplied,
		 * an exception is thrown if any <script> elements are rendered.
		 *
		 * @param {string} markup A string of valid HTML markup.
		 * @param {?function} handleScript Invoked once for each rendered <script>.
		 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
		 */
		function createNodesFromMarkup(markup, handleScript) {
		  var node = dummyNode;
		  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
		  var nodeName = getNodeName(markup);
	
		  var wrap = nodeName && getMarkupWrap(nodeName);
		  if (wrap) {
		    node.innerHTML = wrap[1] + markup + wrap[2];
	
		    var wrapDepth = wrap[0];
		    while (wrapDepth--) {
		      node = node.lastChild;
		    }
		  } else {
		    node.innerHTML = markup;
		  }
	
		  var scripts = node.getElementsByTagName('script');
		  if (scripts.length) {
		    !handleScript ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
		    createArrayFromMixed(scripts).forEach(handleScript);
		  }
	
		  var nodes = Array.from(node.childNodes);
		  while (node.lastChild) {
		    node.removeChild(node.lastChild);
		  }
		  return nodes;
		}
	
		module.exports = createNodesFromMarkup;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 67 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		var invariant = __webpack_require__(8);
	
		/**
		 * Convert array-like objects to arrays.
		 *
		 * This API assumes the caller knows the contents of the data type. For less
		 * well defined inputs use createArrayFromMixed.
		 *
		 * @param {object|function|filelist} obj
		 * @return {array}
		 */
		function toArray(obj) {
		  var length = obj.length;
	
		  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
		  // in old versions of Safari).
		  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
		  !(typeof length === 'number') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
		  !(length === 0 || length - 1 in obj) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
		  !(typeof obj.callee !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
		  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
		  // without method will throw during the slice call and skip straight to the
		  // fallback.
		  if (obj.hasOwnProperty) {
		    try {
		      return Array.prototype.slice.call(obj);
		    } catch (e) {
		      // IE < 9 does not support Array#slice on collections objects
		    }
		  }
	
		  // Fall back to copying key by key. This assumes all keys have a value,
		  // so will not preserve sparsely populated inputs.
		  var ret = Array(length);
		  for (var ii = 0; ii < length; ii++) {
		    ret[ii] = obj[ii];
		  }
		  return ret;
		}
	
		/**
		 * Perform a heuristic test to determine if an object is "array-like".
		 *
		 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
		 *   Joshu replied: "Mu."
		 *
		 * This function determines if its argument has "array nature": it returns
		 * true if the argument is an actual array, an `arguments' object, or an
		 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
		 *
		 * It will return false for other array-like objects like Filelist.
		 *
		 * @param {*} obj
		 * @return {boolean}
		 */
		function hasArrayNature(obj) {
		  return (
		    // not null/false
		    !!obj && (
		    // arrays are objects, NodeLists are functions in Safari
		    typeof obj == 'object' || typeof obj == 'function') &&
		    // quacks like an array
		    'length' in obj &&
		    // not window
		    !('setInterval' in obj) &&
		    // no DOM node should be considered an array-like
		    // a 'select' element has 'length' and 'item' properties on IE8
		    typeof obj.nodeType != 'number' && (
		    // a real array
		    Array.isArray(obj) ||
		    // arguments
		    'callee' in obj ||
		    // HTMLCollection/NodeList
		    'item' in obj)
		  );
		}
	
		/**
		 * Ensure that the argument is an array by wrapping it in an array if it is not.
		 * Creates a copy of the argument if it is already an array.
		 *
		 * This is mostly useful idiomatically:
		 *
		 *   var createArrayFromMixed = require('createArrayFromMixed');
		 *
		 *   function takesOneOrMoreThings(things) {
		 *     things = createArrayFromMixed(things);
		 *     ...
		 *   }
		 *
		 * This allows you to treat `things' as an array, but accept scalars in the API.
		 *
		 * If you need to convert an array-like object, like `arguments`, into an array
		 * use toArray instead.
		 *
		 * @param {*} obj
		 * @return {array}
		 */
		function createArrayFromMixed(obj) {
		  if (!hasArrayNature(obj)) {
		    return [obj];
		  } else if (Array.isArray(obj)) {
		    return obj.slice();
		  } else {
		    return toArray(obj);
		  }
		}
	
		module.exports = createArrayFromMixed;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 68 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		/*eslint-disable fb-www/unsafe-html */
	
		var ExecutionEnvironment = __webpack_require__(22);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * Dummy container used to detect which wraps are necessary.
		 */
		var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
		/**
		 * Some browsers cannot use `innerHTML` to render certain elements standalone,
		 * so we wrap them, render the wrapped nodes, then extract the desired node.
		 *
		 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
		 */
	
		var shouldWrap = {};
	
		var selectWrap = [1, '<select multiple="true">', '</select>'];
		var tableWrap = [1, '<table>', '</table>'];
		var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
		var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
		var markupWrap = {
		  '*': [1, '?<div>', '</div>'],
	
		  'area': [1, '<map>', '</map>'],
		  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
		  'legend': [1, '<fieldset>', '</fieldset>'],
		  'param': [1, '<object>', '</object>'],
		  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
		  'optgroup': selectWrap,
		  'option': selectWrap,
	
		  'caption': tableWrap,
		  'colgroup': tableWrap,
		  'tbody': tableWrap,
		  'tfoot': tableWrap,
		  'thead': tableWrap,
	
		  'td': trWrap,
		  'th': trWrap
		};
	
		// Initialize the SVG elements since we know they'll always need to be wrapped
		// consistently. If they are created inside a <div> they will be initialized in
		// the wrong namespace (and will not display).
		var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
		svgElements.forEach(function (nodeName) {
		  markupWrap[nodeName] = svgWrap;
		  shouldWrap[nodeName] = true;
		});
	
		/**
		 * Gets the markup wrap configuration for the supplied `nodeName`.
		 *
		 * NOTE: This lazily detects which wraps are necessary for the current browser.
		 *
		 * @param {string} nodeName Lowercase `nodeName`.
		 * @return {?array} Markup wrap configuration, if applicable.
		 */
		function getMarkupWrap(nodeName) {
		  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
		  if (!markupWrap.hasOwnProperty(nodeName)) {
		    nodeName = '*';
		  }
		  if (!shouldWrap.hasOwnProperty(nodeName)) {
		    if (nodeName === '*') {
		      dummyNode.innerHTML = '<link />';
		    } else {
		      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
		    }
		    shouldWrap[nodeName] = !dummyNode.firstChild;
		  }
		  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
		}
	
		module.exports = getMarkupWrap;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 69 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMChildrenOperations = __webpack_require__(58);
		var ReactDOMComponentTree = __webpack_require__(5);
	
		/**
		 * Operations used to process updates to DOM nodes.
		 */
		var ReactDOMIDOperations = {
	
		  /**
		   * Updates a component's children by processing a series of updates.
		   *
		   * @param {array<object>} updates List of update configurations.
		   * @internal
		   */
		  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
		    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
		    DOMChildrenOperations.processUpdates(node, updates);
		  }
		};
	
		module.exports = ReactDOMIDOperations;
	
	/***/ },
	/* 70 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		/* global hasOwnProperty:true */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6),
		    _assign = __webpack_require__(24);
	
		var AutoFocusUtils = __webpack_require__(71);
		var CSSPropertyOperations = __webpack_require__(73);
		var DOMLazyTree = __webpack_require__(59);
		var DOMNamespaces = __webpack_require__(60);
		var DOMProperty = __webpack_require__(7);
		var DOMPropertyOperations = __webpack_require__(81);
		var EventPluginHub = __webpack_require__(14);
		var EventPluginRegistry = __webpack_require__(15);
		var ReactBrowserEventEmitter = __webpack_require__(83);
		var ReactDOMComponentFlags = __webpack_require__(9);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactDOMInput = __webpack_require__(86);
		var ReactDOMOption = __webpack_require__(111);
		var ReactDOMSelect = __webpack_require__(112);
		var ReactDOMTextarea = __webpack_require__(113);
		var ReactInstrumentation = __webpack_require__(37);
		var ReactMultiChild = __webpack_require__(114);
		var ReactServerRenderingTransaction = __webpack_require__(133);
	
		var emptyFunction = __webpack_require__(19);
		var escapeTextContentForBrowser = __webpack_require__(64);
		var invariant = __webpack_require__(8);
		var isEventSupported = __webpack_require__(48);
		var shallowEqual = __webpack_require__(123);
		var validateDOMNesting = __webpack_require__(136);
		var warning = __webpack_require__(18);
	
		var Flags = ReactDOMComponentFlags;
		var deleteListener = EventPluginHub.deleteListener;
		var getNode = ReactDOMComponentTree.getNodeFromInstance;
		var listenTo = ReactBrowserEventEmitter.listenTo;
		var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
		// For quickly matching children type, to test if can be treated as content.
		var CONTENT_TYPES = { 'string': true, 'number': true };
	
		var STYLE = 'style';
		var HTML = '__html';
		var RESERVED_PROPS = {
		  children: null,
		  dangerouslySetInnerHTML: null,
		  suppressContentEditableWarning: null
		};
	
		// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
		var DOC_FRAGMENT_TYPE = 11;
	
		function getDeclarationErrorAddendum(internalInstance) {
		  if (internalInstance) {
		    var owner = internalInstance._currentElement._owner || null;
		    if (owner) {
		      var name = owner.getName();
		      if (name) {
		        return ' This DOM node was rendered by `' + name + '`.';
		      }
		    }
		  }
		  return '';
		}
	
		function friendlyStringify(obj) {
		  if (typeof obj === 'object') {
		    if (Array.isArray(obj)) {
		      return '[' + obj.map(friendlyStringify).join(', ') + ']';
		    } else {
		      var pairs = [];
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) {
		          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
		          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
		        }
		      }
		      return '{' + pairs.join(', ') + '}';
		    }
		  } else if (typeof obj === 'string') {
		    return JSON.stringify(obj);
		  } else if (typeof obj === 'function') {
		    return '[function object]';
		  }
		  // Differs from JSON.stringify in that undefined because undefined and that
		  // inf and nan don't become null
		  return String(obj);
		}
	
		var styleMutationWarning = {};
	
		function checkAndWarnForMutatedStyle(style1, style2, component) {
		  if (style1 == null || style2 == null) {
		    return;
		  }
		  if (shallowEqual(style1, style2)) {
		    return;
		  }
	
		  var componentName = component._tag;
		  var owner = component._currentElement._owner;
		  var ownerName;
		  if (owner) {
		    ownerName = owner.getName();
		  }
	
		  var hash = ownerName + '|' + componentName;
	
		  if (styleMutationWarning.hasOwnProperty(hash)) {
		    return;
		  }
	
		  styleMutationWarning[hash] = true;
	
		  process.env.NODE_ENV !== 'production' ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
		}
	
		/**
		 * @param {object} component
		 * @param {?object} props
		 */
		function assertValidProps(component, props) {
		  if (!props) {
		    return;
		  }
		  // Note the use of `==` which checks for null or undefined.
		  if (voidElementTags[component._tag]) {
		    !(props.children == null && props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
		  }
		  if (props.dangerouslySetInnerHTML != null) {
		    !(props.children == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
		    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
		  }
		  if (process.env.NODE_ENV !== 'production') {
		    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
		    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
		    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
		  }
		  !(props.style == null || typeof props.style === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
		}
	
		function enqueuePutListener(inst, registrationName, listener, transaction) {
		  if (transaction instanceof ReactServerRenderingTransaction) {
		    return;
		  }
		  if (process.env.NODE_ENV !== 'production') {
		    // IE8 has no API for event capturing and the `onScroll` event doesn't
		    // bubble.
		    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
		  }
		  var containerInfo = inst._hostContainerInfo;
		  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
		  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
		  listenTo(registrationName, doc);
		  transaction.getReactMountReady().enqueue(putListener, {
		    inst: inst,
		    registrationName: registrationName,
		    listener: listener
		  });
		}
	
		function putListener() {
		  var listenerToPut = this;
		  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
		}
	
		function inputPostMount() {
		  var inst = this;
		  ReactDOMInput.postMountWrapper(inst);
		}
	
		function textareaPostMount() {
		  var inst = this;
		  ReactDOMTextarea.postMountWrapper(inst);
		}
	
		function optionPostMount() {
		  var inst = this;
		  ReactDOMOption.postMountWrapper(inst);
		}
	
		var setAndValidateContentChildDev = emptyFunction;
		if (process.env.NODE_ENV !== 'production') {
		  setAndValidateContentChildDev = function (content) {
		    var hasExistingContent = this._contentDebugID != null;
		    var debugID = this._debugID;
		    // This ID represents the inlined child that has no backing instance:
		    var contentDebugID = -debugID;
	
		    if (content == null) {
		      if (hasExistingContent) {
		        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
		      }
		      this._contentDebugID = null;
		      return;
		    }
	
		    validateDOMNesting(null, String(content), this, this._ancestorInfo);
		    this._contentDebugID = contentDebugID;
		    if (hasExistingContent) {
		      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
		      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
		    } else {
		      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
		      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
		      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
		    }
		  };
		}
	
		// There are so many media events, it makes sense to just
		// maintain a list rather than create a `trapBubbledEvent` for each
		var mediaEvents = {
		  topAbort: 'abort',
		  topCanPlay: 'canplay',
		  topCanPlayThrough: 'canplaythrough',
		  topDurationChange: 'durationchange',
		  topEmptied: 'emptied',
		  topEncrypted: 'encrypted',
		  topEnded: 'ended',
		  topError: 'error',
		  topLoadedData: 'loadeddata',
		  topLoadedMetadata: 'loadedmetadata',
		  topLoadStart: 'loadstart',
		  topPause: 'pause',
		  topPlay: 'play',
		  topPlaying: 'playing',
		  topProgress: 'progress',
		  topRateChange: 'ratechange',
		  topSeeked: 'seeked',
		  topSeeking: 'seeking',
		  topStalled: 'stalled',
		  topSuspend: 'suspend',
		  topTimeUpdate: 'timeupdate',
		  topVolumeChange: 'volumechange',
		  topWaiting: 'waiting'
		};
	
		function trapBubbledEventsLocal() {
		  var inst = this;
		  // If a component renders to null or if another component fatals and causes
		  // the state of the tree to be corrupted, `node` here can be null.
		  !inst._rootNodeID ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
		  var node = getNode(inst);
		  !node ? process.env.NODE_ENV !== 'production' ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
		  switch (inst._tag) {
		    case 'iframe':
		    case 'object':
		      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
		      break;
		    case 'video':
		    case 'audio':
	
		      inst._wrapperState.listeners = [];
		      // Create listener for each media event
		      for (var event in mediaEvents) {
		        if (mediaEvents.hasOwnProperty(event)) {
		          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
		        }
		      }
		      break;
		    case 'source':
		      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
		      break;
		    case 'img':
		      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
		      break;
		    case 'form':
		      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
		      break;
		    case 'input':
		    case 'select':
		    case 'textarea':
		      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
		      break;
		  }
		}
	
		function postUpdateSelectWrapper() {
		  ReactDOMSelect.postUpdateWrapper(this);
		}
	
		// For HTML, certain tags should omit their close tag. We keep a whitelist for
		// those special-case tags.
	
		var omittedCloseTags = {
		  'area': true,
		  'base': true,
		  'br': true,
		  'col': true,
		  'embed': true,
		  'hr': true,
		  'img': true,
		  'input': true,
		  'keygen': true,
		  'link': true,
		  'meta': true,
		  'param': true,
		  'source': true,
		  'track': true,
		  'wbr': true
		};
	
		var newlineEatingTags = {
		  'listing': true,
		  'pre': true,
		  'textarea': true
		};
	
		// For HTML, certain tags cannot have children. This has the same purpose as
		// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
		var voidElementTags = _assign({
		  'menuitem': true
		}, omittedCloseTags);
	
		// We accept any tag to be rendered but since this gets injected into arbitrary
		// HTML, we want to make sure that it's a safe tag.
		// http://www.w3.org/TR/REC-xml/#NT-Name
	
		var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
		var validatedTagCache = {};
		var hasOwnProperty = {}.hasOwnProperty;
	
		function validateDangerousTag(tag) {
		  if (!hasOwnProperty.call(validatedTagCache, tag)) {
		    !VALID_TAG_REGEX.test(tag) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
		    validatedTagCache[tag] = true;
		  }
		}
	
		function isCustomComponent(tagName, props) {
		  return tagName.indexOf('-') >= 0 || props.is != null;
		}
	
		var globalIdCounter = 1;
	
		/**
		 * Creates a new React class that is idempotent and capable of containing other
		 * React components. It accepts event listeners and DOM properties that are
		 * valid according to `DOMProperty`.
		 *
		 *  - Event listeners: `onClick`, `onMouseDown`, etc.
		 *  - DOM properties: `className`, `name`, `title`, etc.
		 *
		 * The `style` property functions differently from the DOM API. It accepts an
		 * object mapping of style properties to values.
		 *
		 * @constructor ReactDOMComponent
		 * @extends ReactMultiChild
		 */
		function ReactDOMComponent(element) {
		  var tag = element.type;
		  validateDangerousTag(tag);
		  this._currentElement = element;
		  this._tag = tag.toLowerCase();
		  this._namespaceURI = null;
		  this._renderedChildren = null;
		  this._previousStyle = null;
		  this._previousStyleCopy = null;
		  this._hostNode = null;
		  this._hostParent = null;
		  this._rootNodeID = 0;
		  this._domID = 0;
		  this._hostContainerInfo = null;
		  this._wrapperState = null;
		  this._topLevelWrapper = null;
		  this._flags = 0;
		  if (process.env.NODE_ENV !== 'production') {
		    this._ancestorInfo = null;
		    setAndValidateContentChildDev.call(this, null);
		  }
		}
	
		ReactDOMComponent.displayName = 'ReactDOMComponent';
	
		ReactDOMComponent.Mixin = {
	
		  /**
		   * Generates root tag markup then recurses. This method has side effects and
		   * is not idempotent.
		   *
		   * @internal
		   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
		   * @param {?ReactDOMComponent} the parent component instance
		   * @param {?object} info about the host container
		   * @param {object} context
		   * @return {string} The computed markup.
		   */
		  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
		    this._rootNodeID = globalIdCounter++;
		    this._domID = hostContainerInfo._idCounter++;
		    this._hostParent = hostParent;
		    this._hostContainerInfo = hostContainerInfo;
	
		    var props = this._currentElement.props;
	
		    switch (this._tag) {
		      case 'audio':
		      case 'form':
		      case 'iframe':
		      case 'img':
		      case 'link':
		      case 'object':
		      case 'source':
		      case 'video':
		        this._wrapperState = {
		          listeners: null
		        };
		        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
		        break;
		      case 'input':
		        ReactDOMInput.mountWrapper(this, props, hostParent);
		        props = ReactDOMInput.getHostProps(this, props);
		        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
		        break;
		      case 'option':
		        ReactDOMOption.mountWrapper(this, props, hostParent);
		        props = ReactDOMOption.getHostProps(this, props);
		        break;
		      case 'select':
		        ReactDOMSelect.mountWrapper(this, props, hostParent);
		        props = ReactDOMSelect.getHostProps(this, props);
		        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
		        break;
		      case 'textarea':
		        ReactDOMTextarea.mountWrapper(this, props, hostParent);
		        props = ReactDOMTextarea.getHostProps(this, props);
		        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
		        break;
		    }
	
		    assertValidProps(this, props);
	
		    // We create tags in the namespace of their parent container, except HTML
		    // tags get no namespace.
		    var namespaceURI;
		    var parentTag;
		    if (hostParent != null) {
		      namespaceURI = hostParent._namespaceURI;
		      parentTag = hostParent._tag;
		    } else if (hostContainerInfo._tag) {
		      namespaceURI = hostContainerInfo._namespaceURI;
		      parentTag = hostContainerInfo._tag;
		    }
		    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
		      namespaceURI = DOMNamespaces.html;
		    }
		    if (namespaceURI === DOMNamespaces.html) {
		      if (this._tag === 'svg') {
		        namespaceURI = DOMNamespaces.svg;
		      } else if (this._tag === 'math') {
		        namespaceURI = DOMNamespaces.mathml;
		      }
		    }
		    this._namespaceURI = namespaceURI;
	
		    if (process.env.NODE_ENV !== 'production') {
		      var parentInfo;
		      if (hostParent != null) {
		        parentInfo = hostParent._ancestorInfo;
		      } else if (hostContainerInfo._tag) {
		        parentInfo = hostContainerInfo._ancestorInfo;
		      }
		      if (parentInfo) {
		        // parentInfo should always be present except for the top-level
		        // component when server rendering
		        validateDOMNesting(this._tag, null, this, parentInfo);
		      }
		      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
		    }
	
		    var mountImage;
		    if (transaction.useCreateElement) {
		      var ownerDocument = hostContainerInfo._ownerDocument;
		      var el;
		      if (namespaceURI === DOMNamespaces.html) {
		        if (this._tag === 'script') {
		          // Create the script via .innerHTML so its "parser-inserted" flag is
		          // set to true and it does not execute
		          var div = ownerDocument.createElement('div');
		          var type = this._currentElement.type;
		          div.innerHTML = '<' + type + '></' + type + '>';
		          el = div.removeChild(div.firstChild);
		        } else if (props.is) {
		          el = ownerDocument.createElement(this._currentElement.type, props.is);
		        } else {
		          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
		          // See discussion in https://github.com/facebook/react/pull/6896
		          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
		          el = ownerDocument.createElement(this._currentElement.type);
		        }
		      } else {
		        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
		      }
		      ReactDOMComponentTree.precacheNode(this, el);
		      this._flags |= Flags.hasCachedChildNodes;
		      if (!this._hostParent) {
		        DOMPropertyOperations.setAttributeForRoot(el);
		      }
		      this._updateDOMProperties(null, props, transaction);
		      var lazyTree = DOMLazyTree(el);
		      this._createInitialChildren(transaction, props, context, lazyTree);
		      mountImage = lazyTree;
		    } else {
		      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
		      var tagContent = this._createContentMarkup(transaction, props, context);
		      if (!tagContent && omittedCloseTags[this._tag]) {
		        mountImage = tagOpen + '/>';
		      } else {
		        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
		      }
		    }
	
		    switch (this._tag) {
		      case 'input':
		        transaction.getReactMountReady().enqueue(inputPostMount, this);
		        if (props.autoFocus) {
		          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
		        }
		        break;
		      case 'textarea':
		        transaction.getReactMountReady().enqueue(textareaPostMount, this);
		        if (props.autoFocus) {
		          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
		        }
		        break;
		      case 'select':
		        if (props.autoFocus) {
		          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
		        }
		        break;
		      case 'button':
		        if (props.autoFocus) {
		          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
		        }
		        break;
		      case 'option':
		        transaction.getReactMountReady().enqueue(optionPostMount, this);
		        break;
		    }
	
		    return mountImage;
		  },
	
		  /**
		   * Creates markup for the open tag and all attributes.
		   *
		   * This method has side effects because events get registered.
		   *
		   * Iterating over object properties is faster than iterating over arrays.
		   * @see http://jsperf.com/obj-vs-arr-iteration
		   *
		   * @private
		   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
		   * @param {object} props
		   * @return {string} Markup of opening tag.
		   */
		  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
		    var ret = '<' + this._currentElement.type;
	
		    for (var propKey in props) {
		      if (!props.hasOwnProperty(propKey)) {
		        continue;
		      }
		      var propValue = props[propKey];
		      if (propValue == null) {
		        continue;
		      }
		      if (registrationNameModules.hasOwnProperty(propKey)) {
		        if (propValue) {
		          enqueuePutListener(this, propKey, propValue, transaction);
		        }
		      } else {
		        if (propKey === STYLE) {
		          if (propValue) {
		            if (process.env.NODE_ENV !== 'production') {
		              // See `_updateDOMProperties`. style block
		              this._previousStyle = propValue;
		            }
		            propValue = this._previousStyleCopy = _assign({}, props.style);
		          }
		          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
		        }
		        var markup = null;
		        if (this._tag != null && isCustomComponent(this._tag, props)) {
		          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
		            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
		          }
		        } else {
		          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
		        }
		        if (markup) {
		          ret += ' ' + markup;
		        }
		      }
		    }
	
		    // For static pages, no need to put React ID and checksum. Saves lots of
		    // bytes.
		    if (transaction.renderToStaticMarkup) {
		      return ret;
		    }
	
		    if (!this._hostParent) {
		      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
		    }
		    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
		    return ret;
		  },
	
		  /**
		   * Creates markup for the content between the tags.
		   *
		   * @private
		   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
		   * @param {object} props
		   * @param {object} context
		   * @return {string} Content markup.
		   */
		  _createContentMarkup: function (transaction, props, context) {
		    var ret = '';
	
		    // Intentional use of != to avoid catching zero/false.
		    var innerHTML = props.dangerouslySetInnerHTML;
		    if (innerHTML != null) {
		      if (innerHTML.__html != null) {
		        ret = innerHTML.__html;
		      }
		    } else {
		      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
		      var childrenToUse = contentToUse != null ? null : props.children;
		      if (contentToUse != null) {
		        // TODO: Validate that text is allowed as a child of this node
		        ret = escapeTextContentForBrowser(contentToUse);
		        if (process.env.NODE_ENV !== 'production') {
		          setAndValidateContentChildDev.call(this, contentToUse);
		        }
		      } else if (childrenToUse != null) {
		        var mountImages = this.mountChildren(childrenToUse, transaction, context);
		        ret = mountImages.join('');
		      }
		    }
		    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
		      // text/html ignores the first character in these tags if it's a newline
		      // Prefer to break application/xml over text/html (for now) by adding
		      // a newline specifically to get eaten by the parser. (Alternately for
		      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
		      // \r is normalized out by HTMLTextAreaElement#value.)
		      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
		      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
		      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
		      // See: Parsing of "textarea" "listing" and "pre" elements
		      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
		      return '\n' + ret;
		    } else {
		      return ret;
		    }
		  },
	
		  _createInitialChildren: function (transaction, props, context, lazyTree) {
		    // Intentional use of != to avoid catching zero/false.
		    var innerHTML = props.dangerouslySetInnerHTML;
		    if (innerHTML != null) {
		      if (innerHTML.__html != null) {
		        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
		      }
		    } else {
		      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
		      var childrenToUse = contentToUse != null ? null : props.children;
		      // TODO: Validate that text is allowed as a child of this node
		      if (contentToUse != null) {
		        // Avoid setting textContent when the text is empty. In IE11 setting
		        // textContent on a text area will cause the placeholder to not
		        // show within the textarea until it has been focused and blurred again.
		        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
		        if (contentToUse !== '') {
		          if (process.env.NODE_ENV !== 'production') {
		            setAndValidateContentChildDev.call(this, contentToUse);
		          }
		          DOMLazyTree.queueText(lazyTree, contentToUse);
		        }
		      } else if (childrenToUse != null) {
		        var mountImages = this.mountChildren(childrenToUse, transaction, context);
		        for (var i = 0; i < mountImages.length; i++) {
		          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
		        }
		      }
		    }
		  },
	
		  /**
		   * Receives a next element and updates the component.
		   *
		   * @internal
		   * @param {ReactElement} nextElement
		   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
		   * @param {object} context
		   */
		  receiveComponent: function (nextElement, transaction, context) {
		    var prevElement = this._currentElement;
		    this._currentElement = nextElement;
		    this.updateComponent(transaction, prevElement, nextElement, context);
		  },
	
		  /**
		   * Updates a DOM component after it has already been allocated and
		   * attached to the DOM. Reconciles the root DOM node, then recurses.
		   *
		   * @param {ReactReconcileTransaction} transaction
		   * @param {ReactElement} prevElement
		   * @param {ReactElement} nextElement
		   * @internal
		   * @overridable
		   */
		  updateComponent: function (transaction, prevElement, nextElement, context) {
		    var lastProps = prevElement.props;
		    var nextProps = this._currentElement.props;
	
		    switch (this._tag) {
		      case 'input':
		        lastProps = ReactDOMInput.getHostProps(this, lastProps);
		        nextProps = ReactDOMInput.getHostProps(this, nextProps);
		        break;
		      case 'option':
		        lastProps = ReactDOMOption.getHostProps(this, lastProps);
		        nextProps = ReactDOMOption.getHostProps(this, nextProps);
		        break;
		      case 'select':
		        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
		        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
		        break;
		      case 'textarea':
		        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
		        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
		        break;
		    }
	
		    assertValidProps(this, nextProps);
		    this._updateDOMProperties(lastProps, nextProps, transaction);
		    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
		    switch (this._tag) {
		      case 'input':
		        // Update the wrapper around inputs *after* updating props. This has to
		        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
		        // raise warnings and prevent the new value from being assigned.
		        ReactDOMInput.updateWrapper(this);
		        break;
		      case 'textarea':
		        ReactDOMTextarea.updateWrapper(this);
		        break;
		      case 'select':
		        // <select> value update needs to occur after <option> children
		        // reconciliation
		        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
		        break;
		    }
		  },
	
		  /**
		   * Reconciles the properties by detecting differences in property values and
		   * updating the DOM as necessary. This function is probably the single most
		   * critical path for performance optimization.
		   *
		   * TODO: Benchmark whether checking for changed values in memory actually
		   *       improves performance (especially statically positioned elements).
		   * TODO: Benchmark the effects of putting this at the top since 99% of props
		   *       do not change for a given reconciliation.
		   * TODO: Benchmark areas that can be improved with caching.
		   *
		   * @private
		   * @param {object} lastProps
		   * @param {object} nextProps
		   * @param {?DOMElement} node
		   */
		  _updateDOMProperties: function (lastProps, nextProps, transaction) {
		    var propKey;
		    var styleName;
		    var styleUpdates;
		    for (propKey in lastProps) {
		      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
		        continue;
		      }
		      if (propKey === STYLE) {
		        var lastStyle = this._previousStyleCopy;
		        for (styleName in lastStyle) {
		          if (lastStyle.hasOwnProperty(styleName)) {
		            styleUpdates = styleUpdates || {};
		            styleUpdates[styleName] = '';
		          }
		        }
		        this._previousStyleCopy = null;
		      } else if (registrationNameModules.hasOwnProperty(propKey)) {
		        if (lastProps[propKey]) {
		          // Only call deleteListener if there was a listener previously or
		          // else willDeleteListener gets called when there wasn't actually a
		          // listener (e.g., onClick={null})
		          deleteListener(this, propKey);
		        }
		      } else if (isCustomComponent(this._tag, lastProps)) {
		        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
		          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
		        }
		      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
		        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
		      }
		    }
		    for (propKey in nextProps) {
		      var nextProp = nextProps[propKey];
		      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
		      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
		        continue;
		      }
		      if (propKey === STYLE) {
		        if (nextProp) {
		          if (process.env.NODE_ENV !== 'production') {
		            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
		            this._previousStyle = nextProp;
		          }
		          nextProp = this._previousStyleCopy = _assign({}, nextProp);
		        } else {
		          this._previousStyleCopy = null;
		        }
		        if (lastProp) {
		          // Unset styles on `lastProp` but not on `nextProp`.
		          for (styleName in lastProp) {
		            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
		              styleUpdates = styleUpdates || {};
		              styleUpdates[styleName] = '';
		            }
		          }
		          // Update styles that changed since `lastProp`.
		          for (styleName in nextProp) {
		            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
		              styleUpdates = styleUpdates || {};
		              styleUpdates[styleName] = nextProp[styleName];
		            }
		          }
		        } else {
		          // Relies on `updateStylesByID` not mutating `styleUpdates`.
		          styleUpdates = nextProp;
		        }
		      } else if (registrationNameModules.hasOwnProperty(propKey)) {
		        if (nextProp) {
		          enqueuePutListener(this, propKey, nextProp, transaction);
		        } else if (lastProp) {
		          deleteListener(this, propKey);
		        }
		      } else if (isCustomComponent(this._tag, nextProps)) {
		        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
		          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
		        }
		      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
		        var node = getNode(this);
		        // If we're updating to null or undefined, we should remove the property
		        // from the DOM node instead of inadvertently setting to a string. This
		        // brings us in line with the same behavior we have on initial render.
		        if (nextProp != null) {
		          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
		        } else {
		          DOMPropertyOperations.deleteValueForProperty(node, propKey);
		        }
		      }
		    }
		    if (styleUpdates) {
		      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
		    }
		  },
	
		  /**
		   * Reconciles the children with the various properties that affect the
		   * children content.
		   *
		   * @param {object} lastProps
		   * @param {object} nextProps
		   * @param {ReactReconcileTransaction} transaction
		   * @param {object} context
		   */
		  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
		    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
		    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
		    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
		    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
		    // Note the use of `!=` which checks for null or undefined.
		    var lastChildren = lastContent != null ? null : lastProps.children;
		    var nextChildren = nextContent != null ? null : nextProps.children;
	
		    // If we're switching from children to content/html or vice versa, remove
		    // the old content
		    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
		    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
		    if (lastChildren != null && nextChildren == null) {
		      this.updateChildren(null, transaction, context);
		    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
		      this.updateTextContent('');
		      if (process.env.NODE_ENV !== 'production') {
		        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
		      }
		    }
	
		    if (nextContent != null) {
		      if (lastContent !== nextContent) {
		        this.updateTextContent('' + nextContent);
		        if (process.env.NODE_ENV !== 'production') {
		          setAndValidateContentChildDev.call(this, nextContent);
		        }
		      }
		    } else if (nextHtml != null) {
		      if (lastHtml !== nextHtml) {
		        this.updateMarkup('' + nextHtml);
		      }
		      if (process.env.NODE_ENV !== 'production') {
		        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
		      }
		    } else if (nextChildren != null) {
		      if (process.env.NODE_ENV !== 'production') {
		        setAndValidateContentChildDev.call(this, null);
		      }
	
		      this.updateChildren(nextChildren, transaction, context);
		    }
		  },
	
		  getHostNode: function () {
		    return getNode(this);
		  },
	
		  /**
		   * Destroys all event registrations for this instance. Does not remove from
		   * the DOM. That must be done by the parent.
		   *
		   * @internal
		   */
		  unmountComponent: function (safely) {
		    switch (this._tag) {
		      case 'audio':
		      case 'form':
		      case 'iframe':
		      case 'img':
		      case 'link':
		      case 'object':
		      case 'source':
		      case 'video':
		        var listeners = this._wrapperState.listeners;
		        if (listeners) {
		          for (var i = 0; i < listeners.length; i++) {
		            listeners[i].remove();
		          }
		        }
		        break;
		      case 'html':
		      case 'head':
		      case 'body':
		        /**
		         * Components like <html> <head> and <body> can't be removed or added
		         * easily in a cross-browser way, however it's valuable to be able to
		         * take advantage of React's reconciliation for styling and <title>
		         * management. So we just document it and throw in dangerous cases.
		         */
		         true ? process.env.NODE_ENV !== 'production' ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
		        break;
		    }
	
		    this.unmountChildren(safely);
		    ReactDOMComponentTree.uncacheNode(this);
		    EventPluginHub.deleteAllListeners(this);
		    this._rootNodeID = 0;
		    this._domID = 0;
		    this._wrapperState = null;
	
		    if (process.env.NODE_ENV !== 'production') {
		      setAndValidateContentChildDev.call(this, null);
		    }
		  },
	
		  getPublicInstance: function () {
		    return getNode(this);
		  }
	
		};
	
		_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
		module.exports = ReactDOMComponent;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 71 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactDOMComponentTree = __webpack_require__(5);
	
		var focusNode = __webpack_require__(72);
	
		var AutoFocusUtils = {
		  focusDOMComponent: function () {
		    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
		  }
		};
	
		module.exports = AutoFocusUtils;
	
	/***/ },
	/* 72 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * @param {DOMElement} node input/textarea to focus
		 */
	
		function focusNode(node) {
		  // IE8 can throw "Can't move focus to the control because it is invisible,
		  // not enabled, or of a type that does not accept the focus." for all kinds of
		  // reasons that are too expensive and fragile to test.
		  try {
		    node.focus();
		  } catch (e) {}
		}
	
		module.exports = focusNode;
	
	/***/ },
	/* 73 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var CSSProperty = __webpack_require__(74);
		var ExecutionEnvironment = __webpack_require__(22);
		var ReactInstrumentation = __webpack_require__(37);
	
		var camelizeStyleName = __webpack_require__(75);
		var dangerousStyleValue = __webpack_require__(77);
		var hyphenateStyleName = __webpack_require__(78);
		var memoizeStringOnly = __webpack_require__(80);
		var warning = __webpack_require__(18);
	
		var processStyleName = memoizeStringOnly(function (styleName) {
		  return hyphenateStyleName(styleName);
		});
	
		var hasShorthandPropertyBug = false;
		var styleFloatAccessor = 'cssFloat';
		if (ExecutionEnvironment.canUseDOM) {
		  var tempStyle = document.createElement('div').style;
		  try {
		    // IE8 throws "Invalid argument." if resetting shorthand style properties.
		    tempStyle.font = '';
		  } catch (e) {
		    hasShorthandPropertyBug = true;
		  }
		  // IE8 only supports accessing cssFloat (standard) as styleFloat
		  if (document.documentElement.style.cssFloat === undefined) {
		    styleFloatAccessor = 'styleFloat';
		  }
		}
	
		if (process.env.NODE_ENV !== 'production') {
		  // 'msTransform' is correct, but the other prefixes should be capitalized
		  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
		  // style values shouldn't contain a semicolon
		  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
		  var warnedStyleNames = {};
		  var warnedStyleValues = {};
		  var warnedForNaNValue = false;
	
		  var warnHyphenatedStyleName = function (name, owner) {
		    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
		      return;
		    }
	
		    warnedStyleNames[name] = true;
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
		  };
	
		  var warnBadVendoredStyleName = function (name, owner) {
		    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
		      return;
		    }
	
		    warnedStyleNames[name] = true;
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
		  };
	
		  var warnStyleValueWithSemicolon = function (name, value, owner) {
		    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
		      return;
		    }
	
		    warnedStyleValues[value] = true;
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
		  };
	
		  var warnStyleValueIsNaN = function (name, value, owner) {
		    if (warnedForNaNValue) {
		      return;
		    }
	
		    warnedForNaNValue = true;
		    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
		  };
	
		  var checkRenderMessage = function (owner) {
		    if (owner) {
		      var name = owner.getName();
		      if (name) {
		        return ' Check the render method of `' + name + '`.';
		      }
		    }
		    return '';
		  };
	
		  /**
		   * @param {string} name
		   * @param {*} value
		   * @param {ReactDOMComponent} component
		   */
		  var warnValidStyle = function (name, value, component) {
		    var owner;
		    if (component) {
		      owner = component._currentElement._owner;
		    }
		    if (name.indexOf('-') > -1) {
		      warnHyphenatedStyleName(name, owner);
		    } else if (badVendoredStyleNamePattern.test(name)) {
		      warnBadVendoredStyleName(name, owner);
		    } else if (badStyleValueWithSemicolonPattern.test(value)) {
		      warnStyleValueWithSemicolon(name, value, owner);
		    }
	
		    if (typeof value === 'number' && isNaN(value)) {
		      warnStyleValueIsNaN(name, value, owner);
		    }
		  };
		}
	
		/**
		 * Operations for dealing with CSS properties.
		 */
		var CSSPropertyOperations = {
	
		  /**
		   * Serializes a mapping of style properties for use as inline styles:
		   *
		   *   > createMarkupForStyles({width: '200px', height: 0})
		   *   "width:200px;height:0;"
		   *
		   * Undefined values are ignored so that declarative programming is easier.
		   * The result should be HTML-escaped before insertion into the DOM.
		   *
		   * @param {object} styles
		   * @param {ReactDOMComponent} component
		   * @return {?string}
		   */
		  createMarkupForStyles: function (styles, component) {
		    var serialized = '';
		    for (var styleName in styles) {
		      if (!styles.hasOwnProperty(styleName)) {
		        continue;
		      }
		      var styleValue = styles[styleName];
		      if (process.env.NODE_ENV !== 'production') {
		        warnValidStyle(styleName, styleValue, component);
		      }
		      if (styleValue != null) {
		        serialized += processStyleName(styleName) + ':';
		        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
		      }
		    }
		    return serialized || null;
		  },
	
		  /**
		   * Sets the value for multiple styles on a node.  If a value is specified as
		   * '' (empty string), the corresponding style property will be unset.
		   *
		   * @param {DOMElement} node
		   * @param {object} styles
		   * @param {ReactDOMComponent} component
		   */
		  setValueForStyles: function (node, styles, component) {
		    if (process.env.NODE_ENV !== 'production') {
		      ReactInstrumentation.debugTool.onHostOperation({
		        instanceID: component._debugID,
		        type: 'update styles',
		        payload: styles
		      });
		    }
	
		    var style = node.style;
		    for (var styleName in styles) {
		      if (!styles.hasOwnProperty(styleName)) {
		        continue;
		      }
		      if (process.env.NODE_ENV !== 'production') {
		        warnValidStyle(styleName, styles[styleName], component);
		      }
		      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
		      if (styleName === 'float' || styleName === 'cssFloat') {
		        styleName = styleFloatAccessor;
		      }
		      if (styleValue) {
		        style[styleName] = styleValue;
		      } else {
		        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
		        if (expansion) {
		          // Shorthand property that IE8 won't like unsetting, so unset each
		          // component to placate it
		          for (var individualStyleName in expansion) {
		            style[individualStyleName] = '';
		          }
		        } else {
		          style[styleName] = '';
		        }
		      }
		    }
		  }
	
		};
	
		module.exports = CSSPropertyOperations;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 74 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * CSS properties which accept numbers but are not in units of "px".
		 */
	
		var isUnitlessNumber = {
		  animationIterationCount: true,
		  borderImageOutset: true,
		  borderImageSlice: true,
		  borderImageWidth: true,
		  boxFlex: true,
		  boxFlexGroup: true,
		  boxOrdinalGroup: true,
		  columnCount: true,
		  flex: true,
		  flexGrow: true,
		  flexPositive: true,
		  flexShrink: true,
		  flexNegative: true,
		  flexOrder: true,
		  gridRow: true,
		  gridColumn: true,
		  fontWeight: true,
		  lineClamp: true,
		  lineHeight: true,
		  opacity: true,
		  order: true,
		  orphans: true,
		  tabSize: true,
		  widows: true,
		  zIndex: true,
		  zoom: true,
	
		  // SVG-related properties
		  fillOpacity: true,
		  floodOpacity: true,
		  stopOpacity: true,
		  strokeDasharray: true,
		  strokeDashoffset: true,
		  strokeMiterlimit: true,
		  strokeOpacity: true,
		  strokeWidth: true
		};
	
		/**
		 * @param {string} prefix vendor-specific prefix, eg: Webkit
		 * @param {string} key style name, eg: transitionDuration
		 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
		 * WebkitTransitionDuration
		 */
		function prefixKey(prefix, key) {
		  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
		}
	
		/**
		 * Support style names that may come passed in prefixed by adding permutations
		 * of vendor prefixes.
		 */
		var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
		// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
		// infinite loop, because it iterates over the newly added props too.
		Object.keys(isUnitlessNumber).forEach(function (prop) {
		  prefixes.forEach(function (prefix) {
		    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
		  });
		});
	
		/**
		 * Most style properties can be unset by doing .style[prop] = '' but IE8
		 * doesn't like doing that with shorthand properties so for the properties that
		 * IE8 breaks on, which are listed here, we instead unset each of the
		 * individual properties. See http://bugs.jquery.com/ticket/12385.
		 * The 4-value 'clock' properties like margin, padding, border-width seem to
		 * behave without any problems. Curiously, list-style works too without any
		 * special prodding.
		 */
		var shorthandPropertyExpansions = {
		  background: {
		    backgroundAttachment: true,
		    backgroundColor: true,
		    backgroundImage: true,
		    backgroundPositionX: true,
		    backgroundPositionY: true,
		    backgroundRepeat: true
		  },
		  backgroundPosition: {
		    backgroundPositionX: true,
		    backgroundPositionY: true
		  },
		  border: {
		    borderWidth: true,
		    borderStyle: true,
		    borderColor: true
		  },
		  borderBottom: {
		    borderBottomWidth: true,
		    borderBottomStyle: true,
		    borderBottomColor: true
		  },
		  borderLeft: {
		    borderLeftWidth: true,
		    borderLeftStyle: true,
		    borderLeftColor: true
		  },
		  borderRight: {
		    borderRightWidth: true,
		    borderRightStyle: true,
		    borderRightColor: true
		  },
		  borderTop: {
		    borderTopWidth: true,
		    borderTopStyle: true,
		    borderTopColor: true
		  },
		  font: {
		    fontStyle: true,
		    fontVariant: true,
		    fontWeight: true,
		    fontSize: true,
		    lineHeight: true,
		    fontFamily: true
		  },
		  outline: {
		    outlineWidth: true,
		    outlineStyle: true,
		    outlineColor: true
		  }
		};
	
		var CSSProperty = {
		  isUnitlessNumber: isUnitlessNumber,
		  shorthandPropertyExpansions: shorthandPropertyExpansions
		};
	
		module.exports = CSSProperty;
	
	/***/ },
	/* 75 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		'use strict';
	
		var camelize = __webpack_require__(76);
	
		var msPattern = /^-ms-/;
	
		/**
		 * Camelcases a hyphenated CSS property name, for example:
		 *
		 *   > camelizeStyleName('background-color')
		 *   < "backgroundColor"
		 *   > camelizeStyleName('-moz-transition')
		 *   < "MozTransition"
		 *   > camelizeStyleName('-ms-transition')
		 *   < "msTransition"
		 *
		 * As Andi Smith suggests
		 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
		 * is converted to lowercase `ms`.
		 *
		 * @param {string} string
		 * @return {string}
		 */
		function camelizeStyleName(string) {
		  return camelize(string.replace(msPattern, 'ms-'));
		}
	
		module.exports = camelizeStyleName;
	
	/***/ },
	/* 76 */
	/***/ function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		var _hyphenPattern = /-(.)/g;
	
		/**
		 * Camelcases a hyphenated string, for example:
		 *
		 *   > camelize('background-color')
		 *   < "backgroundColor"
		 *
		 * @param {string} string
		 * @return {string}
		 */
		function camelize(string) {
		  return string.replace(_hyphenPattern, function (_, character) {
		    return character.toUpperCase();
		  });
		}
	
		module.exports = camelize;
	
	/***/ },
	/* 77 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var CSSProperty = __webpack_require__(74);
		var warning = __webpack_require__(18);
	
		var isUnitlessNumber = CSSProperty.isUnitlessNumber;
		var styleWarnings = {};
	
		/**
		 * Convert a value into the proper css writable value. The style name `name`
		 * should be logical (no hyphens), as specified
		 * in `CSSProperty.isUnitlessNumber`.
		 *
		 * @param {string} name CSS property name such as `topMargin`.
		 * @param {*} value CSS property value such as `10px`.
		 * @param {ReactDOMComponent} component
		 * @return {string} Normalized style value with dimensions applied.
		 */
		function dangerousStyleValue(name, value, component) {
		  // Note that we've removed escapeTextForBrowser() calls here since the
		  // whole string will be escaped when the attribute is injected into
		  // the markup. If you provide unsafe user data here they can inject
		  // arbitrary CSS which may be problematic (I couldn't repro this):
		  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
		  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
		  // This is not an XSS hole but instead a potential CSS injection issue
		  // which has lead to a greater discussion about how we're going to
		  // trust URLs moving forward. See #2115901
	
		  var isEmpty = value == null || typeof value === 'boolean' || value === '';
		  if (isEmpty) {
		    return '';
		  }
	
		  var isNonNumeric = isNaN(value);
		  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
		    return '' + value; // cast to string
		  }
	
		  if (typeof value === 'string') {
		    if (process.env.NODE_ENV !== 'production') {
		      // Allow '0' to pass through without warning. 0 is already special and
		      // doesn't require units, so we don't need to warn about it.
		      if (component && value !== '0') {
		        var owner = component._currentElement._owner;
		        var ownerName = owner ? owner.getName() : null;
		        if (ownerName && !styleWarnings[ownerName]) {
		          styleWarnings[ownerName] = {};
		        }
		        var warned = false;
		        if (ownerName) {
		          var warnings = styleWarnings[ownerName];
		          warned = warnings[name];
		          if (!warned) {
		            warnings[name] = true;
		          }
		        }
		        if (!warned) {
		          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
		        }
		      }
		    }
		    value = value.trim();
		  }
		  return value + 'px';
		}
	
		module.exports = dangerousStyleValue;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 78 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		'use strict';
	
		var hyphenate = __webpack_require__(79);
	
		var msPattern = /^ms-/;
	
		/**
		 * Hyphenates a camelcased CSS property name, for example:
		 *
		 *   > hyphenateStyleName('backgroundColor')
		 *   < "background-color"
		 *   > hyphenateStyleName('MozTransition')
		 *   < "-moz-transition"
		 *   > hyphenateStyleName('msTransition')
		 *   < "-ms-transition"
		 *
		 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
		 * is converted to `-ms-`.
		 *
		 * @param {string} string
		 * @return {string}
		 */
		function hyphenateStyleName(string) {
		  return hyphenate(string).replace(msPattern, '-ms-');
		}
	
		module.exports = hyphenateStyleName;
	
	/***/ },
	/* 79 */
	/***/ function(module, exports) {
	
		'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		var _uppercasePattern = /([A-Z])/g;
	
		/**
		 * Hyphenates a camelcased string, for example:
		 *
		 *   > hyphenate('backgroundColor')
		 *   < "background-color"
		 *
		 * For CSS style names, use `hyphenateStyleName` instead which works properly
		 * with all vendor prefixes, including `ms`.
		 *
		 * @param {string} string
		 * @return {string}
		 */
		function hyphenate(string) {
		  return string.replace(_uppercasePattern, '-$1').toLowerCase();
		}
	
		module.exports = hyphenate;
	
	/***/ },
	/* 80 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 * @typechecks static-only
		 */
	
		'use strict';
	
		/**
		 * Memoizes the return value of a function that accepts one string argument.
		 */
	
		function memoizeStringOnly(callback) {
		  var cache = {};
		  return function (string) {
		    if (!cache.hasOwnProperty(string)) {
		      cache[string] = callback.call(this, string);
		    }
		    return cache[string];
		  };
		}
	
		module.exports = memoizeStringOnly;
	
	/***/ },
	/* 81 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMProperty = __webpack_require__(7);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactInstrumentation = __webpack_require__(37);
	
		var quoteAttributeValueForBrowser = __webpack_require__(82);
		var warning = __webpack_require__(18);
	
		var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
		var illegalAttributeNameCache = {};
		var validatedAttributeNameCache = {};
	
		function isAttributeNameSafe(attributeName) {
		  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
		    return true;
		  }
		  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
		    return false;
		  }
		  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
		    validatedAttributeNameCache[attributeName] = true;
		    return true;
		  }
		  illegalAttributeNameCache[attributeName] = true;
		  process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
		  return false;
		}
	
		function shouldIgnoreValue(propertyInfo, value) {
		  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
		}
	
		/**
		 * Operations for dealing with DOM properties.
		 */
		var DOMPropertyOperations = {
	
		  /**
		   * Creates markup for the ID property.
		   *
		   * @param {string} id Unescaped ID.
		   * @return {string} Markup string.
		   */
		  createMarkupForID: function (id) {
		    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
		  },
	
		  setAttributeForID: function (node, id) {
		    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
		  },
	
		  createMarkupForRoot: function () {
		    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
		  },
	
		  setAttributeForRoot: function (node) {
		    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
		  },
	
		  /**
		   * Creates markup for a property.
		   *
		   * @param {string} name
		   * @param {*} value
		   * @return {?string} Markup string, or null if the property was invalid.
		   */
		  createMarkupForProperty: function (name, value) {
		    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
		    if (propertyInfo) {
		      if (shouldIgnoreValue(propertyInfo, value)) {
		        return '';
		      }
		      var attributeName = propertyInfo.attributeName;
		      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
		        return attributeName + '=""';
		      }
		      return attributeName + '=' + quoteAttributeValueForBrowser(value);
		    } else if (DOMProperty.isCustomAttribute(name)) {
		      if (value == null) {
		        return '';
		      }
		      return name + '=' + quoteAttributeValueForBrowser(value);
		    }
		    return null;
		  },
	
		  /**
		   * Creates markup for a custom property.
		   *
		   * @param {string} name
		   * @param {*} value
		   * @return {string} Markup string, or empty string if the property was invalid.
		   */
		  createMarkupForCustomAttribute: function (name, value) {
		    if (!isAttributeNameSafe(name) || value == null) {
		      return '';
		    }
		    return name + '=' + quoteAttributeValueForBrowser(value);
		  },
	
		  /**
		   * Sets the value for a property on a node.
		   *
		   * @param {DOMElement} node
		   * @param {string} name
		   * @param {*} value
		   */
		  setValueForProperty: function (node, name, value) {
		    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
		    if (propertyInfo) {
		      var mutationMethod = propertyInfo.mutationMethod;
		      if (mutationMethod) {
		        mutationMethod(node, value);
		      } else if (shouldIgnoreValue(propertyInfo, value)) {
		        this.deleteValueForProperty(node, name);
		        return;
		      } else if (propertyInfo.mustUseProperty) {
		        // Contrary to `setAttribute`, object properties are properly
		        // `toString`ed by IE8/9.
		        node[propertyInfo.propertyName] = value;
		      } else {
		        var attributeName = propertyInfo.attributeName;
		        var namespace = propertyInfo.attributeNamespace;
		        // `setAttribute` with objects becomes only `[object]` in IE8/9,
		        // ('' + value) makes it output the correct toString()-value.
		        if (namespace) {
		          node.setAttributeNS(namespace, attributeName, '' + value);
		        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
		          node.setAttribute(attributeName, '');
		        } else {
		          node.setAttribute(attributeName, '' + value);
		        }
		      }
		    } else if (DOMProperty.isCustomAttribute(name)) {
		      DOMPropertyOperations.setValueForAttribute(node, name, value);
		      return;
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      var payload = {};
		      payload[name] = value;
		      ReactInstrumentation.debugTool.onHostOperation({
		        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
		        type: 'update attribute',
		        payload: payload
		      });
		    }
		  },
	
		  setValueForAttribute: function (node, name, value) {
		    if (!isAttributeNameSafe(name)) {
		      return;
		    }
		    if (value == null) {
		      node.removeAttribute(name);
		    } else {
		      node.setAttribute(name, '' + value);
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      var payload = {};
		      payload[name] = value;
		      ReactInstrumentation.debugTool.onHostOperation({
		        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
		        type: 'update attribute',
		        payload: payload
		      });
		    }
		  },
	
		  /**
		   * Deletes an attributes from a node.
		   *
		   * @param {DOMElement} node
		   * @param {string} name
		   */
		  deleteValueForAttribute: function (node, name) {
		    node.removeAttribute(name);
		    if (process.env.NODE_ENV !== 'production') {
		      ReactInstrumentation.debugTool.onHostOperation({
		        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
		        type: 'remove attribute',
		        payload: name
		      });
		    }
		  },
	
		  /**
		   * Deletes the value for a property on a node.
		   *
		   * @param {DOMElement} node
		   * @param {string} name
		   */
		  deleteValueForProperty: function (node, name) {
		    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
		    if (propertyInfo) {
		      var mutationMethod = propertyInfo.mutationMethod;
		      if (mutationMethod) {
		        mutationMethod(node, undefined);
		      } else if (propertyInfo.mustUseProperty) {
		        var propName = propertyInfo.propertyName;
		        if (propertyInfo.hasBooleanValue) {
		          node[propName] = false;
		        } else {
		          node[propName] = '';
		        }
		      } else {
		        node.removeAttribute(propertyInfo.attributeName);
		      }
		    } else if (DOMProperty.isCustomAttribute(name)) {
		      node.removeAttribute(name);
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      ReactInstrumentation.debugTool.onHostOperation({
		        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
		        type: 'remove attribute',
		        payload: name
		      });
		    }
		  }
	
		};
	
		module.exports = DOMPropertyOperations;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 82 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var escapeTextContentForBrowser = __webpack_require__(64);
	
		/**
		 * Escapes attribute value to prevent scripting attacks.
		 *
		 * @param {*} value Value to escape.
		 * @return {string} An escaped string.
		 */
		function quoteAttributeValueForBrowser(value) {
		  return '"' + escapeTextContentForBrowser(value) + '"';
		}
	
		module.exports = quoteAttributeValueForBrowser;
	
	/***/ },
	/* 83 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var EventPluginRegistry = __webpack_require__(15);
		var ReactEventEmitterMixin = __webpack_require__(84);
		var ViewportMetrics = __webpack_require__(54);
	
		var getVendorPrefixedEventName = __webpack_require__(85);
		var isEventSupported = __webpack_require__(48);
	
		/**
		 * Summary of `ReactBrowserEventEmitter` event handling:
		 *
		 *  - Top-level delegation is used to trap most native browser events. This
		 *    may only occur in the main thread and is the responsibility of
		 *    ReactEventListener, which is injected and can therefore support pluggable
		 *    event sources. This is the only work that occurs in the main thread.
		 *
		 *  - We normalize and de-duplicate events to account for browser quirks. This
		 *    may be done in the worker thread.
		 *
		 *  - Forward these native events (with the associated top-level type used to
		 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
		 *    to extract any synthetic events.
		 *
		 *  - The `EventPluginHub` will then process each event by annotating them with
		 *    "dispatches", a sequence of listeners and IDs that care about that event.
		 *
		 *  - The `EventPluginHub` then dispatches the events.
		 *
		 * Overview of React and the event system:
		 *
		 * +------------+    .
		 * |    DOM     |    .
		 * +------------+    .
		 *       |           .
		 *       v           .
		 * +------------+    .
		 * | ReactEvent |    .
		 * |  Listener  |    .
		 * +------------+    .                         +-----------+
		 *       |           .               +--------+|SimpleEvent|
		 *       |           .               |         |Plugin     |
		 * +-----|------+    .               v         +-----------+
		 * |     |      |    .    +--------------+                    +------------+
		 * |     +-----------.--->|EventPluginHub|                    |    Event   |
		 * |            |    .    |              |     +-----------+  | Propagators|
		 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
		 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
		 * |            |    .    |              |     +-----------+  |  utilities |
		 * |     +-----------.--->|              |                    +------------+
		 * |     |      |    .    +--------------+
		 * +-----|------+    .                ^        +-----------+
		 *       |           .                |        |Enter/Leave|
		 *       +           .                +-------+|Plugin     |
		 * +-------------+   .                         +-----------+
		 * | application |   .
		 * |-------------|   .
		 * |             |   .
		 * |             |   .
		 * +-------------+   .
		 *                   .
		 *    React Core     .  General Purpose Event Plugin System
		 */
	
		var hasEventPageXY;
		var alreadyListeningTo = {};
		var isMonitoringScrollValue = false;
		var reactTopListenersCounter = 0;
	
		// For events like 'submit' which don't consistently bubble (which we trap at a
		// lower node than `document`), binding at `document` would cause duplicate
		// events so we don't include them here
		var topEventMapping = {
		  topAbort: 'abort',
		  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
		  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
		  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
		  topBlur: 'blur',
		  topCanPlay: 'canplay',
		  topCanPlayThrough: 'canplaythrough',
		  topChange: 'change',
		  topClick: 'click',
		  topCompositionEnd: 'compositionend',
		  topCompositionStart: 'compositionstart',
		  topCompositionUpdate: 'compositionupdate',
		  topContextMenu: 'contextmenu',
		  topCopy: 'copy',
		  topCut: 'cut',
		  topDoubleClick: 'dblclick',
		  topDrag: 'drag',
		  topDragEnd: 'dragend',
		  topDragEnter: 'dragenter',
		  topDragExit: 'dragexit',
		  topDragLeave: 'dragleave',
		  topDragOver: 'dragover',
		  topDragStart: 'dragstart',
		  topDrop: 'drop',
		  topDurationChange: 'durationchange',
		  topEmptied: 'emptied',
		  topEncrypted: 'encrypted',
		  topEnded: 'ended',
		  topError: 'error',
		  topFocus: 'focus',
		  topInput: 'input',
		  topKeyDown: 'keydown',
		  topKeyPress: 'keypress',
		  topKeyUp: 'keyup',
		  topLoadedData: 'loadeddata',
		  topLoadedMetadata: 'loadedmetadata',
		  topLoadStart: 'loadstart',
		  topMouseDown: 'mousedown',
		  topMouseMove: 'mousemove',
		  topMouseOut: 'mouseout',
		  topMouseOver: 'mouseover',
		  topMouseUp: 'mouseup',
		  topPaste: 'paste',
		  topPause: 'pause',
		  topPlay: 'play',
		  topPlaying: 'playing',
		  topProgress: 'progress',
		  topRateChange: 'ratechange',
		  topScroll: 'scroll',
		  topSeeked: 'seeked',
		  topSeeking: 'seeking',
		  topSelectionChange: 'selectionchange',
		  topStalled: 'stalled',
		  topSuspend: 'suspend',
		  topTextInput: 'textInput',
		  topTimeUpdate: 'timeupdate',
		  topTouchCancel: 'touchcancel',
		  topTouchEnd: 'touchend',
		  topTouchMove: 'touchmove',
		  topTouchStart: 'touchstart',
		  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
		  topVolumeChange: 'volumechange',
		  topWaiting: 'waiting',
		  topWheel: 'wheel'
		};
	
		/**
		 * To ensure no conflicts with other potential React instances on the page
		 */
		var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
		function getListeningForDocument(mountAt) {
		  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
		  // directly.
		  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
		    mountAt[topListenersIDKey] = reactTopListenersCounter++;
		    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
		  }
		  return alreadyListeningTo[mountAt[topListenersIDKey]];
		}
	
		/**
		 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
		 * example:
		 *
		 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
		 *
		 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
		 *
		 * @internal
		 */
		var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
		  /**
		   * Injectable event backend
		   */
		  ReactEventListener: null,
	
		  injection: {
		    /**
		     * @param {object} ReactEventListener
		     */
		    injectReactEventListener: function (ReactEventListener) {
		      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
		      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
		    }
		  },
	
		  /**
		   * Sets whether or not any created callbacks should be enabled.
		   *
		   * @param {boolean} enabled True if callbacks should be enabled.
		   */
		  setEnabled: function (enabled) {
		    if (ReactBrowserEventEmitter.ReactEventListener) {
		      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
		    }
		  },
	
		  /**
		   * @return {boolean} True if callbacks are enabled.
		   */
		  isEnabled: function () {
		    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
		  },
	
		  /**
		   * We listen for bubbled touch events on the document object.
		   *
		   * Firefox v8.01 (and possibly others) exhibited strange behavior when
		   * mounting `onmousemove` events at some node that was not the document
		   * element. The symptoms were that if your mouse is not moving over something
		   * contained within that mount point (for example on the background) the
		   * top-level listeners for `onmousemove` won't be called. However, if you
		   * register the `mousemove` on the document object, then it will of course
		   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
		   * top-level listeners to the document object only, at least for these
		   * movement types of events and possibly all events.
		   *
		   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
		   *
		   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
		   * they bubble to document.
		   *
		   * @param {string} registrationName Name of listener (e.g. `onClick`).
		   * @param {object} contentDocumentHandle Document which owns the container
		   */
		  listenTo: function (registrationName, contentDocumentHandle) {
		    var mountAt = contentDocumentHandle;
		    var isListening = getListeningForDocument(mountAt);
		    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
		    for (var i = 0; i < dependencies.length; i++) {
		      var dependency = dependencies[i];
		      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
		        if (dependency === 'topWheel') {
		          if (isEventSupported('wheel')) {
		            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
		          } else if (isEventSupported('mousewheel')) {
		            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
		          } else {
		            // Firefox needs to capture a different mouse scroll event.
		            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
		            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
		          }
		        } else if (dependency === 'topScroll') {
	
		          if (isEventSupported('scroll', true)) {
		            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
		          } else {
		            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
		          }
		        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
		          if (isEventSupported('focus', true)) {
		            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
		            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
		          } else if (isEventSupported('focusin')) {
		            // IE has `focusin` and `focusout` events which bubble.
		            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
		            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
		            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
		          }
	
		          // to make sure blur and focus event listeners are only attached once
		          isListening.topBlur = true;
		          isListening.topFocus = true;
		        } else if (topEventMapping.hasOwnProperty(dependency)) {
		          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
		        }
	
		        isListening[dependency] = true;
		      }
		    }
		  },
	
		  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
		    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
		  },
	
		  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
		    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
		  },
	
		  /**
		   * Protect against document.createEvent() returning null
		   * Some popup blocker extensions appear to do this:
		   * https://github.com/facebook/react/issues/6887
		   */
		  supportsEventPageXY: function () {
		    if (!document.createEvent) {
		      return false;
		    }
		    var ev = document.createEvent('MouseEvent');
		    return ev != null && 'pageX' in ev;
		  },
	
		  /**
		   * Listens to window scroll and resize events. We cache scroll values so that
		   * application code can access them without triggering reflows.
		   *
		   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
		   * pageX/pageY isn't supported (legacy browsers).
		   *
		   * NOTE: Scroll events do not bubble.
		   *
		   * @see http://www.quirksmode.org/dom/events/scroll.html
		   */
		  ensureScrollValueMonitoring: function () {
		    if (hasEventPageXY === undefined) {
		      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
		    }
		    if (!hasEventPageXY && !isMonitoringScrollValue) {
		      var refresh = ViewportMetrics.refreshScrollValues;
		      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
		      isMonitoringScrollValue = true;
		    }
		  }
	
		});
	
		module.exports = ReactBrowserEventEmitter;
	
	/***/ },
	/* 84 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var EventPluginHub = __webpack_require__(14);
	
		function runEventQueueInBatch(events) {
		  EventPluginHub.enqueueEvents(events);
		  EventPluginHub.processEventQueue(false);
		}
	
		var ReactEventEmitterMixin = {
	
		  /**
		   * Streams a fired top-level event to `EventPluginHub` where plugins have the
		   * opportunity to create `ReactEvent`s to be dispatched.
		   */
		  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
		    runEventQueueInBatch(events);
		  }
		};
	
		module.exports = ReactEventEmitterMixin;
	
	/***/ },
	/* 85 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ExecutionEnvironment = __webpack_require__(22);
	
		/**
		 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
		 *
		 * @param {string} styleProp
		 * @param {string} eventName
		 * @returns {object}
		 */
		function makePrefixMap(styleProp, eventName) {
		  var prefixes = {};
	
		  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
		  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
		  prefixes['Moz' + styleProp] = 'moz' + eventName;
		  prefixes['ms' + styleProp] = 'MS' + eventName;
		  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
		  return prefixes;
		}
	
		/**
		 * A list of event names to a configurable list of vendor prefixes.
		 */
		var vendorPrefixes = {
		  animationend: makePrefixMap('Animation', 'AnimationEnd'),
		  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
		  animationstart: makePrefixMap('Animation', 'AnimationStart'),
		  transitionend: makePrefixMap('Transition', 'TransitionEnd')
		};
	
		/**
		 * Event names that have already been detected and prefixed (if applicable).
		 */
		var prefixedEventNames = {};
	
		/**
		 * Element to check for prefixes on.
		 */
		var style = {};
	
		/**
		 * Bootstrap if a DOM exists.
		 */
		if (ExecutionEnvironment.canUseDOM) {
		  style = document.createElement('div').style;
	
		  // On some platforms, in particular some releases of Android 4.x,
		  // the un-prefixed "animation" and "transition" properties are defined on the
		  // style object but the events that fire will still be prefixed, so we need
		  // to check if the un-prefixed events are usable, and if not remove them from the map.
		  if (!('AnimationEvent' in window)) {
		    delete vendorPrefixes.animationend.animation;
		    delete vendorPrefixes.animationiteration.animation;
		    delete vendorPrefixes.animationstart.animation;
		  }
	
		  // Same as above
		  if (!('TransitionEvent' in window)) {
		    delete vendorPrefixes.transitionend.transition;
		  }
		}
	
		/**
		 * Attempts to determine the correct vendor prefixed event name.
		 *
		 * @param {string} eventName
		 * @returns {string}
		 */
		function getVendorPrefixedEventName(eventName) {
		  if (prefixedEventNames[eventName]) {
		    return prefixedEventNames[eventName];
		  } else if (!vendorPrefixes[eventName]) {
		    return eventName;
		  }
	
		  var prefixMap = vendorPrefixes[eventName];
	
		  for (var styleProp in prefixMap) {
		    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
		      return prefixedEventNames[eventName] = prefixMap[styleProp];
		    }
		  }
	
		  return '';
		}
	
		module.exports = getVendorPrefixedEventName;
	
	/***/ },
	/* 86 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6),
		    _assign = __webpack_require__(24);
	
		var DOMPropertyOperations = __webpack_require__(81);
		var LinkedValueUtils = __webpack_require__(87);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactUpdates = __webpack_require__(31);
	
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		var didWarnValueLink = false;
		var didWarnCheckedLink = false;
		var didWarnValueDefaultValue = false;
		var didWarnCheckedDefaultChecked = false;
		var didWarnControlledToUncontrolled = false;
		var didWarnUncontrolledToControlled = false;
	
		function forceUpdateIfMounted() {
		  if (this._rootNodeID) {
		    // DOM component is still mounted; update
		    ReactDOMInput.updateWrapper(this);
		  }
		}
	
		function isControlled(props) {
		  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
		  return usesChecked ? props.checked != null : props.value != null;
		}
	
		/**
		 * Implements an <input> host component that allows setting these optional
		 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
		 *
		 * If `checked` or `value` are not supplied (or null/undefined), user actions
		 * that affect the checked state or value will trigger updates to the element.
		 *
		 * If they are supplied (and not null/undefined), the rendered element will not
		 * trigger updates to the element. Instead, the props must change in order for
		 * the rendered element to be updated.
		 *
		 * The rendered element will be initialized as unchecked (or `defaultChecked`)
		 * with an empty value (or `defaultValue`).
		 *
		 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
		 */
		var ReactDOMInput = {
		  getHostProps: function (inst, props) {
		    var value = LinkedValueUtils.getValue(props);
		    var checked = LinkedValueUtils.getChecked(props);
	
		    var hostProps = _assign({
		      // Make sure we set .type before any other properties (setting .value
		      // before .type means .value is lost in IE11 and below)
		      type: undefined,
		      // Make sure we set .step before .value (setting .value before .step
		      // means .value is rounded on mount, based upon step precision)
		      step: undefined,
		      // Make sure we set .min & .max before .value (to ensure proper order
		      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
		      min: undefined,
		      max: undefined
		    }, props, {
		      defaultChecked: undefined,
		      defaultValue: undefined,
		      value: value != null ? value : inst._wrapperState.initialValue,
		      checked: checked != null ? checked : inst._wrapperState.initialChecked,
		      onChange: inst._wrapperState.onChange
		    });
	
		    return hostProps;
		  },
	
		  mountWrapper: function (inst, props) {
		    if (process.env.NODE_ENV !== 'production') {
		      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
		      var owner = inst._currentElement._owner;
	
		      if (props.valueLink !== undefined && !didWarnValueLink) {
		        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
		        didWarnValueLink = true;
		      }
		      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
		        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
		        didWarnCheckedLink = true;
		      }
		      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
		        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
		        didWarnCheckedDefaultChecked = true;
		      }
		      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
		        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
		        didWarnValueDefaultValue = true;
		      }
		    }
	
		    var defaultValue = props.defaultValue;
		    inst._wrapperState = {
		      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
		      initialValue: props.value != null ? props.value : defaultValue,
		      listeners: null,
		      onChange: _handleChange.bind(inst)
		    };
	
		    if (process.env.NODE_ENV !== 'production') {
		      inst._wrapperState.controlled = isControlled(props);
		    }
		  },
	
		  updateWrapper: function (inst) {
		    var props = inst._currentElement.props;
	
		    if (process.env.NODE_ENV !== 'production') {
		      var controlled = isControlled(props);
		      var owner = inst._currentElement._owner;
	
		      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
		        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
		        didWarnUncontrolledToControlled = true;
		      }
		      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
		        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
		        didWarnControlledToUncontrolled = true;
		      }
		    }
	
		    // TODO: Shouldn't this be getChecked(props)?
		    var checked = props.checked;
		    if (checked != null) {
		      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
		    }
	
		    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
		    var value = LinkedValueUtils.getValue(props);
		    if (value != null) {
	
		      // Cast `value` to a string to ensure the value is set correctly. While
		      // browsers typically do this as necessary, jsdom doesn't.
		      var newValue = '' + value;
	
		      // To avoid side effects (such as losing text selection), only set value if changed
		      if (newValue !== node.value) {
		        node.value = newValue;
		      }
		    } else {
		      if (props.value == null && props.defaultValue != null) {
		        // In Chrome, assigning defaultValue to certain input types triggers input validation.
		        // For number inputs, the display value loses trailing decimal points. For email inputs,
		        // Chrome raises "The specified value <x> is not a valid email address".
		        //
		        // Here we check to see if the defaultValue has actually changed, avoiding these problems
		        // when the user is inputting text
		        //
		        // https://github.com/facebook/react/issues/7253
		        if (node.defaultValue !== '' + props.defaultValue) {
		          node.defaultValue = '' + props.defaultValue;
		        }
		      }
		      if (props.checked == null && props.defaultChecked != null) {
		        node.defaultChecked = !!props.defaultChecked;
		      }
		    }
		  },
	
		  postMountWrapper: function (inst) {
		    var props = inst._currentElement.props;
	
		    // This is in postMount because we need access to the DOM node, which is not
		    // available until after the component has mounted.
		    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
		    // Detach value from defaultValue. We won't do anything if we're working on
		    // submit or reset inputs as those values & defaultValues are linked. They
		    // are not resetable nodes so this operation doesn't matter and actually
		    // removes browser-default values (eg "Submit Query") when no value is
		    // provided.
	
		    switch (props.type) {
		      case 'submit':
		      case 'reset':
		        break;
		      case 'color':
		      case 'date':
		      case 'datetime':
		      case 'datetime-local':
		      case 'month':
		      case 'time':
		      case 'week':
		        // This fixes the no-show issue on iOS Safari and Android Chrome:
		        // https://github.com/facebook/react/issues/7233
		        node.value = '';
		        node.value = node.defaultValue;
		        break;
		      default:
		        node.value = node.value;
		        break;
		    }
	
		    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
		    // this is needed to work around a chrome bug where setting defaultChecked
		    // will sometimes influence the value of checked (even after detachment).
		    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
		    // We need to temporarily unset name to avoid disrupting radio button groups.
		    var name = node.name;
		    if (name !== '') {
		      node.name = '';
		    }
		    node.defaultChecked = !node.defaultChecked;
		    node.defaultChecked = !node.defaultChecked;
		    if (name !== '') {
		      node.name = name;
		    }
		  }
		};
	
		function _handleChange(event) {
		  var props = this._currentElement.props;
	
		  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
		  // Here we use asap to wait until all updates have propagated, which
		  // is important when using controlled components within layers:
		  // https://github.com/facebook/react/issues/1698
		  ReactUpdates.asap(forceUpdateIfMounted, this);
	
		  var name = props.name;
		  if (props.type === 'radio' && name != null) {
		    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
		    var queryRoot = rootNode;
	
		    while (queryRoot.parentNode) {
		      queryRoot = queryRoot.parentNode;
		    }
	
		    // If `rootNode.form` was non-null, then we could try `form.elements`,
		    // but that sometimes behaves strangely in IE8. We could also try using
		    // `form.getElementsByName`, but that will only return direct children
		    // and won't include inputs that use the HTML5 `form=` attribute. Since
		    // the input might not even be in a form, let's just use the global
		    // `querySelectorAll` to ensure we don't miss anything.
		    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
		    for (var i = 0; i < group.length; i++) {
		      var otherNode = group[i];
		      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
		        continue;
		      }
		      // This will throw if radio buttons rendered by different copies of React
		      // and the same name are rendered into the same form (same as #1939).
		      // That's probably okay; we don't support it just as we don't support
		      // mixing React radio buttons with non-React ones.
		      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
		      !otherInstance ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
		      // If this is a controlled radio button group, forcing the input that
		      // was previously checked to update will cause it to be come re-checked
		      // as appropriate.
		      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
		    }
		  }
	
		  return returnValue;
		}
	
		module.exports = ReactDOMInput;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 87 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var React = __webpack_require__(88);
		var ReactPropTypesSecret = __webpack_require__(110);
	
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		var hasReadOnlyValue = {
		  'button': true,
		  'checkbox': true,
		  'image': true,
		  'hidden': true,
		  'radio': true,
		  'reset': true,
		  'submit': true
		};
	
		function _assertSingleLink(inputProps) {
		  !(inputProps.checkedLink == null || inputProps.valueLink == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
		}
		function _assertValueLink(inputProps) {
		  _assertSingleLink(inputProps);
		  !(inputProps.value == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
		}
	
		function _assertCheckedLink(inputProps) {
		  _assertSingleLink(inputProps);
		  !(inputProps.checked == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
		}
	
		var propTypes = {
		  value: function (props, propName, componentName) {
		    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
		      return null;
		    }
		    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
		  },
		  checked: function (props, propName, componentName) {
		    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
		      return null;
		    }
		    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
		  },
		  onChange: React.PropTypes.func
		};
	
		var loggedTypeFailures = {};
		function getDeclarationErrorAddendum(owner) {
		  if (owner) {
		    var name = owner.getName();
		    if (name) {
		      return ' Check the render method of `' + name + '`.';
		    }
		  }
		  return '';
		}
	
		/**
		 * Provide a linked `value` attribute for controlled forms. You should not use
		 * this outside of the ReactDOM controlled form components.
		 */
		var LinkedValueUtils = {
		  checkPropTypes: function (tagName, props, owner) {
		    for (var propName in propTypes) {
		      if (propTypes.hasOwnProperty(propName)) {
		        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
		      }
		      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		        // Only monitor this failure once because there tends to be a lot of the
		        // same error.
		        loggedTypeFailures[error.message] = true;
	
		        var addendum = getDeclarationErrorAddendum(owner);
		        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
		      }
		    }
		  },
	
		  /**
		   * @param {object} inputProps Props for form component
		   * @return {*} current value of the input either from value prop or link.
		   */
		  getValue: function (inputProps) {
		    if (inputProps.valueLink) {
		      _assertValueLink(inputProps);
		      return inputProps.valueLink.value;
		    }
		    return inputProps.value;
		  },
	
		  /**
		   * @param {object} inputProps Props for form component
		   * @return {*} current checked status of the input either from checked prop
		   *             or link.
		   */
		  getChecked: function (inputProps) {
		    if (inputProps.checkedLink) {
		      _assertCheckedLink(inputProps);
		      return inputProps.checkedLink.value;
		    }
		    return inputProps.checked;
		  },
	
		  /**
		   * @param {object} inputProps Props for form component
		   * @param {SyntheticEvent} event change event to handle
		   */
		  executeOnChange: function (inputProps, event) {
		    if (inputProps.valueLink) {
		      _assertValueLink(inputProps);
		      return inputProps.valueLink.requestChange(event.target.value);
		    } else if (inputProps.checkedLink) {
		      _assertCheckedLink(inputProps);
		      return inputProps.checkedLink.requestChange(event.target.checked);
		    } else if (inputProps.onChange) {
		      return inputProps.onChange.call(undefined, event);
		    }
		  }
		};
	
		module.exports = LinkedValueUtils;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 88 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var ReactChildren = __webpack_require__(89);
		var ReactComponent = __webpack_require__(97);
		var ReactPureComponent = __webpack_require__(100);
		var ReactClass = __webpack_require__(101);
		var ReactDOMFactories = __webpack_require__(103);
		var ReactElement = __webpack_require__(91);
		var ReactPropTypes = __webpack_require__(107);
		var ReactVersion = __webpack_require__(108);
	
		var onlyChild = __webpack_require__(109);
		var warning = __webpack_require__(18);
	
		var createElement = ReactElement.createElement;
		var createFactory = ReactElement.createFactory;
		var cloneElement = ReactElement.cloneElement;
	
		if (process.env.NODE_ENV !== 'production') {
		  var ReactElementValidator = __webpack_require__(104);
		  createElement = ReactElementValidator.createElement;
		  createFactory = ReactElementValidator.createFactory;
		  cloneElement = ReactElementValidator.cloneElement;
		}
	
		var __spread = _assign;
	
		if (process.env.NODE_ENV !== 'production') {
		  var warned = false;
		  __spread = function () {
		    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
		    warned = true;
		    return _assign.apply(null, arguments);
		  };
		}
	
		var React = {
	
		  // Modern
	
		  Children: {
		    map: ReactChildren.map,
		    forEach: ReactChildren.forEach,
		    count: ReactChildren.count,
		    toArray: ReactChildren.toArray,
		    only: onlyChild
		  },
	
		  Component: ReactComponent,
		  PureComponent: ReactPureComponent,
	
		  createElement: createElement,
		  cloneElement: cloneElement,
		  isValidElement: ReactElement.isValidElement,
	
		  // Classic
	
		  PropTypes: ReactPropTypes,
		  createClass: ReactClass.createClass,
		  createFactory: createFactory,
		  createMixin: function (mixin) {
		    // Currently a noop. Will be used to validate and trace mixins.
		    return mixin;
		  },
	
		  // This looks DOM specific but these are actually isomorphic helpers
		  // since they are just generating DOM strings.
		  DOM: ReactDOMFactories,
	
		  version: ReactVersion,
	
		  // Deprecated hook for JSX spread, don't use this for anything.
		  __spread: __spread
		};
	
		module.exports = React;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 89 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var PooledClass = __webpack_require__(90);
		var ReactElement = __webpack_require__(91);
	
		var emptyFunction = __webpack_require__(19);
		var traverseAllChildren = __webpack_require__(94);
	
		var twoArgumentPooler = PooledClass.twoArgumentPooler;
		var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
		var userProvidedKeyEscapeRegex = /\/+/g;
		function escapeUserProvidedKey(text) {
		  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
		}
	
		/**
		 * PooledClass representing the bookkeeping associated with performing a child
		 * traversal. Allows avoiding binding callbacks.
		 *
		 * @constructor ForEachBookKeeping
		 * @param {!function} forEachFunction Function to perform traversal with.
		 * @param {?*} forEachContext Context to perform context with.
		 */
		function ForEachBookKeeping(forEachFunction, forEachContext) {
		  this.func = forEachFunction;
		  this.context = forEachContext;
		  this.count = 0;
		}
		ForEachBookKeeping.prototype.destructor = function () {
		  this.func = null;
		  this.context = null;
		  this.count = 0;
		};
		PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
		function forEachSingleChild(bookKeeping, child, name) {
		  var func = bookKeeping.func,
		      context = bookKeeping.context;
	
		  func.call(context, child, bookKeeping.count++);
		}
	
		/**
		 * Iterates through children that are typically specified as `props.children`.
		 *
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
		 *
		 * The provided forEachFunc(child, index) will be called for each
		 * leaf child.
		 *
		 * @param {?*} children Children tree container.
		 * @param {function(*, int)} forEachFunc
		 * @param {*} forEachContext Context for forEachContext.
		 */
		function forEachChildren(children, forEachFunc, forEachContext) {
		  if (children == null) {
		    return children;
		  }
		  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
		  traverseAllChildren(children, forEachSingleChild, traverseContext);
		  ForEachBookKeeping.release(traverseContext);
		}
	
		/**
		 * PooledClass representing the bookkeeping associated with performing a child
		 * mapping. Allows avoiding binding callbacks.
		 *
		 * @constructor MapBookKeeping
		 * @param {!*} mapResult Object containing the ordered map of results.
		 * @param {!function} mapFunction Function to perform mapping with.
		 * @param {?*} mapContext Context to perform mapping with.
		 */
		function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
		  this.result = mapResult;
		  this.keyPrefix = keyPrefix;
		  this.func = mapFunction;
		  this.context = mapContext;
		  this.count = 0;
		}
		MapBookKeeping.prototype.destructor = function () {
		  this.result = null;
		  this.keyPrefix = null;
		  this.func = null;
		  this.context = null;
		  this.count = 0;
		};
		PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
		function mapSingleChildIntoContext(bookKeeping, child, childKey) {
		  var result = bookKeeping.result,
		      keyPrefix = bookKeeping.keyPrefix,
		      func = bookKeeping.func,
		      context = bookKeeping.context;
	
	
		  var mappedChild = func.call(context, child, bookKeeping.count++);
		  if (Array.isArray(mappedChild)) {
		    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
		  } else if (mappedChild != null) {
		    if (ReactElement.isValidElement(mappedChild)) {
		      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
		      // Keep both the (mapped) and old keys if they differ, just as
		      // traverseAllChildren used to do for objects as children
		      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
		    }
		    result.push(mappedChild);
		  }
		}
	
		function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
		  var escapedPrefix = '';
		  if (prefix != null) {
		    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
		  }
		  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
		  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
		  MapBookKeeping.release(traverseContext);
		}
	
		/**
		 * Maps children that are typically specified as `props.children`.
		 *
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
		 *
		 * The provided mapFunction(child, key, index) will be called for each
		 * leaf child.
		 *
		 * @param {?*} children Children tree container.
		 * @param {function(*, int)} func The map function.
		 * @param {*} context Context for mapFunction.
		 * @return {object} Object containing the ordered map of results.
		 */
		function mapChildren(children, func, context) {
		  if (children == null) {
		    return children;
		  }
		  var result = [];
		  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
		  return result;
		}
	
		function forEachSingleChildDummy(traverseContext, child, name) {
		  return null;
		}
	
		/**
		 * Count the number of children that are typically specified as
		 * `props.children`.
		 *
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
		 *
		 * @param {?*} children Children tree container.
		 * @return {number} The number of children.
		 */
		function countChildren(children, context) {
		  return traverseAllChildren(children, forEachSingleChildDummy, null);
		}
	
		/**
		 * Flatten a children object (typically specified as `props.children`) and
		 * return an array with appropriately re-keyed children.
		 *
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
		 */
		function toArray(children) {
		  var result = [];
		  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
		  return result;
		}
	
		var ReactChildren = {
		  forEach: forEachChildren,
		  map: mapChildren,
		  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
		  count: countChildren,
		  toArray: toArray
		};
	
		module.exports = ReactChildren;
	
	/***/ },
	/* 90 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(42);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * Static poolers. Several custom versions for each potential number of
		 * arguments. A completely generic pooler is easy to implement, but would
		 * require accessing the `arguments` object. In each of these, `this` refers to
		 * the Class itself, not an instance. If any others are needed, simply add them
		 * here, or in their own files.
		 */
		var oneArgumentPooler = function (copyFieldsFrom) {
		  var Klass = this;
		  if (Klass.instancePool.length) {
		    var instance = Klass.instancePool.pop();
		    Klass.call(instance, copyFieldsFrom);
		    return instance;
		  } else {
		    return new Klass(copyFieldsFrom);
		  }
		};
	
		var twoArgumentPooler = function (a1, a2) {
		  var Klass = this;
		  if (Klass.instancePool.length) {
		    var instance = Klass.instancePool.pop();
		    Klass.call(instance, a1, a2);
		    return instance;
		  } else {
		    return new Klass(a1, a2);
		  }
		};
	
		var threeArgumentPooler = function (a1, a2, a3) {
		  var Klass = this;
		  if (Klass.instancePool.length) {
		    var instance = Klass.instancePool.pop();
		    Klass.call(instance, a1, a2, a3);
		    return instance;
		  } else {
		    return new Klass(a1, a2, a3);
		  }
		};
	
		var fourArgumentPooler = function (a1, a2, a3, a4) {
		  var Klass = this;
		  if (Klass.instancePool.length) {
		    var instance = Klass.instancePool.pop();
		    Klass.call(instance, a1, a2, a3, a4);
		    return instance;
		  } else {
		    return new Klass(a1, a2, a3, a4);
		  }
		};
	
		var standardReleaser = function (instance) {
		  var Klass = this;
		  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
		  instance.destructor();
		  if (Klass.instancePool.length < Klass.poolSize) {
		    Klass.instancePool.push(instance);
		  }
		};
	
		var DEFAULT_POOL_SIZE = 10;
		var DEFAULT_POOLER = oneArgumentPooler;
	
		/**
		 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
		 * itself (statically) not adding any prototypical fields. Any CopyConstructor
		 * you give this may have a `poolSize` property, and will look for a
		 * prototypical `destructor` on instances.
		 *
		 * @param {Function} CopyConstructor Constructor that can be used to reset.
		 * @param {Function} pooler Customizable pooler.
		 */
		var addPoolingTo = function (CopyConstructor, pooler) {
		  // Casting as any so that flow ignores the actual implementation and trusts
		  // it to match the type we declared
		  var NewKlass = CopyConstructor;
		  NewKlass.instancePool = [];
		  NewKlass.getPooled = pooler || DEFAULT_POOLER;
		  if (!NewKlass.poolSize) {
		    NewKlass.poolSize = DEFAULT_POOL_SIZE;
		  }
		  NewKlass.release = standardReleaser;
		  return NewKlass;
		};
	
		var PooledClass = {
		  addPoolingTo: addPoolingTo,
		  oneArgumentPooler: oneArgumentPooler,
		  twoArgumentPooler: twoArgumentPooler,
		  threeArgumentPooler: threeArgumentPooler,
		  fourArgumentPooler: fourArgumentPooler
		};
	
		module.exports = PooledClass;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 91 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var ReactCurrentOwner = __webpack_require__(43);
	
		var warning = __webpack_require__(18);
		var canDefineProperty = __webpack_require__(92);
		var hasOwnProperty = Object.prototype.hasOwnProperty;
	
		var REACT_ELEMENT_TYPE = __webpack_require__(93);
	
		var RESERVED_PROPS = {
		  key: true,
		  ref: true,
		  __self: true,
		  __source: true
		};
	
		var specialPropKeyWarningShown, specialPropRefWarningShown;
	
		function hasValidRef(config) {
		  if (process.env.NODE_ENV !== 'production') {
		    if (hasOwnProperty.call(config, 'ref')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }
		  return config.ref !== undefined;
		}
	
		function hasValidKey(config) {
		  if (process.env.NODE_ENV !== 'production') {
		    if (hasOwnProperty.call(config, 'key')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }
		  return config.key !== undefined;
		}
	
		function defineKeyPropWarningGetter(props, displayName) {
		  var warnAboutAccessingKey = function () {
		    if (!specialPropKeyWarningShown) {
		      specialPropKeyWarningShown = true;
		      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
		    }
		  };
		  warnAboutAccessingKey.isReactWarning = true;
		  Object.defineProperty(props, 'key', {
		    get: warnAboutAccessingKey,
		    configurable: true
		  });
		}
	
		function defineRefPropWarningGetter(props, displayName) {
		  var warnAboutAccessingRef = function () {
		    if (!specialPropRefWarningShown) {
		      specialPropRefWarningShown = true;
		      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
		    }
		  };
		  warnAboutAccessingRef.isReactWarning = true;
		  Object.defineProperty(props, 'ref', {
		    get: warnAboutAccessingRef,
		    configurable: true
		  });
		}
	
		/**
		 * Factory method to create a new React element. This no longer adheres to
		 * the class pattern, so do not use new to call it. Also, no instanceof check
		 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
		 * if something is a React Element.
		 *
		 * @param {*} type
		 * @param {*} key
		 * @param {string|object} ref
		 * @param {*} self A *temporary* helper to detect places where `this` is
		 * different from the `owner` when React.createElement is called, so that we
		 * can warn. We want to get rid of owner and replace string `ref`s with arrow
		 * functions, and as long as `this` and owner are the same, there will be no
		 * change in behavior.
		 * @param {*} source An annotation object (added by a transpiler or otherwise)
		 * indicating filename, line number, and/or other information.
		 * @param {*} owner
		 * @param {*} props
		 * @internal
		 */
		var ReactElement = function (type, key, ref, self, source, owner, props) {
		  var element = {
		    // This tag allow us to uniquely identify this as a React Element
		    $$typeof: REACT_ELEMENT_TYPE,
	
		    // Built-in properties that belong on the element
		    type: type,
		    key: key,
		    ref: ref,
		    props: props,
	
		    // Record the component responsible for creating this element.
		    _owner: owner
		  };
	
		  if (process.env.NODE_ENV !== 'production') {
		    // The validation flag is currently mutative. We put it on
		    // an external backing store so that we can freeze the whole object.
		    // This can be replaced with a WeakMap once they are implemented in
		    // commonly used development environments.
		    element._store = {};
	
		    // To make comparing ReactElements easier for testing purposes, we make
		    // the validation flag non-enumerable (where possible, which should
		    // include every environment we run tests in), so the test framework
		    // ignores it.
		    if (canDefineProperty) {
		      Object.defineProperty(element._store, 'validated', {
		        configurable: false,
		        enumerable: false,
		        writable: true,
		        value: false
		      });
		      // self and source are DEV only properties.
		      Object.defineProperty(element, '_self', {
		        configurable: false,
		        enumerable: false,
		        writable: false,
		        value: self
		      });
		      // Two elements created in two different places should be considered
		      // equal for testing purposes and therefore we hide it from enumeration.
		      Object.defineProperty(element, '_source', {
		        configurable: false,
		        enumerable: false,
		        writable: false,
		        value: source
		      });
		    } else {
		      element._store.validated = false;
		      element._self = self;
		      element._source = source;
		    }
		    if (Object.freeze) {
		      Object.freeze(element.props);
		      Object.freeze(element);
		    }
		  }
	
		  return element;
		};
	
		/**
		 * Create and return a new ReactElement of the given type.
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
		 */
		ReactElement.createElement = function (type, config, children) {
		  var propName;
	
		  // Reserved names are extracted
		  var props = {};
	
		  var key = null;
		  var ref = null;
		  var self = null;
		  var source = null;
	
		  if (config != null) {
		    if (hasValidRef(config)) {
		      ref = config.ref;
		    }
		    if (hasValidKey(config)) {
		      key = '' + config.key;
		    }
	
		    self = config.__self === undefined ? null : config.__self;
		    source = config.__source === undefined ? null : config.__source;
		    // Remaining properties are added to a new props object
		    for (propName in config) {
		      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
		        props[propName] = config[propName];
		      }
		    }
		  }
	
		  // Children can be more than one argument, and those are transferred onto
		  // the newly allocated props object.
		  var childrenLength = arguments.length - 2;
		  if (childrenLength === 1) {
		    props.children = children;
		  } else if (childrenLength > 1) {
		    var childArray = Array(childrenLength);
		    for (var i = 0; i < childrenLength; i++) {
		      childArray[i] = arguments[i + 2];
		    }
		    if (process.env.NODE_ENV !== 'production') {
		      if (Object.freeze) {
		        Object.freeze(childArray);
		      }
		    }
		    props.children = childArray;
		  }
	
		  // Resolve default props
		  if (type && type.defaultProps) {
		    var defaultProps = type.defaultProps;
		    for (propName in defaultProps) {
		      if (props[propName] === undefined) {
		        props[propName] = defaultProps[propName];
		      }
		    }
		  }
		  if (process.env.NODE_ENV !== 'production') {
		    if (key || ref) {
		      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
		        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
		        if (key) {
		          defineKeyPropWarningGetter(props, displayName);
		        }
		        if (ref) {
		          defineRefPropWarningGetter(props, displayName);
		        }
		      }
		    }
		  }
		  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
		};
	
		/**
		 * Return a function that produces ReactElements of a given type.
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
		 */
		ReactElement.createFactory = function (type) {
		  var factory = ReactElement.createElement.bind(null, type);
		  // Expose the type on the factory and the prototype so that it can be
		  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
		  // This should not be named `constructor` since this may not be the function
		  // that created the element, and it may not even be a constructor.
		  // Legacy hook TODO: Warn if this is accessed
		  factory.type = type;
		  return factory;
		};
	
		ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
		  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
		  return newElement;
		};
	
		/**
		 * Clone and return a new ReactElement using element as the starting point.
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
		 */
		ReactElement.cloneElement = function (element, config, children) {
		  var propName;
	
		  // Original props are copied
		  var props = _assign({}, element.props);
	
		  // Reserved names are extracted
		  var key = element.key;
		  var ref = element.ref;
		  // Self is preserved since the owner is preserved.
		  var self = element._self;
		  // Source is preserved since cloneElement is unlikely to be targeted by a
		  // transpiler, and the original source is probably a better indicator of the
		  // true owner.
		  var source = element._source;
	
		  // Owner will be preserved, unless ref is overridden
		  var owner = element._owner;
	
		  if (config != null) {
		    if (hasValidRef(config)) {
		      // Silently steal the ref from the parent.
		      ref = config.ref;
		      owner = ReactCurrentOwner.current;
		    }
		    if (hasValidKey(config)) {
		      key = '' + config.key;
		    }
	
		    // Remaining properties override existing props
		    var defaultProps;
		    if (element.type && element.type.defaultProps) {
		      defaultProps = element.type.defaultProps;
		    }
		    for (propName in config) {
		      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
		        if (config[propName] === undefined && defaultProps !== undefined) {
		          // Resolve default props
		          props[propName] = defaultProps[propName];
		        } else {
		          props[propName] = config[propName];
		        }
		      }
		    }
		  }
	
		  // Children can be more than one argument, and those are transferred onto
		  // the newly allocated props object.
		  var childrenLength = arguments.length - 2;
		  if (childrenLength === 1) {
		    props.children = children;
		  } else if (childrenLength > 1) {
		    var childArray = Array(childrenLength);
		    for (var i = 0; i < childrenLength; i++) {
		      childArray[i] = arguments[i + 2];
		    }
		    props.children = childArray;
		  }
	
		  return ReactElement(element.type, key, ref, self, source, owner, props);
		};
	
		/**
		 * Verifies the object is a ReactElement.
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
		 * @param {?object} object
		 * @return {boolean} True if `object` is a valid component.
		 * @final
		 */
		ReactElement.isValidElement = function (object) {
		  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		};
	
		module.exports = ReactElement;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 92 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var canDefineProperty = false;
		if (process.env.NODE_ENV !== 'production') {
		  try {
		    // $FlowFixMe https://github.com/facebook/flow/issues/285
		    Object.defineProperty({}, 'x', { get: function () {} });
		    canDefineProperty = true;
		  } catch (x) {
		    // IE will fail on defineProperty
		  }
		}
	
		module.exports = canDefineProperty;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 93 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		// The Symbol used to tag the ReactElement type. If there is no native Symbol
		// nor polyfill, then a plain number is used for performance.
	
		var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
		module.exports = REACT_ELEMENT_TYPE;
	
	/***/ },
	/* 94 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(42);
	
		var ReactCurrentOwner = __webpack_require__(43);
		var REACT_ELEMENT_TYPE = __webpack_require__(93);
	
		var getIteratorFn = __webpack_require__(95);
		var invariant = __webpack_require__(8);
		var KeyEscapeUtils = __webpack_require__(96);
		var warning = __webpack_require__(18);
	
		var SEPARATOR = '.';
		var SUBSEPARATOR = ':';
	
		/**
		 * This is inlined from ReactElement since this file is shared between
		 * isomorphic and renderers. We could extract this to a
		 *
		 */
	
		/**
		 * TODO: Test that a single child and an array with one item have the same key
		 * pattern.
		 */
	
		var didWarnAboutMaps = false;
	
		/**
		 * Generate a key string that identifies a component within a set.
		 *
		 * @param {*} component A component that could contain a manual key.
		 * @param {number} index Index that is used if a manual key is not provided.
		 * @return {string}
		 */
		function getComponentKey(component, index) {
		  // Do some typechecking here since we call this blindly. We want to ensure
		  // that we don't block potential future ES APIs.
		  if (component && typeof component === 'object' && component.key != null) {
		    // Explicit key
		    return KeyEscapeUtils.escape(component.key);
		  }
		  // Implicit key determined by the index in the set
		  return index.toString(36);
		}
	
		/**
		 * @param {?*} children Children tree container.
		 * @param {!string} nameSoFar Name of the key path so far.
		 * @param {!function} callback Callback to invoke with each child found.
		 * @param {?*} traverseContext Used to pass information throughout the traversal
		 * process.
		 * @return {!number} The number of children in this subtree.
		 */
		function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
		  var type = typeof children;
	
		  if (type === 'undefined' || type === 'boolean') {
		    // All of the above are perceived as null.
		    children = null;
		  }
	
		  if (children === null || type === 'string' || type === 'number' ||
		  // The following is inlined from ReactElement. This means we can optimize
		  // some checks. React Fiber also inlines this logic for similar purposes.
		  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
		    callback(traverseContext, children,
		    // If it's the only child, treat the name as if it was wrapped in an array
		    // so that it's consistent if the number of children grows.
		    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
		    return 1;
		  }
	
		  var child;
		  var nextName;
		  var subtreeCount = 0; // Count of children found in the current subtree.
		  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
		  if (Array.isArray(children)) {
		    for (var i = 0; i < children.length; i++) {
		      child = children[i];
		      nextName = nextNamePrefix + getComponentKey(child, i);
		      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
		    }
		  } else {
		    var iteratorFn = getIteratorFn(children);
		    if (iteratorFn) {
		      var iterator = iteratorFn.call(children);
		      var step;
		      if (iteratorFn !== children.entries) {
		        var ii = 0;
		        while (!(step = iterator.next()).done) {
		          child = step.value;
		          nextName = nextNamePrefix + getComponentKey(child, ii++);
		          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
		        }
		      } else {
		        if (process.env.NODE_ENV !== 'production') {
		          var mapsAsChildrenAddendum = '';
		          if (ReactCurrentOwner.current) {
		            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
		            if (mapsAsChildrenOwnerName) {
		              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
		            }
		          }
		          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
		          didWarnAboutMaps = true;
		        }
		        // Iterator will provide entry [k,v] tuples rather than values.
		        while (!(step = iterator.next()).done) {
		          var entry = step.value;
		          if (entry) {
		            child = entry[1];
		            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
		            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
		          }
		        }
		      }
		    } else if (type === 'object') {
		      var addendum = '';
		      if (process.env.NODE_ENV !== 'production') {
		        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
		        if (children._isReactElement) {
		          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
		        }
		        if (ReactCurrentOwner.current) {
		          var name = ReactCurrentOwner.current.getName();
		          if (name) {
		            addendum += ' Check the render method of `' + name + '`.';
		          }
		        }
		      }
		      var childrenString = String(children);
		       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
		    }
		  }
	
		  return subtreeCount;
		}
	
		/**
		 * Traverses children that are typically specified as `props.children`, but
		 * might also be specified through attributes:
		 *
		 * - `traverseAllChildren(this.props.children, ...)`
		 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
		 *
		 * The `traverseContext` is an optional argument that is passed through the
		 * entire traversal. It can be used to store accumulations or anything else that
		 * the callback might find relevant.
		 *
		 * @param {?*} children Children tree object.
		 * @param {!function} callback To invoke upon traversing each child.
		 * @param {?*} traverseContext Context for traversal.
		 * @return {!number} The number of children in this subtree.
		 */
		function traverseAllChildren(children, callback, traverseContext) {
		  if (children == null) {
		    return 0;
		  }
	
		  return traverseAllChildrenImpl(children, '', callback, traverseContext);
		}
	
		module.exports = traverseAllChildren;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 95 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		/* global Symbol */
	
		var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		/**
		 * Returns the iterator method function contained on the iterable object.
		 *
		 * Be sure to invoke the function with the iterable as context:
		 *
		 *     var iteratorFn = getIteratorFn(myIterable);
		 *     if (iteratorFn) {
		 *       var iterator = iteratorFn.call(myIterable);
		 *       ...
		 *     }
		 *
		 * @param {?object} maybeIterable
		 * @return {?function}
		 */
		function getIteratorFn(maybeIterable) {
		  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		  if (typeof iteratorFn === 'function') {
		    return iteratorFn;
		  }
		}
	
		module.exports = getIteratorFn;
	
	/***/ },
	/* 96 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		/**
		 * Escape and wrap key so it is safe to use as a reactid
		 *
		 * @param {string} key to be escaped.
		 * @return {string} the escaped key.
		 */
	
		function escape(key) {
		  var escapeRegex = /[=:]/g;
		  var escaperLookup = {
		    '=': '=0',
		    ':': '=2'
		  };
		  var escapedString = ('' + key).replace(escapeRegex, function (match) {
		    return escaperLookup[match];
		  });
	
		  return '$' + escapedString;
		}
	
		/**
		 * Unescape and unwrap key for human-readable display
		 *
		 * @param {string} key to unescape.
		 * @return {string} the unescaped key.
		 */
		function unescape(key) {
		  var unescapeRegex = /(=0|=2)/g;
		  var unescaperLookup = {
		    '=0': '=',
		    '=2': ':'
		  };
		  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
		  return ('' + keySubstring).replace(unescapeRegex, function (match) {
		    return unescaperLookup[match];
		  });
		}
	
		var KeyEscapeUtils = {
		  escape: escape,
		  unescape: unescape
		};
	
		module.exports = KeyEscapeUtils;
	
	/***/ },
	/* 97 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(42);
	
		var ReactNoopUpdateQueue = __webpack_require__(98);
	
		var canDefineProperty = __webpack_require__(92);
		var emptyObject = __webpack_require__(99);
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		/**
		 * Base class helpers for the updating state of a component.
		 */
		function ReactComponent(props, context, updater) {
		  this.props = props;
		  this.context = context;
		  this.refs = emptyObject;
		  // We initialize the default updater but the real one gets injected by the
		  // renderer.
		  this.updater = updater || ReactNoopUpdateQueue;
		}
	
		ReactComponent.prototype.isReactComponent = {};
	
		/**
		 * Sets a subset of the state. Always use this to mutate
		 * state. You should treat `this.state` as immutable.
		 *
		 * There is no guarantee that `this.state` will be immediately updated, so
		 * accessing `this.state` after calling this method may return the old value.
		 *
		 * There is no guarantee that calls to `setState` will run synchronously,
		 * as they may eventually be batched together.  You can provide an optional
		 * callback that will be executed when the call to setState is actually
		 * completed.
		 *
		 * When a function is provided to setState, it will be called at some point in
		 * the future (not synchronously). It will be called with the up to date
		 * component arguments (state, props, context). These values can be different
		 * from this.* because your function may be called after receiveProps but before
		 * shouldComponentUpdate, and this new state, props, and context will not yet be
		 * assigned to this.
		 *
		 * @param {object|function} partialState Next partial state or function to
		 *        produce next partial state to be merged with current state.
		 * @param {?function} callback Called after state is updated.
		 * @final
		 * @protected
		 */
		ReactComponent.prototype.setState = function (partialState, callback) {
		  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
		  this.updater.enqueueSetState(this, partialState);
		  if (callback) {
		    this.updater.enqueueCallback(this, callback, 'setState');
		  }
		};
	
		/**
		 * Forces an update. This should only be invoked when it is known with
		 * certainty that we are **not** in a DOM transaction.
		 *
		 * You may want to call this when you know that some deeper aspect of the
		 * component's state has changed but `setState` was not called.
		 *
		 * This will not invoke `shouldComponentUpdate`, but it will invoke
		 * `componentWillUpdate` and `componentDidUpdate`.
		 *
		 * @param {?function} callback Called after update is complete.
		 * @final
		 * @protected
		 */
		ReactComponent.prototype.forceUpdate = function (callback) {
		  this.updater.enqueueForceUpdate(this);
		  if (callback) {
		    this.updater.enqueueCallback(this, callback, 'forceUpdate');
		  }
		};
	
		/**
		 * Deprecated APIs. These APIs used to exist on classic React classes but since
		 * we would like to deprecate them, we're not going to move them over to this
		 * modern base class. Instead, we define a getter that warns if it's accessed.
		 */
		if (process.env.NODE_ENV !== 'production') {
		  var deprecatedAPIs = {
		    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
		    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
		  };
		  var defineDeprecationWarning = function (methodName, info) {
		    if (canDefineProperty) {
		      Object.defineProperty(ReactComponent.prototype, methodName, {
		        get: function () {
		          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
		          return undefined;
		        }
		      });
		    }
		  };
		  for (var fnName in deprecatedAPIs) {
		    if (deprecatedAPIs.hasOwnProperty(fnName)) {
		      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
		    }
		  }
		}
	
		module.exports = ReactComponent;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 98 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2015-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var warning = __webpack_require__(18);
	
		function warnNoop(publicInstance, callerName) {
		  if (process.env.NODE_ENV !== 'production') {
		    var constructor = publicInstance.constructor;
		    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
		  }
		}
	
		/**
		 * This is the abstract API for an update queue.
		 */
		var ReactNoopUpdateQueue = {
	
		  /**
		   * Checks whether or not this composite component is mounted.
		   * @param {ReactClass} publicInstance The instance we want to test.
		   * @return {boolean} True if mounted, false otherwise.
		   * @protected
		   * @final
		   */
		  isMounted: function (publicInstance) {
		    return false;
		  },
	
		  /**
		   * Enqueue a callback that will be executed after all the pending updates
		   * have processed.
		   *
		   * @param {ReactClass} publicInstance The instance to use as `this` context.
		   * @param {?function} callback Called after state is updated.
		   * @internal
		   */
		  enqueueCallback: function (publicInstance, callback) {},
	
		  /**
		   * Forces an update. This should only be invoked when it is known with
		   * certainty that we are **not** in a DOM transaction.
		   *
		   * You may want to call this when you know that some deeper aspect of the
		   * component's state has changed but `setState` was not called.
		   *
		   * This will not invoke `shouldComponentUpdate`, but it will invoke
		   * `componentWillUpdate` and `componentDidUpdate`.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @internal
		   */
		  enqueueForceUpdate: function (publicInstance) {
		    warnNoop(publicInstance, 'forceUpdate');
		  },
	
		  /**
		   * Replaces all of the state. Always use this or `setState` to mutate state.
		   * You should treat `this.state` as immutable.
		   *
		   * There is no guarantee that `this.state` will be immediately updated, so
		   * accessing `this.state` after calling this method may return the old value.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {object} completeState Next state.
		   * @internal
		   */
		  enqueueReplaceState: function (publicInstance, completeState) {
		    warnNoop(publicInstance, 'replaceState');
		  },
	
		  /**
		   * Sets a subset of the state. This only exists because _pendingState is
		   * internal. This provides a merging strategy that is not available to deep
		   * properties which is confusing. TODO: Expose pendingState or don't use it
		   * during the merge.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {object} partialState Next partial state to be merged with state.
		   * @internal
		   */
		  enqueueSetState: function (publicInstance, partialState) {
		    warnNoop(publicInstance, 'setState');
		  }
		};
	
		module.exports = ReactNoopUpdateQueue;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 99 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyObject = {};
	
		if (process.env.NODE_ENV !== 'production') {
		  Object.freeze(emptyObject);
		}
	
		module.exports = emptyObject;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 100 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var ReactComponent = __webpack_require__(97);
		var ReactNoopUpdateQueue = __webpack_require__(98);
	
		var emptyObject = __webpack_require__(99);
	
		/**
		 * Base class helpers for the updating state of a component.
		 */
		function ReactPureComponent(props, context, updater) {
		  // Duplicated from ReactComponent.
		  this.props = props;
		  this.context = context;
		  this.refs = emptyObject;
		  // We initialize the default updater but the real one gets injected by the
		  // renderer.
		  this.updater = updater || ReactNoopUpdateQueue;
		}
	
		function ComponentDummy() {}
		ComponentDummy.prototype = ReactComponent.prototype;
		ReactPureComponent.prototype = new ComponentDummy();
		ReactPureComponent.prototype.constructor = ReactPureComponent;
		// Avoid an extra prototype jump for these methods.
		_assign(ReactPureComponent.prototype, ReactComponent.prototype);
		ReactPureComponent.prototype.isPureReactComponent = true;
	
		module.exports = ReactPureComponent;
	
	/***/ },
	/* 101 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(42),
		    _assign = __webpack_require__(24);
	
		var ReactComponent = __webpack_require__(97);
		var ReactElement = __webpack_require__(91);
		var ReactPropTypeLocationNames = __webpack_require__(102);
		var ReactNoopUpdateQueue = __webpack_require__(98);
	
		var emptyObject = __webpack_require__(99);
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		var MIXINS_KEY = 'mixins';
	
		// Helper function to allow the creation of anonymous functions which do not
		// have .name set to the name of the variable being assigned to.
		function identity(fn) {
		  return fn;
		}
	
		/**
		 * Policies that describe methods in `ReactClassInterface`.
		 */
	
	
		var injectedMixins = [];
	
		/**
		 * Composite components are higher-level components that compose other composite
		 * or host components.
		 *
		 * To create a new type of `ReactClass`, pass a specification of
		 * your new class to `React.createClass`. The only requirement of your class
		 * specification is that you implement a `render` method.
		 *
		 *   var MyComponent = React.createClass({
		 *     render: function() {
		 *       return <div>Hello World</div>;
		 *     }
		 *   });
		 *
		 * The class specification supports a specific protocol of methods that have
		 * special meaning (e.g. `render`). See `ReactClassInterface` for
		 * more the comprehensive protocol. Any other properties and methods in the
		 * class specification will be available on the prototype.
		 *
		 * @interface ReactClassInterface
		 * @internal
		 */
		var ReactClassInterface = {
	
		  /**
		   * An array of Mixin objects to include when defining your component.
		   *
		   * @type {array}
		   * @optional
		   */
		  mixins: 'DEFINE_MANY',
	
		  /**
		   * An object containing properties and methods that should be defined on
		   * the component's constructor instead of its prototype (static methods).
		   *
		   * @type {object}
		   * @optional
		   */
		  statics: 'DEFINE_MANY',
	
		  /**
		   * Definition of prop types for this component.
		   *
		   * @type {object}
		   * @optional
		   */
		  propTypes: 'DEFINE_MANY',
	
		  /**
		   * Definition of context types for this component.
		   *
		   * @type {object}
		   * @optional
		   */
		  contextTypes: 'DEFINE_MANY',
	
		  /**
		   * Definition of context types this component sets for its children.
		   *
		   * @type {object}
		   * @optional
		   */
		  childContextTypes: 'DEFINE_MANY',
	
		  // ==== Definition methods ====
	
		  /**
		   * Invoked when the component is mounted. Values in the mapping will be set on
		   * `this.props` if that prop is not specified (i.e. using an `in` check).
		   *
		   * This method is invoked before `getInitialState` and therefore cannot rely
		   * on `this.state` or use `this.setState`.
		   *
		   * @return {object}
		   * @optional
		   */
		  getDefaultProps: 'DEFINE_MANY_MERGED',
	
		  /**
		   * Invoked once before the component is mounted. The return value will be used
		   * as the initial value of `this.state`.
		   *
		   *   getInitialState: function() {
		   *     return {
		   *       isOn: false,
		   *       fooBaz: new BazFoo()
		   *     }
		   *   }
		   *
		   * @return {object}
		   * @optional
		   */
		  getInitialState: 'DEFINE_MANY_MERGED',
	
		  /**
		   * @return {object}
		   * @optional
		   */
		  getChildContext: 'DEFINE_MANY_MERGED',
	
		  /**
		   * Uses props from `this.props` and state from `this.state` to render the
		   * structure of the component.
		   *
		   * No guarantees are made about when or how often this method is invoked, so
		   * it must not have side effects.
		   *
		   *   render: function() {
		   *     var name = this.props.name;
		   *     return <div>Hello, {name}!</div>;
		   *   }
		   *
		   * @return {ReactComponent}
		   * @nosideeffects
		   * @required
		   */
		  render: 'DEFINE_ONCE',
	
		  // ==== Delegate methods ====
	
		  /**
		   * Invoked when the component is initially created and about to be mounted.
		   * This may have side effects, but any external subscriptions or data created
		   * by this method must be cleaned up in `componentWillUnmount`.
		   *
		   * @optional
		   */
		  componentWillMount: 'DEFINE_MANY',
	
		  /**
		   * Invoked when the component has been mounted and has a DOM representation.
		   * However, there is no guarantee that the DOM node is in the document.
		   *
		   * Use this as an opportunity to operate on the DOM when the component has
		   * been mounted (initialized and rendered) for the first time.
		   *
		   * @param {DOMElement} rootNode DOM element representing the component.
		   * @optional
		   */
		  componentDidMount: 'DEFINE_MANY',
	
		  /**
		   * Invoked before the component receives new props.
		   *
		   * Use this as an opportunity to react to a prop transition by updating the
		   * state using `this.setState`. Current props are accessed via `this.props`.
		   *
		   *   componentWillReceiveProps: function(nextProps, nextContext) {
		   *     this.setState({
		   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
		   *     });
		   *   }
		   *
		   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
		   * transition may cause a state change, but the opposite is not true. If you
		   * need it, you are probably looking for `componentWillUpdate`.
		   *
		   * @param {object} nextProps
		   * @optional
		   */
		  componentWillReceiveProps: 'DEFINE_MANY',
	
		  /**
		   * Invoked while deciding if the component should be updated as a result of
		   * receiving new props, state and/or context.
		   *
		   * Use this as an opportunity to `return false` when you're certain that the
		   * transition to the new props/state/context will not require a component
		   * update.
		   *
		   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
		   *     return !equal(nextProps, this.props) ||
		   *       !equal(nextState, this.state) ||
		   *       !equal(nextContext, this.context);
		   *   }
		   *
		   * @param {object} nextProps
		   * @param {?object} nextState
		   * @param {?object} nextContext
		   * @return {boolean} True if the component should update.
		   * @optional
		   */
		  shouldComponentUpdate: 'DEFINE_ONCE',
	
		  /**
		   * Invoked when the component is about to update due to a transition from
		   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
		   * and `nextContext`.
		   *
		   * Use this as an opportunity to perform preparation before an update occurs.
		   *
		   * NOTE: You **cannot** use `this.setState()` in this method.
		   *
		   * @param {object} nextProps
		   * @param {?object} nextState
		   * @param {?object} nextContext
		   * @param {ReactReconcileTransaction} transaction
		   * @optional
		   */
		  componentWillUpdate: 'DEFINE_MANY',
	
		  /**
		   * Invoked when the component's DOM representation has been updated.
		   *
		   * Use this as an opportunity to operate on the DOM when the component has
		   * been updated.
		   *
		   * @param {object} prevProps
		   * @param {?object} prevState
		   * @param {?object} prevContext
		   * @param {DOMElement} rootNode DOM element representing the component.
		   * @optional
		   */
		  componentDidUpdate: 'DEFINE_MANY',
	
		  /**
		   * Invoked when the component is about to be removed from its parent and have
		   * its DOM representation destroyed.
		   *
		   * Use this as an opportunity to deallocate any external resources.
		   *
		   * NOTE: There is no `componentDidUnmount` since your component will have been
		   * destroyed by that point.
		   *
		   * @optional
		   */
		  componentWillUnmount: 'DEFINE_MANY',
	
		  // ==== Advanced methods ====
	
		  /**
		   * Updates the component's currently mounted DOM representation.
		   *
		   * By default, this implements React's rendering and reconciliation algorithm.
		   * Sophisticated clients may wish to override this.
		   *
		   * @param {ReactReconcileTransaction} transaction
		   * @internal
		   * @overridable
		   */
		  updateComponent: 'OVERRIDE_BASE'
	
		};
	
		/**
		 * Mapping from class specification keys to special processing functions.
		 *
		 * Although these are declared like instance properties in the specification
		 * when defining classes using `React.createClass`, they are actually static
		 * and are accessible on the constructor instead of the prototype. Despite
		 * being static, they must be defined outside of the "statics" key under
		 * which all other static methods are defined.
		 */
		var RESERVED_SPEC_KEYS = {
		  displayName: function (Constructor, displayName) {
		    Constructor.displayName = displayName;
		  },
		  mixins: function (Constructor, mixins) {
		    if (mixins) {
		      for (var i = 0; i < mixins.length; i++) {
		        mixSpecIntoComponent(Constructor, mixins[i]);
		      }
		    }
		  },
		  childContextTypes: function (Constructor, childContextTypes) {
		    if (process.env.NODE_ENV !== 'production') {
		      validateTypeDef(Constructor, childContextTypes, 'childContext');
		    }
		    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
		  },
		  contextTypes: function (Constructor, contextTypes) {
		    if (process.env.NODE_ENV !== 'production') {
		      validateTypeDef(Constructor, contextTypes, 'context');
		    }
		    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
		  },
		  /**
		   * Special case getDefaultProps which should move into statics but requires
		   * automatic merging.
		   */
		  getDefaultProps: function (Constructor, getDefaultProps) {
		    if (Constructor.getDefaultProps) {
		      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
		    } else {
		      Constructor.getDefaultProps = getDefaultProps;
		    }
		  },
		  propTypes: function (Constructor, propTypes) {
		    if (process.env.NODE_ENV !== 'production') {
		      validateTypeDef(Constructor, propTypes, 'prop');
		    }
		    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
		  },
		  statics: function (Constructor, statics) {
		    mixStaticSpecIntoComponent(Constructor, statics);
		  },
		  autobind: function () {} };
	
		function validateTypeDef(Constructor, typeDef, location) {
		  for (var propName in typeDef) {
		    if (typeDef.hasOwnProperty(propName)) {
		      // use a warning instead of an invariant so components
		      // don't show up in prod but only in __DEV__
		      process.env.NODE_ENV !== 'production' ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
		    }
		  }
		}
	
		function validateMethodOverride(isAlreadyDefined, name) {
		  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
		  // Disallow overriding of base class methods unless explicitly allowed.
		  if (ReactClassMixin.hasOwnProperty(name)) {
		    !(specPolicy === 'OVERRIDE_BASE') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
		  }
	
		  // Disallow defining methods more than once unless explicitly allowed.
		  if (isAlreadyDefined) {
		    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
		  }
		}
	
		/**
		 * Mixin helper which handles policy validation and reserved
		 * specification keys when building React classes.
		 */
		function mixSpecIntoComponent(Constructor, spec) {
		  if (!spec) {
		    if (process.env.NODE_ENV !== 'production') {
		      var typeofSpec = typeof spec;
		      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
		      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
		    }
	
		    return;
		  }
	
		  !(typeof spec !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
		  !!ReactElement.isValidElement(spec) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
		  var proto = Constructor.prototype;
		  var autoBindPairs = proto.__reactAutoBindPairs;
	
		  // By handling mixins before any other properties, we ensure the same
		  // chaining order is applied to methods with DEFINE_MANY policy, whether
		  // mixins are listed before or after these methods in the spec.
		  if (spec.hasOwnProperty(MIXINS_KEY)) {
		    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
		  }
	
		  for (var name in spec) {
		    if (!spec.hasOwnProperty(name)) {
		      continue;
		    }
	
		    if (name === MIXINS_KEY) {
		      // We have already handled mixins in a special case above.
		      continue;
		    }
	
		    var property = spec[name];
		    var isAlreadyDefined = proto.hasOwnProperty(name);
		    validateMethodOverride(isAlreadyDefined, name);
	
		    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
		      RESERVED_SPEC_KEYS[name](Constructor, property);
		    } else {
		      // Setup methods on prototype:
		      // The following member methods should not be automatically bound:
		      // 1. Expected ReactClass methods (in the "interface").
		      // 2. Overridden methods (that were mixed in).
		      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
		      var isFunction = typeof property === 'function';
		      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
		      if (shouldAutoBind) {
		        autoBindPairs.push(name, property);
		        proto[name] = property;
		      } else {
		        if (isAlreadyDefined) {
		          var specPolicy = ReactClassInterface[name];
	
		          // These cases should already be caught by validateMethodOverride.
		          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
		          // For methods which are defined more than once, call the existing
		          // methods before calling the new property, merging if appropriate.
		          if (specPolicy === 'DEFINE_MANY_MERGED') {
		            proto[name] = createMergedResultFunction(proto[name], property);
		          } else if (specPolicy === 'DEFINE_MANY') {
		            proto[name] = createChainedFunction(proto[name], property);
		          }
		        } else {
		          proto[name] = property;
		          if (process.env.NODE_ENV !== 'production') {
		            // Add verbose displayName to the function, which helps when looking
		            // at profiling tools.
		            if (typeof property === 'function' && spec.displayName) {
		              proto[name].displayName = spec.displayName + '_' + name;
		            }
		          }
		        }
		      }
		    }
		  }
		}
	
		function mixStaticSpecIntoComponent(Constructor, statics) {
		  if (!statics) {
		    return;
		  }
		  for (var name in statics) {
		    var property = statics[name];
		    if (!statics.hasOwnProperty(name)) {
		      continue;
		    }
	
		    var isReserved = name in RESERVED_SPEC_KEYS;
		    !!isReserved ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
		    var isInherited = name in Constructor;
		    !!isInherited ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
		    Constructor[name] = property;
		  }
		}
	
		/**
		 * Merge two objects, but throw if both contain the same key.
		 *
		 * @param {object} one The first object, which is mutated.
		 * @param {object} two The second object
		 * @return {object} one after it has been mutated to contain everything in two.
		 */
		function mergeIntoWithNoDuplicateKeys(one, two) {
		  !(one && two && typeof one === 'object' && typeof two === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
		  for (var key in two) {
		    if (two.hasOwnProperty(key)) {
		      !(one[key] === undefined) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
		      one[key] = two[key];
		    }
		  }
		  return one;
		}
	
		/**
		 * Creates a function that invokes two functions and merges their return values.
		 *
		 * @param {function} one Function to invoke first.
		 * @param {function} two Function to invoke second.
		 * @return {function} Function that invokes the two argument functions.
		 * @private
		 */
		function createMergedResultFunction(one, two) {
		  return function mergedResult() {
		    var a = one.apply(this, arguments);
		    var b = two.apply(this, arguments);
		    if (a == null) {
		      return b;
		    } else if (b == null) {
		      return a;
		    }
		    var c = {};
		    mergeIntoWithNoDuplicateKeys(c, a);
		    mergeIntoWithNoDuplicateKeys(c, b);
		    return c;
		  };
		}
	
		/**
		 * Creates a function that invokes two functions and ignores their return vales.
		 *
		 * @param {function} one Function to invoke first.
		 * @param {function} two Function to invoke second.
		 * @return {function} Function that invokes the two argument functions.
		 * @private
		 */
		function createChainedFunction(one, two) {
		  return function chainedFunction() {
		    one.apply(this, arguments);
		    two.apply(this, arguments);
		  };
		}
	
		/**
		 * Binds a method to the component.
		 *
		 * @param {object} component Component whose method is going to be bound.
		 * @param {function} method Method to be bound.
		 * @return {function} The bound method.
		 */
		function bindAutoBindMethod(component, method) {
		  var boundMethod = method.bind(component);
		  if (process.env.NODE_ENV !== 'production') {
		    boundMethod.__reactBoundContext = component;
		    boundMethod.__reactBoundMethod = method;
		    boundMethod.__reactBoundArguments = null;
		    var componentName = component.constructor.displayName;
		    var _bind = boundMethod.bind;
		    boundMethod.bind = function (newThis) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
	
		      // User is trying to bind() an autobound method; we effectively will
		      // ignore the value of "this" that the user is trying to use, so
		      // let's warn.
		      if (newThis !== component && newThis !== null) {
		        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
		      } else if (!args.length) {
		        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
		        return boundMethod;
		      }
		      var reboundMethod = _bind.apply(boundMethod, arguments);
		      reboundMethod.__reactBoundContext = component;
		      reboundMethod.__reactBoundMethod = method;
		      reboundMethod.__reactBoundArguments = args;
		      return reboundMethod;
		    };
		  }
		  return boundMethod;
		}
	
		/**
		 * Binds all auto-bound methods in a component.
		 *
		 * @param {object} component Component whose method is going to be bound.
		 */
		function bindAutoBindMethods(component) {
		  var pairs = component.__reactAutoBindPairs;
		  for (var i = 0; i < pairs.length; i += 2) {
		    var autoBindKey = pairs[i];
		    var method = pairs[i + 1];
		    component[autoBindKey] = bindAutoBindMethod(component, method);
		  }
		}
	
		/**
		 * Add more to the ReactClass base class. These are all legacy features and
		 * therefore not already part of the modern ReactComponent.
		 */
		var ReactClassMixin = {
	
		  /**
		   * TODO: This will be deprecated because state should always keep a consistent
		   * type signature and the only use case for this, is to avoid that.
		   */
		  replaceState: function (newState, callback) {
		    this.updater.enqueueReplaceState(this, newState);
		    if (callback) {
		      this.updater.enqueueCallback(this, callback, 'replaceState');
		    }
		  },
	
		  /**
		   * Checks whether or not this composite component is mounted.
		   * @return {boolean} True if mounted, false otherwise.
		   * @protected
		   * @final
		   */
		  isMounted: function () {
		    return this.updater.isMounted(this);
		  }
		};
	
		var ReactClassComponent = function () {};
		_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
		/**
		 * Module for creating composite components.
		 *
		 * @class ReactClass
		 */
		var ReactClass = {
	
		  /**
		   * Creates a composite component class given a class specification.
		   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
		   *
		   * @param {object} spec Class specification (which must define `render`).
		   * @return {function} Component constructor function.
		   * @public
		   */
		  createClass: function (spec) {
		    // To keep our warnings more understandable, we'll use a little hack here to
		    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
		    // unnecessarily identify a class without displayName as 'Constructor'.
		    var Constructor = identity(function (props, context, updater) {
		      // This constructor gets overridden by mocks. The argument is used
		      // by mocks to assert on what gets mounted.
	
		      if (process.env.NODE_ENV !== 'production') {
		        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
		      }
	
		      // Wire up auto-binding
		      if (this.__reactAutoBindPairs.length) {
		        bindAutoBindMethods(this);
		      }
	
		      this.props = props;
		      this.context = context;
		      this.refs = emptyObject;
		      this.updater = updater || ReactNoopUpdateQueue;
	
		      this.state = null;
	
		      // ReactClasses doesn't have constructors. Instead, they use the
		      // getInitialState and componentWillMount methods for initialization.
	
		      var initialState = this.getInitialState ? this.getInitialState() : null;
		      if (process.env.NODE_ENV !== 'production') {
		        // We allow auto-mocks to proceed as if they're returning null.
		        if (initialState === undefined && this.getInitialState._isMockFunction) {
		          // This is probably bad practice. Consider warning here and
		          // deprecating this convenience.
		          initialState = null;
		        }
		      }
		      !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
		      this.state = initialState;
		    });
		    Constructor.prototype = new ReactClassComponent();
		    Constructor.prototype.constructor = Constructor;
		    Constructor.prototype.__reactAutoBindPairs = [];
	
		    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
		    mixSpecIntoComponent(Constructor, spec);
	
		    // Initialize the defaultProps property after all mixins have been merged.
		    if (Constructor.getDefaultProps) {
		      Constructor.defaultProps = Constructor.getDefaultProps();
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      // This is a tag to indicate that the use of these method names is ok,
		      // since it's used with createClass. If it's not, then it's likely a
		      // mistake so we'll warn you to use the static property, property
		      // initializer or constructor respectively.
		      if (Constructor.getDefaultProps) {
		        Constructor.getDefaultProps.isReactClassApproved = {};
		      }
		      if (Constructor.prototype.getInitialState) {
		        Constructor.prototype.getInitialState.isReactClassApproved = {};
		      }
		    }
	
		    !Constructor.prototype.render ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
		    if (process.env.NODE_ENV !== 'production') {
		      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
		      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
		    }
	
		    // Reduce time spent doing lookups by setting these on the prototype.
		    for (var methodName in ReactClassInterface) {
		      if (!Constructor.prototype[methodName]) {
		        Constructor.prototype[methodName] = null;
		      }
		    }
	
		    return Constructor;
		  },
	
		  injection: {
		    injectMixin: function (mixin) {
		      injectedMixins.push(mixin);
		    }
		  }
	
		};
	
		module.exports = ReactClass;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 102 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var ReactPropTypeLocationNames = {};
	
		if (process.env.NODE_ENV !== 'production') {
		  ReactPropTypeLocationNames = {
		    prop: 'prop',
		    context: 'context',
		    childContext: 'child context'
		  };
		}
	
		module.exports = ReactPropTypeLocationNames;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 103 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactElement = __webpack_require__(91);
	
		/**
		 * Create a factory that creates HTML tag elements.
		 *
		 * @private
		 */
		var createDOMFactory = ReactElement.createFactory;
		if (process.env.NODE_ENV !== 'production') {
		  var ReactElementValidator = __webpack_require__(104);
		  createDOMFactory = ReactElementValidator.createFactory;
		}
	
		/**
		 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
		 * This is also accessible via `React.DOM`.
		 *
		 * @public
		 */
		var ReactDOMFactories = {
		  a: createDOMFactory('a'),
		  abbr: createDOMFactory('abbr'),
		  address: createDOMFactory('address'),
		  area: createDOMFactory('area'),
		  article: createDOMFactory('article'),
		  aside: createDOMFactory('aside'),
		  audio: createDOMFactory('audio'),
		  b: createDOMFactory('b'),
		  base: createDOMFactory('base'),
		  bdi: createDOMFactory('bdi'),
		  bdo: createDOMFactory('bdo'),
		  big: createDOMFactory('big'),
		  blockquote: createDOMFactory('blockquote'),
		  body: createDOMFactory('body'),
		  br: createDOMFactory('br'),
		  button: createDOMFactory('button'),
		  canvas: createDOMFactory('canvas'),
		  caption: createDOMFactory('caption'),
		  cite: createDOMFactory('cite'),
		  code: createDOMFactory('code'),
		  col: createDOMFactory('col'),
		  colgroup: createDOMFactory('colgroup'),
		  data: createDOMFactory('data'),
		  datalist: createDOMFactory('datalist'),
		  dd: createDOMFactory('dd'),
		  del: createDOMFactory('del'),
		  details: createDOMFactory('details'),
		  dfn: createDOMFactory('dfn'),
		  dialog: createDOMFactory('dialog'),
		  div: createDOMFactory('div'),
		  dl: createDOMFactory('dl'),
		  dt: createDOMFactory('dt'),
		  em: createDOMFactory('em'),
		  embed: createDOMFactory('embed'),
		  fieldset: createDOMFactory('fieldset'),
		  figcaption: createDOMFactory('figcaption'),
		  figure: createDOMFactory('figure'),
		  footer: createDOMFactory('footer'),
		  form: createDOMFactory('form'),
		  h1: createDOMFactory('h1'),
		  h2: createDOMFactory('h2'),
		  h3: createDOMFactory('h3'),
		  h4: createDOMFactory('h4'),
		  h5: createDOMFactory('h5'),
		  h6: createDOMFactory('h6'),
		  head: createDOMFactory('head'),
		  header: createDOMFactory('header'),
		  hgroup: createDOMFactory('hgroup'),
		  hr: createDOMFactory('hr'),
		  html: createDOMFactory('html'),
		  i: createDOMFactory('i'),
		  iframe: createDOMFactory('iframe'),
		  img: createDOMFactory('img'),
		  input: createDOMFactory('input'),
		  ins: createDOMFactory('ins'),
		  kbd: createDOMFactory('kbd'),
		  keygen: createDOMFactory('keygen'),
		  label: createDOMFactory('label'),
		  legend: createDOMFactory('legend'),
		  li: createDOMFactory('li'),
		  link: createDOMFactory('link'),
		  main: createDOMFactory('main'),
		  map: createDOMFactory('map'),
		  mark: createDOMFactory('mark'),
		  menu: createDOMFactory('menu'),
		  menuitem: createDOMFactory('menuitem'),
		  meta: createDOMFactory('meta'),
		  meter: createDOMFactory('meter'),
		  nav: createDOMFactory('nav'),
		  noscript: createDOMFactory('noscript'),
		  object: createDOMFactory('object'),
		  ol: createDOMFactory('ol'),
		  optgroup: createDOMFactory('optgroup'),
		  option: createDOMFactory('option'),
		  output: createDOMFactory('output'),
		  p: createDOMFactory('p'),
		  param: createDOMFactory('param'),
		  picture: createDOMFactory('picture'),
		  pre: createDOMFactory('pre'),
		  progress: createDOMFactory('progress'),
		  q: createDOMFactory('q'),
		  rp: createDOMFactory('rp'),
		  rt: createDOMFactory('rt'),
		  ruby: createDOMFactory('ruby'),
		  s: createDOMFactory('s'),
		  samp: createDOMFactory('samp'),
		  script: createDOMFactory('script'),
		  section: createDOMFactory('section'),
		  select: createDOMFactory('select'),
		  small: createDOMFactory('small'),
		  source: createDOMFactory('source'),
		  span: createDOMFactory('span'),
		  strong: createDOMFactory('strong'),
		  style: createDOMFactory('style'),
		  sub: createDOMFactory('sub'),
		  summary: createDOMFactory('summary'),
		  sup: createDOMFactory('sup'),
		  table: createDOMFactory('table'),
		  tbody: createDOMFactory('tbody'),
		  td: createDOMFactory('td'),
		  textarea: createDOMFactory('textarea'),
		  tfoot: createDOMFactory('tfoot'),
		  th: createDOMFactory('th'),
		  thead: createDOMFactory('thead'),
		  time: createDOMFactory('time'),
		  title: createDOMFactory('title'),
		  tr: createDOMFactory('tr'),
		  track: createDOMFactory('track'),
		  u: createDOMFactory('u'),
		  ul: createDOMFactory('ul'),
		  'var': createDOMFactory('var'),
		  video: createDOMFactory('video'),
		  wbr: createDOMFactory('wbr'),
	
		  // SVG
		  circle: createDOMFactory('circle'),
		  clipPath: createDOMFactory('clipPath'),
		  defs: createDOMFactory('defs'),
		  ellipse: createDOMFactory('ellipse'),
		  g: createDOMFactory('g'),
		  image: createDOMFactory('image'),
		  line: createDOMFactory('line'),
		  linearGradient: createDOMFactory('linearGradient'),
		  mask: createDOMFactory('mask'),
		  path: createDOMFactory('path'),
		  pattern: createDOMFactory('pattern'),
		  polygon: createDOMFactory('polygon'),
		  polyline: createDOMFactory('polyline'),
		  radialGradient: createDOMFactory('radialGradient'),
		  rect: createDOMFactory('rect'),
		  stop: createDOMFactory('stop'),
		  svg: createDOMFactory('svg'),
		  text: createDOMFactory('text'),
		  tspan: createDOMFactory('tspan')
		};
	
		module.exports = ReactDOMFactories;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 104 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		/**
		 * ReactElementValidator provides a wrapper around a element factory
		 * which validates the props passed to the element. This is intended to be
		 * used only in DEV and could be replaced by a static type checker for languages
		 * that support it.
		 */
	
		'use strict';
	
		var ReactCurrentOwner = __webpack_require__(43);
		var ReactComponentTreeHook = __webpack_require__(41);
		var ReactElement = __webpack_require__(91);
	
		var checkReactTypeSpec = __webpack_require__(105);
	
		var canDefineProperty = __webpack_require__(92);
		var getIteratorFn = __webpack_require__(95);
		var warning = __webpack_require__(18);
	
		function getDeclarationErrorAddendum() {
		  if (ReactCurrentOwner.current) {
		    var name = ReactCurrentOwner.current.getName();
		    if (name) {
		      return ' Check the render method of `' + name + '`.';
		    }
		  }
		  return '';
		}
	
		/**
		 * Warn if there's no key explicitly set on dynamic arrays of children or
		 * object keys are not valid. This allows us to keep track of children between
		 * updates.
		 */
		var ownerHasKeyUseWarning = {};
	
		function getCurrentComponentErrorInfo(parentType) {
		  var info = getDeclarationErrorAddendum();
	
		  if (!info) {
		    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
		    if (parentName) {
		      info = ' Check the top-level render call using <' + parentName + '>.';
		    }
		  }
		  return info;
		}
	
		/**
		 * Warn if the element doesn't have an explicit key assigned to it.
		 * This element is in an array. The array could grow and shrink or be
		 * reordered. All children that haven't already been validated are required to
		 * have a "key" property assigned to it. Error statuses are cached so a warning
		 * will only be shown once.
		 *
		 * @internal
		 * @param {ReactElement} element Element that requires a key.
		 * @param {*} parentType element's parent's type.
		 */
		function validateExplicitKey(element, parentType) {
		  if (!element._store || element._store.validated || element.key != null) {
		    return;
		  }
		  element._store.validated = true;
	
		  var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});
	
		  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
		  if (memoizer[currentComponentErrorInfo]) {
		    return;
		  }
		  memoizer[currentComponentErrorInfo] = true;
	
		  // Usually the current owner is the offender, but if it accepts children as a
		  // property, it may be the creator of the child that's responsible for
		  // assigning it a key.
		  var childOwner = '';
		  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
		    // Give the component that originally created this child.
		    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
		  }
	
		  process.env.NODE_ENV !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
		}
	
		/**
		 * Ensure that every element either is passed in a static location, in an
		 * array with an explicit keys property defined, or in an object literal
		 * with valid key property.
		 *
		 * @internal
		 * @param {ReactNode} node Statically passed child of any type.
		 * @param {*} parentType node's parent's type.
		 */
		function validateChildKeys(node, parentType) {
		  if (typeof node !== 'object') {
		    return;
		  }
		  if (Array.isArray(node)) {
		    for (var i = 0; i < node.length; i++) {
		      var child = node[i];
		      if (ReactElement.isValidElement(child)) {
		        validateExplicitKey(child, parentType);
		      }
		    }
		  } else if (ReactElement.isValidElement(node)) {
		    // This element was passed in a valid location.
		    if (node._store) {
		      node._store.validated = true;
		    }
		  } else if (node) {
		    var iteratorFn = getIteratorFn(node);
		    // Entry iterators provide implicit keys.
		    if (iteratorFn) {
		      if (iteratorFn !== node.entries) {
		        var iterator = iteratorFn.call(node);
		        var step;
		        while (!(step = iterator.next()).done) {
		          if (ReactElement.isValidElement(step.value)) {
		            validateExplicitKey(step.value, parentType);
		          }
		        }
		      }
		    }
		  }
		}
	
		/**
		 * Given an element, validate that its props follow the propTypes definition,
		 * provided by the type.
		 *
		 * @param {ReactElement} element
		 */
		function validatePropTypes(element) {
		  var componentClass = element.type;
		  if (typeof componentClass !== 'function') {
		    return;
		  }
		  var name = componentClass.displayName || componentClass.name;
		  if (componentClass.propTypes) {
		    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
		  }
		  if (typeof componentClass.getDefaultProps === 'function') {
		    process.env.NODE_ENV !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
		  }
		}
	
		var ReactElementValidator = {
	
		  createElement: function (type, props, children) {
		    var validType = typeof type === 'string' || typeof type === 'function';
		    // We warn in this case but don't throw. We expect the element creation to
		    // succeed and there will likely be errors in render.
		    if (!validType) {
		      if (typeof type !== 'function' && typeof type !== 'string') {
		        var info = '';
		        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
		          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
		        }
		        info += getDeclarationErrorAddendum();
		        process.env.NODE_ENV !== 'production' ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
		      }
		    }
	
		    var element = ReactElement.createElement.apply(this, arguments);
	
		    // The result can be nullish if a mock or a custom function is used.
		    // TODO: Drop this when these are no longer allowed as the type argument.
		    if (element == null) {
		      return element;
		    }
	
		    // Skip key warning if the type isn't valid since our key validation logic
		    // doesn't expect a non-string/function type and can throw confusing errors.
		    // We don't want exception behavior to differ between dev and prod.
		    // (Rendering will throw with a helpful message and as soon as the type is
		    // fixed, the key warnings will appear.)
		    if (validType) {
		      for (var i = 2; i < arguments.length; i++) {
		        validateChildKeys(arguments[i], type);
		      }
		    }
	
		    validatePropTypes(element);
	
		    return element;
		  },
	
		  createFactory: function (type) {
		    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
		    // Legacy hook TODO: Warn if this is accessed
		    validatedFactory.type = type;
	
		    if (process.env.NODE_ENV !== 'production') {
		      if (canDefineProperty) {
		        Object.defineProperty(validatedFactory, 'type', {
		          enumerable: false,
		          get: function () {
		            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : void 0;
		            Object.defineProperty(this, 'type', {
		              value: type
		            });
		            return type;
		          }
		        });
		      }
		    }
	
		    return validatedFactory;
		  },
	
		  cloneElement: function (element, props, children) {
		    var newElement = ReactElement.cloneElement.apply(this, arguments);
		    for (var i = 2; i < arguments.length; i++) {
		      validateChildKeys(arguments[i], newElement.type);
		    }
		    validatePropTypes(newElement);
		    return newElement;
		  }
	
		};
	
		module.exports = ReactElementValidator;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 105 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(42);
	
		var ReactPropTypeLocationNames = __webpack_require__(102);
		var ReactPropTypesSecret = __webpack_require__(106);
	
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		var ReactComponentTreeHook;
	
		if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
		  // Temporary hack.
		  // Inline requires don't work well with Jest:
		  // https://github.com/facebook/react/issues/7240
		  // Remove the inline requires when we don't need them anymore:
		  // https://github.com/facebook/react/pull/7178
		  ReactComponentTreeHook = __webpack_require__(41);
		}
	
		var loggedTypeFailures = {};
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?object} element The React element that is being type-checked
		 * @param {?number} debugID The React component instance that is being type-checked
		 * @private
		 */
		function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
		  for (var typeSpecName in typeSpecs) {
		    if (typeSpecs.hasOwnProperty(typeSpecName)) {
		      var error;
		      // Prop type validation may throw. In case they do, we don't want to
		      // fail the render phase where it didn't fail before. So we log it.
		      // After these have been cleaned up, we'll let them throw.
		      try {
		        // This is intentionally an invariant that gets caught. It's the same
		        // behavior as without this statement except with a better message.
		        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
		        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		      } catch (ex) {
		        error = ex;
		      }
		      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
		      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		        // Only monitor this failure once because there tends to be a lot of the
		        // same error.
		        loggedTypeFailures[error.message] = true;
	
		        var componentStackInfo = '';
	
		        if (process.env.NODE_ENV !== 'production') {
		          if (!ReactComponentTreeHook) {
		            ReactComponentTreeHook = __webpack_require__(41);
		          }
		          if (debugID !== null) {
		            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
		          } else if (element !== null) {
		            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
		          }
		        }
	
		        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
		      }
		    }
		  }
		}
	
		module.exports = checkReactTypeSpec;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 106 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	/***/ },
	/* 107 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactElement = __webpack_require__(91);
		var ReactPropTypeLocationNames = __webpack_require__(102);
		var ReactPropTypesSecret = __webpack_require__(106);
	
		var emptyFunction = __webpack_require__(19);
		var getIteratorFn = __webpack_require__(95);
		var warning = __webpack_require__(18);
	
		/**
		 * Collection of methods that allow declaration and validation of props that are
		 * supplied to React components. Example usage:
		 *
		 *   var Props = require('ReactPropTypes');
		 *   var MyArticle = React.createClass({
		 *     propTypes: {
		 *       // An optional string prop named "description".
		 *       description: Props.string,
		 *
		 *       // A required enum prop named "category".
		 *       category: Props.oneOf(['News','Photos']).isRequired,
		 *
		 *       // A prop named "dialog" that requires an instance of Dialog.
		 *       dialog: Props.instanceOf(Dialog).isRequired
		 *     },
		 *     render: function() { ... }
		 *   });
		 *
		 * A more formal specification of how these methods are used:
		 *
		 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		 *   decl := ReactPropTypes.{type}(.isRequired)?
		 *
		 * Each and every declaration produces a function with the same signature. This
		 * allows the creation of custom validation functions. For example:
		 *
		 *  var MyLink = React.createClass({
		 *    propTypes: {
		 *      // An optional string or URI prop named "href".
		 *      href: function(props, propName, componentName) {
		 *        var propValue = props[propName];
		 *        if (propValue != null && typeof propValue !== 'string' &&
		 *            !(propValue instanceof URI)) {
		 *          return new Error(
		 *            'Expected a string or an URI for ' + propName + ' in ' +
		 *            componentName
		 *          );
		 *        }
		 *      }
		 *    },
		 *    render: function() {...}
		 *  });
		 *
		 * @internal
		 */
	
		var ANONYMOUS = '<<anonymous>>';
	
		var ReactPropTypes = {
		  array: createPrimitiveTypeChecker('array'),
		  bool: createPrimitiveTypeChecker('boolean'),
		  func: createPrimitiveTypeChecker('function'),
		  number: createPrimitiveTypeChecker('number'),
		  object: createPrimitiveTypeChecker('object'),
		  string: createPrimitiveTypeChecker('string'),
		  symbol: createPrimitiveTypeChecker('symbol'),
	
		  any: createAnyTypeChecker(),
		  arrayOf: createArrayOfTypeChecker,
		  element: createElementTypeChecker(),
		  instanceOf: createInstanceTypeChecker,
		  node: createNodeChecker(),
		  objectOf: createObjectOfTypeChecker,
		  oneOf: createEnumTypeChecker,
		  oneOfType: createUnionTypeChecker,
		  shape: createShapeTypeChecker
		};
	
		/**
		 * inlined Object.is polyfill to avoid requiring consumers ship their own
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		 */
		/*eslint-disable no-self-compare*/
		function is(x, y) {
		  // SameValue algorithm
		  if (x === y) {
		    // Steps 1-5, 7-10
		    // Steps 6.b-6.e: +0 != -0
		    return x !== 0 || 1 / x === 1 / y;
		  } else {
		    // Step 6.a: NaN == NaN
		    return x !== x && y !== y;
		  }
		}
		/*eslint-enable no-self-compare*/
	
		/**
		 * We use an Error-like object for backward compatibility as people may call
		 * PropTypes directly and inspect their output. However we don't use real
		 * Errors anymore. We don't inspect their stack anyway, and creating them
		 * is prohibitively expensive if they are created too often, such as what
		 * happens in oneOfType() for any type before the one that matched.
		 */
		function PropTypeError(message) {
		  this.message = message;
		  this.stack = '';
		}
		// Make `instanceof Error` still work for returned errors.
		PropTypeError.prototype = Error.prototype;
	
		function createChainableTypeChecker(validate) {
		  if (process.env.NODE_ENV !== 'production') {
		    var manualPropTypeCallCache = {};
		  }
		  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		    componentName = componentName || ANONYMOUS;
		    propFullName = propFullName || propName;
		    if (process.env.NODE_ENV !== 'production') {
		      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
		        var cacheKey = componentName + ':' + propName;
		        if (!manualPropTypeCallCache[cacheKey]) {
		          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
		          manualPropTypeCallCache[cacheKey] = true;
		        }
		      }
		    }
		    if (props[propName] == null) {
		      var locationName = ReactPropTypeLocationNames[location];
		      if (isRequired) {
		        if (props[propName] === null) {
		          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		        }
		        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		      }
		      return null;
		    } else {
		      return validate(props, propName, componentName, location, propFullName);
		    }
		  }
	
		  var chainedCheckType = checkType.bind(null, false);
		  chainedCheckType.isRequired = checkType.bind(null, true);
	
		  return chainedCheckType;
		}
	
		function createPrimitiveTypeChecker(expectedType) {
		  function validate(props, propName, componentName, location, propFullName, secret) {
		    var propValue = props[propName];
		    var propType = getPropType(propValue);
		    if (propType !== expectedType) {
		      var locationName = ReactPropTypeLocationNames[location];
		      // `propValue` being instance of, say, date/regexp, pass the 'object'
		      // check, but we can offer a more precise error message here rather than
		      // 'of type `object`'.
		      var preciseType = getPreciseType(propValue);
	
		      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		    }
		    return null;
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function createAnyTypeChecker() {
		  return createChainableTypeChecker(emptyFunction.thatReturns(null));
		}
	
		function createArrayOfTypeChecker(typeChecker) {
		  function validate(props, propName, componentName, location, propFullName) {
		    if (typeof typeChecker !== 'function') {
		      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		    }
		    var propValue = props[propName];
		    if (!Array.isArray(propValue)) {
		      var locationName = ReactPropTypeLocationNames[location];
		      var propType = getPropType(propValue);
		      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		    }
		    for (var i = 0; i < propValue.length; i++) {
		      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		      if (error instanceof Error) {
		        return error;
		      }
		    }
		    return null;
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function createElementTypeChecker() {
		  function validate(props, propName, componentName, location, propFullName) {
		    var propValue = props[propName];
		    if (!ReactElement.isValidElement(propValue)) {
		      var locationName = ReactPropTypeLocationNames[location];
		      var propType = getPropType(propValue);
		      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		    }
		    return null;
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function createInstanceTypeChecker(expectedClass) {
		  function validate(props, propName, componentName, location, propFullName) {
		    if (!(props[propName] instanceof expectedClass)) {
		      var locationName = ReactPropTypeLocationNames[location];
		      var expectedClassName = expectedClass.name || ANONYMOUS;
		      var actualClassName = getClassName(props[propName]);
		      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		    }
		    return null;
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function createEnumTypeChecker(expectedValues) {
		  if (!Array.isArray(expectedValues)) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		    return emptyFunction.thatReturnsNull;
		  }
	
		  function validate(props, propName, componentName, location, propFullName) {
		    var propValue = props[propName];
		    for (var i = 0; i < expectedValues.length; i++) {
		      if (is(propValue, expectedValues[i])) {
		        return null;
		      }
		    }
	
		    var locationName = ReactPropTypeLocationNames[location];
		    var valuesString = JSON.stringify(expectedValues);
		    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function createObjectOfTypeChecker(typeChecker) {
		  function validate(props, propName, componentName, location, propFullName) {
		    if (typeof typeChecker !== 'function') {
		      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		    }
		    var propValue = props[propName];
		    var propType = getPropType(propValue);
		    if (propType !== 'object') {
		      var locationName = ReactPropTypeLocationNames[location];
		      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		    }
		    for (var key in propValue) {
		      if (propValue.hasOwnProperty(key)) {
		        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		    }
		    return null;
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function createUnionTypeChecker(arrayOfTypeCheckers) {
		  if (!Array.isArray(arrayOfTypeCheckers)) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		    return emptyFunction.thatReturnsNull;
		  }
	
		  function validate(props, propName, componentName, location, propFullName) {
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		        return null;
		      }
		    }
	
		    var locationName = ReactPropTypeLocationNames[location];
		    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function createNodeChecker() {
		  function validate(props, propName, componentName, location, propFullName) {
		    if (!isNode(props[propName])) {
		      var locationName = ReactPropTypeLocationNames[location];
		      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		    }
		    return null;
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function createShapeTypeChecker(shapeTypes) {
		  function validate(props, propName, componentName, location, propFullName) {
		    var propValue = props[propName];
		    var propType = getPropType(propValue);
		    if (propType !== 'object') {
		      var locationName = ReactPropTypeLocationNames[location];
		      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		    }
		    for (var key in shapeTypes) {
		      var checker = shapeTypes[key];
		      if (!checker) {
		        continue;
		      }
		      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		      if (error) {
		        return error;
		      }
		    }
		    return null;
		  }
		  return createChainableTypeChecker(validate);
		}
	
		function isNode(propValue) {
		  switch (typeof propValue) {
		    case 'number':
		    case 'string':
		    case 'undefined':
		      return true;
		    case 'boolean':
		      return !propValue;
		    case 'object':
		      if (Array.isArray(propValue)) {
		        return propValue.every(isNode);
		      }
		      if (propValue === null || ReactElement.isValidElement(propValue)) {
		        return true;
		      }
	
		      var iteratorFn = getIteratorFn(propValue);
		      if (iteratorFn) {
		        var iterator = iteratorFn.call(propValue);
		        var step;
		        if (iteratorFn !== propValue.entries) {
		          while (!(step = iterator.next()).done) {
		            if (!isNode(step.value)) {
		              return false;
		            }
		          }
		        } else {
		          // Iterator will provide entry [k,v] tuples rather than values.
		          while (!(step = iterator.next()).done) {
		            var entry = step.value;
		            if (entry) {
		              if (!isNode(entry[1])) {
		                return false;
		              }
		            }
		          }
		        }
		      } else {
		        return false;
		      }
	
		      return true;
		    default:
		      return false;
		  }
		}
	
		function isSymbol(propType, propValue) {
		  // Native Symbol.
		  if (propType === 'symbol') {
		    return true;
		  }
	
		  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		  if (propValue['@@toStringTag'] === 'Symbol') {
		    return true;
		  }
	
		  // Fallback for non-spec compliant Symbols which are polyfilled.
		  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		    return true;
		  }
	
		  return false;
		}
	
		// Equivalent of `typeof` but with special handling for array and regexp.
		function getPropType(propValue) {
		  var propType = typeof propValue;
		  if (Array.isArray(propValue)) {
		    return 'array';
		  }
		  if (propValue instanceof RegExp) {
		    // Old webkits (at least until Android 4.0) return 'function' rather than
		    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		    // passes PropTypes.object.
		    return 'object';
		  }
		  if (isSymbol(propType, propValue)) {
		    return 'symbol';
		  }
		  return propType;
		}
	
		// This handles more types than `getPropType`. Only used for error messages.
		// See `createPrimitiveTypeChecker`.
		function getPreciseType(propValue) {
		  var propType = getPropType(propValue);
		  if (propType === 'object') {
		    if (propValue instanceof Date) {
		      return 'date';
		    } else if (propValue instanceof RegExp) {
		      return 'regexp';
		    }
		  }
		  return propType;
		}
	
		// Returns class name of the object, if any.
		function getClassName(propValue) {
		  if (!propValue.constructor || !propValue.constructor.name) {
		    return ANONYMOUS;
		  }
		  return propValue.constructor.name;
		}
	
		module.exports = ReactPropTypes;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 108 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		module.exports = '15.4.2';
	
	/***/ },
	/* 109 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
		'use strict';
	
		var _prodInvariant = __webpack_require__(42);
	
		var ReactElement = __webpack_require__(91);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * Returns the first child in a collection of children and verifies that there
		 * is only one child in the collection.
		 *
		 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
		 *
		 * The current implementation of this function assumes that a single child gets
		 * passed without a wrapper, but the purpose of this helper function is to
		 * abstract away the particular structure of children.
		 *
		 * @param {?object} children Child collection structure.
		 * @return {ReactElement} The first and only `ReactElement` contained in the
		 * structure.
		 */
		function onlyChild(children) {
		  !ReactElement.isValidElement(children) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
		  return children;
		}
	
		module.exports = onlyChild;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 110 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	/***/ },
	/* 111 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var React = __webpack_require__(88);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactDOMSelect = __webpack_require__(112);
	
		var warning = __webpack_require__(18);
		var didWarnInvalidOptionChildren = false;
	
		function flattenChildren(children) {
		  var content = '';
	
		  // Flatten children and warn if they aren't strings or numbers;
		  // invalid types are ignored.
		  React.Children.forEach(children, function (child) {
		    if (child == null) {
		      return;
		    }
		    if (typeof child === 'string' || typeof child === 'number') {
		      content += child;
		    } else if (!didWarnInvalidOptionChildren) {
		      didWarnInvalidOptionChildren = true;
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
		    }
		  });
	
		  return content;
		}
	
		/**
		 * Implements an <option> host component that warns when `selected` is set.
		 */
		var ReactDOMOption = {
		  mountWrapper: function (inst, props, hostParent) {
		    // TODO (yungsters): Remove support for `selected` in <option>.
		    if (process.env.NODE_ENV !== 'production') {
		      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
		    }
	
		    // Look up whether this option is 'selected'
		    var selectValue = null;
		    if (hostParent != null) {
		      var selectParent = hostParent;
	
		      if (selectParent._tag === 'optgroup') {
		        selectParent = selectParent._hostParent;
		      }
	
		      if (selectParent != null && selectParent._tag === 'select') {
		        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
		      }
		    }
	
		    // If the value is null (e.g., no specified value or after initial mount)
		    // or missing (e.g., for <datalist>), we don't change props.selected
		    var selected = null;
		    if (selectValue != null) {
		      var value;
		      if (props.value != null) {
		        value = props.value + '';
		      } else {
		        value = flattenChildren(props.children);
		      }
		      selected = false;
		      if (Array.isArray(selectValue)) {
		        // multiple
		        for (var i = 0; i < selectValue.length; i++) {
		          if ('' + selectValue[i] === value) {
		            selected = true;
		            break;
		          }
		        }
		      } else {
		        selected = '' + selectValue === value;
		      }
		    }
	
		    inst._wrapperState = { selected: selected };
		  },
	
		  postMountWrapper: function (inst) {
		    // value="" should make a value attribute (#6219)
		    var props = inst._currentElement.props;
		    if (props.value != null) {
		      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
		      node.setAttribute('value', props.value);
		    }
		  },
	
		  getHostProps: function (inst, props) {
		    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
		    // Read state only from initial mount because <select> updates value
		    // manually; we need the initial state only for server rendering
		    if (inst._wrapperState.selected != null) {
		      hostProps.selected = inst._wrapperState.selected;
		    }
	
		    var content = flattenChildren(props.children);
	
		    if (content) {
		      hostProps.children = content;
		    }
	
		    return hostProps;
		  }
	
		};
	
		module.exports = ReactDOMOption;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 112 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var LinkedValueUtils = __webpack_require__(87);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactUpdates = __webpack_require__(31);
	
		var warning = __webpack_require__(18);
	
		var didWarnValueLink = false;
		var didWarnValueDefaultValue = false;
	
		function updateOptionsIfPendingUpdateAndMounted() {
		  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
		    this._wrapperState.pendingUpdate = false;
	
		    var props = this._currentElement.props;
		    var value = LinkedValueUtils.getValue(props);
	
		    if (value != null) {
		      updateOptions(this, Boolean(props.multiple), value);
		    }
		  }
		}
	
		function getDeclarationErrorAddendum(owner) {
		  if (owner) {
		    var name = owner.getName();
		    if (name) {
		      return ' Check the render method of `' + name + '`.';
		    }
		  }
		  return '';
		}
	
		var valuePropNames = ['value', 'defaultValue'];
	
		/**
		 * Validation function for `value` and `defaultValue`.
		 * @private
		 */
		function checkSelectPropTypes(inst, props) {
		  var owner = inst._currentElement._owner;
		  LinkedValueUtils.checkPropTypes('select', props, owner);
	
		  if (props.valueLink !== undefined && !didWarnValueLink) {
		    process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
		    didWarnValueLink = true;
		  }
	
		  for (var i = 0; i < valuePropNames.length; i++) {
		    var propName = valuePropNames[i];
		    if (props[propName] == null) {
		      continue;
		    }
		    var isArray = Array.isArray(props[propName]);
		    if (props.multiple && !isArray) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
		    } else if (!props.multiple && isArray) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
		    }
		  }
		}
	
		/**
		 * @param {ReactDOMComponent} inst
		 * @param {boolean} multiple
		 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
		 * @private
		 */
		function updateOptions(inst, multiple, propValue) {
		  var selectedValue, i;
		  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
		  if (multiple) {
		    selectedValue = {};
		    for (i = 0; i < propValue.length; i++) {
		      selectedValue['' + propValue[i]] = true;
		    }
		    for (i = 0; i < options.length; i++) {
		      var selected = selectedValue.hasOwnProperty(options[i].value);
		      if (options[i].selected !== selected) {
		        options[i].selected = selected;
		      }
		    }
		  } else {
		    // Do not set `select.value` as exact behavior isn't consistent across all
		    // browsers for all cases.
		    selectedValue = '' + propValue;
		    for (i = 0; i < options.length; i++) {
		      if (options[i].value === selectedValue) {
		        options[i].selected = true;
		        return;
		      }
		    }
		    if (options.length) {
		      options[0].selected = true;
		    }
		  }
		}
	
		/**
		 * Implements a <select> host component that allows optionally setting the
		 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
		 * stringable. If `multiple` is true, the prop must be an array of stringables.
		 *
		 * If `value` is not supplied (or null/undefined), user actions that change the
		 * selected option will trigger updates to the rendered options.
		 *
		 * If it is supplied (and not null/undefined), the rendered options will not
		 * update in response to user actions. Instead, the `value` prop must change in
		 * order for the rendered options to update.
		 *
		 * If `defaultValue` is provided, any options with the supplied values will be
		 * selected.
		 */
		var ReactDOMSelect = {
		  getHostProps: function (inst, props) {
		    return _assign({}, props, {
		      onChange: inst._wrapperState.onChange,
		      value: undefined
		    });
		  },
	
		  mountWrapper: function (inst, props) {
		    if (process.env.NODE_ENV !== 'production') {
		      checkSelectPropTypes(inst, props);
		    }
	
		    var value = LinkedValueUtils.getValue(props);
		    inst._wrapperState = {
		      pendingUpdate: false,
		      initialValue: value != null ? value : props.defaultValue,
		      listeners: null,
		      onChange: _handleChange.bind(inst),
		      wasMultiple: Boolean(props.multiple)
		    };
	
		    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
		      didWarnValueDefaultValue = true;
		    }
		  },
	
		  getSelectValueContext: function (inst) {
		    // ReactDOMOption looks at this initial value so the initial generated
		    // markup has correct `selected` attributes
		    return inst._wrapperState.initialValue;
		  },
	
		  postUpdateWrapper: function (inst) {
		    var props = inst._currentElement.props;
	
		    // After the initial mount, we control selected-ness manually so don't pass
		    // this value down
		    inst._wrapperState.initialValue = undefined;
	
		    var wasMultiple = inst._wrapperState.wasMultiple;
		    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
		    var value = LinkedValueUtils.getValue(props);
		    if (value != null) {
		      inst._wrapperState.pendingUpdate = false;
		      updateOptions(inst, Boolean(props.multiple), value);
		    } else if (wasMultiple !== Boolean(props.multiple)) {
		      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
		      if (props.defaultValue != null) {
		        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
		      } else {
		        // Revert the select back to its default unselected state.
		        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
		      }
		    }
		  }
		};
	
		function _handleChange(event) {
		  var props = this._currentElement.props;
		  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
		  if (this._rootNodeID) {
		    this._wrapperState.pendingUpdate = true;
		  }
		  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
		  return returnValue;
		}
	
		module.exports = ReactDOMSelect;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 113 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6),
		    _assign = __webpack_require__(24);
	
		var LinkedValueUtils = __webpack_require__(87);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactUpdates = __webpack_require__(31);
	
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		var didWarnValueLink = false;
		var didWarnValDefaultVal = false;
	
		function forceUpdateIfMounted() {
		  if (this._rootNodeID) {
		    // DOM component is still mounted; update
		    ReactDOMTextarea.updateWrapper(this);
		  }
		}
	
		/**
		 * Implements a <textarea> host component that allows setting `value`, and
		 * `defaultValue`. This differs from the traditional DOM API because value is
		 * usually set as PCDATA children.
		 *
		 * If `value` is not supplied (or null/undefined), user actions that affect the
		 * value will trigger updates to the element.
		 *
		 * If `value` is supplied (and not null/undefined), the rendered element will
		 * not trigger updates to the element. Instead, the `value` prop must change in
		 * order for the rendered element to be updated.
		 *
		 * The rendered element will be initialized with an empty value, the prop
		 * `defaultValue` if specified, or the children content (deprecated).
		 */
		var ReactDOMTextarea = {
		  getHostProps: function (inst, props) {
		    !(props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
		    // Always set children to the same thing. In IE9, the selection range will
		    // get reset if `textContent` is mutated.  We could add a check in setTextContent
		    // to only set the value if/when the value differs from the node value (which would
		    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
		    // The value can be a boolean or object so that's why it's forced to be a string.
		    var hostProps = _assign({}, props, {
		      value: undefined,
		      defaultValue: undefined,
		      children: '' + inst._wrapperState.initialValue,
		      onChange: inst._wrapperState.onChange
		    });
	
		    return hostProps;
		  },
	
		  mountWrapper: function (inst, props) {
		    if (process.env.NODE_ENV !== 'production') {
		      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
		      if (props.valueLink !== undefined && !didWarnValueLink) {
		        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
		        didWarnValueLink = true;
		      }
		      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
		        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
		        didWarnValDefaultVal = true;
		      }
		    }
	
		    var value = LinkedValueUtils.getValue(props);
		    var initialValue = value;
	
		    // Only bother fetching default value if we're going to use it
		    if (value == null) {
		      var defaultValue = props.defaultValue;
		      // TODO (yungsters): Remove support for children content in <textarea>.
		      var children = props.children;
		      if (children != null) {
		        if (process.env.NODE_ENV !== 'production') {
		          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
		        }
		        !(defaultValue == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
		        if (Array.isArray(children)) {
		          !(children.length <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
		          children = children[0];
		        }
	
		        defaultValue = '' + children;
		      }
		      if (defaultValue == null) {
		        defaultValue = '';
		      }
		      initialValue = defaultValue;
		    }
	
		    inst._wrapperState = {
		      initialValue: '' + initialValue,
		      listeners: null,
		      onChange: _handleChange.bind(inst)
		    };
		  },
	
		  updateWrapper: function (inst) {
		    var props = inst._currentElement.props;
	
		    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
		    var value = LinkedValueUtils.getValue(props);
		    if (value != null) {
		      // Cast `value` to a string to ensure the value is set correctly. While
		      // browsers typically do this as necessary, jsdom doesn't.
		      var newValue = '' + value;
	
		      // To avoid side effects (such as losing text selection), only set value if changed
		      if (newValue !== node.value) {
		        node.value = newValue;
		      }
		      if (props.defaultValue == null) {
		        node.defaultValue = newValue;
		      }
		    }
		    if (props.defaultValue != null) {
		      node.defaultValue = props.defaultValue;
		    }
		  },
	
		  postMountWrapper: function (inst) {
		    // This is in postMount because we need access to the DOM node, which is not
		    // available until after the component has mounted.
		    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
		    var textContent = node.textContent;
	
		    // Only set node.value if textContent is equal to the expected
		    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
		    // will populate textContent as well.
		    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
		    if (textContent === inst._wrapperState.initialValue) {
		      node.value = textContent;
		    }
		  }
		};
	
		function _handleChange(event) {
		  var props = this._currentElement.props;
		  var returnValue = LinkedValueUtils.executeOnChange(props, event);
		  ReactUpdates.asap(forceUpdateIfMounted, this);
		  return returnValue;
		}
	
		module.exports = ReactDOMTextarea;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 114 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var ReactComponentEnvironment = __webpack_require__(115);
		var ReactInstanceMap = __webpack_require__(116);
		var ReactInstrumentation = __webpack_require__(37);
	
		var ReactCurrentOwner = __webpack_require__(43);
		var ReactReconciler = __webpack_require__(34);
		var ReactChildReconciler = __webpack_require__(117);
	
		var emptyFunction = __webpack_require__(19);
		var flattenChildren = __webpack_require__(132);
		var invariant = __webpack_require__(8);
	
		/**
		 * Make an update for markup to be rendered and inserted at a supplied index.
		 *
		 * @param {string} markup Markup that renders into an element.
		 * @param {number} toIndex Destination index.
		 * @private
		 */
		function makeInsertMarkup(markup, afterNode, toIndex) {
		  // NOTE: Null values reduce hidden classes.
		  return {
		    type: 'INSERT_MARKUP',
		    content: markup,
		    fromIndex: null,
		    fromNode: null,
		    toIndex: toIndex,
		    afterNode: afterNode
		  };
		}
	
		/**
		 * Make an update for moving an existing element to another index.
		 *
		 * @param {number} fromIndex Source index of the existing element.
		 * @param {number} toIndex Destination index of the element.
		 * @private
		 */
		function makeMove(child, afterNode, toIndex) {
		  // NOTE: Null values reduce hidden classes.
		  return {
		    type: 'MOVE_EXISTING',
		    content: null,
		    fromIndex: child._mountIndex,
		    fromNode: ReactReconciler.getHostNode(child),
		    toIndex: toIndex,
		    afterNode: afterNode
		  };
		}
	
		/**
		 * Make an update for removing an element at an index.
		 *
		 * @param {number} fromIndex Index of the element to remove.
		 * @private
		 */
		function makeRemove(child, node) {
		  // NOTE: Null values reduce hidden classes.
		  return {
		    type: 'REMOVE_NODE',
		    content: null,
		    fromIndex: child._mountIndex,
		    fromNode: node,
		    toIndex: null,
		    afterNode: null
		  };
		}
	
		/**
		 * Make an update for setting the markup of a node.
		 *
		 * @param {string} markup Markup that renders into an element.
		 * @private
		 */
		function makeSetMarkup(markup) {
		  // NOTE: Null values reduce hidden classes.
		  return {
		    type: 'SET_MARKUP',
		    content: markup,
		    fromIndex: null,
		    fromNode: null,
		    toIndex: null,
		    afterNode: null
		  };
		}
	
		/**
		 * Make an update for setting the text content.
		 *
		 * @param {string} textContent Text content to set.
		 * @private
		 */
		function makeTextContent(textContent) {
		  // NOTE: Null values reduce hidden classes.
		  return {
		    type: 'TEXT_CONTENT',
		    content: textContent,
		    fromIndex: null,
		    fromNode: null,
		    toIndex: null,
		    afterNode: null
		  };
		}
	
		/**
		 * Push an update, if any, onto the queue. Creates a new queue if none is
		 * passed and always returns the queue. Mutative.
		 */
		function enqueue(queue, update) {
		  if (update) {
		    queue = queue || [];
		    queue.push(update);
		  }
		  return queue;
		}
	
		/**
		 * Processes any enqueued updates.
		 *
		 * @private
		 */
		function processQueue(inst, updateQueue) {
		  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
		}
	
		var setChildrenForInstrumentation = emptyFunction;
		if (process.env.NODE_ENV !== 'production') {
		  var getDebugID = function (inst) {
		    if (!inst._debugID) {
		      // Check for ART-like instances. TODO: This is silly/gross.
		      var internal;
		      if (internal = ReactInstanceMap.get(inst)) {
		        inst = internal;
		      }
		    }
		    return inst._debugID;
		  };
		  setChildrenForInstrumentation = function (children) {
		    var debugID = getDebugID(this);
		    // TODO: React Native empty components are also multichild.
		    // This means they still get into this method but don't have _debugID.
		    if (debugID !== 0) {
		      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
		        return children[key]._debugID;
		      }) : []);
		    }
		  };
		}
	
		/**
		 * ReactMultiChild are capable of reconciling multiple children.
		 *
		 * @class ReactMultiChild
		 * @internal
		 */
		var ReactMultiChild = {
	
		  /**
		   * Provides common functionality for components that must reconcile multiple
		   * children. This is used by `ReactDOMComponent` to mount, update, and
		   * unmount child components.
		   *
		   * @lends {ReactMultiChild.prototype}
		   */
		  Mixin: {
	
		    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
		      if (process.env.NODE_ENV !== 'production') {
		        var selfDebugID = getDebugID(this);
		        if (this._currentElement) {
		          try {
		            ReactCurrentOwner.current = this._currentElement._owner;
		            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
		          } finally {
		            ReactCurrentOwner.current = null;
		          }
		        }
		      }
		      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
		    },
	
		    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
		      var nextChildren;
		      var selfDebugID = 0;
		      if (process.env.NODE_ENV !== 'production') {
		        selfDebugID = getDebugID(this);
		        if (this._currentElement) {
		          try {
		            ReactCurrentOwner.current = this._currentElement._owner;
		            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
		          } finally {
		            ReactCurrentOwner.current = null;
		          }
		          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
		          return nextChildren;
		        }
		      }
		      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
		      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
		      return nextChildren;
		    },
	
		    /**
		     * Generates a "mount image" for each of the supplied children. In the case
		     * of `ReactDOMComponent`, a mount image is a string of markup.
		     *
		     * @param {?object} nestedChildren Nested child maps.
		     * @return {array} An array of mounted representations.
		     * @internal
		     */
		    mountChildren: function (nestedChildren, transaction, context) {
		      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
		      this._renderedChildren = children;
	
		      var mountImages = [];
		      var index = 0;
		      for (var name in children) {
		        if (children.hasOwnProperty(name)) {
		          var child = children[name];
		          var selfDebugID = 0;
		          if (process.env.NODE_ENV !== 'production') {
		            selfDebugID = getDebugID(this);
		          }
		          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
		          child._mountIndex = index++;
		          mountImages.push(mountImage);
		        }
		      }
	
		      if (process.env.NODE_ENV !== 'production') {
		        setChildrenForInstrumentation.call(this, children);
		      }
	
		      return mountImages;
		    },
	
		    /**
		     * Replaces any rendered children with a text content string.
		     *
		     * @param {string} nextContent String of content.
		     * @internal
		     */
		    updateTextContent: function (nextContent) {
		      var prevChildren = this._renderedChildren;
		      // Remove any rendered children.
		      ReactChildReconciler.unmountChildren(prevChildren, false);
		      for (var name in prevChildren) {
		        if (prevChildren.hasOwnProperty(name)) {
		           true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
		        }
		      }
		      // Set new text content.
		      var updates = [makeTextContent(nextContent)];
		      processQueue(this, updates);
		    },
	
		    /**
		     * Replaces any rendered children with a markup string.
		     *
		     * @param {string} nextMarkup String of markup.
		     * @internal
		     */
		    updateMarkup: function (nextMarkup) {
		      var prevChildren = this._renderedChildren;
		      // Remove any rendered children.
		      ReactChildReconciler.unmountChildren(prevChildren, false);
		      for (var name in prevChildren) {
		        if (prevChildren.hasOwnProperty(name)) {
		           true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
		        }
		      }
		      var updates = [makeSetMarkup(nextMarkup)];
		      processQueue(this, updates);
		    },
	
		    /**
		     * Updates the rendered children with new children.
		     *
		     * @param {?object} nextNestedChildrenElements Nested child element maps.
		     * @param {ReactReconcileTransaction} transaction
		     * @internal
		     */
		    updateChildren: function (nextNestedChildrenElements, transaction, context) {
		      // Hook used by React ART
		      this._updateChildren(nextNestedChildrenElements, transaction, context);
		    },
	
		    /**
		     * @param {?object} nextNestedChildrenElements Nested child element maps.
		     * @param {ReactReconcileTransaction} transaction
		     * @final
		     * @protected
		     */
		    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
		      var prevChildren = this._renderedChildren;
		      var removedNodes = {};
		      var mountImages = [];
		      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
		      if (!nextChildren && !prevChildren) {
		        return;
		      }
		      var updates = null;
		      var name;
		      // `nextIndex` will increment for each child in `nextChildren`, but
		      // `lastIndex` will be the last index visited in `prevChildren`.
		      var nextIndex = 0;
		      var lastIndex = 0;
		      // `nextMountIndex` will increment for each newly mounted child.
		      var nextMountIndex = 0;
		      var lastPlacedNode = null;
		      for (name in nextChildren) {
		        if (!nextChildren.hasOwnProperty(name)) {
		          continue;
		        }
		        var prevChild = prevChildren && prevChildren[name];
		        var nextChild = nextChildren[name];
		        if (prevChild === nextChild) {
		          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
		          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
		          prevChild._mountIndex = nextIndex;
		        } else {
		          if (prevChild) {
		            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
		            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
		            // The `removedNodes` loop below will actually remove the child.
		          }
		          // The child must be instantiated before it's mounted.
		          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
		          nextMountIndex++;
		        }
		        nextIndex++;
		        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
		      }
		      // Remove children that are no longer present.
		      for (name in removedNodes) {
		        if (removedNodes.hasOwnProperty(name)) {
		          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
		        }
		      }
		      if (updates) {
		        processQueue(this, updates);
		      }
		      this._renderedChildren = nextChildren;
	
		      if (process.env.NODE_ENV !== 'production') {
		        setChildrenForInstrumentation.call(this, nextChildren);
		      }
		    },
	
		    /**
		     * Unmounts all rendered children. This should be used to clean up children
		     * when this component is unmounted. It does not actually perform any
		     * backend operations.
		     *
		     * @internal
		     */
		    unmountChildren: function (safely) {
		      var renderedChildren = this._renderedChildren;
		      ReactChildReconciler.unmountChildren(renderedChildren, safely);
		      this._renderedChildren = null;
		    },
	
		    /**
		     * Moves a child component to the supplied index.
		     *
		     * @param {ReactComponent} child Component to move.
		     * @param {number} toIndex Destination index of the element.
		     * @param {number} lastIndex Last index visited of the siblings of `child`.
		     * @protected
		     */
		    moveChild: function (child, afterNode, toIndex, lastIndex) {
		      // If the index of `child` is less than `lastIndex`, then it needs to
		      // be moved. Otherwise, we do not need to move it because a child will be
		      // inserted or moved before `child`.
		      if (child._mountIndex < lastIndex) {
		        return makeMove(child, afterNode, toIndex);
		      }
		    },
	
		    /**
		     * Creates a child component.
		     *
		     * @param {ReactComponent} child Component to create.
		     * @param {string} mountImage Markup to insert.
		     * @protected
		     */
		    createChild: function (child, afterNode, mountImage) {
		      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
		    },
	
		    /**
		     * Removes a child component.
		     *
		     * @param {ReactComponent} child Child to remove.
		     * @protected
		     */
		    removeChild: function (child, node) {
		      return makeRemove(child, node);
		    },
	
		    /**
		     * Mounts a child with the supplied name.
		     *
		     * NOTE: This is part of `updateChildren` and is here for readability.
		     *
		     * @param {ReactComponent} child Component to mount.
		     * @param {string} name Name of the child.
		     * @param {number} index Index at which to insert the child.
		     * @param {ReactReconcileTransaction} transaction
		     * @private
		     */
		    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
		      child._mountIndex = index;
		      return this.createChild(child, afterNode, mountImage);
		    },
	
		    /**
		     * Unmounts a rendered child.
		     *
		     * NOTE: This is part of `updateChildren` and is here for readability.
		     *
		     * @param {ReactComponent} child Component to unmount.
		     * @private
		     */
		    _unmountChild: function (child, node) {
		      var update = this.removeChild(child, node);
		      child._mountIndex = null;
		      return update;
		    }
	
		  }
	
		};
	
		module.exports = ReactMultiChild;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 115 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		var injected = false;
	
		var ReactComponentEnvironment = {
	
		  /**
		   * Optionally injectable hook for swapping out mount images in the middle of
		   * the tree.
		   */
		  replaceNodeWithMarkup: null,
	
		  /**
		   * Optionally injectable hook for processing a queue of child updates. Will
		   * later move into MultiChildComponents.
		   */
		  processChildrenUpdates: null,
	
		  injection: {
		    injectEnvironment: function (environment) {
		      !!injected ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
		      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
		      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
		      injected = true;
		    }
		  }
	
		};
	
		module.exports = ReactComponentEnvironment;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 116 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * `ReactInstanceMap` maintains a mapping from a public facing stateful
		 * instance (key) and the internal representation (value). This allows public
		 * methods to accept the user facing instance as an argument and map them back
		 * to internal methods.
		 */
	
		// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
		var ReactInstanceMap = {
	
		  /**
		   * This API should be called `delete` but we'd have to make sure to always
		   * transform these to strings for IE support. When this transform is fully
		   * supported we can rename it.
		   */
		  remove: function (key) {
		    key._reactInternalInstance = undefined;
		  },
	
		  get: function (key) {
		    return key._reactInternalInstance;
		  },
	
		  has: function (key) {
		    return key._reactInternalInstance !== undefined;
		  },
	
		  set: function (key, value) {
		    key._reactInternalInstance = value;
		  }
	
		};
	
		module.exports = ReactInstanceMap;
	
	/***/ },
	/* 117 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactReconciler = __webpack_require__(34);
	
		var instantiateReactComponent = __webpack_require__(118);
		var KeyEscapeUtils = __webpack_require__(128);
		var shouldUpdateReactComponent = __webpack_require__(124);
		var traverseAllChildren = __webpack_require__(129);
		var warning = __webpack_require__(18);
	
		var ReactComponentTreeHook;
	
		if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
		  // Temporary hack.
		  // Inline requires don't work well with Jest:
		  // https://github.com/facebook/react/issues/7240
		  // Remove the inline requires when we don't need them anymore:
		  // https://github.com/facebook/react/pull/7178
		  ReactComponentTreeHook = __webpack_require__(41);
		}
	
		function instantiateChild(childInstances, child, name, selfDebugID) {
		  // We found a component instance.
		  var keyUnique = childInstances[name] === undefined;
		  if (process.env.NODE_ENV !== 'production') {
		    if (!ReactComponentTreeHook) {
		      ReactComponentTreeHook = __webpack_require__(41);
		    }
		    if (!keyUnique) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
		    }
		  }
		  if (child != null && keyUnique) {
		    childInstances[name] = instantiateReactComponent(child, true);
		  }
		}
	
		/**
		 * ReactChildReconciler provides helpers for initializing or updating a set of
		 * children. Its output is suitable for passing it onto ReactMultiChild which
		 * does diffed reordering and insertion.
		 */
		var ReactChildReconciler = {
		  /**
		   * Generates a "mount image" for each of the supplied children. In the case
		   * of `ReactDOMComponent`, a mount image is a string of markup.
		   *
		   * @param {?object} nestedChildNodes Nested child maps.
		   * @return {?object} A set of child instances.
		   * @internal
		   */
		  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
		  ) {
		    if (nestedChildNodes == null) {
		      return null;
		    }
		    var childInstances = {};
	
		    if (process.env.NODE_ENV !== 'production') {
		      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
		        return instantiateChild(childInsts, child, name, selfDebugID);
		      }, childInstances);
		    } else {
		      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
		    }
		    return childInstances;
		  },
	
		  /**
		   * Updates the rendered children and returns a new set of children.
		   *
		   * @param {?object} prevChildren Previously initialized set of children.
		   * @param {?object} nextChildren Flat child element maps.
		   * @param {ReactReconcileTransaction} transaction
		   * @param {object} context
		   * @return {?object} A new set of child instances.
		   * @internal
		   */
		  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
		  ) {
		    // We currently don't have a way to track moves here but if we use iterators
		    // instead of for..in we can zip the iterators and check if an item has
		    // moved.
		    // TODO: If nothing has changed, return the prevChildren object so that we
		    // can quickly bailout if nothing has changed.
		    if (!nextChildren && !prevChildren) {
		      return;
		    }
		    var name;
		    var prevChild;
		    for (name in nextChildren) {
		      if (!nextChildren.hasOwnProperty(name)) {
		        continue;
		      }
		      prevChild = prevChildren && prevChildren[name];
		      var prevElement = prevChild && prevChild._currentElement;
		      var nextElement = nextChildren[name];
		      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
		        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
		        nextChildren[name] = prevChild;
		      } else {
		        if (prevChild) {
		          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
		          ReactReconciler.unmountComponent(prevChild, false);
		        }
		        // The child must be instantiated before it's mounted.
		        var nextChildInstance = instantiateReactComponent(nextElement, true);
		        nextChildren[name] = nextChildInstance;
		        // Creating mount image now ensures refs are resolved in right order
		        // (see https://github.com/facebook/react/pull/7101 for explanation).
		        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
		        mountImages.push(nextChildMountImage);
		      }
		    }
		    // Unmount children that are no longer present.
		    for (name in prevChildren) {
		      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
		        prevChild = prevChildren[name];
		        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
		        ReactReconciler.unmountComponent(prevChild, false);
		      }
		    }
		  },
	
		  /**
		   * Unmounts all rendered children. This should be used to clean up children
		   * when this component is unmounted.
		   *
		   * @param {?object} renderedChildren Previously initialized set of children.
		   * @internal
		   */
		  unmountChildren: function (renderedChildren, safely) {
		    for (var name in renderedChildren) {
		      if (renderedChildren.hasOwnProperty(name)) {
		        var renderedChild = renderedChildren[name];
		        ReactReconciler.unmountComponent(renderedChild, safely);
		      }
		    }
		  }
	
		};
	
		module.exports = ReactChildReconciler;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 118 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6),
		    _assign = __webpack_require__(24);
	
		var ReactCompositeComponent = __webpack_require__(119);
		var ReactEmptyComponent = __webpack_require__(125);
		var ReactHostComponent = __webpack_require__(126);
	
		var getNextDebugID = __webpack_require__(127);
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		// To avoid a cyclic dependency, we create the final class in this module
		var ReactCompositeComponentWrapper = function (element) {
		  this.construct(element);
		};
		_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
		  _instantiateReactComponent: instantiateReactComponent
		});
	
		function getDeclarationErrorAddendum(owner) {
		  if (owner) {
		    var name = owner.getName();
		    if (name) {
		      return ' Check the render method of `' + name + '`.';
		    }
		  }
		  return '';
		}
	
		/**
		 * Check if the type reference is a known internal type. I.e. not a user
		 * provided composite type.
		 *
		 * @param {function} type
		 * @return {boolean} Returns true if this is a valid internal type.
		 */
		function isInternalComponentType(type) {
		  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
		}
	
		/**
		 * Given a ReactNode, create an instance that will actually be mounted.
		 *
		 * @param {ReactNode} node
		 * @param {boolean} shouldHaveDebugID
		 * @return {object} A new instance of the element's constructor.
		 * @protected
		 */
		function instantiateReactComponent(node, shouldHaveDebugID) {
		  var instance;
	
		  if (node === null || node === false) {
		    instance = ReactEmptyComponent.create(instantiateReactComponent);
		  } else if (typeof node === 'object') {
		    var element = node;
		    var type = element.type;
		    if (typeof type !== 'function' && typeof type !== 'string') {
		      var info = '';
		      if (process.env.NODE_ENV !== 'production') {
		        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
		          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
		        }
		      }
		      info += getDeclarationErrorAddendum(element._owner);
		       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
		    }
	
		    // Special case string values
		    if (typeof element.type === 'string') {
		      instance = ReactHostComponent.createInternalComponent(element);
		    } else if (isInternalComponentType(element.type)) {
		      // This is temporarily available for custom components that are not string
		      // representations. I.e. ART. Once those are updated to use the string
		      // representation, we can drop this code path.
		      instance = new element.type(element);
	
		      // We renamed this. Allow the old name for compat. :(
		      if (!instance.getHostNode) {
		        instance.getHostNode = instance.getNativeNode;
		      }
		    } else {
		      instance = new ReactCompositeComponentWrapper(element);
		    }
		  } else if (typeof node === 'string' || typeof node === 'number') {
		    instance = ReactHostComponent.createInstanceForText(node);
		  } else {
		     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
		  }
	
		  if (process.env.NODE_ENV !== 'production') {
		    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
		  }
	
		  // These two fields are used by the DOM and ART diffing algorithms
		  // respectively. Instead of using expandos on components, we should be
		  // storing the state needed by the diffing algorithms elsewhere.
		  instance._mountIndex = 0;
		  instance._mountImage = null;
	
		  if (process.env.NODE_ENV !== 'production') {
		    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
		  }
	
		  // Internal instances should fully constructed at this point, so they should
		  // not get any new fields added to them at this point.
		  if (process.env.NODE_ENV !== 'production') {
		    if (Object.preventExtensions) {
		      Object.preventExtensions(instance);
		    }
		  }
	
		  return instance;
		}
	
		module.exports = instantiateReactComponent;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 119 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6),
		    _assign = __webpack_require__(24);
	
		var React = __webpack_require__(88);
		var ReactComponentEnvironment = __webpack_require__(115);
		var ReactCurrentOwner = __webpack_require__(43);
		var ReactErrorUtils = __webpack_require__(17);
		var ReactInstanceMap = __webpack_require__(116);
		var ReactInstrumentation = __webpack_require__(37);
		var ReactNodeTypes = __webpack_require__(120);
		var ReactReconciler = __webpack_require__(34);
	
		if (process.env.NODE_ENV !== 'production') {
		  var checkReactTypeSpec = __webpack_require__(121);
		}
	
		var emptyObject = __webpack_require__(99);
		var invariant = __webpack_require__(8);
		var shallowEqual = __webpack_require__(123);
		var shouldUpdateReactComponent = __webpack_require__(124);
		var warning = __webpack_require__(18);
	
		var CompositeTypes = {
		  ImpureClass: 0,
		  PureClass: 1,
		  StatelessFunctional: 2
		};
	
		function StatelessComponent(Component) {}
		StatelessComponent.prototype.render = function () {
		  var Component = ReactInstanceMap.get(this)._currentElement.type;
		  var element = Component(this.props, this.context, this.updater);
		  warnIfInvalidElement(Component, element);
		  return element;
		};
	
		function warnIfInvalidElement(Component, element) {
		  if (process.env.NODE_ENV !== 'production') {
		    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
		    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
		  }
		}
	
		function shouldConstruct(Component) {
		  return !!(Component.prototype && Component.prototype.isReactComponent);
		}
	
		function isPureComponent(Component) {
		  return !!(Component.prototype && Component.prototype.isPureReactComponent);
		}
	
		// Separated into a function to contain deoptimizations caused by try/finally.
		function measureLifeCyclePerf(fn, debugID, timerType) {
		  if (debugID === 0) {
		    // Top-level wrappers (see ReactMount) and empty components (see
		    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
		    // Both are implementation details that should go away in the future.
		    return fn();
		  }
	
		  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
		  try {
		    return fn();
		  } finally {
		    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
		  }
		}
	
		/**
		 * ------------------ The Life-Cycle of a Composite Component ------------------
		 *
		 * - constructor: Initialization of state. The instance is now retained.
		 *   - componentWillMount
		 *   - render
		 *   - [children's constructors]
		 *     - [children's componentWillMount and render]
		 *     - [children's componentDidMount]
		 *     - componentDidMount
		 *
		 *       Update Phases:
		 *       - componentWillReceiveProps (only called if parent updated)
		 *       - shouldComponentUpdate
		 *         - componentWillUpdate
		 *           - render
		 *           - [children's constructors or receive props phases]
		 *         - componentDidUpdate
		 *
		 *     - componentWillUnmount
		 *     - [children's componentWillUnmount]
		 *   - [children destroyed]
		 * - (destroyed): The instance is now blank, released by React and ready for GC.
		 *
		 * -----------------------------------------------------------------------------
		 */
	
		/**
		 * An incrementing ID assigned to each component when it is mounted. This is
		 * used to enforce the order in which `ReactUpdates` updates dirty components.
		 *
		 * @private
		 */
		var nextMountID = 1;
	
		/**
		 * @lends {ReactCompositeComponent.prototype}
		 */
		var ReactCompositeComponent = {
	
		  /**
		   * Base constructor for all composite component.
		   *
		   * @param {ReactElement} element
		   * @final
		   * @internal
		   */
		  construct: function (element) {
		    this._currentElement = element;
		    this._rootNodeID = 0;
		    this._compositeType = null;
		    this._instance = null;
		    this._hostParent = null;
		    this._hostContainerInfo = null;
	
		    // See ReactUpdateQueue
		    this._updateBatchNumber = null;
		    this._pendingElement = null;
		    this._pendingStateQueue = null;
		    this._pendingReplaceState = false;
		    this._pendingForceUpdate = false;
	
		    this._renderedNodeType = null;
		    this._renderedComponent = null;
		    this._context = null;
		    this._mountOrder = 0;
		    this._topLevelWrapper = null;
	
		    // See ReactUpdates and ReactUpdateQueue.
		    this._pendingCallbacks = null;
	
		    // ComponentWillUnmount shall only be called once
		    this._calledComponentWillUnmount = false;
	
		    if (process.env.NODE_ENV !== 'production') {
		      this._warnedAboutRefsInRender = false;
		    }
		  },
	
		  /**
		   * Initializes the component, renders markup, and registers event listeners.
		   *
		   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
		   * @param {?object} hostParent
		   * @param {?object} hostContainerInfo
		   * @param {?object} context
		   * @return {?string} Rendered markup to be inserted into the DOM.
		   * @final
		   * @internal
		   */
		  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
		    var _this = this;
	
		    this._context = context;
		    this._mountOrder = nextMountID++;
		    this._hostParent = hostParent;
		    this._hostContainerInfo = hostContainerInfo;
	
		    var publicProps = this._currentElement.props;
		    var publicContext = this._processContext(context);
	
		    var Component = this._currentElement.type;
	
		    var updateQueue = transaction.getUpdateQueue();
	
		    // Initialize the public class
		    var doConstruct = shouldConstruct(Component);
		    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
		    var renderedElement;
	
		    // Support functional components
		    if (!doConstruct && (inst == null || inst.render == null)) {
		      renderedElement = inst;
		      warnIfInvalidElement(Component, renderedElement);
		      !(inst === null || inst === false || React.isValidElement(inst)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
		      inst = new StatelessComponent(Component);
		      this._compositeType = CompositeTypes.StatelessFunctional;
		    } else {
		      if (isPureComponent(Component)) {
		        this._compositeType = CompositeTypes.PureClass;
		      } else {
		        this._compositeType = CompositeTypes.ImpureClass;
		      }
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      // This will throw later in _renderValidatedComponent, but add an early
		      // warning now to help debugging
		      if (inst.render == null) {
		        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
		      }
	
		      var propsMutated = inst.props !== publicProps;
		      var componentName = Component.displayName || Component.name || 'Component';
	
		      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
		    }
	
		    // These should be set up in the constructor, but as a convenience for
		    // simpler class abstractions, we set them up after the fact.
		    inst.props = publicProps;
		    inst.context = publicContext;
		    inst.refs = emptyObject;
		    inst.updater = updateQueue;
	
		    this._instance = inst;
	
		    // Store a reference from the instance back to the internal representation
		    ReactInstanceMap.set(inst, this);
	
		    if (process.env.NODE_ENV !== 'production') {
		      // Since plain JS classes are defined without any special initialization
		      // logic, we can not catch common errors early. Therefore, we have to
		      // catch them here, at initialization time, instead.
		      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
		      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
		      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
		      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
		      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
		      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
		      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
		    }
	
		    var initialState = inst.state;
		    if (initialState === undefined) {
		      inst.state = initialState = null;
		    }
		    !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
		    this._pendingStateQueue = null;
		    this._pendingReplaceState = false;
		    this._pendingForceUpdate = false;
	
		    var markup;
		    if (inst.unstable_handleError) {
		      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
		    } else {
		      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
		    }
	
		    if (inst.componentDidMount) {
		      if (process.env.NODE_ENV !== 'production') {
		        transaction.getReactMountReady().enqueue(function () {
		          measureLifeCyclePerf(function () {
		            return inst.componentDidMount();
		          }, _this._debugID, 'componentDidMount');
		        });
		      } else {
		        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
		      }
		    }
	
		    return markup;
		  },
	
		  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
		    if (process.env.NODE_ENV !== 'production') {
		      ReactCurrentOwner.current = this;
		      try {
		        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
		      } finally {
		        ReactCurrentOwner.current = null;
		      }
		    } else {
		      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
		    }
		  },
	
		  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
		    var Component = this._currentElement.type;
	
		    if (doConstruct) {
		      if (process.env.NODE_ENV !== 'production') {
		        return measureLifeCyclePerf(function () {
		          return new Component(publicProps, publicContext, updateQueue);
		        }, this._debugID, 'ctor');
		      } else {
		        return new Component(publicProps, publicContext, updateQueue);
		      }
		    }
	
		    // This can still be an instance in case of factory components
		    // but we'll count this as time spent rendering as the more common case.
		    if (process.env.NODE_ENV !== 'production') {
		      return measureLifeCyclePerf(function () {
		        return Component(publicProps, publicContext, updateQueue);
		      }, this._debugID, 'render');
		    } else {
		      return Component(publicProps, publicContext, updateQueue);
		    }
		  },
	
		  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
		    var markup;
		    var checkpoint = transaction.checkpoint();
		    try {
		      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
		    } catch (e) {
		      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
		      transaction.rollback(checkpoint);
		      this._instance.unstable_handleError(e);
		      if (this._pendingStateQueue) {
		        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
		      }
		      checkpoint = transaction.checkpoint();
	
		      this._renderedComponent.unmountComponent(true);
		      transaction.rollback(checkpoint);
	
		      // Try again - we've informed the component about the error, so they can render an error message this time.
		      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
		      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
		    }
		    return markup;
		  },
	
		  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
		    var inst = this._instance;
	
		    var debugID = 0;
		    if (process.env.NODE_ENV !== 'production') {
		      debugID = this._debugID;
		    }
	
		    if (inst.componentWillMount) {
		      if (process.env.NODE_ENV !== 'production') {
		        measureLifeCyclePerf(function () {
		          return inst.componentWillMount();
		        }, debugID, 'componentWillMount');
		      } else {
		        inst.componentWillMount();
		      }
		      // When mounting, calls to `setState` by `componentWillMount` will set
		      // `this._pendingStateQueue` without triggering a re-render.
		      if (this._pendingStateQueue) {
		        inst.state = this._processPendingState(inst.props, inst.context);
		      }
		    }
	
		    // If not a stateless component, we now render
		    if (renderedElement === undefined) {
		      renderedElement = this._renderValidatedComponent();
		    }
	
		    var nodeType = ReactNodeTypes.getType(renderedElement);
		    this._renderedNodeType = nodeType;
		    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
		    );
		    this._renderedComponent = child;
	
		    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
		    if (process.env.NODE_ENV !== 'production') {
		      if (debugID !== 0) {
		        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
		        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
		      }
		    }
	
		    return markup;
		  },
	
		  getHostNode: function () {
		    return ReactReconciler.getHostNode(this._renderedComponent);
		  },
	
		  /**
		   * Releases any resources allocated by `mountComponent`.
		   *
		   * @final
		   * @internal
		   */
		  unmountComponent: function (safely) {
		    if (!this._renderedComponent) {
		      return;
		    }
	
		    var inst = this._instance;
	
		    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
		      inst._calledComponentWillUnmount = true;
	
		      if (safely) {
		        var name = this.getName() + '.componentWillUnmount()';
		        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
		      } else {
		        if (process.env.NODE_ENV !== 'production') {
		          measureLifeCyclePerf(function () {
		            return inst.componentWillUnmount();
		          }, this._debugID, 'componentWillUnmount');
		        } else {
		          inst.componentWillUnmount();
		        }
		      }
		    }
	
		    if (this._renderedComponent) {
		      ReactReconciler.unmountComponent(this._renderedComponent, safely);
		      this._renderedNodeType = null;
		      this._renderedComponent = null;
		      this._instance = null;
		    }
	
		    // Reset pending fields
		    // Even if this component is scheduled for another update in ReactUpdates,
		    // it would still be ignored because these fields are reset.
		    this._pendingStateQueue = null;
		    this._pendingReplaceState = false;
		    this._pendingForceUpdate = false;
		    this._pendingCallbacks = null;
		    this._pendingElement = null;
	
		    // These fields do not really need to be reset since this object is no
		    // longer accessible.
		    this._context = null;
		    this._rootNodeID = 0;
		    this._topLevelWrapper = null;
	
		    // Delete the reference from the instance to this internal representation
		    // which allow the internals to be properly cleaned up even if the user
		    // leaks a reference to the public instance.
		    ReactInstanceMap.remove(inst);
	
		    // Some existing components rely on inst.props even after they've been
		    // destroyed (in event handlers).
		    // TODO: inst.props = null;
		    // TODO: inst.state = null;
		    // TODO: inst.context = null;
		  },
	
		  /**
		   * Filters the context object to only contain keys specified in
		   * `contextTypes`
		   *
		   * @param {object} context
		   * @return {?object}
		   * @private
		   */
		  _maskContext: function (context) {
		    var Component = this._currentElement.type;
		    var contextTypes = Component.contextTypes;
		    if (!contextTypes) {
		      return emptyObject;
		    }
		    var maskedContext = {};
		    for (var contextName in contextTypes) {
		      maskedContext[contextName] = context[contextName];
		    }
		    return maskedContext;
		  },
	
		  /**
		   * Filters the context object to only contain keys specified in
		   * `contextTypes`, and asserts that they are valid.
		   *
		   * @param {object} context
		   * @return {?object}
		   * @private
		   */
		  _processContext: function (context) {
		    var maskedContext = this._maskContext(context);
		    if (process.env.NODE_ENV !== 'production') {
		      var Component = this._currentElement.type;
		      if (Component.contextTypes) {
		        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
		      }
		    }
		    return maskedContext;
		  },
	
		  /**
		   * @param {object} currentContext
		   * @return {object}
		   * @private
		   */
		  _processChildContext: function (currentContext) {
		    var Component = this._currentElement.type;
		    var inst = this._instance;
		    var childContext;
	
		    if (inst.getChildContext) {
		      if (process.env.NODE_ENV !== 'production') {
		        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
		        try {
		          childContext = inst.getChildContext();
		        } finally {
		          ReactInstrumentation.debugTool.onEndProcessingChildContext();
		        }
		      } else {
		        childContext = inst.getChildContext();
		      }
		    }
	
		    if (childContext) {
		      !(typeof Component.childContextTypes === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
		      if (process.env.NODE_ENV !== 'production') {
		        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
		      }
		      for (var name in childContext) {
		        !(name in Component.childContextTypes) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
		      }
		      return _assign({}, currentContext, childContext);
		    }
		    return currentContext;
		  },
	
		  /**
		   * Assert that the context types are valid
		   *
		   * @param {object} typeSpecs Map of context field to a ReactPropType
		   * @param {object} values Runtime values that need to be type-checked
		   * @param {string} location e.g. "prop", "context", "child context"
		   * @private
		   */
		  _checkContextTypes: function (typeSpecs, values, location) {
		    if (process.env.NODE_ENV !== 'production') {
		      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
		    }
		  },
	
		  receiveComponent: function (nextElement, transaction, nextContext) {
		    var prevElement = this._currentElement;
		    var prevContext = this._context;
	
		    this._pendingElement = null;
	
		    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
		  },
	
		  /**
		   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
		   * is set, update the component.
		   *
		   * @param {ReactReconcileTransaction} transaction
		   * @internal
		   */
		  performUpdateIfNecessary: function (transaction) {
		    if (this._pendingElement != null) {
		      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
		    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
		      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
		    } else {
		      this._updateBatchNumber = null;
		    }
		  },
	
		  /**
		   * Perform an update to a mounted component. The componentWillReceiveProps and
		   * shouldComponentUpdate methods are called, then (assuming the update isn't
		   * skipped) the remaining update lifecycle methods are called and the DOM
		   * representation is updated.
		   *
		   * By default, this implements React's rendering and reconciliation algorithm.
		   * Sophisticated clients may wish to override this.
		   *
		   * @param {ReactReconcileTransaction} transaction
		   * @param {ReactElement} prevParentElement
		   * @param {ReactElement} nextParentElement
		   * @internal
		   * @overridable
		   */
		  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
		    var inst = this._instance;
		    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
		    var willReceive = false;
		    var nextContext;
	
		    // Determine if the context has changed or not
		    if (this._context === nextUnmaskedContext) {
		      nextContext = inst.context;
		    } else {
		      nextContext = this._processContext(nextUnmaskedContext);
		      willReceive = true;
		    }
	
		    var prevProps = prevParentElement.props;
		    var nextProps = nextParentElement.props;
	
		    // Not a simple state update but a props update
		    if (prevParentElement !== nextParentElement) {
		      willReceive = true;
		    }
	
		    // An update here will schedule an update but immediately set
		    // _pendingStateQueue which will ensure that any state updates gets
		    // immediately reconciled instead of waiting for the next batch.
		    if (willReceive && inst.componentWillReceiveProps) {
		      if (process.env.NODE_ENV !== 'production') {
		        measureLifeCyclePerf(function () {
		          return inst.componentWillReceiveProps(nextProps, nextContext);
		        }, this._debugID, 'componentWillReceiveProps');
		      } else {
		        inst.componentWillReceiveProps(nextProps, nextContext);
		      }
		    }
	
		    var nextState = this._processPendingState(nextProps, nextContext);
		    var shouldUpdate = true;
	
		    if (!this._pendingForceUpdate) {
		      if (inst.shouldComponentUpdate) {
		        if (process.env.NODE_ENV !== 'production') {
		          shouldUpdate = measureLifeCyclePerf(function () {
		            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
		          }, this._debugID, 'shouldComponentUpdate');
		        } else {
		          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
		        }
		      } else {
		        if (this._compositeType === CompositeTypes.PureClass) {
		          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
		        }
		      }
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
		    }
	
		    this._updateBatchNumber = null;
		    if (shouldUpdate) {
		      this._pendingForceUpdate = false;
		      // Will set `this.props`, `this.state` and `this.context`.
		      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
		    } else {
		      // If it's determined that a component should not update, we still want
		      // to set props and state but we shortcut the rest of the update.
		      this._currentElement = nextParentElement;
		      this._context = nextUnmaskedContext;
		      inst.props = nextProps;
		      inst.state = nextState;
		      inst.context = nextContext;
		    }
		  },
	
		  _processPendingState: function (props, context) {
		    var inst = this._instance;
		    var queue = this._pendingStateQueue;
		    var replace = this._pendingReplaceState;
		    this._pendingReplaceState = false;
		    this._pendingStateQueue = null;
	
		    if (!queue) {
		      return inst.state;
		    }
	
		    if (replace && queue.length === 1) {
		      return queue[0];
		    }
	
		    var nextState = _assign({}, replace ? queue[0] : inst.state);
		    for (var i = replace ? 1 : 0; i < queue.length; i++) {
		      var partial = queue[i];
		      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
		    }
	
		    return nextState;
		  },
	
		  /**
		   * Merges new props and state, notifies delegate methods of update and
		   * performs update.
		   *
		   * @param {ReactElement} nextElement Next element
		   * @param {object} nextProps Next public object to set as properties.
		   * @param {?object} nextState Next object to set as state.
		   * @param {?object} nextContext Next public object to set as context.
		   * @param {ReactReconcileTransaction} transaction
		   * @param {?object} unmaskedContext
		   * @private
		   */
		  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
		    var _this2 = this;
	
		    var inst = this._instance;
	
		    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
		    var prevProps;
		    var prevState;
		    var prevContext;
		    if (hasComponentDidUpdate) {
		      prevProps = inst.props;
		      prevState = inst.state;
		      prevContext = inst.context;
		    }
	
		    if (inst.componentWillUpdate) {
		      if (process.env.NODE_ENV !== 'production') {
		        measureLifeCyclePerf(function () {
		          return inst.componentWillUpdate(nextProps, nextState, nextContext);
		        }, this._debugID, 'componentWillUpdate');
		      } else {
		        inst.componentWillUpdate(nextProps, nextState, nextContext);
		      }
		    }
	
		    this._currentElement = nextElement;
		    this._context = unmaskedContext;
		    inst.props = nextProps;
		    inst.state = nextState;
		    inst.context = nextContext;
	
		    this._updateRenderedComponent(transaction, unmaskedContext);
	
		    if (hasComponentDidUpdate) {
		      if (process.env.NODE_ENV !== 'production') {
		        transaction.getReactMountReady().enqueue(function () {
		          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
		        });
		      } else {
		        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
		      }
		    }
		  },
	
		  /**
		   * Call the component's `render` method and update the DOM accordingly.
		   *
		   * @param {ReactReconcileTransaction} transaction
		   * @internal
		   */
		  _updateRenderedComponent: function (transaction, context) {
		    var prevComponentInstance = this._renderedComponent;
		    var prevRenderedElement = prevComponentInstance._currentElement;
		    var nextRenderedElement = this._renderValidatedComponent();
	
		    var debugID = 0;
		    if (process.env.NODE_ENV !== 'production') {
		      debugID = this._debugID;
		    }
	
		    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
		      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
		    } else {
		      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
		      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
		      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
		      this._renderedNodeType = nodeType;
		      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
		      );
		      this._renderedComponent = child;
	
		      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
		      if (process.env.NODE_ENV !== 'production') {
		        if (debugID !== 0) {
		          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
		          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
		        }
		      }
	
		      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
		    }
		  },
	
		  /**
		   * Overridden in shallow rendering.
		   *
		   * @protected
		   */
		  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
		    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
		  },
	
		  /**
		   * @protected
		   */
		  _renderValidatedComponentWithoutOwnerOrContext: function () {
		    var inst = this._instance;
		    var renderedElement;
	
		    if (process.env.NODE_ENV !== 'production') {
		      renderedElement = measureLifeCyclePerf(function () {
		        return inst.render();
		      }, this._debugID, 'render');
		    } else {
		      renderedElement = inst.render();
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      // We allow auto-mocks to proceed as if they're returning null.
		      if (renderedElement === undefined && inst.render._isMockFunction) {
		        // This is probably bad practice. Consider warning here and
		        // deprecating this convenience.
		        renderedElement = null;
		      }
		    }
	
		    return renderedElement;
		  },
	
		  /**
		   * @private
		   */
		  _renderValidatedComponent: function () {
		    var renderedElement;
		    if (process.env.NODE_ENV !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
		      ReactCurrentOwner.current = this;
		      try {
		        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
		      } finally {
		        ReactCurrentOwner.current = null;
		      }
		    } else {
		      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
		    }
		    !(
		    // TODO: An `isValidNode` function would probably be more appropriate
		    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
		    return renderedElement;
		  },
	
		  /**
		   * Lazily allocates the refs object and stores `component` as `ref`.
		   *
		   * @param {string} ref Reference name.
		   * @param {component} component Component to store as `ref`.
		   * @final
		   * @private
		   */
		  attachRef: function (ref, component) {
		    var inst = this.getPublicInstance();
		    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
		    var publicComponentInstance = component.getPublicInstance();
		    if (process.env.NODE_ENV !== 'production') {
		      var componentName = component && component.getName ? component.getName() : 'a component';
		      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
		    }
		    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
		    refs[ref] = publicComponentInstance;
		  },
	
		  /**
		   * Detaches a reference name.
		   *
		   * @param {string} ref Name to dereference.
		   * @final
		   * @private
		   */
		  detachRef: function (ref) {
		    var refs = this.getPublicInstance().refs;
		    delete refs[ref];
		  },
	
		  /**
		   * Get a text description of the component that can be used to identify it
		   * in error messages.
		   * @return {string} The name or null.
		   * @internal
		   */
		  getName: function () {
		    var type = this._currentElement.type;
		    var constructor = this._instance && this._instance.constructor;
		    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
		  },
	
		  /**
		   * Get the publicly accessible representation of this component - i.e. what
		   * is exposed by refs and returned by render. Can be null for stateless
		   * components.
		   *
		   * @return {ReactComponent} the public component instance.
		   * @internal
		   */
		  getPublicInstance: function () {
		    var inst = this._instance;
		    if (this._compositeType === CompositeTypes.StatelessFunctional) {
		      return null;
		    }
		    return inst;
		  },
	
		  // Stub
		  _instantiateReactComponent: null
	
		};
	
		module.exports = ReactCompositeComponent;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 120 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var React = __webpack_require__(88);
	
		var invariant = __webpack_require__(8);
	
		var ReactNodeTypes = {
		  HOST: 0,
		  COMPOSITE: 1,
		  EMPTY: 2,
	
		  getType: function (node) {
		    if (node === null || node === false) {
		      return ReactNodeTypes.EMPTY;
		    } else if (React.isValidElement(node)) {
		      if (typeof node.type === 'function') {
		        return ReactNodeTypes.COMPOSITE;
		      } else {
		        return ReactNodeTypes.HOST;
		      }
		    }
		     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
		  }
		};
	
		module.exports = ReactNodeTypes;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 121 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var ReactPropTypeLocationNames = __webpack_require__(122);
		var ReactPropTypesSecret = __webpack_require__(110);
	
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		var ReactComponentTreeHook;
	
		if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
		  // Temporary hack.
		  // Inline requires don't work well with Jest:
		  // https://github.com/facebook/react/issues/7240
		  // Remove the inline requires when we don't need them anymore:
		  // https://github.com/facebook/react/pull/7178
		  ReactComponentTreeHook = __webpack_require__(41);
		}
	
		var loggedTypeFailures = {};
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?object} element The React element that is being type-checked
		 * @param {?number} debugID The React component instance that is being type-checked
		 * @private
		 */
		function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
		  for (var typeSpecName in typeSpecs) {
		    if (typeSpecs.hasOwnProperty(typeSpecName)) {
		      var error;
		      // Prop type validation may throw. In case they do, we don't want to
		      // fail the render phase where it didn't fail before. So we log it.
		      // After these have been cleaned up, we'll let them throw.
		      try {
		        // This is intentionally an invariant that gets caught. It's the same
		        // behavior as without this statement except with a better message.
		        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
		        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		      } catch (ex) {
		        error = ex;
		      }
		      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
		      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		        // Only monitor this failure once because there tends to be a lot of the
		        // same error.
		        loggedTypeFailures[error.message] = true;
	
		        var componentStackInfo = '';
	
		        if (process.env.NODE_ENV !== 'production') {
		          if (!ReactComponentTreeHook) {
		            ReactComponentTreeHook = __webpack_require__(41);
		          }
		          if (debugID !== null) {
		            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
		          } else if (element !== null) {
		            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
		          }
		        }
	
		        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
		      }
		    }
		  }
		}
	
		module.exports = checkReactTypeSpec;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 122 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var ReactPropTypeLocationNames = {};
	
		if (process.env.NODE_ENV !== 'production') {
		  ReactPropTypeLocationNames = {
		    prop: 'prop',
		    context: 'context',
		    childContext: 'child context'
		  };
		}
	
		module.exports = ReactPropTypeLocationNames;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 123 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 * 
		 */
	
		/*eslint-disable no-self-compare */
	
		'use strict';
	
		var hasOwnProperty = Object.prototype.hasOwnProperty;
	
		/**
		 * inlined Object.is polyfill to avoid requiring consumers ship their own
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		 */
		function is(x, y) {
		  // SameValue algorithm
		  if (x === y) {
		    // Steps 1-5, 7-10
		    // Steps 6.b-6.e: +0 != -0
		    // Added the nonzero y check to make Flow happy, but it is redundant
		    return x !== 0 || y !== 0 || 1 / x === 1 / y;
		  } else {
		    // Step 6.a: NaN == NaN
		    return x !== x && y !== y;
		  }
		}
	
		/**
		 * Performs equality by iterating through keys on an object and returning false
		 * when any key has values which are not strictly equal between the arguments.
		 * Returns true when the values of all keys are strictly equal.
		 */
		function shallowEqual(objA, objB) {
		  if (is(objA, objB)) {
		    return true;
		  }
	
		  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
		    return false;
		  }
	
		  var keysA = Object.keys(objA);
		  var keysB = Object.keys(objB);
	
		  if (keysA.length !== keysB.length) {
		    return false;
		  }
	
		  // Test for A's keys different from B.
		  for (var i = 0; i < keysA.length; i++) {
		    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
		module.exports = shallowEqual;
	
	/***/ },
	/* 124 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Given a `prevElement` and `nextElement`, determines if the existing
		 * instance should be updated as opposed to being destroyed or replaced by a new
		 * instance. Both arguments are elements. This ensures that this logic can
		 * operate on stateless trees without any backing instance.
		 *
		 * @param {?object} prevElement
		 * @param {?object} nextElement
		 * @return {boolean} True if the existing instance should be updated.
		 * @protected
		 */
	
		function shouldUpdateReactComponent(prevElement, nextElement) {
		  var prevEmpty = prevElement === null || prevElement === false;
		  var nextEmpty = nextElement === null || nextElement === false;
		  if (prevEmpty || nextEmpty) {
		    return prevEmpty === nextEmpty;
		  }
	
		  var prevType = typeof prevElement;
		  var nextType = typeof nextElement;
		  if (prevType === 'string' || prevType === 'number') {
		    return nextType === 'string' || nextType === 'number';
		  } else {
		    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
		  }
		}
	
		module.exports = shouldUpdateReactComponent;
	
	/***/ },
	/* 125 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyComponentFactory;
	
		var ReactEmptyComponentInjection = {
		  injectEmptyComponentFactory: function (factory) {
		    emptyComponentFactory = factory;
		  }
		};
	
		var ReactEmptyComponent = {
		  create: function (instantiate) {
		    return emptyComponentFactory(instantiate);
		  }
		};
	
		ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
		module.exports = ReactEmptyComponent;
	
	/***/ },
	/* 126 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		var genericComponentClass = null;
		var textComponentClass = null;
	
		var ReactHostComponentInjection = {
		  // This accepts a class that receives the tag string. This is a catch all
		  // that can render any kind of tag.
		  injectGenericComponentClass: function (componentClass) {
		    genericComponentClass = componentClass;
		  },
		  // This accepts a text component class that takes the text string to be
		  // rendered as props.
		  injectTextComponentClass: function (componentClass) {
		    textComponentClass = componentClass;
		  }
		};
	
		/**
		 * Get a host internal component class for a specific tag.
		 *
		 * @param {ReactElement} element The element to create.
		 * @return {function} The internal class constructor function.
		 */
		function createInternalComponent(element) {
		  !genericComponentClass ? process.env.NODE_ENV !== 'production' ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
		  return new genericComponentClass(element);
		}
	
		/**
		 * @param {ReactText} text
		 * @return {ReactComponent}
		 */
		function createInstanceForText(text) {
		  return new textComponentClass(text);
		}
	
		/**
		 * @param {ReactComponent} component
		 * @return {boolean}
		 */
		function isTextComponent(component) {
		  return component instanceof textComponentClass;
		}
	
		var ReactHostComponent = {
		  createInternalComponent: createInternalComponent,
		  createInstanceForText: createInstanceForText,
		  isTextComponent: isTextComponent,
		  injection: ReactHostComponentInjection
		};
	
		module.exports = ReactHostComponent;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 127 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var nextDebugID = 1;
	
		function getNextDebugID() {
		  return nextDebugID++;
		}
	
		module.exports = getNextDebugID;
	
	/***/ },
	/* 128 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		/**
		 * Escape and wrap key so it is safe to use as a reactid
		 *
		 * @param {string} key to be escaped.
		 * @return {string} the escaped key.
		 */
	
		function escape(key) {
		  var escapeRegex = /[=:]/g;
		  var escaperLookup = {
		    '=': '=0',
		    ':': '=2'
		  };
		  var escapedString = ('' + key).replace(escapeRegex, function (match) {
		    return escaperLookup[match];
		  });
	
		  return '$' + escapedString;
		}
	
		/**
		 * Unescape and unwrap key for human-readable display
		 *
		 * @param {string} key to unescape.
		 * @return {string} the unescaped key.
		 */
		function unescape(key) {
		  var unescapeRegex = /(=0|=2)/g;
		  var unescaperLookup = {
		    '=0': '=',
		    '=2': ':'
		  };
		  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
		  return ('' + keySubstring).replace(unescapeRegex, function (match) {
		    return unescaperLookup[match];
		  });
		}
	
		var KeyEscapeUtils = {
		  escape: escape,
		  unescape: unescape
		};
	
		module.exports = KeyEscapeUtils;
	
	/***/ },
	/* 129 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var ReactCurrentOwner = __webpack_require__(43);
		var REACT_ELEMENT_TYPE = __webpack_require__(130);
	
		var getIteratorFn = __webpack_require__(131);
		var invariant = __webpack_require__(8);
		var KeyEscapeUtils = __webpack_require__(128);
		var warning = __webpack_require__(18);
	
		var SEPARATOR = '.';
		var SUBSEPARATOR = ':';
	
		/**
		 * This is inlined from ReactElement since this file is shared between
		 * isomorphic and renderers. We could extract this to a
		 *
		 */
	
		/**
		 * TODO: Test that a single child and an array with one item have the same key
		 * pattern.
		 */
	
		var didWarnAboutMaps = false;
	
		/**
		 * Generate a key string that identifies a component within a set.
		 *
		 * @param {*} component A component that could contain a manual key.
		 * @param {number} index Index that is used if a manual key is not provided.
		 * @return {string}
		 */
		function getComponentKey(component, index) {
		  // Do some typechecking here since we call this blindly. We want to ensure
		  // that we don't block potential future ES APIs.
		  if (component && typeof component === 'object' && component.key != null) {
		    // Explicit key
		    return KeyEscapeUtils.escape(component.key);
		  }
		  // Implicit key determined by the index in the set
		  return index.toString(36);
		}
	
		/**
		 * @param {?*} children Children tree container.
		 * @param {!string} nameSoFar Name of the key path so far.
		 * @param {!function} callback Callback to invoke with each child found.
		 * @param {?*} traverseContext Used to pass information throughout the traversal
		 * process.
		 * @return {!number} The number of children in this subtree.
		 */
		function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
		  var type = typeof children;
	
		  if (type === 'undefined' || type === 'boolean') {
		    // All of the above are perceived as null.
		    children = null;
		  }
	
		  if (children === null || type === 'string' || type === 'number' ||
		  // The following is inlined from ReactElement. This means we can optimize
		  // some checks. React Fiber also inlines this logic for similar purposes.
		  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
		    callback(traverseContext, children,
		    // If it's the only child, treat the name as if it was wrapped in an array
		    // so that it's consistent if the number of children grows.
		    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
		    return 1;
		  }
	
		  var child;
		  var nextName;
		  var subtreeCount = 0; // Count of children found in the current subtree.
		  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
		  if (Array.isArray(children)) {
		    for (var i = 0; i < children.length; i++) {
		      child = children[i];
		      nextName = nextNamePrefix + getComponentKey(child, i);
		      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
		    }
		  } else {
		    var iteratorFn = getIteratorFn(children);
		    if (iteratorFn) {
		      var iterator = iteratorFn.call(children);
		      var step;
		      if (iteratorFn !== children.entries) {
		        var ii = 0;
		        while (!(step = iterator.next()).done) {
		          child = step.value;
		          nextName = nextNamePrefix + getComponentKey(child, ii++);
		          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
		        }
		      } else {
		        if (process.env.NODE_ENV !== 'production') {
		          var mapsAsChildrenAddendum = '';
		          if (ReactCurrentOwner.current) {
		            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
		            if (mapsAsChildrenOwnerName) {
		              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
		            }
		          }
		          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
		          didWarnAboutMaps = true;
		        }
		        // Iterator will provide entry [k,v] tuples rather than values.
		        while (!(step = iterator.next()).done) {
		          var entry = step.value;
		          if (entry) {
		            child = entry[1];
		            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
		            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
		          }
		        }
		      }
		    } else if (type === 'object') {
		      var addendum = '';
		      if (process.env.NODE_ENV !== 'production') {
		        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
		        if (children._isReactElement) {
		          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
		        }
		        if (ReactCurrentOwner.current) {
		          var name = ReactCurrentOwner.current.getName();
		          if (name) {
		            addendum += ' Check the render method of `' + name + '`.';
		          }
		        }
		      }
		      var childrenString = String(children);
		       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
		    }
		  }
	
		  return subtreeCount;
		}
	
		/**
		 * Traverses children that are typically specified as `props.children`, but
		 * might also be specified through attributes:
		 *
		 * - `traverseAllChildren(this.props.children, ...)`
		 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
		 *
		 * The `traverseContext` is an optional argument that is passed through the
		 * entire traversal. It can be used to store accumulations or anything else that
		 * the callback might find relevant.
		 *
		 * @param {?*} children Children tree object.
		 * @param {!function} callback To invoke upon traversing each child.
		 * @param {?*} traverseContext Context for traversal.
		 * @return {!number} The number of children in this subtree.
		 */
		function traverseAllChildren(children, callback, traverseContext) {
		  if (children == null) {
		    return 0;
		  }
	
		  return traverseAllChildrenImpl(children, '', callback, traverseContext);
		}
	
		module.exports = traverseAllChildren;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 130 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		// The Symbol used to tag the ReactElement type. If there is no native Symbol
		// nor polyfill, then a plain number is used for performance.
	
		var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
		module.exports = REACT_ELEMENT_TYPE;
	
	/***/ },
	/* 131 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		/* global Symbol */
	
		var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		/**
		 * Returns the iterator method function contained on the iterable object.
		 *
		 * Be sure to invoke the function with the iterable as context:
		 *
		 *     var iteratorFn = getIteratorFn(myIterable);
		 *     if (iteratorFn) {
		 *       var iterator = iteratorFn.call(myIterable);
		 *       ...
		 *     }
		 *
		 * @param {?object} maybeIterable
		 * @return {?function}
		 */
		function getIteratorFn(maybeIterable) {
		  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		  if (typeof iteratorFn === 'function') {
		    return iteratorFn;
		  }
		}
	
		module.exports = getIteratorFn;
	
	/***/ },
	/* 132 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var KeyEscapeUtils = __webpack_require__(128);
		var traverseAllChildren = __webpack_require__(129);
		var warning = __webpack_require__(18);
	
		var ReactComponentTreeHook;
	
		if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
		  // Temporary hack.
		  // Inline requires don't work well with Jest:
		  // https://github.com/facebook/react/issues/7240
		  // Remove the inline requires when we don't need them anymore:
		  // https://github.com/facebook/react/pull/7178
		  ReactComponentTreeHook = __webpack_require__(41);
		}
	
		/**
		 * @param {function} traverseContext Context passed through traversal.
		 * @param {?ReactComponent} child React child component.
		 * @param {!string} name String name of key path to child.
		 * @param {number=} selfDebugID Optional debugID of the current internal instance.
		 */
		function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
		  // We found a component instance.
		  if (traverseContext && typeof traverseContext === 'object') {
		    var result = traverseContext;
		    var keyUnique = result[name] === undefined;
		    if (process.env.NODE_ENV !== 'production') {
		      if (!ReactComponentTreeHook) {
		        ReactComponentTreeHook = __webpack_require__(41);
		      }
		      if (!keyUnique) {
		        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
		      }
		    }
		    if (keyUnique && child != null) {
		      result[name] = child;
		    }
		  }
		}
	
		/**
		 * Flattens children that are typically specified as `props.children`. Any null
		 * children will not be included in the resulting object.
		 * @return {!object} flattened children keyed by name.
		 */
		function flattenChildren(children, selfDebugID) {
		  if (children == null) {
		    return children;
		  }
		  var result = {};
	
		  if (process.env.NODE_ENV !== 'production') {
		    traverseAllChildren(children, function (traverseContext, child, name) {
		      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
		    }, result);
		  } else {
		    traverseAllChildren(children, flattenSingleChildIntoContext, result);
		  }
		  return result;
		}
	
		module.exports = flattenChildren;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 133 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var PooledClass = __webpack_require__(25);
		var Transaction = __webpack_require__(46);
		var ReactInstrumentation = __webpack_require__(37);
		var ReactServerUpdateQueue = __webpack_require__(134);
	
		/**
		 * Executed within the scope of the `Transaction` instance. Consider these as
		 * being member methods, but with an implied ordering while being isolated from
		 * each other.
		 */
		var TRANSACTION_WRAPPERS = [];
	
		if (process.env.NODE_ENV !== 'production') {
		  TRANSACTION_WRAPPERS.push({
		    initialize: ReactInstrumentation.debugTool.onBeginFlush,
		    close: ReactInstrumentation.debugTool.onEndFlush
		  });
		}
	
		var noopCallbackQueue = {
		  enqueue: function () {}
		};
	
		/**
		 * @class ReactServerRenderingTransaction
		 * @param {boolean} renderToStaticMarkup
		 */
		function ReactServerRenderingTransaction(renderToStaticMarkup) {
		  this.reinitializeTransaction();
		  this.renderToStaticMarkup = renderToStaticMarkup;
		  this.useCreateElement = false;
		  this.updateQueue = new ReactServerUpdateQueue(this);
		}
	
		var Mixin = {
		  /**
		   * @see Transaction
		   * @abstract
		   * @final
		   * @return {array} Empty list of operation wrap procedures.
		   */
		  getTransactionWrappers: function () {
		    return TRANSACTION_WRAPPERS;
		  },
	
		  /**
		   * @return {object} The queue to collect `onDOMReady` callbacks with.
		   */
		  getReactMountReady: function () {
		    return noopCallbackQueue;
		  },
	
		  /**
		   * @return {object} The queue to collect React async events.
		   */
		  getUpdateQueue: function () {
		    return this.updateQueue;
		  },
	
		  /**
		   * `PooledClass` looks for this, and will invoke this before allowing this
		   * instance to be reused.
		   */
		  destructor: function () {},
	
		  checkpoint: function () {},
	
		  rollback: function () {}
		};
	
		_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
		PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
		module.exports = ReactServerRenderingTransaction;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 134 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2015-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var ReactUpdateQueue = __webpack_require__(135);
	
		var warning = __webpack_require__(18);
	
		function warnNoop(publicInstance, callerName) {
		  if (process.env.NODE_ENV !== 'production') {
		    var constructor = publicInstance.constructor;
		    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
		  }
		}
	
		/**
		 * This is the update queue used for server rendering.
		 * It delegates to ReactUpdateQueue while server rendering is in progress and
		 * switches to ReactNoopUpdateQueue after the transaction has completed.
		 * @class ReactServerUpdateQueue
		 * @param {Transaction} transaction
		 */
	
		var ReactServerUpdateQueue = function () {
		  function ReactServerUpdateQueue(transaction) {
		    _classCallCheck(this, ReactServerUpdateQueue);
	
		    this.transaction = transaction;
		  }
	
		  /**
		   * Checks whether or not this composite component is mounted.
		   * @param {ReactClass} publicInstance The instance we want to test.
		   * @return {boolean} True if mounted, false otherwise.
		   * @protected
		   * @final
		   */
	
	
		  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
		    return false;
		  };
	
		  /**
		   * Enqueue a callback that will be executed after all the pending updates
		   * have processed.
		   *
		   * @param {ReactClass} publicInstance The instance to use as `this` context.
		   * @param {?function} callback Called after state is updated.
		   * @internal
		   */
	
	
		  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
		    if (this.transaction.isInTransaction()) {
		      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
		    }
		  };
	
		  /**
		   * Forces an update. This should only be invoked when it is known with
		   * certainty that we are **not** in a DOM transaction.
		   *
		   * You may want to call this when you know that some deeper aspect of the
		   * component's state has changed but `setState` was not called.
		   *
		   * This will not invoke `shouldComponentUpdate`, but it will invoke
		   * `componentWillUpdate` and `componentDidUpdate`.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @internal
		   */
	
	
		  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
		    if (this.transaction.isInTransaction()) {
		      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
		    } else {
		      warnNoop(publicInstance, 'forceUpdate');
		    }
		  };
	
		  /**
		   * Replaces all of the state. Always use this or `setState` to mutate state.
		   * You should treat `this.state` as immutable.
		   *
		   * There is no guarantee that `this.state` will be immediately updated, so
		   * accessing `this.state` after calling this method may return the old value.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {object|function} completeState Next state.
		   * @internal
		   */
	
	
		  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
		    if (this.transaction.isInTransaction()) {
		      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
		    } else {
		      warnNoop(publicInstance, 'replaceState');
		    }
		  };
	
		  /**
		   * Sets a subset of the state. This only exists because _pendingState is
		   * internal. This provides a merging strategy that is not available to deep
		   * properties which is confusing. TODO: Expose pendingState or don't use it
		   * during the merge.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {object|function} partialState Next partial state to be merged with state.
		   * @internal
		   */
	
	
		  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
		    if (this.transaction.isInTransaction()) {
		      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
		    } else {
		      warnNoop(publicInstance, 'setState');
		    }
		  };
	
		  return ReactServerUpdateQueue;
		}();
	
		module.exports = ReactServerUpdateQueue;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 135 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2015-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var ReactCurrentOwner = __webpack_require__(43);
		var ReactInstanceMap = __webpack_require__(116);
		var ReactInstrumentation = __webpack_require__(37);
		var ReactUpdates = __webpack_require__(31);
	
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		function enqueueUpdate(internalInstance) {
		  ReactUpdates.enqueueUpdate(internalInstance);
		}
	
		function formatUnexpectedArgument(arg) {
		  var type = typeof arg;
		  if (type !== 'object') {
		    return type;
		  }
		  var displayName = arg.constructor && arg.constructor.name || type;
		  var keys = Object.keys(arg);
		  if (keys.length > 0 && keys.length < 20) {
		    return displayName + ' (keys: ' + keys.join(', ') + ')';
		  }
		  return displayName;
		}
	
		function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
		  var internalInstance = ReactInstanceMap.get(publicInstance);
		  if (!internalInstance) {
		    if (process.env.NODE_ENV !== 'production') {
		      var ctor = publicInstance.constructor;
		      // Only warn when we have a callerName. Otherwise we should be silent.
		      // We're probably calling from enqueueCallback. We don't want to warn
		      // there because we already warned for the corresponding lifecycle method.
		      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
		    }
		    return null;
		  }
	
		  if (process.env.NODE_ENV !== 'production') {
		    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
		  }
	
		  return internalInstance;
		}
	
		/**
		 * ReactUpdateQueue allows for state updates to be scheduled into a later
		 * reconciliation step.
		 */
		var ReactUpdateQueue = {
	
		  /**
		   * Checks whether or not this composite component is mounted.
		   * @param {ReactClass} publicInstance The instance we want to test.
		   * @return {boolean} True if mounted, false otherwise.
		   * @protected
		   * @final
		   */
		  isMounted: function (publicInstance) {
		    if (process.env.NODE_ENV !== 'production') {
		      var owner = ReactCurrentOwner.current;
		      if (owner !== null) {
		        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
		        owner._warnedAboutRefsInRender = true;
		      }
		    }
		    var internalInstance = ReactInstanceMap.get(publicInstance);
		    if (internalInstance) {
		      // During componentWillMount and render this will still be null but after
		      // that will always render to something. At least for now. So we can use
		      // this hack.
		      return !!internalInstance._renderedComponent;
		    } else {
		      return false;
		    }
		  },
	
		  /**
		   * Enqueue a callback that will be executed after all the pending updates
		   * have processed.
		   *
		   * @param {ReactClass} publicInstance The instance to use as `this` context.
		   * @param {?function} callback Called after state is updated.
		   * @param {string} callerName Name of the calling function in the public API.
		   * @internal
		   */
		  enqueueCallback: function (publicInstance, callback, callerName) {
		    ReactUpdateQueue.validateCallback(callback, callerName);
		    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
		    // Previously we would throw an error if we didn't have an internal
		    // instance. Since we want to make it a no-op instead, we mirror the same
		    // behavior we have in other enqueue* methods.
		    // We also need to ignore callbacks in componentWillMount. See
		    // enqueueUpdates.
		    if (!internalInstance) {
		      return null;
		    }
	
		    if (internalInstance._pendingCallbacks) {
		      internalInstance._pendingCallbacks.push(callback);
		    } else {
		      internalInstance._pendingCallbacks = [callback];
		    }
		    // TODO: The callback here is ignored when setState is called from
		    // componentWillMount. Either fix it or disallow doing so completely in
		    // favor of getInitialState. Alternatively, we can disallow
		    // componentWillMount during server-side rendering.
		    enqueueUpdate(internalInstance);
		  },
	
		  enqueueCallbackInternal: function (internalInstance, callback) {
		    if (internalInstance._pendingCallbacks) {
		      internalInstance._pendingCallbacks.push(callback);
		    } else {
		      internalInstance._pendingCallbacks = [callback];
		    }
		    enqueueUpdate(internalInstance);
		  },
	
		  /**
		   * Forces an update. This should only be invoked when it is known with
		   * certainty that we are **not** in a DOM transaction.
		   *
		   * You may want to call this when you know that some deeper aspect of the
		   * component's state has changed but `setState` was not called.
		   *
		   * This will not invoke `shouldComponentUpdate`, but it will invoke
		   * `componentWillUpdate` and `componentDidUpdate`.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @internal
		   */
		  enqueueForceUpdate: function (publicInstance) {
		    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
		    if (!internalInstance) {
		      return;
		    }
	
		    internalInstance._pendingForceUpdate = true;
	
		    enqueueUpdate(internalInstance);
		  },
	
		  /**
		   * Replaces all of the state. Always use this or `setState` to mutate state.
		   * You should treat `this.state` as immutable.
		   *
		   * There is no guarantee that `this.state` will be immediately updated, so
		   * accessing `this.state` after calling this method may return the old value.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {object} completeState Next state.
		   * @internal
		   */
		  enqueueReplaceState: function (publicInstance, completeState) {
		    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
		    if (!internalInstance) {
		      return;
		    }
	
		    internalInstance._pendingStateQueue = [completeState];
		    internalInstance._pendingReplaceState = true;
	
		    enqueueUpdate(internalInstance);
		  },
	
		  /**
		   * Sets a subset of the state. This only exists because _pendingState is
		   * internal. This provides a merging strategy that is not available to deep
		   * properties which is confusing. TODO: Expose pendingState or don't use it
		   * during the merge.
		   *
		   * @param {ReactClass} publicInstance The instance that should rerender.
		   * @param {object} partialState Next partial state to be merged with state.
		   * @internal
		   */
		  enqueueSetState: function (publicInstance, partialState) {
		    if (process.env.NODE_ENV !== 'production') {
		      ReactInstrumentation.debugTool.onSetState();
		      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
		    }
	
		    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
		    if (!internalInstance) {
		      return;
		    }
	
		    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
		    queue.push(partialState);
	
		    enqueueUpdate(internalInstance);
		  },
	
		  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
		    internalInstance._pendingElement = nextElement;
		    // TODO: introduce _pendingContext instead of setting it directly.
		    internalInstance._context = nextContext;
		    enqueueUpdate(internalInstance);
		  },
	
		  validateCallback: function (callback, callerName) {
		    !(!callback || typeof callback === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
		  }
	
		};
	
		module.exports = ReactUpdateQueue;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 136 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2015-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var emptyFunction = __webpack_require__(19);
		var warning = __webpack_require__(18);
	
		var validateDOMNesting = emptyFunction;
	
		if (process.env.NODE_ENV !== 'production') {
		  // This validation code was written based on the HTML5 parsing spec:
		  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
		  //
		  // Note: this does not catch all invalid nesting, nor does it try to (as it's
		  // not clear what practical benefit doing so provides); instead, we warn only
		  // for cases where the parser will give a parse tree differing from what React
		  // intended. For example, <b><div></div></b> is invalid but we don't warn
		  // because it still parses correctly; we do warn for other cases like nested
		  // <p> tags where the beginning of the second element implicitly closes the
		  // first, causing a confusing mess.
	
		  // https://html.spec.whatwg.org/multipage/syntax.html#special
		  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
		  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
		  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
		  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
		  // TODO: Distinguish by namespace here -- for <title>, including it here
		  // errs on the side of fewer warnings
		  'foreignObject', 'desc', 'title'];
	
		  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
		  var buttonScopeTags = inScopeTags.concat(['button']);
	
		  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
		  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
		  var emptyAncestorInfo = {
		    current: null,
	
		    formTag: null,
		    aTagInScope: null,
		    buttonTagInScope: null,
		    nobrTagInScope: null,
		    pTagInButtonScope: null,
	
		    listItemTagAutoclosing: null,
		    dlItemTagAutoclosing: null
		  };
	
		  var updatedAncestorInfo = function (oldInfo, tag, instance) {
		    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
		    var info = { tag: tag, instance: instance };
	
		    if (inScopeTags.indexOf(tag) !== -1) {
		      ancestorInfo.aTagInScope = null;
		      ancestorInfo.buttonTagInScope = null;
		      ancestorInfo.nobrTagInScope = null;
		    }
		    if (buttonScopeTags.indexOf(tag) !== -1) {
		      ancestorInfo.pTagInButtonScope = null;
		    }
	
		    // See rules for 'li', 'dd', 'dt' start tags in
		    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
		    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
		      ancestorInfo.listItemTagAutoclosing = null;
		      ancestorInfo.dlItemTagAutoclosing = null;
		    }
	
		    ancestorInfo.current = info;
	
		    if (tag === 'form') {
		      ancestorInfo.formTag = info;
		    }
		    if (tag === 'a') {
		      ancestorInfo.aTagInScope = info;
		    }
		    if (tag === 'button') {
		      ancestorInfo.buttonTagInScope = info;
		    }
		    if (tag === 'nobr') {
		      ancestorInfo.nobrTagInScope = info;
		    }
		    if (tag === 'p') {
		      ancestorInfo.pTagInButtonScope = info;
		    }
		    if (tag === 'li') {
		      ancestorInfo.listItemTagAutoclosing = info;
		    }
		    if (tag === 'dd' || tag === 'dt') {
		      ancestorInfo.dlItemTagAutoclosing = info;
		    }
	
		    return ancestorInfo;
		  };
	
		  /**
		   * Returns whether
		   */
		  var isTagValidWithParent = function (tag, parentTag) {
		    // First, let's check if we're in an unusual parsing mode...
		    switch (parentTag) {
		      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
		      case 'select':
		        return tag === 'option' || tag === 'optgroup' || tag === '#text';
		      case 'optgroup':
		        return tag === 'option' || tag === '#text';
		      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
		      // but
		      case 'option':
		        return tag === '#text';
	
		      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
		      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
		      // No special behavior since these rules fall back to "in body" mode for
		      // all except special table nodes which cause bad parsing behavior anyway.
	
		      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
		      case 'tr':
		        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
		      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
		      case 'tbody':
		      case 'thead':
		      case 'tfoot':
		        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
		      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
		      case 'colgroup':
		        return tag === 'col' || tag === 'template';
	
		      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
		      case 'table':
		        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
		      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
		      case 'head':
		        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
		      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
		      case 'html':
		        return tag === 'head' || tag === 'body';
		      case '#document':
		        return tag === 'html';
		    }
	
		    // Probably in the "in body" parsing mode, so we outlaw only tag combos
		    // where the parsing rules cause implicit opens or closes to be added.
		    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
		    switch (tag) {
		      case 'h1':
		      case 'h2':
		      case 'h3':
		      case 'h4':
		      case 'h5':
		      case 'h6':
		        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
		      case 'rp':
		      case 'rt':
		        return impliedEndTags.indexOf(parentTag) === -1;
	
		      case 'body':
		      case 'caption':
		      case 'col':
		      case 'colgroup':
		      case 'frame':
		      case 'head':
		      case 'html':
		      case 'tbody':
		      case 'td':
		      case 'tfoot':
		      case 'th':
		      case 'thead':
		      case 'tr':
		        // These tags are only valid with a few parents that have special child
		        // parsing rules -- if we're down here, then none of those matched and
		        // so we allow it only if we don't know what the parent is, as all other
		        // cases are invalid.
		        return parentTag == null;
		    }
	
		    return true;
		  };
	
		  /**
		   * Returns whether
		   */
		  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
		    switch (tag) {
		      case 'address':
		      case 'article':
		      case 'aside':
		      case 'blockquote':
		      case 'center':
		      case 'details':
		      case 'dialog':
		      case 'dir':
		      case 'div':
		      case 'dl':
		      case 'fieldset':
		      case 'figcaption':
		      case 'figure':
		      case 'footer':
		      case 'header':
		      case 'hgroup':
		      case 'main':
		      case 'menu':
		      case 'nav':
		      case 'ol':
		      case 'p':
		      case 'section':
		      case 'summary':
		      case 'ul':
	
		      case 'pre':
		      case 'listing':
	
		      case 'table':
	
		      case 'hr':
	
		      case 'xmp':
	
		      case 'h1':
		      case 'h2':
		      case 'h3':
		      case 'h4':
		      case 'h5':
		      case 'h6':
		        return ancestorInfo.pTagInButtonScope;
	
		      case 'form':
		        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
		      case 'li':
		        return ancestorInfo.listItemTagAutoclosing;
	
		      case 'dd':
		      case 'dt':
		        return ancestorInfo.dlItemTagAutoclosing;
	
		      case 'button':
		        return ancestorInfo.buttonTagInScope;
	
		      case 'a':
		        // Spec says something about storing a list of markers, but it sounds
		        // equivalent to this check.
		        return ancestorInfo.aTagInScope;
	
		      case 'nobr':
		        return ancestorInfo.nobrTagInScope;
		    }
	
		    return null;
		  };
	
		  /**
		   * Given a ReactCompositeComponent instance, return a list of its recursive
		   * owners, starting at the root and ending with the instance itself.
		   */
		  var findOwnerStack = function (instance) {
		    if (!instance) {
		      return [];
		    }
	
		    var stack = [];
		    do {
		      stack.push(instance);
		    } while (instance = instance._currentElement._owner);
		    stack.reverse();
		    return stack;
		  };
	
		  var didWarn = {};
	
		  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
		    ancestorInfo = ancestorInfo || emptyAncestorInfo;
		    var parentInfo = ancestorInfo.current;
		    var parentTag = parentInfo && parentInfo.tag;
	
		    if (childText != null) {
		      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
		      childTag = '#text';
		    }
	
		    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
		    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
		    var problematic = invalidParent || invalidAncestor;
	
		    if (problematic) {
		      var ancestorTag = problematic.tag;
		      var ancestorInstance = problematic.instance;
	
		      var childOwner = childInstance && childInstance._currentElement._owner;
		      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
		      var childOwners = findOwnerStack(childOwner);
		      var ancestorOwners = findOwnerStack(ancestorOwner);
	
		      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
		      var i;
	
		      var deepestCommon = -1;
		      for (i = 0; i < minStackLen; i++) {
		        if (childOwners[i] === ancestorOwners[i]) {
		          deepestCommon = i;
		        } else {
		          break;
		        }
		      }
	
		      var UNKNOWN = '(unknown)';
		      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
		        return inst.getName() || UNKNOWN;
		      });
		      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
		        return inst.getName() || UNKNOWN;
		      });
		      var ownerInfo = [].concat(
		      // If the parent and child instances have a common owner ancestor, start
		      // with that -- otherwise we just start with the parent's owners.
		      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
		      // If we're warning about an invalid (non-parent) ancestry, add '...'
		      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
		      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
		      if (didWarn[warnKey]) {
		        return;
		      }
		      didWarn[warnKey] = true;
	
		      var tagDisplayName = childTag;
		      var whitespaceInfo = '';
		      if (childTag === '#text') {
		        if (/\S/.test(childText)) {
		          tagDisplayName = 'Text nodes';
		        } else {
		          tagDisplayName = 'Whitespace text nodes';
		          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
		        }
		      } else {
		        tagDisplayName = '<' + childTag + '>';
		      }
	
		      if (invalidParent) {
		        var info = '';
		        if (ancestorTag === 'table' && childTag === 'tr') {
		          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
		        }
		        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
		      } else {
		        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
		      }
		    }
		  };
	
		  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
		  // For testing
		  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
		    ancestorInfo = ancestorInfo || emptyAncestorInfo;
		    var parentInfo = ancestorInfo.current;
		    var parentTag = parentInfo && parentInfo.tag;
		    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
		  };
		}
	
		module.exports = validateDOMNesting;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 137 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var DOMLazyTree = __webpack_require__(59);
		var ReactDOMComponentTree = __webpack_require__(5);
	
		var ReactDOMEmptyComponent = function (instantiate) {
		  // ReactCompositeComponent uses this:
		  this._currentElement = null;
		  // ReactDOMComponentTree uses these:
		  this._hostNode = null;
		  this._hostParent = null;
		  this._hostContainerInfo = null;
		  this._domID = 0;
		};
		_assign(ReactDOMEmptyComponent.prototype, {
		  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
		    var domID = hostContainerInfo._idCounter++;
		    this._domID = domID;
		    this._hostParent = hostParent;
		    this._hostContainerInfo = hostContainerInfo;
	
		    var nodeValue = ' react-empty: ' + this._domID + ' ';
		    if (transaction.useCreateElement) {
		      var ownerDocument = hostContainerInfo._ownerDocument;
		      var node = ownerDocument.createComment(nodeValue);
		      ReactDOMComponentTree.precacheNode(this, node);
		      return DOMLazyTree(node);
		    } else {
		      if (transaction.renderToStaticMarkup) {
		        // Normally we'd insert a comment node, but since this is a situation
		        // where React won't take over (static pages), we can simply return
		        // nothing.
		        return '';
		      }
		      return '<!--' + nodeValue + '-->';
		    }
		  },
		  receiveComponent: function () {},
		  getHostNode: function () {
		    return ReactDOMComponentTree.getNodeFromInstance(this);
		  },
		  unmountComponent: function () {
		    ReactDOMComponentTree.uncacheNode(this);
		  }
		});
	
		module.exports = ReactDOMEmptyComponent;
	
	/***/ },
	/* 138 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2015-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var invariant = __webpack_require__(8);
	
		/**
		 * Return the lowest common ancestor of A and B, or null if they are in
		 * different trees.
		 */
		function getLowestCommonAncestor(instA, instB) {
		  !('_hostNode' in instA) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
		  !('_hostNode' in instB) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
		  var depthA = 0;
		  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
		    depthA++;
		  }
		  var depthB = 0;
		  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
		    depthB++;
		  }
	
		  // If A is deeper, crawl up.
		  while (depthA - depthB > 0) {
		    instA = instA._hostParent;
		    depthA--;
		  }
	
		  // If B is deeper, crawl up.
		  while (depthB - depthA > 0) {
		    instB = instB._hostParent;
		    depthB--;
		  }
	
		  // Walk in lockstep until we find a match.
		  var depth = depthA;
		  while (depth--) {
		    if (instA === instB) {
		      return instA;
		    }
		    instA = instA._hostParent;
		    instB = instB._hostParent;
		  }
		  return null;
		}
	
		/**
		 * Return if A is an ancestor of B.
		 */
		function isAncestor(instA, instB) {
		  !('_hostNode' in instA) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
		  !('_hostNode' in instB) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
		  while (instB) {
		    if (instB === instA) {
		      return true;
		    }
		    instB = instB._hostParent;
		  }
		  return false;
		}
	
		/**
		 * Return the parent instance of the passed-in instance.
		 */
		function getParentInstance(inst) {
		  !('_hostNode' in inst) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
		  return inst._hostParent;
		}
	
		/**
		 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
		 */
		function traverseTwoPhase(inst, fn, arg) {
		  var path = [];
		  while (inst) {
		    path.push(inst);
		    inst = inst._hostParent;
		  }
		  var i;
		  for (i = path.length; i-- > 0;) {
		    fn(path[i], 'captured', arg);
		  }
		  for (i = 0; i < path.length; i++) {
		    fn(path[i], 'bubbled', arg);
		  }
		}
	
		/**
		 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
		 * should would receive a `mouseEnter` or `mouseLeave` event.
		 *
		 * Does not invoke the callback on the nearest common ancestor because nothing
		 * "entered" or "left" that element.
		 */
		function traverseEnterLeave(from, to, fn, argFrom, argTo) {
		  var common = from && to ? getLowestCommonAncestor(from, to) : null;
		  var pathFrom = [];
		  while (from && from !== common) {
		    pathFrom.push(from);
		    from = from._hostParent;
		  }
		  var pathTo = [];
		  while (to && to !== common) {
		    pathTo.push(to);
		    to = to._hostParent;
		  }
		  var i;
		  for (i = 0; i < pathFrom.length; i++) {
		    fn(pathFrom[i], 'bubbled', argFrom);
		  }
		  for (i = pathTo.length; i-- > 0;) {
		    fn(pathTo[i], 'captured', argTo);
		  }
		}
	
		module.exports = {
		  isAncestor: isAncestor,
		  getLowestCommonAncestor: getLowestCommonAncestor,
		  getParentInstance: getParentInstance,
		  traverseTwoPhase: traverseTwoPhase,
		  traverseEnterLeave: traverseEnterLeave
		};
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 139 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6),
		    _assign = __webpack_require__(24);
	
		var DOMChildrenOperations = __webpack_require__(58);
		var DOMLazyTree = __webpack_require__(59);
		var ReactDOMComponentTree = __webpack_require__(5);
	
		var escapeTextContentForBrowser = __webpack_require__(64);
		var invariant = __webpack_require__(8);
		var validateDOMNesting = __webpack_require__(136);
	
		/**
		 * Text nodes violate a couple assumptions that React makes about components:
		 *
		 *  - When mounting text into the DOM, adjacent text nodes are merged.
		 *  - Text nodes cannot be assigned a React root ID.
		 *
		 * This component is used to wrap strings between comment nodes so that they
		 * can undergo the same reconciliation that is applied to elements.
		 *
		 * TODO: Investigate representing React components in the DOM with text nodes.
		 *
		 * @class ReactDOMTextComponent
		 * @extends ReactComponent
		 * @internal
		 */
		var ReactDOMTextComponent = function (text) {
		  // TODO: This is really a ReactText (ReactNode), not a ReactElement
		  this._currentElement = text;
		  this._stringText = '' + text;
		  // ReactDOMComponentTree uses these:
		  this._hostNode = null;
		  this._hostParent = null;
	
		  // Properties
		  this._domID = 0;
		  this._mountIndex = 0;
		  this._closingComment = null;
		  this._commentNodes = null;
		};
	
		_assign(ReactDOMTextComponent.prototype, {
	
		  /**
		   * Creates the markup for this text node. This node is not intended to have
		   * any features besides containing text content.
		   *
		   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
		   * @return {string} Markup for this text node.
		   * @internal
		   */
		  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
		    if (process.env.NODE_ENV !== 'production') {
		      var parentInfo;
		      if (hostParent != null) {
		        parentInfo = hostParent._ancestorInfo;
		      } else if (hostContainerInfo != null) {
		        parentInfo = hostContainerInfo._ancestorInfo;
		      }
		      if (parentInfo) {
		        // parentInfo should always be present except for the top-level
		        // component when server rendering
		        validateDOMNesting(null, this._stringText, this, parentInfo);
		      }
		    }
	
		    var domID = hostContainerInfo._idCounter++;
		    var openingValue = ' react-text: ' + domID + ' ';
		    var closingValue = ' /react-text ';
		    this._domID = domID;
		    this._hostParent = hostParent;
		    if (transaction.useCreateElement) {
		      var ownerDocument = hostContainerInfo._ownerDocument;
		      var openingComment = ownerDocument.createComment(openingValue);
		      var closingComment = ownerDocument.createComment(closingValue);
		      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
		      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
		      if (this._stringText) {
		        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
		      }
		      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
		      ReactDOMComponentTree.precacheNode(this, openingComment);
		      this._closingComment = closingComment;
		      return lazyTree;
		    } else {
		      var escapedText = escapeTextContentForBrowser(this._stringText);
	
		      if (transaction.renderToStaticMarkup) {
		        // Normally we'd wrap this between comment nodes for the reasons stated
		        // above, but since this is a situation where React won't take over
		        // (static pages), we can simply return the text as it is.
		        return escapedText;
		      }
	
		      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
		    }
		  },
	
		  /**
		   * Updates this component by updating the text content.
		   *
		   * @param {ReactText} nextText The next text content
		   * @param {ReactReconcileTransaction} transaction
		   * @internal
		   */
		  receiveComponent: function (nextText, transaction) {
		    if (nextText !== this._currentElement) {
		      this._currentElement = nextText;
		      var nextStringText = '' + nextText;
		      if (nextStringText !== this._stringText) {
		        // TODO: Save this as pending props and use performUpdateIfNecessary
		        // and/or updateComponent to do the actual update for consistency with
		        // other component types?
		        this._stringText = nextStringText;
		        var commentNodes = this.getHostNode();
		        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
		      }
		    }
		  },
	
		  getHostNode: function () {
		    var hostNode = this._commentNodes;
		    if (hostNode) {
		      return hostNode;
		    }
		    if (!this._closingComment) {
		      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
		      var node = openingComment.nextSibling;
		      while (true) {
		        !(node != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
		        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
		          this._closingComment = node;
		          break;
		        }
		        node = node.nextSibling;
		      }
		    }
		    hostNode = [this._hostNode, this._closingComment];
		    this._commentNodes = hostNode;
		    return hostNode;
		  },
	
		  unmountComponent: function () {
		    this._closingComment = null;
		    this._commentNodes = null;
		    ReactDOMComponentTree.uncacheNode(this);
		  }
	
		});
	
		module.exports = ReactDOMTextComponent;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 140 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var ReactUpdates = __webpack_require__(31);
		var Transaction = __webpack_require__(46);
	
		var emptyFunction = __webpack_require__(19);
	
		var RESET_BATCHED_UPDATES = {
		  initialize: emptyFunction,
		  close: function () {
		    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
		  }
		};
	
		var FLUSH_BATCHED_UPDATES = {
		  initialize: emptyFunction,
		  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
		};
	
		var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
		function ReactDefaultBatchingStrategyTransaction() {
		  this.reinitializeTransaction();
		}
	
		_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
		  getTransactionWrappers: function () {
		    return TRANSACTION_WRAPPERS;
		  }
		});
	
		var transaction = new ReactDefaultBatchingStrategyTransaction();
	
		var ReactDefaultBatchingStrategy = {
		  isBatchingUpdates: false,
	
		  /**
		   * Call the provided function in a context within which calls to `setState`
		   * and friends are batched such that components aren't updated unnecessarily.
		   */
		  batchedUpdates: function (callback, a, b, c, d, e) {
		    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
		    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
		    // The code is written this way to avoid extra allocations
		    if (alreadyBatchingUpdates) {
		      return callback(a, b, c, d, e);
		    } else {
		      return transaction.perform(callback, null, a, b, c, d, e);
		    }
		  }
		};
	
		module.exports = ReactDefaultBatchingStrategy;
	
	/***/ },
	/* 141 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var EventListener = __webpack_require__(142);
		var ExecutionEnvironment = __webpack_require__(22);
		var PooledClass = __webpack_require__(25);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactUpdates = __webpack_require__(31);
	
		var getEventTarget = __webpack_require__(47);
		var getUnboundedScrollPosition = __webpack_require__(143);
	
		/**
		 * Find the deepest React component completely containing the root of the
		 * passed-in instance (for use when entire React trees are nested within each
		 * other). If React trees are not nested, returns null.
		 */
		function findParent(inst) {
		  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
		  // traversal, but caching is difficult to do correctly without using a
		  // mutation observer to listen for all DOM changes.
		  while (inst._hostParent) {
		    inst = inst._hostParent;
		  }
		  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
		  var container = rootNode.parentNode;
		  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
		}
	
		// Used to store ancestor hierarchy in top level callback
		function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
		  this.topLevelType = topLevelType;
		  this.nativeEvent = nativeEvent;
		  this.ancestors = [];
		}
		_assign(TopLevelCallbackBookKeeping.prototype, {
		  destructor: function () {
		    this.topLevelType = null;
		    this.nativeEvent = null;
		    this.ancestors.length = 0;
		  }
		});
		PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
		function handleTopLevelImpl(bookKeeping) {
		  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
		  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
		  // Loop through the hierarchy, in case there's any nested components.
		  // It's important that we build the array of ancestors before calling any
		  // event handlers, because event handlers can modify the DOM, leading to
		  // inconsistencies with ReactMount's node cache. See #1105.
		  var ancestor = targetInst;
		  do {
		    bookKeeping.ancestors.push(ancestor);
		    ancestor = ancestor && findParent(ancestor);
		  } while (ancestor);
	
		  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
		    targetInst = bookKeeping.ancestors[i];
		    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
		  }
		}
	
		function scrollValueMonitor(cb) {
		  var scrollPosition = getUnboundedScrollPosition(window);
		  cb(scrollPosition);
		}
	
		var ReactEventListener = {
		  _enabled: true,
		  _handleTopLevel: null,
	
		  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
		  setHandleTopLevel: function (handleTopLevel) {
		    ReactEventListener._handleTopLevel = handleTopLevel;
		  },
	
		  setEnabled: function (enabled) {
		    ReactEventListener._enabled = !!enabled;
		  },
	
		  isEnabled: function () {
		    return ReactEventListener._enabled;
		  },
	
		  /**
		   * Traps top-level events by using event bubbling.
		   *
		   * @param {string} topLevelType Record from `EventConstants`.
		   * @param {string} handlerBaseName Event name (e.g. "click").
		   * @param {object} element Element on which to attach listener.
		   * @return {?object} An object with a remove function which will forcefully
		   *                  remove the listener.
		   * @internal
		   */
		  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
		    if (!element) {
		      return null;
		    }
		    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
		  },
	
		  /**
		   * Traps a top-level event by using event capturing.
		   *
		   * @param {string} topLevelType Record from `EventConstants`.
		   * @param {string} handlerBaseName Event name (e.g. "click").
		   * @param {object} element Element on which to attach listener.
		   * @return {?object} An object with a remove function which will forcefully
		   *                  remove the listener.
		   * @internal
		   */
		  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
		    if (!element) {
		      return null;
		    }
		    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
		  },
	
		  monitorScrollValue: function (refresh) {
		    var callback = scrollValueMonitor.bind(null, refresh);
		    EventListener.listen(window, 'scroll', callback);
		  },
	
		  dispatchEvent: function (topLevelType, nativeEvent) {
		    if (!ReactEventListener._enabled) {
		      return;
		    }
	
		    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
		    try {
		      // Event queue being processed in the same cycle allows
		      // `preventDefault`.
		      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
		    } finally {
		      TopLevelCallbackBookKeeping.release(bookKeeping);
		    }
		  }
		};
	
		module.exports = ReactEventListener;
	
	/***/ },
	/* 142 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 *
		 * Licensed under the Apache License, Version 2.0 (the "License");
		 * you may not use this file except in compliance with the License.
		 * You may obtain a copy of the License at
		 *
		 * http://www.apache.org/licenses/LICENSE-2.0
		 *
		 * Unless required by applicable law or agreed to in writing, software
		 * distributed under the License is distributed on an "AS IS" BASIS,
		 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
		 * See the License for the specific language governing permissions and
		 * limitations under the License.
		 *
		 * @typechecks
		 */
	
		var emptyFunction = __webpack_require__(19);
	
		/**
		 * Upstream version of event listener. Does not take into account specific
		 * nature of platform.
		 */
		var EventListener = {
		  /**
		   * Listen to DOM events during the bubble phase.
		   *
		   * @param {DOMEventTarget} target DOM element to register listener on.
		   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
		   * @param {function} callback Callback function.
		   * @return {object} Object with a `remove` method.
		   */
		  listen: function listen(target, eventType, callback) {
		    if (target.addEventListener) {
		      target.addEventListener(eventType, callback, false);
		      return {
		        remove: function remove() {
		          target.removeEventListener(eventType, callback, false);
		        }
		      };
		    } else if (target.attachEvent) {
		      target.attachEvent('on' + eventType, callback);
		      return {
		        remove: function remove() {
		          target.detachEvent('on' + eventType, callback);
		        }
		      };
		    }
		  },
	
		  /**
		   * Listen to DOM events during the capture phase.
		   *
		   * @param {DOMEventTarget} target DOM element to register listener on.
		   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
		   * @param {function} callback Callback function.
		   * @return {object} Object with a `remove` method.
		   */
		  capture: function capture(target, eventType, callback) {
		    if (target.addEventListener) {
		      target.addEventListener(eventType, callback, true);
		      return {
		        remove: function remove() {
		          target.removeEventListener(eventType, callback, true);
		        }
		      };
		    } else {
		      if (process.env.NODE_ENV !== 'production') {
		        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
		      }
		      return {
		        remove: emptyFunction
		      };
		    }
		  },
	
		  registerDefault: function registerDefault() {}
		};
	
		module.exports = EventListener;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 143 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		'use strict';
	
		/**
		 * Gets the scroll position of the supplied element or window.
		 *
		 * The return values are unbounded, unlike `getScrollPosition`. This means they
		 * may be negative or exceed the element boundaries (which is possible using
		 * inertial scrolling).
		 *
		 * @param {DOMWindow|DOMElement} scrollable
		 * @return {object} Map with `x` and `y` keys.
		 */
	
		function getUnboundedScrollPosition(scrollable) {
		  if (scrollable === window) {
		    return {
		      x: window.pageXOffset || document.documentElement.scrollLeft,
		      y: window.pageYOffset || document.documentElement.scrollTop
		    };
		  }
		  return {
		    x: scrollable.scrollLeft,
		    y: scrollable.scrollTop
		  };
		}
	
		module.exports = getUnboundedScrollPosition;
	
	/***/ },
	/* 144 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMProperty = __webpack_require__(7);
		var EventPluginHub = __webpack_require__(14);
		var EventPluginUtils = __webpack_require__(16);
		var ReactComponentEnvironment = __webpack_require__(115);
		var ReactEmptyComponent = __webpack_require__(125);
		var ReactBrowserEventEmitter = __webpack_require__(83);
		var ReactHostComponent = __webpack_require__(126);
		var ReactUpdates = __webpack_require__(31);
	
		var ReactInjection = {
		  Component: ReactComponentEnvironment.injection,
		  DOMProperty: DOMProperty.injection,
		  EmptyComponent: ReactEmptyComponent.injection,
		  EventPluginHub: EventPluginHub.injection,
		  EventPluginUtils: EventPluginUtils.injection,
		  EventEmitter: ReactBrowserEventEmitter.injection,
		  HostComponent: ReactHostComponent.injection,
		  Updates: ReactUpdates.injection
		};
	
		module.exports = ReactInjection;
	
	/***/ },
	/* 145 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _assign = __webpack_require__(24);
	
		var CallbackQueue = __webpack_require__(32);
		var PooledClass = __webpack_require__(25);
		var ReactBrowserEventEmitter = __webpack_require__(83);
		var ReactInputSelection = __webpack_require__(146);
		var ReactInstrumentation = __webpack_require__(37);
		var Transaction = __webpack_require__(46);
		var ReactUpdateQueue = __webpack_require__(135);
	
		/**
		 * Ensures that, when possible, the selection range (currently selected text
		 * input) is not disturbed by performing the transaction.
		 */
		var SELECTION_RESTORATION = {
		  /**
		   * @return {Selection} Selection information.
		   */
		  initialize: ReactInputSelection.getSelectionInformation,
		  /**
		   * @param {Selection} sel Selection information returned from `initialize`.
		   */
		  close: ReactInputSelection.restoreSelection
		};
	
		/**
		 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
		 * high level DOM manipulations (like temporarily removing a text input from the
		 * DOM).
		 */
		var EVENT_SUPPRESSION = {
		  /**
		   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
		   * the reconciliation.
		   */
		  initialize: function () {
		    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
		    ReactBrowserEventEmitter.setEnabled(false);
		    return currentlyEnabled;
		  },
	
		  /**
		   * @param {boolean} previouslyEnabled Enabled status of
		   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
		   *   restores the previous value.
		   */
		  close: function (previouslyEnabled) {
		    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
		  }
		};
	
		/**
		 * Provides a queue for collecting `componentDidMount` and
		 * `componentDidUpdate` callbacks during the transaction.
		 */
		var ON_DOM_READY_QUEUEING = {
		  /**
		   * Initializes the internal `onDOMReady` queue.
		   */
		  initialize: function () {
		    this.reactMountReady.reset();
		  },
	
		  /**
		   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
		   */
		  close: function () {
		    this.reactMountReady.notifyAll();
		  }
		};
	
		/**
		 * Executed within the scope of the `Transaction` instance. Consider these as
		 * being member methods, but with an implied ordering while being isolated from
		 * each other.
		 */
		var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
		if (process.env.NODE_ENV !== 'production') {
		  TRANSACTION_WRAPPERS.push({
		    initialize: ReactInstrumentation.debugTool.onBeginFlush,
		    close: ReactInstrumentation.debugTool.onEndFlush
		  });
		}
	
		/**
		 * Currently:
		 * - The order that these are listed in the transaction is critical:
		 * - Suppresses events.
		 * - Restores selection range.
		 *
		 * Future:
		 * - Restore document/overflow scroll positions that were unintentionally
		 *   modified via DOM insertions above the top viewport boundary.
		 * - Implement/integrate with customized constraint based layout system and keep
		 *   track of which dimensions must be remeasured.
		 *
		 * @class ReactReconcileTransaction
		 */
		function ReactReconcileTransaction(useCreateElement) {
		  this.reinitializeTransaction();
		  // Only server-side rendering really needs this option (see
		  // `ReactServerRendering`), but server-side uses
		  // `ReactServerRenderingTransaction` instead. This option is here so that it's
		  // accessible and defaults to false when `ReactDOMComponent` and
		  // `ReactDOMTextComponent` checks it in `mountComponent`.`
		  this.renderToStaticMarkup = false;
		  this.reactMountReady = CallbackQueue.getPooled(null);
		  this.useCreateElement = useCreateElement;
		}
	
		var Mixin = {
		  /**
		   * @see Transaction
		   * @abstract
		   * @final
		   * @return {array<object>} List of operation wrap procedures.
		   *   TODO: convert to array<TransactionWrapper>
		   */
		  getTransactionWrappers: function () {
		    return TRANSACTION_WRAPPERS;
		  },
	
		  /**
		   * @return {object} The queue to collect `onDOMReady` callbacks with.
		   */
		  getReactMountReady: function () {
		    return this.reactMountReady;
		  },
	
		  /**
		   * @return {object} The queue to collect React async events.
		   */
		  getUpdateQueue: function () {
		    return ReactUpdateQueue;
		  },
	
		  /**
		   * Save current transaction state -- if the return value from this method is
		   * passed to `rollback`, the transaction will be reset to that state.
		   */
		  checkpoint: function () {
		    // reactMountReady is the our only stateful wrapper
		    return this.reactMountReady.checkpoint();
		  },
	
		  rollback: function (checkpoint) {
		    this.reactMountReady.rollback(checkpoint);
		  },
	
		  /**
		   * `PooledClass` looks for this, and will invoke this before allowing this
		   * instance to be reused.
		   */
		  destructor: function () {
		    CallbackQueue.release(this.reactMountReady);
		    this.reactMountReady = null;
		  }
		};
	
		_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
		PooledClass.addPoolingTo(ReactReconcileTransaction);
	
		module.exports = ReactReconcileTransaction;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 146 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactDOMSelection = __webpack_require__(147);
	
		var containsNode = __webpack_require__(149);
		var focusNode = __webpack_require__(72);
		var getActiveElement = __webpack_require__(152);
	
		function isInDocument(node) {
		  return containsNode(document.documentElement, node);
		}
	
		/**
		 * @ReactInputSelection: React input selection module. Based on Selection.js,
		 * but modified to be suitable for react and has a couple of bug fixes (doesn't
		 * assume buttons have range selections allowed).
		 * Input selection module for React.
		 */
		var ReactInputSelection = {
	
		  hasSelectionCapabilities: function (elem) {
		    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
		    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
		  },
	
		  getSelectionInformation: function () {
		    var focusedElem = getActiveElement();
		    return {
		      focusedElem: focusedElem,
		      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
		    };
		  },
	
		  /**
		   * @restoreSelection: If any selection information was potentially lost,
		   * restore it. This is useful when performing operations that could remove dom
		   * nodes and place them back in, resulting in focus being lost.
		   */
		  restoreSelection: function (priorSelectionInformation) {
		    var curFocusedElem = getActiveElement();
		    var priorFocusedElem = priorSelectionInformation.focusedElem;
		    var priorSelectionRange = priorSelectionInformation.selectionRange;
		    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
		      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
		        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
		      }
		      focusNode(priorFocusedElem);
		    }
		  },
	
		  /**
		   * @getSelection: Gets the selection bounds of a focused textarea, input or
		   * contentEditable node.
		   * -@input: Look up selection bounds of this input
		   * -@return {start: selectionStart, end: selectionEnd}
		   */
		  getSelection: function (input) {
		    var selection;
	
		    if ('selectionStart' in input) {
		      // Modern browser with input or textarea.
		      selection = {
		        start: input.selectionStart,
		        end: input.selectionEnd
		      };
		    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
		      // IE8 input.
		      var range = document.selection.createRange();
		      // There can only be one selection per document in IE, so it must
		      // be in our element.
		      if (range.parentElement() === input) {
		        selection = {
		          start: -range.moveStart('character', -input.value.length),
		          end: -range.moveEnd('character', -input.value.length)
		        };
		      }
		    } else {
		      // Content editable or old IE textarea.
		      selection = ReactDOMSelection.getOffsets(input);
		    }
	
		    return selection || { start: 0, end: 0 };
		  },
	
		  /**
		   * @setSelection: Sets the selection bounds of a textarea or input and focuses
		   * the input.
		   * -@input     Set selection bounds of this input or textarea
		   * -@offsets   Object of same form that is returned from get*
		   */
		  setSelection: function (input, offsets) {
		    var start = offsets.start;
		    var end = offsets.end;
		    if (end === undefined) {
		      end = start;
		    }
	
		    if ('selectionStart' in input) {
		      input.selectionStart = start;
		      input.selectionEnd = Math.min(end, input.value.length);
		    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
		      var range = input.createTextRange();
		      range.collapse(true);
		      range.moveStart('character', start);
		      range.moveEnd('character', end - start);
		      range.select();
		    } else {
		      ReactDOMSelection.setOffsets(input, offsets);
		    }
		  }
		};
	
		module.exports = ReactInputSelection;
	
	/***/ },
	/* 147 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ExecutionEnvironment = __webpack_require__(22);
	
		var getNodeForCharacterOffset = __webpack_require__(148);
		var getTextContentAccessor = __webpack_require__(26);
	
		/**
		 * While `isCollapsed` is available on the Selection object and `collapsed`
		 * is available on the Range object, IE11 sometimes gets them wrong.
		 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
		 */
		function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
		  return anchorNode === focusNode && anchorOffset === focusOffset;
		}
	
		/**
		 * Get the appropriate anchor and focus node/offset pairs for IE.
		 *
		 * The catch here is that IE's selection API doesn't provide information
		 * about whether the selection is forward or backward, so we have to
		 * behave as though it's always forward.
		 *
		 * IE text differs from modern selection in that it behaves as though
		 * block elements end with a new line. This means character offsets will
		 * differ between the two APIs.
		 *
		 * @param {DOMElement} node
		 * @return {object}
		 */
		function getIEOffsets(node) {
		  var selection = document.selection;
		  var selectedRange = selection.createRange();
		  var selectedLength = selectedRange.text.length;
	
		  // Duplicate selection so we can move range without breaking user selection.
		  var fromStart = selectedRange.duplicate();
		  fromStart.moveToElementText(node);
		  fromStart.setEndPoint('EndToStart', selectedRange);
	
		  var startOffset = fromStart.text.length;
		  var endOffset = startOffset + selectedLength;
	
		  return {
		    start: startOffset,
		    end: endOffset
		  };
		}
	
		/**
		 * @param {DOMElement} node
		 * @return {?object}
		 */
		function getModernOffsets(node) {
		  var selection = window.getSelection && window.getSelection();
	
		  if (!selection || selection.rangeCount === 0) {
		    return null;
		  }
	
		  var anchorNode = selection.anchorNode;
		  var anchorOffset = selection.anchorOffset;
		  var focusNode = selection.focusNode;
		  var focusOffset = selection.focusOffset;
	
		  var currentRange = selection.getRangeAt(0);
	
		  // In Firefox, range.startContainer and range.endContainer can be "anonymous
		  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
		  // divs do not seem to expose properties, triggering a "Permission denied
		  // error" if any of its properties are accessed. The only seemingly possible
		  // way to avoid erroring is to access a property that typically works for
		  // non-anonymous divs and catch any error that may otherwise arise. See
		  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
		  try {
		    /* eslint-disable no-unused-expressions */
		    currentRange.startContainer.nodeType;
		    currentRange.endContainer.nodeType;
		    /* eslint-enable no-unused-expressions */
		  } catch (e) {
		    return null;
		  }
	
		  // If the node and offset values are the same, the selection is collapsed.
		  // `Selection.isCollapsed` is available natively, but IE sometimes gets
		  // this value wrong.
		  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
		  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
		  var tempRange = currentRange.cloneRange();
		  tempRange.selectNodeContents(node);
		  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
		  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
		  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
		  var end = start + rangeLength;
	
		  // Detect whether the selection is backward.
		  var detectionRange = document.createRange();
		  detectionRange.setStart(anchorNode, anchorOffset);
		  detectionRange.setEnd(focusNode, focusOffset);
		  var isBackward = detectionRange.collapsed;
	
		  return {
		    start: isBackward ? end : start,
		    end: isBackward ? start : end
		  };
		}
	
		/**
		 * @param {DOMElement|DOMTextNode} node
		 * @param {object} offsets
		 */
		function setIEOffsets(node, offsets) {
		  var range = document.selection.createRange().duplicate();
		  var start, end;
	
		  if (offsets.end === undefined) {
		    start = offsets.start;
		    end = start;
		  } else if (offsets.start > offsets.end) {
		    start = offsets.end;
		    end = offsets.start;
		  } else {
		    start = offsets.start;
		    end = offsets.end;
		  }
	
		  range.moveToElementText(node);
		  range.moveStart('character', start);
		  range.setEndPoint('EndToStart', range);
		  range.moveEnd('character', end - start);
		  range.select();
		}
	
		/**
		 * In modern non-IE browsers, we can support both forward and backward
		 * selections.
		 *
		 * Note: IE10+ supports the Selection object, but it does not support
		 * the `extend` method, which means that even in modern IE, it's not possible
		 * to programmatically create a backward selection. Thus, for all IE
		 * versions, we use the old IE API to create our selections.
		 *
		 * @param {DOMElement|DOMTextNode} node
		 * @param {object} offsets
		 */
		function setModernOffsets(node, offsets) {
		  if (!window.getSelection) {
		    return;
		  }
	
		  var selection = window.getSelection();
		  var length = node[getTextContentAccessor()].length;
		  var start = Math.min(offsets.start, length);
		  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
		  // IE 11 uses modern selection, but doesn't support the extend method.
		  // Flip backward selections, so we can set with a single range.
		  if (!selection.extend && start > end) {
		    var temp = end;
		    end = start;
		    start = temp;
		  }
	
		  var startMarker = getNodeForCharacterOffset(node, start);
		  var endMarker = getNodeForCharacterOffset(node, end);
	
		  if (startMarker && endMarker) {
		    var range = document.createRange();
		    range.setStart(startMarker.node, startMarker.offset);
		    selection.removeAllRanges();
	
		    if (start > end) {
		      selection.addRange(range);
		      selection.extend(endMarker.node, endMarker.offset);
		    } else {
		      range.setEnd(endMarker.node, endMarker.offset);
		      selection.addRange(range);
		    }
		  }
		}
	
		var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
		var ReactDOMSelection = {
		  /**
		   * @param {DOMElement} node
		   */
		  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
		  /**
		   * @param {DOMElement|DOMTextNode} node
		   * @param {object} offsets
		   */
		  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
		};
	
		module.exports = ReactDOMSelection;
	
	/***/ },
	/* 148 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Given any node return the first leaf node without children.
		 *
		 * @param {DOMElement|DOMTextNode} node
		 * @return {DOMElement|DOMTextNode}
		 */
	
		function getLeafNode(node) {
		  while (node && node.firstChild) {
		    node = node.firstChild;
		  }
		  return node;
		}
	
		/**
		 * Get the next sibling within a container. This will walk up the
		 * DOM if a node's siblings have been exhausted.
		 *
		 * @param {DOMElement|DOMTextNode} node
		 * @return {?DOMElement|DOMTextNode}
		 */
		function getSiblingNode(node) {
		  while (node) {
		    if (node.nextSibling) {
		      return node.nextSibling;
		    }
		    node = node.parentNode;
		  }
		}
	
		/**
		 * Get object describing the nodes which contain characters at offset.
		 *
		 * @param {DOMElement|DOMTextNode} root
		 * @param {number} offset
		 * @return {?object}
		 */
		function getNodeForCharacterOffset(root, offset) {
		  var node = getLeafNode(root);
		  var nodeStart = 0;
		  var nodeEnd = 0;
	
		  while (node) {
		    if (node.nodeType === 3) {
		      nodeEnd = nodeStart + node.textContent.length;
	
		      if (nodeStart <= offset && nodeEnd >= offset) {
		        return {
		          node: node,
		          offset: offset - nodeStart
		        };
		      }
	
		      nodeStart = nodeEnd;
		    }
	
		    node = getLeafNode(getSiblingNode(node));
		  }
		}
	
		module.exports = getNodeForCharacterOffset;
	
	/***/ },
	/* 149 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		var isTextNode = __webpack_require__(150);
	
		/*eslint-disable no-bitwise */
	
		/**
		 * Checks if a given DOM node contains or is another DOM node.
		 */
		function containsNode(outerNode, innerNode) {
		  if (!outerNode || !innerNode) {
		    return false;
		  } else if (outerNode === innerNode) {
		    return true;
		  } else if (isTextNode(outerNode)) {
		    return false;
		  } else if (isTextNode(innerNode)) {
		    return containsNode(outerNode, innerNode.parentNode);
		  } else if ('contains' in outerNode) {
		    return outerNode.contains(innerNode);
		  } else if (outerNode.compareDocumentPosition) {
		    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
		  } else {
		    return false;
		  }
		}
	
		module.exports = containsNode;
	
	/***/ },
	/* 150 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		var isNode = __webpack_require__(151);
	
		/**
		 * @param {*} object The object to check.
		 * @return {boolean} Whether or not the object is a DOM text node.
		 */
		function isTextNode(object) {
		  return isNode(object) && object.nodeType == 3;
		}
	
		module.exports = isTextNode;
	
	/***/ },
	/* 151 */
	/***/ function(module, exports) {
	
		'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		/**
		 * @param {*} object The object to check.
		 * @return {boolean} Whether or not the object is a DOM node.
		 */
		function isNode(object) {
		  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
		}
	
		module.exports = isNode;
	
	/***/ },
	/* 152 */
	/***/ function(module, exports) {
	
		'use strict';
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * @typechecks
		 */
	
		/* eslint-disable fb-www/typeof-undefined */
	
		/**
		 * Same as document.activeElement but wraps in a try-catch block. In IE it is
		 * not safe to call document.activeElement if there is nothing focused.
		 *
		 * The activeElement will be null only if the document or document body is not
		 * yet defined.
		 */
		function getActiveElement() /*?DOMElement*/{
		  if (typeof document === 'undefined') {
		    return null;
		  }
		  try {
		    return document.activeElement || document.body;
		  } catch (e) {
		    return document.body;
		  }
		}
	
		module.exports = getActiveElement;
	
	/***/ },
	/* 153 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var NS = {
		  xlink: 'http://www.w3.org/1999/xlink',
		  xml: 'http://www.w3.org/XML/1998/namespace'
		};
	
		// We use attributes for everything SVG so let's avoid some duplication and run
		// code instead.
		// The following are all specified in the HTML config already so we exclude here.
		// - class (as className)
		// - color
		// - height
		// - id
		// - lang
		// - max
		// - media
		// - method
		// - min
		// - name
		// - style
		// - target
		// - type
		// - width
		var ATTRS = {
		  accentHeight: 'accent-height',
		  accumulate: 0,
		  additive: 0,
		  alignmentBaseline: 'alignment-baseline',
		  allowReorder: 'allowReorder',
		  alphabetic: 0,
		  amplitude: 0,
		  arabicForm: 'arabic-form',
		  ascent: 0,
		  attributeName: 'attributeName',
		  attributeType: 'attributeType',
		  autoReverse: 'autoReverse',
		  azimuth: 0,
		  baseFrequency: 'baseFrequency',
		  baseProfile: 'baseProfile',
		  baselineShift: 'baseline-shift',
		  bbox: 0,
		  begin: 0,
		  bias: 0,
		  by: 0,
		  calcMode: 'calcMode',
		  capHeight: 'cap-height',
		  clip: 0,
		  clipPath: 'clip-path',
		  clipRule: 'clip-rule',
		  clipPathUnits: 'clipPathUnits',
		  colorInterpolation: 'color-interpolation',
		  colorInterpolationFilters: 'color-interpolation-filters',
		  colorProfile: 'color-profile',
		  colorRendering: 'color-rendering',
		  contentScriptType: 'contentScriptType',
		  contentStyleType: 'contentStyleType',
		  cursor: 0,
		  cx: 0,
		  cy: 0,
		  d: 0,
		  decelerate: 0,
		  descent: 0,
		  diffuseConstant: 'diffuseConstant',
		  direction: 0,
		  display: 0,
		  divisor: 0,
		  dominantBaseline: 'dominant-baseline',
		  dur: 0,
		  dx: 0,
		  dy: 0,
		  edgeMode: 'edgeMode',
		  elevation: 0,
		  enableBackground: 'enable-background',
		  end: 0,
		  exponent: 0,
		  externalResourcesRequired: 'externalResourcesRequired',
		  fill: 0,
		  fillOpacity: 'fill-opacity',
		  fillRule: 'fill-rule',
		  filter: 0,
		  filterRes: 'filterRes',
		  filterUnits: 'filterUnits',
		  floodColor: 'flood-color',
		  floodOpacity: 'flood-opacity',
		  focusable: 0,
		  fontFamily: 'font-family',
		  fontSize: 'font-size',
		  fontSizeAdjust: 'font-size-adjust',
		  fontStretch: 'font-stretch',
		  fontStyle: 'font-style',
		  fontVariant: 'font-variant',
		  fontWeight: 'font-weight',
		  format: 0,
		  from: 0,
		  fx: 0,
		  fy: 0,
		  g1: 0,
		  g2: 0,
		  glyphName: 'glyph-name',
		  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
		  glyphOrientationVertical: 'glyph-orientation-vertical',
		  glyphRef: 'glyphRef',
		  gradientTransform: 'gradientTransform',
		  gradientUnits: 'gradientUnits',
		  hanging: 0,
		  horizAdvX: 'horiz-adv-x',
		  horizOriginX: 'horiz-origin-x',
		  ideographic: 0,
		  imageRendering: 'image-rendering',
		  'in': 0,
		  in2: 0,
		  intercept: 0,
		  k: 0,
		  k1: 0,
		  k2: 0,
		  k3: 0,
		  k4: 0,
		  kernelMatrix: 'kernelMatrix',
		  kernelUnitLength: 'kernelUnitLength',
		  kerning: 0,
		  keyPoints: 'keyPoints',
		  keySplines: 'keySplines',
		  keyTimes: 'keyTimes',
		  lengthAdjust: 'lengthAdjust',
		  letterSpacing: 'letter-spacing',
		  lightingColor: 'lighting-color',
		  limitingConeAngle: 'limitingConeAngle',
		  local: 0,
		  markerEnd: 'marker-end',
		  markerMid: 'marker-mid',
		  markerStart: 'marker-start',
		  markerHeight: 'markerHeight',
		  markerUnits: 'markerUnits',
		  markerWidth: 'markerWidth',
		  mask: 0,
		  maskContentUnits: 'maskContentUnits',
		  maskUnits: 'maskUnits',
		  mathematical: 0,
		  mode: 0,
		  numOctaves: 'numOctaves',
		  offset: 0,
		  opacity: 0,
		  operator: 0,
		  order: 0,
		  orient: 0,
		  orientation: 0,
		  origin: 0,
		  overflow: 0,
		  overlinePosition: 'overline-position',
		  overlineThickness: 'overline-thickness',
		  paintOrder: 'paint-order',
		  panose1: 'panose-1',
		  pathLength: 'pathLength',
		  patternContentUnits: 'patternContentUnits',
		  patternTransform: 'patternTransform',
		  patternUnits: 'patternUnits',
		  pointerEvents: 'pointer-events',
		  points: 0,
		  pointsAtX: 'pointsAtX',
		  pointsAtY: 'pointsAtY',
		  pointsAtZ: 'pointsAtZ',
		  preserveAlpha: 'preserveAlpha',
		  preserveAspectRatio: 'preserveAspectRatio',
		  primitiveUnits: 'primitiveUnits',
		  r: 0,
		  radius: 0,
		  refX: 'refX',
		  refY: 'refY',
		  renderingIntent: 'rendering-intent',
		  repeatCount: 'repeatCount',
		  repeatDur: 'repeatDur',
		  requiredExtensions: 'requiredExtensions',
		  requiredFeatures: 'requiredFeatures',
		  restart: 0,
		  result: 0,
		  rotate: 0,
		  rx: 0,
		  ry: 0,
		  scale: 0,
		  seed: 0,
		  shapeRendering: 'shape-rendering',
		  slope: 0,
		  spacing: 0,
		  specularConstant: 'specularConstant',
		  specularExponent: 'specularExponent',
		  speed: 0,
		  spreadMethod: 'spreadMethod',
		  startOffset: 'startOffset',
		  stdDeviation: 'stdDeviation',
		  stemh: 0,
		  stemv: 0,
		  stitchTiles: 'stitchTiles',
		  stopColor: 'stop-color',
		  stopOpacity: 'stop-opacity',
		  strikethroughPosition: 'strikethrough-position',
		  strikethroughThickness: 'strikethrough-thickness',
		  string: 0,
		  stroke: 0,
		  strokeDasharray: 'stroke-dasharray',
		  strokeDashoffset: 'stroke-dashoffset',
		  strokeLinecap: 'stroke-linecap',
		  strokeLinejoin: 'stroke-linejoin',
		  strokeMiterlimit: 'stroke-miterlimit',
		  strokeOpacity: 'stroke-opacity',
		  strokeWidth: 'stroke-width',
		  surfaceScale: 'surfaceScale',
		  systemLanguage: 'systemLanguage',
		  tableValues: 'tableValues',
		  targetX: 'targetX',
		  targetY: 'targetY',
		  textAnchor: 'text-anchor',
		  textDecoration: 'text-decoration',
		  textRendering: 'text-rendering',
		  textLength: 'textLength',
		  to: 0,
		  transform: 0,
		  u1: 0,
		  u2: 0,
		  underlinePosition: 'underline-position',
		  underlineThickness: 'underline-thickness',
		  unicode: 0,
		  unicodeBidi: 'unicode-bidi',
		  unicodeRange: 'unicode-range',
		  unitsPerEm: 'units-per-em',
		  vAlphabetic: 'v-alphabetic',
		  vHanging: 'v-hanging',
		  vIdeographic: 'v-ideographic',
		  vMathematical: 'v-mathematical',
		  values: 0,
		  vectorEffect: 'vector-effect',
		  version: 0,
		  vertAdvY: 'vert-adv-y',
		  vertOriginX: 'vert-origin-x',
		  vertOriginY: 'vert-origin-y',
		  viewBox: 'viewBox',
		  viewTarget: 'viewTarget',
		  visibility: 0,
		  widths: 0,
		  wordSpacing: 'word-spacing',
		  writingMode: 'writing-mode',
		  x: 0,
		  xHeight: 'x-height',
		  x1: 0,
		  x2: 0,
		  xChannelSelector: 'xChannelSelector',
		  xlinkActuate: 'xlink:actuate',
		  xlinkArcrole: 'xlink:arcrole',
		  xlinkHref: 'xlink:href',
		  xlinkRole: 'xlink:role',
		  xlinkShow: 'xlink:show',
		  xlinkTitle: 'xlink:title',
		  xlinkType: 'xlink:type',
		  xmlBase: 'xml:base',
		  xmlns: 0,
		  xmlnsXlink: 'xmlns:xlink',
		  xmlLang: 'xml:lang',
		  xmlSpace: 'xml:space',
		  y: 0,
		  y1: 0,
		  y2: 0,
		  yChannelSelector: 'yChannelSelector',
		  z: 0,
		  zoomAndPan: 'zoomAndPan'
		};
	
		var SVGDOMPropertyConfig = {
		  Properties: {},
		  DOMAttributeNamespaces: {
		    xlinkActuate: NS.xlink,
		    xlinkArcrole: NS.xlink,
		    xlinkHref: NS.xlink,
		    xlinkRole: NS.xlink,
		    xlinkShow: NS.xlink,
		    xlinkTitle: NS.xlink,
		    xlinkType: NS.xlink,
		    xmlBase: NS.xml,
		    xmlLang: NS.xml,
		    xmlSpace: NS.xml
		  },
		  DOMAttributeNames: {}
		};
	
		Object.keys(ATTRS).forEach(function (key) {
		  SVGDOMPropertyConfig.Properties[key] = 0;
		  if (ATTRS[key]) {
		    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
		  }
		});
	
		module.exports = SVGDOMPropertyConfig;
	
	/***/ },
	/* 154 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var EventPropagators = __webpack_require__(13);
		var ExecutionEnvironment = __webpack_require__(22);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactInputSelection = __webpack_require__(146);
		var SyntheticEvent = __webpack_require__(28);
	
		var getActiveElement = __webpack_require__(152);
		var isTextInputElement = __webpack_require__(49);
		var shallowEqual = __webpack_require__(123);
	
		var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
		var eventTypes = {
		  select: {
		    phasedRegistrationNames: {
		      bubbled: 'onSelect',
		      captured: 'onSelectCapture'
		    },
		    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
		  }
		};
	
		var activeElement = null;
		var activeElementInst = null;
		var lastSelection = null;
		var mouseDown = false;
	
		// Track whether a listener exists for this plugin. If none exist, we do
		// not extract events. See #3639.
		var hasListener = false;
	
		/**
		 * Get an object which is a unique representation of the current selection.
		 *
		 * The return value will not be consistent across nodes or browsers, but
		 * two identical selections on the same node will return identical objects.
		 *
		 * @param {DOMElement} node
		 * @return {object}
		 */
		function getSelection(node) {
		  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
		    return {
		      start: node.selectionStart,
		      end: node.selectionEnd
		    };
		  } else if (window.getSelection) {
		    var selection = window.getSelection();
		    return {
		      anchorNode: selection.anchorNode,
		      anchorOffset: selection.anchorOffset,
		      focusNode: selection.focusNode,
		      focusOffset: selection.focusOffset
		    };
		  } else if (document.selection) {
		    var range = document.selection.createRange();
		    return {
		      parentElement: range.parentElement(),
		      text: range.text,
		      top: range.boundingTop,
		      left: range.boundingLeft
		    };
		  }
		}
	
		/**
		 * Poll selection to see whether it's changed.
		 *
		 * @param {object} nativeEvent
		 * @return {?SyntheticEvent}
		 */
		function constructSelectEvent(nativeEvent, nativeEventTarget) {
		  // Ensure we have the right element, and that the user is not dragging a
		  // selection (this matches native `select` event behavior). In HTML5, select
		  // fires only on input and textarea thus if there's no focused element we
		  // won't dispatch.
		  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
		    return null;
		  }
	
		  // Only fire when selection has actually changed.
		  var currentSelection = getSelection(activeElement);
		  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
		    lastSelection = currentSelection;
	
		    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
		    syntheticEvent.type = 'select';
		    syntheticEvent.target = activeElement;
	
		    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
		    return syntheticEvent;
		  }
	
		  return null;
		}
	
		/**
		 * This plugin creates an `onSelect` event that normalizes select events
		 * across form elements.
		 *
		 * Supported elements are:
		 * - input (see `isTextInputElement`)
		 * - textarea
		 * - contentEditable
		 *
		 * This differs from native browser implementations in the following ways:
		 * - Fires on contentEditable fields as well as inputs.
		 * - Fires for collapsed selection.
		 * - Fires after user input.
		 */
		var SelectEventPlugin = {
	
		  eventTypes: eventTypes,
	
		  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		    if (!hasListener) {
		      return null;
		    }
	
		    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
		    switch (topLevelType) {
		      // Track the input node that has focus.
		      case 'topFocus':
		        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
		          activeElement = targetNode;
		          activeElementInst = targetInst;
		          lastSelection = null;
		        }
		        break;
		      case 'topBlur':
		        activeElement = null;
		        activeElementInst = null;
		        lastSelection = null;
		        break;
	
		      // Don't fire the event while the user is dragging. This matches the
		      // semantics of the native select event.
		      case 'topMouseDown':
		        mouseDown = true;
		        break;
		      case 'topContextMenu':
		      case 'topMouseUp':
		        mouseDown = false;
		        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
		      // Chrome and IE fire non-standard event when selection is changed (and
		      // sometimes when it hasn't). IE's event fires out of order with respect
		      // to key and input events on deletion, so we discard it.
		      //
		      // Firefox doesn't support selectionchange, so check selection status
		      // after each key entry. The selection changes after keydown and before
		      // keyup, but we check on keydown as well in the case of holding down a
		      // key, when multiple keydown events are fired but only one keyup is.
		      // This is also our approach for IE handling, for the reason above.
		      case 'topSelectionChange':
		        if (skipSelectionChangeEvent) {
		          break;
		        }
		      // falls through
		      case 'topKeyDown':
		      case 'topKeyUp':
		        return constructSelectEvent(nativeEvent, nativeEventTarget);
		    }
	
		    return null;
		  },
	
		  didPutListener: function (inst, registrationName, listener) {
		    if (registrationName === 'onSelect') {
		      hasListener = true;
		    }
		  }
		};
	
		module.exports = SelectEventPlugin;
	
	/***/ },
	/* 155 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var EventListener = __webpack_require__(142);
		var EventPropagators = __webpack_require__(13);
		var ReactDOMComponentTree = __webpack_require__(5);
		var SyntheticAnimationEvent = __webpack_require__(156);
		var SyntheticClipboardEvent = __webpack_require__(157);
		var SyntheticEvent = __webpack_require__(28);
		var SyntheticFocusEvent = __webpack_require__(158);
		var SyntheticKeyboardEvent = __webpack_require__(159);
		var SyntheticMouseEvent = __webpack_require__(52);
		var SyntheticDragEvent = __webpack_require__(162);
		var SyntheticTouchEvent = __webpack_require__(163);
		var SyntheticTransitionEvent = __webpack_require__(164);
		var SyntheticUIEvent = __webpack_require__(53);
		var SyntheticWheelEvent = __webpack_require__(165);
	
		var emptyFunction = __webpack_require__(19);
		var getEventCharCode = __webpack_require__(160);
		var invariant = __webpack_require__(8);
	
		/**
		 * Turns
		 * ['abort', ...]
		 * into
		 * eventTypes = {
		 *   'abort': {
		 *     phasedRegistrationNames: {
		 *       bubbled: 'onAbort',
		 *       captured: 'onAbortCapture',
		 *     },
		 *     dependencies: ['topAbort'],
		 *   },
		 *   ...
		 * };
		 * topLevelEventsToDispatchConfig = {
		 *   'topAbort': { sameConfig }
		 * };
		 */
		var eventTypes = {};
		var topLevelEventsToDispatchConfig = {};
		['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
		  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
		  var onEvent = 'on' + capitalizedEvent;
		  var topEvent = 'top' + capitalizedEvent;
	
		  var type = {
		    phasedRegistrationNames: {
		      bubbled: onEvent,
		      captured: onEvent + 'Capture'
		    },
		    dependencies: [topEvent]
		  };
		  eventTypes[event] = type;
		  topLevelEventsToDispatchConfig[topEvent] = type;
		});
	
		var onClickListeners = {};
	
		function getDictionaryKey(inst) {
		  // Prevents V8 performance issue:
		  // https://github.com/facebook/react/pull/7232
		  return '.' + inst._rootNodeID;
		}
	
		function isInteractive(tag) {
		  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
		}
	
		var SimpleEventPlugin = {
	
		  eventTypes: eventTypes,
	
		  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
		    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
		    if (!dispatchConfig) {
		      return null;
		    }
		    var EventConstructor;
		    switch (topLevelType) {
		      case 'topAbort':
		      case 'topCanPlay':
		      case 'topCanPlayThrough':
		      case 'topDurationChange':
		      case 'topEmptied':
		      case 'topEncrypted':
		      case 'topEnded':
		      case 'topError':
		      case 'topInput':
		      case 'topInvalid':
		      case 'topLoad':
		      case 'topLoadedData':
		      case 'topLoadedMetadata':
		      case 'topLoadStart':
		      case 'topPause':
		      case 'topPlay':
		      case 'topPlaying':
		      case 'topProgress':
		      case 'topRateChange':
		      case 'topReset':
		      case 'topSeeked':
		      case 'topSeeking':
		      case 'topStalled':
		      case 'topSubmit':
		      case 'topSuspend':
		      case 'topTimeUpdate':
		      case 'topVolumeChange':
		      case 'topWaiting':
		        // HTML Events
		        // @see http://www.w3.org/TR/html5/index.html#events-0
		        EventConstructor = SyntheticEvent;
		        break;
		      case 'topKeyPress':
		        // Firefox creates a keypress event for function keys too. This removes
		        // the unwanted keypress events. Enter is however both printable and
		        // non-printable. One would expect Tab to be as well (but it isn't).
		        if (getEventCharCode(nativeEvent) === 0) {
		          return null;
		        }
		      /* falls through */
		      case 'topKeyDown':
		      case 'topKeyUp':
		        EventConstructor = SyntheticKeyboardEvent;
		        break;
		      case 'topBlur':
		      case 'topFocus':
		        EventConstructor = SyntheticFocusEvent;
		        break;
		      case 'topClick':
		        // Firefox creates a click event on right mouse clicks. This removes the
		        // unwanted click events.
		        if (nativeEvent.button === 2) {
		          return null;
		        }
		      /* falls through */
		      case 'topDoubleClick':
		      case 'topMouseDown':
		      case 'topMouseMove':
		      case 'topMouseUp':
		      // TODO: Disabled elements should not respond to mouse events
		      /* falls through */
		      case 'topMouseOut':
		      case 'topMouseOver':
		      case 'topContextMenu':
		        EventConstructor = SyntheticMouseEvent;
		        break;
		      case 'topDrag':
		      case 'topDragEnd':
		      case 'topDragEnter':
		      case 'topDragExit':
		      case 'topDragLeave':
		      case 'topDragOver':
		      case 'topDragStart':
		      case 'topDrop':
		        EventConstructor = SyntheticDragEvent;
		        break;
		      case 'topTouchCancel':
		      case 'topTouchEnd':
		      case 'topTouchMove':
		      case 'topTouchStart':
		        EventConstructor = SyntheticTouchEvent;
		        break;
		      case 'topAnimationEnd':
		      case 'topAnimationIteration':
		      case 'topAnimationStart':
		        EventConstructor = SyntheticAnimationEvent;
		        break;
		      case 'topTransitionEnd':
		        EventConstructor = SyntheticTransitionEvent;
		        break;
		      case 'topScroll':
		        EventConstructor = SyntheticUIEvent;
		        break;
		      case 'topWheel':
		        EventConstructor = SyntheticWheelEvent;
		        break;
		      case 'topCopy':
		      case 'topCut':
		      case 'topPaste':
		        EventConstructor = SyntheticClipboardEvent;
		        break;
		    }
		    !EventConstructor ? process.env.NODE_ENV !== 'production' ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
		    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
		    EventPropagators.accumulateTwoPhaseDispatches(event);
		    return event;
		  },
	
		  didPutListener: function (inst, registrationName, listener) {
		    // Mobile Safari does not fire properly bubble click events on
		    // non-interactive elements, which means delegated click listeners do not
		    // fire. The workaround for this bug involves attaching an empty click
		    // listener on the target node.
		    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
		    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
		      var key = getDictionaryKey(inst);
		      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
		      if (!onClickListeners[key]) {
		        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
		      }
		    }
		  },
	
		  willDeleteListener: function (inst, registrationName) {
		    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
		      var key = getDictionaryKey(inst);
		      onClickListeners[key].remove();
		      delete onClickListeners[key];
		    }
		  }
	
		};
	
		module.exports = SimpleEventPlugin;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 156 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticEvent = __webpack_require__(28);
	
		/**
		 * @interface Event
		 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
		 */
		var AnimationEventInterface = {
		  animationName: null,
		  elapsedTime: null,
		  pseudoElement: null
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticEvent}
		 */
		function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
		module.exports = SyntheticAnimationEvent;
	
	/***/ },
	/* 157 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticEvent = __webpack_require__(28);
	
		/**
		 * @interface Event
		 * @see http://www.w3.org/TR/clipboard-apis/
		 */
		var ClipboardEventInterface = {
		  clipboardData: function (event) {
		    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
		  }
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticUIEvent}
		 */
		function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
		module.exports = SyntheticClipboardEvent;
	
	/***/ },
	/* 158 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticUIEvent = __webpack_require__(53);
	
		/**
		 * @interface FocusEvent
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/
		 */
		var FocusEventInterface = {
		  relatedTarget: null
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticUIEvent}
		 */
		function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
		module.exports = SyntheticFocusEvent;
	
	/***/ },
	/* 159 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticUIEvent = __webpack_require__(53);
	
		var getEventCharCode = __webpack_require__(160);
		var getEventKey = __webpack_require__(161);
		var getEventModifierState = __webpack_require__(55);
	
		/**
		 * @interface KeyboardEvent
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/
		 */
		var KeyboardEventInterface = {
		  key: getEventKey,
		  location: null,
		  ctrlKey: null,
		  shiftKey: null,
		  altKey: null,
		  metaKey: null,
		  repeat: null,
		  locale: null,
		  getModifierState: getEventModifierState,
		  // Legacy Interface
		  charCode: function (event) {
		    // `charCode` is the result of a KeyPress event and represents the value of
		    // the actual printable character.
	
		    // KeyPress is deprecated, but its replacement is not yet final and not
		    // implemented in any major browser. Only KeyPress has charCode.
		    if (event.type === 'keypress') {
		      return getEventCharCode(event);
		    }
		    return 0;
		  },
		  keyCode: function (event) {
		    // `keyCode` is the result of a KeyDown/Up event and represents the value of
		    // physical keyboard key.
	
		    // The actual meaning of the value depends on the users' keyboard layout
		    // which cannot be detected. Assuming that it is a US keyboard layout
		    // provides a surprisingly accurate mapping for US and European users.
		    // Due to this, it is left to the user to implement at this time.
		    if (event.type === 'keydown' || event.type === 'keyup') {
		      return event.keyCode;
		    }
		    return 0;
		  },
		  which: function (event) {
		    // `which` is an alias for either `keyCode` or `charCode` depending on the
		    // type of the event.
		    if (event.type === 'keypress') {
		      return getEventCharCode(event);
		    }
		    if (event.type === 'keydown' || event.type === 'keyup') {
		      return event.keyCode;
		    }
		    return 0;
		  }
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticUIEvent}
		 */
		function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
		module.exports = SyntheticKeyboardEvent;
	
	/***/ },
	/* 160 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * `charCode` represents the actual "character code" and is safe to use with
		 * `String.fromCharCode`. As such, only keys that correspond to printable
		 * characters produce a valid `charCode`, the only exception to this is Enter.
		 * The Tab-key is considered non-printable and does not have a `charCode`,
		 * presumably because it does not produce a tab-character in browsers.
		 *
		 * @param {object} nativeEvent Native browser event.
		 * @return {number} Normalized `charCode` property.
		 */
	
		function getEventCharCode(nativeEvent) {
		  var charCode;
		  var keyCode = nativeEvent.keyCode;
	
		  if ('charCode' in nativeEvent) {
		    charCode = nativeEvent.charCode;
	
		    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
		    if (charCode === 0 && keyCode === 13) {
		      charCode = 13;
		    }
		  } else {
		    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
		    charCode = keyCode;
		  }
	
		  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
		  // Must not discard the (non-)printable Enter-key.
		  if (charCode >= 32 || charCode === 13) {
		    return charCode;
		  }
	
		  return 0;
		}
	
		module.exports = getEventCharCode;
	
	/***/ },
	/* 161 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var getEventCharCode = __webpack_require__(160);
	
		/**
		 * Normalization of deprecated HTML5 `key` values
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
		 */
		var normalizeKey = {
		  'Esc': 'Escape',
		  'Spacebar': ' ',
		  'Left': 'ArrowLeft',
		  'Up': 'ArrowUp',
		  'Right': 'ArrowRight',
		  'Down': 'ArrowDown',
		  'Del': 'Delete',
		  'Win': 'OS',
		  'Menu': 'ContextMenu',
		  'Apps': 'ContextMenu',
		  'Scroll': 'ScrollLock',
		  'MozPrintableKey': 'Unidentified'
		};
	
		/**
		 * Translation from legacy `keyCode` to HTML5 `key`
		 * Only special keys supported, all others depend on keyboard layout or browser
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
		 */
		var translateToKey = {
		  8: 'Backspace',
		  9: 'Tab',
		  12: 'Clear',
		  13: 'Enter',
		  16: 'Shift',
		  17: 'Control',
		  18: 'Alt',
		  19: 'Pause',
		  20: 'CapsLock',
		  27: 'Escape',
		  32: ' ',
		  33: 'PageUp',
		  34: 'PageDown',
		  35: 'End',
		  36: 'Home',
		  37: 'ArrowLeft',
		  38: 'ArrowUp',
		  39: 'ArrowRight',
		  40: 'ArrowDown',
		  45: 'Insert',
		  46: 'Delete',
		  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
		  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
		  144: 'NumLock',
		  145: 'ScrollLock',
		  224: 'Meta'
		};
	
		/**
		 * @param {object} nativeEvent Native browser event.
		 * @return {string} Normalized `key` property.
		 */
		function getEventKey(nativeEvent) {
		  if (nativeEvent.key) {
		    // Normalize inconsistent values reported by browsers due to
		    // implementations of a working draft specification.
	
		    // FireFox implements `key` but returns `MozPrintableKey` for all
		    // printable characters (normalized to `Unidentified`), ignore it.
		    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
		    if (key !== 'Unidentified') {
		      return key;
		    }
		  }
	
		  // Browser does not implement `key`, polyfill as much of it as we can.
		  if (nativeEvent.type === 'keypress') {
		    var charCode = getEventCharCode(nativeEvent);
	
		    // The enter-key is technically both printable and non-printable and can
		    // thus be captured by `keypress`, no other non-printable key should.
		    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
		  }
		  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
		    // While user keyboard layout determines the actual meaning of each
		    // `keyCode` value, almost all function keys have a universal value.
		    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
		  }
		  return '';
		}
	
		module.exports = getEventKey;
	
	/***/ },
	/* 162 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticMouseEvent = __webpack_require__(52);
	
		/**
		 * @interface DragEvent
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/
		 */
		var DragEventInterface = {
		  dataTransfer: null
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticUIEvent}
		 */
		function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
		module.exports = SyntheticDragEvent;
	
	/***/ },
	/* 163 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticUIEvent = __webpack_require__(53);
	
		var getEventModifierState = __webpack_require__(55);
	
		/**
		 * @interface TouchEvent
		 * @see http://www.w3.org/TR/touch-events/
		 */
		var TouchEventInterface = {
		  touches: null,
		  targetTouches: null,
		  changedTouches: null,
		  altKey: null,
		  metaKey: null,
		  ctrlKey: null,
		  shiftKey: null,
		  getModifierState: getEventModifierState
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticUIEvent}
		 */
		function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
		module.exports = SyntheticTouchEvent;
	
	/***/ },
	/* 164 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticEvent = __webpack_require__(28);
	
		/**
		 * @interface Event
		 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
		 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
		 */
		var TransitionEventInterface = {
		  propertyName: null,
		  elapsedTime: null,
		  pseudoElement: null
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticEvent}
		 */
		function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
		module.exports = SyntheticTransitionEvent;
	
	/***/ },
	/* 165 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var SyntheticMouseEvent = __webpack_require__(52);
	
		/**
		 * @interface WheelEvent
		 * @see http://www.w3.org/TR/DOM-Level-3-Events/
		 */
		var WheelEventInterface = {
		  deltaX: function (event) {
		    return 'deltaX' in event ? event.deltaX :
		    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
		    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
		  },
		  deltaY: function (event) {
		    return 'deltaY' in event ? event.deltaY :
		    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
		    'wheelDeltaY' in event ? -event.wheelDeltaY :
		    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
		    'wheelDelta' in event ? -event.wheelDelta : 0;
		  },
		  deltaZ: null,
	
		  // Browsers without "deltaMode" is reporting in raw wheel delta where one
		  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
		  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
		  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
		  deltaMode: null
		};
	
		/**
		 * @param {object} dispatchConfig Configuration used to dispatch this event.
		 * @param {string} dispatchMarker Marker identifying the event target.
		 * @param {object} nativeEvent Native browser event.
		 * @extends {SyntheticMouseEvent}
		 */
		function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
		  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
		}
	
		SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
		module.exports = SyntheticWheelEvent;
	
	/***/ },
	/* 166 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var DOMLazyTree = __webpack_require__(59);
		var DOMProperty = __webpack_require__(7);
		var React = __webpack_require__(88);
		var ReactBrowserEventEmitter = __webpack_require__(83);
		var ReactCurrentOwner = __webpack_require__(43);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactDOMContainerInfo = __webpack_require__(167);
		var ReactDOMFeatureFlags = __webpack_require__(168);
		var ReactFeatureFlags = __webpack_require__(33);
		var ReactInstanceMap = __webpack_require__(116);
		var ReactInstrumentation = __webpack_require__(37);
		var ReactMarkupChecksum = __webpack_require__(169);
		var ReactReconciler = __webpack_require__(34);
		var ReactUpdateQueue = __webpack_require__(135);
		var ReactUpdates = __webpack_require__(31);
	
		var emptyObject = __webpack_require__(99);
		var instantiateReactComponent = __webpack_require__(118);
		var invariant = __webpack_require__(8);
		var setInnerHTML = __webpack_require__(61);
		var shouldUpdateReactComponent = __webpack_require__(124);
		var warning = __webpack_require__(18);
	
		var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
		var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
		var ELEMENT_NODE_TYPE = 1;
		var DOC_NODE_TYPE = 9;
		var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
		var instancesByReactRootID = {};
	
		/**
		 * Finds the index of the first character
		 * that's not common between the two given strings.
		 *
		 * @return {number} the index of the character where the strings diverge
		 */
		function firstDifferenceIndex(string1, string2) {
		  var minLen = Math.min(string1.length, string2.length);
		  for (var i = 0; i < minLen; i++) {
		    if (string1.charAt(i) !== string2.charAt(i)) {
		      return i;
		    }
		  }
		  return string1.length === string2.length ? -1 : minLen;
		}
	
		/**
		 * @param {DOMElement|DOMDocument} container DOM element that may contain
		 * a React component
		 * @return {?*} DOM element that may have the reactRoot ID, or null.
		 */
		function getReactRootElementInContainer(container) {
		  if (!container) {
		    return null;
		  }
	
		  if (container.nodeType === DOC_NODE_TYPE) {
		    return container.documentElement;
		  } else {
		    return container.firstChild;
		  }
		}
	
		function internalGetID(node) {
		  // If node is something like a window, document, or text node, none of
		  // which support attributes or a .getAttribute method, gracefully return
		  // the empty string, as if the attribute were missing.
		  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
		}
	
		/**
		 * Mounts this component and inserts it into the DOM.
		 *
		 * @param {ReactComponent} componentInstance The instance to mount.
		 * @param {DOMElement} container DOM element to mount into.
		 * @param {ReactReconcileTransaction} transaction
		 * @param {boolean} shouldReuseMarkup If true, do not insert markup
		 */
		function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
		  var markerName;
		  if (ReactFeatureFlags.logTopLevelRenders) {
		    var wrappedElement = wrapperInstance._currentElement.props.child;
		    var type = wrappedElement.type;
		    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
		    console.time(markerName);
		  }
	
		  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
		  );
	
		  if (markerName) {
		    console.timeEnd(markerName);
		  }
	
		  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
		  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
		}
	
		/**
		 * Batched mount.
		 *
		 * @param {ReactComponent} componentInstance The instance to mount.
		 * @param {DOMElement} container DOM element to mount into.
		 * @param {boolean} shouldReuseMarkup If true, do not insert markup
		 */
		function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
		  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
		  /* useCreateElement */
		  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
		  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
		  ReactUpdates.ReactReconcileTransaction.release(transaction);
		}
	
		/**
		 * Unmounts a component and removes it from the DOM.
		 *
		 * @param {ReactComponent} instance React component instance.
		 * @param {DOMElement} container DOM element to unmount from.
		 * @final
		 * @internal
		 * @see {ReactMount.unmountComponentAtNode}
		 */
		function unmountComponentFromNode(instance, container, safely) {
		  if (process.env.NODE_ENV !== 'production') {
		    ReactInstrumentation.debugTool.onBeginFlush();
		  }
		  ReactReconciler.unmountComponent(instance, safely);
		  if (process.env.NODE_ENV !== 'production') {
		    ReactInstrumentation.debugTool.onEndFlush();
		  }
	
		  if (container.nodeType === DOC_NODE_TYPE) {
		    container = container.documentElement;
		  }
	
		  // http://jsperf.com/emptying-a-node
		  while (container.lastChild) {
		    container.removeChild(container.lastChild);
		  }
		}
	
		/**
		 * True if the supplied DOM node has a direct React-rendered child that is
		 * not a React root element. Useful for warning in `render`,
		 * `unmountComponentAtNode`, etc.
		 *
		 * @param {?DOMElement} node The candidate DOM node.
		 * @return {boolean} True if the DOM element contains a direct child that was
		 * rendered by React but is not a root element.
		 * @internal
		 */
		function hasNonRootReactChild(container) {
		  var rootEl = getReactRootElementInContainer(container);
		  if (rootEl) {
		    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
		    return !!(inst && inst._hostParent);
		  }
		}
	
		/**
		 * True if the supplied DOM node is a React DOM element and
		 * it has been rendered by another copy of React.
		 *
		 * @param {?DOMElement} node The candidate DOM node.
		 * @return {boolean} True if the DOM has been rendered by another copy of React
		 * @internal
		 */
		function nodeIsRenderedByOtherInstance(container) {
		  var rootEl = getReactRootElementInContainer(container);
		  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
		}
	
		/**
		 * True if the supplied DOM node is a valid node element.
		 *
		 * @param {?DOMElement} node The candidate DOM node.
		 * @return {boolean} True if the DOM is a valid DOM node.
		 * @internal
		 */
		function isValidContainer(node) {
		  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
		}
	
		/**
		 * True if the supplied DOM node is a valid React node element.
		 *
		 * @param {?DOMElement} node The candidate DOM node.
		 * @return {boolean} True if the DOM is a valid React DOM node.
		 * @internal
		 */
		function isReactNode(node) {
		  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
		}
	
		function getHostRootInstanceInContainer(container) {
		  var rootEl = getReactRootElementInContainer(container);
		  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
		  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
		}
	
		function getTopLevelWrapperInContainer(container) {
		  var root = getHostRootInstanceInContainer(container);
		  return root ? root._hostContainerInfo._topLevelWrapper : null;
		}
	
		/**
		 * Temporary (?) hack so that we can store all top-level pending updates on
		 * composites instead of having to worry about different types of components
		 * here.
		 */
		var topLevelRootCounter = 1;
		var TopLevelWrapper = function () {
		  this.rootID = topLevelRootCounter++;
		};
		TopLevelWrapper.prototype.isReactComponent = {};
		if (process.env.NODE_ENV !== 'production') {
		  TopLevelWrapper.displayName = 'TopLevelWrapper';
		}
		TopLevelWrapper.prototype.render = function () {
		  return this.props.child;
		};
		TopLevelWrapper.isReactTopLevelWrapper = true;
	
		/**
		 * Mounting is the process of initializing a React component by creating its
		 * representative DOM elements and inserting them into a supplied `container`.
		 * Any prior content inside `container` is destroyed in the process.
		 *
		 *   ReactMount.render(
		 *     component,
		 *     document.getElementById('container')
		 *   );
		 *
		 *   <div id="container">                   <-- Supplied `container`.
		 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
		 *       // ...                                 component.
		 *     </div>
		 *   </div>
		 *
		 * Inside of `container`, the first element rendered is the "reactRoot".
		 */
		var ReactMount = {
	
		  TopLevelWrapper: TopLevelWrapper,
	
		  /**
		   * Used by devtools. The keys are not important.
		   */
		  _instancesByReactRootID: instancesByReactRootID,
	
		  /**
		   * This is a hook provided to support rendering React components while
		   * ensuring that the apparent scroll position of its `container` does not
		   * change.
		   *
		   * @param {DOMElement} container The `container` being rendered into.
		   * @param {function} renderCallback This must be called once to do the render.
		   */
		  scrollMonitor: function (container, renderCallback) {
		    renderCallback();
		  },
	
		  /**
		   * Take a component that's already mounted into the DOM and replace its props
		   * @param {ReactComponent} prevComponent component instance already in the DOM
		   * @param {ReactElement} nextElement component instance to render
		   * @param {DOMElement} container container to render into
		   * @param {?function} callback function triggered on completion
		   */
		  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
		    ReactMount.scrollMonitor(container, function () {
		      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
		      if (callback) {
		        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
		      }
		    });
	
		    return prevComponent;
		  },
	
		  /**
		   * Render a new component into the DOM. Hooked by hooks!
		   *
		   * @param {ReactElement} nextElement element to render
		   * @param {DOMElement} container container to render into
		   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
		   * @return {ReactComponent} nextComponent
		   */
		  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
		    // Various parts of our code (such as ReactCompositeComponent's
		    // _renderValidatedComponent) assume that calls to render aren't nested;
		    // verify that that's the case.
		    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
		    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
		    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
		    var componentInstance = instantiateReactComponent(nextElement, false);
	
		    // The initial render is synchronous but any updates that happen during
		    // rendering, in componentWillMount or componentDidMount, will be batched
		    // according to the current batching strategy.
	
		    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
		    var wrapperID = componentInstance._instance.rootID;
		    instancesByReactRootID[wrapperID] = componentInstance;
	
		    return componentInstance;
		  },
	
		  /**
		   * Renders a React component into the DOM in the supplied `container`.
		   *
		   * If the React component was previously rendered into `container`, this will
		   * perform an update on it and only mutate the DOM as necessary to reflect the
		   * latest React component.
		   *
		   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
		   * @param {ReactElement} nextElement Component element to render.
		   * @param {DOMElement} container DOM element to render into.
		   * @param {?function} callback function triggered on completion
		   * @return {ReactComponent} Component instance rendered in `container`.
		   */
		  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
		    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
		    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
		  },
	
		  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
		    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
		    !React.isValidElement(nextElement) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
		    // Check if it quacks like an element
		    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
		    process.env.NODE_ENV !== 'production' ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
		    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
		    var nextContext;
		    if (parentComponent) {
		      var parentInst = ReactInstanceMap.get(parentComponent);
		      nextContext = parentInst._processChildContext(parentInst._context);
		    } else {
		      nextContext = emptyObject;
		    }
	
		    var prevComponent = getTopLevelWrapperInContainer(container);
	
		    if (prevComponent) {
		      var prevWrappedElement = prevComponent._currentElement;
		      var prevElement = prevWrappedElement.props.child;
		      if (shouldUpdateReactComponent(prevElement, nextElement)) {
		        var publicInst = prevComponent._renderedComponent.getPublicInstance();
		        var updatedCallback = callback && function () {
		          callback.call(publicInst);
		        };
		        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
		        return publicInst;
		      } else {
		        ReactMount.unmountComponentAtNode(container);
		      }
		    }
	
		    var reactRootElement = getReactRootElementInContainer(container);
		    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
		    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
		    if (process.env.NODE_ENV !== 'production') {
		      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
		      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
		        var rootElementSibling = reactRootElement;
		        while (rootElementSibling) {
		          if (internalGetID(rootElementSibling)) {
		            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
		            break;
		          }
		          rootElementSibling = rootElementSibling.nextSibling;
		        }
		      }
		    }
	
		    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
		    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
		    if (callback) {
		      callback.call(component);
		    }
		    return component;
		  },
	
		  /**
		   * Renders a React component into the DOM in the supplied `container`.
		   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
		   *
		   * If the React component was previously rendered into `container`, this will
		   * perform an update on it and only mutate the DOM as necessary to reflect the
		   * latest React component.
		   *
		   * @param {ReactElement} nextElement Component element to render.
		   * @param {DOMElement} container DOM element to render into.
		   * @param {?function} callback function triggered on completion
		   * @return {ReactComponent} Component instance rendered in `container`.
		   */
		  render: function (nextElement, container, callback) {
		    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
		  },
	
		  /**
		   * Unmounts and destroys the React component rendered in the `container`.
		   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
		   *
		   * @param {DOMElement} container DOM element containing a React component.
		   * @return {boolean} True if a component was found in and unmounted from
		   *                   `container`
		   */
		  unmountComponentAtNode: function (container) {
		    // Various parts of our code (such as ReactCompositeComponent's
		    // _renderValidatedComponent) assume that calls to render aren't nested;
		    // verify that that's the case. (Strictly speaking, unmounting won't cause a
		    // render but we still don't expect to be in a render call here.)
		    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
		    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
		    if (process.env.NODE_ENV !== 'production') {
		      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
		    }
	
		    var prevComponent = getTopLevelWrapperInContainer(container);
		    if (!prevComponent) {
		      // Check if the node being unmounted was rendered by React, but isn't a
		      // root node.
		      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
		      // Check if the container itself is a React root node.
		      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
		      if (process.env.NODE_ENV !== 'production') {
		        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
		      }
	
		      return false;
		    }
		    delete instancesByReactRootID[prevComponent._instance.rootID];
		    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
		    return true;
		  },
	
		  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
		    !isValidContainer(container) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
		    if (shouldReuseMarkup) {
		      var rootElement = getReactRootElementInContainer(container);
		      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
		        ReactDOMComponentTree.precacheNode(instance, rootElement);
		        return;
		      } else {
		        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
		        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
		        var rootMarkup = rootElement.outerHTML;
		        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
		        var normalizedMarkup = markup;
		        if (process.env.NODE_ENV !== 'production') {
		          // because rootMarkup is retrieved from the DOM, various normalizations
		          // will have occurred which will not be present in `markup`. Here,
		          // insert markup into a <div> or <iframe> depending on the container
		          // type to perform the same normalizations before comparing.
		          var normalizer;
		          if (container.nodeType === ELEMENT_NODE_TYPE) {
		            normalizer = document.createElement('div');
		            normalizer.innerHTML = markup;
		            normalizedMarkup = normalizer.innerHTML;
		          } else {
		            normalizer = document.createElement('iframe');
		            document.body.appendChild(normalizer);
		            normalizer.contentDocument.write(markup);
		            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
		            document.body.removeChild(normalizer);
		          }
		        }
	
		        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
		        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
		        !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
		        if (process.env.NODE_ENV !== 'production') {
		          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
		        }
		      }
		    }
	
		    !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
		    if (transaction.useCreateElement) {
		      while (container.lastChild) {
		        container.removeChild(container.lastChild);
		      }
		      DOMLazyTree.insertTreeBefore(container, markup, null);
		    } else {
		      setInnerHTML(container, markup);
		      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
		    }
	
		    if (process.env.NODE_ENV !== 'production') {
		      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
		      if (hostNode._debugID !== 0) {
		        ReactInstrumentation.debugTool.onHostOperation({
		          instanceID: hostNode._debugID,
		          type: 'mount',
		          payload: markup.toString()
		        });
		      }
		    }
		  }
		};
	
		module.exports = ReactMount;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 167 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var validateDOMNesting = __webpack_require__(136);
	
		var DOC_NODE_TYPE = 9;
	
		function ReactDOMContainerInfo(topLevelWrapper, node) {
		  var info = {
		    _topLevelWrapper: topLevelWrapper,
		    _idCounter: 1,
		    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
		    _node: node,
		    _tag: node ? node.nodeName.toLowerCase() : null,
		    _namespaceURI: node ? node.namespaceURI : null
		  };
		  if (process.env.NODE_ENV !== 'production') {
		    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
		  }
		  return info;
		}
	
		module.exports = ReactDOMContainerInfo;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 168 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactDOMFeatureFlags = {
		  useCreateElement: true,
		  useFiber: false
		};
	
		module.exports = ReactDOMFeatureFlags;
	
	/***/ },
	/* 169 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var adler32 = __webpack_require__(170);
	
		var TAG_END = /\/?>/;
		var COMMENT_START = /^<\!\-\-/;
	
		var ReactMarkupChecksum = {
		  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
		  /**
		   * @param {string} markup Markup string
		   * @return {string} Markup string with checksum attribute attached
		   */
		  addChecksumToMarkup: function (markup) {
		    var checksum = adler32(markup);
	
		    // Add checksum (handle both parent tags, comments and self-closing tags)
		    if (COMMENT_START.test(markup)) {
		      return markup;
		    } else {
		      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
		    }
		  },
	
		  /**
		   * @param {string} markup to use
		   * @param {DOMElement} element root React element
		   * @returns {boolean} whether or not the markup is the same
		   */
		  canReuseMarkup: function (markup, element) {
		    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
		    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
		    var markupChecksum = adler32(markup);
		    return markupChecksum === existingChecksum;
		  }
		};
	
		module.exports = ReactMarkupChecksum;
	
	/***/ },
	/* 170 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		'use strict';
	
		var MOD = 65521;
	
		// adler32 is not cryptographically strong, and is only used to sanity check that
		// markup generated on the server matches the markup generated on the client.
		// This implementation (a modified version of the SheetJS version) has been optimized
		// for our use case, at the expense of conforming to the adler32 specification
		// for non-ascii inputs.
		function adler32(data) {
		  var a = 1;
		  var b = 0;
		  var i = 0;
		  var l = data.length;
		  var m = l & ~0x3;
		  while (i < m) {
		    var n = Math.min(i + 4096, m);
		    for (; i < n; i += 4) {
		      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
		    }
		    a %= MOD;
		    b %= MOD;
		  }
		  for (; i < l; i++) {
		    b += a += data.charCodeAt(i);
		  }
		  a %= MOD;
		  b %= MOD;
		  return a | b << 16;
		}
	
		module.exports = adler32;
	
	/***/ },
	/* 171 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		module.exports = '15.4.2';
	
	/***/ },
	/* 172 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var _prodInvariant = __webpack_require__(6);
	
		var ReactCurrentOwner = __webpack_require__(43);
		var ReactDOMComponentTree = __webpack_require__(5);
		var ReactInstanceMap = __webpack_require__(116);
	
		var getHostComponentFromComposite = __webpack_require__(173);
		var invariant = __webpack_require__(8);
		var warning = __webpack_require__(18);
	
		/**
		 * Returns the DOM node rendered by this element.
		 *
		 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
		 *
		 * @param {ReactComponent|DOMElement} componentOrElement
		 * @return {?DOMElement} The root node of this element.
		 */
		function findDOMNode(componentOrElement) {
		  if (process.env.NODE_ENV !== 'production') {
		    var owner = ReactCurrentOwner.current;
		    if (owner !== null) {
		      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
		      owner._warnedAboutRefsInRender = true;
		    }
		  }
		  if (componentOrElement == null) {
		    return null;
		  }
		  if (componentOrElement.nodeType === 1) {
		    return componentOrElement;
		  }
	
		  var inst = ReactInstanceMap.get(componentOrElement);
		  if (inst) {
		    inst = getHostComponentFromComposite(inst);
		    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
		  }
	
		  if (typeof componentOrElement.render === 'function') {
		     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
		  } else {
		     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
		  }
		}
	
		module.exports = findDOMNode;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 173 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactNodeTypes = __webpack_require__(120);
	
		function getHostComponentFromComposite(inst) {
		  var type;
	
		  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
		    inst = inst._renderedComponent;
		  }
	
		  if (type === ReactNodeTypes.HOST) {
		    return inst._renderedComponent;
		  } else if (type === ReactNodeTypes.EMPTY) {
		    return null;
		  }
		}
	
		module.exports = getHostComponentFromComposite;
	
	/***/ },
	/* 174 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactMount = __webpack_require__(166);
	
		module.exports = ReactMount.renderSubtreeIntoContainer;
	
	/***/ },
	/* 175 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMProperty = __webpack_require__(7);
		var EventPluginRegistry = __webpack_require__(15);
		var ReactComponentTreeHook = __webpack_require__(41);
	
		var warning = __webpack_require__(18);
	
		if (process.env.NODE_ENV !== 'production') {
		  var reactProps = {
		    children: true,
		    dangerouslySetInnerHTML: true,
		    key: true,
		    ref: true,
	
		    autoFocus: true,
		    defaultValue: true,
		    valueLink: true,
		    defaultChecked: true,
		    checkedLink: true,
		    innerHTML: true,
		    suppressContentEditableWarning: true,
		    onFocusIn: true,
		    onFocusOut: true
		  };
		  var warnedProperties = {};
	
		  var validateProperty = function (tagName, name, debugID) {
		    if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
		      return true;
		    }
		    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
		      return true;
		    }
		    if (EventPluginRegistry.registrationNameModules.hasOwnProperty(name)) {
		      return true;
		    }
		    warnedProperties[name] = true;
		    var lowerCasedName = name.toLowerCase();
	
		    // data-* attributes should be lowercase; suggest the lowercase version
		    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
		    var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;
	
		    if (standardName != null) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown DOM property %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
		      return true;
		    } else if (registrationName != null) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown event handler property %s. Did you mean `%s`?%s', name, registrationName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
		      return true;
		    } else {
		      // We were unable to guess which prop the user intended.
		      // It is likely that the user was just blindly spreading/forwarding props
		      // Components should be careful to only render valid props/attributes.
		      // Warning will be invoked in warnUnknownProperties to allow grouping.
		      return false;
		    }
		  };
		}
	
		var warnUnknownProperties = function (debugID, element) {
		  var unknownProps = [];
		  for (var key in element.props) {
		    var isValid = validateProperty(element.type, key, debugID);
		    if (!isValid) {
		      unknownProps.push(key);
		    }
		  }
	
		  var unknownPropString = unknownProps.map(function (prop) {
		    return '`' + prop + '`';
		  }).join(', ');
	
		  if (unknownProps.length === 1) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown prop %s on <%s> tag. Remove this prop from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
		  } else if (unknownProps.length > 1) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown props %s on <%s> tag. Remove these props from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
		  }
		};
	
		function handleElement(debugID, element) {
		  if (element == null || typeof element.type !== 'string') {
		    return;
		  }
		  if (element.type.indexOf('-') >= 0 || element.props.is) {
		    return;
		  }
		  warnUnknownProperties(debugID, element);
		}
	
		var ReactDOMUnknownPropertyHook = {
		  onBeforeMountComponent: function (debugID, element) {
		    handleElement(debugID, element);
		  },
		  onBeforeUpdateComponent: function (debugID, element) {
		    handleElement(debugID, element);
		  }
		};
	
		module.exports = ReactDOMUnknownPropertyHook;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 176 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var ReactComponentTreeHook = __webpack_require__(41);
	
		var warning = __webpack_require__(18);
	
		var didWarnValueNull = false;
	
		function handleElement(debugID, element) {
		  if (element == null) {
		    return;
		  }
		  if (element.type !== 'input' && element.type !== 'textarea' && element.type !== 'select') {
		    return;
		  }
		  if (element.props != null && element.props.value === null && !didWarnValueNull) {
		    process.env.NODE_ENV !== 'production' ? warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
	
		    didWarnValueNull = true;
		  }
		}
	
		var ReactDOMNullInputValuePropHook = {
		  onBeforeMountComponent: function (debugID, element) {
		    handleElement(debugID, element);
		  },
		  onBeforeUpdateComponent: function (debugID, element) {
		    handleElement(debugID, element);
		  }
		};
	
		module.exports = ReactDOMNullInputValuePropHook;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 177 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var DOMProperty = __webpack_require__(7);
		var ReactComponentTreeHook = __webpack_require__(41);
	
		var warning = __webpack_require__(18);
	
		var warnedProperties = {};
		var rARIA = new RegExp('^(aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	
		function validateProperty(tagName, name, debugID) {
		  if (warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
		    return true;
		  }
	
		  if (rARIA.test(name)) {
		    var lowerCasedName = name.toLowerCase();
		    var standardName = DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
		    // If this is an aria-* attribute, but is not listed in the known DOM
		    // DOM properties, then it is an invalid aria-* attribute.
		    if (standardName == null) {
		      warnedProperties[name] = true;
		      return false;
		    }
		    // aria-* attributes should be lowercase; suggest the lowercase version.
		    if (name !== standardName) {
		      process.env.NODE_ENV !== 'production' ? warning(false, 'Unknown ARIA attribute %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
		      warnedProperties[name] = true;
		      return true;
		    }
		  }
	
		  return true;
		}
	
		function warnInvalidARIAProps(debugID, element) {
		  var invalidProps = [];
	
		  for (var key in element.props) {
		    var isValid = validateProperty(element.type, key, debugID);
		    if (!isValid) {
		      invalidProps.push(key);
		    }
		  }
	
		  var unknownPropString = invalidProps.map(function (prop) {
		    return '`' + prop + '`';
		  }).join(', ');
	
		  if (invalidProps.length === 1) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
		  } else if (invalidProps.length > 1) {
		    process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
		  }
		}
	
		function handleElement(debugID, element) {
		  if (element == null || typeof element.type !== 'string') {
		    return;
		  }
		  if (element.type.indexOf('-') >= 0 || element.props.is) {
		    return;
		  }
	
		  warnInvalidARIAProps(debugID, element);
		}
	
		var ReactDOMInvalidARIAHook = {
		  onBeforeMountComponent: function (debugID, element) {
		    if (process.env.NODE_ENV !== 'production') {
		      handleElement(debugID, element);
		    }
		  },
		  onBeforeUpdateComponent: function (debugID, element) {
		    if (process.env.NODE_ENV !== 'production') {
		      handleElement(debugID, element);
		    }
		  }
		};
	
		module.exports = ReactDOMInvalidARIAHook;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))
	
	/***/ },
	/* 178 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2015 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	
		function classNames() {
			var classes = '';
			var arg;
	
			for (var i = 0; i < arguments.length; i++) {
				arg = arguments[i];
				if (!arg) {
					continue;
				}
	
				if ('string' === typeof arg || 'number' === typeof arg) {
					classes += ' ' + arg;
				} else if (Object.prototype.toString.call(arg) === '[object Array]') {
					classes += ' ' + classNames.apply(null, arg);
				} else if ('object' === typeof arg) {
					for (var key in arg) {
						if (!arg.hasOwnProperty(key) || !arg[key]) {
							continue;
						}
						classes += ' ' + key;
					}
				}
			}
			return classes.substr(1);
		}
	
		// safely export classNames for node / browserify
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		}
	
		// safely export classNames for RequireJS
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      return !fn(el)
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ },
/* 576 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 577 */
20,
/* 578 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 579 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter v5.1.0 - git.io/ee
	 * Unlicense - http://unlicense.org/
	 * Oliver Caldwell - http://oli.me.uk/
	 * @preserve
	 */
	
	;(function (exports) {
	    'use strict';
	
	    /**
	     * Class for managing events.
	     * Can be extended to provide event functionality in other classes.
	     *
	     * @class EventEmitter Manages event registering and emitting.
	     */
	    function EventEmitter() {}
	
	    // Shortcuts to improve speed and size
	    var proto = EventEmitter.prototype;
	    var originalGlobalValue = exports.EventEmitter;
	
	    /**
	     * Finds the index of the listener for the event in its storage array.
	     *
	     * @param {Function[]} listeners Array of listeners to search through.
	     * @param {Function} listener Method to look for.
	     * @return {Number} Index of the specified listener, -1 if not found
	     * @api private
	     */
	    function indexOfListener(listeners, listener) {
	        var i = listeners.length;
	        while (i--) {
	            if (listeners[i].listener === listener) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	    /**
	     * Alias a method while keeping the context correct, to allow for overwriting of target method.
	     *
	     * @param {String} name The name of the target method.
	     * @return {Function} The aliased method
	     * @api private
	     */
	    function alias(name) {
	        return function aliasClosure() {
	            return this[name].apply(this, arguments);
	        };
	    }
	
	    /**
	     * Returns the listener array for the specified event.
	     * Will initialise the event object and listener arrays if required.
	     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
	     * Each property in the object response is an array of listener functions.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Function[]|Object} All listener functions for the event.
	     */
	    proto.getListeners = function getListeners(evt) {
	        var events = this._getEvents();
	        var response;
	        var key;
	
	        // Return a concatenated array of all matching events if
	        // the selector is a regular expression.
	        if (evt instanceof RegExp) {
	            response = {};
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    response[key] = events[key];
	                }
	            }
	        }
	        else {
	            response = events[evt] || (events[evt] = []);
	        }
	
	        return response;
	    };
	
	    /**
	     * Takes a list of listener objects and flattens it into a list of listener functions.
	     *
	     * @param {Object[]} listeners Raw listener objects.
	     * @return {Function[]} Just the listener functions.
	     */
	    proto.flattenListeners = function flattenListeners(listeners) {
	        var flatListeners = [];
	        var i;
	
	        for (i = 0; i < listeners.length; i += 1) {
	            flatListeners.push(listeners[i].listener);
	        }
	
	        return flatListeners;
	    };
	
	    /**
	     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
	     *
	     * @param {String|RegExp} evt Name of the event to return the listeners from.
	     * @return {Object} All listener functions for an event in an object.
	     */
	    proto.getListenersAsObject = function getListenersAsObject(evt) {
	        var listeners = this.getListeners(evt);
	        var response;
	
	        if (listeners instanceof Array) {
	            response = {};
	            response[evt] = listeners;
	        }
	
	        return response || listeners;
	    };
	
	    function isValidListener (listener) {
	        if (typeof listener === 'function' || listener instanceof RegExp) {
	            return true
	        } else if (listener && typeof listener === 'object') {
	            return isValidListener(listener.listener)
	        } else {
	            return false
	        }
	    }
	
	    /**
	     * Adds a listener function to the specified event.
	     * The listener will not be added if it is a duplicate.
	     * If the listener returns true then it will be removed after it is called.
	     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListener = function addListener(evt, listener) {
	        if (!isValidListener(listener)) {
	            throw new TypeError('listener must be a function');
	        }
	
	        var listeners = this.getListenersAsObject(evt);
	        var listenerIsWrapped = typeof listener === 'object';
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
	                listeners[key].push(listenerIsWrapped ? listener : {
	                    listener: listener,
	                    once: false
	                });
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of addListener
	     */
	    proto.on = alias('addListener');
	
	    /**
	     * Semi-alias of addListener. It will add a listener that will be
	     * automatically removed after its first execution.
	     *
	     * @param {String|RegExp} evt Name of the event to attach the listener to.
	     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addOnceListener = function addOnceListener(evt, listener) {
	        return this.addListener(evt, {
	            listener: listener,
	            once: true
	        });
	    };
	
	    /**
	     * Alias of addOnceListener.
	     */
	    proto.once = alias('addOnceListener');
	
	    /**
	     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
	     * You need to tell it what event names should be matched by a regex.
	     *
	     * @param {String} evt Name of the event to create.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvent = function defineEvent(evt) {
	        this.getListeners(evt);
	        return this;
	    };
	
	    /**
	     * Uses defineEvent to define multiple events.
	     *
	     * @param {String[]} evts An array of event names to define.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.defineEvents = function defineEvents(evts) {
	        for (var i = 0; i < evts.length; i += 1) {
	            this.defineEvent(evts[i]);
	        }
	        return this;
	    };
	
	    /**
	     * Removes a listener function from the specified event.
	     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to remove the listener from.
	     * @param {Function} listener Method to remove from the event.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListener = function removeListener(evt, listener) {
	        var listeners = this.getListenersAsObject(evt);
	        var index;
	        var key;
	
	        for (key in listeners) {
	            if (listeners.hasOwnProperty(key)) {
	                index = indexOfListener(listeners[key], listener);
	
	                if (index !== -1) {
	                    listeners[key].splice(index, 1);
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeListener
	     */
	    proto.off = alias('removeListener');
	
	    /**
	     * Adds listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
	     * You can also pass it a regular expression to add the array of listeners to all events that match it.
	     * Yeah, this function does quite a bit. That's probably a bad thing.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.addListeners = function addListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(false, evt, listeners);
	    };
	
	    /**
	     * Removes listeners in bulk using the manipulateListeners method.
	     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be removed.
	     * You can also pass it a regular expression to remove the listeners from all events that match it.
	     *
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeListeners = function removeListeners(evt, listeners) {
	        // Pass through to manipulateListeners
	        return this.manipulateListeners(true, evt, listeners);
	    };
	
	    /**
	     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
	     * The first argument will determine if the listeners are removed (true) or added (false).
	     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
	     * You can also pass it an event name and an array of listeners to be added/removed.
	     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
	     *
	     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
	     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
	     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
	        var i;
	        var value;
	        var single = remove ? this.removeListener : this.addListener;
	        var multiple = remove ? this.removeListeners : this.addListeners;
	
	        // If evt is an object then pass each of its properties to this method
	        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
	            for (i in evt) {
	                if (evt.hasOwnProperty(i) && (value = evt[i])) {
	                    // Pass the single listener straight through to the singular method
	                    if (typeof value === 'function') {
	                        single.call(this, i, value);
	                    }
	                    else {
	                        // Otherwise pass back to the multiple function
	                        multiple.call(this, i, value);
	                    }
	                }
	            }
	        }
	        else {
	            // So evt must be a string
	            // And listeners must be an array of listeners
	            // Loop over it and pass each one to the multiple method
	            i = listeners.length;
	            while (i--) {
	                single.call(this, evt, listeners[i]);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes all listeners from a specified event.
	     * If you do not specify an event then all listeners will be removed.
	     * That means every event will be emptied.
	     * You can also pass a regex to remove all events that match it.
	     *
	     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.removeEvent = function removeEvent(evt) {
	        var type = typeof evt;
	        var events = this._getEvents();
	        var key;
	
	        // Remove different things depending on the state of evt
	        if (type === 'string') {
	            // Remove all listeners for the specified event
	            delete events[evt];
	        }
	        else if (evt instanceof RegExp) {
	            // Remove all events matching the regex.
	            for (key in events) {
	                if (events.hasOwnProperty(key) && evt.test(key)) {
	                    delete events[key];
	                }
	            }
	        }
	        else {
	            // Remove all listeners in all events
	            delete this._events;
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of removeEvent.
	     *
	     * Added to mirror the node API.
	     */
	    proto.removeAllListeners = alias('removeEvent');
	
	    /**
	     * Emits an event of your choice.
	     * When emitted, every listener attached to that event will be executed.
	     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
	     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
	     * So they will not arrive within the array on the other side, they will be separate.
	     * You can also pass a regular expression to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {Array} [args] Optional array of arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emitEvent = function emitEvent(evt, args) {
	        var listenersMap = this.getListenersAsObject(evt);
	        var listeners;
	        var listener;
	        var i;
	        var key;
	        var response;
	
	        for (key in listenersMap) {
	            if (listenersMap.hasOwnProperty(key)) {
	                listeners = listenersMap[key].slice(0);
	
	                for (i = 0; i < listeners.length; i++) {
	                    // If the listener returns true then it shall be removed from the event
	                    // The function is executed either with a basic call or an apply if there is an args array
	                    listener = listeners[i];
	
	                    if (listener.once === true) {
	                        this.removeListener(evt, listener.listener);
	                    }
	
	                    response = listener.listener.apply(this, args || []);
	
	                    if (response === this._getOnceReturnValue()) {
	                        this.removeListener(evt, listener.listener);
	                    }
	                }
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Alias of emitEvent
	     */
	    proto.trigger = alias('emitEvent');
	
	    /**
	     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
	     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
	     *
	     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
	     * @param {...*} Optional additional arguments to be passed to each listener.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.emit = function emit(evt) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        return this.emitEvent(evt, args);
	    };
	
	    /**
	     * Sets the current value to check against when executing listeners. If a
	     * listeners return value matches the one set here then it will be removed
	     * after execution. This value defaults to true.
	     *
	     * @param {*} value The new value to check for when executing listeners.
	     * @return {Object} Current instance of EventEmitter for chaining.
	     */
	    proto.setOnceReturnValue = function setOnceReturnValue(value) {
	        this._onceReturnValue = value;
	        return this;
	    };
	
	    /**
	     * Fetches the current value to check against when executing listeners. If
	     * the listeners return value matches this one then it should be removed
	     * automatically. It will return true by default.
	     *
	     * @return {*|Boolean} The current value to check for or the default, true.
	     * @api private
	     */
	    proto._getOnceReturnValue = function _getOnceReturnValue() {
	        if (this.hasOwnProperty('_onceReturnValue')) {
	            return this._onceReturnValue;
	        }
	        else {
	            return true;
	        }
	    };
	
	    /**
	     * Fetches the events object and creates one if required.
	     *
	     * @return {Object} The events storage object.
	     * @api private
	     */
	    proto._getEvents = function _getEvents() {
	        return this._events || (this._events = {});
	    };
	
	    /**
	     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
	     *
	     * @return {Function} Non conflicting EventEmitter class.
	     */
	    EventEmitter.noConflict = function noConflict() {
	        exports.EventEmitter = originalGlobalValue;
	        return EventEmitter;
	    };
	
	    // Expose the class either via AMD, CommonJS or the global object
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return EventEmitter;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === 'object' && module.exports){
	        module.exports = EventEmitter;
	    }
	    else {
	        exports.EventEmitter = EventEmitter;
	    }
	}(this || {}));


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.3a7776be.js
 **/